[
  {
    "id": "creavit-8758417850665",
    "brand": "Creavit",
    "title": "Duck Duroplast Yavaş Kapanan Klozet Kapağı Mat Siyah",
    "category": "Duroplast Klozet Kapakları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-mat-siyah-4423.png?v=1748942107",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-mat-siyah-4423.png?v=1748942107",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-mat-siyah-4425.jpg?v=1748942107",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-mat-siyah-4424.jpg?v=1747806488"
    ],
    "price": "5355.00",
    "sku": "KC0903.01.1400E",
    "tags": [
      "duck",
      "duroplast",
      "kapak",
      "klozet kapağı",
      "Mat Siyah",
      "tak-çıkar",
      "yavaş kapama",
      "yaz-25-indirim",
      "Yuvarlak"
    ],
    "variants": [
      {
        "id": 52920968741161,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KC0903.01.1400E",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5355.00",
        "grams": 0,
        "compare_at_price": "10500.00",
        "position": 1,
        "product_id": 8758417850665,
        "created_at": "2026-04-03T12:16:07+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h2 _msthidden=\"1\" _msttexthash=\"1952106\" _msthash=\"435\">Creavit Duck Yavaş Kapanan Klozet Kapağı (KC0903.01.1400E)</h2>\n<p _msthidden=\"1\" _msttexthash=\"25222067\" _msthash=\"434\"><strong>Creavit'in Duck serisine ait bu klozet kapağı</strong>, modern tasarımı ve dayanıklı yapısıyla banyonuza şıklık katacak bir üründür. <strong>Yavaş kapanma özelliği</strong> sayesinde sessiz ve güvenli bir kullanım sunar.</p>\n<h3 _msthidden=\"1\" _msttexthash=\"11312626\" _msthash=\"433\">🔧 Teknik Özellikler</h3>\n<ul _msthidden=\"12\">\n<li _msttexthash=\"390364\" _msthidden=\"1\" _msthash=\"421\">\n<strong>Ürün Kodu:</strong> KC0903.01.1400E</li>\n<li _msttexthash=\"122603\" _msthidden=\"1\" _msthash=\"422\">\n<strong>Seri:</strong> Duck</li>\n<li _msttexthash=\"990340\" _msthidden=\"1\" _msthash=\"423\">\n<strong>Malzeme:</strong> Duroplast (antibakteriyel)</li>\n<li _msttexthash=\"215709\" _msthidden=\"1\" _msthash=\"424\">\n<strong>Renk:</strong> Mat Siyah</li>\n<li _msttexthash=\"169221\" _msthidden=\"1\" _msthash=\"425\">\n<strong>Şekil:</strong> Oval</li>\n<li _msttexthash=\"315770\" _msthidden=\"1\" _msthash=\"426\">\n<strong>Ölçüler:</strong> 445 x 360 mm</li>\n<li _msttexthash=\"359905\" _msthidden=\"1\" _msthash=\"427\">\n<strong>Yavaş Kapanma:</strong> Evet</li>\n<li _msttexthash=\"337181\" _msthidden=\"1\" _msthash=\"428\">\n<strong>Amortisör:</strong> Mevcut</li>\n<li _msttexthash=\"1704248\" _msthidden=\"1\" _msthash=\"429\">\n<strong>Montaj:</strong> Üstten sıkmalı, tak-çıkar özellikli</li>\n<li _msttexthash=\"3898973\" _msthidden=\"1\" _msthash=\"430\">\n<strong>Uyumluluk:</strong> Creavit Free ve TP325 Serisi Mat Siyah renkli Asma Klozet ile uyumludur</li>\n<li _msttexthash=\"445419\" _msthidden=\"1\" _msthash=\"431\">\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n<li _msttexthash=\"419575\" _msthidden=\"1\" _msthash=\"432\">\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\n<p _msttexthash=\"65086320\" _msthidden=\"1\" _msthash=\"420\">Bu klozet kapağı, <strong>yavaş kapanma özelliği</strong> sayesinde sessiz bir kullanım sağlar ve klozete zarar vermeden kapanır. <strong>Duroplast malzeme</strong>, dayanıklılığı ve kolay temizlenebilirliği ile öne çıkar. <strong>Üstten sıkmalı montaj sistemi</strong>, kurulumu kolaylaştırır ve temizlik sırasında kapağın kolayca çıkarılmasına olanak tanır.</p>"
  },
  {
    "id": "creavit-10052478271785",
    "brand": "Creavit",
    "title": "Gömme Rezervuar Üçlü Set",
    "category": "Gömme Rezervuarlar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/8050.png?v=1775138778",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/8050.png?v=1775138778"
    ],
    "price": "8526.00",
    "sku": "SET.GR5001.3.50L",
    "tags": [
      "ara kesme valfi",
      "ara musluk",
      "Gömme Rezervuar",
      "Kumanda Paneli",
      "Musluklar"
    ],
    "variants": [
      {
        "id": 52936579088681,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.GR5001.3.50L",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8526.00",
        "grams": 0,
        "compare_at_price": "12180.00",
        "position": 1,
        "product_id": 10052478271785,
        "created_at": "2026-04-06T12:25:39+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h4>Gömme Rezervuar Üçlü Set</h4>\r\n<p>Modern banyolar için tasarlanan bu üçlü set; gömme rezervuar, ara kesme valfi ve kumanda panelinden oluşur. Estetik görünüm, su tasarrufu ve uzun ömürlü kullanım sunar.</p>\r\n<h4>GR5001 Gömme Rezervuar</h4>\r\n<ul>\r\n<li>\n<strong>Ürün Tipi:</strong> Gömme rezervuar (asma klozet uyumlu)</li>\r\n<li>\n<strong>Ürün Kodu:</strong> GR5001</li>\r\n<li>\n<strong>Deşarj Sistemi:</strong> Çift kademeli (3 / 6 litre)</li>\r\n<li>\n<strong>Ayak Yapısı:</strong> Metal ayaklı (yüksek dayanım)</li>\r\n<li>\n<strong>Çalışma:</strong> Sessiz dolum ve boşaltım sistemi</li>\n</ul>\r\n<h4>MS.AC50L Ara Kesme Valfi</h4>\r\n<ul>\r\n<li>\n<strong>Ürün Tipi:</strong> Aç-kapa ara kesme valfi (stop valf)</li>\r\n<li>\n<strong>Ürün Kodu:</strong> MS.AC50L</li>\r\n<li>\n<strong>Bağlantı Ölçüsü:</strong> 1/2\" – 1/2\"</li>\r\n<li>\n<strong>Montaj Tipi:</strong> Ankastre (duvar içi montaj)</li>\r\n<li>\n<strong>Malzeme:</strong> PPRC gövde</li>\r\n<li>\n<strong>Kullanım Tipi:</strong> Aç-kapa mekanizma</li>\r\n<li>\n<strong>Açma/Kapama:</strong> 180° dönüş</li>\r\n<li>\n<strong>Garanti:</strong> 2 yıl</li>\r\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\r\n<h4>GP8002.00 Kumanda Paneli</h4>\r\n<ul>\r\n<li>\n<strong>Ürün Tipi:</strong> Gömme rezervuar kumanda paneli</li>\r\n<li>\n<strong>Ürün Kodu:</strong> GP8002.00</li>\r\n<li>\n<strong>Seri:</strong> Arc</li>\r\n<li>\n<strong>Çalışma Sistemi:</strong> Manuel (basmalı)</li>\r\n<li>\n<strong>Deşarj Tipi:</strong> Çift kademeli (3 / 6 L uyumlu)</li>\r\n<li>\n<strong>Renk:</strong> Mat gri</li>\r\n<li>\n<strong>Malzeme:</strong> ABS plastik + krom kaplama</li>\r\n<li>\n<strong>Ölçüler:</strong> Yaklaşık 245 x 163 x 14 mm</li>\r\n<li>\n<strong>Montaj:</strong> Duvar üzeri (rezervuar ön yüzüne)</li>\r\n<li>\n<strong>Uyumluluk:</strong> Tüm Creavit gömme rezervuarlar</li>\r\n<li>\n<strong>Garanti:</strong> 2 yıl</li>\n</ul>\r\n<p><strong>Not:</strong> Ürünler set olarak gönderilmektedir ve montaj için profesyonel destek önerilir.</p>"
  },
  {
    "id": "creavit-8475207631145",
    "brand": "Creavit",
    "title": "Bevel Mafsallı Mutfak Armatürü",
    "category": "Mutfak Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bevel-mafsalli-mutfak-armaturu-3585.png?v=1747221054",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bevel-mafsalli-mutfak-armaturu-3585.png?v=1747221054",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bevel-mafsalli-mutfak-armaturu-3587.jpg?v=1747221057",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bevel-mafsalli-mutfak-armaturu-3586.jpg?v=1747221060"
    ],
    "price": "5850.00",
    "sku": "BT.BV8645",
    "tags": [
      "Armatür",
      "krom",
      "mafsallı armatür",
      "mutfak",
      "Mutfak Armatürü",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52915810140457,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.BV8645",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5850.00",
        "grams": 0,
        "compare_at_price": "7800.00",
        "position": 1,
        "product_id": 8475207631145,
        "created_at": "2026-04-02T11:49:59+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h4 data-section-id=\"1oo9ipw\" data-start=\"114\" data-end=\"168\">Creavit Bevel Mafsallı Mutfak Bataryası – BT.BV8645</h4>\n<p data-start=\"170\" data-end=\"458\">Modern mutfaklar için tasarlanan <strong data-start=\"203\" data-end=\"256\">Creavit Bevel BT.BV8645 Mafsallı Mutfak Bataryası</strong>, mafsallı ve oynar başlık yapısı sayesinde maksimum hareket kabiliyeti sunar. Ergonomik kullanımı, şık tasarımı ve dayanıklı yapısıyla mutfağınızda hem estetik hem de fonksiyonelliği bir araya getirir.</p>\n<h4 data-section-id=\"cenipd\" data-start=\"465\" data-end=\"491\">Öne Çıkan Özellikler</h4>\n<ul data-start=\"492\" data-end=\"734\">\n<li data-section-id=\"1en3ntp\" data-start=\"492\" data-end=\"541\">Mafsallı başlık sayesinde geniş hareket alanı</li>\n<li data-section-id=\"g6xrxu\" data-start=\"542\" data-end=\"599\">Döner gövde ile çift hazneli evyelerde rahat kullanım</li>\n<li data-section-id=\"1jjguxq\" data-start=\"600\" data-end=\"658\">35 mm seramik kartuş ile uzun ömürlü ve damlatmaz yapı</li>\n<li data-section-id=\"rlkmmt\" data-start=\"659\" data-end=\"708\">Tek kumanda ile kolay sıcak-soğuk su kontrolü</li>\n<li data-section-id=\"ry0sug\" data-start=\"709\" data-end=\"734\">Modern ve şık tasarım</li>\n</ul>\n<h4 data-section-id=\"1jnehg1\" data-start=\"741\" data-end=\"765\">Ürün Özellikleri</h4>\n<ul data-start=\"766\" data-end=\"957\">\n<li data-section-id=\"1lj2ibh\" data-start=\"766\" data-end=\"810\">\n<strong data-start=\"768\" data-end=\"782\">Ürün Tipi:</strong> Mafsallı mutfak bataryası</li>\n<li data-section-id=\"1y9ods7\" data-start=\"811\" data-end=\"830\">\n<strong data-start=\"813\" data-end=\"822\">Seri:</strong> Bevel</li>\n<li data-section-id=\"zmssks\" data-start=\"831\" data-end=\"861\">\n<strong data-start=\"833\" data-end=\"852\">Kullanım Alanı:</strong> Mutfak</li>\n<li data-section-id=\"mt4rvx\" data-start=\"862\" data-end=\"909\">\n<strong data-start=\"864\" data-end=\"881\">Armatür Tipi:</strong> Tek kumandalı mix batarya</li>\n<li data-section-id=\"edhu9b\" data-start=\"910\" data-end=\"957\">\n<strong data-start=\"912\" data-end=\"928\">Montaj Tipi:</strong> Tezgah üstü (dikey montaj)</li>\n</ul>\n<h4 data-section-id=\"x4ny6m\" data-start=\"964\" data-end=\"978\">Ölçüler</h4>\n<ul data-start=\"979\" data-end=\"1050\">\n<li data-section-id=\"1rw751b\" data-start=\"979\" data-end=\"1013\">\n<strong data-start=\"981\" data-end=\"1004\">Çıkış Ucu Uzunluğu:</strong> 183 mm</li>\n<li data-section-id=\"1bvz40o\" data-start=\"1014\" data-end=\"1050\">\n<strong data-start=\"1016\" data-end=\"1041\">Çıkış Ucu Yüksekliği:</strong> 280 mm</li>\n</ul>\n<h3 data-section-id=\"1fyayno\" data-start=\"1057\" data-end=\"1079\">Teknik Detaylar</h3>\n<ul data-start=\"1080\" data-end=\"1223\">\n<li data-section-id=\"84lu2m\" data-start=\"1080\" data-end=\"1116\">\n<strong data-start=\"1082\" data-end=\"1093\">Kartuş:</strong> 35 mm seramik kartuş</li>\n<li data-section-id=\"1htaf9w\" data-start=\"1117\" data-end=\"1146\">\n<strong data-start=\"1119\" data-end=\"1133\">Su Debisi:</strong> 7 – 8 L/dk</li>\n<li data-section-id=\"4rovco\" data-start=\"1147\" data-end=\"1182\">\n<strong data-start=\"1149\" data-end=\"1162\">Borulama:</strong> Döner borulu yapı</li>\n<li data-section-id=\"1srzmeb\" data-start=\"1183\" data-end=\"1223\">\n<strong data-start=\"1185\" data-end=\"1196\">Başlık:</strong> Mafsallı ve oynar başlık</li>\n</ul>\n<h4 data-section-id=\"ylwnx9\" data-start=\"1230\" data-end=\"1249\">Kutu İçeriği</h4>\n<ul data-start=\"1250\" data-end=\"1316\">\n<li data-section-id=\"kmwep4\" data-start=\"1250\" data-end=\"1269\">Batarya gövdesi</li>\n<li data-section-id=\"6dl4o5\" data-start=\"1270\" data-end=\"1293\">Bağlantı hortumları</li>\n<li data-section-id=\"121zhfk\" data-start=\"1294\" data-end=\"1316\">Montaj ekipmanları</li>\n</ul>"
  },
  {
    "id": "creavit-10049456996649",
    "brand": "Creavit",
    "title": "Antik Kapaklı 80 Cm Zeytuni Lavabo Dolabı İkili Set",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/8017.png?v=1774878001",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/8017.png?v=1774878001",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/8018.png?v=1774878004"
    ],
    "price": "37125.00",
    "sku": "SET.ANTLD081.KPK.2.ZEY",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52912698655017,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.ANTLD081.KPK.2.ZEY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "37125.00",
        "grams": 0,
        "compare_at_price": "49500.00",
        "position": 1,
        "product_id": 10049456996649,
        "created_at": "2026-04-01T16:59:42+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<h4 data-section-id=\"tuv5j2\" data-end=\"205\" data-start=\"143\">Antik 80 Cm Zeytuni Kapaklı Lavabo Dolabı İkili Set</h4>\r\n<p data-end=\"546\" data-start=\"207\">Klasik tasarım anlayışının modern detaylarla buluştuğu <strong data-end=\"287\" data-start=\"262\">Antik Banyo Mobilyası</strong>, Creavit Design Team imzası taşır. Dengeli formu, sade antrasit rengi ve zarif çizgileri sayesinde banyolarda sıcak ve zamansız bir atmosfer oluşturur. Fonksiyonel çekmeceleri ile hem düzenli depolama alanı sağlar hem de banyonuza şık bir görünüm kazandırır.</p>\r\n<h4 data-section-id=\"1ks1ami\" data-end=\"569\" data-start=\"553\">Ürün Ölçüleri</h4>\r\n<p data-end=\"590\" data-start=\"571\"><strong data-end=\"588\" data-start=\"571\">Lavabo Dolabı</strong></p>\r\n<ul>\r\n<li data-end=\"610\" data-start=\"593\">Genişlik: 77 Cm</li>\r\n<li data-end=\"630\" data-start=\"613\">Derinlik: 48 Cm</li>\r\n<li data-end=\"651\" data-start=\"633\">Yükseklik: 61 Cm</li>\r\n<li data-end=\"700\" data-start=\"654\">Lavabo ile birlikte toplam genişlik: <strong data-end=\"700\" data-start=\"691\">80 Cm</strong>\n</li>\n</ul>\r\n<p data-end=\"792\" data-start=\"782\"><strong data-end=\"790\" data-start=\"782\">Ayna</strong></p>\r\n<ul>\r\n<li data-end=\"805\" data-start=\"795\">60 × 80 Cm</li>\n</ul>\r\n<h4 data-section-id=\"nlixhc\" data-end=\"831\" data-start=\"812\">Ürün Özellikleri</h4>\r\n<ul>\r\n<li data-end=\"874\" data-start=\"835\">%100 <strong data-end=\"858\" data-start=\"840\">MDF malzemeden</strong> üretilmiştir.</li>\r\n<li data-end=\"933\" data-start=\"877\">Dayanıklı yapısı sayesinde uzun ömürlü kullanım sunar.</li>\r\n<li data-end=\"1002\" data-start=\"936\">Kapaklı lavabo dolabı ile <strong data-end=\"992\" data-start=\"968\">geniş depolama alanı</strong> sağlar.</li>\r\n<li data-end=\"1085\" data-start=\"1005\">Modern <strong data-end=\"1029\" data-start=\"1012\">zeytuni renk</strong> ile banyolara şık ve bütüncül bir görünüm kazandırır.</li>\r\n<li data-end=\"1176\" data-start=\"1088\">Fonksiyonel ve estetik tasarımı sayesinde hem küçük hem de büyük banyolar için uygundur.</li>\n</ul>\r\n<h4 data-section-id=\"10q5435\" data-end=\"1199\" data-start=\"1183\">Paket İçeriği</h4>\r\n<ul>\r\n<li data-end=\"1249\" data-start=\"1203\">1 Adet <strong data-end=\"1247\" data-start=\"1210\">80 Cm İki Çekmeceli Lavabo Dolabı</strong>\n</li>\r\n<li data-end=\"1295\" data-start=\"1278\">1 Adet <strong data-end=\"1293\" data-start=\"1285\">Ayna</strong>\n</li>\r\n<li data-end=\"1344\" data-start=\"1298\">1 Adet <strong data-end=\"1344\" data-start=\"1305\">AN081 Kodlu Seramik Etajerli Lavabo</strong>\n</li>\n</ul>\r\n<p data-end=\"1418\" data-start=\"1351\"><strong data-end=\"1359\" data-start=\"1351\">Not: </strong>Armatür, sifon alt grubu ve süzgeç ürüne dahil değildir.</p>"
  },
  {
    "id": "creavit-10049452343593",
    "brand": "Creavit",
    "title": "Antik Kapaklı 80 Cm Antrasit Lavabo Dolabı İkili Set",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/8015.png?v=1774877645",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/8015.png?v=1774877645",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/8016.png?v=1774877648"
    ],
    "price": "37125.00",
    "sku": "SET.ANTLD081.KPK.2.ANT",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52912678764841,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.ANTLD081.KPK.2.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "37125.00",
        "grams": 0,
        "compare_at_price": "49500.00",
        "position": 1,
        "product_id": 10049452343593,
        "created_at": "2026-04-01T16:56:51+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h4 data-start=\"143\" data-end=\"205\" data-section-id=\"tuv5j2\">Antik 80 Cm Antrasit Kapaklı Lavabo Dolabı İkili Set</h4>\r\n<p data-start=\"207\" data-end=\"546\">Klasik tasarım anlayışının modern detaylarla buluştuğu <strong data-start=\"262\" data-end=\"287\">Antik Banyo Mobilyası</strong>, Creavit Design Team imzası taşır. Dengeli formu, sade antrasit rengi ve zarif çizgileri sayesinde banyolarda sıcak ve zamansız bir atmosfer oluşturur. Fonksiyonel çekmeceleri ile hem düzenli depolama alanı sağlar hem de banyonuza şık bir görünüm kazandırır.</p>\r\n<h4 data-start=\"553\" data-end=\"569\" data-section-id=\"1ks1ami\">Ürün Ölçüleri</h4>\r\n<p data-start=\"571\" data-end=\"590\"><strong data-start=\"571\" data-end=\"588\">Lavabo Dolabı</strong></p>\r\n<ul>\r\n<li data-start=\"593\" data-end=\"610\">Genişlik: 77 Cm</li>\r\n<li data-start=\"613\" data-end=\"630\">Derinlik: 48 Cm</li>\r\n<li data-start=\"633\" data-end=\"651\">Yükseklik: 61 Cm</li>\r\n<li data-start=\"654\" data-end=\"700\">Lavabo ile birlikte toplam genişlik: <strong data-start=\"691\" data-end=\"700\">80 Cm</strong>\n</li>\n</ul>\r\n<p data-start=\"782\" data-end=\"792\"><strong data-start=\"782\" data-end=\"790\">Ayna</strong></p>\r\n<ul>\r\n<li data-start=\"795\" data-end=\"805\">60 × 80 Cm</li>\n</ul>\r\n<h4 data-start=\"812\" data-end=\"831\" data-section-id=\"nlixhc\">Ürün Özellikleri</h4>\r\n<ul>\r\n<li data-start=\"835\" data-end=\"874\">%100 <strong data-start=\"840\" data-end=\"858\">MDF malzemeden</strong> üretilmiştir.</li>\r\n<li data-start=\"877\" data-end=\"933\">Dayanıklı yapısı sayesinde uzun ömürlü kullanım sunar.</li>\r\n<li data-start=\"936\" data-end=\"1002\">Kapaklı lavabo dolabı ile <strong data-start=\"968\" data-end=\"992\">geniş depolama alanı</strong> sağlar.</li>\r\n<li data-start=\"1005\" data-end=\"1085\">Modern <strong data-start=\"1012\" data-end=\"1029\">antrasit renk</strong> ile banyolara şık ve bütüncül bir görünüm kazandırır.</li>\r\n<li data-start=\"1088\" data-end=\"1176\">Fonksiyonel ve estetik tasarımı sayesinde hem küçük hem de büyük banyolar için uygundur.</li>\n</ul>\r\n<h4 data-start=\"1183\" data-end=\"1199\" data-section-id=\"10q5435\">Paket İçeriği</h4>\r\n<ul>\r\n<li data-start=\"1203\" data-end=\"1249\">1 Adet <strong data-start=\"1210\" data-end=\"1247\">80 Cm İki Çekmeceli Lavabo Dolabı</strong>\n</li>\r\n<li data-start=\"1278\" data-end=\"1295\">1 Adet <strong data-start=\"1285\" data-end=\"1293\">Ayna</strong>\n</li>\r\n<li data-start=\"1298\" data-end=\"1344\">1 Adet <strong data-start=\"1305\" data-end=\"1344\">AN081 Kodlu Seramik Etajerli Lavabo</strong>\n</li>\n</ul>\r\n<p data-start=\"1351\" data-end=\"1418\"><strong data-start=\"1351\" data-end=\"1359\">Not: </strong>Armatür, sifon alt grubu ve süzgeç ürüne dahil değildir.</p>"
  },
  {
    "id": "creavit-10049422491945",
    "brand": "Creavit",
    "title": "Antik Kapaklı 80 Cm Beyaz Lavabo Dolabı İkili Set",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-kapakli-80-cm-beyaz-lavabo-dolabi-ikili-set-8011.jpg?v=1774876246",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-kapakli-80-cm-beyaz-lavabo-dolabi-ikili-set-8011.jpg?v=1774876246",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-kapakli-80-cm-beyaz-lavabo-dolabi-ikili-set-8012.jpg?v=1774876248",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-kapakli-80-cm-beyaz-lavabo-dolabi-ikili-set-8013.jpg?v=1774876250",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-kapakli-80-cm-beyaz-lavabo-dolabi-ikili-set-8014.jpg?v=1774876252"
    ],
    "price": "37125.00",
    "sku": "SET.ANTLD081.KPK.2.BYZ",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52912660807977,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.ANTLD081.KPK.2.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "37125.00",
        "grams": 0,
        "compare_at_price": "49500.00",
        "position": 1,
        "product_id": 10049422491945,
        "created_at": "2026-04-01T16:53:49+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h4 data-section-id=\"tuv5j2\" data-end=\"205\" data-start=\"143\">Antik 80 Cm Beyaz Kapaklı Lavabo Dolabı İkili Set</h4>\n<p data-end=\"546\" data-start=\"207\">Klasik tasarım anlayışının modern detaylarla buluştuğu <strong data-end=\"287\" data-start=\"262\">Antik Banyo Mobilyası</strong>, Creavit Design Team imzası taşır. Dengeli formu, sade antrasit rengi ve zarif çizgileri sayesinde banyolarda sıcak ve zamansız bir atmosfer oluşturur. Fonksiyonel çekmeceleri ile hem düzenli depolama alanı sağlar hem de banyonuza şık bir görünüm kazandırır.</p>\n<h4 data-section-id=\"1ks1ami\" data-end=\"569\" data-start=\"553\">Ürün Ölçüleri</h4>\n<p data-end=\"590\" data-start=\"571\"><strong data-end=\"588\" data-start=\"571\">Lavabo Dolabı</strong></p>\n<ul>\n<li data-end=\"610\" data-start=\"593\">Genişlik: 77 Cm</li>\n<li data-end=\"630\" data-start=\"613\">Derinlik: 48 Cm</li>\n<li data-end=\"651\" data-start=\"633\">Yükseklik: 61 Cm</li>\n<li data-end=\"700\" data-start=\"654\">Lavabo ile birlikte toplam genişlik: <strong data-end=\"700\" data-start=\"691\">80 Cm</strong>\n</li>\n</ul>\n<p data-end=\"792\" data-start=\"782\"><strong data-end=\"790\" data-start=\"782\">Ayna</strong></p>\n<ul>\n<li data-end=\"805\" data-start=\"795\">60 × 80 Cm</li>\n</ul>\n<h4 data-section-id=\"nlixhc\" data-end=\"831\" data-start=\"812\">Ürün Özellikleri</h4>\n<ul>\n<li data-end=\"874\" data-start=\"835\">%100 <strong data-end=\"858\" data-start=\"840\">MDF malzemeden</strong> üretilmiştir.</li>\n<li data-end=\"933\" data-start=\"877\">Dayanıklı yapısı sayesinde uzun ömürlü kullanım sunar.</li>\n<li data-end=\"1002\" data-start=\"936\">Kapaklı lavabo dolabı ile <strong data-end=\"992\" data-start=\"968\">geniş depolama alanı</strong> sağlar.</li>\n<li data-end=\"1085\" data-start=\"1005\">Modern <strong data-end=\"1029\" data-start=\"1012\">beyaz renk</strong> ile banyolara şık ve bütüncül bir görünüm kazandırır.</li>\n<li data-end=\"1176\" data-start=\"1088\">Fonksiyonel ve estetik tasarımı sayesinde hem küçük hem de büyük banyolar için uygundur.</li>\n</ul>\n<h4 data-section-id=\"10q5435\" data-end=\"1199\" data-start=\"1183\">Paket İçeriği</h4>\n<ul>\n<li data-end=\"1249\" data-start=\"1203\">1 Adet <strong data-end=\"1247\" data-start=\"1210\">80 Cm İki Çekmeceli Lavabo Dolabı</strong>\n</li>\n<li data-end=\"1295\" data-start=\"1278\">1 Adet <strong data-end=\"1293\" data-start=\"1285\">Ayna</strong>\n</li>\n<li data-end=\"1344\" data-start=\"1298\">1 Adet <strong data-end=\"1344\" data-start=\"1305\">AN081 Kodlu Seramik Etajerli Lavabo</strong>\n</li>\n</ul>\n<p data-end=\"1418\" data-start=\"1351\"><strong data-end=\"1359\" data-start=\"1351\">Not: </strong>Armatür, sifon alt grubu ve süzgeç ürüne dahil değildir.</p>"
  },
  {
    "id": "creavit-10049373929769",
    "brand": "Creavit",
    "title": "Antik İki Çekmeceli 80 Cm Beyaz Lavabo Dolabı İkili Set",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/8005.jpg?v=1774869835",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/8005.jpg?v=1774869835",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/8006.jpg?v=1774869835",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/8004.jpg?v=1774869835",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/8003.jpg?v=1774869835"
    ],
    "price": "62865.00",
    "sku": "SET.ANTLD081.2CK.2.BYZ",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "iki çekmeceli lavabo dolabı",
      "Lavabo Dolabı",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52912623059241,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.ANTLD081.2CK.2.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "62865.00",
        "grams": 0,
        "compare_at_price": "83820.00",
        "position": 1,
        "product_id": 10049373929769,
        "created_at": "2026-04-01T16:47:39+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<div class=\"[--thread-content-max-width:40rem] @w-lg/main:[--thread-content-max-width:48rem] mx-auto max-w-(--thread-content-max-width) flex-1 group/turn-messages focus-visible:outline-hidden relative flex w-full min-w-0 flex-col agent-turn\" tabindex=\"-1\">\n<h4 class=\"markdown prose dark:prose-invert w-full wrap-break-word light markdown-new-styling\" data-start=\"143\" data-end=\"205\" data-section-id=\"tuv5j2\" data-message-author-role=\"assistant\" data-message-id=\"7d822aa1-3e96-4a6f-87a9-a7e0f2d5b152\" data-message-model-slug=\"gpt-5-3\" tabindex=\"-1\">Antik 80 Cm Beyaz İki Çekmeceli Lavabo Dolabı İkili Set</h4>\n<p class=\"markdown prose dark:prose-invert w-full wrap-break-word light markdown-new-styling\" data-start=\"207\" data-end=\"546\" data-message-author-role=\"assistant\" data-message-id=\"7d822aa1-3e96-4a6f-87a9-a7e0f2d5b152\" data-message-model-slug=\"gpt-5-3\" tabindex=\"-1\">Klasik tasarım anlayışının modern detaylarla buluştuğu <strong data-start=\"262\" data-end=\"287\">Antik Banyo Mobilyası</strong>, Creavit Design Team imzası taşır. Dengeli formu, sade antrasit rengi ve zarif çizgileri sayesinde banyolarda sıcak ve zamansız bir atmosfer oluşturur. Fonksiyonel çekmeceleri ile hem düzenli depolama alanı sağlar hem de banyonuza şık bir görünüm kazandırır.</p>\n<h4 class=\"markdown prose dark:prose-invert w-full wrap-break-word light markdown-new-styling\" data-start=\"553\" data-end=\"569\" data-section-id=\"1ks1ami\" data-message-author-role=\"assistant\" data-message-id=\"7d822aa1-3e96-4a6f-87a9-a7e0f2d5b152\" data-message-model-slug=\"gpt-5-3\" tabindex=\"-1\">Ürün Ölçüleri</h4>\n<p class=\"markdown prose dark:prose-invert w-full wrap-break-word light markdown-new-styling\" data-start=\"571\" data-end=\"590\" data-message-author-role=\"assistant\" data-message-id=\"7d822aa1-3e96-4a6f-87a9-a7e0f2d5b152\" data-message-model-slug=\"gpt-5-3\" tabindex=\"-1\"><strong data-start=\"571\" data-end=\"588\">Lavabo Dolabı </strong></p>\n<ul>\n<li>Genişlik: 77 Cm</li>\n<li>Derinlik: 48 Cm</li>\n<li>Yükseklik: 61 Cm</li>\n<li>Lavabo ile birlikte toplam genişlik: <strong data-start=\"691\" data-end=\"700\">80 Cm</strong>\n</li>\n</ul>\n<p class=\"flex max-w-full flex-col gap-4 grow\" data-start=\"782\" data-end=\"792\"><strong data-start=\"782\" data-end=\"790\">Ayna </strong></p>\n<ul>\n<li class=\"flex max-w-full flex-col gap-4 grow\" data-start=\"782\" data-end=\"792\">60 × 80 Cm</li>\n</ul>\n<h4 data-start=\"812\" data-end=\"831\" data-section-id=\"nlixhc\">Ürün Özellikleri</h4>\n<ul>\n<li data-start=\"812\" data-end=\"831\" data-section-id=\"nlixhc\">%100 <strong data-start=\"840\" data-end=\"858\">MDF malzemeden</strong> üretilmiştir.</li>\n<li data-start=\"812\" data-end=\"831\" data-section-id=\"nlixhc\">Dayanıklı yapısı sayesinde uzun ömürlü kullanım sunar.</li>\n<li data-start=\"812\" data-end=\"831\" data-section-id=\"nlixhc\">İki çekmeceli lavabo dolabı ile <strong data-start=\"968\" data-end=\"992\">geniş depolama alanı</strong> sağlar.</li>\n<li data-start=\"812\" data-end=\"831\" data-section-id=\"nlixhc\">Modern <strong data-start=\"1012\" data-end=\"1029\">beyaz renk</strong> ile banyolara şık ve bütüncül bir görünüm kazandırır.</li>\n<li data-start=\"812\" data-end=\"831\" data-section-id=\"nlixhc\">Fonksiyonel ve estetik tasarımı sayesinde hem küçük hem de büyük banyolar için uygundur.</li>\n</ul>\n<h4 data-start=\"1183\" data-end=\"1199\" data-section-id=\"10q5435\">Paket İçeriği</h4>\n<ul>\n<li data-start=\"1183\" data-end=\"1199\" data-section-id=\"10q5435\">1 Adet <strong data-start=\"1210\" data-end=\"1247\">80 Cm İki Çekmeceli Lavabo Dolabı</strong>\n</li>\n<li data-start=\"1183\" data-end=\"1199\" data-section-id=\"10q5435\">1 Adet <strong data-start=\"1285\" data-end=\"1293\">Ayna</strong>\n</li>\n<li data-start=\"1183\" data-end=\"1199\" data-section-id=\"10q5435\">1 Adet <strong data-start=\"1305\" data-end=\"1344\">AN081 Kodlu Seramik Etajerli Lavabo</strong>\n</li>\n</ul>\n<p data-start=\"1351\" data-end=\"1418\"><strong data-start=\"1351\" data-end=\"1359\">Not: </strong>Armatür, sifon alt grubu ve süzgeç ürüne dahil değildir.</p>\n</div>"
  },
  {
    "id": "creavit-10049371406633",
    "brand": "Creavit",
    "title": "Antik İki Çekmeceli 80 Cm Antrasit Lavabo Dolabı İkili Set",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/8001.png?v=1774868449",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/8001.png?v=1774868449",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/8002.png?v=1774868451"
    ],
    "price": "62865.00",
    "sku": "SET.ANTLD081.2CK.2.ANT",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "iki çekmeceli lavabo dolabı",
      "Lavabo Dolabı",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52912596123945,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.ANTLD081.2CK.2.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "62865.00",
        "grams": 0,
        "compare_at_price": "83820.00",
        "position": 1,
        "product_id": 10049371406633,
        "created_at": "2026-04-01T16:41:13+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<div class=\"[--thread-content-max-width:40rem] @w-lg/main:[--thread-content-max-width:48rem] mx-auto max-w-(--thread-content-max-width) flex-1 group/turn-messages focus-visible:outline-hidden relative flex w-full min-w-0 flex-col agent-turn\" tabindex=\"-1\">\n<h4 class=\"markdown prose dark:prose-invert w-full wrap-break-word light markdown-new-styling\" data-message-model-slug=\"gpt-5-3\" data-message-id=\"7d822aa1-3e96-4a6f-87a9-a7e0f2d5b152\" data-message-author-role=\"assistant\" data-section-id=\"tuv5j2\" data-end=\"205\" data-start=\"143\">Antik 80 Cm Antrasit İki Çekmeceli Lavabo Dolabı Banyo Seti</h4>\n<p class=\"markdown prose dark:prose-invert w-full wrap-break-word light markdown-new-styling\" data-message-model-slug=\"gpt-5-3\" data-message-id=\"7d822aa1-3e96-4a6f-87a9-a7e0f2d5b152\" data-message-author-role=\"assistant\" data-end=\"546\" data-start=\"207\">Klasik tasarım anlayışının modern detaylarla buluştuğu <strong data-end=\"287\" data-start=\"262\">Antik Banyo Mobilyası</strong>, Creavit Design Team imzası taşır. Dengeli formu, sade antrasit rengi ve zarif çizgileri sayesinde banyolarda sıcak ve zamansız bir atmosfer oluşturur. Fonksiyonel çekmeceleri ile hem düzenli depolama alanı sağlar hem de banyonuza şık bir görünüm kazandırır.</p>\n<h4 class=\"markdown prose dark:prose-invert w-full wrap-break-word light markdown-new-styling\" data-message-model-slug=\"gpt-5-3\" data-message-id=\"7d822aa1-3e96-4a6f-87a9-a7e0f2d5b152\" data-message-author-role=\"assistant\" data-section-id=\"1ks1ami\" data-end=\"569\" data-start=\"553\">Ürün Ölçüleri</h4>\n<p class=\"markdown prose dark:prose-invert w-full wrap-break-word light markdown-new-styling\" data-message-model-slug=\"gpt-5-3\" data-message-id=\"7d822aa1-3e96-4a6f-87a9-a7e0f2d5b152\" data-message-author-role=\"assistant\" data-end=\"590\" data-start=\"571\"><strong data-end=\"588\" data-start=\"571\">Lavabo Dolabı </strong></p>\n<ul>\n<li class=\"markdown prose dark:prose-invert w-full wrap-break-word light markdown-new-styling\" data-message-model-slug=\"gpt-5-3\" data-message-id=\"7d822aa1-3e96-4a6f-87a9-a7e0f2d5b152\" data-message-author-role=\"assistant\" data-end=\"590\" data-start=\"571\">Genişlik: 77 Cm</li>\n<li class=\"markdown prose dark:prose-invert w-full wrap-break-word light markdown-new-styling\" data-message-model-slug=\"gpt-5-3\" data-message-id=\"7d822aa1-3e96-4a6f-87a9-a7e0f2d5b152\" data-message-author-role=\"assistant\" data-end=\"590\" data-start=\"571\">Derinlik: 48 Cm</li>\n<li class=\"markdown prose dark:prose-invert w-full wrap-break-word light markdown-new-styling\" data-message-model-slug=\"gpt-5-3\" data-message-id=\"7d822aa1-3e96-4a6f-87a9-a7e0f2d5b152\" data-message-author-role=\"assistant\" data-end=\"590\" data-start=\"571\">Yükseklik: 61 Cm</li>\n<li class=\"markdown prose dark:prose-invert w-full wrap-break-word light markdown-new-styling\" data-message-model-slug=\"gpt-5-3\" data-message-id=\"7d822aa1-3e96-4a6f-87a9-a7e0f2d5b152\" data-message-author-role=\"assistant\" data-end=\"590\" data-start=\"571\">Lavabo ile birlikte toplam genişlik: <strong data-end=\"700\" data-start=\"691\">80 Cm</strong>\n</li>\n</ul>\n<p class=\"flex max-w-full flex-col gap-4 grow\" data-end=\"792\" data-start=\"782\"><strong data-end=\"790\" data-start=\"782\">Ayna </strong></p>\n<ul>\n<li class=\"flex max-w-full flex-col gap-4 grow\" data-end=\"792\" data-start=\"782\">60 × 80 Cm</li>\n</ul>\n<h4 data-section-id=\"nlixhc\" data-end=\"831\" data-start=\"812\">Ürün Özellikleri</h4>\n<ul>\n<li data-section-id=\"nlixhc\" data-end=\"831\" data-start=\"812\">%100 <strong data-end=\"858\" data-start=\"840\">MDF malzemeden</strong> üretilmiştir.</li>\n<li data-section-id=\"nlixhc\" data-end=\"831\" data-start=\"812\">Dayanıklı yapısı sayesinde uzun ömürlü kullanım sunar.</li>\n<li data-section-id=\"nlixhc\" data-end=\"831\" data-start=\"812\">İki çekmeceli lavabo dolabı ile <strong data-end=\"992\" data-start=\"968\">geniş depolama alanı</strong> sağlar.</li>\n<li data-section-id=\"nlixhc\" data-end=\"831\" data-start=\"812\">Modern <strong data-end=\"1029\" data-start=\"1012\">antrasit renk</strong> ile banyolara şık ve bütüncül bir görünüm kazandırır.</li>\n<li data-section-id=\"nlixhc\" data-end=\"831\" data-start=\"812\">Fonksiyonel ve estetik tasarımı sayesinde hem küçük hem de büyük banyolar için uygundur.</li>\n</ul>\n<h4 data-section-id=\"10q5435\" data-end=\"1199\" data-start=\"1183\">Paket İçeriği</h4>\n<ul>\n<li data-section-id=\"10q5435\" data-end=\"1199\" data-start=\"1183\">1 Adet <strong data-end=\"1247\" data-start=\"1210\">80 Cm İki Çekmeceli Lavabo Dolabı</strong>\n</li>\n<li data-section-id=\"10q5435\" data-end=\"1199\" data-start=\"1183\">1 Adet <strong data-end=\"1293\" data-start=\"1285\">Ayna</strong>\n</li>\n<li data-section-id=\"10q5435\" data-end=\"1199\" data-start=\"1183\">1 Adet <strong data-end=\"1344\" data-start=\"1305\">AN081 Kodlu Seramik Etajerli Lavabo</strong>\n</li>\n</ul>\n<p data-end=\"1418\" data-start=\"1351\"><strong data-end=\"1359\" data-start=\"1351\">Not: </strong>Armatür, sifon alt grubu ve süzgeç ürüne dahil değildir.</p>\n</div>"
  },
  {
    "id": "creavit-10049370456361",
    "brand": "Creavit",
    "title": "Antik İki Çekmeceli 80 Cm Zeytuni Lavabo Dolabı İkili Set",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-iki-cekmeceli-80-cm-zeytuni-lavabo-dolabi-seti-7999.png?v=1774868070",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-iki-cekmeceli-80-cm-zeytuni-lavabo-dolabi-seti-7999.png?v=1774868070",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-iki-cekmeceli-80-cm-zeytuni-lavabo-dolabi-seti-8000.png?v=1774868073"
    ],
    "price": "62865.00",
    "sku": "SET.ANTLD081.2CK.2.ZEY",
    "tags": [
      "Banyo Mobilyası",
      "iki çekmeceli lavabo dolabı",
      "Lavabo Dolabı",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52912566731049,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.ANTLD081.2CK.2.ZEY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "62865.00",
        "grams": 0,
        "compare_at_price": "83820.00",
        "position": 1,
        "product_id": 10049370456361,
        "created_at": "2026-04-01T16:33:59+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<div class=\"[--thread-content-max-width:40rem] @w-lg/main:[--thread-content-max-width:48rem] mx-auto max-w-(--thread-content-max-width) flex-1 group/turn-messages focus-visible:outline-hidden relative flex w-full min-w-0 flex-col agent-turn\" tabindex=\"-1\">\n<h4 class=\"markdown prose dark:prose-invert w-full wrap-break-word light markdown-new-styling\" data-message-model-slug=\"gpt-5-3\" data-message-id=\"7d822aa1-3e96-4a6f-87a9-a7e0f2d5b152\" data-message-author-role=\"assistant\" data-section-id=\"tuv5j2\" data-end=\"205\" data-start=\"143\">Antik 80 Cm Zeytuni İki Çekmeceli Lavabo Dolabı Banyo Seti</h4>\n<p class=\"markdown prose dark:prose-invert w-full wrap-break-word light markdown-new-styling\" data-message-model-slug=\"gpt-5-3\" data-message-id=\"7d822aa1-3e96-4a6f-87a9-a7e0f2d5b152\" data-message-author-role=\"assistant\" data-end=\"546\" data-start=\"207\">Klasik tasarım anlayışının modern detaylarla buluştuğu <strong data-end=\"287\" data-start=\"262\">Antik Banyo Mobilyası</strong>, Creavit Design Team imzası taşır. Dengeli formu, sade antrasit rengi ve zarif çizgileri sayesinde banyolarda sıcak ve zamansız bir atmosfer oluşturur. Fonksiyonel çekmeceleri ile hem düzenli depolama alanı sağlar hem de banyonuza şık bir görünüm kazandırır.</p>\n<h4 class=\"markdown prose dark:prose-invert w-full wrap-break-word light markdown-new-styling\" data-message-model-slug=\"gpt-5-3\" data-message-id=\"7d822aa1-3e96-4a6f-87a9-a7e0f2d5b152\" data-message-author-role=\"assistant\" data-section-id=\"1ks1ami\" data-end=\"569\" data-start=\"553\">Ürün Ölçüleri</h4>\n<p class=\"markdown prose dark:prose-invert w-full wrap-break-word light markdown-new-styling\" data-message-model-slug=\"gpt-5-3\" data-message-id=\"7d822aa1-3e96-4a6f-87a9-a7e0f2d5b152\" data-message-author-role=\"assistant\" data-end=\"590\" data-start=\"571\"><strong data-end=\"588\" data-start=\"571\">Lavabo Dolabı </strong></p>\n<ul>\n<li class=\"markdown prose dark:prose-invert w-full wrap-break-word light markdown-new-styling\" data-message-model-slug=\"gpt-5-3\" data-message-id=\"7d822aa1-3e96-4a6f-87a9-a7e0f2d5b152\" data-message-author-role=\"assistant\" data-end=\"590\" data-start=\"571\">Genişlik: 77 Cm</li>\n<li class=\"markdown prose dark:prose-invert w-full wrap-break-word light markdown-new-styling\" data-message-model-slug=\"gpt-5-3\" data-message-id=\"7d822aa1-3e96-4a6f-87a9-a7e0f2d5b152\" data-message-author-role=\"assistant\" data-end=\"590\" data-start=\"571\">Derinlik: 48 Cm</li>\n<li class=\"markdown prose dark:prose-invert w-full wrap-break-word light markdown-new-styling\" data-message-model-slug=\"gpt-5-3\" data-message-id=\"7d822aa1-3e96-4a6f-87a9-a7e0f2d5b152\" data-message-author-role=\"assistant\" data-end=\"590\" data-start=\"571\">Yükseklik: 61 Cm</li>\n<li class=\"markdown prose dark:prose-invert w-full wrap-break-word light markdown-new-styling\" data-message-model-slug=\"gpt-5-3\" data-message-id=\"7d822aa1-3e96-4a6f-87a9-a7e0f2d5b152\" data-message-author-role=\"assistant\" data-end=\"590\" data-start=\"571\">Lavabo ile birlikte toplam genişlik: <strong data-end=\"700\" data-start=\"691\">80 Cm</strong>\n</li>\n</ul>\n<p class=\"flex max-w-full flex-col gap-4 grow\" data-end=\"792\" data-start=\"782\"><strong data-end=\"790\" data-start=\"782\">Ayna </strong></p>\n<ul>\n<li class=\"flex max-w-full flex-col gap-4 grow\" data-end=\"792\" data-start=\"782\">60 × 80 Cm</li>\n</ul>\n<h4 data-section-id=\"nlixhc\" data-end=\"831\" data-start=\"812\">Ürün Özellikleri</h4>\n<ul>\n<li data-section-id=\"nlixhc\" data-end=\"831\" data-start=\"812\">%100 <strong data-end=\"858\" data-start=\"840\">MDF malzemeden</strong> üretilmiştir.</li>\n<li data-section-id=\"nlixhc\" data-end=\"831\" data-start=\"812\">Dayanıklı yapısı sayesinde uzun ömürlü kullanım sunar.</li>\n<li data-section-id=\"nlixhc\" data-end=\"831\" data-start=\"812\">İki çekmeceli lavabo dolabı ile <strong data-end=\"992\" data-start=\"968\">geniş depolama alanı</strong> sağlar.</li>\n<li data-section-id=\"nlixhc\" data-end=\"831\" data-start=\"812\">Modern <strong data-end=\"1029\" data-start=\"1012\">zeytuni renk</strong> ile banyolara şık ve bütüncül bir görünüm kazandırır.</li>\n<li data-section-id=\"nlixhc\" data-end=\"831\" data-start=\"812\">Fonksiyonel ve estetik tasarımı sayesinde hem küçük hem de büyük banyolar için uygundur.</li>\n</ul>\n<h4 data-section-id=\"10q5435\" data-end=\"1199\" data-start=\"1183\">Paket İçeriği</h4>\n<ul>\n<li data-section-id=\"10q5435\" data-end=\"1199\" data-start=\"1183\">1 Adet <strong data-end=\"1247\" data-start=\"1210\">80 Cm İki Çekmeceli Lavabo Dolabı</strong>\n</li>\n<li data-section-id=\"10q5435\" data-end=\"1199\" data-start=\"1183\">Adet <strong data-end=\"1293\" data-start=\"1285\">Ayna</strong>\n</li>\n<li data-section-id=\"10q5435\" data-end=\"1199\" data-start=\"1183\">1 Adet <strong data-end=\"1344\" data-start=\"1305\">AN081 Kodlu Seramik Etajerli Lavabo</strong>\n</li>\n</ul>\n<p data-end=\"1418\" data-start=\"1351\"><strong data-end=\"1359\" data-start=\"1351\">Not: </strong>Armatür, sifon alt grubu ve süzgeç ürüne dahil değildir.</p>\n</div>"
  },
  {
    "id": "creavit-10049343553833",
    "brand": "Creavit",
    "title": "Antik Kapaklı 100 Cm Zeytuni Lavabo Dolabı İkili Set",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-kapakli-100-cm-antrasit-lavabo-dolabi-ikili-set-7995.png?v=1774861980",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-kapakli-100-cm-antrasit-lavabo-dolabi-ikili-set-7995.png?v=1774861980",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-kapakli-100-cm-antrasit-lavabo-dolabi-ikili-set-7996.png?v=1774861982"
    ],
    "price": "41827.50",
    "sku": "SET.ANTLD101.KPK.2.ZEY",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52912557850921,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.ANTLD101.KPK.2.ZEY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "41827.50",
        "grams": 0,
        "compare_at_price": "55770.00",
        "position": 1,
        "product_id": 10049343553833,
        "created_at": "2026-04-01T16:31:31+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h4 data-section-id=\"tuv5j2\" data-end=\"205\" data-start=\"143\">Antik 100 Cm Antrasit Kapaklı Lavabo Dolabı İkili Set</h4>\r\n<p data-end=\"546\" data-start=\"207\">Klasik tasarım anlayışının modern detaylarla buluştuğu <strong data-end=\"287\" data-start=\"262\">Antik Banyo Mobilyası</strong>, Creavit Design Team imzası taşır. Dengeli formu, sade beyaz rengi ve zarif çizgileri sayesinde banyolarda sıcak ve zamansız bir atmosfer oluşturur. Fonksiyonel çekmeceleri ile hem düzenli depolama alanı sağlar hem de banyonuza şık bir görünüm kazandırır.</p>\r\n<h4 data-section-id=\"1ks1ami\" data-end=\"569\" data-start=\"553\">Ürün Ölçüleri</h4>\r\n<p data-end=\"590\" data-start=\"571\"><strong data-end=\"588\" data-start=\"571\">Lavabo Dolabı</strong></p>\r\n<ul>\r\n<li data-end=\"610\" data-start=\"593\">Genişlik: 97 Cm</li>\r\n<li data-end=\"630\" data-start=\"613\">Derinlik: 48 Cm</li>\r\n<li data-end=\"651\" data-start=\"633\">Yükseklik: 61 Cm</li>\r\n<li data-end=\"700\" data-start=\"654\">Lavabo ile birlikte toplam genişlik: <strong data-end=\"700\" data-start=\"691\">100 Cm</strong>\n</li>\n</ul>\r\n<p data-end=\"792\" data-start=\"782\"><strong data-end=\"790\" data-start=\"782\">Ayna</strong></p>\r\n<ul>\r\n<li data-end=\"805\" data-start=\"795\">60 × 80 Cm</li>\n</ul>\r\n<h4 data-section-id=\"nlixhc\" data-end=\"831\" data-start=\"812\">Ürün Özellikleri</h4>\r\n<ul>\r\n<li data-end=\"874\" data-start=\"835\">%100 <strong data-end=\"858\" data-start=\"840\">MDF malzemeden</strong> üretilmiştir.</li>\r\n<li data-end=\"933\" data-start=\"877\">Dayanıklı yapısı sayesinde uzun ömürlü kullanım sunar.</li>\r\n<li data-end=\"1002\" data-start=\"936\">Kapaklı lavabo dolabı ile <strong data-end=\"992\" data-start=\"968\">geniş depolama alanı</strong> sağlar.</li>\r\n<li data-end=\"1085\" data-start=\"1005\">Modern <strong data-end=\"1029\" data-start=\"1012\">antrasit renk</strong> ile banyolara şık ve bütüncül bir görünüm kazandırır.</li>\r\n<li data-end=\"1176\" data-start=\"1088\">Fonksiyonel ve estetik tasarımı sayesinde hem küçük hem de büyük banyolar için uygundur.</li>\n</ul>\r\n<h4 data-section-id=\"10q5435\" data-end=\"1199\" data-start=\"1183\">Paket İçeriği</h4>\r\n<ul>\r\n<li data-end=\"1249\" data-start=\"1203\">1 Adet <strong data-end=\"1247\" data-start=\"1210\">100 Cm Kapaklı Lavabo Dolabı</strong>\n</li>\r\n<li data-end=\"1295\" data-start=\"1278\">1 Adet <strong data-end=\"1293\" data-start=\"1285\">Ayna</strong>\n</li>\r\n<li data-end=\"1344\" data-start=\"1298\">1 Adet <strong data-end=\"1344\" data-start=\"1305\">AN101 Kodlu Seramik Etajerli Lavabo</strong>\n</li>\n</ul>\r\n<p data-end=\"1418\" data-start=\"1351\"><strong data-end=\"1359\" data-start=\"1351\">Not: </strong>Armatür, sifon alt grubu ve süzgeç ürüne dahil değildir.</p>"
  },
  {
    "id": "creavit-10049339654441",
    "brand": "Creavit",
    "title": "Antik Kapaklı 100 Cm Antrasit Lavabo Dolabı İkili Set",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-kapakli-100-cm-beyaz-lavabo-dolabi-ikili-set-7991.png?v=1774860968",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-kapakli-100-cm-beyaz-lavabo-dolabi-ikili-set-7991.png?v=1774860968",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-kapakli-100-cm-beyaz-lavabo-dolabi-ikili-set-7992.png?v=1774860970"
    ],
    "price": "41827.50",
    "sku": "SET.ANTLD101.KPK.2.ANT",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52912550117673,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.ANTLD101.KPK.2.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "41827.50",
        "grams": 0,
        "compare_at_price": "55770.00",
        "position": 1,
        "product_id": 10049339654441,
        "created_at": "2026-04-01T16:28:08+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h4 data-start=\"143\" data-end=\"205\" data-section-id=\"tuv5j2\">Antik 100 Cm Antrasit Kapaklı Lavabo Dolabı İkili Set</h4>\r\n<p data-start=\"207\" data-end=\"546\">Klasik tasarım anlayışının modern detaylarla buluştuğu <strong data-start=\"262\" data-end=\"287\">Antik Banyo Mobilyası</strong>, Creavit Design Team imzası taşır. Dengeli formu, sade beyaz rengi ve zarif çizgileri sayesinde banyolarda sıcak ve zamansız bir atmosfer oluşturur. Fonksiyonel çekmeceleri ile hem düzenli depolama alanı sağlar hem de banyonuza şık bir görünüm kazandırır.</p>\r\n<h4 data-start=\"553\" data-end=\"569\" data-section-id=\"1ks1ami\">Ürün Ölçüleri</h4>\r\n<p data-start=\"571\" data-end=\"590\"><strong data-start=\"571\" data-end=\"588\">Lavabo Dolabı</strong></p>\r\n<ul>\r\n<li data-start=\"593\" data-end=\"610\">Genişlik: 97 Cm</li>\r\n<li data-start=\"613\" data-end=\"630\">Derinlik: 48 Cm</li>\r\n<li data-start=\"633\" data-end=\"651\">Yükseklik: 61 Cm</li>\r\n<li data-start=\"654\" data-end=\"700\">Lavabo ile birlikte toplam genişlik: <strong data-start=\"691\" data-end=\"700\">100 Cm</strong>\n</li>\n</ul>\r\n<p data-start=\"782\" data-end=\"792\"><strong data-start=\"782\" data-end=\"790\">Ayna</strong></p>\r\n<ul>\r\n<li data-start=\"795\" data-end=\"805\">60 × 80 Cm</li>\n</ul>\r\n<h4 data-start=\"812\" data-end=\"831\" data-section-id=\"nlixhc\">Ürün Özellikleri</h4>\r\n<ul>\r\n<li data-start=\"835\" data-end=\"874\">%100 <strong data-start=\"840\" data-end=\"858\">MDF malzemeden</strong> üretilmiştir.</li>\r\n<li data-start=\"877\" data-end=\"933\">Dayanıklı yapısı sayesinde uzun ömürlü kullanım sunar.</li>\r\n<li data-start=\"936\" data-end=\"1002\">Kapaklı lavabo dolabı ile <strong data-start=\"968\" data-end=\"992\">geniş depolama alanı</strong> sağlar.</li>\r\n<li data-start=\"1005\" data-end=\"1085\">Modern <strong data-start=\"1012\" data-end=\"1029\">antrasit renk</strong> ile banyolara şık ve bütüncül bir görünüm kazandırır.</li>\r\n<li data-start=\"1088\" data-end=\"1176\">Fonksiyonel ve estetik tasarımı sayesinde hem küçük hem de büyük banyolar için uygundur.</li>\n</ul>\r\n<h4 data-start=\"1183\" data-end=\"1199\" data-section-id=\"10q5435\">Paket İçeriği</h4>\r\n<ul>\r\n<li data-start=\"1203\" data-end=\"1249\">1 Adet <strong data-start=\"1210\" data-end=\"1247\">100 Cm Kapaklı Lavabo Dolabı</strong>\n</li>\r\n<li data-start=\"1278\" data-end=\"1295\">1 Adet <strong data-start=\"1285\" data-end=\"1293\">Ayna</strong>\n</li>\r\n<li data-start=\"1298\" data-end=\"1344\">1 Adet <strong data-start=\"1305\" data-end=\"1344\">AN101 Kodlu Seramik Etajerli Lavabo</strong>\n</li>\n</ul>\r\n<p data-start=\"1351\" data-end=\"1418\"><strong data-start=\"1351\" data-end=\"1359\">Not: </strong>Armatür, sifon alt grubu ve süzgeç ürüne dahil değildir.</p>"
  },
  {
    "id": "creavit-10049339097385",
    "brand": "Creavit",
    "title": "Antik Kapaklı 100 Cm Beyaz Lavabo Dolabı İkili Set",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7983.jpg?v=1774860565",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7983.jpg?v=1774860565",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7984.jpg?v=1774860567",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7985.jpg?v=1774860568",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7986.jpg?v=1774860571"
    ],
    "price": "41827.50",
    "sku": "SET.ANTLD101.KPK.2.BYZ",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52912542744873,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.ANTLD101.KPK.2.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "41827.50",
        "grams": 0,
        "compare_at_price": "55770.00",
        "position": 1,
        "product_id": 10049339097385,
        "created_at": "2026-04-01T16:25:19+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h4 data-section-id=\"tuv5j2\" data-end=\"205\" data-start=\"143\">Antik 100 Cm Beyaz Kapaklı Lavabo Dolabı İkili Set</h4>\r\n<p data-end=\"546\" data-start=\"207\">Klasik tasarım anlayışının modern detaylarla buluştuğu <strong data-end=\"287\" data-start=\"262\">Antik Banyo Mobilyası</strong>, Creavit Design Team imzası taşır. Dengeli formu, sade beyaz rengi ve zarif çizgileri sayesinde banyolarda sıcak ve zamansız bir atmosfer oluşturur. Fonksiyonel çekmeceleri ile hem düzenli depolama alanı sağlar hem de banyonuza şık bir görünüm kazandırır.</p>\r\n<h4 data-section-id=\"1ks1ami\" data-end=\"569\" data-start=\"553\">Ürün Ölçüleri</h4>\r\n<p data-end=\"590\" data-start=\"571\"><strong data-end=\"588\" data-start=\"571\">Lavabo Dolabı</strong></p>\r\n<ul>\r\n<li data-end=\"610\" data-start=\"593\">Genişlik: 97 Cm</li>\r\n<li data-end=\"630\" data-start=\"613\">Derinlik: 48 Cm</li>\r\n<li data-end=\"651\" data-start=\"633\">Yükseklik: 61 Cm</li>\r\n<li data-end=\"700\" data-start=\"654\">Lavabo ile birlikte toplam genişlik: <strong data-end=\"700\" data-start=\"691\">100 Cm</strong>\n</li>\n</ul>\r\n<p data-end=\"792\" data-start=\"782\"><strong data-end=\"790\" data-start=\"782\">Ayna</strong></p>\r\n<ul>\r\n<li data-end=\"805\" data-start=\"795\">60 × 80 Cm</li>\n</ul>\r\n<h4 data-section-id=\"nlixhc\" data-end=\"831\" data-start=\"812\">Ürün Özellikleri</h4>\r\n<ul>\r\n<li data-end=\"874\" data-start=\"835\">%100 <strong data-end=\"858\" data-start=\"840\">MDF malzemeden</strong> üretilmiştir.</li>\r\n<li data-end=\"933\" data-start=\"877\">Dayanıklı yapısı sayesinde uzun ömürlü kullanım sunar.</li>\r\n<li data-end=\"1002\" data-start=\"936\">Kapaklı lavabo dolabı ile <strong data-end=\"992\" data-start=\"968\">geniş depolama alanı</strong> sağlar.</li>\r\n<li data-end=\"1085\" data-start=\"1005\">Modern <strong data-end=\"1029\" data-start=\"1012\">beyaz renk</strong> ile banyolara şık ve bütüncül bir görünüm kazandırır.</li>\r\n<li data-end=\"1176\" data-start=\"1088\">Fonksiyonel ve estetik tasarımı sayesinde hem küçük hem de büyük banyolar için uygundur.</li>\n</ul>\r\n<h4 data-section-id=\"10q5435\" data-end=\"1199\" data-start=\"1183\">Paket İçeriği</h4>\r\n<ul>\r\n<li data-end=\"1249\" data-start=\"1203\">1 Adet <strong data-end=\"1247\" data-start=\"1210\">100 Cm Kapaklı Lavabo Dolabı</strong>\n</li>\r\n<li data-end=\"1295\" data-start=\"1278\">1 Adet <strong data-end=\"1293\" data-start=\"1285\">Ayna</strong>\n</li>\r\n<li data-end=\"1344\" data-start=\"1298\">1 Adet <strong data-end=\"1344\" data-start=\"1305\">AN101 Kodlu Seramik Etajerli Lavabo</strong>\n</li>\n</ul>\r\n<p data-end=\"1418\" data-start=\"1351\"><strong data-end=\"1359\" data-start=\"1351\">Not: </strong>Armatür, sifon alt grubu ve süzgeç ürüne dahil değildir.</p>"
  },
  {
    "id": "creavit-10049331986729",
    "brand": "Creavit",
    "title": "Antik İki Çekmeceli 100 Cm Zeytuni Lavabo Dolabı İkili Set",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-iki-cekmeceli-100-cm-antrasit-lavabo-dolabi-ikili-set-7980.png?v=1774857282",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-iki-cekmeceli-100-cm-antrasit-lavabo-dolabi-ikili-set-7980.png?v=1774857282",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-iki-cekmeceli-100-cm-zeytuni-lavabo-dolabi-ikili-set-7982.png?v=1774857284"
    ],
    "price": "68145.00",
    "sku": "SET.ANTLD101.2CK.2.ZEY",
    "tags": [
      "Banyo Mobilyası",
      "iki çekmeceli lavabo dolabı",
      "Lavabo Dolabı",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52912532390185,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.ANTLD101.2CK.2.ZEY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "68145.00",
        "grams": 0,
        "compare_at_price": "90860.00",
        "position": 1,
        "product_id": 10049331986729,
        "created_at": "2026-04-01T16:22:47+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h4 data-start=\"143\" data-end=\"205\" data-section-id=\"tuv5j2\">Antik 100 Cm Zeytuni İki Çekmeceli Lavabo Dolabı İkili Set</h4>\r\n<p data-start=\"207\" data-end=\"546\">Klasik tasarım anlayışının modern detaylarla buluştuğu <strong data-start=\"262\" data-end=\"287\">Antik Banyo Mobilyası</strong>, Creavit Design Team imzası taşır. Dengeli formu, sade beyaz rengi ve zarif çizgileri sayesinde banyolarda sıcak ve zamansız bir atmosfer oluşturur. Fonksiyonel çekmeceleri ile hem düzenli depolama alanı sağlar hem de banyonuza şık bir görünüm kazandırır.</p>\r\n<h4 data-start=\"553\" data-end=\"569\" data-section-id=\"1ks1ami\">Ürün Ölçüleri</h4>\r\n<p data-start=\"571\" data-end=\"590\"><strong data-start=\"571\" data-end=\"588\">Lavabo Dolabı</strong></p>\r\n<ul>\r\n<li data-start=\"593\" data-end=\"610\">Genişlik: 97 Cm</li>\r\n<li data-start=\"613\" data-end=\"630\">Derinlik: 48 Cm</li>\r\n<li data-start=\"633\" data-end=\"651\">Yükseklik: 61 Cm</li>\r\n<li data-start=\"654\" data-end=\"700\">Lavabo ile birlikte toplam genişlik: <strong data-start=\"691\" data-end=\"700\">100 Cm</strong>\n</li>\n</ul>\r\n<p data-start=\"782\" data-end=\"792\"><strong data-start=\"782\" data-end=\"790\">Ayna</strong></p>\r\n<ul>\r\n<li data-start=\"795\" data-end=\"805\">60 × 80 Cm</li>\n</ul>\r\n<h4 data-start=\"812\" data-end=\"831\" data-section-id=\"nlixhc\">Ürün Özellikleri</h4>\r\n<ul>\r\n<li data-start=\"835\" data-end=\"874\">%100 <strong data-start=\"840\" data-end=\"858\">MDF malzemeden</strong> üretilmiştir.</li>\r\n<li data-start=\"877\" data-end=\"933\">Dayanıklı yapısı sayesinde uzun ömürlü kullanım sunar.</li>\r\n<li data-start=\"936\" data-end=\"1002\">İki çekmeceli lavabo dolabı ile <strong data-start=\"968\" data-end=\"992\">geniş depolama alanı</strong> sağlar.</li>\r\n<li data-start=\"1005\" data-end=\"1085\">Modern <strong data-start=\"1012\" data-end=\"1029\">zeytuni renk</strong> ile banyolara şık ve bütüncül bir görünüm kazandırır.</li>\r\n<li data-start=\"1088\" data-end=\"1176\">Fonksiyonel ve estetik tasarımı sayesinde hem küçük hem de büyük banyolar için uygundur.</li>\n</ul>\r\n<h4 data-start=\"1183\" data-end=\"1199\" data-section-id=\"10q5435\">Paket İçeriği</h4>\r\n<ul>\r\n<li data-start=\"1203\" data-end=\"1249\">1 Adet <strong data-start=\"1210\" data-end=\"1247\">100 Cm İki Çekmeceli Lavabo Dolabı</strong>\n</li>\r\n<li data-start=\"1278\" data-end=\"1295\">1 Adet <strong data-start=\"1285\" data-end=\"1293\">Ayna</strong>\n</li>\r\n<li data-start=\"1298\" data-end=\"1344\">1 Adet <strong data-start=\"1305\" data-end=\"1344\">AN101 Kodlu Seramik Etajerli Lavabo</strong>\n</li>\n</ul>\r\n<p data-start=\"1351\" data-end=\"1418\"><strong data-start=\"1351\" data-end=\"1359\">Not: </strong>Armatür, sifon alt grubu ve süzgeç ürüne dahil değildir.</p>"
  },
  {
    "id": "creavit-10049330610473",
    "brand": "Creavit",
    "title": "Antik İki Çekmeceli 100 Cm Antrasit Lavabo Dolabı İkili Set",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7976.png?v=1774856663",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7976.png?v=1774856663",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7977.png?v=1774856666"
    ],
    "price": "68145.00",
    "sku": "SET.ANTLD101.2CK.2.ANT",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "iki çekmeceli lavabo dolabı",
      "Lavabo Dolabı",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52912524460329,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.ANTLD101.2CK.2.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "68145.00",
        "grams": 0,
        "compare_at_price": "90860.00",
        "position": 1,
        "product_id": 10049330610473,
        "created_at": "2026-04-01T16:19:25+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h4 data-section-id=\"tuv5j2\" data-end=\"205\" data-start=\"143\">Antik 100 Cm Antrasit İki Çekmeceli Lavabo Dolabı İkili Set</h4>\r\n<p data-end=\"546\" data-start=\"207\">Klasik tasarım anlayışının modern detaylarla buluştuğu <strong data-end=\"287\" data-start=\"262\">Antik Banyo Mobilyası</strong>, Creavit Design Team imzası taşır. Dengeli formu, sade beyaz rengi ve zarif çizgileri sayesinde banyolarda sıcak ve zamansız bir atmosfer oluşturur. Fonksiyonel çekmeceleri ile hem düzenli depolama alanı sağlar hem de banyonuza şık bir görünüm kazandırır.</p>\r\n<h4 data-section-id=\"1ks1ami\" data-end=\"569\" data-start=\"553\">Ürün Ölçüleri</h4>\r\n<p data-end=\"590\" data-start=\"571\"><strong data-end=\"588\" data-start=\"571\">Lavabo Dolabı</strong></p>\r\n<ul>\r\n<li data-end=\"610\" data-start=\"593\">Genişlik: 97 Cm</li>\r\n<li data-end=\"630\" data-start=\"613\">Derinlik: 48 Cm</li>\r\n<li data-end=\"651\" data-start=\"633\">Yükseklik: 61 Cm</li>\r\n<li data-end=\"700\" data-start=\"654\">Lavabo ile birlikte toplam genişlik: <strong data-end=\"700\" data-start=\"691\">100 Cm</strong>\n</li>\n</ul>\r\n<p data-end=\"792\" data-start=\"782\"><strong data-end=\"790\" data-start=\"782\">Ayna</strong></p>\r\n<ul>\r\n<li data-end=\"805\" data-start=\"795\">60 × 80 Cm</li>\n</ul>\r\n<h4 data-section-id=\"nlixhc\" data-end=\"831\" data-start=\"812\">Ürün Özellikleri</h4>\r\n<ul>\r\n<li data-end=\"874\" data-start=\"835\">%100 <strong data-end=\"858\" data-start=\"840\">MDF malzemeden</strong> üretilmiştir.</li>\r\n<li data-end=\"933\" data-start=\"877\">Dayanıklı yapısı sayesinde uzun ömürlü kullanım sunar.</li>\r\n<li data-end=\"1002\" data-start=\"936\">İki çekmeceli lavabo dolabı ile <strong data-end=\"992\" data-start=\"968\">geniş depolama alanı</strong> sağlar.</li>\r\n<li data-end=\"1085\" data-start=\"1005\">Modern <strong data-end=\"1029\" data-start=\"1012\">antrasit renk</strong> ile banyolara şık ve bütüncül bir görünüm kazandırır.</li>\r\n<li data-end=\"1176\" data-start=\"1088\">Fonksiyonel ve estetik tasarımı sayesinde hem küçük hem de büyük banyolar için uygundur.</li>\n</ul>\r\n<h4 data-section-id=\"10q5435\" data-end=\"1199\" data-start=\"1183\">Paket İçeriği</h4>\r\n<ul>\r\n<li data-end=\"1249\" data-start=\"1203\">1 Adet <strong data-end=\"1247\" data-start=\"1210\">100 Cm İki Çekmeceli Lavabo Dolabı</strong>\n</li>\r\n<li data-end=\"1295\" data-start=\"1278\">1 Adet <strong data-end=\"1293\" data-start=\"1285\">Ayna</strong>\n</li>\r\n<li data-end=\"1344\" data-start=\"1298\">1 Adet <strong data-end=\"1344\" data-start=\"1305\">AN101 Kodlu Seramik Etajerli Lavabo</strong>\n</li>\n</ul>\r\n<p data-end=\"1418\" data-start=\"1351\"><strong data-end=\"1359\" data-start=\"1351\">Not: </strong>Armatür, sifon alt grubu ve süzgeç ürüne dahil değildir.</p>"
  },
  {
    "id": "creavit-10049329430825",
    "brand": "Creavit",
    "title": "Antik İki Çekmeceli 100 Cm Beyaz Lavabo Dolabı İkili Set",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-iki-cekmeceli-100-cm-beyaz-lavabo-dolabi-ikili-set-7972.jpg?v=1774855610",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-iki-cekmeceli-100-cm-beyaz-lavabo-dolabi-ikili-set-7972.jpg?v=1774855610",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-iki-cekmeceli-100-cm-beyaz-lavabo-dolabi-ikili-set-7973.jpg?v=1774855612",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-iki-cekmeceli-100-cm-beyaz-lavabo-dolabi-ikili-set-7974.jpg?v=1774855614",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-iki-cekmeceli-100-cm-beyaz-lavabo-dolabi-ikili-set-7975.jpg?v=1774855616"
    ],
    "price": "68145.00",
    "sku": "SET.ANTLD101.2CK.2.BYZ",
    "tags": [
      "Banyo Mobilyası",
      "iki çekmeceli lavabo dolabı",
      "Lavabo Dolabı",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52912495329577,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.ANTLD101.2CK.2.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "68145.00",
        "grams": 0,
        "compare_at_price": "90860.00",
        "position": 1,
        "product_id": 10049329430825,
        "created_at": "2026-04-01T16:13:02+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h4 data-start=\"143\" data-end=\"205\" data-section-id=\"tuv5j2\">Antik 100 Cm Beyaz İki Çekmeceli Lavabo Dolabı İkili Set</h4>\r\n<p data-start=\"207\" data-end=\"546\">Klasik tasarım anlayışının modern detaylarla buluştuğu <strong data-start=\"262\" data-end=\"287\">Antik Banyo Mobilyası</strong>, Creavit Design Team imzası taşır. Dengeli formu, sade beyaz rengi ve zarif çizgileri sayesinde banyolarda sıcak ve zamansız bir atmosfer oluşturur. Fonksiyonel çekmeceleri ile hem düzenli depolama alanı sağlar hem de banyonuza şık bir görünüm kazandırır.</p>\r\n<h4 data-start=\"553\" data-end=\"569\" data-section-id=\"1ks1ami\">Ürün Ölçüleri</h4>\r\n<p data-start=\"571\" data-end=\"590\"><strong data-start=\"571\" data-end=\"588\">Lavabo Dolabı</strong></p>\r\n<ul>\r\n<li data-start=\"593\" data-end=\"610\">Genişlik: 97 Cm</li>\r\n<li data-start=\"613\" data-end=\"630\">Derinlik: 48 Cm</li>\r\n<li data-start=\"633\" data-end=\"651\">Yükseklik: 61 Cm</li>\r\n<li data-start=\"654\" data-end=\"700\">Lavabo ile birlikte toplam genişlik: <strong data-start=\"691\" data-end=\"700\">100 Cm</strong>\n</li>\n</ul>\r\n<p data-start=\"782\" data-end=\"792\"><strong data-start=\"782\" data-end=\"790\">Ayna</strong></p>\r\n<ul>\r\n<li data-start=\"795\" data-end=\"805\">60 × 80 Cm</li>\n</ul>\r\n<h4 data-start=\"812\" data-end=\"831\" data-section-id=\"nlixhc\">Ürün Özellikleri</h4>\r\n<ul>\r\n<li data-start=\"835\" data-end=\"874\">%100 <strong data-start=\"840\" data-end=\"858\">MDF malzemeden</strong> üretilmiştir.</li>\r\n<li data-start=\"877\" data-end=\"933\">Dayanıklı yapısı sayesinde uzun ömürlü kullanım sunar.</li>\r\n<li data-start=\"936\" data-end=\"1002\">İki çekmeceli lavabo dolabı ile <strong data-start=\"968\" data-end=\"992\">geniş depolama alanı</strong> sağlar.</li>\r\n<li data-start=\"1005\" data-end=\"1085\">Modern <strong data-start=\"1012\" data-end=\"1029\">beyaz renk</strong> ile banyolara şık ve bütüncül bir görünüm kazandırır.</li>\r\n<li data-start=\"1088\" data-end=\"1176\">Fonksiyonel ve estetik tasarımı sayesinde hem küçük hem de büyük banyolar için uygundur.</li>\n</ul>\r\n<h4 data-start=\"1183\" data-end=\"1199\" data-section-id=\"10q5435\">Paket İçeriği</h4>\r\n<ul>\r\n<li data-start=\"1203\" data-end=\"1249\">1 Adet <strong data-start=\"1210\" data-end=\"1247\">100 Cm İki Çekmeceli Lavabo Dolabı</strong>\n</li>\r\n<li data-start=\"1278\" data-end=\"1295\">1 Adet <strong data-start=\"1285\" data-end=\"1293\">Ayna</strong>\n</li>\r\n<li data-start=\"1298\" data-end=\"1344\">1 Adet <strong data-start=\"1305\" data-end=\"1344\">AN101 Kodlu Seramik Etajerli Lavabo</strong>\n</li>\n</ul>\r\n<p data-start=\"1351\" data-end=\"1418\"><strong data-start=\"1351\" data-end=\"1359\">Not: </strong>Armatür, sifon alt grubu ve süzgeç ürüne dahil değildir.</p>"
  },
  {
    "id": "creavit-10044448112937",
    "brand": "Creavit",
    "title": "Antik Dolap Uyumlu 80 Cm Lavabo ve Ayak Seti",
    "category": "Etajerli Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7965.png?v=1774267690",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7965.png?v=1774267690",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7966.png?v=1774267691",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7967.png?v=1774267693",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/an081_Mekan_1.png?v=1774270331",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/an081_Mekan_2.png?v=1774270331",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/an081_Mekan.png?v=1774270331"
    ],
    "price": "10845.00",
    "sku": "SET.AN081270.BYZ",
    "tags": [
      "etajerli lavabo",
      "Lavabo",
      "seramik"
    ],
    "variants": [
      {
        "id": 52916266959145,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.AN081270.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "10845.00",
        "grams": 0,
        "compare_at_price": "14460.00",
        "position": 1,
        "product_id": 10044448112937,
        "created_at": "2026-04-02T15:28:17+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h4 data-section-id=\"xp7c2b\" data-start=\"200\" data-end=\"261\"><span role=\"text\"><strong data-start=\"203\" data-end=\"261\">Creavit Antik 80 Cm Etajerli Lavabo ve Konsol Ayak Seti</strong></span></h4>\n<p data-start=\"263\" data-end=\"477\">Banyonuza klasik şıklık ve fonksiyonelliği bir arada kazandırın!<br data-start=\"327\" data-end=\"330\">Creavit Antik serisine ait 80 cm etajerli lavabo, zarif tasarımı ve kullanışlı yapısıyla hem modern hem de klasik banyolar için ideal bir çözümdür.</p>\n<p data-start=\"479\" data-end=\"739\">Ürün, banyo dolaplarıyla uyumlu şekilde kullanılabileceği gibi, kutu içeriğinde yer alan <strong data-start=\"568\" data-end=\"596\">2 adet Antik konsol ayak</strong> ile bağımsız kullanım imkânı da sunar. Geniş etajer alanı sayesinde sabunluk ve banyo aksesuarlarınızı düzenli şekilde konumlandırabilirsiniz.</p>\n<p data-start=\"741\" data-end=\"839\">Pürüzsüz seramik yüzeyi, leke tutmayan yapısı ile kolay temizlenir ve uzun ömürlü kullanım sağlar.</p>\n<h4 data-section-id=\"1bbnhu2\" data-start=\"846\" data-end=\"866\"><span role=\"text\"><strong data-start=\"849\" data-end=\"866\">Ürün Ölçüleri</strong></span></h4>\n<ul data-start=\"867\" data-end=\"950\">\n<li data-section-id=\"1o5ckg0\" data-start=\"867\" data-end=\"886\">Genişlik: 80 cm</li>\n<li data-section-id=\"te2j4z\" data-start=\"887\" data-end=\"906\">Derinlik: 50 cm</li>\n<li data-section-id=\"dqbzqb\" data-start=\"907\" data-end=\"927\">Yükseklik: 20 cm</li>\n<li data-section-id=\"1dguh4l\" data-start=\"928\" data-end=\"950\">İç Derinlik: 15 cm</li>\n</ul>\n<h4 data-section-id=\"1qxfxq8\" data-start=\"957\" data-end=\"980\"><span role=\"text\"><strong data-start=\"960\" data-end=\"980\">Ürün Özellikleri</strong></span></h4>\n<ul data-start=\"981\" data-end=\"1264\">\n<li data-section-id=\"1hci3v\" data-start=\"981\" data-end=\"1035\">Etajerli lavabo tasarımı ile ekstra kullanım alanı</li>\n<li data-section-id=\"13up7uc\" data-start=\"1036\" data-end=\"1088\">Dolap uyumlu veya duvara monte kullanım seçeneği</li>\n<li data-section-id=\"1uvjo4m\" data-start=\"1089\" data-end=\"1133\">Parlak beyaz, kolay temizlenebilir yüzey</li>\n<li data-section-id=\"36bnai\" data-start=\"1134\" data-end=\"1162\">Armatür delikli kullanım</li>\n<li data-section-id=\"1ggzmce\" data-start=\"1163\" data-end=\"1193\">Taşma delikli güvenli yapı</li>\n<li data-section-id=\"z3trp9\" data-start=\"1194\" data-end=\"1234\">Antik konsol ayak ile uyumlu tasarım</li>\n<li data-section-id=\"1ti9pcx\" data-start=\"1235\" data-end=\"1264\">Dayanıklı seramik malzeme</li>\n</ul>\n<h4 data-section-id=\"rzy5tx\" data-start=\"1271\" data-end=\"1290\"><span role=\"text\"><strong data-start=\"1274\" data-end=\"1290\">Kutu İçeriği</strong></span></h4>\n<ul data-start=\"1291\" data-end=\"1380\">\n<li data-section-id=\"1n3awmc\" data-start=\"1291\" data-end=\"1323\">1 adet AN081 Etajerli Lavabo</li>\n<li data-section-id=\"1te1lot\" data-start=\"1324\" data-end=\"1358\">2 adet KL270 Antik Konsol Ayak</li>\n<li data-section-id=\"1l51q76\" data-start=\"1359\" data-end=\"1380\">Montaj Aparatları</li>\n</ul>\n<h4 data-section-id=\"7r8pke\" data-start=\"1387\" data-end=\"1416\"><span role=\"text\"><strong data-start=\"1390\" data-end=\"1416\">Dahil Olmayan Parçalar</strong></span></h4>\n<ul data-start=\"1417\" data-end=\"1474\">\n<li data-section-id=\"10d1sed\" data-start=\"1417\" data-end=\"1447\">Lavabo bataryası (armatür)</li>\n<li data-section-id=\"hy0z5g\" data-start=\"1448\" data-end=\"1474\">Sifon ve Sifon Başlığı</li>\n</ul>"
  },
  {
    "id": "creavit-10038298181929",
    "brand": "Creavit",
    "title": "Flexio 80 Cm Kapaklı Katlanabilir Lavabo Dolabı 270 Derece Antrasit Set",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7960.jpg?v=1773145557",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7960.jpg?v=1773145557",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7961.jpg?v=1773145559",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7962.jpg?v=1773145561",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7963.jpg?v=1773145563",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7964.png?v=1773145565"
    ],
    "price": "22357.50",
    "sku": "SET.FLXLD080.KPK.270.ANT",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52912847290665,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.FLXLD080.KPK.270.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "22357.50",
        "grams": 0,
        "compare_at_price": "29810.00",
        "position": 1,
        "product_id": 10038298181929,
        "created_at": "2026-04-01T17:29:17+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<h4 data-end=\"200\" data-start=\"135\" data-section-id=\"1pgj1i0\">Flexio 80 Cm Kapaklı Katlanabilir Antrasit Lavabo Dolabı Seti</h4>\r\n<p data-end=\"548\" data-start=\"202\">Pratik ve şık <strong data-end=\"258\" data-start=\"216\">Flexio Katlanabilir Lavabo Dolabı Seti</strong>, modern banyolar için tasarlandı. <strong data-end=\"314\" data-start=\"293\">Melamin kaplaması</strong> ve özel kilitleme noktalarıyla defalarca kurulup sökülebilir; <strong data-end=\"400\" data-start=\"377\">ekipman gerektirmez</strong>. Sökme-takma sırasında deformasyon veya rijitlik kaybı olmaz, fuar alanları, taşınmalar veya konsept değişikliklerinde kolayca kullanabilirsiniz.</p>\r\n<h4 data-end=\"597\" data-start=\"555\"><strong data-end=\"597\" data-start=\"560\">Hızlı Kurulum – 20 Saniyede Hazır</strong></h4>\r\n<ol>\r\n<li data-end=\"618\" data-start=\"601\">Kutudan çıkarın.</li>\r\n<li data-end=\"636\" data-start=\"622\">Gövdeyi dışa katlayın.</li>\r\n<li data-end=\"664\" data-start=\"640\">Parçaları yerine takın.</li>\r\n<li data-end=\"687\" data-start=\"668\">Kapakları kapatın.</li>\r\n<li data-end=\"713\" data-start=\"691\">Lavaboyu yerleştirin.</li>\n</ol>\r\n<h4 data-end=\"742\" data-start=\"720\"><strong data-end=\"742\" data-start=\"725\">Ürün Ölçüleri</strong></h4>\r\n<ul>\r\n<li data-end=\"809\" data-start=\"745\">\n<strong data-end=\"763\" data-start=\"745\">Lavabo Dolabı:</strong> 76 × 43 × 47 cm <em data-end=\"807\" data-start=\"780\">(Lavabo ile toplam 80 cm)</em>\n</li>\r\n<li data-end=\"834\" data-start=\"812\">\n<strong data-end=\"821\" data-start=\"812\">Ayna:</strong> 80× 64 cm</li>\r\n<li data-end=\"867\" data-start=\"837\">\n<strong data-end=\"849\" data-start=\"837\">Malzeme:</strong> Melamin kaplama</li>\n</ul>\r\n<h4 data-end=\"896\" data-start=\"874\"><strong data-end=\"896\" data-start=\"879\">Paket İçeriği</strong></h4>\r\n<ul>\r\n<li data-end=\"949\" data-start=\"899\">1 Adet 80 Cm Kapaklı Katlanabilir Lavabo Dolabı</li>\r\n<li data-end=\"979\" data-start=\"952\">1 Adet Katlanabilir Ayna</li>\r\n<li data-end=\"1021\" data-start=\"982\">1 Adet SU080 Seramik Etajerli Lavabo</li>\n</ul>\r\n<p><strong>Not:</strong><span> Armatür, sifon alt grubu ve süzgeç dahil değildir.</span></p>"
  },
  {
    "id": "creavit-10038293266729",
    "brand": "Creavit",
    "title": "Flexio 80 Cm Kapaklı Katlanabilir Lavabo Dolabı 270 Derece Beyaz Set",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/flexio-7954.jpg?v=1773144994",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/flexio-7954.jpg?v=1773144994",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/flexio-7955.jpg?v=1773144996",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/flexio-7956.jpg?v=1773144998",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/flexio-7957.jpg?v=1773144999",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/flexio-7958.png?v=1773145002",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/flexio-7959.png?v=1773145004"
    ],
    "price": "22357.50",
    "sku": "SET.FLXLD080.KPK.270.BYZ",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52912828776745,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.FLXLD080.KPK.270.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "22357.50",
        "grams": 0,
        "compare_at_price": "29810.00",
        "position": 1,
        "product_id": 10038293266729,
        "created_at": "2026-04-01T17:23:53+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h4 data-end=\"200\" data-start=\"135\" data-section-id=\"1pgj1i0\">Flexio 80 Cm Kapaklı Katlanabilir Beyaz Lavabo Dolabı Seti</h4>\n<p data-end=\"548\" data-start=\"202\">Pratik ve şık <strong data-end=\"258\" data-start=\"216\">Flexio Katlanabilir Lavabo Dolabı Seti</strong>, modern banyolar için tasarlandı. <strong data-end=\"314\" data-start=\"293\">Melamin kaplaması</strong> ve özel kilitleme noktalarıyla defalarca kurulup sökülebilir; <strong data-end=\"400\" data-start=\"377\">ekipman gerektirmez</strong>. Sökme-takma sırasında deformasyon veya rijitlik kaybı olmaz, fuar alanları, taşınmalar veya konsept değişikliklerinde kolayca kullanabilirsiniz.</p>\n<h4 data-end=\"597\" data-start=\"555\"><strong data-end=\"597\" data-start=\"560\">Hızlı Kurulum – 20 Saniyede Hazır</strong></h4>\n<ol>\n<li data-end=\"618\" data-start=\"601\">Kutudan çıkarın.</li>\n<li data-end=\"636\" data-start=\"622\">Gövdeyi dışa katlayın.</li>\n<li data-end=\"664\" data-start=\"640\">Parçaları yerine takın.</li>\n<li data-end=\"687\" data-start=\"668\">Kapakları kapatın.</li>\n<li data-end=\"713\" data-start=\"691\">Lavaboyu yerleştirin.</li>\n</ol>\n<h4 data-end=\"742\" data-start=\"720\"><strong data-end=\"742\" data-start=\"725\">Ürün Ölçüleri</strong></h4>\n<ul>\n<li data-end=\"809\" data-start=\"745\">\n<strong data-end=\"763\" data-start=\"745\">Lavabo Dolabı:</strong> 76 × 43 × 47 cm <em data-end=\"807\" data-start=\"780\">(Lavabo ile toplam 80 cm)</em>\n</li>\n<li data-end=\"834\" data-start=\"812\">\n<strong data-end=\"821\" data-start=\"812\">Ayna:</strong> 80× 64 cm</li>\n<li data-end=\"867\" data-start=\"837\">\n<strong data-end=\"849\" data-start=\"837\">Malzeme:</strong> Melamin kaplama</li>\n</ul>\n<h4 data-end=\"896\" data-start=\"874\"><strong data-end=\"896\" data-start=\"879\">Paket İçeriği</strong></h4>\n<ul>\n<li data-end=\"949\" data-start=\"899\">1 Adet 80 Cm Kapaklı Katlanabilir Lavabo Dolabı</li>\n<li data-end=\"979\" data-start=\"952\">1 Adet Katlanabilir Ayna</li>\n<li data-end=\"1021\" data-start=\"982\">1 Adet SU080 Seramik Etajerli Lavabo</li>\n</ul>\n<p><strong>Not:</strong><span> Armatür, sifon alt grubu ve süzgeç dahil değildir.</span></p>"
  },
  {
    "id": "creavit-10038274818345",
    "brand": "Creavit",
    "title": "Flexio 65 Cm Kapaklı Katlanabilir Lavabo Dolabı 270 Derece Beyaz Set",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7947.jpg?v=1773142125",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7947.jpg?v=1773142125",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7948.jpg?v=1773142127",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7949.jpg?v=1773142129",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7950.jpg?v=1773142132",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7951.png?v=1773142135",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7952.png?v=1773142137",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7953.png?v=1773142140"
    ],
    "price": "19552.50",
    "sku": "SET.FLXLD065.KPK.270.BYZ",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52915806404905,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.FLXLD065.KPK.270.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "19552.50",
        "grams": 0,
        "compare_at_price": "26070.00",
        "position": 1,
        "product_id": 10038274818345,
        "created_at": "2026-04-02T11:48:14+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<div class=\"markdown prose dark:prose-invert w-full wrap-break-word light markdown-new-styling\">\n<h4 data-section-id=\"1pgj1i0\" data-start=\"135\" data-end=\"200\">Flexio 65 Cm Kapaklı Katlanabilir Beyaz Lavabo Dolabı Seti</h4>\n<p data-start=\"202\" data-end=\"548\">Pratik ve şık <strong data-start=\"216\" data-end=\"258\">Flexio Katlanabilir Lavabo Dolabı Seti</strong>, modern banyolar için tasarlandı. <strong data-start=\"293\" data-end=\"314\">Melamin kaplaması</strong> ve özel kilitleme noktalarıyla defalarca kurulup sökülebilir; <strong data-start=\"377\" data-end=\"400\">ekipman gerektirmez</strong>. Sökme-takma sırasında deformasyon veya rijitlik kaybı olmaz, fuar alanları, taşınmalar veya konsept değişikliklerinde kolayca kullanabilirsiniz.</p>\n<h4 data-start=\"555\" data-end=\"597\"><strong data-start=\"560\" data-end=\"597\">Hızlı Kurulum – 20 Saniyede Hazır</strong></h4>\n<ol>\n<li data-start=\"601\" data-end=\"618\">Kutudan çıkarın.</li>\n<li data-start=\"622\" data-end=\"636\">Gövdeyi dışa katlayın.</li>\n<li data-start=\"640\" data-end=\"664\">Parçaları yerine takın.</li>\n<li data-start=\"668\" data-end=\"687\">Kapakları kapatın.</li>\n<li data-start=\"691\" data-end=\"713\">Lavaboyu yerleştirin.</li>\n</ol>\n<h4 data-start=\"720\" data-end=\"742\"><strong data-start=\"725\" data-end=\"742\">Ürün Ölçüleri</strong></h4>\n<ul>\n<li data-start=\"745\" data-end=\"809\">\n<strong data-start=\"745\" data-end=\"763\">Lavabo Dolabı:</strong> 61 × 43 × 47 cm <em data-start=\"780\" data-end=\"807\">(Lavabo ile toplam 65 cm)</em>\n</li>\n<li data-start=\"812\" data-end=\"834\">\n<strong data-start=\"812\" data-end=\"821\">Ayna:</strong> 60 × 64 cm</li>\n<li data-start=\"837\" data-end=\"867\">\n<strong data-start=\"837\" data-end=\"849\">Malzeme:</strong> Melamin kaplama</li>\n</ul>\n<h4 data-start=\"874\" data-end=\"896\"><strong data-start=\"879\" data-end=\"896\">Paket İçeriği</strong></h4>\n<ul>\n<li data-start=\"899\" data-end=\"949\">1 Adet 65 Cm Kapaklı Katlanabilir Lavabo Dolabı</li>\n<li data-start=\"952\" data-end=\"979\">1 Adet Katlanabilir Ayna</li>\n<li data-start=\"982\" data-end=\"1021\">1 Adet SU065 Seramik Etajerli Lavabo</li>\n</ul>\n<p><strong style=\"font-size: 0.875rem;\">Not:</strong><span style=\"font-size: 0.875rem;\"> Armatür, sifon alt grubu ve süzgeç dahil değildir.</span></p>\n<span></span>\n</div>"
  },
  {
    "id": "creavit-10038272393513",
    "brand": "Creavit",
    "title": "Flexio 65 Cm Kapaklı Katlanabilir Lavabo Dolabı 270 Derece Antrasit Set",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/flexio-65-cm-kapakli-lavabo-dolabi-270-derece-antrasit-set-7921.jpg?v=1773141720",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/flexio-65-cm-kapakli-lavabo-dolabi-270-derece-antrasit-set-7921.jpg?v=1773141720",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/flexio-65-cm-kapakli-lavabo-dolabi-270-derece-antrasit-set-7922.jpg?v=1773141722",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/flexio-65-cm-kapakli-lavabo-dolabi-270-derece-antrasit-set-7923.jpg?v=1773141724",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/flexio-65-cm-kapakli-lavabo-dolabi-270-derece-antrasit-set-7924.jpg?v=1773141726",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/flexio-65-cm-kapakli-lavabo-dolabi-270-derece-antrasit-set-7946.png?v=1773141728"
    ],
    "price": "19552.50",
    "sku": "SET.FLXLD065.KPK.270.ANT",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52912926589225,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.FLXLD065.KPK.270.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "19552.50",
        "grams": 0,
        "compare_at_price": "26070.00",
        "position": 1,
        "product_id": 10038272393513,
        "created_at": "2026-04-01T17:36:46+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<div class=\"flex max-w-full flex-col gap-4 grow\">\n<div class=\"min-h-8 text-message relative flex w-full flex-col items-end gap-2 text-start break-words whitespace-normal [.text-message+&amp;]:mt-1\" data-message-model-slug=\"gpt-5-3\" data-message-id=\"eda13c8e-f711-43c1-85cf-fbe663f7d0e6\" data-message-author-role=\"assistant\">\n<div class=\"flex w-full flex-col gap-1 empty:hidden\">\n<div class=\"markdown prose dark:prose-invert w-full wrap-break-word light markdown-new-styling\">\n<h4 data-end=\"200\" data-start=\"135\" data-section-id=\"1pgj1i0\">Flexio 65 Cm Kapaklı Katlanabilir Antrasit Lavabo Dolabı Seti</h4>\n<p data-end=\"548\" data-start=\"202\">Pratik ve şık <strong data-end=\"258\" data-start=\"216\">Flexio Katlanabilir Lavabo Dolabı Seti</strong>, modern banyolar için tasarlandı. <strong data-end=\"314\" data-start=\"293\">Melamin kaplaması</strong> ve özel kilitleme noktalarıyla defalarca kurulup sökülebilir; <strong data-end=\"400\" data-start=\"377\">ekipman gerektirmez</strong>. Sökme-takma sırasında deformasyon veya rijitlik kaybı olmaz, fuar alanları, taşınmalar veya konsept değişikliklerinde kolayca kullanabilirsiniz.</p>\n<h4 data-end=\"597\" data-start=\"555\"><strong data-end=\"597\" data-start=\"560\">Hızlı Kurulum – 20 Saniyede Hazır</strong></h4>\n<ol>\n<li data-end=\"618\" data-start=\"601\">Kutudan çıkarın</li>\n<li data-end=\"636\" data-start=\"622\">Gövdeyi açın</li>\n<li data-end=\"664\" data-start=\"640\">Parçaları yerine takın</li>\n<li data-end=\"687\" data-start=\"668\">Kapakları kapatın</li>\n<li data-end=\"713\" data-start=\"691\">Lavaboyu yerleştirin</li>\n</ol>\n<h4 data-end=\"742\" data-start=\"720\"><strong data-end=\"742\" data-start=\"725\">Ürün Ölçüleri</strong></h4>\n<ul>\n<li data-end=\"809\" data-start=\"745\">\n<strong data-end=\"763\" data-start=\"745\">Lavabo Dolabı:</strong> 61 × 43 × 47 cm <em data-end=\"807\" data-start=\"780\">(Lavabo ile toplam 65 cm)</em>\n</li>\n<li data-end=\"834\" data-start=\"812\">\n<strong data-end=\"821\" data-start=\"812\">Ayna:</strong> 60 × 64 cm</li>\n<li data-end=\"867\" data-start=\"837\">\n<strong data-end=\"849\" data-start=\"837\">Malzeme:</strong> Melamin kaplama</li>\n</ul>\n<h4 data-end=\"896\" data-start=\"874\"><strong data-end=\"896\" data-start=\"879\">Paket İçeriği</strong></h4>\n<ul>\n<li data-end=\"949\" data-start=\"899\">1 Adet 65 Cm Kapaklı Katlanabilir Lavabo Dolabı</li>\n<li data-end=\"979\" data-start=\"952\">1 Adet Katlanabilir Ayna</li>\n<li data-end=\"1021\" data-start=\"982\">1 Adet SU065 Seramik Etajerli Lavabo<strong style=\"font-size: 0.875rem;\"></strong>\n</li>\n</ul>\n<p><strong style=\"font-size: 0.875rem;\">Not:</strong><span style=\"font-size: 0.875rem;\"> Armatür, sifon alt grubu ve süzgeç dahil değildir.</span></p>\n<p data-end=\"65\" data-start=\"0\"> </p>\n<div class=\"z-0 flex min-h-[46px] justify-start\"><br></div>\n<span></span>\n<p> </p>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-10038244999465",
    "brand": "Creavit",
    "title": "Antik Kapaklı 100 Cm Zeytuni Lavabo Dolabı Seti",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7944.jpg?v=1773135043",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7944.jpg?v=1773135043",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7945.jpg?v=1773135045"
    ],
    "price": "68227.50",
    "sku": "SET.LD101.KPK.ZEY",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "boy dolabı",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52843254382889,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.LD101.KPK.ZEY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "68227.50",
        "grams": 0,
        "compare_at_price": "90970.00",
        "position": 1,
        "product_id": 10038244999465,
        "created_at": "2026-03-17T13:07:50+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h4 data-start=\"143\" data-end=\"205\" data-section-id=\"tuv5j2\">Antik 100 Cm Zeytuni Kapaklı Lavabo Dolabı Banyo Seti</h4>\r\n<p data-start=\"207\" data-end=\"546\">Klasik tasarım anlayışının modern detaylarla buluştuğu <strong data-start=\"262\" data-end=\"287\">Antik Banyo Mobilyası</strong>, Creavit Design Team imzası taşır. Dengeli formu, sade antrasit rengi ve zarif çizgileri sayesinde banyolarda sıcak ve zamansız bir atmosfer oluşturur. Fonksiyonel çekmeceleri ile hem düzenli depolama alanı sağlar hem de banyonuza şık bir görünüm kazandırır.</p>\r\n<h4 data-start=\"553\" data-end=\"569\" data-section-id=\"1ks1ami\">Ürün Ölçüleri</h4>\r\n<p data-start=\"571\" data-end=\"590\"><strong data-start=\"571\" data-end=\"588\">Lavabo Dolabı</strong></p>\r\n<ul>\r\n<li data-start=\"593\" data-end=\"610\">Genişlik: 97 Cm</li>\r\n<li data-start=\"613\" data-end=\"630\">Derinlik: 48 Cm</li>\r\n<li data-start=\"633\" data-end=\"651\">Yükseklik: 61 Cm</li>\r\n<li data-start=\"654\" data-end=\"700\">Lavabo ile birlikte toplam genişlik: <strong data-start=\"691\" data-end=\"700\">100 Cm</strong>\n</li>\n</ul>\r\n<p data-start=\"702\" data-end=\"718\"><strong data-start=\"702\" data-end=\"716\">Boy Dolabı</strong></p>\r\n<ul>\r\n<li data-start=\"721\" data-end=\"738\">Genişlik: 40 Cm</li>\r\n<li data-start=\"741\" data-end=\"758\">Derinlik: 40 Cm</li>\r\n<li data-start=\"761\" data-end=\"780\">Yükseklik: 160 Cm</li>\n</ul>\r\n<p data-start=\"782\" data-end=\"792\"><strong data-start=\"782\" data-end=\"790\">Ayna</strong></p>\r\n<ul>\r\n<li data-start=\"795\" data-end=\"805\">60 × 80 Cm</li>\n</ul>\r\n<h4 data-start=\"812\" data-end=\"831\" data-section-id=\"nlixhc\">Ürün Özellikleri</h4>\r\n<ul>\r\n<li data-start=\"835\" data-end=\"874\">%100 <strong data-start=\"840\" data-end=\"858\">MDF malzemeden</strong> üretilmiştir.</li>\r\n<li data-start=\"877\" data-end=\"933\">Dayanıklı yapısı sayesinde uzun ömürlü kullanım sunar.</li>\r\n<li data-start=\"936\" data-end=\"1002\">Kapaklı lavabo dolabı ile <strong data-start=\"951\" data-end=\"987\">pratik ve düzenli depolama alanı</strong> sağlar.</li>\r\n<li data-start=\"1005\" data-end=\"1085\">Modern <strong data-start=\"1012\" data-end=\"1029\">zeytuni renk</strong> ile banyolara şık ve bütüncül bir görünüm kazandırır.</li>\r\n<li data-start=\"1088\" data-end=\"1176\">Fonksiyonel ve estetik tasarımı sayesinde hem küçük hem de büyük banyolar için uygundur.</li>\n</ul>\r\n<h4 data-start=\"1183\" data-end=\"1199\" data-section-id=\"10q5435\">Paket İçeriği</h4>\r\n<ul>\r\n<li data-start=\"1203\" data-end=\"1249\">1 Adet <strong data-start=\"1210\" data-end=\"1247\">100 Cm İki Kapaklı Lavabo Dolabı</strong>\n</li>\r\n<li data-start=\"1252\" data-end=\"1275\">1 Adet <strong data-start=\"1259\" data-end=\"1273\">Boy Dolabı</strong>\n</li>\r\n<li data-start=\"1278\" data-end=\"1295\">1 Adet <strong data-start=\"1285\" data-end=\"1293\">Ayna</strong>\n</li>\r\n<li data-start=\"1298\" data-end=\"1344\">1 Adet <strong data-start=\"1305\" data-end=\"1344\">AN101 Kodlu Seramik Etajerli Lavabo</strong>\n</li>\n</ul>\r\n<p data-start=\"1351\" data-end=\"1418\"><strong data-start=\"1351\" data-end=\"1359\">Not: </strong>Armatür, sifon alt grubu ve süzgeç ürüne dahil değildir.</p>"
  },
  {
    "id": "creavit-10038241689897",
    "brand": "Creavit",
    "title": "Antik Kapaklı 100 Cm Antrasit Lavabo Dolabı Seti",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7942.jpg?v=1773134727",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7942.jpg?v=1773134727",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7943.jpg?v=1773134730"
    ],
    "price": "68227.50",
    "sku": "SET.LD101.KPK.ANT",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "boy dolabı",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı",
      "Sağ Boy Dolabı"
    ],
    "variants": [
      {
        "id": 52843254186281,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.LD101.KPK.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "68227.50",
        "grams": 0,
        "compare_at_price": "90970.00",
        "position": 1,
        "product_id": 10038241689897,
        "created_at": "2026-03-17T13:07:47+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<h4 data-section-id=\"tuv5j2\" data-end=\"205\" data-start=\"143\">Antik 100 Cm Antrasit Kapaklı Lavabo Dolabı Banyo Seti</h4>\r\n<p data-end=\"546\" data-start=\"207\">Klasik tasarım anlayışının modern detaylarla buluştuğu <strong data-end=\"287\" data-start=\"262\">Antik Banyo Mobilyası</strong>, Creavit Design Team imzası taşır. Dengeli formu, sade antrasit rengi ve zarif çizgileri sayesinde banyolarda sıcak ve zamansız bir atmosfer oluşturur. Fonksiyonel çekmeceleri ile hem düzenli depolama alanı sağlar hem de banyonuza şık bir görünüm kazandırır.</p>\r\n<h4 data-section-id=\"1ks1ami\" data-end=\"569\" data-start=\"553\">Ürün Ölçüleri</h4>\r\n<p data-end=\"590\" data-start=\"571\"><strong data-end=\"588\" data-start=\"571\">Lavabo Dolabı</strong></p>\r\n<ul>\r\n<li data-end=\"610\" data-start=\"593\">Genişlik: 97 Cm</li>\r\n<li data-end=\"630\" data-start=\"613\">Derinlik: 48 Cm</li>\r\n<li data-end=\"651\" data-start=\"633\">Yükseklik: 61 Cm</li>\r\n<li data-end=\"700\" data-start=\"654\">Lavabo ile birlikte toplam genişlik: <strong data-end=\"700\" data-start=\"691\">100 Cm</strong>\n</li>\n</ul>\r\n<p data-end=\"718\" data-start=\"702\"><strong data-end=\"716\" data-start=\"702\">Boy Dolabı</strong></p>\r\n<ul>\r\n<li data-end=\"738\" data-start=\"721\">Genişlik: 40 Cm</li>\r\n<li data-end=\"758\" data-start=\"741\">Derinlik: 40 Cm</li>\r\n<li data-end=\"780\" data-start=\"761\">Yükseklik: 160 Cm</li>\n</ul>\r\n<p data-end=\"792\" data-start=\"782\"><strong data-end=\"790\" data-start=\"782\">Ayna</strong></p>\r\n<ul>\r\n<li data-end=\"805\" data-start=\"795\">60 × 80 Cm</li>\n</ul>\r\n<h4 data-section-id=\"nlixhc\" data-end=\"831\" data-start=\"812\">Ürün Özellikleri</h4>\r\n<ul>\r\n<li data-end=\"874\" data-start=\"835\">%100 <strong data-end=\"858\" data-start=\"840\">MDF malzemeden</strong> üretilmiştir.</li>\r\n<li data-end=\"933\" data-start=\"877\">Dayanıklı yapısı sayesinde uzun ömürlü kullanım sunar.</li>\r\n<li data-end=\"1002\" data-start=\"936\">Kapaklı lavabo dolabı ile <strong data-end=\"987\" data-start=\"951\">pratik ve düzenli depolama alanı</strong> sağlar.</li>\r\n<li data-end=\"1085\" data-start=\"1005\">Modern <strong data-end=\"1029\" data-start=\"1012\">antrasit renk</strong> ile banyolara şık ve bütüncül bir görünüm kazandırır.</li>\r\n<li data-end=\"1176\" data-start=\"1088\">Fonksiyonel ve estetik tasarımı sayesinde hem küçük hem de büyük banyolar için uygundur.</li>\n</ul>\r\n<h4 data-section-id=\"10q5435\" data-end=\"1199\" data-start=\"1183\">Paket İçeriği</h4>\r\n<ul>\r\n<li data-end=\"1249\" data-start=\"1203\">1 Adet <strong data-end=\"1247\" data-start=\"1210\">100 Cm İki Kapaklı Lavabo Dolabı</strong>\n</li>\r\n<li data-end=\"1275\" data-start=\"1252\">1 Adet <strong data-end=\"1273\" data-start=\"1259\">Boy Dolabı</strong>\n</li>\r\n<li data-end=\"1295\" data-start=\"1278\">1 Adet <strong data-end=\"1293\" data-start=\"1285\">Ayna</strong>\n</li>\r\n<li data-end=\"1344\" data-start=\"1298\">1 Adet <strong data-end=\"1344\" data-start=\"1305\">AN101 Kodlu Seramik Etajerli Lavabo</strong>\n</li>\n</ul>\r\n<p data-end=\"1418\" data-start=\"1351\"><strong data-end=\"1359\" data-start=\"1351\">Not: </strong>Armatür, sifon alt grubu ve süzgeç ürüne dahil değildir.</p>"
  },
  {
    "id": "creavit-10038236381481",
    "brand": "Creavit",
    "title": "Antik İki Çekmeceli 100 Cm Zeytuni Lavabo Dolabı Seti",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7940.jpg?v=1773133298",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7940.jpg?v=1773133298",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7941.jpg?v=1773133300"
    ],
    "price": "94545.00",
    "sku": "SET.LD101.2CK.ZEY",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "boy dolabı",
      "Düz Ayna",
      "Lavabo Dolabı",
      "Sağ Boy Dolabı",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843254055209,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.LD101.2CK.ZEY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "94545.00",
        "grams": 0,
        "compare_at_price": "126060.00",
        "position": 1,
        "product_id": 10038236381481,
        "created_at": "2026-03-17T13:07:44+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<h4 data-start=\"143\" data-end=\"205\" data-section-id=\"tuv5j2\">Antik 100 Cm Zeytuni İki Çekmeceli Lavabo Dolabı Banyo Seti</h4>\r\n<p data-start=\"207\" data-end=\"546\">Klasik tasarım anlayışının modern detaylarla buluştuğu <strong data-start=\"262\" data-end=\"287\">Antik Banyo Mobilyası</strong>, Creavit Design Team imzası taşır. Dengeli formu, sade antrasit rengi ve zarif çizgileri sayesinde banyolarda sıcak ve zamansız bir atmosfer oluşturur. Fonksiyonel çekmeceleri ile hem düzenli depolama alanı sağlar hem de banyonuza şık bir görünüm kazandırır.</p>\r\n<h4 data-start=\"553\" data-end=\"569\" data-section-id=\"1ks1ami\">Ürün Ölçüleri</h4>\r\n<p data-start=\"571\" data-end=\"590\"><strong data-start=\"571\" data-end=\"588\">Lavabo Dolabı</strong></p>\r\n<ul>\r\n<li data-start=\"593\" data-end=\"610\">Genişlik: 97 Cm</li>\r\n<li data-start=\"613\" data-end=\"630\">Derinlik: 48 Cm</li>\r\n<li data-start=\"633\" data-end=\"651\">Yükseklik: 61 Cm</li>\r\n<li data-start=\"654\" data-end=\"700\">Lavabo ile birlikte toplam genişlik: <strong data-start=\"691\" data-end=\"700\">100 Cm</strong>\n</li>\n</ul>\r\n<p data-start=\"702\" data-end=\"718\"><strong data-start=\"702\" data-end=\"716\">Boy Dolabı</strong></p>\r\n<ul>\r\n<li data-start=\"721\" data-end=\"738\">Genişlik: 40 Cm</li>\r\n<li data-start=\"741\" data-end=\"758\">Derinlik: 40 Cm</li>\r\n<li data-start=\"761\" data-end=\"780\">Yükseklik: 160 Cm</li>\n</ul>\r\n<p data-start=\"782\" data-end=\"792\"><strong data-start=\"782\" data-end=\"790\">Ayna</strong></p>\r\n<ul>\r\n<li data-start=\"795\" data-end=\"805\">60 × 80 Cm</li>\n</ul>\r\n<h4 data-start=\"812\" data-end=\"831\" data-section-id=\"nlixhc\">Ürün Özellikleri</h4>\r\n<ul>\r\n<li data-start=\"835\" data-end=\"874\">%100 <strong data-start=\"840\" data-end=\"858\">MDF malzemeden</strong> üretilmiştir.</li>\r\n<li data-start=\"877\" data-end=\"933\">Dayanıklı yapısı sayesinde uzun ömürlü kullanım sunar.</li>\r\n<li data-start=\"936\" data-end=\"1002\">İki çekmeceli lavabo dolabı ile <strong data-start=\"968\" data-end=\"992\">geniş depolama alanı</strong> sağlar.</li>\r\n<li data-start=\"1005\" data-end=\"1085\">Modern<strong data-start=\"1012\" data-end=\"1029\"> zeytuni renk</strong> ile banyolara şık ve bütüncül bir görünüm kazandırır.</li>\r\n<li data-start=\"1088\" data-end=\"1176\">Fonksiyonel ve estetik tasarımı sayesinde hem küçük hem de büyük banyolar için uygundur.</li>\n</ul>\r\n<h4 data-start=\"1183\" data-end=\"1199\" data-section-id=\"10q5435\">Paket İçeriği</h4>\r\n<ul>\r\n<li data-start=\"1203\" data-end=\"1249\">1 Adet <strong data-start=\"1210\" data-end=\"1247\">100 Cm İki Çekmeceli Lavabo Dolabı</strong>\n</li>\r\n<li data-start=\"1252\" data-end=\"1275\">1 Adet <strong data-start=\"1259\" data-end=\"1273\">Boy Dolabı</strong>\n</li>\r\n<li data-start=\"1278\" data-end=\"1295\">1 Adet <strong data-start=\"1285\" data-end=\"1293\">Ayna</strong>\n</li>\r\n<li data-start=\"1298\" data-end=\"1344\">1 Adet <strong data-start=\"1305\" data-end=\"1344\">AN101 Kodlu Seramik Etajerli Lavabo</strong>\n</li>\n</ul>\r\n<p data-start=\"1351\" data-end=\"1418\"><strong data-start=\"1351\" data-end=\"1359\">Not: </strong>Armatür, sifon alt grubu ve süzgeç ürüne dahil değildir.</p>"
  },
  {
    "id": "creavit-10038234743081",
    "brand": "Creavit",
    "title": "Antik İki Çekmeceli 100 Cm Antrasit Lavabo Dolabı Seti",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7938.jpg?v=1773132565",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7938.jpg?v=1773132565",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7939.jpg?v=1773132566"
    ],
    "price": "94545.00",
    "sku": "SET.LD101.2CK.ANT",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "boy dolabı",
      "Lavabo Dolabı",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843253956905,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.LD101.2CK.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "94545.00",
        "grams": 0,
        "compare_at_price": "126060.00",
        "position": 1,
        "product_id": 10038234743081,
        "created_at": "2026-03-17T13:07:41+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\n<h4 data-start=\"143\" data-end=\"205\" data-section-id=\"tuv5j2\">Antik 100 Cm Antrasit İki Çekmeceli Lavabo Dolabı Banyo Seti</h4>\n<p data-start=\"207\" data-end=\"546\">Klasik tasarım anlayışının modern detaylarla buluştuğu <strong data-start=\"262\" data-end=\"287\">Antik Banyo Mobilyası</strong>, Creavit Design Team imzası taşır. Dengeli formu, sade antrasit rengi ve zarif çizgileri sayesinde banyolarda sıcak ve zamansız bir atmosfer oluşturur. Fonksiyonel çekmeceleri ile hem düzenli depolama alanı sağlar hem de banyonuza şık bir görünüm kazandırır.</p>\n<h4 data-start=\"553\" data-end=\"569\" data-section-id=\"1ks1ami\">Ürün Ölçüleri</h4>\n<p data-start=\"571\" data-end=\"590\"><strong data-start=\"571\" data-end=\"588\">Lavabo Dolabı</strong></p>\n<ul>\n<li data-start=\"593\" data-end=\"610\">Genişlik: 97 Cm</li>\n<li data-start=\"613\" data-end=\"630\">Derinlik: 48 Cm</li>\n<li data-start=\"633\" data-end=\"651\">Yükseklik: 61 Cm</li>\n<li data-start=\"654\" data-end=\"700\">Lavabo ile birlikte toplam genişlik: <strong data-start=\"691\" data-end=\"700\">100 Cm</strong>\n</li>\n</ul>\n<p data-start=\"702\" data-end=\"718\"><strong data-start=\"702\" data-end=\"716\">Boy Dolabı</strong></p>\n<ul>\n<li data-start=\"721\" data-end=\"738\">Genişlik: 40 Cm</li>\n<li data-start=\"741\" data-end=\"758\">Derinlik: 40 Cm</li>\n<li data-start=\"761\" data-end=\"780\">Yükseklik: 160 Cm</li>\n</ul>\n<p data-start=\"782\" data-end=\"792\"><strong data-start=\"782\" data-end=\"790\">Ayna</strong></p>\n<ul>\n<li data-start=\"795\" data-end=\"805\">60 × 80 Cm</li>\n</ul>\n<h4 data-start=\"812\" data-end=\"831\" data-section-id=\"nlixhc\">Ürün Özellikleri</h4>\n<ul>\n<li data-start=\"835\" data-end=\"874\">%100 <strong data-start=\"840\" data-end=\"858\">MDF malzemeden</strong> üretilmiştir.</li>\n<li data-start=\"877\" data-end=\"933\">Dayanıklı yapısı sayesinde uzun ömürlü kullanım sunar.</li>\n<li data-start=\"936\" data-end=\"1002\">İki çekmeceli lavabo dolabı ile <strong data-start=\"968\" data-end=\"992\">geniş depolama alanı</strong> sağlar.</li>\n<li data-start=\"1005\" data-end=\"1085\">Modern <strong data-start=\"1012\" data-end=\"1029\">antrasit renk</strong> ile banyolara şık ve bütüncül bir görünüm kazandırır.</li>\n<li data-start=\"1088\" data-end=\"1176\">Fonksiyonel ve estetik tasarımı sayesinde hem küçük hem de büyük banyolar için uygundur.</li>\n</ul>\n<h4 data-start=\"1183\" data-end=\"1199\" data-section-id=\"10q5435\">Paket İçeriği</h4>\n<ul>\n<li data-start=\"1203\" data-end=\"1249\">1 Adet <strong data-start=\"1210\" data-end=\"1247\">100 Cm İki Çekmeceli Lavabo Dolabı</strong>\n</li>\n<li data-start=\"1252\" data-end=\"1275\">1 Adet <strong data-start=\"1259\" data-end=\"1273\">Boy Dolabı</strong>\n</li>\n<li data-start=\"1278\" data-end=\"1295\">1 Adet <strong data-start=\"1285\" data-end=\"1293\">Ayna</strong>\n</li>\n<li data-start=\"1298\" data-end=\"1344\">1 Adet <strong data-start=\"1305\" data-end=\"1344\">AN101 Kodlu Seramik Etajerli Lavabo</strong>\n</li>\n</ul>\n<p data-start=\"1351\" data-end=\"1418\"><strong data-start=\"1351\" data-end=\"1359\">Not: </strong>Armatür, sifon alt grubu ve süzgeç ürüne dahil değildir.</p>"
  },
  {
    "id": "creavit-10038223405353",
    "brand": "Creavit",
    "title": "Antik Kapaklı 80 Cm Zeytuni Lavabo Dolabı Seti",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7936.jpg?v=1773129286",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7936.jpg?v=1773129286",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7937.jpg?v=1773129288"
    ],
    "price": "63525.00",
    "sku": "SET.LD081.KPK.ZEY",
    "tags": [
      "Ayna",
      "Banyo Mobilyası",
      "boy dolabı",
      "kapaklı lavabo dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843253793065,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.LD081.KPK.ZEY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "63525.00",
        "grams": 0,
        "compare_at_price": "84700.00",
        "position": 1,
        "product_id": 10038223405353,
        "created_at": "2026-03-17T13:07:37+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\n<h4 data-start=\"143\" data-end=\"205\" data-section-id=\"tuv5j2\">Antik 80 Cm Zeytuni Kapaklı Lavabo Dolabı Banyo Seti</h4>\n<p data-start=\"207\" data-end=\"546\">Klasik tasarım anlayışının modern detaylarla buluştuğu <strong data-start=\"262\" data-end=\"287\">Antik Banyo Mobilyası</strong>, Creavit Design Team imzası taşır. Dengeli formu, sade antrasit rengi ve zarif çizgileri sayesinde banyolarda sıcak ve zamansız bir atmosfer oluşturur. Fonksiyonel çekmeceleri ile hem düzenli depolama alanı sağlar hem de banyonuza şık bir görünüm kazandırır.</p>\n<h4 data-start=\"553\" data-end=\"569\" data-section-id=\"1ks1ami\">Ürün Ölçüleri</h4>\n<p data-start=\"571\" data-end=\"590\"><strong data-start=\"571\" data-end=\"588\">Lavabo Dolabı</strong></p>\n<ul>\n<li data-start=\"593\" data-end=\"610\">Genişlik: 77 Cm</li>\n<li data-start=\"613\" data-end=\"630\">Derinlik: 48 Cm</li>\n<li data-start=\"633\" data-end=\"651\">Yükseklik: 61 Cm</li>\n<li data-start=\"654\" data-end=\"700\">Lavabo ile birlikte toplam genişlik: <strong data-start=\"691\" data-end=\"700\">80 Cm</strong>\n</li>\n</ul>\n<p data-start=\"702\" data-end=\"718\"><strong data-start=\"702\" data-end=\"716\">Boy Dolabı</strong></p>\n<ul>\n<li data-start=\"721\" data-end=\"738\">Genişlik: 40 Cm</li>\n<li data-start=\"741\" data-end=\"758\">Derinlik: 40 Cm</li>\n<li data-start=\"761\" data-end=\"780\">Yükseklik: 160 Cm</li>\n</ul>\n<p data-start=\"782\" data-end=\"792\"><strong data-start=\"782\" data-end=\"790\">Ayna</strong></p>\n<ul>\n<li data-start=\"795\" data-end=\"805\">60 × 80 Cm</li>\n</ul>\n<h4 data-start=\"812\" data-end=\"831\" data-section-id=\"nlixhc\">Ürün Özellikleri</h4>\n<ul>\n<li data-start=\"835\" data-end=\"874\">%100 <strong data-start=\"840\" data-end=\"858\">MDF malzemeden</strong> üretilmiştir.</li>\n<li data-start=\"877\" data-end=\"933\">Dayanıklı yapısı sayesinde uzun ömürlü kullanım sunar.</li>\n<li data-start=\"936\" data-end=\"1002\">Kapaklı lavabo dolabı ile <strong data-end=\"987\" data-start=\"951\">pratik ve düzenli depolama alanı</strong> sağlar.</li>\n<li data-start=\"1005\" data-end=\"1085\">Modern <strong data-start=\"1012\" data-end=\"1029\">zeytuni renk</strong> ile banyolara şık ve bütüncül bir görünüm kazandırır.</li>\n<li data-start=\"1088\" data-end=\"1176\">Fonksiyonel ve estetik tasarımı sayesinde hem küçük hem de büyük banyolar için uygundur.</li>\n</ul>\n<h4 data-start=\"1183\" data-end=\"1199\" data-section-id=\"10q5435\">Paket İçeriği</h4>\n<ul>\n<li data-start=\"1203\" data-end=\"1249\">1 Adet <strong data-start=\"1210\" data-end=\"1247\">80 Cm İki Kapaklı Lavabo Dolabı</strong>\n</li>\n<li data-start=\"1252\" data-end=\"1275\">1 Adet <strong data-start=\"1259\" data-end=\"1273\">Boy Dolabı</strong>\n</li>\n<li data-start=\"1278\" data-end=\"1295\">1 Adet <strong data-start=\"1285\" data-end=\"1293\">Ayna</strong>\n</li>\n<li data-start=\"1298\" data-end=\"1344\">1 Adet <strong data-start=\"1305\" data-end=\"1344\">AN081 Kodlu Seramik Etajerli Lavabo</strong>\n</li>\n</ul>\n<p data-start=\"1351\" data-end=\"1418\"><strong data-start=\"1351\" data-end=\"1359\">Not: </strong>Armatür, sifon alt grubu ve süzgeç ürüne dahil değildir.</p>"
  },
  {
    "id": "creavit-10038219931945",
    "brand": "Creavit",
    "title": "Antik Kapaklı 80 Cm Antrasit Lavabo Dolabı Seti",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ANTIK.ANT.80CM.KPK.ON_1.jpg?v=1773128045",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ANTIK.ANT.80CM.KPK.ON_1.jpg?v=1773128045",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7935.jpg?v=1773128045"
    ],
    "price": "63525.00",
    "sku": "SET.LD081.KPK.ANT",
    "tags": [
      "Ayna",
      "Banyo Mobilyası",
      "boy dolabı",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52843253661993,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.LD081.KPK.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "63525.00",
        "grams": 0,
        "compare_at_price": "84700.00",
        "position": 1,
        "product_id": 10038219931945,
        "created_at": "2026-03-17T13:07:34+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<div class=\"[--thread-content-max-width:40rem] @w-lg/main:[--thread-content-max-width:48rem] mx-auto max-w-(--thread-content-max-width) flex-1 group/turn-messages focus-visible:outline-hidden relative flex w-full min-w-0 flex-col agent-turn\" tabindex=\"-1\">\n<h4 data-start=\"143\" data-end=\"205\" data-section-id=\"tuv5j2\">Antik 80 Cm Antrasit Kapaklı Lavabo Dolabı Banyo Seti</h4>\n<p data-start=\"207\" data-end=\"546\">Klasik tasarım anlayışının modern detaylarla buluştuğu <strong data-start=\"262\" data-end=\"287\">Antik Banyo Mobilyası</strong>, Creavit Design Team imzası taşır. Dengeli formu, sade antrasit rengi ve zarif çizgileri sayesinde banyolarda sıcak ve zamansız bir atmosfer oluşturur. Fonksiyonel çekmeceleri ile hem düzenli depolama alanı sağlar hem de banyonuza şık bir görünüm kazandırır.</p>\n<h4 data-start=\"553\" data-end=\"569\" data-section-id=\"1ks1ami\">Ürün Ölçüleri</h4>\n<p data-start=\"571\" data-end=\"590\"><strong data-start=\"571\" data-end=\"588\">Lavabo Dolabı</strong></p>\n<ul>\n<li data-start=\"593\" data-end=\"610\">Genişlik: 77 Cm</li>\n<li data-start=\"613\" data-end=\"630\">Derinlik: 48 Cm</li>\n<li data-start=\"633\" data-end=\"651\">Yükseklik: 61 Cm</li>\n<li data-start=\"654\" data-end=\"700\">Lavabo ile birlikte toplam genişlik: <strong data-start=\"691\" data-end=\"700\">80 Cm</strong>\n</li>\n</ul>\n<p data-start=\"702\" data-end=\"718\"><strong data-start=\"702\" data-end=\"716\">Boy Dolabı</strong></p>\n<ul>\n<li data-start=\"721\" data-end=\"738\">Genişlik: 40 Cm</li>\n<li data-start=\"741\" data-end=\"758\">Derinlik: 40 Cm</li>\n<li data-start=\"761\" data-end=\"780\">Yükseklik: 160 Cm</li>\n</ul>\n<p data-start=\"782\" data-end=\"792\"><strong data-start=\"782\" data-end=\"790\">Ayna</strong></p>\n<ul>\n<li data-start=\"795\" data-end=\"805\">60 × 80 Cm</li>\n</ul>\n<h4 data-start=\"812\" data-end=\"831\" data-section-id=\"nlixhc\">Ürün Özellikleri</h4>\n<ul>\n<li data-start=\"835\" data-end=\"874\">%100 <strong data-start=\"840\" data-end=\"858\">MDF malzemeden</strong> üretilmiştir.</li>\n<li data-start=\"877\" data-end=\"933\">Dayanıklı yapısı sayesinde uzun ömürlü kullanım sunar.</li>\n<li data-start=\"936\" data-end=\"1002\">Kapaklı lavabo dolabı ile <strong data-start=\"951\" data-end=\"987\">pratik ve düzenli depolama alanı</strong> sağlar.</li>\n<li data-start=\"1005\" data-end=\"1085\">Modern <strong data-start=\"1012\" data-end=\"1029\">antrasit renk</strong> ile banyolara şık ve bütüncül bir görünüm kazandırır.</li>\n<li data-start=\"1088\" data-end=\"1176\">Fonksiyonel ve estetik tasarımı sayesinde hem küçük hem de büyük banyolar için uygundur.</li>\n</ul>\n<h4 data-start=\"1183\" data-end=\"1199\" data-section-id=\"10q5435\">Paket İçeriği</h4>\n<ul>\n<li data-start=\"1203\" data-end=\"1249\">1 Adet <strong data-start=\"1210\" data-end=\"1247\">80 Cm İki Kapaklı Lavabo Dolabı</strong>\n</li>\n<li data-start=\"1252\" data-end=\"1275\">1 Adet <strong data-start=\"1259\" data-end=\"1273\">Boy Dolabı</strong>\n</li>\n<li data-start=\"1278\" data-end=\"1295\">1 Adet <strong data-start=\"1285\" data-end=\"1293\">Ayna</strong>\n</li>\n<li data-start=\"1298\" data-end=\"1344\">1 Adet <strong data-start=\"1305\" data-end=\"1344\">AN081 Kodlu Seramik Etajerli Lavabo</strong>\n</li>\n</ul>\n<p data-start=\"1351\" data-end=\"1418\"><strong data-start=\"1351\" data-end=\"1359\">Not: </strong>Armatür, sifon alt grubu ve süzgeç ürüne dahil değildir.</p>\n</div>"
  },
  {
    "id": "creavit-10038216917289",
    "brand": "Creavit",
    "title": "Antik İki Çekmeceli 80 Cm Zeytuni Lavabo Dolabı Seti",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7932.jpg?v=1773126600",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7932.jpg?v=1773126600",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/7933.jpg?v=1773126602"
    ],
    "price": "89265.00",
    "sku": "SET.LD081.2CK.ZEY",
    "tags": [
      "Ayna",
      "Banyo Mobilyası",
      "boy dolabı",
      "Lavabo Dolabı",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843253498153,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.LD081.2CK.ZEY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "89265.00",
        "grams": 0,
        "compare_at_price": "119020.00",
        "position": 1,
        "product_id": 10038216917289,
        "created_at": "2026-03-17T13:07:31+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h4 data-section-id=\"tuv5j2\" data-end=\"205\" data-start=\"143\">Antik 80 Cm Zeytuni İki Çekmeceli Lavabo Dolabı Banyo Seti</h4>\n<p data-end=\"546\" data-start=\"207\">Klasik tasarım anlayışının modern detaylarla buluştuğu <strong data-end=\"287\" data-start=\"262\">Antik Banyo Mobilyası</strong>, Creavit Design Team imzası taşır. Dengeli formu, sade antrasit rengi ve zarif çizgileri sayesinde banyolarda sıcak ve zamansız bir atmosfer oluşturur. Fonksiyonel çekmeceleri ile hem düzenli depolama alanı sağlar hem de banyonuza şık bir görünüm kazandırır.</p>\n<h4 data-section-id=\"1ks1ami\" data-end=\"569\" data-start=\"553\">Ürün Ölçüleri</h4>\n<p data-end=\"590\" data-start=\"571\"><strong data-end=\"588\" data-start=\"571\">Lavabo Dolabı</strong></p>\n<ul>\n<li data-end=\"610\" data-start=\"593\">Genişlik: 77 Cm</li>\n<li data-end=\"630\" data-start=\"613\">Derinlik: 48 Cm</li>\n<li data-end=\"651\" data-start=\"633\">Yükseklik: 61 Cm</li>\n<li data-end=\"700\" data-start=\"654\">Lavabo ile birlikte toplam genişlik: <strong data-end=\"700\" data-start=\"691\">80 Cm</strong>\n</li>\n</ul>\n<p data-end=\"718\" data-start=\"702\"><strong data-end=\"716\" data-start=\"702\">Boy Dolabı</strong></p>\n<ul>\n<li data-end=\"738\" data-start=\"721\">Genişlik: 40 Cm</li>\n<li data-end=\"758\" data-start=\"741\">Derinlik: 40 Cm</li>\n<li data-end=\"780\" data-start=\"761\">Yükseklik: 160 Cm</li>\n</ul>\n<p data-end=\"792\" data-start=\"782\"><strong data-end=\"790\" data-start=\"782\">Ayna</strong></p>\n<ul>\n<li data-end=\"805\" data-start=\"795\">60 × 80 Cm</li>\n</ul>\n<h4 data-section-id=\"nlixhc\" data-end=\"831\" data-start=\"812\">Ürün Özellikleri</h4>\n<ul>\n<li data-end=\"874\" data-start=\"835\">%100 <strong data-end=\"858\" data-start=\"840\">MDF malzemeden</strong> üretilmiştir.</li>\n<li data-end=\"933\" data-start=\"877\">Dayanıklı yapısı sayesinde uzun ömürlü kullanım sunar.</li>\n<li data-end=\"1002\" data-start=\"936\">İki çekmeceli lavabo dolabı ile <strong data-end=\"992\" data-start=\"968\">geniş depolama alanı</strong> sağlar.</li>\n<li data-end=\"1085\" data-start=\"1005\">Modern <strong data-end=\"1029\" data-start=\"1012\">zeytuni renk</strong> ile banyolara şık ve bütüncül bir görünüm kazandırır.</li>\n<li data-end=\"1176\" data-start=\"1088\">Fonksiyonel ve estetik tasarımı sayesinde hem küçük hem de büyük banyolar için uygundur.</li>\n</ul>\n<h4 data-section-id=\"10q5435\" data-end=\"1199\" data-start=\"1183\">Paket İçeriği</h4>\n<ul>\n<li data-end=\"1249\" data-start=\"1203\">1 Adet <strong data-end=\"1247\" data-start=\"1210\">80 Cm İki Çekmeceli Lavabo Dolabı</strong>\n</li>\n<li data-end=\"1275\" data-start=\"1252\">1 Adet <strong data-end=\"1273\" data-start=\"1259\">Boy Dolabı</strong>\n</li>\n<li data-end=\"1295\" data-start=\"1278\">1 Adet <strong data-end=\"1293\" data-start=\"1285\">Ayna</strong>\n</li>\n<li data-end=\"1344\" data-start=\"1298\">1 Adet <strong data-end=\"1344\" data-start=\"1305\">AN081 Kodlu Seramik Etajerli Lavabo</strong>\n</li>\n</ul>\n<p data-end=\"1418\" data-start=\"1351\"><strong data-end=\"1359\" data-start=\"1351\">Not: </strong>Armatür, sifon alt grubu ve süzgeç ürüne dahil değildir.</p>"
  },
  {
    "id": "creavit-10038202171689",
    "brand": "Creavit",
    "title": "Antik İki Çekmeceli 80 Cm Antrasit Lavabo Dolabı Seti",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-iki-cekmeceli-80-cm-antrasit-lavabo-dolabi-seti-7930.jpg?v=1773125033",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-iki-cekmeceli-80-cm-antrasit-lavabo-dolabi-seti-7930.jpg?v=1773125033",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-iki-cekmeceli-80-cm-antrasit-lavabo-dolabi-seti-7931.jpg?v=1773125035"
    ],
    "price": "89265.00",
    "sku": "SET.LD081.2CK.ANT",
    "tags": [
      "Antrasit",
      "Ayna",
      "Banyo Mobilyası",
      "boy dolabı",
      "Lavabo Dolabı",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843253367081,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.LD081.2CK.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "89265.00",
        "grams": 0,
        "compare_at_price": "119020.00",
        "position": 1,
        "product_id": 10038202171689,
        "created_at": "2026-03-17T13:07:28+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<article data-turn=\"assistant\" data-scroll-anchor=\"false\" data-testid=\"conversation-turn-2\" data-turn-id=\"request-WEB:5ae53063-406a-43ab-8a79-76a791dc9937-0\" class=\"text-token-text-primary w-full focus:outline-none [--shadow-height:45px] has-data-writing-block:pointer-events-none has-data-writing-block:-mt-(--shadow-height) has-data-writing-block:pt-(--shadow-height) [&amp;:has([data-writing-block])&gt;*]:pointer-events-auto scroll-mt-[calc(var(--header-height)+min(200px,max(70px,20svh)))]\" tabindex=\"-1\">\n<div class=\"text-base my-auto mx-auto [--thread-content-margin:var(--thread-content-margin-xs,calc(var(--spacing)*4))] @w-sm/main:[--thread-content-margin:var(--thread-content-margin-sm,calc(var(--spacing)*6))] @w-lg/main:[--thread-content-margin:var(--thread-content-margin-lg,calc(var(--spacing)*16))] px-(--thread-content-margin)\">\n<div class=\"[--thread-content-max-width:40rem] @w-lg/main:[--thread-content-max-width:48rem] mx-auto max-w-(--thread-content-max-width) flex-1 group/turn-messages focus-visible:outline-hidden relative flex w-full min-w-0 flex-col agent-turn\" tabindex=\"-1\">\n<div class=\"flex max-w-full flex-col gap-4 grow\">\n<div data-message-model-slug=\"gpt-5-3\" data-message-id=\"7d822aa1-3e96-4a6f-87a9-a7e0f2d5b152\" data-message-author-role=\"assistant\" class=\"min-h-8 text-message relative flex w-full flex-col items-end gap-2 text-start break-words whitespace-normal [.text-message+&amp;]:mt-1\">\n<div class=\"flex w-full flex-col gap-1 empty:hidden\">\n<div class=\"markdown prose dark:prose-invert w-full wrap-break-word light markdown-new-styling\">\n<h4 data-section-id=\"tuv5j2\" data-end=\"205\" data-start=\"143\">Antik 80 Cm Antrasit İki Çekmeceli Lavabo Dolabı Banyo Seti</h4>\n<p data-end=\"546\" data-start=\"207\">Klasik tasarım anlayışının modern detaylarla buluştuğu <strong data-end=\"287\" data-start=\"262\">Antik Banyo Mobilyası</strong>, Creavit Design Team imzası taşır. Dengeli formu, sade antrasit rengi ve zarif çizgileri sayesinde banyolarda sıcak ve zamansız bir atmosfer oluşturur. Fonksiyonel çekmeceleri ile hem düzenli depolama alanı sağlar hem de banyonuza şık bir görünüm kazandırır.</p>\n<h4 data-section-id=\"1ks1ami\" data-end=\"569\" data-start=\"553\">Ürün Ölçüleri</h4>\n<p data-end=\"590\" data-start=\"571\"><strong data-end=\"588\" data-start=\"571\">Lavabo Dolabı</strong></p>\n<ul>\n<li data-end=\"610\" data-start=\"593\">Genişlik: 77 Cm</li>\n<li data-end=\"630\" data-start=\"613\">Derinlik: 48 Cm</li>\n<li data-end=\"651\" data-start=\"633\">Yükseklik: 61 Cm</li>\n<li data-end=\"700\" data-start=\"654\">Lavabo ile birlikte toplam genişlik: <strong data-end=\"700\" data-start=\"691\">80 Cm</strong>\n</li>\n</ul>\n<p data-end=\"718\" data-start=\"702\"><strong data-end=\"716\" data-start=\"702\">Boy Dolabı</strong></p>\n<ul>\n<li data-end=\"738\" data-start=\"721\">Genişlik: 40 Cm</li>\n<li data-end=\"758\" data-start=\"741\">Derinlik: 40 Cm</li>\n<li data-end=\"780\" data-start=\"761\">Yükseklik: 160 Cm</li>\n</ul>\n<p data-end=\"792\" data-start=\"782\"><strong data-end=\"790\" data-start=\"782\">Ayna</strong></p>\n<ul>\n<li data-end=\"805\" data-start=\"795\">60 × 80 Cm</li>\n</ul>\n<h4 data-section-id=\"nlixhc\" data-end=\"831\" data-start=\"812\">Ürün Özellikleri</h4>\n<ul>\n<li data-end=\"874\" data-start=\"835\">%100 <strong data-end=\"858\" data-start=\"840\">MDF malzemeden</strong> üretilmiştir.</li>\n<li data-end=\"933\" data-start=\"877\">Dayanıklı yapısı sayesinde uzun ömürlü kullanım sunar.</li>\n<li data-end=\"1002\" data-start=\"936\">İki çekmeceli lavabo dolabı ile <strong data-end=\"992\" data-start=\"968\">geniş depolama alanı</strong> sağlar.</li>\n<li data-end=\"1085\" data-start=\"1005\">Modern <strong data-end=\"1029\" data-start=\"1012\">antrasit renk</strong> ile banyolara şık ve bütüncül bir görünüm kazandırır.</li>\n<li data-end=\"1176\" data-start=\"1088\">Fonksiyonel ve estetik tasarımı sayesinde hem küçük hem de büyük banyolar için uygundur.</li>\n</ul>\n<h4 data-section-id=\"10q5435\" data-end=\"1199\" data-start=\"1183\">Paket İçeriği</h4>\n<ul>\n<li data-end=\"1249\" data-start=\"1203\">1 Adet <strong data-end=\"1247\" data-start=\"1210\">80 Cm İki Çekmeceli Lavabo Dolabı</strong>\n</li>\n<li data-end=\"1275\" data-start=\"1252\">1 Adet <strong data-end=\"1273\" data-start=\"1259\">Boy Dolabı</strong>\n</li>\n<li data-end=\"1295\" data-start=\"1278\">1 Adet <strong data-end=\"1293\" data-start=\"1285\">Ayna</strong>\n</li>\n<li data-end=\"1344\" data-start=\"1298\">1 Adet <strong data-end=\"1344\" data-start=\"1305\">AN081 Kodlu Seramik Etajerli Lavabo</strong>\n</li>\n</ul>\n<p data-end=\"1418\" data-start=\"1351\"><strong data-end=\"1359\" data-start=\"1351\">Not: </strong>Armatür, sifon alt grubu ve süzgeç ürüne dahil değildir.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</article>"
  },
  {
    "id": "creavit-10035433767209",
    "brand": "Creavit",
    "title": "D10 50 cm Melamin Raflı Ayna Dafne",
    "category": "462591525161",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-50-cm-melamin-rafli-ayna-dafne-5719.jpg?v=1772627627",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-50-cm-melamin-rafli-ayna-dafne-5719.jpg?v=1772627627",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-50-cm-melamin-rafli-ayna-dafne-5720.jpg?v=1772627630",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-50-cm-melamin-rafli-ayna-dafne-5721_af96e00f-2dca-4f69-b4ae-952cf84324ca.jpg?v=1772627632",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-50-cm-melamin-rafli-ayna-dafne-5722_77c15b76-7766-42d5-80f3-7f7de670d03a.jpg?v=1772627635"
    ],
    "price": "2200.00",
    "sku": "D10.RA050.ML.DAF",
    "tags": [],
    "variants": [
      {
        "id": 52920976572713,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.RA050.ML.DAF",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2200.00",
        "grams": 0,
        "compare_at_price": "2750.00",
        "position": 1,
        "product_id": 10035433767209,
        "created_at": "2026-04-03T12:17:25+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\r\n<p><strong>İçinde Sen Varsın</strong></p>\r\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\r\n<p><strong>Saklama Alanını Belirle</strong></p>\r\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\r\n<p><strong>Renkleri Deneyimle</strong></p>\r\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p><!---->"
  },
  {
    "id": "creavit-10032735158569",
    "brand": "Creavit",
    "title": "Loop Siyah Mat Çanak Lavabo Armatür ve Sifon Başlığı Set",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-siyah-mat-canak-lavabo-armatur-ve-sifon-basligi-set-7925.png?v=1772449553",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-siyah-mat-canak-lavabo-armatur-ve-sifon-basligi-set-7925.png?v=1772449553",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/set1_2.png?v=1772452630",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-siyah-mat-canak-lavabo-armatur-ve-sifon-basligi-set-7926.png?v=1772452630",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-siyah-mat-canak-lavabo-armatur-ve-sifon-basligi-set-7927.png?v=1772452630",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-siyah-mat-canak-lavabo-armatur-ve-sifon-basligi-set-7928.png?v=1772452630",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-siyah-mat-canak-lavabo-armatur-ve-sifon-basligi-set-7929.png?v=1772452630"
    ],
    "price": "10301.96",
    "sku": "LP145SMSET",
    "tags": [
      "Loop",
      "tezgah üstü",
      "Vitrifiye",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52927542821161,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP145SMSET",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "10301.96",
        "grams": 0,
        "compare_at_price": "12412.00",
        "position": 1,
        "product_id": 10032735158569,
        "created_at": "2026-04-04T16:40:39+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<div class=\"product-description\">\r\n<h3>Loop Yuvarlak Çanak Lavabo Siyah Mat (LP145-00SM00E-0000)</h3>\r\n<p>Şık ve modern tasarımıyla banyonuza zarafet katacak Creavit Loop yuvarlak çanak lavabo. Yüzey montaj tipi sayesinde kolay kurulum, dayanıklı malzemesiyle uzun ömürlü kullanım sunar.</p>\r\n<ul>\r\n<li>\n<strong>Ürün Kodu:</strong> LP145-00SM00E-0000</li>\r\n<li>\n<strong>Boyutlar:</strong> 450 × 112 mm</li>\r\n<li>\n<strong>Montaj Tipi:</strong> Tezgah Üstü</li>\r\n<li>\n<strong>Armatür Deliği:</strong> Armatür Deliksiz</li>\r\n<li>\n<strong>Su Taşma Deliği:</strong> Yok</li>\r\n<li>\n<strong>Garanti Süresi:</strong> 12 Yıl</li>\r\n<li>\n<strong>Sifon Başlığı:</strong> Dahildir (SFU.SF030.SYM)</li>\r\n<li>\n<strong>Armatür:</strong> Dahildir (BT.VS6500S)</li>\n</ul>\r\n<h2>Öne Çıkan Özellikler</h2>\r\n<ul>\r\n<li>\n<strong>Yüksek Dayanıklılık:</strong> Kaliteli seramik malzeme, çizilmelere ve darbelere karşı dirençli.</li>\r\n<li>\n<strong>Kolay Temizlik:</strong> Pürüzsüz yüzey sayesinde leke ve kir tutmaz, hızlı bakım imkânı.</li>\r\n<li>\n<strong>Estetik Tasarım:</strong> Minimal çizgileri ve yuvarlak formu ile her banyoya uyum sağlar.</li>\r\n<li>\n<strong>Pratik Kurulum:</strong> Tezgah üstü montaj, ek aparat gerektirmeden hızlı montaj imkânı.</li>\n</ul>\r\n<h2>Detaylar</h2>\r\n<p>Creavit’in 12 yıllık üretici garantisi ile sunulan Loop çanak lavabo, SFu.SF030.SYM sifon başlığı ve BT.VS6500S modeli armatürü ile eksiksiz bir set olarak teslim edilir. Su taşma deliği bulunmadığı için ekstra güvenlik önlemi gerektirmez. Armatür deliği olmaması, size armatür seçimi konusunda tam özgürlük sunar.</p>\r\n<h2>Kurulum ve Teslimat</h2>\r\n<p>• Ürün, montaja hazır olarak paketlenir.<br>• Kurulum kılavuzu ile birlikte gönderilir.<br>• Tüm Türkiye’ye ücretsiz kargo.</p>\r\n<h2>Neden Creavit?</h2>\r\n<p>Creavit, yenilikçi tasarımları ve yüksek kalite standartlarıyla banyo çözümlerinde lider markadır. Uzun ömürlü ürün portföyü, modern estetik anlayışı ve güçlü müşteri desteği ile fark yaratır.</p>\n</div>"
  },
  {
    "id": "creavit-9523938033961",
    "brand": "Creavit",
    "title": "Ondea Uzun Lavabo Armatürü Metalik Gri",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-uzun-lavabo-armaturu-metalik-gri-6600.png?v=1747229865",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-uzun-lavabo-armaturu-metalik-gri-6600.png?v=1747229865",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-uzun-lavabo-armaturu-metalik-gri-6601.jpg?v=1747229868",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-uzun-lavabo-armaturu-metalik-gri-6602.jpg?v=1747229871"
    ],
    "price": "11655.00",
    "sku": "BT.RT6500GR",
    "tags": [
      "Armatür",
      "Banyo",
      "Lavabo Armatürü",
      "Metalik Gri",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52916326498601,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.RT6500GR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11655.00",
        "grams": 0,
        "compare_at_price": "15540.00",
        "position": 1,
        "product_id": 9523938033961,
        "created_at": "2026-04-02T15:53:39+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Creavit'in genç ve yenilikçi tasarımı Ondea, köşeli ve sert hatlı tasarımıyla ıslak mekanlara karakteristik bir görüntü katıyor. Ondea Lavabo Armatürü'nün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizmasi, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle banyo deneyiminiz daha keyifli hale gelecek. Creavit armatürleri gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>"
  },
  {
    "id": "creavit-9523937149225",
    "brand": "Creavit",
    "title": "Ondea Uzun Lavabo Armatürü Krom",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-uzun-lavabo-armaturu-krom-6597.png?v=1747229850",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-uzun-lavabo-armaturu-krom-6597.png?v=1747229850",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-uzun-lavabo-armaturu-krom-6598.jpg?v=1747229853",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-uzun-lavabo-armaturu-krom-6599.jpg?v=1747229855"
    ],
    "price": "9315.00",
    "sku": "BT.RT6500",
    "tags": [
      "Armatür",
      "Banyo",
      "Krom",
      "Lavabo Armatürü",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52916318077225,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.RT6500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9315.00",
        "grams": 0,
        "compare_at_price": "12420.00",
        "position": 1,
        "product_id": 9523937149225,
        "created_at": "2026-04-02T15:51:03+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Creavit'in genç ve yenilikçi tasarımı Ondea, köşeli ve sert hatlı tasarımıyla ıslak mekanlara karakteristik bir görüntü katıyor. Ondea Lavabo Armatürü'nün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizmasi, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle banyo deneyiminiz daha keyifli hale gelecek. Creavit armatürleri gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>"
  },
  {
    "id": "creavit-8757449392425",
    "brand": "Creavit",
    "title": "Ondea Mutfak Armatürü Metalik Gri",
    "category": "Mutfak Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-mutfak-armaturu-metalik-gri-4392.png?v=1747223893",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-mutfak-armaturu-metalik-gri-4392.png?v=1747223893",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-mutfak-armaturu-metalik-gri-4395.jpg?v=1747223897",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-mutfak-armaturu-metalik-gri-4393.jpg?v=1747223900",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-mutfak-armaturu-metalik-gri-4394.jpg?v=1747223903",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-mutfak-armaturu-metalik-gri-4396.jpg?v=1747223907"
    ],
    "price": "10485.00",
    "sku": "BT.RT8500GR",
    "tags": [
      "Armatür",
      "Metalik Gri",
      "mutfak",
      "Mutfak Armatürü",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52920968315177,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.RT8500GR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "10485.00",
        "grams": 0,
        "compare_at_price": "13980.00",
        "position": 1,
        "product_id": 8757449392425,
        "created_at": "2026-04-03T12:16:01+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Creavit'in genç ve yenilikçi tasarımı Ondea, köşeli ve sert hatlı tasarımıyla ıslak mekanlara karakteristik bir görüntü katıyor. Ondea Mutfak Armatürü'nün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizmasi, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle mutfak deneyiminiz daha keyifli hale gelecek. Creavit armatürleri gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>"
  },
  {
    "id": "creavit-8757446902057",
    "brand": "Creavit",
    "title": "Ondea Mutfak Armatürü Krom",
    "category": "Mutfak Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-mutfak-armaturu-krom-4388.png?v=1747223876",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-mutfak-armaturu-krom-4388.png?v=1747223876",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-mutfak-armaturu-krom-4390.jpg?v=1747223881"
    ],
    "price": "8370.00",
    "sku": "BT.RT8500",
    "tags": [
      "Armatür",
      "Krom",
      "mutfak",
      "Mutfak Armatürü",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52916303397161,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.RT8500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8370.00",
        "grams": 0,
        "compare_at_price": "11160.00",
        "position": 1,
        "product_id": 8757446902057,
        "created_at": "2026-04-02T15:45:35+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Creavit'in genç ve yenilikçi tasarımı Ondea, köşeli ve sert hatlı tasarımıyla ıslak mekanlara karakteristik bir görüntü katıyor. Ondea Mutfak Armatürü'nün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizmasi, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle mutfak deneyiminiz daha keyifli hale gelecek. Creavit armatürleri gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>"
  },
  {
    "id": "creavit-8742360056105",
    "brand": "Creavit",
    "title": "Ondea Banyo Armatürü Metalik Gri",
    "category": "Banyo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-banyo-armaturu-metalik-gri-4318.png?v=1747223609",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-banyo-armaturu-metalik-gri-4318.png?v=1747223609",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-banyo-armaturu-metalik-gri-4320.jpg?v=1747223617"
    ],
    "price": "10215.00",
    "sku": "BT.RT2500GR",
    "tags": [
      "Armatür",
      "Banyo",
      "banyo armatürü",
      "Metalik Gri",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52916296581417,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.RT2500GR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "10215.00",
        "grams": 0,
        "compare_at_price": "13620.00",
        "position": 1,
        "product_id": 8742360056105,
        "created_at": "2026-04-02T15:42:45+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\" data-mce-fragment=\"1\">\n<div class=\"react-scroll-to-bottom--css-vfjev-79elbk h-full dark:bg-gray-800\" data-mce-fragment=\"1\">\n<div class=\"react-scroll-to-bottom--css-vfjev-1n7m0yu\" data-mce-fragment=\"1\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\" data-mce-fragment=\"1\">\n<div class=\"group w-full text-gray-800 dark:text-gray-100 border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-mce-fragment=\"1\">\n<div class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\" data-mce-fragment=\"1\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\" data-mce-fragment=\"1\">\n<div class=\"flex flex-grow flex-col gap-3\" data-mce-fragment=\"1\">\n<div class=\"min-h-[20px] flex items-start overflow-x-auto whitespace-pre-wrap break-words\" data-mce-fragment=\"1\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\n<p data-mce-fragment=\"1\">Creavit'in genç ve yenilikçi tasarımı Ondea, köşeli ve sert hatlı tasarımıyla ıslak mekanlara karakteristik bir görüntü katıyor. Ondea Banyo Armatürü'nün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizmasi, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle banyo deneyiminiz daha keyifli hale gelecek. Creavit armatürleri gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8742357074217",
    "brand": "Creavit",
    "title": "Ondea Banyo Armatürü Krom",
    "category": "Banyo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-banyo-armaturu-krom-4315.png?v=1747223595",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-banyo-armaturu-krom-4315.png?v=1747223595",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-banyo-armaturu-krom-4316.jpg?v=1747223601"
    ],
    "price": "8370.00",
    "sku": "BT.RT2500",
    "tags": [
      "Armatür",
      "Banyo",
      "banyo armatürü",
      "Krom",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52916291895593,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.RT2500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8370.00",
        "grams": 0,
        "compare_at_price": "11160.00",
        "position": 1,
        "product_id": 8742357074217,
        "created_at": "2026-04-02T15:40:30+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\" data-mce-fragment=\"1\">\n<div class=\"react-scroll-to-bottom--css-vfjev-79elbk h-full dark:bg-gray-800\" data-mce-fragment=\"1\">\n<div class=\"react-scroll-to-bottom--css-vfjev-1n7m0yu\" data-mce-fragment=\"1\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\" data-mce-fragment=\"1\">\n<div class=\"group w-full text-gray-800 dark:text-gray-100 border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-mce-fragment=\"1\">\n<div class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\" data-mce-fragment=\"1\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\" data-mce-fragment=\"1\">\n<div class=\"flex flex-grow flex-col gap-3\" data-mce-fragment=\"1\">\n<div class=\"min-h-[20px] flex items-start overflow-x-auto whitespace-pre-wrap break-words\" data-mce-fragment=\"1\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\n<p data-mce-fragment=\"1\">Creavit'in genç ve yenilikçi tasarımı Ondea, köşeli ve sert hatlı tasarımıyla ıslak mekanlara karakteristik bir görüntü katıyor.  Ondea Banyo Armatürünün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizmasi, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle banyo deneyiminiz daha keyifli hale gelecek.  Creavit armatürleri gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8737216168233",
    "brand": "Creavit",
    "title": "Ondea Lavabo Armatürü Metalik Gri",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-lavabo-armaturu-metalik-gri-4270.png?v=1747212359",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-lavabo-armaturu-metalik-gri-4270.png?v=1747212359",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-lavabo-armaturu-metalik-gri-4271.jpg?v=1747212366",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-lavabo-armaturu-metalik-gri-4273.jpg?v=1747212369",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-lavabo-armaturu-metalik-gri-4274.jpg?v=1747212372"
    ],
    "price": "7200.00",
    "sku": "BT.RT1500GR",
    "tags": [
      "Armatür",
      "Banyo",
      "Krom",
      "Lavabo Armatürü",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52916286685481,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.RT1500GR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7200.00",
        "grams": 0,
        "compare_at_price": "9600.00",
        "position": 1,
        "product_id": 8737216168233,
        "created_at": "2026-04-02T15:38:00+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Creavit'in genç ve yenilikçi tasarımı Ondea, köşeli ve sert hatlı tasarımıyla ıslak mekanlara karakteristik bir görüntü katıyor. Ondea Lavabo Armatürü'nün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizmasi, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle banyo deneyiminiz daha keyifli hale gelecek. Creavit armatürleri gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>"
  },
  {
    "id": "creavit-8735435653417",
    "brand": "Creavit",
    "title": "Ondea Lavabo Armatürü Krom",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-lavabo-armaturu-krom-4264.png?v=1747223402",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-lavabo-armaturu-krom-4264.png?v=1747223402",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-lavabo-armaturu-krom-4265.jpg?v=1747223410",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-lavabo-armaturu-krom-4266.jpg?v=1747223415",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-lavabo-armaturu-krom-4268.jpg?v=1747223418",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ritmo-lavabo-armaturu-krom-4269.jpg?v=1747223422"
    ],
    "price": "5805.00",
    "sku": "BT.RT1500",
    "tags": [
      "Armatür",
      "Banyo",
      "Krom",
      "Lavabo Armatürü",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52916277870889,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.RT1500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5805.00",
        "grams": 0,
        "compare_at_price": "7740.00",
        "position": 1,
        "product_id": 8735435653417,
        "created_at": "2026-04-02T15:33:42+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Creavit'in genç ve yenilikçi tasarımı Ondea, köşeli ve sert hatlı tasarımıyla ıslak mekanlara karakteristik bir görüntü katıyor. Ondea Lavabo Armatürü'nün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizmasi, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle banyo deneyiminiz daha keyifli hale gelecek. Creavit armatürleri gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>"
  },
  {
    "id": "creavit-10005906686249",
    "brand": "Creavit",
    "title": "Vasa Uzun Lavabo Armatürü Mat Siyah",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vasa-uzun-lavabo-armaturu-mat-siyah-7920.png?v=1770033618",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vasa-uzun-lavabo-armaturu-mat-siyah-7920.png?v=1770033618",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/BT.VS6500_Cizim.png?v=1770621387"
    ],
    "price": "3400.00",
    "sku": "BT.VS6500S",
    "tags": [
      "Lavabo Armatürü",
      "Mat Siyah Armatür",
      "Siyah Armatür",
      "Uzun Lavabo Armatürü",
      "Vasa Lavabo Armatürü"
    ],
    "variants": [
      {
        "id": 52927549473065,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.VS6500S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3400.00",
        "grams": 0,
        "compare_at_price": "6000.00",
        "position": 1,
        "product_id": 10005906686249,
        "created_at": "2026-04-04T16:42:42+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h2>Vasa Uzun Lavabo Armatürü Mat Siyah</h2>\n<p>Tezgah üstü çanak lavabolar için özel olarak tasarlanan bu yüksek tip siyah kaplamalı lavabo bataryası, modern tasarımı, dayanıklı iç yapısı ve su tasarrufu sağlayan Neoperl perlatörü ile hem şıklık hem de yüksek performans sunar.</p>\n<h3>Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Çıkış Ucu Uzunluğu:</strong> 150 mm</li>\n<li>\n<strong>Çıkış Ucu Yüksekliği:</strong> 182 mm</li>\n<li>\n<strong>Ürün Genişliği:</strong> 184 mm</li>\n<li>\n<strong>Ürün Boyu:</strong> 257 mm</li>\n<li>\n<strong>Yüzey:</strong> Siyah kaplama</li>\n</ul>\n<h3>Su Akışı ve Dayanıklılık</h3>\n<ul>\n<li>\n<strong>Perlatör:</strong> 18’lik Neoperl – 3 bar basınçta 6 L/dk</li>\n<li>\n<strong>Çalışma Basıncı:</strong> Min. 1 bar – Maks. 5 bar</li>\n<li>\n<strong>Flex Hortum:</strong> 304 SUS paslanmaz çelik örgülü, F 3/8 bağlantı, 55 cm, M10 uç</li>\n</ul>\n<h3>Açma – Kapama Mekanizması</h3>\n<ul>\n<li>\n<strong>Kartuş Tipi:</strong> 25 mm üstten O-ringli</li>\n<li>\n<strong>Sıcak Su Dayanımı:</strong> Maksimum 90°C</li>\n<li>\n<strong>Ömür:</strong> EN 817 standardına uygundur (kullanım koşullarına göre değişebilir)</li>\n</ul>\n<h3>Montaj Bilgileri</h3>\n<ul>\n<li>\n<strong>Montaj Tipi:</strong> Tezgah üstü M35 çanak lavabolar için uygundur</li>\n<li>Kolay montaj sistemi</li>\n<li>Taban bileziği dahildir</li>\n</ul>\n<h3>Garanti ve Standartlar</h3>\n<ul>\n<li>\n<strong>Garanti Süresi:</strong> 5 yıl</li>\n<li>\n<strong>Korozyon Dayanımı:</strong> EN 248 standardı – 200 saat tuz testi</li>\n</ul>\n<h3>Paket İçeriği</h3>\n<ul>\n<li>3/8 Flex hortum</li>\n<li>Taban bileziği</li>\n<li>Kolay montaj aparatı</li>\n</ul>\n<p><strong>Ağırlık:</strong> 1,095 kg</p>\n<h3>Kullanım ve Bakım Tavsiyesi</h3>\n<p>Ürün ağır kimyasal içeren temizlik maddeleri ile temizlenmemelidir. Her kullanımdan sonra yüzeyin kuru bir bez ile silinmesi, siyah kaplamanın ilk günkü görünümünü uzun süre korumasını sağlar.</p>"
  },
  {
    "id": "creavit-10005905998121",
    "brand": "Creavit",
    "title": "Vasa Uzun Lavabo Armatürü",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vasa-uzun-lavabo-armaturu-7919.png?v=1770033023",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vasa-uzun-lavabo-armaturu-7919.png?v=1770033023",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/BT.VS6500_Cizim.png?v=1770621387"
    ],
    "price": "3050.00",
    "sku": "BT.VS6500",
    "tags": [
      "armatürler",
      "lavabo armatürleri",
      "Lavabo Armatürü",
      "Uzun Lavabo Armatürü",
      "Vasa Lavabo Armatürü"
    ],
    "variants": [
      {
        "id": 52938837229865,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.VS6500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3050.00",
        "grams": 0,
        "compare_at_price": "5300.00",
        "position": 1,
        "product_id": 10005905998121,
        "created_at": "2026-04-06T21:54:20+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h2>Vasa Uzun Lavabo Armatürü</h2>\n<p>Tezgah üstü çanak lavabolar için özel olarak tasarlanan bu yüksek tip krom kaplamalı lavabo bataryası, modern görünümü, güçlü iç mekanizması ve su tasarrufu sağlayan Neoperl perlatörü ile üstün kullanım konforu sunar.</p>\n<h3>Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Çıkış Ucu Uzunluğu:</strong> 150 mm</li>\n<li>\n<strong>Çıkış Ucu Yüksekliği:</strong> 182 mm</li>\n<li>\n<strong>Ürün Genişliği:</strong> 184 mm</li>\n<li>\n<strong>Ürün Boyu:</strong> 257 mm</li>\n<li>\n<strong>Yüzey:</strong> Krom kaplama</li>\n</ul>\n<h3>Su Akışı ve Dayanıklılık</h3>\n<ul>\n<li>\n<strong>Perlatör:</strong> 18’lik Neoperl – 3 bar basınçta 6 L/dk</li>\n<li>\n<strong>Çalışma Basıncı:</strong> Min. 1 bar – Maks. 5 bar</li>\n<li>\n<strong>Flex Hortum:</strong> 304 SUS paslanmaz çelik örgülü, F 3/8 bağlantı, 55 cm, M10 uç</li>\n</ul>\n<h3>Açma – Kapama Mekanizması</h3>\n<ul>\n<li>\n<strong>Kartuş Tipi:</strong> 25 mm üstten O-ringli</li>\n<li>\n<strong>Sıcak Su Dayanımı:</strong> Maksimum 90°C</li>\n<li>\n<strong>Ömür:</strong> EN 817 standardına uygundur (kullanım koşullarına göre değişebilir)</li>\n</ul>\n<h3>Montaj Bilgileri</h3>\n<ul>\n<li>\n<strong>Montaj Tipi:</strong> Tezgah üstü M35 çanak lavabolar için uygundur</li>\n<li>Kolay montaj sistemi</li>\n<li>Taban bileziği dahildir</li>\n</ul>\n<h3>Garanti ve Standartlar</h3>\n<ul>\n<li>\n<strong>Garanti Süresi:</strong> 5 yıl</li>\n<li>\n<strong>Korozyon Dayanımı:</strong> EN 248 standardı – 200 saat tuz testi</li>\n</ul>\n<h3>Paket İçeriği</h3>\n<ul>\n<li>3/8 Flex hortum</li>\n<li>Taban bileziği</li>\n<li>Kolay montaj aparatı</li>\n</ul>\n<p><strong>Ağırlık:</strong> 1,095 kg</p>\n<h3>Kullanım ve Bakım Tavsiyesi</h3>\n<p>Ürün ağır kimyasal içeren temizlik maddeleri ile temizlenmemelidir. Her kullanımdan sonra yüzeyin kuru bir bez ile silinmesi, krom kaplamanın parlaklığını ve uzun ömürlü kullanımını korur.</p>"
  },
  {
    "id": "creavit-10005901672745",
    "brand": "Creavit",
    "title": "Vasa Lavabo Armatürü Mat Siyah",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vasa-lavabo-armaturu-mat-siyah-7917.png?v=1770621365",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vasa-lavabo-armaturu-mat-siyah-7917.png?v=1770621365",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/BT.VS1500_Cizim_1.png?v=1770799637",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vasa-lavabo-armaturu-mat-siyah-7918.png?v=1770621365"
    ],
    "price": "2700.00",
    "sku": "BT.VS1500S",
    "tags": [
      "Armatür",
      "Lavabo Armatürü",
      "Mat Siyah Armatür",
      "Siyah Armatür"
    ],
    "variants": [
      {
        "id": 52939371020585,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.VS1500S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2700.00",
        "grams": 0,
        "compare_at_price": "4600.00",
        "position": 1,
        "product_id": 10005901672745,
        "created_at": "2026-04-07T00:32:04+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h2>Vasa Lavabo Armatürü Mat Siyah</h2>\n<p>Modern banyolar için özel olarak tasarlanan bu siyah kaplamalı lavabo bataryası, şık görünümü ve uzun ömürlü iç mekanizması ile hem estetik hem de yüksek performans sunar.</p>\n<h3>Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Çıkış Ucu Uzunluğu:</strong> 126 mm</li>\n<li>\n<strong>Çıkış Ucu Yüksekliği:</strong> 77 mm</li>\n<li>\n<strong>Ürün Genişliği:</strong> 159 mm</li>\n<li>\n<strong>Ürün Boyu:</strong> 152 mm</li>\n<li>\n<strong>Yüzey:</strong> Siyah kaplama</li>\n</ul>\n<h3>Su Akışı ve Dayanıklılık</h3>\n<ul>\n<li>\n<strong>Perlatör:</strong> M18 – 3 bar basınçta 6 L/dk</li>\n<li>\n<strong>Çalışma Basıncı:</strong> Min. 1 bar – Maks. 5 bar</li>\n<li>\n<strong>Flex Hortum:</strong> SS 304 paslanmaz çelik örgülü, F 3/8 bağlantı, 45 cm, M10 uç</li>\n</ul>\n<h3>Açma – Kapama Mekanizması</h3>\n<ul>\n<li>\n<strong>Kartuş Tipi:</strong> 25 mm üstten O-ringli</li>\n<li>\n<strong>Sıcak Su Dayanımı:</strong> Maksimum 90°C</li>\n<li>\n<strong>Ömür:</strong> EN 817 standardına uygundur (kullanım koşullarına göre değişebilir)</li>\n</ul>\n<h3>Montaj Bilgileri</h3>\n<ul>\n<li>Seramik lavabo üzerine montaj</li>\n<li>Kolay montaj sistemi</li>\n<li>Taban bileziği dahildir</li>\n</ul>\n<h3>Garanti ve Standartlar</h3>\n<ul>\n<li>\n<strong>Garanti Süresi:</strong> 5 yıl</li>\n<li>\n<strong>Korozyon Dayanımı:</strong> EN 248 standardı – 200 saat tuz testi</li>\n</ul>\n<h3>Paket İçeriği</h3>\n<ul>\n<li>3/8 Flex hortum</li>\n<li>Taban bileziği</li>\n<li>Kolay montaj aparatı</li>\n</ul>\n<p><strong>Ağırlık:</strong> 0,84 kg</p>\n<h3>Kullanım ve Bakım Tavsiyesi</h3>\n<p>Ürün ağır kimyasal içeren temizlik maddeleri ile temizlenmemelidir. Her kullanımdan sonra yüzeyin kuru bir bez ile silinmesi, siyah kaplamanın uzun süre ilk günkü görünümünü korumasına yardımcı olur.</p>"
  },
  {
    "id": "creavit-10005899116841",
    "brand": "Creavit",
    "title": "Vasa Lavabo Armatürü",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vasa-lavabo-armaturu-7915.png?v=1771314743",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vasa-lavabo-armaturu-7915.png?v=1771314743",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vasa-lavabo-armaturu-7916.png?v=1771314743",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/BT.VS1500_Cizim_1.png?v=1770799637"
    ],
    "price": "2450.00",
    "sku": "BT.VS1500",
    "tags": [
      "Krom",
      "Krom Armatür",
      "Kısa Armatür",
      "Lavabo Armatürü"
    ],
    "variants": [
      {
        "id": 52932677009705,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.VS1500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2450.00",
        "grams": 0,
        "compare_at_price": "4100.00",
        "position": 1,
        "product_id": 10005899116841,
        "created_at": "2026-04-05T14:43:10+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h2>Vasa Lavabo Bataryası </h2>\n<p>Modern banyo ve lavabo alanları için tasarlanan bu krom kaplamalı lavabo bataryası; yüksek dayanımı, düşük su tüketimi ve uzun ömürlü kartuş sistemi ile hem estetik hem de fonksiyonel bir kullanım sunar.</p>\n<h3>Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Çıkış Ucu Uzunluğu:</strong> 126 mm</li>\n<li>\n<strong>Çıkış Ucu Yüksekliği:</strong> 77 mm</li>\n<li>\n<strong>Ürün Genişliği:</strong> 159 mm</li>\n<li>\n<strong>Ürün Boyu:</strong> 152 mm</li>\n<li>\n<strong>Yüzey:</strong> Krom kaplama</li>\n</ul>\n<h3>Su Akışı ve Dayanıklılık</h3>\n<ul>\n<li>\n<strong>Perlatör:</strong> M18 – 3 bar basınçta 6 L/dk</li>\n<li>\n<strong>Çalışma Basıncı:</strong> Min. 1 bar – Maks. 5 bar</li>\n<li>\n<strong>Flex Hortum:</strong> SS 304 paslanmaz çelik örgülü, F 3/8 bağlantı, 45 cm, M10 uç</li>\n</ul>\n<h3>Açma – Kapama Mekanizması</h3>\n<ul>\n<li>\n<strong>Kartuş Tipi:</strong> 25 mm üstten O-ringli</li>\n<li>\n<strong>Sıcak Su Dayanımı:</strong> Maksimum 90°C</li>\n<li>\n<strong>Ömür:</strong> EN 817 standardına uygundur (kullanım koşullarına göre değişebilir)</li>\n</ul>\n<h3>Montaj Bilgileri</h3>\n<ul>\n<li>Seramik lavabo üzerine montaj</li>\n<li>Kolay montaj sistemi</li>\n<li>Taban bileziği dahildir</li>\n</ul>\n<h3>Garanti ve Standartlar</h3>\n<ul>\n<li>\n<strong>Garanti Süresi:</strong> 5 yıl</li>\n<li>\n<strong>Korozyon Dayanımı:</strong> EN 248 standardı – 200 saat tuz testi</li>\n</ul>\n<h3>Paket İçeriği</h3>\n<ul>\n<li>3/8 Flex hortum</li>\n<li>Taban bileziği</li>\n<li>Kolay montaj aparatı</li>\n</ul>\n<p><strong>Ağırlık:</strong> 0,84 kg</p>\n<h3>Kullanım ve Bakım Tavsiyesi</h3>\n<p>Ürün ağır kimyasal içeren temizlik maddeleri ile temizlenmemelidir. Her kullanımdan sonra yüzeyin kuru bir bez ile silinmesi, krom kaplamanın parlaklığını ve uzun ömürlü kullanımını sağlar.</p>"
  },
  {
    "id": "creavit-10002039636265",
    "brand": "Creavit",
    "title": "Nuovo Banyo Armatürü",
    "category": "Banyo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/nuovo-banyo-armaturu-7911.png?v=1769586690",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/nuovo-banyo-armaturu-7911.png?v=1769586690",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/nuovo-banyo-armaturu-7912.png?v=1769586693",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/nuovo-banyo-armaturu-7913.png?v=1769586696",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/nuovo-banyo-armaturu-7914.png?v=1769586698"
    ],
    "price": "8325.00",
    "sku": "BT.NU2500",
    "tags": [
      "Armatür",
      "banyo armatürü"
    ],
    "variants": [
      {
        "id": 52843212931369,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.NU2500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8325.00",
        "grams": 0,
        "compare_at_price": "11100.00",
        "position": 1,
        "product_id": 10002039636265,
        "created_at": "2026-03-17T12:54:33+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Çıkış Ucu Uzunluğu 175 Mm</p>\n<p>Uzun Ömürlü 35 Mm Seramik Kartuş</p>\n<p>%100 Pirinç Malzeme Üzeri Krom Kaplama</p>\n<p>Ürün Sadece Banyo Bataryasından Oluşmaktadır, El Duşu ve Duş Hortumu Ürüne Dahil Değildir.</p>"
  },
  {
    "id": "creavit-9972222263593",
    "brand": "Creavit",
    "title": "D20 30cm SAĞ Boy Dolabı Melamin Kapak Gri (Demonte)",
    "category": "444613296425",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30cm-sag-boy-dolabi-melamin-kapak-gri-demonte-5462.jpg?v=1766477198",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30cm-sag-boy-dolabi-melamin-kapak-gri-demonte-5462.jpg?v=1766477198",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30cm-sag-boy-dolabi-melamin-kapak-gri-demonte-5463.jpg?v=1766477200",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30cm-sag-boy-dolabi-melamin-kapak-gri-demonte-5464.jpg?v=1766477202",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30cm-sag-boy-dolabi-melamin-kapak-gri-demonte-5465.jpg?v=1766477204"
    ],
    "price": "9735.00",
    "sku": "D.D20.BD030.SAG.ML.GRI",
    "tags": [],
    "variants": [
      {
        "id": 52843193008425,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.BD030.SAG.ML.GRI",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "9735.00",
        "grams": 0,
        "compare_at_price": "12980.00",
        "position": 1,
        "product_id": 9972222263593,
        "created_at": "2026-03-17T12:48:26+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-9972221641001",
    "brand": "Creavit",
    "title": "D20 30cm SOL Boy Dolabı Gri (Demonte)",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30cm-sol-boy-dolabi-gri-demonte-5466.jpg?v=1766477072",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30cm-sol-boy-dolabi-gri-demonte-5466.jpg?v=1766477072",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30cm-sol-boy-dolabi-gri-demonte-5467.jpg?v=1766477073",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30cm-sol-boy-dolabi-gri-demonte-5468.jpg?v=1766477075",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30cm-sol-boy-dolabi-gri-demonte-5469.jpg?v=1766477077"
    ],
    "price": "9735.00",
    "sku": "D.D20.BD030.SOL.ML.GRI",
    "tags": [],
    "variants": [
      {
        "id": 52843193139497,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.BD030.SOL.ML.GRI",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9735.00",
        "grams": 0,
        "compare_at_price": "12980.00",
        "position": 1,
        "product_id": 9972221641001,
        "created_at": "2026-03-17T12:48:29+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-9972220035369",
    "brand": "Creavit",
    "title": "D20 65cm İki Çekmeceli Lavabo Dolabı Gri (Demonte)",
    "category": "468907032873",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65cm-iki-cekmeceli-lavabo-dolabi-gri-demonte-6164.jpg?v=1766476742",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65cm-iki-cekmeceli-lavabo-dolabi-gri-demonte-6164.jpg?v=1766476742",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65cm-iki-cekmeceli-lavabo-dolabi-gri-demonte-6165.jpg?v=1766476744",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65cm-iki-cekmeceli-lavabo-dolabi-gri-demonte-6166.jpg?v=1766476746",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65cm-iki-cekmeceli-lavabo-dolabi-gri-demonte-6167.jpg?v=1766476749"
    ],
    "price": "15675.00",
    "sku": "D.D20.LD065.2CK.ML.GRI",
    "tags": [],
    "variants": [
      {
        "id": 52843195695401,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD065.2CK.ML.GRI",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "15675.00",
        "grams": 0,
        "compare_at_price": "20900.00",
        "position": 1,
        "product_id": 9972220035369,
        "created_at": "2026-03-17T12:49:29+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-9972219281705",
    "brand": "Creavit",
    "title": "D20 80cm İki Çekmeceli Lavabo Dolabı Gri Melamin Kapak (Demonte)",
    "category": "468907032873",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80cm-iki-cekmeceli-lavabo-dolabi-gri-melamin-kapak-demonte-6020.jpg?v=1766476713",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80cm-iki-cekmeceli-lavabo-dolabi-gri-melamin-kapak-demonte-6020.jpg?v=1766476713",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80cm-iki-cekmeceli-lavabo-dolabi-gri-melamin-kapak-demonte-6021.jpg?v=1766476715",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80cm-iki-cekmeceli-lavabo-dolabi-gri-melamin-kapak-demonte-6022.jpg?v=1766476717",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80cm-iki-cekmeceli-lavabo-dolabi-gri-melamin-kapak-demonte-6023.jpg?v=1766476719"
    ],
    "price": "16665.00",
    "sku": "D.D20.LD080.2CK.ML.GRI",
    "tags": [],
    "variants": [
      {
        "id": 52843195171113,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD080.2CK.ML.GRI",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "16665.00",
        "grams": 0,
        "compare_at_price": "22220.00",
        "position": 1,
        "product_id": 9972219281705,
        "created_at": "2026-03-17T12:49:17+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-9965387907369",
    "brand": "Creavit",
    "title": "Font Lavabo Dolabı 50 Cm ve Ayna Seti",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/1_1.png?v=1767713642",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/1_1.png?v=1767713642",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/1_3.png?v=1767713642",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/1_2.png?v=1766069280",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/1_4.png?v=1766069253"
    ],
    "price": "14355.00",
    "sku": "SET.FONT5410.BB",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "font",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52936356528425,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.FONT5410.BB",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "14355.00",
        "grams": 0,
        "compare_at_price": "19140.00",
        "position": 1,
        "product_id": 9965387907369,
        "created_at": "2026-04-06T11:12:45+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<ul style=\"font-size: 13px; font-family: Arial, Verdana; white-space: normal; word-spacing: 0px; text-transform: none; font-weight: 400; color: rgb(0,0,0); font-style: normal; orphans: 2; widows: 2; letter-spacing: normal; text-indent: 0px; font-variant-ligatures: normal; font-variant-caps: normal; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial;\">\n<li>Genişlik x Derinlik x Yükseklik: 50x85x40 cm.</li>\n<li>NX242-00CB00E-0000 Kodlu Seramik Lavabo Dahildir.</li>\n<li>Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</li>\n<li>Aynalı Dolap Ölçüleri: 50x68x12</li>\n<li>Ürün Lavabo Dolabı, Lavabo ve Aynalı Dolaptan Oluşmaktadır.</li>\n<li>Tek Kapaklı</li>\n<li>MDF</li>\n</ul>\n<p> </p>"
  },
  {
    "id": "creavit-9952707248425",
    "brand": "Creavit",
    "title": "Pion Boy Dolabı 40*160 Cm Beyaz",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-boy-dolabi-40-160-cm-beyaz-7898.png?v=1764748325",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-boy-dolabi-40-160-cm-beyaz-7898.png?v=1764748325"
    ],
    "price": "17886.00",
    "sku": "OB.PN2160.01.BB",
    "tags": [
      "Banyo Mobilyası",
      "boy dolabı"
    ],
    "variants": [
      {
        "id": 52836784406825,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "OB.PN2160.01.BB",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "17886.00",
        "grams": 0,
        "compare_at_price": "29810.00",
        "position": 1,
        "product_id": 9952707248425,
        "created_at": "2026-03-15T21:45:48+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Ürün Ölçüleri: 40*160*32 Cm</p>\n<p>Beyaz Renk</p>\n<p>MDF Malzeme</p>\n<p>Montaj Tipi: Asma</p>\n<p>Garanti Süresi: 2 Yıl</p>"
  },
  {
    "id": "creavit-9952706789673",
    "brand": "Creavit",
    "title": "Pion Boy Dolabı 40*160 Cm Cappucino",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-boy-dolabi-40-160-cm-cappucino-7897.png?v=1764748241",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-boy-dolabi-40-160-cm-cappucino-7897.png?v=1764748241"
    ],
    "price": "17886.00",
    "sku": "OB.PN2160.01.CP",
    "tags": [
      "Banyo Mobilyası",
      "boy dolabı"
    ],
    "variants": [
      {
        "id": 52915861160233,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "OB.PN2160.01.CP",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "17886.00",
        "grams": 0,
        "compare_at_price": "29810.00",
        "position": 1,
        "product_id": 9952706789673,
        "created_at": "2026-04-02T12:10:40+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Ürün Ölçüleri: 40*160*32 Cm</p>\n<p>Cappucino Renk</p>\n<p>MDF Malzeme</p>\n<p>Montaj Tipi: Asma</p>\n<p>Garanti Süresi: 2 Yıl</p>"
  },
  {
    "id": "creavit-9952706199849",
    "brand": "Creavit",
    "title": "Pion Boy Dolabı 40*160 Cm Antrasit",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-boy-dolabi-40-160-cm-antrasit-7896.png?v=1764748131",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-boy-dolabi-40-160-cm-antrasit-7896.png?v=1764748131"
    ],
    "price": "17886.00",
    "sku": "OB.PN2160.01.AA",
    "tags": [
      "Banyo Mobilyası",
      "boy dolabı"
    ],
    "variants": [
      {
        "id": 52876512493865,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "OB.PN2160.01.AA",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "17886.00",
        "grams": 0,
        "compare_at_price": "29810.00",
        "position": 1,
        "product_id": 9952706199849,
        "created_at": "2026-03-25T12:27:53+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Ürün Ölçüleri: 40*160*32 Cm</p>\n<p>Antrasit Renk</p>\n<p>MDF Malzeme</p>\n<p>Montaj Tipi: Asma</p>\n<p>Garanti Süresi: 2 Yıl</p>"
  },
  {
    "id": "creavit-9951423201577",
    "brand": "Creavit",
    "title": "Pion 120 CM Lavabo Dolabı Beyaz Antrasit ve Led Ayna",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-120-cm-lavabo-dolabi-beyaz-antrasit-ve-led-ayna-7891.jpg?v=1764661199",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-120-cm-lavabo-dolabi-beyaz-antrasit-ve-led-ayna-7891.jpg?v=1764661199",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-120-cm-lavabo-dolabi-beyaz-antrasit-ve-led-ayna-7892.jpg?v=1764661201"
    ],
    "price": "36000.00",
    "sku": "SET.PİON120.BA",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52911034695977,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.PİON120.BA",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "36000.00",
        "grams": 0,
        "compare_at_price": "80000.00",
        "position": 1,
        "product_id": 9951423201577,
        "created_at": "2026-04-01T08:05:48+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Lavabo Dolabı Ölçüsü: 120*85*52 Cm</p>\n<p>Ayna Ölçüsü: 118* 58*14 Cm</p>\n<p>Çekmeceli Lavabo Dolabı</p>\n<p>Gizli Çekmece Mevcuttur</p>\n<p>Yavaş Kanan Çekmece Özelliğine Sahiptir</p>\n<p>Şık ve Dayanaklı Lake Kaplama</p>\n<p>Garanti Süresi: 2 Yıl</p>\n<p>Ürün Lavabo Dolabı ve Ayna Olarak Gönderilecektir.</p>"
  },
  {
    "id": "creavit-9946948436265",
    "brand": "Creavit",
    "title": "Pion 120 Cm Lavabo Dolabı Beyaz Cappucino ve Led Ayna",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-120-cm-lavabo-dolabi-beyaz-cappucino-ve-led-ayna-7887.png?v=1764077462",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-120-cm-lavabo-dolabi-beyaz-cappucino-ve-led-ayna-7887.png?v=1764077462",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-120-cm-lavabo-dolabi-beyaz-cappucino-ve-led-ayna-7888.png?v=1764077466",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-120-cm-lavabo-dolabi-beyaz-cappucino-ve-led-ayna-7889.png?v=1764077469"
    ],
    "price": "36000.00",
    "sku": "SET.PİON120.BC",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52911034728745,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.PİON120.BC",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "36000.00",
        "grams": 0,
        "compare_at_price": "80000.00",
        "position": 1,
        "product_id": 9946948436265,
        "created_at": "2026-04-01T08:05:51+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Lavabo Dolabı Ölçüsü: 120*85*52 Cm</p>\n<p>Ayna Ölçüsü: 118* 58*14 Cm</p>\n<p>Çekmeceli Lavabo Dolabı</p>\n<p>Gizli Çekmece Mevcuttur</p>\n<p>Yavaş Kanan Çekmece Özelliğine Sahiptir</p>\n<p>Şık ve Dayanaklı Lake Kaplama</p>\n<p>Garanti Süresi: 2 Yıl</p>\n<p>Ürün Lavabo Dolabı ve Ayna Olarak Gönderilecektir.</p>"
  },
  {
    "id": "creavit-9946930151721",
    "brand": "Creavit",
    "title": "Angel Lavabo Dolabı 100 Cm Beyaz Krom ve Led Ayna",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/angel-lavabo-dolabi-100-cm-beyaz-krom-ve-led-ayna-7885.png?v=1764074129",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/angel-lavabo-dolabi-100-cm-beyaz-krom-ve-led-ayna-7885.png?v=1764074129",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/angel-lavabo-dolabi-100-cm-beyaz-krom-ve-led-ayna-7886.png?v=1764074132"
    ],
    "price": "27000.00",
    "sku": "SET.ANGEL100.W",
    "tags": [
      "Banyo Mobilyası",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52836647141673,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.ANGEL100.W",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "27000.00",
        "grams": 0,
        "compare_at_price": "60000.00",
        "position": 1,
        "product_id": 9946930151721,
        "created_at": "2026-03-15T21:08:27+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Ürün Ölçüleri: 100*85*50 Cm.</p>\n<p>Ürün Lavabo Dahil Yerden 85 Cm yükseklikte Monte Edilmelidir.</p>\n<p>Şık ve Dayanaklı Lake Malzemeden Üretilmiştir.</p>\n<p>Yavaş Kapanan Çekmece Özelliğine Sahiptir.</p>\n<p>Ürün Üzerinde Entegre Havluluk Mevcuttur.</p>\n<p>Ürün Beyaz Renktir.</p>\n<p>Ayna Ölçüsü: 92*50*5 Cm.</p>\n<p>Ayna Led Işığı Rengi: Gün Işığı</p>\n<p>Garanti Süresi: 2 Yıl</p>\n<p>Lavabo Dahildir.</p>\n<p>Ürün Ayna Ve Dolap Olarak İki Parça Set Halinde Gönderilecektir.</p>"
  },
  {
    "id": "creavit-9946921992489",
    "brand": "Creavit",
    "title": "Angel Lavabo Dolabı 120 Cm Beyaz Bakır ve Led Ayna",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/angel-lavabo-dolabi-120-cm-beyaz-bakir-ve-led-ayna-7883.png?v=1764073097",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/angel-lavabo-dolabi-120-cm-beyaz-bakir-ve-led-ayna-7883.png?v=1764073097",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/angel-lavabo-dolabi-120-cm-beyaz-bakir-ve-led-ayna-7884.png?v=1764073100"
    ],
    "price": "31500.00",
    "sku": "SET.ANGEL120.BBK",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz"
    ],
    "variants": [
      {
        "id": 52836646977833,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.ANGEL120.BBK",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "31500.00",
        "grams": 0,
        "compare_at_price": "70000.00",
        "position": 1,
        "product_id": 9946921992489,
        "created_at": "2026-03-15T21:08:24+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Ürün Ölçüleri: 120*85*50 Cm.</p>\n<p>Ürün Lavabo Dahil Yerden 85 Cm yükseklikte Monte Edilmelidir.</p>\n<p>Şık ve Dayanıklı Lake Malzemeden Üretilmiştir.</p>\n<p>Yavaş Kapanan Çekmece Özelliğine Sahiptir.</p>\n<p>Ürün Üzerinde Entegre Havluluk Mevcuttur.</p>\n<p>Ürün Beyaz Renktir.</p>\n<p>Ayna Ölçüsü: 92*50*5 Cm.</p>\n<p>Ayna Led Işığı Rengi: Gün Işığı</p>\n<p>Garanti Süresi: 2 Yıl</p>\n<p>Lavabo Dahildir.</p>\n<p>Ürün Ayna Ve Dolap Olarak İki Parça Set Halinde Gönderilecektir.</p>"
  },
  {
    "id": "creavit-9946916684073",
    "brand": "Creavit",
    "title": "Zeon 100 Cm Lavabo Dolabı Azure ve Led Ayna",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/zeon-100-cm-lavabo-dolabi-azure-ve-led-ayna-7881.png?v=1764072131",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/zeon-100-cm-lavabo-dolabi-azure-ve-led-ayna-7881.png?v=1764072131",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/zeon-100-cm-lavabo-dolabi-azure-ve-led-ayna-7882.png?v=1764072134"
    ],
    "price": "24750.00",
    "sku": "SET.ZEON100.MM",
    "tags": [
      "Ayna",
      "Banyo Mobilyası",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52836646125865,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.ZEON100.MM",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "24750.00",
        "grams": 0,
        "compare_at_price": "55000.00",
        "position": 1,
        "product_id": 9946916684073,
        "created_at": "2026-03-15T21:08:12+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Ürün<span style=\"font-size: 0.875rem;\"> Ölçüleri: </span><span style=\"font-size: 0.875rem;\">100*85*45 Cm</span></p>\n<p>Üründe Entegre Havluluk Mevcuttur.</p>\n<p>Şık ve Dayanıklı Lake Kaplama</p>\n<p>Bas-Aç Kapak</p>\n<p>Ayna Ölçüleri: 90*70*3,4 Cm</p>\n<p>Lavabo Dahildir.</p>\n<p>Ürün Lavabo Dolabı ve Ayna ile Birlikte Set Halinde İki Parça Olarak Gönderilecektir.</p>"
  },
  {
    "id": "creavit-9886599610665",
    "brand": "Creavit",
    "title": "Perge 80 Cm Lavabo Dolabı Mat Safir Blue Led Ayna ve Ayna Yan Dolap Seti",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/perge-80-cm-lavabo-dolabi-mat-safir-blue-led-ayna-ve-ayna-yan-dolap-seti-7875.png?v=1763389444",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/perge-80-cm-lavabo-dolabi-mat-safir-blue-led-ayna-ve-ayna-yan-dolap-seti-7875.png?v=1763389444",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/perge-80-cm-lavabo-dolabi-mat-safir-blue-led-ayna-ve-ayna-yan-dolap-seti-7876.png?v=1763389446",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/perge-80-cm-lavabo-dolabi-mat-safir-blue-led-ayna-ve-ayna-yan-dolap-seti-7877.png?v=1763389448",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/perge-80-cm-lavabo-dolabi-mat-safir-blue-led-ayna-ve-ayna-yan-dolap-seti-7878.png?v=1763389452"
    ],
    "price": "19305.00",
    "sku": "SET.PERGE080.MSB",
    "tags": [
      "Ayna",
      "Banyo Mobilyası",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52836647993641,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.PERGE080.MSB",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "19305.00",
        "grams": 0,
        "compare_at_price": "39000.00",
        "position": 1,
        "product_id": 9886599610665,
        "created_at": "2026-03-15T21:08:46+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Ürün Ölçüleri: 80*60*49 Cm.</p>\n<p>Yavaş Kapanan Çekmece Özelliğine Sahiptir.</p>\n<p>Şık ve Dayanıklı Lake Kaplama.</p>\n<p>Ayna Ölçüsü: 50*80 Cm.</p>\n<p>Ayna yan Dolap Ölçüsü: 30*80*23 Cm.</p>\n<p>Lavabo Dahildir.</p>\n<p>Ürün Lavabo Dolabı, Ayna ve Ayna Yan Dolap Olarak Üç Parça Set Halinde Gönderilecektir.</p>"
  },
  {
    "id": "creavit-9886593646889",
    "brand": "Creavit",
    "title": "Perge 100 Cm Lavabo Dolabı Mat Gri Led Ayna ve Ayna Yan Dolap Seti",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/perge-100-cm-lavabo-dolabi-mat-gri-led-ayna-ve-ayna-yan-dolap-seti-7873.png?v=1763389069",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/perge-100-cm-lavabo-dolabi-mat-gri-led-ayna-ve-ayna-yan-dolap-seti-7873.png?v=1763389069",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/perge-100-cm-lavabo-dolabi-mat-gri-led-ayna-ve-ayna-yan-dolap-seti-7874.png?v=1763389072"
    ],
    "price": "20790.00",
    "sku": "SET.PERGE100.MGR",
    "tags": [
      "Ayna",
      "Banyo Mobilyası",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52920915460393,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.PERGE100.MGR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "20790.00",
        "grams": 0,
        "compare_at_price": "42000.00",
        "position": 1,
        "product_id": 9886593646889,
        "created_at": "2026-04-03T12:02:07+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Ürün Ölçüleri: 100*60*49 Cm.</p>\n<p>Yavaş Kapanan Çekmece Özelliğine Sahiptir.</p>\n<p>Şık ve Dayanıklı Lake Kaplama.</p>\n<p>Ayna Ölçüsü: 50*80 Cm.</p>\n<p>Ayna yan Dolap Ölçüsü: 30*80*23 Cm.</p>\n<p>Lavabo Dahildir.</p>\n<p>Ürün Lavabo Dolabı, Ayna ve Ayna Yan Dolap Olarak Üç Parça Set Halinde Gönderilecektir.</p>"
  },
  {
    "id": "creavit-9886585159977",
    "brand": "Creavit",
    "title": "Perge 100 Cm Lavabo Dolabı Mat Beyaz Led Ayna ve Ayna yan dolap Seti",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/perge-100-cm-lavabo-dolabi-mat-beyaz-led-ayna-ve-ayna-yan-dolap-seti-7869.png?v=1763388635",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/perge-100-cm-lavabo-dolabi-mat-beyaz-led-ayna-ve-ayna-yan-dolap-seti-7869.png?v=1763388635",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/perge-100-cm-lavabo-dolabi-mat-beyaz-led-ayna-ve-ayna-yan-dolap-seti-7870.png?v=1763388638",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/perge-100-cm-lavabo-dolabi-mat-beyaz-led-ayna-ve-ayna-yan-dolap-seti-7871.png?v=1763388641",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/perge-100-cm-lavabo-dolabi-mat-beyaz-led-ayna-ve-ayna-yan-dolap-seti-7872.png?v=1763388644"
    ],
    "price": "20790.00",
    "sku": "SET.PERGE100.MBY",
    "tags": [
      "Ayna",
      "Banyo Mobilyası",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52836648157481,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.PERGE100.MBY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "20790.00",
        "grams": 0,
        "compare_at_price": "42000.00",
        "position": 1,
        "product_id": 9886585159977,
        "created_at": "2026-03-15T21:08:49+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Ürün Ölçüleri: 100*60*49 Cm.</p>\n<p>Yavaş Kapanan Çekmece Özelliğine Sahiptir.</p>\n<p>Şık ve Dayanıklı Lake Kaplama.</p>\n<p>Ayna Ölçüsü: 50*80 Cm.</p>\n<p>Ayna yan Dolap Ölçüsü: 30*80*23 Cm.</p>\n<p>Lavabo Dahildir.</p>\n<p>Ürün Lavabo Dolabı, Ayna ve Ayna Yan Dolap Olarak Üç Parça Set Halinde Gönderilecektir.</p>"
  },
  {
    "id": "creavit-9886576804137",
    "brand": "Creavit",
    "title": "Perge  Boy Dolap 35*130 Cm Mat Antrasit",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/perge-boy-dolap-35-130-cm-mat-antrasit-7868.png?v=1763388295",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/perge-boy-dolap-35-130-cm-mat-antrasit-7868.png?v=1763388295"
    ],
    "price": "8910.00",
    "sku": "PG2130.01.MAN",
    "tags": [
      "Banyo Mobilyası",
      "boy dolabı"
    ],
    "variants": [
      {
        "id": 52836726440233,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "PG2130.01.MAN",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8910.00",
        "grams": 0,
        "compare_at_price": "13500.00",
        "position": 1,
        "product_id": 9886576804137,
        "created_at": "2026-03-15T21:34:28+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Ürün Ölçüleri: 50*130*35 Cm</p>\n<p>Mat Antrasit Renk</p>\n<p>MDF Malzeme</p>\n<p>Montaj Tipi Asma</p>\n<p>Garanti Süresi: 2 Yıl</p>"
  },
  {
    "id": "creavit-9886572642601",
    "brand": "Creavit",
    "title": "Mıo Boy Dolap 35*140 Cm Antrasit - Koyu Safir",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mio-boy-dolap-35-140-cm-antrasit-koyu-safir-7867.png?v=1763387971",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mio-boy-dolap-35-140-cm-antrasit-koyu-safir-7867.png?v=1763387971"
    ],
    "price": "5100.00",
    "sku": "MI2140.00.AKS",
    "tags": [
      "Banyo Mobilyası",
      "boy dolabı",
      "mio"
    ],
    "variants": [
      {
        "id": 52836711825705,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MI2140.00.AKS",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5100.00",
        "grams": 0,
        "compare_at_price": "8500.00",
        "position": 1,
        "product_id": 9886572642601,
        "created_at": "2026-03-15T21:28:02+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Ürün Ölçüleri: 35*140*25 Cm</p>\n<p>Yavaş Kapanan Kapak.</p>\n<p>Garanti Süresi: 2 Yıl</p>\n<p>Konumlandırma: Asma</p>"
  },
  {
    "id": "creavit-9886566482217",
    "brand": "Creavit",
    "title": "Vero Boy Dolabı 40*130 Cm Antrasit-Arkadya",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vero-boy-dolabi-40-130-cm-antrasit-arkadya-7864.png?v=1763387538",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vero-boy-dolabi-40-130-cm-antrasit-arkadya-7864.png?v=1763387538",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vero-boy-dolabi-40-130-cm-antrasit-arkadya-7865.png?v=1763387541",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vero-boy-dolabi-40-130-cm-antrasit-arkadya-7866.png?v=1763387544"
    ],
    "price": "5100.00",
    "sku": "VR2130.00.AAR",
    "tags": [
      "Banyo Mobilyası",
      "boy dolabı"
    ],
    "variants": [
      {
        "id": 52836693639465,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "VR2130.00.AAR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5100.00",
        "grams": 0,
        "compare_at_price": "8500.00",
        "position": 1,
        "product_id": 9886566482217,
        "created_at": "2026-03-15T21:25:22+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Ürün Ölçüleri: 40*130*32 Cm.</p>\n<p>Mdflam Malzeme.</p>\n<p>Yavaş Kapanan Kapak.</p>\n<p>Gövde Antrasit Kapak Arkadya Renk.</p>\n<p>Garanti Süresi: 2 Yıl</p>\n<p>Konumlandırma: Asma</p>"
  },
  {
    "id": "creavit-9886555767081",
    "brand": "Creavit",
    "title": "Antik 100 Cm Lavabo Dolabı Desenli Siyah - Beyaz",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-100-cm-lavabo-dolabi-desenli-siyah-beyaz-7833.png?v=1763386774",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-100-cm-lavabo-dolabi-desenli-siyah-beyaz-7833.png?v=1763386774",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-100-cm-lavabo-dolabi-desenli-siyah-beyaz-7862.png?v=1763386777",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-100-cm-lavabo-dolabi-desenli-siyah-beyaz-7863.png?v=1763386779"
    ],
    "price": "24000.00",
    "sku": "AN0100.02.SB",
    "tags": [
      "Banyo Mobilyası",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52836693442857,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "AN0100.02.SB",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "24000.00",
        "grams": 0,
        "compare_at_price": "40000.00",
        "position": 1,
        "product_id": 9886555767081,
        "created_at": "2026-03-15T21:25:13+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Ürün Ölçüleri: 100*85*50 Cm</p>\n<p>Desenli Siyah Beyaz Renk</p>\n<p>Yavaş Kapanan Kapak</p>\n<p>Mdflam Üzeri Lake</p>\n<p>Konumlandırma: Ayaklı</p>\n<p>Garanti Süresi: 2 Yıl</p>"
  },
  {
    "id": "creavit-9885245112617",
    "brand": "Creavit",
    "title": "Zeon 100 Cm Lavabo Dolabı Plazzo ve Led Ayna",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-zeon-palazzo-lavabo-dolabi-ayna-banyo-mobilyasi.png?v=1763364304",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-zeon-palazzo-lavabo-dolabi-ayna-banyo-mobilyasi.png?v=1763364304",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/zeon-100-cm-lavabo-dolabi-plazzo-ve-led-ayna-7855.png?v=1763364304",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-zeon-palazzo-lavabo-dolabi-ayna-yan-dolap-banyo-mobilyasi-3.png?v=1763364304",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-zeon-palazzo-lavabo-dolabi-ayna-yan-dolap-banyo-mobilyasi-2.png?v=1763364304",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-zeon-palazzo-lavabo-dolabi-ayna-yan-dolap-banyo-mobilyasi-1.png?v=1763364304"
    ],
    "price": "24750.00",
    "sku": "SET.ZEON100.PZ",
    "tags": [
      "Ayna",
      "Banyo Mobilyası",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52836646289705,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.ZEON100.PZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "24750.00",
        "grams": 0,
        "compare_at_price": "55000.00",
        "position": 1,
        "product_id": 9885245112617,
        "created_at": "2026-03-15T21:08:15+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Ürün Ölçüleri: 100*85*45 Cm</p>\n<p>Üründe Entegre Havluluk Mevcuttur.</p>\n<p>Şık ve Dayanıklı Lake Kaplama</p>\n<p>Bas-Aç Kapak</p>\n<p>Ayna Ölçüleri: 90*70*3,4 Cm</p>\n<p>Lavabo Dahildir.</p>\n<p>Ürün Lavabo Dolabı ve Ayna ile Birlikte Set Halinde İki Parça Olarak Gönderilecektir.</p>"
  },
  {
    "id": "creavit-9885239804201",
    "brand": "Creavit",
    "title": "Zeon 100 Cm Lavabo Dolabı Beyaz ve Led Ayna",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/zeon-100-cm-lavabo-dolabi-beyaz-ve-led-ayna-7852.png?v=1763363076",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/zeon-100-cm-lavabo-dolabi-beyaz-ve-led-ayna-7852.png?v=1763363076",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/zeon-100-cm-lavabo-dolabi-beyaz-ve-led-ayna-7853.png?v=1763363078"
    ],
    "price": "24750.00",
    "sku": "SET.ZEON100.BB",
    "tags": [
      "Ayna",
      "Banyo Mobilyası",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52836646027561,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.ZEON100.BB",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "24750.00",
        "grams": 0,
        "compare_at_price": "55000.00",
        "position": 1,
        "product_id": 9885239804201,
        "created_at": "2026-03-15T21:08:09+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Ürün Ölçüleri: 100*85*45 Cm</p>\n<p>Üründe Entegre Havluluk Mevcuttur.</p>\n<p>Şık ve Dayanıklı Lake Kaplama</p>\n<p>Bas-Aç Kapak</p>\n<p>Ayna Ölçüleri: 90*70*3,4 Cm</p>\n<p>Lavabo Dahildir.</p>\n<p>Ürün Lavabo Dolabı ve Ayna ile Birlikte Set Halinde İki Parça Olarak Gönderilecektir.</p>"
  },
  {
    "id": "creavit-9885163716905",
    "brand": "Creavit",
    "title": "Perge 100 Cm Lavabo Dolabı Mat Safir Blue Led Ayna ve Ayna Yan Dolap Seti",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/perge-100-cm-lavabo-dolabi-mat-safir-blue-led-ayna-ve-ayna-yan-dolap-seti-7851.png?v=1763361464",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/perge-100-cm-lavabo-dolabi-mat-safir-blue-led-ayna-ve-ayna-yan-dolap-seti-7851.png?v=1763361464",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-perge-mat-safir-mavi-cekmeceli-lavabo-dolabi-led-ayna-takimi-banyo-mobilyasi-100cm-3.png?v=1763361489",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-perge-mat-safir-mavi-cekmeceli-lavabo-dolabi-led-ayna-takimi-banyo-mobilyasi-100cm-2.png?v=1763361488",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-perge-mat-safir-mavi-cekmeceli-lavabo-dolabi-led-ayna-takimi-banyo-mobilyasi-100cm-1.png?v=1763361489"
    ],
    "price": "20790.00",
    "sku": "SET.PERGE100.MSB",
    "tags": [
      "Banyo Mobilyası"
    ],
    "variants": [
      {
        "id": 52836648419625,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.PERGE100.MSB",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "20790.00",
        "grams": 0,
        "compare_at_price": "42000.00",
        "position": 1,
        "product_id": 9885163716905,
        "created_at": "2026-03-15T21:08:56+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Ürün Ölçüleri: 100*60*49 Cm.</p>\n<p>Yavaş Kapanan Çekmece Özelliğine Sahiptir.</p>\n<p>Şık ve Dayanıklı Lake Kaplama.</p>\n<p>Ayna Ölçüsü: 50*80 Cm.</p>\n<p>Ayna yan Dolap Ölçüsü: 30*80*23 Cm.</p>\n<p>Lavabo Dahildir.</p>\n<p>Ürün Lavabo Dolabı, Ayna ve Ayna Yan Dolap Olarak Üç Parça Set Halinde Gönderilecektir.</p>\n<p> </p>"
  },
  {
    "id": "creavit-9885090775337",
    "brand": "Creavit",
    "title": "Perge 60 Cm Lavabo Dolabı Mat Safir Blue ve Led Ayna",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/perge-60-cm-lavabo-dolabi-mat-safir-blue-ve-led-ayna-7849.png?v=1763360555",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/perge-60-cm-lavabo-dolabi-mat-safir-blue-ve-led-ayna-7849.png?v=1763360555",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-perge-mat-safir-mavi-cekmeceli-lavabo-dolabi-led-ayna-banyo-mobilyasi.png?v=1763360571",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-perge-mat-safir-mavi-cekmeceli-lavabo-dolabi-led-ayna-banyo-mobilyasi-5.png?v=1763360571",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-perge-mat-safir-mavi-cekmeceli-lavabo-dolabi-led-ayna-banyo-mobilyasi-4.png?v=1763360571",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-perge-mat-safir-mavi-cekmeceli-lavabo-dolabi-led-ayna-banyo-mobilyasi-3.png?v=1763360573",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-perge-mat-safir-mavi-cekmeceli-lavabo-dolabi-led-ayna-banyo-mobilyasi-1.png?v=1763360571"
    ],
    "price": "14850.00",
    "sku": "SET.PERGE060.MSB",
    "tags": [
      "Banyo Mobilyası"
    ],
    "variants": [
      {
        "id": 52898530984233,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.PERGE060.MSB",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "14850.00",
        "grams": 0,
        "compare_at_price": "30000.00",
        "position": 1,
        "product_id": 9885090775337,
        "created_at": "2026-03-30T15:00:11+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Ürün Ölçüleri: 60*58*51 Cm.</p>\n<p>Yavaş Kapanan Çekmece Özelliğine Sahiptir.</p>\n<p>MDFLAM Üzeri Lake Kaplama</p>\n<p>Ürün Mat Safir Blue Renktir.</p>\n<p>Ayna Ölçüsü: 50*80 Cm</p>\n<p>Lavabo Dahildir.</p>\n<p>Ürün Ayna ile Birlikte İki Parça Set Halinde Gönderilecektir.</p>"
  },
  {
    "id": "creavit-9885012656425",
    "brand": "Creavit",
    "title": "Perge 60 Cm Lavabo Dolabı Mat Gri ve Led Ayna",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-perge-mat-gri-cekmeceli-lavabo-dolabi-led-ayna-banyo-mobilyasi.png?v=1763360318",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-perge-mat-gri-cekmeceli-lavabo-dolabi-led-ayna-banyo-mobilyasi.png?v=1763360318",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-perge-mat-gri-cekmeceli-lavabo-dolabi-led-ayna-banyo-mobilyasi-3.png?v=1763360318",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-perge-mat-gri-cekmeceli-lavabo-dolabi-led-ayna-banyo-mobilyasi-1.png?v=1763360318",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-perge-mat-gri-cekmeceli-lavabo-dolabi-led-ayna-banyo-mobilyasi-2.png?v=1763360318"
    ],
    "price": "14850.00",
    "sku": "SET.PERGE060.MGR",
    "tags": [
      "Banyo Mobilyası"
    ],
    "variants": [
      {
        "id": 52880685564201,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.PERGE060.MGR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "14850.00",
        "grams": 0,
        "compare_at_price": "30000.00",
        "position": 1,
        "product_id": 9885012656425,
        "created_at": "2026-03-26T10:49:10+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Ürün Ölçüleri: 60*58*51 Cm.</p>\n<p>Yavaş Kapanan Çekmece Özelliğine Sahiptir.</p>\n<p>MDFLAM Üzeri Lake Kaplama</p>\n<p>Ürün Mat Gri Renktir.</p>\n<p>Ayna Ölçüsü: 50*80 Cm</p>\n<p>Lavabo Dahildir.</p>\n<p>Ürün Ayna ile Birlikte İki Parça Set Halinde Gönderilecektir.</p>\n<p> </p>"
  },
  {
    "id": "creavit-9885000565033",
    "brand": "Creavit",
    "title": "Angel Lavabo Dolabı 120 Cm Plazzo ve Led Ayna",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-angel-krom-lavabo-dolabi-ayna-banyo-mobilyas-1_1.png?v=1763359408",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-angel-krom-lavabo-dolabi-ayna-banyo-mobilyas-1_1.png?v=1763359408",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-angel-krom-lavabo-dolabi-ayna-banyo-mobilyas-2-.009_1.png?v=1763359408",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-angel-krom-lavabo-dolabi-ayna-banyo-mobilyas-3_1.png?v=1763359408"
    ],
    "price": "31500.00",
    "sku": "SET.ANGEL120.PZK",
    "tags": [
      "Banyo Mobilyası"
    ],
    "variants": [
      {
        "id": 52836646846761,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.ANGEL120.PZK",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "31500.00",
        "grams": 0,
        "compare_at_price": "70000.00",
        "position": 1,
        "product_id": 9885000565033,
        "created_at": "2026-03-15T21:08:21+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Ürün Ölçüleri: 120*39*50 Cm.</p>\n<p>Ürün Lavabo Dahil Yerden 85 Cm yükseklikte Monte Edilmelidir.</p>\n<p>Şık ve Dayanıklı Lake Malzemeden Üretilmiştir.</p>\n<p>Yavaş Kapanan Çekmece Özelliğine Sahiptir.</p>\n<p>Ürün Üzerinde entegre Havluluk Mevcuttur.</p>\n<p>Ürün Plazzo Renktir.</p>\n<p>Ayna Ölçüsü: 92*50*5 Cm.</p>\n<p>Ayna Led Işığı Rengi: Gün Işığı</p>\n<p>Garanti Süresi: 2 Yıl</p>\n<p>Lavabo Dahildir.</p>\n<p>Ürün Ayna Ve Dolap Olarak İki Parça Set Halinde Gönderilecektir</p>"
  },
  {
    "id": "creavit-9884991422761",
    "brand": "Creavit",
    "title": "Angel 120 Cm Lavabo Dolabı Beyaz ve Led Ayna",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-angel-bakir-lavabo-dolabi-ayna-banyo-mobilyas-1_1_647a9f5d-9994-48b3-af51-d6e618e27613.png?v=1763358892",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-angel-bakir-lavabo-dolabi-ayna-banyo-mobilyas-1_1_647a9f5d-9994-48b3-af51-d6e618e27613.png?v=1763358892",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-angel-bakir-lavabo-dolabi-ayna-banyo-mobilyas-3_1_575e2375-05b7-4b3c-ba69-0157bf1a5dd6.png?v=1763358892",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-angel-bakir-lavabo-dolabi-ayna-banyo-mobilyas-4_1_484c9cb2-002c-42e1-afb2-3484fe3f69dc.png?v=1763358892",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-angel-bakir-lavabo-dolabi-ayna-banyo-mobilyasi_1_b49d8a2e-3c1c-4835-80e5-06b985b1f427.png?v=1763358892",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-angel-bakir-lavabo-dolabi-banyo-mobilyasi-2_1_2c224766-6282-475a-9d78-95293fc922d4.png?v=1763358892"
    ],
    "price": "31500.00",
    "sku": "SET.ANGEL120.BBR",
    "tags": [
      "Banyo Mobilyası"
    ],
    "variants": [
      {
        "id": 52836646420777,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.ANGEL120.BBR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "31500.00",
        "grams": 0,
        "compare_at_price": "70000.00",
        "position": 1,
        "product_id": 9884991422761,
        "created_at": "2026-03-15T21:08:18+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Ürün Ölçüleri: 120*39*50 Cm.</p>\n<p>Ürün Lavabo Dahil Yerden 85 Cm yükseklikte Monte Edilmelidir.</p>\n<p>Şık ve Dayanaklı Lake Malzemeden Üretilmiştir.</p>\n<p>Yavaş Kapanan Çekmece Özelliğine Sahiptir.</p>\n<p>Ürün Üzerinde entegre Havluluk Mevcuttur.</p>\n<p>Ürün Beyaz Renktir.</p>\n<p>Ayna Ölçüsü: 92*50*5 Cm.</p>\n<p>Ayna Led Işığı Rengi: Gün Işığı</p>\n<p>Garanti Süresi: 2 Yıl</p>\n<p>Lavabo Dahildir.</p>\n<p>Ürün Ayna Ve Dolap Olarak İki Parça Set Halinde Gönderilecektir</p>"
  },
  {
    "id": "creavit-9879861592361",
    "brand": "Creavit",
    "title": "Pion 120 Cm Lavabo Dolabı Beyaz Siyah ve Led Ayna",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-120-cm-lavabo-dolabi-beyaz-siyah-ve-led-ayna-7838.png?v=1763119271",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-120-cm-lavabo-dolabi-beyaz-siyah-ve-led-ayna-7838.png?v=1763119271",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-pion-lavabo-dolabi-120cm-banyo-mobilyasi-siyah-3.png?v=1763119465",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-pion-lavabo-dolabi-120cm-banyo-mobilyasi-siyah.png?v=1763119465"
    ],
    "price": "36000.00",
    "sku": "SET.PİON120.BS",
    "tags": [
      "Banyo Mobilyası"
    ],
    "variants": [
      {
        "id": 52911034663209,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.PİON120.BS",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "36000.00",
        "grams": 0,
        "compare_at_price": "80000.00",
        "position": 1,
        "product_id": 9879861592361,
        "created_at": "2026-04-01T08:05:44+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Lavabo Dolabı Ölçüsü: 120*85*52 Cm</p>\n<p>Ayna Ölçüsü: 118* 58*14 Cm</p>\n<p>Çekmeceli Lavabo Dolabı</p>\n<p>Gizli Çekmece Mevcuttur</p>\n<p>Yavaş Kanan Çekmece Özelliğine Sahiptir</p>\n<p>Şık ve Dayanaklı Lake Kaplama</p>\n<p>Garanti Süresi: 2 Yıl</p>\n<p>Ürün Lavabo Dolabı ve Ayna Olarak Gönderilecektir.</p>"
  },
  {
    "id": "creavit-9879760109865",
    "brand": "Creavit",
    "title": "Drop 130 Cm Boy Dolabı Ön Kapak Aynalı Beyaz",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-130-cm-boy-dolabi-on-kapak-aynali-beyaz-7837.png?v=1763116316",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-130-cm-boy-dolabi-on-kapak-aynali-beyaz-7837.png?v=1763116316"
    ],
    "price": "10500.00",
    "sku": "DP2130.02.BB",
    "tags": [
      "Banyo Mobilyası"
    ],
    "variants": [
      {
        "id": 52836693737769,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DP2130.02.BB",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "10500.00",
        "grams": 0,
        "compare_at_price": "17500.00",
        "position": 1,
        "product_id": 9879760109865,
        "created_at": "2026-03-15T21:25:29+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Ürün Ölçüleri: 40*130*35 Cm.</p>\n<p>Beyaz Renk.</p>\n<p>Aynalı ve Yavaş Kapanan Kapak.</p>\n<p>MDF Malzeme.</p>\n<p>Montaj Tipi: Asma.</p>\n<p>Garanti Süresi: 2 Yıl.</p>"
  },
  {
    "id": "creavit-9879755686185",
    "brand": "Creavit",
    "title": "Drop 130 Cm Boy Dolabı Ön Kapak Aynalı Antrasit",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-130-cm-boy-dolabi-on-kapak-aynali-antrasit-7836.png?v=1763116164",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-130-cm-boy-dolabi-on-kapak-aynali-antrasit-7836.png?v=1763116164"
    ],
    "price": "10500.00",
    "sku": "DP2130.02.AA",
    "tags": [
      "Banyo Mobilyası"
    ],
    "variants": [
      {
        "id": 52836693705001,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DP2130.02.AA",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "10500.00",
        "grams": 0,
        "compare_at_price": "17500.00",
        "position": 1,
        "product_id": 9879755686185,
        "created_at": "2026-03-15T21:25:26+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><!-- x-tinymce/html -->Ürün Ölçüleri: 40*130*35 Cm.</p>\n<p>Antrasit Renk.</p>\n<p>Aynalı ve Yavaş Kapanan Kapak.</p>\n<p>MDF Malzeme.</p>\n<p>Montaj Tipi: Asma.</p>\n<p>Garanti Süresi: 2 Yıl.</p>"
  },
  {
    "id": "creavit-9878990127401",
    "brand": "Creavit",
    "title": "D10 65cm.KPK.Lav.Dlp.ML.DAF.LK.DAF",
    "category": "456291287337",
    "image": "",
    "images": [],
    "price": "7392.00",
    "sku": "D10.LD065.K.M.L.0202",
    "tags": [],
    "variants": [
      {
        "id": 52843076092201,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.K.M.L.0202",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7392.00",
        "grams": 0,
        "compare_at_price": "9240.00",
        "position": 1,
        "product_id": 9878990127401,
        "created_at": "2026-03-17T11:53:59+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": ""
  },
  {
    "id": "creavit-9875451216169",
    "brand": "Creavit",
    "title": "Antik 115 Cm Boy Dolabı Desenli Siyah - Beyaz",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-115-cm-boy-dolabi-desenli-siyah-beyaz-7835.png?v=1762762568",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-115-cm-boy-dolabi-desenli-siyah-beyaz-7835.png?v=1762762568"
    ],
    "price": "15000.00",
    "sku": "AN2115.02.SB",
    "tags": [
      "Banyo Mobilyası",
      "boy dolabı"
    ],
    "variants": [
      {
        "id": 52836693573929,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "AN2115.02.SB",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "15000.00",
        "grams": 0,
        "compare_at_price": "25000.00",
        "position": 1,
        "product_id": 9875451216169,
        "created_at": "2026-03-15T21:25:19+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Ürün Ölçüleri: 50*115*45 Cm.</p>\n<p>Desenli Siyah Renk.</p>\n<p>Yavaş Kapanan Kapak.</p>\n<p>Ürün MDF Malzemedir.</p>\n<p>Garanti Süresi: 2 Yıl</p>"
  },
  {
    "id": "creavit-9875450134825",
    "brand": "Creavit",
    "title": "Antik 115 Cm Boy Dolabı Desenli Beyaz - Beyaz",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-115-cm-boy-dolabi-desenli-beyaz-beyaz-7834.png?v=1762762258",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/antik-115-cm-boy-dolabi-desenli-beyaz-beyaz-7834.png?v=1762762258"
    ],
    "price": "15000.00",
    "sku": "AN2115.02.BB",
    "tags": [
      "Banyo Mobilyası"
    ],
    "variants": [
      {
        "id": 52836693475625,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "AN2115.02.BB",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "15000.00",
        "grams": 0,
        "compare_at_price": "25000.00",
        "position": 1,
        "product_id": 9875450134825,
        "created_at": "2026-03-15T21:25:16+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Ürün Ölçüleri: 50*115*45 Cm.</p>\n<p>Desenli Beyaz Renk.</p>\n<p>Yavaş Kapanan Kapak.</p>\n<p>Ürün MDF Malzemedir.</p>\n<p>Garanti Süresi: 2 Yıl</p>"
  },
  {
    "id": "creavit-9875446661417",
    "brand": "Creavit",
    "title": "Angel Boy Dolabı 45*120 Cm Palazzo - Krom",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/angel-boy-dolabi-45-120-cm-palazzo-krom-7832.png?v=1762761318",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/angel-boy-dolabi-45-120-cm-palazzo-krom-7832.png?v=1762761318"
    ],
    "price": "18000.00",
    "sku": "AL2120.00.PZ",
    "tags": [
      "Banyo Mobilyası"
    ],
    "variants": [
      {
        "id": 52836649500969,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "AL2120.00.PZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "18000.00",
        "grams": 0,
        "compare_at_price": "30000.00",
        "position": 1,
        "product_id": 9875446661417,
        "created_at": "2026-03-15T21:09:18+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Ürün Ölçüleri: 45*120*35 Cm</p>\n<p>Plazzo Krom Renk</p>\n<p>MDF Malzeme</p>\n<p>Montaj Tipi: Asma</p>\n<p>Garanti Süresi: 2 Yıl</p>"
  },
  {
    "id": "creavit-9875446268201",
    "brand": "Creavit",
    "title": "Angel Boy Dolabı 45*120 Cm  Beyaz - Bakır",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/angel-boy-dolabi-45-120-cm-beyaz-bakir-7831.png?v=1762761258",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/angel-boy-dolabi-45-120-cm-beyaz-bakir-7831.png?v=1762761258"
    ],
    "price": "18000.00",
    "sku": "AL2120.00.BB",
    "tags": [
      "Banyo Mobilyası"
    ],
    "variants": [
      {
        "id": 52836649009449,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "AL2120.00.BB",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "18000.00",
        "grams": 0,
        "compare_at_price": "30000.00",
        "position": 1,
        "product_id": 9875446268201,
        "created_at": "2026-03-15T21:09:08+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Ürün Ölçüleri: 45*120*35 Cm</p>\n<p>Beyaz Bakır Renk</p>\n<p>MDF Malzeme</p>\n<p>Montaj Tipi: Asma</p>\n<p>Garanti Süresi: 2 Yıl</p>"
  },
  {
    "id": "creavit-9867618550057",
    "brand": "Creavit",
    "title": "D10 100 Cm Kapaklı Lavabo Dolabı Melamin Gri Gövde Melamin Antrasit Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-kpk-lav-dlp-ml-gri-ml-ant-7800.jpg?v=1762166482",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-kpk-lav-dlp-ml-gri-ml-ant-7800.jpg?v=1762166482",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-kpk-lav-dlp-ml-gri-ml-ant-7801.jpg?v=1762166484",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-kpk-lav-dlp-ml-gri-ml-ant-7802.jpg?v=1762166486"
    ],
    "price": "6864.00",
    "sku": "D10.LD100.K.M.M.0305",
    "tags": [],
    "variants": [
      {
        "id": 52921492439337,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.K.M.M.0305",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6864.00",
        "grams": 0,
        "compare_at_price": "8580.00",
        "position": 1,
        "product_id": 9867618550057,
        "created_at": "2026-04-03T14:46:16+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>"
  },
  {
    "id": "creavit-9867618386217",
    "brand": "Creavit",
    "title": "D10 100 Cm Kapaklı Lavabo dolabı Melamin Dafne Gövde Melamin Meşe Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-kpk-lav-dlp-ml-daf-ml-mse-7797.jpg?v=1762166460",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-kpk-lav-dlp-ml-daf-ml-mse-7797.jpg?v=1762166460",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-kpk-lav-dlp-ml-daf-ml-mse-7798.jpg?v=1762166463",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-kpk-lav-dlp-ml-daf-ml-mse-7799.jpg?v=1762166465"
    ],
    "price": "6864.00",
    "sku": "D10.LD100.K.M.M.0204",
    "tags": [
      "D10"
    ],
    "variants": [
      {
        "id": 52920979849513,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.K.M.M.0204",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6864.00",
        "grams": 0,
        "compare_at_price": "8580.00",
        "position": 1,
        "product_id": 9867618386217,
        "created_at": "2026-04-03T12:18:42+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>"
  },
  {
    "id": "creavit-9867618287913",
    "brand": "Creavit",
    "title": "D10 100 Cm Kapaklı Lavabo Dolabı Melamin Gövde Melamin Beyaz Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-kpk-lav-dlp-ml-byz-ml-byz-7790.jpg?v=1762166439",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-kpk-lav-dlp-ml-byz-ml-byz-7790.jpg?v=1762166439",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-kpk-lav-dlp-ml-byz-ml-byz-7791.jpg?v=1762166442",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-kpk-lav-dlp-ml-byz-ml-byz-7792.jpg?v=1762166444"
    ],
    "price": "6864.00",
    "sku": "D10.LD100.K.M.M.0101",
    "tags": [
      "D10"
    ],
    "variants": [
      {
        "id": 52922141049129,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.K.M.M.0101",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6864.00",
        "grams": 0,
        "compare_at_price": "8580.00",
        "position": 1,
        "product_id": 9867618287913,
        "created_at": "2026-04-03T17:14:40+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>"
  },
  {
    "id": "creavit-9867617993001",
    "brand": "Creavit",
    "title": "D10 100 Cm Kapaklı Lavabo Dolabı Melamin Gövde Lake Kapak Dafne",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-kpk-lav-dlp-ml-daf-lk-daf-7775.jpg?v=1762166419",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-kpk-lav-dlp-ml-daf-lk-daf-7775.jpg?v=1762166419",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-kpk-lav-dlp-ml-daf-lk-daf-7776.jpg?v=1762166421",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-kpk-lav-dlp-ml-daf-lk-daf-7777.jpg?v=1762166422"
    ],
    "price": "9064.00",
    "sku": "D10.LD100.K.M.L.0202",
    "tags": [
      "D10"
    ],
    "variants": [
      {
        "id": 52843082711337,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.K.M.L.0202",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9064.00",
        "grams": 0,
        "compare_at_price": "11330.00",
        "position": 1,
        "product_id": 9867617993001,
        "created_at": "2026-03-17T11:56:25+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>"
  },
  {
    "id": "creavit-9867617894697",
    "brand": "Creavit",
    "title": "D10 100 Cm İki Çekmeceli Lavabo Dolabı Melamin Gri Gövde Melamin Antrasit Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-2ck-lav-dlp-ml-gri-ml-ant-7769.jpg?v=1762166399",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-2ck-lav-dlp-ml-gri-ml-ant-7769.jpg?v=1762166399",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-2ck-lav-dlp-ml-gri-ml-ant-7770.jpg?v=1762166402",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-2ck-lav-dlp-ml-gri-ml-ant-7771.jpg?v=1762166403"
    ],
    "price": "11352.00",
    "sku": "D10.LD100.2C.M.M.0305",
    "tags": [
      "D10"
    ],
    "variants": [
      {
        "id": 52843086184745,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.2C.M.M.0305",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11352.00",
        "grams": 0,
        "compare_at_price": "14190.00",
        "position": 1,
        "product_id": 9867617894697,
        "created_at": "2026-03-17T11:57:49+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>"
  },
  {
    "id": "creavit-9867617861929",
    "brand": "Creavit",
    "title": "D10 100 Cm İki Çekmeceli Lavabo Dolabı Melamin Dafne Gövde Melamin Meşe Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-2ck-lav-dlp-ml-daf-ml-mse-7766.jpg?v=1762166378",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-2ck-lav-dlp-ml-daf-ml-mse-7766.jpg?v=1762166378",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-2ck-lav-dlp-ml-daf-ml-mse-7767.jpg?v=1762166380",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-2ck-lav-dlp-ml-daf-ml-mse-7768.jpg?v=1762166382"
    ],
    "price": "11352.00",
    "sku": "D10.LD100.2C.M.M.0204",
    "tags": [
      "D10",
      "iki çekmeceli lavabo dolabı",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843076813097,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.2C.M.M.0204",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11352.00",
        "grams": 0,
        "compare_at_price": "14190.00",
        "position": 1,
        "product_id": 9867617861929,
        "created_at": "2026-03-17T11:54:15+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>"
  },
  {
    "id": "creavit-9867617665321",
    "brand": "Creavit",
    "title": "D10 100 Cm İki Çekmeceli Lavabo Dolabı Melamin Gövde Melamin Kapak Beyaz",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-2ck-lav-dlp-ml-byz-ml-byz-7763.jpg?v=1762166358",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-2ck-lav-dlp-ml-byz-ml-byz-7763.jpg?v=1762166358",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-2ck-lav-dlp-ml-byz-ml-byz-7764.jpg?v=1762166360",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-2ck-lav-dlp-ml-byz-ml-byz-7765.jpg?v=1762166363"
    ],
    "price": "11352.00",
    "sku": "D10.LD100.2C.M.M.0101",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "iki çekmeceli lavabo dolabı",
      "Lavabo Dolabı",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843076682025,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.2C.M.M.0101",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11352.00",
        "grams": 0,
        "compare_at_price": "14190.00",
        "position": 1,
        "product_id": 9867617665321,
        "created_at": "2026-03-17T11:54:12+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>"
  },
  {
    "id": "creavit-9867617632553",
    "brand": "Creavit",
    "title": "D10 80 Cm Kapaklı Lavabo Dolabı Melamin Dafne Gövde Melamin Meşe Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-kpk-lav-dlp-ml-daf-ml-mse-7758.jpg?v=1762166338",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-kpk-lav-dlp-ml-daf-ml-mse-7758.jpg?v=1762166338",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-kpk-lav-dlp-ml-daf-ml-mse-7759.jpg?v=1762166341",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-kpk-lav-dlp-ml-daf-ml-mse-7760.jpg?v=1762166343"
    ],
    "price": "6248.00",
    "sku": "D10.LD080.K.M.M.0204",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52843078648105,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD080.K.M.M.0204",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "6248.00",
        "grams": 0,
        "compare_at_price": "7810.00",
        "position": 1,
        "product_id": 9867617632553,
        "created_at": "2026-03-17T11:54:53+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>"
  },
  {
    "id": "creavit-9867617501481",
    "brand": "Creavit",
    "title": "D10 80 Cm Kapaklı Lavabo Dolabı Melamin Gövde Melamin Kapak Beyaz",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-kpk-lav-dlp-ml-byz-ml-byz-7755.jpg?v=1762166316",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-kpk-lav-dlp-ml-byz-ml-byz-7755.jpg?v=1762166316",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-kpk-lav-dlp-ml-byz-ml-byz-7756.jpg?v=1762166318",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-kpk-lav-dlp-ml-byz-ml-byz-7757.jpg?v=1762166320"
    ],
    "price": "6248.00",
    "sku": "D10.LD080.K.M.M.0101",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52933920850217,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD080.K.M.M.0101",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6248.00",
        "grams": 0,
        "compare_at_price": "7810.00",
        "position": 1,
        "product_id": 9867617501481,
        "created_at": "2026-04-05T23:21:25+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>"
  },
  {
    "id": "creavit-9867617304873",
    "brand": "Creavit",
    "title": "D10 80 Cm Kapaklı Lavabo Dolabı Melamin Gövde Gri Lake Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-kpk-lav-dlp-ml-gri-lk-gri-7752.jpg?v=1762166295",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-kpk-lav-dlp-ml-gri-lk-gri-7752.jpg?v=1762166295",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-kpk-lav-dlp-ml-gri-lk-gri-7753.jpg?v=1762166298",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-kpk-lav-dlp-ml-gri-lk-gri-7754.jpg?v=1762166299"
    ],
    "price": "8096.00",
    "sku": "D10.LD080.K.M.L.0303",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52843082449193,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD080.K.M.L.0303",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8096.00",
        "grams": 0,
        "compare_at_price": "10120.00",
        "position": 1,
        "product_id": 9867617304873,
        "created_at": "2026-03-17T11:56:19+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>"
  },
  {
    "id": "creavit-9867617239337",
    "brand": "Creavit",
    "title": "D10 80 Cm Kapaklı Lavabo Dolabı Melamin Gövde Dafne Lake Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-kpk-lav-dlp-ml-daf-lk-daf-7749.jpg?v=1762166275",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-kpk-lav-dlp-ml-daf-lk-daf-7749.jpg?v=1762166275",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-kpk-lav-dlp-ml-daf-lk-daf-7750.jpg?v=1762166276",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-kpk-lav-dlp-ml-daf-lk-daf-7751.jpg?v=1762166279"
    ],
    "price": "8096.00",
    "sku": "D10.LD080.K.M.L.0202",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52939312267561,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD080.K.M.L.0202",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "8096.00",
        "grams": 0,
        "compare_at_price": "10120.00",
        "position": 1,
        "product_id": 9867617239337,
        "created_at": "2026-04-07T00:11:38+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>"
  },
  {
    "id": "creavit-9867617206569",
    "brand": "Creavit",
    "title": "D10 80 Cm Kapaklı Lavabo Dolabı Melamin Gövde Beyaz Lake Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-kpk-lav-dlp-ml-byz-lk-byz-7746.jpg?v=1762166256",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-kpk-lav-dlp-ml-byz-lk-byz-7746.jpg?v=1762166256",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-kpk-lav-dlp-ml-byz-lk-byz-7747.jpg?v=1762166259"
    ],
    "price": "8096.00",
    "sku": "D10.LD080.K.M.L.0101",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52843076419881,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD080.K.M.L.0101",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "8096.00",
        "grams": 0,
        "compare_at_price": "10120.00",
        "position": 1,
        "product_id": 9867617206569,
        "created_at": "2026-03-17T11:54:06+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>"
  },
  {
    "id": "creavit-9867617173801",
    "brand": "Creavit",
    "title": "D10 80 Cm İki Çekmeceli Lavabo Dolabı Melamin Grı Gövde Melamin Antrasit Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-2ck-lav-dlp-ml-gri-ml-ant-7743.jpg?v=1762166237",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-2ck-lav-dlp-ml-gri-ml-ant-7743.jpg?v=1762166237",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-2ck-lav-dlp-ml-gri-ml-ant-7744.jpg?v=1762166239",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-2ck-lav-dlp-ml-gri-ml-ant-7745.jpg?v=1762166241"
    ],
    "price": "9680.00",
    "sku": "D10.LD080.2C.M.M.0305",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "iki çekmeceli lavabo dolabı",
      "Lavabo Dolabı",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843077370153,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD080.2C.M.M.0305",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "9680.00",
        "grams": 0,
        "compare_at_price": "12100.00",
        "position": 1,
        "product_id": 9867617173801,
        "created_at": "2026-03-17T11:54:27+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>"
  },
  {
    "id": "creavit-9867617009961",
    "brand": "Creavit",
    "title": "D10 80 Cm İki Çekmeceli Lavabo Dolabı Melamin Dafne Melamin Meşe Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-2ck-lav-dlp-ml-daf-ml-mse-7740.jpg?v=1762166217",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-2ck-lav-dlp-ml-daf-ml-mse-7740.jpg?v=1762166217",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-2ck-lav-dlp-ml-daf-ml-mse-7741.jpg?v=1762166219",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-2ck-lav-dlp-ml-daf-ml-mse-7742.jpg?v=1762166221"
    ],
    "price": "9680.00",
    "sku": "D10.LD080.2C.M.M.0204",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "iki çekmeceli lavabo dolabı",
      "Lavabo Dolabı",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843082121513,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD080.2C.M.M.0204",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9680.00",
        "grams": 0,
        "compare_at_price": "12100.00",
        "position": 1,
        "product_id": 9867617009961,
        "created_at": "2026-03-17T11:56:12+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>"
  },
  {
    "id": "creavit-9867616944425",
    "brand": "Creavit",
    "title": "D10 80 Cm İki Çekmeceli Lavabo Dolabı Melamin Gövde Melamin Kapak Beyaz",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-2ck-lav-dlp-ml-byz-ml-byz-7737.jpg?v=1762166198",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-2ck-lav-dlp-ml-byz-ml-byz-7737.jpg?v=1762166198",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-2ck-lav-dlp-ml-byz-ml-byz-7738.jpg?v=1762166200",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-2ck-lav-dlp-ml-byz-ml-byz-7739.jpg?v=1762166202"
    ],
    "price": "9680.00",
    "sku": "D10.LD080.2C.M.M.0101",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "iki çekmeceli lavabo dolabı",
      "Lavabo Dolabı",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52911789965609,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD080.2C.M.M.0101",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "9680.00",
        "grams": 0,
        "compare_at_price": "12100.00",
        "position": 1,
        "product_id": 9867616944425,
        "created_at": "2026-04-01T11:43:23+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>"
  },
  {
    "id": "creavit-9867616911657",
    "brand": "Creavit",
    "title": "D10 80 Cm İki Çekmeceli Lavabo Dolabı Melamin Gövde Gri Lake Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-2ck-lav-dlp-ml-gri-lk-gri-7734.jpg?v=1762166179",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-2ck-lav-dlp-ml-gri-lk-gri-7734.jpg?v=1762166179",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-2ck-lav-dlp-ml-gri-lk-gri-7735.jpg?v=1762166181",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-2ck-lav-dlp-ml-gri-lk-gri-7736.jpg?v=1762166183"
    ],
    "price": "11264.00",
    "sku": "D10.LD080.2C.M.L.0303",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "iki çekmeceli lavabo dolabı",
      "Lavabo Dolabı",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843076288809,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD080.2C.M.L.0303",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "11264.00",
        "grams": 0,
        "compare_at_price": "14080.00",
        "position": 1,
        "product_id": 9867616911657,
        "created_at": "2026-03-17T11:54:03+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "D10 İKİ ÇEKMECELİ LAVABO DOLABI LAKE GRI KAPAK"
  },
  {
    "id": "creavit-9867616747817",
    "brand": "Creavit",
    "title": "D10 80 Cm İki Çekmeceli Lavabo Dolabı Melamin Gövde Dafne Lake Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-2ck-lav-dlp-ml-daf-lk-daf-7731.jpg?v=1762166160",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-2ck-lav-dlp-ml-daf-lk-daf-7731.jpg?v=1762166160",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-2ck-lav-dlp-ml-daf-lk-daf-7732.jpg?v=1762166162",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-2ck-lav-dlp-ml-daf-lk-daf-7733.jpg?v=1762166164"
    ],
    "price": "11264.00",
    "sku": "D10.LD080.2C.M.L.0202",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "iki çekmeceli lavabo dolabı",
      "Lavabo Dolabı",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52932161503529,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD080.2C.M.L.0202",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11264.00",
        "grams": 0,
        "compare_at_price": "14080.00",
        "position": 1,
        "product_id": 9867616747817,
        "created_at": "2026-04-05T12:00:42+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>"
  },
  {
    "id": "creavit-9867616715049",
    "brand": "Creavit",
    "title": "D10 65 Cm Kapaklı Lavabo Dolabı Melamin Gri Gövde Melamin Antrasit Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-kpk-lav-dlp-ml-gri-ml-ant-7725.jpg?v=1762166140",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-kpk-lav-dlp-ml-gri-ml-ant-7725.jpg?v=1762166140",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-kpk-lav-dlp-ml-gri-ml-ant-7726.jpg?v=1762166142",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-kpk-lav-dlp-ml-gri-ml-ant-7727.jpg?v=1762166144"
    ],
    "price": "5720.00",
    "sku": "D10.LD065.K.M.M.0305",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "Kapaksız Lavabo Dolabı",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52932372726057,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.K.M.M.0305",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5720.00",
        "grams": 0,
        "compare_at_price": "7150.00",
        "position": 1,
        "product_id": 9867616715049,
        "created_at": "2026-04-05T13:06:40+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>"
  },
  {
    "id": "creavit-9867616682281",
    "brand": "Creavit",
    "title": "D10 65 Cm Kapaklı Lavabo Dolabı Melamin Gri Gövde Lake Gri Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-kpk-lav-dlp-ml-gri-lk-gri-7719.jpg?v=1762166120",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-kpk-lav-dlp-ml-gri-lk-gri-7719.jpg?v=1762166120",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-kpk-lav-dlp-ml-gri-lk-gri-7720.jpg?v=1762166122",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-kpk-lav-dlp-ml-gri-lk-gri-7721.jpg?v=1762166124"
    ],
    "price": "7392.00",
    "sku": "D10.LD065.K.M.L.0303",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52921491947817,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.K.M.L.0303",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7392.00",
        "grams": 0,
        "compare_at_price": "9240.00",
        "position": 1,
        "product_id": 9867616682281,
        "created_at": "2026-04-03T14:46:09+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>"
  },
  {
    "id": "creavit-9867616485673",
    "brand": "Creavit",
    "title": "D10 65cm.2CK.Lav.Dlp.ML.GRI.ML.ANT",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-2ck-lav-dlp-ml-gri-ml-ant-7707.jpg?v=1762166086",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-2ck-lav-dlp-ml-gri-ml-ant-7707.jpg?v=1762166086",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-2ck-lav-dlp-ml-gri-ml-ant-7708.jpg?v=1762166088",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-2ck-lav-dlp-ml-gri-ml-ant-7709.jpg?v=1762166091"
    ],
    "price": "9064.00",
    "sku": "D10.LD065.2C.M.M.0305",
    "tags": [],
    "variants": [
      {
        "id": 52843081597225,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.2C.M.M.0305",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9064.00",
        "grams": 0,
        "compare_at_price": "11330.00",
        "position": 1,
        "product_id": 9867616485673,
        "created_at": "2026-03-17T11:56:00+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "D10 65 CM İKİ ÇEKMECELİ LAVABO DOLABI MELAMİN GÖVDE GRİ MELAMİN KAPAK ANTRASİT"
  },
  {
    "id": "creavit-9867616420137",
    "brand": "Creavit",
    "title": "D10 65cm.2CK.Lav.Dlp.ML.DAF.ML.MSE",
    "category": "456291287337",
    "image": "",
    "images": [],
    "price": "9064.00",
    "sku": "D10.LD065.2C.M.M.0204",
    "tags": [],
    "variants": [
      {
        "id": 52843075993897,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.2C.M.M.0204",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9064.00",
        "grams": 0,
        "compare_at_price": "11330.00",
        "position": 1,
        "product_id": 9867616420137,
        "created_at": "2026-03-17T11:53:56+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": ""
  },
  {
    "id": "creavit-9867616354601",
    "brand": "Creavit",
    "title": "D10 65cm.2CK.Lav.Dlp.ML.BYZ.ML.BYZ",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-2ck-lav-dlp-ml-byz-ml-byz-7698.jpg?v=1762166052",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-2ck-lav-dlp-ml-byz-ml-byz-7698.jpg?v=1762166052",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-2ck-lav-dlp-ml-byz-ml-byz-7699.jpg?v=1762166055",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-2ck-lav-dlp-ml-byz-ml-byz-7700.jpg?v=1762166057"
    ],
    "price": "9064.00",
    "sku": "D10.LD065.2C.M.M.0101",
    "tags": [],
    "variants": [
      {
        "id": 52843075830057,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.2C.M.M.0101",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9064.00",
        "grams": 0,
        "compare_at_price": "11330.00",
        "position": 1,
        "product_id": 9867616354601,
        "created_at": "2026-03-17T11:53:53+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "D10 65 CM İKİ ÇEKMECELİ LAVABO DOLABI MELAMİN GÖVDE MELAMİN KAPAK BEYAZ"
  },
  {
    "id": "creavit-9867616125225",
    "brand": "Creavit",
    "title": "D10 80 Cm Next Lavabo Dolabı İki Çek. Beyaz Lake",
    "category": "468907032873",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-2ck-lav-dlp-ml-byz-lk-byz-tmbyz-7728.jpg?v=1762166029",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-2ck-lav-dlp-ml-byz-lk-byz-tmbyz-7728.jpg?v=1762166029",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-2ck-lav-dlp-ml-byz-lk-byz-tmbyz-7729.jpg?v=1762166031",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-2ck-lav-dlp-ml-byz-lk-byz-tmbyz-7730.jpg?v=1762166033"
    ],
    "price": "11176.00",
    "sku": "D10.LD080.2C.M.L.T.01011",
    "tags": [],
    "variants": [
      {
        "id": 52843094573353,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD080.2C.M.L.T.01011",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "11176.00",
        "grams": 0,
        "compare_at_price": "13970.00",
        "position": 1,
        "product_id": 9867616125225,
        "created_at": "2026-03-17T12:00:47+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "D10 80 CM İKİ ÇEKEMECELİ TEZGAHLI LAKE BEYAZ LAVABO DOLABI"
  },
  {
    "id": "creavit-8975707570473",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı Çekmeceli 80 cm Gri Lake Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-80cm-gri-lavabo-dolabi-cekmeceli-lake-banyo-mobilyasi.png?v=1748253448",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-80cm-gri-lavabo-dolabi-cekmeceli-lake-banyo-mobilyasi.png?v=1748253448",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-80-cm-gri-lake-6066.jpg?v=1748253448",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-80-cm-gri-lake-6063.jpg?v=1748253448",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-80-cm-gri-lake-6064.jpg?v=1748253448",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-80-cm-gri-lake-6065.jpg?v=1748253448",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-80-cm-gri-lake-6067.jpg?v=1748253445",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-80-cm-gri-lake-6068.jpg?v=1748253445"
    ],
    "price": "8096.00",
    "sku": "D10.LD080.1C.M.L.T.03033",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "Gri",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52936009220393,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD080.1C.M.L.T.03033",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8096.00",
        "grams": 0,
        "compare_at_price": "10120.00",
        "position": 1,
        "product_id": 8975707570473,
        "created_at": "2026-04-06T09:21:16+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-8975543796009",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı İki Çekmeceli 80 cm Beyaz Lake Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-80cm-beyaz-lavabo-dolabi-cift-cekmeceli-lake-banyo-mobilyasi.png?v=1748254737",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-80cm-beyaz-lavabo-dolabi-cift-cekmeceli-lake-banyo-mobilyasi.png?v=1748254737",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-80-cm-beyaz-lake-kapak-5985.jpg?v=1748254737",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-80-cm-beyaz-lake-kapak-5986.jpg?v=1748254737",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-80-cm-beyaz-lake-kapak-5984.jpg?v=1748254737",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-80-cm-beyaz-lake-kapak-5988.jpg?v=1748254734",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-80-cm-beyaz-lake-kapak-5990.jpg?v=1748254734"
    ],
    "price": "11264.00",
    "sku": "D10.LD080.2C.M.L.0101",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "iki çekmeceli lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843078385961,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD080.2C.M.L.0101",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "11264.00",
        "grams": 0,
        "compare_at_price": "14080.00",
        "position": 1,
        "product_id": 8975543796009,
        "created_at": "2026-03-17T11:54:46+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-9867611668777",
    "brand": "Creavit",
    "title": "D10 100cm.KPK.Lav.Dlp.ML.BYZ.LK.BYZ",
    "category": "468907098409",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-kpk-lav-dlp-ml-byz-lk-byz-7772.jpg?v=1762165506",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-kpk-lav-dlp-ml-byz-lk-byz-7772.jpg?v=1762165506",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-kpk-lav-dlp-ml-byz-lk-byz-7773.jpg?v=1762165508",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-kpk-lav-dlp-ml-byz-lk-byz-7774.jpg?v=1762165510"
    ],
    "price": "9064.00",
    "sku": "D10.LD100.K.M.L.0101",
    "tags": [],
    "variants": [
      {
        "id": 52913467228457,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.K.M.L.0101",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9064.00",
        "grams": 0,
        "compare_at_price": "11330.00",
        "position": 1,
        "product_id": 9867611668777,
        "created_at": "2026-04-01T20:24:19+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>D10 100 CM KAPAKLI LAVABO DOLABI MELAMİN GÖVDE LAKE BEYAZ KAPAK</p>\r\n<p> </p>"
  },
  {
    "id": "creavit-9867611537705",
    "brand": "Creavit",
    "title": "D10 65cm.KPK.Lav.Dlp.ML.BYZ.LK.BYZ",
    "category": "468907098409",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-kpk-lav-dlp-ml-byz-lk-byz-7710.jpg?v=1762165485",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-kpk-lav-dlp-ml-byz-lk-byz-7710.jpg?v=1762165485",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-kpk-lav-dlp-ml-byz-lk-byz-7711.jpg?v=1762165487",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-kpk-lav-dlp-ml-byz-lk-byz-7712.jpg?v=1762165490"
    ],
    "price": "7392.00",
    "sku": "D10.LD065.K.M.L.0101",
    "tags": [],
    "variants": [
      {
        "id": 52843093197097,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.K.M.L.0101",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7392.00",
        "grams": 0,
        "compare_at_price": "9240.00",
        "position": 1,
        "product_id": 9867611537705,
        "created_at": "2026-03-17T12:00:15+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "D10 65 CM KAPAKLI LAVABO DOLABI MELAMİN GÖVDE BEYAZ LAKE KAPAK"
  },
  {
    "id": "creavit-9867611439401",
    "brand": "Creavit",
    "title": "D10 65cm.2CK.Lav.Dlp.ML.BYZ.LK.BYZ",
    "category": "468907032873",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-2ck-lav-dlp-ml-byz-lk-byz-7686.jpg?v=1762165466",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-2ck-lav-dlp-ml-byz-lk-byz-7686.jpg?v=1762165466",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-2ck-lav-dlp-ml-byz-lk-byz-7687.jpg?v=1762165468",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-2ck-lav-dlp-ml-byz-lk-byz-7688.jpg?v=1762165470"
    ],
    "price": "10648.00",
    "sku": "D10.LD065.2C.M.L.0101",
    "tags": [],
    "variants": [
      {
        "id": 52843075731753,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.2C.M.L.0101",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "10648.00",
        "grams": 0,
        "compare_at_price": "13310.00",
        "position": 1,
        "product_id": 9867611439401,
        "created_at": "2026-03-17T11:53:50+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>D10 65 CM İKİ ÇEMECELİ LAVABO DOLABI MELAMİN GÖVDE LAKE KAPAK BEYAZ</p>\r\n<p> </p>"
  },
  {
    "id": "creavit-8973510377769",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı Çekmeceli 100 cm Beyaz Lake",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-beyaz-lake-5855.jpg?v=1747227608",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-beyaz-lake-5855.jpg?v=1747227608",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-beyaz-lake-5856.jpg?v=1747227612",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-beyaz-lake-5857.jpg?v=1747227615",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-beyaz-lake-5858.jpg?v=1747227617",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-beyaz-lake-5859.jpg?v=1747227620"
    ],
    "price": "10824.00",
    "sku": "D10.LD100.1C.M.L.T.01011",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843080122665,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.1C.M.L.T.01011",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "10824.00",
        "grams": 0,
        "compare_at_price": "13530.00",
        "position": 1,
        "product_id": 8973510377769,
        "created_at": "2026-03-17T11:55:25+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8973491667241",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı İki Çekmeceli 100 cm Gri Antrasit",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-gri-antrasit-5800.png?v=1747234078",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-gri-antrasit-5800.png?v=1747234078",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-gri-antrasit-5801.jpg?v=1747234081",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-gri-antrasit-5802.jpg?v=1747234084",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-gri-antrasit-5803.jpg?v=1747234087",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-gri-antrasit-5804.jpg?v=1747234089",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-gri-antrasit-5805.jpg?v=1747234093",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-gri-antrasit-5806.jpg?v=1747234097",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-gri-antrasit-5807.jpg?v=1747234101",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-gri-antrasit-5808.jpg?v=1747234105"
    ],
    "price": "10824.00",
    "sku": "D10.LD100.2C.M.M.T.03053",
    "tags": [
      "Antrasit",
      "Banyo Mobilyası",
      "D10",
      "Gri",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843072979241,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.2C.M.M.T.03053",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "10824.00",
        "grams": 0,
        "compare_at_price": "13530.00",
        "position": 1,
        "product_id": 8973491667241,
        "created_at": "2026-03-17T11:52:48+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-8974696546601",
    "brand": "Creavit",
    "title": "D10 80cm Kapaklı Lavabo Dolabı Gri Melamin Antrasit",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-kapakli-lavabo-dolabi-gri-melamin-antrasit-5946.jpg?v=1747227961",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-kapakli-lavabo-dolabi-gri-melamin-antrasit-5946.jpg?v=1747227961",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-kapakli-lavabo-dolabi-gri-melamin-antrasit-5947.jpg?v=1747227963",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-kapakli-lavabo-dolabi-gri-melamin-antrasit-5948.jpg?v=1747227966",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80cm-kapakli-lavabo-dolabi-gri-melamin-antrasit-5949.jpg?v=1747227969"
    ],
    "price": "6248.00",
    "sku": "D10.LD080.K.M.M.0305",
    "tags": [
      "%10 indirim Yaz",
      "Antrasit",
      "Banyo Mobilyası",
      "D10",
      "D20",
      "Gri",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843073765673,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD080.K.M.M.0305",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "6248.00",
        "grams": 0,
        "compare_at_price": "7810.00",
        "position": 1,
        "product_id": 8974696546601,
        "created_at": "2026-03-17T11:53:06+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-8975747514665",
    "brand": "Creavit",
    "title": "D10 Eksen Lavabo Dolabı Çekmeceli 80 cm Dafne Lake Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-eksen-lavabolu-80cm-dafne-lavabo-dolabi-cekmeceli-lake-banyo-mobilyasi.png?v=1748252986",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-eksen-lavabolu-80cm-dafne-lavabo-dolabi-cekmeceli-lake-banyo-mobilyasi.png?v=1748252986",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-80-cm-dafne-lake-6086.jpg?v=1748252986",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-80-cm-dafne-lake-6088.jpg?v=1748252986",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-80-cm-dafne-lake-6087.jpg?v=1748252986",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-80-cm-dafne-lake-6085.jpg?v=1748252986",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-80-cm-dafne-lake-6090.jpg?v=1748252981",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-80-cm-dafne-lake-6091.jpg?v=1748252981"
    ],
    "price": "8184.00",
    "sku": "D10.LD080.1C.M.L.0202",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "Dafne",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843074421033,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD080.1C.M.L.0202",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "8184.00",
        "grams": 0,
        "compare_at_price": "10230.00",
        "position": 1,
        "product_id": 8975747514665,
        "created_at": "2026-03-17T11:53:22+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-9867611210025",
    "brand": "Creavit",
    "title": "D10 65 Cm Tek Çekmeceli Lavabo Dolabı Tezgahlı Lake Gri",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/Tekli_1.png?v=1764662740",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/Tekli_1.png?v=1764662740",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/decogenius-view-1.png?v=1764662741",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/decogenius-view-2.png?v=1764662742"
    ],
    "price": "7568.00",
    "sku": "D10.LD065.1C.M.L.T.03033",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "Lavabo Dolabı",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843078811945,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.1C.M.L.T.03033",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "7568.00",
        "grams": 0,
        "compare_at_price": "9460.00",
        "position": 1,
        "product_id": 9867611210025,
        "created_at": "2026-03-17T11:54:57+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Ürün Ölçüleri: 65*32*41 Cm</p>\n<p>Çekmeceli Dolap</p>\n<p>Gövde Suntalam, Kapaklar Lake</p>\n<p>Uyumlu Lavabosu İle Birlikte Gönderilir. (NX242)</p>\n<p>Garanti Süresi: 2 Yıl<br></p>"
  },
  {
    "id": "creavit-8970396631337",
    "brand": "Creavit",
    "title": "D10 80 cm Melamin Aynalı Dolap Beyaz",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-aynali-banyo-dolabi-D10.AD080.ML.BYZ.jpg?v=1743147663",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-aynali-banyo-dolabi-D10.AD080.ML.BYZ.jpg?v=1743147663"
    ],
    "price": "5016.00",
    "sku": "D10.AD080.ML.BYZ",
    "tags": [
      "%10 indirim Yaz",
      "Ayna",
      "Aynalı Dolap",
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "D20",
      "Melamin",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52896594854185,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.AD080.ML.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5016.00",
        "grams": 0,
        "compare_at_price": "6270.00",
        "position": 1,
        "product_id": 8970396631337,
        "created_at": "2026-03-30T00:50:07+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8969225961769",
    "brand": "Creavit",
    "title": "D10 20 cm Sağ Üst Dolap Gri Melamin Gövde Antrasit Kapak",
    "category": "Üst Dolaplar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-gri-melamin-govde-antrasit-kapak.png?v=1749122537",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-gri-melamin-govde-antrasit-kapak.png?v=1749122537",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sag-ust-dolap-gri-melamin-govde-antrasit-kapak-5633_864637f5-0fc7-44a7-9317-102707804061.jpg?v=1749122771",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-gri-melamin-govde-antrasit-kapak-5641.jpg?v=1749122771",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-gri-melamin-govde-antrasit-kapak-5642.jpg?v=1749122771",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-gri-melamin-govde-antrasit-kapak-5643.jpg?v=1749122771",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-gri-melamin-govde-antrasit-kapak-5645.jpg?v=1749122771",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-gri-melamin-govde-antrasit-kapak-5646.jpg?v=1749122771"
    ],
    "price": "2288.00",
    "sku": "D10.UD020.SAG.M.M.0305",
    "tags": [
      "Antrasit",
      "Banyo Mobilyası",
      "D10",
      "Gri",
      "Melamin",
      "Sağ Üst Dolap",
      "yaz-10-indirim",
      "Üst Dolap"
    ],
    "variants": [
      {
        "id": 52843092738345,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.UD020.SAG.M.M.0305",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "2288.00",
        "grams": 0,
        "compare_at_price": "2860.00",
        "position": 1,
        "product_id": 8969225961769,
        "created_at": "2026-03-17T12:00:05+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>D10'la Karıştır, Banyona Yakıştır!</strong></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-9867606130985",
    "brand": "Creavit",
    "title": "D10 Eksen Lavabo Dolabı Çekmeceli 65 cm Antrasit Melamin",
    "category": "468907032873",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-65-cm-antrasit-melamin-5244.jpg?v=1762163713",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-65-cm-antrasit-melamin-5244.jpg?v=1762163713",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-65-cm-antrasit-melamin-5245.jpg?v=1762163715",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-65-cm-antrasit-melamin-5246.jpg?v=1762163717",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-65-cm-antrasit-melamin-5247.jpg?v=1762163718",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-65-cm-antrasit-melamin-5248.jpg?v=1762163721"
    ],
    "price": "6336.00",
    "sku": "D10.LD065.1C.M.M.0305",
    "tags": [],
    "variants": [
      {
        "id": 52843091329321,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.1C.M.M.0305",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "6336.00",
        "grams": 0,
        "compare_at_price": "7920.00",
        "position": 1,
        "product_id": 9867606130985,
        "created_at": "2026-03-17T11:59:37+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<meta charset=\"utf-8\">\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><span>D10’la Karıştır, Banyona Yakıştır!</span></p>\r\n\r\n<p><strong>İçinde Sen Varsın</strong></p>\r\n\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><span>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</span></p>\r\n\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><strong>Saklama Alanını Belirle </strong></p>\r\n\r\n<p><span>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek saklama alanını genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</span></p>\r\n\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><strong>Renkleri Deneyimle </strong></p>\r\n\r\n<p><span>D10’un renklerini kendi zevklerine göre kombinleyerek banyonda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için </span><span>banyo bu tarafta.</span></p>\r\n\r\n<div class=\"page\" title=\"Page 178\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><strong>Senin Lavab’ON </strong></p>\r\n\r\n<p><span>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş banyo deneyimi bu tarafta. </span></p>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>"
  },
  {
    "id": "creavit-9867595383081",
    "brand": "Creavit",
    "title": "D10 40 cm Sol Boy Dolabı Dafne Melamin Gövde Lake Kapak",
    "category": "462591328553",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-dafne-melamin-govde-lake-kapak-5497.jpg?v=1762160894",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-dafne-melamin-govde-lake-kapak-5497.jpg?v=1762160894",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-dafne-melamin-govde-lake-kapak-5498.jpg?v=1762160896",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-dafne-melamin-govde-lake-kapak-5499.jpg?v=1762160898",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-dafne-melamin-govde-lake-kapak-5500.jpg?v=1762160900",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-dafne-melamin-govde-lake-kapak-5501.jpg?v=1762160903"
    ],
    "price": "8536.00",
    "sku": "D10.BD040.SOL.M.L.0202",
    "tags": [],
    "variants": [
      {
        "id": 52921485361449,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.BD040.SOL.M.L.0202",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8536.00",
        "grams": 0,
        "compare_at_price": "10670.00",
        "position": 1,
        "product_id": 9867595383081,
        "created_at": "2026-04-03T14:44:43+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\r\n<p><strong>İçinde Sen Varsın</strong></p>\r\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\r\n<p><strong>Saklama Alanını Belirle</strong></p>\r\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\r\n<p><strong>Renkleri Deneyimle</strong></p>\r\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p><!---->"
  },
  {
    "id": "creavit-9867594334505",
    "brand": "Creavit",
    "title": "D10 40 cm Sağ Boy Dolabı Gri Melamin Gövde Lake Kapak",
    "category": "462591328553",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-gri-melamin-govde-lake-kapak-5512.jpg?v=1762160672",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-gri-melamin-govde-lake-kapak-5512.jpg?v=1762160672",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-gri-melamin-govde-lake-kapak-5513_80a0689c-94b4-43b4-b7bf-1395ffc9a23f.jpg?v=1762160674",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-gri-melamin-govde-lake-kapak-5514.jpg?v=1762160676",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-gri-melamin-govde-lake-kapak-5515.jpg?v=1762160678",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-gri-melamin-govde-lake-kapak-5516.jpg?v=1762160681",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-gri-melamin-govde-lake-kapak-5517.jpg?v=1762160683"
    ],
    "price": "8536.00",
    "sku": "D10.BD040.SAG.M.L.0303",
    "tags": [],
    "variants": [
      {
        "id": 52843088118057,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.BD040.SAG.M.L.0303",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8536.00",
        "grams": 0,
        "compare_at_price": "10670.00",
        "position": 1,
        "product_id": 9867594334505,
        "created_at": "2026-03-17T11:58:32+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>D10'la Karıştır, Banyona Yakıştır!</strong></p>\r\n<p><strong>İçinde Sen Varsın</strong></p>\r\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\r\n<p><strong>Saklama Alanını Belirle</strong></p>\r\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\r\n<p><strong>Renkleri Deneyimle</strong></p>\r\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-9867594105129",
    "brand": "Creavit",
    "title": "D10 40 cm Sağ Boy Dolabı Dafne Melamin Gövde Lake Kapak",
    "category": "462591328553",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-dafne-melamin-govde-lake-kapak-5491.jpg?v=1762160628",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-dafne-melamin-govde-lake-kapak-5491.jpg?v=1762160628",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-dafne-melamin-govde-lake-kapak-5492.jpg?v=1762160631",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-dafne-melamin-govde-lake-kapak-5493.jpg?v=1762160633",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-dafne-melamin-govde-lake-kapak-5494.jpg?v=1762160635",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-dafne-melamin-govde-lake-kapak-5495.jpg?v=1762160637",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-dafne-melamin-govde-lake-kapak-5496.jpg?v=1762160640"
    ],
    "price": "8536.00",
    "sku": "D10.BD040.SAG.M.L.0202",
    "tags": [],
    "variants": [
      {
        "id": 52921485197609,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.BD040.SAG.M.L.0202",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8536.00",
        "grams": 0,
        "compare_at_price": "10670.00",
        "position": 1,
        "product_id": 9867594105129,
        "created_at": "2026-04-03T14:44:40+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>D10'la Karıştır, Banyona Yakıştır!</strong></p>\r\n<p><strong>İçinde Sen Varsın</strong></p>\r\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\r\n<p><strong>Saklama Alanını Belirle</strong></p>\r\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\r\n<p><strong>Renkleri Deneyimle</strong></p>\r\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-9867593908521",
    "brand": "Creavit",
    "title": "D10 40 cm Sağ Boy Dolabı Beyaz Melamin Gövde Lake Kapak",
    "category": "462591328553",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-beyaz-melamin-govde-lake-kapak-5470.jpg?v=1762160597",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-beyaz-melamin-govde-lake-kapak-5470.jpg?v=1762160597",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-beyaz-melamin-govde-lake-kapak-5471_38158290-fcd2-437e-93b6-2c69d914750b.jpg?v=1762160600",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-beyaz-melamin-govde-lake-kapak-5472_b935422c-2592-4ba3-8889-53485268c205.jpg?v=1762160602",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-beyaz-melamin-govde-lake-kapak-5473.jpg?v=1762160605",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-beyaz-melamin-govde-lake-kapak-5474.jpg?v=1762160607",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-beyaz-melamin-govde-lake-kapak-5475.jpg?v=1762160608"
    ],
    "price": "8536.00",
    "sku": "D10.BD040.SAG.M.L.0101",
    "tags": [],
    "variants": [
      {
        "id": 52920975032617,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.BD040.SAG.M.L.0101",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8536.00",
        "grams": 0,
        "compare_at_price": "10670.00",
        "position": 1,
        "product_id": 9867593908521,
        "created_at": "2026-04-03T12:17:03+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>D10'la Karıştır, Banyona Yakıştır!</strong></p>\r\n<p><strong>İçinde Sen Varsın</strong></p>\r\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\r\n<p><strong>Saklama Alanını Belirle</strong></p>\r\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\r\n<p><strong>Renkleri Deneyimle</strong></p>\r\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8967726432553",
    "brand": "Creavit",
    "title": "D10 30 cm SOL Boy Dolabı Melamin Gri Gövde Lake Gri Kapak",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-boy-dolabi-gri-melamin-govde-lake-kapak-5457.jpg?v=1757662715",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-boy-dolabi-gri-melamin-govde-lake-kapak-5457.jpg?v=1757662715",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-boy-dolabi-30cm-gri-lake-banyo-mobilyasi.png?v=1757662715",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-boy-dolabi-gri-melamin-govde-lake-kapak-5458.jpg?v=1749209164",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-boy-dolabi-gri-melamin-govde-lake-kapak-5460.jpg?v=1749209164",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-boy-dolabi-gri-melamin-govde-lake-kapak-5461.jpg?v=1749209164"
    ],
    "price": "8008.00",
    "sku": "D10.BD030.SOL.M.L.0303",
    "tags": [
      "Banyo Mobilyası",
      "boy dolabı",
      "D10",
      "Gri",
      "Lake",
      "Melamin",
      "Sol Boy Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843091460393,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.BD030.SOL.M.L.0303",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8008.00",
        "grams": 0,
        "compare_at_price": "10010.00",
        "position": 1,
        "product_id": 8967726432553,
        "created_at": "2026-03-17T11:59:40+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-9867590795561",
    "brand": "Creavit",
    "title": "D10 30cm.SAĞ.Boy.Dlp.ML.GRI.ML.ANT",
    "category": "456291287337",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30cm-sag-boy-dlp-ml-gri-ml-ant-7807.jpg?v=1762160046",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30cm-sag-boy-dlp-ml-gri-ml-ant-7807.jpg?v=1762160046",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30cm-sag-boy-dlp-ml-gri-ml-ant-7808.jpg?v=1762160048",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30cm-sag-boy-dlp-ml-gri-ml-ant-7809.jpg?v=1762160051",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30cm-sag-boy-dlp-ml-gri-ml-ant-7810.jpg?v=1762160053"
    ],
    "price": "5896.00",
    "sku": "D10.BD030.SAG.M.M.0305",
    "tags": [],
    "variants": [
      {
        "id": 52843087528233,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.BD030.SAG.M.M.0305",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5896.00",
        "grams": 0,
        "compare_at_price": "7370.00",
        "position": 1,
        "product_id": 9867590795561,
        "created_at": "2026-03-17T11:58:19+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<p><strong>İçinde Sen Varsın</strong></p>\r\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\r\n<p><strong>Saklama Alanını Belirle</strong></p>\r\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\r\n<p><strong>Renkleri Deneyimle</strong></p>\r\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8969462874409",
    "brand": "Creavit",
    "title": "D10 80 cm Yuvarlak Ayna",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-yuvarlak-ayna-d10-80-cm-banyo-mobilyasi.png?v=1749043105",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-yuvarlak-ayna-d10-80-cm-banyo-mobilyasi.png?v=1749043105",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80-cm-yuvarlak-ayna-5657.jpg?v=1749043105",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80-cm-yuvarlak-ayna-5656.jpg?v=1749043105",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80-cm-yuvarlak-ayna-5658.jpg?v=1749043104",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80-cm-yuvarlak-ayna-5659.jpg?v=1749043104"
    ],
    "price": "2992.00",
    "sku": "D10.YA080",
    "tags": [
      "Ayna",
      "Banyo Mobilyası",
      "D10",
      "yaz-10-indirim",
      "Yuvarlak",
      "Yuvarlak Ayna"
    ],
    "variants": [
      {
        "id": 52843088380201,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.YA080",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2992.00",
        "grams": 0,
        "compare_at_price": "3740.00",
        "position": 1,
        "product_id": 8969462874409,
        "created_at": "2026-03-17T11:58:38+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8969458745641",
    "brand": "Creavit",
    "title": "D10 65 cm Yuvarlak Ayna",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-yuvarlak-ayna-d10-65-cm-banyo-mobilyasi.png?v=1749043166",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-yuvarlak-ayna-d10-65-cm-banyo-mobilyasi.png?v=1749043166",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65-cm-yuvarlak-ayna-5653.jpg?v=1749043166",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65-cm-yuvarlak-ayna-5652.jpg?v=1749043166",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65-cm-yuvarlak-ayna-5654.jpg?v=1749043162",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65-cm-yuvarlak-ayna-5655.jpg?v=1749043162"
    ],
    "price": "2112.00",
    "sku": "D10.YA065",
    "tags": [
      "Ayna",
      "Banyo Mobilyası",
      "D10",
      "yaz-10-indirim",
      "Yuvarlak",
      "Yuvarlak Ayna"
    ],
    "variants": [
      {
        "id": 52843072192809,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.YA065",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "2112.00",
        "grams": 0,
        "compare_at_price": "2640.00",
        "position": 1,
        "product_id": 8969458745641,
        "created_at": "2026-03-17T11:52:29+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8974672920873",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı İki Çekmeceli 100 cm Gri Gövde Lake Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-100cm-gri-lavabo-dolabi-cift-cekmeceli-lake-banyo-mobilyasi.png?v=1748255710",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-100cm-gri-lavabo-dolabi-cift-cekmeceli-lake-banyo-mobilyasi.png?v=1748255710",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-gri-govde-lake-kapak-5924.jpg?v=1748255710",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-gri-govde-lake-kapak-5927.jpg?v=1748255710",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-gri-govde-lake-kapak-5925.jpg?v=1748255710",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-gri-govde-lake-kapak-5926.jpg?v=1748255710",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-gri-govde-lake-kapak-5923.jpg?v=1748255710",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-gri-govde-lake-kapak-5928.jpg?v=1748255650",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-gri-govde-lake-kapak-5929.jpg?v=1748255650"
    ],
    "price": "12584.00",
    "sku": "D10.LD100.2C.M.L.T.03033",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "Gri",
      "iki çekmeceli lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52921486377257,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.2C.M.L.T.03033",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "12584.00",
        "grams": 0,
        "compare_at_price": "15730.00",
        "position": 1,
        "product_id": 8974672920873,
        "created_at": "2026-04-03T14:44:56+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-8969214165289",
    "brand": "Creavit",
    "title": "D10 30 cm Sol Üst Dolap Gri Melamin Gövde Antrasit Kapak",
    "category": "Üst Dolaplar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-antrasit-melamin-kapak-ust-dolap-banyo-mobilyasi-1.png?v=1749122684",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-antrasit-melamin-kapak-ust-dolap-banyo-mobilyasi-1.png?v=1749122684",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-gri-melamin-govde-antrasit-kapak-5637.jpg?v=1749122684",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-gri-melamin-govde-antrasit-kapak-5638.jpg?v=1749122684",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-gri-melamin-govde-antrasit-kapak-5639.jpg?v=1749122684",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-gri-melamin-govde-antrasit-kapak-5640.jpg?v=1749122684"
    ],
    "price": "2552.00",
    "sku": "D10.UD030.SOL.M.M.0305",
    "tags": [
      "Antrasit",
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "Melamin",
      "Sol Üst Dolap",
      "yaz-10-indirim",
      "Üst Dolap"
    ],
    "variants": [
      {
        "id": 52843089035561,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.UD030.SOL.M.M.0305",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2552.00",
        "grams": 0,
        "compare_at_price": "3190.00",
        "position": 1,
        "product_id": 8969214165289,
        "created_at": "2026-03-17T11:58:53+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>D10'la Karıştır, Banyona Yakıştır!</strong></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8969205547305",
    "brand": "Creavit",
    "title": "D10 30 cm Sol Üst Dolap Gri Melamin Gövde Lake Kapak",
    "category": "Üst Dolaplar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-gri-melamin-govde-lake-kapak.png?v=1749123002",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-gri-melamin-govde-lake-kapak.png?v=1749123002",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-gri-melamin-govde-lake-kapak-5623.jpg?v=1749123002",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-gri-melamin-govde-lake-kapak-5622.jpg?v=1749123002",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-gri-melamin-govde-lake-kapak-5624.jpg?v=1749123000",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-gri-melamin-govde-lake-kapak-5625.jpg?v=1749123000",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-gri-melamin-govde-lake-kapak-5626.jpg?v=1749123000"
    ],
    "price": "3344.00",
    "sku": "D10.UD030.SOL.M.L.0303",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "Gri",
      "Lake",
      "Melamin",
      "Sol Üst Dolap",
      "yaz-10-indirim",
      "Üst Dolap"
    ],
    "variants": [
      {
        "id": 52843078222121,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.UD030.SOL.M.L.0303",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3344.00",
        "grams": 0,
        "compare_at_price": "4180.00",
        "position": 1,
        "product_id": 8969205547305,
        "created_at": "2026-03-17T11:54:43+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>D10'la Karıştır, Banyona Yakıştır!</strong></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8969184149801",
    "brand": "Creavit",
    "title": "D10 30 cm Sol Üst Dolap Beyaz Melamin Gövde Lake Kapak",
    "category": "Üst Dolaplar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-beyaz-melamin-govde-lake-kapak.png?v=1749128224",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-beyaz-melamin-govde-lake-kapak.png?v=1749128224",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-beyaz-melamin-govde-lake-kapak-5591.jpg?v=1749128224",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-beyaz-melamin-govde-lake-kapak-5590.jpg?v=1749128224",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-beyaz-melamin-govde-lake-kapak-5592.jpg?v=1749128217",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-beyaz-melamin-govde-lake-kapak-5593.jpg?v=1749128217",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-beyaz-melamin-govde-lake-kapak-5594.jpg?v=1749128217"
    ],
    "price": "3344.00",
    "sku": "D10.UD030.SOL.M.L.0101",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "Lake",
      "Melamin",
      "Sol Üst Dolap",
      "yaz-10-indirim",
      "Üst Dolap"
    ],
    "variants": [
      {
        "id": 52869542838569,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.UD030.SOL.M.L.0101",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "3344.00",
        "grams": 0,
        "compare_at_price": "4180.00",
        "position": 1,
        "product_id": 8969184149801,
        "created_at": "2026-03-24T00:27:14+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8969186935081",
    "brand": "Creavit",
    "title": "D10 30 cm Sağ Üst Dolap Beyaz Melamin Gövde Melamin Kapak",
    "category": "Üst Dolaplar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-beyaz-melamin-govde-melamin-kapak_271e1e41-6d7a-40f7-bea6-5297497127dd.png?v=1749127854",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-beyaz-melamin-govde-melamin-kapak_271e1e41-6d7a-40f7-bea6-5297497127dd.png?v=1749127854",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sag-ust-dolap-beyaz-melamin-govde-melamin-kapak-5595.jpg?v=1749127854",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sag-ust-dolap-beyaz-melamin-govde-melamin-kapak-5596.jpg?v=1749127854",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sag-ust-dolap-beyaz-melamin-govde-melamin-kapak-5597.jpg?v=1749127854",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sag-ust-dolap-beyaz-melamin-govde-melamin-kapak-5598.jpg?v=1749127854"
    ],
    "price": "2552.00",
    "sku": "D10.UD030.SAG.M.M.0101",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "Melamin",
      "Sağ Üst Dolap",
      "yaz-10-indirim",
      "Üst Dolap"
    ],
    "variants": [
      {
        "id": 52843090084137,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.UD030.SAG.M.M.0101",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2552.00",
        "grams": 0,
        "compare_at_price": "3190.00",
        "position": 1,
        "product_id": 8969186935081,
        "created_at": "2026-03-17T11:59:12+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>D10'la Karıştır, Banyona Yakıştır!</strong></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8969207873833",
    "brand": "Creavit",
    "title": "D10 30 cm Sağ Üst Dolap Gri Melamin Gövde Lake Kapak",
    "category": "Üst Dolaplar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sag-ust-dolap-gri-melamin-govde-lake-kapak-5627.jpg?v=1747226545",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sag-ust-dolap-gri-melamin-govde-lake-kapak-5627.jpg?v=1747226545",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sag-ust-dolap-gri-melamin-govde-lake-kapak-5628.jpg?v=1747226549",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sag-ust-dolap-gri-melamin-govde-lake-kapak-5629.jpg?v=1747226551",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sag-ust-dolap-gri-melamin-govde-lake-kapak-5630.jpg?v=1747226554",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sag-ust-dolap-gri-melamin-govde-lake-kapak-5631.jpg?v=1747226556"
    ],
    "price": "3344.00",
    "sku": "D10.UD030.SAG.M.L.0303",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "Gri",
      "Lake",
      "Melamin",
      "Sağ Üst Dolap",
      "yaz-10-indirim",
      "Üst Dolap"
    ],
    "variants": [
      {
        "id": 52843071897897,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.UD030.SAG.M.L.0303",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "3344.00",
        "grams": 0,
        "compare_at_price": "4180.00",
        "position": 1,
        "product_id": 8969207873833,
        "created_at": "2026-03-17T11:52:23+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>D10'la Karıştır, Banyona Yakıştır!</strong></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8969192177961",
    "brand": "Creavit",
    "title": "D10 30 cm Sağ Üst Dolap Dafne Melamin Gövde Lake Kapak",
    "category": "Üst Dolaplar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-dafne-melamin-govde-lake-kapak_c2ecf091-0db0-4313-bc31-640fed216c00.png?v=1749123401",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-dafne-melamin-govde-lake-kapak_c2ecf091-0db0-4313-bc31-640fed216c00.png?v=1749123401",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sag-ust-dolap-dafne-melamin-govde-lake-kapak-5604.jpg?v=1749123401",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sag-ust-dolap-dafne-melamin-govde-lake-kapak-5605.jpg?v=1749123401",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sag-ust-dolap-dafne-melamin-govde-lake-kapak-5606.jpg?v=1749123401",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sag-ust-dolap-dafne-melamin-govde-lake-kapak-5607.jpg?v=1749123401",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sag-ust-dolap-dafne-melamin-govde-lake-kapak-5608.jpg?v=1749123401"
    ],
    "price": "3344.00",
    "sku": "D10.UD030.SAG.M.L.0202",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "Dafne",
      "Lake",
      "Melamin",
      "Sağ Üst Dolap",
      "yaz-10-indirim",
      "Üst Dolap"
    ],
    "variants": [
      {
        "id": 52920975491369,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.UD030.SAG.M.L.0202",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3344.00",
        "grams": 0,
        "compare_at_price": "4180.00",
        "position": 1,
        "product_id": 8969192177961,
        "created_at": "2026-04-03T12:17:10+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>D10'la Karıştır, Banyona Yakıştır!</strong></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8969230778665",
    "brand": "Creavit",
    "title": "D10 20 cm Sol Üst Dolap Gri Melamin Gövde Antrasit Kapak",
    "category": "Üst Dolaplar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-gri-melamin-govde-antrasit-kapak-5647.jpg?v=1747233900",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-gri-melamin-govde-antrasit-kapak-5647.jpg?v=1747233900",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-gri-melamin-govde-antrasit-kapak-5648.jpg?v=1747233904",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-gri-melamin-govde-antrasit-kapak-5649.jpg?v=1747233907",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-gri-melamin-govde-antrasit-kapak-5650.jpg?v=1747233909",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-gri-melamin-govde-antrasit-kapak-5651.jpg?v=1747233915"
    ],
    "price": "2288.00",
    "sku": "D10.UD020.SOL.M.M.0305",
    "tags": [
      "Antrasit",
      "Banyo Mobilyası",
      "D10",
      "Gri",
      "Melamin",
      "Sol Üst Dolap",
      "yaz-10-indirim",
      "Üst Dolap"
    ],
    "variants": [
      {
        "id": 52843072061737,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.UD020.SOL.M.M.0305",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "2288.00",
        "grams": 0,
        "compare_at_price": "2860.00",
        "position": 1,
        "product_id": 8969230778665,
        "created_at": "2026-03-17T11:52:26+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>D10'la Karıştır, Banyona Yakıştır!</strong></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8968518992169",
    "brand": "Creavit",
    "title": "D10 20 cm Sağ Üst Dolap Beyaz Melamin Gövde Melamin Kapak",
    "category": "Üst Dolaplar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-beyaz-melamin-govde-kapak_fbb54135-92f1-4214-8b87-acd1c8f82c81.png?v=1749137263",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-beyaz-melamin-govde-kapak_fbb54135-92f1-4214-8b87-acd1c8f82c81.png?v=1749137263",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-beyaz-melamin-govde-melamin-kapak-5532.jpg?v=1749137263",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-beyaz-melamin-govde-melamin-kapak-5533.jpg?v=1749137263",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-beyaz-melamin-govde-melamin-kapak-5535.jpg?v=1749137263",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-beyaz-melamin-govde-melamin-kapak-5536.jpg?v=1749137263"
    ],
    "price": "2288.00",
    "sku": "D10.UD020.SAG.M.M.0101",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "Melamin",
      "Sağ Üst Dolap",
      "yaz-10-indirim",
      "Üst Dolap"
    ],
    "variants": [
      {
        "id": 52843083923753,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.UD020.SAG.M.M.0101",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2288.00",
        "grams": 0,
        "compare_at_price": "2860.00",
        "position": 1,
        "product_id": 8968518992169,
        "created_at": "2026-03-17T11:56:52+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>D10'la Karıştır, Banyona Yakıştır!</strong></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8968545730857",
    "brand": "Creavit",
    "title": "D10 20 cm Sol Üst Dolap Dafne Melamin Gövde Lake Kapak",
    "category": "Üst Dolaplar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-dafne-melamin-govde-lake-kapak.png?v=1749136853",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-dafne-melamin-govde-lake-kapak.png?v=1749136853",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-dafne-melamin-govde-lake-kapak-5560.jpg?v=1749136853",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-dafne-melamin-govde-lake-kapak-5559.jpg?v=1749136853",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-dafne-melamin-govde-lake-kapak-5561.jpg?v=1749136848",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-dafne-melamin-govde-lake-kapak-5562.jpg?v=1749136848",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-dafne-melamin-govde-lake-kapak-5563.jpg?v=1749136848"
    ],
    "price": "2992.00",
    "sku": "D10.UD020.SOL.M.L.0202",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "Dafne",
      "Lake",
      "Melamin",
      "Sol Üst Dolap",
      "yaz-10-indirim",
      "Üst Dolap"
    ],
    "variants": [
      {
        "id": 52843089953065,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.UD020.SOL.M.L.0202",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2992.00",
        "grams": 0,
        "compare_at_price": "3740.00",
        "position": 1,
        "product_id": 8968545730857,
        "created_at": "2026-03-17T11:59:09+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>D10'la Karıştır, Banyona Yakıştır!</strong></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8970559914281",
    "brand": "Creavit",
    "title": "D10 50 cm Melamin Raflı Ayna Beyaz",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/24.png?v=1748264355",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/24.png?v=1748264355",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-50-cm-melamin-rafli-ayna-beyaz-5715.jpg?v=1748264355",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-50-cm-melamin-rafli-ayna-beyaz-5717.jpg?v=1748264355"
    ],
    "price": "2200.00",
    "sku": "D10.RA050.ML.BYZ",
    "tags": [
      "Ayna",
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "Raflı Ayna",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843093885225,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.RA050.ML.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2200.00",
        "grams": 0,
        "compare_at_price": "2750.00",
        "position": 1,
        "product_id": 8970559914281,
        "created_at": "2026-03-17T12:00:31+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8970526294313",
    "brand": "Creavit",
    "title": "D10 100 cm Düz Ayna",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100-cm-duz-ayna-5688.jpg?v=1747226880",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100-cm-duz-ayna-5688.jpg?v=1747226880",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100-cm-duz-ayna-5689.jpg?v=1747226882",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100-cm-duz-ayna-5690.jpg?v=1747226885"
    ],
    "price": "3520.00",
    "sku": "D10.DA100",
    "tags": [
      "Ayna",
      "Banyo Mobilyası",
      "D10",
      "Düz Ayna",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52920976081193,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.DA100",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3520.00",
        "grams": 0,
        "compare_at_price": "4400.00",
        "position": 1,
        "product_id": 8970526294313,
        "created_at": "2026-04-03T12:17:19+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>D10'la Karıştır, Banyona Yakıştır!</strong></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-9867569561897",
    "brand": "Creavit",
    "title": "D10 100 cm Melamin Aynalı Dolap Gri",
    "category": "456291287337",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100-cm-melamin-aynali-dolap-gri-7722.jpg?v=1762155147",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100-cm-melamin-aynali-dolap-gri-7722.jpg?v=1762155147",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100-cm-melamin-aynali-dolap-gri-7723.jpg?v=1762155150",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100-cm-melamin-aynali-dolap-gri-7724.jpg?v=1762155152"
    ],
    "price": "5896.00",
    "sku": "D10.AD100.ML.GRI",
    "tags": [],
    "variants": [
      {
        "id": 52920978768169,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.AD100.ML.GRI",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5896.00",
        "grams": 0,
        "compare_at_price": "7370.00",
        "position": 1,
        "product_id": 9867569561897,
        "created_at": "2026-04-03T12:18:17+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<p><strong>İçinde Sen Varsın</strong></p>\r\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\r\n<p><strong>Saklama Alanını Belirle</strong></p>\r\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\r\n<p><strong>Renkleri Deneyimle</strong></p>\r\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p><!---->"
  },
  {
    "id": "creavit-9867567071529",
    "brand": "Creavit",
    "title": "D10 100 cm Melamin Aynalı Dolap Beyaz",
    "category": "456291287337",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100-cm-melamin-aynali-dolap-beyaz-7713.jpg?v=1762154875",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100-cm-melamin-aynali-dolap-beyaz-7713.jpg?v=1762154875",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100-cm-melamin-aynali-dolap-beyaz-7714.jpg?v=1762154877",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100-cm-melamin-aynali-dolap-beyaz-7715.jpg?v=1762154879"
    ],
    "price": "5896.00",
    "sku": "D10.AD100.ML.BYZ",
    "tags": [],
    "variants": [
      {
        "id": 52920978637097,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.AD100.ML.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5896.00",
        "grams": 0,
        "compare_at_price": "7370.00",
        "position": 1,
        "product_id": 9867567071529,
        "created_at": "2026-04-03T12:18:14+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<p><strong>İçinde Sen Varsın</strong></p>\r\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\r\n<p><strong>Saklama Alanını Belirle</strong></p>\r\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\r\n<p><strong>Renkleri Deneyimle</strong></p>\r\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p><!---->"
  },
  {
    "id": "creavit-9867563008297",
    "brand": "Creavit",
    "title": "D10 60cm.ML.Aynalı Dolap Dafne",
    "category": "456291287337",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-60cm-ml-aynali-dolap-dafne-7683.jpg?v=1762154136",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-60cm-ml-aynali-dolap-dafne-7683.jpg?v=1762154136",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-60cm-ml-aynali-dolap-dafne-7684.jpg?v=1762154139",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-60cm-ml-aynali-dolap-dafne-7685.jpg?v=1762154141"
    ],
    "price": "4048.00",
    "sku": "D10.AD060.ML.DAF",
    "tags": [],
    "variants": [
      {
        "id": 52921959711017,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.AD060.ML.DAF",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "4048.00",
        "grams": 0,
        "compare_at_price": "5060.00",
        "position": 1,
        "product_id": 9867563008297,
        "created_at": "2026-04-03T16:28:55+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<p><strong>İçinde Sen Varsın</strong></p>\r\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\r\n<p><strong>Saklama Alanını Belirle</strong></p>\r\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\r\n<p><strong>Renkleri Deneyimle</strong></p>\r\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p><!---->"
  },
  {
    "id": "creavit-9867562189097",
    "brand": "Creavit",
    "title": "D10 60cm.ML.Aynalı Dolap Beyaz",
    "category": "456291287337",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-60cm-ml-aynali-dolap-beyaz-7680.jpg?v=1762154011",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-60cm-ml-aynali-dolap-beyaz-7680.jpg?v=1762154011",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-60cm-ml-aynali-dolap-beyaz-7681.jpg?v=1762154014",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-60cm-ml-aynali-dolap-beyaz-7682.jpg?v=1762154016"
    ],
    "price": "4048.00",
    "sku": "D10.AD060.ML.BYZ",
    "tags": [],
    "variants": [
      {
        "id": 52843085136169,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.AD060.ML.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "4048.00",
        "grams": 0,
        "compare_at_price": "5060.00",
        "position": 1,
        "product_id": 9867562189097,
        "created_at": "2026-03-17T11:57:24+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<p><strong>İçinde Sen Varsın</strong></p>\r\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\r\n<p><strong>Saklama Alanını Belirle</strong></p>\r\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\r\n<p><strong>Renkleri Deneyimle</strong></p>\r\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p><!---->"
  },
  {
    "id": "creavit-9860864901417",
    "brand": "Creavit",
    "title": "D10 100cm Eksen Lavabo Dolabı Melamin Gri Gövde Lake Gri Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-kpk-lav-dlp-ml-gri-lk-gri-7679.jpg?v=1761912258",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-kpk-lav-dlp-ml-gri-lk-gri-7679.jpg?v=1761912258",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-kpk-lav-dlp-ml-gri-lk-gri-7677.jpg?v=1761912258"
    ],
    "price": "9064.00",
    "sku": "D10.LD100.K.M.L.0303",
    "tags": [],
    "variants": [
      {
        "id": 52927683297577,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.K.M.L.0303",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9064.00",
        "grams": 0,
        "compare_at_price": "11330.00",
        "position": 1,
        "product_id": 9860864901417,
        "created_at": "2026-04-04T17:18:09+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html --><!-- x-tinymce/html --> \r\n<p><strong>İçinde Sen Varsın</strong></p>\r\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\r\n<p><strong>Saklama Alanını Belirle</strong></p>\r\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\r\n<p><strong>Renkleri Deneyimle</strong></p>\r\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\r\n<p><strong>Senin Lavab'ON</strong></p>\r\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p><!---->"
  },
  {
    "id": "creavit-9860857495849",
    "brand": "Creavit",
    "title": "D10 65cm Eksen Lavabo Dolabı Kapaklı Melamin Dafne Gövde Melamin Antrasit Meşe Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-kpk-lav-dlp-ml-daf-ml-mse-7676.jpg?v=1761911712",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-kpk-lav-dlp-ml-daf-ml-mse-7676.jpg?v=1761911712",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-kpk-lav-dlp-ml-daf-ml-mse-7674.jpg?v=1761911712",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-kpk-lav-dlp-ml-daf-ml-mse-7675.jpg?v=1761911712"
    ],
    "price": "5720.00",
    "sku": "D10.LD065.K.M.M.0204",
    "tags": [],
    "variants": [
      {
        "id": 52907559780649,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.K.M.M.0204",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5720.00",
        "grams": 0,
        "compare_at_price": "7150.00",
        "position": 1,
        "product_id": 9860857495849,
        "created_at": "2026-03-31T17:09:35+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<p><strong>İçinde Sen Varsın</strong></p>\r\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\r\n<p><strong>Saklama Alanını Belirle</strong></p>\r\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\r\n<p><strong>Renkleri Deneyimle</strong></p>\r\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\r\n<p><strong>Senin Lavab'ON</strong></p>\r\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p><!---->"
  },
  {
    "id": "creavit-9860852515113",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı Kapaklı 65 cm Dafne Gövde Lake Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-dafne-govde-lake-kapak-6123.jpg?v=1761911387",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-dafne-govde-lake-kapak-6123.jpg?v=1761911387",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-dafne-govde-lake-kapak-6124.jpg?v=1761911389",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-dafne-govde-lake-kapak-6125.jpg?v=1761911391",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-dafne-govde-lake-kapak-6126.jpg?v=1761911393",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-dafne-govde-lake-kapak-6127.jpg?v=1761911395",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-dafne-govde-lake-kapak-6128.jpg?v=1761911397"
    ],
    "price": "7480.00",
    "sku": "D10.LD065.K.M.L.T.02022",
    "tags": [],
    "variants": [
      {
        "id": 52891828748585,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.K.M.L.T.02022",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7480.00",
        "grams": 0,
        "compare_at_price": "9350.00",
        "position": 1,
        "product_id": 9860852515113,
        "created_at": "2026-03-28T17:34:24+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\r\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\r\n<p><strong>Saklama Alanını Belirle</strong></p>\r\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\r\n<p><strong>Renkleri Deneyimle</strong></p>\r\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\r\n<p><strong>Senin Lavab'ON</strong></p>\r\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p><!---->"
  },
  {
    "id": "creavit-9860840456489",
    "brand": "Creavit",
    "title": "D10 65cm Eksen Lavabo Dolabı Kapaklı Melamin Beyaz Gövde Melamin Beyaz Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-kpk-lav-dlp-ml-byz-ml-byz-7673.jpg?v=1761911263",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-kpk-lav-dlp-ml-byz-ml-byz-7673.jpg?v=1761911263",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-kpk-lav-dlp-ml-byz-ml-byz-7671.jpg?v=1761911263",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-kpk-lav-dlp-ml-byz-ml-byz-7672.jpg?v=1761911263"
    ],
    "price": "5720.00",
    "sku": "D10.LD065.K.M.M.0101",
    "tags": [],
    "variants": [
      {
        "id": 52843085791529,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.K.M.M.0101",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "5720.00",
        "grams": 0,
        "compare_at_price": "7150.00",
        "position": 1,
        "product_id": 9860840456489,
        "created_at": "2026-03-17T11:57:40+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html --><!-- x-tinymce/html --> \r\n<p><strong>İçinde Sen Varsın</strong></p>\r\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\r\n<p><strong>Saklama Alanını Belirle</strong></p>\r\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\r\n<p><strong>Renkleri Deneyimle</strong></p>\r\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\r\n<p><strong>Senin Lavab'ON</strong></p>\r\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p><!---->"
  },
  {
    "id": "creavit-9860835836201",
    "brand": "Creavit",
    "title": "D10 100cm Eksen Lavabo Dolabı Melamin Gri Gövde Lake Gri Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-2ck-lav-dlp-ml-gri-lk-gri-7670.jpg?v=1761911485",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-2ck-lav-dlp-ml-gri-lk-gri-7670.jpg?v=1761911485",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-2ck-lav-dlp-ml-gri-lk-gri-7668.jpg?v=1761911485",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-2ck-lav-dlp-ml-gri-lk-gri-7669.jpg?v=1761911485"
    ],
    "price": "13112.00",
    "sku": "D10.LD100.2C.M.L.0303",
    "tags": [],
    "variants": [
      {
        "id": 52920979783977,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.2C.M.L.0303",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "13112.00",
        "grams": 0,
        "compare_at_price": "16390.00",
        "position": 1,
        "product_id": 9860835836201,
        "created_at": "2026-04-03T12:18:39+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html --><!-- x-tinymce/html --> \r\n<p><strong>İçinde Sen Varsın</strong></p>\r\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\r\n<p><strong>Saklama Alanını Belirle</strong></p>\r\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\r\n<p><strong>Renkleri Deneyimle</strong></p>\r\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\r\n<p><strong>Senin Lavab'ON</strong></p>\r\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p><!---->"
  },
  {
    "id": "creavit-9860826497321",
    "brand": "Creavit",
    "title": "D10 100cm Eksen Lavabo Dolabı Melamin Beyaz Gövde Lake Beyaz Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-2ck-lav-dlp-ml-byz-lk-byz-7666.jpg?v=1761910211",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-2ck-lav-dlp-ml-byz-lk-byz-7666.jpg?v=1761910211",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-2ck-lav-dlp-ml-byz-lk-byz-7665.jpg?v=1761910211",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100cm-2ck-lav-dlp-ml-byz-lk-byz-7667.jpg?v=1761910067"
    ],
    "price": "13112.00",
    "sku": "D10.LD100.2C.M.L.0101",
    "tags": [],
    "variants": [
      {
        "id": 52920979554601,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.2C.M.L.0101",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "13112.00",
        "grams": 0,
        "compare_at_price": "16390.00",
        "position": 1,
        "product_id": 9860826497321,
        "created_at": "2026-04-03T12:18:36+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<p><strong>İçinde Sen Varsın</strong></p>\r\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\r\n<p><strong>Saklama Alanını Belirle</strong></p>\r\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\r\n<p><strong>Renkleri Deneyimle</strong></p>\r\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\r\n<p><strong>Senin Lavab'ON</strong></p>\r\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p><!---->"
  },
  {
    "id": "creavit-9860805624105",
    "brand": "Creavit",
    "title": "D10 Eksen Lavabo Dolabı İki Çekmeceli Melamin Gri Gövde Lake Gri Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-2ck-lav-dlp-ml-gri-lk-gri-7663.jpg?v=1761909568",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-2ck-lav-dlp-ml-gri-lk-gri-7663.jpg?v=1761909568",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65cm-2ck-lav-dlp-ml-gri-lk-gri-7662.jpg?v=1761909568"
    ],
    "price": "10648.00",
    "sku": "D10.LD065.2C.M.L.0303",
    "tags": [],
    "variants": [
      {
        "id": 52920979161385,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.2C.M.L.0303",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "10648.00",
        "grams": 0,
        "compare_at_price": "13310.00",
        "position": 1,
        "product_id": 9860805624105,
        "created_at": "2026-04-03T12:18:26+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\r\n<p><strong>İçinde Sen Varsın</strong></p>\r\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\r\n<p><strong>Saklama Alanını Belirle</strong></p>\r\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\r\n<p><strong>Renkleri Deneyimle</strong></p>\r\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\r\n<p><strong>Senin Lavab'ON</strong></p>\r\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p><!---->"
  },
  {
    "id": "creavit-9850900644137",
    "brand": "Creavit",
    "title": "Liva Mutfak Armatürü",
    "category": "Mutfak Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/liva-mutfak-armaturu-7658.jpg?v=1761137831",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/liva-mutfak-armaturu-7658.jpg?v=1761137831",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/liva-mutfak-armaturu-7659.jpg?v=1761137833"
    ],
    "price": "2040.00",
    "sku": "BT.LV8500",
    "tags": [
      "Armatür",
      "Liva",
      "Mutfak Armatürü"
    ],
    "variants": [
      {
        "id": 52836649173289,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.LV8500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "2040.00",
        "grams": 0,
        "compare_at_price": "3400.00",
        "position": 1,
        "product_id": 9850900644137,
        "created_at": "2026-03-15T21:09:11+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Ürün %100 Pirinç Malzemedir. </p>\n<p>Çıkış Ucu Uzunluğu 204 Mm.</p>\n<p>Çıkış Ucu Yüksekliği 229 Mm.</p>\n<p>Uzun Ömürlü 35 Mm Seramik Oynar Mafsal.</p>\n<p>Montaj Yeri: Tezgah.</p>\n<p>Garanti Süresi: 5 Yıl</p>"
  },
  {
    "id": "creavit-9850900250921",
    "brand": "Creavit",
    "title": "Spiralli Mutfak Armatürü",
    "category": "Mutfak Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spiralli-mutfak-armaturu-7660.jpg?v=1761137770",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spiralli-mutfak-armaturu-7660.jpg?v=1761137770",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spiralli-mutfak-armaturu-7661.jpg?v=1761137773"
    ],
    "price": "4725.00",
    "sku": "BT.MF8320S",
    "tags": [
      "mutfak",
      "Mutfak Armatürü",
      "Spiralli Mutfak Armatürü"
    ],
    "variants": [
      {
        "id": 52920235393321,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.MF8320S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "4725.00",
        "grams": 0,
        "compare_at_price": "6300.00",
        "position": 1,
        "product_id": 9850900250921,
        "created_at": "2026-04-03T09:09:19+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Ürün %100 Pirinç Malzemedir.</p>\r\n<p>Çıkış Ucu Uzunluğu 184 Mm.</p>\r\n<p>Çıkış Ucu Yüksekliği 113 Mm.</p>\r\n<p>Fonksiyonel El Duşu ve Paslanmaz Spiral</p>\r\n<p>Döner Borulu</p>\r\n<p>Uzun Ömürlü 40 mm Seramik Kartuş.</p>\r\n<p>Montaj Yeri: Tezgah.</p>\r\n<p>Garanti Süresi: 5 Yıl</p>"
  },
  {
    "id": "creavit-9850899988777",
    "brand": "Creavit",
    "title": "Ufo Beyaz - Beyaz Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ufo-beyaz-beyaz-kumanda-paneli-7656.jpg?v=1761137717",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ufo-beyaz-beyaz-kumanda-paneli-7656.jpg?v=1761137717"
    ],
    "price": "675.00",
    "sku": "GP1001.00",
    "tags": [
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "Rezervuar",
      "Rezervuarlar"
    ],
    "variants": [
      {
        "id": 52843261395241,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP1001.00",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "675.00",
        "grams": 0,
        "compare_at_price": "900.00",
        "position": 1,
        "product_id": 9850899988777,
        "created_at": "2026-03-17T13:09:59+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Ürün Beyaz Renklidir.</p>\r\n<p>Ürün Ölçüleri: 245x163x14 Cm.</p>\r\n<p>Ürün Sadece Creavit Gömme Rezervuarlar ile Uyumludur.</p>"
  },
  {
    "id": "creavit-9850899824937",
    "brand": "Creavit",
    "title": "Ufo Mat Krom Kaplama Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ufo-mat-krom-kaplama-kumanda-paneli-7657.jpg?v=1761137665",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ufo-mat-krom-kaplama-kumanda-paneli-7657.jpg?v=1761137665"
    ],
    "price": "1215.00",
    "sku": "GP1003.00",
    "tags": [
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "Rezervuar",
      "Rezervuarlar"
    ],
    "variants": [
      {
        "id": 52856438948137,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP1003.00",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1215.00",
        "grams": 0,
        "compare_at_price": "1620.00",
        "position": 1,
        "product_id": 9850899824937,
        "created_at": "2026-03-20T18:38:32+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Ürün Mat Krom Renklidir. </p>\r\n<p>Ürün Ölçüleri: 245x163x14 Cm</p>\r\n<p>Ürün Sadece Creavit Gömme Rezervuarlar ile Uyumludur.</p>"
  },
  {
    "id": "creavit-8974698119465",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı Kapaklı 80 cm Gri Gövde Lake Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-80cm-gri-lavabo-dolabi-kapakli-lake-banyo-mobilyasi.png?v=1748255265",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-80cm-gri-lavabo-dolabi-kapakli-lake-banyo-mobilyasi.png?v=1748255265",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-80-cm-gri-govde-lake-kapak-5953.jpg?v=1748255265",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-80-cm-gri-govde-lake-kapak-5954.jpg?v=1748255265",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-80-cm-gri-govde-lake-kapak-5952.jpg?v=1748255265",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-80-cm-gri-govde-lake-kapak-5955.jpg?v=1748255261",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-80-cm-gri-govde-lake-kapak-5956.jpg?v=1748255261"
    ],
    "price": "7920.00",
    "sku": "D10.LD080.K.M.L.T.03033",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "Gri",
      "kapaklı lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843073896745,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD080.K.M.L.T.03033",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "7920.00",
        "grams": 0,
        "compare_at_price": "9900.00",
        "position": 1,
        "product_id": 8974698119465,
        "created_at": "2026-03-17T11:53:09+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-8975596060969",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı İki Çekmeceli 80 cm Gri Lake Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-80cm-gri-lavabo-dolabi-cift-cekmeceli-lake-banyo-mobilyasi.png?v=1748254405",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-80cm-gri-lavabo-dolabi-cift-cekmeceli-lake-banyo-mobilyasi.png?v=1748254405",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-80-cm-gri-lake-kapak-6006.jpg?v=1748254405",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-80-cm-gri-lake-kapak-6008.jpg?v=1748254405",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-80-cm-gri-lake-kapak-6009.jpg?v=1748254405",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-80-cm-gri-lake-kapak-6007.jpg?v=1748254405",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-80-cm-gri-lake-kapak-6005.jpg?v=1748254405",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-80-cm-gri-lake-kapak-6010.jpg?v=1748254392",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-80-cm-gri-lake-kapak-6012.jpg?v=1748254392"
    ],
    "price": "11176.00",
    "sku": "D10.LD080.2C.M.L.T.03033",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "Gri",
      "iki çekmeceli lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843093459241,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD080.2C.M.L.T.03033",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11176.00",
        "grams": 0,
        "compare_at_price": "13970.00",
        "position": 1,
        "product_id": 8975596060969,
        "created_at": "2026-03-17T12:00:21+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-8975583609129",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı İki Çekmeceli 80 cm Dafne Lake Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-80cm-dafne-lavabo-dolabi-cift-cekmeceli-lake-banyo-mobilyasi.png?v=1748254506",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-80cm-dafne-lavabo-dolabi-cift-cekmeceli-lake-banyo-mobilyasi.png?v=1748254506",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-80-cm-dafne-lake-kapak-5997.jpg?v=1748254506",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-80-cm-dafne-lake-kapak-5998.jpg?v=1748254506",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-80-cm-dafne-lake-kapak-5996.jpg?v=1748254506",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-80-cm-dafne-lake-kapak-6002.jpg?v=1748254503",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-80-cm-dafne-lake-kapak-6004.jpg?v=1748254503"
    ],
    "price": "11176.00",
    "sku": "D10.LD080.2C.M.L.T.02022",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "Dafne",
      "iki çekmeceli lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52921487065385,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD080.2C.M.L.T.02022",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "11176.00",
        "grams": 0,
        "compare_at_price": "13970.00",
        "position": 1,
        "product_id": 8975583609129,
        "created_at": "2026-04-03T14:45:05+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-8974696251689",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı Kapaklı 80 cm Beyaz Melamin Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-80cm-beyaz-lavabo-dolabi-kapakli-melamin-banyo-mobilyasi.png?v=1748255397",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-80cm-beyaz-lavabo-dolabi-kapakli-melamin-banyo-mobilyasi.png?v=1748255397",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-80-cm-beyaz-5943.jpg?v=1748255397",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-80-cm-beyaz-5942.jpg?v=1748255397",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-80-cm-beyaz-5941.jpg?v=1748255397",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-80-cm-beyaz-5944.jpg?v=1748255393",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-80-cm-beyaz-5945.jpg?v=1748255393"
    ],
    "price": "6072.00",
    "sku": "D10.LD080.K.M.M.T.01011",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843073601833,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD080.K.M.M.T.01011",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "6072.00",
        "grams": 0,
        "compare_at_price": "7590.00",
        "position": 1,
        "product_id": 8974696251689,
        "created_at": "2026-03-17T11:53:03+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-8974668726569",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı İki Çekmeceli 100 cm Dafne Gövde Lake Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-100cm-dafne-lavabo-dolabi-cift-cekmeceli-lake-banyo-mobilyasi.png?v=1748255803",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-100cm-dafne-lavabo-dolabi-cift-cekmeceli-lake-banyo-mobilyasi.png?v=1748255803",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-dafne-govde-lake-kapak-5918.jpg?v=1748255803",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-dafne-govde-lake-kapak-5919.jpg?v=1748255803",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-dafne-govde-lake-kapak-5917.jpg?v=1748255803",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-dafne-govde-lake-kapak-5921.jpg?v=1748255792",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-dafne-govde-lake-kapak-5922.jpg?v=1748255792"
    ],
    "price": "12584.00",
    "sku": "D10.LD100.2C.M.L.T.02022",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "Dafne",
      "iki çekmeceli lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52920061493545,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.2C.M.L.T.02022",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "12584.00",
        "grams": 0,
        "compare_at_price": "15730.00",
        "position": 1,
        "product_id": 8974668726569,
        "created_at": "2026-04-03T08:18:27+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-8974665089321",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı İki Çekmeceli 100 cm Beyaz Gövde Lake Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-100cm-beyaz-lavabo-dolabi-cift-cekmeceli-lake-banyo-mobilyasi.png?v=1748255884",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-100cm-beyaz-lavabo-dolabi-cift-cekmeceli-lake-banyo-mobilyasi.png?v=1748255884",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-beyaz-govde-lake-kapak-5914.jpg?v=1748255884",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-beyaz-govde-lake-kapak-5913.jpg?v=1748255884",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-beyaz-govde-lake-kapak-5912.jpg?v=1748255884",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-beyaz-govde-lake-kapak-5915.jpg?v=1748255880",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-beyaz-govde-lake-kapak-5916.jpg?v=1748255880"
    ],
    "price": "12584.00",
    "sku": "D10.LD100.2C.M.L.T.01011",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "iki çekmeceli lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843080646953,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.2C.M.L.T.01011",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "12584.00",
        "grams": 0,
        "compare_at_price": "15730.00",
        "position": 1,
        "product_id": 8974665089321,
        "created_at": "2026-03-17T11:55:38+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8973529841961",
    "brand": "Creavit",
    "title": "D10 Eksen Lavabo Dolabı Çekmeceli 100 cm Gri Gövde Antrasit Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-eksen-antrasit-lavabo-dolabi-cekmeceli-melamin-100cm-banyo-mobilyasi.png?v=1748261478",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-eksen-antrasit-lavabo-dolabi-cekmeceli-melamin-100cm-banyo-mobilyasi.png?v=1748261478",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-gri-govde-antrasit-kapak-5879.jpg?v=1748261478",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-gri-govde-antrasit-kapak-5880.jpg?v=1748261478",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-gri-govde-antrasit-kapak-5878.jpg?v=1748261478",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-gri-govde-antrasit-kapak-5882.jpg?v=1748261476",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-gri-govde-antrasit-kapak-5883.jpg?v=1748261476"
    ],
    "price": "9240.00",
    "sku": "D10.LD100.1C.M.M.0305",
    "tags": [
      "Antrasit",
      "Banyo Mobilyası",
      "D10",
      "Gri",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843090247977,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.1C.M.M.0305",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9240.00",
        "grams": 0,
        "compare_at_price": "11550.00",
        "position": 1,
        "product_id": 8973529841961,
        "created_at": "2026-03-17T11:59:15+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-8973427736873",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı Kapaklı 100 cm Gri Melamin Gövde Antrasit Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-100cm-antrasit-lavabo-dolabi-cekmeceli-melamin-banyo-mobilyasi.png?v=1748263386",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-100cm-antrasit-lavabo-dolabi-cekmeceli-melamin-banyo-mobilyasi.png?v=1748263386",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-gri-melamin-govde-antrasit-kapak-5752.jpg?v=1748263386",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-gri-melamin-govde-antrasit-kapak-5753.jpg?v=1748263386",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-gri-melamin-govde-antrasit-kapak-5751.jpg?v=1748263386",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-gri-melamin-govde-antrasit-kapak-5754.jpg?v=1748263384",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-gri-melamin-govde-antrasit-kapak-5755.jpg?v=1748263384"
    ],
    "price": "6424.00",
    "sku": "D10.LD100.K.M.M.T.03053",
    "tags": [
      "Antrasit",
      "Banyo Mobilyası",
      "D10",
      "Gri",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52914005705001,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.K.M.M.T.03053",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "6424.00",
        "grams": 0,
        "compare_at_price": "8030.00",
        "position": 1,
        "product_id": 8973427736873,
        "created_at": "2026-04-01T23:47:38+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-9849557778729",
    "brand": "Creavit",
    "title": "D10 40 cm Sol Boy Dolabı Gri Melamin Gövde Lake Kapak",
    "category": "462591328553",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-gri-melamin-govde-lake-kapak-5518.jpg?v=1761034820",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-gri-melamin-govde-lake-kapak-5518.jpg?v=1761034820",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-gri-melamin-govde-lake-kapak-5519_72197041-fc88-4c2f-b236-17b6b218ff87.jpg?v=1761034823",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-gri-melamin-govde-lake-kapak-5520.jpg?v=1761034825",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-gri-melamin-govde-lake-kapak-5521.jpg?v=1761034828",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-gri-melamin-govde-lake-kapak-5522.jpg?v=1761034830",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-gri-melamin-govde-lake-kapak-5523.jpg?v=1761034831"
    ],
    "price": "8536.00",
    "sku": "D10.BD040.SOL.M.L.0303",
    "tags": [],
    "variants": [
      {
        "id": 52864577634601,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.BD040.SOL.M.L.0303",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "8536.00",
        "grams": 0,
        "compare_at_price": "10670.00",
        "position": 1,
        "product_id": 9849557778729,
        "created_at": "2026-03-22T20:52:55+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-9848677695785",
    "brand": "Creavit",
    "title": "Angel Led Ayna 92cm",
    "category": "456291287337",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/angel-led-ayna-92cm-7655.webp?v=1760947737",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/angel-led-ayna-92cm-7655.webp?v=1760947737"
    ],
    "price": "7080.00",
    "sku": "AL4001.01.BB",
    "tags": [],
    "variants": [
      {
        "id": 52452314874153,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "AL4001.01.BB",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "7080.00",
        "grams": 0,
        "compare_at_price": "11800.00",
        "position": 1,
        "product_id": 9848677695785,
        "created_at": "2026-01-16T16:20:34+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p data-end=\"279\" data-start=\"139\"><strong>Angel LED Ayna 92 cm</strong></p>\r\n<p data-end=\"279\" data-start=\"139\">Şıklığı ve modern tasarımıyla banyonuza estetik bir dokunuş katacak <strong data-end=\"225\" data-start=\"207\">Angel LED Ayna</strong>, fonksiyonelliği ve zarif görünümü bir arada sunar.</p>\r\n<p data-end=\"301\" data-start=\"281\"><strong data-end=\"299\" data-start=\"281\">Ürün Ölçüleri:</strong></p>\r\n<ul data-end=\"384\" data-start=\"302\">\r\n<li data-end=\"334\" data-start=\"302\">\r\n<p data-end=\"334\" data-start=\"304\"><strong data-end=\"317\" data-start=\"304\">Genişlik:</strong> 920 mm (92 cm)</p>\n</li>\r\n<li data-end=\"360\" data-start=\"335\">\r\n<p data-end=\"360\" data-start=\"337\"><strong data-end=\"351\" data-start=\"337\">Yükseklik:</strong> 500 mm</p>\n</li>\r\n<li data-end=\"384\" data-start=\"361\">\r\n<p data-end=\"384\" data-start=\"363\"><strong data-end=\"376\" data-start=\"363\">Derinlik:</strong> 45 mm</p>\n</li>\n</ul>\r\n<p data-end=\"594\" data-start=\"386\">Kompakt yapısı sayesinde hem küçük hem büyük banyolarda rahatlıkla kullanılabilir. LED aydınlatmasıyla net ve parlak bir görüntü sağlayarak makyaj, tıraş ve kişisel bakım işlemlerinizde maksimum konfor sunar.</p>"
  },
  {
    "id": "creavit-8973432783145",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı Kapaklı 100 cm Melamin Gövde Beyaz",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-melamin-govde-beyaz-5761.jpg?v=1747227220",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-melamin-govde-beyaz-5761.jpg?v=1747227220",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-melamin-govde-beyaz-5762.jpg?v=1747227223",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-melamin-govde-beyaz-5763.jpg?v=1747227225",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-melamin-govde-beyaz-5764.jpg?v=1747227230",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-melamin-govde-beyaz-5765.jpg?v=1747227234"
    ],
    "price": "6424.00",
    "sku": "D10.LD100.K.M.M.T.01011",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843092050217,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.K.M.M.T.01011",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6424.00",
        "grams": 0,
        "compare_at_price": "8030.00",
        "position": 1,
        "product_id": 8973432783145,
        "created_at": "2026-03-17T11:59:53+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-8974676984105",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı Kapaklı 80 cm Gri Gövde Antrasit Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-80-cm-gri-govde-antrasit-kapak-5930.jpg?v=1747234552",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-80-cm-gri-govde-antrasit-kapak-5930.jpg?v=1747234552",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-80-cm-gri-govde-antrasit-kapak-5931.jpg?v=1747234554",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-80-cm-gri-govde-antrasit-kapak-5932.jpg?v=1747234558",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-80-cm-gri-govde-antrasit-kapak-5933.jpg?v=1747234561",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-80-cm-gri-govde-antrasit-kapak-5934.jpg?v=1747234564",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-80-cm-gri-govde-antrasit-kapak-5935.jpg?v=1747234568"
    ],
    "price": "6072.00",
    "sku": "D10.LD080.K.M.M.T.03053",
    "tags": [
      "Antrasit",
      "Banyo Mobilyası",
      "D10",
      "Gri",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843080810793,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD080.K.M.M.T.03053",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6072.00",
        "grams": 0,
        "compare_at_price": "7590.00",
        "position": 1,
        "product_id": 8974676984105,
        "created_at": "2026-03-17T11:55:41+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-9842108203305",
    "brand": "Creavit",
    "title": "Pion lavabo Dolabı 120 Cm Beyaz-Meşe",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-lavabo-dolabi-120-cm-beyaz-mese-7647.jpg?v=1760446705",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-lavabo-dolabi-120-cm-beyaz-mese-7647.jpg?v=1760446705",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-lavabo-dolabi-120-cm-beyaz-mese-7648.jpg?v=1760446708",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-lavabo-dolabi-120-cm-beyaz-mese-7649.jpg?v=1760446710",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-lavabo-dolabi-120-cm-beyaz-mese-7650.jpg?v=1760446713"
    ],
    "price": "71197.50",
    "sku": "PN0120.01.BDM",
    "tags": [
      "Banyo Mobilyası",
      "Lavabo Dolabı",
      "Pion"
    ],
    "variants": [
      {
        "id": 52843186422057,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "PN0120.01.BDM",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "71197.50",
        "grams": 0,
        "compare_at_price": "94930.00",
        "position": 1,
        "product_id": 9842108203305,
        "created_at": "2026-03-17T12:46:31+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h3 data-start=\"208\" data-end=\"284\"><strong data-start=\"211\" data-end=\"284\">Büyük Düşünülmüş Geniş Banyolar: Creavit Pion 120 cm Banyo Mobilyası!</strong></h3>\n<p data-start=\"286\" data-end=\"573\">Şıklık, işlevsellik ve kaliteyi bir araya getiren <strong data-start=\"336\" data-end=\"373\">Creavit Pion 120 cm Lavabo Dolabı</strong>, geniş banyolarda modern tasarımıyla fark yaratıyor.<br data-start=\"426\" data-end=\"429\">Dayanıklı malzemelerden üretilen Pion 120 cm banyo dolabı, uzun ömürlü kullanım sunarken zarif çizgileriyle banyonuza estetik bir dokunuş katar.</p>\n<p data-start=\"575\" data-end=\"804\"><strong data-start=\"575\" data-end=\"590\">Pion serisi</strong>, farklı ölçü ve kombinasyon seçenekleriyle her banyoya uyum sağlar. Geniş depolama alanı sayesinde kişisel eşyalarınızı düzenli biçimde saklayabilir, banyonuzda ferah ve konforlu bir atmosfer oluşturabilirsiniz.</p>\n<h3 data-start=\"811\" data-end=\"835\"><strong data-start=\"815\" data-end=\"835\">Ürün Özellikleri</strong></h3>\n<p data-start=\"839\" data-end=\"870\"><strong data-start=\"839\" data-end=\"854\">Model Kodu:</strong> PN0120.01.BDM</p>\n<p data-start=\"873\" data-end=\"889\"><strong data-start=\"873\" data-end=\"882\">Seri:</strong> Pion</p>\n<p data-start=\"873\" data-end=\"889\"><strong data-start=\"892\" data-end=\"904\">Ölçüler:</strong> 1195 × 850 × 525 mm</p>\n<p data-start=\"929\" data-end=\"972\"><strong data-start=\"929\" data-end=\"945\">Montaj Tipi:</strong> Duvara asma (asma modül)</p>\n<p data-start=\"975\" data-end=\"1026\"><strong data-start=\"975\" data-end=\"987\">Malzeme:</strong> MDF üzeri yüksek kalite lake kaplama</p>\n<p data-start=\"1029\" data-end=\"1077\"><strong data-start=\"1029\" data-end=\"1038\">Renk:</strong> Mat beyaz ve doğal meşe kombinasyonu</p>\n<p data-start=\"1080\" data-end=\"1131\"><strong data-start=\"1080\" data-end=\"1102\">Kapak Mekanizması:</strong> Soft-close (yavaş kapanır)</p>\n<p data-start=\"1134\" data-end=\"1194\"><strong data-start=\"1134\" data-end=\"1151\">Lavabo Uyumu:</strong> 120 cm Drop serisi lavabolarla uyumludur(Lavabo Dahildir.)</p>\n<p data-start=\"1197\" data-end=\"1224\"><strong data-start=\"1197\" data-end=\"1216\">Garanti Süresi:</strong> 2 yıl</p>\n<p data-start=\"1227\" data-end=\"1307\"><strong data-start=\"1227\" data-end=\"1254\">Dahil Olmayan Parçalar:</strong> Armatür, sifon ve boy dolabı fiyata dahil değildir</p>\n<h3 data-start=\"1314\" data-end=\"1388\"><strong data-start=\"1317\" data-end=\"1388\">Creavit Pion 120 cm – Modern Banyolar için Şık ve Fonksiyonel Çözüm</strong></h3>\n<p data-start=\"1389\" data-end=\"1568\">Estetik tasarımı, kaliteli malzemesi ve geniş kullanım alanıyla <strong data-start=\"1453\" data-end=\"1489\">Creavit Pion 120 cm Banyo Dolabı</strong>, banyonuzun hem görünümünü hem de kullanım konforunu bir üst seviyeye taşır.</p>"
  },
  {
    "id": "creavit-9842103517481",
    "brand": "Creavit",
    "title": "Pion Led Ayna",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-led-ayna-7651.jpg?v=1760445796",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-led-ayna-7651.jpg?v=1760445796",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-led-ayna-7652.jpg?v=1760445799"
    ],
    "price": "36135.00",
    "sku": "PN1120.01.BB",
    "tags": [
      "Ayna",
      "Banyo Mobilyası",
      "dolaplı ayna",
      "Pion"
    ],
    "variants": [
      {
        "id": 52915860832553,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "PN1120.01.BB",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "36135.00",
        "grams": 0,
        "compare_at_price": "48180.00",
        "position": 1,
        "product_id": 9842103517481,
        "created_at": "2026-04-02T12:10:36+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h3 data-end=\"253\" data-start=\"184\"><strong data-end=\"253\" data-start=\"187\">Büyük Düşünülmüş Geniş Banyolar: Creavit Pion 120 cm LED Ayna!</strong></h3>\n<p data-end=\"506\" data-start=\"255\">Modern banyolarda aydınlık, netlik ve estetiği bir araya getiren <strong data-end=\"352\" data-start=\"320\">Creavit Pion 120 cm LED Ayna</strong>, zarif tasarımıyla Pion serisini tamamlıyor.<br data-end=\"400\" data-start=\"397\">Şık çerçevesi ve entegre LED aydınlatması sayesinde hem dekoratif hem de fonksiyonel bir kullanım sunar.</p>\n<p data-end=\"769\" data-start=\"508\">Yüksek kalite standartlarında üretilen Pion LED Ayna, banyonuza ferahlık ve modernlik katarken, uzun ömürlü yapısıyla da güvenli bir kullanım sağlar.<br data-end=\"660\" data-start=\"657\">Creavit’in özgün tasarım anlayışını yansıtan bu ürün, <strong data-end=\"743\" data-start=\"714\">Pion 120 cm lavabo dolabı</strong> ile mükemmel uyum sağlar.</p>\n<hr data-end=\"774\" data-start=\"771\">\n<h3 data-end=\"800\" data-start=\"776\"><strong data-end=\"800\" data-start=\"780\">Ürün Özellikleri</strong></h3>\n<p data-end=\"834\" data-start=\"804\"><strong data-end=\"819\" data-start=\"804\">Model Kodu:</strong> PN1120.01.BB</p>\n<p data-end=\"873\" data-start=\"837\"><strong data-end=\"850\" data-start=\"837\">Ürün Adı:</strong> Pion 120 cm LED Ayna</p>\n<p data-end=\"892\" data-start=\"876\"><strong data-end=\"885\" data-start=\"876\">Seri:</strong> Pion</p>\n<p data-end=\"929\" data-start=\"895\"><strong data-end=\"907\" data-start=\"895\">Ölçüler:</strong> 1180 × 580 × 140 mm</p>\n<p data-end=\"981\" data-start=\"932\"><strong data-end=\"947\" data-start=\"932\">Aydınlatma:</strong> Entegre LED aydınlatmalı sistem</p>\n<p data-end=\"1040\" data-start=\"984\"><strong data-end=\"1001\" data-start=\"984\">Renk / Yüzey:</strong> Beyaz çerçeve – modern hatlı tasarım</p>\n<p data-end=\"1107\" data-start=\"1043\"><strong data-end=\"1055\" data-start=\"1043\">Malzeme:</strong> Nem dayanımlı malzeme, ayna yüzeyi özel kaplamalı</p>\n<p data-end=\"1172\" data-start=\"1110\"><strong data-end=\"1124\" data-start=\"1110\">Uyumluluk:</strong> Pion 120 cm lavabo dolabı ile takım oluşturur</p>\n<p data-end=\"1213\" data-start=\"1175\"><strong data-end=\"1191\" data-start=\"1175\">Montaj Tipi:</strong> Duvara monte edilir</p>\n<p data-end=\"1236\" data-start=\"1216\"><strong data-end=\"1228\" data-start=\"1216\">Garanti:</strong> 2 yıl</p>\n<hr data-end=\"1241\" data-start=\"1238\">\n<h3 data-end=\"1310\" data-start=\"1243\"><strong data-end=\"1310\" data-start=\"1246\">Creavit Pion 120 cm LED Ayna – Işıltılı, Modern, Fonksiyonel</strong></h3>\n<p data-end=\"1504\" data-start=\"1311\">Yalın hatları, güçlü aydınlatması ve zarif tasarımıyla <strong data-end=\"1383\" data-start=\"1366\">Pion LED Ayna</strong>, banyolarınıza estetik bir atmosfer kazandırır.<br data-end=\"1434\" data-start=\"1431\">Hem fonksiyonel hem de şık bir tamamlayıcı arayanlar için ideal seçim!</p>"
  },
  {
    "id": "creavit-9842103288105",
    "brand": "Creavit",
    "title": "Pion Boy Dolabı Meşe",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-pion-boy-dolabi-mese-7653.jpg?v=1760445741",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-pion-boy-dolabi-mese-7653.jpg?v=1760445741",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-pion-boy-dolabi-mese-7654.jpg?v=1760445744"
    ],
    "price": "27555.00",
    "sku": "PN2160.02.BDM",
    "tags": [
      "Banyo Mobilyası",
      "boy dolabı",
      "Pion"
    ],
    "variants": [
      {
        "id": 52912293609769,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "PN2160.02.BDM",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "27555.00",
        "grams": 0,
        "compare_at_price": "36740.00",
        "position": 1,
        "product_id": 9842103288105,
        "created_at": "2026-04-01T14:57:39+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h3 data-end=\"253\" data-start=\"189\"><strong data-end=\"253\" data-start=\"192\">Büyük Düşünülmüş Geniş Banyolar: Creavit Pion Boy Dolabı!</strong></h3>\n<p data-end=\"526\" data-start=\"255\">Geniş banyolar için özel olarak tasarlanmış <strong data-end=\"326\" data-start=\"299\">Creavit Pion Boy Dolabı</strong>, işlevsellik ve şıklığı bir araya getiriyor. Dayanıklı malzemelerden üretilmiş olan Pion Boy Dolabı, uzun ömürlü kullanım sunarken, modern ve zarif tasarımı ile banyonuza estetik bir dokunuş katacak.</p>\n<p data-end=\"755\" data-start=\"528\"><strong data-end=\"543\" data-start=\"528\">Pion serisi</strong>, farklı ölçü ve kombinasyon seçenekleriyle her banyoya uyum sağlar. Geniş depolama alanı sayesinde kişisel eşyalarınızı düzenli biçimde saklayabilir, banyonuzda ferah ve konforlu bir atmosfer oluşturabilirsiniz.</p>\n<h3 data-end=\"786\" data-start=\"762\"><strong data-end=\"786\" data-start=\"766\">Ürün Özellikleri</strong></h3>\n<p data-end=\"821\" data-start=\"790\"><strong data-end=\"805\" data-start=\"790\">Model Kodu:</strong> PN2160.02.BDM</p>\n<p data-end=\"840\" data-start=\"824\"><strong data-end=\"833\" data-start=\"824\">Seri:</strong> Pion</p>\n<p data-end=\"877\" data-start=\"843\"><strong data-end=\"855\" data-start=\"843\">Ölçüler:</strong> 400 × 1600 × 320 mm</p>\n<p data-end=\"917\" data-start=\"880\"><strong data-end=\"896\" data-start=\"880\">Montaj Tipi:</strong> Asma (duvara asma)</p>\n<p data-end=\"957\" data-start=\"920\"><strong data-end=\"932\" data-start=\"920\">Malzeme:</strong> MDF üzeri lake kaplama</p>\n<p data-end=\"1008\" data-start=\"960\"><strong data-end=\"969\" data-start=\"960\">Renk:</strong> Mat beyaz ve doğal meşe kombinasyonu</p>\n<p data-end=\"1069\" data-start=\"1011\"><strong data-end=\"1033\" data-start=\"1011\">Kapak Mekanizması:</strong> Soft-close (yavaş kapanan sistem)</p>\n<p data-end=\"1099\" data-start=\"1072\"><strong data-end=\"1091\" data-start=\"1072\">Garanti Süresi:</strong> 2 yıl</p>\n<p data-end=\"1128\" data-start=\"1102\"><strong data-end=\"1118\" data-start=\"1102\">Üretim Yeri:</strong> Türkiye</p>\n<p data-end=\"1178\" data-start=\"1131\"><strong data-end=\"1149\" data-start=\"1131\">Uyumlu Lavabo:</strong> DP120 serisi ile uyumludur</p>\n<p data-end=\"1227\" data-start=\"1181\"><strong data-end=\"1193\" data-start=\"1181\">Ağırlık:</strong> 32,68 kg (net), 34,40 kg (brüt)</p>\n<p data-end=\"1268\" data-start=\"1230\"><strong data-end=\"1246\" data-start=\"1230\">Koli Ölçüsü:</strong> 1630 × 435 × 350 mm</p>\n<p data-end=\"1369\" data-start=\"1271\"><strong data-end=\"1284\" data-start=\"1271\">RAL Kodu:</strong> Mat Beyaz - Meşe Kaplama Üzeri İpek Mat Vernik</p>\n<h3 data-end=\"1454\" data-start=\"1376\"><strong data-end=\"1454\" data-start=\"1379\">Creavit Pion Boy Dolabı – Modern Banyolar için Şık ve Fonksiyonel Çözüm</strong></h3>\n<p data-end=\"1624\" data-start=\"1456\">Estetik tasarımı, kaliteli malzemesi ve geniş kullanım alanıyla <strong data-end=\"1547\" data-start=\"1520\">Creavit Pion Boy Dolabı</strong>, banyonuzun hem görünümünü hem de kullanım konforunu bir üst seviyeye taşır.</p>"
  },
  {
    "id": "creavit-9826522464553",
    "brand": "Creavit",
    "title": "Bloom Parlak Krom Kaplama Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bloom-parlak-krom-kaplama-kumanda-paneli-7643.jpg?v=1758635804",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bloom-parlak-krom-kaplama-kumanda-paneli-7643.jpg?v=1758635804",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bloom-parlak-krom-kaplama-kumanda-paneli-7644.jpg?v=1758635806"
    ],
    "price": "2352.00",
    "sku": "GP1104.00",
    "tags": [
      "Bloom",
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "Rezervuar",
      "Rezervuarlar"
    ],
    "variants": [
      {
        "id": 52843222204713,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP1104.00",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2352.00",
        "grams": 0,
        "compare_at_price": "3360.00",
        "position": 1,
        "product_id": 9826522464553,
        "created_at": "2026-03-17T12:56:55+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Creavit Bloom Kumanda Paneli banyo deneyiminizi işlevsel hale getirirken aynı zamanda modern ve şık görünümüyle banyonuza estetik bir katkı sunar. Kaliteli malzemelerden üretilmiş olan Creavit kumanda panelleri dayanıklı yapısıyla da uzun ömürlü kullanım sağlar.</p>\r\n<p>Bloom Kumanda Paneli sadece Creavit marka gömme rezervuarlar ile uyumludur.</p>"
  },
  {
    "id": "creavit-9826521710889",
    "brand": "Creavit",
    "title": "Bloom Mat Krom Kaplama Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bloom-mat-krom-kaplama-kumanda-paneli-7641.jpg?v=1758635607",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bloom-mat-krom-kaplama-kumanda-paneli-7641.jpg?v=1758635607",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bloom-mat-krom-kaplama-kumanda-paneli-7642.jpg?v=1758635610"
    ],
    "price": "2352.00",
    "sku": "GP1103.00",
    "tags": [
      "Bloom",
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "Rezervuar",
      "Rezervuarlar"
    ],
    "variants": [
      {
        "id": 52843212734761,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP1103.00",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2352.00",
        "grams": 0,
        "compare_at_price": "3360.00",
        "position": 1,
        "product_id": 9826521710889,
        "created_at": "2026-03-17T12:54:30+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Creavit Bloom Kumanda Paneli banyo deneyiminizi işlevsel hale getirirken aynı zamanda modern ve şık görünümüyle banyonuza estetik bir katkı sunar. Kaliteli malzemelerden üretilmiş olan Creavit kumanda panelleri dayanıklı yapısıyla da uzun ömürlü kullanım sağlar.</p>\r\n<p>Bloom Kumanda Paneli sadece Creavit marka gömme rezervuarlar ile uyumludur.</p>"
  },
  {
    "id": "creavit-9826521219369",
    "brand": "Creavit",
    "title": "Bloom Gun Grey Boyalı Kumanda Panel",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bloom-gun-grey-boyali-kumanda-panel-7639.jpg?v=1758635488",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bloom-gun-grey-boyali-kumanda-panel-7639.jpg?v=1758635488",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bloom-gun-grey-boyali-kumanda-panel-7640.jpg?v=1758635491"
    ],
    "price": "2016.00",
    "sku": "GP1102.11",
    "tags": [
      "Bloom",
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "Rezervuar",
      "Rezervuarlar"
    ],
    "variants": [
      {
        "id": 52843212538153,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP1102.11",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2016.00",
        "grams": 0,
        "compare_at_price": "2880.00",
        "position": 1,
        "product_id": 9826521219369,
        "created_at": "2026-03-17T12:54:27+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Creavit Bloom Kumanda Paneli banyo deneyiminizi işlevsel hale getirirken aynı zamanda modern ve şık görünümüyle banyonuza estetik bir katkı sunar. Kaliteli malzemelerden üretilmiş olan Creavit kumanda panelleri dayanıklı yapısıyla da uzun ömürlü kullanım sağlar.</p>\r\n<p>Bloom Kumanda Paneli sadece Creavit marka gömme rezervuarlar ile uyumludur.</p>"
  },
  {
    "id": "creavit-9826520367401",
    "brand": "Creavit",
    "title": "Bloom Kömür Karası Boyalı Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bloom-komur-karasi-boyali-kumanda-paneli-7637.jpg?v=1758635234",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bloom-komur-karasi-boyali-kumanda-paneli-7637.jpg?v=1758635234",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bloom-komur-karasi-boyali-kumanda-paneli-7638.jpg?v=1758635237"
    ],
    "price": "2016.00",
    "sku": "GP1102.10",
    "tags": [
      "Bloom",
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "Rezervuar",
      "Rezervuarlar"
    ],
    "variants": [
      {
        "id": 52920980046121,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP1102.10",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2016.00",
        "grams": 0,
        "compare_at_price": "2880.00",
        "position": 1,
        "product_id": 9826520367401,
        "created_at": "2026-04-03T12:18:45+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Creavit Bloom Kumanda Paneli banyo deneyiminizi işlevsel hale getirirken aynı zamanda modern ve şık görünümüyle banyonuza estetik bir katkı sunar. Kaliteli malzemelerden üretilmiş olan Creavit kumanda panelleri dayanıklı yapısıyla da uzun ömürlü kullanım sağlar.</p>\r\n<p>Bloom Kumanda Paneli sadece Creavit marka gömme rezervuarlar ile uyumludur.</p>"
  },
  {
    "id": "creavit-9826516369705",
    "brand": "Creavit",
    "title": "Bloom Mat Cool Grey Boyalı Kumanda Panel",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bloom-mat-cool-grey-boyali-kumanda-panel-7635.jpg?v=1758635090",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bloom-mat-cool-grey-boyali-kumanda-panel-7635.jpg?v=1758635090",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bloom-mat-cool-grey-boyali-kumanda-panel-7636.jpg?v=1758635093"
    ],
    "price": "2016.00",
    "sku": "GP1102.07",
    "tags": [
      "Bloom",
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Rezervuar",
      "Rezervuarlar"
    ],
    "variants": [
      {
        "id": 52843233935657,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP1102.07",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2016.00",
        "grams": 0,
        "compare_at_price": "2880.00",
        "position": 1,
        "product_id": 9826516369705,
        "created_at": "2026-03-17T13:01:14+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Creavit Bloom Kumanda Paneli banyo deneyiminizi işlevsel hale getirirken aynı zamanda modern ve şık görünümüyle banyonuza estetik bir katkı sunar. Kaliteli malzemelerden üretilmiş olan Creavit kumanda panelleri dayanıklı yapısıyla da uzun ömürlü kullanım sağlar.</p>\r\n<p>Bloom Kumanda Paneli sadece Creavit marka gömme rezervuarlar ile uyumludur.</p>"
  },
  {
    "id": "creavit-9826515943721",
    "brand": "Creavit",
    "title": "Bloom Mat Cappucino Boyalı Kumanda Panel",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bloom-mat-cappucino-boyali-kumanda-panel-7633.jpg?v=1758634966",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bloom-mat-cappucino-boyali-kumanda-panel-7633.jpg?v=1758634966",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bloom-mat-cappucino-boyali-kumanda-panel-7634.jpg?v=1758634969"
    ],
    "price": "2016.00",
    "sku": "GP1102.06",
    "tags": [
      "Bloom",
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Rezervuar",
      "Rezervuarlar"
    ],
    "variants": [
      {
        "id": 52843212112169,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP1102.06",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2016.00",
        "grams": 0,
        "compare_at_price": "2880.00",
        "position": 1,
        "product_id": 9826515943721,
        "created_at": "2026-03-17T12:54:20+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Creavit Bloom Kumanda Paneli banyo deneyiminizi işlevsel hale getirirken aynı zamanda modern ve şık görünümüyle banyonuza estetik bir katkı sunar. Kaliteli malzemelerden üretilmiş olan Creavit kumanda panelleri dayanıklı yapısıyla da uzun ömürlü kullanım sağlar.</p>\r\n<p>Bloom Kumanda Paneli sadece Creavit marka gömme rezervuarlar ile uyumludur.</p>"
  },
  {
    "id": "creavit-9826515288361",
    "brand": "Creavit",
    "title": "Bloom Mat Antrasit Boyalı Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bloom-mat-antrasit-boyali-kumanda-paneli-7631.jpg?v=1758634773",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bloom-mat-antrasit-boyali-kumanda-paneli-7631.jpg?v=1758634773",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bloom-mat-antrasit-boyali-kumanda-paneli-7632.jpg?v=1758634776"
    ],
    "price": "2016.00",
    "sku": "GP1102.04",
    "tags": [
      "Bloom",
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Rezervuar",
      "Rezervuarlar"
    ],
    "variants": [
      {
        "id": 52843211882793,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP1102.04",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2016.00",
        "grams": 0,
        "compare_at_price": "2880.00",
        "position": 1,
        "product_id": 9826515288361,
        "created_at": "2026-03-17T12:54:17+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Creavit Bloom Kumanda Paneli banyo deneyiminizi işlevsel hale getirirken aynı zamanda modern ve şık görünümüyle banyonuza estetik bir katkı sunar. Kaliteli malzemelerden üretilmiş olan Creavit kumanda panelleri dayanıklı yapısıyla da uzun ömürlü kullanım sağlar.</p>\r\n<p>Bloom Kumanda Paneli sadece Creavit marka gömme rezervuarlar ile uyumludur.</p>"
  },
  {
    "id": "creavit-9826514239785",
    "brand": "Creavit",
    "title": "Bloom Mat Gri Boyalı Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bloom-mat-gri-boyali-kumanda-paneli-7629.jpg?v=1758634600",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bloom-mat-gri-boyali-kumanda-paneli-7629.jpg?v=1758634600",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bloom-mat-gri-boyali-kumanda-paneli-7630.jpg?v=1758634602"
    ],
    "price": "1386.00",
    "sku": "GP1102.00",
    "tags": [
      "Bloom",
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Rezervuar",
      "Rezervuarlar"
    ],
    "variants": [
      {
        "id": 52921492930857,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP1102.00",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1386.00",
        "grams": 0,
        "compare_at_price": "1980.00",
        "position": 1,
        "product_id": 9826514239785,
        "created_at": "2026-04-03T14:46:22+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Creavit Bloom Kumanda Paneli banyo deneyiminizi işlevsel hale getirirken aynı zamanda modern ve şık görünümüyle banyonuza estetik bir katkı sunar. Kaliteli malzemelerden üretilmiş olan Creavit kumanda panelleri dayanıklı yapısıyla da uzun ömürlü kullanım sağlar.</p>\r\n<p>Bloom Kumanda Paneli sadece Creavit marka gömme rezervuarlar ile uyumludur.</p>"
  },
  {
    "id": "creavit-9826513322281",
    "brand": "Creavit",
    "title": "Bloom Beyaz Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bloom-beyaz-kumanda-paneli-7627.jpg?v=1758634417",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bloom-beyaz-kumanda-paneli-7627.jpg?v=1758634417",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bloom-beyaz-kumanda-paneli-7628.jpg?v=1758634419"
    ],
    "price": "1050.00",
    "sku": "GP1101.00",
    "tags": [
      "Bloom",
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Rezervuar",
      "Rezervuarlar"
    ],
    "variants": [
      {
        "id": 52843226431785,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP1101.00",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1050.00",
        "grams": 0,
        "compare_at_price": "1500.00",
        "position": 1,
        "product_id": 9826513322281,
        "created_at": "2026-03-17T12:58:30+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Creavit Bloom Kumanda Paneli banyo deneyiminizi işlevsel hale getirirken aynı zamanda modern ve şık görünümüyle banyonuza estetik bir katkı sunar. Kaliteli malzemelerden üretilmiş olan Creavit kumanda panelleri dayanıklı yapısıyla da uzun ömürlü kullanım sağlar.</p>\r\n<p>Bloom Kumanda Paneli sadece Creavit marka gömme rezervuarlar ile uyumludur.</p>"
  },
  {
    "id": "creavit-9826507194665",
    "brand": "Creavit",
    "title": "Petra Tezgah Üstü Lavabo 65 Cm.",
    "category": "462596342057",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/petra-tezgah-ustu-lavabo-65-cm-7623.jpg?v=1758632952",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/petra-tezgah-ustu-lavabo-65-cm-7623.jpg?v=1758632952",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/petra-tezgah-ustu-lavabo-65-cm-7624.jpg?v=1758632955",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/petra-tezgah-ustu-lavabo-65-cm-7625.jpg?v=1758632958",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/petra-tezgah-ustu-lavabo-65-cm-7626.jpg?v=1758632961"
    ],
    "price": "3945.00",
    "sku": "PR065-00CB00E-0000",
    "tags": [],
    "variants": [
      {
        "id": 52843188977961,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "PR065-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "3945.00",
        "grams": 0,
        "compare_at_price": "5260.00",
        "position": 1,
        "product_id": 9826507194665,
        "created_at": "2026-03-17T12:47:25+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<div class=\"product-specs p-4 rounded-lg shadow-md bg-white\">\r\n<h2 class=\"text-xl font-bold mb-3 border-b pb-2\">Ürün Genel Bilgiler</h2>\r\n<ul class=\"list-disc pl-6 mb-4\">\r\n<li>\n<strong>Ürün Adı:</strong> Petra Oval Asimetrik Tezgah Üstü Lavabo</li>\r\n<li>\n<strong>Marka:</strong> Creavit</li>\r\n<li>\n<strong>Seri:</strong> Petra</li>\r\n<li>\n<strong>Renk:</strong> Beyaz (Parlak)</li>\r\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\r\n<li>\n<strong>Garanti Süresi:</strong> 12 yıl Creavit garantisi</li>\r\n<li>\n<strong>Yetkili Servis Desteği:</strong> Var</li>\r\n<li>\n<strong>Ücretsiz Montaj:</strong> Yok</li>\r\n<li>\n<strong>Süzgeç ve Sifon:</strong> Dahil değildir</li>\n</ul>\r\n<h2 class=\"text-xl font-bold mb-3 border-b pb-2\">Ölçü ve Fiziksel Özellikler</h2>\r\n<table class=\"table-auto border-collapse w-full mb-4\">\r\n<tbody>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold w-1/2\">Ölçüler (Genişlik × Yükseklik × Derinlik)</td>\r\n<td class=\"py-2\">650 × 135 × 400 mm</td>\n</tr>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold\">Lavabo Uzunluğu (Genişlik)</td>\r\n<td class=\"py-2\">650 mm</td>\n</tr>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold\">Lavabo Derinliği (Ön-arka)</td>\r\n<td class=\"py-2\">400 mm</td>\n</tr>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold\">Ürün Ağırlığı</td>\r\n<td class=\"py-2\">10,34 kg</td>\n</tr>\r\n<tr>\r\n<td class=\"py-2 font-semibold\">Lavabo İç Şekli</td>\r\n<td class=\"py-2\">Oval</td>\n</tr>\n</tbody>\n</table>\r\n<h2 class=\"text-xl font-bold mb-3 border-b pb-2\">Kullanım / Montaj / Diğer Teknik Bilgiler</h2>\r\n<ul class=\"list-disc pl-6\">\r\n<li>Montaj Tipi: Tezgah üstü (set üstü lavabo)</li>\r\n<li>Armatür Deliği: Orta armatür delikli</li>\r\n<li>Su Taşma Deliği: Yok</li>\r\n<li>Ayaklı Kullanım: Uygun değil</li>\r\n<li>Süzgeç ve Sifon: Ürüne dahil değildir</li>\n</ul>\n</div>"
  },
  {
    "id": "creavit-9826505490729",
    "brand": "Creavit",
    "title": "Volga 50*60 Tezgah Üstü Lavabo",
    "category": "462596342057",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/volga-50-60-tezgah-ustu-lavabo-7621.jpg?v=1758632626",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/volga-50-60-tezgah-ustu-lavabo-7621.jpg?v=1758632626"
    ],
    "price": "4950.00",
    "sku": "VX260-00CB00E-0000",
    "tags": [],
    "variants": [
      {
        "id": 52920278647081,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "VX260-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "4950.00",
        "grams": 0,
        "compare_at_price": "6600.00",
        "position": 1,
        "product_id": 9826505490729,
        "created_at": "2026-04-03T09:17:18+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<div class=\"product-specs p-4 rounded-lg shadow-md bg-white\">\r\n<h2 class=\"text-xl font-bold mb-3 border-b pb-2\">Ürün Genel Bilgileri</h2>\r\n<ul class=\"list-disc pl-6 mb-4\">\r\n<li>\n<strong>Ürün Adı:</strong> Volga Tezgah Üstü Kare Lavabo 50×60 cm</li>\r\n<li>\n<strong>Marka:</strong> Creavit</li>\r\n<li>\n<strong>Seri:</strong> Volga</li>\r\n<li>\n<strong>Renk:</strong> Beyaz</li>\r\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\r\n<h2 class=\"text-xl font-bold mb-3 border-b pb-2\">Ölçü ve Fiziksel Özellikler</h2>\r\n<table class=\"table-auto border-collapse w-full mb-4\">\r\n<tbody>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold w-1/2\">Genişlik × Yükseklik × Derinlik</td>\r\n<td class=\"py-2\">600 × 150 × 500 mm</td>\n</tr>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold\">Lavabo uzunluğu</td>\r\n<td class=\"py-2\">600 mm</td>\n</tr>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold\">Lavabo genişliği (ön-arka derinlik)</td>\r\n<td class=\"py-2\">500 mm</td>\n</tr>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold\">Ürün ağırlığı</td>\r\n<td class=\"py-2\">23,14 kg</td>\n</tr>\r\n<tr>\r\n<td class=\"py-2 font-semibold\">Lavabo iç şekli</td>\r\n<td class=\"py-2\">Dikdörtgen</td>\n</tr>\n</tbody>\n</table>\r\n<h2 class=\"text-xl font-bold mb-3 border-b pb-2\">Kullanım / Montaj / Diğer Teknik Bilgiler</h2>\r\n<ul class=\"list-disc pl-6 mb-4\">\r\n<li>Montaj Tipi: Tezgahüstü (Lavabo, tezgahın üzerinde yerleştirilecek şekilde)</li>\r\n<li>Su taşma deliği: Var</li>\r\n<li>Ayaklı kullanım: Uygun değil</li>\r\n<li>Süzgeç ve sifon: Dahil değil</li>\n</ul>\r\n<h2 class=\"text-xl font-bold mb-3 border-b pb-2\">Garanti &amp; Servis</h2>\r\n<ul class=\"list-disc pl-6\">\r\n<li>Garanti Süresi: 12 yıl Creavit garantisi</li>\r\n<li>Yetkili servis desteği: Var</li>\r\n<li>Ücretsiz montaj: Yok</li>\n</ul>\n</div>"
  },
  {
    "id": "creavit-9826505392425",
    "brand": "Creavit",
    "title": "Volga 50*50 Tezgah Üstü Kare Lavabo",
    "category": "462596342057",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/volga-50-50-tezgah-ustu-kare-lavabo-7619.jpg?v=1758632558",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/volga-50-50-tezgah-ustu-kare-lavabo-7619.jpg?v=1758632558",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/volga-50-50-tezgah-ustu-kare-lavabo-7620.jpg?v=1758632561"
    ],
    "price": "4207.50",
    "sku": "VX255-00CB00E-0000",
    "tags": [],
    "variants": [
      {
        "id": 52920271798569,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "VX255-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "4207.50",
        "grams": 0,
        "compare_at_price": "5610.00",
        "position": 1,
        "product_id": 9826505392425,
        "created_at": "2026-04-03T09:15:28+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<div class=\"product-specs p-4 rounded-lg shadow-md bg-white\">\r\n<h2 class=\"text-xl font-bold mb-3 border-b pb-2\">Ürün Genel Bilgileri</h2>\r\n<ul class=\"list-disc pl-6 mb-4\">\r\n<li>\n<strong>Ürün Adı:</strong> Volga Tezgah Üstü Kare Lavabo 50×50 cm</li>\r\n<li>\n<strong>Marka:</strong> Creavit</li>\r\n<li>\n<strong>Seri:</strong> Volga</li>\r\n<li>\n<strong>Renk:</strong> Beyaz</li>\r\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\r\n<h2 class=\"text-xl font-bold mb-3 border-b pb-2\">Ölçü ve Fiziksel Özellikler</h2>\r\n<table class=\"table-auto border-collapse w-full mb-4\">\r\n<tbody>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold w-1/2\">Genişlik × Yükseklik × Derinlik</td>\r\n<td class=\"py-2\">500 × 122 × 500 mm</td>\n</tr>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold\">Lavabo uzunluğu</td>\r\n<td class=\"py-2\">500 mm</td>\n</tr>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold\">Lavabo genişliği (ön-arka derinlik)</td>\r\n<td class=\"py-2\">500 mm</td>\n</tr>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold\">Ürün ağırlığı</td>\r\n<td class=\"py-2\">18,6 kg</td>\n</tr>\r\n<tr>\r\n<td class=\"py-2 font-semibold\">Lavabo iç şekli</td>\r\n<td class=\"py-2\">Kare</td>\n</tr>\n</tbody>\n</table>\r\n<h2 class=\"text-xl font-bold mb-3 border-b pb-2\">Kullanım / Montaj / Diğer Teknik Bilgiler</h2>\r\n<ul class=\"list-disc pl-6 mb-4\">\r\n<li>Montaj Tipi: Tezgahüstü (Lavabo, tezgahın üzerinde yerleştirilecek şekilde)</li>\r\n<li>Su taşma deliği: Var</li>\r\n<li>Ayaklı kullanım: Uygun değil</li>\r\n<li>Süzgeç ve sifon: Dahil değil</li>\n</ul>\r\n<h2 class=\"text-xl font-bold mb-3 border-b pb-2\">Garanti &amp; Servis</h2>\r\n<ul class=\"list-disc pl-6\">\r\n<li>Garanti Süresi: 12 yıl Creavit garantisi</li>\r\n<li>Yetkili servis desteği: Var</li>\r\n<li>Ücretsiz montaj: Yok</li>\n</ul>\n</div>"
  },
  {
    "id": "creavit-9826500411689",
    "brand": "Creavit",
    "title": "Deep Tezgah Üstü Lavabo 45 Cm. Mat Cappuccino",
    "category": "462596342057",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/deep-tezgah-ustu-lavabo-45-cm-mat-cappuccino-7617.jpg?v=1758631574",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/deep-tezgah-ustu-lavabo-45-cm-mat-cappuccino-7617.jpg?v=1758631574",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/deep-tezgah-ustu-lavabo-45-cm-mat-cappuccino-7618.jpg?v=1758631577"
    ],
    "price": "5490.00",
    "sku": "DE045-00CM00E-0000",
    "tags": [],
    "variants": [
      {
        "id": 52920306434345,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DE045-00CM00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5490.00",
        "grams": 0,
        "compare_at_price": "7320.00",
        "position": 1,
        "product_id": 9826500411689,
        "created_at": "2026-04-03T09:30:17+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<div class=\"product-specs p-4 rounded-lg shadow-md bg-white\">\r\n<h2 class=\"text-xl font-bold mb-3 border-b pb-2\">Ürün Genel Bilgiler</h2>\r\n<ul class=\"list-disc pl-6 mb-4\">\r\n<li>\n<strong>Ürün Adı:</strong> Deep 45 cm Set Üstü Lavabo</li>\r\n<li>\n<strong>Marka:</strong> Creavit</li>\r\n<li>\n<strong>Seri:</strong> Deep</li>\r\n<li>\n<strong>Renk:</strong> Cappuccino</li>\r\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\r\n<li>\n<strong>Garanti Süresi:</strong> 12 yıl Creavit garantisi</li>\r\n<li>\n<strong>Yetkili Servis Desteği:</strong> Var</li>\r\n<li>\n<strong>Ücretsiz Montaj:</strong> Yok</li>\r\n<li>\n<strong>Süzgeç ve Sifon:</strong> Dahil değil</li>\n</ul>\r\n<h2 class=\"text-xl font-bold mb-3 border-b pb-2\">Ölçü ve Fiziksel Özellikler</h2>\r\n<table class=\"table-auto border-collapse w-full mb-4\">\r\n<tbody>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold w-1/2\">Ölçüler (Genişlik × Yükseklik × Derinlik)</td>\r\n<td class=\"py-2\">450 × 150 × 450 mm</td>\n</tr>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold\">Lavabo Uzunluğu (Genişlik)</td>\r\n<td class=\"py-2\">450 mm</td>\n</tr>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold\">Lavabo Derinliği (Ön-arka)</td>\r\n<td class=\"py-2\">450 mm</td>\n</tr>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold\">Ürün Ağırlığı</td>\r\n<td class=\"py-2\">10,85 kg</td>\n</tr>\r\n<tr>\r\n<td class=\"py-2 font-semibold\">Lavabo İç Şekli</td>\r\n<td class=\"py-2\">Yuvarlak çanak biçiminde</td>\n</tr>\n</tbody>\n</table>\r\n<h2 class=\"text-xl font-bold mb-3 border-b pb-2\">Kullanım / Montaj / Diğer Teknik Bilgiler</h2>\r\n<ul class=\"list-disc pl-6\">\r\n<li>Montaj Tipi: Tezgah üstü (set üstü lavabo)</li>\r\n<li>Armatür Deliği: Deliksiz (batarya deliği yok)</li>\r\n<li>Su Taşma Deliği: Yok</li>\r\n<li>Ayaklı Kullanım: Uygun değil</li>\r\n<li>Süzgeç ve Sifon: Ürüne dahil değildir</li>\n</ul>\n</div>"
  },
  {
    "id": "creavit-9826499133737",
    "brand": "Creavit",
    "title": "Deep Tezgah Üstü LAvabo 45 Cm.",
    "category": "462596342057",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/deep-tezgah-ustu-lavabo-45-cm-7614.jpg?v=1758631398",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/deep-tezgah-ustu-lavabo-45-cm-7614.jpg?v=1758631398",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/deep-tezgah-ustu-lavabo-45-cm-7615.jpg?v=1758631401"
    ],
    "price": "3915.00",
    "sku": "DE045-00CB00E-0000",
    "tags": [],
    "variants": [
      {
        "id": 52920295424297,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DE045-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3915.00",
        "grams": 0,
        "compare_at_price": "5220.00",
        "position": 1,
        "product_id": 9826499133737,
        "created_at": "2026-04-03T09:25:02+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<div class=\"product-specs p-4 rounded-lg shadow-md bg-white\">\r\n<h2 class=\"text-xl font-bold mb-3 border-b pb-2\">Ürün Genel Bilgiler</h2>\r\n<ul class=\"list-disc pl-6 mb-4\">\r\n<li>\n<strong>Ürün Adı:</strong> Deep 45 cm Set Üstü Lavabo</li>\r\n<li>\n<strong>Marka:</strong> Creavit</li>\r\n<li>\n<strong>Seri:</strong> Deep</li>\r\n<li>\n<strong>Renk:</strong> Beyaz</li>\r\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\r\n<li>\n<strong>Garanti Süresi:</strong> 12 yıl Creavit garantisi</li>\r\n<li>\n<strong>Yetkili Servis Desteği:</strong> Var</li>\r\n<li>\n<strong>Ücretsiz Montaj:</strong> Yok</li>\r\n<li>\n<strong>Süzgeç ve Sifon:</strong> Dahil değil</li>\n</ul>\r\n<h2 class=\"text-xl font-bold mb-3 border-b pb-2\">Ölçü ve Fiziksel Özellikler</h2>\r\n<table class=\"table-auto border-collapse w-full mb-4\">\r\n<tbody>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold w-1/2\">Ölçüler (Genişlik × Yükseklik × Derinlik)</td>\r\n<td class=\"py-2\">450 × 150 × 450 mm</td>\n</tr>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold\">Lavabo Uzunluğu (Genişlik)</td>\r\n<td class=\"py-2\">450 mm</td>\n</tr>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold\">Lavabo Derinliği (Ön-arka)</td>\r\n<td class=\"py-2\">450 mm</td>\n</tr>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold\">Ürün Ağırlığı</td>\r\n<td class=\"py-2\">10,85 kg</td>\n</tr>\r\n<tr>\r\n<td class=\"py-2 font-semibold\">Lavabo İç Şekli</td>\r\n<td class=\"py-2\">Yuvarlak çanak biçiminde</td>\n</tr>\n</tbody>\n</table>\r\n<h2 class=\"text-xl font-bold mb-3 border-b pb-2\">Kullanım / Montaj / Diğer Teknik Bilgiler</h2>\r\n<ul class=\"list-disc pl-6\">\r\n<li>Montaj Tipi: Tezgah üstü (set üstü lavabo)</li>\r\n<li>Armatür Deliği: Deliksiz (batarya deliği yok)</li>\r\n<li>Su Taşma Deliği: Yok</li>\r\n<li>Ayaklı Kullanım: Uygun değil</li>\r\n<li>Süzgeç ve Sifon: Ürüne dahil değildir</li>\n</ul>\n</div>"
  },
  {
    "id": "creavit-9826497888553",
    "brand": "Creavit",
    "title": "Mina Tezgah Üzeri Çanak Lavabo 65 Cm.",
    "category": "462596342057",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mina-tezgah-uzeri-canak-lavabo-65-cm-7612.jpg?v=1758631177",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mina-tezgah-uzeri-canak-lavabo-65-cm-7612.jpg?v=1758631177",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mina-tezgah-uzeri-canak-lavabo-65-cm-7613.jpg?v=1758631180"
    ],
    "price": "6390.00",
    "sku": "MN165-00CB00E-0000",
    "tags": [],
    "variants": [
      {
        "id": 52920295391529,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MN165-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6390.00",
        "grams": 0,
        "compare_at_price": "8520.00",
        "position": 1,
        "product_id": 9826497888553,
        "created_at": "2026-04-03T09:24:58+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<div class=\"product-specs p-4 rounded-lg shadow-md bg-white\">\r\n<h2 class=\"text-xl font-bold mb-3 border-b pb-2\">Ürün Genel Bilgiler</h2>\r\n<ul class=\"list-disc pl-6 mb-4\">\r\n<li>\n<strong>Ürün Adı:</strong> Mina Tezgah Üstü Çanak Lavabo 65 cm</li>\r\n<li>\n<strong>Marka:</strong> Creavit</li>\r\n<li>\n<strong>Seri:</strong> Mina</li>\r\n<li>\n<strong>Renk:</strong> Beyaz</li>\r\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\r\n<li>\n<strong>Garanti Süresi:</strong> 10 yıl Creavit garantisi</li>\n</ul>\r\n<h2 class=\"text-xl font-bold mb-3 border-b pb-2\">Ölçü ve Fiziksel Özellikler</h2>\r\n<table class=\"table-auto border-collapse w-full mb-4\">\r\n<tbody>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold w-1/2\">Ölçüler (Genişlik × Yükseklik × Derinlik)</td>\r\n<td class=\"py-2\">646 × 155 × 404 mm</td>\n</tr>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold\">Lavabo Uzunluğu (Genişlik)</td>\r\n<td class=\"py-2\">646 mm</td>\n</tr>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold\">Lavabo Derinliği (Ön-arka)</td>\r\n<td class=\"py-2\">404 mm</td>\n</tr>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold\">Ürün Ağırlığı</td>\r\n<td class=\"py-2\">15,36 kg</td>\n</tr>\r\n<tr>\r\n<td class=\"py-2 font-semibold\">Lavabo İç Şekli</td>\r\n<td class=\"py-2\">Oval / Çanak biçiminde (oval çanak)</td>\n</tr>\n</tbody>\n</table>\r\n<h2 class=\"text-xl font-bold mb-3 border-b pb-2\">Kullanım / Montaj / Diğer Teknik Bilgiler</h2>\r\n<ul class=\"list-disc pl-6\">\r\n<li>Montaj Tipi: Tezgahüstü (çanak lavabo)</li>\r\n<li>Armatür (batarya) deliği: Deliksiz (batarya deliği yok)</li>\r\n<li>Su taşma deliği: Yok</li>\r\n<li>Ayaklı kullanım: Uygun değil</li>\r\n<li>Süzgeç ve sifon: Ürüne dahil değil</li>\n</ul>\n</div>"
  },
  {
    "id": "creavit-9826495660329",
    "brand": "Creavit",
    "title": "Volga 50*70 Tezgah Üstü Lavabo",
    "category": "462596342057",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/volga-50-70-tezgah-ustu-lavabo-7610.jpg?v=1758630396",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/volga-50-70-tezgah-ustu-lavabo-7610.jpg?v=1758630396",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/volga-50-70-tezgah-ustu-lavabo-7611.jpg?v=1758630399"
    ],
    "price": "5310.00",
    "sku": "VX270-00CB00E-0000",
    "tags": [],
    "variants": [
      {
        "id": 52920282251561,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "VX270-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5310.00",
        "grams": 0,
        "compare_at_price": "7080.00",
        "position": 1,
        "product_id": 9826495660329,
        "created_at": "2026-04-03T09:18:31+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<div class=\"product-specs p-4 rounded-lg shadow-md bg-white\">\r\n<h2 class=\"text-xl font-bold mb-3 border-b pb-2\">Ürün Genel Bilgileri</h2>\r\n<ul class=\"list-disc pl-6 mb-4\">\r\n<li>\n<strong>Ürün Adı:</strong> Volga Tezgah Üstü Kare Lavabo 50×70 cm</li>\r\n<li>\n<strong>Marka:</strong> Creavit</li>\r\n<li>\n<strong>Seri:</strong> Volga</li>\r\n<li>\n<strong>Renk:</strong> Beyaz</li>\r\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\r\n<h2 class=\"text-xl font-bold mb-3 border-b pb-2\">Ölçü ve Fiziksel Özellikler</h2>\r\n<table class=\"table-auto border-collapse w-full mb-4\">\r\n<tbody>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold w-1/2\">Genişlik × Yükseklik × Derinlik</td>\r\n<td class=\"py-2\">700 × 152 × 500 mm</td>\n</tr>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold\">Lavabo uzunluğu</td>\r\n<td class=\"py-2\">700 mm</td>\n</tr>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold\">Lavabo genişliği (ön-arka derinlik)</td>\r\n<td class=\"py-2\">500 mm</td>\n</tr>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold\">Ürün ağırlığı</td>\r\n<td class=\"py-2\">20,08 kg</td>\n</tr>\r\n<tr>\r\n<td class=\"py-2 font-semibold\">Lavabo iç şekli</td>\r\n<td class=\"py-2\">Dikdörtgen</td>\n</tr>\n</tbody>\n</table>\r\n<h2 class=\"text-xl font-bold mb-3 border-b pb-2\">Kullanım / Montaj / Diğer Teknik Bilgiler</h2>\r\n<ul class=\"list-disc pl-6 mb-4\">\r\n<li>Montaj Tipi: Tezgahüstü (Lavabo, tezgahın üzerinde yerleştirilecek şekilde)</li>\r\n<li>Su taşma deliği: Var</li>\r\n<li>Ayaklı kullanım: Uygun değil</li>\r\n<li>Süzgeç ve sifon: Dahil değil</li>\n</ul>\r\n<h2 class=\"text-xl font-bold mb-3 border-b pb-2\">Garanti &amp; Servis</h2>\r\n<ul class=\"list-disc pl-6\">\r\n<li>Garanti Süresi: 12 yıl Creavit garantisi</li>\r\n<li>Yetkili servis desteği: Var</li>\r\n<li>Ücretsiz montaj: Yok</li>\n</ul>\n</div>\r\n<p> </p>"
  },
  {
    "id": "creavit-9826493333801",
    "brand": "Creavit",
    "title": "Volga 40*50 Tezgah Üstü Lavabo",
    "category": "462596342057",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/volga-40-50-tezgah-ustu-lavabo-7608.jpg?v=1758629556",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/volga-40-50-tezgah-ustu-lavabo-7608.jpg?v=1758629556",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/volga-40-50-tezgah-ustu-lavabo-7609.jpg?v=1758629558"
    ],
    "price": "3862.50",
    "sku": "VX242-00CB00E-0000",
    "tags": [],
    "variants": [
      {
        "id": 52920265146665,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "VX242-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3862.50",
        "grams": 0,
        "compare_at_price": "5150.00",
        "position": 1,
        "product_id": 9826493333801,
        "created_at": "2026-04-03T09:13:49+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<div class=\"product-specs p-4 rounded-lg shadow-md bg-white\">\r\n<h2 class=\"text-xl font-bold mb-3 border-b pb-2\">Ürün Genel Bilgileri</h2>\r\n<ul class=\"list-disc pl-6 mb-4\">\r\n<li>\n<strong>Ürün Adı:</strong> Volga Tezgah Üstü Kare Lavabo 40×50 cm</li>\r\n<li>\n<strong>Marka:</strong> Creavit</li>\r\n<li>\n<strong>Seri:</strong> Volga</li>\r\n<li>\n<strong>Renk:</strong> Beyaz</li>\r\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\r\n<h2 class=\"text-xl font-bold mb-3 border-b pb-2\">Ölçü ve Fiziksel Özellikler</h2>\r\n<table class=\"table-auto border-collapse w-full mb-4\">\r\n<tbody>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold w-1/2\">Genişlik × Yükseklik × Derinlik</td>\r\n<td class=\"py-2\">500 × 127 × 400 mm</td>\n</tr>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold\">Lavabo uzunluğu</td>\r\n<td class=\"py-2\">500 mm</td>\n</tr>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold\">Lavabo genişliği (ön-arka derinlik)</td>\r\n<td class=\"py-2\">400 mm</td>\n</tr>\r\n<tr class=\"border-b\">\r\n<td class=\"py-2 font-semibold\">Ürün ağırlığı</td>\r\n<td class=\"py-2\">18,6 kg</td>\n</tr>\r\n<tr>\r\n<td class=\"py-2 font-semibold\">Lavabo iç şekli</td>\r\n<td class=\"py-2\">Dörtgen</td>\n</tr>\n</tbody>\n</table>\r\n<h2 class=\"text-xl font-bold mb-3 border-b pb-2\">Kullanım / Montaj / Diğer Teknik Bilgiler</h2>\r\n<ul class=\"list-disc pl-6 mb-4\">\r\n<li>Montaj Tipi: Tezgahüstü (Lavabo, tezgahın üzerinde yerleştirilecek şekilde)</li>\r\n<li>Su taşma deliği: Var</li>\r\n<li>Ayaklı kullanım: Uygun değil</li>\r\n<li>Süzgeç ve sifon: Dahil değil</li>\n</ul>\r\n<h2 class=\"text-xl font-bold mb-3 border-b pb-2\">Garanti &amp; Servis</h2>\r\n<ul class=\"list-disc pl-6\">\r\n<li>Garanti Süresi: 10 yıl Creavit garantisi</li>\r\n<li>Yetkili servis desteği: Var</li>\r\n<li>Ücretsiz montaj: Yok</li>\n</ul>\n</div>"
  },
  {
    "id": "creavit-9826380972329",
    "brand": "Creavit",
    "title": "Mare Rim-Off Asma Klozet v Duroplast Kapak Set",
    "category": "462592246057",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mare-rim-off-asma-klozet-v-duroplast-kapak-set-7605.jpg?v=1758609596",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mare-rim-off-asma-klozet-v-duroplast-kapak-set-7605.jpg?v=1758609596",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mare-rim-off-asma-klozet-v-duroplast-kapak-set-7606.jpg?v=1758609599",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mare-rim-off-asma-klozet-v-duroplast-kapak-set-7607.jpg?v=1758609601"
    ],
    "price": "11955.60",
    "sku": "SET.MA321DP.BYZ",
    "tags": [],
    "variants": [
      {
        "id": 52921476677929,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.MA321DP.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "11955.60",
        "grams": 0,
        "compare_at_price": "22140.00",
        "position": 1,
        "product_id": 9826380972329,
        "created_at": "2026-04-03T14:42:42+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h2>Creavit Mare Rim-Off Kanalsız Asma Klozet - Beyaz</h2>\r\n<p><strong>Ürün Kodu:</strong> MA321-00CB00E-0000</p>\r\n<p><strong>Seri:</strong> Mare</p>\r\n<p><strong>Renk: </strong>Beyaz</p>\r\n<p><strong>Ölçüler:</strong> 360 x 360 x 520 mm</p>\r\n<p><strong>Tasarım:</strong> Oval dış hatlara sahip, modern ve estetik görünüm</p>\r\n<p><strong>Montaj Tipi:</strong> Duvara asma (asma klozet)</p>\r\n<p><strong>Pis Su Çıkışı:</strong> Duvardan</p>\r\n<p><strong>Taharet Borusu:</strong> Var</p>\r\n<p><strong>Klozet Kapağı:</strong> Dahildir; KC3103.01.2000E</p>\r\n<p><strong>Garanti Süresi:</strong> 12 Yıl</p>\r\n<p><strong>Üretim Yeri:</strong> Türkiye</p>\r\n<h3>Rim-Off Teknolojisi</h3>\r\n<p>Kanalsız iç yapısı sayesinde bakterilerin ve kirlerin birikmesini önler. Bu sayede temizlik daha kolay ve hijyenik hale gelir.</p>\r\n<h4>Not:</h4>\r\n<p>Ürünün düzgün çalışabilmesi için uyumlu bir gömme rezervuar gereklidir. Gömme rezervuar ürüne dahil değildir ve ayrıca sipariş edilmelidir.</p>"
  },
  {
    "id": "creavit-9822331633961",
    "brand": "Creavit",
    "title": "Trend Asma Klozet ve Kapak Set",
    "category": "462592246057",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/trend-asma-klozet-ve-kapak-set-7602.jpg?v=1758114897",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/trend-asma-klozet-ve-kapak-set-7602.jpg?v=1758114897",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/trend-asma-klozet-ve-kapak-set-7604.jpg?v=1758114899"
    ],
    "price": "6650.00",
    "sku": "SET.TP324DP.BYZ",
    "tags": [],
    "variants": [
      {
        "id": 52921476383017,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.TP324DP.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "6650.00",
        "grams": 0,
        "compare_at_price": "9500.00",
        "position": 1,
        "product_id": 9822331633961,
        "created_at": "2026-04-03T14:42:39+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h3>TP324-00CB00E-0000 Asma Klozet – Beyaz (Trend Serisi)</h3>\r\n<p><strong>Creavit Trend</strong> serisinin bu beyaz asma klozeti, kompakt alanlara modern bir dokunuş kazandırmak için tasarlanmıştır. Estetik ve işlevselliği bir arada sunar.</p>\r\n<h3>Teknik Özellikler:</h3>\r\n<ul>\r\n<li>\n<strong>Ürün Kodu:</strong> TP324-00CB00E-0000</li>\r\n<li>\n<strong>Seri:</strong> Trend</li>\r\n<li>\n<strong>Renk:</strong> Beyaz</li>\r\n<li>\n<strong>Boyutlar:</strong> 355 mm (Genişlik) x 344 mm (Yükseklik) x 551 mm (Derinlik)</li>\r\n<li>\n<strong>Montaj Tipi:</strong> Duvara asma</li>\r\n<li>\n<strong>Pis Su Çıkışı:</strong> Duvardan</li>\r\n<li>\n<strong>Yıkama Sistemi:</strong> Kanallı</li>\r\n<li>\n<strong>Taharet Borusu:</strong> Dahildir</li>\r\n<li>\n<strong>Klozet Kapağı:</strong> Dahildir (KC2303.01.0000E – Trend Duroplast Yavaş Kapanan Beyaz Klozet Kapağı)</li>\r\n<li>\n<strong>Ürün Ağırlığı:</strong> 30,6 kg</li>\r\n<li>\n<strong>Garanti Süresi:</strong> 12 yıl</li>\n</ul>\r\n<h3>Avantajları:</h3>\r\n<ul>\r\n<li>\n<strong>Kompakt ve Zarif Tasarım:</strong> Küçük banyolar için ideal boyutlarda sade ve modern bir görünüm sunar.</li>\r\n<li>\n<strong>Kolay Temizlik:</strong> Asma tasarımı sayesinde klozet altı alan kolayca temizlenebilir.</li>\r\n<li>\n<strong>Su Tasarrufu:</strong> 3-6 litre arasında su tüketimi ile çevre dostu bir kullanım sunar.</li>\n</ul>\r\n<p><strong>Not:</strong> Ürünün düzgün çalışabilmesi için uyumlu bir <strong>gömme rezervuar</strong> gereklidir. Gömme rezervuar ürünle birlikte gelmez ve ayrıca sipariş edilmelidir.</p>\r\n<p><em>Creavit Trend Asma Klozet, yüksek kaliteli seramik malzemesi ve kullanıcı dostu detaylarıyla uzun ömürlü bir deneyim sağlar.</em></p>"
  },
  {
    "id": "creavit-9822327996713",
    "brand": "Creavit",
    "title": "D20 100 cm Melamin Aynalı Dolap Gri",
    "category": "462591525161",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-melamin-aynali-dolap-gri-5678.jpg?v=1758113907",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-melamin-aynali-dolap-gri-5678.jpg?v=1758113907",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-melamin-aynali-dolap-gri-5679.jpg?v=1758113909",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-melamin-aynali-dolap-gri-5680.jpg?v=1758113911",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-melamin-aynali-dolap-gri-5681.jpg?v=1758113914"
    ],
    "price": "9652.50",
    "sku": "D20.AD100.ML.GRI",
    "tags": [],
    "variants": [
      {
        "id": 52843237572905,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D20.AD100.ML.GRI",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9652.50",
        "grams": 0,
        "compare_at_price": "12870.00",
        "position": 1,
        "product_id": 9822327996713,
        "created_at": "2026-03-17T13:02:39+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-9822326423849",
    "brand": "Creavit",
    "title": "D20 80cm Melamin Aynalı Dolap Gri",
    "category": "462591525161",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80cm-melamin-aynali-dolap-gri-5672_89589d76-ba1e-4bec-8c02-7cd24da9c98c.jpg?v=1758113556",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80cm-melamin-aynali-dolap-gri-5672_89589d76-ba1e-4bec-8c02-7cd24da9c98c.jpg?v=1758113556",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80cm-melamin-aynali-dolap-gri-5673_b5c2baed-6e78-428f-acd3-a9fb3d8108d6.jpg?v=1758113559",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80cm-melamin-aynali-dolap-gri-5674_4b083470-8452-405c-bd38-5f4fec919a9e.jpg?v=1758113561",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80cm-melamin-aynali-dolap-gri-5675_0cb93d92-ad84-456e-bbe4-8e19b46f6276.jpg?v=1758113564"
    ],
    "price": "8332.50",
    "sku": "D20.AD080.ML.GRI",
    "tags": [],
    "variants": [
      {
        "id": 52921485558057,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D20.AD080.ML.GRI",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8332.50",
        "grams": 0,
        "compare_at_price": "11110.00",
        "position": 1,
        "product_id": 9822326423849,
        "created_at": "2026-04-03T14:44:46+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<div class=\"page\" title=\"Page 177\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>İçinde Sen Varsın</strong></p>\n<div class=\"page\" title=\"Page 177\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><span>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</span></p>\n<div class=\"page\" title=\"Page 177\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Saklama Alanını Belirle </strong></p>\n<p><span>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek saklama alanını genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</span></p>\n<div class=\"page\" title=\"Page 177\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Renkleri Deneyimle </strong></p>\n<p><span>D10’un renklerini kendi zevklerine göre kombinleyerek banyonda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için </span><span>banyo bu tarafta.</span></p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9822324326697",
    "brand": "Creavit",
    "title": "D20 60cm Melamin Aynalı Dolap Gri",
    "category": "462591525161",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-60cm-melamin-aynali-dolap-gri-5664_d3ab801f-518f-4149-a78e-80b5235ba56a.jpg?v=1758113280",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-60cm-melamin-aynali-dolap-gri-5664_d3ab801f-518f-4149-a78e-80b5235ba56a.jpg?v=1758113280",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-60cm-melamin-aynali-dolap-gri-5665_d31096f2-a6e8-4e44-bd57-9d1eae5c93cf.jpg?v=1758113282",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-60cm-melamin-aynali-dolap-gri-5666_499baa7e-07c4-4506-904b-542d731cf924.jpg?v=1758113285",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-60cm-melamin-aynali-dolap-gri-5667_dcf013d1-ea7f-4989-b641-4597ad25482c.jpg?v=1758113287"
    ],
    "price": "6847.50",
    "sku": "D20.AD060.ML.GRI",
    "tags": [],
    "variants": [
      {
        "id": 52843193237801,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D20.AD060.ML.GRI",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6847.50",
        "grams": 0,
        "compare_at_price": "9130.00",
        "position": 1,
        "product_id": 9822324326697,
        "created_at": "2026-03-17T12:48:32+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8975782871337",
    "brand": "Creavit",
    "title": "D20 65cm Kapaklı Lavabo Dolabı Gri Melamin Kapak (Demonte)",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65cm-kapakli-lavabo-dolabi-gri-melamin-kapak-demonte-6112.jpg?v=1747238890",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65cm-kapakli-lavabo-dolabi-gri-melamin-kapak-demonte-6112.jpg?v=1747238890",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65cm-kapakli-lavabo-dolabi-gri-melamin-kapak-demonte-6113.jpg?v=1747238892",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65cm-kapakli-lavabo-dolabi-gri-melamin-kapak-demonte-6114.jpg?v=1747238895",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65cm-kapakli-lavabo-dolabi-gri-melamin-kapak-demonte-6115.jpg?v=1747238897"
    ],
    "price": "10147.50",
    "sku": "D.D20.LD065.KPK.ML.GRI",
    "tags": [
      "%10 indirim Yaz",
      "Antrasit",
      "Banyo Mobilyası",
      "D10",
      "D20",
      "Gri",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843195269417,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD065.KPK.ML.GRI",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "10147.50",
        "grams": 0,
        "compare_at_price": "13530.00",
        "position": 1,
        "product_id": 8975782871337,
        "created_at": "2026-03-17T12:49:20+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<div class=\"page\" title=\"Page 177\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>İçinde Sen Varsın</strong></p>\n<div class=\"page\" title=\"Page 177\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><span>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</span></p>\n<div class=\"page\" title=\"Page 177\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Saklama Alanını Belirle </strong></p>\n<p><span>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek saklama alanını genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</span></p>\n<div class=\"page\" title=\"Page 177\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Renkleri Deneyimle </strong></p>\n<p><span>D10’un renklerini kendi zevklerine göre kombinleyerek banyonda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için </span><span>banyo bu tarafta.</span></p>\n<div class=\"page\" title=\"Page 178\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Senin Lavab’ON </strong></p>\n<p><span>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş banyo deneyimi bu tarafta. </span></p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8973433209129",
    "brand": "Creavit",
    "title": "D20 100cm Kapaklı Lavabo Dolabı Gri (Demonte)",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100cm-kapakli-lavabo-dolabi-gri-demonte-5766.jpg?v=1747227242",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100cm-kapakli-lavabo-dolabi-gri-demonte-5766.jpg?v=1747227242",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100cm-kapakli-lavabo-dolabi-gri-demonte-5767.jpg?v=1747227245",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100cm-kapakli-lavabo-dolabi-gri-demonte-5768.jpg?v=1747227247",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100cm-kapakli-lavabo-dolabi-gri-demonte-5769.jpg?v=1747227251"
    ],
    "price": "12045.00",
    "sku": "D.D20.LD100.KPK.ML.GRI",
    "tags": [
      "%10 indirim Yaz",
      "Antrasit",
      "Banyo Mobilyası",
      "D10",
      "D20",
      "Gri",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843194122537,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD100.KPK.ML.GRI",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "12045.00",
        "grams": 0,
        "compare_at_price": "16060.00",
        "position": 1,
        "product_id": 8973433209129,
        "created_at": "2026-03-17T12:48:54+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-9822317150505",
    "brand": "Creavit",
    "title": "Lara Duroplast Yavaş Kapanan Kapaklı Kömür Karası Set",
    "category": "Takım Klozetler",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-duroplast-yavas-kapanan-kapakli-komur-karasi-set-7598.jpg?v=1758112107",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-duroplast-yavas-kapanan-kapakli-komur-karasi-set-7598.jpg?v=1758112107",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-duroplast-yavas-kapanan-kapakli-komur-karasi-set-7599.jpg?v=1758112110",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-duroplast-yavas-kapanan-kapakli-komur-karasi-set-7600.jpg?v=1758112113",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-duroplast-yavas-kapanan-kapakli-komur-karasi-set-7601.png?v=1758112115"
    ],
    "price": "27804.00",
    "sku": "SET.LR360DP.KK",
    "tags": [
      "duvara dayalı klozet",
      "Lara",
      "Takım Klozet",
      "Vitrifiye"
    ],
    "variants": [
      {
        "id": 52922427834665,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.LR360DP.KK",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "27804.00",
        "grams": 0,
        "compare_at_price": "39720.00",
        "position": 1,
        "product_id": 9822317150505,
        "created_at": "2026-04-03T18:28:21+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<p><strong>İkonik Tasarım: </strong>Creavit Nova Klozetler banyo tasarımında yenilikçi ve modern bir yaklaşım isteyenlere özel seçenekler sunuyor. Bu özel tasarımlı klozet serisi beyaz rengi ve zarif hatlarıyla, banyonuza sade ve çağdaş bir dokunuş eklerken, aynı zamanda işlevselliğiyle de dikkat çekiyor.</p>\r\n<p data-mce-fragment=\"1\"><span style=\"FONT-FAMILY: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif\"><strong>Bakterilere Yer Bırakmayan Tasarım: </strong>Nova Rim-Off Klozetler, kanalsız tasarımları sayesinde klozet içerisinde temizlik esnasında ulaşılması güç yüzeyleri minimize eder. İç haznede erişilemeyen yüzey olmadığı için bakteri ve türevleri için elverişli ortam oluşmasına engel olur.</span></p>\r\n<p data-mce-fragment=\"1\"><span style=\"FONT-FAMILY: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif\"><strong>Temizlikte Kolaylık: </strong>Creavit sırlama teknolojisi sayesinde klozet üzerinde kireç ve su lekeleri gibi istenmeyen izlerin oluşması engellenir. Banyo temizliğini kolaylaştırırken hijyen seviyelerini de korur.</span></p><!---->"
  },
  {
    "id": "creavit-9822310039849",
    "brand": "Creavit",
    "title": "Free Kömür Karası Asma Klozet ve Kapak Set",
    "category": "462592246057",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-komur-karasi-asma-klozet-ve-kapak-set-7590.jpg?v=1758110162",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-komur-karasi-asma-klozet-ve-kapak-set-7590.jpg?v=1758110162",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-komur-karasi-asma-klozet-ve-kapak-set-7591.jpg?v=1758110165",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-komur-karasi-asma-klozet-ve-kapak-set-7592.jpg?v=1758110167"
    ],
    "price": "20664.00",
    "sku": "SET.FE320DP.KK",
    "tags": [],
    "variants": [
      {
        "id": 52843173675305,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.FE320DP.KK",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "20664.00",
        "grams": 0,
        "compare_at_price": "29520.00",
        "position": 1,
        "product_id": 9822310039849,
        "created_at": "2026-03-17T12:42:54+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<ul>\r\n<li>\n<strong>Ürün Kodu:</strong> FE320-00KK00E-0000</li>\r\n<li>\n<strong>Seri:</strong> Free</li>\r\n<li>\n<strong>Renk:</strong> Kömür Karası</li>\r\n<li>\n<strong>Boyutlar:</strong> 355 mm (Genişlik) x 350 mm (Yükseklik) x 510 mm (Derinlik)</li>\r\n<li>\n<strong>Montaj Tipi:</strong> Duvara asma (gizli montaj)</li>\r\n<li>\n<strong>Pis Su Çıkışı:</strong> Duvardan</li>\r\n<li>\n<strong>Yıkama Sistemi:</strong> Kanallı</li>\r\n<li>\n<strong>Taharet Borusu:</strong> Dahildir; sadece gizli bağlantı yapılabilir, yandan bağlantı yapılamaz</li>\r\n<li>\n<strong>Klozet Kapağı:</strong> Dahildir; KC0903.01.2100E (Duck Duroplast Yavaş Kapanan Kömür Karası Klozet Kapağı)</li>\r\n<li>\n<strong>Garanti Süresi:</strong> 12 Yıl</li>\r\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\r\n<h4>Öne Çıkan Özellikler</h4>\r\n<ul>\r\n<li>\n<strong>Yuvarlak Hatlı Tasarım:</strong> Modern banyolar için estetik ve şık bir görünüm sunar.</li>\r\n<li>\n<strong>Kolay Temizlik:</strong> Pürüzsüz yüzeyi ve asma tasarımı sayesinde klozet altı alanı kolayca temizlenebilir.</li>\r\n<li>\n<strong>Su Tasarrufu:</strong> 3-6 litre arasında su tüketimi ile çevre dostu bir kullanım sağlar.</li>\r\n<li>\n<strong>Mat Siyah Yüzey:</strong> Sofistike ve modern bir banyo atmosferi yaratır.</li>\n</ul>\r\n<p><strong>Not:</strong> Montaj kiti (gizli montaj seti) ürünle birlikte sunulmaktadır.</p>\r\n<p><strong>Uyarı:</strong> Ürünün düzgün çalışabilmesi için uyumlu bir gömme rezervuar gereklidir. Gömme rezervuar ürüne dahil değildir ve ayrıca sipariş edilmelidir.</p>\r\n<p><strong>Creavit Free Asma Klozet</strong>, modern tasarımı ve kullanıcı dostu özellikleriyle banyonuza değer katacak bir üründür. Yüksek kaliteli malzemesiyle uzun ömürlü bir kullanım deneyimi sunar.</p>"
  },
  {
    "id": "creavit-9817390317865",
    "brand": "Creavit",
    "title": "D10 30cm SOL Boy Dolabı Melamin Gri Gövde Melamin Antrasit Kapak",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/D10.BD030.ML.GRI.ML.ANT.jpg?v=1757663398",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/D10.BD030.ML.GRI.ML.ANT.jpg?v=1757663398",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/BOY-DOLAP-OLCU-ORTAK.jpg?v=1757663398",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/D10.BD030-MELAMIN-KAPAK-RENKLER.jpg?v=1757663385"
    ],
    "price": "5896.00",
    "sku": "D10.BD030.SOL.M.M.0305",
    "tags": [
      "D10"
    ],
    "variants": [
      {
        "id": 52843075567913,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.BD030.SOL.M.M.0305",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5896.00",
        "grams": 0,
        "compare_at_price": "7370.00",
        "position": 1,
        "product_id": 9817390317865,
        "created_at": "2026-03-17T11:53:47+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-9817382813993",
    "brand": "Creavit",
    "title": "D10 30cm SOL Boy Dolabı Melamin Dafne Gövde Melamin Meşe Kapak",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D10-boy-dolabi-banyo-mobilyasi-D10.BD030.ML.DAF.ML.MSE.webp?v=1757662415",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D10-boy-dolabi-banyo-mobilyasi-D10.BD030.ML.DAF.ML.MSE.webp?v=1757662415"
    ],
    "price": "5896.00",
    "sku": "D10.BD030.SOL.M.M.0204",
    "tags": [
      "D10"
    ],
    "variants": [
      {
        "id": 52843085529385,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.BD030.SOL.M.M.0204",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5896.00",
        "grams": 0,
        "compare_at_price": "7370.00",
        "position": 1,
        "product_id": 9817382813993,
        "created_at": "2026-03-17T11:57:34+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-9817377767721",
    "brand": "Creavit",
    "title": "D10 30cm SOL Boy Dolabı Melamin Beyaz Gövde Melamin Beyaz Kapak",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D10-boy-dolabi-banyo-mobilyasi-D10.BD030.ML.BYZ.ML.BYZ.webp?v=1757662260",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D10-boy-dolabi-banyo-mobilyasi-D10.BD030.ML.BYZ.ML.BYZ.webp?v=1757662260"
    ],
    "price": "5896.00",
    "sku": "D10.BD030.SOL.M.M.0101",
    "tags": [
      "D10"
    ],
    "variants": [
      {
        "id": 52843085431081,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.BD030.SOL.M.M.0101",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5896.00",
        "grams": 0,
        "compare_at_price": "7370.00",
        "position": 1,
        "product_id": 9817377767721,
        "created_at": "2026-03-17T11:57:31+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": ""
  },
  {
    "id": "creavit-9817367380265",
    "brand": "Creavit",
    "title": "D10 30 cm SOL Boy Dolabı Melamin Dafne Gövde Lake Dafne Kapak",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30cm-sag-boy-dolabi-cizgili-dafne-lake-kapak-demonte-5440.webp?v=1757661801",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30cm-sag-boy-dolabi-cizgili-dafne-lake-kapak-demonte-5440.webp?v=1757661801",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30cm-sag-boy-dolabi-cizgili-dafne-lake-kapak-demonte-5441.webp?v=1757661854",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30cm-sag-boy-dolabi-cizgili-dafne-lake-kapak-demonte-5442.webp?v=1757661855",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30cm-sag-boy-dolabi-cizgili-dafne-lake-kapak-demonte-5444.webp?v=1757661855"
    ],
    "price": "8008.00",
    "sku": "D10.BD030.SOL.M.L.0202",
    "tags": [
      "D10"
    ],
    "variants": [
      {
        "id": 52921491718441,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.BD030.SOL.M.L.0202",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8008.00",
        "grams": 0,
        "compare_at_price": "10010.00",
        "position": 1,
        "product_id": 9817367380265,
        "created_at": "2026-04-03T14:46:06+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8967722697001",
    "brand": "Creavit",
    "title": "D10 30cm SAĞ Boy Dolabı Melamin Dafne Gövde Melamin Meşe Kapak",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D10-boy-dolabi-banyo-mobilyasi-D10.BD030.ML.DAF.ML.MSE.jpg?v=1743147668",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D10-boy-dolabi-banyo-mobilyasi-D10.BD030.ML.DAF.ML.MSE.jpg?v=1743147668"
    ],
    "price": "5896.00",
    "sku": "D10.BD030.SAG.M.M.0204",
    "tags": [
      "D10"
    ],
    "variants": [
      {
        "id": 52843075469609,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.BD030.SAG.M.M.0204",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5896.00",
        "grams": 0,
        "compare_at_price": "7370.00",
        "position": 1,
        "product_id": 8967722697001,
        "created_at": "2026-03-17T11:53:44+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8967717978409",
    "brand": "Creavit",
    "title": "D10 30cm SAĞ Boy Dolabı Melamin Beyaz Gövde Melamin Beyaz Kapak",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D10-boy-dolabi-banyo-mobilyasi-D10.BD030.ML.BYZ.ML.BYZ.jpg?v=1743147670",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D10-boy-dolabi-banyo-mobilyasi-D10.BD030.ML.BYZ.ML.BYZ.jpg?v=1743147670"
    ],
    "price": "5896.00",
    "sku": "D10.BD030.SAG.M.M.0101",
    "tags": [
      "D10"
    ],
    "variants": [
      {
        "id": 52920978997545,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.BD030.SAG.M.M.0101",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5896.00",
        "grams": 0,
        "compare_at_price": "7370.00",
        "position": 1,
        "product_id": 8967717978409,
        "created_at": "2026-04-03T12:18:23+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8970506535209",
    "brand": "Creavit",
    "title": "D10 100 cm Melamin Aynalı Dolap Dafne",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-100cm-aynali-dolap-banyo-mobilyasi-D10.AD100.ML.DAF.jpg?v=1743147661",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-100cm-aynali-dolap-banyo-mobilyasi-D10.AD100.ML.DAF.jpg?v=1743147661"
    ],
    "price": "5896.00",
    "sku": "D10.AD100.ML.DAF",
    "tags": [
      "%10 indirim Yaz",
      "Ayna",
      "Aynalı Dolap",
      "Banyo Mobilyası",
      "D10",
      "D20",
      "Dafne",
      "Melamin",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52895192908073,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.AD100.ML.DAF",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5896.00",
        "grams": 0,
        "compare_at_price": "7370.00",
        "position": 1,
        "product_id": 8970506535209,
        "created_at": "2026-03-29T15:30:55+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-9813930410281",
    "brand": "Creavit",
    "title": "Trend Duroplast Yavaş Kapanan Beyaz Klozet Kapağı",
    "category": "Duroplast Klozet Kapakları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/trend-duroplast-yavas-kapanan-beyaz-klozet-kapagi-7579.jpg?v=1757314652",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/trend-duroplast-yavas-kapanan-beyaz-klozet-kapagi-7579.jpg?v=1757314652"
    ],
    "price": "2520.00",
    "sku": "KC2303.01.0000E",
    "tags": [
      "duroplast",
      "kapak",
      "Kare",
      "klozet kapağı",
      "tak-çıkar",
      "yaz-25-indirim"
    ],
    "variants": [
      {
        "id": 52921492668713,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KC2303.01.0000E",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "2520.00",
        "grams": 0,
        "compare_at_price": "3600.00",
        "position": 1,
        "product_id": 9813930410281,
        "created_at": "2026-04-03T14:46:19+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\">\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\">\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<h4>Creavit Trend Yavaş Kapanan Klozet Kapağı – KC2303.01.0000E</h4>\n<p>Creavit'in <strong>Trend</strong> serisine ait olan <strong>KC2303.01.0000E</strong> kodlu klozet kapağı, modern tasarımı ve dayanıklı yapısıyla banyonuza şıklık katmak için ideal bir tercihtir. <strong>Yavaş kapanma</strong> özelliği sayesinde sessiz ve güvenli bir kullanım sunar. <strong>Duroplast</strong> malzemeden üretilmiştir, bu da ürünü hem dayanıklı hem de hijyenik kılar.</p>\n<h4>Teknik Özellikler</h4>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> KC2303.01.0000E</li>\n<li>\n<strong>Seri:</strong> Trend</li>\n<li>\n<strong>Malzeme:</strong> Duroplast</li>\n<li>\n<strong>Renk:</strong> Beyaz</li>\n<li>\n<strong>Şekil:</strong> Yuvarlak</li>\n<li>\n<strong>Ölçüler:</strong> 357 × 425 mm</li>\n<li>\n<strong>Ağırlık:</strong> 2,85 kg</li>\n<li>\n<strong>Yavaş Kapanma:</strong> Evet</li>\n<li>\n<strong>Amortisör:</strong> Mevcut</li>\n<li>\n<strong>Montaj:</strong> Üstten sıkmalı, tak-çıkar özelliği ile kolay montaj</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit TP324 serisi klozetle uyumludur</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\n<h4>Ürün Açıklaması</h4>\n<p>Bu klozet kapağı, <strong>yavaş kapanma özelliği</strong> sayesinde sessiz bir kullanım sağlar ve klozete zarar vermeden kapanır. <strong>Duroplast</strong> malzemesi sayesinde uzun ömürlüdür ve kolay temizlenebilir. Üstten sıkmalı montaj sistemi sayesinde kapağın kurulumu pratik olup, temizlik sırasında çıkarılması da oldukça kolaydır.</p>\n<p><strong>Creavit</strong> <strong>TP324 serisi</strong> klozetle tam uyumludur ve banyonuzda hem estetik hem de işlevsel bir çözüm sunar.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9811013828905",
    "brand": "Creavit",
    "title": "Solo Lavabo Banyo Armatürü ve Duş Seti",
    "category": "Banyo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-lavabo-banyo-armaturu-ve-dus-seti-7575.jpg?v=1757057758",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-lavabo-banyo-armaturu-ve-dus-seti-7575.jpg?v=1757057758",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-lavabo-banyo-armaturu-ve-dus-seti-7576.png?v=1757057761",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-lavabo-banyo-armaturu-ve-dus-seti-7577.png?v=1757057763",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-lavabo-banyo-armaturu-ve-dus-seti-7578.png?v=1757057766"
    ],
    "price": "12600.00",
    "sku": "BTSO1525SH425SET",
    "tags": [
      "Armatür",
      "banyo armatürü",
      "duş setleri",
      "Lavabo Armatürü",
      "Solo"
    ],
    "variants": [
      {
        "id": 52936573518121,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BTSO1525SH425SET",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "12600.00",
        "grams": 0,
        "compare_at_price": "18000.00",
        "position": 1,
        "product_id": 9811013828905,
        "created_at": "2026-04-06T12:22:45+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt\"><b><font face=\"SAPGUI-Icons\">Set İçeriği <?xml:namespace prefix = \"o\" ns = \"urn:schemas-microsoft-com:office:office\" /><o:p></o:p></font></b></p>\r\n<ul style=\"MARGIN-TOP: 0cm\" type=\"disc\">\r\n<li class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt; mso-list: l0 level1 lfo1; tab-stops: list 36.0pt\"><font face=\"SAPGUI-Icons\"><b>BT.SO1500</b> – Solo Lavabo Bataryası<o:p></o:p></font></li>\r\n<li class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt; mso-list: l0 level1 lfo1; tab-stops: list 36.0pt\"><font face=\"SAPGUI-Icons\"><b>BT.SO2500</b> – Solo Banyo Bataryası<o:p></o:p></font></li>\r\n<li class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt; mso-list: l0 level1 lfo1; tab-stops: list 36.0pt\"><font face=\"SAPGUI-Icons\"><b>DS.SH425</b> – Aria 5 Fonksiyonlu El Duşu Seti<o:p></o:p></font></li>\n</ul>\r\n<div class=\"MsoNormal\" style=\"TEXT-ALIGN: center; MARGIN: 0cm 0cm 8pt\" align=\"center\"><font face=\"SAPGUI-Icons\">\r\n<hr align=\"center\" size=\"2\" width=\"100%\">\r\n</font></div>\r\n<p class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt\"><b><font face=\"SAPGUI-Icons\">BT.SO1500 – Solo Lavabo Bataryası<o:p></o:p></font></b></p>\r\n<p class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt\"><font face=\"SAPGUI-Icons\">Creavit'in BT.SO1500 kodlu Solo Lavabo Bataryası, modern tasarımı ve dayanıklı yapısıyla banyolarınıza şıklık katacak bir üründür. Tek kumandalı yapısı sayesinde su sıcaklığı ve debisi kolayca ayarlanabilir.<o:p></o:p></font></p>\r\n<ul style=\"MARGIN-TOP: 0cm\" type=\"disc\">\r\n<li class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt; mso-list: l2 level1 lfo2; tab-stops: list 36.0pt\"><font face=\"SAPGUI-Icons\">Seri: Solo<o:p></o:p></font></li>\r\n<li class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt; mso-list: l2 level1 lfo2; tab-stops: list 36.0pt\"><font face=\"SAPGUI-Icons\">Kullanım Alanı: Lavabo<o:p></o:p></font></li>\r\n<li class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt; mso-list: l2 level1 lfo2; tab-stops: list 36.0pt\"><font face=\"SAPGUI-Icons\">Montaj Tipi: Tezgah üstü (dikey düzlem)<o:p></o:p></font></li>\r\n<li class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt; mso-list: l2 level1 lfo2; tab-stops: list 36.0pt\"><font face=\"SAPGUI-Icons\">Armatür Tipi: Tek kumandalı mix armatür<o:p></o:p></font></li>\r\n<li class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt; mso-list: l2 level1 lfo2; tab-stops: list 36.0pt\"><font face=\"SAPGUI-Icons\">Çıkış Ucu Uzunluğu: 119 Mm<o:p></o:p></font></li>\r\n<li class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt; mso-list: l2 level1 lfo2; tab-stops: list 36.0pt\"><font face=\"SAPGUI-Icons\">Çıkış Ucu Yüksekliği: 115 Mm<o:p></o:p></font></li>\r\n<li class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt; mso-list: l2 level1 lfo2; tab-stops: list 36.0pt\"><font face=\"SAPGUI-Icons\">Kartuş: Uzun ömürlü 35 mm seramik kartuş (ayaklı)<o:p></o:p></font></li>\r\n<li class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt; mso-list: l2 level1 lfo2; tab-stops: list 36.0pt\"><font face=\"SAPGUI-Icons\">Malzeme: %100 pirinç gövde<o:p></o:p></font></li>\r\n<li class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt; mso-list: l2 level1 lfo2; tab-stops: list 36.0pt\"><font face=\"SAPGUI-Icons\">Kaplama: Parlak krom<o:p></o:p></font></li>\r\n<li class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt; mso-list: l2 level1 lfo2; tab-stops: list 36.0pt\"><font face=\"SAPGUI-Icons\">Montaj Aparatları: 3/8\" - M10 - 50 cm fleks hortumlar ve sabitleme aparatları dahil<o:p></o:p></font></li>\r\n<li class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt; mso-list: l2 level1 lfo2; tab-stops: list 36.0pt\"><font face=\"SAPGUI-Icons\">Garanti Süresi: 5 yıl<o:p></o:p></font></li>\n</ul>\r\n<div class=\"MsoNormal\" style=\"TEXT-ALIGN: center; MARGIN: 0cm 0cm 8pt\" align=\"center\"><font face=\"SAPGUI-Icons\">\r\n<hr align=\"center\" size=\"2\" width=\"100%\">\r\n</font></div>\r\n<p class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt\"><b><font face=\"SAPGUI-Icons\">DS.SH425 – Aria 5 Fonksiyonlu El Duşu Seti<o:p></o:p></font></b></p>\r\n<p class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt\"><font face=\"SAPGUI-Icons\">Creavit'in DS.SH425 kodlu Aria 5 Fonksiyonlu El Duşu Seti, beş farklı su akış modu ve ayarlanabilir yükseklik imkânı ile kişiselleştirilmiş duş keyfi sunar. Yuvarlak duş başlığı ve şık krom kaplamasıyla banyoya modern bir görünüm kazandırır..<o:p></o:p></font></p>\r\n<ul style=\"MARGIN-TOP: 0cm\" type=\"disc\">\r\n<li class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt; mso-list: l1 level1 lfo3; tab-stops: list 36.0pt\"><font face=\"SAPGUI-Icons\">Ürün Kodu: DS.SH425<o:p></o:p></font></li>\r\n<li class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt; mso-list: l1 level1 lfo3; tab-stops: list 36.0pt\"><font face=\"SAPGUI-Icons\">Model Adı: Aria 5 Fonksiyonlu El Duşu Seti<o:p></o:p></font></li>\r\n<li class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt; mso-list: l1 level1 lfo3; tab-stops: list 36.0pt\"><font face=\"SAPGUI-Icons\">Duş Hortumu Uzunluğu: 1500 mm<o:p></o:p></font></li>\r\n<li class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt; mso-list: l1 level1 lfo3; tab-stops: list 36.0pt\"><font face=\"SAPGUI-Icons\">Fonksiyon Sayısı: 5 farklı su akış modu<o:p></o:p></font></li>\r\n<li class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt; mso-list: l1 level1 lfo3; tab-stops: list 36.0pt\"><font face=\"SAPGUI-Icons\">Duş Başlığı Şekli: Yuvarlak<o:p></o:p></font></li>\r\n<li class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt; mso-list: l1 level1 lfo3; tab-stops: list 36.0pt\"><font face=\"SAPGUI-Icons\">Kurulum Türü: Duvara Montaj<o:p></o:p></font></li>\r\n<li class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt; mso-list: l1 level1 lfo3; tab-stops: list 36.0pt\"><font face=\"SAPGUI-Icons\">Kaplama: Parlak Krom <o:p></o:p></font></li>\r\n<li class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt; mso-list: l1 level1 lfo3; tab-stops: list 36.0pt\"><font face=\"SAPGUI-Icons\">El Duşu ve Hortumu: Dahil<o:p></o:p></font></li>\r\n<li class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt; mso-list: l1 level1 lfo3; tab-stops: list 36.0pt\"><font face=\"SAPGUI-Icons\">Garanti Süresi: 2 yıl<o:p></o:p></font></li>\n</ul>\r\n<p class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt\"><o:p><font face=\"SAPGUI-Icons\"> </font></o:p></p>"
  },
  {
    "id": "creavit-9811009208617",
    "brand": "Creavit",
    "title": "Solo Lavabo Banyo Mutfak Armatürü Set",
    "category": "Banyo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-lavabo-banyo-mutfak-armaturu-set-7571.jpg?v=1757057657",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-lavabo-banyo-mutfak-armaturu-set-7571.jpg?v=1757057657",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-lavabo-banyo-mutfak-armaturu-set-7572.png?v=1757057659",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-lavabo-banyo-mutfak-armaturu-set-7573.png?v=1757057662",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-lavabo-banyo-mutfak-armaturu-set-7574.png?v=1757057664"
    ],
    "price": "14328.00",
    "sku": "BTSO15258500SET",
    "tags": [
      "Armatür",
      "banyo armatürü",
      "Lavabo Armatürü",
      "Mutfak Armatürü",
      "Solo"
    ],
    "variants": [
      {
        "id": 52936576074025,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BTSO15258500SET",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "14328.00",
        "grams": 0,
        "compare_at_price": "20340.00",
        "position": 1,
        "product_id": 9811009208617,
        "created_at": "2026-04-06T12:23:35+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h3>Ürüne Dahil Olan Bataryalar </h3>\r\n<ul>\r\n<li>\n<strong>BT.SO1500</strong> – Solo Lavabo Bataryası</li>\r\n<li>\n<strong>BT.SO2500</strong> – Solo Banyo Bataryası</li>\r\n<li>\n<strong>BT.SO8500</strong> – Solo Mutfak Bataryası</li>\n</ul>\r\n<hr>\r\n\r\n<h4>BT.SO1500 – Solo Lavabo Bataryası</h4>\r\n<p>Creavit'in BT.SO1500 kodlu Solo Lavabo Bataryası, modern tasarımı ve dayanıklı yapısıyla banyolarınıza şıklık katacak bir üründür. Tek kumandalı yapısı sayesinde su sıcaklığı ve debisi kolayca ayarlanabilir.</p>\r\n<ul>\r\n<li>Seri: Solo</li>\r\n<li>Kullanım Alanı: Lavabo</li>\r\n<li>Montaj Tipi: Tezgah üstü (dikey düzlem)</li>\r\n<li>Armatür Tipi: Tek kumandalı mix armatür</li>\r\n<li>Çıkış Ucu Uzunluğu: 119 Mm</li>\r\n<li>Çıkış Ucu Yüksekliği: 115 Mm</li>\r\n<li>Kartuş: Uzun ömürlü 35 mm seramik kartuş (ayaklı)</li>\r\n<li>Malzeme: %100 pirinç gövde</li>\r\n<li>Kaplama: Parlak krom</li>\r\n<li>Montaj Aparatları: 3/8\" - M10 - 50 cm fleks hortumlar ve sabitleme aparatları dahil</li>\r\n<li>Garanti Süresi: 5 yıl</li>\n</ul>\r\n<hr>\r\n\r\n<h4>BT.SO2500 – Solo Banyo Bataryası</h4>\r\n<p>Creavit'in BT.SO2500 kodlu Solo Banyo Bataryası, modern tasarımı ve dayanıklı yapısıyla banyolarınıza şıklık katacak bir üründür. Tek kumandalı yapısı sayesinde su sıcaklığı ve debisi kolayca ayarlanabilir.</p>\r\n<ul>\r\n<li>Seri: Solo</li>\r\n<li>Kullanım Alanı: Banyo</li>\r\n<li>Montaj Tipi: Duvar montajı (standart)</li>\r\n<li>Armatür Tipi: Tek Kumandalı Mix Armatür</li>\r\n<li>Açma/Kapama Mekanizması: Tek kumandalı</li>\r\n<li>Kartuş: Uzun Ömürlü 35 mm Seramik Kartuş</li>\r\n<li>Su Giriş Sayısı: 2 giriş</li>\r\n<li>Bağlantı Deliği: 2 delikli</li>\r\n<li>Çıkış Ucu Uzunluğu: 157 Mm</li>\r\n<li>Yönlendirici: Kilitlemeli yönlendirici</li>\r\n<li>Malzeme: Pirinç gövde</li>\r\n<li>Kaplama: Krom</li>\r\n<li>Garanti Süresi: 5 yıl</li>\n</ul>\r\n<hr>\r\n\r\n<h4>BT.SO8500 – Solo Mutfak Bataryası</h4>\r\n<p>Creavit'in BT.SO8500 kodlu Solo Mutfak Bataryası, modern tasarımı ve fonksiyonelliğiyle mutfağınıza şıklık katacak bir üründür. Yüksek çıkış ucu ve döner boru özelliği sayesinde kullanım kolaylığı sağlar.</p>\r\n<ul>\r\n<li>Seri: Solo</li>\r\n<li>Kullanım Alanı: Mutfak</li>\r\n<li>Montaj Tipi: Tezgah üstü (dikey düzlem)</li>\r\n<li>Armatür Tipi: Tek Kumandalı Mix Armatür</li>\r\n<li>Çıkış Ucu Uzunluğu: 161 Mm</li>\r\n<li>Çıkış Ucu Yüksekliği: 250 Mm</li>\r\n<li>Kartuş: Uzun ömürlü 35 mm seramik kartuş </li>\r\n<li>Perlatör: Sessiz su akışı sağlayan, kireç temizleme sistemli</li>\r\n<li>Döner Boru: 360° dönebilen</li>\r\n<li>Su Giriş Sayısı: 2 giriş (sıcak-soğuk)</li>\r\n<li>Malzeme: Pirinç gövde</li>\r\n<li>Kaplama: Parlak krom</li>\r\n<li>Garanti Süresi: 5 yıl</li>\n</ul>"
  },
  {
    "id": "creavit-9811005473065",
    "brand": "Creavit",
    "title": "Luna Lavabo Banyo Armatürü ve Duş Seti",
    "category": "Termostatik Banyo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/luna-lavabo-banyo-armaturu-ve-dus-seti-7567.jpg?v=1757057569",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/luna-lavabo-banyo-armaturu-ve-dus-seti-7567.jpg?v=1757057569",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/luna-lavabo-banyo-armaturu-ve-dus-seti-7568.png?v=1757057572",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/luna-lavabo-banyo-armaturu-ve-dus-seti-7569.png?v=1757057574",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/luna-lavabo-banyo-armaturu-ve-dus-seti-7570.png?v=1757057577"
    ],
    "price": "11088.00",
    "sku": "BTLN1525SH425SET",
    "tags": [
      "banyo armatürü",
      "duş setleri",
      "Lavabo Armatürü",
      "Luna"
    ],
    "variants": [
      {
        "id": 52936572240169,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BTLN1525SH425SET",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11088.00",
        "grams": 0,
        "compare_at_price": "15840.00",
        "position": 1,
        "product_id": 9811005473065,
        "created_at": "2026-04-06T12:21:32+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h3>Set İçeriği </h3>\r\n<ul>\r\n<li>\n<strong>BT.LN1500</strong> – Luna Lavabo Bataryası</li>\r\n<li>\n<strong>BT.LN2500</strong> – Luna Banyo Bataryası</li>\r\n<li>\n<strong>DS.SH425</strong> – Aria 5 Fonksiyonlu El Duşu Seti</li>\n</ul>\r\n<hr>\r\n\r\n<h4>BT.LN1500 – Luna Lavabo Bataryası</h4>\r\n<p>Creavit'in BT.LN1500 kodlu Luna Lavabo Bataryası, modern tasarımı ve dayanıklı yapısıyla banyolarınıza şıklık katacak bir üründür. Tek kumandalı yapısı sayesinde su sıcaklığı ve debisi kolayca ayarlanabilir.</p>\r\n<ul>\r\n<li>Seri: Luna</li>\r\n<li>Kullanım Alanı: Lavabo</li>\r\n<li>Montaj Tipi: Tezgah üstü (dikey düzlem)</li>\r\n<li>Armatür Tipi: Tek kumandalı mix armatür</li>\r\n<li>Çıkış Ucu Uzunluğu: 92 Mm</li>\r\n<li>Çıkış Ucu Yüksekliği: 109 Mm</li>\r\n<li>Kartuş: Uzun ömürlü 35 mm seramik kartuş (ayaklı)</li>\r\n<li>Malzeme: %100 pirinç gövde</li>\r\n<li>Kaplama: Parlak krom</li>\r\n<li>Montaj Aparatları: 3/8\" - M10 - 50 cm fleks hortumlar ve sabitleme aparatları dahil</li>\r\n<li>Garanti Süresi: 5 yıl</li>\n</ul>\r\n<hr>\r\n\r\n<h4>BT.LN2500 – Luna Banyo Bataryası</h4>\r\n<p>Creavit'in BT.LN2500 kodlu Luna Banyo Bataryası, modern tasarımı ve dayanıklı yapısıyla banyolarınıza şıklık katacak bir üründür. Tek kumandalı yapısı sayesinde su sıcaklığı ve debisi kolayca ayarlanabilir.</p>\r\n<ul>\r\n<li>Seri: Luna</li>\r\n<li>Kullanım Alanı: Banyo</li>\r\n<li>Montaj Tipi: Duvar montajı (standart)</li>\r\n<li>Armatür Tipi: Tek Kumandalı Mix Armatür</li>\r\n<li>Açma/Kapama Mekanizması: Tek kumandalı</li>\r\n<li>Kartuş: Uzun Ömürlü 35 mm Seramik Kartuş</li>\r\n<li>Su Giriş Sayısı: 2 giriş</li>\r\n<li>Bağlantı Deliği: 2 delikli</li>\r\n<li>Çıkış Ucu Uzunluğu: 144 mm</li>\r\n<li>Yönlendirici: Kilitlemeli yönlendirici</li>\r\n<li>Malzeme: Pirinç gövde</li>\r\n<li>Kaplama: Krom</li>\r\n<li>Garanti Süresi: 5 yıl</li>\n</ul>\r\n<hr>\r\n\r\n<h4>DS.SH425 – Aria 5 Fonksiyonlu El Duşu Seti</h4>\r\n<p>Creavit'in DS.SH425 kodlu Aria 5 Fonksiyonlu El Duşu Seti, b<span class=\"s6\">eş farklı su akış modu ve ayarlanabilir yükseklik imkânı ile kişiselleştirilmiş duş keyfi sunar. Yuvarlak duş başlığı ve şık krom kaplamasıyla banyoya modern bir görünüm kazandırır.</span>.</p>\r\n<ul>\r\n<li>Ürün Kodu: DS.SH425</li>\r\n<li>Model Adı: Aria 5 Fonksiyonlu El Duşu Seti</li>\r\n<li>Duş Hortumu Uzunluğu: 1500 mm</li>\r\n<li>Fonksiyon Sayısı: 5 farklı su akış modu</li>\r\n<li>Duş Başlığı Şekli: Yuvarlak</li>\r\n<li>Kurulum Türü: Duvara Montaj</li>\r\n<li>Kaplama: Parlak Krom </li>\r\n<li>El Duşu ve Hortumu: Dahil</li>\r\n<li>Garanti Süresi: 2 yıl</li>\n</ul>"
  },
  {
    "id": "creavit-9811002491177",
    "brand": "Creavit",
    "title": "Luna Lavabo Banyo Mutfak Armatürü Set",
    "category": "Banyo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/luna-lavabo-banyo-mutfak-armaturu-set-7563.jpg?v=1757057493",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/luna-lavabo-banyo-mutfak-armaturu-set-7563.jpg?v=1757057493",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/luna-lavabo-banyo-mutfak-armaturu-set-7564.png?v=1757057496",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/luna-lavabo-banyo-mutfak-armaturu-set-7565.png?v=1757057499",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/luna-lavabo-banyo-mutfak-armaturu-set-7566.png?v=1757057502"
    ],
    "price": "12495.00",
    "sku": "BTLN15258500SET",
    "tags": [
      "Armatür",
      "banyo armatürü",
      "Lavabo Armatürü",
      "Luna",
      "Mutfak Armatürü"
    ],
    "variants": [
      {
        "id": 52936568570153,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BTLN15258500SET",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "12495.00",
        "grams": 0,
        "compare_at_price": "17580.00",
        "position": 1,
        "product_id": 9811002491177,
        "created_at": "2026-04-06T12:19:22+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h3>Ürüne Dahil Olan Bataryalar </h3>\r\n<ul>\r\n<li>\n<strong>BT.LN1500</strong> – Luna Lavabo Bataryası</li>\r\n<li>\n<strong>BT.LN2500</strong> – Luna Banyo Bataryası</li>\r\n<li>\n<strong>BT.LN8500</strong> – Luna Mutfak Bataryası</li>\n</ul>\r\n<hr>\r\n\r\n<h4>BT.LN1500 – Luna Lavabo Bataryası</h4>\r\n<p>Creavit'in BT.LN1500 kodlu Luna Lavabo Bataryası, modern tasarımı ve dayanıklı yapısıyla banyolarınıza şıklık katacak bir üründür. Tek kumandalı yapısı sayesinde su sıcaklığı ve debisi kolayca ayarlanabilir.</p>\r\n<ul>\r\n<li>Seri: Luna</li>\r\n<li>Kullanım Alanı: Lavabo</li>\r\n<li>Montaj Tipi: Tezgah üstü (dikey düzlem)</li>\r\n<li>Armatür Tipi: Tek kumandalı mix armatür</li>\r\n<li>Çıkış Ucu Uzunluğu: 92 Mm</li>\r\n<li>Çıkış Ucu Yüksekliği: 109 Mm</li>\r\n<li>Kartuş: Uzun ömürlü 35 mm seramik kartuş (ayaklı)</li>\r\n<li>Malzeme: %100 pirinç gövde</li>\r\n<li>Kaplama: Parlak krom</li>\r\n<li>Montaj Aparatları: 3/8\" - M10 - 50 cm fleks hortumlar ve sabitleme aparatları dahil</li>\r\n<li>Garanti Süresi: 5 yıl</li>\n</ul>\r\n<hr>\r\n\r\n<h4>BT.LN2500 – Luna Banyo Bataryası</h4>\r\n<p>Creavit'in BT.LN2500 kodlu Luna Banyo Bataryası, modern tasarımı ve dayanıklı yapısıyla banyolarınıza şıklık katacak bir üründür. Tek kumandalı yapısı sayesinde su sıcaklığı ve debisi kolayca ayarlanabilir.</p>\r\n<ul>\r\n<li>Seri: Luna</li>\r\n<li>Kullanım Alanı: Banyo</li>\r\n<li>Montaj Tipi: Duvar montajı (standart)</li>\r\n<li>Armatür Tipi: Tek Kumandalı Mix Armatür</li>\r\n<li>Açma/Kapama Mekanizması: Tek kumandalı</li>\r\n<li>Kartuş: Uzun Ömürlü 35 mm Seramik Kartuş</li>\r\n<li>Su Giriş Sayısı: 2 giriş</li>\r\n<li>Bağlantı Deliği: 2 delikli</li>\r\n<li>Çıkış Ucu Uzunluğu: 144 mm</li>\r\n<li>Yönlendirici: Kilitlemeli yönlendirici</li>\r\n<li>Malzeme: Pirinç gövde</li>\r\n<li>Kaplama: Krom</li>\r\n<li>Garanti Süresi: 5 yıl</li>\n</ul>\r\n<hr>\r\n\r\n<h4>BT.LN8500 – Luna Mutfak Bataryası</h4>\r\n<p>Creavit'in BT.LN8500 kodlu Luna Mutfak Bataryası, modern tasarımı ve fonksiyonelliğiyle mutfağınıza şıklık katacak bir üründür. Yüksek çıkış ucu ve döner boru özelliği sayesinde kullanım kolaylığı sağlar.</p>\r\n<ul>\r\n<li>Seri: Luna</li>\r\n<li>Kullanım Alanı: Mutfak</li>\r\n<li>Montaj Tipi: Tezgah üstü (dikey düzlem)</li>\r\n<li>Armatür Tipi: Tek Kumandalı Mix Armatür</li>\r\n<li>Çıkış Ucu Uzunluğu: 204 mm</li>\r\n<li>Çıkış Ucu Yüksekliği: 229 mm</li>\r\n<li>Kartuş: Uzun ömürlü 35 mm seramik kartuş </li>\r\n<li>Perlatör: Sessiz su akışı sağlayan, kireç temizleme sistemli</li>\r\n<li>Döner Boru: 360° dönebilen</li>\r\n<li>Su Giriş Sayısı: 2 giriş (sıcak-soğuk)</li>\r\n<li>Malzeme: Pirinç gövde</li>\r\n<li>Kaplama: Parlak krom</li>\r\n<li>Garanti Süresi: 5 yıl</li>\n</ul>"
  },
  {
    "id": "creavit-9806001078569",
    "brand": "Creavit",
    "title": "Ness Vortex Asma Klozet ve Kapak Seti",
    "category": "Asma Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ness-vortex-asma-klozet-ve-kapak-seti-7550.jpg?v=1756735547",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ness-vortex-asma-klozet-ve-kapak-seti-7550.jpg?v=1756735547",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ness-vortex-asma-klozet-ve-kapak-seti-7551.jpg?v=1756735550",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ness-vortex-asma-klozet-ve-kapak-seti-7552.jpg?v=1756735552",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ness-vortex-asma-klozet-ve-kapak-seti-7553.jpg?v=1756735555",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ness-vortex-asma-klozet-ve-kapak-seti-7554.jpg?v=1756735557",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ness-vortex-asma-klozet-ve-kapak-seti-7562.jpg?v=1756735559"
    ],
    "price": "16212.00",
    "sku": "SET.NS323DP.BYZ",
    "tags": [
      "asma klozet",
      "Beyaz",
      "Ness"
    ],
    "variants": [
      {
        "id": 52843173347625,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.NS323DP.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "16212.00",
        "grams": 0,
        "compare_at_price": "23160.00",
        "position": 1,
        "product_id": 9806001078569,
        "created_at": "2026-03-17T12:42:48+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\"><span style=\"FONT-FAMILY: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif\">Creavit Ar-Ge/ Tasarım ekibi tarafından geliştirilen bu son teknoloji sistem, suyun dairesel hareketiyle klozeti derinlemesine ve su sıçratmadan temizler. Klozetin içinde güçlü bir su döngüsü yaratan sistem uçtan uca mükemmel ve sessiz bir temizlik deneyimi yaşatır. Aynı zamanda kolay bir temizlik sürecine ve su tasarrufuna da sahiptir.</span></div>\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<span style=\"FONT-FAMILY: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif\"></span><br>\n</div>\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\"><strong><span style=\"FONT-FAMILY: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif\">Çok Daha Sessiz</span></strong></div>\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<span style=\"FONT-FAMILY: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif\"></span><br>\n</div>\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\"><span style=\"FONT-FAMILY: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif\">Fonksiyonel özellikleriyle hijyen alışkanlıklarınızı değiştiren Vortex, konfor özellikleriyle de dikkat çekiyor. Geleneksel klozetlere göre %35 daha sessiz bir yapıda çalışan Vortex yıkama teknolojisi ile banyodaki konforunuzu arttırın.</span></div>\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\"><br></div>\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\"><strong><span style=\"FONT-FAMILY: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif\">Yalın Tasarım</span></strong></div>\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<strong><span style=\"FONT-FAMILY: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif\"></span></strong><br>\n</div>\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\"><span style=\"FONT-FAMILY: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif\">Kullanıcı alışkanlıkları dikkate alınarak tasarlanan Vortex sunduğu inovatif yeniliklerin yanı sıra, yalın tasarımı ile banyodaki estetik bütünlüğe uygun bir yapıda yaratıldı. Zamansız tasarım dili ve yenilikçi özellikleriyle Vortex yıkama teknolojisi ile konforlu banyo deneyimi bu tarafta.</span></div>"
  },
  {
    "id": "creavit-9791049793833",
    "brand": "Creavit",
    "title": "Vega Lavabo Banyo Armatürü ve Duş Seti",
    "category": "Duş Setleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vega-lavabo-banyo-armaturu-ve-dus-seti-7542.jpg?v=1755601963",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vega-lavabo-banyo-armaturu-ve-dus-seti-7542.jpg?v=1755601963",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vega-lavabo-banyo-armaturu-ve-dus-seti-7543.jpg?v=1755601966",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vega-lavabo-banyo-armaturu-ve-dus-seti-7544.jpg?v=1755601968",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vega-lavabo-banyo-armaturu-ve-dus-seti-7545.jpg?v=1755601971"
    ],
    "price": "13230.00",
    "sku": "BTVG182840SH425SET",
    "tags": [
      "Armatür",
      "banyo armatürü",
      "duş seti",
      "Lavabo Armatürü",
      "Vega"
    ],
    "variants": [
      {
        "id": 52920507367721,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BTVG182840SH425SET",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "13230.00",
        "grams": 0,
        "compare_at_price": "18900.00",
        "position": 1,
        "product_id": 9791049793833,
        "created_at": "2026-04-03T10:23:18+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<p><strong><span class=\"s6\">Ürün Set İçeriği</span></strong></p>\n<p><span class=\"s6\">Bu ürün setine aşağıdaki <strong>Creavit</strong> batarya ve duş seti modelleri <strong>dahildir</strong>:</span></p>\n<p><span class=\"s6\">• BT.VG1840 – Vega Lavabo Bataryası<br>• BT.VG2840 – Vega Banyo Bataryası<br>• DS.SH425 – Aria 5 Fonksiyonlu Sürgülü El Duşu Seti</span></p>\n<p><strong><span class=\"s6\">BT.VG1840 – Vega Lavabo Bataryası</span></strong></p>\n<p><span class=\"s6\">Modern tasarımı ve dayanıklı yapısıyla banyolara şıklık katacak tek kumandalı lavabo bataryasıdır. Su sıcaklığı ve debisi kolayca ayarlanabilir.</span></p>\n<p><span class=\"s6\"> • Seri: Vega<br>• Kullanım Alanı: Lavabo<br>• Montaj Tipi: Tezgah üstü (dikey düzlem)<br>• Armatür Tipi: Tek kumandalı mix armatür<br>• Çıkış Ucu Uzunluğu: 115,7 mm<br>• Çıkış Ucu Yüksekliği: 92,7 mm<br>• Kartuş: 35 mm seramik kartuş (uzun ömürlü, ayaklı)<br>• Malzeme: %100 pirinç gövde<br>• Kaplama: Parlak krom<br>• Perlatör: Sessiz su akışı, kireç temizleme sistemli<br>• Montaj Aparatları: 3/8\" – M10 – 50 cm fleks hortumlar ve sabitleme aparatları dahil<br>• Garanti Süresi: 5 yıl </span></p>\n<p><strong><span class=\"s6\">BT.VG2840 – Vega Banyo Bataryası</span></strong></p>\n<p><span class=\"s6\">Dayanıklı pirinç gövdesi ve tek kumandalı yapısıyla kullanışlı bir banyo bataryasıdır. Kilitlemeli yönlendirici ve modern tasarımı ile öne çıkar.</span></p>\n<p><span class=\"s6\"> • Seri: Vega<br>• Kullanım Alanı: Banyo<br>• Montaj Tipi: Duvar montajı (standart)<br>• Armatür Tipi: Aplike (duvara monte)<br>• Açma/Kapama: Tek kumandalı<br>• Kartuş: 35 mm seramik kartuş (uzun ömürlü)<br>• Su Giriş Sayısı: 2 giriş<br>• Bağlantı Deliği: 2 delikli<br>• Çıkış Ucu Uzunluğu: 151,5 mm<br>• Yönlendirici: Kilitlemeli diverter<br>• Malzeme: Pirinç gövde<br>• Kaplama: Krom<br>• Garanti Süresi: 5 yıl </span></p>\n<p><strong><span class=\"s6\">DS.SH425 – Aria 5 Fonksiyonlu Sürgülü El Duşu Seti</span></strong></p>\n<p><span class=\"s6\">Beş farklı su akış modu ve ayarlanabilir yükseklik imkânı ile kişiselleştirilmiş duş keyfi sunar. Yuvarlak duş başlığı ve şık krom kaplamasıyla banyoya modern bir görünüm kazandırır.</span></p>\n<p><span class=\"s6\"> • Ürün Kodu: DS.SH425<br>• Model Adı: Aria Sürgülü El Duş Seti 5F<br>• Duş Hortumu Uzunluğu: 1500 mm<br>• Fonksiyon Sayısı: 5 farklı su akış modu<br>• Duş Başlığı Şekli: Yuvarlak<br>• Kurulum Türü: Duvara montaj<br>• Renk / Kaplama: Parlak krom<br>• El Duşu ve Hortumu: Dahil<br>• Garanti Süresi: 2 yıl </span></p>\n</div>"
  },
  {
    "id": "creavit-9787985658153",
    "brand": "Creavit",
    "title": "Punto Termostatik 2 Yollu Ankastre Duş Seti",
    "category": "Duş Setleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/punto-termostatik-2-yollu-ankastre-dus-seti-7539.jpg?v=1755513630",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/punto-termostatik-2-yollu-ankastre-dus-seti-7539.jpg?v=1755513630",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/punto-termostatik-2-yollu-ankastre-dus-seti-7540.jpg?v=1755513633",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/punto-termostatik-2-yollu-ankastre-dus-seti-7541.jpg?v=1755513637"
    ],
    "price": "32400.00",
    "sku": "DS.SH540.SYM",
    "tags": [],
    "variants": [
      {
        "id": 52843221287209,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.SH540.SYM",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "32400.00",
        "grams": 0,
        "compare_at_price": "43200.00",
        "position": 1,
        "product_id": 9787985658153,
        "created_at": "2026-03-17T12:56:33+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<p><strong><span class=\"s6\">Creavit DS.SH540.SYM – Punto Termostatik 2 Yollu Ankastre Duş Seti (Mat Siyah)</span></strong></p>\n<p><span class=\"s6\">Şık tasarımı, güvenli termostatik sistemi ve fonksiyonel ankastre gövdesiyle modern banyolara özel konforlu bir duş deneyimi sunar.</span></p>\n<p><strong><span class=\"s6\">Uygulama Alanı</span></strong></p>\n<p><span class=\"s6\">Banyolar için tasarlanmış olup, ankastre (gömme) montaj sistemiyle kullanılmaktadır.</span></p>\n<p><strong><span class=\"s6\">Ürün Özellikleri</span></strong></p>\n<p><span class=\"s6\">Termostatik kartuş ile su sıcaklığını sabit tutar. El duşu, oval tepe duşu ve diverter çıkış gagası olmak üzere farklı su çıkışlarına sahiptir. 2 fonksiyonlu oval el duşu farklı sprey seçenekleri sunarken, 1500 mm PVC hortumu esnek ve dayanıklı bir kullanım sağlar. Oval tepe duşu ise tek fonksiyonlu olup geniş ve modern bir başlığa sahiptir.</span></p>\n<p><strong><span class=\"s6\">Armatür ve Mekanizma</span></strong></p>\n<p><span class=\"s6\">Duvar içine gömülen ankastre gövde yapısına sahiptir. Termostatik kartuş sayesinde güvenli ve sabit sıcaklıkta duş imkânı sunar.</span></p>\n<p><strong><span class=\"s6\">Montaj Bilgileri</span></strong></p>\n<p><span class=\"s6\">Duvara ankastre olarak monte edilir. Paket içeriğinde el duşu, tepe duşu, hortum, mafsal, gövde, dirsek ve çıkış gagası bulunur. Önerilen montaj yükseklikleri: Tepe duşu 210–220 cm, el duşu 150–160 cm, ankastre gövde 90–100 cm, su çıkış gagası 65 cm’dir.</span></p>\n<p><strong><span class=\"s6\">Paketleme / Ağırlık</span></strong></p>\n<p><span class=\"s6\">Ürün ağırlığı yaklaşık 4 kg’dır.</span></p>\n<p><strong><span class=\"s6\">Teknik Özellikler</span></strong></p>\n<p><span class=\"s6\"> • Ürün Kodu: DS.SH540.SYM<br>• Sistem Tipi: 2 yollu termostatik ankastre duş seti<br>• Su Çıkışları: El duşu, tepe duşu, diverter çıkış gagası<br>• El Duşu: Oval, 2 fonksiyonlu<br>• Tepe Duşu: Oval, tek fonksiyonlu<br>• Duş Hortumu: 1500 mm PVC<br>• Montaj Tipi: Duvara ankastre (sıva altı + sıva üstü)<br>• Montaj Yükseklikleri: Tepe duşu 210–220 cm; El duşu 150–160 cm; Gövde 90–100 cm; Gagası 65 cm<br>• Ürün Ağırlığı: ≈ 4 kg<br>• Renk / Kaplama: Mat Siyah </span></p>\n<p><span class=\"s6\">Not: Teknik bilgiler üretici dokümanlarına dayalıdır. Montaj öncesinde tesisat ölçülerinizi kontrol etmeniz önerilir.</span></p>\n</div>"
  },
  {
    "id": "creavit-9787983790377",
    "brand": "Creavit",
    "title": "Piano Tepe Duş Sistemi Termostatik Gun Grey",
    "category": "Duş Sistemi",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/med-DS.PN710GR-2_8aa2f248-9aae-4cff-ab48-322d26d19b1d.jpg?v=1755763864",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/med-DS.PN710GR-2_8aa2f248-9aae-4cff-ab48-322d26d19b1d.jpg?v=1755763864",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/med-dsc-6802_ae3bce60-c7f4-4278-ba6b-f61f267d0466.jpg?v=1755763864",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/med-dsc-6926_edcbf9c6-a794-403c-b8c4-2f373195ce3c.jpg?v=1755763864",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/med-dsc-7711_95fa34da-44d4-413f-ab5c-488c9605d8c3.jpg?v=1755763864",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/med-dsc-6845.jpg?v=1755763864",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/med-dsc-6852_fbee8f0a-cad8-422b-b35e-8d2aafcbfb19.jpg?v=1755763864",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/med-dsc-6850_33434e53-0fe2-486c-9d3f-eece7b53017f.jpg?v=1755763864",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/med-dsc-6863.jpg?v=1755763864",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/med-dsc-6859.jpg?v=1755763864",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/med-dsc-6816.jpg?v=1755763864",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/med-dsc-6806.jpg?v=1755763864",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/med-dsc-6904_c8299f3b-f80b-4bae-b69e-76737c6da040.jpg?v=1755763864",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/med-dsc-6770_7c1d5850-69c4-4f4b-8709-a8275029f87c.jpg?v=1755763864",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/med-dsc-6884_c59a8a5c-c3f9-4d84-b9f6-83c862150f90.jpg?v=1755763864",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/med-dsc-6882_55074144-b55d-4e26-af62-eb8b0a4dafc2.jpg?v=1755763864",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/med-dsc-6848_bddc7f6d-ce81-4c1d-9099-da11e55d9560.jpg?v=1755763864",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/med-dsc-6918_0d57f38b-5f50-4405-b219-6676d856c4a3.jpg?v=1755763864",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/med-dsc-6917_6756ee2e-115d-4d75-bf9e-e3e4206f8fa5.jpg?v=1755763864"
    ],
    "price": "45900.00",
    "sku": "DS.PN710GR",
    "tags": [],
    "variants": [
      {
        "id": 52912459088169,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.PN710GR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "45900.00",
        "grams": 0,
        "compare_at_price": "61200.00",
        "position": 1,
        "product_id": 9787983790377,
        "created_at": "2026-04-01T16:04:53+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<p><strong><span class=\"s6\">Creavit DS.PN710GR – Piano Tepe Duş Sistemi (Gun Grey)</span></strong></p>\n<p><span class=\"s6\">Modern tasarımı, termostatik güvenliği ve çoklu çıkış seçenekleri ile banyolarda konforlu bir duş deneyimi sunar.</span></p>\n<p><strong><span class=\"s6\">Uygulama Alanı</span></strong></p>\n<p><span class=\"s6\">Banyolar için özel olarak tasarlanmıştır. Duvara monte edilerek standart tesisat bağlantılarıyla uyumludur.</span></p>\n<p><strong><span class=\"s6\">Ürün Özellikleri</span></strong></p>\n<p><span class=\"s6\">Termostatik kartuş sayesinde su sıcaklığı sabit tutulur. 5 farklı çıkış noktası ile (tepe duşu, gövde jet, el duşu, bide sprey, su çıkış gagası) geniş kapsamlı bir duş keyfi yaşatır. 3 fonksiyonlu el duşu kişiselleştirilmiş kullanım imkânı sunarken, dijital sıcaklık göstergesi suyun ısısını net bir şekilde takip etmenizi sağlar.</span></p>\n<p><strong><span class=\"s6\">Armatür ve Mekanizma</span></strong></p>\n<p><span class=\"s6\">İç mekanizma, su bağlantısını sağlayan armatür sistemine sahiptir. Termostatik kartuş ile güvenli ve sabit sıcaklıkta duş imkânı verir.</span></p>\n<p><strong><span class=\"s6\">Montaj Bilgileri</span></strong></p>\n<p><span class=\"s6\">Duvara monte edilebilecek şekilde tasarlanmıştır. Paket içeriğinde montaj setleri, eksantrik dirsekler, el duşu, spiral hortum ve mafsal bulunur. Montaj yüksekliği zemin veya duş teknesinden itibaren minimum 80 cm olmalıdır. Ürün boyu 1161 mm’dir.</span></p>\n<p><strong><span class=\"s6\">Paketleme / Ağırlık</span></strong></p>\n<p><span class=\"s6\">Ambalajlı ürün ağırlığı yaklaşık 11 kg’dır.</span></p>\n<p><strong><span class=\"s6\">Teknik Özellikler</span></strong></p>\n<p><span class=\"s6\"> • Ürün Kodu: DS.PN710GR<br>• Sistem Tipi: Termostatik duş sistemi<br>• Su Çıkışları: Tepe duşu, gövde jet, el duşu, bide sprey, su çıkış gagası<br>• El Duşu: 3 fonksiyonlu<br>• Sıcaklık Göstergesi: Dijital<br>• Montaj: Duvara montaj, standart bağlantılar<br>• Ürün Boyu: 1161 mm<br>• Min. Bağlantı Yüksekliği: 80 cm<br>• Ambalaj Ağırlığı: ≈ 11 kg<br>• Renk / Kaplama: Gun Grey (Metalik Gri) </span></p>\n<p><span class=\"s6\">Not: Teknik bilgiler üretici dokümanlarına dayalıdır. Montaj öncesinde tesisat ölçülerinizi kontrol etmeniz önerilir.</span></p>\n</div>"
  },
  {
    "id": "creavit-9787980153129",
    "brand": "Creavit",
    "title": "Gordo Tezgah Üstü Lavabo Ø40 Cm",
    "category": "Tezgah Üstü Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gordo-tezgah-ustu-lavabo-40-cm-7528.jpg?v=1755513516",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gordo-tezgah-ustu-lavabo-40-cm-7528.jpg?v=1755513516",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gordo-tezgah-ustu-lavabo-40-cm-7529.jpg?v=1755513518",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gordo-tezgah-ustu-lavabo-40-cm-7530.jpg?v=1755513521",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gordo-tezgah-ustu-lavabo-40-cm-7531.jpg?v=1755513523"
    ],
    "price": "7200.00",
    "sku": "GO140-00CB00E-0000",
    "tags": [],
    "variants": [
      {
        "id": 52920306073897,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GO140-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7200.00",
        "grams": 0,
        "compare_at_price": "9600.00",
        "position": 1,
        "product_id": 9787980153129,
        "created_at": "2026-04-03T09:30:14+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<p><strong><span class=\"s6\">Creavit Gordo Tezgah Üstü Çanak Lavabo – GO140-00CB00E-0000</span></strong></p>\n<p><span class=\"s6\">Modern banyolar için kompakt ve zarif bir seçim. Tezgah üstü montaja uygun, yuvarlak çanak formuyla şık ve fonksiyonel bir kullanım sunar.</span></p>\n<p><strong><span class=\"s6\">Teknik Özellikler</span></strong></p>\n<p><span class=\"s6\"> Model Kodu: GO140-00CB00E-0000<br>Seri: Gordo<br>Ürün Tipi: Tezgah üstü çanak lavabo<br>Boyutlar: 420 × 135 × 420 mm<br>Genişlik / Derinlik: 420 mm<br>Yükseklik: 135 mm<br>İç Şekil: Yuvarlak çanak formu<br>Ağırlık: 9,10 kg </span></p>\n<p><strong><span class=\"s6\">Tasarım ve Fonksiyonellik</span></strong></p>\n<p><span class=\"s6\"> Renk: Beyaz<br>Armatür Deliği: Deliksiz (armatür yuvası bulunmaz)<br>Su Taşma Deliği: Yok<br>Montaj: Tezgah üstü montaja uygundur<br>Kullanım: Ayaklı kullanım için uygun değildir </span></p>\n<p><strong><span class=\"s6\">Dayanıklılık ve Servis</span></strong></p>\n<p><span class=\"s6\"> Üretim Yeri: Türkiye<br>Garanti Süresi: 12 Yıl Creavit garantisi<br>Servis: Yetkili servis hizmeti bulunmaktadır (ücretsiz montaj sunulmaz)<br>Süzgeç &amp; Sifon: Pakete dahil değildir, ayrıca temin edilmelidir </span></p>\n<p><strong><span class=\"s6\">Teknik Tablo</span></strong></p>\n<p><span class=\"s6\"> Model: GO140-00CB00E-0000<br>Seri: Gordo<br>Tip: Tezgah üstü çanak lavabo<br>Boyutlar: 420 × 135 × 420 mm<br>Ağırlık: 9,10 kg<br>Armatür Deliği: Deliksiz<br>Su Taşma: Yok<br>Montaj: Tezgah üstü<br>Garanti: 12 Yıl </span></p>\n<p><strong><span class=\"s6\">Not:</span></strong> <span class=\"s6\">Deliksiz model olduğu için armatür tezgaha veya duvara monte edilmelidir. Süzgeç ve sifon ayrı satılır.</span></p>\n</div>"
  },
  {
    "id": "creavit-9747678036265",
    "brand": "Creavit",
    "title": "Vega Lavabo Armatürü + Vega Banyo Armatürü + Vega Mutfak Armatürü Set Krom",
    "category": "456291287337",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vega-lavabo-armaturu-vega-banyo-armaturu-vega-mutfak-armaturu-set-krom-6642.png?v=1751962297",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vega-lavabo-armaturu-vega-banyo-armaturu-vega-mutfak-armaturu-set-krom-6642.png?v=1751962297"
    ],
    "price": "3720.00",
    "sku": "BTVG184028408640SET",
    "tags": [],
    "variants": [
      {
        "id": 52452381163817,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BTVG184028408640SET",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "3720.00",
        "grams": 0,
        "compare_at_price": "6200.00",
        "position": 1,
        "product_id": 9747678036265,
        "created_at": "2026-01-16T16:46:41+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\" data-mce-fragment=\"1\">\n<div class=\"react-scroll-to-bottom--css-vfjev-79elbk h-full dark:bg-gray-800\" data-mce-fragment=\"1\">\n<div class=\"react-scroll-to-bottom--css-vfjev-1n7m0yu\" data-mce-fragment=\"1\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\" data-mce-fragment=\"1\">\n<div class=\"group w-full text-gray-800 dark:text-gray-100 border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-mce-fragment=\"1\">\n<div class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\" data-mce-fragment=\"1\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\" data-mce-fragment=\"1\">\n<div class=\"flex flex-grow flex-col gap-3\" data-mce-fragment=\"1\">\n<div class=\"min-h-[20px] flex items-start overflow-x-auto whitespace-pre-wrap break-words\" data-mce-fragment=\"1\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\n<p><meta charset=\"utf-8\">Şıklığı ve işlevselliği bir araya getiren Vega Armatür serisi ile evinizde estetik bir atmosfer yaratırken aynı zamanda günlük kullanımlarınızda konfor sağlar. Vega Armatür ailesinin pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizması, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle banyo ve mutfak deneyiminiz daha keyifli hale gelecek. <meta charset=\"utf-8\">Creavit armatürleri, gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>\n<p data-mce-fragment=\"1\">Paket içindeki ürünler;</p>\n<p data-mce-fragment=\"1\">BT.VG1840 Vega Lavabo Armatürü</p>\n<p data-mce-fragment=\"1\"><meta charset=\"utf-8\"><meta charset=\"utf-8\">BT.VG2840 Vega Banyo Armatürü</p>\n<p data-mce-fragment=\"1\"><meta charset=\"utf-8\">BT.VG8640 Vega Mutfak Armatürü</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9728734757161",
    "brand": "Creavit",
    "title": "Terra Rim-Off Duroplast Kapaklı Gömme Rezervuar Set",
    "category": "462592246057",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-rim-off-duroplast-kapakli-gomme-rezervuar-set-7406.png?v=1750059552",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-rim-off-duroplast-kapakli-gomme-rezervuar-set-7406.png?v=1750059552",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-rim-off-duroplast-kapakli-gomme-rezervuar-set-7407.jpg?v=1750059556",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-rim-off-duroplast-kapakli-gomme-rezervuar-set-7408.jpg?v=1750059559",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-rim-off-duroplast-kapakli-gomme-rezervuar-set-7409.jpg?v=1750059561",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-rim-off-duroplast-kapakli-gomme-rezervuar-set-7410.jpg?v=1750059564",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-rim-off-duroplast-kapakli-gomme-rezervuar-set-7411.png?v=1750059566"
    ],
    "price": "20454.00",
    "sku": "TP329.CB.SET",
    "tags": [
      "asma klozet",
      "asma klozet set"
    ],
    "variants": [
      {
        "id": 52892851962153,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "TP329.CB.SET",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "20454.00",
        "grams": 0,
        "compare_at_price": "29220.00",
        "position": 1,
        "product_id": 9728734757161,
        "created_at": "2026-03-28T22:37:07+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<div class=\"product-detail\">\n<h3 class=\"title\">Ürün Set İçeriği</h3>\n<p>Bu set içerisinde <strong>Creavit Terra Rim-Off Asma Klozet</strong> ve gerekli tüm aksesuarlar <strong>DAHİLDİR</strong>:</p>\n<ul class=\"detail-list\">\n<li>TP329-00CB00E-0000 Kodlu <strong>Terra Rim-Off Asma Klozet</strong>\n</li>\n<li>KC0903.02.0000E Kodlu <strong>Duck Duroplast Yavaş Kapanan Klozet Kapağı</strong>\n</li>\n<li>GR5001 Kodlu <strong>Gömme Rezervuar</strong>\n</li>\n<li>GP9002.00 Kodlu <strong>Kumanda Paneli</strong>\n</li>\n<li>MS.AC50L Kodlu <strong>Ara Musluk</strong>\n</li>\n</ul>\n<h4 class=\"subtitle\">TP329-00CB00E-0000 – Creavit Terra Rim-Off Asma Klozet</h4>\n<ul class=\"detail-list\">\n<li>\n<strong>Ürün Kodu:</strong> TP329-00CB00E-0000</li>\n<li>\n<strong>Seri:</strong> Terra</li>\n<li>\n<strong>Renk:</strong> Beyaz</li>\n<li>\n<strong>Boyutlar:</strong> 355 mm (Genişlik) x 345 mm (Yükseklik) x 510 mm (Derinlik)</li>\n<li>\n<strong>Montaj Tipi:</strong> Duvara asma (gizli montaj)</li>\n<li>\n<strong>Pis Su Çıkışı:</strong> Duvardan</li>\n<li>\n<strong>Yıkama Sistemi:</strong> Kanalsız (Rim-Off)</li>\n<li>\n<strong>Taharet Borusu:</strong> Dahildir (yalnızca gizli bağlantı yapılabilir, yandan bağlantı yapılamaz)</li>\n<li>\n<strong>Klozet Kapağı:</strong> KC0903.02.0000E Duck Duroplast Yavaş Kapanan</li>\n<li>\n<strong>Gömme Rezervuar:</strong> GR5001</li>\n<li>\n<strong>Kumanda Paneli:</strong> GP9002.00</li>\n<li>\n<strong>Ara Musluk:</strong> MS.AC50L</li>\n<li>\n<strong>Garanti Süresi:</strong> 12 Yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\n<h4 class=\"subtitle\">Öne Çıkan Özellikler</h4>\n<ul class=\"detail-list\">\n<li>\n<strong>Kanalsız Tasarım (Rim-Off):</strong> Bakteri ve kir birikimi engellenir.</li>\n<li>\n<strong>Kolay Temizlik:</strong> Asma tasarım sayesinde klozet altı kolayca temizlenir.</li>\n<li>\n<strong>Su Tasarrufu:</strong> 3-6 litre arası su tüketimi ile çevre dostu kullanım.</li>\n</ul>\n<p><strong>Not:</strong> Gizli montaj kiti ürünle birlikte sunulmaktadır.</p>\n<p><strong>Creavit Terra Rim-Off Asma Klozet</strong>, modern tasarımı ve hijyenik özellikleriyle uzun ömürlü kullanım sağlar.</p>\n</div>"
  },
  {
    "id": "creavit-9728729809193",
    "brand": "Creavit",
    "title": "Terra Rim-Off Gömme Rezervuarlı Thermoplast Kapaklı Set",
    "category": "Asma Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-rim-off-gomme-rezervuarli-thermoplast-kapakli-set-7400.png?v=1750058102",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-rim-off-gomme-rezervuarli-thermoplast-kapakli-set-7400.png?v=1750058102",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-rim-off-gomme-rezervuarli-thermoplast-kapakli-set-7401.jpg?v=1750058105",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-rim-off-gomme-rezervuarli-thermoplast-kapakli-set-7402.jpg?v=1750058108",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-rim-off-gomme-rezervuarli-thermoplast-kapakli-set-7403.jpg?v=1750058111",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-rim-off-gomme-rezervuarli-thermoplast-kapakli-set-7404.jpg?v=1750058114",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-rim-off-gomme-rezervuarli-thermoplast-kapakli-set-7405.png?v=1750058116"
    ],
    "price": "18816.00",
    "sku": "TP329.GR.SET",
    "tags": [
      "asma klozet",
      "asma klozet set"
    ],
    "variants": [
      {
        "id": 52892851798313,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "TP329.GR.SET",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "18816.00",
        "grams": 0,
        "compare_at_price": "26880.00",
        "position": 1,
        "product_id": 9728729809193,
        "created_at": "2026-03-28T22:37:04+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<ul>\r\n<li>\n<strong>Ürün Kodu:</strong> TP329-00CB00E-0000</li>\r\n<li>\n<strong>Seri:</strong> Terra </li>\r\n<li>\n<strong>Renk:</strong> Beyaz</li>\r\n<li>\n<strong>Boyutlar:</strong> 355 mm (Genişlik) x 345 mm (Yükseklik) x 510 mm (Derinlik)</li>\r\n<li>\n<strong>Montaj Tipi:</strong> Duvara asma (gizli montaj)</li>\r\n<li>\n<strong>Pis Su Çıkışı:</strong> Duvardan</li>\r\n<li>\n<strong>Yıkama Sistemi:</strong> Kanalsız (Rim-Off)</li>\r\n<li>\n<strong>Taharet Borusu:</strong> Dahildir; sadece gizli bağlantı yapılabilir, yandan bağlantı yapılamaz</li>\r\n<li>\n<strong>Klozet Kapağı:</strong> Dahildir KC0903.03.0000E (Duck Thermoplast Yavaş Kapanan Klozet Kapağı)</li>\r\n<li>\n<strong>Gömme Rezervuar:</strong> Dahildir GR5001</li>\r\n<li>\n<strong>Kumanda Paneli: </strong>Dahildir; GP9002.00</li>\r\n<li>\n<strong>Ara Musluk:</strong> Dahildir; MS.AC50L</li>\r\n<li>\n<strong>Garanti Süresi:</strong> 12 Yıl</li>\r\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\r\n<h4>Öne Çıkan Özellikler</h4>\r\n<ul>\r\n<li>\n<strong>Kanalsız Tasarım (Rim-Off):</strong> Geleneksel klozetlerde bulunan yıkama kanalları bu modelde bulunmaz, bu sayede bakteri ve kir birikimi minimize edilir.</li>\r\n<li>\n<strong>Kolay Temizlik:</strong> Asma tasarımı sayesinde klozet altı alanı kolayca temizlenebilir.</li>\r\n<li>\n<strong>Su Tasarrufu:</strong> 3-6 litre arasında su tüketimi ile çevre dostu bir kullanım sağlar.</li>\n</ul>\r\n<p><strong>Not:</strong> Montaj kiti (gizli montaj seti) ürünle birlikte sunulmaktadır.</p>\r\n<p><strong>Creavit Terra Rim-Off Asma Klozet</strong>, modern tasarımı ve hijyenik özellikleriyle banyonuza değer katacak bir üründür. Yüksek kaliteli malzemesi ve kullanıcı dostu detaylarıyla uzun ömürlü bir kullanım deneyimi sunar.</p>"
  },
  {
    "id": "creavit-9728464879913",
    "brand": "Creavit",
    "title": "Terra Rim-Off Asma Klozet ve Duck Thermoplast Yavaş Kapanan Klozet Kapağı Set",
    "category": "Asma Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-terra-asma-klozet-beyaz_e028d89a-8e18-495c-a622-f12dd22a84b1.png?v=1750057021",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-terra-asma-klozet-beyaz_e028d89a-8e18-495c-a622-f12dd22a84b1.png?v=1750057021",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-rim-off-asma-klozet-ve-duck-thermoplast-yavas-kapanan-klozet-kapagi-set-7398.jpg?v=1750057021",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-rim-off-asma-klozet-ve-duck-thermoplast-yavas-kapanan-klozet-kapagi-set-7399.jpg?v=1750057021"
    ],
    "price": "7497.00",
    "sku": "SET.TP329TP.BYZ",
    "tags": [
      "asma klozet"
    ],
    "variants": [
      {
        "id": 52892851503401,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.TP329TP.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7497.00",
        "grams": 0,
        "compare_at_price": "14700.00",
        "position": 1,
        "product_id": 9728464879913,
        "created_at": "2026-03-28T22:37:00+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<div class=\"product-details\">\n<h3>Creavit TP329-00CB00E-0000 Terra Rim-Off Kanalsız Asma Klozet</h3>\n<section class=\"product-highlights\">\n<h3>🏷️ Temel Bilgiler</h3>\n<ul>\n<li>\n<strong>Marka:</strong> Creavit</li>\n<li>\n<strong>Ürün Adı:</strong> Terra Rim-Off Kanalsız Asma Klozet</li>\n<li>\n<strong>Ürün Kodu:</strong> TP329-00CB00E-0000</li>\n<li>\n<strong>Seri:</strong> Terra</li>\n<li>\n<strong>Renk:</strong> Beyaz</li>\n<li>\n<strong>Garanti Süresi:</strong> 12 Yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\n</section>\n<section class=\"product-design\">\n<h3>🧼 Tasarım Özellikleri</h3>\n<ul>\n<li>Rim-Off (Kanalsız) iç yüzey tasarımı ile hijyenik ve kolay temizlik</li>\n<li>Duvara monte edilen asma klozet yapısı</li>\n<li>Yerden yüksek montaj ile ferah ve temiz bir görünüm</li>\n</ul>\n</section>\n<section class=\"product-structure\">\n<h3>🚽 Yapı &amp; Montaj</h3>\n<ul>\n<li>\n<strong>Malzeme:</strong> Dayanıklı beyaz seramik</li>\n<li>\n<strong>Montaj Tipi:</strong> Duvara asma</li>\n<li>\n<strong>Pis Su Çıkışı:</strong> Arka (duvar) tipi</li>\n<li>\n<strong>Taharet Borusu:</strong> Ürün içinde mevcut</li>\n<li>\n<strong>Klozet Kapağı:</strong> KC0903.03.0000E Duck Thermoplast Yavaş Kapanan Klozet Kapağı</li>\n</ul>\n</section>\n<section class=\"product-package\">\n<h3>🧩 Paket İçeriği</h3>\n<ul>\n<li>Terra Rim-Off Asma Klozet</li>\n<li>Duck Duroplast Yavaş Kapanan Klozet Kapağı</li>\n<li>Montaj kiti</li>\n<li>Bağlantı hortumları (varsa)</li>\n<li>Kullanım ve montaj kılavuzu</li>\n</ul>\n</section>\n<section class=\"product-advantages\">\n<h3>⭐ Öne Çıkan Avantajlar</h3>\n<ul>\n<li>Hijyenik Rim-Off yapısı sayesinde bakteri birikimini önler</li>\n<li>Minimalist, şık ve modern tasarım</li>\n<li>Kolay temizlik sağlayan pürüzsüz yüzey</li>\n<li>Yüksek kaliteli seramikten üretilmiş, uzun ömürlü yapı</li>\n</ul>\n</section>\n<p><strong>Creavit TP329-00CB00E-0000 Terra Rim-Off</strong> asma klozet, modern banyolar için şık, hijyenik ve fonksiyonel bir tercihtir. Kolay montajı, yüksek performansı ve 12 yıl garantisi ile güvenle kullanılabilir. </p>\n</div>"
  },
  {
    "id": "creavit-9728440566057",
    "brand": "Creavit",
    "title": "Terra Rim-Off Asma Klozet ve Duck Duroplast Yavaş Kapanan Kapak Seti",
    "category": "Asma Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-terra-asma-klozet-beyaz_0af81ad6-41c4-443a-9014-e505c96d06ac.png?v=1750057040",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-terra-asma-klozet-beyaz_0af81ad6-41c4-443a-9014-e505c96d06ac.png?v=1750057040",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-rim-off-asma-klozet-ve-duck-duroplast-yavas-kapanan-kapak-seti-7395.jpg?v=1750057040",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-rim-off-asma-klozet-ve-duck-duroplast-yavas-kapanan-kapak-seti-7396.jpg?v=1750057040"
    ],
    "price": "11928.00",
    "sku": "SET.TP329DP.BYZ",
    "tags": [
      "asma klozet"
    ],
    "variants": [
      {
        "id": 52892851372329,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.TP329DP.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11928.00",
        "grams": 0,
        "compare_at_price": "17040.00",
        "position": 1,
        "product_id": 9728440566057,
        "created_at": "2026-03-28T22:36:57+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<div class=\"product-details\">\n<h3>Creavit TP329-00CB00E-0000 Terra Rim-Off Kanalsız Asma Klozet</h3>\n<section class=\"product-highlights\">\n<h3>🏷️ Temel Bilgiler</h3>\n<ul>\n<li>\n<strong>Marka:</strong> Creavit</li>\n<li>\n<strong>Ürün Adı:</strong> Terra Rim-Off Kanalsız Asma Klozet</li>\n<li>\n<strong>Ürün Kodu:</strong> TP329-00CB00E-0000</li>\n<li>\n<strong>Seri:</strong> Terra</li>\n<li>\n<strong>Renk:</strong> Beyaz</li>\n<li>\n<strong>Garanti Süresi:</strong> 12 Yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\n</section>\n<section class=\"product-design\">\n<h3>🧼 Tasarım Özellikleri</h3>\n<ul>\n<li>Rim-Off (Kanalsız) iç yüzey tasarımı ile hijyenik ve kolay temizlik</li>\n<li>Duvara monte edilen asma klozet yapısı</li>\n<li>Yerden yüksek montaj ile ferah ve temiz bir görünüm</li>\n</ul>\n</section>\n<section class=\"product-structure\">\n<h3>🚽 Yapı &amp; Montaj</h3>\n<ul>\n<li>\n<strong>Malzeme:</strong> Dayanıklı beyaz seramik</li>\n<li>\n<strong>Montaj Tipi:</strong> Duvara asma</li>\n<li>\n<strong>Pis Su Çıkışı:</strong> Arka (duvar) tipi</li>\n<li>\n<strong>Taharet Borusu:</strong> Ürün içinde mevcut</li>\n<li>\n<strong>Klozet Kapağı:</strong> KC0903.02.0000E Duck Duroplast, yavaş kapanan</li>\n</ul>\n</section>\n<section class=\"product-package\">\n<h3>🧩 Paket İçeriği</h3>\n<ul>\n<li>Terra Rim-Off Asma Klozet</li>\n<li>Duck Duroplast Yavaş Kapanan Klozet Kapağı</li>\n<li>Montaj kiti</li>\n<li>Bağlantı hortumları (varsa)</li>\n<li>Kullanım ve montaj kılavuzu</li>\n</ul>\n</section>\n<section class=\"product-advantages\">\n<h3>⭐ Öne Çıkan Avantajlar</h3>\n<ul>\n<li>Hijyenik Rim-Off yapısı sayesinde bakteri birikimini önler</li>\n<li>Minimalist, şık ve modern tasarım</li>\n<li>Kolay temizlik sağlayan pürüzsüz yüzey</li>\n<li>Yüksek kaliteli seramikten üretilmiş, uzun ömürlü yapı</li>\n</ul>\n</section>\n<p><strong>Creavit TP329-00CB00E-0000 Terra Rim-Off</strong> asma klozet, modern banyolar için şık, hijyenik ve fonksiyonel bir tercihtir. Kolay montajı, yüksek performansı ve 12 yıl garantisi ile güvenle kullanılabilir. </p>\n</div>"
  },
  {
    "id": "creavit-9700597825833",
    "brand": "Creavit",
    "title": "Vega Lavabo Banyo ve Mutfak Armatürü Set",
    "category": "Banyo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vega-lavabo-banyo-ve-mutfak-armaturu-set-7377.png?v=1747383631",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vega-lavabo-banyo-ve-mutfak-armaturu-set-7377.png?v=1747383631",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vega-lavabo-banyo-ve-mutfak-armaturu-set-7367.png?v=1747383631",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vega-lavabo-banyo-ve-mutfak-armaturu-set-7368.jpg?v=1747383421",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vega-lavabo-banyo-ve-mutfak-armaturu-set-7369.png?v=1747383424"
    ],
    "price": "15960.00",
    "sku": "BTVG18288640SET",
    "tags": [
      "Armatür",
      "banyo armatürü",
      "Lavabo Armatürü",
      "Mutfak Armatürü",
      "Vega"
    ],
    "variants": [
      {
        "id": 52843244519721,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BTVG18288640SET",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "15960.00",
        "grams": 0,
        "compare_at_price": "22800.00",
        "position": 1,
        "product_id": 9700597825833,
        "created_at": "2026-03-17T13:04:41+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h3>Ürüne Dahil Olan Bataryalar </h3>\n<ul>\n<li>\n<strong>BT.VG1840</strong> – Vega Lavabo Bataryası</li>\n<li>\n<strong>BT.VG2840</strong> – Vega Banyo Bataryası</li>\n<li>\n<strong>BT.VG8640</strong> – Vega Mutfak Bataryası</li>\n</ul>\n<hr>\n<h4>BT.VG1840 – Vega Lavabo Bataryası</h4>\n<p>Creavit'in BT.VG1840 kodlu Vega Lavabo Bataryası, modern tasarımı ve dayanıklı yapısıyla banyolarınıza şıklık katacak bir üründür. Tek kumandalı yapısı sayesinde su sıcaklığı ve debisi kolayca ayarlanabilir.</p>\n<ul>\n<li>Seri: Vega</li>\n<li>Kullanım Alanı: Lavabo</li>\n<li>Montaj Tipi: Tezgah üstü (dikey düzlem)</li>\n<li>Armatür Tipi: Tek kumandalı mix armatür</li>\n<li>Çıkış Ucu Uzunluğu: 115,7 mm</li>\n<li>Çıkış Ucu Yüksekliği: 92,7 mm</li>\n<li>Kartuş: Uzun ömürlü 35 mm seramik kartuş (ayaklı)</li>\n<li>Malzeme: %100 pirinç gövde</li>\n<li>Kaplama: Parlak krom</li>\n<li>Perlatör: Sessiz su akışı sağlayan, kireç temizleme sistemli</li>\n<li>Montaj Aparatları: 3/8\" - M10 - 50 cm fleks hortumlar ve sabitleme aparatları dahil</li>\n<li>Garanti Süresi: 5 yıl</li>\n</ul>\n<hr>\n<h4>BT.VG2840 – Vega Banyo Bataryası</h4>\n<p>Creavit'in BT.VG2840 kodlu Vega Banyo Bataryası, modern tasarımı ve dayanıklı yapısıyla banyolarınıza şıklık katacak bir üründür. Tek kumandalı yapısı sayesinde su sıcaklığı ve debisi kolayca ayarlanabilir.</p>\n<ul>\n<li>Seri: Vega</li>\n<li>Kullanım Alanı: Banyo</li>\n<li>Montaj Tipi: Duvar montajı (standart)</li>\n<li>Armatür Tipi: Aplike (duvara monte)</li>\n<li>Açma/Kapama Mekanizması: Tek kumandalı</li>\n<li>Kartuş: 35 mm seramik kartuş (uzun ömürlü, ayaklı)</li>\n<li>Su Giriş Sayısı: 2 giriş</li>\n<li>Bağlantı Deliği: 2 delikli</li>\n<li>Çıkış Ucu Uzunluğu: 151,5 mm</li>\n<li>Yönlendirici: Kilitlemeli yönlendirici</li>\n<li>Malzeme: Pirinç gövde</li>\n<li>Kaplama: Krom</li>\n<li>Garanti Süresi: 5 yıl</li>\n</ul>\n<hr>\n<h4>BT.VG8640 – Vega Mutfak Bataryası</h4>\n<p>Creavit'in BT.VG8640 kodlu Vega Mutfak Bataryası, modern tasarımı ve fonksiyonelliğiyle mutfağınıza şıklık katacak bir üründür. Yüksek çıkış ucu ve döner boru özelliği sayesinde kullanım kolaylığı sağlar.</p>\n<ul>\n<li>Seri: Vega</li>\n<li>Kullanım Alanı: Mutfak</li>\n<li>Montaj Tipi: Tezgah üstü (dikey düzlem)</li>\n<li>Armatür Tipi: Kuğu tipi, tek kumandalı (aç-kapa)</li>\n<li>Çıkış Ucu Uzunluğu: 165,3 mm</li>\n<li>Çıkış Ucu Yüksekliği: 215,8 mm</li>\n<li>Kartuş: Uzun ömürlü 35 mm seramik kartuş (ayaklı)</li>\n<li>Perlatör: Sessiz su akışı sağlayan, kireç temizleme sistemli</li>\n<li>Döner Boru: 360° dönebilen</li>\n<li>Su Giriş Sayısı: 2 giriş (sıcak-soğuk)</li>\n<li>Malzeme: Pirinç gövde</li>\n<li>Kaplama: Parlak krom</li>\n<li>Garanti Süresi: 5 yıl</li>\n</ul>"
  },
  {
    "id": "creavit-8968461975849",
    "brand": "Creavit",
    "title": "D10 40 cm SAĞ Boy Dolabı Melamin Gri Gövde Melamin Antrasit Kapak",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-boy-dolabi-40cm-antrasit-banyo-mobilyasi_230fa0d2-39ab-4e82-942e-49ba25426969.png?v=1749137441",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-boy-dolabi-40cm-antrasit-banyo-mobilyasi_230fa0d2-39ab-4e82-942e-49ba25426969.png?v=1749137441",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-gri-melamin-govde-antrasit-kapak-5524.jpg?v=1749137441",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-gri-melamin-govde-antrasit-kapak-5525.jpg?v=1749137441",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-gri-melamin-govde-antrasit-kapak-5526.jpg?v=1749137441",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-gri-melamin-govde-antrasit-kapak-5527.jpg?v=1749137441"
    ],
    "price": "6424.00",
    "sku": "D10.BD040.SAG.M.M.0305",
    "tags": [
      "Antrasit",
      "Banyo Mobilyası",
      "boy dolabı",
      "D10",
      "Gri",
      "Melamin",
      "Sağ Boy Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843089756457,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.BD040.SAG.M.M.0305",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6424.00",
        "grams": 0,
        "compare_at_price": "8030.00",
        "position": 1,
        "product_id": 8968461975849,
        "created_at": "2026-03-17T11:59:06+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-9700174692649",
    "brand": "Creavit",
    "title": "Elegant Rim-Off Duroplast Yavaş Kapanan Klozet Kapaklı Mat Cappucino Set",
    "category": "Rim-Off Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/10_03f5ac32-acb4-4fb1-99d4-57df03f4ff56.png?v=1749543968",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/10_03f5ac32-acb4-4fb1-99d4-57df03f4ff56.png?v=1749543968",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/11_cfac7865-4c42-4c51-813f-c5f5f8782a06.png?v=1749543968",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-eg321-8_1.jpg?v=1749544534",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-elegant-kapak9_1.jpg?v=1749544534",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-eg321-3_491df9d6-cdae-477d-99ae-81e9727f360f.jpg?v=1749544534",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-elegant-kapak2.jpg?v=1749544534",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-elegant-kapak3.jpg?v=1749544534",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-eg321-4_bca96500-da64-4674-9031-1482acbcfe0c.jpg?v=1749544534",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-eg321-7_795a176d-2a76-4571-b024-99f8cffe7751.jpg?v=1749544534"
    ],
    "price": "23562.00",
    "sku": "SET.EG321DP.CM",
    "tags": [
      "asma klozet",
      "asma klozet set"
    ],
    "variants": [
      {
        "id": 52843172888873,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.EG321DP.CM",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "23562.00",
        "grams": 0,
        "compare_at_price": "33660.00",
        "position": 1,
        "product_id": 9700174692649,
        "created_at": "2026-03-17T12:42:35+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h2>Creavit Elegant Rim-Off Kanalsız Asma Klozet - Mat Cappucino</h2>\r\n<p><strong>Ürün Kodu:</strong> EG321-00CM00E-0000</p>\r\n<p><strong>Seri:</strong> Elegant</p>\r\n<p><strong>Renk:</strong> Mat Cappucino</p>\r\n<p><strong>Ölçüler:</strong> 513 x 370 mm</p>\r\n<p><strong>Tasarım:</strong> Köşeli dış hatlara sahip, modern ve estetik görünüm</p>\r\n<p><strong>Montaj Tipi:</strong> Duvara asma (asma klozet)</p>\r\n<p><strong>Pis Su Çıkışı:</strong> Duvardan</p>\r\n<p><strong>Taharet Borusu:</strong> Var</p>\r\n<p><strong>Klozet Kapağı:</strong> Dahildir; KC1103.01.0800E</p>\r\n<p><strong>Garanti Süresi:</strong> 12 Yıl</p>\r\n<p><strong>Üretim Yeri:</strong> Türkiye</p>\r\n<h3>Rim-Off Teknolojisi</h3>\r\n<p>Kanalsız iç yapısı sayesinde bakterilerin ve kirlerin birikmesini önler. Bu sayede temizlik daha kolay ve hijyenik hale gelir.</p>\r\n<h4>Not:</h4>\r\n<p>Ürünün düzgün çalışabilmesi için uyumlu bir gömme rezervuar gereklidir. Gömme rezervuar ürüne dahil değildir ve ayrıca sipariş edilmelidir.</p>"
  },
  {
    "id": "creavit-9699177398569",
    "brand": "Creavit",
    "title": "Loop Cool Grey Çanak Lavabo Armatür ve Sifon Başlığı Set",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-cool-grey-lavabo-sifon-basligi-armatur-set.png?v=1756816463",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-cool-grey-lavabo-sifon-basligi-armatur-set.png?v=1756816463",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-cool-grey-canak-lavabo.png?v=1756816497",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/RB063_7.png?v=1756816875",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/RB063_6_9b137cb7-82ec-400c-bcab-c7fa1d5540d7.png?v=1756816875",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/18_3e06575b-2379-4744-8b9c-0994393aa333.png?v=1756818306"
    ],
    "price": "18270.00",
    "sku": "LP145CGSET",
    "tags": [
      "Loop",
      "Tezgah Üstü Lavabo",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52920331993385,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP145CGSET",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "18270.00",
        "grams": 0,
        "compare_at_price": "26100.00",
        "position": 1,
        "product_id": 9699177398569,
        "created_at": "2026-04-03T09:38:06+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<!-- Shopify Ürün Açıklaması: LP145-00CB00E-0000 Loop Yuvarlak Çanak Lavabo -->\n<div class=\"product-description\">\n<p>Şık ve modern tasarımıyla banyonuza zarafet katacak Creavit Loop yuvarlak çanak lavabo. Yüzey montaj tipi sayesinde kolay kurulum, dayanıklı malzemesiyle uzun ömürlü kullanım sunar. <meta charset=\"utf-8\">Creavit’in 12 yıllık üretici garantisi ile sunulan Loop çanak lavabo, SF.SF030 sifon başlığı ve BT.SO6500 modeli armatürü ile eksiksiz bir set olarak teslim edilir. Su taşma deliği bulunmadığı için ekstra güvenlik önlemi gerektirmez. Armatür deliği olmaması, size armatür seçimi konusunda tam özgürlük sunar.</p>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> LP145-00CG00E-0000</li>\n<li>\n<strong>Boyutlar:</strong> 450 × 112 mm</li>\n<li>\n<strong>Montaj Tipi:</strong> Tezgah Üstü</li>\n<li>\n<strong>Armatür Deliği:</strong> Armatür Deliksiz</li>\n<li>\n<strong>Su Taşma Deliği:</strong> Yok</li>\n<li>\n<strong>Garanti Süresi:</strong> 12 Yıl</li>\n<li>\n<strong>Sifon Başlığı:</strong> Dahildir (SFU.SF030.CGR)</li>\n<li>\n<strong>Armatür:</strong> Dahildir (BT.SO6500)</li>\n</ul>\n<h4>Kurulum ve Teslimat</h4>\n<p>• Ürün, montaja hazır olarak paketlenir.<br>• Kurulum kılavuzu ile birlikte gönderilir.<br>• Tüm Türkiye’ye ücretsiz kargo ve 12 ay parça garantisi.</p>\n</div>"
  },
  {
    "id": "creavit-9699168485673",
    "brand": "Creavit",
    "title": "Loop Mint Yeşili Çanak Lavabo Armatür ve Sifon Başlığı Set",
    "category": "462596342057",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/RB063_9.png?v=1756817378",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/RB063_9.png?v=1756817378",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-loop-mint-canak-lavabo-sifon-basligi-set.png?v=1756817378",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/19_11e47ebd-9fdd-492a-b5e2-ae5f93cbdd22.png?v=1756817378",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/RB063_6.png?v=1756817378",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/18_73b4e3ca-ba7a-4700-b075-51a9230649de.png?v=1756817378"
    ],
    "price": "18270.00",
    "sku": "LP145MTSET",
    "tags": [],
    "variants": [
      {
        "id": 52843244060969,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP145MTSET",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "18270.00",
        "grams": 0,
        "compare_at_price": "26100.00",
        "position": 1,
        "product_id": 9699168485673,
        "created_at": "2026-03-17T13:04:35+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<!-- Shopify Ürün Açıklaması: LP145-00CB00E-0000 Loop Yuvarlak Çanak Lavabo -->\n<div class=\"product-description\">\n<h3>Loop Yuvarlak Çanak Lavabo Mint Yeşili (LP145-00MT00E-0000)</h3>\n<p>Şık ve modern tasarımıyla banyonuza zarafet katacak Creavit Loop yuvarlak çanak lavabo. Yüzey montaj tipi sayesinde kolay kurulum, dayanıklı malzemesiyle uzun ömürlü kullanım sunar. <meta charset=\"utf-8\">Creavit’in 12 yıllık üretici garantisi ile sunulan Loop çanak lavabo, SF.SF030 sifon başlığı ve BT.SO6500 modeli armatürü ile eksiksiz bir set olarak teslim edilir. Su taşma deliği bulunmadığı için ekstra güvenlik önlemi gerektirmez. Armatür deliği olmaması, size armatür seçimi konusunda tam özgürlük sunar.</p>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> LP145-00MT00E-0000</li>\n<li>\n<strong>Boyutlar:</strong> 450 × 112 mm</li>\n<li>\n<strong>Montaj Tipi:</strong> Tezgah Üstü</li>\n<li>\n<strong>Armatür Deliği:</strong> Armatür Deliksiz</li>\n<li>\n<strong>Su Taşma Deliği:</strong> Yok</li>\n<li>\n<strong>Garanti Süresi:</strong> 12 Yıl</li>\n<li>\n<strong>Sifon Başlığı:</strong> Dahildir (SF.SF030)</li>\n<li>\n<strong>Armatür:</strong> Dahildir (BT.SO6500)</li>\n</ul>\n<h2>Kurulum ve Teslimat</h2>\n<p>• Ürün, montaja hazır olarak paketlenir.<br>• Kurulum kılavuzu ile birlikte gönderilir.<br>• Tüm Türkiye’ye ücretsiz kargo.</p>\n</div>"
  },
  {
    "id": "creavit-9699165438249",
    "brand": "Creavit",
    "title": "Loop Beyaz Çanak Lavabo Armatür ve Sifon Başlığı Seti",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/RB063_10.png?v=1756818233",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/RB063_10.png?v=1756818233",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/18_3e06575b-2379-4744-8b9c-0994393aa333.png?v=1756818306",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/RB063_6_c0282956-36d3-4370-9d5e-57f4beb1f758.png?v=1756818306",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-canak-lavabo-armatur-ve-sifon-basligi-seti-7348.jpg?v=1756818290",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-canak-lavabo-armatur-ve-sifon-basligi-seti-7349.jpg?v=1756818290"
    ],
    "price": "14574.00",
    "sku": "LOOP145BEYAZSET",
    "tags": [
      "Loop",
      "tezgah üstü lavabo set",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52920317542697,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LOOP145BEYAZSET",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "14574.00",
        "grams": 0,
        "compare_at_price": "20820.00",
        "position": 1,
        "product_id": 9699165438249,
        "created_at": "2026-04-03T09:34:14+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<!-- Shopify Ürün Açıklaması: LP145-00CB00E-0000 Loop Yuvarlak Çanak Lavabo -->\n<div class=\"product-description\">\n<p>Şık ve modern tasarımıyla banyonuza zarafet katacak Creavit Loop yuvarlak çanak lavabo. Yüzey montaj tipi sayesinde kolay kurulum, dayanıklı malzemesiyle uzun ömürlü kullanım sunar. <meta charset=\"utf-8\">Creavit’in 12 yıllık üretici garantisi ile sunulan Loop çanak lavabo, SF.SF030 sifon başlığı ve BT.SO6500 modeli armatürü ile eksiksiz bir set olarak teslim edilir. Su taşma deliği bulunmadığı için ekstra güvenlik önlemi gerektirmez. Armatür deliği olmaması, size armatür seçimi konusunda tam özgürlük sunar.</p>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> LP145-00CB00E-0000</li>\n<li>\n<strong>Boyutlar:</strong> 450 × 112 mm</li>\n<li>\n<strong>Montaj Tipi:</strong> Tezgah Üstü</li>\n<li>\n<strong>Armatür Deliği:</strong> Armatür Deliksiz</li>\n<li>\n<strong>Su Taşma Deliği:</strong> Yok</li>\n<li>\n<strong>Garanti Süresi:</strong> 12 Yıl</li>\n<li>\n<strong>Sifon Başlığı:</strong> Dahildir (SF.SF030)</li>\n<li>\n<strong>Armatür:</strong> Dahildir (BT.SO6500)</li>\n</ul>\n<h4>Kurulum ve Teslimat</h4>\n<p>• Ürün, montaja hazır olarak paketlenir.<br>• Kurulum kılavuzu ile birlikte gönderilir.<br>• Tüm Türkiye’ye ücretsiz kargo.</p>\n</div>"
  },
  {
    "id": "creavit-9696446808361",
    "brand": "Creavit",
    "title": "Free Rim-Off Duroplast Yavaş Kapanan Klozet Kapaklı Nil Yeşili Set",
    "category": "Rim-Off Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free1.jpg?v=1754555194",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free1.jpg?v=1754555194",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free2.jpg?v=1754555194"
    ],
    "price": "23478.00",
    "sku": "SET.FE322DP.NY",
    "tags": [
      "asma klozet",
      "free",
      "kanalsız klozet",
      "Nil Yeşili"
    ],
    "variants": [
      {
        "id": 52843171447081,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.FE322DP.NY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "23478.00",
        "grams": 0,
        "compare_at_price": "33540.00",
        "position": 1,
        "product_id": 9696446808361,
        "created_at": "2026-03-17T12:42:05+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h2>Creavit Free Rim-Off Kanalsız Asma Klozet - Mat Nil Yeşili</h2>\r\n<p><strong>Ürün Kodu:</strong> FE322-00NY00E-0000</p>\r\n<p><strong>Seri:</strong> Free</p>\r\n<p><strong>Renk:</strong> Mat Nil Yeşili</p>\r\n<p><strong>Ölçüler:</strong> 510 x 355 mm</p>\r\n<p><strong>Montaj Tipi:</strong> Duvara asma (asma klozet)</p>\r\n<p><strong>Pis Su Çıkışı:</strong> Duvardan</p>\r\n<p><strong>Taharet Borusu:</strong> Var</p>\r\n<p><strong>Klozet Kapağı:</strong> Dahildir; KC0903.01.2000E</p>\r\n<p><strong>Garanti Süresi:</strong> 12 Yıl</p>\r\n<p><strong>Üretim Yeri:</strong> Türkiye</p>\r\n<h3>Rim-Off Teknolojisi</h3>\r\n<p>Kanalsız iç yapısı sayesinde, bakterilerin ve kirlerin birikmesini önler. Bu sayede temizlik daha kolay ve hijyenik hale gelir.</p>\r\n<h4>Not:</h4>\r\n<p>Ürünün düzgün çalışabilmesi için uyumlu bir gömme rezervuar gereklidir. Gömme rezervuar ürüne dahil değildir ve ayrıca sipariş edilmelidir.</p>\r\n<p>Bu ürün, hem estetik tasarımı hem de fonksiyonel özellikleriyle banyonuza modern bir dokunuş katacaktır.</p>"
  },
  {
    "id": "creavit-9696439566633",
    "brand": "Creavit",
    "title": "Free Rim-Off Duroplast Yavaş Kapanan Klozet Kapaklı İnci Mat Beyaz Set",
    "category": "Rim-Off Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/10.png?v=1749541919",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/10.png?v=1749541919",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/11.png?v=1749541919",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-free-9.png?v=1749541919",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-elegant-kapak8.jpg?v=1749541919",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-free-7_d02629c8-8e52-48c1-8b56-e57d07cbe13e.png?v=1749541919",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-free-5_64b395e0-12fd-4b35-9a36-04ade1307ba2.png?v=1749541919"
    ],
    "price": "21168.00",
    "sku": "SET.FE322DP.MB",
    "tags": [
      "asma klozet",
      "asma klozet set",
      "free",
      "İnci Beyaz",
      "kanalsız klozet"
    ],
    "variants": [
      {
        "id": 52843171348777,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.FE322DP.MB",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "21168.00",
        "grams": 0,
        "compare_at_price": "30240.00",
        "position": 1,
        "product_id": 9696439566633,
        "created_at": "2026-03-17T12:42:02+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h3>Creavit Free Rim-Off Kanalsız Asma Klozet - İnci Mat Beyaz</h3>\n<p><strong>Ürün Kodu:</strong> FE322-00MB00E-0000</p>\n<p><strong>Seri:</strong> Free</p>\n<p><strong>Renk:</strong> İnci Mat Beyaz</p>\n<p><strong>Ölçüler:</strong> 510 x 355 mm</p>\n<p><strong>Montaj Tipi:</strong> Duvara asma (asma klozet)</p>\n<p><strong>Pis Su Çıkışı:</strong> Duvardan</p>\n<p><strong>Taharet Borusu:</strong> Var</p>\n<p><strong>Klozet Kapağı:</strong> Dahildir; KC0903.01.0100E</p>\n<p><strong>Garanti Süresi:</strong> 12 Yıl</p>\n<p><strong>Üretim Yeri:</strong> Türkiye</p>\n<h3>Rim-Off Teknolojisi</h3>\n<p>Kanalsız iç yapısı sayesinde, bakterilerin ve kirlerin birikmesini önler. Bu sayede temizlik daha kolay ve hijyenik hale gelir.</p>\n<h4>Not: </h4>\n<p>Ürünün düzgün çalışabilmesi için uyumlu bir gömme rezervuar gereklidir. Gömme rezervuar ürüne dahil değildir ve ayrıca sipariş edilmelidir.</p>\n<p>Bu ürün, hem estetik tasarımı hem de fonksiyonel özellikleriyle banyonuza modern bir dokunuş katacaktır.</p>"
  },
  {
    "id": "creavit-9696392380713",
    "brand": "Creavit",
    "title": "Free Rim-Off Duroplast Yavaş Kapanan Klozet Kapaklı Kömür Karası Set",
    "category": "Rim-Off Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/FE320-00KK00E-0000_-_3.jpg?v=1758110903",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/FE320-00KK00E-0000_-_3.jpg?v=1758110903",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/FE322-00KK00E-0000_-3.jpg?v=1758110903",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/FE322-00KK00E-0000.jpg?v=1758110902",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/KC0903.01.2100E.jpg?v=1758110902"
    ],
    "price": "23478.00",
    "sku": "SET.FE322DP.KK",
    "tags": [
      "asma klozet",
      "free",
      "kanalsız klozet",
      "Kömür Karası"
    ],
    "variants": [
      {
        "id": 52843171217705,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.FE322DP.KK",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "23478.00",
        "grams": 0,
        "compare_at_price": "33540.00",
        "position": 1,
        "product_id": 9696392380713,
        "created_at": "2026-03-17T12:41:59+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h2>Creavit Free Rim-Off Kanalsız Asma Klozet - Kömür Karası</h2>\n<p><strong>Ürün Kodu:</strong> FE322-00KK00E-0000</p>\n<p><strong>Seri:</strong> Free</p>\n<p><strong>Renk:</strong> Kömür Karası</p>\n<p><strong>Ölçüler:</strong> 510 x 355 mm</p>\n<p><strong>Montaj Tipi:</strong> Duvara asma (asma klozet)</p>\n<p><strong>Pis Su Çıkışı:</strong> Duvardan</p>\n<p><strong>Taharet Borusu:</strong> Var</p>\n<p><strong>Klozet Kapağı:</strong> Dahildir; KC0903.01.2100E</p>\n<p><strong>Garanti Süresi:</strong> 12 Yıl</p>\n<p><strong>Üretim Yeri:</strong> Türkiye</p>\n<h3>Rim-Off Teknolojisi</h3>\n<p>Kanalsız iç yapısı sayesinde, bakterilerin ve kirlerin birikmesini önler. Bu sayede temizlik daha kolay ve hijyenik hale gelir.</p>\n<h4>Not: Ürünün düzgün çalışabilmesi için uyumlu bir gömme rezervuar gereklidir. Gömme rezervuar ürüne dahil değildir ve ayrıca sipariş edilmelidir.</h4>\n<p>Bu ürün, hem estetik tasarımı hem de fonksiyonel özellikleriyle banyonuza modern bir dokunuş katacaktır.</p>"
  },
  {
    "id": "creavit-9696382812457",
    "brand": "Creavit",
    "title": "Free Rim-Off Duroplast Yavaş Kapanan Klozet Kapaklı Cool Grey Set",
    "category": "Rim-Off Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/freeg1.jpg?v=1754555373",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/freeg1.jpg?v=1754555373",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/freeg2.jpg?v=1754555373"
    ],
    "price": "23478.00",
    "sku": "SET.FE322DP.CG",
    "tags": [
      "asma klozet",
      "asma klozet set",
      "Cool Grey",
      "free",
      "kanalsız klozet"
    ],
    "variants": [
      {
        "id": 52843171086633,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.FE322DP.CG",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "23478.00",
        "grams": 0,
        "compare_at_price": "33540.00",
        "position": 1,
        "product_id": 9696382812457,
        "created_at": "2026-03-17T12:41:56+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h4>Rim-Off Teknolojisi</h4>\n<p>Kanalsız iç yapısı sayesinde, bakterilerin ve kirlerin birikmesini önler. Bu sayede temizlik daha kolay ve hijyenik hale gelir.</p>\n<h4>Not: Ürünün düzgün çalışabilmesi için uyumlu bir gömme rezervuar gereklidir. Gömme rezervuar ürüne dahil değildir ve ayrıca sipariş edilmelidir.</h4>\n<p>Bu ürün, hem estetik tasarımı hem de fonksiyonel özellikleriyle banyonuza modern bir dokunuş katacaktır.</p>\n<p><strong>Ürün Kodu:</strong> FE322-00CG00E-0000</p>\n<p><strong>Seri:</strong> Free</p>\n<p><strong>Renk:</strong> Cool Grey Mat</p>\n<p><strong>Ölçüler:</strong> 510 x 355 mm</p>\n<p><strong>Montaj Tipi:</strong> Duvara asma (asma klozet)</p>\n<p><strong>Pis Su Çıkışı:</strong> Duvardan</p>\n<p><strong>Taharet Borusu:</strong> Var</p>\n<p><strong>Klozet Kapağı:</strong> Dahildir; KC0903.01.1800E</p>\n<p><strong>Garanti Süresi:</strong> 12 Yıl</p>\n<p><strong>Üretim Yeri:</strong> Türkiye</p>"
  },
  {
    "id": "creavit-9696369443113",
    "brand": "Creavit",
    "title": "Free Rim-Off Duroplast Yavaş Kapanan Klozet Kapaklı Berry Set",
    "category": "Rim-Off Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/10_7a324005-3c6c-4897-adf4-d25aa0920d7e.png?v=1749542438",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/10_7a324005-3c6c-4897-adf4-d25aa0920d7e.png?v=1749542438",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/11_5f2953c8-7a5f-456d-a97e-6cf1a9400476.png?v=1749542438",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-free-6.png?v=1749542438",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-free-rim-off-kanalsiz-cool-berry-asma-klozet-2.png?v=1749542438",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-free-8_9ba22e58-c7d2-453d-8f8e-b0782b6c459b.png?v=1749542438",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-elegant-kapak9.jpg?v=1749542438",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-free-5_293bcefd-ec2d-4e7a-9e1a-ed01ab02a69f.png?v=1749542438",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-free-1.png?v=1749542438"
    ],
    "price": "23478.00",
    "sku": "SET.FE322DP.BR",
    "tags": [
      "asma klozet",
      "asma klozet set",
      "Berry",
      "free",
      "kanalsız klozet"
    ],
    "variants": [
      {
        "id": 52843170955561,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.FE322DP.BR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "23478.00",
        "grams": 0,
        "compare_at_price": "33540.00",
        "position": 1,
        "product_id": 9696369443113,
        "created_at": "2026-03-17T12:41:53+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h2>Creavit Free Rim-Off Kanalsız Asma Klozet - Berry Mat</h2>\n<p><strong>Ürün Kodu:</strong> FE322-00BR00E-0000</p>\n<p><strong>Seri:</strong> Free</p>\n<p><strong>Renk:</strong> Berry Mat</p>\n<p><strong>Ölçüler:</strong> 510 x 355 mm</p>\n<p><strong>Montaj Tipi:</strong> Duvara asma (asma klozet)</p>\n<p><strong>Pis Su Çıkışı:</strong> Duvardan</p>\n<p><strong>Taharet Borusu:</strong> Var</p>\n<p><strong>Klozet Kapağı:</strong> Dahildir; KC0903.01.1900E</p>\n<p><strong>Garanti Süresi:</strong> 12 Yıl</p>\n<p><strong>Üretim Yeri:</strong> Türkiye</p>\n<h3>Rim-Off Teknolojisi</h3>\n<p>Kanalsız iç yapısı sayesinde, bakterilerin ve kirlerin birikmesini önler. Bu sayede temizlik daha kolay ve hijyenik hale gelir.</p>\n<h4>Not: Ürünün düzgün çalışabilmesi için uyumlu bir gömme rezervuar gereklidir. Gömme rezervuar ürüne dahil değildir ve ayrıca sipariş edilmelidir.</h4>\n<p>Bu ürün, hem estetik tasarımı hem de fonksiyonel özellikleriyle banyonuza modern bir dokunuş katacaktır.</p>"
  },
  {
    "id": "creavit-9696195281193",
    "brand": "Creavit",
    "title": "Elegant Rim-Off Duroplast Yavaş Kapanan Klozet Kapaklı Nil Yeşili Set",
    "category": "Rim-Off Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/10_4869f538-fe5c-4c42-95c7-bae3ce5cd540.png?v=1749542905",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/10_4869f538-fe5c-4c42-95c7-bae3ce5cd540.png?v=1749542905",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/11_d4388c9d-99c1-403b-9a6a-e5631c4c7289.png?v=1749542905",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-eg321-8_bc81aaf5-e6c9-43b1-90d8-c8fa259b4779.jpg?v=1749542905",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-elegant-kapak5.jpg?v=1749542905",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-eg321-3_00f7127b-0cb2-4386-ac74-14b4e66c84cc.jpg?v=1749542905",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-elegant-kapak2_f80d2ea3-a572-48b6-bd4f-5c414dda897b.jpg?v=1749544550",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-elegant-kapak3_92c93fb2-7a00-4dc5-8e7c-8cc65edced88.jpg?v=1749544550",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-eg321-4_e9123964-0cc2-491e-b1db-8fc6575c39f5.jpg?v=1749544550",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-eg321-7_f9997ad2-d74d-4949-a9df-0206ed92eb2d.jpg?v=1749544550"
    ],
    "price": "23562.00",
    "sku": "SET.EG321DP.NY",
    "tags": [
      "asma klozet",
      "asma klozet set",
      "elegant",
      "kanalsız klozet",
      "Nil Yeşili"
    ],
    "variants": [
      {
        "id": 52843173249321,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.EG321DP.NY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "23562.00",
        "grams": 0,
        "compare_at_price": "33660.00",
        "position": 1,
        "product_id": 9696195281193,
        "created_at": "2026-03-17T12:42:44+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h2>Creavit Elegant Rim-Off Kanalsız Asma Klozet - Mat Nil Yeşili</h2>\n<p><strong>Ürün Kodu:</strong> EG321-00NY00E-0000</p>\n<p><strong>Seri:</strong> Elegant</p>\n<p><strong>Renk:</strong> Mat Nil Yeşili</p>\n<p><strong>Ölçüler:</strong> 513 x 370 mm</p>\n<p><strong>Tasarım:</strong> Köşeli dış hatlara sahip, modern ve estetik görünüm</p>\n<p><strong>Montaj Tipi:</strong> Duvara asma (asma klozet)</p>\n<p><strong>Pis Su Çıkışı:</strong> Duvardan</p>\n<p><strong>Taharet Borusu:</strong> Var</p>\n<p><strong>Klozet Kapağı:</strong> Dahildir; KC1103.01.2000E</p>\n<p><strong>Garanti Süresi:</strong> 12 Yıl</p>\n<p><strong>Üretim Yeri:</strong> Türkiye</p>\n<h3>Rim-Off Teknolojisi</h3>\n<p>Kanalsız iç yapısı sayesinde bakterilerin ve kirlerin birikmesini önler. Bu sayede temizlik daha kolay ve hijyenik hale gelir.</p>\n<h4>Not:</h4>\n<p>Ürünün düzgün çalışabilmesi için uyumlu bir gömme rezervuar gereklidir. Gömme rezervuar ürüne dahil değildir ve ayrıca sipariş edilmelidir.</p>"
  },
  {
    "id": "creavit-9696190169385",
    "brand": "Creavit",
    "title": "Elegant Kanalsız Asma Klozet + Duroplast Yavaş Kapanan Klozet Kapağı İnci Mat Beyaz - Set",
    "category": "Rim-Off Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-rim-off-duroplast-yavas-kapanan-klozet-kapakli-inci-mat-beyaz-set-7331.png?v=1746780917",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-rim-off-duroplast-yavas-kapanan-klozet-kapakli-inci-mat-beyaz-set-7331.png?v=1746780917",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-eg321-1_d08c0704-92dd-47ce-8615-2f1954b6ab42.jpg?v=1748955122",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-eg321-2_38a1d752-3efb-49f0-8d8a-527b63cf47be.jpg?v=1748955122",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-eg321-3_b8fc5c19-691e-42e6-a3b9-9a829b1064bb.jpg?v=1748955122",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-eg321-9.jpg?v=1748955122",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-rim-off-duroplast-yavas-kapanan-klozet-kapakli-inci-mat-beyaz-set-7332.png?v=1748955122"
    ],
    "price": "21252.00",
    "sku": "SET.EG321DP.MB",
    "tags": [
      "asma klozet",
      "asma klozet set",
      "Beyaz",
      "elegant",
      "kanalsız klozet",
      "rim-off"
    ],
    "variants": [
      {
        "id": 52843173118249,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.EG321DP.MB",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "21252.00",
        "grams": 0,
        "compare_at_price": "30360.00",
        "position": 1,
        "product_id": 9696190169385,
        "created_at": "2026-03-17T12:42:41+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h2>Creavit Elegant Rim-Off Kanalsız Asma Klozet - Mat Beyaz</h2>\n<p><strong>Ürün Kodu:</strong> EG321-00MB00E-0000</p>\n<p><strong>Seri:</strong> Elegant</p>\n<p><strong>Renk:</strong> Mat Beyaz</p>\n<p><strong>Ölçüler:</strong> 513 x 370 mm</p>\n<p><strong>Tasarım:</strong> Köşeli dış hatlara sahip, modern ve estetik görünüm</p>\n<p><strong>Montaj Tipi:</strong> Duvara asma (asma klozet)</p>\n<p><strong>Pis Su Çıkışı:</strong> Duvardan</p>\n<p><strong>Taharet Borusu:</strong> Var</p>\n<p><strong>Klozet Kapağı:</strong> Dahildir; KC1103.01.0100E</p>\n<p><strong>Garanti Süresi:</strong> 12 Yıl</p>\n<p><strong>Üretim Yeri:</strong> Türkiye</p>\n<h3>Rim-Off Teknolojisi</h3>\n<p>Kanalsız iç yapısı sayesinde bakterilerin ve kirlerin birikmesini önler. Bu sayede temizlik daha kolay ve hijyenik hale gelir.</p>\n<h4>Not:</h4>\n<p>Ürünün düzgün çalışabilmesi için uyumlu bir gömme rezervuar gereklidir. Gömme rezervuar ürüne dahil değildir ve ayrıca sipariş edilmelidir.</p>"
  },
  {
    "id": "creavit-9696182403369",
    "brand": "Creavit",
    "title": "Elegant Rim-Off Duroplast Yavaş Kapanan Klozet Kapaklı Kömür Karası Set",
    "category": "Rim-Off Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/EG321-00KK00E-0000_-_2.jpg?v=1758109249",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/EG321-00KK00E-0000_-_2.jpg?v=1758109249",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/EG321-00KK00E-0000._-_3.jpg?v=1758109249",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/EG321-00KK00E-0000.jpg?v=1758109249",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/KC1103.01.2100E.jpg?v=1758109249"
    ],
    "price": "23562.00",
    "sku": "SET.EG321DP.KK",
    "tags": [
      "asma klozet",
      "asma klozet set",
      "elegant",
      "kanalsız klozet",
      "Kömür Karası"
    ],
    "variants": [
      {
        "id": 52843172987177,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.EG321DP.KK",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "23562.00",
        "grams": 0,
        "compare_at_price": "33660.00",
        "position": 1,
        "product_id": 9696182403369,
        "created_at": "2026-03-17T12:42:38+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h2>Creavit Elegant Rim-Off Kanalsız Asma Klozet - Kömür Karası</h2>\r\n<p><strong>Ürün Kodu:</strong> EG321-00KK00E-0000</p>\r\n<p><strong>Seri:</strong> Elegant</p>\r\n<p><strong>Renk:</strong> Kömür Karası</p>\r\n<p><strong>Ölçüler:</strong> 513 x 370 mm</p>\r\n<p><strong>Tasarım:</strong> Köşeli dış hatlara sahip, modern ve estetik görünüm</p>\r\n<p><strong>Montaj Tipi:</strong> Duvara asma (asma klozet)</p>\r\n<p><strong>Pis Su Çıkışı:</strong> Duvardan</p>\r\n<p><strong>Taharet Borusu:</strong> Var</p>\r\n<p><strong>Klozet Kapağı:</strong> Dahildir; KC1103.01.2100E</p>\r\n<p><strong>Garanti Süresi:</strong> 12 Yıl</p>\r\n<p><strong>Üretim Yeri:</strong> Türkiye</p>\r\n<h3>Rim-Off Teknolojisi</h3>\r\n<p>Kanalsız iç yapısı sayesinde bakterilerin ve kirlerin birikmesini önler. Bu sayede temizlik daha kolay ve hijyenik hale gelir.</p>\r\n<h4>Not:</h4>\r\n<p>Ürünün düzgün çalışabilmesi için uyumlu bir gömme rezervuar gereklidir. Gömme rezervuar ürüne dahil değildir ve ayrıca sipariş edilmelidir.</p>"
  },
  {
    "id": "creavit-9696168739113",
    "brand": "Creavit",
    "title": "Elegant Rim-Off Duroplast Yavaş Kapanan Klozet Kapaklı Cool Grey Set",
    "category": "Rim-Off Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/10_ee9f9695-789e-402a-9caf-81be470c2947.png?v=1749544879",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/10_ee9f9695-789e-402a-9caf-81be470c2947.png?v=1749544879",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/11_6542a2d0-83a3-42a9-8a76-e424e2928ab5.png?v=1749544879",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-eg321-8_1_184c3343-b6a9-4746-91aa-fda7a9866eb6.jpg?v=1749544879",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-elegant-kapak9_1_36c71651-3be2-431f-80f0-c85ad30452df.jpg?v=1749544879",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-eg321-3_1d8b4c31-98e9-441b-87bd-182e5943f595.jpg?v=1749544879",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-elegant-kapak2_a933e445-bd68-4da8-aaf3-9b3895d9b547.jpg?v=1749544879",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-elegant-kapak3_01275af2-9215-4b70-a220-bf7ddffb9d45.jpg?v=1749544879",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-eg321-4_cc481aa7-79d1-4bdd-b7ed-7ce946ba8d2a.jpg?v=1749544879",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-eg321-7_ef040de0-4c70-46ae-9164-77e6235256f3.jpg?v=1749544879"
    ],
    "price": "23562.00",
    "sku": "SET.EG321DP.CG",
    "tags": [
      "asma klozet",
      "asma klozet set",
      "Cool Grey",
      "elegant",
      "kanalsız klozet"
    ],
    "variants": [
      {
        "id": 52843172790569,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.EG321DP.CG",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "23562.00",
        "grams": 0,
        "compare_at_price": "33660.00",
        "position": 1,
        "product_id": 9696168739113,
        "created_at": "2026-03-17T12:42:32+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h2>Creavit Elegant Rim-Off Kanalsız Asma Klozet - Mat Cool Grey</h2>\r\n<p><strong>Ürün Kodu:</strong> EG321-00CG00E-0000</p>\r\n<p><strong>Seri:</strong> Elegant</p>\r\n<p><strong>Renk:</strong> Mat Cool Grey</p>\r\n<p><strong>Ölçüler:</strong> 513 x 370 mm</p>\r\n<p><strong>Tasarım:</strong> Köşeli dış hatlara sahip, modern ve estetik görünüm</p>\r\n<p><strong>Montaj Tipi:</strong> Duvara asma (asma klozet)</p>\r\n<p><strong>Pis Su Çıkışı:</strong> Duvardan</p>\r\n<p><strong>Taharet Borusu:</strong> Var</p>\r\n<p><strong>Klozet Kapağı:</strong> Dahildir; KC1103.01.1800E</p>\r\n<p><strong>Garanti Süresi:</strong> 12 Yıl</p>\r\n<p><strong>Üretim Yeri:</strong> Türkiye</p>\r\n<h3>Rim-Off Teknolojisi</h3>\r\n<p>Kanalsız iç yapısı sayesinde bakterilerin ve kirlerin birikmesini önler. Bu sayede temizlik daha kolay ve hijyenik hale gelir.</p>\r\n<h4>Not:</h4>\r\n<p>Ürünün düzgün çalışabilmesi için uyumlu bir gömme rezervuar gereklidir. Gömme rezervuar ürüne dahil değildir ve ayrıca sipariş edilmelidir.</p>"
  },
  {
    "id": "creavit-9696163725609",
    "brand": "Creavit",
    "title": "Elegant Rim-Off Duroplast Yavaş Kapanan Klozet Kapaklı Mat Berry Set",
    "category": "Rim-Off Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/10_acabbdd9-52d8-4c2f-89dc-0b0a2fff8bde.png?v=1749543463",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/10_acabbdd9-52d8-4c2f-89dc-0b0a2fff8bde.png?v=1749543463",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/11_73ac6b6c-f970-4899-8cd7-a854424a9628.png?v=1749543463",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-elegant-kapak9_1_01773b37-cc83-4a0a-a046-bab80d6f95d7.jpg?v=1749544639",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-eg321-8_1_15b30517-03c0-4035-97f0-6e4260e00528.jpg?v=1749544639",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-eg321-3_de30c2be-7672-4274-b4cc-ccd81e806f1e.jpg?v=1749544639",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-elegant-kapak2_a033ec78-1296-4553-8152-59514016edec.jpg?v=1749544639",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-elegant-kapak3_11eb4ef2-be77-4ab8-a2fa-820cfab68d61.jpg?v=1749544639",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-eg321-4_a6dbf637-2534-4b6c-aa39-9ca2adb1c053.jpg?v=1749544639",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-eg321-7_99248ea3-5627-4358-a805-abe46b4f536b.jpg?v=1749544639"
    ],
    "price": "23562.00",
    "sku": "SET.EG321DP.BR",
    "tags": [
      "asma klozet",
      "asma klozet set",
      "Berry",
      "elegant",
      "kanalsız klozet"
    ],
    "variants": [
      {
        "id": 52843172659497,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.EG321DP.BR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "23562.00",
        "grams": 0,
        "compare_at_price": "33660.00",
        "position": 1,
        "product_id": 9696163725609,
        "created_at": "2026-03-17T12:42:29+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h2>Creavit Elegant Rim-Off Kanalsız Asma Klozet - Mat Berry</h2>\n<p><strong>Ürün Kodu:</strong> EG321-00BR00E-0000</p>\n<p><strong>Seri:</strong> Elegant</p>\n<p><strong>Renk:</strong> Mat Berry</p>\n<p><strong>Ölçüler:</strong> 513 x 370 mm</p>\n<p><strong>Tasarım:</strong> Köşeli dış hatlara sahip, modern ve estetik görünüm</p>\n<p><strong>Montaj Tipi:</strong> Duvara asma (asma klozet)</p>\n<p><strong>Pis Su Çıkışı:</strong> Duvardan</p>\n<p><strong>Taharet Borusu:</strong> Var</p>\n<p><strong>Klozet Kapağı:</strong> Dahildir; KC1103.01.1900E</p>\n<p><strong>Garanti Süresi:</strong> 12 Yıl</p>\n<p><strong>Üretim Yeri:</strong> Türkiye</p>\n<h3>Rim-Off Teknolojisi</h3>\n<p>Kanalsız iç yapısı sayesinde bakterilerin ve kirlerin birikmesini önler. Bu sayede temizlik daha kolay ve hijyenik hale gelir.</p>\n<h4>Not:</h4>\n<p>Ürünün düzgün çalışabilmesi için uyumlu bir gömme rezervuar gereklidir. Gömme rezervuar ürüne dahil değildir ve ayrıca sipariş edilmelidir.</p>"
  },
  {
    "id": "creavit-9696152748329",
    "brand": "Creavit",
    "title": "Elegant Rim-Off Duroplast Yavaş Kapanan Klozet Kapaklı Mat Antrasit Set",
    "category": "Rim-Off Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/10_22071e5b-ca31-4051-820a-9daa14c2b1d7.png?v=1749544306",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/10_22071e5b-ca31-4051-820a-9daa14c2b1d7.png?v=1749544306",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/11_f4fb4d54-54d3-42ac-9286-27a76b504576.png?v=1749544305",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-elegant-kapak9_1_b5db5634-2f22-4ff4-b928-14db59d7855f.jpg?v=1749544661",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-eg321-8_1_affd86b9-0879-4cf0-a545-85fe608abf60.jpg?v=1749544661",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-eg321-3_1d8b4c31-98e9-441b-87bd-182e5943f595.jpg?v=1749544879",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-elegant-kapak2_940ec739-c6f6-4df2-a215-b6e4badbb722.jpg?v=1749544661",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-elegant-kapak3_9e74f75b-8519-47d5-9305-2a58e518e52a.jpg?v=1749544661",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-eg321-4_cc481aa7-79d1-4bdd-b7ed-7ce946ba8d2a.jpg?v=1749544879",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-eg321-7_ef040de0-4c70-46ae-9164-77e6235256f3.jpg?v=1749544879"
    ],
    "price": "23562.00",
    "sku": "SET.EG321DP.AM",
    "tags": [
      "asma klozet",
      "asma klozet set",
      "elegant",
      "kanalsız klozet",
      "Mat Antrasit"
    ],
    "variants": [
      {
        "id": 52843172430121,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.EG321DP.AM",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "23562.00",
        "grams": 0,
        "compare_at_price": "33660.00",
        "position": 1,
        "product_id": 9696152748329,
        "created_at": "2026-03-17T12:42:26+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h3>Creavit Elegant Rim-Off Kanalsız Asma Klozet - Mat Antrasit</h3>\r\n<p><strong>Ürün Kodu:</strong> EG321-00AM00E-0000</p>\r\n<p><strong>Seri:</strong> Elegant</p>\r\n<p><strong>Renk:</strong> Mat Antrasit</p>\r\n<p><strong>Ölçüler:</strong> 513 x 370 mm</p>\r\n<p><strong>Tasarım:</strong> Köşeli dış hatlara sahip, modern ve estetik görünüm</p>\r\n<p><strong>Montaj Tipi:</strong> Duvara asma (asma klozet)</p>\r\n<p><strong>Pis Su Çıkışı:</strong> Duvardan</p>\r\n<p><strong>Taharet Borusu:</strong> Var</p>\r\n<p><strong>Klozet Kapağı:</strong> Dahildir; KC1103.01.0400E</p>\r\n<p><strong>Garanti Süresi:</strong> 12 Yıl</p>\r\n<p><strong>Üretim Yeri:</strong> Türkiye</p>\r\n<h3>Rim-Off Teknolojisi</h3>\r\n<p>Kanalsız iç yapısı sayesinde bakterilerin ve kirlerin birikmesini önler. Bu sayede temizlik daha kolay ve hijyenik hale gelir.</p>\r\n<h4>Not:</h4>\r\n<p>Ürünün düzgün çalışabilmesi için uyumlu bir gömme rezervuar gereklidir. Gömme rezervuar ürüne dahil değildir ve ayrıca sipariş edilmelidir.</p>"
  },
  {
    "id": "creavit-9695055970601",
    "brand": "Creavit",
    "title": "Lavabo Sifon Başlığı Pop-up Taşmasız Cool Grey",
    "category": "Lavabo Sifonları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lav-sifon-basligi-pop-up-tsmsz-cool-grey-7314.jpg?v=1746691293",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lav-sifon-basligi-pop-up-tsmsz-cool-grey-7314.jpg?v=1746691293"
    ],
    "price": "1890.00",
    "sku": "SFU.SF030.CGR",
    "tags": [
      "banyo aksesuarı",
      "Gri",
      "Lavabo Gideri",
      "Lavabo Sifon Başlığı",
      "Lavabo Sifonu",
      "Taşmasız Sifon"
    ],
    "variants": [
      {
        "id": 52920470733097,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SFU.SF030.CGR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1890.00",
        "grams": 0,
        "compare_at_price": "2520.00",
        "position": 1,
        "product_id": 9695055970601,
        "created_at": "2026-04-03T10:11:23+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\n<p><span>Creavit lavabo sifonları banyo ve lavabo alanlarınızı daha hijyenik, temiz ve işlevsel hale getirmek için tasarlandı. Ayrıca pratik kullanımları sayesinde suyun sorunsuz bir şekilde akmasını ve atıkların hızlıca uzaklaştırılmasını garanti ederken, yüksek kaliteli malzemelerle banyo ve lavabonuzun görünümünü tamamlar.</span></p>"
  },
  {
    "id": "creavit-9695029526825",
    "brand": "Creavit",
    "title": "Terra Asma Klozet Gömme Rezervuarlı Set",
    "category": "462592246057",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-asma-klozet-termoplast-kapak-gri-kumanda-paneli-gomme-rezervuar-ara-kesme-valfi-set-6613_4ec4e329-9929-44ec-a8ba-b483d1c7e0bf.png?v=1747382510",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-asma-klozet-termoplast-kapak-gri-kumanda-paneli-gomme-rezervuar-ara-kesme-valfi-set-6613_4ec4e329-9929-44ec-a8ba-b483d1c7e0bf.png?v=1747382510",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-asma-klozet-gomme-rezervuarli-set-7308.jpg?v=1747382510",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-asma-klozet-gomme-rezervuarli-set-7309.jpg?v=1747382510",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-asma-klozet-gomme-rezervuarli-set-7310.jpg?v=1747382510",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-asma-klozet-gomme-rezervuarli-set-7311.jpg?v=1747382510",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-asma-klozet-gomme-rezervuarli-set-7312.jpg?v=1747382510",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-asma-klozet-gomme-rezervuarli-set-7313.png?v=1747382510"
    ],
    "price": "17682.00",
    "sku": "TP325.CB.SET",
    "tags": [
      "asma klozet",
      "asma klozet set"
    ],
    "variants": [
      {
        "id": 52843243634985,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "TP325.CB.SET",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "17682.00",
        "grams": 0,
        "compare_at_price": "25260.00",
        "position": 1,
        "product_id": 9695029526825,
        "created_at": "2026-03-17T13:04:29+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h3>TP325-00CB00E-0000 Asma Klozet – Beyaz (Terra Serisi)</h3>\n<p><strong>Creavit Terra</strong> serisinin bu beyaz asma klozeti, modern banyolar için estetik ve fonksiyonelliği bir arada sunar. Yumuşak hatları, pürüzsüz yüzeyi ve kullanıcı dostu özellikleriyle uzun ömürlü bir deneyim sağlar.</p>\n<h3>Teknik Özellikler:</h3>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> TP325-00CB00E-0000</li>\n<li>\n<strong>Seri:</strong> Terra</li>\n<li>\n<strong>Renk:</strong> Beyaz</li>\n<li>\n<strong>Boyutlar:</strong> 355 mm (Genişlik) x 345 mm (Yükseklik) x 508 mm (Derinlik)</li>\n<li>\n<strong>Montaj Tipi:</strong> Duvara asma</li>\n<li>\n<strong>Pis Su Çıkışı:</strong> Duvardan</li>\n<li>\n<strong>Yıkama Sistemi:</strong> Kanallı</li>\n<li>\n<strong>Taharet Borusu:</strong> Dahildir</li>\n<li>\n<strong>Klozet Kapağı:</strong> Yavaş kapanır kapak dahil (Kod: KC0903.03.0000E)</li>\n<li>\n<strong>Gömme Rezervuar: </strong>Dahildir GR5001</li>\n<li>\n<strong>Kumanda Paneli:</strong> Dahildir GP9002.00</li>\n<li>\n<strong>Ara Musluk:</strong> Dahildir. MS.AC50L</li>\n<li>\n<strong>Ürün Ağırlığı:</strong> 24,3 kg</li>\n<li>\n<strong>Klozet Kapağı Ağırlığı:</strong> 2,55 kg</li>\n<li>\n<strong>Garanti Süresi:</strong> 12 Yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\n<h3>Avantajları: </h3>\n<ul>\n<li>\n<strong>Modern ve Minimalist Tasarım:</strong> Yumuşak köşeleri ve pürüzsüz yüzeyiyle banyonuza şıklık katar.</li>\n<li>\n<strong>Kolay Temizlik:</strong> Asma tasarımı sayesinde klozet altı alanı kolayca temizlenebilir.</li>\n<li>\n<strong>Su Tasarrufu:</strong> 3-6 litre arasında su tüketimi ile çevre dostu bir kullanım sunar.</li>\n<li>\n<strong>Yavaş Kapanır Kapak:</strong> Dahili yavaş kapanır klozet kapağı, sessiz ve konforlu bir kullanım sağlar.</li>\n</ul>\n<p><em>Creavit Terra Asma Klozet, modern banyolar için tasarlanmış şık ve dayanıklı bir tercihtir.</em></p>"
  },
  {
    "id": "creavit-9695017074985",
    "brand": "Creavit",
    "title": "Free Rim-Off Mat Antrasit Renkli Gömme Rezervuar Takım Set",
    "category": "Rim-Off Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-kanalsiz-asma-klozet-antrasit-duroplast-kapak-antrasit-kumanda-paneli-gomme-rezervuar-a-6621_9df01fb4-b175-4c2e-b7d0-2c128a107158.png?v=1747382571",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-kanalsiz-asma-klozet-antrasit-duroplast-kapak-antrasit-kumanda-paneli-gomme-rezervuar-a-6621_9df01fb4-b175-4c2e-b7d0-2c128a107158.png?v=1747382571",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-rim-off-mat-antrasit-renkli-gomme-rezervuar-takim-set-7301.jpg?v=1747382571",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-rim-off-mat-antrasit-renkli-gomme-rezervuar-takim-set-7302.jpg?v=1747382571",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-rim-off-mat-antrasit-renkli-gomme-rezervuar-takim-set-7303.jpg?v=1747382571",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-rim-off-mat-antrasit-renkli-gomme-rezervuar-takim-set-7304.jpg?v=1747382571",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-rim-off-mat-antrasit-renkli-gomme-rezervuar-takim-set-7305.jpg?v=1747382571",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-rim-off-mat-antrasit-renkli-gomme-rezervuar-takim-set-7306.jpg?v=1747382571",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-rim-off-mat-antrasit-renkli-gomme-rezervuar-takim-set-7307.png?v=1747382571"
    ],
    "price": "33054.00",
    "sku": "FE322.AM.SET",
    "tags": [
      "Antrasit",
      "asma klozet",
      "asma klozet set",
      "free",
      "kanalsız klozet"
    ],
    "variants": [
      {
        "id": 52843243110697,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "FE322.AM.SET",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "33054.00",
        "grams": 0,
        "compare_at_price": "47220.00",
        "position": 1,
        "product_id": 9695017074985,
        "created_at": "2026-03-17T13:04:26+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<ul>\n<li>\n<strong>Ürün Kodu:</strong> FE322-00AM00E-0000</li>\n<li>\n<strong>Seri:</strong> Free </li>\n<li>\n<strong>Renk:</strong> Mat Antrasit</li>\n<li>\n<strong>Boyutlar:</strong> 355 mm (Genişlik) x 350 mm (Yükseklik) x 510 mm (Derinlik)</li>\n<li>\n<strong>Montaj Tipi:</strong> Duvara asma (gizli montaj)</li>\n<li>\n<strong>Pis Su Çıkışı:</strong> Duvardan</li>\n<li>\n<strong>Yıkama Sistemi:</strong> Kanalsız (Rim-Off)</li>\n<li>\n<strong>Taharet Borusu:</strong> Dahildir; sadece gizli bağlantı yapılabilir, yandan bağlantı yapılamaz</li>\n<li>\n<strong>Klozet Kapağı:</strong> Dahildir KC0903.01.1400E (Duck Duroplast Yavaş Kapanan Mat Antrasit Klozet Kapağı)</li>\n<li>\n<strong>Gömme Rezervuar:</strong> Dahildir GR5001</li>\n<li>\n<strong>Kumanda Paneli: </strong>Dahildir; GP9002.04</li>\n<li>\n<strong>Ara Musluk:</strong> Dahildir; MS.AC50L.ANM</li>\n<li>\n<strong>Ürün Ağırlığı:</strong> 26,83 kg</li>\n<li>\n<strong>Garanti Süresi:</strong> 12 Yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\n<h4>Öne Çıkan Özellikler</h4>\n<ul>\n<li>\n<strong>Kanalsız Tasarım (Rim-Off):</strong> Geleneksel klozetlerde bulunan yıkama kanalları bu modelde bulunmaz, bu sayede bakteri ve kir birikimi minimize edilir.</li>\n<li>\n<strong>Mat Antrasit Yüzey:</strong> Modern banyolar için şık ve sofistike bir görünüm sunar.</li>\n<li>\n<strong>Kolay Temizlik:</strong> Asma tasarımı sayesinde klozet altı alanı kolayca temizlenebilir.</li>\n<li>\n<strong>Su Tasarrufu:</strong> 3-6 litre arasında su tüketimi ile çevre dostu bir kullanım sağlar.</li>\n</ul>\n<p><strong>Not:</strong> Montaj kiti (gizli montaj seti) ürünle birlikte sunulmaktadır.</p>\n<p><strong>Creavit Free Rim-Off Asma Klozet</strong>, modern tasarımı ve hijyenik özellikleriyle banyonuza değer katacak bir üründür. Yüksek kaliteli malzemesi ve kullanıcı dostu detaylarıyla uzun ömürlü bir kullanım deneyimi sunar.</p>"
  },
  {
    "id": "creavit-9695012356393",
    "brand": "Creavit",
    "title": "Lara Duvara Dayalı Klozet + Thermoplast Yavaş Kapanan Klozet Kapağı Beyaz - Set",
    "category": "Rim-Off Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-beyaz-takim-klozet-duvara-dayali-klozet.png?v=1748864006",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-beyaz-takim-klozet-duvara-dayali-klozet.png?v=1748864006",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7287.jpg?v=1748864006",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7288.jpg?v=1748864006",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7289.jpg?v=1748864006",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7290.png?v=1748864006",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7291.jpg?v=1748864006",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7292.jpg?v=1748864006",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7293.jpg?v=1748864006"
    ],
    "price": "15918.00",
    "sku": "SET.LR360TP.BYZ",
    "tags": [
      "Beyaz",
      "duvara dayalı klozet",
      "Lara",
      "Takım Klozet",
      "Vitrifiye"
    ],
    "variants": [
      {
        "id": 52938328768809,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.LR360TP.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "15918.00",
        "grams": 0,
        "compare_at_price": "22740.00",
        "position": 1,
        "product_id": 9695012356393,
        "created_at": "2026-04-06T20:06:18+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<p><strong>İkonik Tasarım: </strong>Creavit Nova Klozetler banyo tasarımında yenilikçi ve modern bir yaklaşım isteyenlere özel seçenekler sunuyor. Bu özel tasarımlı klozet serisi beyaz rengi ve zarif hatlarıyla, banyonuza sade ve çağdaş bir dokunuş eklerken, aynı zamanda işlevselliğiyle de dikkat çekiyor.</p>\r\n<p data-mce-fragment=\"1\"><span style=\"FONT-FAMILY: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif\"><strong>Bakterilere Yer Bırakmayan Tasarım: </strong>Nova Rim-Off Klozetler, kanalsız tasarımları sayesinde klozet içerisinde temizlik esnasında ulaşılması güç yüzeyleri minimize eder. İç haznede erişilemeyen yüzey olmadığı için bakteri ve türevleri için elverişli ortam oluşmasına engel olur.</span></p>\r\n<p data-mce-fragment=\"1\"><span style=\"FONT-FAMILY: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif\"><strong>Temizlikte Kolaylık: </strong>Creavit sırlama teknolojisi sayesinde klozet üzerinde kireç ve su lekeleri gibi istenmeyen izlerin oluşması engellenir. Banyo temizliğini kolaylaştırırken hijyen seviyelerini de korur.</span></p><!---->"
  },
  {
    "id": "creavit-9694546592041",
    "brand": "Creavit",
    "title": "Letoon Kanalsız Klozet + Duroplast Yavaş Kapanan Klozet Kapağı Beyaz - Set",
    "category": "Rim-Off Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-letoon-kanalsiz-tuvalet-beyaz.png?v=1748865337",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-letoon-kanalsiz-tuvalet-beyaz.png?v=1748865337",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/letoon-rim-off-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7275.jpg?v=1748865337",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/letoon-rim-off-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7276.jpg?v=1748865337",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/letoon-rim-off-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7277.jpg?v=1748865337",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/letoon-rim-off-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7278.png?v=1748865337",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/letoon-rim-off-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7279.jpg?v=1748865337",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/letoon-rim-off-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7280.jpg?v=1748865337"
    ],
    "price": "18228.00",
    "sku": "SET.LT361DP.BYZ",
    "tags": [
      "Beyaz",
      "kanalsız klozet",
      "Letoon",
      "rim-off",
      "Takım Klozet"
    ],
    "variants": [
      {
        "id": 52920963957033,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.LT361DP.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "18228.00",
        "grams": 0,
        "compare_at_price": "26040.00",
        "position": 1,
        "product_id": 9694546592041,
        "created_at": "2026-04-03T12:14:48+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\n<p><strong>İkonik Tasarım: </strong>Creavit Letoon Klozetler banyo tasarımında yenilikçi ve modern bir yaklaşım isteyenlere özel seçenekler sunuyor. Bu özel tasarımlı klozet serisi beyaz rengi ve zarif hatlarıyla, banyonuza sade ve çağdaş bir dokunuş eklerken, aynı zamanda işlevselliğiyle de dikkat çekiyor.</p>\n<p data-mce-fragment=\"1\"><span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;\"><strong>Bakterilere Yer Bırakmayan Tasarım: </strong>Letoon Rim-Off Klozetler, kanalsız tasarımları sayesinde klozet içerisinde temizlik esnasında ulaşılması güç yüzeyleri minimize eder. İç haznede erişilemeyen yüzey olmadığı için bakteri ve türevleri için elverişli ortam oluşmasına engel olur.</span></p>\n<p data-mce-fragment=\"1\"><span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;\"><strong>Temizlikte Kolaylık: </strong>Creavit sırlama teknolojisi sayesinde klozet üzerinde kireç ve su lekeleri gibi istenmeyen izlerin oluşması engellenir. Banyo temizliğini kolaylaştırırken hijyen seviyelerini de korur.</span></p>\n<!---->"
  },
  {
    "id": "creavit-9694545936681",
    "brand": "Creavit",
    "title": "Letoon Kanalsız Klozet + Thermoplast Yavaş Kapanan Klozet Kapağı Beyaz - Set",
    "category": "Rim-Off Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-letoon-kanalsiz-tuvalet-beyaz_3ff3e304-62e0-4ae2-83ee-7bbf72625595.png?v=1748865865",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-letoon-kanalsiz-tuvalet-beyaz_3ff3e304-62e0-4ae2-83ee-7bbf72625595.png?v=1748865865",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/letoon-rim-off-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7271.jpg?v=1748865865",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/letoon-rim-off-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7269.jpg?v=1748865865",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/letoon-rim-off-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7270.jpg?v=1748865865",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/letoon-rim-off-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7272.png?v=1748865864",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/letoon-rim-off-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7273.jpg?v=1748865864",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/letoon-rim-off-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7274.jpg?v=1748865864"
    ],
    "price": "16380.00",
    "sku": "SET.LT361TP.BYZ",
    "tags": [
      "Beyaz",
      "kanalsız klozet",
      "Letoon",
      "rim-off",
      "Takım Klozet"
    ],
    "variants": [
      {
        "id": 52920964088105,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.LT361TP.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "16380.00",
        "grams": 0,
        "compare_at_price": "23400.00",
        "position": 1,
        "product_id": 9694545936681,
        "created_at": "2026-04-03T12:14:51+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\n<p><strong>İkonik Tasarım: </strong>Creavit Letoon Klozetler banyo tasarımında yenilikçi ve modern bir yaklaşım isteyenlere özel seçenekler sunuyor. Bu özel tasarımlı klozet serisi beyaz rengi ve zarif hatlarıyla, banyonuza sade ve çağdaş bir dokunuş eklerken, aynı zamanda işlevselliğiyle de dikkat çekiyor.</p>\n<p data-mce-fragment=\"1\"><span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;\"><strong>Bakterilere Yer Bırakmayan Tasarım: </strong>Letoon Rim-Off Klozetler, kanalsız tasarımları sayesinde klozet içerisinde temizlik esnasında ulaşılması güç yüzeyleri minimize eder. İç haznede erişilemeyen yüzey olmadığı için bakteri ve türevleri için elverişli ortam oluşmasına engel olur.</span></p>\n<p data-mce-fragment=\"1\"><span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;\"><strong>Temizlikte Kolaylık: </strong>Creavit sırlama teknolojisi sayesinde klozet üzerinde kireç ve su lekeleri gibi istenmeyen izlerin oluşması engellenir. Banyo temizliğini kolaylaştırırken hijyen seviyelerini de korur.</span></p>\n<!---->"
  },
  {
    "id": "creavit-9694543479081",
    "brand": "Creavit",
    "title": "Nova Kanalsız Klozet + Duroplast Yavaş Kapanan Klozet Kapağı Beyaz - Set",
    "category": "462595850537",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-nova-kanalsiz-tuvalet-beyaz.png?v=1748866337",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-nova-kanalsiz-tuvalet-beyaz.png?v=1748866337",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/nova-rim-off-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7264.jpg?v=1748866337",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/nova-rim-off-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7263.jpg?v=1748866337",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/nova-rim-off-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7265.jpg?v=1748866337",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/nova-rim-off-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7266.png?v=1748866337",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/nova-rim-off-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7267.jpg?v=1748866330",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/nova-rim-off-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7268.jpg?v=1748866330"
    ],
    "price": "18816.00",
    "sku": "SET.NV361DP.BYZ",
    "tags": [
      "Beyaz",
      "kanalsız klozet",
      "nova",
      "rim-off",
      "Takım Klozet"
    ],
    "variants": [
      {
        "id": 52929276510505,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.NV361DP.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "18816.00",
        "grams": 0,
        "compare_at_price": "26880.00",
        "position": 1,
        "product_id": 9694543479081,
        "created_at": "2026-04-05T00:05:14+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\n<p><strong>İkonik Tasarım: </strong>Creavit Nova Klozetler banyo tasarımında yenilikçi ve modern bir yaklaşım isteyenlere özel seçenekler sunuyor. Bu özel tasarımlı klozet serisi beyaz rengi ve zarif hatlarıyla, banyonuza sade ve çağdaş bir dokunuş eklerken, aynı zamanda işlevselliğiyle de dikkat çekiyor.</p>\n<p data-mce-fragment=\"1\"><span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;\"><strong>Bakterilere Yer Bırakmayan Tasarım: </strong>Nova Rim-Off Klozetler, kanalsız tasarımları sayesinde klozet içerisinde temizlik esnasında ulaşılması güç yüzeyleri minimize eder. İç haznede erişilemeyen yüzey olmadığı için bakteri ve türevleri için elverişli ortam oluşmasına engel olur.</span></p>\n<p data-mce-fragment=\"1\"><span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;\"><strong>Temizlikte Kolaylık: </strong>Creavit sırlama teknolojisi sayesinde klozet üzerinde kireç ve su lekeleri gibi istenmeyen izlerin oluşması engellenir. Banyo temizliğini kolaylaştırırken hijyen seviyelerini de korur.</span></p>\n<!---->"
  },
  {
    "id": "creavit-9694542725417",
    "brand": "Creavit",
    "title": "Mare Kanalsız Klozet + Duroplast Yavaş Kapanan Klozet Kapağı Beyaz - Set",
    "category": "Rim-Off Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-mare-kanalsiz-tuvalet-duvara-dayali-beyaz.png?v=1748939446",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-mare-kanalsiz-tuvalet-duvara-dayali-beyaz.png?v=1748939446",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mare-rim-off-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7257.jpg?v=1748939446",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mare-rim-off-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7258.jpg?v=1748939446",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mare-rim-off-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7256.jpg?v=1748939446",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mare-rim-off-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7259.jpg?v=1748939443",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mare-rim-off-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7260.png?v=1748939443",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mare-rim-off-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7261.jpg?v=1748939443",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mare-rim-off-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7262.jpg?v=1748939443"
    ],
    "price": "21798.00",
    "sku": "SET.MA361DP.BYZ",
    "tags": [
      "Takım Klozet"
    ],
    "variants": [
      {
        "id": 52921474613545,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.MA361DP.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "21798.00",
        "grams": 0,
        "compare_at_price": "31140.00",
        "position": 1,
        "product_id": 9694542725417,
        "created_at": "2026-04-03T14:42:16+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\n<p><strong>İkonik Tasarım: </strong>Creavit Mare Klozetler banyo tasarımında yenilikçi ve modern bir yaklaşım isteyenlere özel seçenekler sunuyor. Bu özel tasarımlı klozet serisi beyaz rengi ve zarif hatlarıyla, banyonuza sade ve çağdaş bir dokunuş eklerken, aynı zamanda işlevselliğiyle de dikkat çekiyor.</p>\n<p data-mce-fragment=\"1\"><span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;\"><strong>Bakterilere Yer Bırakmayan Tasarım: </strong>Mare Rim-Off Klozetler, kanalsız tasarımları sayesinde klozet içerisinde temizlik esnasında ulaşılması güç yüzeyleri minimize eder. İç haznede erişilemeyen yüzey olmadığı için bakteri ve türevleri için elverişli ortam oluşmasına engel olur.</span></p>\n<p data-mce-fragment=\"1\"><span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;\"><strong>Temizlikte Kolaylık: </strong>Creavit sırlama teknolojisi sayesinde klozet üzerinde kireç ve su lekeleri gibi istenmeyen izlerin oluşması engellenir. Banyo temizliğini kolaylaştırırken hijyen seviyelerini de korur.</span></p>\n<!---->"
  },
  {
    "id": "creavit-9694536991017",
    "brand": "Creavit",
    "title": "Solo Kanalsız Klozet + Duroplast Yavaş Kapanan Klozet Kapağı Beyaz - Set",
    "category": "Rim-Off Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-solo-kanalsiz-tuvalet-duvara-dayali-beyaz.png?v=1748940056",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-solo-kanalsiz-tuvalet-duvara-dayali-beyaz.png?v=1748940056",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-rim-off-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7251.jpg?v=1748940056",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-rim-off-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7250.jpg?v=1748940056",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-rim-off-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7252.jpg?v=1748940055",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-rim-off-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7253.png?v=1748940055",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-rim-off-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7254.jpg?v=1748940055",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-rim-off-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7255.jpg?v=1748940055"
    ],
    "price": "22428.00",
    "sku": "SET.SO361DP.BYZ",
    "tags": [
      "Beyaz",
      "duvara dayalı klozet",
      "kanalsız klozet",
      "rim-off",
      "Solo",
      "Takım Klozet"
    ],
    "variants": [
      {
        "id": 52921474908457,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.SO361DP.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "22428.00",
        "grams": 0,
        "compare_at_price": "32040.00",
        "position": 1,
        "product_id": 9694536991017,
        "created_at": "2026-04-03T14:42:19+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\n<p><strong>İkonik Tasarım: </strong>Creavit Solo Klozetler banyo tasarımında yenilikçi ve modern bir yaklaşım isteyenlere özel seçenekler sunuyor. Bu özel tasarımlı klozet serisi beyaz rengi ve zarif hatlarıyla, banyonuza sade ve çağdaş bir dokunuş eklerken, aynı zamanda işlevselliğiyle de dikkat çekiyor.</p>\n<p data-mce-fragment=\"1\"><span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;\"><strong>Bakterilere Yer Bırakmayan Tasarım: </strong>Solo Rim-Off Klozetler, kanalsız tasarımları sayesinde klozet içerisinde temizlik esnasında ulaşılması güç yüzeyleri minimize eder. İç haznede erişilemeyen yüzey olmadığı için bakteri ve türevleri için elverişli ortam oluşmasına engel olur.</span></p>\n<p data-mce-fragment=\"1\"><span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;\"><strong>Temizlikte Kolaylık: </strong>Creavit sırlama teknolojisi sayesinde klozet üzerinde kireç ve su lekeleri gibi istenmeyen izlerin oluşması engellenir. Banyo temizliğini kolaylaştırırken hijyen seviyelerini de korur.</span></p>\n<!---->"
  },
  {
    "id": "creavit-9694519689513",
    "brand": "Creavit",
    "title": "Free Antrasit Asma Klozet ve Duroplast Yavaş Kapanan Klozet Kapağı",
    "category": "Asma Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-antrasit-asma-klozet-ve-duroplast-yavas-kapanan-klozet-kapagi-7190.jpg?v=1754555510",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-antrasit-asma-klozet-ve-duroplast-yavas-kapanan-klozet-kapagi-7190.jpg?v=1754555510",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-antrasit-asma-klozet-ve-duroplast-yavas-kapanan-klozet-kapagi-7191_8292d1ad-85c0-4ac1-9449-bdd0e483c100.jpg?v=1754555510",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-antrasit-asma-klozet-ve-duroplast-yavas-kapanan-klozet-kapagi-7192_da60983d-0902-42cc-bcbd-038e85d3f0b1.jpg?v=1747232215"
    ],
    "price": "20664.00",
    "sku": "SET.FE320DP.AM",
    "tags": [
      "Antrasit",
      "asma klozet",
      "free"
    ],
    "variants": [
      {
        "id": 52843169513769,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.FE320DP.AM",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "20664.00",
        "grams": 0,
        "compare_at_price": "29520.00",
        "position": 1,
        "product_id": 9694519689513,
        "created_at": "2026-03-17T12:41:22+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<div>\r\n<h2>Creavit Free Asma Klozet - Mat Antrasit</h2>\r\n<ul>\r\n<li>\n<strong>Ürün Kodu:</strong> FE320-00AM00E-0000</li>\r\n<li>\n<strong>Seri:</strong> Free</li>\r\n<li>\n<strong>Renk:</strong> Mat Antrasit</li>\r\n<li>\n<strong>Boyutlar:</strong> 355 mm (Genişlik) x 350 mm (Yükseklik) x 510 mm (Derinlik)</li>\r\n<li>\n<strong>Montaj Tipi:</strong> Duvara asma (gizli montaj)</li>\r\n<li>\n<strong>Pis Su Çıkışı:</strong> Duvardan</li>\r\n<li>\n<strong>Yıkama Sistemi:</strong> Kanallı</li>\r\n<li>\n<strong>Taharet Borusu:</strong> Dahildir; sadece gizli bağlantı yapılabilir, yandan bağlantı yapılamaz</li>\r\n<li>\n<strong>Klozet Kapağı:</strong> Dahildir; KC0903.01.0400E (Duck Duroplast Yavaş Kapanan Mat Antrasit Klozet Kapağı)</li>\r\n<li>\n<strong>Ürün Ağırlığı:</strong> 24,68 kg</li>\r\n<li>\n<strong>Garanti Süresi:</strong> 12 Yıl</li>\r\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\r\n<h3>Öne Çıkan Özellikler</h3>\r\n<ul>\r\n<li>\n<strong>Modern ve Şık Tasarım:</strong> Yuvarlak hatlı formu ve mat antrasit yüzeyiyle banyonuza estetik bir dokunuş katar.</li>\r\n<li>\n<strong>Kolay Temizlik:</strong> Asma tasarımı sayesinde klozet altı alanı kolayca temizlenebilir.</li>\r\n<li>\n<strong>Su Tasarrufu:</strong> 3-6 litre arasında su tüketimi ile çevre dostu bir kullanım sunar.</li>\r\n<li>\n<strong>Yerden Tasarruf:</strong> Duvara asma montajı ile banyonuzda daha fazla alan sağlar.</li>\n</ul>\r\n<p><strong>Not:</strong> Gömme rezervuar ürüne dahil değildir; ayrıca sipariş edilmelidir.</p>\r\n<p>Creavit Free Asma Klozet, modern tasarımı ve kullanıcı dostu özellikleriyle banyonuza değer katacak bir üründür. Yüksek kaliteli malzemesi ve fonksiyonelliğiyle uzun ömürlü bir kullanım deneyimi sunar.</p>\n</div>"
  },
  {
    "id": "creavit-9693921444137",
    "brand": "Creavit",
    "title": "Free Kanalsız Klozet + Duroplast Yavaş Kapanan Klozet Kapağı Beyaz - Set",
    "category": "Rim-Off Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-free-kanalsiz-klozet-taharet-musluklu-beyaz.png?v=1748940794",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-free-kanalsiz-klozet-taharet-musluklu-beyaz.png?v=1748940794",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-rim-off-t-m-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7247.jpg?v=1748940794",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-rim-off-t-m-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7246.jpg?v=1748940794",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-rim-off-t-m-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7248.jpg?v=1748940791",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-rim-off-t-m-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7249.jpg?v=1748940791",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4411_c3b034cb-5d06-446a-b10b-820ccdc98542.jpg?v=1748941703"
    ],
    "price": "21126.00",
    "sku": "SET.FE322DP34.02.BYZ",
    "tags": [
      "asma klozet",
      "Beyaz",
      "free",
      "kanalsız klozet",
      "rim-off",
      "Vitrifiye",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52921475072297,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.FE322DP34.02.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "21126.00",
        "grams": 0,
        "compare_at_price": "30180.00",
        "position": 1,
        "product_id": 9693921444137,
        "created_at": "2026-04-03T14:42:22+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<div class=\"markdown prose w-full break-words dark:prose-invert light\"><span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"><strong>Bakterilere Yer Bırakmayan Tasarım: </strong>Free Rim-Off Klozetler, kanalsız tasarımları sayesinde klozet içerisinde temizlik esnasında ulaşılması güç yüzeyleri minimize eder. İç haznede erişilemeyen yüzey olmadığı için bakteri ve türevleri için elverişli ortam oluşmasına engel olur.</span></div>\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<strong><span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\">Minimalist ve Modern: </span></strong><span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\">Creavit Free Rim-Off Asma klozetler, modern bir banyo ve yüksek hijyen standartlarıyla değer verenler için tasarlandı. Free Asma Klozet  minimalist hatları ile banyonuza çağdaş bir dokunuş ekleyecek.</span><span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"></span>\n</div>\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"><strong>Yerden Tasarruf: </strong>Creavit Asma Klozetler, yere değmeyen duvara monte yapıları sayesinde temizlik sırasında tüm yüzeylere erişmenizi sağlar. Banyoda kusursuz hijyen beklentilerinizi Creavit Kanalsız Klozetlerin sunduğu hijyen çözümleri ile karşılayacaksınız.</span><span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"></span>\n</div>\n<div class=\"markdown prose w-full break-words dark:prose-invert light\"><strong><span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\">Klozetler için montaj kiti dahildir.</span></strong></div>"
  },
  {
    "id": "creavit-9693899653417",
    "brand": "Creavit",
    "title": "Free Kanalsız Klozet + Thermoplast Yavaş Kapanan Klozet Kapağı Beyaz - Set",
    "category": "Rim-Off Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-free-kanalsiz-klozet-taharet-musluklu-beyaz_12ae48ae-1068-4389-9c41-12bef2242e86.png?v=1748941113",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-free-kanalsiz-klozet-taharet-musluklu-beyaz_12ae48ae-1068-4389-9c41-12bef2242e86.png?v=1748941113",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-rim-off-t-m-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7243.jpg?v=1748941113",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-rim-off-t-m-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7242.jpg?v=1748941113",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-rim-off-t-m-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7244.jpg?v=1748941109",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-rim-off-t-m-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7245.jpg?v=1748941109",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-thermoplast-yavas-kapanan-klozet-kapagi-beyaz-4450_760f7e91-45d2-4ca8-b631-df0b1f3fb6f2.jpg?v=1748941171"
    ],
    "price": "19488.00",
    "sku": "SET.FE322TP34.02.BYZ",
    "tags": [
      "asma klozet"
    ],
    "variants": [
      {
        "id": 52921475334441,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.FE322TP34.02.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "19488.00",
        "grams": 0,
        "compare_at_price": "27840.00",
        "position": 1,
        "product_id": 9693899653417,
        "created_at": "2026-04-03T14:42:26+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<div class=\"markdown prose w-full break-words dark:prose-invert light\"><span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"><strong>Bakterilere Yer Bırakmayan Tasarım: </strong>Free Rim-Off Klozetler, kanalsız tasarımları sayesinde klozet içerisinde temizlik esnasında ulaşılması güç yüzeyleri minimize eder. İç haznede erişilemeyen yüzey olmadığı için bakteri ve türevleri için elverişli ortam oluşmasına engel olur.</span></div>\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<strong><span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\">Minimalist ve Modern: </span></strong><span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\">Creavit Free Rim-Off Asma klozetler, modern bir banyo ve yüksek hijyen standartlarıyla değer verenler için tasarlandı. Free Asma Klozet  minimalist hatları ile banyonuza çağdaş bir dokunuş ekleyecek.</span><span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"></span>\n</div>\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"><strong>Yerden Tasarruf: </strong>Creavit Asma Klozetler, yere değmeyen duvara monte yapıları sayesinde temizlik sırasında tüm yüzeylere erişmenizi sağlar. Banyoda kusursuz hijyen beklentilerinizi Creavit Kanalsız Klozetlerin sunduğu hijyen çözümleri ile karşılayacaksınız.</span><span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"></span>\n</div>\n<div class=\"markdown prose w-full break-words dark:prose-invert light\"><strong><span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\">Klozetler için montaj kiti dahildir.</span></strong></div>"
  },
  {
    "id": "creavit-9693880516905",
    "brand": "Creavit",
    "title": "Free Asma Klozet + Duroplast Yavaş Kapanan Klozet Kapağı Beyaz - Set",
    "category": "Asma Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-free-asma-klozet-beyaz.png?v=1748941636",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-free-asma-klozet-beyaz.png?v=1748941636",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7240.jpg?v=1748941636",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7239.jpg?v=1748941636",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7241.jpg?v=1748941578",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4411_998c9d41-1088-4d19-b9cd-e375f8995b4b.jpg?v=1748941634"
    ],
    "price": "12222.00",
    "sku": "SET.FE320DP.BYZ",
    "tags": [
      "asma klozet",
      "asma klozet set",
      "Beyaz",
      "free",
      "Vitrifiye",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52920964350249,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.FE320DP.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "12222.00",
        "grams": 0,
        "compare_at_price": "17460.00",
        "position": 1,
        "product_id": 9693880516905,
        "created_at": "2026-04-03T12:14:57+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<p>Creavit Free Asma Klozet, modern tasarımı ve kullanıcı dostu özellikleriyle banyonuza değer katacak bir üründür. Yüksek kaliteli malzemesi ve fonksiyonelliğiyle uzun ömürlü bir kullanım deneyimi sunar.</p>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> FE320-00CB00E-0000</li>\n<li>\n<strong>Seri:</strong> Free</li>\n<li>\n<strong>Renk:</strong> Beyaz</li>\n<li>\n<strong>Boyutlar:</strong> 355 mm (Genişlik) x 350 mm (Yükseklik) x 510 mm (Derinlik)</li>\n<li>\n<strong>Montaj Tipi:</strong> Duvara asma (gizli montaj)</li>\n<li>\n<strong>Pis Su Çıkışı:</strong> Duvardan</li>\n<li>\n<strong>Yıkama Sistemi:</strong> Kanallı</li>\n<li>\n<strong>Taharet Borusu:</strong> Dahildir; sadece gizli bağlantı yapılabilir, yandan bağlantı yapılamaz</li>\n<li>\n<strong>Klozet Kapağı:</strong> Dahildir; KC0903.02.0000E (Duck Duroplast Yavaş Kapanan Beyaz Klozet Kapağı)</li>\n<li>\n<strong>Ürün Ağırlığı:</strong> 24,68 kg</li>\n<li>\n<strong>Garanti Süresi:</strong> 12 Yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\n<h4>Öne Çıkan Özellikler</h4>\n<ul>\n<li>\n<strong>Modern ve Şık Tasarım:</strong> Yuvarlak hatlı formu ve beyaz yüzeyiyle banyonuza estetik bir dokunuş katar.</li>\n<li>\n<strong>Kolay Temizlik:</strong> Asma tasarımı sayesinde klozet altı alanı kolayca temizlenebilir.</li>\n<li>\n<strong>Su Tasarrufu:</strong> 3-6 litre arasında su tüketimi ile çevre dostu bir kullanım sunar.</li>\n<li>\n<strong>Yerden Tasarruf:</strong> Duvara asma montajı ile banyonuzda daha fazla alan sağlar.</li>\n</ul>\n<p><strong>Not:</strong> Ürünün düzgün çalışabilmesi için uyumlu bir gömme rezervuar gereklidir. Gömme rezervuar ürüne dahil değildir ve ayrıca sipariş edilmelidir.</p>"
  },
  {
    "id": "creavit-9693872292137",
    "brand": "Creavit",
    "title": "Free Asma Klozet + Thermoplast Yavaş Kapanan Klozet Kapağı Beyaz - Set",
    "category": "Asma Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-free-asma-klozet-beyaz_85e602a0-02e4-436a-9128-15af9ab26bec.png?v=1748941777",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-free-asma-klozet-beyaz_85e602a0-02e4-436a-9128-15af9ab26bec.png?v=1748941777",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7237.jpg?v=1748941777",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7236.jpg?v=1748941777",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7238.jpg?v=1748941774",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-thermoplast-yavas-kapanan-klozet-kapagi-beyaz-4450_55bebb0b-5855-4474-8faf-8bf935c81325.jpg?v=1748941772"
    ],
    "price": "10584.00",
    "sku": "SET.FE320TP.BYZ",
    "tags": [
      "asma klozet",
      "asma klozet set",
      "Beyaz",
      "free"
    ],
    "variants": [
      {
        "id": 52920964579625,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.FE320TP.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "10584.00",
        "grams": 0,
        "compare_at_price": "15120.00",
        "position": 1,
        "product_id": 9693872292137,
        "created_at": "2026-04-03T12:15:00+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<ul>\r\n<li>\n<strong>Ürün Kodu:</strong> FE320-00CB00E-0000</li>\r\n<li>\n<strong>Seri:</strong> Free</li>\r\n<li>\n<strong>Renk:</strong> Beyaz</li>\r\n<li>\n<strong>Boyutlar:</strong> 355 mm (Genişlik) x 350 mm (Yükseklik) x 510 mm (Derinlik)</li>\r\n<li>\n<strong>Montaj Tipi:</strong> Duvara asma (gizli montaj)</li>\r\n<li>\n<strong>Pis Su Çıkışı:</strong> Duvardan</li>\r\n<li>\n<strong>Yıkama Sistemi:</strong> Kanallı</li>\r\n<li>\n<strong>Taharet Borusu:</strong> Dahildir; sadece gizli bağlantı yapılabilir, yandan bağlantı yapılamaz</li>\r\n<li>\n<strong>Klozet Kapağı:</strong> Dahildir; KC0903.03.0000E (Duck Thermoplast Yavaş Kapanan Beyaz Klozet Kapağı)</li>\r\n<li>\n<strong>Ürün Ağırlığı:</strong> 24,68 kg</li>\r\n<li>\n<strong>Garanti Süresi:</strong> 12 Yıl</li>\r\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\r\n<h3>Öne Çıkan Özellikler</h3>\r\n<ul>\r\n<li>\n<strong>Modern ve Şık Tasarım:</strong> Yuvarlak hatlı formu ve beyaz yüzeyiyle banyonuza estetik bir dokunuş katar.</li>\r\n<li>\n<strong>Kolay Temizlik:</strong> Asma tasarımı sayesinde klozet altı alanı kolayca temizlenebilir.</li>\r\n<li>\n<strong>Su Tasarrufu:</strong> 3-6 litre arasında su tüketimi ile çevre dostu bir kullanım sunar.</li>\r\n<li>\n<strong>Yerden Tasarruf:</strong> Duvara asma montajı ile banyonuzda daha fazla alan sağlar.</li>\n</ul>\r\n<p><strong>Not:</strong> Ürünün düzgün çalışabilmesi için uyumlu bir gömme rezervuar gereklidir. Gömme rezervuar ürüne dahil değildir ve ayrıca sipariş edilmelidir.</p>\r\n<p><strong>Creavit Free Asma Klozet</strong>, modern tasarımı ve kullanıcı dostu özellikleriyle banyonuza değer katacak bir üründür. Yüksek kaliteli malzemesi ve fonksiyonelliğiyle uzun ömürlü bir kullanım deneyimi sunar.</p>"
  },
  {
    "id": "creavit-9693858005289",
    "brand": "Creavit",
    "title": "Free Duroplast Yavaş Kapanan Klozet Kapaklı Mat Cappucino Set",
    "category": "Asma Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-duroplast-yavas-kapanan-klozet-kapakli-mat-cappucino-set-7235.jpg?v=1747232251",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-duroplast-yavas-kapanan-klozet-kapakli-mat-cappucino-set-7235.jpg?v=1747232251"
    ],
    "price": "20664.00",
    "sku": "SET.FE320DP.CM",
    "tags": [
      "asma klozet",
      "asma klozet set",
      "free",
      "Mat Cappuccino"
    ],
    "variants": [
      {
        "id": 52843170234665,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.FE320DP.CM",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "20664.00",
        "grams": 0,
        "compare_at_price": "29520.00",
        "position": 1,
        "product_id": 9693858005289,
        "created_at": "2026-03-17T12:41:37+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<ul>\r\n<li>\n<strong>Ürün Kodu:</strong> FE320-00CM00E-0000</li>\r\n<li>\n<strong>Seri:</strong> Free</li>\r\n<li>\n<strong>Renk:</strong> Mat Cappuccino</li>\r\n<li>\n<strong>Boyutlar:</strong> 355 mm (Genişlik) x 350 mm (Yükseklik) x 510 mm (Derinlik)</li>\r\n<li>\n<strong>Montaj Tipi:</strong> Duvara asma (gizli montaj)</li>\r\n<li>\n<strong>Pis Su Çıkışı:</strong> Duvardan</li>\r\n<li>\n<strong>Yıkama Sistemi:</strong> Kanallı</li>\r\n<li>\n<strong>Taharet Borusu:</strong> Dahildir; sadece gizli bağlantı yapılabilir, yandan bağlantı yapılamaz</li>\r\n<li>\n<strong>Klozet Kapağı:</strong> Dahildir; KC0903.01.0800E (Duck Duroplast Yavaş Kapanan Mat Cappuccino Klozet Kapağı)</li>\r\n<li>\n<strong>Ürün Ağırlığı:</strong> 24,68 kg</li>\r\n<li>\n<strong>Garanti Süresi:</strong> 12 Yıl</li>\r\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\r\n<h4>Öne Çıkan Özellikler</h4>\r\n<ul>\r\n<li>\n<strong>Modern ve Şık Tasarım:</strong> Yuvarlak hatlı formu ve mat cappuccino yüzeyiyle banyonuza estetik bir dokunuş katar.</li>\r\n<li>\n<strong>Kolay Temizlik:</strong> Asma tasarımı sayesinde klozet altı alanı kolayca temizlenebilir.</li>\r\n<li>\n<strong>Su Tasarrufu:</strong> 3-6 litre arasında su tüketimi ile çevre dostu bir kullanım sunar.</li>\r\n<li>\n<strong>Yerden Tasarruf:</strong> Duvara asma montajı ile banyonuzda daha fazla alan sağlar.</li>\n</ul>\r\n<p><strong>Not:</strong> Gömme rezervuar ürüne dahil değildir; ayrıca sipariş edilmelidir.</p>\r\n<p><strong>Creavit Free Asma Klozet</strong>, modern tasarımı ve kullanıcı dostu özellikleriyle banyonuza değer katacak bir üründür. Yüksek kaliteli malzemesi ve fonksiyonelliğiyle uzun ömürlü bir kullanım deneyimi sunar.</p>"
  },
  {
    "id": "creavit-9693834150185",
    "brand": "Creavit",
    "title": "Free Rim-Off Duroplast Yavaş Kapanan Klozet Kapaklı Mat Antrasit Set",
    "category": "Rim-Off Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-rim-off-duroplast-yavas-kapanan-klozet-kapakli-mat-antrasit-set-7229.jpg?v=1748264323",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-rim-off-duroplast-yavas-kapanan-klozet-kapakli-mat-antrasit-set-7229.jpg?v=1748264323",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-rim-off-duroplast-yavas-kapanan-klozet-kapakli-mat-antrasit-set-7228.jpg?v=1748264323",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-rim-off-duroplast-yavas-kapanan-klozet-kapakli-mat-antrasit-set-7227.jpg?v=1748264323"
    ],
    "price": "23478.00",
    "sku": "SET.FE322DP.AM",
    "tags": [
      "asma klozet",
      "asma klozet set",
      "free",
      "kanalsız klozet",
      "Mat Antrasit"
    ],
    "variants": [
      {
        "id": 52920964743465,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.FE322DP.AM",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "23478.00",
        "grams": 0,
        "compare_at_price": "33540.00",
        "position": 1,
        "product_id": 9693834150185,
        "created_at": "2026-04-03T12:15:04+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<ul>\r\n<li>\n<strong>Ürün Kodu:</strong> FE322-00AM00E-0000</li>\r\n<li>\n<strong>Seri:</strong> Free</li>\r\n<li>\n<strong>Renk:</strong> Mat Antrasit</li>\r\n<li>\n<strong>Boyutlar:</strong> 355 mm (Genişlik) x 350 mm (Yükseklik) x 510 mm (Derinlik)</li>\r\n<li>\n<strong>Montaj Tipi:</strong> Duvara asma (gizli montaj)</li>\r\n<li>\n<strong>Pis Su Çıkışı:</strong> Duvardan</li>\r\n<li>\n<strong>Yıkama Sistemi:</strong> Kanalsız (Rim-Off)</li>\r\n<li>\n<strong>Taharet Borusu:</strong> Dahildir; sadece gizli bağlantı yapılabilir, yandan bağlantı yapılamaz</li>\r\n<li>\n<strong>Klozet Kapağı:</strong> Dahildir KC0903.01.1400E (Duck Duroplast Yavaş Kapanan Mat Antrasit Klozet Kapağı)</li>\r\n<li>\n<strong>Ürün Ağırlığı:</strong> 26,83 kg</li>\r\n<li>\n<strong>Garanti Süresi:</strong> 12 Yıl</li>\r\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\r\n<h4>Öne Çıkan Özellikler</h4>\r\n<ul>\r\n<li>\n<strong>Kanalsız Tasarım (Rim-Off):</strong> Geleneksel klozetlerde bulunan yıkama kanalları bu modelde bulunmaz, bu sayede bakteri ve kir birikimi minimize edilir.</li>\r\n<li>\n<strong>Mat Antrasit Yüzey:</strong> Modern banyolar için şık ve sofistike bir görünüm sunar.</li>\r\n<li>\n<strong>Kolay Temizlik:</strong> Asma tasarımı sayesinde klozet altı alanı kolayca temizlenebilir.</li>\r\n<li>\n<strong>Su Tasarrufu:</strong> 3-6 litre arasında su tüketimi ile çevre dostu bir kullanım sağlar.</li>\n</ul>\r\n<p><strong>Not:</strong> Montaj kiti (gizli montaj seti) ürünle birlikte sunulmaktadır.</p>\r\n<p><strong>Uyarı:</strong> Ürünün düzgün çalışabilmesi için uyumlu bir gömme rezervuar gereklidir. Gömme rezervuar ürüne dahil değildir ve ayrıca sipariş edilmelidir.</p>\r\n<p><strong>Creavit Free Rim-Off Asma Klozet</strong>, modern tasarımı ve hijyenik özellikleriyle banyonuza değer katacak bir üründür. Yüksek kaliteli malzemesi ve kullanıcı dostu detaylarıyla uzun ömürlü bir kullanım deneyimi sunar.</p>"
  },
  {
    "id": "creavit-9693831528745",
    "brand": "Creavit",
    "title": "Free Kanalsız Klozet + Duroplast Yavaş Kapanan Klozet Kapağı Beyaz - Set",
    "category": "Rim-Off Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-free-kanalsiz-tuvalet-beyaz.png?v=1748942518",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-free-kanalsiz-tuvalet-beyaz.png?v=1748942518",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-rim-off-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7224.jpg?v=1748942518",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-rim-off-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7225.jpg?v=1748942518",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-rim-off-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7226.jpg?v=1748942518",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4411_1aa86759-7491-4dce-9268-80f30d19f902.jpg?v=1748942530"
    ],
    "price": "14616.00",
    "sku": "SET.FE322DP.BYZ",
    "tags": [
      "asma klozet",
      "free",
      "kanalsız klozet",
      "rim-off"
    ],
    "variants": [
      {
        "id": 52920964907305,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.FE322DP.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "14616.00",
        "grams": 0,
        "compare_at_price": "20880.00",
        "position": 1,
        "product_id": 9693831528745,
        "created_at": "2026-04-03T12:15:07+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<ul>\r\n<li>\n<strong>Ürün Kodu:</strong> FE322-00CB00E-0000</li>\r\n<li>\n<strong>Seri:</strong> Free</li>\r\n<li>\n<strong>Renk:</strong> Beyaz</li>\r\n<li>\n<strong>Boyutlar:</strong> 355 mm (Genişlik) x 350 mm (Yükseklik) x 510 mm (Derinlik)</li>\r\n<li>\n<strong>Montaj Tipi:</strong> Duvara asma (gizli montaj)</li>\r\n<li>\n<strong>Pis Su Çıkışı:</strong> Duvardan</li>\r\n<li>\n<strong>Yıkama Sistemi:</strong> Kanalsız (Rim-Off)</li>\r\n<li>\n<strong>Taharet Borusu:</strong> Dahildir; sadece gizli bağlantı yapılabilir, yandan bağlantı yapılamaz</li>\r\n<li>\n<strong>Klozet Kapağı:</strong> Dahildir;  KC0903.02.0000E (Duck Duroplast Yavaş Kapanan Beyaz Klozet Kapağı)</li>\r\n<li>\n<strong>Ürün Ağırlığı:</strong> 26,83 kg</li>\r\n<li>\n<strong>Garanti Süresi:</strong> 12 Yıl</li>\r\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\r\n<h4>Öne Çıkan Özellikler</h4>\r\n<ul>\r\n<li>\n<strong>Kanalsız Tasarım (Rim-Off):</strong> Geleneksel klozetlerde bulunan yıkama kanalları bu modelde bulunmaz, bu sayede bakteri ve kir birikimi minimize edilir.</li>\r\n<li>\n<strong>Kolay Temizlik:</strong> Asma tasarımı sayesinde klozet altı alanı kolayca temizlenebilir.</li>\r\n<li>\n<strong>Su Tasarrufu:</strong> 3-6 litre arasında su tüketimi ile çevre dostu bir kullanım sağlar.</li>\n</ul>\r\n<p><strong>Not:</strong> Montaj kiti (gizli montaj seti) ürünle birlikte sunulmaktadır.</p>\r\n<p><strong>Uyarı:</strong> Ürünün düzgün çalışabilmesi için uyumlu bir gömme rezervuar gereklidir. Gömme rezervuar ürüne dahil değildir ve ayrıca sipariş edilmelidir.</p>\r\n<p><strong>Creavit Free Rim-Off Asma Klozet</strong>, modern tasarımı ve hijyenik özellikleriyle banyonuza değer katacak bir üründür. Yüksek kaliteli malzemesi ve kullanıcı dostu detaylarıyla uzun ömürlü bir kullanım deneyimi sunar.</p>"
  },
  {
    "id": "creavit-9693830971689",
    "brand": "Creavit",
    "title": "Free Kanalsız Klozet + Thermoplast Yavaş Kapanan Klozet Kapağı Beyaz - Set",
    "category": "Rim-Off Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-free-kanalsiz-tuvalet-beyaz_4d18b970-a8af-4493-8142-ba6ad1c9707e.png?v=1748942681",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-free-kanalsiz-tuvalet-beyaz_4d18b970-a8af-4493-8142-ba6ad1c9707e.png?v=1748942681",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-rim-off-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7221.jpg?v=1748942681",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-rim-off-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7223.jpg?v=1748942681",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-rim-off-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7222.jpg?v=1748942679",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-thermoplast-yavas-kapanan-klozet-kapagi-beyaz-4450_b395b9d5-dfde-44c6-8f3e-4ee8967bd390.jpg?v=1748942689"
    ],
    "price": "12978.00",
    "sku": "SET.FE322TP.BYZ",
    "tags": [
      "asma klozet",
      "Beyaz",
      "free",
      "kanalsız klozet",
      "rim-off"
    ],
    "variants": [
      {
        "id": 52920965136681,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.FE322TP.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "12978.00",
        "grams": 0,
        "compare_at_price": "18540.00",
        "position": 1,
        "product_id": 9693830971689,
        "created_at": "2026-04-03T12:15:10+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<ul>\r\n<li>\n<strong>Ürün Kodu:</strong> FE322-00CB00E-0000</li>\r\n<li>\n<strong>Seri:</strong> Free</li>\r\n<li>\n<strong>Renk:</strong> Beyaz</li>\r\n<li>\n<strong>Boyutlar:</strong> 355 mm (Genişlik) x 350 mm (Yükseklik) x 510 mm (Derinlik)</li>\r\n<li>\n<strong>Montaj Tipi:</strong> Duvara asma (gizli montaj)</li>\r\n<li>\n<strong>Pis Su Çıkışı:</strong> Duvardan</li>\r\n<li>\n<strong>Yıkama Sistemi:</strong> Kanalsız (Rim-Off)</li>\r\n<li>\n<strong>Taharet Borusu:</strong> Dahildir; sadece gizli bağlantı yapılabilir, yandan bağlantı yapılamaz</li>\r\n<li>\n<strong>Klozet Kapağı:</strong> Dahildir; KC0903.03.0000E (Duck Thermoplast Yavaş Kapanan Beyaz Klozet Kapağı)</li>\r\n<li>\n<strong>Ürün Ağırlığı:</strong> 26,83 kg</li>\r\n<li>\n<strong>Garanti Süresi:</strong> 12 Yıl</li>\r\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\r\n<h4>Öne Çıkan Özellikler</h4>\r\n<ul>\r\n<li>\n<strong>Kanalsız Tasarım (Rim-Off):</strong> Geleneksel klozetlerde bulunan yıkama kanalları bu modelde bulunmaz, bu sayede bakteri ve kir birikimi minimize edilir.</li>\r\n<li>\n<strong>Kolay Temizlik:</strong> Asma tasarımı sayesinde klozet altı alanı kolayca temizlenebilir.</li>\r\n<li>\n<strong>Su Tasarrufu:</strong> 3-6 litre arasında su tüketimi ile çevre dostu bir kullanım sağlar.</li>\n</ul>\r\n<p><strong>Not:</strong> Montaj kiti (gizli montaj seti) ürünle birlikte sunulmaktadır.</p>\r\n<p><strong>Uyarı:</strong> Ürünün düzgün çalışabilmesi için uyumlu bir gömme rezervuar gereklidir. Gömme rezervuar ürüne dahil değildir ve ayrıca sipariş edilmelidir.</p>\r\n<p><strong>Creavit Free Rim-Off Asma Klozet</strong>, modern tasarımı ve hijyenik özellikleriyle banyonuza değer katacak bir üründür. Yüksek kaliteli malzemesi ve kullanıcı dostu detaylarıyla uzun ömürlü bir kullanım deneyimi sunar.</p>"
  },
  {
    "id": "creavit-9693823926569",
    "brand": "Creavit",
    "title": "Free Rim-Off Duroplast Yavaş Kapanan Klozet Kapaklı Mat Cappucino Set",
    "category": "Rim-Off Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-rim-off-duroplast-yavas-kapanan-klozet-kapakli-mat-cappucino-set-7220.jpg?v=1754555466",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-rim-off-duroplast-yavas-kapanan-klozet-kapakli-mat-cappucino-set-7220.jpg?v=1754555466",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-rim-off-duroplast-yavas-kapanan-klozet-kapakli-mat-cappucino-set-7219.jpg?v=1754555466",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/free-rim-off-duroplast-yavas-kapanan-klozet-kapakli-mat-cappucino-set-7218.jpg?v=1747817466"
    ],
    "price": "23478.00",
    "sku": "SET.FE322DP.CM",
    "tags": [
      "asma klozet",
      "asma klozet set",
      "free",
      "kanalsız klozet",
      "Mat Cappuccino"
    ],
    "variants": [
      {
        "id": 52876507185449,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.FE322DP.CM",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "23478.00",
        "grams": 0,
        "compare_at_price": "33540.00",
        "position": 1,
        "product_id": 9693823926569,
        "created_at": "2026-03-25T12:22:21+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<ul>\r\n<li>\n<strong>Ürün Kodu:</strong> FE322-00CM00E-0000</li>\r\n<li>\n<strong>Seri:</strong> Free</li>\r\n<li>\n<strong>Renk:</strong> Mat Cappuccino</li>\r\n<li>\n<strong>Boyutlar:</strong> 355 mm (Genişlik) x 350 mm (Yükseklik) x 510 mm (Derinlik)</li>\r\n<li>\n<strong>Montaj Tipi:</strong> Duvara asma (gizli montaj)</li>\r\n<li>\n<strong>Pis Su Çıkışı:</strong> Duvardan</li>\r\n<li>\n<strong>Yıkama Sistemi:</strong> Kanalsız (Rim-Off)</li>\r\n<li>\n<strong>Taharet Borusu:</strong> Dahildir; sadece gizli bağlantı yapılabilir, yandan bağlantı yapılamaz</li>\r\n<li>\n<strong>Klozet Kapağı:</strong> Dahildir;  KC0903.01.0800E (Duck Duroplast Yavaş Kapanan Mat Cappuccino Klozet Kapağı)</li>\r\n<li>\n<strong>Garanti Süresi:</strong> 12 Yıl</li>\r\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\r\n<h4>Öne Çıkan Özellikler</h4>\r\n<ul>\r\n<li>\n<strong>Kanalsız Tasarım (Rim-Off):</strong> Geleneksel klozetlerde bulunan yıkama kanalları bu modelde bulunmaz, bu sayede bakteri ve kir birikimi minimize edilir.</li>\r\n<li>\n<strong>Mat Cappuccino Yüzey:</strong> Modern banyolar için şık ve sofistike bir görünüm sunar.</li>\r\n<li>\n<strong>Kolay Temizlik:</strong> Asma tasarımı sayesinde klozet altı alanı kolayca temizlenebilir.</li>\r\n<li>\n<strong>Su Tasarrufu:</strong> 3-6 litre arasında su tüketimi ile çevre dostu bir kullanım sağlar.</li>\n</ul>\r\n<p><strong>Not:</strong> Montaj kiti (gizli montaj seti) ürünle birlikte sunulmaktadır.</p>\r\n<p><strong>Uyarı:</strong> Ürünün düzgün çalışabilmesi için uyumlu bir gömme rezervuar gereklidir. Gömme rezervuar ürüne dahil değildir ve ayrıca sipariş edilmelidir.</p>\r\n<p><strong>Creavit Free Rim-Off Asma Klozet</strong>, modern tasarımı ve hijyenik özellikleriyle banyonuza değer katacak bir üründür. Yüksek kaliteli malzemesi ve kullanıcı dostu detaylarıyla uzun ömürlü bir kullanım deneyimi sunar.</p>"
  },
  {
    "id": "creavit-9693686366505",
    "brand": "Creavit",
    "title": "Perla Asma Klozet + Duroplast Yavaş Kapanan Klozet Kapağı Beyaz - Set",
    "category": "Asma Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-perla-asma-klozet-beyaz.png?v=1748943500",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-perla-asma-klozet-beyaz.png?v=1748943500",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/perla-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7213.jpg?v=1748943500",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/perla-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7212.jpg?v=1748943500",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/perla-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7214.jpg?v=1748943500",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/cinar-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4429_e13398df-ce8a-4182-a77a-27d2fe00fdf5.jpg?v=1748943776"
    ],
    "price": "8946.00",
    "sku": "SET.TP320DP.BYZ",
    "tags": [
      "asma klozet",
      "Beyaz",
      "perla"
    ],
    "variants": [
      {
        "id": 52843171578153,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.TP320DP.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8946.00",
        "grams": 0,
        "compare_at_price": "12780.00",
        "position": 1,
        "product_id": 9693686366505,
        "created_at": "2026-03-17T12:42:08+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h3>TP320-00CB00E-0000 Asma Klozet – Beyaz (Perla Serisi)</h3>\r\n<p><strong>Creavit Perla</strong> serisinin bu beyaz asma klozeti, kompakt alanlara modern bir dokunuş kazandırmak için tasarlanmıştır. Estetik ve işlevselliği bir arada sunar.</p>\r\n<h3>Teknik Özellikler:</h3>\r\n<ul>\r\n<li>\n<strong>Ürün Kodu:</strong> TP320-00CB00E-0000</li>\r\n<li>\n<strong>Seri:</strong> Perla</li>\r\n<li>\n<strong>Renk:</strong> Beyaz</li>\r\n<li>\n<strong>Boyutlar:</strong> 362 mm (Genişlik) x 331 mm (Yükseklik) x 486 mm (Derinlik)</li>\r\n<li>\n<strong>Montaj Tipi:</strong> Duvara asma</li>\r\n<li>\n<strong>Pis Su Çıkışı:</strong> Duvardan</li>\r\n<li>\n<strong>Yıkama Sistemi:</strong> Kanallı</li>\r\n<li>\n<strong>Taharet Borusu:</strong> Dahildir</li>\r\n<li>\n<strong>Klozet Kapağı:</strong> Dahildir (KC0703.01.0000E – Çınar Duroplast Yavaş Kapanan Beyaz Klozet Kapağı)</li>\r\n<li>\n<strong>Ürün Ağırlığı:</strong> 15,31 kg</li>\r\n<li>\n<strong>Klozet Kapağı Ağırlığı:</strong> 2,85 kg</li>\r\n<li>\n<strong>Garanti Süresi:</strong> 12 yıl</li>\n</ul>\r\n<h3>Avantajları:</h3>\r\n<ul>\r\n<li>\n<strong>Kompakt ve Zarif Tasarım:</strong> Küçük banyolar için ideal boyutlarda sade ve modern bir görünüm sunar.</li>\r\n<li>\n<strong>Kolay Temizlik:</strong> Asma tasarımı sayesinde klozet altı alan kolayca temizlenebilir.</li>\r\n<li>\n<strong>Su Tasarrufu:</strong> 3-6 litre arasında su tüketimi ile çevre dostu bir kullanım sunar.</li>\n</ul>\r\n<p><strong>Not:</strong> Ürünün düzgün çalışabilmesi için uyumlu bir <strong>gömme rezervuar</strong> gereklidir. Gömme rezervuar ürünle birlikte gelmez ve ayrıca sipariş edilmelidir.</p>\r\n<p><em>Creavit Perla Asma Klozet, yüksek kaliteli seramik malzemesi ve kullanıcı dostu detaylarıyla uzun ömürlü bir deneyim sağlar.</em></p>"
  },
  {
    "id": "creavit-9693684564265",
    "brand": "Creavit",
    "title": "Perla Asma Klozet + Thermoplast Yavaş Kapanan Klozet Kapağı Beyaz - Set",
    "category": "Asma Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-perla-asma-klozet-beyaz_f0cd6dd6-34d3-4fe7-a2c1-e1495c74e8ee.png?v=1748944128",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-perla-asma-klozet-beyaz_f0cd6dd6-34d3-4fe7-a2c1-e1495c74e8ee.png?v=1748944128",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/perla-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7210.jpg?v=1748944128",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/perla-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7209.jpg?v=1748944128",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/perla-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7211.jpg?v=1748944128",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/cinar-thermoplast-yavas-kapanan-klozet-kapagi-beyaz-4457_09e3f973-85ca-40b1-bbb6-f27165b5972f.jpg?v=1748944156"
    ],
    "price": "7182.00",
    "sku": "SET.TP320TP.BYZ",
    "tags": [
      "asma klozet",
      "Beyaz",
      "perla"
    ],
    "variants": [
      {
        "id": 52912456761641,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.TP320TP.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7182.00",
        "grams": 0,
        "compare_at_price": "10260.00",
        "position": 1,
        "product_id": 9693684564265,
        "created_at": "2026-04-01T16:04:22+03:00",
        "updated_at": "2026-04-07T05:25:30+03:00"
      }
    ],
    "description": "<h3>TP320-00CB00E-0000 Asma Klozet – Beyaz (Perla Serisi)</h3>\r\n<p><strong>Creavit Perla</strong> serisi, kompakt banyolar için özel olarak tasarlanmış sade ve zarif bir asma klozet sunar. Küçük alanlarda şıklık ve işlevselliği bir araya getirir.</p>\r\n<h3>Teknik Özellikler:</h3>\r\n<ul>\r\n<li>\n<strong>Ürün Kodu:</strong> TP320-00CB00E-0000</li>\r\n<li>\n<strong>Seri:</strong> Perla</li>\r\n<li>\n<strong>Renk:</strong> Beyaz</li>\r\n<li>\n<strong>Boyutlar:</strong> 362 mm (Genişlik) x 331 mm (Yükseklik) x 486 mm (Derinlik)</li>\r\n<li>\n<strong>Montaj Tipi:</strong> Duvara asma</li>\r\n<li>\n<strong>Pis Su Çıkışı:</strong> Duvardan</li>\r\n<li>\n<strong>Yıkama Sistemi:</strong> Kanallı</li>\r\n<li>\n<strong>Taharet Borusu:</strong> Dahildir</li>\r\n<li>\n<strong>Klozet Kapağı:</strong> Dahildir (KC0703.03.0000E – Çınar Thermoplast Yavaş Kapanan Beyaz)</li>\r\n<li>\n<strong>Ürün Ağırlığı:</strong> 15,31 kg</li>\r\n<li>\n<strong>Klozet Kapağı Ağırlığı:</strong> 2,85 kg</li>\r\n<li>\n<strong>Garanti Süresi:</strong> 12 yıl</li>\n</ul>\r\n<h3>Avantajları:</h3>\r\n<ul>\r\n<li>\n<strong>Kompakt ve Zarif Tasarım:</strong> Küçük banyolar için ideal boyutlarda, sade ve modern bir görünüm sunar.</li>\r\n<li>\n<strong>Kolay Temizlik:</strong> Asma tasarımı sayesinde klozet altı alanı kolayca temizlenebilir.</li>\r\n<li>\n<strong>Su Tasarrufu:</strong> 3-6 litre arasında su tüketimi ile çevre dostu bir kullanım sağlar.</li>\n</ul>\r\n<p><strong>Not:</strong> Ürünün düzgün çalışabilmesi için uyumlu bir <strong>gömme rezervuar</strong> gereklidir. Gömme rezervuar ürünle birlikte gelmez ve ayrıca temin edilmelidir.</p>\r\n<p><em>Creavit Perla Asma Klozet, modern banyolar için estetik ve fonksiyonelliği bir arada sunan ideal bir seçenektir. Yüksek kaliteli malzemesi ve kullanıcı dostu özellikleriyle uzun ömürlü bir kullanım deneyimi sağlar.</em></p>"
  },
  {
    "id": "creavit-9693682073897",
    "brand": "Creavit",
    "title": "Terra Asma Klozet + Duroplast Yavaş Kapanan Klozet Kapağı Beyaz - Set",
    "category": "Asma Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-terra-asma-klozet-beyaz.png?v=1748944590",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-terra-asma-klozet-beyaz.png?v=1748944590",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7206.jpg?v=1748944583",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7207.jpg?v=1748944583",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7208.jpg?v=1748944583",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4411_9189f992-9074-429d-b430-c9115a514ffc.jpg?v=1748944656"
    ],
    "price": "10794.00",
    "sku": "SET.TP325DP.BYZ",
    "tags": [
      "asma klozet",
      "Beyaz",
      "Terra"
    ],
    "variants": [
      {
        "id": 52920965366057,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.TP325DP.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "10794.00",
        "grams": 0,
        "compare_at_price": "15420.00",
        "position": 1,
        "product_id": 9693682073897,
        "created_at": "2026-04-03T12:15:13+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<h3>TP325-00CB00E-0000 Asma Klozet – Beyaz (Terra Serisi)</h3>\n<p><strong>Creavit Terra</strong> serisinin bu beyaz asma klozeti, modern banyolar için estetik ve fonksiyonelliği bir arada sunar. Yumuşak hatları, pürüzsüz yüzeyi ve kullanıcı dostu özellikleriyle uzun ömürlü bir deneyim sağlar.</p>\n<h3>Teknik Özellikler:</h3>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> TP325-00CB00E-0000</li>\n<li>\n<strong>Seri:</strong> Terra</li>\n<li>\n<strong>Renk:</strong> Beyaz</li>\n<li>\n<strong>Boyutlar:</strong> 355 mm (Genişlik) x 345 mm (Yükseklik) x 508 mm (Derinlik)</li>\n<li>\n<strong>Montaj Tipi:</strong> Duvara asma</li>\n<li>\n<strong>Pis Su Çıkışı:</strong> Duvardan</li>\n<li>\n<strong>Yıkama Sistemi:</strong> Kanallı</li>\n<li>\n<strong>Taharet Borusu:</strong> Dahildir</li>\n<li>\n<strong>Klozet Kapağı:</strong> Yavaş kapanır kapak dahil (Kod: KC0903.02.0000E)</li>\n<li>\n<strong>Ürün Ağırlığı:</strong> 24,3 kg</li>\n<li>\n<strong>Klozet Kapağı Ağırlığı:</strong> 2,55 kg</li>\n<li>\n<strong>Garanti Süresi:</strong> 12 Yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\n<h3>Avantajları:</h3>\n<ul>\n<li>\n<strong>Modern ve Minimalist Tasarım:</strong> Yumuşak köşeleri ve pürüzsüz yüzeyiyle banyonuza şıklık katar.</li>\n<li>\n<strong>Kolay Temizlik:</strong> Asma tasarımı sayesinde klozet altı alanı kolayca temizlenebilir.</li>\n<li>\n<strong>Su Tasarrufu:</strong> 3-6 litre arasında su tüketimi ile çevre dostu bir kullanım sunar.</li>\n<li>\n<strong>Yavaş Kapanır Kapak:</strong> Dahili yavaş kapanır klozet kapağı, sessiz ve konforlu bir kullanım sağlar.</li>\n</ul>\n<p><strong>Not:</strong> Ürünün düzgün çalışabilmesi için uyumlu bir <strong>gömme rezervuar</strong> gereklidir. Gömme rezervuar ürüne dahil değildir ve ayrıca sipariş edilmelidir.</p>\n<p><em>Creavit Terra Asma Klozet, modern banyolar için tasarlanmış şık ve dayanıklı bir tercihtir.</em></p>"
  },
  {
    "id": "creavit-9693677715753",
    "brand": "Creavit",
    "title": "Terra Asma Klozet + Thermoplast Yavaş Kapanan Klozet Kapağı Beyaz - Set",
    "category": "Asma Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-terra-asma-klozet-beyaz_5c558c11-73ff-46b9-adf4-c077f65669d6.png?v=1748944912",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-terra-asma-klozet-beyaz_5c558c11-73ff-46b9-adf4-c077f65669d6.png?v=1748944912",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7203.jpg?v=1748944912",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7204.jpg?v=1748944912",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7205.jpg?v=1748944912",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-thermoplast-yavas-kapanan-klozet-kapagi-beyaz-4450_e41851f1-4920-4c65-b188-2c858dabf8b0.jpg?v=1748944922"
    ],
    "price": "9156.00",
    "sku": "SET.TP325TP.BYZ",
    "tags": [
      "asma klozet",
      "Beyaz",
      "Terra"
    ],
    "variants": [
      {
        "id": 52920965660969,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.TP325TP.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9156.00",
        "grams": 0,
        "compare_at_price": "13080.00",
        "position": 1,
        "product_id": 9693677715753,
        "created_at": "2026-04-03T12:15:17+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<h3>TP325-00CB00E-0000 Asma Klozet – Beyaz (Terra Serisi)</h3>\n<p><strong>Creavit Terra</strong> serisinin bu şık asma klozeti, modern banyolar için hem estetik hem de fonksiyonel bir çözüm sunar. Yumuşak hatları ve dayanıklı yapısıyla dikkat çeker. <meta charset=\"utf-8\">3-6 litre arasında su tüketimi ile çevre dostu bir kullanım sunar.<strong></strong> Dahili yavaş kapanır klozet kapağı, sessiz ve konforlu bir kullanım sağlar.</p>\n<h3>Teknik Özellikler:</h3>\n<ul>\n<li>\n<strong>Montaj Tipi:</strong> Duvara asma</li>\n<li>\n<strong>Yıkama Sistemi:</strong> Kanallı</li>\n<li>\n<strong>Taharet Borusu:</strong> Dahildir</li>\n<li>\n<strong>Klozet Kapağı:</strong> Yavaş kapanır kapak dahil (Kod: KC0903.03.0000E)</li>\n<li>\n<strong>Klozet Kapağı Ağırlığı:</strong> 2,55 kg</li>\n<li>\n<strong>Garanti Süresi:</strong> 12 Yıl</li>\n</ul>\n<p><strong>Not:</strong> Ürünün düzgün çalışabilmesi için uyumlu bir <strong>gömme rezervuar</strong> gereklidir. Gömme rezervuar ürüne dahil değildir ve ayrıca sipariş edilmelidir.</p>"
  },
  {
    "id": "creavit-9693639147817",
    "brand": "Creavit",
    "title": "Tetra Asma Klozet + Duroplast Yavaş Kapanan Klozet Kapağı Beyaz - Set",
    "category": "Asma Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-tetra-asma-klozet-beyaz.png?v=1748952113",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-tetra-asma-klozet-beyaz.png?v=1748952113",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tetra-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7198.jpg?v=1748952113",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tetra-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7197.jpg?v=1748952113",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tetra-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7196.jpg?v=1748952113"
    ],
    "price": "12600.00",
    "sku": "SET.TP326DP.BYZ",
    "tags": [
      "asma klozet",
      "Beyaz",
      "Tetra"
    ],
    "variants": [
      {
        "id": 52929276772649,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.TP326DP.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "12600.00",
        "grams": 0,
        "compare_at_price": "18000.00",
        "position": 1,
        "product_id": 9693639147817,
        "created_at": "2026-04-05T00:05:17+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p style=\"margin: 0cm 0cm 8pt;\" class=\"MsoNormal\"><b><span style=\"font-family: Calibri;\">Modern ve Şık: Creavit Tetra Asma Klozet<!--?xml:namespace prefix = \"o\" ns = \"urn:schemas-microsoft-com:office:office\" /--></span></b></p>\n<p style=\"margin: 0cm 0cm 8pt;\" class=\"MsoNormal\"><b><span style=\"font-family: Calibri;\">Creavit asma klozetler, çağdaş banyo tasarımlarının vazgeçilmez bir parçası haline gelerek modern tarz ve pratik kullanımı bir araya getiriyor. Geleneksel klozetlere göre konforlu banyo deneyiminiz yükseltecek Creavit Asma Klozet avantajlarıyla tanışın!</span></b></p>\n<p style=\"margin: 0cm 0cm 8pt;\" class=\"MsoNormal\"><span style=\"font-family: Calibri;\"><b>Yerden Tasarruf: </b>Asma klozetler, zeminden yüksekte monte edildiği için banyo alanınızın daha geniş ve ferah görünmesini sağlar. Bu, özellikle küçük banyolar için ideal bir çözümdür.<br><b>Modern Tasarım: </b>Tetra Asma Klozet, banyonuza minimalist ve modern bir hava sunarken zarif çizgileri ile banyonuza çağdaş bir dokunuş ekler.</span><b><br><span style=\"font-family: Calibri;\">Temizlik Kolaylığı: </span></b><span style=\"font-family: Calibri;\">Tetra Asma Klozetlerin iç yapısı daha az karmaşık olduğundan, temizlik işleri daha kolay ve hızlı hale gelir. Hijyenik bir banyo ortamı sağlar.</span><b><br><span style=\"font-family: Calibri;\">Gizli Sıhhi Tesisat: </span></b><span style=\"font-family: Calibri;\">Asma klozetler, sıhhi tesisatın çoğunu duvar içine gizler. Bu durum da banyonuzun daha düzenli ve şık görünmesini sağlar.</span><b><br><span style=\"font-family: Calibri;\">Sessiz Çalışma: </span></b><span style=\"font-family: Calibri;\">Sessiz su tahliye sistemi ile çalışan Creavit Asma Klozetler rahatsız edici gürültüyü minimize eder.</span></p>\n<p style=\"margin: 0cm 0cm 8pt;\" class=\"MsoNormal\"><b><span style=\"font-family: Calibri;\">Creavit Asma klozetler, modern bir banyo tasarımı ve yüksek hijyen standartlarına değer verenler için mükemmel bir seçenektir!</span></b></p>\n<p style=\"margin: 0cm 0cm 8pt;\" class=\"MsoNormal\"><b><span style=\"font-family: Calibri;\">Ürün Klozet ve Klozet Kapağı ile Birlikte Gönderilmektedir. </span></b></p>"
  },
  {
    "id": "creavit-9693633282345",
    "brand": "Creavit",
    "title": "Tetra Asma Klozet + Thermoplast Yavaş Kapanan Klozet Kapağı Beyaz - Set",
    "category": "Asma Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-tetra-asma-klozet-beyaz_1dfa604b-7c6b-4db3-b89b-d611e82fd7bb.png?v=1748952509",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-tetra-asma-klozet-beyaz_1dfa604b-7c6b-4db3-b89b-d611e82fd7bb.png?v=1748952509",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tetra-thermopalst-yavas-kapanan-klozet-kapakli-beyaz-set-7195.jpg?v=1748952509",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tetra-thermopalst-yavas-kapanan-klozet-kapakli-beyaz-set-7194.jpg?v=1748952509",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tetra-thermopalst-yavas-kapanan-klozet-kapakli-beyaz-set-7193.jpg?v=1748952509"
    ],
    "price": "10962.00",
    "sku": "SET.TP326TP.BYZ",
    "tags": [
      "asma klozet",
      "asma klozet set",
      "Beyaz",
      "Tetra"
    ],
    "variants": [
      {
        "id": 52938328932649,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.TP326TP.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "10962.00",
        "grams": 0,
        "compare_at_price": "15660.00",
        "position": 1,
        "product_id": 9693633282345,
        "created_at": "2026-04-06T20:06:21+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt\"><b><font face=\"Calibri\">Modern ve Şık: Creavit Tetra Asma Klozet<?xml:namespace prefix = \"o\" ns = \"urn:schemas-microsoft-com:office:office\" /><o:p></o:p></font></b></p>\r\n<p class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt\"><b><font face=\"Calibri\">Creavit asma klozetler, çağdaş banyo tasarımlarının vazgeçilmez bir parçası haline gelerek modern tarz ve pratik kullanımı bir araya getiriyor. Geleneksel klozetlere göre konforlu banyo deneyiminiz yükseltecek Creavit Asma Klozet avantajlarıyla tanışın!<o:p></o:p></font></b></p>\r\n<p class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt\"><font face=\"Calibri\"><strong>Yerden Tasarruf: </strong>Asma klozetler, zeminden yüksekte monte edildiği için banyo alanınızın daha geniş ve ferah görünmesini sağlar. Bu, özellikle küçük banyolar için ideal bir çözümdür.<br><strong>Modern Tasarım: </strong>Tetra Asma Klozet, banyonuza minimalist ve modern bir hava sunarken zarif çizgileri ile banyonuza çağdaş bir dokunuş ekler.<br><strong>Temizlik Kolaylığı: </strong>Tetra Asma Klozetlerin iç yapısı daha az karmaşık olduğundan, temizlik işleri daha kolay ve hızlı hale gelir. Hijyenik bir banyo ortamı sağlar.<br><strong>Gizli Sıhhi Tesisat:</strong> Asma klozetler, sıhhi tesisatın çoğunu duvar içine gizler. Bu durum da banyonuzun daha düzenli ve şık görünmesini sağlar.<br><strong>Sessiz Çalışma: </strong>Sessiz su tahliye sistemi ile çalışan Creavit Asma Klozetler rahatsız edici gürültüyü minimize eder<strong>.<o:p></o:p></strong></font></p>\r\n<p class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt\"><b><font face=\"Calibri\">Creavit Asma klozetler, modern bir banyo tasarımı ve yüksek hijyen standartlarına değer verenler için mükemmel bir seçenektir!</font></b></p>\r\n<p class=\"MsoNormal\" style=\"MARGIN: 0cm 0cm 8pt\"><b><font face=\"Calibri\">Ürün Klozet ve Klozet Kapağı Olarak Gönderilmektedir.</font></b></p>"
  },
  {
    "id": "creavit-9693626368297",
    "brand": "Creavit",
    "title": "Lara Duvara Dayalı Klozet + Duroplast Yavaş Kapanan Klozet Kapağı Beyaz - Set",
    "category": "Takım Klozetler",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-beyaz-takim-klozet-duvara-dayali-klozet_7253c326-15e0-4588-9190-5a32d2a30cb8.png?v=1748864785",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-beyaz-takim-klozet-duvara-dayali-klozet_7253c326-15e0-4588-9190-5a32d2a30cb8.png?v=1748864785",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7289_c687ff09-ec58-47fd-89c8-6863d5236c64.jpg?v=1748864785",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7288_8b07d7a3-8eb0-49b0-9976-fa72c785aad5.jpg?v=1748864785",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7287_9a2284cf-b639-43d6-b259-110de205998c.jpg?v=1748864785",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7290_e5a17c42-5d59-402f-a3bd-5427c7c0887e.png?v=1748865057",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-duroplast-yavas-kapanan-klozet-kapakli-beyaz-set-7284.jpg?v=1748865057",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-thermoplast-yavas-kapanan-klozet-kapakli-beyaz-set-7292_5d46a15f-6057-46a7-a726-08507498d16e.jpg?v=1748865057",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4421_0373c35a-4065-41ef-8a81-766f6b315034.jpg?v=1748865057"
    ],
    "price": "17556.00",
    "sku": "SET.LR360DP.BYZ",
    "tags": [
      "Beyaz",
      "duvara dayalı klozet",
      "Lara",
      "Takım Klozet",
      "Vitrifiye"
    ],
    "variants": [
      {
        "id": 52929276248361,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.LR360DP.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "17556.00",
        "grams": 0,
        "compare_at_price": "25080.00",
        "position": 1,
        "product_id": 9693626368297,
        "created_at": "2026-04-05T00:05:11+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<p><strong>İkonik Tasarım: </strong>Creavit Nova Klozetler banyo tasarımında yenilikçi ve modern bir yaklaşım isteyenlere özel seçenekler sunuyor. Bu özel tasarımlı klozet serisi beyaz rengi ve zarif hatlarıyla, banyonuza sade ve çağdaş bir dokunuş eklerken, aynı zamanda işlevselliğiyle de dikkat çekiyor.</p>\r\n<p data-mce-fragment=\"1\"><span style=\"FONT-FAMILY: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif\"><strong>Bakterilere Yer Bırakmayan Tasarım: </strong>Nova Rim-Off Klozetler, kanalsız tasarımları sayesinde klozet içerisinde temizlik esnasında ulaşılması güç yüzeyleri minimize eder. İç haznede erişilemeyen yüzey olmadığı için bakteri ve türevleri için elverişli ortam oluşmasına engel olur.</span></p>\r\n<p data-mce-fragment=\"1\"><span style=\"FONT-FAMILY: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif\"><strong>Temizlikte Kolaylık: </strong>Creavit sırlama teknolojisi sayesinde klozet üzerinde kireç ve su lekeleri gibi istenmeyen izlerin oluşması engellenir. Banyo temizliğini kolaylaştırırken hijyen seviyelerini de korur.</span></p><!---->"
  },
  {
    "id": "creavit-9693617848617",
    "brand": "Creavit",
    "title": "Elegant Kanalsız Asma Klozet + Duroplast Yavaş Kapanan Klozet Kapağı Beyaz - Set",
    "category": "Rim-Off Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-elegant-kanalsiz-klozet-takimi-beyaz.png?v=1748953195",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-elegant-kanalsiz-klozet-takimi-beyaz.png?v=1748953195",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-asma-klozet-ve-duroplast-yavas-kapanan-klozet-kapagi-7187.jpg?v=1748953195",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-asma-klozet-ve-duroplast-yavas-kapanan-klozet-kapagi-7185.jpg?v=1748953195",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-asma-klozet-ve-duroplast-yavas-kapanan-klozet-kapagi-7188.jpg?v=1748953195",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-asma-klozet-ve-duroplast-yavas-kapanan-klozet-kapagi-7186.jpg?v=1748953195",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-asma-klozet-ve-duroplast-yavas-kapanan-klozet-kapagi-7189.jpg?v=1748953195",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-asma-klozet-ve-duroplast-yavas-kapanan-klozet-kapagi-7184.jpg?v=1748953195"
    ],
    "price": "14826.00",
    "sku": "SET.EG321DP.BYZ",
    "tags": [
      "asma klozet",
      "asma klozet set",
      "elegant",
      "kanalsız klozet"
    ],
    "variants": [
      {
        "id": 52921474285865,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.EG321DP.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "14826.00",
        "grams": 0,
        "compare_at_price": "21180.00",
        "position": 1,
        "product_id": 9693617848617,
        "created_at": "2026-04-03T14:42:10+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"markdown prose w-full break-words dark:prose-invert light\"><span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\">Elegant Kanalsız Klozetler, köşeli dış hatları ve asma yapısıyla kolay temizlenir. Kanalsız tasarımları sayesinde iç haznede erişilemeyen yüzey olmadığı için bakteri ve türevleri için elverişli ortam oluşmasına engel olur. Elegant Asma Klozetlerin güçlü formu ile banyonuzda tarzı ve kusursuz hijyeni yakalayacaksınız.</span></div>\n<div class=\"markdown prose w-full break-words dark:prose-invert light\"><br></div>\n<div class=\"markdown prose w-full break-words dark:prose-invert light\"><strong><span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\">Klozetler için montaj kiti dahildir.</span></strong></div>"
  },
  {
    "id": "creavit-9692416377129",
    "brand": "Creavit",
    "title": "Nova Kanalsız Duvara Dayalı Klozet + Thermoplast Yavaş Kapanan Klozet Kapağı Beyaz - Set",
    "category": "Rim-Off Klozet",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/nova-klozet-rim-off-duvara-dayali-beyaz-7179_b9107cdb-deed-4e67-9de2-5732f3d1e7d3.jpg?v=1746598134",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/nova-klozet-rim-off-duvara-dayali-beyaz-7179_b9107cdb-deed-4e67-9de2-5732f3d1e7d3.jpg?v=1746598134",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/nova-klozet-rim-off-duvara-dayali-beyaz-7180_d50651ed-72ef-4dd8-bc4b-4639b390b19b.jpg?v=1746598136",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/nova-klozet-rim-off-duvara-dayali-beyaz-7182_2eacfc06-7328-4fe7-94d0-95b79e21fe70.jpg?v=1748954360",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/nova-klozet-rim-off-duvara-dayali-beyaz-7181_32879f58-c08e-4306-b09e-6739b168f181.jpg?v=1748954360",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/nova-klozet-rim-off-duvara-dayali-beyaz-7183_2831a2c0-50b6-4c32-be96-bb0a946e574c.jpg?v=1746598144"
    ],
    "price": "17178.00",
    "sku": "SET.NV361TP.BYZ",
    "tags": [
      "Beyaz",
      "kanalsız klozet",
      "nova",
      "rim-off",
      "Takım Klozet",
      "takım klozet set"
    ],
    "variants": [
      {
        "id": 52938328473897,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SET.NV361TP.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "17178.00",
        "grams": 0,
        "compare_at_price": "24540.00",
        "position": 1,
        "product_id": 9692416377129,
        "created_at": "2026-04-06T20:06:14+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\n<p><strong>İkonik Tasarım: </strong>Creavit Nova Klozetler banyo tasarımında yenilikçi ve modern bir yaklaşım isteyenlere özel seçenekler sunuyor. Bu özel tasarımlı klozet serisi beyaz rengi ve zarif hatlarıyla, banyonuza sade ve çağdaş bir dokunuş eklerken, aynı zamanda işlevselliğiyle de dikkat çekiyor.</p>\n<p data-mce-fragment=\"1\"><span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;\"><strong>Bakterilere Yer Bırakmayan Tasarım: </strong>Nova Rim-Off Klozetler, kanalsız tasarımları sayesinde klozet içerisinde temizlik esnasında ulaşılması güç yüzeyleri minimize eder. İç haznede erişilemeyen yüzey olmadığı için bakteri ve türevleri için elverişli ortam oluşmasına engel olur.</span></p>\n<p data-mce-fragment=\"1\"><span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;\"><strong>Temizlikte Kolaylık: </strong>Creavit sırlama teknolojisi sayesinde klozet üzerinde kireç ve su lekeleri gibi istenmeyen izlerin oluşması engellenir. Banyo temizliğini kolaylaştırırken hijyen seviyelerini de korur.</span></p>\n<!---->"
  },
  {
    "id": "creavit-9677248889129",
    "brand": "Creavit",
    "title": "Patara Yuvarlak Led Ayna 60 cm Mat Beyaz",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT.4060.02.MBY.jpg?v=1756816564",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT.4060.02.MBY.jpg?v=1756816564",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-patara-boy-dolabi-beyaz_9178cab1-9e99-4e33-b5ad-ecc9dd347bcc.png?v=1756816564"
    ],
    "price": "21120.00",
    "sku": "PT4060.02.MBY",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "Patara"
    ],
    "variants": [
      {
        "id": 52843211686185,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "PT4060.02.MBY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "21120.00",
        "grams": 0,
        "compare_at_price": "28160.00",
        "position": 1,
        "product_id": 9677248889129,
        "created_at": "2026-03-17T12:54:14+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><meta charset=\"utf-8\">Zarif tasarımı ve fonksiyonelliği bir araya getiren Patara banyo mobilyaları, masif kulpları ve ayaklı yapısıyla şıklığı ön plana çıkarıyor. LED aynası banyolara modern bir dokunuş katarken, kullanım konforunuz artacak. Geniş depolama alanı, banyo malzemelerinizi düzenli bir şekilde saklamanızı sağlarken, kaliteli malzemesi uzun ömürlü bir kullanım sunar. Creavit Patara serisi estetik ve pratik çözümler arayanlar için idealdir!</p>"
  },
  {
    "id": "creavit-9590884270377",
    "brand": "Creavit",
    "title": "Terra Gun Grey Boyalı Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-terra-gun-grey-kumanda-paneli.png?v=1748962752",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-terra-gun-grey-kumanda-paneli.png?v=1748962752",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-gun-grey-boyali-kumanda-paneli-7148.jpg?v=1748962752",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-gun-grey-boyali-kumanda-paneli-7149.jpg?v=1748962752",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-gun-grey-boyali-kumanda-paneli-7150.jpg?v=1748962752"
    ],
    "price": "2016.00",
    "sku": "GP9002.11",
    "tags": [
      "Gun Grey",
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "Rezervuar",
      "Rezervuarlar",
      "Terra",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52843211358505,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP9002.11",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2016.00",
        "grams": 0,
        "compare_at_price": "2880.00",
        "position": 1,
        "product_id": 9590884270377,
        "created_at": "2026-03-17T12:54:08+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><meta charset=\"utf-8\"><span data-mce-fragment=\"1\">Creavit Terra Kumanda Paneli banyo deneyiminizi işlevsel hale getirirken aynı zamanda modern ve şık görünümüyle banyonuza estetik bir katkı sunar. Kaliteli malzemelerden üretilmiş olan bu kumanda paneli dayanıklı yapısıyla da uzun ömürlü kullanım sağlar.</span></p>\n<p><span data-mce-fragment=\"1\"><meta charset=\"utf-8\">\n<strong>Terra kumanda paneli sadece Creavit Marka Gömme Rezervuarlar İle Uyumludur.</strong></span></p>"
  },
  {
    "id": "creavit-9590860251433",
    "brand": "Creavit",
    "title": "Terra Kömür Karası Boyalı Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-terra-gun-komur-karasi-paneli.png?v=1748962859",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-terra-gun-komur-karasi-paneli.png?v=1748962859",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-komur-karasi-boyali-kumanda-paneli-7145.jpg?v=1748962859",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-komur-karasi-boyali-kumanda-paneli-7146.jpg?v=1748962859",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-komur-karasi-boyali-kumanda-paneli-7147.jpg?v=1748962859"
    ],
    "price": "2016.00",
    "sku": "GP9002.10",
    "tags": [
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "Kömür Karası",
      "Rezervuar",
      "Rezervuarlar",
      "Terra",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52843245568297,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP9002.10",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2016.00",
        "grams": 0,
        "compare_at_price": "2880.00",
        "position": 1,
        "product_id": 9590860251433,
        "created_at": "2026-03-17T13:05:03+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><meta charset=\"utf-8\"><span data-mce-fragment=\"1\">Creavit Terra Kumanda Paneli banyo deneyiminizi işlevsel hale getirirken aynı zamanda modern ve şık görünümüyle banyonuza estetik bir katkı sunar. Kaliteli malzemelerden üretilmiş olan bu kumanda paneli dayanıklı yapısıyla da uzun ömürlü kullanım sağlar.</span></p>\n<p><span data-mce-fragment=\"1\"><meta charset=\"utf-8\">Terra kumanda paneli sadece Creavit Marka Gömme Rezervuarlar İle Uyumludur.</span></p>"
  },
  {
    "id": "creavit-8976456450345",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı Çekmeceli 65 cm Dafne Melamin",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-65cm-antrasit-mese-lavabo-dolabi-cekmeceli-banyo-mobilyasi.png?v=1748177181",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-65cm-antrasit-mese-lavabo-dolabi-cekmeceli-banyo-mobilyasi.png?v=1748177181",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-65-cm-dafne-melamin-6194.jpg?v=1748177181",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-65-cm-dafne-melamin-6195.jpg?v=1748177181",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-65-cm-dafne-melamin-6193.jpg?v=1748177181",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-65-cm-dafne-melamin-6196.jpg?v=1748177178",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-65-cm-dafne-melamin-6197.jpg?v=1748177178"
    ],
    "price": "6336.00",
    "sku": "D10.LD065.1C.M.M.T.02042",
    "tags": [
      "Antrasit",
      "Banyo Mobilyası",
      "D10",
      "Dafne",
      "Lavabo Dolabı",
      "Melamin",
      "Meşe",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52921488834857,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.1C.M.M.T.02042",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6336.00",
        "grams": 0,
        "compare_at_price": "7920.00",
        "position": 1,
        "product_id": 8976456450345,
        "created_at": "2026-04-03T14:45:28+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<meta charset=\"utf-8\">\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><span>D10’la Karıştır, Banyona Yakıştır!</span></p>\r\n\r\n<p><strong>İçinde Sen Varsın</strong></p>\r\n\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><span>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</span></p>\r\n\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><strong>Saklama Alanını Belirle </strong></p>\r\n\r\n<p><span>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek saklama alanını genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</span></p>\r\n\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><strong>Renkleri Deneyimle </strong></p>\r\n\r\n<p><span>D10’un renklerini kendi zevklerine göre kombinleyerek banyonda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için </span><span>banyo bu tarafta.</span></p>\r\n\r\n<div class=\"page\" title=\"Page 178\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><strong>Senin Lavab’ON </strong></p>\r\n\r\n<p><span>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş banyo deneyimi bu tarafta. </span></p>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>"
  },
  {
    "id": "creavit-8976429613353",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı İki Çekmeceli 65 cm Beyaz Lake Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-65cm-beyaz-lavabo-dolabi-cekmeceli-lake-banyo-mobilyasi.png?v=1748177386",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-65cm-beyaz-lavabo-dolabi-cekmeceli-lake-banyo-mobilyasi.png?v=1748177386",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-beyaz-lake-kapak-6186.jpg?v=1748177386",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-beyaz-lake-kapak-6187.jpg?v=1748177386",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-beyaz-lake-kapak-6185.jpg?v=1748177386",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-beyaz-lake-kapak-6188.jpg?v=1748177381",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-beyaz-lake-kapak-6189.jpg?v=1748177381"
    ],
    "price": "10648.00",
    "sku": "D10.LD065.2C.M.L.T.01011",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "iki çekmeceli lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843075305769,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.2C.M.L.T.01011",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "10648.00",
        "grams": 0,
        "compare_at_price": "13310.00",
        "position": 1,
        "product_id": 8976429613353,
        "created_at": "2026-03-17T11:53:41+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<meta charset=\"utf-8\">\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><span>D10’la Karıştır, Banyona Yakıştır!</span></p>\r\n\r\n<p><strong>İçinde Sen Varsın</strong></p>\r\n\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><span>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</span></p>\r\n\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><strong>Saklama Alanını Belirle </strong></p>\r\n\r\n<p><span>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek saklama alanını genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</span></p>\r\n\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><strong>Renkleri Deneyimle </strong></p>\r\n\r\n<p><span>D10’un renklerini kendi zevklerine göre kombinleyerek banyonda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için </span><span>banyo bu tarafta.</span></p>\r\n\r\n<div class=\"page\" title=\"Page 178\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><strong>Senin Lavab’ON </strong></p>\r\n\r\n<p><span>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş banyo deneyimi bu tarafta. </span></p>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>"
  },
  {
    "id": "creavit-8976423813417",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı İki Çekmeceli 65 cm Dafne Lake Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-65cm-dafne-lavabo-dolabi-cekmeceli-lake-banyo-mobilyasi.png?v=1748177504",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-65cm-dafne-lavabo-dolabi-cekmeceli-lake-banyo-mobilyasi.png?v=1748177504",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-dafne-lake-kapak-6179.jpg?v=1748177504",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-dafne-lake-kapak-6178.jpg?v=1748177504",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-dafne-lake-kapak-6177.jpg?v=1748177504",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-dafne-lake-kapak-6182.jpg?v=1748177494",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-dafne-lake-kapak-6184.jpg?v=1748177494"
    ],
    "price": "10648.00",
    "sku": "D10.LD065.2C.M.L.T.02022",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "Dafne",
      "iki çekmeceli lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52920977654057,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.2C.M.L.T.02022",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "10648.00",
        "grams": 0,
        "compare_at_price": "13310.00",
        "position": 1,
        "product_id": 8976423813417,
        "created_at": "2026-04-03T12:17:41+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8976417325353",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı İki Çekmeceli 65 cm Gri Lake Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-65cm-gri-lavabo-dolabi-cekmeceli-lake-banyo-mobilyasi.png?v=1748177640",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-65cm-gri-lavabo-dolabi-cekmeceli-lake-banyo-mobilyasi.png?v=1748177640",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-gri-lake-kapak-6170.jpg?v=1748177640",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-gri-lake-kapak-6171.jpg?v=1748177640",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-gri-lake-kapak-6172.jpg?v=1748177640",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-gri-lake-kapak-6169.jpg?v=1748177640",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-gri-lake-kapak-6174.jpg?v=1748177629",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-gri-lake-kapak-6176.jpg?v=1748177629"
    ],
    "price": "10648.00",
    "sku": "D10.LD065.2C.M.L.T.03033",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "Gri",
      "iki çekmeceli lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52921488539945,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.2C.M.L.T.03033",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "10648.00",
        "grams": 0,
        "compare_at_price": "13310.00",
        "position": 1,
        "product_id": 8976417325353,
        "created_at": "2026-04-03T14:45:24+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-8976395305257",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı İki Çekmeceli 65 cm Beyaz",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-65cm-beyaz-lavabo-dolabi-cekmeceli-melamin-banyo-mobilyasi.png?v=1748177836",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-65cm-beyaz-lavabo-dolabi-cekmeceli-melamin-banyo-mobilyasi.png?v=1748177836",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-beyaz-6160.jpg?v=1748177836",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-beyaz-6159.jpg?v=1748177836",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-beyaz-6158.jpg?v=1748177836",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-beyaz-6161.jpg?v=1748177832",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-beyaz-6163.jpg?v=1748177832"
    ],
    "price": "9152.00",
    "sku": "D10.LD065.2C.M.M.T.01011",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52920977391913,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.2C.M.M.T.01011",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9152.00",
        "grams": 0,
        "compare_at_price": "11440.00",
        "position": 1,
        "product_id": 8976395305257,
        "created_at": "2026-04-03T12:17:38+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-8976389275945",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı İki Çekmeceli 65 cm Dafne Gövde Antrasit Meşe Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-65cm-antrasit-mese-lavabo-dolabi-cekmeceli-melamin-banyo-mobilyasi.png?v=1748251067",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-65cm-antrasit-mese-lavabo-dolabi-cekmeceli-melamin-banyo-mobilyasi.png?v=1748251067",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-dafne-govde-antrasit-mese-kapak-6154.jpg?v=1748251067",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-dafne-govde-antrasit-mese-kapak-6153.jpg?v=1748251067",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-dafne-govde-antrasit-mese-kapak-6152.jpg?v=1748251067",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-dafne-govde-antrasit-mese-kapak-6155.jpg?v=1748251064",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-dafne-govde-antrasit-mese-kapak-6156.jpg?v=1748251064"
    ],
    "price": "9152.00",
    "sku": "D10.LD065.2C.M.M.T.02042",
    "tags": [
      "Antrasit",
      "Banyo Mobilyası",
      "D10",
      "Dafne",
      "Lavabo Dolabı",
      "Melamin",
      "Meşe",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843075010857,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.2C.M.M.T.02042",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9152.00",
        "grams": 0,
        "compare_at_price": "11440.00",
        "position": 1,
        "product_id": 8976389275945,
        "created_at": "2026-03-17T11:53:35+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8976378659113",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı İki Çekmeceli 65 cm Gri Gövde Antrasit Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-65cm-antrasit-lavabo-dolabi-cekmeceli-melamin-banyo-mobilyasi.png?v=1748251396",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-65cm-antrasit-lavabo-dolabi-cekmeceli-melamin-banyo-mobilyasi.png?v=1748251396",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-gri-govde-antrasit-kapak-6147.jpg?v=1748251396",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-gri-govde-antrasit-kapak-6146.jpg?v=1748251396",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-gri-govde-antrasit-kapak-6145.jpg?v=1748251396",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-gri-govde-antrasit-kapak-6144.jpg?v=1748251396",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-gri-govde-antrasit-kapak-6149.jpg?v=1748251390",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-65-cm-gri-govde-antrasit-kapak-6150.jpg?v=1748251390"
    ],
    "price": "9152.00",
    "sku": "D10.LD065.2C.M.M.T.03053",
    "tags": [
      "Antrasit",
      "Banyo Mobilyası",
      "D10",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843074912553,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.2C.M.M.T.03053",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "9152.00",
        "grams": 0,
        "compare_at_price": "11440.00",
        "position": 1,
        "product_id": 8976378659113,
        "created_at": "2026-03-17T11:53:32+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-8975837167913",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı Kapaklı 65 cm Beyaz Lake Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-65cm-beyaz-lavabo-dolabi-kapakli-lake-banyo-mobilyasi.png?v=1748252207",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-65cm-beyaz-lavabo-dolabi-kapakli-lake-banyo-mobilyasi.png?v=1748252207",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-beyaz-lake-kapak-6130.jpg?v=1748252207",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-beyaz-lake-kapak-6131.jpg?v=1748252207",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-beyaz-lake-kapak-6129.jpg?v=1748252207",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-beyaz-lake-kapak-6132.jpg?v=1748252203",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-beyaz-lake-kapak-6133.jpg?v=1748252203"
    ],
    "price": "7480.00",
    "sku": "D10.LD065.K.M.L.T.01011",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "kapaklı lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843074781481,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.K.M.L.T.01011",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7480.00",
        "grams": 0,
        "compare_at_price": "9350.00",
        "position": 1,
        "product_id": 8975837167913,
        "created_at": "2026-03-17T11:53:28+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<meta charset=\"utf-8\">\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><span>D10’la Karıştır, Banyona Yakıştır!</span></p>\r\n\r\n<p><strong>İçinde Sen Varsın</strong></p>\r\n\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><span>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</span></p>\r\n\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><strong>Saklama Alanını Belirle </strong></p>\r\n\r\n<p><span>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek saklama alanını genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</span></p>\r\n\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><strong>Renkleri Deneyimle </strong></p>\r\n\r\n<p><span>D10’un renklerini kendi zevklerine göre kombinleyerek banyonda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için </span><span>banyo bu tarafta.</span></p>\r\n\r\n<div class=\"page\" title=\"Page 178\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><strong>Senin Lavab’ON </strong></p>\r\n\r\n<p><span>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş banyo deneyimi bu tarafta. </span></p>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>"
  },
  {
    "id": "creavit-8975822029097",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı Kapaklı 65 cm Gri Gövde Lake Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-65cm-gri-lavabo-dolabi-kapakli-lake-banyo-mobilyasi.png?v=1748252337",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-65cm-gri-lavabo-dolabi-kapakli-lake-banyo-mobilyasi.png?v=1748252337",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-gri-govde-lake-kapak-6119.jpg?v=1748252337",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-gri-govde-lake-kapak-6120.jpg?v=1748252337",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-gri-govde-lake-kapak-6118.jpg?v=1748252337",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-gri-govde-lake-kapak-6121.jpg?v=1748252333",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-gri-govde-lake-kapak-6122.jpg?v=1748252333"
    ],
    "price": "7480.00",
    "sku": "D10.LD065.K.M.L.T.03033",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "Gri",
      "kapaklı lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52920977129769,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.K.M.L.T.03033",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7480.00",
        "grams": 0,
        "compare_at_price": "9350.00",
        "position": 1,
        "product_id": 8975822029097,
        "created_at": "2026-04-03T12:17:35+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p> </p>\n<div class=\"page\" title=\"Page 177\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><span>D10’la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<div class=\"page\" title=\"Page 177\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><span>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</span></p>\n<div class=\"page\" title=\"Page 177\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Saklama Alanını Belirle </strong></p>\n<p><span>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek saklama alanını genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</span></p>\n<div class=\"page\" title=\"Page 177\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Renkleri Deneyimle </strong></p>\n<p><span>D10’un renklerini kendi zevklerine göre kombinleyerek banyonda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için </span><span>banyo bu tarafta.</span></p>\n<div class=\"page\" title=\"Page 178\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Senin Lavab’ON </strong></p>\n<p><span>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş banyo deneyimi bu tarafta. </span></p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8975776678185",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı Kapaklı 65 cm Beyaz Melamin Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-65cm-beyaz-lavabo-dolabi-kapakli-melamin-banyo-mobilyasi.png?v=1748252496",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-65cm-beyaz-lavabo-dolabi-kapakli-melamin-banyo-mobilyasi.png?v=1748252496",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-beyaz-6108.jpg?v=1748252496",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-beyaz-6109.jpg?v=1748252496",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-beyaz-6107.jpg?v=1748252496",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-beyaz-6110.jpg?v=1748252492",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-beyaz-6111.jpg?v=1748252492"
    ],
    "price": "5808.00",
    "sku": "D10.LD065.K.M.M.T.01011",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843074584873,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.K.M.M.T.01011",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "5808.00",
        "grams": 0,
        "compare_at_price": "7260.00",
        "position": 1,
        "product_id": 8975776678185,
        "created_at": "2026-03-17T11:53:25+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<meta charset=\"utf-8\">\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><span>D10’la Karıştır, Banyona Yakıştır!</span></p>\r\n\r\n<p><strong>İçinde Sen Varsın</strong></p>\r\n\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><span>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</span></p>\r\n\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><strong>Saklama Alanını Belirle </strong></p>\r\n\r\n<p><span>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek saklama alanını genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</span></p>\r\n\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><strong>Renkleri Deneyimle </strong></p>\r\n\r\n<p><span>D10’un renklerini kendi zevklerine göre kombinleyerek banyonda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için </span><span>banyo bu tarafta.</span></p>\r\n\r\n<div class=\"page\" title=\"Page 178\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><strong>Senin Lavab’ON </strong></p>\r\n\r\n<p><span>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş banyo deneyimi bu tarafta. </span></p>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>"
  },
  {
    "id": "creavit-8975766716713",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı Kapaklı 65 cm Dafne Gövde Antrasit Meşe Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-65cm-antrasit-mese-lavabo-dolabi-kapakli-melamin-banyo-mobilyasi.png?v=1748252631",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-65cm-antrasit-mese-lavabo-dolabi-kapakli-melamin-banyo-mobilyasi.png?v=1748252631",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-dafne-govde-antrasit-mese-kapak-6103.jpg?v=1748252631",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-dafne-govde-antrasit-mese-kapak-6104.jpg?v=1748252631",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-dafne-govde-antrasit-mese-kapak-6102.jpg?v=1748252631",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-dafne-govde-antrasit-mese-kapak-6105.jpg?v=1748252628",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-dafne-govde-antrasit-mese-kapak-6106.jpg?v=1748252628"
    ],
    "price": "5808.00",
    "sku": "D10.LD065.K.M.M.T.02042",
    "tags": [
      "Antrasit",
      "Banyo Mobilyası",
      "D10",
      "Dafne",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı",
      "Meşe",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843076944169,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.K.M.M.T.02042",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "5808.00",
        "grams": 0,
        "compare_at_price": "7260.00",
        "position": 1,
        "product_id": 8975766716713,
        "created_at": "2026-03-17T11:54:18+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<meta charset=\"utf-8\">\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><span>D10’la Karıştır, Banyona Yakıştır!</span></p>\r\n\r\n<p><strong>İçinde Sen Varsın</strong></p>\r\n\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><span>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</span></p>\r\n\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><strong>Saklama Alanını Belirle </strong></p>\r\n\r\n<p><span>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek saklama alanını genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</span></p>\r\n\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><strong>Renkleri Deneyimle </strong></p>\r\n\r\n<p><span>D10’un renklerini kendi zevklerine göre kombinleyerek banyonda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için </span><span>banyo bu tarafta.</span></p>\r\n\r\n<div class=\"page\" title=\"Page 178\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><strong>Senin Lavab’ON </strong></p>\r\n\r\n<p><span>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş banyo deneyimi bu tarafta. </span></p>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>"
  },
  {
    "id": "creavit-8975758393641",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı Kapaklı 65 cm Gri Gövde Antrasit Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-65cm-antrasit-lavabo-dolabi-kapakli-melamin-banyo-mobilyasi.png?v=1748252725",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-65cm-antrasit-lavabo-dolabi-kapakli-melamin-banyo-mobilyasi.png?v=1748252725",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-gri-govde-antrasit-kapak-6098.jpg?v=1748252725",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-gri-govde-antrasit-kapak-6099.jpg?v=1748252725",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-gri-govde-antrasit-kapak-6097.jpg?v=1748252725",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-gri-govde-antrasit-kapak-6100.jpg?v=1748252721",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-65-cm-gri-govde-antrasit-kapak-6101.jpg?v=1748252721"
    ],
    "price": "5808.00",
    "sku": "D10.LD065.K.M.M.T.03053",
    "tags": [
      "Antrasit",
      "Banyo Mobilyası",
      "D10",
      "Gri",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843081367849,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.K.M.M.T.03053",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5808.00",
        "grams": 0,
        "compare_at_price": "7260.00",
        "position": 1,
        "product_id": 8975758393641,
        "created_at": "2026-03-17T11:55:53+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<meta charset=\"utf-8\">\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><span>D10’la Karıştır, Banyona Yakıştır!</span></p>\r\n\r\n<p><strong>İçinde Sen Varsın</strong></p>\r\n\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><span>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</span></p>\r\n\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><strong>Saklama Alanını Belirle </strong></p>\r\n\r\n<p><span>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek saklama alanını genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</span></p>\r\n\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><strong>Renkleri Deneyimle </strong></p>\r\n\r\n<p><span>D10’un renklerini kendi zevklerine göre kombinleyerek banyonda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için </span><span>banyo bu tarafta.</span></p>\r\n\r\n<div class=\"page\" title=\"Page 178\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><strong>Senin Lavab’ON </strong></p>\r\n\r\n<p><span>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş banyo deneyimi bu tarafta. </span></p>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>"
  },
  {
    "id": "creavit-8975752528169",
    "brand": "Creavit",
    "title": "D10 Eksen Lavabo Dolabı Çekmeceli 80 cm Beyaz Lake kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-eksen-lavabolu-80cm-beyaz-lavabo-dolabi-cekmeceli-lake-banyo-mobilyasi.png?v=1748252854",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-eksen-lavabolu-80cm-beyaz-lavabo-dolabi-cekmeceli-lake-banyo-mobilyasi.png?v=1748252854",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-80-cm-beyaz-lake-6094.jpg?v=1748252854",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-80-cm-beyaz-lake-6093.jpg?v=1748252854",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-80-cm-beyaz-lake-6092.jpg?v=1748252854",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-80-cm-beyaz-lake-6095.jpg?v=1748252851",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-80-cm-beyaz-lake-6096.jpg?v=1748252851"
    ],
    "price": "8184.00",
    "sku": "D10.LD080.1C.M.L.0101",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843077108009,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD080.1C.M.L.0101",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "8184.00",
        "grams": 0,
        "compare_at_price": "10230.00",
        "position": 1,
        "product_id": 8975752528169,
        "created_at": "2026-03-17T11:54:21+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<meta charset=\"utf-8\">\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><span>D10’la Karıştır, Banyona Yakıştır!</span></p>\r\n\r\n<p><strong>İçinde Sen Varsın</strong></p>\r\n\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><span>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</span></p>\r\n\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><strong>Saklama Alanını Belirle </strong></p>\r\n\r\n<p><span>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek saklama alanını genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</span></p>\r\n\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><strong>Renkleri Deneyimle </strong></p>\r\n\r\n<p><span>D10’un renklerini kendi zevklerine göre kombinleyerek banyonda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için </span><span>banyo bu tarafta.</span></p>\r\n\r\n<div class=\"page\" title=\"Page 178\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><strong>Senin Lavab’ON </strong></p>\r\n\r\n<p><span>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş banyo deneyimi bu tarafta. </span></p>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>"
  },
  {
    "id": "creavit-8975738765609",
    "brand": "Creavit",
    "title": "D10 Eksen Lavabo Dolabı Çekmeceli 80 cm Gri Lake Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-eksen-lavabolu-80cm-gri-lavabo-dolabi-cekmeceli-lake-banyo-mobilyasi.png?v=1748253155",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-eksen-lavabolu-80cm-gri-lavabo-dolabi-cekmeceli-lake-banyo-mobilyasi.png?v=1748253155",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-80-cm-gri-lake-6080.jpg?v=1748253155",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-80-cm-gri-lake-6081.jpg?v=1748253155",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-80-cm-gri-lake-6079.jpg?v=1748253155",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-80-cm-gri-lake-6083.jpg?v=1748253152",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-80-cm-gri-lake-6084.jpg?v=1748253152"
    ],
    "price": "8184.00",
    "sku": "D10.LD080.1C.M.L.0303",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "Gri",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52917813969193,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD080.1C.M.L.0303",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8184.00",
        "grams": 0,
        "compare_at_price": "10230.00",
        "position": 1,
        "product_id": 8975738765609,
        "created_at": "2026-04-02T22:29:03+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-8975725134121",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı Çekmeceli 80 cm Beyaz Lake Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-80cm-beyaz-lavabo-dolabi-cekmeceli-lake-banyo-mobilyasi.png?v=1748253274",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-80cm-beyaz-lavabo-dolabi-cekmeceli-lake-banyo-mobilyasi.png?v=1748253274",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-80-cm-beyaz-lake-6075.jpg?v=1748253274",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-80-cm-beyaz-lake-6076.jpg?v=1748253274",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-80-cm-beyaz-lake-6074.jpg?v=1748253274",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-80-cm-beyaz-lake-6077.jpg?v=1748253272",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-80-cm-beyaz-lake-6078.jpg?v=1748253272"
    ],
    "price": "8096.00",
    "sku": "D10.LD080.1C.M.L.T.01011",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843074289961,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD080.1C.M.L.T.01011",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8096.00",
        "grams": 0,
        "compare_at_price": "10120.00",
        "position": 1,
        "product_id": 8975725134121,
        "created_at": "2026-03-17T11:53:19+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8975699902761",
    "brand": "Creavit",
    "title": "D10 Eksen Lavabo Dolabı Çekmeceli 80 cm Beyaz Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-eksen-lavabolu-80cm-beyaz-lavabo-dolabi-cekmeceli-melamin-banyo-mobilyasi.png?v=1748253552",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-eksen-lavabolu-80cm-beyaz-lavabo-dolabi-cekmeceli-melamin-banyo-mobilyasi.png?v=1748253552",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-80-cm-beyaz-6058.jpg?v=1748253552",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-80-cm-beyaz-6059.jpg?v=1748253552",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-80-cm-beyaz-6057.jpg?v=1748253552",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-80-cm-beyaz-6061.jpg?v=1748253545",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-80-cm-beyaz-6062.jpg?v=1748253545"
    ],
    "price": "6864.00",
    "sku": "D10.LD080.1C.M.M.0101",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52921487327529,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD080.1C.M.M.0101",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "6864.00",
        "grams": 0,
        "compare_at_price": "8580.00",
        "position": 1,
        "product_id": 8975699902761,
        "created_at": "2026-04-03T14:45:08+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<meta charset=\"utf-8\">\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><span>D10’la Karıştır, Banyona Yakıştır!</span></p>\r\n\r\n<p><strong>İçinde Sen Varsın</strong></p>\r\n\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><span>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</span></p>\r\n\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><strong>Saklama Alanını Belirle </strong></p>\r\n\r\n<p><span>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek saklama alanını genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</span></p>\r\n\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><strong>Renkleri Deneyimle </strong></p>\r\n\r\n<p><span>D10’un renklerini kendi zevklerine göre kombinleyerek banyonda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için </span><span>banyo bu tarafta.</span></p>\r\n\r\n<div class=\"page\" title=\"Page 178\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><strong>Senin Lavab’ON </strong></p>\r\n\r\n<p><span>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş banyo deneyimi bu tarafta. </span></p>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>"
  },
  {
    "id": "creavit-8975690268969",
    "brand": "Creavit",
    "title": "D10 Eksen Lavabo Dolabı Çekmeceli 80 cm Dafne Gövde Antrasit Meşe Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-eksen-antrasit-mese-lavabo-dolabi-cekmeceli-melamin-banyo-mobilyasi.png?v=1748253680",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-eksen-antrasit-mese-lavabo-dolabi-cekmeceli-melamin-banyo-mobilyasi.png?v=1748253680",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-80-cm-dafne-govde-antrasit-mese-kapak-6052.jpg?v=1748253680",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-80-cm-dafne-govde-antrasit-mese-kapak-6053.jpg?v=1748253680",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-80-cm-dafne-govde-antrasit-mese-kapak-6051.jpg?v=1748253680",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-80-cm-dafne-govde-antrasit-mese-kapak-6055.jpg?v=1748253676",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-80-cm-dafne-govde-antrasit-mese-kapak-6056.jpg?v=1748253676"
    ],
    "price": "6864.00",
    "sku": "D10.LD080.1C.M.M.0204",
    "tags": [
      "Antrasit",
      "Banyo Mobilyası",
      "D10",
      "Dafne",
      "Lavabo Dolabı",
      "Melamin",
      "Meşe",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843081072937,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD080.1C.M.M.0204",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6864.00",
        "grams": 0,
        "compare_at_price": "8580.00",
        "position": 1,
        "product_id": 8975690268969,
        "created_at": "2026-03-17T11:55:47+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<meta charset=\"utf-8\">\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><span>D10’la Karıştır, Banyona Yakıştır!</span></p>\r\n\r\n<p><strong>İçinde Sen Varsın</strong></p>\r\n\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><span>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</span></p>\r\n\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><strong>Saklama Alanını Belirle </strong></p>\r\n\r\n<p><span>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek saklama alanını genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</span></p>\r\n\r\n<div class=\"page\" title=\"Page 177\">\r\n<div class=\"section\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><strong>Renkleri Deneyimle </strong></p>\r\n\r\n<p><span>D10’un renklerini kendi zevklerine göre kombinleyerek banyonda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için </span><span>banyo bu tarafta.</span></p>\r\n\r\n<div class=\"page\" title=\"Page 178\">\r\n<div class=\"layoutArea\">\r\n<div class=\"column\">\r\n<p><strong>Senin Lavab’ON </strong></p>\r\n\r\n<p><span>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş banyo deneyimi bu tarafta. </span></p>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>"
  },
  {
    "id": "creavit-8975656419625",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı Çekmeceli 80 cm Dafne Gövde Antrasit Meşe Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-antrasit-mese-lavabo-dolabi-cekmeceli-melamin-banyo-mobilyasi.png?v=1748253996",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-antrasit-mese-lavabo-dolabi-cekmeceli-melamin-banyo-mobilyasi.png?v=1748253996",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-80-cm-dafne-govde-antrasit-mese-kapak-6031.jpg?v=1748253996",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-80-cm-dafne-govde-antrasit-mese-kapak-6032.jpg?v=1748253996",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-80-cm-dafne-govde-antrasit-mese-kapak-6030.jpg?v=1748253996",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-80-cm-dafne-govde-antrasit-mese-kapak-6036.jpg?v=1748253988",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-80-cm-dafne-govde-antrasit-mese-kapak-6038.jpg?v=1748253988"
    ],
    "price": "6688.00",
    "sku": "D10.LD080.1C.M.M.T.02042",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "Lavabo Dolabı",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843088675113,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD080.1C.M.M.T.02042",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6688.00",
        "grams": 0,
        "compare_at_price": "8360.00",
        "position": 1,
        "product_id": 8975656419625,
        "created_at": "2026-03-17T11:58:44+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-8975646097705",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı Çekmeceli 80 cm Beyaz Melamin Gövde",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D10-cekmeceli-melamin-kapak--beyaz-next-lavabo-dolabi-banyo-mobilyasi-80cm.png?v=1748254062",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D10-cekmeceli-melamin-kapak--beyaz-next-lavabo-dolabi-banyo-mobilyasi-80cm.png?v=1748254062",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-80-cm-beyaz-melamin-govde-6026.jpg?v=1748254062",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-80-cm-beyaz-melamin-govde-6025.jpg?v=1748254062",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-80-cm-beyaz-melamin-govde-6024.jpg?v=1748254059",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-80-cm-beyaz-melamin-govde-6027.jpg?v=1748254054",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-80-cm-beyaz-melamin-govde-6028.jpg?v=1748254054"
    ],
    "price": "6688.00",
    "sku": "D10.LD080.1C.M.M.T.01011",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "Lavabo Dolabı",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843074126121,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD080.1C.M.M.T.01011",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "6688.00",
        "grams": 0,
        "compare_at_price": "8360.00",
        "position": 1,
        "product_id": 8975646097705,
        "created_at": "2026-03-17T11:53:16+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-8975627354409",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı İki Çekmeceli 80 cm Beyaz Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-80cm-beyaz-lavabo-dolabi-cift-cekmeceli-melamin-banyo-mobilyasi_png.png?v=1748254263",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-80cm-beyaz-lavabo-dolabi-cift-cekmeceli-melamin-banyo-mobilyasi_png.png?v=1748254263",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-80-cm-beyaz-6017.jpg?v=1748254263",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-80-cm-beyaz-6016.jpg?v=1748254263",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-80-cm-beyaz-6015.jpg?v=1748254263",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-80-cm-beyaz-6018.jpg?v=1748254260",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-80-cm-beyaz-6019.jpg?v=1748254260"
    ],
    "price": "9504.00",
    "sku": "D10.LD080.2C.M.M.T.01011",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "iki çekmeceli lavabo dolabı",
      "Lavabo Dolabı",
      "Melamin",
      "Meşe",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843088511273,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD080.2C.M.M.T.01011",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9504.00",
        "grams": 0,
        "compare_at_price": "11880.00",
        "position": 1,
        "product_id": 8975627354409,
        "created_at": "2026-03-17T11:58:41+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8975506440489",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı İki Çekmeceli 80 cm Dafne Gövde Antrasit Meşe Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-80cm-antrasit-mese-lavabo-dolabi-cift-cekmeceli-melamin-banyo-mobilyasi.png?v=1748254865",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-80cm-antrasit-mese-lavabo-dolabi-cift-cekmeceli-melamin-banyo-mobilyasi.png?v=1748254865",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-80-cm-dafne-govde-antrasit-mese-kapak-5968.jpg?v=1748254865",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-80-cm-dafne-govde-antrasit-mese-kapak-5969.jpg?v=1748254865",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-80-cm-dafne-govde-antrasit-mese-kapak-5967.jpg?v=1748254865",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-80-cm-dafne-govde-antrasit-mese-kapak-5970.jpg?v=1748254861",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-80-cm-dafne-govde-antrasit-mese-kapak-5971.jpg?v=1748254861"
    ],
    "price": "9504.00",
    "sku": "D10.LD080.2C.M.M.T.02042",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "Dafne",
      "iki çekmeceli lavabo dolabı",
      "Lavabo Dolabı",
      "Melamin",
      "Meşe",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843073995049,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD080.2C.M.M.T.02042",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9504.00",
        "grams": 0,
        "compare_at_price": "11880.00",
        "position": 1,
        "product_id": 8975506440489,
        "created_at": "2026-03-17T11:53:12+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-8974702149929",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı Kapaklı 80 cm Beyaz Lake Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-80cm-beyaz-lavabo-dolabi-kapakli-lake-banyo-mobilyasi.png?v=1748255048",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-80cm-beyaz-lavabo-dolabi-kapakli-lake-banyo-mobilyasi.png?v=1748255048",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-80-cm-beyaz-lake-kapak-5963.jpg?v=1748255048",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-80-cm-beyaz-lake-kapak-5964.jpg?v=1748255048",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-80-cm-beyaz-lake-kapak-5962.jpg?v=1748255048",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-80-cm-beyaz-lake-kapak-5965.jpg?v=1748255043",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-80-cm-beyaz-lake-kapak-5966.jpg?v=1748255043"
    ],
    "price": "7920.00",
    "sku": "D10.LD080.K.M.L.T.01011",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "kapaklı lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52921486868777,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD080.K.M.L.T.01011",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7920.00",
        "grams": 0,
        "compare_at_price": "9900.00",
        "position": 1,
        "product_id": 8974702149929,
        "created_at": "2026-04-03T14:45:02+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-8974694875433",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı Kapaklı 80 cm Dafne Gövde Antrasit Meşe Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-80cm-antrasit-mese--lavabo-dolabi-kapakli-melamin-banyo-mobilyasi.png?v=1748255490",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-80cm-antrasit-mese--lavabo-dolabi-kapakli-melamin-banyo-mobilyasi.png?v=1748255490",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-80-cm-dafne-govde-antrasit-mese-kapak-5938.jpg?v=1748255490",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-80-cm-dafne-govde-antrasit-mese-kapak-5937.jpg?v=1748255490",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-80-cm-dafne-govde-antrasit-mese-kapak-5936.jpg?v=1748255490",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-80-cm-dafne-govde-antrasit-mese-kapak-5939.jpg?v=1748255485",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-80-cm-dafne-govde-antrasit-mese-kapak-5940.jpg?v=1748255485"
    ],
    "price": "6072.00",
    "sku": "D10.LD080.K.M.M.T.02042",
    "tags": [
      "Antrasit",
      "Banyo Mobilyası",
      "D10",
      "Dafne",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı",
      "Meşe",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843090903337,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD080.K.M.M.T.02042",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6072.00",
        "grams": 0,
        "compare_at_price": "7590.00",
        "position": 1,
        "product_id": 8974694875433,
        "created_at": "2026-03-17T11:59:28+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-8974638121257",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı Çekmeceli 100 cm Gri Gövde Antrasit Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-antrasit-lavabo-dolabi-cekmeceli-melamin-100cm-banyo-mobilyasi.png?v=1748261042",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-antrasit-lavabo-dolabi-cekmeceli-melamin-100cm-banyo-mobilyasi.png?v=1748261042",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-gri-govde-antrasit-kapak-5897.jpg?v=1748261042",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-gri-govde-antrasit-kapak-5896.jpg?v=1748261042",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-gri-govde-antrasit-kapak-5895.jpg?v=1748261042",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-gri-govde-antrasit-kapak-5898.jpg?v=1748261037",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-gri-govde-antrasit-kapak-5899.jpg?v=1748261037"
    ],
    "price": "8888.00",
    "sku": "D10.LD100.1C.M.M.T.03053",
    "tags": [
      "Antrasit",
      "Banyo Mobilyası",
      "D10",
      "Gri",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843091165481,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.1C.M.M.T.03053",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8888.00",
        "grams": 0,
        "compare_at_price": "11110.00",
        "position": 1,
        "product_id": 8974638121257,
        "created_at": "2026-03-17T11:59:34+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-8974630027561",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı Çekmeceli 100 cm Dafne Gövde Antrasit Meşe Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-antrasit-mese-lavabo-dolabi-cekmeceli-melamin-100cm-banyo-mobilyasi.png?v=1748261202",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-antrasit-mese-lavabo-dolabi-cekmeceli-melamin-100cm-banyo-mobilyasi.png?v=1748261202",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-dafne-govde-antrasit-mese-kapak-5890.jpg?v=1748261202",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-dafne-govde-antrasit-mese-kapak-5891.jpg?v=1748261202",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-dafne-govde-antrasit-mese-kapak-5889.jpg?v=1748261202",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-dafne-govde-antrasit-mese-kapak-5893.jpg?v=1748261198",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-dafne-govde-antrasit-mese-kapak-5894.jpg?v=1748261198"
    ],
    "price": "8888.00",
    "sku": "D10.LD100.1C.M.M.T.02042",
    "tags": [
      "Antrasit",
      "Banyo Mobilyası",
      "D10",
      "Lavabo Dolabı",
      "Melamin",
      "Meşe",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843073503529,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.1C.M.M.T.02042",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8888.00",
        "grams": 0,
        "compare_at_price": "11110.00",
        "position": 1,
        "product_id": 8974630027561,
        "created_at": "2026-03-17T11:53:00+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-8974613709097",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı Çekmeceli 100 cm Beyaz Melamin Gövde",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-beyaz-lavabo-dolabi-cekmeceli-melamin-100cm-banyo-mobilyasi.png?v=1748261336",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-beyaz-lavabo-dolabi-cekmeceli-melamin-100cm-banyo-mobilyasi.png?v=1748261336",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-beyaz-melamin-govde-5885.jpg?v=1748261336",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-beyaz-melamin-govde-5886.jpg?v=1748261336",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-beyaz-melamin-govde-5884.jpg?v=1748261336",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-beyaz-melamin-govde-5887.jpg?v=1748261332",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-beyaz-melamin-govde-5888.jpg?v=1748261332"
    ],
    "price": "8888.00",
    "sku": "D10.LD100.1C.M.M.T.01011",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843080515881,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.1C.M.M.T.01011",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8888.00",
        "grams": 0,
        "compare_at_price": "11110.00",
        "position": 1,
        "product_id": 8974613709097,
        "created_at": "2026-03-17T11:55:35+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-8973525188905",
    "brand": "Creavit",
    "title": "D10 Eksen Lavabo Dolabı Çekmeceli 100 cm Dafne Gövde Antrasit Meşe Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-eksen-antrasit-mese-lavabo-dolabi-cekmeceli-melamin-100cm-banyo-mobilyasi.png?v=1748261569",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-eksen-antrasit-mese-lavabo-dolabi-cekmeceli-melamin-100cm-banyo-mobilyasi.png?v=1748261569",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-dafne-govde-antrasit-mese-kapak-5874.jpg?v=1748261569",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-dafne-govde-antrasit-mese-kapak-5873.jpg?v=1748261569",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-dafne-govde-antrasit-mese-kapak-5872.jpg?v=1748261569",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-dafne-govde-antrasit-mese-kapak-5871.jpg?v=1748261569",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-dafne-govde-antrasit-mese-kapak-5876.jpg?v=1748261558",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-dafne-govde-antrasit-mese-kapak-5877.jpg?v=1748261558"
    ],
    "price": "9240.00",
    "sku": "D10.LD100.1C.M.M.0204",
    "tags": [
      "Antrasit",
      "Banyo Mobilyası",
      "D10",
      "Lavabo Dolabı",
      "Melamin",
      "Meşe",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843080384809,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.1C.M.M.0204",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9240.00",
        "grams": 0,
        "compare_at_price": "11550.00",
        "position": 1,
        "product_id": 8973525188905,
        "created_at": "2026-03-17T11:55:32+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-8973520765225",
    "brand": "Creavit",
    "title": "D10 Eksen Lavabo Dolabı Çekmeceli 100 cm Beyaz Melamin",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-eksen-beyaz-lavabo-dolabi-cekmeceli-melamin-100cm-banyo-mobilyasi.png?v=1748261743",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-eksen-beyaz-lavabo-dolabi-cekmeceli-melamin-100cm-banyo-mobilyasi.png?v=1748261743",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-beyaz-melamin-5866.jpg?v=1748261743",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-beyaz-melamin-5867.jpg?v=1748261743",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-beyaz-melamin-5865.jpg?v=1748261743",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-beyaz-melamin-5869.jpg?v=1748261740",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-beyaz-melamin-5870.jpg?v=1748261740"
    ],
    "price": "9240.00",
    "sku": "D10.LD100.1C.M.M.0101",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843073372457,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.1C.M.M.0101",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9240.00",
        "grams": 0,
        "compare_at_price": "11550.00",
        "position": 1,
        "product_id": 8973520765225,
        "created_at": "2026-03-17T11:52:57+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8973513556265",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı Çekmeceli 100 cm Dafne Lake",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-100cm-dafne-lavabo-dolabi-cekmeceli-lake-banyo-mobilyasi.png?v=1748261836",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-100cm-dafne-lavabo-dolabi-cekmeceli-lake-banyo-mobilyasi.png?v=1748261836",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-dafne-lake-5862.jpg?v=1748261836",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-dafne-lake-5861.jpg?v=1748261836",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-dafne-lake-5860.jpg?v=1748261836",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-dafne-lake-5863.jpg?v=1748261832",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-dafne-lake-5864.jpg?v=1748261832"
    ],
    "price": "10824.00",
    "sku": "D10.LD100.1C.M.L.T.02022",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "Dafne",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843080253737,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.1C.M.L.T.02022",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "10824.00",
        "grams": 0,
        "compare_at_price": "13530.00",
        "position": 1,
        "product_id": 8973513556265,
        "created_at": "2026-03-17T11:55:28+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-8973508444457",
    "brand": "Creavit",
    "title": "D10 Eksen Lavabo Dolabı Çekmeceli 100 cm Gri Lake Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-eksen-lavabolu-100cm-gri-lavabo-dolabi-cift-cekmeceli-lake-banyo-mobilyasi.png?v=1748261962",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-eksen-lavabolu-100cm-gri-lavabo-dolabi-cift-cekmeceli-lake-banyo-mobilyasi.png?v=1748261962",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-gri-lake-5850.jpg?v=1748261962",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-gri-lake-5851.jpg?v=1748261962",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-gri-lake-5849.jpg?v=1748261962",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-gri-lake-5853.jpg?v=1748261958",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-gri-lake-5854.jpg?v=1748261958"
    ],
    "price": "11176.00",
    "sku": "D10.LD100.1C.M.L.0303",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "Gri",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52920976965929,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.1C.M.L.0303",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11176.00",
        "grams": 0,
        "compare_at_price": "13970.00",
        "position": 1,
        "product_id": 8973508444457,
        "created_at": "2026-04-03T12:17:32+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8973500121385",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı Çekmeceli 100 cm Gri Lake Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-100cm-gri-lavabo-dolabi-cekmeceli-lake-banyo-mobilyasi.png?v=1748262654",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-100cm-gri-lavabo-dolabi-cekmeceli-lake-banyo-mobilyasi.png?v=1748262654",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-gri-lake-5846.jpg?v=1748262654",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-gri-lake-5844.jpg?v=1748262654",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-gri-lake-5845.jpg?v=1748262654",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-gri-lake-5843.jpg?v=1748262654",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-gri-lake-5847.jpg?v=1748262650",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-100-cm-gri-lake-5848.jpg?v=1748262650"
    ],
    "price": "10824.00",
    "sku": "D10.LD100.1C.M.L.T.03033",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "Gri",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843079860521,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.1C.M.L.T.03033",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "10824.00",
        "grams": 0,
        "compare_at_price": "13530.00",
        "position": 1,
        "product_id": 8973500121385,
        "created_at": "2026-03-17T11:55:19+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-8973499629865",
    "brand": "Creavit",
    "title": "D10 Eksen Lavabo Dolabı Çekmeceli 100 cm Dafne Lake Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-eksen-lavabolu-100cm-dafne-lavabo-dolabi-cekmeceli-lake-banyo-mobilyasi.png?v=1748262888",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-eksen-lavabolu-100cm-dafne-lavabo-dolabi-cekmeceli-lake-banyo-mobilyasi.png?v=1748262888",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-dafne-lake-5837.jpg?v=1748262888",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-dafne-lake-5836.jpg?v=1748262888",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-dafne-lake-5838.jpg?v=1748262888",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-dafne-lake-5839.jpg?v=1748262888",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-dafne-lake-5835.jpg?v=1748262888",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-dafne-lake-5841.jpg?v=1748262876",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-dafne-lake-5842.jpg?v=1748262876"
    ],
    "price": "11176.00",
    "sku": "D10.LD100.1C.M.L.0202",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "Dafne",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52936374255913,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.1C.M.L.0202",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11176.00",
        "grams": 0,
        "compare_at_price": "13970.00",
        "position": 1,
        "product_id": 8973499629865,
        "created_at": "2026-04-06T11:18:11+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-8973498614057",
    "brand": "Creavit",
    "title": "D10 Eksen Lavabo Dolabı Çekmeceli 100 cm Beyaz Lake Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-eksen-lavabolu-100cm-beyaz-lavabo-dolabi-cekmeceli-lake-banyo-mobilyasi.png?v=1748262987",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-eksen-lavabolu-100cm-beyaz-lavabo-dolabi-cekmeceli-lake-banyo-mobilyasi.png?v=1748262987",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-beyaz-lake-5830.jpg?v=1748262987",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-beyaz-lake-5831.jpg?v=1748262987",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-beyaz-lake-5829.jpg?v=1748262987",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-beyaz-lake-5833.jpg?v=1748262983",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-100-cm-beyaz-lake-5834.jpg?v=1748262983"
    ],
    "price": "11176.00",
    "sku": "D10.LD100.1C.M.L.0101",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843073241385,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.1C.M.L.0101",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11176.00",
        "grams": 0,
        "compare_at_price": "13970.00",
        "position": 1,
        "product_id": 8973498614057,
        "created_at": "2026-03-17T11:52:54+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8973495533865",
    "brand": "Creavit",
    "title": "D20 100cm İki Çekmeceli Lavabo Dolabı Gri (Demonte)",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100cm-iki-cekmeceli-lavabo-dolabi-gri-demonte-5823.jpg?v=1747227455",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100cm-iki-cekmeceli-lavabo-dolabi-gri-demonte-5823.jpg?v=1747227455",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100cm-iki-cekmeceli-lavabo-dolabi-gri-demonte-5824.jpg?v=1747227459",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100cm-iki-cekmeceli-lavabo-dolabi-gri-demonte-5825.jpg?v=1747227461",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100cm-iki-cekmeceli-lavabo-dolabi-gri-demonte-5826.jpg?v=1747227464"
    ],
    "price": "17820.00",
    "sku": "D.D20.LD100.2CK.ML.GRI",
    "tags": [
      "%10 indirim Yaz",
      "Antrasit",
      "Banyo Mobilyası",
      "D10",
      "D20",
      "Gri",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843194417449,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD100.2CK.ML.GRI",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "17820.00",
        "grams": 0,
        "compare_at_price": "23760.00",
        "position": 1,
        "product_id": 8973495533865,
        "created_at": "2026-03-17T12:49:00+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-8973494911273",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı İki Çekmeceli 100 cm Beyaz Melamin Gövde",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-beyaz-melamin-govde.png?v=1749035418",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-beyaz-melamin-govde.png?v=1749035418",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-beyaz-melamin-govde-5818.jpg?v=1749035418",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-beyaz-melamin-govde-5817.jpg?v=1749035418",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-beyaz-melamin-govde-5820.jpg?v=1749035418",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-beyaz-melamin-govde-5821.jpg?v=1749035402"
    ],
    "price": "10824.00",
    "sku": "D10.LD100.2C.M.M.T.01011",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52871389020457,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.2C.M.M.T.01011",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "10824.00",
        "grams": 0,
        "compare_at_price": "13530.00",
        "position": 1,
        "product_id": 8973494911273,
        "created_at": "2026-03-24T12:34:12+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8973492977961",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı İki Çekmeceli 100 cm Dafne Gövde Antrasit Meşe Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-dafne-govde-antrasit-mese.png?v=1749041564",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-dafne-govde-antrasit-mese.png?v=1749041564",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-dafne-govde-antrasit-mese-5811.jpg?v=1749041564",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-dafne-govde-antrasit-mese-5812.jpg?v=1749041564",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-dafne-govde-antrasit-mese-5809.jpg?v=1749041564",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-dafne-govde-antrasit-mese-5814.jpg?v=1749041559",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-iki-cekmeceli-100-cm-dafne-govde-antrasit-mese-5816.jpg?v=1749041559"
    ],
    "price": "10824.00",
    "sku": "D10.LD100.2C.M.M.T.02042",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "Dafne",
      "Lavabo Dolabı",
      "Melamin",
      "Meşe",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52939370889513,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.2C.M.M.T.02042",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "10824.00",
        "grams": 0,
        "compare_at_price": "13530.00",
        "position": 1,
        "product_id": 8973492977961,
        "created_at": "2026-04-07T00:32:01+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-8973488423209",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı Kapaklı 100 cm Beyaz Melamin Gövde Lake Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-beyaz-melamin-govde-lake-kapak.png?v=1749041813",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-beyaz-melamin-govde-lake-kapak.png?v=1749041813",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-beyaz-melamin-govde-lake-kapak-5783.jpg?v=1749041813",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-beyaz-melamin-govde-lake-kapak-5784.jpg?v=1749041813",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-beyaz-melamin-govde-lake-kapak-5782.jpg?v=1749041813",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-beyaz-melamin-govde-lake-kapak-5785.jpg?v=1749041808",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-beyaz-melamin-govde-lake-kapak-5786.jpg?v=1749041808"
    ],
    "price": "8624.00",
    "sku": "D10.LD100.K.M.L.T.01011",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "kapaklı lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843079631145,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.K.M.L.T.01011",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8624.00",
        "grams": 0,
        "compare_at_price": "10780.00",
        "position": 1,
        "product_id": 8973488423209,
        "created_at": "2026-03-17T11:55:16+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8973487800617",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı Kapaklı 100 cm Dafne Melamin Gövde Lake Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-dafne-melamin-govde-lake-kapak.png?v=1749041931",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-dafne-melamin-govde-lake-kapak.png?v=1749041931",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-dafne-melamin-govde-lake-kapak-5778.jpg?v=1749041931",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-dafne-melamin-govde-lake-kapak-5779.jpg?v=1749041931",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-dafne-melamin-govde-lake-kapak-5777.jpg?v=1749041931",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-dafne-melamin-govde-lake-kapak-5780.jpg?v=1749041928",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-dafne-melamin-govde-lake-kapak-5781.jpg?v=1749041928"
    ],
    "price": "8624.00",
    "sku": "D10.LD100.K.M.L.T.02022",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "Dafne",
      "kapaklı lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52900461642025,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.K.M.L.T.02022",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "8624.00",
        "grams": 0,
        "compare_at_price": "10780.00",
        "position": 1,
        "product_id": 8973487800617,
        "created_at": "2026-03-30T20:53:40+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8973482524969",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı Kapaklı 100 cm Gri Melamin Gövde Lake Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-gri-melamin-govde-lake-kapak.png?v=1749042051",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-gri-melamin-govde-lake-kapak.png?v=1749042051",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-gri-melamin-govde-lake-kapak-5773.jpg?v=1749042051",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-gri-melamin-govde-lake-kapak-5774.jpg?v=1749042051",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-gri-melamin-govde-lake-kapak-5772.jpg?v=1749042051",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-gri-melamin-govde-lake-kapak-5775.jpg?v=1749042049",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-gri-melamin-govde-lake-kapak-5776.jpg?v=1749042049"
    ],
    "price": "8624.00",
    "sku": "D10.LD100.K.M.L.T.03033",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "Gri",
      "kapaklı lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843079401769,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.K.M.L.T.03033",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8624.00",
        "grams": 0,
        "compare_at_price": "10780.00",
        "position": 1,
        "product_id": 8973482524969,
        "created_at": "2026-03-17T11:55:10+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-8973429768489",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı Kapaklı 100 cm Dafne Melamin Gövde Antrasit Meşe Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-100cm-antrasit-mese--lavabo-dolabi-cekmeceli-melamin-banyo-mobilyasi.png?v=1748263228",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-next-lavabolu-100cm-antrasit-mese--lavabo-dolabi-cekmeceli-melamin-banyo-mobilyasi.png?v=1748263228",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-dafne-melamin-govde-antrasit-mese-kapak-5757.jpg?v=1748263228",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-dafne-melamin-govde-antrasit-mese-kapak-5758.jpg?v=1748263228",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-dafne-melamin-govde-antrasit-mese-kapak-5756.jpg?v=1748263228",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-dafne-melamin-govde-antrasit-mese-kapak-5759.jpg?v=1748263222",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-kapakli-100-cm-dafne-melamin-govde-antrasit-mese-kapak-5760.jpg?v=1748263222"
    ],
    "price": "6424.00",
    "sku": "D10.LD100.K.M.M.T.02042",
    "tags": [
      "Antrasit",
      "Banyo Mobilyası",
      "D10",
      "Dafne",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı",
      "Meşe",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52898979316009,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD100.K.M.M.T.02042",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6424.00",
        "grams": 0,
        "compare_at_price": "8030.00",
        "position": 1,
        "product_id": 8973429768489,
        "created_at": "2026-03-30T17:15:03+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>\n<p><meta charset=\"utf-8\"><strong>Senin Lavab'ON</strong></p>\n<p>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş  banyo deneyimi bu tarafta.</p>\n<!---->"
  },
  {
    "id": "creavit-8970561913129",
    "brand": "Creavit",
    "title": "D10 60 cm Melamin Raflı Ayna Antrasit Meşe",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/16_64064475-def3-4141-af2a-6b9676174688.png?v=1748264820",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/16_64064475-def3-4141-af2a-6b9676174688.png?v=1748264820",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-60-cm-melamin-rafli-ayna-antrasit-mese-5749.jpg?v=1748264820",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-60-cm-melamin-rafli-ayna-antrasit-mese-5747.jpg?v=1748264820",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-60-cm-melamin-rafli-ayna-antrasit-mese-5748.jpg?v=1748264820"
    ],
    "price": "2376.00",
    "sku": "D10.RA060.ML.MSE",
    "tags": [
      "Antrasit",
      "Ayna",
      "Banyo Mobilyası",
      "D10",
      "Meşe",
      "Raflı Ayna",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843072880937,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.RA060.ML.MSE",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2376.00",
        "grams": 0,
        "compare_at_price": "2970.00",
        "position": 1,
        "product_id": 8970561913129,
        "created_at": "2026-03-17T11:52:45+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8970561749289",
    "brand": "Creavit",
    "title": "D10 60 cm Melamin Raflı Ayna Gri",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/18_882873e0-1a6b-48fc-b054-27c64b525346.png?v=1748264842",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/18_882873e0-1a6b-48fc-b054-27c64b525346.png?v=1748264842",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-60-cm-melamin-rafli-ayna-gri-5743.jpg?v=1748264842",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-60-cm-melamin-rafli-ayna-gri-5744.jpg?v=1748264842"
    ],
    "price": "2376.00",
    "sku": "D10.RA060.ML.GRI",
    "tags": [
      "Ayna",
      "Banyo Mobilyası",
      "D10",
      "Gri",
      "Raflı Ayna",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843077533993,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.RA060.ML.GRI",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2376.00",
        "grams": 0,
        "compare_at_price": "2970.00",
        "position": 1,
        "product_id": 8970561749289,
        "created_at": "2026-03-17T11:54:30+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8970561552681",
    "brand": "Creavit",
    "title": "D10 60 cm Melamin Raflı Ayna Dafne",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/17_fe6f816b-8044-4f34-b3ef-fa06561db613.png?v=1748264865",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/17_fe6f816b-8044-4f34-b3ef-fa06561db613.png?v=1748264865",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-60-cm-melamin-rafli-ayna-dafne-5741.jpg?v=1748264865",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-60-cm-melamin-rafli-ayna-dafne-5739.jpg?v=1748264865",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-60-cm-melamin-rafli-ayna-dafne-5740.jpg?v=1748264865"
    ],
    "price": "2376.00",
    "sku": "D10.RA060.ML.DAF",
    "tags": [
      "Ayna",
      "Banyo Mobilyası",
      "D10",
      "Dafne",
      "Raflı Ayna",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52921485787433,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.RA060.ML.DAF",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2376.00",
        "grams": 0,
        "compare_at_price": "2970.00",
        "position": 1,
        "product_id": 8970561552681,
        "created_at": "2026-04-03T14:44:49+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8970561290537",
    "brand": "Creavit",
    "title": "D10 60 cm Melamin Raflı Ayna Beyaz",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/19_7558df46-c5f4-45fa-882f-aa0a5d0385aa.png?v=1748264883",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/19_7558df46-c5f4-45fa-882f-aa0a5d0385aa.png?v=1748264883",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-60-cm-melamin-rafli-ayna-beyaz-5735.jpg?v=1748264883",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-60-cm-melamin-rafli-ayna-beyaz-5737.jpg?v=1748264883"
    ],
    "price": "2376.00",
    "sku": "D10.RA060.ML.BYZ",
    "tags": [
      "Ayna",
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "Raflı Ayna",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52920976703785,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.RA060.ML.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2376.00",
        "grams": 0,
        "compare_at_price": "2970.00",
        "position": 1,
        "product_id": 8970561290537,
        "created_at": "2026-04-03T12:17:28+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8970560799017",
    "brand": "Creavit",
    "title": "D10 60 cm Melamin Raflı Ayna Antrasit",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/20_3b7d57cb-746e-4df2-b85b-716426575c46.png?v=1748264901",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/20_3b7d57cb-746e-4df2-b85b-716426575c46.png?v=1748264901",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-60-cm-melamin-rafli-ayna-antrasit-5732.jpg?v=1748264901",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-60-cm-melamin-rafli-ayna-antrasit-5731.jpg?v=1748264901",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-60-cm-melamin-rafli-ayna-antrasit-5733.jpg?v=1748264901"
    ],
    "price": "2376.00",
    "sku": "D10.RA060.ML.ANT",
    "tags": [
      "Antrasit",
      "Ayna",
      "Banyo Mobilyası",
      "D10",
      "Raflı Ayna",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52896580501801,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.RA060.ML.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2376.00",
        "grams": 0,
        "compare_at_price": "2970.00",
        "position": 1,
        "product_id": 8970560799017,
        "created_at": "2026-03-30T00:45:02+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8970560602409",
    "brand": "Creavit",
    "title": "D10 50 cm Melamin Raflı Ayna Antrasit Meşe",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/21.png?v=1748264234",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/21.png?v=1748264234",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-50-cm-melamin-rafli-ayna-antrasit-mese-5730.jpg?v=1748264234",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-50-cm-melamin-rafli-ayna-antrasit-mese-5727.jpg?v=1748264234",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-50-cm-melamin-rafli-ayna-antrasit-mese-5729.jpg?v=1748264234"
    ],
    "price": "2200.00",
    "sku": "D10.RA050.ML.MSE",
    "tags": [
      "Antrasit",
      "Ayna",
      "Banyo Mobilyası",
      "D10",
      "Meşe",
      "Raflı Ayna",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843091067177,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.RA050.ML.MSE",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2200.00",
        "grams": 0,
        "compare_at_price": "2750.00",
        "position": 1,
        "product_id": 8970560602409,
        "created_at": "2026-03-17T11:59:31+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8970556277033",
    "brand": "Creavit",
    "title": "D10 50 cm Melamin Raflı Ayna Antrasit",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/25.png?v=1748264380",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/25.png?v=1748264380",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-50-cm-melamin-rafli-ayna-antrasit-5711.jpg?v=1748264380",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-50-cm-melamin-rafli-ayna-antrasit-5712.jpg?v=1748264380",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-50-cm-melamin-rafli-ayna-antrasit-5713.jpg?v=1748264380"
    ],
    "price": "2200.00",
    "sku": "D10.RA050.ML.ANT",
    "tags": [
      "Antrasit",
      "Ayna",
      "Banyo Mobilyası",
      "D10",
      "Raflı Ayna",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843091886377,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.RA050.ML.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2200.00",
        "grams": 0,
        "compare_at_price": "2750.00",
        "position": 1,
        "product_id": 8970556277033,
        "created_at": "2026-03-17T11:59:50+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8970555949353",
    "brand": "Creavit",
    "title": "D10 45 cm Melamin Raflı Ayna Antrasit Meşe",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/16_01664758-d78a-4046-a38d-1e9081a5253f.png?v=1748264484",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/16_01664758-d78a-4046-a38d-1e9081a5253f.png?v=1748264484",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-45-cm-melamin-rafli-ayna-antrasit-mese-5709.jpg?v=1748264484",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-45-cm-melamin-rafli-ayna-antrasit-mese-5707.jpg?v=1748264484",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-45-cm-melamin-rafli-ayna-antrasit-mese-5708.jpg?v=1748264484"
    ],
    "price": "2024.00",
    "sku": "D10.RA045.ML.MSE",
    "tags": [
      "Antrasit",
      "Ayna",
      "Banyo Mobilyası",
      "D10",
      "Meşe",
      "Raflı Ayna",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843084775721,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.RA045.ML.MSE",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2024.00",
        "grams": 0,
        "compare_at_price": "2530.00",
        "position": 1,
        "product_id": 8970555949353,
        "created_at": "2026-03-17T11:57:15+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8970552312105",
    "brand": "Creavit",
    "title": "D10 45 cm Melamin Raflı Ayna Gri",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/18_bdb6e252-b1c5-4f49-8cd5-afea15e5c7ef.png?v=1748264524",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/18_bdb6e252-b1c5-4f49-8cd5-afea15e5c7ef.png?v=1748264524",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-45-cm-melamin-rafli-ayna-gri-5703.jpg?v=1748264524",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-45-cm-melamin-rafli-ayna-gri-5706.jpg?v=1748264524"
    ],
    "price": "2024.00",
    "sku": "D10.RA045.ML.GRI",
    "tags": [
      "Ayna",
      "Banyo Mobilyası",
      "D10",
      "Gri",
      "Raflı Ayna",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843084644649,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.RA045.ML.GRI",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2024.00",
        "grams": 0,
        "compare_at_price": "2530.00",
        "position": 1,
        "product_id": 8970552312105,
        "created_at": "2026-03-17T11:57:11+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8970547921193",
    "brand": "Creavit",
    "title": "D10 45 cm Melamin Raflı Ayna Dafne",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/17_781bebe8-b060-4fbd-a288-8d8126cd8544.png?v=1748264554",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/17_781bebe8-b060-4fbd-a288-8d8126cd8544.png?v=1748264554",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-45-cm-melamin-rafli-ayna-dafne-5699.jpg?v=1748264554",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-45-cm-melamin-rafli-ayna-dafne-5702.jpg?v=1748264554"
    ],
    "price": "2024.00",
    "sku": "D10.RA045.ML.DAF",
    "tags": [
      "Ayna",
      "Banyo Mobilyası",
      "D10",
      "Dafne",
      "Raflı Ayna",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843092508969,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.RA045.ML.DAF",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "2024.00",
        "grams": 0,
        "compare_at_price": "2530.00",
        "position": 1,
        "product_id": 8970547921193,
        "created_at": "2026-03-17T11:59:59+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8970543235369",
    "brand": "Creavit",
    "title": "D10 45 cm Melamin Raflı Ayna Antrasit",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/20_d9c52270-ebd8-47fd-86f8-8ab7c422d6a1.png?v=1748264590",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/20_d9c52270-ebd8-47fd-86f8-8ab7c422d6a1.png?v=1748264590",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-45-cm-melamin-rafli-ayna-antrasit-5698.jpg?v=1748264590",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-45-cm-melamin-rafli-ayna-antrasit-5695.jpg?v=1748264590",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-45-cm-melamin-rafli-ayna-antrasit-5697.jpg?v=1748264590"
    ],
    "price": "2024.00",
    "sku": "D10.RA045.ML.ANT",
    "tags": [
      "Antrasit",
      "Ayna",
      "Banyo Mobilyası",
      "D10",
      "Raflı Ayna",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52920976343337,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.RA045.ML.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2024.00",
        "grams": 0,
        "compare_at_price": "2530.00",
        "position": 1,
        "product_id": 8970543235369,
        "created_at": "2026-04-03T12:17:22+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8970536485161",
    "brand": "Creavit",
    "title": "D10 45 cm Melamin Raflı Ayna Beyaz",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/19_527d2b32-556c-422b-879b-b1fb1b6a0a7d.png?v=1748264615",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/19_527d2b32-556c-422b-879b-b1fb1b6a0a7d.png?v=1748264615",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-45-cm-melamin-rafli-ayna-beyaz-5691.jpg?v=1748264615",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-45-cm-melamin-rafli-ayna-beyaz-5692.jpg?v=1748264615"
    ],
    "price": "2024.00",
    "sku": "D10.RA045.ML.BYZ",
    "tags": [
      "Ayna",
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "Raflı Ayna",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52892894527785,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.RA045.ML.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2024.00",
        "grams": 0,
        "compare_at_price": "2530.00",
        "position": 1,
        "product_id": 8970536485161,
        "created_at": "2026-03-28T22:49:44+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8970525540649",
    "brand": "Creavit",
    "title": "D10 80 cm Düz Ayna",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-duz-ayna-d10-80-cm-banyo-mobilyasi.png?v=1749042311",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-duz-ayna-d10-80-cm-banyo-mobilyasi.png?v=1749042311",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80-cm-duz-ayna-5685.jpg?v=1749042309",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80-cm-duz-ayna-5686.jpg?v=1749042309",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-80-cm-duz-ayna-5687.jpg?v=1749042309"
    ],
    "price": "2904.00",
    "sku": "D10.DA080",
    "tags": [
      "Ayna",
      "Banyo Mobilyası",
      "D10",
      "Düz Ayna",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843072487721,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.DA080",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2904.00",
        "grams": 0,
        "compare_at_price": "3630.00",
        "position": 1,
        "product_id": 8970525540649,
        "created_at": "2026-03-17T11:52:35+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8970524754217",
    "brand": "Creavit",
    "title": "D10 65 cm Düz Ayna",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-duz-ayna-d10-60-cm-banyo-mobilyasi.png?v=1749042415",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-duz-ayna-d10-60-cm-banyo-mobilyasi.png?v=1749042415",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65-cm-duz-ayna-5682.jpg?v=1749042415",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65-cm-duz-ayna-5683.jpg?v=1749042415",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-65-cm-duz-ayna-5684.jpg?v=1749042415"
    ],
    "price": "2464.00",
    "sku": "D10.DA065",
    "tags": [
      "Ayna",
      "Banyo Mobilyası",
      "D10",
      "Düz Ayna",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843072356649,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.DA065",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2464.00",
        "grams": 0,
        "compare_at_price": "3080.00",
        "position": 1,
        "product_id": 8970524754217,
        "created_at": "2026-03-17T11:52:32+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8969499869481",
    "brand": "Creavit",
    "title": "D10 60cm Melamin Aynalı Dolap Gri",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-60cm-melamin-aynali-dolap-gri-5664.jpg?v=1747226672",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-60cm-melamin-aynali-dolap-gri-5664.jpg?v=1747226672",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-60cm-melamin-aynali-dolap-gri-5665.jpg?v=1747226674",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-60cm-melamin-aynali-dolap-gri-5666.jpg?v=1747226677",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-60cm-melamin-aynali-dolap-gri-5667.jpg?v=1747226680"
    ],
    "price": "4048.00",
    "sku": "D10.AD060.ML.GRI",
    "tags": [
      "%10 indirim Yaz",
      "Ayna",
      "Aynalı Dolap",
      "Banyo Mobilyası",
      "D10",
      "Melamin",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52864577863977,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.AD060.ML.GRI",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "4048.00",
        "grams": 0,
        "compare_at_price": "5060.00",
        "position": 1,
        "product_id": 8969499869481,
        "created_at": "2026-03-22T20:53:01+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8969463922985",
    "brand": "Creavit",
    "title": "D10 100 cm Yuvarlak Ayna",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-yuvarlak-ayna-d10-100-cm-banyo-mobilyasi.png?v=1749042989",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-yuvarlak-ayna-d10-100-cm-banyo-mobilyasi.png?v=1749042989",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100-cm-yuvarlak-ayna-5661.jpg?v=1749042989",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100-cm-yuvarlak-ayna-5660.jpg?v=1749042989",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100-cm-yuvarlak-ayna-5663.jpg?v=1749042989",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-100-cm-yuvarlak-ayna-5662.jpg?v=1749042989"
    ],
    "price": "4136.00",
    "sku": "D10.YA100",
    "tags": [
      "Ayna",
      "Banyo Mobilyası",
      "D10",
      "yaz-10-indirim",
      "Yuvarlak",
      "Yuvarlak Ayna"
    ],
    "variants": [
      {
        "id": 52843089199401,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.YA100",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "4136.00",
        "grams": 0,
        "compare_at_price": "5170.00",
        "position": 1,
        "product_id": 8969463922985,
        "created_at": "2026-03-17T11:58:57+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>D10'la Karıştır, Banyona Yakıştır!</strong></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8969211445545",
    "brand": "Creavit",
    "title": "D10 30 cm Sağ Üst Dolap Gri Melamin Gövde Antrasit Kapak",
    "category": "Üst Dolaplar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-antrasit-melamin-kapak-ust-dolap-banyo-mobilyasi-1_bb7b3d4f-439e-485c-9531-2726d3f83d1f.png?v=1749122723",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-antrasit-melamin-kapak-ust-dolap-banyo-mobilyasi-1_bb7b3d4f-439e-485c-9531-2726d3f83d1f.png?v=1749122723",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sag-ust-dolap-gri-melamin-govde-antrasit-kapak-5632.jpg?v=1749122723",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sag-ust-dolap-gri-melamin-govde-antrasit-kapak-5634.jpg?v=1749122721",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sag-ust-dolap-gri-melamin-govde-antrasit-kapak-5635.jpg?v=1749122721",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sag-ust-dolap-gri-melamin-govde-antrasit-kapak-5636.jpg?v=1749122721"
    ],
    "price": "2552.00",
    "sku": "D10.UD030.SAG.M.M.0305",
    "tags": [
      "Antrasit",
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "Melamin",
      "Sağ Üst Dolap",
      "yaz-10-indirim",
      "Üst Dolap"
    ],
    "variants": [
      {
        "id": 52843088249129,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.UD030.SAG.M.M.0305",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2552.00",
        "grams": 0,
        "compare_at_price": "3190.00",
        "position": 1,
        "product_id": 8969211445545,
        "created_at": "2026-03-17T11:58:35+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>D10'la Karıştır, Banyona Yakıştır!</strong></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8969198108969",
    "brand": "Creavit",
    "title": "D10 30 cm Sol Üst Dolap Dafne Melamin Gövde Antrasit Meşe Kapak",
    "category": "Üst Dolaplar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-dafne-melamin-govde-antrasit-mese-kapak.png?v=1749123153",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-dafne-melamin-govde-antrasit-mese-kapak.png?v=1749123153",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-dafne-melamin-govde-antrasit-mese-kapak-5618.jpg?v=1749123153",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-dafne-melamin-govde-antrasit-mese-kapak-5619.jpg?v=1749123153",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-dafne-melamin-govde-antrasit-mese-kapak-5620.jpg?v=1749123153",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-dafne-melamin-govde-antrasit-mese-kapak-5621.jpg?v=1749123153"
    ],
    "price": "2552.00",
    "sku": "D10.UD030.SOL.M.M.0204",
    "tags": [
      "Antrasit",
      "Banyo Mobilyası",
      "D10",
      "Dafne",
      "Melamin",
      "Sol Üst Dolap",
      "yaz-10-indirim",
      "Üst Dolap"
    ],
    "variants": [
      {
        "id": 52843084546345,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.UD030.SOL.M.M.0204",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2552.00",
        "grams": 0,
        "compare_at_price": "3190.00",
        "position": 1,
        "product_id": 8969198108969,
        "created_at": "2026-03-17T11:57:08+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>D10'la Karıştır, Banyona Yakıştır!</strong></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8969195716905",
    "brand": "Creavit",
    "title": "D10 30 cm Sağ Üst Dolap Dafne Melamin Gövde Antrasit Meşe Kapak",
    "category": "Üst Dolaplar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-dafne-melamin-govde-antrasit-mese-kapak_856be2d3-e7c3-49c4-acc2-dc74dd9f50cd.png?v=1749123238",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-dafne-melamin-govde-antrasit-mese-kapak_856be2d3-e7c3-49c4-acc2-dc74dd9f50cd.png?v=1749123238",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sag-ust-dolap-dafne-melamin-govde-antrasit-mese-kapak-5614.jpg?v=1749123238",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sag-ust-dolap-dafne-melamin-govde-antrasit-mese-kapak-5615.jpg?v=1749123238",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sag-ust-dolap-dafne-melamin-govde-antrasit-mese-kapak-5616.jpg?v=1749123238",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sag-ust-dolap-dafne-melamin-govde-antrasit-mese-kapak-5617.jpg?v=1749123238"
    ],
    "price": "2552.00",
    "sku": "D10.UD030.SAG.M.M.0204",
    "tags": [
      "Antrasit",
      "Banyo Mobilyası",
      "D10",
      "Dafne",
      "Melamin",
      "Sağ Üst Dolap",
      "yaz-10-indirim",
      "Üst Dolap"
    ],
    "variants": [
      {
        "id": 52843071734057,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.UD030.SAG.M.M.0204",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2552.00",
        "grams": 0,
        "compare_at_price": "3190.00",
        "position": 1,
        "product_id": 8969195716905,
        "created_at": "2026-03-17T11:52:19+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>D10'la Karıştır, Banyona Yakıştır!</strong></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8969194275113",
    "brand": "Creavit",
    "title": "D10 30 cm Sol Üst Dolap Dafne Melamin Gövde Lake Kapak",
    "category": "Üst Dolaplar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-dafne-melamin-govde-lake-kapak.png?v=1749123374",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-dafne-melamin-govde-lake-kapak.png?v=1749123374",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-dafne-melamin-govde-lake-kapak-5610.jpg?v=1749123374",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-dafne-melamin-govde-lake-kapak-5609.jpg?v=1749123374",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-dafne-melamin-govde-lake-kapak-5611.jpg?v=1749123372",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-dafne-melamin-govde-lake-kapak-5612.jpg?v=1749123372",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-dafne-melamin-govde-lake-kapak-5613.jpg?v=1749123372"
    ],
    "price": "3344.00",
    "sku": "D10.UD030.SOL.M.L.0202",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "Dafne",
      "Lake",
      "Melamin",
      "Sol Üst Dolap",
      "yaz-10-indirim",
      "Üst Dolap"
    ],
    "variants": [
      {
        "id": 52891828617513,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.UD030.SOL.M.L.0202",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3344.00",
        "grams": 0,
        "compare_at_price": "4180.00",
        "position": 1,
        "product_id": 8969194275113,
        "created_at": "2026-03-28T17:34:21+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>D10'la Karıştır, Banyona Yakıştır!</strong></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8969190375721",
    "brand": "Creavit",
    "title": "D10 30 cm Sol Üst Dolap Beyaz Melamin Gövde Melamin Kapak",
    "category": "Üst Dolaplar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-beyaz-melamin-govde-melamin-kapak.png?v=1749123535",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-beyaz-melamin-govde-melamin-kapak.png?v=1749123535",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-beyaz-melamin-govde-melamin-kapak-5599.jpg?v=1749123535",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-beyaz-melamin-govde-melamin-kapak-5600.jpg?v=1749123535",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-beyaz-melamin-govde-melamin-kapak-5602.jpg?v=1749123531",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30-cm-sol-ust-dolap-beyaz-melamin-govde-melamin-kapak-5603.jpg?v=1749123531"
    ],
    "price": "2552.00",
    "sku": "D10.UD030.SOL.M.M.0101",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "Melamin",
      "Sol Üst Dolap",
      "yaz-10-indirim",
      "Üst Dolap"
    ],
    "variants": [
      {
        "id": 52912524886313,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.UD030.SOL.M.M.0101",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2552.00",
        "grams": 0,
        "compare_at_price": "3190.00",
        "position": 1,
        "product_id": 8969190375721,
        "created_at": "2026-04-01T16:19:39+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>D10'la Karıştır, Banyona Yakıştır!</strong></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8968551170345",
    "brand": "Creavit",
    "title": "D10 20 cm Sol Üst Dolap Gri Melamin Gövde Lake Kapak",
    "category": "Üst Dolaplar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-gri-melamin-govde-lake-kapak.png?v=1749128762",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-gri-melamin-govde-lake-kapak.png?v=1749128762",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-gri-melamin-govde-lake-kapak-5582.jpg?v=1749128762",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-gri-melamin-govde-lake-kapak-5580.jpg?v=1749128762",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-gri-melamin-govde-lake-kapak-5581.jpg?v=1749128762",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-gri-melamin-govde-lake-kapak-5583.jpg?v=1749128760",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-gri-melamin-govde-lake-kapak-5584.jpg?v=1749128760"
    ],
    "price": "2992.00",
    "sku": "D10.UD020.SOL.M.L.0303",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "Gri",
      "Lake",
      "Melamin",
      "Sol Üst Dolap",
      "yaz-10-indirim",
      "Üst Dolap"
    ],
    "variants": [
      {
        "id": 52843084153129,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.UD020.SOL.M.L.0303",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2992.00",
        "grams": 0,
        "compare_at_price": "3740.00",
        "position": 1,
        "product_id": 8968551170345,
        "created_at": "2026-03-17T11:56:59+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>D10'la Karıştır, Banyona Yakıştır!</strong></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8968550154537",
    "brand": "Creavit",
    "title": "D10 20 cm Sağ Üst Dolap Gri Melamin Gövde Lake Kapak",
    "category": "Üst Dolaplar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-gri-melamin-govde-lake-kapak_6756503e-57c8-40fc-999e-544c6906de31.png?v=1749128928",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-gri-melamin-govde-lake-kapak_6756503e-57c8-40fc-999e-544c6906de31.png?v=1749128928",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-gri-melamin-govde-lake-kapak-5576.jpg?v=1749128928",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-gri-melamin-govde-lake-kapak-5575.jpg?v=1749128928",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-gri-melamin-govde-lake-kapak-5577.jpg?v=1749128927",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-gri-melamin-govde-lake-kapak-5578.jpg?v=1749128927",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-gri-melamin-govde-lake-kapak-5579.jpg?v=1749128927"
    ],
    "price": "2992.00",
    "sku": "D10.UD020.SAG.M.L.0303",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "Gri",
      "Lake",
      "Melamin",
      "Sağ Üst Dolap",
      "yaz-10-indirim",
      "Üst Dolap"
    ],
    "variants": [
      {
        "id": 52843071570217,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.UD020.SAG.M.L.0303",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "2992.00",
        "grams": 0,
        "compare_at_price": "3740.00",
        "position": 1,
        "product_id": 8968550154537,
        "created_at": "2026-03-17T11:52:16+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>D10'la Karıştır, Banyona Yakıştır!</strong></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8968549400873",
    "brand": "Creavit",
    "title": "D10 20 cm Sol Üst Dolap Dafne Melamin Gövde Antrasit Meşe Kapak",
    "category": "Üst Dolaplar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-dafne-melamin-govde-antrasit-mese-kapak.png?v=1749136682",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-dafne-melamin-govde-antrasit-mese-kapak.png?v=1749136682",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-dafne-melamin-govde-antrasit-mese-kapak-5571.jpg?v=1749136682",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-dafne-melamin-govde-antrasit-mese-kapak-5570.jpg?v=1749136682",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-dafne-melamin-govde-antrasit-mese-kapak-5572.jpg?v=1749136678",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-dafne-melamin-govde-antrasit-mese-kapak-5573.jpg?v=1749136678",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-dafne-melamin-govde-antrasit-mese-kapak-5574.jpg?v=1749136678"
    ],
    "price": "2288.00",
    "sku": "D10.UD020.SOL.M.M.0204",
    "tags": [
      "Antrasit",
      "Banyo Mobilyası",
      "D10",
      "Dafne",
      "Melamin",
      "Sol Üst Dolap",
      "yaz-10-indirim",
      "Üst Dolap"
    ],
    "variants": [
      {
        "id": 52843071406377,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.UD020.SOL.M.M.0204",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2288.00",
        "grams": 0,
        "compare_at_price": "2860.00",
        "position": 1,
        "product_id": 8968549400873,
        "created_at": "2026-03-17T11:52:13+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8968548024617",
    "brand": "Creavit",
    "title": "D10 20 cm Sağ Üst Dolap Dafne Melamin Gövde Antrasit Meşe Kapak",
    "category": "Üst Dolaplar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-dafne-melamin-govde-antrasit-mese-kapak_3e633dc5-428a-4707-886a-35f32218cba5.png?v=1749136722",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-dafne-melamin-govde-antrasit-mese-kapak_3e633dc5-428a-4707-886a-35f32218cba5.png?v=1749136722",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-dafne-melamin-govde-antrasit-mese-kapak-5565.jpg?v=1749136722",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-dafne-melamin-govde-antrasit-mese-kapak-5564.jpg?v=1749136722",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-dafne-melamin-govde-antrasit-mese-kapak-5567.jpg?v=1749136721",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-dafne-melamin-govde-antrasit-mese-kapak-5568.jpg?v=1749136721",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-dafne-melamin-govde-antrasit-mese-kapak-5569.jpg?v=1749136721"
    ],
    "price": "2288.00",
    "sku": "D10.UD020.SAG.M.M.0204",
    "tags": [
      "Antrasit",
      "Banyo Mobilyası",
      "D10",
      "Dafne",
      "Melamin",
      "Sağ Üst Dolap",
      "yaz-10-indirim",
      "Üst Dolap"
    ],
    "variants": [
      {
        "id": 52843071275305,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.UD020.SAG.M.M.0204",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2288.00",
        "grams": 0,
        "compare_at_price": "2860.00",
        "position": 1,
        "product_id": 8968548024617,
        "created_at": "2026-03-17T11:52:10+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>D10'la Karıştır, Banyona Yakıştır!</strong></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8968537538857",
    "brand": "Creavit",
    "title": "D10 20 cm Sağ Üst Dolap Dafne Melamin Gövde Lake Kapak",
    "category": "Üst Dolaplar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-dafne-melamin-govde-lake-kapak_413480c3-d157-4596-92f5-2afcca907787.png?v=1749136891",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-dafne-melamin-govde-lake-kapak_413480c3-d157-4596-92f5-2afcca907787.png?v=1749136891",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-dafne-melamin-govde-lake-kapak-5553.jpg?v=1749136891",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-dafne-melamin-govde-lake-kapak-5552.jpg?v=1749136891",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-dafne-melamin-govde-lake-kapak-5555.jpg?v=1749136889",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-dafne-melamin-govde-lake-kapak-5556.jpg?v=1749136889",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-dafne-melamin-govde-lake-kapak-5557.jpg?v=1749136889"
    ],
    "price": "2992.00",
    "sku": "D10.UD020.SAG.M.L.0202",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "Dafne",
      "Lake",
      "Melamin",
      "Sağ Üst Dolap",
      "yaz-10-indirim",
      "Üst Dolap"
    ],
    "variants": [
      {
        "id": 52843092279593,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.UD020.SAG.M.L.0202",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2992.00",
        "grams": 0,
        "compare_at_price": "3740.00",
        "position": 1,
        "product_id": 8968537538857,
        "created_at": "2026-03-17T11:59:56+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>D10'la Karıştır, Banyona Yakıştır!</strong></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8968535310633",
    "brand": "Creavit",
    "title": "D10 20 cm Sol Üst Dolap Beyaz Melamin Gövde Lake Kapak",
    "category": "Üst Dolaplar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-beyaz-melamin-govde-lake-kapak.png?v=1749137088",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-beyaz-melamin-govde-lake-kapak.png?v=1749137088",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-beyaz-melamin-govde-lake-kapak-5547.jpg?v=1749137088",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-beyaz-melamin-govde-lake-kapak-5549.jpg?v=1749137088",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-beyaz-melamin-govde-lake-kapak-5550.jpg?v=1749137088",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-beyaz-melamin-govde-lake-kapak-5551.jpg?v=1749137088"
    ],
    "price": "2992.00",
    "sku": "D10.UD020.SOL.M.L.0101",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "Lake",
      "Melamin",
      "Sol Üst Dolap",
      "yaz-10-indirim",
      "Üst Dolap"
    ],
    "variants": [
      {
        "id": 52912352035113,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.UD020.SOL.M.L.0101",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2992.00",
        "grams": 0,
        "compare_at_price": "3740.00",
        "position": 1,
        "product_id": 8968535310633,
        "created_at": "2026-04-01T15:23:25+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>D10'la Karıştır, Banyona Yakıştır!</strong></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8968525447465",
    "brand": "Creavit",
    "title": "D10 20 cm Sağ Üst Dolap Beyaz Melamin Gövde Lake Kapak",
    "category": "Üst Dolaplar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-beyaz-melamin-govde-lake-kapak_79d1e5ff-1ce7-41f6-a1e0-90ab55874dd3.png?v=1749137116",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-beyaz-melamin-govde-lake-kapak_79d1e5ff-1ce7-41f6-a1e0-90ab55874dd3.png?v=1749137116",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-beyaz-melamin-govde-lake-kapak-5541.jpg?v=1749137116",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-beyaz-melamin-govde-lake-kapak-5543.jpg?v=1749137116",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-beyaz-melamin-govde-lake-kapak-5544.jpg?v=1749137116",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sag-ust-dolap-beyaz-melamin-govde-lake-kapak-5546.jpg?v=1749137116"
    ],
    "price": "2992.00",
    "sku": "D10.UD020.SAG.M.L.0101",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "Lake",
      "Melamin",
      "yaz-10-indirim",
      "Üst Dolap"
    ],
    "variants": [
      {
        "id": 52843071045929,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.UD020.SAG.M.L.0101",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "2992.00",
        "grams": 0,
        "compare_at_price": "3740.00",
        "position": 1,
        "product_id": 8968525447465,
        "created_at": "2026-03-17T11:52:03+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>D10'la Karıştır, Banyona Yakıştır!</strong></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8968523907369",
    "brand": "Creavit",
    "title": "D10 20 cm Sol Üst Dolap Beyaz Melamin Gövde Melamin Kapak",
    "category": "Üst Dolaplar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-beyaz-melamin-govde-kapak.png?v=1749137242",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-beyaz-melamin-govde-kapak.png?v=1749137242",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-beyaz-melamin-govde-melamin-kapak-5537.jpg?v=1749137242",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-beyaz-melamin-govde-melamin-kapak-5538.jpg?v=1749137242",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-beyaz-melamin-govde-melamin-kapak-5539.jpg?v=1749137242",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-20-cm-sol-ust-dolap-beyaz-melamin-govde-melamin-kapak-5540.jpg?v=1749137242"
    ],
    "price": "2288.00",
    "sku": "D10.UD020.SOL.M.M.0101",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "Melamin",
      "Sol Üst Dolap",
      "yaz-10-indirim",
      "Üst Dolap"
    ],
    "variants": [
      {
        "id": 52843084022057,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.UD020.SOL.M.M.0101",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2288.00",
        "grams": 0,
        "compare_at_price": "2860.00",
        "position": 1,
        "product_id": 8968523907369,
        "created_at": "2026-03-17T11:56:56+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>D10'la Karıştır, Banyona Yakıştır!</strong></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8968463581481",
    "brand": "Creavit",
    "title": "D10 40 cm Sol Boy Dolabı Gri Melamin Gövde, Antrasit Kapak",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-boy-dolabi-40cm-antrasit-banyo-mobilyasi.png?v=1749137390",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-boy-dolabi-40cm-antrasit-banyo-mobilyasi.png?v=1749137390",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-gri-melamin-govde-antrasit-kapak-5528.jpg?v=1749137390",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-gri-melamin-govde-antrasit-kapak-5529.jpg?v=1749137390",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-gri-melamin-govde-antrasit-kapak-5530.jpg?v=1749137390",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-gri-melamin-govde-antrasit-kapak-5531.jpg?v=1749137390"
    ],
    "price": "6424.00",
    "sku": "D10.BD040.SOL.M.M.0305",
    "tags": [
      "Antrasit",
      "Banyo Mobilyası",
      "boy dolabı",
      "D10",
      "Gri",
      "Melamin",
      "Sol Boy Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52920975294761,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.BD040.SOL.M.M.0305",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6424.00",
        "grams": 0,
        "compare_at_price": "8030.00",
        "position": 1,
        "product_id": 8968463581481,
        "created_at": "2026-04-03T12:17:06+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8968457290025",
    "brand": "Creavit",
    "title": "D10 40 cm SOL Boy Dolabı Melamin Dafne Gövde Melamin Antrasit Meşe Kapak",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-boy-dolabi-40cm-antrasit-mese-dafne-banyo-mobilyasi.png?v=1749208067",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-boy-dolabi-40cm-antrasit-mese-dafne-banyo-mobilyasi.png?v=1749208067",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-dafne-melamin-govde-antrasit-mese-kapak-5508.jpg?v=1749208067",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-dafne-melamin-govde-antrasit-mese-kapak-5507.jpg?v=1749208067",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-dafne-melamin-govde-antrasit-mese-kapak-5509.jpg?v=1749208064",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-dafne-melamin-govde-antrasit-mese-kapak-5510.jpg?v=1749208064",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-dafne-melamin-govde-antrasit-mese-kapak-5511.jpg?v=1749208064"
    ],
    "price": "6424.00",
    "sku": "D10.BD040.SOL.M.M.0204",
    "tags": [
      "Antrasit",
      "Banyo Mobilyası",
      "boy dolabı",
      "D10",
      "Dafne",
      "Melamin",
      "Meşe",
      "Sağ Boy Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843091591465,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.BD040.SOL.M.M.0204",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6424.00",
        "grams": 0,
        "compare_at_price": "8030.00",
        "position": 1,
        "product_id": 8968457290025,
        "created_at": "2026-03-17T11:59:43+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span>D10'la Karıştır, Banyona Yakıştır!</span></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.<meta charset=\"utf-8\"></p>\n<!---->"
  },
  {
    "id": "creavit-8968455946537",
    "brand": "Creavit",
    "title": "D10 40 cm SAĞ Boy Dolabı Melamin Dafne Gövde Melamin Antrasit Meşe Kapak",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-boy-dolabi-40cm-antrasit-mese-dafne-banyo-mobilyasi_41469895-6b7f-4bd0-9412-2bcb1ed5ae79.png?v=1749208230",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-boy-dolabi-40cm-antrasit-mese-dafne-banyo-mobilyasi_41469895-6b7f-4bd0-9412-2bcb1ed5ae79.png?v=1749208230",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-dafne-melamin-govde-antrasit-mese-kapak-5503.jpg?v=1749208230",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-dafne-melamin-govde-antrasit-mese-kapak-5502.jpg?v=1749208230",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-dafne-melamin-govde-antrasit-mese-kapak-5504.jpg?v=1749208229",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-dafne-melamin-govde-antrasit-mese-kapak-5505.jpg?v=1749208229",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-dafne-melamin-govde-antrasit-mese-kapak-5506.jpg?v=1749208229"
    ],
    "price": "6424.00",
    "sku": "D10.BD040.SAG.M.M.0204",
    "tags": [
      "Antrasit",
      "Banyo Mobilyası",
      "boy dolabı",
      "D10",
      "Dafne",
      "Melamin",
      "Meşe",
      "Sağ Boy Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843083497769,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.BD040.SAG.M.M.0204",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6424.00",
        "grams": 0,
        "compare_at_price": "8030.00",
        "position": 1,
        "product_id": 8968455946537,
        "created_at": "2026-03-17T11:56:43+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>D10'la Karıştır, Banyona Yakıştır!</strong></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8968454209833",
    "brand": "Creavit",
    "title": "D10 40 cm SOL Boy Dolabı Melamin Beyaz Gövde Melamin Beyaz Kapak",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-boy-dolabi-40cm-beyaz-banyo-mobilyasi.png?v=1749208332",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-boy-dolabi-40cm-beyaz-banyo-mobilyasi.png?v=1749208332",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-beyaz-melamin-govde-melamin-kapak-5487.jpg?v=1749208332",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-beyaz-melamin-govde-melamin-kapak-5486.jpg?v=1749208332",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-beyaz-melamin-govde-melamin-kapak-5488.jpg?v=1749208331",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-beyaz-melamin-govde-melamin-kapak-5489.jpg?v=1749208331",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-beyaz-melamin-govde-melamin-kapak-5490.jpg?v=1749208331"
    ],
    "price": "6424.00",
    "sku": "D10.BD040.SOL.M.M.0101",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "boy dolabı",
      "D10",
      "Melamin",
      "Sol Boy Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843083235625,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.BD040.SOL.M.M.0101",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6424.00",
        "grams": 0,
        "compare_at_price": "8030.00",
        "position": 1,
        "product_id": 8968454209833,
        "created_at": "2026-03-17T11:56:37+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8968451260713",
    "brand": "Creavit",
    "title": "D10 40 cm SAĞ Boy Dolabı Melamin Beyaz Gövde Melamin Beyaz Kapak",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-boy-dolabi-40cm-beyaz-banyo-mobilyasi_abe78f70-5e65-4235-9e40-190e02806776.png?v=1749208409",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-boy-dolabi-40cm-beyaz-banyo-mobilyasi_abe78f70-5e65-4235-9e40-190e02806776.png?v=1749208409",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-beyaz-melamin-govde-melamin-kapak-5482.jpg?v=1749208409",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-beyaz-melamin-govde-melamin-kapak-5481.jpg?v=1749208409",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-beyaz-melamin-govde-melamin-kapak-5483.jpg?v=1749208408",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-beyaz-melamin-govde-melamin-kapak-5484.jpg?v=1749208408",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sag-boy-dolabi-beyaz-melamin-govde-melamin-kapak-5485.jpg?v=1749208408"
    ],
    "price": "6424.00",
    "sku": "D10.BD040.SAG.M.M.0101",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "boy dolabı",
      "D10",
      "Melamin",
      "Sağ Boy Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52912524722473,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.BD040.SAG.M.M.0101",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6424.00",
        "grams": 0,
        "compare_at_price": "8030.00",
        "position": 1,
        "product_id": 8968451260713,
        "created_at": "2026-04-01T16:19:35+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>D10'la Karıştır, Banyona Yakıştır!</strong></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8968450474281",
    "brand": "Creavit",
    "title": "D10 40 cm SOL Boy Dolabı Melamin Beyaz Gövde Lake Beyaz Kapak",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-boy-dolabi-40cm-beyaz-melamin-banyo-mobilyasi.png?v=1749208708",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-boy-dolabi-40cm-beyaz-melamin-banyo-mobilyasi.png?v=1749208708",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-beyaz-melamin-govde-lake-kapak-5477.jpg?v=1749208708",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-beyaz-melamin-govde-lake-kapak-5476.jpg?v=1749208708",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-beyaz-melamin-govde-lake-kapak-5478.jpg?v=1749208672",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-beyaz-melamin-govde-lake-kapak-5479.jpg?v=1749208672",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-40-cm-sol-boy-dolabi-beyaz-melamin-govde-lake-kapak-5480.jpg?v=1749208672"
    ],
    "price": "8536.00",
    "sku": "D10.BD040.SOL.M.L.0101",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "boy dolabı",
      "D10",
      "Lake",
      "Melamin",
      "Sol Boy Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843093033257,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.BD040.SOL.M.L.0101",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8536.00",
        "grams": 0,
        "compare_at_price": "10670.00",
        "position": 1,
        "product_id": 8968450474281,
        "created_at": "2026-03-17T12:00:11+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>D10'la Karıştır, Banyona Yakıştır!</strong></p>\n<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8967725351209",
    "brand": "Creavit",
    "title": "D10 30cm SAĞ Boy Dolabı Melamin Gri Gövde Lake Gri Kapak",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30cm-sag-boy-dolabi-cizgili-gri-lake-kapak-demonte-5453.jpg?v=1747225928",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30cm-sag-boy-dolabi-cizgili-gri-lake-kapak-demonte-5453.jpg?v=1747225928",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30cm-sag-boy-dolabi-cizgili-gri-lake-kapak-demonte-5454.jpg?v=1747225931",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30cm-sag-boy-dolabi-cizgili-gri-lake-kapak-demonte-5455.jpg?v=1747225933",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30cm-sag-boy-dolabi-cizgili-gri-lake-kapak-demonte-5456.jpg?v=1747225935"
    ],
    "price": "8008.00",
    "sku": "D10.BD030.SAG.M.L.0303",
    "tags": [
      "D10"
    ],
    "variants": [
      {
        "id": 52843094671657,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.BD030.SAG.M.L.0303",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8008.00",
        "grams": 0,
        "compare_at_price": "10010.00",
        "position": 1,
        "product_id": 8967725351209,
        "created_at": "2026-03-17T12:00:50+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8967720632617",
    "brand": "Creavit",
    "title": "D10 30cm SAĞ Boy Dolabı Melamin Dafne Gövde Lake Dafne Kapak",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30cm-sag-boy-dolabi-cizgili-dafne-lake-kapak-demonte-5440.jpg?v=1757661712",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-30cm-sag-boy-dolabi-cizgili-dafne-lake-kapak-demonte-5440.jpg?v=1757661712",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30cm-sag-boy-dolabi-cizgili-dafne-lake-kapak-demonte-5441.jpg?v=1747225855",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30cm-sag-boy-dolabi-cizgili-dafne-lake-kapak-demonte-5442.jpg?v=1747225857",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30cm-sag-boy-dolabi-cizgili-dafne-lake-kapak-demonte-5443.jpg?v=1747225859",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30cm-sag-boy-dolabi-cizgili-dafne-lake-kapak-demonte-5444.jpg?v=1747225862"
    ],
    "price": "8008.00",
    "sku": "D10.BD030.SAG.M.L.0202",
    "tags": [
      "D10"
    ],
    "variants": [
      {
        "id": 52920978899241,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.BD030.SAG.M.L.0202",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8008.00",
        "grams": 0,
        "compare_at_price": "10010.00",
        "position": 1,
        "product_id": 8967720632617,
        "created_at": "2026-04-03T12:18:20+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>İçinde Sen Varsın</strong></p>\n<p>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</p>\n<p><strong>Saklama Alanını Belirle</strong></p>\n<p>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</p>\n<p><strong>Renkleri Deneyimle</strong></p>\n<p>D10'un renklerini kendi zevklerine göre kombinleyerek banyoda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için banyo bu tarafta.</p>"
  },
  {
    "id": "creavit-8883238338857",
    "brand": "Creavit",
    "title": "D10 65cm İki Çekmeceli Lavabo Dolabı Dafne Lake Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65cm-iki-cekmeceli-lavabo-dolabi-cizgili-dafne-lake-kapak-demonte-5258.jpg?v=1747225784",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65cm-iki-cekmeceli-lavabo-dolabi-cizgili-dafne-lake-kapak-demonte-5258.jpg?v=1747225784",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65cm-iki-cekmeceli-lavabo-dolabi-cizgili-dafne-lake-kapak-demonte-5259.jpg?v=1747225786",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65cm-iki-cekmeceli-lavabo-dolabi-cizgili-dafne-lake-kapak-demonte-5260.jpg?v=1747225789",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65cm-iki-cekmeceli-lavabo-dolabi-cizgili-dafne-lake-kapak-demonte-5261.jpg?v=1747225791",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65cm-iki-cekmeceli-lavabo-dolabi-cizgili-dafne-lake-kapak-demonte-5262.jpg?v=1747225794"
    ],
    "price": "10648.00",
    "sku": "D10.LD065.2C.M.L.0202",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "D10",
      "D20",
      "Dafne",
      "iki çekmeceli lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52921959907625,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.2C.M.L.0202",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "10648.00",
        "grams": 0,
        "compare_at_price": "13310.00",
        "position": 1,
        "product_id": 8883238338857,
        "created_at": "2026-04-03T16:28:58+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>İçinde Sen Varsın</strong></p>\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><span>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</span></p>\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Saklama Alanını Belirle </strong></p>\n<p><span>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek saklama alanını genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</span></p>\n<div title=\"Page 177\" class=\"page\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Renkleri Deneyimle </strong></p>\n<p><span>D10’un renklerini kendi zevklerine göre kombinleyerek banyonda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için </span><span>banyo bu tarafta.</span></p>\n<div title=\"Page 178\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Senin Lavab’ON </strong></p>\n<p><span>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş banyo deneyimi bu tarafta. </span></p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8882987467049",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı Çekmeceli 65 cm Antrasit Melamin Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-65-cm-antrasit-melamin.png?v=1749209451",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-65-cm-antrasit-melamin.png?v=1749209451",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-65-cm-antrasit-melamin-5251.jpg?v=1749209451",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-65-cm-antrasit-melamin-5250.jpg?v=1749209451",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-65-cm-antrasit-melamin-5249.jpg?v=1749209451",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-65-cm-antrasit-melamin-5252.jpg?v=1749209449",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-65-cm-antrasit-melamin-5253.jpg?v=1749209449"
    ],
    "price": "6336.00",
    "sku": "D10.LD065.1C.M.M.T.03053",
    "tags": [
      "Antrasit",
      "Banyo Mobilyası",
      "D10",
      "Gri",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843079106857,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.1C.M.M.T.03053",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6336.00",
        "grams": 0,
        "compare_at_price": "7920.00",
        "position": 1,
        "product_id": 8882987467049,
        "created_at": "2026-03-17T11:55:03+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>İçinde Sen Varsın</strong></p>\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><span>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</span></p>\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Saklama Alanını Belirle </strong></p>\n<p><span>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek saklama alanını genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</span></p>\n<div title=\"Page 177\" class=\"page\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Renkleri Deneyimle </strong></p>\n<p><span>D10’un renklerini kendi zevklerine göre kombinleyerek banyonda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için </span><span>banyo bu tarafta.</span></p>\n<div title=\"Page 178\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Senin Lavab’ON </strong></p>\n<p><span>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş banyo deneyimi bu tarafta. </span></p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8882965872937",
    "brand": "Creavit",
    "title": "D10 Eksen Lavabo Dolabı Çekmeceli 65 cm Küllü Gri Lake Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-65-cm-kullu-gri-lake.png?v=1749210051",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-65-cm-kullu-gri-lake.png?v=1749210051",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-65-cm-kullu-gri-lake-5239.jpg?v=1749210051",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-65-cm-kullu-gri-lake-5240.jpg?v=1749210051",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-65-cm-kullu-gri-lake-5238.jpg?v=1749210051",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-65-cm-kullu-gri-lake-5241.jpg?v=1749210048",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-65-cm-kullu-gri-lake-5242.jpg?v=1749210048",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-65-cm-kullu-gri-lake-5243.jpg?v=1749210048"
    ],
    "price": "7480.00",
    "sku": "D10.LD065.1C.M.L.0303",
    "tags": [
      "Banyo Mobilyası",
      "D10",
      "Gri",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843078091049,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.1C.M.L.0303",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "7480.00",
        "grams": 0,
        "compare_at_price": "9350.00",
        "position": 1,
        "product_id": 8882965872937,
        "created_at": "2026-03-17T11:54:40+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>İçinde Sen Varsın</strong></p>\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><span>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</span></p>\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Saklama Alanını Belirle </strong></p>\n<p><span>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek saklama alanını genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</span></p>\n<div title=\"Page 177\" class=\"page\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Renkleri Deneyimle </strong></p>\n<p><span>D10’un renklerini kendi zevklerine göre kombinleyerek banyonda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için </span><span>banyo bu tarafta.</span></p>\n<div title=\"Page 178\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Senin Lavab’ON </strong></p>\n<p><span>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş banyo deneyimi bu tarafta. </span></p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8882957222185",
    "brand": "Creavit",
    "title": "D10 Eksen Lavabo Dolabı Çekmeceli 65 cm Dafne Melamin Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-65-cm-dafne-melamin.png?v=1749210169",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-65-cm-dafne-melamin.png?v=1749210169",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-65-cm-dafne-melamin-5234.jpg?v=1749210169",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-65-cm-dafne-melamin-5233.jpg?v=1749210169",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-65-cm-dafne-melamin-5232.jpg?v=1749210169",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-65-cm-dafne-melamin-5231.jpg?v=1749210169",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-65-cm-dafne-melamin-5236.jpg?v=1749210162",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-65-cm-dafne-melamin-5237.jpg?v=1749210162"
    ],
    "price": "6336.00",
    "sku": "D10.LD065.1C.M.M.0204",
    "tags": [
      "Antrasit",
      "Banyo Mobilyası",
      "D10",
      "Dafne",
      "Lavabo Dolabı",
      "Melamin",
      "Meşe",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52876210733353,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.1C.M.M.0204",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6336.00",
        "grams": 0,
        "compare_at_price": "7920.00",
        "position": 1,
        "product_id": 8882957222185,
        "created_at": "2026-03-25T10:35:37+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>İçinde Sen Varsın</strong></p>\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><span>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</span></p>\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Saklama Alanını Belirle </strong></p>\n<p><span>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek saklama alanını genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</span></p>\n<div title=\"Page 177\" class=\"page\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Renkleri Deneyimle </strong></p>\n<p><span>D10’un renklerini kendi zevklerine göre kombinleyerek banyonda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için </span><span>banyo bu tarafta.</span></p>\n<div title=\"Page 178\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Senin Lavab’ON </strong></p>\n<p><span>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş banyo deneyimi bu tarafta. </span></p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8882884149545",
    "brand": "Creavit",
    "title": "D10 Next Lavabo Dolabı Çekmeceli 65 cm Beyaz Melamin Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-drop-siyah-kumanda-paneli_4.png?v=1749215622",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-drop-siyah-kumanda-paneli_4.png?v=1749215622",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-65-cm-beyaz-melamin-5210.jpg?v=1749215622",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-65-cm-beyaz-melamin-5211.jpg?v=1749215622",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-65-cm-beyaz-melamin-5209.jpg?v=1749215622",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-65-cm-beyaz-melamin-5212.jpg?v=1749215622",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-next-lavabo-dolabi-cekmeceli-65-cm-beyaz-melamin-5213.jpg?v=1749215622"
    ],
    "price": "6336.00",
    "sku": "D10.LD065.1C.M.M.T.01011",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52921484935465,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.1C.M.M.T.01011",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "6336.00",
        "grams": 0,
        "compare_at_price": "7920.00",
        "position": 1,
        "product_id": 8882884149545,
        "created_at": "2026-04-03T14:44:37+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>İçinde Sen Varsın</strong></p>\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><span>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</span></p>\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Saklama Alanını Belirle </strong></p>\n<p><span>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek saklama alanını genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</span></p>\n<div title=\"Page 177\" class=\"page\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Renkleri Deneyimle </strong></p>\n<p><span>D10’un renklerini kendi zevklerine göre kombinleyerek banyonda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için </span><span>banyo bu tarafta.</span></p>\n<div title=\"Page 178\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Senin Lavab’ON </strong></p>\n<p><span>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş banyo deneyimi bu tarafta. </span></p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8882789417257",
    "brand": "Creavit",
    "title": "D10 Eksen Lavabo Dolabı Çekmeceli 65 cm Beyaz Lake Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-65-cm-beyaz-lake.png?v=1749218677",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-65-cm-beyaz-lake.png?v=1749218677",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-65-cm-beyaz-lake-5191.jpg?v=1749218677",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-65-cm-beyaz-lake-5192.jpg?v=1749218677",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-65-cm-beyaz-lake-5190.jpg?v=1749218677",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-65-cm-beyaz-lake-5193.jpg?v=1749218674",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d10-eksen-lavabo-dolabi-cekmeceli-65-cm-beyaz-lake-5194.jpg?v=1749218674"
    ],
    "price": "7480.00",
    "sku": "D10.LD065.1C.M.L.0101",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "D10",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52920974901545,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D10.LD065.1C.M.L.0101",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7480.00",
        "grams": 0,
        "compare_at_price": "9350.00",
        "position": 1,
        "product_id": 8882789417257,
        "created_at": "2026-04-03T12:17:00+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"page\" title=\"Page 177\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>İçinde Sen Varsın</strong></p>\n<div class=\"page\" title=\"Page 177\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><span>Kullanıcı alışkanlıklarını yakından takip ederek geliştirdiğimiz D10; sizleri kişiselleştirilebilir banyo deneyimini keşfetmeye davet ediyor. Farklı renk, boyut ve özelliklere sahip D10 ürünlerini kendiniz kombinleyerek hayallerinizdeki banyoyu yaratabilir, konfor alanınızı kişiselleştirerek kendi banyonuzu tasarlayabilirsiniz.</span></p>\n<div class=\"page\" title=\"Page 177\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Saklama Alanını Belirle </strong></p>\n<p><span>Farklı boyut seçenekleri ile saklama ihtiyacın olan dolabı deneyimleyerek saklama alanını genişliğini belirleyebilir, alan kullanımını dilediğin gibi şekillendirebilirsin.</span></p>\n<div class=\"page\" title=\"Page 177\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Renkleri Deneyimle </strong></p>\n<p><span>D10’un renklerini kendi zevklerine göre kombinleyerek banyonda dilediğin derinliği ve tasarım tonunu yaratabilirsin. Güne başladığın ve günü sonlandırdığın alanı daha fazla sen yapmak için </span><span>banyo bu tarafta.</span></p>\n<div class=\"page\" title=\"Page 178\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Senin Lavab’ON </strong></p>\n<p><span>Banyonun her detayını şekillendirmen için lavabo tasarım esnekliği onda, D10 ile kişiselleştirilmiş banyo deneyimi bu tarafta. </span></p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9523932856617",
    "brand": "Creavit",
    "title": "Lua Uzun Lavabo Armatürü Krom",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-uzun-lavabo-armaturu-krom-6591.png?v=1747234906",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-uzun-lavabo-armaturu-krom-6591.png?v=1747234906",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-uzun-lavabo-armaturu-krom-6592.jpg?v=1747234908",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-uzun-lavabo-armaturu-krom-6593.jpg?v=1747234911"
    ],
    "price": "9765.00",
    "sku": "BT.LU6500",
    "tags": [
      "Armatür",
      "Banyo",
      "Krom",
      "Lavabo Armatürü",
      "Lua",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843235082537,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.LU6500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9765.00",
        "grams": 0,
        "compare_at_price": "13020.00",
        "position": 1,
        "product_id": 9523932856617,
        "created_at": "2026-03-17T13:01:42+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Creavit Lua Duşta, Banyoda, Mutfakta!</strong></p>\r\n<p>Lua<strong> </strong>Armatür serisi özel olarak tasarlanan ideal su çıkış ucu eğimiyle suyun şelale görünümünde akmasını sağlar. Şık ve minimalist çizgileriyle banyo dekorasyonunuza sofistike bir dokunuş katar. Lua armatür serisi hızlı ve kolay bir şekilde monte edilir. Standart armatür deliği ölçüleriyle uyumludur. Çoğu lavabo veya tezgaha rahatlıkla takılabilir. Creavit armatürleri gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p><!---->"
  },
  {
    "id": "creavit-9587392446761",
    "brand": "Creavit",
    "title": "Duck Duroplast Yavaş Kapanan Klozet Kapağı Kömür Karası",
    "category": "Duroplast Klozet Kapakları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-duck-free-komur-karasi-klozet-kapagi_6fe5e85f-4911-4198-bbfb-ac81661700ff.png?v=1749032871",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-duck-free-komur-karasi-klozet-kapagi_6fe5e85f-4911-4198-bbfb-ac81661700ff.png?v=1749032871",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-free-kapak.jpg?v=1749032871",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-elegant-kapak5_1.jpg?v=1749032871",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-komur-karasi-6754.png?v=1749032871"
    ],
    "price": "7350.00",
    "sku": "KC0903.01.2100E",
    "tags": [
      "duck",
      "duroplast",
      "kapak",
      "klozet kapağı",
      "Kömür Karası",
      "tak-çıkar",
      "yavaş kapama",
      "yaz-25-indirim",
      "Yuvarlak"
    ],
    "variants": [
      {
        "id": 52921490735401,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KC0903.01.2100E",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7350.00",
        "grams": 0,
        "compare_at_price": "10500.00",
        "position": 1,
        "product_id": 9587392446761,
        "created_at": "2026-04-03T14:45:53+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<p><strong>Pratik Kullanım:</strong> Tek hareket ile zorlanmadan çıkartılabilen tak-çıkar kapak özellikli Creavit klozet kapakları ile temizlik sırasında tüm yüzeyler kolayca temizlenir. </p>\r\n<p><span><strong>Antibakteriyel Malzeme: </strong>Antibakteriyel Duroplast malzeme ile klozet kapağı üzerinde bakteri ve mikropların üremesi önlenerek banyonuzun daha hijyenik ve temiz olması sağlanır. Amasra Ultima Duroplast Yavaş Kapanan Klozet Kapağı ile uzun ömürlü kullanım ve kolay temizlik elde edeceksiniz.</span></p>\r\n<p><strong>Yavaş Kapanan Kapak:</strong> Creavit Amasra Ultima Klozet Kapağı yavaş kapanma özelliği sayesinde sessiz ve  nazikçe kapanır. Ani çarpmaları ve gürültüyü engelleyerek rahatlatıcı bir banyo deneyiminin tadını çıkarmanıza yardımcı olur.</p>"
  },
  {
    "id": "creavit-9661236216105",
    "brand": "Creavit",
    "title": "Elegant Duroplast Yavaş Kapanan Klozet Kapağı inci Mat Beyaz",
    "category": "Duroplast Klozet Kapakları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-elegant-klozet-kapagi-beyaz.png?v=1748954670",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-elegant-klozet-kapagi-beyaz.png?v=1748954670",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-inci-mat-beyaz-7170.jpg?v=1748954670",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-inci-mat-beyaz-7171.jpg?v=1748954670",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-inci-mat-beyaz-7172.jpg?v=1748954670",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-inci-mat-beyaz-7173.jpg?v=1748954670",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-inci-mat-beyaz-7169.jpg?v=1748954670"
    ],
    "price": "7434.00",
    "sku": "KC1103.01.0100E",
    "tags": [
      "Beyaz",
      "duroplast",
      "elegant",
      "kapak",
      "Kare",
      "klozet kapağı",
      "tak-çıkar",
      "yavaş kapama",
      "yaz-25-indirim"
    ],
    "variants": [
      {
        "id": 52843211522345,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KC1103.01.0100E",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7434.00",
        "grams": 0,
        "compare_at_price": "10620.00",
        "position": 1,
        "product_id": 9661236216105,
        "created_at": "2026-03-17T12:54:11+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<p><strong>Pratik Kullanım:</strong> Tek hareket ile zorlanmadan çıkartılabilen tak-çıkar kapak özellikli Creavit klozet kapakları ile temizlik sırasında tüm yüzeyler kolayca temizlenir. </p>\r\n<p><span><strong>Antibakteriyel Malzeme: </strong>Antibakteriyel Duroplast malzeme ile klozet kapağı üzerinde bakteri ve mikropların üremesi önlenerek banyonuzun daha hijyenik ve temiz olması sağlanır. Amasra Ultima Duroplast Yavaş Kapanan Klozet Kapağı ile uzun ömürlü kullanım ve kolay temizlik elde edeceksiniz.</span></p>\r\n<p><strong>Yavaş Kapanan Kapak:</strong> Creavit Amasra Ultima Klozet Kapağı yavaş kapanma özelliği sayesinde sessiz ve  nazikçe kapanır. Ani çarpmaları ve gürültüyü engelleyerek rahatlatıcı bir banyo deneyiminin tadını çıkarmanıza yardımcı olur.</p>"
  },
  {
    "id": "creavit-9587501957417",
    "brand": "Creavit",
    "title": "Loop Gen-Z Kare 40 cm Masa Üstü İnce Lavabo Selçuklu Extra Beyaz",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-loop-selcuklu-canak-lavabo-beyaz-kare.png?v=1749032429",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-loop-selcuklu-canak-lavabo-beyaz-kare.png?v=1749032429",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-gen-z-kare-40-cm-masa-ustu-ince-lavabo-selcuklu-extra-beyaz-6796.png?v=1749032429"
    ],
    "price": "11610.00",
    "sku": "LP040-00CB00E-SK00",
    "tags": [
      "Beyaz",
      "Gen-Z",
      "Kare",
      "Lavabo",
      "Selçuklu",
      "Tezgahüstü",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843174756649,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP040-00CB00E-SK00",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11610.00",
        "grams": 0,
        "compare_at_price": "15480.00",
        "position": 1,
        "product_id": 9587501957417,
        "created_at": "2026-03-17T12:43:13+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Gen - Z</strong> koleksiyonu, Creavit üretim felsefesindeki inovatif bakışın şekil bulmuş halini banyolara taşıyor. Banyolar için yenilikçi çözümler <strong>Gen -Z</strong> koleksiyonunda estetik bakış açışını baştan sona değiştiren tasarımlarla hayatımıza giriyor.</p>\n<p><strong>Teknoloji Tasarımını Gen - Z'de Buldu</strong></p>\n<p>Creavit tasarım ekibi ve Ar-Ge'si teknolojinin hayatımıza getirdiği kolaylık ve yenilikleri banyolarımıza taşımıya devam ediyor.</p>\n<p><strong>Rölyef</strong></p>\n<p><meta charset=\"utf-8\">Banyonuzun her köşesinde sanat ve estetiği keşfedin! Gen-Z, özel olarak tasarlanmış lavabo kabartmaları ile banyonuza bir sanat galerisi havası katıyor. Her bir kabartma  deseni, lavabo üstünde sanatın büyüsünü yaşatıyor. Bu sanatsal dokunuşlar, hijyen alanınıza sadece işlevselliğin ötesinde estetik ve özgünlük getiriyorç Gen-Z lavabolar ile banyonuzun her anını sanatla doldurun ve her gününüzü bir sanat eseriyle çevreleyin.<meta charset=\"utf-8\"></p>"
  },
  {
    "id": "creavit-9588501905705",
    "brand": "Creavit",
    "title": "Loop Yuvarlak Masa Üstü Çanak Lavabo Ø40 cm Selçuklu Extra Beyaz",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-loop-selcuklu-canak-lavabo-beyaz-yuvarlak.png?v=1749031848",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-loop-selcuklu-canak-lavabo-beyaz-yuvarlak.png?v=1749031848",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-loop-selcuklu-rolyef-canak-lavabo-beyaz-yuvarlak.png?v=1749031848",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-40-cm-selcuklu-extra-beyaz-6799.png?v=1749031848"
    ],
    "price": "11610.00",
    "sku": "LP140-00CB00E-SK00",
    "tags": [
      "Beyaz",
      "Gen-Z",
      "Lavabo",
      "Loop",
      "Selçuklu",
      "Tezgahüstü",
      "yaz-15-indirim",
      "Yuvarlak",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843256480041,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP140-00CB00E-SK00",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11610.00",
        "grams": 0,
        "compare_at_price": "15480.00",
        "position": 1,
        "product_id": 9588501905705,
        "created_at": "2026-03-17T13:08:25+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Gen - Z</strong> koleksiyonu, Creavit üretim felsefesindeki inovatif bakışın şekil bulmuş halini banyolara taşıyor. Banyolar için yenilikçi çözümler <strong>Gen -Z</strong> koleksiyonunda estetik bakış açışını baştan sona değiştiren tasarımlarla hayatımıza giriyor.</p>\n<p><strong>Teknoloji Tasarımını Gen - Z'de Buldu</strong></p>\n<p>Creavit tasarım ekibi ve Ar-Ge'si teknolojinin hayatımıza getirdiği kolaylık ve yenilikleri banyolarımıza taşımıya devam ediyor.</p>\n<p><strong>Rölyef</strong></p>\n<p><meta charset=\"utf-8\">Banyonuzun her köşesinde sanat ve estetiği keşfedin! Gen-Z, özel olarak tasarlanmış lavabo kabartmaları ile banyonuza bir sanat galerisi havası katıyor. Her bir kabartma  deseni, lavabo üstünde sanatın büyüsünü yaşatıyor. Bu sanatsal dokunuşlar, hijyen alanınıza sadece işlevselliğin ötesinde estetik ve özgünlük getiriyorç Gen-Z lavabolar ile banyonuzun her anını sanatla doldurun ve her gününüzü bir sanat eseriyle çevreleyin.</p>"
  },
  {
    "id": "creavit-9588506755369",
    "brand": "Creavit",
    "title": "Loop Gen-Z Yuvarlak Masa Üstü Çanak Lavabo Ø40 cm Karikatür Baskı Extra Beyaz",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-loop-gen-z-karikatur-yuvarlak-canak-lavabo-LP140.png?v=1749030995",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-loop-gen-z-karikatur-yuvarlak-canak-lavabo-LP140.png?v=1749030995",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-gen-z-yuvarlak-masa-ustu-canak-lavabo-40-cm-karikatur-baski-extra-beyaz-6803.png?v=1749030995",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-gen-z-yuvarlak-masa-ustu-canak-lavabo-40-cm-karikatur-baski-extra-beyaz-6802.png?v=1749030995"
    ],
    "price": "11160.00",
    "sku": "LP140-00CB00E-KB00",
    "tags": [
      "Beyaz",
      "Gen-Z",
      "Karikatür",
      "Lavabo",
      "Loop",
      "Tezgahüstü",
      "yaz-15-indirim",
      "Yuvarlak",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52920256266537,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP140-00CB00E-KB00",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11160.00",
        "grams": 0,
        "compare_at_price": "14880.00",
        "position": 1,
        "product_id": 9588506755369,
        "created_at": "2026-04-03T09:11:24+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Gen - Z</strong> koleksiyonu, Creavit üretim felsefesindeki inovatif bakışın şekil bulmuş halini banyolara taşıyor. Banyolar için yenilikçi çözümler <strong>Gen -Z</strong> koleksiyonunda estetik bakış açışını baştan sona değiştiren tasarımlarla hayatımıza giriyor.</p>\n<p><strong>Teknoloji Tasarımını Gen - Z'de Buldu</strong></p>\n<p>Creavit tasarım ekibi ve Ar-Ge'si teknolojinin hayatımıza getirdiği kolaylık ve yenilikleri banyolarımıza taşımıya devam ediyor.</p>\n<p><strong>Dijital Baskı</strong></p>\n<p><meta charset=\"utf-8\">Banyonuzun detaylarında sizi simgeleyen ayrıntılar mı istiyorsunuz? Sanat benim vazgeçilmezim, banyonu bir sanat galerisi gibi tasarlamak istiyorum diyorsanız Gen-Z art tam size göre. Mekanı sanatla bütünleştiren serimizde klasik ve size özel yapılmış yeni eserleri sergileyebilir, hijyen alanınıza göz alıcı bir estetik getirebilirsiniz.</p>"
  },
  {
    "id": "creavit-9588531953961",
    "brand": "Creavit",
    "title": "Loop Kare Masa Üstü İnce Çanak Lavabo 45 cm Extra Sakura",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-sakura-6839.png?v=1747230785",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-sakura-6839.png?v=1747230785",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-sakura-6840.png?v=1747230788",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-sakura-6841.png?v=1747230791",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-sakura-6842.png?v=1747230794"
    ],
    "price": "11700.00",
    "sku": "LP046-00SK00E-0000",
    "tags": [
      "Kare",
      "Lavabo",
      "Loop",
      "Sakura",
      "Tezgahüstü",
      "Ultra İnce",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843176591657,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP046-00SK00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11700.00",
        "grams": 0,
        "compare_at_price": "15600.00",
        "position": 1,
        "product_id": 9588531953961,
        "created_at": "2026-03-17T12:43:41+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz modern sanat galerisine dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9588529529129",
    "brand": "Creavit",
    "title": "Loop Kare Masa Üstü İnce Çanak Lavabo 45 cm Extra Mint",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-mint-6835.png?v=1747230768",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-mint-6835.png?v=1747230768",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-mint-6836.png?v=1747230771",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-mint-6837.png?v=1747230774",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-mint-6838.png?v=1747230777"
    ],
    "price": "11700.00",
    "sku": "LP046-00MT00E-0000",
    "tags": [
      "Kare",
      "Lavabo",
      "Loop",
      "Mint",
      "Tezgahüstü",
      "Ultra İnce",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843176362281,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP046-00MT00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11700.00",
        "grams": 0,
        "compare_at_price": "15600.00",
        "position": 1,
        "product_id": 9588529529129,
        "created_at": "2026-03-17T12:43:38+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz modern sanat galerisine dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9588528120105",
    "brand": "Creavit",
    "title": "Loop Kare Masa Üstü İnce Çanak Lavabo 45 cm Nil Yeşili",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-nil-yesili-6831.png?v=1747230750",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-nil-yesili-6831.png?v=1747230750",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-nil-yesili-6832.png?v=1747230754",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-nil-yesili-6833.png?v=1747230757",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-nil-yesili-6834.png?v=1747230760"
    ],
    "price": "11700.00",
    "sku": "LP046-00NY00E-0000",
    "tags": [
      "Kare",
      "Lavabo",
      "Loop",
      "Nil Yeşili",
      "Tezgahüstü",
      "Ultra İnce",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843176034601,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP046-00NY00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11700.00",
        "grams": 0,
        "compare_at_price": "15600.00",
        "position": 1,
        "product_id": 9588528120105,
        "created_at": "2026-03-17T12:43:35+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz modern sanat galerisine dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9588522942761",
    "brand": "Creavit",
    "title": "Loop Kare Masa Üstü İnce Çanak Lavabo 45 cm Extra Berry",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-berry-6827.png?v=1747230733",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-berry-6827.png?v=1747230733",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-berry-6828.png?v=1747230736",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-berry-6829.png?v=1747230739",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-berry-6830.png?v=1747230742"
    ],
    "price": "11700.00",
    "sku": "LP046-00BR00E-0000",
    "tags": [
      "Berry",
      "Kare",
      "Lavabo",
      "Loop",
      "Tezgahüstü",
      "Ultra İnce",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843175903529,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP046-00BR00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11700.00",
        "grams": 0,
        "compare_at_price": "15600.00",
        "position": 1,
        "product_id": 9588522942761,
        "created_at": "2026-03-17T12:43:32+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz modern sanat galerisine dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9588521566505",
    "brand": "Creavit",
    "title": "Loop Kare Masa Üstü İnce Çanak Lavabo 45 cm Extra Cool Grey",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-cool-grey-6823.png?v=1747230715",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-cool-grey-6823.png?v=1747230715",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-cool-grey-6824.png?v=1747230718",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-cool-grey-6825.png?v=1747230721",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-cool-grey-6826.png?v=1747230724"
    ],
    "price": "11700.00",
    "sku": "LP046-00CG00E-0000",
    "tags": [
      "Cool Grey",
      "Kare",
      "Lavabo",
      "Loop",
      "Tezgahüstü",
      "Ultra İnce",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843247075625,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP046-00CG00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11700.00",
        "grams": 0,
        "compare_at_price": "15600.00",
        "position": 1,
        "product_id": 9588521566505,
        "created_at": "2026-03-17T13:05:28+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz modern sanat galerisine dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9588520845609",
    "brand": "Creavit",
    "title": "Loop Kare Masa Üstü İnce Çanak Lavabo 45 cm Extra Mat Cappuccino",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-mat-cappuccino-6819.png?v=1747230693",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-mat-cappuccino-6819.png?v=1747230693",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-mat-cappuccino-6820.png?v=1747230700",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-mat-cappuccino-6821.png?v=1747230703",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-mat-cappuccino-6822.png?v=1747230707"
    ],
    "price": "11700.00",
    "sku": "LP046-00CM00E-0000",
    "tags": [
      "Kare",
      "Lavabo",
      "Loop",
      "Mat Cappuccino",
      "Tezgahüstü",
      "Ultra İnce",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843175739689,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP046-00CM00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11700.00",
        "grams": 0,
        "compare_at_price": "15600.00",
        "position": 1,
        "product_id": 9588520845609,
        "created_at": "2026-03-17T12:43:29+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz modern sanat galerisine dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9588519698729",
    "brand": "Creavit",
    "title": "Loop Kare Masa Üstü İnce Çanak Lavabo 45 cm Extra Mat Antrasit",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-mat-antrasit-6815.png?v=1747230668",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-mat-antrasit-6815.png?v=1747230668",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-mat-antrasit-6816.png?v=1747230673",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-mat-antrasit-6817.png?v=1747230677",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-mat-antrasit-6818.png?v=1747230681"
    ],
    "price": "11700.00",
    "sku": "LP046-00AM00E-0000",
    "tags": [
      "Kare",
      "Lavabo",
      "Loop",
      "Mat Antrasit",
      "Tezgahüstü",
      "Ultra İnce",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843175477545,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP046-00AM00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11700.00",
        "grams": 0,
        "compare_at_price": "15600.00",
        "position": 1,
        "product_id": 9588519698729,
        "created_at": "2026-03-17T12:43:26+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz modern sanat galerisine dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9588518027561",
    "brand": "Creavit",
    "title": "Loop Kare Masa Üstü İnce Çanak Lavabo 45 cm Extra Kömür Karası",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-komur-karasi-6811.png?v=1747230651",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-komur-karasi-6811.png?v=1747230651",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-komur-karasi-6812.png?v=1747230654",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-komur-karasi-6813.png?v=1747230657",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-komur-karasi-6814.png?v=1747230660"
    ],
    "price": "11700.00",
    "sku": "LP046-00KK00E-0000",
    "tags": [
      "Kare",
      "Kömür Karası",
      "Lavabo",
      "Loop",
      "Tezgahüstü",
      "Ultra İnce",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843175346473,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP046-00KK00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11700.00",
        "grams": 0,
        "compare_at_price": "15600.00",
        "position": 1,
        "product_id": 9588518027561,
        "created_at": "2026-03-17T12:43:23+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz modern sanat galerisine dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9588516913449",
    "brand": "Creavit",
    "title": "Loop Kare Masa Üstü İnce Çanak Lavabo 45 cm Extra Mat Beyaz",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-mat-beyaz-6808.png?v=1747230635",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-mat-beyaz-6808.png?v=1747230635",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-mat-beyaz-6809.png?v=1747230638",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-mat-beyaz-6810.png?v=1747230642"
    ],
    "price": "10125.00",
    "sku": "LP046-00MB00E-0000",
    "tags": [
      "Beyaz",
      "Kare",
      "Lavabo",
      "Loop",
      "Tezgahüstü",
      "Ultra İnce",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843175215401,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP046-00MB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "10125.00",
        "grams": 0,
        "compare_at_price": "13500.00",
        "position": 1,
        "product_id": 9588516913449,
        "created_at": "2026-03-17T12:43:20+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz modern sanat galerisine dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9588534444329",
    "brand": "Creavit",
    "title": "Loop Kare Masa Üstü İnce Çanak Lavabo 45 cm Extra Neon",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-neon-6843.png?v=1747230802",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-neon-6843.png?v=1747230802",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-neon-6844.png?v=1747230805",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-neon-6845.png?v=1747230809",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-neon-6846.png?v=1747230811"
    ],
    "price": "11700.00",
    "sku": "LP046-00NN00E-0000",
    "tags": [
      "Kare",
      "Lavabo",
      "Loop",
      "Neon",
      "Tezgahüstü",
      "Ultra İnce",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843176722729,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP046-00NN00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11700.00",
        "grams": 0,
        "compare_at_price": "15600.00",
        "position": 1,
        "product_id": 9588534444329,
        "created_at": "2026-03-17T12:43:44+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz modern sanat galerisine dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9588536213801",
    "brand": "Creavit",
    "title": "Loop Kare Masa Üstü İnce Çanak Lavabo 45 cm Extra Şeftali Tüyü",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-seftali-tuyu-6847.png?v=1747230820",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-seftali-tuyu-6847.png?v=1747230820",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-seftali-tuyu-6848.png?v=1747230824",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-seftali-tuyu-6849.png?v=1747230827",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-seftali-tuyu-6850.png?v=1747230830",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-seftali-tuyu-6851.png?v=1747230833"
    ],
    "price": "11700.00",
    "sku": "LP046-00ST00E-0000",
    "tags": [
      "Kare",
      "Lavabo",
      "Loop",
      "Tezgahüstü",
      "Ultra İnce",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo",
      "Şeftali Tüyü"
    ],
    "variants": [
      {
        "id": 52843176853801,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP046-00ST00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11700.00",
        "grams": 0,
        "compare_at_price": "15600.00",
        "position": 1,
        "product_id": 9588536213801,
        "created_at": "2026-03-17T12:43:48+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz modern sanat galerisine dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9588569211177",
    "brand": "Creavit",
    "title": "Loop Kare Masa Üstü İnce Çanak Lavabo 45 cm Extra Limon Çiçeği",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-limon-cicegi-6852.png?v=1747230841",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-limon-cicegi-6852.png?v=1747230841",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-limon-cicegi-6853.png?v=1747230845",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-limon-cicegi-6854.png?v=1747230848",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-masa-ustu-ince-canak-lavabo-45-cm-extra-limon-cicegi-6855.png?v=1747230851"
    ],
    "price": "11700.00",
    "sku": "LP046-00LC00E-0000",
    "tags": [
      "Kare",
      "Lavabo",
      "Limon Çiçeği",
      "Loop",
      "Tezgahüstü",
      "Ultra İnce",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843177017641,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP046-00LC00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11700.00",
        "grams": 0,
        "compare_at_price": "15600.00",
        "position": 1,
        "product_id": 9588569211177,
        "created_at": "2026-03-17T12:43:51+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz modern sanat galerisine dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9589475049769",
    "brand": "Creavit",
    "title": "Loop Yuvarlak Masa Üstü Çanak Lavabo Ø45 cm Extra Kömür Karası",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-komur-karasi-6921.png?v=1747231108",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-komur-karasi-6921.png?v=1747231108",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-komur-karasi-6922.png?v=1747231112",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-komur-karasi-6923.png?v=1747231115",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-komur-karasi-6924.png?v=1747231119",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-komur-karasi-6925.png?v=1747231122"
    ],
    "price": "11385.00",
    "sku": "LP145-00KK00E-0000",
    "tags": [
      "Kömür Karası",
      "Lavabo",
      "Loop",
      "Tezgah Üstü Lavabo",
      "Tezgahüstü",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843179213097,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP145-00KK00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11385.00",
        "grams": 0,
        "compare_at_price": "15180.00",
        "position": 1,
        "product_id": 9589475049769,
        "created_at": "2026-03-17T12:44:31+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz modern sanat galerisine dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9589511455017",
    "brand": "Creavit",
    "title": "Loop Yuvarlak Masa Üstü Çanak Lavabo Ø45 cm Extra Şeftali Tüyü",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-seftali-tuyu-6975.png?v=1747231315",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-seftali-tuyu-6975.png?v=1747231315",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-seftali-tuyu-6976.png?v=1747231318",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-seftali-tuyu-6977.png?v=1747231321",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-seftali-tuyu-6978.png?v=1747231325",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-seftali-tuyu-6979.png?v=1747231328"
    ],
    "price": "11385.00",
    "sku": "LP145-00ST00E-0000",
    "tags": [
      "Lavabo",
      "Loop",
      "Tezgah Üstü Lavabo",
      "Tezgahüstü",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo",
      "Şeftali Tüyü"
    ],
    "variants": [
      {
        "id": 52843180425513,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP145-00ST00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11385.00",
        "grams": 0,
        "compare_at_price": "15180.00",
        "position": 1,
        "product_id": 9589511455017,
        "created_at": "2026-03-17T12:44:53+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz modern sanat galerisine dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9589511684393",
    "brand": "Creavit",
    "title": "Loop Yuvarlak Masa Üstü Çanak Lavabo Ø45 cm Extra Limon Çiçeği",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-limon-cicegi-6981.png?v=1747231338",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-limon-cicegi-6981.png?v=1747231338",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-limon-cicegi-6982.png?v=1747231342",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-limon-cicegi-6983.png?v=1747231345",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-limon-cicegi-6984.png?v=1747231349",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-limon-cicegi-6985.png?v=1747231352"
    ],
    "price": "11385.00",
    "sku": "LP145-00LC00E-0000",
    "tags": [
      "Lavabo",
      "Limon Çiçeği",
      "Loop",
      "Tezgah Üstü Lavabo",
      "Tezgahüstü",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843180523817,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP145-00LC00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11385.00",
        "grams": 0,
        "compare_at_price": "15180.00",
        "position": 1,
        "product_id": 9589511684393,
        "created_at": "2026-03-17T12:44:56+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz modern sanat galerisine dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9656188338473",
    "brand": "Creavit",
    "title": "Banyo Mobilyası Demonte Takım Montaj Hizmeti",
    "category": "Banyo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/banyo-mobilyasi-demonte-takim-montaj-hizmeti-7168.jpg?v=1747232121",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/banyo-mobilyasi-demonte-takim-montaj-hizmeti-7168.jpg?v=1747232121"
    ],
    "price": "3250.00",
    "sku": "HIZMET.MSE02",
    "tags": [],
    "variants": [
      {
        "id": 52504498241833,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "HIZMET.MSE02",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3250.00",
        "grams": 0,
        "compare_at_price": "3900.00",
        "position": 1,
        "product_id": 9656188338473,
        "created_at": "2026-01-26T09:52:26+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<ul>\n<li>Altyapı tesisatta kullanılan malzeme işçiliği fiyata dahil değildir.</li>\n<li>Demonte ürün sökümü hariçtir. </li>\n<li>Creavit Batarya, Ara Musluk ve Lavabo Sifonu montaj bedeli içerisindedir.</li>\n<li>Montaj yapılacak mekanın hazır olması gerekmektedir.  </li>\n<li>Creavit banyo mobilyası demonte alt modül montajı için yetkili servislerin sunduğu hizmetler 1 yıl garantilidir.</li>\n<li>Servis Ekipleri Pazar günleri hariç 09:00 - 18:00 saatleri arasında çalışmaktadır.</li>\n<li>Müşteri desteği taleplerine 48 saat içerisinde geri dönüş sağlanacaktır.</li>\n<li>Montaj işlemine söküm işlemi dahil değildir. Sadece takım işlemi dahildir. Sökme işlemi için servisimiz ekstradan ücret talep edebilir.</li>\n<li>Montaj işlemi tamamlandığında yetkili servisler müşteri imzasını alarak hizmet belgesinin bir kopyasını müşteriye teslim etmekle yükümlüdür.</li>\n</ul>"
  },
  {
    "id": "creavit-9587411353897",
    "brand": "Creavit",
    "title": "Elegant Duroplast Yavaş Kapanan Klozet Kapağı Mat Antrasit",
    "category": "Duroplast Klozet Kapakları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-mat-antrasit-6755.png?v=1747806106",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-mat-antrasit-6755.png?v=1747806106",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-mat-antrasit-6756.jpg?v=1747806106",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-mat-antrasit-6757.jpg?v=1747248297",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-mat-antrasit-6758.jpg?v=1747248299",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-mat-antrasit-6759.jpg?v=1747248303",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-mat-antrasit-6760.jpg?v=1747248305",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-mat-antrasit-6761.jpg?v=1747248308"
    ],
    "price": "7434.00",
    "sku": "KC1103.01.0400E",
    "tags": [
      "duroplast",
      "elegant",
      "kapak",
      "Kare",
      "klozet kapağı",
      "Mat Antrasit",
      "tak-çıkar",
      "yavaş kapama",
      "yaz-25-indirim"
    ],
    "variants": [
      {
        "id": 52843209752873,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KC1103.01.0400E",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7434.00",
        "grams": 0,
        "compare_at_price": "10620.00",
        "position": 1,
        "product_id": 9587411353897,
        "created_at": "2026-03-17T12:53:40+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<p><strong>Pratik Kullanım:</strong> Tek hareket ile zorlanmadan çıkartılabilen tak-çıkar kapak özellikli Creavit klozet kapakları ile temizlik sırasında tüm yüzeyler kolayca temizlenir. </p>\r\n<p><span><strong>Antibakteriyel Malzeme: </strong>Antibakteriyel Duroplast malzeme ile klozet kapağı üzerinde bakteri ve mikropların üremesi önlenerek banyonuzun daha hijyenik ve temiz olması sağlanır. Amasra Ultima Duroplast Yavaş Kapanan Klozet Kapağı ile uzun ömürlü kullanım ve kolay temizlik elde edeceksiniz.</span></p>\r\n<p><strong>Yavaş Kapanan Kapak:</strong> Creavit Amasra Ultima Klozet Kapağı yavaş kapanma özelliği sayesinde sessiz ve  nazikçe kapanır. Ani çarpmaları ve gürültüyü engelleyerek rahatlatıcı bir banyo deneyiminin tadını çıkarmanıza yardımcı olur.</p>"
  },
  {
    "id": "creavit-9587418071337",
    "brand": "Creavit",
    "title": "Elegant Duroplast Yavaş Kapanan Klozet Kapağı Berry",
    "category": "Duroplast Klozet Kapakları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-berry-6762.png?v=1747806097",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-berry-6762.png?v=1747806097",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-berry-6763.jpg?v=1747806097",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-berry-6764.jpg?v=1747248322",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-berry-6765.jpg?v=1747248325",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-berry-6766.jpg?v=1747248327",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-berry-6767.jpg?v=1747248330",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-berry-6768.jpg?v=1747248333"
    ],
    "price": "7434.00",
    "sku": "KC1103.01.1900E",
    "tags": [
      "Berry",
      "duroplast",
      "elegant",
      "kapak",
      "Kare",
      "klozet kapağı",
      "tak-çıkar",
      "yavaş kapama",
      "yaz-25-indirim"
    ],
    "variants": [
      {
        "id": 52843210015017,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KC1103.01.1900E",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7434.00",
        "grams": 0,
        "compare_at_price": "10620.00",
        "position": 1,
        "product_id": 9587418071337,
        "created_at": "2026-03-17T12:53:43+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<p><strong>Pratik Kullanım:</strong> Tek hareket ile zorlanmadan çıkartılabilen tak-çıkar kapak özellikli Creavit klozet kapakları ile temizlik sırasında tüm yüzeyler kolayca temizlenir. </p>\r\n<p><span><strong>Antibakteriyel Malzeme: </strong>Antibakteriyel Duroplast malzeme ile klozet kapağı üzerinde bakteri ve mikropların üremesi önlenerek banyonuzun daha hijyenik ve temiz olması sağlanır. Amasra Ultima Duroplast Yavaş Kapanan Klozet Kapağı ile uzun ömürlü kullanım ve kolay temizlik elde edeceksiniz.</span></p>\r\n<p><strong>Yavaş Kapanan Kapak:</strong> Creavit Amasra Ultima Klozet Kapağı yavaş kapanma özelliği sayesinde sessiz ve  nazikçe kapanır. Ani çarpmaları ve gürültüyü engelleyerek rahatlatıcı bir banyo deneyiminin tadını çıkarmanıza yardımcı olur.</p>"
  },
  {
    "id": "creavit-9587418923305",
    "brand": "Creavit",
    "title": "Elegant Duroplast Yavaş Kapanan Klozet Kapağı Cool Grey",
    "category": "Duroplast Klozet Kapakları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-cool-grey-6769.png?v=1747806090",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-cool-grey-6769.png?v=1747806090",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-cool-grey-6770.jpg?v=1747806090",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-cool-grey-6771.jpg?v=1747806090",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-cool-grey-6772.jpg?v=1757424055",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-cool-grey-6773.jpg?v=1757424055",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-cool-grey-6774.jpg?v=1747248444",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-cool-grey-6775.jpg?v=1747248447"
    ],
    "price": "7434.00",
    "sku": "KC1103.01.1800E",
    "tags": [
      "Cool Grey",
      "duroplast",
      "elegant",
      "kapak",
      "Kare",
      "klozet kapağı",
      "tak-çıkar",
      "yavaş kapama",
      "yaz-25-indirim"
    ],
    "variants": [
      {
        "id": 52843239604521,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KC1103.01.1800E",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7434.00",
        "grams": 0,
        "compare_at_price": "10620.00",
        "position": 1,
        "product_id": 9587418923305,
        "created_at": "2026-03-17T13:03:23+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<p><strong>Pratik Kullanım:</strong> Tek hareket ile zorlanmadan çıkartılabilen tak-çıkar kapak özellikli Creavit klozet kapakları ile temizlik sırasında tüm yüzeyler kolayca temizlenir. </p>\r\n<p><span><strong>Antibakteriyel Malzeme: </strong>Antibakteriyel Duroplast malzeme ile klozet kapağı üzerinde bakteri ve mikropların üremesi önlenerek banyonuzun daha hijyenik ve temiz olması sağlanır. Amasra Ultima Duroplast Yavaş Kapanan Klozet Kapağı ile uzun ömürlü kullanım ve kolay temizlik elde edeceksiniz.</span></p>\r\n<p><strong>Yavaş Kapanan Kapak:</strong> Creavit Amasra Ultima Klozet Kapağı yavaş kapanma özelliği sayesinde sessiz ve  nazikçe kapanır. Ani çarpmaları ve gürültüyü engelleyerek rahatlatıcı bir banyo deneyiminin tadını çıkarmanıza yardımcı olur.</p>"
  },
  {
    "id": "creavit-9587419676969",
    "brand": "Creavit",
    "title": "Elegant Duroplast Yavaş Kapanan Klozet Mat Cappuccino",
    "category": "Duroplast Klozet Kapakları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-mat-cappuccino-6776.png?v=1747806085",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-mat-cappuccino-6776.png?v=1747806085",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-mat-cappuccino-6777.jpg?v=1747806085",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-mat-cappuccino-6778.jpg?v=1747248347",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-mat-cappuccino-6779.jpg?v=1747248349",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-mat-cappuccino-6780.jpg?v=1747248352",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-mat-cappuccino-6781.jpg?v=1747248354"
    ],
    "price": "7434.00",
    "sku": "KC1103.01.0800E",
    "tags": [
      "duroplast",
      "elegant",
      "kapak",
      "Kare",
      "klozet kapağı",
      "Mat Cappuccino",
      "tak-çıkar",
      "yavaş kapama",
      "yaz-25-indirim"
    ],
    "variants": [
      {
        "id": 52920361648425,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KC1103.01.0800E",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7434.00",
        "grams": 0,
        "compare_at_price": "10620.00",
        "position": 1,
        "product_id": 9587419676969,
        "created_at": "2026-04-03T09:46:08+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<p><strong>Pratik Kullanım:</strong> Tek hareket ile zorlanmadan çıkartılabilen tak-çıkar kapak özellikli Creavit klozet kapakları ile temizlik sırasında tüm yüzeyler kolayca temizlenir. </p>\r\n<p><span><strong>Antibakteriyel Malzeme: </strong>Antibakteriyel Duroplast malzeme ile klozet kapağı üzerinde bakteri ve mikropların üremesi önlenerek banyonuzun daha hijyenik ve temiz olması sağlanır. Amasra Ultima Duroplast Yavaş Kapanan Klozet Kapağı ile uzun ömürlü kullanım ve kolay temizlik elde edeceksiniz.</span></p>\r\n<p><strong>Yavaş Kapanan Kapak:</strong> Creavit Amasra Ultima Klozet Kapağı yavaş kapanma özelliği sayesinde sessiz ve  nazikçe kapanır. Ani çarpmaları ve gürültüyü engelleyerek rahatlatıcı bir banyo deneyiminin tadını çıkarmanıza yardımcı olur.</p>"
  },
  {
    "id": "creavit-9587420594473",
    "brand": "Creavit",
    "title": "Elegant Duroplast Yavaş Kapanan Klozet Kömür Karası",
    "category": "Duroplast Klozet Kapakları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-komur-karasi-6782.png?v=1747806077",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-komur-karasi-6782.png?v=1747806077",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-komur-karasi-6783.jpg?v=1747806077",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-komur-karasi-6784.jpg?v=1747806077",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-komur-karasi-6785.jpg?v=1747806077",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-komur-karasi-6786.jpg?v=1747806077",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-komur-karasi-6787.jpg?v=1747806077",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-komur-karasi-6788.jpg?v=1747806077"
    ],
    "price": "7434.00",
    "sku": "KC1103.01.2100E",
    "tags": [
      "duroplast",
      "elegant",
      "kapak",
      "Kare",
      "klozet kapağı",
      "Kömür Karası",
      "tak-çıkar",
      "yavaş kapama",
      "yaz-25-indirim"
    ],
    "variants": [
      {
        "id": 52843245437225,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KC1103.01.2100E",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7434.00",
        "grams": 0,
        "compare_at_price": "10620.00",
        "position": 1,
        "product_id": 9587420594473,
        "created_at": "2026-03-17T13:05:00+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<p><strong>Pratik Kullanım:</strong> Tek hareket ile zorlanmadan çıkartılabilen tak-çıkar kapak özellikli Creavit klozet kapakları ile temizlik sırasında tüm yüzeyler kolayca temizlenir. </p>\r\n<p><span><strong>Antibakteriyel Malzeme: </strong>Antibakteriyel Duroplast malzeme ile klozet kapağı üzerinde bakteri ve mikropların üremesi önlenerek banyonuzun daha hijyenik ve temiz olması sağlanır. Amasra Ultima Duroplast Yavaş Kapanan Klozet Kapağı ile uzun ömürlü kullanım ve kolay temizlik elde edeceksiniz.</span></p>\r\n<p><strong>Yavaş Kapanan Kapak:</strong> Creavit Amasra Ultima Klozet Kapağı yavaş kapanma özelliği sayesinde sessiz ve  nazikçe kapanır. Ani çarpmaları ve gürültüyü engelleyerek rahatlatıcı bir banyo deneyiminin tadını çıkarmanıza yardımcı olur.</p>"
  },
  {
    "id": "creavit-9587421774121",
    "brand": "Creavit",
    "title": "Elegant Duroplast Yavaş Kapanan Klozet Kapağı Nil Yeşili",
    "category": "Duroplast Klozet Kapakları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-nil-yesili-6789.png?v=1747806052",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-nil-yesili-6789.png?v=1747806052",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-nil-yesili-6790.jpg?v=1747806052",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-nil-yesili-6791.jpg?v=1747806052"
    ],
    "price": "7434.00",
    "sku": "KC1103.01.2000E",
    "tags": [
      "duroplast",
      "elegant",
      "kapak",
      "Kare",
      "klozet kapağı",
      "Nil Yeşili",
      "tak-çıkar",
      "yavaş kapama",
      "yaz-25-indirim"
    ],
    "variants": [
      {
        "id": 52843266507049,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KC1103.01.2000E",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7434.00",
        "grams": 0,
        "compare_at_price": "10620.00",
        "position": 1,
        "product_id": 9587421774121,
        "created_at": "2026-03-17T13:11:38+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<p><strong>Pratik Kullanım:</strong> Tek hareket ile zorlanmadan çıkartılabilen tak-çıkar kapak özellikli Creavit klozet kapakları ile temizlik sırasında tüm yüzeyler kolayca temizlenir. </p>\r\n<p><span><strong>Antibakteriyel Malzeme: </strong>Antibakteriyel Duroplast malzeme ile klozet kapağı üzerinde bakteri ve mikropların üremesi önlenerek banyonuzun daha hijyenik ve temiz olması sağlanır. Amasra Ultima Duroplast Yavaş Kapanan Klozet Kapağı ile uzun ömürlü kullanım ve kolay temizlik elde edeceksiniz.</span></p>\r\n<p><strong>Yavaş Kapanan Kapak:</strong> Creavit Amasra Ultima Klozet Kapağı yavaş kapanma özelliği sayesinde sessiz ve  nazikçe kapanır. Ani çarpmaları ve gürültüyü engelleyerek rahatlatıcı bir banyo deneyiminin tadını çıkarmanıza yardımcı olur.</p>"
  },
  {
    "id": "creavit-9589578563881",
    "brand": "Creavit",
    "title": "Çubuk Led Aplik 50cm Beyaz",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-colorit-2_a468cfa6-614c-4a0d-9636-81a0c1e2cadf.png?v=1747918400",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-colorit-2_a468cfa6-614c-4a0d-9636-81a0c1e2cadf.png?v=1747918400"
    ],
    "price": "7177.50",
    "sku": "MA.AP45002",
    "tags": [
      "Ayna",
      "ayna aksesuarı",
      "banyo aksesuarı",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "Beyaz",
      "Colorit"
    ],
    "variants": [
      {
        "id": 52843202904361,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.AP45002",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "7177.50",
        "grams": 0,
        "compare_at_price": "9570.00",
        "position": 1,
        "product_id": 9589578563881,
        "created_at": "2026-03-17T12:51:57+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"page\" title=\"Page 177\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div class=\"page\" title=\"Page 177\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div class=\"page\" title=\"Page 177\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div class=\"page\" title=\"Page 177\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div class=\"page\" title=\"Page 178\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Yeni banyonun yenilikçi tasarımı</strong></p>\n<p>Zamansız tasarım çizgisi ile minimal ölçülerde elegant bir banyo deneyimi sunan Colorit; solid tezgah ve lake kaplama yapısı ile uzun yıllar rahatlıkla kullanabileceğiniz sağlamlıkta yaratıldı. Colorit farklı lavabo seçenekleri, ideal ölçüdeki saklama alanları ile kusursuz bir mekan kurgusu kişisel banyo deneyimi için yaratıldı.</p>\n<p><strong>Hangisi Daha Konforlu?</strong></p>\n<p>Banyo malzemeleriniz için ideal bir düzen kurgulamayı amaçlayan Colorit, çekmeceli ve kapaklı seçenekleri ve konfor özellikleri opsiyonuyla kişisel banyo deneyimizi üst seviyeye çıkarıyor. Colorit oval aynası ile banyonuza ve kendinize geniş bir perspektiften bakmanızı sağlıyor.<meta charset=\"utf-8\"><strong></strong></p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9589577908521",
    "brand": "Creavit",
    "title": "Çubuk Led Aplik 50cm Siyah",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-led-aplik-siyah.png?v=1757340247",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-led-aplik-siyah.png?v=1757340247",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-oval-ayna-40x80-cm-berry-7036.png?v=1757340247"
    ],
    "price": "7177.50",
    "sku": "MA.AP45001",
    "tags": [
      "Ayna",
      "ayna aksesuarı",
      "banyo aksesuarı",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "Colorit",
      "siyah"
    ],
    "variants": [
      {
        "id": 52843202773289,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.AP45001",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "7177.50",
        "grams": 0,
        "compare_at_price": "9570.00",
        "position": 1,
        "product_id": 9589577908521,
        "created_at": "2026-03-17T12:51:54+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"page\" title=\"Page 177\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div class=\"page\" title=\"Page 177\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div class=\"page\" title=\"Page 177\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div class=\"page\" title=\"Page 177\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div class=\"page\" title=\"Page 178\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Yeni banyonun yenilikçi tasarımı</strong></p>\n<p>Zamansız tasarım çizgisi ile minimal ölçülerde elegant bir banyo deneyimi sunan Colorit; solid tezgah ve lake kaplama yapısı ile uzun yıllar rahatlıkla kullanabileceğiniz sağlamlıkta yaratıldı. Colorit farklı lavabo seçenekleri, ideal ölçüdeki saklama alanları ile kusursuz bir mekan kurgusu kişisel banyo deneyimi için yaratıldı.</p>\n<p><strong>Hangisi Daha Konforlu?</strong></p>\n<p>Banyo malzemeleriniz için ideal bir düzen kurgulamayı amaçlayan Colorit, çekmeceli ve kapaklı seçenekleri ve konfor özellikleri opsiyonuyla kişisel banyo deneyimizi üst seviyeye çıkarıyor. Colorit oval aynası ile banyonuza ve kendinize geniş bir perspektiften bakmanızı sağlıyor.<meta charset=\"utf-8\"><strong></strong></p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9590411198761",
    "brand": "Creavit",
    "title": "Patara Lavabo Dolabı 60 cm Mat Beyaz",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT0060.42.MBY.jpg?v=1756816528",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT0060.42.MBY.jpg?v=1756816528",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-patara-banyo-mobilyasi-beyaz.png?v=1756816528",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/patara-lavabo-dolabi-60-cm-mat-beyaz-7098.png?v=1756816528",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-patara-4_e424ebd3-7c58-4246-96de-197719627d06.png?v=1756816528"
    ],
    "price": "27555.00",
    "sku": "PT0060.42.MBY",
    "tags": [
      "Banyo Mobilyası",
      "Lavabo Dolabı",
      "Mat Beyaz",
      "Patara",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843206869289,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "PT0060.42.MBY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "27555.00",
        "grams": 0,
        "compare_at_price": "36740.00",
        "position": 1,
        "product_id": 9590411198761,
        "created_at": "2026-03-17T12:52:49+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 178\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p>Zarif tasarımı ve fonksiyonelliği bir araya getiren Patara banyo mobilyaları, masif kulpları ve ayaklı yapısıyla şıklığı ön plana çıkarıyor. LED aynası banyolara modern bir dokunuş katarken, kullanım konforunuz artacak. Geniş depolama alanı, banyo malzemelerinizi düzenli bir şekilde saklamanızı sağlarken, kaliteli malzemesi uzun ömürlü bir kullanım sunar. Creavit Patara serisi estetik ve pratik çözümler arayanlar için idealdir!</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9590436954409",
    "brand": "Creavit",
    "title": "Patara Dikdörgen Led Ayna 55x75cm Mat Beyaz",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-patara-dikdortgen-led-ayna-beyaz.png?v=1748175714",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-patara-dikdortgen-led-ayna-beyaz.png?v=1748175714",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/patara-dikdorgen-led-ayna-55x75cm-mat-beyaz-7110.png?v=1748175714"
    ],
    "price": "19717.50",
    "sku": "PT4055.01.MBY",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "Mat Beyaz",
      "Patara"
    ],
    "variants": [
      {
        "id": 52843207688489,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "PT4055.01.MBY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "19717.50",
        "grams": 0,
        "compare_at_price": "26290.00",
        "position": 1,
        "product_id": 9590436954409,
        "created_at": "2026-03-17T12:53:02+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 178\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p>Zarif tasarımı ve fonksiyonelliği bir araya getiren Patara banyo mobilyaları, masif kulpları ve ayaklı yapısıyla şıklığı ön plana çıkarıyor. LED aynası banyolara modern bir dokunuş katarken, kullanım konforunuz artacak. Geniş depolama alanı, banyo malzemelerinizi düzenli bir şekilde saklamanızı sağlarken, kaliteli malzemesi uzun ömürlü bir kullanım sunar. Creavit Patara serisi estetik ve pratik çözümler arayanlar için idealdir!</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9590502064425",
    "brand": "Creavit",
    "title": "Patara Yuvarlak Led Ayna 85cm Mat Beyaz",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT.4060.02.MBY_ed956158-4910-467c-be9e-14bc132ba92c.jpg?v=1756816957",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT.4060.02.MBY_ed956158-4910-467c-be9e-14bc132ba92c.jpg?v=1756816957",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/patara-yuvarlak-led-ayna-85cm-mat-beyaz-7115.png?v=1756816957",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-patara-beyaz-banyo-mobilyasi_272cfef1-49fb-43ce-8916-a4c6587de929.png?v=1756816957",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/patara-yuvarlak-led-ayna-85cm-mat-beyaz-7114.png?v=1756816957"
    ],
    "price": "27720.00",
    "sku": "PT4085.02.MBY",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "Mat Beyaz",
      "Patara"
    ],
    "variants": [
      {
        "id": 52843208114473,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "PT4085.02.MBY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "27720.00",
        "grams": 0,
        "compare_at_price": "36960.00",
        "position": 1,
        "product_id": 9590502064425,
        "created_at": "2026-03-17T12:53:12+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 178\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p>Zarif tasarımı ve fonksiyonelliği bir araya getiren Patara banyo mobilyaları, masif kulpları ve ayaklı yapısıyla şıklığı ön plana çıkarıyor. LED aynası banyolara modern bir dokunuş katarken, kullanım konforunuz artacak. Geniş depolama alanı, banyo malzemelerinizi düzenli bir şekilde saklamanızı sağlarken, kaliteli malzemesi uzun ömürlü bir kullanım sunar. Creavit Patara serisi estetik ve pratik çözümler arayanlar için idealdir!</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9590727082281",
    "brand": "Creavit",
    "title": "Patara Boy Dolabı 147 cm Mat Beyaz",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT2147.01.MBY.jpg?v=1756816016",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT2147.01.MBY.jpg?v=1756816016",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-patara-boy-dolabi-beyaz.png?v=1756816016",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-patara-beyaz-banyo-mobilyasi.png?v=1756816016",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-patara-3.png?v=1756816016",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-patara-2_d1eb2930-9572-4e50-8883-b0bf61787f04.png?v=1756816016",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-patara-5.png?v=1756816016",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-patara-4_b1028e8d-6d93-418e-a64f-9740902e2c8b.png?v=1756816016"
    ],
    "price": "18232.50",
    "sku": "PT2147.01.MBY",
    "tags": [
      "Banyo Mobilyası",
      "boy dolabı",
      "Mat Beyaz",
      "Patara"
    ],
    "variants": [
      {
        "id": 52843232854313,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "PT2147.01.MBY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "18232.50",
        "grams": 0,
        "compare_at_price": "24310.00",
        "position": 1,
        "product_id": 9590727082281,
        "created_at": "2026-03-17T13:00:52+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 178\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p>Zarif tasarımı ve fonksiyonelliği bir araya getiren Patara banyo mobilyaları, masif kulpları ve ayaklı yapısıyla şıklığı ön plana çıkarıyor. LED aynası banyolara modern bir dokunuş katarken, kullanım konforunuz artacak. Geniş depolama alanı, banyo malzemelerinizi düzenli bir şekilde saklamanızı sağlarken, kaliteli malzemesi uzun ömürlü bir kullanım sunar. Creavit Patara serisi estetik ve pratik çözümler arayanlar için idealdir!</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9590429974825",
    "brand": "Creavit",
    "title": "Patara Lavabo Dolabı 100cm Mat Cappuccino",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT0100.42.MCP.jpg?v=1756816377",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT0100.42.MCP.jpg?v=1756816377",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-patara-cappuccino_f52d502f-5d87-4dd5-9f98-9dc21dce5ccf.png?v=1756816377",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/patara-lavabo-dolabi-100cm-mat-cappuccino-7105.png?v=1756816377",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-patara-4_93698be9-7c4f-46f5-afcd-7c72a3a4e751.png?v=1756816377"
    ],
    "price": "35227.50",
    "sku": "PT0100.42.MCP",
    "tags": [
      "Banyo Mobilyası",
      "Lavabo Dolabı",
      "Mat Cappuccino",
      "Patara",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843260805417,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "PT0100.42.MCP",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "35227.50",
        "grams": 0,
        "compare_at_price": "46970.00",
        "position": 1,
        "product_id": 9590429974825,
        "created_at": "2026-03-17T13:09:49+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Zarif tasarımı ve fonksiyonelliği bir araya getiren Patara banyo mobilyaları, masif kulpları ve ayaklı yapısıyla şıklığı ön plana çıkarıyor. LED aynası banyolara modern bir dokunuş katarken, kullanım konforunuz artacak. Geniş depolama alanı, banyo malzemelerinizi düzenli bir şekilde saklamanızı sağlarken, kaliteli malzemesi uzun ömürlü bir kullanım sunar. Creavit Patara serisi estetik ve pratik çözümler arayanlar için idealdir!</p>"
  },
  {
    "id": "creavit-9590607479081",
    "brand": "Creavit",
    "title": "Patara Yuvarlak Led Ayna 60 cm Mat Cappuccino",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT4060.02.MCP.jpg?v=1756816929",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT4060.02.MCP.jpg?v=1756816929",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-patara-cappuccino.png?v=1756816929"
    ],
    "price": "21120.00",
    "sku": "PT4060.02.MCP",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "Mat Cappuccino",
      "Patara"
    ],
    "variants": [
      {
        "id": 52843208311081,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "PT4060.02.MCP",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "21120.00",
        "grams": 0,
        "compare_at_price": "28160.00",
        "position": 1,
        "product_id": 9590607479081,
        "created_at": "2026-03-17T12:53:15+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Zarif tasarımı ve fonksiyonelliği bir araya getiren Patara banyo mobilyaları, masif kulpları ve ayaklı yapısıyla şıklığı ön plana çıkarıyor. LED aynası banyolara modern bir dokunuş katarken, kullanım konforunuz artacak. Geniş depolama alanı, banyo malzemelerinizi düzenli bir şekilde saklamanızı sağlarken, kaliteli malzemesi uzun ömürlü bir kullanım sunar. Creavit Patara serisi estetik ve pratik çözümler arayanlar için idealdir!</p>"
  },
  {
    "id": "creavit-9590439117097",
    "brand": "Creavit",
    "title": "Patara Dikdörgen Led Ayna 55 x 75 cm Mat Cappuccino",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-patara-dikdortgen-led-ayna-cappuccino.png?v=1748175542",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-patara-dikdortgen-led-ayna-cappuccino.png?v=1748175542",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/patara-dikdorgen-led-ayna-55-x-75-cm-mat-cappuccino-7111.png?v=1748175542"
    ],
    "price": "19717.50",
    "sku": "PT4055.01.MCP",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "Mat Cappuccino",
      "Patara"
    ],
    "variants": [
      {
        "id": 52843207819561,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "PT4055.01.MCP",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "19717.50",
        "grams": 0,
        "compare_at_price": "26290.00",
        "position": 1,
        "product_id": 9590439117097,
        "created_at": "2026-03-17T12:53:05+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Zarif tasarımı ve fonksiyonelliği bir araya getiren Patara banyo mobilyaları, masif kulpları ve ayaklı yapısıyla şıklığı ön plana çıkarıyor. LED aynası banyolara modern bir dokunuş katarken, kullanım konforunuz artacak. Geniş depolama alanı, banyo malzemelerinizi düzenli bir şekilde saklamanızı sağlarken, kaliteli malzemesi uzun ömürlü bir kullanım sunar. Creavit Patara serisi estetik ve pratik çözümler arayanlar için idealdir!</p>"
  },
  {
    "id": "creavit-9590417260841",
    "brand": "Creavit",
    "title": "Patara Lavabo Dolabı 60 cm Mat Cappuccino",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT0060.42.MCP.jpg?v=1756816499",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT0060.42.MCP.jpg?v=1756816499",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-patara-banyo-mobilyasi-cappuccino.png?v=1756816499",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/Artboard4.png?v=1756816499",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/patara-lavabo-dolabi-60-cm-mat-cappuccino-7099.png?v=1756816499",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-patara-4_c565e394-b76f-4006-bc70-862f607b26b0.png?v=1756816499"
    ],
    "price": "27555.00",
    "sku": "PT0060.42.MCP",
    "tags": [
      "Banyo Mobilyası",
      "Lavabo Dolabı",
      "Mat Cappuccino",
      "Patara",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843207131433,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "PT0060.42.MCP",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "27555.00",
        "grams": 0,
        "compare_at_price": "36740.00",
        "position": 1,
        "product_id": 9590417260841,
        "created_at": "2026-03-17T12:52:53+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Zarif tasarımı ve fonksiyonelliği bir araya getiren Patara banyo mobilyaları, masif kulpları ve ayaklı yapısıyla şıklığı ön plana çıkarıyor. LED aynası banyolara modern bir dokunuş katarken, kullanım konforunuz artacak. Geniş depolama alanı, banyo malzemelerinizi düzenli bir şekilde saklamanızı sağlarken, kaliteli malzemesi uzun ömürlü bir kullanım sunar. Creavit Patara serisi estetik ve pratik çözümler arayanlar için idealdir!</p>"
  },
  {
    "id": "creavit-9590667706665",
    "brand": "Creavit",
    "title": "Patara Yuvarlak Led Ayna 85cm Mat Cappuccino",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT4085.02.MCP.jpg?v=1756816690",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT4085.02.MCP.jpg?v=1756816690",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-patara-boy-dolabi-cappuccino.png?v=1756816690",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/patara-yuvarlak-led-ayna-85cm-mat-cappuccino-7120.png?v=1756816690"
    ],
    "price": "27720.00",
    "sku": "PT4085.02.MCP",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "Mat Cappuccino",
      "Patara"
    ],
    "variants": [
      {
        "id": 52843210375465,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "PT4085.02.MCP",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "27720.00",
        "grams": 0,
        "compare_at_price": "36960.00",
        "position": 1,
        "product_id": 9590667706665,
        "created_at": "2026-03-17T12:53:49+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Zarif tasarımı ve fonksiyonelliği bir araya getiren Patara banyo mobilyaları, masif kulpları ve ayaklı yapısıyla şıklığı ön plana çıkarıyor. LED aynası banyolara modern bir dokunuş katarken, kullanım konforunuz artacak. Geniş depolama alanı, banyo malzemelerinizi düzenli bir şekilde saklamanızı sağlarken, kaliteli malzemesi uzun ömürlü bir kullanım sunar. Creavit Patara serisi estetik ve pratik çözümler arayanlar için idealdir!</p>"
  },
  {
    "id": "creavit-9590733439273",
    "brand": "Creavit",
    "title": "Patara Boy Dolabı 147cm Mat Cappuccino",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT2147.01.MCP.jpg?v=1756815956",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT2147.01.MCP.jpg?v=1756815956",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/Artboard3_96923282-7300-4076-90e2-bb343d45c837.png?v=1756815956",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-patara-2_c27b6cf1-af6c-41bc-a6ef-f28c0dde10c1.png?v=1756815956",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-patara-4_ec77075d-2b69-433f-a5cc-28da64dc0874.png?v=1756815956"
    ],
    "price": "18232.50",
    "sku": "PT2147.01.MCP",
    "tags": [
      "Banyo Mobilyası",
      "boy dolabı",
      "Mat Cappuccino",
      "Patara"
    ],
    "variants": [
      {
        "id": 52843210866985,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "PT2147.01.MCP",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "18232.50",
        "grams": 0,
        "compare_at_price": "24310.00",
        "position": 1,
        "product_id": 9590733439273,
        "created_at": "2026-03-17T12:53:56+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Zarif tasarımı ve fonksiyonelliği bir araya getiren Patara banyo mobilyaları, masif kulpları ve ayaklı yapısıyla şıklığı ön plana çıkarıyor. LED aynası banyolara modern bir dokunuş katarken, kullanım konforunuz artacak. Geniş depolama alanı, banyo malzemelerinizi düzenli bir şekilde saklamanızı sağlarken, kaliteli malzemesi uzun ömürlü bir kullanım sunar. Creavit Patara serisi estetik ve pratik çözümler arayanlar için idealdir!</p>"
  },
  {
    "id": "creavit-9590420603177",
    "brand": "Creavit",
    "title": "Patara Lavabo Dolabı 60cm Mat Yeşil",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT0060.42.MYE.jpg?v=1756816473",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT0060.42.MYE.jpg?v=1756816473",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/med-PT0060.42PT2147.01PT4055.01-1.jpg?v=1756816473",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/patara-lavabo-dolabi-60cm-mat-yesil-7101.png?v=1756816473"
    ],
    "price": "27555.00",
    "sku": "PT0060.42.MYE",
    "tags": [
      "Banyo Mobilyası",
      "Lavabo Dolabı",
      "Mat Yeşil",
      "Patara",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843207393577,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "PT0060.42.MYE",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "27555.00",
        "grams": 0,
        "compare_at_price": "36740.00",
        "position": 1,
        "product_id": 9590420603177,
        "created_at": "2026-03-17T12:52:56+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><meta charset=\"utf-8\">Zarif tasarımı ve fonksiyonelliği bir araya getiren Patara banyo mobilyaları, masif kulpları ve ayaklı yapısıyla şıklığı ön plana çıkarıyor. LED aynası banyolara modern bir dokunuş katarken, kullanım konforunuz artacak. Geniş depolama alanı, banyo malzemelerinizi düzenli bir şekilde saklamanızı sağlarken, kaliteli malzemesi uzun ömürlü bir kullanım sunar. Creavit Patara serisi estetik ve pratik çözümler arayanlar için idealdir!</p>"
  },
  {
    "id": "creavit-9590433808681",
    "brand": "Creavit",
    "title": "Patara Lavabo Dolabı 100cm Mat Yeşil",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT0100.42.MYE.jpg?v=1756816216",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT0100.42.MYE.jpg?v=1756816216",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-patara-boy-dolabi-yesil_24ef0599-6ab3-4067-b138-bdc236c0f7af.png?v=1756816216",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-patara_bf4c19fa-bb13-4bc9-a249-1c83f3bb491c.png?v=1756816216",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/patara-lavabo-dolabi-100cm-mat-yesil-7107.png?v=1756816216",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-patara-4_cbd2cf2b-b585-4675-8820-de8b5e97a329.png?v=1756816216"
    ],
    "price": "35227.50",
    "sku": "PT0100.42.MYE",
    "tags": [
      "Banyo Mobilyası",
      "Lavabo Dolabı",
      "Mat Yeşil",
      "Patara",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52921491194153,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "PT0100.42.MYE",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "35227.50",
        "grams": 0,
        "compare_at_price": "46970.00",
        "position": 1,
        "product_id": 9590433808681,
        "created_at": "2026-04-03T14:46:00+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><meta charset=\"utf-8\">Zarif tasarımı ve fonksiyonelliği bir araya getiren Patara banyo mobilyaları, masif kulpları ve ayaklı yapısıyla şıklığı ön plana çıkarıyor. LED aynası banyolara modern bir dokunuş katarken, kullanım konforunuz artacak. Geniş depolama alanı, banyo malzemelerinizi düzenli bir şekilde saklamanızı sağlarken, kaliteli malzemesi uzun ömürlü bir kullanım sunar. Creavit Patara serisi estetik ve pratik çözümler arayanlar için idealdir!</p>"
  },
  {
    "id": "creavit-9590486139177",
    "brand": "Creavit",
    "title": "Patara Dikdörgen Led Ayna 55x75cm Mat Yeşil",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT4085.01.MYE.jpg?v=1756816990",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT4085.01.MYE.jpg?v=1756816990",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-patara-banyo-mobilyasi-yesil.png?v=1756816990",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/patara-dikdorgen-led-ayna-55x75cm-mat-yesil-7113.png?v=1756816990"
    ],
    "price": "19717.50",
    "sku": "PT4055.01.MYE",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "Mat Yeşil",
      "Patara"
    ],
    "variants": [
      {
        "id": 52843207950633,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "PT4055.01.MYE",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "19717.50",
        "grams": 0,
        "compare_at_price": "26290.00",
        "position": 1,
        "product_id": 9590486139177,
        "created_at": "2026-03-17T12:53:09+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><meta charset=\"utf-8\">Zarif tasarımı ve fonksiyonelliği bir araya getiren Patara banyo mobilyaları, masif kulpları ve ayaklı yapısıyla şıklığı ön plana çıkarıyor. LED aynası banyolara modern bir dokunuş katarken, kullanım konforunuz artacak. Geniş depolama alanı, banyo malzemelerinizi düzenli bir şekilde saklamanızı sağlarken, kaliteli malzemesi uzun ömürlü bir kullanım sunar. Creavit Patara serisi estetik ve pratik çözümler arayanlar için idealdir!</p>"
  },
  {
    "id": "creavit-9590621241641",
    "brand": "Creavit",
    "title": "Patara Yuvarlak Led Ayna 60cm Mat Yeşil",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT4060.02.MYE.jpg?v=1756816893",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT4060.02.MYE.jpg?v=1756816893",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-patara-boy-dolabi-yesil_1c00f6f1-026b-4c02-8ff2-99984087d8b1.png?v=1756816893"
    ],
    "price": "21120.00",
    "sku": "PT4060.02.MYE",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "Mat Yeşil",
      "Patara"
    ],
    "variants": [
      {
        "id": 52843208442153,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "PT4060.02.MYE",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "21120.00",
        "grams": 0,
        "compare_at_price": "28160.00",
        "position": 1,
        "product_id": 9590621241641,
        "created_at": "2026-03-17T12:53:18+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><meta charset=\"utf-8\">Zarif tasarımı ve fonksiyonelliği bir araya getiren Patara banyo mobilyaları, masif kulpları ve ayaklı yapısıyla şıklığı ön plana çıkarıyor. LED aynası banyolara modern bir dokunuş katarken, kullanım konforunuz artacak. Geniş depolama alanı, banyo malzemelerinizi düzenli bir şekilde saklamanızı sağlarken, kaliteli malzemesi uzun ömürlü bir kullanım sunar. Creavit Patara serisi estetik ve pratik çözümler arayanlar için idealdir!</p>"
  },
  {
    "id": "creavit-9590721577257",
    "brand": "Creavit",
    "title": "Patara Yuvarlak Led Ayna 85cm Mat Yeşil",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT4085.02.MYE.jpg?v=1756816644",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT4085.02.MYE.jpg?v=1756816644",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-patara_87abe3c1-2508-4e00-8f98-892c16692ccd.png?v=1756816644",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/patara-yuvarlak-led-ayna-85cm-mat-yesil-7121.png?v=1756816644"
    ],
    "price": "27720.00",
    "sku": "PT4085.02.MYE",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "Mat Yeşil",
      "Patara"
    ],
    "variants": [
      {
        "id": 52843210604841,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "PT4085.02.MYE",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "27720.00",
        "grams": 0,
        "compare_at_price": "36960.00",
        "position": 1,
        "product_id": 9590721577257,
        "created_at": "2026-03-17T12:53:53+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><meta charset=\"utf-8\">Zarif tasarımı ve fonksiyonelliği bir araya getiren Patara banyo mobilyaları, masif kulpları ve ayaklı yapısıyla şıklığı ön plana çıkarıyor. LED aynası banyolara modern bir dokunuş katarken, kullanım konforunuz artacak. Geniş depolama alanı, banyo malzemelerinizi düzenli bir şekilde saklamanızı sağlarken, kaliteli malzemesi uzun ömürlü bir kullanım sunar. Creavit Patara serisi estetik ve pratik çözümler arayanlar için idealdir!</p>"
  },
  {
    "id": "creavit-9590736257321",
    "brand": "Creavit",
    "title": "Patara Boy Dolabı 147 cm Mat Yeşil",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT2147.01.MYE.jpg?v=1756815913",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT2147.01.MYE.jpg?v=1756815913",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-patara-boy-dolabi-yesil.png?v=1756815913",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-patara.png?v=1756815913",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-patara-2.png?v=1756815913",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/patara-boy-dolabi-147-cm-mat-yesil-7127.png?v=1756815913",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-patara-4.png?v=1756815913"
    ],
    "price": "18232.50",
    "sku": "PT2147.01.MYE",
    "tags": [
      "Banyo Mobilyası",
      "boy dolabı",
      "Mat Yeşil",
      "Patara"
    ],
    "variants": [
      {
        "id": 52843236983081,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "PT2147.01.MYE",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "18232.50",
        "grams": 0,
        "compare_at_price": "24310.00",
        "position": 1,
        "product_id": 9590736257321,
        "created_at": "2026-03-17T13:02:27+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><meta charset=\"utf-8\">Zarif tasarımı ve fonksiyonelliği bir araya getiren Patara banyo mobilyaları, masif kulpları ve ayaklı yapısıyla şıklığı ön plana çıkarıyor. LED aynası banyolara modern bir dokunuş katarken, kullanım konforunuz artacak. Geniş depolama alanı, banyo malzemelerinizi düzenli bir şekilde saklamanızı sağlarken, kaliteli malzemesi uzun ömürlü bir kullanım sunar. Creavit Patara serisi estetik ve pratik çözümler arayanlar için idealdir!</p>"
  },
  {
    "id": "creavit-9589580136745",
    "brand": "Creavit",
    "title": "Arya Lavabo Dolabı 70 cm Siyah",
    "category": "Kapaksız Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-arya-siyah-kapaksiz-lavabo-doalbi-banyo-mobilyasi.png?v=1748176792",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-arya-siyah-kapaksiz-lavabo-doalbi-banyo-mobilyasi.png?v=1748176792",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-arya-2_81581bcc-7112-4aab-b2eb-9f86caae8490.png?v=1748176792",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arya-lavabo-dolabi-70-cm-siyah-7082.png?v=1748176792",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arya-lavabo-dolabi-70-cm-siyah-7079.png?v=1748176792",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-arya-1_675578cc-a4b5-46b6-b546-4a3bc18c072c.png?v=1748176790"
    ],
    "price": "17280.00",
    "sku": "AR065-M1",
    "tags": [
      "Arya",
      "Banyo Mobilyası",
      "Kapaksız Lavabo Dolabı",
      "Lavabo Dolabı",
      "siyah"
    ],
    "variants": [
      {
        "id": 52921490932009,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "AR065-M1",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "17280.00",
        "grams": 0,
        "compare_at_price": "23040.00",
        "position": 1,
        "product_id": 9589580136745,
        "created_at": "2026-04-03T14:45:57+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-start=\"0\" data-end=\"236\" class=\"\">Arya Lavabo Dolabı ile şıklık ve işlevselliği bir araya getirin! Siyah rengin zamansız karizmasıyla banyonuza modern bir dokunuş katarken, açık depolama alanı sayesinde tüm aksesuarlarınızı düzenli bir şekilde sergileyebilirsiniz.</p>\n<p data-start=\"238\" data-end=\"525\" class=\"\">Akıllı tasarımı, en küçük eşyalarınızı bile kolayca bulmanızı ve onlara hızlıca erişmenizi sağlar. Lavabo yanı ızgaralı tezgah diş fırçalarınız, sabunluk ve diğer günlük ihtiyaçlarınız için kullanışlı alan sunar.</p>"
  },
  {
    "id": "creavit-9589583216937",
    "brand": "Creavit",
    "title": "Arya Ayna 65 cm Siyah",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-arya-siyah-ayna.png?v=1747918507",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-arya-siyah-ayna.png?v=1747918507",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-arya-4.png?v=1747918564",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arya-ayna-65-cm-siyah-7085.png?v=1747918564",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-arya-1.png?v=1747918564"
    ],
    "price": "13200.00",
    "sku": "AR065-A.SS",
    "tags": [
      "Arya",
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "siyah"
    ],
    "variants": [
      {
        "id": 52843203035433,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "AR065-A.SS",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "13200.00",
        "grams": 0,
        "compare_at_price": "17600.00",
        "position": 1,
        "product_id": 9589583216937,
        "created_at": "2026-03-17T12:52:00+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-start=\"0\" data-end=\"236\" class=\"\">Arya Lavabo Dolabı ile şıklık ve işlevselliği bir araya getirin! Siyah rengin zamansız karizmasıyla banyonuza modern bir dokunuş katarken, açık depolama alanı sayesinde tüm aksesuarlarınızı düzenli bir şekilde sergileyebilirsiniz.</p>\n<p data-start=\"238\" data-end=\"525\" class=\"\">Akıllı tasarımı, en küçük eşyalarınızı bile kolayca bulmanızı ve onlara hızlıca erişmenizi sağlar. Lavabo yanı ızgaralı tezgah diş fırçalarınız, sabunluk ve diğer günlük ihtiyaçlarınız için kullanışlı alan sunar.</p>"
  },
  {
    "id": "creavit-9589560181033",
    "brand": "Creavit",
    "title": "Colorit Kapaklı Lavabo Dolabı 60 cm Ocean",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-lavabo-dolabi-banyo-mobilyasi-ocean_b62d8ca0-c033-4144-a05a-d83df3c7f2fc.png?v=1747920903",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-lavabo-dolabi-banyo-mobilyasi-ocean_b62d8ca0-c033-4144-a05a-d83df3c7f2fc.png?v=1747920903",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-colorit-3copy_9c116a04-7e6a-4213-b2dd-a9de4fc40b46.png?v=1747920903",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-colorit-5_a0334376-5a76-4033-a47a-be5e8ff3c3ce.png?v=1747920903",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-kapakli-lavabo-dolabi-60-cm-ocean-7003.png?v=1747920903",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-colorit-8_0fe86e40-dbe4-4282-a685-48fdf935fb0b.png?v=1747920903"
    ],
    "price": "26977.50",
    "sku": "CO0060.01.OCE",
    "tags": [
      "Banyo Mobilyası",
      "Colorit",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı",
      "ocean"
    ],
    "variants": [
      {
        "id": 52843201167657,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "CO0060.01.OCE",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "26977.50",
        "grams": 0,
        "compare_at_price": "35970.00",
        "position": 1,
        "product_id": 9589560181033,
        "created_at": "2026-03-17T12:51:17+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 178\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Yeni Banyonun Yenilikçi Tasarımı</strong></p>\n<p>Zamansız tasarım çizgisi ile minimal ölçülerde elegant bir banyo deneyimi sunan Colorit; solid tezgah ve lake kaplama yapısı ile uzun yıllar rahatlıkla kullanabileceğiniz sağlamlıkta yaratıldı. Colorit ideal ölçüdeki saklama alanları ile kusursuz bir mekan kurgusuyla kişisel banyo deneyimi için yaratıldı.</p>\n<p><strong>Hangisi Daha Konforlu?</strong></p>\n<p>Banyo malzemeleriniz için ideal bir düzen kurgulamayı amaçlayan Colorit, çekmeceli ve kapaklı seçenekleri ve konfor özellikleri opsiyonuyla kişisel banyo deneyimizi üst seviyeye çıkarıyor. Colorit oval aynası ile banyonuza ve kendinize geniş bir perspektiften bakmanızı sağlıyor.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9589556216105",
    "brand": "Creavit",
    "title": "Colorit Kapaklı Lavabo Dolabı 60 cm Cappuccino",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-lavabo-dolabi-banyo-mobilyasi-cappuccino_08036b5d-0810-4daf-846e-7d7f0a8ba692.png?v=1748163911",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-lavabo-dolabi-banyo-mobilyasi-cappuccino_08036b5d-0810-4daf-846e-7d7f0a8ba692.png?v=1748163911",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-colorit-1_8e910224-4fa0-4bea-97a4-e3ac429a23c9.png?v=1757247412",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-kapakli-lavabo-dolabi-60-cm-cappuccino-6994.png?v=1748163911",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-colorit-5_ba11ebb9-225c-4c56-b8a1-224c7556501a.png?v=1748163911",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-kapakli-lavabo-dolabi-60-cm-cappuccino-6992.png?v=1748163911"
    ],
    "price": "26977.50",
    "sku": "CO0060.01.MCP",
    "tags": [
      "Banyo Mobilyası",
      "Cappuccino",
      "Colorit",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52843201036585,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "CO0060.01.MCP",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "26977.50",
        "grams": 0,
        "compare_at_price": "35970.00",
        "position": 1,
        "product_id": 9589556216105,
        "created_at": "2026-03-17T12:51:13+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 178\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Yeni Banyonun Yenilikçi Tasarımı</strong></p>\n<p>Zamansız tasarım çizgisi ile minimal ölçülerde elegant bir banyo deneyimi sunan Colorit; solid tezgah ve lake kaplama yapısı ile uzun yıllar rahatlıkla kullanabileceğiniz sağlamlıkta yaratıldı. Colorit ideal ölçüdeki saklama alanları ile kusursuz bir mekan kurgusuyla kişisel banyo deneyimi için yaratıldı.</p>\n<p><strong>Hangisi Daha Konforlu?</strong></p>\n<p>Banyo malzemeleriniz için ideal bir düzen kurgulamayı amaçlayan Colorit, çekmeceli ve kapaklı seçenekleri ve konfor özellikleri opsiyonuyla kişisel banyo deneyimizi üst seviyeye çıkarıyor. Colorit oval aynası ile banyonuza ve kendinize geniş bir perspektiften bakmanızı sağlıyor.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9589572174121",
    "brand": "Creavit",
    "title": "Colorit Oval Ayna 40x80 cm Cappuccino",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-oval-ayna-cappuccino.png?v=1747918599",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-oval-ayna-cappuccino.png?v=1747918599",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-oval-ayna-40x80-cm-cappuccino-7039.png?v=1747918599",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-oval-ayna-40x80-cm-cappuccino-7041.png?v=1747918599",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-oval-ayna-40x80-cm-cappuccino-7042.png?v=1747918599"
    ],
    "price": "9405.00",
    "sku": "CO1040.00.MCP",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "Cappuccino",
      "Colorit"
    ],
    "variants": [
      {
        "id": 52843201921321,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "CO1040.00.MCP",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9405.00",
        "grams": 0,
        "compare_at_price": "12540.00",
        "position": 1,
        "product_id": 9589572174121,
        "created_at": "2026-03-17T12:51:36+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 178\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Yeni Banyonun Yenilikçi Tasarımı</strong></p>\n<p>Zamansız tasarım çizgisi ile minimal ölçülerde elegant bir banyo deneyimi sunan Colorit; solid tezgah ve lake kaplama yapısı ile uzun yıllar rahatlıkla kullanabileceğiniz sağlamlıkta yaratıldı. Colorit ideal ölçüdeki saklama alanları ile kusursuz bir mekan kurgusuyla kişisel banyo deneyimi için yaratıldı.</p>\n<p><strong>Hangisi Daha Konforlu?</strong></p>\n<p>Banyo malzemeleriniz için ideal bir düzen kurgulamayı amaçlayan Colorit, çekmeceli ve kapaklı seçenekleri ve konfor özellikleri opsiyonuyla kişisel banyo deneyimizi üst seviyeye çıkarıyor. Colorit oval aynası ile banyonuza ve kendinize geniş bir perspektiften bakmanızı sağlıyor.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9589559722281",
    "brand": "Creavit",
    "title": "Colorit Kapaklı Lavabo Dolabı 60 cm Nil Yeşili",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-lavabo-dolabi-banyo-mobilyasi-nil-yesili_e5a4ed80-9282-4cfe-9cbf-d12f039765ac.png?v=1747923298",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-lavabo-dolabi-banyo-mobilyasi-nil-yesili_e5a4ed80-9282-4cfe-9cbf-d12f039765ac.png?v=1747923298",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/2_b6f32950-575f-43b4-a93e-cc49e83fb030.png?v=1747923298",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-colorit-3_3e2702f4-5b8e-42e9-9b39-f33f9587f0d5.png?v=1747923298",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-colorit-5_d0fc9eb4-fa21-43f3-ac30-998d14121013.png?v=1748163794",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-kapakli-lavabo-dolabi-60-cm-nil-yesili-6997.png?v=1748163794"
    ],
    "price": "26977.50",
    "sku": "CO0060.01.NY",
    "tags": [
      "Banyo Mobilyası",
      "Colorit",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı",
      "Nil Yeşili"
    ],
    "variants": [
      {
        "id": 52843262673193,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "CO0060.01.NY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "26977.50",
        "grams": 0,
        "compare_at_price": "35970.00",
        "position": 1,
        "product_id": 9589559722281,
        "created_at": "2026-03-17T13:10:20+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 178\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Yeni Banyonun Yenilikçi Tasarımı</strong></p>\n<p>Zamansız tasarım çizgisi ile minimal ölçülerde elegant bir banyo deneyimi sunan Colorit; solid tezgah ve lake kaplama yapısı ile uzun yıllar rahatlıkla kullanabileceğiniz sağlamlıkta yaratıldı. Colorit ideal ölçüdeki saklama alanları ile kusursuz bir mekan kurgusuyla kişisel banyo deneyimi için yaratıldı.</p>\n<p><strong>Hangisi Daha Konforlu?</strong></p>\n<p>Banyo malzemeleriniz için ideal bir düzen kurgulamayı amaçlayan Colorit, çekmeceli ve kapaklı seçenekleri ve konfor özellikleri opsiyonuyla kişisel banyo deneyimizi üst seviyeye çıkarıyor. Colorit oval aynası ile banyonuza ve kendinize geniş bir perspektiften bakmanızı sağlıyor.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9589572927785",
    "brand": "Creavit",
    "title": "Colorit Oval Ayna 40x80 cm Nil Yeşili",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-oval-ayna-nil-yesili_35cf9a55-4650-43e6-bc0c-0604db3aa042.png?v=1747918297",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-oval-ayna-nil-yesili_35cf9a55-4650-43e6-bc0c-0604db3aa042.png?v=1747918297",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-oval-ayna-40x80-cm-nil-yesili-7043.png?v=1747918297",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-oval-ayna-40x80-cm-nil-yesili-7045.png?v=1747918297",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-oval-ayna-40x80-cm-nil-yesili-7046.png?v=1747918297"
    ],
    "price": "9405.00",
    "sku": "CO1040.00.NY",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "Colorit",
      "Nil Yeşili"
    ],
    "variants": [
      {
        "id": 52843202085161,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "CO1040.00.NY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9405.00",
        "grams": 0,
        "compare_at_price": "12540.00",
        "position": 1,
        "product_id": 9589572927785,
        "created_at": "2026-03-17T12:51:39+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 178\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Yeni Banyonun Yenilikçi Tasarımı</strong></p>\n<p>Zamansız tasarım çizgisi ile minimal ölçülerde elegant bir banyo deneyimi sunan Colorit; solid tezgah ve lake kaplama yapısı ile uzun yıllar rahatlıkla kullanabileceğiniz sağlamlıkta yaratıldı. Colorit ideal ölçüdeki saklama alanları ile kusursuz bir mekan kurgusuyla kişisel banyo deneyimi için yaratıldı.</p>\n<p><strong>Hangisi Daha Konforlu?</strong></p>\n<p>Banyo malzemeleriniz için ideal bir düzen kurgulamayı amaçlayan Colorit, çekmeceli ve kapaklı seçenekleri ve konfor özellikleri opsiyonuyla kişisel banyo deneyimizi üst seviyeye çıkarıyor. Colorit oval aynası ile banyonuza ve kendinize geniş bir perspektiften bakmanızı sağlıyor.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9589571748137",
    "brand": "Creavit",
    "title": "Colorit Oval Ayna 40x80 cm Berry",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-oval-ayna-berry.png?v=1747918634",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-oval-ayna-berry.png?v=1747918634",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-oval-ayna-40x80-cm-berry-7036.png?v=1757340247",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-oval-ayna-40x80-cm-berry-7038.png?v=1747918634",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-oval-ayna-40x80-cm-berry-7037.png?v=1747918634"
    ],
    "price": "9405.00",
    "sku": "CO1040.00.BE",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "Berry",
      "Colorit"
    ],
    "variants": [
      {
        "id": 52843201823017,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "CO1040.00.BE",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9405.00",
        "grams": 0,
        "compare_at_price": "12540.00",
        "position": 1,
        "product_id": 9589571748137,
        "created_at": "2026-03-17T12:51:33+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 178\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Yeni Banyonun Yenilikçi Tasarımı</strong></p>\n<p>Zamansız tasarım çizgisi ile minimal ölçülerde elegant bir banyo deneyimi sunan Colorit; solid tezgah ve lake kaplama yapısı ile uzun yıllar rahatlıkla kullanabileceğiniz sağlamlıkta yaratıldı. Colorit ideal ölçüdeki saklama alanları ile kusursuz bir mekan kurgusuyla kişisel banyo deneyimi için yaratıldı.</p>\n<p><strong>Hangisi Daha Konforlu?</strong></p>\n<p>Banyo malzemeleriniz için ideal bir düzen kurgulamayı amaçlayan Colorit, çekmeceli ve kapaklı seçenekleri ve konfor özellikleri opsiyonuyla kişisel banyo deneyimizi üst seviyeye çıkarıyor. Colorit oval aynası ile banyonuza ve kendinize geniş bir perspektiften bakmanızı sağlıyor.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9589513978153",
    "brand": "Creavit",
    "title": "Colorit Kapaklı Lavabo Dolabı 60 cm Berry",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-lavabo-dolabi-banyo-mobilyasi-berry_0885c3ed-f408-4afe-ae4c-63889c8ca217.png?v=1748164053",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-lavabo-dolabi-banyo-mobilyasi-berry_0885c3ed-f408-4afe-ae4c-63889c8ca217.png?v=1748164053",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-kapakli-lavabo-dolabi-60-cm-berry-6987.png?v=1757340865",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-colorit-8_7e80139a-8df2-4ce2-850e-56100c2f139a.png?v=1748164053",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-colorit-5_9b75cc59-d44a-4d7b-bc02-da1e0ade058f.png?v=1748164053",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-kapakli-lavabo-dolabi-60-cm-berry-6988.png?v=1748164053"
    ],
    "price": "26977.50",
    "sku": "CO0060.01.BE",
    "tags": [
      "Banyo Mobilyası",
      "Berry",
      "Colorit",
      "kapaklı lavabo dolabı",
      "Lake",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52843200905513,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "CO0060.01.BE",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "26977.50",
        "grams": 0,
        "compare_at_price": "35970.00",
        "position": 1,
        "product_id": 9589513978153,
        "created_at": "2026-03-17T12:51:10+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 178\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Yeni Banyonun Yenilikçi Tasarımı</strong></p>\n<p>Zamansız tasarım çizgisi ile minimal ölçülerde elegant bir banyo deneyimi sunan Colorit; solid tezgah ve lake kaplama yapısı ile uzun yıllar rahatlıkla kullanabileceğiniz sağlamlıkta yaratıldı. Colorit ideal ölçüdeki saklama alanları ile kusursuz bir mekan kurgusuyla kişisel banyo deneyimi için yaratıldı.</p>\n<p><strong>Hangisi Daha Konforlu?</strong></p>\n<p>Banyo malzemeleriniz için ideal bir düzen kurgulamayı amaçlayan Colorit, çekmeceli ve kapaklı seçenekleri ve konfor özellikleri opsiyonuyla kişisel banyo deneyimizi üst seviyeye çıkarıyor. Colorit oval aynası ile banyonuza ve kendinize geniş bir perspektiften bakmanızı sağlıyor.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9589563588905",
    "brand": "Creavit",
    "title": "Colorit Kapaklı Lavabo Dolabı 60 cm Şeftali Tüyü",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-lavabo-dolabi-banyo-mobilyasi-seftali-tuyu_851fed70-fe53-47b8-9c15-eee7bd44dcf6.png?v=1747920514",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-lavabo-dolabi-banyo-mobilyasi-seftali-tuyu_851fed70-fe53-47b8-9c15-eee7bd44dcf6.png?v=1747920514",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/3_a4212ff7-08dd-438e-83aa-149b3dc6d6dd.png?v=1747920514",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-kapakli-lavabo-dolabi-60-cm-seftali-tuyu-7005.png?v=1747920514",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-kapakli-lavabo-dolabi-60-cm-seftali-tuyu-7006.png?v=1747920514",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-colorit-5_2907390a-7866-4ad5-9c24-db6c753fce4d.png?v=1747920514",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-colorit-8_f73b8cf7-7cb0-4d4c-971d-9ce901d391d4.png?v=1747920514"
    ],
    "price": "26977.50",
    "sku": "CO0060.01.SFT",
    "tags": [
      "Banyo Mobilyası",
      "Colorit",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı",
      "Şeftali Tüyü"
    ],
    "variants": [
      {
        "id": 52843267260713,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "CO0060.01.SFT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "26977.50",
        "grams": 0,
        "compare_at_price": "35970.00",
        "position": 1,
        "product_id": 9589563588905,
        "created_at": "2026-03-17T13:11:51+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 178\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Yeni Banyonun Yenilikçi Tasarımı</strong></p>\n<p>Zamansız tasarım çizgisi ile minimal ölçülerde elegant bir banyo deneyimi sunan Colorit; solid tezgah ve lake kaplama yapısı ile uzun yıllar rahatlıkla kullanabileceğiniz sağlamlıkta yaratıldı. Colorit ideal ölçüdeki saklama alanları ile kusursuz bir mekan kurgusuyla kişisel banyo deneyimi için yaratıldı.</p>\n<p><strong>Hangisi Daha Konforlu?</strong></p>\n<p>Banyo malzemeleriniz için ideal bir düzen kurgulamayı amaçlayan Colorit, çekmeceli ve kapaklı seçenekleri ve konfor özellikleri opsiyonuyla kişisel banyo deneyimizi üst seviyeye çıkarıyor. Colorit oval aynası ile banyonuza ve kendinize geniş bir perspektiften bakmanızı sağlıyor.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9588587659561",
    "brand": "Creavit",
    "title": "Loop 45cm Masa Üstü Çanak Lavabo Extra Limon Çiçeği",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-limon-cicegi-6912.png?v=1747231072",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-limon-cicegi-6912.png?v=1747231072",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-limon-cicegi-6913.png?v=1747231075",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-limon-cicegi-6914.png?v=1747231078",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-limon-cicegi-6915.png?v=1747231081"
    ],
    "price": "9810.00",
    "sku": "LP146-00LC00E-0000",
    "tags": [
      "Lavabo",
      "Limon Çiçeği",
      "Loop",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843179082025,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP146-00LC00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9810.00",
        "grams": 0,
        "compare_at_price": "13080.00",
        "position": 1,
        "product_id": 9588587659561,
        "created_at": "2026-03-17T12:44:28+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz Modern Sanat Galerisine Dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop Lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5 mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9588586905897",
    "brand": "Creavit",
    "title": "Loop 45cm Masa Üstü Çanak Lavabo Extra Şeftali Tüyü",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-seftali-tuyu-6907.png?v=1747231052",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-seftali-tuyu-6907.png?v=1747231052",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-seftali-tuyu-6908.png?v=1747231055",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-seftali-tuyu-6909.png?v=1747231059",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-seftali-tuyu-6910.png?v=1747231062"
    ],
    "price": "11700.00",
    "sku": "LP146-00ST00E-0000",
    "tags": [
      "Lavabo",
      "Loop",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo",
      "Şeftali Tüyü"
    ],
    "variants": [
      {
        "id": 52843178918185,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP146-00ST00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11700.00",
        "grams": 0,
        "compare_at_price": "15600.00",
        "position": 1,
        "product_id": 9588586905897,
        "created_at": "2026-03-17T12:44:25+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz Modern Sanat Galerisine Dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop Lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5 mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9588586185001",
    "brand": "Creavit",
    "title": "Loop 45cm Masa Üstü Çanak Lavabo Extra Neon",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-neon-6902.png?v=1747231033",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-neon-6902.png?v=1747231033",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-neon-6903.png?v=1747231036",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-neon-6904.png?v=1747231040",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-neon-6905.png?v=1747231043"
    ],
    "price": "11700.00",
    "sku": "LP146-00NN00E-0000",
    "tags": [
      "Lavabo",
      "Loop",
      "Neon",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843178819881,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP146-00NN00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11700.00",
        "grams": 0,
        "compare_at_price": "15600.00",
        "position": 1,
        "product_id": 9588586185001,
        "created_at": "2026-03-17T12:44:22+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz Modern Sanat Galerisine Dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop Lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5 mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9588582678825",
    "brand": "Creavit",
    "title": "Loop 45cm Masa Üstü Çanak Lavabo Extra Sakura",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-sakura-6897.png?v=1747231015",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-sakura-6897.png?v=1747231015",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-sakura-6898.png?v=1747231018",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-sakura-6899.png?v=1747231022",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-sakura-6900.png?v=1747231024"
    ],
    "price": "11700.00",
    "sku": "LP146-00SK00E-0000",
    "tags": [
      "Lavabo",
      "Loop",
      "Sakura",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843178524969,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP146-00SK00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "11700.00",
        "grams": 0,
        "compare_at_price": "15600.00",
        "position": 1,
        "product_id": 9588582678825,
        "created_at": "2026-03-17T12:44:19+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz Modern Sanat Galerisine Dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop Lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5 mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9588582220073",
    "brand": "Creavit",
    "title": "Loop 45cm Masa Üstü Çanak Lavabo Extra Mint",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-mint-6892.png?v=1747230996",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-mint-6892.png?v=1747230996",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-mint-6893.png?v=1747230999",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-mint-6894.png?v=1747231002",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-mint-6895.png?v=1747231005"
    ],
    "price": "11700.00",
    "sku": "LP146-00MT00E-0000",
    "tags": [
      "Lavabo",
      "Loop",
      "Mint",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843178328361,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP146-00MT00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11700.00",
        "grams": 0,
        "compare_at_price": "15600.00",
        "position": 1,
        "product_id": 9588582220073,
        "created_at": "2026-03-17T12:44:15+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz Modern Sanat Galerisine Dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop Lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5 mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9588581794089",
    "brand": "Creavit",
    "title": "Loop 45cm Masa Üstü Çanak Lavabo Extra Nil yeşili",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-nil-yesili-6887.png?v=1747230977",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-nil-yesili-6887.png?v=1747230977",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-nil-yesili-6888.png?v=1747230980",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-nil-yesili-6889.png?v=1747230983",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-nil-yesili-6890.png?v=1747230986"
    ],
    "price": "11700.00",
    "sku": "LP146-00NY00E-0000",
    "tags": [
      "Lavabo",
      "Loop",
      "Nil Yeşili",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843178197289,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP146-00NY00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "11700.00",
        "grams": 0,
        "compare_at_price": "15600.00",
        "position": 1,
        "product_id": 9588581794089,
        "created_at": "2026-03-17T12:44:12+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz Modern Sanat Galerisine Dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop Lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5 mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9588581204265",
    "brand": "Creavit",
    "title": "Loop 45cm Masa Üstü Çanak Lavabo Extra Berry",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-berry-6882.png?v=1747230958",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-berry-6882.png?v=1747230958",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-berry-6883.png?v=1747230961",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-berry-6884.png?v=1747230964",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-berry-6885.png?v=1747230967"
    ],
    "price": "11700.00",
    "sku": "LP146-00BR00E-0000",
    "tags": [
      "Berry",
      "Lavabo",
      "Loop",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843178066217,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP146-00BR00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11700.00",
        "grams": 0,
        "compare_at_price": "15600.00",
        "position": 1,
        "product_id": 9588581204265,
        "created_at": "2026-03-17T12:44:09+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz Modern Sanat Galerisine Dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop Lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5 mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9588580548905",
    "brand": "Creavit",
    "title": "Loop 45cm Masa Üstü Çanak Lavabo Extra Cool Grey",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-cool-grey-6877.png?v=1747230940",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-cool-grey-6877.png?v=1747230940",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-cool-grey-6878.png?v=1747230943",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-cool-grey-6879.png?v=1747230946",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-cool-grey-6880.png?v=1747230949"
    ],
    "price": "11700.00",
    "sku": "LP146-00CG00E-0000",
    "tags": [
      "Cool Grey",
      "Lavabo",
      "Loop",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843177935145,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP146-00CG00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11700.00",
        "grams": 0,
        "compare_at_price": "15600.00",
        "position": 1,
        "product_id": 9588580548905,
        "created_at": "2026-03-17T12:44:06+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz Modern Sanat Galerisine Dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop Lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5 mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9588579893545",
    "brand": "Creavit",
    "title": "Loop 45cm Masa Üstü Çanak Lavabo Extra Mat Cappuccino",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-mat-cappuccino-6871.png?v=1747230918",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-mat-cappuccino-6871.png?v=1747230918",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-mat-cappuccino-6872.png?v=1747230921",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-mat-cappuccino-6873.png?v=1747230924",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-mat-cappuccino-6874.png?v=1747230928",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-mat-cappuccino-6875.png?v=1747230931"
    ],
    "price": "11700.00",
    "sku": "LP146-00CM00E-0000",
    "tags": [
      "Lavabo",
      "Loop",
      "Mat Cappuccino",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843177771305,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP146-00CM00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11700.00",
        "grams": 0,
        "compare_at_price": "15600.00",
        "position": 1,
        "product_id": 9588579893545,
        "created_at": "2026-03-17T12:44:03+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz Modern Sanat Galerisine Dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop Lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5 mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9588578812201",
    "brand": "Creavit",
    "title": "Loop 45cm Masa Üstü Çanak Lavabo Extra Mat Antrasit",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-mat-antrasit-6866.png?v=1747230898",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-mat-antrasit-6866.png?v=1747230898",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-mat-antrasit-6867.png?v=1747230902",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-mat-antrasit-6868.png?v=1747230905",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-mat-antrasit-6869.png?v=1747230908"
    ],
    "price": "11700.00",
    "sku": "LP146-00AM00E-0000",
    "tags": [
      "Lavabo",
      "Loop",
      "Mat Antrasit",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843177640233,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP146-00AM00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11700.00",
        "grams": 0,
        "compare_at_price": "15600.00",
        "position": 1,
        "product_id": 9588578812201,
        "created_at": "2026-03-17T12:44:00+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz Modern Sanat Galerisine Dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop Lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5 mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9588577829161",
    "brand": "Creavit",
    "title": "Loop 45cm Masa Üstü Çanak Lavabo Extra Kömür Karası",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-komur-karasi-6861.png?v=1747230879",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-komur-karasi-6861.png?v=1747230879",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-komur-karasi-6862.png?v=1747230883",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-komur-karasi-6863.png?v=1747230886",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-komur-karasi-6864.png?v=1747230889"
    ],
    "price": "11700.00",
    "sku": "LP146-00KK00E-0000",
    "tags": [
      "Kömür Karası",
      "Lavabo",
      "Loop",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843177476393,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP146-00KK00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11700.00",
        "grams": 0,
        "compare_at_price": "15600.00",
        "position": 1,
        "product_id": 9588577829161,
        "created_at": "2026-03-17T12:43:57+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz Modern Sanat Galerisine Dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop Lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5 mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9588576551209",
    "brand": "Creavit",
    "title": "Loop 45cm Masa Üstü Çanak Lavabo Extra Mat Beyaz",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-loop-canak-lavabo-beyaz-LP146MB.png?v=1749029468",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-loop-canak-lavabo-beyaz-LP146MB.png?v=1749029468",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-mat-beyaz-6856.png?v=1749029468",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-mat-beyaz-6857.png?v=1749029468",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-mat-beyaz-6858.png?v=1749029468",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-extra-mat-beyaz-6859.png?v=1749029468",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-loop146-1.png?v=1749029535"
    ],
    "price": "10125.00",
    "sku": "LP146-00MB00E-0000",
    "tags": [
      "Lavabo",
      "Loop",
      "Mat Beyaz",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843177148713,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP146-00MB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "10125.00",
        "grams": 0,
        "compare_at_price": "13500.00",
        "position": 1,
        "product_id": 9588576551209,
        "created_at": "2026-03-17T12:43:54+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz Modern Sanat Galerisine Dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop Lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5 mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9590640148777",
    "brand": "Creavit",
    "title": "Patara Dikdörgen Led Ayna 85x65cm Mat Yeşil",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT4055.01.MYE.jpg?v=1756816747",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT4055.01.MYE.jpg?v=1756816747"
    ],
    "price": "22852.50",
    "sku": "PT4085.01.MYE",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "Mat Yeşil",
      "Patara"
    ],
    "variants": [
      {
        "id": 52843210244393,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "PT4085.01.MYE",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "22852.50",
        "grams": 0,
        "compare_at_price": "30470.00",
        "position": 1,
        "product_id": 9590640148777,
        "created_at": "2026-03-17T12:53:46+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><meta charset=\"utf-8\">Zarif tasarımı ve fonksiyonelliği bir araya getiren Patara banyo mobilyaları, masif kulpları ve ayaklı yapısıyla şıklığı ön plana çıkarıyor. LED aynası banyolara modern bir dokunuş katarken, kullanım konforunuz artacak. Geniş depolama alanı, banyo malzemelerinizi düzenli bir şekilde saklamanızı sağlarken, kaliteli malzemesi uzun ömürlü bir kullanım sunar. Creavit Patara serisi estetik ve pratik çözümler arayanlar için idealdir!</p>"
  },
  {
    "id": "creavit-9590638018857",
    "brand": "Creavit",
    "title": "Patara Dikdörgen Led Ayna 85x65cm Mat Cappuccino",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT4085.01.MCP.jpg?v=1756816772",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT4085.01.MCP.jpg?v=1756816772"
    ],
    "price": "22852.50",
    "sku": "PT4085.01.MCP",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "Mat Cappuccino",
      "Patara"
    ],
    "variants": [
      {
        "id": 52843208671529,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "PT4085.01.MCP",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "22852.50",
        "grams": 0,
        "compare_at_price": "30470.00",
        "position": 1,
        "product_id": 9590638018857,
        "created_at": "2026-03-17T12:53:24+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Zarif tasarımı ve fonksiyonelliği bir araya getiren Patara banyo mobilyaları, masif kulpları ve ayaklı yapısıyla şıklığı ön plana çıkarıyor. LED aynası banyolara modern bir dokunuş katarken, kullanım konforunuz artacak. Geniş depolama alanı, banyo malzemelerinizi düzenli bir şekilde saklamanızı sağlarken, kaliteli malzemesi uzun ömürlü bir kullanım sunar. Creavit Patara serisi estetik ve pratik çözümler arayanlar için idealdir!</p>"
  },
  {
    "id": "creavit-9590636249385",
    "brand": "Creavit",
    "title": "Patara Dikdörgen Led Ayna 85x65cm Mat Beyaz",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT4085.01.MBY.jpg?v=1756816813",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT4085.01.MBY.jpg?v=1756816813"
    ],
    "price": "22852.50",
    "sku": "PT4085.01.MBY",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "Mat Beyaz",
      "Patara"
    ],
    "variants": [
      {
        "id": 52843208540457,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "PT4085.01.MBY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "22852.50",
        "grams": 0,
        "compare_at_price": "30470.00",
        "position": 1,
        "product_id": 9590636249385,
        "created_at": "2026-03-17T12:53:21+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 178\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p>Zarif tasarımı ve fonksiyonelliği bir araya getiren Patara banyo mobilyaları, masif kulpları ve ayaklı yapısıyla şıklığı ön plana çıkarıyor. LED aynası banyolara modern bir dokunuş katarken, kullanım konforunuz artacak. Geniş depolama alanı, banyo malzemelerinizi düzenli bir şekilde saklamanızı sağlarken, kaliteli malzemesi uzun ömürlü bir kullanım sunar. Creavit Patara serisi estetik ve pratik çözümler arayanlar için idealdir!</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9590424568105",
    "brand": "Creavit",
    "title": "Patara Lavabo Dolabı 100cm Mat Beyaz",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT0100.42.MBY.jpg?v=1756816424",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/PT0100.42.MBY.jpg?v=1756816424",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-patara-boy-dolabi-beyaz_3ad63269-a9d0-44cb-be0e-66a0cb49c7b7.png?v=1756816424",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/patara-lavabo-dolabi-100cm-mat-beyaz-7104.png?v=1756816424",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-patara-3_76244b28-a5de-48e7-b4d1-3ebadc9993bb.png?v=1756816424",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-patara-5_085ed29f-4941-4ef0-b4b7-7fdace87b80b.png?v=1756816424",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-patara-4_6fe76181-b236-4c69-9c08-43f4af20826a.png?v=1756816424"
    ],
    "price": "35227.50",
    "sku": "PT0100.42.MBY",
    "tags": [
      "Banyo Mobilyası",
      "Lavabo Dolabı",
      "Mat Beyaz",
      "Patara",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843232657705,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "PT0100.42.MBY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "35227.50",
        "grams": 0,
        "compare_at_price": "46970.00",
        "position": 1,
        "product_id": 9590424568105,
        "created_at": "2026-03-17T13:00:49+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 178\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p>Zarif tasarımı ve fonksiyonelliği bir araya getiren Patara banyo mobilyaları, masif kulpları ve ayaklı yapısıyla şıklığı ön plana çıkarıyor. LED aynası banyolara modern bir dokunuş katarken, kullanım konforunuz artacak. Geniş depolama alanı, banyo malzemelerinizi düzenli bir şekilde saklamanızı sağlarken, kaliteli malzemesi uzun ömürlü bir kullanım sunar. Creavit Patara serisi estetik ve pratik çözümler arayanlar için idealdir!</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9589587345705",
    "brand": "Creavit",
    "title": "Saily Oval Led Ayna 53 cm",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-saily-led-ayna.png?v=1748176440",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-saily-led-ayna.png?v=1748176440",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-saily-4.png?v=1748176440",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-saily-1.png?v=1748176640",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/saily-oval-led-ayna-53-cm-7096.png?v=1748176440"
    ],
    "price": "16252.50",
    "sku": "SM4055.00.SS",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "Saily"
    ],
    "variants": [
      {
        "id": 52843206738217,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SM4055.00.SS",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "16252.50",
        "grams": 0,
        "compare_at_price": "21670.00",
        "position": 1,
        "product_id": 9589587345705,
        "created_at": "2026-03-17T12:52:46+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Sadece Size Özel</strong></p>\n<p>Banyo içinde ihtiyacınız olan tüm ürünleri depolayabileceğiniz Sailyi 100 cm çekmeceli dolabı, kısa çamaşır sepeti, dolap üzeri çekmecesi ile banyo düzeninize bütüncül ve kesin bir çözüm sunuyor.</p>\n<p><meta charset=\"utf-8\"><strong>Mükemmel Harmoni</strong></p>\n<p>Dafne ve Siyah renkelerinin kusursuz harmonisinden ortaya çıkan Saily, banyonuzda ferah ve iç açıcı bir atmosfer yaratır. elegant duruşuyla dikkat çeken Saily, sağlam yapısı ile uzun yıllar kullanabileceğiniz bir banyo çözümü için yaratıldı.<strong></strong></p>"
  },
  {
    "id": "creavit-9589586559273",
    "brand": "Creavit",
    "title": "Saily Çamaşır Sepetli Boy Dolabı",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-saily-camasir-sepetli-boy-dolabi-banyo-mobilyasi.png?v=1748176640",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-saily-camasir-sepetli-boy-dolabi-banyo-mobilyasi.png?v=1748176640",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-saily-camasir-sepetli-boy-dolabi.png?v=1748176640",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-saily-1.png?v=1748176640",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/saily-camasir-sepetli-boy-dolabi-7093.png?v=1748176640"
    ],
    "price": "19882.50",
    "sku": "SM2075.00.SD",
    "tags": [
      "Banyo Mobilyası",
      "boy dolabı",
      "Saily",
      "çamaşır sepeti",
      "çamaşır sepetli boy dolabı"
    ],
    "variants": [
      {
        "id": 52843205853481,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SM2075.00.SD",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "19882.50",
        "grams": 0,
        "compare_at_price": "26510.00",
        "position": 1,
        "product_id": 9589586559273,
        "created_at": "2026-03-17T12:52:43+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Sadece Size Özel</strong></p>\n<p>Banyo içinde ihtiyacınız olan tüm ürünleri depolayabileceğiniz Sailyi 100 cm çekmeceli dolabı, kısa çamaşır sepeti, dolap üzeri çekmecesi ile banyo düzeninize bütüncül ve kesin bir çözüm sunuyor.</p>\n<p><meta charset=\"utf-8\"><strong>Mükemmel Harmoni</strong></p>\n<p>Dafne ve Siyah renkelerinin kusursuz harmonisinden ortaya çıkan Saily, banyonuzda ferah ve iç açıcı bir atmosfer yaratır. elegant duruşuyla dikkat çeken Saily, sağlam yapısı ile uzun yıllar kullanabileceğiniz bir banyo çözümü için yaratıldı.</p>"
  },
  {
    "id": "creavit-9589585674537",
    "brand": "Creavit",
    "title": "Saily Lavabo Dolabı 100 cm",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-saily-lavabo-dolabi-cappuccino.png?v=1748176692",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-saily-lavabo-dolabi-cappuccino.png?v=1748176692",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-saily-2.png?v=1748176692",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-eticaret-saily-1_34028cfe-aadc-4cad-84ea-4c3916d32723.png?v=1748176692",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/saily-lavabo-dolabi-100-cm-7090.png?v=1748176692"
    ],
    "price": "29865.00",
    "sku": "SM0100.42.SD",
    "tags": [
      "Banyo Mobilyası",
      "Lavabo Dolabı",
      "Saily",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843203166505,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SM0100.42.SD",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "29865.00",
        "grams": 0,
        "compare_at_price": "39820.00",
        "position": 1,
        "product_id": 9589585674537,
        "created_at": "2026-03-17T12:52:03+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Sadece Size Özel</strong></p>\n<p>Banyo içinde ihtiyacınız olan tüm ürünleri depolayabileceğiniz Sailyi 100 cm çekmeceli dolabı, kısa çamaşır sepeti, dolap üzeri çekmecesi ile banyo düzeninize bütüncül ve kesin bir çözüm sunuyor.</p>\n<p><meta charset=\"utf-8\"><strong>Mükemmel Harmoni</strong></p>\n<p>Dafne ve Siyah renkelerinin kusursuz harmonisinden ortaya çıkan Saily, banyonuzda ferah ve iç açıcı bir atmosfer yaratır. elegant duruşuyla dikkat çeken Saily, sağlam yapısı ile uzun yıllar kullanabileceğiniz bir banyo çözümü için yaratıldı.</p>"
  },
  {
    "id": "creavit-9589576859945",
    "brand": "Creavit",
    "title": "Colorit  Boy Dolabı 40x75 cm Şeftali Tüyü",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-camasir-sepetli-boy-dolabi-seftali-tuyu.png?v=1747917672",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-camasir-sepetli-boy-dolabi-seftali-tuyu.png?v=1747917672",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-camasir-sepetli-boy-dolabi-40x75-cm-seftali-tuyu-7073.png?v=1747917672",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-camasir-sepetli-boy-dolabi-40x75-cm-seftali-tuyu-7075.png?v=1747917672",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-camasir-sepetli-boy-dolabi-40x75-cm-seftali-tuyu-7076.png?v=1747917672"
    ],
    "price": "27472.50",
    "sku": "CO2075.00.SFT",
    "tags": [
      "Banyo Mobilyası",
      "boy dolabı",
      "Colorit",
      "çamaşır sepeti",
      "çamaşır sepetli boy dolabı",
      "Şeftali Tüyü"
    ],
    "variants": [
      {
        "id": 52843268342057,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "CO2075.00.SFT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "27472.50",
        "grams": 0,
        "compare_at_price": "36630.00",
        "position": 1,
        "product_id": 9589576859945,
        "created_at": "2026-03-17T13:12:13+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 178\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Yeni Banyonun Yenilikçi Tasarımı</strong></p>\n<p>Zamansız tasarım çizgisi ile minimal ölçülerde elegant bir banyo deneyimi sunan Colorit; solid tezgah ve lake kaplama yapısı ile uzun yıllar rahatlıkla kullanabileceğiniz sağlamlıkta yaratıldı. Colorit ideal ölçüdeki saklama alanları ile kusursuz bir mekan kurgusuyla kişisel banyo deneyimi için yaratıldı.</p>\n<p><strong>Hangisi Daha Konforlu?</strong></p>\n<p>Banyo malzemeleriniz için ideal bir düzen kurgulamayı amaçlayan Colorit, çekmeceli ve kapaklı seçenekleri ve konfor özellikleri opsiyonuyla kişisel banyo deneyimizi üst seviyeye çıkarıyor. Colorit oval aynası ile banyonuza ve kendinize geniş bir perspektiften bakmanızı sağlıyor.<meta charset=\"utf-8\"><strong></strong></p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9589576171817",
    "brand": "Creavit",
    "title": "Colorit Boy Dolabı 40x75 cm Ocean",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-camasir-sepetli-boy-dolabi-ocean-mavi.png?v=1747917950",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-camasir-sepetli-boy-dolabi-ocean-mavi.png?v=1747917950",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-camasir-sepetli-boy-dolabi-40x75-cm-ocean-7068.png?v=1747917950",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-camasir-sepetli-boy-dolabi-40x75-cm-ocean-7071.png?v=1747917950",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-camasir-sepetli-boy-dolabi-40x75-cm-ocean-7072.png?v=1747917950"
    ],
    "price": "27472.50",
    "sku": "CO2075.00.OCE",
    "tags": [
      "Banyo Mobilyası",
      "boy dolabı",
      "Colorit",
      "ocean",
      "çamaşır sepeti",
      "çamaşır sepetli boy dolabı"
    ],
    "variants": [
      {
        "id": 52920978342185,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "CO2075.00.OCE",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "27472.50",
        "grams": 0,
        "compare_at_price": "36630.00",
        "position": 1,
        "product_id": 9589576171817,
        "created_at": "2026-04-03T12:18:07+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 178\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Yeni Banyonun Yenilikçi Tasarımı</strong></p>\n<p>Zamansız tasarım çizgisi ile minimal ölçülerde elegant bir banyo deneyimi sunan Colorit; solid tezgah ve lake kaplama yapısı ile uzun yıllar rahatlıkla kullanabileceğiniz sağlamlıkta yaratıldı. Colorit ideal ölçüdeki saklama alanları ile kusursuz bir mekan kurgusuyla kişisel banyo deneyimi için yaratıldı.</p>\n<p><strong>Hangisi Daha Konforlu?</strong></p>\n<p>Banyo malzemeleriniz için ideal bir düzen kurgulamayı amaçlayan Colorit, çekmeceli ve kapaklı seçenekleri ve konfor özellikleri opsiyonuyla kişisel banyo deneyimizi üst seviyeye çıkarıyor. Colorit oval aynası ile banyonuza ve kendinize geniş bir perspektiften bakmanızı sağlıyor.<meta charset=\"utf-8\"><strong></strong></p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9589576007977",
    "brand": "Creavit",
    "title": "Colorit Boy Dolabı 40x75 cm Nil Yeşili",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-camasir-sepetli-boy-dolabi-nil-yesili.png?v=1747918032",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-camasir-sepetli-boy-dolabi-nil-yesili.png?v=1747918032",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-camasir-sepetli-boy-dolabi-40x75-cm-nil-yesili-7063.png?v=1747918032",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-camasir-sepetli-boy-dolabi-40x75-cm-nil-yesili-7066.png?v=1747918030",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-camasir-sepetli-boy-dolabi-40x75-cm-nil-yesili-7067.png?v=1747918030"
    ],
    "price": "27472.50",
    "sku": "CO2075.00.NY",
    "tags": [
      "Banyo Mobilyası",
      "boy dolabı",
      "Colorit",
      "Nil Yeşili",
      "çamaşır sepeti",
      "çamaşır sepetli boy dolabı"
    ],
    "variants": [
      {
        "id": 52843202478377,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "CO2075.00.NY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "27472.50",
        "grams": 0,
        "compare_at_price": "36630.00",
        "position": 1,
        "product_id": 9589576007977,
        "created_at": "2026-03-17T12:51:48+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 178\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Yeni Banyonun Yenilikçi Tasarımı</strong></p>\n<p>Zamansız tasarım çizgisi ile minimal ölçülerde elegant bir banyo deneyimi sunan Colorit; solid tezgah ve lake kaplama yapısı ile uzun yıllar rahatlıkla kullanabileceğiniz sağlamlıkta yaratıldı. Colorit ideal ölçüdeki saklama alanları ile kusursuz bir mekan kurgusuyla kişisel banyo deneyimi için yaratıldı.</p>\n<p><strong>Hangisi Daha Konforlu?</strong></p>\n<p>Banyo malzemeleriniz için ideal bir düzen kurgulamayı amaçlayan Colorit, çekmeceli ve kapaklı seçenekleri ve konfor özellikleri opsiyonuyla kişisel banyo deneyimizi üst seviyeye çıkarıyor. Colorit oval aynası ile banyonuza ve kendinize geniş bir perspektiften bakmanızı sağlıyor.<meta charset=\"utf-8\"><strong></strong></p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9589575811369",
    "brand": "Creavit",
    "title": "Colorit Boy Dolabı 40x75 cm Cappuccino",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-camasir-sepetli-boy-dolabi-cappuccino.png?v=1747918073",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-camasir-sepetli-boy-dolabi-cappuccino.png?v=1747918073",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-colorit-1_8e910224-4fa0-4bea-97a4-e3ac429a23c9.png?v=1757247412",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-camasir-sepetli-boy-dolabi-40x75-cm-cappuccino-7061.png?v=1757247412"
    ],
    "price": "27472.50",
    "sku": "CO2075.00.MCP",
    "tags": [
      "Banyo Mobilyası",
      "boy dolabı",
      "Cappuccino",
      "Colorit",
      "çamaşır sepeti",
      "çamaşır sepetli boy dolabı"
    ],
    "variants": [
      {
        "id": 52843202347305,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "CO2075.00.MCP",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "27472.50",
        "grams": 0,
        "compare_at_price": "36630.00",
        "position": 1,
        "product_id": 9589575811369,
        "created_at": "2026-03-17T12:51:45+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 178\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Yeni Banyonun Yenilikçi Tasarımı</strong></p>\n<p>Zamansız tasarım çizgisi ile minimal ölçülerde elegant bir banyo deneyimi sunan Colorit; solid tezgah ve lake kaplama yapısı ile uzun yıllar rahatlıkla kullanabileceğiniz sağlamlıkta yaratıldı. Colorit ideal ölçüdeki saklama alanları ile kusursuz bir mekan kurgusuyla kişisel banyo deneyimi için yaratıldı.</p>\n<p><strong>Hangisi Daha Konforlu?</strong></p>\n<p>Banyo malzemeleriniz için ideal bir düzen kurgulamayı amaçlayan Colorit, çekmeceli ve kapaklı seçenekleri ve konfor özellikleri opsiyonuyla kişisel banyo deneyimizi üst seviyeye çıkarıyor. Colorit oval aynası ile banyonuza ve kendinize geniş bir perspektiften bakmanızı sağlıyor.<meta charset=\"utf-8\"><strong></strong></p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9589575352617",
    "brand": "Creavit",
    "title": "Colorit Boy Dolabı 40x75 cm Berry",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-camasir-sepetli-boy-dolabi-berry.png?v=1747918102",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-camasir-sepetli-boy-dolabi-berry.png?v=1747918102",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-camasir-sepetli-boy-dolabi-40x75-cm-berry-7054.png?v=1747918102",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-camasir-sepetli-boy-dolabi-40x75-cm-berry-7056.png?v=1747918100",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-camasir-sepetli-boy-dolabi-40x75-cm-berry-7057.png?v=1747918100"
    ],
    "price": "27472.50",
    "sku": "CO2075.00.BE",
    "tags": [
      "Banyo Mobilyası",
      "Berry",
      "boy dolabı",
      "Colorit",
      "çamaşır sepeti",
      "çamaşır sepetli boy dolabı"
    ],
    "variants": [
      {
        "id": 52843202216233,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "CO2075.00.BE",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "27472.50",
        "grams": 0,
        "compare_at_price": "36630.00",
        "position": 1,
        "product_id": 9589575352617,
        "created_at": "2026-03-17T12:51:42+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 178\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Yeni Banyonun Yenilikçi Tasarımı</strong></p>\n<p>Zamansız tasarım çizgisi ile minimal ölçülerde elegant bir banyo deneyimi sunan Colorit; solid tezgah ve lake kaplama yapısı ile uzun yıllar rahatlıkla kullanabileceğiniz sağlamlıkta yaratıldı. Colorit ideal ölçüdeki saklama alanları ile kusursuz bir mekan kurgusuyla kişisel banyo deneyimi için yaratıldı.</p>\n<p><strong>Hangisi Daha Konforlu?</strong></p>\n<p>Banyo malzemeleriniz için ideal bir düzen kurgulamayı amaçlayan Colorit, çekmeceli ve kapaklı seçenekleri ve konfor özellikleri opsiyonuyla kişisel banyo deneyimizi üst seviyeye çıkarıyor. Colorit oval aynası ile banyonuza ve kendinize geniş bir perspektiften bakmanızı sağlıyor.<meta charset=\"utf-8\"><strong></strong></p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9589574697257",
    "brand": "Creavit",
    "title": "Colorit Oval Ayna 40x80 cm Şeftali Tüyü",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-oval-ayna-seftali-tuyu.png?v=1747918144",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-oval-ayna-seftali-tuyu.png?v=1747918144",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-oval-ayna-40x80-cm-seftali-tuyu-7052.png?v=1747918144",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-oval-ayna-40x80-cm-seftali-tuyu-7053.png?v=1757340865",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-colorit-8.png?v=1747918247"
    ],
    "price": "9405.00",
    "sku": "CO1040.00.SFT",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "Colorit",
      "Şeftali Tüyü"
    ],
    "variants": [
      {
        "id": 52843265884457,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "CO1040.00.SFT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9405.00",
        "grams": 0,
        "compare_at_price": "12540.00",
        "position": 1,
        "product_id": 9589574697257,
        "created_at": "2026-03-17T13:11:26+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 178\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Yeni Banyonun Yenilikçi Tasarımı</strong></p>\n<p>Zamansız tasarım çizgisi ile minimal ölçülerde elegant bir banyo deneyimi sunan Colorit; solid tezgah ve lake kaplama yapısı ile uzun yıllar rahatlıkla kullanabileceğiniz sağlamlıkta yaratıldı. Colorit ideal ölçüdeki saklama alanları ile kusursuz bir mekan kurgusuyla kişisel banyo deneyimi için yaratıldı.</p>\n<p><strong>Hangisi Daha Konforlu?</strong></p>\n<p>Banyo malzemeleriniz için ideal bir düzen kurgulamayı amaçlayan Colorit, çekmeceli ve kapaklı seçenekleri ve konfor özellikleri opsiyonuyla kişisel banyo deneyimizi üst seviyeye çıkarıyor. Colorit oval aynası ile banyonuza ve kendinize geniş bir perspektiften bakmanızı sağlıyor.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9589573812521",
    "brand": "Creavit",
    "title": "Colorit Oval Ayna 40x80 cm Ocean",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-oval-ayna-ocean.png?v=1747918188",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-oval-ayna-ocean.png?v=1747918188",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-oval-ayna-40x80-cm-ocean-7047.png?v=1747918188",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-oval-ayna-40x80-cm-ocean-7048.png?v=1747918188",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-oval-ayna-40x80-cm-ocean-7049.png?v=1747918257",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-oval-ayna-40x80-cm-ocean-7050.png?v=1747918257"
    ],
    "price": "9405.00",
    "sku": "CO1040.00.OCE",
    "tags": [
      "Ayna",
      "Banyo Aynası",
      "Banyo Mobilyası",
      "Colorit",
      "ocean"
    ],
    "variants": [
      {
        "id": 52843245928745,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "CO1040.00.OCE",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9405.00",
        "grams": 0,
        "compare_at_price": "12540.00",
        "position": 1,
        "product_id": 9589573812521,
        "created_at": "2026-03-17T13:05:12+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 178\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Yeni Banyonun Yenilikçi Tasarımı</strong></p>\n<p>Zamansız tasarım çizgisi ile minimal ölçülerde elegant bir banyo deneyimi sunan Colorit; solid tezgah ve lake kaplama yapısı ile uzun yıllar rahatlıkla kullanabileceğiniz sağlamlıkta yaratıldı. Colorit ideal ölçüdeki saklama alanları ile kusursuz bir mekan kurgusuyla kişisel banyo deneyimi için yaratıldı.</p>\n<p><strong>Hangisi Daha Konforlu?</strong></p>\n<p>Banyo malzemeleriniz için ideal bir düzen kurgulamayı amaçlayan Colorit, çekmeceli ve kapaklı seçenekleri ve konfor özellikleri opsiyonuyla kişisel banyo deneyimizi üst seviyeye çıkarıyor. Colorit oval aynası ile banyonuza ve kendinize geniş bir perspektiften bakmanızı sağlıyor.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9589570601257",
    "brand": "Creavit",
    "title": "Colorit Çekmeceli Lavabo Dolabı 60 cm Şeftali Tüyü",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-lavabo-dolabi-banyo-mobilyasi-seftali-tuyu.png?v=1747918774",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-lavabo-dolabi-banyo-mobilyasi-seftali-tuyu.png?v=1747918774",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-cekmeceli-lavabo-dolabi-60-cm-seftali-tuyu-7031.png?v=1747919588",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-cekmeceli-lavabo-dolabi-60-cm-seftali-tuyu-7032.png?v=1747919586",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-cekmeceli-lavabo-dolabi-60-cm-seftali-tuyu-7034.png?v=1747919586"
    ],
    "price": "43725.00",
    "sku": "CO0060.41.SFT",
    "tags": [
      "Banyo Mobilyası",
      "Colorit",
      "Lavabo Dolabı",
      "çekmeceli lavabo dolabı",
      "Şeftali Tüyü"
    ],
    "variants": [
      {
        "id": 52843259756841,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "CO0060.41.SFT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "43725.00",
        "grams": 0,
        "compare_at_price": "58300.00",
        "position": 1,
        "product_id": 9589570601257,
        "created_at": "2026-03-17T13:09:24+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 178\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Yeni Banyonun Yenilikçi Tasarımı</strong></p>\n<p>Zamansız tasarım çizgisi ile minimal ölçülerde elegant bir banyo deneyimi sunan Colorit; solid tezgah ve lake kaplama yapısı ile uzun yıllar rahatlıkla kullanabileceğiniz sağlamlıkta yaratıldı. Colorit ideal ölçüdeki saklama alanları ile kusursuz bir mekan kurgusuyla kişisel banyo deneyimi için yaratıldı.</p>\n<p><strong>Hangisi Daha Konforlu?</strong></p>\n<p>Banyo malzemeleriniz için ideal bir düzen kurgulamayı amaçlayan Colorit, çekmeceli ve kapaklı seçenekleri ve konfor özellikleri opsiyonuyla kişisel banyo deneyimizi üst seviyeye çıkarıyor. Colorit oval aynası ile banyonuza ve kendinize geniş bir perspektiften bakmanızı sağlıyor.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9589570371881",
    "brand": "Creavit",
    "title": "Colorit Çekmeceli Lavabo Dolabı 60 cm Ocean",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-lavabo-dolabi-banyo-mobilyasi-ocean.png?v=1747919848",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-lavabo-dolabi-banyo-mobilyasi-ocean.png?v=1747919848",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-colorit-3copy.png?v=1747919848",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-cekmeceli-lavabo-dolabi-60-cm-ocean-7026.png?v=1747919848",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-cekmeceli-lavabo-dolabi-60-cm-ocean-7029.png?v=1747919848",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-colorit-8_13d07c32-aa86-47c8-902e-628efd85a06b.png?v=1747919848"
    ],
    "price": "43725.00",
    "sku": "CO0060.41.OCE",
    "tags": [
      "Banyo Mobilyası",
      "Colorit",
      "Lavabo Dolabı",
      "ocean",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843201691945,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "CO0060.41.OCE",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "43725.00",
        "grams": 0,
        "compare_at_price": "58300.00",
        "position": 1,
        "product_id": 9589570371881,
        "created_at": "2026-03-17T12:51:29+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 178\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Yeni Banyonun Yenilikçi Tasarımı</strong></p>\n<p>Zamansız tasarım çizgisi ile minimal ölçülerde elegant bir banyo deneyimi sunan Colorit; solid tezgah ve lake kaplama yapısı ile uzun yıllar rahatlıkla kullanabileceğiniz sağlamlıkta yaratıldı. Colorit ideal ölçüdeki saklama alanları ile kusursuz bir mekan kurgusuyla kişisel banyo deneyimi için yaratıldı.</p>\n<p><strong>Hangisi Daha Konforlu?</strong></p>\n<p>Banyo malzemeleriniz için ideal bir düzen kurgulamayı amaçlayan Colorit, çekmeceli ve kapaklı seçenekleri ve konfor özellikleri opsiyonuyla kişisel banyo deneyimizi üst seviyeye çıkarıyor. Colorit oval aynası ile banyonuza ve kendinize geniş bir perspektiften bakmanızı sağlıyor.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9589569487145",
    "brand": "Creavit",
    "title": "Colorit Çekmeceli Lavabo Dolabı 60 cm Nil Yeşili",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-lavabo-dolabi-banyo-mobilyasi-nil-yesili.png?v=1747920026",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-lavabo-dolabi-banyo-mobilyasi-nil-yesili.png?v=1747920026",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-colorit-3.png?v=1747920026",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-cekmeceli-lavabo-dolabi-60-cm-nil-yesili-7021.png?v=1747920026",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-cekmeceli-lavabo-dolabi-60-cm-nil-yesili-7022.png?v=1747920026",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-colorit-8_9fe46323-c917-45f3-a383-dd11729e6ac3.png?v=1747920026"
    ],
    "price": "43725.00",
    "sku": "CO0060.41.NY",
    "tags": [
      "Banyo Mobilyası",
      "Colorit",
      "Lavabo Dolabı",
      "Nil Yeşili",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843201528105,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "CO0060.41.NY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "43725.00",
        "grams": 0,
        "compare_at_price": "58300.00",
        "position": 1,
        "product_id": 9589569487145,
        "created_at": "2026-03-17T12:51:26+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 178\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Yeni Banyonun Yenilikçi Tasarımı</strong></p>\n<p>Zamansız tasarım çizgisi ile minimal ölçülerde elegant bir banyo deneyimi sunan Colorit; solid tezgah ve lake kaplama yapısı ile uzun yıllar rahatlıkla kullanabileceğiniz sağlamlıkta yaratıldı. Colorit ideal ölçüdeki saklama alanları ile kusursuz bir mekan kurgusuyla kişisel banyo deneyimi için yaratıldı.</p>\n<p><strong>Hangisi Daha Konforlu?</strong></p>\n<p>Banyo malzemeleriniz için ideal bir düzen kurgulamayı amaçlayan Colorit, çekmeceli ve kapaklı seçenekleri ve konfor özellikleri opsiyonuyla kişisel banyo deneyimizi üst seviyeye çıkarıyor. Colorit oval aynası ile banyonuza ve kendinize geniş bir perspektiften bakmanızı sağlıyor.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9589569159465",
    "brand": "Creavit",
    "title": "Colorit Çekmeceli Lavabo Dolabı 60 cm Cappuccino",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-lavabo-dolabi-banyo-mobilyasi-cappuccino.png?v=1747920143",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-lavabo-dolabi-banyo-mobilyasi-cappuccino.png?v=1747920143",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-colorit-1.png?v=1747920143",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-cekmeceli-lavabo-dolabi-60-cm-cappuccino-7016.png?v=1747920143",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-cekmeceli-lavabo-dolabi-60-cm-cappuccino-7017.png?v=1747920143",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-cekmeceli-lavabo-dolabi-60-cm-cappuccino-7018.png?v=1747920143"
    ],
    "price": "43725.00",
    "sku": "CO0060.41.MCP",
    "tags": [
      "Banyo Mobilyası",
      "Cappuccino",
      "Colorit",
      "Lavabo Dolabı",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843201397033,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "CO0060.41.MCP",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "43725.00",
        "grams": 0,
        "compare_at_price": "58300.00",
        "position": 1,
        "product_id": 9589569159465,
        "created_at": "2026-03-17T12:51:23+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 178\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Yeni Banyonun Yenilikçi Tasarımı</strong></p>\n<p>Zamansız tasarım çizgisi ile minimal ölçülerde elegant bir banyo deneyimi sunan Colorit; solid tezgah ve lake kaplama yapısı ile uzun yıllar rahatlıkla kullanabileceğiniz sağlamlıkta yaratıldı. Colorit ideal ölçüdeki saklama alanları ile kusursuz bir mekan kurgusuyla kişisel banyo deneyimi için yaratıldı.</p>\n<p><strong>Hangisi Daha Konforlu?</strong></p>\n<p>Banyo malzemeleriniz için ideal bir düzen kurgulamayı amaçlayan Colorit, çekmeceli ve kapaklı seçenekleri ve konfor özellikleri opsiyonuyla kişisel banyo deneyimizi üst seviyeye çıkarıyor. Colorit oval aynası ile banyonuza ve kendinize geniş bir perspektiften bakmanızı sağlıyor.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9589566603561",
    "brand": "Creavit",
    "title": "Colorit Çekmeceli Lavabo Dolabı 60 cm Berry",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-lavabo-dolabi-banyo-mobilyasi-berry.png?v=1747920350",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-colorit-lavabo-dolabi-banyo-mobilyasi-berry.png?v=1747920350",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-cekmeceli-lavabo-dolabi-60-cm-berry-7009.png?v=1747920350",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-cekmeceli-lavabo-dolabi-60-cm-berry-7010.png?v=1747920350",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/colorit-cekmeceli-lavabo-dolabi-60-cm-berry-7011.png?v=1747920350",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crv-colorit-8_21685d8f-5b5d-45bd-8e0d-0eb69ffdf05f.png?v=1747920350"
    ],
    "price": "43725.00",
    "sku": "CO0060.41.BE",
    "tags": [
      "Banyo Mobilyası",
      "Berry",
      "Colorit",
      "Lavabo Dolabı",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843201298729,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "CO0060.41.BE",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "43725.00",
        "grams": 0,
        "compare_at_price": "58300.00",
        "position": 1,
        "product_id": 9589566603561,
        "created_at": "2026-03-17T12:51:20+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 177\" class=\"page\">\n<div class=\"section\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<div title=\"Page 178\" class=\"page\">\n<div class=\"layoutArea\">\n<div class=\"column\">\n<p><strong>Yeni Banyonun Yenilikçi Tasarımı</strong></p>\n<p>Zamansız tasarım çizgisi ile minimal ölçülerde elegant bir banyo deneyimi sunan Colorit; solid tezgah ve lake kaplama yapısı ile uzun yıllar rahatlıkla kullanabileceğiniz sağlamlıkta yaratıldı. Colorit ideal ölçüdeki saklama alanları ile kusursuz bir mekan kurgusuyla kişisel banyo deneyimi için yaratıldı.</p>\n<p><strong>Hangisi Daha Konforlu?</strong></p>\n<p>Banyo malzemeleriniz için ideal bir düzen kurgulamayı amaçlayan Colorit, çekmeceli ve kapaklı seçenekleri ve konfor özellikleri opsiyonuyla kişisel banyo deneyimizi üst seviyeye çıkarıyor. Colorit oval aynası ile banyonuza ve kendinize geniş bir perspektiften bakmanızı sağlıyor.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9588507869481",
    "brand": "Creavit",
    "title": "Loop Gen-Z Yuvarlak Masa Üstü Çanak Lavabo Ø40 cm Grafiti Baskı Extra Beyaz",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-loop-gen-z-yuvarlak-canak-lavabo-LP140CB.png?v=1749030544",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-loop-gen-z-yuvarlak-canak-lavabo-LP140CB.png?v=1749030544",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-gen-z-yuvarlak-masa-ustu-canak-lavabo-40-cm-grafiti-baski-extra-beyaz-6806.png?v=1749030544",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-gen-z-yuvarlak-masa-ustu-canak-lavabo-40-cm-grafiti-baski-extra-beyaz-6805.png?v=1749030543"
    ],
    "price": "11160.00",
    "sku": "LP140-00CB00E-GB00",
    "tags": [
      "Beyaz",
      "Gen-Z",
      "Grafiti",
      "Lavabo",
      "Loop",
      "Tezgahüstü",
      "yaz-15-indirim",
      "Yuvarlak",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843189535017,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP140-00CB00E-GB00",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11160.00",
        "grams": 0,
        "compare_at_price": "14880.00",
        "position": 1,
        "product_id": 9588507869481,
        "created_at": "2026-03-17T12:47:37+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Gen - Z</strong> koleksiyonu, Creavit üretim felsefesindeki inovatif bakışın şekil bulmuş halini banyolara taşıyor. Banyolar için yenilikçi çözümler <strong>Gen -Z</strong> koleksiyonunda estetik bakış açısını baştan sona değiştiren tasarımlarla hayatımıza giriyor.</p>\n<p><strong>Teknoloji Tasarımını Gen - Z'de Buldu</strong></p>\n<p>Creavit tasarım ekibi ve Ar-Ge'si teknolojinin hayatımıza getirdiği kolaylık ve yenilikleri banyolarımıza taşımıya devam ediyor.</p>\n<p><strong>Dijital Baskı</strong></p>\n<p><meta charset=\"utf-8\">Banyonuzun detaylarında sizi simgeleyen ayrıntılar mı istiyorsunuz? Sanat benim vazgeçilmezim, banyonu bir sanat galerisi gibi tasarlamak istiyorum diyorsanız Gen-Z art tam size göre. Mekanı sanatla bütünleştiren serimizde klasik ve size özel yapılmış yeni eserleri sergileyebilir, hijyen alanınıza göz alıcı bir estetik getirebilirsiniz.</p>"
  },
  {
    "id": "creavit-9587508183337",
    "brand": "Creavit",
    "title": "Loop Gen-Z Kare 40 cm Masa Üstü İnce Lavabo Grafiti Baskı Extra Beyaz",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavt-loop-grafitti-kare-canak-lavabo-gen-z.png?v=1749032085",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavt-loop-grafitti-kare-canak-lavabo-gen-z.png?v=1749032085",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-gen-z-kare-40-cm-masa-ustu-ince-lavabo-grafiti-baski-extra-beyaz-6798.png?v=1749032085"
    ],
    "price": "11160.00",
    "sku": "LP040-00CB00E-GB00",
    "tags": [
      "Beyaz",
      "Gen-Z",
      "Grafiti",
      "Kare",
      "Lavabo",
      "Tezgahüstü",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843256316201,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP040-00CB00E-GB00",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11160.00",
        "grams": 0,
        "compare_at_price": "14880.00",
        "position": 1,
        "product_id": 9587508183337,
        "created_at": "2026-03-17T13:08:22+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Gen - Z</strong> koleksiyonu, Creavit üretim felsefesindeki inovatif bakışın şekil bulmuş halini banyolara taşıyor. Banyolar için yenilikçi çözümler <strong>Gen -Z</strong> koleksiyonunda estetik bakış açışını baştan sona değiştiren tasarımlarla hayatımıza giriyor.</p>\n<p><strong>Teknoloji Tasarımını Gen - Z'de Buldu</strong></p>\n<p>Creavit tasarım ekibi ve Ar-Ge'si teknolojinin hayatımıza getirdiği kolaylık ve yenilikleri banyolarımıza taşımıya devam ediyor.</p>\n<p><strong>Dijital Baskı</strong></p>\n<p><meta charset=\"utf-8\">Banyonuzun detaylarında sizi simgeleyen ayrıntılar mı istiyorsunuz? Sanat benim vazgeçilmezim, banyonu bir sanat galerisi gibi tasarlamak istiyorum diyorsanız Gen-Z art tam size göre. Mekanı sanatla bütünleştiren serimizde klasik ve size özel yapılmış yeni eserleri sergileyebilir, hijyen alanınıza göz alıcı bir estetik getirebilirsiniz.<meta charset=\"utf-8\"><meta charset=\"utf-8\"></p>"
  },
  {
    "id": "creavit-9587505824041",
    "brand": "Creavit",
    "title": "Loop Gen-Z Kare 40 cm Masa Üstü İnce Lavabo Karikatür Baskı Extra Beyaz",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-gen-z-loop-kare-canak-lavabo-karikatur.png?v=1749032349",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-gen-z-loop-kare-canak-lavabo-karikatur.png?v=1749032349",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-gen-z-kare-40-cm-masa-ustu-ince-lavabo-karikatur-baski-extra-beyaz-6797.png?v=1749032349"
    ],
    "price": "11160.00",
    "sku": "LP040-00CB00E-KB00",
    "tags": [
      "Beyaz",
      "Gen-Z",
      "Kare",
      "Karikatür",
      "Lavabo",
      "Tezgahüstü",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843256119593,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP040-00CB00E-KB00",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11160.00",
        "grams": 0,
        "compare_at_price": "14880.00",
        "position": 1,
        "product_id": 9587505824041,
        "created_at": "2026-03-17T13:08:19+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Gen - Z</strong> koleksiyonu, Creavit üretim felsefesindeki inovatif bakışın şekil bulmuş halini banyolara taşıyor. Banyolar için yenilikçi çözümler <strong>Gen -Z</strong> koleksiyonunda estetik bakış açışını baştan sona değiştiren tasarımlarla hayatımıza giriyor.</p>\n<p><strong>Teknoloji Tasarımını Gen - Z'de Buldu</strong></p>\n<p>Creavit tasarım ekibi ve Ar-Ge'si teknolojinin hayatımıza getirdiği kolaylık ve yenilikleri banyolarımıza taşımıya devam ediyor.</p>\n<p><strong>Dijital Baskı</strong></p>\n<p><meta charset=\"utf-8\">Banyonuzun detaylarında sizi simgeleyen ayrıntılar mı istiyorsunuz? Sanat benim vazgeçilmezim, banyonu bir sanat galerisi gibi tasarlamak istiyorum diyorsanız Gen-Z art tam size göre. Mekanı sanatla bütünleştiren serimizde klasik ve size özel yapılmış yeni eserleri sergileyebilir, hijyen alanınıza göz alıcı bir estetik getirebilirsiniz.</p>"
  },
  {
    "id": "creavit-9590846587177",
    "brand": "Creavit",
    "title": "Terra Mat Nil Yeşili Boyalı Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-terra-nil-yesili-kumanda-paneli.png?v=1748962898",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-terra-nil-yesili-kumanda-paneli.png?v=1748962898",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-nil-yesili-boyali-kumanda-paneli-7141.png?v=1748962898",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-nil-yesili-boyali-kumanda-paneli-7142.jpg?v=1748962898",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-nil-yesili-boyali-kumanda-paneli-7143.jpg?v=1748962898",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-nil-yesili-boyali-kumanda-paneli-7144.jpg?v=1748962898"
    ],
    "price": "2016.00",
    "sku": "GP9002.09",
    "tags": [
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "Nil Yeşili",
      "Rezervuar",
      "Rezervuarlar",
      "Terra",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52843211227433,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP9002.09",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2016.00",
        "grams": 0,
        "compare_at_price": "2880.00",
        "position": 1,
        "product_id": 9590846587177,
        "created_at": "2026-03-17T12:54:05+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><meta charset=\"utf-8\"><span data-mce-fragment=\"1\">Creavit Terra Kumanda Paneli banyo deneyiminizi işlevsel hale getirirken aynı zamanda modern ve şık görünümüyle banyonuza estetik bir katkı sunar. Kaliteli malzemelerden üretilmiş olan bu kumanda paneli dayanıklı yapısıyla da uzun ömürlü kullanım sağlar.</span></p>\n<p><span data-mce-fragment=\"1\"><meta charset=\"utf-8\">\n<strong>Terra kumanda paneli sadece Creavit Marka Gömme Rezervuarlar İle Uyumludur.</strong></span></p>"
  },
  {
    "id": "creavit-9590806413609",
    "brand": "Creavit",
    "title": "Terra Mat Berry Boyalı Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-terra-berry-kumanda-paneli.png?v=1748962924",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-terra-berry-kumanda-paneli.png?v=1748962924",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-berry-boyali-kumanda-paneli-7136.png?v=1748962924",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-berry-boyali-kumanda-paneli-7137.jpg?v=1748962924",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-berry-boyali-kumanda-paneli-7138.jpg?v=1748962924",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-berry-boyali-kumanda-paneli-7139.jpg?v=1748962924"
    ],
    "price": "2016.00",
    "sku": "GP9002.08",
    "tags": [
      "Berry",
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "Rezervuar",
      "Rezervuarlar",
      "Terra",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52921491521833,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP9002.08",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2016.00",
        "grams": 0,
        "compare_at_price": "2880.00",
        "position": 1,
        "product_id": 9590806413609,
        "created_at": "2026-04-03T14:46:03+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><meta charset=\"utf-8\"><span data-mce-fragment=\"1\">Creavit Terra Kumanda Paneli banyo deneyiminizi işlevsel hale getirirken aynı zamanda modern ve şık görünümüyle banyonuza estetik bir katkı sunar. Kaliteli malzemelerden üretilmiş olan bu kumanda paneli dayanıklı yapısıyla da uzun ömürlü kullanım sağlar.</span></p>\n<p><span data-mce-fragment=\"1\"><meta charset=\"utf-8\">\n<strong>Terra kumanda paneli sadece Creavit Marka Gömme Rezervuarlar İle Uyumludur.</strong></span></p>"
  },
  {
    "id": "creavit-9590792782121",
    "brand": "Creavit",
    "title": "Terra Mat Cool Grey Boyalı Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-terra-cool-grey-kumanda-paneli.png?v=1748962953",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-terra-cool-grey-kumanda-paneli.png?v=1748962953",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-cool-grey-boyali-kumanda-paneli-7131.png?v=1748962953",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-cool-grey-boyali-kumanda-paneli-7132.jpg?v=1748962953",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-cool-grey-boyali-kumanda-paneli-7133.jpg?v=1748962953",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-cool-grey-boyali-kumanda-paneli-7134.jpg?v=1748962953"
    ],
    "price": "2016.00",
    "sku": "GP9002.07",
    "tags": [
      "Cool Grey",
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "Rezervuar",
      "Rezervuarlar",
      "Terra",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52920978538793,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP9002.07",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2016.00",
        "grams": 0,
        "compare_at_price": "2880.00",
        "position": 1,
        "product_id": 9590792782121,
        "created_at": "2026-04-03T12:18:10+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><meta charset=\"utf-8\"><span data-mce-fragment=\"1\">Creavit Terra Kumanda Paneli banyo deneyiminizi işlevsel hale getirirken aynı zamanda modern ve şık görünümüyle banyonuza estetik bir katkı sunar. Kaliteli malzemelerden üretilmiş olan bu kumanda paneli dayanıklı yapısıyla da uzun ömürlü kullanım sağlar.</span></p>\n<p><span data-mce-fragment=\"1\"><meta charset=\"utf-8\">\n<strong>Terra kumanda paneli sadece Creavit Marka Gömme Rezervuarlar İle Uyumludur.</strong></span></p>"
  },
  {
    "id": "creavit-9589511029033",
    "brand": "Creavit",
    "title": "Loop Yuvarlak Masa Üstü Çanak Lavabo Ø45 cm Extra Neon",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-neon-6967.png?v=1747231284",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-neon-6967.png?v=1747231284",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-neon-6968.png?v=1747231287",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-neon-6969.png?v=1747231291",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-neon-6970.png?v=1747231294",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-neon-6971.png?v=1747231298",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-neon-6972.png?v=1747231301",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-neon-6973.jpg?v=1747231304"
    ],
    "price": "11385.00",
    "sku": "LP145-00NN00E-0000",
    "tags": [
      "Lavabo",
      "Loop",
      "Neon",
      "Tezgah Üstü Lavabo",
      "Tezgahüstü",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843180261673,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP145-00NN00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11385.00",
        "grams": 0,
        "compare_at_price": "15180.00",
        "position": 1,
        "product_id": 9589511029033,
        "created_at": "2026-03-17T12:44:50+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz modern sanat galerisine dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9589510045993",
    "brand": "Creavit",
    "title": "Loop Yuvarlak Masa Üstü Çanak Lavabo Ø45 cm Extra Sakura",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-sakura-6959.png?v=1747231254",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-sakura-6959.png?v=1747231254",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-sakura-6960.png?v=1747231257",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-sakura-6961.png?v=1747231260",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-sakura-6962.png?v=1747231264",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-sakura-6963.png?v=1747231268",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-sakura-6964.png?v=1747231271",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-sakura-6965.jpg?v=1747231273"
    ],
    "price": "11385.00",
    "sku": "LP145-00SK00E-0000",
    "tags": [
      "Lavabo",
      "Loop",
      "Sakura",
      "Tezgah Üstü Lavabo",
      "Tezgahüstü",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843180130601,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP145-00SK00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11385.00",
        "grams": 0,
        "compare_at_price": "15180.00",
        "position": 1,
        "product_id": 9589510045993,
        "created_at": "2026-03-17T12:44:47+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz modern sanat galerisine dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9589509357865",
    "brand": "Creavit",
    "title": "Loop Yuvarlak Masa Üstü Çanak Lavabo Ø45 cm Extra Mint",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-mint-6951.png?v=1747231224",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-mint-6951.png?v=1747231224",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-mint-6952.png?v=1747231227",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-mint-6953.png?v=1747231231",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-mint-6954.png?v=1747231234",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-mint-6955.png?v=1747231238",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-mint-6956.png?v=1747231241",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-mint-6957.jpg?v=1747231244"
    ],
    "price": "11385.00",
    "sku": "LP145-00MT00E-0000",
    "tags": [
      "Lavabo",
      "Loop",
      "Mint",
      "Tezgah Üstü Lavabo",
      "Tezgahüstü",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843179966761,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP145-00MT00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11385.00",
        "grams": 0,
        "compare_at_price": "15180.00",
        "position": 1,
        "product_id": 9589509357865,
        "created_at": "2026-03-17T12:44:43+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz modern sanat galerisine dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9589505032489",
    "brand": "Creavit",
    "title": "Loop Yuvarlak Masa Üstü Çanak Lavabo Ø45 cm Nil Yeşili",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-nil-yesili-6943.png?v=1747231192",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-nil-yesili-6943.png?v=1747231192",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-nil-yesili-6944.png?v=1747231195",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-nil-yesili-6945.png?v=1747231198",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-nil-yesili-6946.png?v=1747231201",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-nil-yesili-6947.png?v=1747231206",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-nil-yesili-6948.png?v=1747231211",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-nil-yesili-6949.jpg?v=1747231213"
    ],
    "price": "11385.00",
    "sku": "LP145-00NY00E-0000",
    "tags": [
      "Lavabo",
      "Loop",
      "Nil Yeşili",
      "Tezgah Üstü Lavabo",
      "Tezgahüstü",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843179835689,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP145-00NY00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11385.00",
        "grams": 0,
        "compare_at_price": "15180.00",
        "position": 1,
        "product_id": 9589505032489,
        "created_at": "2026-03-17T12:44:40+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz modern sanat galerisine dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9589499953449",
    "brand": "Creavit",
    "title": "Loop Yuvarlak Masa Üstü Çanak Lavabo Ø45 cm Extra Berry",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-berry-6935.png?v=1747231162",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-berry-6935.png?v=1747231162",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-berry-6936.png?v=1747231165",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-berry-6937.png?v=1747231169",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-berry-6938.png?v=1747231172",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-berry-6939.png?v=1747231176",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-berry-6940.png?v=1747231179",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-berry-6941.jpg?v=1747231181"
    ],
    "price": "11385.00",
    "sku": "LP145-00BR00E-0000",
    "tags": [
      "Berry",
      "Lavabo",
      "Loop",
      "Tezgah Üstü Lavabo",
      "Tezgahüstü",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843179508009,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP145-00BR00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11385.00",
        "grams": 0,
        "compare_at_price": "15180.00",
        "position": 1,
        "product_id": 9589499953449,
        "created_at": "2026-03-17T12:44:37+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz modern sanat galerisine dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9589492810025",
    "brand": "Creavit",
    "title": "Loop Yuvarlak Masa Üstü Çanak Lavabo Ø45 cm Extra Cool Grey",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-cool-grey-6927.png?v=1747231133",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-cool-grey-6927.png?v=1747231133",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-cool-grey-6928.png?v=1747231136",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-cool-grey-6929.png?v=1747231139",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-cool-grey-6930.png?v=1747231143",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-cool-grey-6931.png?v=1747231146",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-cool-grey-6932.png?v=1747231149",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-cool-grey-6933.jpg?v=1747231151"
    ],
    "price": "11385.00",
    "sku": "LP145-00CG00E-0000",
    "tags": [
      "Cool Grey",
      "Lavabo",
      "Loop",
      "Tezgah Üstü Lavabo",
      "Tezgahüstü",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843179376937,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP145-00CG00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11385.00",
        "grams": 0,
        "compare_at_price": "15180.00",
        "position": 1,
        "product_id": 9589492810025,
        "created_at": "2026-03-17T12:44:34+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz modern sanat galerisine dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9588642152745",
    "brand": "Creavit",
    "title": "Loop Yuvarlak Masa Üstü Çanak Lavabo Ø45 cm Extra Mat Beyaz",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-mat-beyaz-6917.png?v=1747231090",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-mat-beyaz-6917.png?v=1747231090",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-mat-beyaz-6918.png?v=1747231093",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-mat-beyaz-6919.png?v=1747231096",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-masa-ustu-canak-lavabo-45-cm-extra-mat-beyaz-6920.png?v=1747231100"
    ],
    "price": "6570.00",
    "sku": "LP145-00MB00E-0000",
    "tags": [
      "Lavabo",
      "Loop",
      "Mat Beyaz",
      "Tezgah Üstü Lavabo",
      "Tezgahüstü",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52920615338281,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP145-00MB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6570.00",
        "grams": 0,
        "compare_at_price": "8760.00",
        "position": 1,
        "product_id": 9588642152745,
        "created_at": "2026-04-03T10:52:18+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz modern sanat galerisine dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-9587389333801",
    "brand": "Creavit",
    "title": "Duck Duroplast Yavaş Kapanan Klozet Kapağı Nil Yeşili",
    "category": "Duroplast Klozet Kapakları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-nil-yesili-6752.png?v=1747806121",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-nil-yesili-6752.png?v=1747806121",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-nil-yesili-6753.png?v=1747806121"
    ],
    "price": "7350.00",
    "sku": "KC0903.01.2000E",
    "tags": [
      "duck",
      "duroplast",
      "kapak",
      "klozet kapağı",
      "Nil Yeşili",
      "tak-çıkar",
      "yavaş kapama",
      "yaz-25-indirim",
      "Yuvarlak"
    ],
    "variants": [
      {
        "id": 52843209326889,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KC0903.01.2000E",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7350.00",
        "grams": 0,
        "compare_at_price": "10500.00",
        "position": 1,
        "product_id": 9587389333801,
        "created_at": "2026-03-17T12:53:33+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<p><strong>Pratik Kullanım:</strong> Tek hareket ile zorlanmadan çıkartılabilen tak-çıkar kapak özellikli Creavit klozet kapakları ile temizlik sırasında tüm yüzeyler kolayca temizlenir. </p>\r\n<p><span><strong>Antibakteriyel Malzeme: </strong>Antibakteriyel Duroplast malzeme ile klozet kapağı üzerinde bakteri ve mikropların üremesi önlenerek banyonuzun daha hijyenik ve temiz olması sağlanır. Amasra Ultima Duroplast Yavaş Kapanan Klozet Kapağı ile uzun ömürlü kullanım ve kolay temizlik elde edeceksiniz.</span></p>\r\n<p><strong>Yavaş Kapanan Kapak:</strong> Creavit Amasra Ultima Klozet Kapağı yavaş kapanma özelliği sayesinde sessiz ve  nazikçe kapanır. Ani çarpmaları ve gürültüyü engelleyerek rahatlatıcı bir banyo deneyiminin tadını çıkarmanıza yardımcı olur.</p>"
  },
  {
    "id": "creavit-9587385991465",
    "brand": "Creavit",
    "title": "Duck Duroplast Yavaş Kapanan Klozet Kapağı Cool Grey",
    "category": "Duroplast Klozet Kapakları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-cool-grey-6750.png?v=1747806125",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-cool-grey-6750.png?v=1747806125",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-cool-grey-6751.png?v=1747806125"
    ],
    "price": "7350.00",
    "sku": "KC0903.01.1800E",
    "tags": [
      "Cool Grey",
      "duck",
      "duroplast",
      "kapak",
      "klozet kapağı",
      "tak-çıkar",
      "yavaş kapama",
      "yaz-25-indirim",
      "Yuvarlak"
    ],
    "variants": [
      {
        "id": 52843209064745,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KC0903.01.1800E",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7350.00",
        "grams": 0,
        "compare_at_price": "10500.00",
        "position": 1,
        "product_id": 9587385991465,
        "created_at": "2026-03-17T12:53:30+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<p><strong>Pratik Kullanım:</strong> Tek hareket ile zorlanmadan çıkartılabilen tak-çıkar kapak özellikli Creavit klozet kapakları ile temizlik sırasında tüm yüzeyler kolayca temizlenir. </p>\r\n<p><span><strong>Antibakteriyel Malzeme: </strong>Antibakteriyel Duroplast malzeme ile klozet kapağı üzerinde bakteri ve mikropların üremesi önlenerek banyonuzun daha hijyenik ve temiz olması sağlanır. Amasra Ultima Duroplast Yavaş Kapanan Klozet Kapağı ile uzun ömürlü kullanım ve kolay temizlik elde edeceksiniz.</span></p>\r\n<p><strong>Yavaş Kapanan Kapak:</strong> Creavit Amasra Ultima Klozet Kapağı yavaş kapanma özelliği sayesinde sessiz ve  nazikçe kapanır. Ani çarpmaları ve gürültüyü engelleyerek rahatlatıcı bir banyo deneyiminin tadını çıkarmanıza yardımcı olur.</p>"
  },
  {
    "id": "creavit-9587376619817",
    "brand": "Creavit",
    "title": "Duck Duroplast Yavaş Kapanan Klozet Kapağı Mat Berry",
    "category": "Duroplast Klozet Kapakları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-mat-berry-6748.png?v=1747806132",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-mat-berry-6748.png?v=1747806132",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-mat-berry-6749.png?v=1747806133"
    ],
    "price": "7350.00",
    "sku": "KC0903.01.1900E",
    "tags": [
      "Berry",
      "duck",
      "duroplast",
      "kapak",
      "klozet kapağı",
      "tak-çıkar",
      "yavaş kapama",
      "yaz-25-indirim",
      "Yuvarlak"
    ],
    "variants": [
      {
        "id": 52843208769833,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KC0903.01.1900E",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7350.00",
        "grams": 0,
        "compare_at_price": "10500.00",
        "position": 1,
        "product_id": 9587376619817,
        "created_at": "2026-03-17T12:53:27+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<p><strong>Pratik Kullanım:</strong> Tek hareket ile zorlanmadan çıkartılabilen tak-çıkar kapak özellikli Creavit klozet kapakları ile temizlik sırasında tüm yüzeyler kolayca temizlenir. </p>\r\n<p><span><strong>Antibakteriyel Malzeme: </strong>Antibakteriyel Duroplast malzeme ile klozet kapağı üzerinde bakteri ve mikropların üremesi önlenerek banyonuzun daha hijyenik ve temiz olması sağlanır. Amasra Ultima Duroplast Yavaş Kapanan Klozet Kapağı ile uzun ömürlü kullanım ve kolay temizlik elde edeceksiniz.</span></p>\r\n<p><strong>Yavaş Kapanan Kapak:</strong> Creavit Amasra Ultima Klozet Kapağı yavaş kapanma özelliği sayesinde sessiz ve  nazikçe kapanır. Ani çarpmaları ve gürültüyü engelleyerek rahatlatıcı bir banyo deneyiminin tadını çıkarmanıza yardımcı olur.</p>"
  },
  {
    "id": "creavit-9523943506217",
    "brand": "Creavit",
    "title": "Sharp Uzun Lavabo Armatürü Siyah",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-uzun-lavabo-armaturu-siyah-6604.png?v=1747229885",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-uzun-lavabo-armaturu-siyah-6604.png?v=1747229885"
    ],
    "price": "9315.00",
    "sku": "BT.SR6500S",
    "tags": [
      "Armatür",
      "Lavabo Armatürü",
      "Pirinç",
      "sessiz su akışı",
      "Sharp",
      "siyah",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843235377449,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.SR6500S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9315.00",
        "grams": 0,
        "compare_at_price": "12420.00",
        "position": 1,
        "product_id": 9523943506217,
        "created_at": "2026-03-17T13:01:48+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Şıklığı ve işlevselliği bir araya getiren Sharp Lavabo Armatürü banyonuzda estetik bir atmosfer yaratırken aynı zamanda günlük kullanımlarınızda konfor sağlar. Sharp Lavabo Armatürü'nün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizması, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle banyo deneyiminiz daha keyifli hale gelecek. Creavit armatürleri, gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>"
  },
  {
    "id": "creavit-8633550143785",
    "brand": "Creavit",
    "title": "Mio Lavabo Dolabı 45 cm Antrasit-Kansas",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-mio-lavabo-dolabi-kansas-banyo-mobilyasi.png?v=1746543786",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-mio-lavabo-dolabi-kansas-banyo-mobilyasi.png?v=1746543786",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-mio-lavabo-dolabi-banyo-mobilyasi-MI0045.00.AK-B_3e612827-e8da-40e7-9bb4-43eb0fe245ba.jpg?v=1746543786",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-mio-lavabo-dolabi-banyo-mobilyasi-MI0045.00.AK-A_2b5a3f60-5206-4663-8a5a-047cb8e514bb.jpg?v=1746543786",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-mio-lavabo-dolabi-banyo-mobilyasi-MI0045.00.AK-C_d0df7ba1-2869-4de4-922f-c626d2265b00.jpg?v=1746543786",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-mio-lavabo-dolabi-banyo-mobilyasi-MI0045.00.AK-D_14445a78-e5c5-43f0-ab50-d2f43f8990e1.jpg?v=1746543783"
    ],
    "price": "4284.00",
    "sku": "MI0045.00.AK",
    "tags": [
      "Banyo Mobilyası",
      "küçük banyolar",
      "Lavabo Dolabı",
      "mio"
    ],
    "variants": [
      {
        "id": 49625115459881,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MI0045.00.AK",
        "requires_shipping": true,
        "taxable": true,
        "featured_image": null,
        "available": false,
        "price": "4284.00",
        "grams": 0,
        "compare_at_price": "5040.00",
        "position": 1,
        "product_id": 8633550143785,
        "created_at": "2025-01-07T17:48:13+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\">Küçük ve dar banyolar için özel olarak tasarlanmış Mio Boy Dolabı işlevsellik ve şıklığı bir araya getiriyor. Sınırlı alana sahip banyolarda ek depolama ihtiyacını karşılamak üzere tasarlanan bu dolap dayanıklı malzemelerle uzun ömürlü kullanım sunarken, modern ve zarif tasarımı ile banyonuza zarif bir hava katacak.</p>\n<p data-mce-fragment=\"1\">Mio Banyo Mobilyaları hayalinizi yansıtan estetik ve karakteristik fonksiyonel ürünlerle banyonuzda büyük düşünmenizi sağlayacak. İhtiyacınıza uygun depolama seçenekleri ile banyonuzu her zaman düzenli tutun.</p>"
  },
  {
    "id": "creavit-9575379206441",
    "brand": "Creavit",
    "title": "Banyo Mobilyası Demonte Boy Dolabı Montaj Hizmeti",
    "category": "Banyo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/banyo-mobilyasi-demonte-boy-dolabi-montaj-hizmeti-6654.png?v=1747230056",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/banyo-mobilyasi-demonte-boy-dolabi-montaj-hizmeti-6654.png?v=1747230056"
    ],
    "price": "1750.00",
    "sku": "HIZMET.MBD02",
    "tags": [
      "montaj hizmeti"
    ],
    "variants": [
      {
        "id": 52436532789545,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "HIZMET.MBD02",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1750.00",
        "grams": 0,
        "compare_at_price": "1750.00",
        "position": 1,
        "product_id": 9575379206441,
        "created_at": "2026-01-13T17:25:32+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<ul>\n<li>Altyapı tesisatta kullanılan malzeme işçiliği fiyata dahil değildir.</li>\n<li>demonte ürün sökümü hariçtir.</li>\n<li>Creavit banyo mobilyası boy dolabı montaj hizmeti için yetkili servislerin sunduğu hizmetler 1 yıl garantilidir.</li>\n<li>Servis Ekipleri Pazar günleri hariç 09:00 - 18:00 saatleri arasında çalışmaktadır.</li>\n<li>Müşteri desteği taleplerine 48 saat içerisinde geri dönüş sağlanacaktır.</li>\n<li>Montaj işlemine söküm işlemi dahil değildir. Sadece takım işlemi dahildir. Sökme işlemi için servisimiz ekstradan ücret talep edebilir.</li>\n<li>Montaj işlemi tamamlandığında yetkili servisler müşteri imzasını alarak hizmet belgesinin bir kopyasını müşteriye teslim etmekle yükümlüdür.<meta charset=\"utf-8\">\n</li>\n</ul>"
  },
  {
    "id": "creavit-9575370031401",
    "brand": "Creavit",
    "title": "Banyo Mobilyası Demonte Alt Modül Montaj Hizmeti",
    "category": "Banyo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/banyo-mobilyasi-demonte-alt-modul-montaj-hizmeti-6653.png?v=1746555800",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/banyo-mobilyasi-demonte-alt-modul-montaj-hizmeti-6653.png?v=1746555800"
    ],
    "price": "3500.00",
    "sku": "HIZMET.MAM02",
    "tags": [
      "montaj hizmeti"
    ],
    "variants": [
      {
        "id": 52436532724009,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "HIZMET.MAM02",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3500.00",
        "grams": 0,
        "compare_at_price": "3500.00",
        "position": 1,
        "product_id": 9575370031401,
        "created_at": "2026-01-13T17:25:29+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<ul>\n<li>Altyapı tesisatta kullanılan malzeme işçiliği fiyata dahil değildir.</li>\n<li>Demonte ürün sökümü hariçtir. </li>\n<li>Creavit Batarya, Ara Musluk ve Lavabo Sifonu montaj bedeli içerisindedir.</li>\n<li>Montaj yapılacak mekanın hazır olması gerekmektedir.  </li>\n<li>Creavit banyo mobilyası demonte alt modül montajı için yetkili servislerin sunduğu hizmetler 1 yıl garantilidir.</li>\n<li>Montaj işlemine söküm işlemi dahil değildir. Sadece takım işlemi dahildir. Sökme işlemi için servisimiz ekstradan ücret talep edebilir.</li>\n<li>Servis Ekipleri Pazar günleri hariç 09:00 - 18:00 saatleri arasında çalışmaktadır.</li>\n<li>Müşteri desteği taleplerine 48 saat içerisinde geri dönüş sağlanacaktır.</li>\n<li>Montaj işlemi tamamlandığında yetkili servisler müşteri imzasını alarak hizmet belgesinin bir kopyasını müşteriye teslim etmekle yükümlüdür.<meta charset=\"utf-8\">\n</li>\n</ul>"
  },
  {
    "id": "creavit-9546648191273",
    "brand": "Creavit",
    "title": "D20 30 Cm Sağa Açılır Boy Dolabı Dafne Melamin Kapak (Demonte)",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-dafne-bej-melamin-boy-dolabi-30cm-banyo-mobilyasi_1.png?v=1748164529",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-dafne-bej-melamin-boy-dolabi-30cm-banyo-mobilyasi_1.png?v=1748164529",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-saga-acilir-boy-dolabi-dafne-melamin-kapak-demonte-6649.jpg?v=1748164529",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-saga-acilir-boy-dolabi-dafne-melamin-kapak-demonte-6650.jpg?v=1748164529",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-saga-acilir-boy-dolabi-dafne-melamin-kapak-demonte-6651.jpg?v=1748164529",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-saga-acilir-boy-dolabi-dafne-melamin-kapak-demonte-6652.jpg?v=1748164529"
    ],
    "price": "9735.00",
    "sku": "D.D20.BD030.SAG.ML.DAF",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "Beyaz",
      "boy dolabı",
      "D20",
      "Melamin",
      "Sağ Boy Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843192516905,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.BD030.SAG.ML.DAF",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9735.00",
        "grams": 0,
        "compare_at_price": "12980.00",
        "position": 1,
        "product_id": 9546648191273,
        "created_at": "2026-03-17T12:48:20+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span><strong></strong></p>"
  },
  {
    "id": "creavit-9546604347689",
    "brand": "Creavit",
    "title": "D20 65 Cm Kapaklı Lavabo Dolabı Antrasit Lake Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-antrasit-lake-lavabo-dolabi-kapakli-65cm.png?v=1748164584",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-antrasit-lake-lavabo-dolabi-kapakli-65cm.png?v=1748164584",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-kapakli-lavabo-dolabi-antrasit-lake-kapak-6646.jpg?v=1748164584",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-kapakli-lavabo-dolabi-antrasit-lake-kapak-6647.jpg?v=1748164584",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-kapakli-lavabo-dolabi-antrasit-lake-kapak-6645.jpg?v=1748164584",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-kapakli-lavabo-dolabi-antrasit-lake-kapak-6648.jpg?v=1748164580"
    ],
    "price": "13992.00",
    "sku": "D.D20.LD065.KPK.LK.ANT",
    "tags": [
      "%10 indirim Yaz",
      "Antrasit",
      "Banyo Mobilyası",
      "D20",
      "kapaklı lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52920978243881,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD065.KPK.LK.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "13992.00",
        "grams": 0,
        "compare_at_price": "17490.00",
        "position": 1,
        "product_id": 9546604347689,
        "created_at": "2026-04-03T12:18:04+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523961921833",
    "brand": "Creavit",
    "title": "Vega Eviye-mutfak Bataryası",
    "category": "Mutfak Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vega-eviye-mutfak-bataryasi-6611.png?v=1747229931",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vega-eviye-mutfak-bataryasi-6611.png?v=1747229931"
    ],
    "price": "6075.00",
    "sku": "BT.VG8640",
    "tags": [
      "Armatür",
      "krom",
      "mutfak",
      "Mutfak Armatürü",
      "Vega",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843235737897,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.VG8640",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6075.00",
        "grams": 0,
        "compare_at_price": "8100.00",
        "position": 1,
        "product_id": 9523961921833,
        "created_at": "2026-03-17T13:01:58+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Şıklığı ve işlevselliği bir araya getiren Vega Mutfak Armatürü mutfağınızda estetik bir atmosfer yaratırken aynı zamanda günlük kullanımlarınızda konfor sağlar. Vega Mutfak Armatürünün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizmasi, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle mutfak deneyiminiz daha keyifli hale gelecek. Ayrıca döner borulu yapısı bulaşık yıkarken ve lavabo temizliğinde kolaylık sağlar. Creavit armatürleri gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p><!---->"
  },
  {
    "id": "creavit-9523961528617",
    "brand": "Creavit",
    "title": "Vega Banyo Armatürü",
    "category": "Banyo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vega-banyo-armaturu-6610.jpg?v=1747229924",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vega-banyo-armaturu-6610.jpg?v=1747229924"
    ],
    "price": "6120.00",
    "sku": "BT.VG2840",
    "tags": [
      "Armatür",
      "Banyo",
      "banyo armatürü",
      "Krom",
      "sessiz su akışı",
      "Vega",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843235639593,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.VG2840",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6120.00",
        "grams": 0,
        "compare_at_price": "8160.00",
        "position": 1,
        "product_id": 9523961528617,
        "created_at": "2026-03-17T13:01:54+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-vfjev-79elbk h-full dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-vfjev-1n7m0yu\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-col text-sm dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"group w-full text-gray-800 dark:text-gray-100 border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-mce-fragment=\"1\">\r\n<div class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\" data-mce-fragment=\"1\">\r\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-grow flex-col gap-3\" data-mce-fragment=\"1\">\r\n<div class=\"min-h-[20px] flex items-start overflow-x-auto whitespace-pre-wrap break-words\" data-mce-fragment=\"1\">\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p>Şıklığı ve işlevselliği bir araya getiren Vega Banyo Armatürü banyonuzda estetik bir atmosfer yaratırken aynı zamanda günlük kullanımlarınızda konfor sağlar. Vega Banyo Armatürü'nün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizmasi, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle banyo deneyiminiz daha keyifli hale gelecek. Creavit armatürleri, gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>\n<span><br></span>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9523959267625",
    "brand": "Creavit",
    "title": "Vega Lavabo Armatürü",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vega-lavabo-armaturu-6609.png?v=1747229916",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vega-lavabo-armaturu-6609.png?v=1747229916",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/vega-lavabo-armaturu-6612.jpg?v=1747229918"
    ],
    "price": "4837.50",
    "sku": "BT.VG1840",
    "tags": [
      "Armatür",
      "Banyo",
      "Krom",
      "Lavabo Armatürü",
      "Vega",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843235508521,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.VG1840",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "4837.50",
        "grams": 0,
        "compare_at_price": "6450.00",
        "position": 1,
        "product_id": 9523959267625,
        "created_at": "2026-03-17T13:01:51+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Vega Lavabo Armatürü %100 Pirinç; Çıkış Ucu uzunluğu 115 Mm.; Çıkış Ucu Yüksekliği 92 Mm.; Uzun Ömürlü 35 Mm Ayaklı Seramik Kartuş; Sessiz Su Akışı Sağlayan Perlatör;</p>"
  },
  {
    "id": "creavit-9523951108393",
    "brand": "Creavit",
    "title": "Luna Mutfak Armatürü",
    "category": "Mutfak Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/luna-mutfak-armaturu-6607.png?v=1747229900",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/luna-mutfak-armaturu-6607.png?v=1747229900"
    ],
    "price": "4455.00",
    "sku": "BT.LN8500",
    "tags": [
      "Armatür",
      "krom",
      "Luna",
      "mutfak",
      "Mutfak Armatürü",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52933781520681,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.LN8500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "4455.00",
        "grams": 0,
        "compare_at_price": "5940.00",
        "position": 1,
        "product_id": 9523951108393,
        "created_at": "2026-04-05T22:05:16+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Şıklığı ve işlevselliği bir araya getiren Luna Mutfak Armatürü mutfağınızda estetik bir atmosfer yaratırken aynı zamanda günlük kullanımlarınızda konfor sağlar. Luna Mutfak Armatürünün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizmasi, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle mutfak deneyiminiz daha keyifli hale gelecek. Ayrıca döner borulu yapısı bulaşık yıkarken ve lavabo temizliğinde kolaylık sağlar. Creavit armatürleri gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p><!---->"
  },
  {
    "id": "creavit-9523949797673",
    "brand": "Creavit",
    "title": "Luna Banyo Armatürü",
    "category": "Banyo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-luna-banyo-armaturu.png?v=1756899321",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-luna-banyo-armaturu.png?v=1756899321"
    ],
    "price": "5085.00",
    "sku": "BT.LN2500",
    "tags": [
      "Armatür",
      "Banyo",
      "banyo armatürü",
      "Krom",
      "Luna",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52933781389609,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.LN2500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5085.00",
        "grams": 0,
        "compare_at_price": "6780.00",
        "position": 1,
        "product_id": 9523949797673,
        "created_at": "2026-04-05T22:05:13+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Şıklığı ve işlevselliği bir araya getiren Luna Banyo Armatürü banyonuzda estetik bir atmosfer yaratırken aynı zamanda günlük kullanımlarınızda konfor sağlar. Luna Banyo Armatürü'nün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizmasi, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle banyo deneyiminiz daha keyifli hale gelecek. Creavit armatürleri, gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>"
  },
  {
    "id": "creavit-9523948126505",
    "brand": "Creavit",
    "title": "Luna Lavabo Armatürü Krom",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/24_434409b3-49b3-4b95-886e-51b5a9ae026e.png?v=1756818702",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/24_434409b3-49b3-4b95-886e-51b5a9ae026e.png?v=1756818702",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/25_0b16c0e9-9e6d-4285-a438-96e744c49aca.png?v=1756818702"
    ],
    "price": "3645.00",
    "sku": "BT.LN1500",
    "tags": [
      "Armatür",
      "Banyo",
      "Krom",
      "Lavabo Armatürü",
      "Luna",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52933781258537,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.LN1500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3645.00",
        "grams": 0,
        "compare_at_price": "4860.00",
        "position": 1,
        "product_id": 9523948126505,
        "created_at": "2026-04-05T22:05:09+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\" data-mce-fragment=\"1\">\n<div class=\"react-scroll-to-bottom--css-vfjev-79elbk h-full dark:bg-gray-800\" data-mce-fragment=\"1\">\n<div class=\"react-scroll-to-bottom--css-vfjev-1n7m0yu\" data-mce-fragment=\"1\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\" data-mce-fragment=\"1\">\n<div class=\"group w-full text-gray-800 dark:text-gray-100 border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-mce-fragment=\"1\">\n<div class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\" data-mce-fragment=\"1\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\" data-mce-fragment=\"1\">\n<div class=\"flex flex-grow flex-col gap-3\" data-mce-fragment=\"1\">\n<div class=\"min-h-[20px] flex items-start overflow-x-auto whitespace-pre-wrap break-words\" data-mce-fragment=\"1\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\n<p>Şıklığı ve işlevselliği bir araya getiren Luna Lavabo Armatürü banyonuzda estetik bir atmosfer yaratırken aynı zamanda günlük kullanımlarınızda konfor sağlar. Luna Lavabo Armatürü'nün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizmasi, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle banyo deneyiminiz daha keyifli hale gelecek. Creavit armatürleri, gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9523941998889",
    "brand": "Creavit",
    "title": "Sharp Uzun Lavabo Armatürü",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-uzun-lavabo-armaturu-6603.png?v=1747229878",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-uzun-lavabo-armaturu-6603.png?v=1747229878"
    ],
    "price": "7695.00",
    "sku": "BT.SR6500",
    "tags": [
      "Armatür",
      "Krom",
      "Lavabo Armatürü",
      "Pirinç",
      "sessiz su akışı",
      "Sharp",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52890669842729,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.SR6500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7695.00",
        "grams": 0,
        "compare_at_price": "10260.00",
        "position": 1,
        "product_id": 9523941998889,
        "created_at": "2026-03-28T12:54:58+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Şıklığı ve işlevselliği bir araya getiren Sharp Lavabo Armatürü banyonuzda estetik bir atmosfer yaratırken aynı zamanda günlük kullanımlarınızda konfor sağlar. Sharp Lavabo Armatürü'nün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizması, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle banyo deneyiminiz daha keyifli hale gelecek. Creavit armatürleri, gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>"
  },
  {
    "id": "creavit-9523933380905",
    "brand": "Creavit",
    "title": "Lua Uzun Lavabo Armatürü Metalik Gri",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-uzun-lavabo-armaturu-metalik-gri-6594.png?v=1747229838",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-uzun-lavabo-armaturu-metalik-gri-6594.png?v=1747229838",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-uzun-lavabo-armaturu-metalik-gri-6595.jpg?v=1747229840",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-uzun-lavabo-armaturu-metalik-gri-6596.jpg?v=1747229842"
    ],
    "price": "12105.00",
    "sku": "BT.LU6500GR",
    "tags": [
      "Armatür",
      "Banyo",
      "Lavabo Armatürü",
      "Lua",
      "Metalik Gri",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843327357225,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.LU6500GR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "12105.00",
        "grams": 0,
        "compare_at_price": "16140.00",
        "position": 1,
        "product_id": 9523933380905,
        "created_at": "2026-03-17T13:38:38+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Creavit Lua Duşta, Banyoda, Mutfakta!</strong></p>\r\n<p>Lua<strong> </strong>Armatür serisi özel olarak tasarlanan ideal su çıkış ucu eğimiyle suyun şelale görünümünde akmasını sağlar. Şık ve minimalist çizgileriyle banyo dekorasyonunuza sofistike bir dokunuş katar. Lua armatür serisi hızlı ve kolay bir şekilde monte edilir. Standart armatür deliği ölçüleriyle uyumludur. Çoğu lavabo veya tezgaha rahatlıkla takılabilir. Creavit armatürleri gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p><!---->"
  },
  {
    "id": "creavit-9523928039721",
    "brand": "Creavit",
    "title": "Flow Uzun Lavabo Armatürü",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/flow-uzun-lavabo-armaturu-6590.png?v=1747229830",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/flow-uzun-lavabo-armaturu-6590.png?v=1747229830"
    ],
    "price": "8370.00",
    "sku": "BT.FL6500",
    "tags": [
      "Armatür",
      "Banyo",
      "Flow",
      "Krom",
      "Lavabo Armatürü",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843234984233,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.FL6500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8370.00",
        "grams": 0,
        "compare_at_price": "11160.00",
        "position": 1,
        "product_id": 9523928039721,
        "created_at": "2026-03-17T13:01:38+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-vfjev-79elbk h-full dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-vfjev-1n7m0yu\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-col text-sm dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"group w-full text-gray-800 dark:text-gray-100 border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-mce-fragment=\"1\">\r\n<div class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\" data-mce-fragment=\"1\">\r\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-grow flex-col gap-3\" data-mce-fragment=\"1\">\r\n<div class=\"min-h-[20px] flex items-start overflow-x-auto whitespace-pre-wrap break-words\" data-mce-fragment=\"1\">\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p>Şıklığı ve işlevselliği bir araya getiren Flow Lavabo Armatürü banyonuzda estetik bir atmosfer yaratırken aynı zamanda günlük kullanımlarınızda konfor sağlar. Flow Lavabo Armatürü'nün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizmasi, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle banyo deneyiminiz daha keyifli hale gelecek. Creavit armatürleri, gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-9523926761769",
    "brand": "Creavit",
    "title": "Alfa Uzun Lavabo Armatürü Siyah",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/alfa-uzun-lavabo-armaturu-siyah-6587.png?v=1747229816",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/alfa-uzun-lavabo-armaturu-siyah-6587.png?v=1747229816",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/alfa-uzun-lavabo-armaturu-siyah-6588.png?v=1747229819",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/alfa-uzun-lavabo-armaturu-siyah-6589.png?v=1747229823"
    ],
    "price": "9000.00",
    "sku": "BT.AL6500S",
    "tags": [
      "Alfa",
      "Armatür",
      "Banyo",
      "Lavabo Armatürü",
      "siyah",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843241898281,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.AL6500S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9000.00",
        "grams": 0,
        "compare_at_price": "12000.00",
        "position": 1,
        "product_id": 9523926761769,
        "created_at": "2026-03-17T13:04:09+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"product-description\">\n<p>Creavit'in <strong>Alfa serisine</strong> ait <strong>BT.AL6500S</strong> modeli, çanak lavabolar için özel olarak tasarlanmış uzun lavabo bataryasıdır. Modern tasarımı ve fonksiyonelliğiyle banyonuza estetik bir dokunuş katmak isteyenler için ideal bir tercihtir.</p>\n<hr>\n<h3>Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Model Kodu:</strong> BT.AL6500S</li>\n<li>\n<strong>Seri:</strong> Alfa</li>\n<li>\n<strong>Malzeme:</strong> %100 pirinç</li>\n<li>\n<strong>Kaplama:</strong> Mat Siyah</li>\n<li>\n<strong>Renk: </strong>Mat Siyah</li>\n<li>\n<strong>Armatür Tipi:</strong> Tek kumandalı miks armatür</li>\n<li>\n<strong>Montaj Tipi:</strong> Tezgah üstü montaj (dikey düzlem)</li>\n<li>\n<strong>Kartuş:</strong> Uzun ömürlü 26 mm seramik kartuş</li>\n<li>\n<strong>Su Akış Debisi:</strong> 7–8 litre/dakika</li>\n<li>\n<strong>Çıkış Ucu Uzunluğu:</strong> 160 mm</li>\n<li>\n<strong>Çıkış Ucu Yüksekliği:</strong> 212 mm</li>\n<li>\n<strong>Boru:</strong> Sabit</li>\n<li>\n<strong>Şekil:</strong> Kare</li>\n<li>\n<strong>Su Girişi:</strong> Sıcak ve soğuk su için çift giriş</li>\n<li>\n<strong>Garanti Süresi:</strong> 5 yıl</li>\n</ul>\n<hr>\n<h3>Öne Çıkan Özellikler</h3>\n<ul>\n<li>\n<strong>Modern Tasarım:</strong> Minimalist ve şık hatlarıyla banyonuza estetik bir dokunuş katar.</li>\n<li>\n<strong>Dayanıklı Malzeme:</strong> %100 pirinç gövde, uzun ömürlü kullanım sağlar.</li>\n<li>\n<strong>Seramik Kartuş:</strong> Sıcaklık ve su debisi ayarlarını hassas bir şekilde yapar, uzun ömürlüdür.</li>\n<li>\n<strong>Kolay Montaj:</strong> Tezgah üstü montaj ile pratik kurulum imkanı sunar.</li>\n</ul>\n<hr>\n<h3>Paket İçeriği</h3>\n<ul>\n<li>Creavit AL6500S Alfa Uzun Siyah Lavabo Bataryası</li>\n<li>3/8\" - M10 - 50 cm fleks hortumlar ve sabitleme aparatları</li>\n<li>Kullanım ve bakım kılavuzu</li>\n</ul>\n<hr>\n<p><strong>Creavit AL6500 Alfa Uzun Lavabo Bataryası</strong>, şıklığı, dayanıklılığı ve fonksiyonelliğiyle banyonuza modern bir atmosfer katmak isteyenler için ideal bir tercihtir. Krom kaplama ve seramik kartuş gibi özellikleri sayesinde uzun ömürlü ve kullanıcı dostudur.</p>\n</div>"
  },
  {
    "id": "creavit-9523925909801",
    "brand": "Creavit",
    "title": "Alfa Uzun Lavabo Armatürü",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/alfa-uzun-lavabo-armaturu-6586.png?v=1747229808",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/alfa-uzun-lavabo-armaturu-6586.png?v=1747229808"
    ],
    "price": "8370.00",
    "sku": "BT.AL6500",
    "tags": [
      "Alfa",
      "Armatür",
      "Banyo",
      "Krom",
      "Lavabo Armatürü",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843236000041,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.AL6500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8370.00",
        "grams": 0,
        "compare_at_price": "11160.00",
        "position": 1,
        "product_id": 9523925909801,
        "created_at": "2026-03-17T13:02:04+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"product-description\">\n<p>Creavit'in <strong>Alfa serisine</strong> ait <strong>BT.AL6500</strong> modeli, çanak lavabolar için özel olarak tasarlanmış uzun lavabo bataryasıdır. Modern tasarımı ve fonksiyonelliğiyle banyonuza estetik bir dokunuş katmak isteyenler için ideal bir tercihtir.</p>\n<hr>\n<h3>🛠️ Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Model Kodu:</strong> BT.AL6500</li>\n<li>\n<strong>Seri:</strong> Alfa</li>\n<li>\n<strong>Malzeme:</strong> %100 pirinç</li>\n<li>\n<strong>Kaplama:</strong> Krom </li>\n<li>\n<strong>Renk: </strong>Krom</li>\n<li>\n<strong>Armatür Tipi:</strong> Tek kumandalı miks armatür</li>\n<li>\n<strong>Montaj Tipi:</strong> Tezgah üstü montaj (dikey düzlem)</li>\n<li>\n<strong>Kartuş:</strong> Uzun ömürlü 26 mm seramik kartuş</li>\n<li>\n<strong>Su Akış Debisi:</strong> 7–8 litre/dakika</li>\n<li>\n<strong>Çıkış Ucu Uzunluğu:</strong> 160 mm</li>\n<li>\n<strong>Çıkış Ucu Yüksekliği:</strong> 212 mm</li>\n<li>\n<strong>Boru:</strong> Sabit</li>\n<li>\n<strong>Şekil:</strong> Kare</li>\n<li>\n<strong>Su Girişi:</strong> Sıcak ve soğuk su için çift giriş</li>\n<li>\n<strong>Garanti Süresi:</strong> 5 yıl</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>\n<strong>Modern Tasarım:</strong> Minimalist ve şık hatlarıyla banyonuza estetik bir dokunuş katar.</li>\n<li>\n<strong>Dayanıklı Malzeme:</strong> %100 pirinç gövde, uzun ömürlü kullanım sağlar.</li>\n<li>\n<strong>Seramik Kartuş:</strong> Sıcaklık ve su debisi ayarlarını hassas bir şekilde yapar, uzun ömürlüdür.</li>\n<li>\n<strong>Kolay Montaj:</strong> Tezgah üstü montaj ile pratik kurulum imkanı sunar.</li>\n</ul>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>Creavit AL6500 Alfa Uzun Lavabo Bataryası</li>\n<li>3/8\" - M10 - 50 cm fleks hortumlar ve sabitleme aparatları</li>\n<li>Kullanım ve bakım kılavuzu</li>\n</ul>\n<hr>\n<p><strong>Creavit AL6500 Alfa Uzun Lavabo Bataryası</strong>, şıklığı, dayanıklılığı ve fonksiyonelliğiyle banyonuza modern bir atmosfer katmak isteyenler için ideal bir tercihtir. Krom kaplama ve seramik kartuş gibi özellikleri sayesinde uzun ömürlü ve kullanıcı dostudur.</p>\n</div>"
  },
  {
    "id": "creavit-9523843367209",
    "brand": "Creavit",
    "title": "D20 100 Cm Kapaklı Lavabo Dolabı Everest Melamin",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-everest-melamin-lavabo-dolabi-kapakli-100cm.png?v=1748164647",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-everest-melamin-lavabo-dolabi-kapakli-100cm.png?v=1748164647",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-kapakli-lavabo-dolabi-everest-melamin-6584.jpg?v=1748164647",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-kapakli-lavabo-dolabi-everest-melamin-6583.jpg?v=1748164647",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-kapakli-lavabo-dolabi-everest-melamin-6582.jpg?v=1748164647",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-kapakli-lavabo-dolabi-everest-melamin-6585.jpg?v=1748164644"
    ],
    "price": "12045.00",
    "sku": "D.D20.LD100.KPK.ML.EVR",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "D20",
      "Everest",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843200610601,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD100.KPK.ML.EVR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "12045.00",
        "grams": 0,
        "compare_at_price": "16060.00",
        "position": 1,
        "product_id": 9523843367209,
        "created_at": "2026-03-17T12:51:07+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523842416937",
    "brand": "Creavit",
    "title": "D20 100 Cm Kapaklı Lavabo Dolabı Dafne Melamin Kapak (Demonte)",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-dafne-melamin-lavabo-dolabi-kapakli-100cm_4d99f585-c5eb-48d5-9e70-cdcadd872e6b.png?v=1748164805",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-dafne-melamin-lavabo-dolabi-kapakli-100cm_4d99f585-c5eb-48d5-9e70-cdcadd872e6b.png?v=1748164805",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-kapakli-lavabo-dolabi-dafne-melamin-kapak-6578.jpg?v=1748164805",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-kapakli-lavabo-dolabi-dafne-melamin-kapak-6580.jpg?v=1748164805",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-kapakli-lavabo-dolabi-dafne-melamin-kapak-6579.jpg?v=1748164805",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-kapakli-lavabo-dolabi-dafne-melamin-kapak-6577.jpg?v=1748164805",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-kapakli-lavabo-dolabi-dafne-melamin-kapak-6581.jpg?v=1748164805"
    ],
    "price": "12045.00",
    "sku": "D.D20.LD100.KPK.ML.DAF",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "D20",
      "Dafne",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843194286377,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD100.KPK.ML.DAF",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "12045.00",
        "grams": 0,
        "compare_at_price": "16060.00",
        "position": 1,
        "product_id": 9523842416937,
        "created_at": "2026-03-17T12:48:57+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523841564969",
    "brand": "Creavit",
    "title": "D20 100 Cm Kapaklı Lavabo Dolabı Beyaz Melamin Kapak (Demonte)",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-beyaz-melamin-lavabo-dolabi-kapakli-100cm.png?v=1748164866",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-beyaz-melamin-lavabo-dolabi-kapakli-100cm.png?v=1748164866",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-kapakli-lavabo-dolabi-beyaz-melamin-kapak-6575.jpg?v=1748164866",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-kapakli-lavabo-dolabi-beyaz-melamin-kapak-6574.jpg?v=1748164866",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-kapakli-lavabo-dolabi-beyaz-melamin-kapak-6573.jpg?v=1748164866",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-kapakli-lavabo-dolabi-beyaz-melamin-kapak-6576.jpg?v=1748164859"
    ],
    "price": "12045.00",
    "sku": "D.D20.LD100.KPK.ML.BYZ",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "Beyaz",
      "D20",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843238457641,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD100.KPK.ML.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "12045.00",
        "grams": 0,
        "compare_at_price": "16060.00",
        "position": 1,
        "product_id": 9523841564969,
        "created_at": "2026-03-17T13:02:58+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523839795497",
    "brand": "Creavit",
    "title": "D20 100 Cm Kapaklı Lavabo Dolabı Antrasit Melamin Kapak (Demonte)",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-antrasit-melamin-lavabo-dolabi-kapakli-100cm.png?v=1748164917",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-antrasit-melamin-lavabo-dolabi-kapakli-100cm.png?v=1748164917",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-kapakli-lavabo-dolabi-antrasit-melamin-6571.jpg?v=1748164917",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-kapakli-lavabo-dolabi-antrasit-melamin-6570.jpg?v=1748164917",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-kapakli-lavabo-dolabi-antrasit-melamin-6569.jpg?v=1748164917",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-kapakli-lavabo-dolabi-antrasit-melamin-6572.jpg?v=1748164915"
    ],
    "price": "12045.00",
    "sku": "D.D20.LD100.KPK.ML.ANT",
    "tags": [
      "%10 indirim Yaz",
      "Antrasit",
      "Banyo Mobilyası",
      "D20",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52920978178345,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD100.KPK.ML.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "12045.00",
        "grams": 0,
        "compare_at_price": "16060.00",
        "position": 1,
        "product_id": 9523839795497,
        "created_at": "2026-04-03T12:18:00+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523838550313",
    "brand": "Creavit",
    "title": "D20 100 Cm Kapaklı Lavabo Dolabı Dafne Lake Kapak (Demonte)",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-dafne-lake-lavabo-dolabi-kapakli-100cm_583cb4bf-91ab-4580-9733-eac84e08205d.png?v=1748164963",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-dafne-lake-lavabo-dolabi-kapakli-100cm_583cb4bf-91ab-4580-9733-eac84e08205d.png?v=1748164963",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-kapakli-lavabo-dolabi-dafne-lake-6567.jpg?v=1748164963",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-kapakli-lavabo-dolabi-dafne-lake-6566.jpg?v=1748164963",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-kapakli-lavabo-dolabi-dafne-lake-6565.jpg?v=1748164963",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-kapakli-lavabo-dolabi-dafne-lake-6568.jpg?v=1748164959"
    ],
    "price": "16808.00",
    "sku": "D.D20.LD100.KPK.LK.DAF",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "D20",
      "Dafne",
      "kapaklı lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52920978112809,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD100.KPK.LK.DAF",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "16808.00",
        "grams": 0,
        "compare_at_price": "21010.00",
        "position": 1,
        "product_id": 9523838550313,
        "created_at": "2026-04-03T12:17:57+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523837272361",
    "brand": "Creavit",
    "title": "D20 100 Cm Kapaklı Lavabo Dolabı Beyaz Lake Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-beyaz-lake-lavabo-dolabi-kapakli-100cm.png?v=1748165020",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-beyaz-lake-lavabo-dolabi-kapakli-100cm.png?v=1748165020",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-kapakli-lavabo-dolabi-beyaz-lake-kapak-6563.jpg?v=1748165020",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-kapakli-lavabo-dolabi-beyaz-lake-kapak-6562.jpg?v=1748165020",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-kapakli-lavabo-dolabi-beyaz-lake-kapak-6561.jpg?v=1748165020",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-kapakli-lavabo-dolabi-beyaz-lake-kapak-6564.jpg?v=1748165016"
    ],
    "price": "16808.00",
    "sku": "D.D20.LD100.KPK.LK.BYZ",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "Beyaz",
      "D20",
      "kapaklı lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843199562025,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD100.KPK.LK.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "16808.00",
        "grams": 0,
        "compare_at_price": "21010.00",
        "position": 1,
        "product_id": 9523837272361,
        "created_at": "2026-03-17T12:50:58+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523836125481",
    "brand": "Creavit",
    "title": "D20 100 Cm Kapaklı Lavabo Dolabı Antrasit Lake",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-antrasit-lake-lavabo-dolabi-kapakli-100cm.png?v=1748165063",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-antrasit-lake-lavabo-dolabi-kapakli-100cm.png?v=1748165063",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-kapakli-lavabo-dolabi-antrasit-lake-6557.jpg?v=1748165063",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-kapakli-lavabo-dolabi-antrasit-lake-6558.jpg?v=1748165063",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-kapakli-lavabo-dolabi-antrasit-lake-6559.jpg?v=1748165063",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-kapakli-lavabo-dolabi-antrasit-lake-6556.jpg?v=1748165063",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-kapakli-lavabo-dolabi-antrasit-lake-6560.jpg?v=1748165058"
    ],
    "price": "16808.00",
    "sku": "D.D20.LD100.KPK.LK.ANT",
    "tags": [
      "%10 indirim Yaz",
      "Antrasit",
      "Banyo Mobilyası",
      "D20",
      "kapaklı lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52921490276649,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD100.KPK.LK.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "16808.00",
        "grams": 0,
        "compare_at_price": "21010.00",
        "position": 1,
        "product_id": 9523836125481,
        "created_at": "2026-04-03T14:45:47+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523834650921",
    "brand": "Creavit",
    "title": "D20 100 Cm İki Çekmeceli Lavabo Dolabı Everest Melamin Kapak (Demonte)",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-everest-melamin-lavabo-dolabi-cekmeceli-100cm.png?v=1748165105",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-everest-melamin-lavabo-dolabi-cekmeceli-100cm.png?v=1748165105",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-iki-cekmeceli-lavabo-dolabi-everest-melamin-kapak-6554.jpg?v=1748165105",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-iki-cekmeceli-lavabo-dolabi-everest-melamin-kapak-6553.jpg?v=1748165105",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-iki-cekmeceli-lavabo-dolabi-everest-melamin-kapak-6552.jpg?v=1748165105",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-iki-cekmeceli-lavabo-dolabi-everest-melamin-kapak-6555.jpg?v=1748165103"
    ],
    "price": "17820.00",
    "sku": "D.D20.LD100.2CK.ML.EVR",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "D20",
      "Everest",
      "iki çekmeceli lavabo dolabı",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843199398185,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD100.2CK.ML.EVR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "17820.00",
        "grams": 0,
        "compare_at_price": "23760.00",
        "position": 1,
        "product_id": 9523834650921,
        "created_at": "2026-03-17T12:50:54+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523833766185",
    "brand": "Creavit",
    "title": "D20 100 Cm İki Çekmeceli Lavabo Dolabı Dafne Melamin Kapak (Demonte)",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-dafne-melamin-lavabo-dolabi-cekmeceli-100cm.png?v=1748165170",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-dafne-melamin-lavabo-dolabi-cekmeceli-100cm.png?v=1748165170",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-iki-cekmeceli-lavabo-dolabi-dafne-melamin-kapak-demonte-6548.jpg?v=1748165170",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-iki-cekmeceli-lavabo-dolabi-dafne-melamin-kapak-demonte-6547.jpg?v=1748165170",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-iki-cekmeceli-lavabo-dolabi-dafne-melamin-kapak-demonte-6549.jpg?v=1748165170",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-iki-cekmeceli-lavabo-dolabi-dafne-melamin-kapak-demonte-6550.jpg?v=1748165170",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-iki-cekmeceli-lavabo-dolabi-dafne-melamin-kapak-demonte-6546.jpg?v=1748165161",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-iki-cekmeceli-lavabo-dolabi-dafne-melamin-kapak-demonte-6551.jpg?v=1748165151"
    ],
    "price": "17820.00",
    "sku": "D.D20.LD100.2CK.ML.DAF",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "D20",
      "Dafne",
      "iki çekmeceli lavabo dolabı",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52921485984041,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD100.2CK.ML.DAF",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "17820.00",
        "grams": 0,
        "compare_at_price": "23760.00",
        "position": 1,
        "product_id": 9523833766185,
        "created_at": "2026-04-03T14:44:52+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523832652073",
    "brand": "Creavit",
    "title": "D20 100 Cm İki Çekmeceli Lavabo Dolabı Beyaz Melamin Kapak (Demonte)",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-beyaz-melamin-lavabo-dolabi-cekmeceli-100cm.png?v=1748165216",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-beyaz-melamin-lavabo-dolabi-cekmeceli-100cm.png?v=1748165216",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-iki-cekmeceli-lavabo-dolabi-beyaz-melamin-kapak-demonte-6543.jpg?v=1748165216",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-iki-cekmeceli-lavabo-dolabi-beyaz-melamin-kapak-demonte-6544.jpg?v=1748165216",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-iki-cekmeceli-lavabo-dolabi-beyaz-melamin-kapak-demonte-6542.jpg?v=1748165216",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-iki-cekmeceli-lavabo-dolabi-beyaz-melamin-kapak-demonte-6545.jpg?v=1748165213"
    ],
    "price": "17820.00",
    "sku": "D.D20.LD100.2CK.ML.BYZ",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "Beyaz",
      "D20",
      "iki çekmeceli lavabo dolabı",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843194581289,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD100.2CK.ML.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "17820.00",
        "grams": 0,
        "compare_at_price": "23760.00",
        "position": 1,
        "product_id": 9523832652073,
        "created_at": "2026-03-17T12:49:04+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523832258857",
    "brand": "Creavit",
    "title": "D20 100 Cm İki Çekmeceli Lavabo Dolabı Antrasit Melamin Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-antrasit-melamin-lavabo-dolabi-cekmeceli-100cm.png?v=1748166122",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-antrasit-melamin-lavabo-dolabi-cekmeceli-100cm.png?v=1748166122",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-iki-cekmeceli-lv-dlb-antrasit-melamin-6540.jpg?v=1748166122",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-iki-cekmeceli-lv-dlb-antrasit-melamin-6539.jpg?v=1748166122",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-iki-cekmeceli-lv-dlb-antrasit-melamin-6538.jpg?v=1748166122",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-iki-cekmeceli-lv-dlb-antrasit-melamin-6541.jpg?v=1748166119"
    ],
    "price": "17820.00",
    "sku": "D.D20.LD100.2CK.ML.ANT",
    "tags": [
      "%10 indirim Yaz",
      "Antrasit",
      "Banyo Mobilyası",
      "D20",
      "iki çekmeceli lavabo dolabı",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843199299881,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD100.2CK.ML.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "17820.00",
        "grams": 0,
        "compare_at_price": "23760.00",
        "position": 1,
        "product_id": 9523832258857,
        "created_at": "2026-03-17T12:50:51+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523831767337",
    "brand": "Creavit",
    "title": "D20 100 Cm İki Çekmeceli Lavabo Dolabı Dafne Lake Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-dafne-lake-lavabo-dolabi-cekmeceli-100cm.png?v=1748166167",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-dafne-lake-lavabo-dolabi-cekmeceli-100cm.png?v=1748166167",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-iki-cekmeceli-lavabo-dolabi-dafne-lake-kapak-6536.jpg?v=1748166167",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-iki-cekmeceli-lavabo-dolabi-dafne-lake-kapak-6535.jpg?v=1748166167",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-iki-cekmeceli-lavabo-dolabi-dafne-lake-kapak-6534.jpg?v=1748166167",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-iki-cekmeceli-lavabo-dolabi-dafne-lake-kapak-6537.jpg?v=1748166163"
    ],
    "price": "23320.00",
    "sku": "D.D20.LD100.2CK.LK.DAF",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "D20",
      "Dafne",
      "iki çekmeceli lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843199168809,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD100.2CK.LK.DAF",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "23320.00",
        "grams": 0,
        "compare_at_price": "29150.00",
        "position": 1,
        "product_id": 9523831767337,
        "created_at": "2026-03-17T12:50:48+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523831275817",
    "brand": "Creavit",
    "title": "D20 100 Cm İki Çekmeceli Lavabo Dolabı Beyaz Lake Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-beyaz-lake-lavabo-dolabi-cekmeceli-100cm.png?v=1748166287",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-beyaz-lake-lavabo-dolabi-cekmeceli-100cm.png?v=1748166287",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-iki-cekmeceli-lavabo-dolabi-beyaz-lake-kapak-6532.jpg?v=1748166287",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-iki-cekmeceli-lavabo-dolabi-beyaz-lake-kapak-6531.jpg?v=1748166287",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-iki-cekmeceli-lavabo-dolabi-beyaz-lake-kapak-6530.jpg?v=1748166287",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-iki-cekmeceli-lavabo-dolabi-beyaz-lake-kapak-6533.jpg?v=1748166284"
    ],
    "price": "23320.00",
    "sku": "D.D20.LD100.2CK.LK.BYZ",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "Beyaz",
      "D20",
      "iki çekmeceli lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843199070505,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD100.2CK.LK.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "23320.00",
        "grams": 0,
        "compare_at_price": "29150.00",
        "position": 1,
        "product_id": 9523831275817,
        "created_at": "2026-03-17T12:50:45+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523830489385",
    "brand": "Creavit",
    "title": "D20 100 Cm İki Çekmeceli Lavabo Dolabı Antrasit Lake Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-antrasit-lake-lavabo-dolabi-cekmeceli-100cm.png?v=1748166334",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-antrasit-lake-lavabo-dolabi-cekmeceli-100cm.png?v=1748166334",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-iki-cekmeceli-lavabo-dolabi-antrasit-lake-6526.jpg?v=1748166334",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-iki-cekmeceli-lavabo-dolabi-antrasit-lake-6528.jpg?v=1748166334",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-iki-cekmeceli-lavabo-dolabi-antrasit-lake-6527.jpg?v=1748166334",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-iki-cekmeceli-lavabo-dolabi-antrasit-lake-6525.jpg?v=1748166334",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-iki-cekmeceli-lavabo-dolabi-antrasit-lake-6529.jpg?v=1748166328"
    ],
    "price": "23320.00",
    "sku": "D.D20.LD100.2CK.LK.ANT",
    "tags": [
      "%10 indirim Yaz",
      "Antrasit",
      "Banyo Mobilyası",
      "D20",
      "iki çekmeceli lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843234099497,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD100.2CK.LK.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "23320.00",
        "grams": 0,
        "compare_at_price": "29150.00",
        "position": 1,
        "product_id": 9523830489385,
        "created_at": "2026-03-17T13:01:17+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523829571881",
    "brand": "Creavit",
    "title": "D20 80 Cm Kapaklı Lavabo Dolabı Everest Melamin Kapak (Demonte)",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-everest-melamin-lavabo-dolabi-kapakli-80cm.png?v=1748166376",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-everest-melamin-lavabo-dolabi-kapakli-80cm.png?v=1748166376",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-kapakli-lavabo-dolabi-everest-melamin-kapak-6523.jpg?v=1748166376",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-kapakli-lavabo-dolabi-everest-melamin-kapak-6522.jpg?v=1748166376",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-kapakli-lavabo-dolabi-everest-melamin-kapak-6521.jpg?v=1748166376",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-kapakli-lavabo-dolabi-everest-melamin-kapak-6524.jpg?v=1748166374"
    ],
    "price": "10972.50",
    "sku": "D.D20.LD080.KPK.ML.EVR",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "D20",
      "Everest",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843198939433,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD080.KPK.ML.EVR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "10972.50",
        "grams": 0,
        "compare_at_price": "14630.00",
        "position": 1,
        "product_id": 9523829571881,
        "created_at": "2026-03-17T12:50:42+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523828425001",
    "brand": "Creavit",
    "title": "D20 80 Cm Kapaklı Lavabo Dolabı Dafne Melamin Kapak (Demonte)",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-dafne-melamin-lavabo-dolabi-kapakli-80cm.png?v=1748166429",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-dafne-melamin-lavabo-dolabi-kapakli-80cm.png?v=1748166429",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-kapakli-lavabo-dolabi-dafne-melamin-kapak-demonte-6519.jpg?v=1748166429",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-kapakli-lavabo-dolabi-dafne-melamin-kapak-demonte-6518.jpg?v=1748166429",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-kapakli-lavabo-dolabi-dafne-melamin-kapak-demonte-6517.jpg?v=1748166429",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-kapakli-lavabo-dolabi-dafne-melamin-kapak-demonte-6520.jpg?v=1748166426"
    ],
    "price": "10972.50",
    "sku": "D.D20.LD080.KPK.ML.DAF",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "D20",
      "Dafne",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52921486573865,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD080.KPK.ML.DAF",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "10972.50",
        "grams": 0,
        "compare_at_price": "14630.00",
        "position": 1,
        "product_id": 9523828425001,
        "created_at": "2026-04-03T14:44:59+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523828130089",
    "brand": "Creavit",
    "title": "D20 80 Cm Kapaklı Lavabo Dolabı Beyaz Melamin Kapak (Demonte)",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-beyaz-melamin-lavabo-dolabi-kapakli-80cm.png?v=1748166474",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-beyaz-melamin-lavabo-dolabi-kapakli-80cm.png?v=1748166474",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-kapakli-lavabo-dolabi-beyaz-melamin-kapak-demonte-6515.jpg?v=1748166474",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-kapakli-lavabo-dolabi-beyaz-melamin-kapak-demonte-6514.jpg?v=1748166474",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-kapakli-lavabo-dolabi-beyaz-melamin-kapak-demonte-6513.jpg?v=1748166474",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-kapakli-lavabo-dolabi-beyaz-melamin-kapak-demonte-6516.jpg?v=1748166471"
    ],
    "price": "10972.50",
    "sku": "D.D20.LD080.KPK.ML.BYZ",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "Beyaz",
      "D20",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843224105257,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD080.KPK.ML.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "10972.50",
        "grams": 0,
        "compare_at_price": "14630.00",
        "position": 1,
        "product_id": 9523828130089,
        "created_at": "2026-03-17T12:57:40+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523827474729",
    "brand": "Creavit",
    "title": "D20 80 Cm Kapaklı Lavabo Dolabı Antrasit Melamin Kapak (Demonte)",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-antrasit-melamin-lavabo-dolabi-kapakli-80cm.png?v=1748166520",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-antrasit-melamin-lavabo-dolabi-kapakli-80cm.png?v=1748166520",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-kapakli-lavabo-dolabi-antrasit-melamin-kapak-6510.jpg?v=1748166520",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-kapakli-lavabo-dolabi-antrasit-melamin-kapak-6511.jpg?v=1748166520",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-kapakli-lavabo-dolabi-antrasit-melamin-kapak-6509.jpg?v=1748166520",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-kapakli-lavabo-dolabi-antrasit-melamin-kapak-6512.jpg?v=1748166517"
    ],
    "price": "10972.50",
    "sku": "D.D20.LD080.KPK.ML.ANT",
    "tags": [
      "%10 indirim Yaz",
      "Antrasit",
      "Banyo Mobilyası",
      "D20",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52920978014505,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD080.KPK.ML.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "10972.50",
        "grams": 0,
        "compare_at_price": "14630.00",
        "position": 1,
        "product_id": 9523827474729,
        "created_at": "2026-04-03T12:17:54+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523825770793",
    "brand": "Creavit",
    "title": "D20 80 Cm Kapaklı Lavabo Dolabı Beyaz Lake Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-beyaz-lake-lavabo-dolabi-kapakli-80cm.png?v=1748166561",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-beyaz-lake-lavabo-dolabi-kapakli-80cm.png?v=1748166561",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-kapakli-lavabo-dolabi-beyaz-lake-6507.jpg?v=1748166561",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-kapakli-lavabo-dolabi-beyaz-lake-6506.jpg?v=1748166561",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-kapakli-lavabo-dolabi-beyaz-lake-6505.jpg?v=1748166561",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-kapakli-lavabo-dolabi-beyaz-lake-6508.jpg?v=1748166559"
    ],
    "price": "15048.00",
    "sku": "D.D20.LD080.KPK.LK.BYZ",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "Beyaz",
      "D20",
      "kapaklı lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843226005801,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD080.KPK.LK.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "15048.00",
        "grams": 0,
        "compare_at_price": "18810.00",
        "position": 1,
        "product_id": 9523825770793,
        "created_at": "2026-03-17T12:58:21+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523823542569",
    "brand": "Creavit",
    "title": "D20 80 Cm Kapaklı Lavabo Dolabı Dafne Lake",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-dafne-lake-lavabo-dolabi-kapakli-80cm.png?v=1748166594",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-dafne-lake-lavabo-dolabi-kapakli-80cm.png?v=1748166594",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-kapakli-lavabo-dolabi-dafne-lake-6503.jpg?v=1748166594",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-kapakli-lavabo-dolabi-dafne-lake-6502.jpg?v=1748166594",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-kapakli-lavabo-dolabi-dafne-lake-6501.jpg?v=1748166594",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-kapakli-lavabo-dolabi-dafne-lake-6504.jpg?v=1748166592"
    ],
    "price": "15048.00",
    "sku": "D.D20.LD080.KPK.LK.DAF",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "D20",
      "Dafne",
      "kapaklı lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52920977883433,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD080.KPK.LK.DAF",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "15048.00",
        "grams": 0,
        "compare_at_price": "18810.00",
        "position": 1,
        "product_id": 9523823542569,
        "created_at": "2026-04-03T12:17:51+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523821904169",
    "brand": "Creavit",
    "title": "D20 80 cm Kapaklı Lavabo Dolabı Antrasit Lake Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-antrasit-lake-lavabo-dolabi-kapakli-80cm.png?v=1748166647",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-antrasit-lake-lavabo-dolabi-kapakli-80cm.png?v=1748166647",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-kapakli-lavabo-dolabi-antrasit-lake-kapak-6497.jpg?v=1748166647",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-kapakli-lavabo-dolabi-antrasit-lake-kapak-6499.jpg?v=1748166647",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-kapakli-lavabo-dolabi-antrasit-lake-kapak-6498.jpg?v=1748166647",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-kapakli-lavabo-dolabi-antrasit-lake-kapak-6496.jpg?v=1748166644",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-kapakli-lavabo-dolabi-antrasit-lake-kapak-6500.jpg?v=1748166633"
    ],
    "price": "15048.00",
    "sku": "D.D20.LD080.KPK.LK.ANT",
    "tags": [
      "%10 indirim Yaz",
      "Antrasit",
      "Banyo Mobilyası",
      "D20",
      "kapaklı lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52921224266025,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD080.KPK.LK.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "15048.00",
        "grams": 0,
        "compare_at_price": "18810.00",
        "position": 1,
        "product_id": 9523821904169,
        "created_at": "2026-04-03T13:25:52+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523820626217",
    "brand": "Creavit",
    "title": "D20 80 Cm İki Çekmeceli Lavabo Dolabı Everest Melamin Kapak (Demonte)",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-everest-melamin-lavabo-dolabi-cekmeceli-80cm.png?v=1748166690",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-everest-melamin-lavabo-dolabi-cekmeceli-80cm.png?v=1748166690",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-iki-cekmeceli-lavabo-dolabi-everest-melamin-kapak-6494.jpg?v=1748166690",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-iki-cekmeceli-lavabo-dolabi-everest-melamin-kapak-6493.jpg?v=1748166690",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-iki-cekmeceli-lavabo-dolabi-everest-melamin-kapak-6492.jpg?v=1748166690",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-iki-cekmeceli-lavabo-dolabi-everest-melamin-kapak-6495.jpg?v=1748166688"
    ],
    "price": "16665.00",
    "sku": "D.D20.LD080.2CK.ML.EVR",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "D20",
      "Everest",
      "iki çekmeceli lavabo dolabı",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843279188265,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD080.2CK.ML.EVR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "16665.00",
        "grams": 0,
        "compare_at_price": "22220.00",
        "position": 1,
        "product_id": 9523820626217,
        "created_at": "2026-03-17T13:13:18+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523819249961",
    "brand": "Creavit",
    "title": "D20 80 Cm İki Çekmeceli Lavabo Dolabı Dafne Melamin (Demonte)",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-dafne-melamin-lavabo-dolabi-cekmeceli-80cm.png?v=1748166743",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-dafne-melamin-lavabo-dolabi-cekmeceli-80cm.png?v=1748166743",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-iki-cekmeceli-lav-dolabi-dafne-melamin-demonte-6490.jpg?v=1748166743",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-iki-cekmeceli-lav-dolabi-dafne-melamin-demonte-6487.jpg?v=1748166743",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-iki-cekmeceli-lav-dolabi-dafne-melamin-demonte-6488.jpg?v=1748166743",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-iki-cekmeceli-lav-dolabi-dafne-melamin-demonte-6489.jpg?v=1748166743",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-iki-cekmeceli-lav-dolabi-dafne-melamin-demonte-6486.jpg?v=1748166743",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-iki-cekmeceli-lav-dolabi-dafne-melamin-demonte-6491.jpg?v=1748166734"
    ],
    "price": "16665.00",
    "sku": "D.D20.LD080.2CK.ML.DAF",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "D20",
      "Dafne",
      "iki çekmeceli lavabo dolabı",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843195007273,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD080.2CK.ML.DAF",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "16665.00",
        "grams": 0,
        "compare_at_price": "22220.00",
        "position": 1,
        "product_id": 9523819249961,
        "created_at": "2026-03-17T12:49:13+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523818332457",
    "brand": "Creavit",
    "title": "D20 80 Cm İki Çekmeceli Lavabo Dolabı Beyaz Melamin Kapak (Demonte)",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-beyaz-melamin-lavabo-dolabi-cekmeceli-80cm.png?v=1748166802",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-beyaz-melamin-lavabo-dolabi-cekmeceli-80cm.png?v=1748166802",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-iki-cekmeceli-lavabo-dolabi-beyaz-melamin-kapak-demonte-6484.jpg?v=1748166802",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-iki-cekmeceli-lavabo-dolabi-beyaz-melamin-kapak-demonte-6483.jpg?v=1748166802",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-iki-cekmeceli-lavabo-dolabi-beyaz-melamin-kapak-demonte-6482.jpg?v=1748166802",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-iki-cekmeceli-lavabo-dolabi-beyaz-melamin-kapak-demonte-6485.jpg?v=1748166794"
    ],
    "price": "16665.00",
    "sku": "D.D20.LD080.2CK.ML.BYZ",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "Beyaz",
      "D20",
      "iki çekmeceli lavabo dolabı",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843194876201,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD080.2CK.ML.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "16665.00",
        "grams": 0,
        "compare_at_price": "22220.00",
        "position": 1,
        "product_id": 9523818332457,
        "created_at": "2026-03-17T12:49:10+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523817283881",
    "brand": "Creavit",
    "title": "D20 80 Cm İki Çekmeceli Lavabo Dolabı Antrasit Melamin Kapak (Demonte)",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-antrasit-melamin-lavabo-dolabi-cekmeceli-80cm_b7f91d17-6ea7-422e-8dcf-fd74a50bb367.png?v=1748166863",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-antrasit-melamin-lavabo-dolabi-cekmeceli-80cm_b7f91d17-6ea7-422e-8dcf-fd74a50bb367.png?v=1748166863",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-iki-cekmeceli-lav-dlb-antrasit-melamin-6480.jpg?v=1748166863",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-iki-cekmeceli-lav-dlb-antrasit-melamin-6479.jpg?v=1748166863",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-iki-cekmeceli-lav-dlb-antrasit-melamin-6478.jpg?v=1748166863",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-iki-cekmeceli-lav-dlb-antrasit-melamin-6481.jpg?v=1748166860"
    ],
    "price": "16665.00",
    "sku": "D.D20.LD080.2CK.ML.ANT",
    "tags": [
      "%10 indirim Yaz",
      "Antrasit",
      "Banyo Mobilyası",
      "D20",
      "iki çekmeceli lavabo dolabı",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843247468841,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD080.2CK.ML.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "16665.00",
        "grams": 0,
        "compare_at_price": "22220.00",
        "position": 1,
        "product_id": 9523817283881,
        "created_at": "2026-03-17T13:05:37+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523815645481",
    "brand": "Creavit",
    "title": "D20 80 Cm İki Çekmeceli Lavabo Dolabı Dafne Lake Kapak (Demonte)",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-dafne-iki-cekmeceli-lake-kapakli-banyo-mobilyasi-80cm.png?v=1748169609",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-dafne-iki-cekmeceli-lake-kapakli-banyo-mobilyasi-80cm.png?v=1748169609",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-iki-cekmeceli-lavabo-dolabi-dafne-lake-kapak-6476.jpg?v=1748169609",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-iki-cekmeceli-lavabo-dolabi-dafne-lake-kapak-6475.jpg?v=1748169609",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-iki-cekmeceli-lavabo-dolabi-dafne-lake-kapak-6474.jpg?v=1748169609",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-iki-cekmeceli-lavabo-dolabi-dafne-lake-kapak-6477.jpg?v=1748169609"
    ],
    "price": "21208.00",
    "sku": "D.D20.LD080.2CK.LK.DAF",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "D20",
      "Dafne",
      "iki çekmeceli lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843198677289,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD080.2CK.LK.DAF",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "21208.00",
        "grams": 0,
        "compare_at_price": "26510.00",
        "position": 1,
        "product_id": 9523815645481,
        "created_at": "2026-03-17T12:50:36+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523814039849",
    "brand": "Creavit",
    "title": "D20 80 Cm İki Çekmeceli Lavabo Dolabı Beyaz Lake Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-beyaz-lake-lavabo-dolabi-cekmeceli-80cm_51150b90-b418-4a8e-ad9a-b9a4fc7d6820.png?v=1748168082",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-beyaz-lake-lavabo-dolabi-cekmeceli-80cm_51150b90-b418-4a8e-ad9a-b9a4fc7d6820.png?v=1748168082",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-iki-cekmeceli-lavabo-dolabi-beyaz-lake-6470.png?v=1748168082",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-iki-cekmeceli-lavabo-dolabi-beyaz-lake-6472.jpg?v=1748168082",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-iki-cekmeceli-lavabo-dolabi-beyaz-lake-6471.jpg?v=1748168082",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-iki-cekmeceli-lavabo-dolabi-beyaz-lake-6469.jpg?v=1748168082",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-iki-cekmeceli-lavabo-dolabi-beyaz-lake-6473.jpg?v=1748168078"
    ],
    "price": "21208.00",
    "sku": "D.D20.LD080.2CK.LK.BYZ",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "Beyaz",
      "D20",
      "iki çekmeceli lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52936996192553,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD080.2CK.LK.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "21208.00",
        "grams": 0,
        "compare_at_price": "26510.00",
        "position": 1,
        "product_id": 9523814039849,
        "created_at": "2026-04-06T14:16:42+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523812794665",
    "brand": "Creavit",
    "title": "D20 80 Cm İki Çekmeceli Lavabo Dolabı Antrasit Lake Kapak (Demonte)",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-antrasit-lake-lavabo-dolabi-cekmeceli-80cm_c84e60d5-6342-4fe1-8aef-b2b582603d86.png?v=1748168122",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-antrasit-lake-lavabo-dolabi-cekmeceli-80cm_c84e60d5-6342-4fe1-8aef-b2b582603d86.png?v=1748168122",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-iki-cekmeceli-lav-dolabi-antrasit-lake-6467.jpg?v=1748168122",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-iki-cekmeceli-lav-dolabi-antrasit-lake-6466.jpg?v=1748168122",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-iki-cekmeceli-lav-dolabi-antrasit-lake-6465.jpg?v=1748168122",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-iki-cekmeceli-lav-dolabi-antrasit-lake-6468.jpg?v=1748168120"
    ],
    "price": "21208.00",
    "sku": "D.D20.LD080.2CK.LK.ANT",
    "tags": [
      "%10 indirim Yaz",
      "Antrasit",
      "Banyo Mobilyası",
      "D20",
      "iki çekmeceli lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843225710889,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD080.2CK.LK.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "21208.00",
        "grams": 0,
        "compare_at_price": "26510.00",
        "position": 1,
        "product_id": 9523812794665,
        "created_at": "2026-03-17T12:58:18+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523811057961",
    "brand": "Creavit",
    "title": "D20 65 Cm Kapaklı Lavabo Dolabı Everest Melamin",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-everest-melamin-lavabo-dolabi-kapakli-65cm.png?v=1748168342",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-everest-melamin-lavabo-dolabi-kapakli-65cm.png?v=1748168342",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-kapakli-lavabo-dolabi-everest-melamin-6461.jpg?v=1748168342",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-kapakli-lavabo-dolabi-everest-melamin-6463.jpg?v=1748168342",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-kapakli-lavabo-dolabi-everest-melamin-6462.jpg?v=1748168342",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-kapakli-lavabo-dolabi-everest-melamin-6460.jpg?v=1748168341",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-kapakli-lavabo-dolabi-everest-melamin-6464.jpg?v=1748168330"
    ],
    "price": "10147.50",
    "sku": "D.D20.LD065.KPK.ML.EVR",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "D20",
      "Everest",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843198382377,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD065.KPK.ML.EVR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "10147.50",
        "grams": 0,
        "compare_at_price": "13530.00",
        "position": 1,
        "product_id": 9523811057961,
        "created_at": "2026-03-17T12:50:30+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523810173225",
    "brand": "Creavit",
    "title": "D20 65 Cm Kapaklı Lavabo Dolabı Dafne Melamin Kapak (Demonte)",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-dafne-melamin-lavabo-dolabi-kapakli-65cm.png?v=1748168391",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-dafne-melamin-lavabo-dolabi-kapakli-65cm.png?v=1748168391",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-kapakli-lavabo-dolabi-dafne-melamin-kapak-6458.jpg?v=1748168391",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-kapakli-lavabo-dolabi-dafne-melamin-kapak-6457.jpg?v=1748168391",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-kapakli-lavabo-dolabi-dafne-melamin-kapak-6456.jpg?v=1748168390",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-kapakli-lavabo-dolabi-dafne-melamin-kapak-6459.jpg?v=1748168383"
    ],
    "price": "10147.50",
    "sku": "D.D20.LD065.KPK.ML.DAF",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "D20",
      "Dafne",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52921487819049,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD065.KPK.ML.DAF",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "10147.50",
        "grams": 0,
        "compare_at_price": "13530.00",
        "position": 1,
        "product_id": 9523810173225,
        "created_at": "2026-04-03T14:45:15+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523807355177",
    "brand": "Creavit",
    "title": "D20 65 Cm Kapaklı Lavabo Dolabı Beyaz Melamin (Demonte)",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-beyaz-melamin-lavabo-dolabi-kapakli-65cm.png?v=1748168453",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-beyaz-melamin-lavabo-dolabi-kapakli-65cm.png?v=1748168453",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-kapakli-lavabo-dolabi-beyaz-melamin-6454.jpg?v=1748168453",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-kapakli-lavabo-dolabi-beyaz-melamin-6453.jpg?v=1748168453",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-kapakli-lavabo-dolabi-beyaz-melamin-6452.jpg?v=1748168453",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-kapakli-lavabo-dolabi-beyaz-melamin-6455.jpg?v=1748168450"
    ],
    "price": "10147.50",
    "sku": "D.D20.LD065.KPK.ML.BYZ",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "Beyaz",
      "D20",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52921488081193,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD065.KPK.ML.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "10147.50",
        "grams": 0,
        "compare_at_price": "13530.00",
        "position": 1,
        "product_id": 9523807355177,
        "created_at": "2026-04-03T14:45:18+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523806077225",
    "brand": "Creavit",
    "title": "D20 65 Cm Kapaklı Lavabo Dolabı Antrasit Melamin (Demonte)",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-antrasit-melamin-lavabo-dolabi-kapakli-65cm.png?v=1748168496",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-antrasit-melamin-lavabo-dolabi-kapakli-65cm.png?v=1748168496",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-kapakli-lavabo-dolabi-antrasit-melamin-6450.jpg?v=1748168496",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-kapakli-lavabo-dolabi-antrasit-melamin-6449.jpg?v=1748168496",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-kapakli-lavabo-dolabi-antrasit-melamin-6448.jpg?v=1748168496",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-kapakli-lavabo-dolabi-antrasit-melamin-6451.jpg?v=1748168490"
    ],
    "price": "10147.50",
    "sku": "D.D20.LD065.KPK.ML.ANT",
    "tags": [
      "%10 indirim Yaz",
      "Antrasit",
      "Banyo Mobilyası",
      "D20",
      "kapaklı lavabo dolabı",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843259363625,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD065.KPK.ML.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "10147.50",
        "grams": 0,
        "compare_at_price": "13530.00",
        "position": 1,
        "product_id": 9523806077225,
        "created_at": "2026-03-17T13:09:17+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523185549609",
    "brand": "Creavit",
    "title": "D20 65 Cm Kapaklı Lavabo Dolabı Dafne Lake Kapak",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-dafne-lake-lavabo-dolabi-kapakli-65cm.png?v=1748168535",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-dafne-lake-lavabo-dolabi-kapakli-65cm.png?v=1748168535",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-kapakli-lavabo-dolabi-dafne-lake-6446.jpg?v=1748168535",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-kapakli-lavabo-dolabi-dafne-lake-6445.jpg?v=1748168535",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-kapakli-lavabo-dolabi-dafne-lake-6444.jpg?v=1748168535",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-kapakli-lavabo-dolabi-dafne-lake-6447.jpg?v=1748168530"
    ],
    "price": "13992.00",
    "sku": "D.D20.LD065.KPK.LK.DAF",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "D20",
      "Dafne",
      "kapaklı lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52921490047273,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD065.KPK.LK.DAF",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "13992.00",
        "grams": 0,
        "compare_at_price": "17490.00",
        "position": 1,
        "product_id": 9523185549609,
        "created_at": "2026-04-03T14:45:44+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523183419689",
    "brand": "Creavit",
    "title": "D20 65 Cm Kapaklı Lavabo Dolabı Beyaz Lake Kapak (Demonte)",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-beyaz-lake-lavabo-dolabi-kapakli-65cm.png?v=1748168588",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-beyaz-lake-lavabo-dolabi-kapakli-65cm.png?v=1748168588",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-kapakli-lavabo-dolabi-beyaz-lake-6440.jpg?v=1748168588",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-kapakli-lavabo-dolabi-beyaz-lake-6441.jpg?v=1748168588",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-kapakli-lavabo-dolabi-beyaz-lake-6442.jpg?v=1748168588",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-kapakli-lavabo-dolabi-beyaz-lake-6439.jpg?v=1748168588",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-kapakli-lavabo-dolabi-beyaz-lake-6443.jpg?v=1748168578"
    ],
    "price": "13992.00",
    "sku": "D.D20.LD065.KPK.LK.BYZ",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "Beyaz",
      "D20",
      "kapaklı lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52921489752361,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD065.KPK.LK.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "13992.00",
        "grams": 0,
        "compare_at_price": "17490.00",
        "position": 1,
        "product_id": 9523183419689,
        "created_at": "2026-04-03T14:45:41+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523182600489",
    "brand": "Creavit",
    "title": "D20 65 Cm İki Çekmeceli Lavabo Dolabı Everest Melamin Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-everest-melamin-lavabo-dolabi-cekmeceli-65cm.png?v=1748168628",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-everest-melamin-lavabo-dolabi-cekmeceli-65cm.png?v=1748168628",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-cekmeceli-lavabo-dolabi-everest-melamin-kapak-6435.jpg?v=1748168628",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-cekmeceli-lavabo-dolabi-everest-melamin-kapak-6437.jpg?v=1748168628",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-cekmeceli-lavabo-dolabi-everest-melamin-kapak-6436.jpg?v=1748168628",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-cekmeceli-lavabo-dolabi-everest-melamin-kapak-6434.jpg?v=1748168628",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-cekmeceli-lavabo-dolabi-everest-melamin-kapak-6438.jpg?v=1748168616"
    ],
    "price": "15675.00",
    "sku": "D.D20.LD065.2CK.ML.EVR",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "D20",
      "Everest",
      "iki çekmeceli lavabo dolabı",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843198054697,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD065.2CK.ML.EVR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "15675.00",
        "grams": 0,
        "compare_at_price": "20900.00",
        "position": 1,
        "product_id": 9523182600489,
        "created_at": "2026-03-17T12:50:21+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523181977897",
    "brand": "Creavit",
    "title": "D20 65 Cm İki Çekmeceli Lavabo Dolabı Dafne Melamin Kapak (Demonte)",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-dafne-melamin-lavabo-dolabi-cekmeceli-65cm.png?v=1748168712",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-dafne-melamin-lavabo-dolabi-cekmeceli-65cm.png?v=1748168712",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-cekmeceli-lavabo-dolabi-dafne-melamin-kapak-demonte-6429.jpg?v=1748168712",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-cekmeceli-lavabo-dolabi-dafne-melamin-kapak-demonte-6430.jpg?v=1748168712",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-cekmeceli-lavabo-dolabi-dafne-melamin-kapak-demonte-6432.jpg?v=1748168712",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-cekmeceli-lavabo-dolabi-dafne-melamin-kapak-demonte-6431.jpg?v=1748168712",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-cekmeceli-lavabo-dolabi-dafne-melamin-kapak-demonte-6428.jpg?v=1748168712",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-cekmeceli-lavabo-dolabi-dafne-melamin-kapak-demonte-6433.jpg?v=1748168700"
    ],
    "price": "15675.00",
    "sku": "D.D20.LD065.2CK.ML.DAF",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "D20",
      "Dafne",
      "iki çekmeceli lavabo dolabı",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843197923625,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD065.2CK.ML.DAF",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "15675.00",
        "grams": 0,
        "compare_at_price": "20900.00",
        "position": 1,
        "product_id": 9523181977897,
        "created_at": "2026-03-17T12:50:18+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523181617449",
    "brand": "Creavit",
    "title": "D20 65 Cm İki Çelmeceli Lavabo Dolabı Beyaz Melamin Kapak (Demonte)",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-beyaz-melamin-lavabo-dolabi-cekmeceli-65cm.png?v=1748168759",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-beyaz-melamin-lavabo-dolabi-cekmeceli-65cm.png?v=1748168759",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-celmeceli-lavabo-dolabi-beyaz-melamin-kapak-demonte-6426.jpg?v=1748168759",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-celmeceli-lavabo-dolabi-beyaz-melamin-kapak-demonte-6425.jpg?v=1748168759",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-celmeceli-lavabo-dolabi-beyaz-melamin-kapak-demonte-6424.jpg?v=1748168759",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-celmeceli-lavabo-dolabi-beyaz-melamin-kapak-demonte-6427.jpg?v=1748168754"
    ],
    "price": "15675.00",
    "sku": "D.D20.LD065.2CK.ML.BYZ",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "Beyaz",
      "D20",
      "iki çekmeceli lavabo dolabı",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52921488277801,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD065.2CK.ML.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "15675.00",
        "grams": 0,
        "compare_at_price": "20900.00",
        "position": 1,
        "product_id": 9523181617449,
        "created_at": "2026-04-03T14:45:21+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523181257001",
    "brand": "Creavit",
    "title": "D20 65 Cm İki Çelmeceli Lavabo Dolabı Antrasit Melamin (Demonte)",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-antrasit-melamin-lavabo-dolabi-cekmeceli-65cm.png?v=1748168901",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-antrasit-melamin-lavabo-dolabi-cekmeceli-65cm.png?v=1748168901",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-celmeceli-lavabo-dolabi-antrasit-melamin-6422.jpg?v=1748168901",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-celmeceli-lavabo-dolabi-antrasit-melamin-6421.jpg?v=1748168901",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-celmeceli-lavabo-dolabi-antrasit-melamin-6420.jpg?v=1748168901",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-celmeceli-lavabo-dolabi-antrasit-melamin-6423.jpg?v=1748168897"
    ],
    "price": "15675.00",
    "sku": "D.D20.LD065.2CK.ML.ANT",
    "tags": [
      "%10 indirim Yaz",
      "Antrasit",
      "Banyo Mobilyası",
      "D20",
      "iki çekmeceli lavabo dolabı",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843197759785,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD065.2CK.ML.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "15675.00",
        "grams": 0,
        "compare_at_price": "20900.00",
        "position": 1,
        "product_id": 9523181257001,
        "created_at": "2026-03-17T12:50:15+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523180798249",
    "brand": "Creavit",
    "title": "D20 65 Cm İki Çelmeceli Lavabo Dolabı Dafne Lake Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-dafne-iki-cekmeceli-lake-kapakli-banyo-mobilyasi-65cm.png?v=1748169415",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-dafne-iki-cekmeceli-lake-kapakli-banyo-mobilyasi-65cm.png?v=1748169415",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-celmeceli-lavabo-dolabi-dafne-lake-kapak-6416.jpg?v=1748169415",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-celmeceli-lavabo-dolabi-dafne-lake-kapak-6418.jpg?v=1748169415",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-celmeceli-lavabo-dolabi-dafne-lake-kapak-6417.jpg?v=1748169415",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-celmeceli-lavabo-dolabi-dafne-lake-kapak-6415.jpg?v=1748169415",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-celmeceli-lavabo-dolabi-dafne-lake-kapak-6419.jpg?v=1748169410"
    ],
    "price": "20152.00",
    "sku": "D.D20.LD065.2CK.LK.DAF",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "D20",
      "Dafne",
      "iki çekmeceli lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843247173929,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD065.2CK.LK.DAF",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "20152.00",
        "grams": 0,
        "compare_at_price": "25190.00",
        "position": 1,
        "product_id": 9523180798249,
        "created_at": "2026-03-17T13:05:31+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523180503337",
    "brand": "Creavit",
    "title": "D20 65 Cm İki Çelmeceli Lavabo Dolabı Beyaz Lake Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-beyaz-lavabo-dolabi-65cm.png?v=1748169653",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-beyaz-lavabo-dolabi-65cm.png?v=1748169653",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-celmeceli-lavabo-dolabi-beyaz-lake-kapak-6411.jpg?v=1748169653",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-celmeceli-lavabo-dolabi-beyaz-lake-kapak-6413.jpg?v=1748169653",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-celmeceli-lavabo-dolabi-beyaz-lake-kapak-6412.jpg?v=1748169653",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-celmeceli-lavabo-dolabi-beyaz-lake-kapak-6410.jpg?v=1748169653",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-celmeceli-lavabo-dolabi-beyaz-lake-kapak-6414.jpg?v=1748169649"
    ],
    "price": "20152.00",
    "sku": "D.D20.LD065.2CK.LK.BYZ",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "Beyaz",
      "D20",
      "iki çekmeceli lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843268964649,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD065.2CK.LK.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "20152.00",
        "grams": 0,
        "compare_at_price": "25190.00",
        "position": 1,
        "product_id": 9523180503337,
        "created_at": "2026-03-17T13:12:25+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523180110121",
    "brand": "Creavit",
    "title": "D20 65 Cm İki Çelmeceli Lavabo Dolabı Antrasit Lake Kapak",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-antrasit-lavabo-dolabi-65cm.png?v=1748169687",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-D20-antrasit-lavabo-dolabi-65cm.png?v=1748169687",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-celmeceli-lavabo-dolabi-antrasit-lake-kapak-6408.jpg?v=1748169687",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-celmeceli-lavabo-dolabi-antrasit-lake-kapak-6407.jpg?v=1748169687",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-celmeceli-lavabo-dolabi-antrasit-lake-kapak-6406.jpg?v=1748169687",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-iki-celmeceli-lavabo-dolabi-antrasit-lake-kapak-6409.jpg?v=1748169682"
    ],
    "price": "20152.00",
    "sku": "D.D20.LD065.2CK.LK.ANT",
    "tags": [
      "%10 indirim Yaz",
      "Antrasit",
      "Banyo Mobilyası",
      "D20",
      "iki çekmeceli lavabo dolabı",
      "Lake",
      "Lavabo Dolabı",
      "Melamin",
      "yaz-10-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52920977752361,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.LD065.2CK.LK.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "20152.00",
        "grams": 0,
        "compare_at_price": "25190.00",
        "position": 1,
        "product_id": 9523180110121,
        "created_at": "2026-04-03T12:17:44+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523176898857",
    "brand": "Creavit",
    "title": "D20 30 Cm Sola Açılır Boy Dolabı Everest Melamin Kapak (Demonte)",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-boy-dolabi-melamin-everest.png?v=1748169754",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-boy-dolabi-melamin-everest.png?v=1748169754",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-sola-acilir-boy-dolabi-everest-melamin-kapak-6404.jpg?v=1748169754",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-sola-acilir-boy-dolabi-everest-melamin-kapak-6403.jpg?v=1748169754",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-sola-acilir-boy-dolabi-everest-melamin-kapak-6405.jpg?v=1748169752"
    ],
    "price": "9735.00",
    "sku": "D.D20.BD030.SOL.ML.EVR",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "boy dolabı",
      "D20",
      "Everest",
      "Melamin",
      "Sol Boy Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52885929394473,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.BD030.SOL.ML.EVR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9735.00",
        "grams": 0,
        "compare_at_price": "12980.00",
        "position": 1,
        "product_id": 9523176898857,
        "created_at": "2026-03-27T15:03:43+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span><strong></strong></p>"
  },
  {
    "id": "creavit-9523176702249",
    "brand": "Creavit",
    "title": "D20 30 Cm Sola Açılır Boy Dolabı Antrasit Melamin Kapak (Demonte)",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-boy-dolabi-melamin-antrasit.png?v=1748169790",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-boy-dolabi-melamin-antrasit.png?v=1748169790",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-sola-acilir-boy-dolabi-antrasit-melamin-kapak-6401.jpg?v=1748169790",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-sola-acilir-boy-dolabi-antrasit-melamin-kapak-6402.jpg?v=1748169790"
    ],
    "price": "9735.00",
    "sku": "D.D20.BD030.SOL.ML.ANT",
    "tags": [
      "%10 indirim Yaz",
      "Antrasit",
      "Banyo Mobilyası",
      "boy dolabı",
      "D20",
      "Melamin",
      "Sol Boy Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843197497641,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.BD030.SOL.ML.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9735.00",
        "grams": 0,
        "compare_at_price": "12980.00",
        "position": 1,
        "product_id": 9523176702249,
        "created_at": "2026-03-17T12:50:09+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span><strong></strong></p>"
  },
  {
    "id": "creavit-9523176177961",
    "brand": "Creavit",
    "title": "D20 30 Cm Sola Açılır Boy Dolabı Dafne Melamin Kapak (Demonte)",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-boy-dolabi-melamin-dafne.png?v=1748169836",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-boy-dolabi-melamin-dafne.png?v=1748169836",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-sola-acilir-boy-dolabi-dafne-melamin-kapak-demonte-6398.jpg?v=1748169836",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-sola-acilir-boy-dolabi-dafne-melamin-kapak-demonte-6399.jpg?v=1748169836",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-sola-acilir-boy-dolabi-dafne-melamin-kapak-demonte-6397.jpg?v=1748169836",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-sola-acilir-boy-dolabi-dafne-melamin-kapak-demonte-6400.jpg?v=1748169834"
    ],
    "price": "9735.00",
    "sku": "D.D20.BD030.SOL.ML.DAF",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "boy dolabı",
      "D20",
      "Dafne",
      "Melamin",
      "Sol Boy Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843192647977,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.BD030.SOL.ML.DAF",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9735.00",
        "grams": 0,
        "compare_at_price": "12980.00",
        "position": 1,
        "product_id": 9523176177961,
        "created_at": "2026-03-17T12:48:23+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span><strong></strong></p>"
  },
  {
    "id": "creavit-9523174736169",
    "brand": "Creavit",
    "title": "D20 30 Cm Sola Açılır Boy Dolabı Beyaz Melamin Kapak (Demonte)",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-boy-dolabi-melamin-beyaz.png?v=1748169868",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-boy-dolabi-melamin-beyaz.png?v=1748169868",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-sola-acilir-boy-dolabi-beyaz-melamin-kapak-demonte-6395.jpg?v=1748169868",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-sola-acilir-boy-dolabi-beyaz-melamin-kapak-demonte-6396.jpg?v=1748169868"
    ],
    "price": "9735.00",
    "sku": "D.D20.BD030.SOL.ML.BYZ",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "Beyaz",
      "boy dolabı",
      "D20",
      "Melamin",
      "Sağ Boy Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52851577979177,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.BD030.SOL.ML.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9735.00",
        "grams": 0,
        "compare_at_price": "12980.00",
        "position": 1,
        "product_id": 9523174736169,
        "created_at": "2026-03-19T12:54:59+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span><strong></strong></p>"
  },
  {
    "id": "creavit-9523174080809",
    "brand": "Creavit",
    "title": "D20 30 Cm Sola Açılır Boy Dolabı Dafne Lake Kapak (Demonte)",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-boy-dolabi-lake-dafne.png?v=1748169904",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-boy-dolabi-lake-dafne.png?v=1748169904",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-sola-acilir-boy-dolabi-dafne-lake-kapak-6393.jpg?v=1748169904",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-sola-acilir-boy-dolabi-dafne-lake-kapak-6392.jpg?v=1748169904",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-sola-acilir-boy-dolabi-dafne-lake-kapak-6394.jpg?v=1748169900"
    ],
    "price": "14080.00",
    "sku": "D.D20.BD030.SOL.LK.DAF",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "boy dolabı",
      "D20",
      "Dafne",
      "Lake",
      "Melamin",
      "Sol Boy Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52921489588521,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.BD030.SOL.LK.DAF",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "14080.00",
        "grams": 0,
        "compare_at_price": "17600.00",
        "position": 1,
        "product_id": 9523174080809,
        "created_at": "2026-04-03T14:45:38+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span><strong></strong></p>"
  },
  {
    "id": "creavit-9523173916969",
    "brand": "Creavit",
    "title": "D20 30 Cm Sola Açılır Boy Dolabı Beyaz Lake Kapak (Demonte)",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-boy-dolabi-lake-beyaz.png?v=1748169930",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-boy-dolabi-lake-beyaz.png?v=1748169930",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-sola-acilir-boy-dolabi-beyaz-lake-kapak-6390.jpg?v=1748169930",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-sola-acilir-boy-dolabi-beyaz-lake-kapak-6389.jpg?v=1748169930",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-sola-acilir-boy-dolabi-beyaz-lake-kapak-6391.jpg?v=1748169928"
    ],
    "price": "14080.00",
    "sku": "D.D20.BD030.SOL.LK.BYZ",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "Beyaz",
      "boy dolabı",
      "D20",
      "Lake",
      "Melamin",
      "Sol Boy Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52938522853673,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.BD030.SOL.LK.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "14080.00",
        "grams": 0,
        "compare_at_price": "17600.00",
        "position": 1,
        "product_id": 9523173916969,
        "created_at": "2026-04-06T20:53:18+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span><strong></strong></p>"
  },
  {
    "id": "creavit-9523173392681",
    "brand": "Creavit",
    "title": "D20 30 Cm Sola Açılır Boy Dolabı Antrasit Lake Kapak (Demonte)",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-boy-dolabi-lake-antrasit.png?v=1748169956",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-boy-dolabi-lake-antrasit.png?v=1748169956",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-sola-acilir-boy-dolabi-antrasit-lake-kapak-6387.jpg?v=1748169956",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-sola-acilir-boy-dolabi-antrasit-lake-kapak-6386.jpg?v=1748169956",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-sola-acilir-boy-dolabi-antrasit-lake-kapak-6388.jpg?v=1748169954"
    ],
    "price": "14080.00",
    "sku": "D.D20.BD030.SOL.LK.ANT",
    "tags": [
      "%10 indirim Yaz",
      "Antrasit",
      "Banyo Mobilyası",
      "boy dolabı",
      "D20",
      "Lake",
      "Melamin",
      "Sol Boy Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843225612585,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.BD030.SOL.LK.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "14080.00",
        "grams": 0,
        "compare_at_price": "17600.00",
        "position": 1,
        "product_id": 9523173392681,
        "created_at": "2026-03-17T12:58:15+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span><strong></strong></p>"
  },
  {
    "id": "creavit-9523173097769",
    "brand": "Creavit",
    "title": "D20 30 Cm Sağa Açılır Boy Dolabı Everest Melamin Kapak (Demonte)",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-boy-dolabi-melamin-everest_e7ccefde-7e42-48d9-b235-20b576ff772c.png?v=1748169989",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-boy-dolabi-melamin-everest_e7ccefde-7e42-48d9-b235-20b576ff772c.png?v=1748169989",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-saga-acilir-boy-dolabi-everest-melamin-kapak-6384.jpg?v=1748169989",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-saga-acilir-boy-dolabi-everest-melamin-kapak-6383.jpg?v=1748169989",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-saga-acilir-boy-dolabi-everest-melamin-kapak-6385.jpg?v=1748169987"
    ],
    "price": "9735.00",
    "sku": "D.D20.BD030.SAG.ML.EVR",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "boy dolabı",
      "D20",
      "Everest",
      "Melamin",
      "Sağ Boy Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843267817769,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.BD030.SAG.ML.EVR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9735.00",
        "grams": 0,
        "compare_at_price": "12980.00",
        "position": 1,
        "product_id": 9523173097769,
        "created_at": "2026-03-17T13:12:01+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span><strong></strong></p>"
  },
  {
    "id": "creavit-9523170640169",
    "brand": "Creavit",
    "title": "D20 30 Cm Sağa Açılır Boy Dolabı Antrasit Melamin Kapak (Demonte)",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-boy-dolabi-melamin-antrasit_75754600-9199-408f-8a57-24e6af1f9aeb.png?v=1748170022",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-boy-dolabi-melamin-antrasit_75754600-9199-408f-8a57-24e6af1f9aeb.png?v=1748170022",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-saga-acilir-boy-dolabi-antrasit-melamin-kapak-6381.jpg?v=1748170020",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-saga-acilir-boy-dolabi-antrasit-melamin-kapak-6382.jpg?v=1748170020"
    ],
    "price": "9735.00",
    "sku": "D.D20.BD030.SAG.ML.ANT",
    "tags": [
      "%10 indirim Yaz",
      "Antrasit",
      "Banyo Mobilyası",
      "boy dolabı",
      "D20",
      "Melamin",
      "Sağ Boy Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843231379753,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.BD030.SAG.ML.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "9735.00",
        "grams": 0,
        "compare_at_price": "12980.00",
        "position": 1,
        "product_id": 9523170640169,
        "created_at": "2026-03-17T13:00:19+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span><strong></strong></p>"
  },
  {
    "id": "creavit-9523168936233",
    "brand": "Creavit",
    "title": "D20 30 Cm Sağa Açılır Boy Dolabı Beyaz Melamin Kapak (Demonte)",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-boy-dolabi-melamin-beyaz_5049223e-7100-4233-807a-865085daf8db.png?v=1748170073",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-boy-dolabi-melamin-beyaz_5049223e-7100-4233-807a-865085daf8db.png?v=1748170073",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-saga-acilir-boy-dolabi-beyaz-melamin-kapak-demonte-6379.jpg?v=1748170073",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-saga-acilir-boy-dolabi-beyaz-melamin-kapak-demonte-6380.jpg?v=1748170073"
    ],
    "price": "9735.00",
    "sku": "D.D20.BD030.SAG.ML.BYZ",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "Beyaz",
      "boy dolabı",
      "D20",
      "Melamin",
      "Sağ Boy Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843192189225,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.BD030.SAG.ML.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9735.00",
        "grams": 0,
        "compare_at_price": "12980.00",
        "position": 1,
        "product_id": 9523168936233,
        "created_at": "2026-03-17T12:48:14+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span><strong></strong></p>"
  },
  {
    "id": "creavit-9523166478633",
    "brand": "Creavit",
    "title": "D20 30 Cm Sağa Açılır Boy Dolabı Antrasit Lake (Demonte)",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-boy-dolabi-lake-antrasit_4e614364-3146-4186-accd-699399d0489d.png?v=1748170100",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-boy-dolabi-lake-antrasit_4e614364-3146-4186-accd-699399d0489d.png?v=1748170100",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-saga-acilir-boy-dolabi-antrasit-lake-6377.jpg?v=1748170100",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-saga-acilir-boy-dolabi-antrasit-lake-6376.jpg?v=1748170100",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-saga-acilir-boy-dolabi-antrasit-lake-6378.jpg?v=1748170095"
    ],
    "price": "14080.00",
    "sku": "D.D20.BD030.SAG.LK.ANT",
    "tags": [
      "%10 indirim Yaz",
      "Antrasit",
      "Banyo Mobilyası",
      "boy dolabı",
      "D20",
      "Lake",
      "Melamin",
      "Sağ Boy Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843197104425,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.BD030.SAG.LK.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "14080.00",
        "grams": 0,
        "compare_at_price": "17600.00",
        "position": 1,
        "product_id": 9523166478633,
        "created_at": "2026-03-17T12:49:59+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span><strong></strong></p>"
  },
  {
    "id": "creavit-9523165167913",
    "brand": "Creavit",
    "title": "D20 30 Cm Sağa Açılır Boy Dolabı Dafne Lake Kapak",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-boy-dolabi-lake-dafne_59d361fd-94d6-401c-8448-c6bc15b5747d.png?v=1748170127",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-boy-dolabi-lake-dafne_59d361fd-94d6-401c-8448-c6bc15b5747d.png?v=1748170127",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-saga-acilir-boy-dolabi-dafne-lake-kapak-6374.jpg?v=1748170127",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-saga-acilir-boy-dolabi-dafne-lake-kapak-6373.jpg?v=1748170127",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-saga-acilir-boy-dolabi-dafne-lake-kapak-6375.jpg?v=1748170126"
    ],
    "price": "14080.00",
    "sku": "D.D20.BD030.SAG.LK.DAF",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "boy dolabı",
      "D20",
      "Dafne",
      "Lake",
      "Melamin",
      "Sağ Boy Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843237802281,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.BD030.SAG.LK.DAF",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "14080.00",
        "grams": 0,
        "compare_at_price": "17600.00",
        "position": 1,
        "product_id": 9523165167913,
        "created_at": "2026-03-17T13:02:42+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span><strong></strong></p>"
  },
  {
    "id": "creavit-9523163627817",
    "brand": "Creavit",
    "title": "D20 30 Cm Sağa Açılır Boy Dolabı Beyaz Lake Kapak (Demonte)",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-boy-dolabi-lake-beyaz_82ef3566-2820-4bc2-bea9-0484a6c43cc8.png?v=1748170154",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-boy-dolabi-lake-beyaz_82ef3566-2820-4bc2-bea9-0484a6c43cc8.png?v=1748170154",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-saga-acilir-boy-dolabi-beyaz-lake-6371.jpg?v=1748170154",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-saga-acilir-boy-dolabi-beyaz-lake-6370.jpg?v=1748170154",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-30-cm-saga-acilir-boy-dolabi-beyaz-lake-6372.jpg?v=1748170153"
    ],
    "price": "14080.00",
    "sku": "D.D20.BD030.SAG.LK.BYZ",
    "tags": [
      "%10 indirim Yaz",
      "Banyo Mobilyası",
      "Beyaz",
      "boy dolabı",
      "D20",
      "Lake",
      "Melamin",
      "Sağ Boy Dolabı",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843196973353,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D.D20.BD030.SAG.LK.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "14080.00",
        "grams": 0,
        "compare_at_price": "17600.00",
        "position": 1,
        "product_id": 9523163627817,
        "created_at": "2026-03-17T12:49:56+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span><strong></strong></p>"
  },
  {
    "id": "creavit-9523118899497",
    "brand": "Creavit",
    "title": "D20 100 Cm Yuvarlak Ayna",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-yuvarlakayna-100cm.png?v=1748170208",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-yuvarlakayna-100cm.png?v=1748170208",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-yuvarlak-ayna-6368.jpg?v=1748170208",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-yuvarlak-ayna-6367.jpg?v=1748170208",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-yuvarlak-ayna-6366.jpg?v=1748170208",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-yuvarlak-ayna-6369.jpg?v=1748170200"
    ],
    "price": "5197.50",
    "sku": "D20.YA100",
    "tags": [
      "%10 indirim Yaz",
      "Ayna",
      "Banyo Mobilyası",
      "D20",
      "yaz-10-indirim",
      "Yuvarlak Ayna"
    ],
    "variants": [
      {
        "id": 52843196809513,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D20.YA100",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5197.50",
        "grams": 0,
        "compare_at_price": "6930.00",
        "position": 1,
        "product_id": 9523118899497,
        "created_at": "2026-03-17T12:49:53+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523118375209",
    "brand": "Creavit",
    "title": "D20 80 Cm Yuvarlak Ayna",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-yuvarlakayna-80cm.png?v=1748170240",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-yuvarlakayna-80cm.png?v=1748170240",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-yuvarlak-ayna-6362.jpg?v=1748170240",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-yuvarlak-ayna-6365.jpg?v=1748170235"
    ],
    "price": "3795.00",
    "sku": "D20.YA080",
    "tags": [
      "%10 indirim Yaz",
      "Ayna",
      "Banyo Mobilyası",
      "D20",
      "yaz-10-indirim",
      "Yuvarlak Ayna"
    ],
    "variants": [
      {
        "id": 52921489326377,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D20.YA080",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3795.00",
        "grams": 0,
        "compare_at_price": "5060.00",
        "position": 1,
        "product_id": 9523118375209,
        "created_at": "2026-04-03T14:45:34+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523117162793",
    "brand": "Creavit",
    "title": "D20 65 Cm Yuvarlak Ayna",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-yuvarlakayna-65cm.png?v=1748170263",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-yuvarlakayna-65cm.png?v=1748170263",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-yuvarlak-ayna-6358.jpg?v=1748170263",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-yuvarlak-ayna-6360.jpg?v=1748170263"
    ],
    "price": "2722.50",
    "sku": "D20.YA065",
    "tags": [
      "%10 indirim Yaz",
      "Ayna",
      "Banyo Mobilyası",
      "D20",
      "yaz-10-indirim",
      "Yuvarlak Ayna"
    ],
    "variants": [
      {
        "id": 52843196547369,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D20.YA065",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2722.50",
        "grams": 0,
        "compare_at_price": "3630.00",
        "position": 1,
        "product_id": 9523117162793,
        "created_at": "2026-03-17T12:49:47+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523113427241",
    "brand": "Creavit",
    "title": "D20 100 Cm Düz Ayna",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-duz-ayna-100cm.png?v=1748170476",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-duz-ayna-100cm.png?v=1748170476",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-duz-ayna-6356.jpg?v=1748170476",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-duz-ayna-6355.jpg?v=1748170476",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-duz-ayna-6357.jpg?v=1748170475"
    ],
    "price": "4537.50",
    "sku": "D20.DA100",
    "tags": [
      "%10 indirim Yaz",
      "Ayna",
      "Banyo Mobilyası",
      "D20",
      "Düz Ayna",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843196383529,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D20.DA100",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "4537.50",
        "grams": 0,
        "compare_at_price": "6050.00",
        "position": 1,
        "product_id": 9523113427241,
        "created_at": "2026-03-17T12:49:44+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523113197865",
    "brand": "Creavit",
    "title": "D20 80 Cm Düz Ayna",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-duz-ayna-80cm.png?v=1748170576",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-duz-ayna-80cm.png?v=1748170576",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-duz-ayna-6353.jpg?v=1748170576",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-duz-ayna-6352.jpg?v=1748170576",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-duz-ayna-6354.jpg?v=1748170574"
    ],
    "price": "3795.00",
    "sku": "D20.DA080",
    "tags": [
      "%10 indirim Yaz",
      "Ayna",
      "Banyo Mobilyası",
      "D20",
      "Düz Ayna",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843196219689,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D20.DA080",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3795.00",
        "grams": 0,
        "compare_at_price": "5060.00",
        "position": 1,
        "product_id": 9523113197865,
        "created_at": "2026-03-17T12:49:41+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523112804649",
    "brand": "Creavit",
    "title": "D20 65 Cm Düz Ayna",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-duz-ayna-65cm.png?v=1748170716",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-duz-ayna-65cm.png?v=1748170716",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-duz-ayna-6350.jpg?v=1748170716",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-duz-ayna-6349.jpg?v=1748170716",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-65-cm-duz-ayna-6351.jpg?v=1748170712"
    ],
    "price": "3217.50",
    "sku": "D20.DA065",
    "tags": [
      "%10 indirim Yaz",
      "Ayna",
      "Banyo Mobilyası",
      "D20",
      "Düz Ayna",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843196055849,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D20.DA065",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3217.50",
        "grams": 0,
        "compare_at_price": "4290.00",
        "position": 1,
        "product_id": 9523112804649,
        "created_at": "2026-03-17T12:49:38+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-9523112050985",
    "brand": "Creavit",
    "title": "D20 100 Cm Everest Aynalı Dolap Melamin Gövde",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-everest-dolapli-ayna-100cm.png?v=1748171029",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-everest-dolapli-ayna-100cm.png?v=1748171029",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-everest-aynali-dolap-melamin-govde-6345.jpg?v=1748171029",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-everest-aynali-dolap-melamin-govde-6346.jpg?v=1748171029",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-everest-aynali-dolap-melamin-govde-6344.jpg?v=1748171029",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-everest-aynali-dolap-melamin-govde-6347.jpg?v=1748171026",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-everest-aynali-dolap-melamin-govde-6348.jpg?v=1748171026"
    ],
    "price": "9652.50",
    "sku": "D20.AD100.ML.EVR",
    "tags": [
      "%10 indirim Yaz",
      "Ayna",
      "Aynalı Dolap",
      "Banyo Mobilyası",
      "D20",
      "Everest",
      "Melamin",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843195957545,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D20.AD100.ML.EVR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9652.50",
        "grams": 0,
        "compare_at_price": "12870.00",
        "position": 1,
        "product_id": 9523112050985,
        "created_at": "2026-03-17T12:49:35+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>\r\n<p> </p><!---->"
  },
  {
    "id": "creavit-9523106840873",
    "brand": "Creavit",
    "title": "D20 100 Cm Melamin Aynalı Dolap Antrasit",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-antrasit-dolapli-ayna-100cm.png?v=1748171286",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-antrasit-dolapli-ayna-100cm.png?v=1748171286",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-melamin-aynali-dolap-antrasit-6340.jpg?v=1748171286",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-melamin-aynali-dolap-antrasit-6339.jpg?v=1748171286",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-melamin-aynali-dolap-antrasit-6341.jpg?v=1748171286",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-melamin-aynali-dolap-antrasit-6342.jpg?v=1748171280",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-melamin-aynali-dolap-antrasit-6343.jpg?v=1748171280"
    ],
    "price": "9652.50",
    "sku": "D20.AD100.ML.ANT",
    "tags": [
      "%10 indirim Yaz",
      "Antrasit",
      "Ayna",
      "Aynalı Dolap",
      "Banyo Mobilyası",
      "D20",
      "Melamin",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52921489031465,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D20.AD100.ML.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9652.50",
        "grams": 0,
        "compare_at_price": "12870.00",
        "position": 1,
        "product_id": 9523106840873,
        "created_at": "2026-04-03T14:45:31+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p><!---->"
  },
  {
    "id": "creavit-9523106152745",
    "brand": "Creavit",
    "title": "D20 100 Cm Dafne Aynalı Dolap Melamin Gövde",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-dafne-dolapli-ayna-100cm.png?v=1748171898",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-dafne-dolapli-ayna-100cm.png?v=1748171898",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-dafne-aynali-dolap-melamin-govde-6335.jpg?v=1748171898",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-dafne-aynali-dolap-melamin-govde-6336.jpg?v=1748171898",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-dafne-aynali-dolap-melamin-govde-6334.jpg?v=1748171898",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-dafne-aynali-dolap-melamin-govde-6337.jpg?v=1748171894",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-dafne-aynali-dolap-melamin-govde-6338.jpg?v=1748171894"
    ],
    "price": "9652.50",
    "sku": "D20.AD100.ML.DAF",
    "tags": [
      "%10 indirim Yaz",
      "Ayna",
      "Aynalı Dolap",
      "Banyo Mobilyası",
      "D20",
      "Dafne",
      "Melamin",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52920975655209,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D20.AD100.ML.DAF",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9652.50",
        "grams": 0,
        "compare_at_price": "12870.00",
        "position": 1,
        "product_id": 9523106152745,
        "created_at": "2026-04-03T12:17:13+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>\r\n<p> </p><!---->"
  },
  {
    "id": "creavit-9523104874793",
    "brand": "Creavit",
    "title": "D20 100 Cm Beyaz Aynalı Dolap Melamin Gövde",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-beyaz-dolapli-ayna-100cm.png?v=1748172106",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-beyaz-dolapli-ayna-100cm.png?v=1748172106",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-beyaz-aynali-dolap-melamin-govde-6330.jpg?v=1748172106",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-beyaz-aynali-dolap-melamin-govde-6331.jpg?v=1748172106",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-beyaz-aynali-dolap-melamin-govde-6329.jpg?v=1748172106",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-beyaz-aynali-dolap-melamin-govde-6332.jpg?v=1748172103",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-100-cm-beyaz-aynali-dolap-melamin-govde-6333.jpg?v=1748172103"
    ],
    "price": "9652.50",
    "sku": "D20.AD100.ML.BYZ",
    "tags": [
      "%10 indirim Yaz",
      "Ayna",
      "Aynalı Dolap",
      "Banyo Mobilyası",
      "Beyaz",
      "D20",
      "Melamin",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52920975819049,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D20.AD100.ML.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9652.50",
        "grams": 0,
        "compare_at_price": "12870.00",
        "position": 1,
        "product_id": 9523104874793,
        "created_at": "2026-04-03T12:17:16+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>\r\n<p> </p><!---->"
  },
  {
    "id": "creavit-9523103334697",
    "brand": "Creavit",
    "title": "D20 80 Cm Everest Aynalı Dolap Melamin Gövde",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-everest-dolapli-ayna-80cm.png?v=1748172495",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-everest-dolapli-ayna-80cm.png?v=1748172495",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-everest-aynali-dolap-melamin-govde-6326.jpg?v=1748172495",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-everest-aynali-dolap-melamin-govde-6325.jpg?v=1748172495",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-everest-aynali-dolap-melamin-govde-6327.jpg?v=1748172493",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-everest-aynali-dolap-melamin-govde-6328.jpg?v=1748172493"
    ],
    "price": "8332.50",
    "sku": "D20.AD080.ML.EVR",
    "tags": [
      "%10 indirim Yaz",
      "Ayna",
      "Aynalı Dolap",
      "Banyo Mobilyası",
      "D20",
      "Everest",
      "Melamin",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843195859241,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D20.AD080.ML.EVR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "8332.50",
        "grams": 0,
        "compare_at_price": "11110.00",
        "position": 1,
        "product_id": 9523103334697,
        "created_at": "2026-03-17T12:49:32+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>\r\n<p> </p><!---->"
  },
  {
    "id": "creavit-9523102777641",
    "brand": "Creavit",
    "title": "D20 80 Cm Melamin Aynalı Dolap Antrasit",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-antrasit-dolapli-ayna-80cm.png?v=1748172624",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-antrasit-dolapli-ayna-80cm.png?v=1748172624",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-melamin-aynali-dolap-antrasit-6322.jpg?v=1748172624",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-melamin-aynali-dolap-antrasit-6321.jpg?v=1748172624",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-melamin-aynali-dolap-antrasit-6323.jpg?v=1748172622",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-melamin-aynali-dolap-antrasit-6324.jpg?v=1748172622"
    ],
    "price": "8332.50",
    "sku": "D20.AD080.ML.ANT",
    "tags": [
      "%10 indirim Yaz",
      "Antrasit",
      "Ayna",
      "Aynalı Dolap",
      "Banyo Mobilyası",
      "D20",
      "Melamin",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843247337769,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D20.AD080.ML.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8332.50",
        "grams": 0,
        "compare_at_price": "11110.00",
        "position": 1,
        "product_id": 9523102777641,
        "created_at": "2026-03-17T13:05:34+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>\r\n<p> </p><!---->"
  },
  {
    "id": "creavit-9523102089513",
    "brand": "Creavit",
    "title": "D20 80 Cm Dafne Aynalı Dolap Melamin Gövde",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-dafne-dolapli-ayna-80cm.png?v=1748172723",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-dafne-dolapli-ayna-80cm.png?v=1748172723",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-dafne-aynali-dolap-melamin-govde-6318.jpg?v=1748172723",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-dafne-aynali-dolap-melamin-govde-6317.jpg?v=1748172723",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-dafne-aynali-dolap-melamin-govde-6319.jpg?v=1748172721",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-dafne-aynali-dolap-melamin-govde-6320.jpg?v=1748172721"
    ],
    "price": "8332.50",
    "sku": "D20.AD080.ML.DAF",
    "tags": [
      "%10 indirim Yaz",
      "Ayna",
      "Aynalı Dolap",
      "Banyo Mobilyası",
      "D20",
      "Dafne",
      "Melamin",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843193532713,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D20.AD080.ML.DAF",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "8332.50",
        "grams": 0,
        "compare_at_price": "11110.00",
        "position": 1,
        "product_id": 9523102089513,
        "created_at": "2026-03-17T12:48:38+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>\r\n<p> </p><!---->"
  },
  {
    "id": "creavit-9523101139241",
    "brand": "Creavit",
    "title": "D20 80 Cm Beyaz Aynalı Dolap Melamin Gövde",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-beyaz-dolapli-ayna-80cm.png?v=1748172836",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-beyaz-dolapli-ayna-80cm.png?v=1748172836",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-beyaz-aynali-dolap-melamin-govde-6314.jpg?v=1748172836",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-beyaz-aynali-dolap-melamin-govde-6313.jpg?v=1748172836",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-beyaz-aynali-dolap-melamin-govde-6315.jpg?v=1748172835",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-80-cm-beyaz-aynali-dolap-melamin-govde-6316.jpg?v=1748172835"
    ],
    "price": "8332.50",
    "sku": "D20.AD080.ML.BYZ",
    "tags": [
      "%10 indirim Yaz",
      "Ayna",
      "Aynalı Dolap",
      "Banyo Mobilyası",
      "Beyaz",
      "D20",
      "Melamin",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843237441833,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D20.AD080.ML.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "8332.50",
        "grams": 0,
        "compare_at_price": "11110.00",
        "position": 1,
        "product_id": 9523101139241,
        "created_at": "2026-03-17T13:02:36+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>\r\n<p> </p><!---->"
  },
  {
    "id": "creavit-9523100451113",
    "brand": "Creavit",
    "title": "D20 60 Cm Everest Aynalı Dolap Melamin Gövde",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-everest-dolapli-ayna-60cm.png?v=1748172970",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-everest-dolapli-ayna-60cm.png?v=1748172970",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-60-cm-everest-aynali-dolap-melamin-govde-6309.jpg?v=1748172970",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-60-cm-everest-aynali-dolap-melamin-govde-6310.jpg?v=1748172970",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-60-cm-everest-aynali-dolap-melamin-govde-6308.jpg?v=1748172970",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-60-cm-everest-aynali-dolap-melamin-govde-6311.jpg?v=1748172963",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-60-cm-everest-aynali-dolap-melamin-govde-6312.jpg?v=1748172963"
    ],
    "price": "6847.50",
    "sku": "D20.AD060.ML.EVR",
    "tags": [
      "%10 indirim Yaz",
      "Ayna",
      "Aynalı Dolap",
      "Banyo Mobilyası",
      "D20",
      "Everest",
      "Melamin",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843225448745,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D20.AD060.ML.EVR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6847.50",
        "grams": 0,
        "compare_at_price": "9130.00",
        "position": 1,
        "product_id": 9523100451113,
        "created_at": "2026-03-17T12:58:11+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>\n<!---->"
  },
  {
    "id": "creavit-9523099074857",
    "brand": "Creavit",
    "title": "D20 60 Cm Melamin Aynalı Dolap Dafne",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-dafne-dolapli-ayna-60cm.png?v=1748173073",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-dafne-dolapli-ayna-60cm.png?v=1748173073",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-60-cm-melamin-aynali-dolap-dafne-6304.jpg?v=1748173073",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-60-cm-melamin-aynali-dolap-dafne-6305.jpg?v=1748173073",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-60-cm-melamin-aynali-dolap-dafne-6303.jpg?v=1748173073",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-60-cm-melamin-aynali-dolap-dafne-6306.jpg?v=1748173069",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-60-cm-melamin-aynali-dolap-dafne-6307.jpg?v=1748173069"
    ],
    "price": "6847.50",
    "sku": "D20.AD060.ML.DAF",
    "tags": [
      "%10 indirim Yaz",
      "Ayna",
      "Aynalı Dolap",
      "Banyo Mobilyası",
      "D20",
      "Dafne",
      "Melamin",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843193368873,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D20.AD060.ML.DAF",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6847.50",
        "grams": 0,
        "compare_at_price": "9130.00",
        "position": 1,
        "product_id": 9523099074857,
        "created_at": "2026-03-17T12:48:35+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\r\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\r\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>\r\n<p> </p><!---->"
  },
  {
    "id": "creavit-9523098812713",
    "brand": "Creavit",
    "title": "D20 60 Cm Beyaz Aynalı Dolap Melamin Gövde",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-beyaz-dolapli-ayna-60cm.png?v=1748173183",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-beyaz-dolapli-ayna-60cm.png?v=1748173183",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-60-cm-beyaz-aynali-dolap-melamin-govde-6299.jpg?v=1748173183",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-60-cm-beyaz-aynali-dolap-melamin-govde-6301.jpg?v=1748173183",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-60-cm-beyaz-aynali-dolap-melamin-govde-6298.jpg?v=1748173183",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-60-cm-beyaz-aynali-dolap-melamin-govde-6300.jpg?v=1748173183",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-60-cm-beyaz-aynali-dolap-melamin-govde-6302.jpg?v=1748173179"
    ],
    "price": "6847.50",
    "sku": "D20.AD060.ML.BYZ",
    "tags": [
      "%10 indirim Yaz",
      "Ayna",
      "Aynalı Dolap",
      "Banyo Mobilyası",
      "Beyaz",
      "D20",
      "Melamin",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52851578110249,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D20.AD060.ML.BYZ",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "6847.50",
        "grams": 0,
        "compare_at_price": "9130.00",
        "position": 1,
        "product_id": 9523098812713,
        "created_at": "2026-03-19T12:55:02+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>\n<!---->"
  },
  {
    "id": "creavit-9523097436457",
    "brand": "Creavit",
    "title": "D20 60 Cm Melamin Aynalı Dolap Antrasit",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-antrasit-dolapli-ayna-60cm.png?v=1748173284",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-d20-antrasit-dolapli-ayna-60cm.png?v=1748173284",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-60-cm-melamin-aynali-dolap-antrasit-6294.jpg?v=1748173284",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-60-cm-melamin-aynali-dolap-antrasit-6295.jpg?v=1748173284",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-60-cm-melamin-aynali-dolap-antrasit-6293.jpg?v=1748173284",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-60-cm-melamin-aynali-dolap-antrasit-6296.jpg?v=1748173280",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/d20-60-cm-melamin-aynali-dolap-antrasit-6297.jpg?v=1748173280"
    ],
    "price": "6847.50",
    "sku": "D20.AD060.ML.ANT",
    "tags": [
      "%10 indirim Yaz",
      "Antrasit",
      "Ayna",
      "Aynalı Dolap",
      "Banyo Mobilyası",
      "D20",
      "Melamin",
      "yaz-10-indirim"
    ],
    "variants": [
      {
        "id": 52843224269097,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "D20.AD060.ML.ANT",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6847.50",
        "grams": 0,
        "compare_at_price": "9130.00",
        "position": 1,
        "product_id": 9523097436457,
        "created_at": "2026-03-17T12:57:43+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Mix &amp; Match ailesinin yeni üyesi D20 ile tanışın!</strong></p>\n<p><span>D20 setleri farklı renk ve boyut seçenekleri ile banyolara özgürlük sunuyor. Yalın ve derinlikli tasarım dili ile banyoda ferah bir atmosfer yaratan D20, geniş saklama alanlarıyla daha düzenli bir mekan kurgusu vadediyor.</span></p>\n<p><span>Güne başladığınız ve günü sonlandırdığınız yerin her detayı sizi yansıtsın. D20 ile banyo tasarımınızı özgürleştirerek daha kişisel bir deneyim yaşayabilirsiniz. Kendi konfor algılarınıza göre tasarladığınız mekan ile yaşam kalitesinizi arttırabilirsiniz.</span></p>\n<!---->"
  },
  {
    "id": "creavit-9480379171113",
    "brand": "Creavit",
    "title": "Banyo Mobilyası Boy Dolabı Montaj Hizmeti",
    "category": "Banyo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/banyo-mobilyasi-demonte-boy-dolabi-montaj-hizmeti-6654.png?v=1747230056",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/banyo-mobilyasi-demonte-boy-dolabi-montaj-hizmeti-6654.png?v=1747230056"
    ],
    "price": "1400.00",
    "sku": "HIZMET.MBD01",
    "tags": [
      "montaj hizmeti"
    ],
    "variants": [
      {
        "id": 52436532691241,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "HIZMET.MBD01",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1400.00",
        "grams": 0,
        "compare_at_price": "1400.00",
        "position": 1,
        "product_id": 9480379171113,
        "created_at": "2026-01-13T17:25:26+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<ul>\n<li>Altyapı tesisatta kullanılan malzeme işciliği fiyata dahil değildir.</li>\n<li>Demonte ürün sökümü hariçtir.</li>\n<li>Montaj yapılacak mekanın hazır olması gerekmektedir.</li>\n<li>Creavit banyo mobilyası boy dolabı montaj hizmeti için yetkili servislerin sunduğu hizmetler 1 yıl garantilidir.</li>\n<li>Montaj işlemine söküm işlemi dahil değildir. Sadece takım işlemi dahildir. Sökme işlemi için servisimiz ekstradan ücret talep edebilir.</li>\n<li>Servis Ekipleri Pazar günleri hariç 09:00 - 18:00 saatleri arasında çalışmaktadır.</li>\n<li>Müşteri desteği taleplerine 48 saat içerisinde geri dönüş sağlanacaktır.</li>\n<li>Montaj işlemi tamamlandığında yetkili servisler müşteri imzasını alarak hizmet belgesinin bir kopyasını müşteriye teslim etmekle yükümlüdür.<meta charset=\"utf-8\">\n</li>\n</ul>"
  },
  {
    "id": "creavit-9480335819049",
    "brand": "Creavit",
    "title": "Banyo Mobilyası Alt Modül Montaj Hizmeti",
    "category": "Banyo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/banyo-mobilyasi-alt-modul-montaj-hizmeti-6291.png?v=1746596027",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/banyo-mobilyasi-alt-modul-montaj-hizmeti-6291.png?v=1746596027"
    ],
    "price": "2450.00",
    "sku": "HIZMET.MAM01",
    "tags": [
      "montaj hizmeti"
    ],
    "variants": [
      {
        "id": 52436532625705,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "HIZMET.MAM01",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2450.00",
        "grams": 0,
        "compare_at_price": "2450.00",
        "position": 1,
        "product_id": 9480335819049,
        "created_at": "2026-01-13T17:25:23+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<ul>\n<li>Altyapı tesisatta kullanılan malzeme işçiliği fiyata dahil değildir.</li>\n<li>Demonte ürün sökümü hariçtir. </li>\n<li>Creavit batarya, ara musluk ve lavabo sifonu montaj bedeli içerisine dahildir.</li>\n<li>Montaj yapılacak mekanın hazır olması gerekmektedir.</li>\n<li>Creavit banyo mobilyası alt modül montajı için yetkili servislerin sunduğu hizmetler 1 yıl garantilidir.</li>\n<li>Servis Ekipleri Pazar günleri hariç 09:00 - 18:00 saatleri arasında çalışmaktadır.</li>\n<li>Müşteri desteği taleplerine 48 saat içerisinde geri dönüş sağlanacaktır.</li>\n<li>Montaj işlemine söküm işlemi dahil değildir. Sadece takım işlemi dahildir. Sökme işlemi için servisimiz ekstradan ücret talep edebilir.</li>\n<li>Montaj işlemi tamamlandığında yetkili servisler müşteri imzasını alarak hizmet belgesinin bir kopyasını müşteriye teslim etmekle yükümlüdür.<meta charset=\"utf-8\">\n</li>\n</ul>"
  },
  {
    "id": "creavit-9480292368681",
    "brand": "Creavit",
    "title": "Banyo Mobilyası Üst Modül Montaj Hizmeti",
    "category": "Banyo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/banyo-mobilyasi-ust-modul-montaj-hizmeti-6290.png?v=1746596020",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/banyo-mobilyasi-ust-modul-montaj-hizmeti-6290.png?v=1746596020"
    ],
    "price": "1400.00",
    "sku": "HIZMET.MUM01",
    "tags": [
      "montaj hizmeti"
    ],
    "variants": [
      {
        "id": 52436532560169,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "HIZMET.MUM01",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1400.00",
        "grams": 0,
        "compare_at_price": "1400.00",
        "position": 1,
        "product_id": 9480292368681,
        "created_at": "2026-01-13T17:25:20+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<ul>\n<li>Altyapı tesisatta kullanılan malzeme işçiliği fiyata dahil değildir. </li>\n<li>Demonte ürün sökümü hariçtir.</li>\n<li>Montaj yapılacak mekanın hazır olması gerekmektedir.</li>\n<li>Creavit banyo mobilyası üst modül montajı için yetkili servislerin sunduğu hizmetler 1 yıl garantilidir.</li>\n<li>Servis Ekipleri Pazar günleri hariç 09:00 - 18:00 saatleri arasında çalışmaktadır.</li>\n<li>Montaj işlemine söküm işlemi dahil değildir. Sadece takım işlemi dahildir. Sökme işlemi için servisimiz ekstradan ücret talep edebilir.</li>\n<li>Müşteri desteği taleplerine 48 saat içerisinde geri dönüş sağlanacaktır.</li>\n<li>Montaj işlemi tamamlandığında yetkili servisler müşteri imzasını alarak hizmet belgesinin bir kopyasını müşteriye teslim etmekle yükümlüdür.<meta charset=\"utf-8\">\n</li>\n</ul>"
  },
  {
    "id": "creavit-9479337181481",
    "brand": "Creavit",
    "title": "Lavabo Montaj Hizmeti",
    "category": "Banyo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-montaj-hizmeti-6289.png?v=1747223213",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-montaj-hizmeti-6289.png?v=1747223213"
    ],
    "price": "2450.00",
    "sku": "HIZMET.LAV01",
    "tags": [
      "montaj hizmeti",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52436532494633,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "HIZMET.LAV01",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2450.00",
        "grams": 0,
        "compare_at_price": "2450.00",
        "position": 1,
        "product_id": 9479337181481,
        "created_at": "2026-01-13T17:25:17+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<ul>\n<li>Creavit Armatür, iki adet ara musluk ve sifon montajları dahildir. </li>\n<li>Uzatma, flex hortum demonte ürün sökümü hariçtir.</li>\n<li>Montaj yapılacak mekanın hazır olması gerekmektedir.</li>\n<li>Creavit lavabo montajı için yetkili servislerin sunduğu hizmetler 1 yıl garantilidir.</li>\n<li>Servis Ekipleri Pazar günleri hariç 09:00 - 18:00 saatleri arasında çalışmaktadır.</li>\n<li>Montaj işlemine söküm işlemi dahil değildir. Sadece takım işlemi dahildir. Sökme işlemi için servisimiz ekstradan ücret talep edebilir.</li>\n<li>Müşteri desteği taleplerine 48 saat içerisinde geri dönüş sağlanacaktır.</li>\n<li>Montaj işlemi tamamlandığında yetkili servisler müşteri imzasını alarak hizmet belgesinin bir kopyasını müşteriye teslim etmekle yükümlüdür.<meta charset=\"utf-8\">\n</li>\n</ul>"
  },
  {
    "id": "creavit-9479323746601",
    "brand": "Creavit",
    "title": "Asma/ Takım Klozet Montaj Hizmeti",
    "category": "Banyo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/asma-takim-klozet-montaj-hizmeti-6288.png?v=1747229130",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/asma-takim-klozet-montaj-hizmeti-6288.png?v=1747229130"
    ],
    "price": "2450.00",
    "sku": "HIZMET.KLO01",
    "tags": [
      "montaj hizmeti"
    ],
    "variants": [
      {
        "id": 52436532461865,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "HIZMET.KLO01",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2450.00",
        "grams": 0,
        "compare_at_price": "2450.00",
        "position": 1,
        "product_id": 9479323746601,
        "created_at": "2026-01-13T17:25:14+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<ul>\n<li>Klozet Kapağı ve ara musluk montajları dahildir.</li>\n<li>Uzatma flex hortumu demonte ürün sökümü fiyata dahil değildir.</li>\n<li>Montaj yapılacak mekanın hazır olması gerekmektedir.</li>\n<li>Creavit asma/ takım klozet montajı için yetkili servislerin sunduğu hizmetler 1 yıl garantilidir.</li>\n<li>Servis Ekipleri Pazar günleri hariç 09:00 - 18:00 saatleri arasında çalışmaktadır.</li>\n<li>Montaj işlemine söküm işlemi dahil değildir. Sadece takım işlemi dahildir. Sökme işlemi için servisimiz ekstradan ücret talep edebilir.</li>\n<li>Müşteri desteği taleplerine 48 saat içerisinde geri dönüş sağlanacaktır.</li>\n<li>Montaj işlemi tamamlandığında yetkili servisler müşteri imzasını alarak hizmet belgesinin bir kopyasını müşteriye teslim etmekle yükümlüdür.<meta charset=\"utf-8\">\n</li>\n</ul>"
  },
  {
    "id": "creavit-9479310868777",
    "brand": "Creavit",
    "title": "Rezervuar/ İç Takım Montaj Hizmeti",
    "category": "Banyo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/rezervuar-ic-takim-montaj-hizmeti-6287.png?v=1747229123",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/rezervuar-ic-takim-montaj-hizmeti-6287.png?v=1747229123"
    ],
    "price": "1750.00",
    "sku": "HIZMET.REZ01",
    "tags": [
      "montaj hizmeti"
    ],
    "variants": [
      {
        "id": 52436532396329,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "HIZMET.REZ01",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1750.00",
        "grams": 0,
        "compare_at_price": "1750.00",
        "position": 1,
        "product_id": 9479310868777,
        "created_at": "2026-01-13T17:25:11+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<ul>\n<li>Creavit rezervuar/ iç takım montajı için yetkili servislerin sunduğu hizmetler 1 yıl garantilidir.</li>\n<li>Servis Ekipleri Pazar günleri hariç 09:00 - 18:00 saatleri arasında çalışmaktadır.</li>\n<li>Müşteri desteği taleplerine 48 saat içerisinde geri dönüş sağlanacaktır.</li>\n<li>Montaj işlemine söküm işlemi dahil değildir. Sadece takım işlemi dahildir. Sökme işlemi için servisimiz ekstradan ücret talep edebilir.</li>\n<li>Montaj işlemi tamamlandığında yetkili servisler müşteri imzasını alarak hizmet belgesinin bir kopyasını müşteriye teslim etmekle yükümlüdür.<meta charset=\"utf-8\">\n</li>\n</ul>"
  },
  {
    "id": "creavit-9479302906153",
    "brand": "Creavit",
    "title": "Gömme Rezervuar Montaj Hizmeti",
    "category": "Banyo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gomme-rezervuar-montaj-hizmeti-6286.png?v=1747229115",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gomme-rezervuar-montaj-hizmeti-6286.png?v=1747229115"
    ],
    "price": "2800.00",
    "sku": "HIZMET.GOM01",
    "tags": [
      "montaj hizmeti"
    ],
    "variants": [
      {
        "id": 52436532166953,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "HIZMET.GOM01",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2800.00",
        "grams": 0,
        "compare_at_price": "2800.00",
        "position": 1,
        "product_id": 9479302906153,
        "created_at": "2026-01-13T17:25:08+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<ul>\n<li>Kırma işlemi, temiz pis su tesisat bağlantıları, altyapı ve işçiliği hariçtir.</li>\n<li>Asma klozet montajı hariçtir.</li>\n<li>Montaj yapılacak mekanın hazır olması gerekmektedir.</li>\n<li>Creavit gömme rezervuar montajı için yetkili servislerin sunduğu hizmetler 1 yıl garantilidir.</li>\n<li>Servis Ekipleri Pazar günleri hariç 09:00 - 18:00 saatleri arasında çalışmaktadır.</li>\n<li>Müşteri desteği taleplerine 48 saat içerisinde geri dönüş sağlanacaktır.</li>\n<li>Montaj işlemi tamamlandığında yetkili servisler müşteri imzasını alarak hizmet belgesinin bir kopyasını müşteriye teslim etmekle yükümlüdür.<meta charset=\"utf-8\">\n</li>\n</ul>"
  },
  {
    "id": "creavit-9479279640873",
    "brand": "Creavit",
    "title": "Armatür/ Duş Sistemi Ürünleri Montaj Hizmeti",
    "category": "Banyo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/armatur-dus-sistemi-urunleri-montaj-hizmeti-6285.png?v=1747229107",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/armatur-dus-sistemi-urunleri-montaj-hizmeti-6285.png?v=1747229107"
    ],
    "price": "1750.00",
    "sku": "HIZMET.ARM01",
    "tags": [
      "montaj hizmeti",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52436532920617,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "HIZMET.ARM01",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1750.00",
        "grams": 0,
        "compare_at_price": "1750.00",
        "position": 1,
        "product_id": 9479279640873,
        "created_at": "2026-01-13T17:25:38+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<ul>\n<li>Creavit armatür/ duş sistemi montajı için yetkili servislerin sunduğu hizmetler 1 yıl garantilidir.</li>\n<li>Servis Ekipleri Pazar günleri hariç 09:00 - 18:00 saatleri arasında çalışmaktadır.</li>\n<li>Müşteri desteği taleplerine 48 saat içerisinde geri dönüş sağlanacaktır.</li>\n<li>Montaj işlemi tamamlandığında yetkili servisler müşteri imzasını alarak hizmet belgesinin bir kopyasını müşteriye teslim etmekle yükümlüdür.<meta charset=\"utf-8\">\n</li>\n</ul>"
  },
  {
    "id": "creavit-9479237337385",
    "brand": "Creavit",
    "title": "Aksesuar/ Diğer Mini Montaj Hizmeti",
    "category": "Banyo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/aksesuar-diger-mini-montaj-hizmeti-6284.png?v=1747229098",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/aksesuar-diger-mini-montaj-hizmeti-6284.png?v=1747229098"
    ],
    "price": "1400.00",
    "sku": "HIZMET.AKS01",
    "tags": [
      "montaj hizmeti"
    ],
    "variants": [
      {
        "id": 52436532953385,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "HIZMET.AKS01",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1400.00",
        "grams": 0,
        "compare_at_price": "1400.00",
        "position": 1,
        "product_id": 9479237337385,
        "created_at": "2026-01-13T17:25:41+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<ul>\n<li>Creavit tamamlayıcı ürün montajı için yetkili servislerin sunduğu hizmetler 1 yıl garantilidir.</li>\n<li>Altyapı tesisatta kullanılan malzeme işciliği fiyata dahil değildir.</li>\n<li>Demonte ürün sökümü hariçtir.</li>\n<li>Montaj yapılacak mekanın hazır olması gerekmektedir.</li>\n<li>Servis Ekipleri Pazar günleri hariç 09:00 - 18:00 saatleri arasında çalışmaktadır.</li>\n<li>Montaj işlemine söküm işlemi dahil değildir. Sadece takım işlemi dahildir. Sökme işlemi için servisimiz ekstradan ücret talep edebilir.</li>\n<li>Müşteri desteği taleplerine 48 saat içerisinde geri dönüş sağlanacaktır.</li>\n<li>Montaj işlemi tamamlandığında yetkili servisler müşteri imzasını alarak hizmet belgesinin bir kopyasını müşteriye teslim etmekle yükümlüdür.<meta charset=\"utf-8\">\n</li>\n</ul>"
  },
  {
    "id": "creavit-9347379101993",
    "brand": "Creavit",
    "title": "Royale Diş Fırçalığı",
    "category": "Diş Fırçalık",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-royale-dis-fircaligi-krom.png?v=1749035190",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-royale-dis-fircaligi-krom.png?v=1749035190",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-dis-fircaligi-6281.jpg?v=1749035190",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-dis-fircaligi-6283.jpg?v=1749035190",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-dis-fircaligi-6280.jpg?v=1749035190"
    ],
    "price": "1440.00",
    "sku": "MA.BR20204",
    "tags": [
      "banyo aksesuarı",
      "diş fırçalık",
      "Krom",
      "royale",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52912502604073,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.BR20204",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1440.00",
        "grams": 0,
        "compare_at_price": "1920.00",
        "position": 1,
        "product_id": 9347379101993,
        "created_at": "2026-04-01T16:14:35+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</span><br></p>"
  },
  {
    "id": "creavit-8801756905769",
    "brand": "Creavit",
    "title": "Ara Kesme Valfi 1/2-1/2\" Beyaz Mat",
    "category": "Ara Musluklar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-ara-kesme-valfi-beyaz-1.png?v=1749221049",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-ara-kesme-valfi-beyaz-1.png?v=1749221049",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ara-kesme-valfi-1-2-1-2-beyaz-mat-4752.png?v=1749221049",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ara-kesme-valfi-1-2-1-2-beyaz-mat-4751.png?v=1749221049",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ara-kesme-valfi-1-2-1-2-beyaz-mat-4753.png?v=1749221036"
    ],
    "price": "2025.00",
    "sku": "MS.AC50L.MBY",
    "tags": [
      "ara kesme valfi",
      "ara musluk",
      "Mat Beyaz",
      "Musluklar",
      "valf"
    ],
    "variants": [
      {
        "id": 52843240653097,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MS.AC50L.MBY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2025.00",
        "grams": 0,
        "compare_at_price": "2700.00",
        "position": 1,
        "product_id": 8801756905769,
        "created_at": "2026-03-17T13:03:44+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p style=\"TEXT-ALIGN: left\"><span data-mce-fragment=\"1\">Minimalist şıklığı ve fonksiyonelliği bir araya getiren Creavit ara musluklar modern banyolara zarafet katıyor. Kolay kullanımı ve pürüzsüz su akışı ile banyo deneyiminizi maksimum konforla taçlandırıyor. Yüksek kaliteli malzemelerle üretilen Creavit ara musluklarını uzun yıllar boyunca güvenle kullanabilirsiniz.</span><span data-mce-fragment=\"1\"></span></p>"
  },
  {
    "id": "creavit-8801755988265",
    "brand": "Creavit",
    "title": "Ara Kesme Valfi 1/2-1/2\" Cool Grey",
    "category": "Ara Musluklar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-ara-kesme-valfi-gri-1.png?v=1749221140",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-ara-kesme-valfi-gri-1.png?v=1749221140",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ara-kesme-valfi-1-2-1-2-cool-grey-4739.png?v=1749221138",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ara-kesme-valfi-1-2-1-2-cool-grey-4741.png?v=1749221138"
    ],
    "price": "2025.00",
    "sku": "MS.AC50L.CGR",
    "tags": [
      "ara kesme valfi",
      "ara musluk",
      "Musluklar",
      "valf"
    ],
    "variants": [
      {
        "id": 52843221975337,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MS.AC50L.CGR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2025.00",
        "grams": 0,
        "compare_at_price": "2700.00",
        "position": 1,
        "product_id": 8801755988265,
        "created_at": "2026-03-17T12:56:49+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p style=\"TEXT-ALIGN: left\"><span data-mce-fragment=\"1\">Minimalist şıklığı ve fonksiyonelliği bir araya getiren Creavit ara musluklar modern banyolara zarafet katıyor. Kolay kullanımı ve pürüzsüz su akışı ile banyo deneyiminizi maksimum konforla taçlandırıyor. Yüksek kaliteli malzemelerle üretilen Creavit ara musluklarını uzun yıllar boyunca güvenle kullanabilirsiniz.</span><span data-mce-fragment=\"1\"></span></p>"
  },
  {
    "id": "creavit-8801756709161",
    "brand": "Creavit",
    "title": "Ara Kesme Valfi 1/2-1/2\" Nil Yeşili",
    "category": "Ara Musluklar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-ara-kesme-valfi-nilyesili.png?v=1749221088",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-ara-kesme-valfi-nilyesili.png?v=1749221088",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ara-kesme-valfi-1-2-1-2-nil-yesili-4749.png?v=1749221088",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ara-kesme-valfi-1-2-1-2-nil-yesili-4748.png?v=1749221088",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ara-kesme-valfi-1-2-1-2-nil-yesili-4750.png?v=1749221082"
    ],
    "price": "2025.00",
    "sku": "MS.AC50L.NYL",
    "tags": [
      "ara kesme valfi",
      "ara musluk",
      "Musluklar",
      "valf"
    ],
    "variants": [
      {
        "id": 52843222073641,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MS.AC50L.NYL",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2025.00",
        "grams": 0,
        "compare_at_price": "2700.00",
        "position": 1,
        "product_id": 8801756709161,
        "created_at": "2026-03-17T12:56:52+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p style=\"TEXT-ALIGN: left\"><span data-mce-fragment=\"1\">Minimalist şıklığı ve fonksiyonelliği bir araya getiren Creavit ara musluklar modern banyolara zarafet katıyor. Kolay kullanımı ve pürüzsüz su akışı ile banyo deneyiminizi maksimum konforla taçlandırıyor. Yüksek kaliteli malzemelerle üretilen Creavit ara musluklarını uzun yıllar boyunca güvenle kullanabilirsiniz.</span><span data-mce-fragment=\"1\"></span></p>"
  },
  {
    "id": "creavit-8801756545321",
    "brand": "Creavit",
    "title": "Ara Kesme Valfi 1/2-1/2\" Berry",
    "category": "Ara Musluklar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-ara-kesme-valfi-berry-1.png?v=1749221123",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-ara-kesme-valfi-berry-1.png?v=1749221123",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ara-kesme-valfi-1-2-1-2-berry-4747.png?v=1749221123",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ara-kesme-valfi-1-2-1-2-berry-4745.png?v=1749221123",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ara-kesme-valfi-1-2-1-2-berry-4746.png?v=1749221123"
    ],
    "price": "2025.00",
    "sku": "MS.AC50L.BRY",
    "tags": [
      "ara kesme valfi",
      "ara musluk",
      "Berry",
      "Musluklar",
      "valf"
    ],
    "variants": [
      {
        "id": 52843246682409,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MS.AC50L.BRY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2025.00",
        "grams": 0,
        "compare_at_price": "2700.00",
        "position": 1,
        "product_id": 8801756545321,
        "created_at": "2026-03-17T13:05:22+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p style=\"TEXT-ALIGN: left\"><span data-mce-fragment=\"1\">Minimalist şıklığı ve fonksiyonelliği bir araya getiren Creavit ara musluklar modern banyolara zarafet katıyor. Kolay kullanımı ve pürüzsüz su akışı ile banyo deneyiminizi maksimum konforla taçlandırıyor. Yüksek kaliteli malzemelerle üretilen Creavit ara musluklarını uzun yıllar boyunca güvenle kullanabilirsiniz.</span><span data-mce-fragment=\"1\"></span></p>"
  },
  {
    "id": "creavit-8808955871529",
    "brand": "Creavit",
    "title": "Lavabo Sifon 33 cm G1 1/4 mat siyah",
    "category": "Lavabo Sifonları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-33-cm-g1-1-4-mat-siyah-4874.png?v=1747224862",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-33-cm-g1-1-4-mat-siyah-4874.png?v=1747224862",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-33-cm-g1-1-4-mat-siyah-4875.png?v=1747224865"
    ],
    "price": "3015.00",
    "sku": "SF.SF198-S",
    "tags": [
      "banyo aksesuarı",
      "Lavabo Gideri",
      "Lavabo Sifon Başlığı",
      "Lavabo Sifonu",
      "Mat Siyah",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52843225153833,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SF.SF198-S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3015.00",
        "grams": 0,
        "compare_at_price": "4020.00",
        "position": 1,
        "product_id": 8808955871529,
        "created_at": "2026-03-17T12:58:05+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<p><span data-mce-fragment=\"1\">Creavit</span><span data-mce-fragment=\"1\"> lavabo sifonları, banyo ve lavabo alanlarınızı daha hijyenik, daha temiz ve daha işlevsel hale getirmek için tasarlandı. Zarif tasarımları, sade çizgileri ve yüksek kaliteli malzemeleriyle </span><span data-mce-fragment=\"1\">bu lavabo </span><span data-mce-fragment=\"1\">sifonları, banyo veya lavabonuzun estetiğini mükemmel bir şekilde tamamlar. Ayrıca, pratik kullanım sağlayan teknolojileri sayesinde suyun sorunsuz bir şekilde akmasını ve atıkların hızlıca uzaklaştırılmasını garanti eder. Hijyen konusundaki hassasiyetimiz, </span><span data-mce-fragment=\"1\">sifonları temizlemesi kolay ve hijyenik tutar. Su tasarrufu odaklı tasarımı, sürdürülebilirlik çabalarına katkı sağlar. </span><span data-mce-fragment=\"1\">Creavit lavabo</span><span data-mce-fragment=\"1\"> sifonları, banyo ve lavabo deneyiminizi daha konforlu ve çevre dostu hale getirmek için mükemmel bir seçenektir.</span></p>"
  },
  {
    "id": "creavit-8757442511145",
    "brand": "Creavit",
    "title": "Nuovo Mutfak Armatürü Krom",
    "category": "Mutfak Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/nuovo-mutfak-armaturu-krom-4383.jpg?v=1747232604",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/nuovo-mutfak-armaturu-krom-4383.jpg?v=1747232604",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/nuovo-mutfak-armaturu-krom-4384.jpg?v=1747232609"
    ],
    "price": "9675.00",
    "sku": "BT.NU8500",
    "tags": [
      "Armatür",
      "krom",
      "mutfak",
      "Mutfak Armatürü",
      "Nuovo",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52923790524713,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.NU8500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9675.00",
        "grams": 0,
        "compare_at_price": "12900.00",
        "position": 1,
        "product_id": 8757442511145,
        "created_at": "2026-04-03T23:25:57+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\">Creavit'in genç ve yenilikçi tasarımı Nuovo, köşeli ve sert hatlı tasarımıyla ıslak mekanlara karakteristik bir görüntü katıyor. Yalın yapısı, Creavit hijyen ve kalite standartları ile banyo, mutfak ve lavabonuzda uzun süreli bir armatür deneyimi için yaratıldı. Creavit armatürleri gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>"
  },
  {
    "id": "creavit-8631582589225",
    "brand": "Creavit",
    "title": "Oval Lavabo 40*50 cm Duvara Dayalı Beyaz",
    "category": "Ayaklı Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/oval-lavabo-40-50-cm-duvara-dayali-beyaz-3988.png?v=1747222425",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/oval-lavabo-40-50-cm-duvara-dayali-beyaz-3988.png?v=1747222425",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/oval-lavabo-40-50-cm-duvara-dayali-beyaz-3989.png?v=1747222428",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/oval-lavabo-40-50-cm-duvara-dayali-beyaz-3990.png?v=1747222431",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/oval-lavabo-40-50-cm-duvara-dayali-beyaz-3991.png?v=1747222435"
    ],
    "price": "2268.00",
    "sku": "TP155-00CB00E-0000",
    "tags": [
      "Ayaklı Lavabo",
      "Beyaz",
      "küçük",
      "küçük banyolar",
      "Lavabo",
      "Oval",
      "Oval Lavabo",
      "Vitrifiye",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52452316315945,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "TP155-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2268.00",
        "grams": 0,
        "compare_at_price": "3780.00",
        "position": 1,
        "product_id": 8631582589225,
        "created_at": "2026-01-16T16:20:51+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Yerden Tasarruf:</strong> Oval Lavabo az yer kaplayan tasarımı ile sınırlı alanlarda etkili bir çözüm sunar. Banyonuzu ferah ve kullanışlı hale getirir.</p>\n<p data-mce-fragment=\"1\"><meta charset=\"utf-8\"><strong>Estetik Çeşitlilik: </strong>Oval Lavabolar farklı tarzlara uyacak şekilde tasarlandı. Modern minimalizmden, geleneksel tarzlara kadar her zevke hitap ediyor.<strong> </strong></p>\n<p data-mce-fragment=\"1\"><meta charset=\"utf-8\"><strong>Dayanıklı Malzemeler: </strong>Kaliteli malzemelerle üretilen Creavit Lavabolar günlük kullanıma karşı sağlam bir yapı sunar. Pürüzsüz yüzeyi kolay temizlenerek zamandan tasarruf sağlar.<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> </span></p>"
  },
  {
    "id": "creavit-8631582556457",
    "brand": "Creavit",
    "title": "Oval Lavabo 36*45cm Duvara Dayalı Beyaz",
    "category": "Ayaklı Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/oval-lavabo-36-45cm-duvara-dayali-beyaz-3981.png?v=1747234205",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/oval-lavabo-36-45cm-duvara-dayali-beyaz-3981.png?v=1747234205",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/oval-lavabo-36-45cm-duvara-dayali-beyaz-3982.png?v=1747234209",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/oval-lavabo-36-45cm-duvara-dayali-beyaz-3984.png?v=1747234214",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/oval-lavabo-36-45cm-duvara-dayali-beyaz-3985.png?v=1747234218",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/oval-lavabo-36-45cm-duvara-dayali-beyaz-3986.png?v=1747234221",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/oval-lavabo-36-45cm-duvara-dayali-beyaz-3987.png?v=1747234225"
    ],
    "price": "2016.00",
    "sku": "TP145-00CB00E-0000",
    "tags": [
      "Ayaklı Lavabo",
      "Beyaz",
      "küçük",
      "küçük banyolar",
      "Lavabo",
      "Oval",
      "Oval Lavabo",
      "Vitrifiye",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52921477300521,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "TP145-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2016.00",
        "grams": 0,
        "compare_at_price": "3360.00",
        "position": 1,
        "product_id": 8631582556457,
        "created_at": "2026-04-03T14:42:51+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Yerden Tasarruf:</strong> Oval Lavabo az yer kaplayan tasarımı ile sınırlı alanlarda etkili bir çözüm sunar. Banyonuzu ferah ve kullanışlı hale getirir.</p>\n<p data-mce-fragment=\"1\"><meta charset=\"utf-8\"><strong>Estetik Çeşitlilik: </strong>Oval Lavabolar farklı tarzlara uyacak şekilde tasarlandı. Modern minimalizmden, geleneksel tarzlara kadar her zevke hitap ediyor.<strong> </strong></p>\n<p data-mce-fragment=\"1\"><meta charset=\"utf-8\"><strong>Dayanıklı Malzemeler: </strong>Kaliteli malzemelerle üretilen Creavit Lavabolar günlük kullanıma karşı sağlam bir yapı sunar. Pürüzsüz yüzeyi kolay temizlenerek zamandan tasarruf sağlar.<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> </span></p>"
  },
  {
    "id": "creavit-8631582490921",
    "brand": "Creavit",
    "title": "Lara Lavabo 60 cm Beyaz",
    "category": "Ayaklı Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-lavabo-60-cm-beyaz-3974.png?v=1747233762",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-lavabo-60-cm-beyaz-3974.png?v=1747233762",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-lavabo-60-cm-beyaz-3975.png?v=1747233767",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-lavabo-60-cm-beyaz-3976.png?v=1747233771",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-lavabo-60-cm-beyaz-3978.png?v=1747233777",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-lavabo-60-cm-beyaz-3979.png?v=1747233779",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-lavabo-60-cm-beyaz-3980.png?v=1747233784"
    ],
    "price": "3600.00",
    "sku": "LR060-00CB00E-0000",
    "tags": [
      "Ayaklı Lavabo",
      "Beyaz",
      "Lara",
      "Lavabo",
      "Vitrifiye",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52920966709545,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LR060-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3600.00",
        "grams": 0,
        "compare_at_price": "6000.00",
        "position": 1,
        "product_id": 8631582490921,
        "created_at": "2026-04-03T12:15:32+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<meta charset=\"utf-8\">\r\n<p data-mce-fragment=\"1\"><span data-mce-fragment=\"1\">Konfor ve Mekan Uyumlu</span>: Creavit Lara Lavabo</p>\r\n\r\n<p data-mce-fragment=\"1\"><meta charset=\"utf-8\"><span data-mce-fragment=\"1\">Creavit Lara Lavabo</span>, banyo düzenlemelerinde hem işlevselliği hem de estetiği bir araya getiren mükemmel bir seçenektir. Sınırlı alanda maksimum kullanım ile banyo deneyiminizi yükselteceksiniz.</p>\r\n\r\n<p data-mce-fragment=\"1\">Alan Tasarrufu:<span data-mce-fragment=\"1\"> Lara lavabolar, dar veya sınırlı alanlara sahip banyolar için mükemmel bir seçenektir. Boş alanlarınızı en iyi şekilde kullanarak banyonuzun daha ferah ve düzenli görünmesini sağlar.</span><br data-mce-fragment=\"1\">\r\nEstetik Çeşitlilik:<span data-mce-fragment=\"1\"> Lara lavabo serisi, farklı tarz ve dekorlara uyum sağlayacak şekilde tasarlanmıştır. Modern minimalizmden geleneksel tarzlara kadar her zevke hitap ederler.</span><br data-mce-fragment=\"1\">\r\nKolay Temizlik:<span data-mce-fragment=\"1\"> Özel tasarımları sayesinde su sıçramalarını en aza indirirler ve temizlikleri son derece kolaydır. Banyonuzu temiz ve düzenli tutmanızı sağlarlar.</span><br data-mce-fragment=\"1\">\r\nDayanıklılık:<span data-mce-fragment=\"1\"> Creavit Lara lavabolar, dayanıklı malzemelerle üretilir. Uzun yıllar boyunca sorunsuz banyo deneyimi yaşayabilirsiniz. </span></p>"
  },
  {
    "id": "creavit-8631582425385",
    "brand": "Creavit",
    "title": "Key Köşeli Lavabo 36x45 cm Beyaz",
    "category": "Ayaklı Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/key-koseli-lavabo-36x45-cm-beyaz-3968.png?v=1747222395",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/key-koseli-lavabo-36x45-cm-beyaz-3968.png?v=1747222395",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/key-koseli-lavabo-36x45-cm-beyaz-3969.png?v=1747222401",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/key-koseli-lavabo-36x45-cm-beyaz-3970.png?v=1747222405",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/key-koseli-lavabo-36x45-cm-beyaz-3971.png?v=1747222408",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/key-koseli-lavabo-36x45-cm-beyaz-3972.png?v=1747222412",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/key-koseli-lavabo-36x45-cm-beyaz-3973.png?v=1747222416"
    ],
    "price": "2340.00",
    "sku": "KY045-00CB00E-0000",
    "tags": [
      "Ayaklı Lavabo",
      "Beyaz",
      "Key",
      "Lavabo",
      "Vitrifiye",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52535036379433,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY045-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2340.00",
        "grams": 0,
        "compare_at_price": "3900.00",
        "position": 1,
        "product_id": 8631582425385,
        "created_at": "2026-01-30T14:11:10+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Pratik ve Şık: Creavit Key Köşeli Lavabo</p>\r\n\r\n<p><meta charset=\"utf-8\"><span data-mce-fragment=\"1\">Creavit Key Köşeli Lavabo</span>, banyo düzenlemelerinde hem işlevselliği hem de estetiği bir araya getiren mükemmel bir seçenektir. Sınırlı alanda maksimum kullanım ile banyo deneyiminizi yükselteceksiniz.</p>\r\n\r\n<p>Alan Tasarrufu:<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> Köşeli lavabolar, dar veya sınırlı alanlara sahip banyolar için mükemmel bir seçenektir. Boş alanlarınızı en iyi şekilde kullanarak banyonuzun daha ferah ve düzenli görünmesini sağlarlar.</span><br>\r\nEstetik Çeşitlilik:<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> Köşeli lavabolar, farklı tarz ve dekorlara uyum sağlayacak şekilde tasarlanmıştır. Modern minimalizmden geleneksel tarzlara kadar her zevke hitap ederler.</span><br>\r\nKolay Temizlik:<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> Pratik tasarımları sayesinde su sıçramalarını en aza indirirler ve temizlikleri son derece kolaydır. Banyonuzu temiz ve düzenli tutmanızı sağlarlar.</span><br>\r\nDayanıklılık:<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> Creavit Key Köşeli lavabolar, dayanıklı malzemelerle üretilir ve uzun yıllar boyunca sorunsuz banyo deneyimi yaşayabilirsiniz. </span><br>\r\n<br>\r\n<meta charset=\"utf-8\"></p>"
  },
  {
    "id": "creavit-8631582720297",
    "brand": "Creavit",
    "title": "Sedef Yarım Ayak Beyaz",
    "category": "Ayaklı Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sedef-yarim-ayak-beyaz-4002.png?v=1747222466",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sedef-yarim-ayak-beyaz-4002.png?v=1747222466",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sedef-yarim-ayak-beyaz-4003.png?v=1747222469",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sedef-yarim-ayak-beyaz-4004.png?v=1747222473",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sedef-yarim-ayak-beyaz-4005.png?v=1747222476",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sedef-yarim-ayak-beyaz-4006.png?v=1747222481"
    ],
    "price": "1800.00",
    "sku": "SD260-00CB00E-0000",
    "tags": [
      "Ayaklı Lavabo",
      "Beyaz",
      "Lavabo",
      "Sedef",
      "Vitrifiye",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52789503230249,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SD260-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "1800.00",
        "grams": 0,
        "compare_at_price": "3000.00",
        "position": 1,
        "product_id": 8631582720297,
        "created_at": "2026-03-03T11:49:38+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Yerden Tasarruf:</strong> Oval Lavabo az yer kaplayan tasarımı ile sınırlı alanlarda etkili bir çözüm sunar. Banyonuzu ferah ve kullanışlı hale getirir.</p>\n<p data-mce-fragment=\"1\"><meta charset=\"utf-8\"><strong>Estetik Çeşitlilik: </strong>Oval Lavabolar farklı tarzlara uyacak şekilde tasarlandı. Modern minimalizmden, geleneksel tarzlara kadar her zevke hitap ediyor.<strong> </strong></p>\n<p data-mce-fragment=\"1\"><meta charset=\"utf-8\"><strong>Dayanıklı Malzemeler: </strong>Kaliteli malzemelerle üretilen Creavit Lavabolar günlük kullanıma karşı sağlam bir yapı sunar. Pürüzsüz yüzeyi kolay temizlenerek zamandan tasarruf sağlar.<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> </span></p>\n<!---->"
  },
  {
    "id": "creavit-8631582753065",
    "brand": "Creavit",
    "title": "Sedef Kısa Yarım Ayak Beyaz",
    "category": "Ayaklı Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sedef-kisa-yarim-ayak-beyaz-4007.png?v=1747222491",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sedef-kisa-yarim-ayak-beyaz-4007.png?v=1747222491",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sedef-kisa-yarim-ayak-beyaz-4008.png?v=1747222494",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sedef-kisa-yarim-ayak-beyaz-4009.png?v=1747222498",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sedef-kisa-yarim-ayak-beyaz-4010.png?v=1747222500",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sedef-kisa-yarim-ayak-beyaz-4011.png?v=1747222505"
    ],
    "price": "1728.00",
    "sku": "SD265-00CB00E-0000",
    "tags": [
      "Ayaklı Lavabo",
      "Beyaz",
      "Lavabo",
      "Sedef",
      "Vitrifiye",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52737938555177,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SD265-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1728.00",
        "grams": 0,
        "compare_at_price": "2880.00",
        "position": 1,
        "product_id": 8631582753065,
        "created_at": "2026-02-23T15:03:04+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Yerden Tasarruf:</strong> Oval Lavabo az yer kaplayan tasarımı ile sınırlı alanlarda etkili bir çözüm sunar. Banyonuzu ferah ve kullanışlı hale getirir.</p>\n<p data-mce-fragment=\"1\"><meta charset=\"utf-8\"><strong>Estetik Çeşitlilik: </strong>Oval Lavabolar farklı tarzlara uyacak şekilde tasarlandı. Modern minimalizmden, geleneksel tarzlara kadar her zevke hitap ediyor.<strong> </strong></p>\n<p data-mce-fragment=\"1\"><meta charset=\"utf-8\"><strong>Dayanıklı Malzemeler: </strong>Kaliteli malzemelerle üretilen Creavit Lavabolar günlük kullanıma karşı sağlam bir yapı sunar. Pürüzsüz yüzeyi kolay temizlenerek zamandan tasarruf sağlar.<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> </span></p>\n<!---->"
  },
  {
    "id": "creavit-8631582654761",
    "brand": "Creavit",
    "title": "Lara Yarım Ayak Beyaz",
    "category": "Ayaklı Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-yarim-ayak-beyaz-3997.png?v=1747233793",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-yarim-ayak-beyaz-3997.png?v=1747233793",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-yarim-ayak-beyaz-3998.png?v=1747233797",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-yarim-ayak-beyaz-3999.png?v=1747233800",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-yarim-ayak-beyaz-4000.png?v=1747233806",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-yarim-ayak-beyaz-4001.png?v=1747233810"
    ],
    "price": "1728.00",
    "sku": "LR260-00CB00E-0000",
    "tags": [
      "Ayaklı Lavabo",
      "Beyaz",
      "Lara",
      "Lavabo",
      "Vitrifiye",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52921477431593,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LR260-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1728.00",
        "grams": 0,
        "compare_at_price": "2880.00",
        "position": 1,
        "product_id": 8631582654761,
        "created_at": "2026-04-03T14:42:54+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Yerden Tasarruf:</strong> Key Köşeli Lavabo az yer kaplayan tasarımı ile sınırlı alanlarda etkili bir çözüm sunar. Banyonuzu ferah ve kullanışlı hale getirir.</p>\n<p data-mce-fragment=\"1\"><meta charset=\"utf-8\"><strong>Estetik Çeşitlilik: </strong>Key Köşeli Lavabolar farklı tarzlara uyacak şekilde tasarlandı. Modern minimalizmden, geleneksel tarzlara kadar her zevke hitap ediyor.<strong> </strong></p>\n<p data-mce-fragment=\"1\"><meta charset=\"utf-8\"><strong>Dayanıklı Malzemeler: </strong>Kaliteli malzemelerle üretilen Creavit Lavabolar günlük kullanıma karşı sağlam bir yapı sunar. Pürüzsüz yüzeyi kolay temizlenerek zamandan tasarruf sağlar.<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> </span></p>\n<!---->"
  },
  {
    "id": "creavit-8631582621993",
    "brand": "Creavit",
    "title": "Key Yarım Ayak Beyaz",
    "category": "Ayaklı Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/key-yarim-ayak-beyaz-3992.png?v=1747447138",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/key-yarim-ayak-beyaz-3992.png?v=1747447138",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/key-yarim-ayak-beyaz-3993.png?v=1747447141",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/key-yarim-ayak-beyaz-3994.png?v=1747447144",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/key-yarim-ayak-beyaz-3995.png?v=1747447147",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/key-yarim-ayak-beyaz-3996.png?v=1747447150"
    ],
    "price": "1512.00",
    "sku": "KY260-00CB00E-0000",
    "tags": [
      "Ayaklı Lavabo",
      "Beyaz",
      "Key",
      "Lavabo",
      "Vitrifiye",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52452316348713,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY260-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1512.00",
        "grams": 0,
        "compare_at_price": "2520.00",
        "position": 1,
        "product_id": 8631582621993,
        "created_at": "2026-01-16T16:20:54+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Yerden Tasarruf:</strong> Key Köşeli Lavabo az yer kaplayan tasarımı ile sınırlı alanlarda etkili bir çözüm sunar. Banyonuzu ferah ve kullanışlı hale getirir.</p>\n<p data-mce-fragment=\"1\"><meta charset=\"utf-8\"><strong>Estetik Çeşitlilik: </strong>Key Köşeli Lavabolar farklı tarzlara uyacak şekilde tasarlandı. Modern minimalizmden, geleneksel tarzlara kadar her zevke hitap ediyor.<strong> </strong></p>\n<p data-mce-fragment=\"1\"><meta charset=\"utf-8\"><strong>Dayanıklı Malzemeler: </strong>Kaliteli malzemelerle üretilen Creavit Lavabolar günlük kullanıma karşı sağlam bir yapı sunar. Pürüzsüz yüzeyi kolay temizlenerek zamandan tasarruf sağlar.<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> </span></p>"
  },
  {
    "id": "creavit-8760238080297",
    "brand": "Creavit",
    "title": "Mare Duroplast Yavaş Kapanan Klozet Kapağı Beyaz",
    "category": "Duroplast Klozet Kapakları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mare-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4447.jpg?v=1747806442",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mare-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4447.jpg?v=1747806442",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mare-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4446.jpg?v=1747806442",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mare-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4448.png?v=1747806442"
    ],
    "price": "3780.00",
    "sku": "KC1703.03.0000E",
    "tags": [
      "Beyaz",
      "duroplast",
      "kapak",
      "klozet kapağı",
      "Mare",
      "tak-çıkar",
      "yavaş kapama",
      "yaz-25-indirim",
      "Yuvarlak"
    ],
    "variants": [
      {
        "id": 52843262804265,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KC1703.03.0000E",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3780.00",
        "grams": 0,
        "compare_at_price": "5400.00",
        "position": 1,
        "product_id": 8760238080297,
        "created_at": "2026-03-17T13:10:24+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<h3>Creavit Mare Serisi Yavaş Kapanan Klozet Kapağı - Beyaz (KC1703.03.0000E)</h3>\n<p><strong>Creavit KC1703.03.0000E</strong> klozet kapağı, Creavit'in <strong>Mare serisine</strong> ait, beyaz renkli ve <strong>antibakteriyel özelliklere</strong> sahip bir üründür. Yavaş kapanma (<em>soft-close</em>) teknolojisi ve dayanıklı <strong>Duroplast</strong> malzemesi ile kullanıcı konforunu ve hijyeni ön planda tutar.</p>\n<h3>🛠️ Ürün Özellikleri</h3>\n<ul>\n<li>\n<strong>Model Kodu:</strong> KC1703.03.0000E</li>\n<li>\n<strong>Seri:</strong> Mare</li>\n<li>\n<strong>Renk:</strong> Beyaz</li>\n<li>\n<strong>Malzeme:</strong> Duroplast (antibakteriyel)</li>\n<li>\n<strong>Ölçüler:</strong> 445 x 333 mm</li>\n<li>\n<strong>Kapanma Özelliği:</strong> Yavaş kapanma (soft-close)</li>\n<li>\n<strong>Menteşe Türü:</strong> Metal menteşe</li>\n<li>\n<strong>Montaj Tipi:</strong> Üstten montaj (tak-çıkar özellikli)</li>\n<li>\n<strong>Ağırlık:</strong> Yaklaşık 2,8 kg</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n<li>\n<strong>Uyumluluk:</strong> MA361-00CB00E-0000 kodlu Mare Rim-Off duvara dayalı klozet modeli ile uyumludur.</li>\n</ul>\n<h3>🧼 Hijyen ve Temizlik</h3>\n<p><strong>Duroplast</strong> malzeme, <strong>antibakteriyel</strong> özellikleri sayesinde bakteri ve mikropların üremesini engeller. Bu, klozet kapağının daha hijyenik ve temiz kalmasını sağlar. Ayrıca <strong>yavaş kapanma özelliği</strong>, kapağın klozete çarparak zarar verme riskini ortadan kaldırır.</p>"
  },
  {
    "id": "creavit-8818721095977",
    "brand": "Creavit",
    "title": "Planet 2li WC Kağıtlığı Kapaksız Mat Siyah",
    "category": "Tuvalet Kağıtlığı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-planet-tuvalet-kagitligi-ikili-kapaksiz-siyah.png?v=1749218845",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-planet-tuvalet-kagitligi-ikili-kapaksiz-siyah.png?v=1749218845",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-2li-wc-kagitligi-kapaksiz-mat-siyah-5112.jpg?v=1749218845",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-2li-wc-kagitligi-kapaksiz-mat-siyah-5114.jpg?v=1749218845",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-2li-wc-kagitligi-kapaksiz-mat-siyah-5113.jpg?v=1749218845",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-2li-wc-kagitligi-kapaksiz-mat-siyah-5111.jpg?v=1749218845",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-2li-wc-kagitligi-kapaksiz-mat-siyah-5115.jpg?v=1749218830"
    ],
    "price": "3285.00",
    "sku": "MA.PL18808-S",
    "tags": [
      "banyo aksesuarı",
      "Mat Siyah",
      "planet",
      "tuvalet kağıtlığı",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52843229577513,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.PL18808-S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3285.00",
        "grams": 0,
        "compare_at_price": "4380.00",
        "position": 1,
        "product_id": 8818721095977,
        "created_at": "2026-03-17T12:59:39+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</span><br></p>"
  },
  {
    "id": "creavit-8818719588649",
    "brand": "Creavit",
    "title": "Planet Tekli Tuvalet Kağıtlığı Mat Siyah",
    "category": "Tuvalet Kağıtlığı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-planet-tekli-tuvalet-kagitligi-kapasiz-siyah.png?v=1749220415",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-planet-tekli-tuvalet-kagitligi-kapasiz-siyah.png?v=1749220415",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tekli-tuvalet-kagitligi-mat-siyah-5087.jpg?v=1749220415",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tekli-tuvalet-kagitligi-mat-siyah-5090.jpg?v=1749220415",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tekli-tuvalet-kagitligi-mat-siyah-5089.jpg?v=1749220415",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tekli-tuvalet-kagitligi-mat-siyah-5086.jpg?v=1749220415",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tekli-tuvalet-kagitligi-mat-siyah-5091.jpg?v=1749220415"
    ],
    "price": "2475.00",
    "sku": "MA.PL18807-S",
    "tags": [
      "banyo aksesuarı",
      "Mat Siyah",
      "planet",
      "tuvalet kağıtlığı",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52876508528937,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.PL18807-S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2475.00",
        "grams": 0,
        "compare_at_price": "3300.00",
        "position": 1,
        "product_id": 8818719588649,
        "created_at": "2026-03-25T12:22:50+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</span><br></p>"
  },
  {
    "id": "creavit-8818719850793",
    "brand": "Creavit",
    "title": "Planet İkili Tuvalet Kağıtlığı Kapaksız",
    "category": "Tuvalet Kağıtlığı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-planet-tuvalet-kagitligi-ikili-kapaksiz-krom.png?v=1749218881",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-planet-tuvalet-kagitligi-ikili-kapaksiz-krom.png?v=1749218881",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-ikili-tuvalet-kagitligi-kapaksiz-5093.jpg?v=1749218881",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-ikili-tuvalet-kagitligi-kapaksiz-5095.jpg?v=1749218881",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-ikili-tuvalet-kagitligi-kapaksiz-5092.jpg?v=1749218881",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-ikili-tuvalet-kagitligi-kapaksiz-5096.jpg?v=1749218868"
    ],
    "price": "2925.00",
    "sku": "MA.PL18808",
    "tags": [
      "banyo aksesuarı",
      "Krom",
      "planet",
      "tuvalet kağıtlığı",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52843229380905,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.PL18808",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2925.00",
        "grams": 0,
        "compare_at_price": "3900.00",
        "position": 1,
        "product_id": 8818719850793,
        "created_at": "2026-03-17T12:59:36+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</span><br></p>"
  },
  {
    "id": "creavit-8816354656553",
    "brand": "Creavit",
    "title": "Planet İkili Askılık Mat Siyah",
    "category": "Havluluk",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-ikili-askilik-mat-siyah-5018.jpg?v=1747225126",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-ikili-askilik-mat-siyah-5018.jpg?v=1747225126",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-ikili-askilik-mat-siyah-5019.jpg?v=1747225129",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-ikili-askilik-mat-siyah-5020.jpg?v=1747225131",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-ikili-askilik-mat-siyah-5021.jpg?v=1747225134",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-ikili-askilik-mat-siyah-5022.jpg?v=1747225136",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-ikili-askilik-mat-siyah-5023.jpg?v=1747225140"
    ],
    "price": "1890.00",
    "sku": "MA.PL18806-S",
    "tags": [
      "askılık",
      "banyo aksesuarı",
      "havluluk",
      "ikili askılık",
      "Mat Siyah",
      "planet",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52843228987689,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.PL18806-S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1890.00",
        "grams": 0,
        "compare_at_price": "2520.00",
        "position": 1,
        "product_id": 8816354656553,
        "created_at": "2026-03-17T12:59:26+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini artırır.</span></p>"
  },
  {
    "id": "creavit-8816349610281",
    "brand": "Creavit",
    "title": "Planet İkili Askılık",
    "category": "Havluluk",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-ikili-askilik-5013.jpg?v=1747225107",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-ikili-askilik-5013.jpg?v=1747225107",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-ikili-askilik-5014.jpg?v=1747225109",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-ikili-askilik-5015.jpg?v=1747225112",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-ikili-askilik-5016.jpg?v=1747225114",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-ikili-askilik-5017.jpg?v=1747225117"
    ],
    "price": "1710.00",
    "sku": "MA.PL18806",
    "tags": [
      "banyo aksesuarı",
      "havluluk",
      "ikili askılık",
      "Krom",
      "planet",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52843247730985,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.PL18806",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1710.00",
        "grams": 0,
        "compare_at_price": "2280.00",
        "position": 1,
        "product_id": 8816349610281,
        "created_at": "2026-03-17T13:05:43+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini artırır.</span></p>"
  },
  {
    "id": "creavit-8758421029161",
    "brand": "Creavit",
    "title": "Solo Duroplast Yavaş Kapanan Klozet Kapağı Beyaz",
    "category": "Duroplast Klozet Kapakları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4427.jpg?v=1747806480",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4427.jpg?v=1747806480",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4426.jpg?v=1747806480"
    ],
    "price": "3780.00",
    "sku": "KC2003.03.0000E",
    "tags": [
      "Beyaz",
      "duroplast",
      "kapak",
      "Kare",
      "klozet kapağı",
      "Solo",
      "tak-çıkar",
      "yavaş kapama",
      "yaz-25-indirim"
    ],
    "variants": [
      {
        "id": 52922282443049,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KC2003.03.0000E",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3780.00",
        "grams": 0,
        "compare_at_price": "5400.00",
        "position": 1,
        "product_id": 8758421029161,
        "created_at": "2026-04-03T17:50:12+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<h3>Creavit Solo Duroplast Yavaş Kapanan Klozet Kapağı (KC2003.03.0000E)</h3>\n<p>Creavit'in Solo serisine ait modern ve dayanıklı bir klozet kapağıdır. Yavaş kapanma özelliği sayesinde sessiz ve güvenli bir kullanım sunar. Duroplast malzemeden üretilmiş olup, hijyenik yapısı ve kolay temizlenebilirliği ile dikkat çeker.</p>\n<h3>🔧 Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> KC2003.03.0000E</li>\n<li>\n<strong>Seri:</strong> Solo</li>\n<li>\n<strong>Malzeme:</strong> Duroplast (antibakteriyel)</li>\n<li>\n<strong>Renk:</strong> Beyaz</li>\n<li>\n<strong>Şekil:</strong> Oval</li>\n<li>\n<strong>Ölçüler:</strong> 426 x 350 mm</li>\n<li>\n<strong>Ağırlık:</strong> 2,80 kg</li>\n<li>\n<strong>Menteşe Malzemesi:</strong> Metal</li>\n<li>\n<strong>Yavaş Kapanma:</strong> Evet (soft close)</li>\n<li>\n<strong>Amortisör:</strong> Mevcut</li>\n<li>\n<strong>Montaj:</strong> Üstten sıkmalı, tak-çıkar özellikli</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit Solo serisi duvara tam dayalı klozetlerle uyumludur.</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\n<h3>🛠️ Ürün Özellikleri</h3>\n<ul>\n<li>\n<strong>Yavaş Kapanma Özelliği:</strong> Kapağın yavaş ve sessiz bir şekilde kapanmasını sağlar, ani çarpmaları ve gürültüyü engeller.</li>\n<li>\n<strong>Antibakteriyel Duroplast Malzeme:</strong> Bakteri ve mikropların üremesini önleyerek hijyenik bir kullanım sunar.</li>\n<li>\n<strong>Kolay Montaj ve Temizlik:</strong> Üstten sıkmalı montaj sistemi sayesinde kurulumu kolaydır ve temizlik sırasında kapağın kolayca çıkarılmasına olanak tanır.</li>\n<li>\n<strong>Dayanıklı Metal Menteşeler:</strong> Uzun ömürlü kullanım için sağlam metal menteşelerle donatılmıştır.</li>\n</ul>"
  },
  {
    "id": "creavit-8631581671721",
    "brand": "Creavit",
    "title": "Loop 45cm Masa Üstü Çanak Lavabo Beyaz",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-beyaz-3891.png?v=1747805423",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-beyaz-3891.png?v=1747805423",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-beyaz-3892.jpg?v=1747805423",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-beyaz-3893.jpg?v=1747805423",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-beyaz-3894.jpg?v=1747805423",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-beyaz-3895.jpg?v=1747805423",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-beyaz-3896.jpg?v=1747805423",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-45cm-masa-ustu-canak-lavabo-beyaz-3897.png?v=1747805423"
    ],
    "price": "8280.00",
    "sku": "LP146-00CB00E-0000",
    "tags": [
      "Beyaz",
      "Lavabo",
      "Loop",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52868680384809,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP146-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8280.00",
        "grams": 0,
        "compare_at_price": "11040.00",
        "position": 1,
        "product_id": 8631581671721,
        "created_at": "2026-03-23T20:23:15+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz Modern Sanat Galerisine Dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop Lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5 mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-8631581573417",
    "brand": "Creavit",
    "title": "Loop Yuvarlak Çanak Lavabo Ø45 cm Mat Siyah",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-mat-siyah-3883.png?v=1747805430",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-mat-siyah-3883.png?v=1747805430",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-mat-siyah-3884.jpg?v=1747805430",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-mat-siyah-3885.jpg?v=1747805430",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-mat-siyah-3886.jpg?v=1747805430",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-mat-siyah-3887.jpg?v=1747805430",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-mat-siyah-3888.jpg?v=1747805430",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-mat-siyah-3889.jpg?v=1747222066",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-mat-siyah-3890.png?v=1747222069"
    ],
    "price": "9375.00",
    "sku": "LP145-00SM00E-0000",
    "tags": [
      "Lavabo",
      "Loop",
      "Mat Siyah",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52927549112617,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP145-00SM00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9375.00",
        "grams": 0,
        "compare_at_price": "12500.00",
        "position": 1,
        "product_id": 8631581573417,
        "created_at": "2026-04-04T16:42:36+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz modern sanat galerisine dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-8631581540649",
    "brand": "Creavit",
    "title": "Loop Yuvarlak Çanak Lavabo Ø45 cm Mat Cappuccino",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-mat-cappuccino-3874.png?v=1747805435",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-mat-cappuccino-3874.png?v=1747805435",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-mat-cappuccino-3875.jpg?v=1747805435",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-mat-cappuccino-3876.jpg?v=1747805435",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-mat-cappuccino-3877.png?v=1747805435",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-mat-cappuccino-3878.jpg?v=1747805435",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-mat-cappuccino-3879.png?v=1747805435",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-mat-cappuccino-3881.jpg?v=1747222034",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-mat-cappuccino-3882.png?v=1747222038"
    ],
    "price": "11385.00",
    "sku": "LP145-00CM00E-0000",
    "tags": [
      "Lavabo",
      "Loop",
      "Mat Cappuccino",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843257364777,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP145-00CM00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11385.00",
        "grams": 0,
        "compare_at_price": "15180.00",
        "position": 1,
        "product_id": 8631581540649,
        "created_at": "2026-03-17T13:08:37+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz modern sanat galerisine dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-8631581475113",
    "brand": "Creavit",
    "title": "Loop Yuvarlak Çanak Lavabo Ø45 cm Mat Antrasit",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-mat-antrasit-3856.png?v=1747805508",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-mat-antrasit-3856.png?v=1747805508",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-mat-antrasit-3857.jpg?v=1747805508",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-mat-antrasit-3858.jpg?v=1747805508",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-mat-antrasit-3860.png?v=1747805508",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-mat-antrasit-3861.png?v=1747805508",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-mat-antrasit-3862.jpg?v=1747805508",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-mat-antrasit-3864.jpg?v=1747805508"
    ],
    "price": "11385.00",
    "sku": "LP145-00AM00E-0000",
    "tags": [
      "Lavabo",
      "Loop",
      "Mat Antrasit",
      "Tezgah Üstü Lavabo",
      "Tezgahüstü",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843187044649,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP145-00AM00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11385.00",
        "grams": 0,
        "compare_at_price": "15180.00",
        "position": 1,
        "product_id": 8631581475113,
        "created_at": "2026-03-17T12:46:43+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz modern sanat galerisine dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-8760428724521",
    "brand": "Creavit",
    "title": "Drop Mat Siyah Boyalı Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-mat-siyah-boyali-kumanda-paneli-4472.jpg?v=1747224064",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-mat-siyah-boyali-kumanda-paneli-4472.jpg?v=1747224064",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-mat-siyah-boyali-kumanda-paneli-4473.jpg?v=1747224068",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-mat-siyah-boyali-kumanda-paneli-4474.jpg?v=1747224070",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-mat-siyah-boyali-kumanda-paneli-4475.jpg?v=1747224072",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-mat-siyah-boyali-kumanda-paneli-4476.jpg?v=1747224075",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-mat-siyah-boyali-kumanda-paneli-4477.jpg?v=1747224077",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-mat-siyah-boyali-kumanda-paneli-4478.jpg?v=1747224081"
    ],
    "price": "2016.00",
    "sku": "GP2002.01",
    "tags": [
      "Klozet Sistemi",
      "Kumanda Paneli",
      "Rezervuar",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52843203297577,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP2002.01",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2016.00",
        "grams": 0,
        "compare_at_price": "2880.00",
        "position": 1,
        "product_id": 8760428724521,
        "created_at": "2026-03-17T12:52:06+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<h3>Creavit GP2002.01 Drop Mat Siyah Boyalı Kumanda Paneli</h3>\n<p><strong>Creavit</strong>'in modern banyolar için tasarladığı şık ve işlevsel bir üründür. Creavit gömme rezervuar sistemleriyle uyumludur ve estetik görünümü ile dikkat çeker.</p>\n<hr>\n<h3>🛠️ Ürün Özellikleri</h3>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> GP2002.01</li>\n<li>\n<strong>Seri:</strong> Drop</li>\n<li>\n<strong>Renk:</strong> Mat Siyah</li>\n<li>\n<strong>Materyal:</strong> ABS plastik ve krom kaplama</li>\n<li>\n<strong>Boyutlar:</strong> 246 x 163 x 13 mm (Genişlik x Yükseklik x Derinlik)</li>\n<li>\n<strong>Çalışma Prensibi:</strong> Çift kademeli manuel deşarj sistemi</li>\n<li>\n<strong>Montaj:</strong> Duvar üzerine kolay montaj</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>\n<strong>Modern Tasarım:</strong> Şık ve ince yapısıyla banyonuza estetik bir hava katar.</li>\n<li>\n<strong>Kullanım Kolaylığı:</strong> Manuel çalışma modu ile pratik kullanım imkânı sunar.</li>\n<li>\n<strong>Dayanıklı Malzeme:</strong> ABS plastik ve krom kaplama uzun ömürlü kullanım sağlar.</li>\n<li>\n<strong>Kolay Montaj:</strong> Hızlı ve basit kurulum imkânı ile zaman kazandırır.</li>\n</ul>\n<hr>\n<h3>🧼 Temizlik ve Bakım</h3>\n<p>Krom kaplama yüzeyi sayesinde leke tutmaz, kolay temizlenir. Nemli bir bezle silinmesi yeterlidir.</p>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>1 adet Drop Mat Siyah Boyalı Kumanda Paneli (GP2002.01)</li>\n<li>Montaj için gerekli bağlantı elemanları</li>\n<li>Kullanım ve montaj kılavuzu</li>\n</ul>\n<hr>\n<p><strong>Creavit GP2002.01</strong>, kolay montajı, dayanıklı yapısı ve modern görünümü ile banyonuza değer katar.</p>"
  },
  {
    "id": "creavit-8760428691753",
    "brand": "Creavit",
    "title": "Drop Mat Gri Boyalı Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-mat-gri-boyali-kumanda-paneli-4465.jpg?v=1747224037",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-mat-gri-boyali-kumanda-paneli-4465.jpg?v=1747224037",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-mat-gri-boyali-kumanda-paneli-4466.jpg?v=1747224040",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-mat-gri-boyali-kumanda-paneli-4467.jpg?v=1747224042",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-mat-gri-boyali-kumanda-paneli-4468.jpg?v=1747224044",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-mat-gri-boyali-kumanda-paneli-4469.jpg?v=1747224048",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-mat-gri-boyali-kumanda-paneli-4470.jpg?v=1747224051",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-mat-gri-boyali-kumanda-paneli-4471.jpg?v=1747224053"
    ],
    "price": "1386.00",
    "sku": "GP2002.00",
    "tags": [
      "Klozet Sistemi",
      "Kumanda Paneli",
      "Rezervuar",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52928362250537,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP2002.00",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1386.00",
        "grams": 0,
        "compare_at_price": "1980.00",
        "position": 1,
        "product_id": 8760428691753,
        "created_at": "2026-04-04T20:26:22+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<h3>Creavit GP2002.00 Drop Mat Gri Kumanda Paneli</h3>\n<p><strong>Creavit GP2002.00 Drop Mat Gri Kumanda Paneli</strong>, Creavit'in modern banyolar için tasarladığı şık ve işlevsel bir üründür. Gömme rezervuar sistemleriyle uyumlu olan bu panel, estetik görünümü ve kullanıcı dostu özellikleriyle dikkat çeker.</p>\n<hr>\n<h3>🛠️ Ürün Özellikleri</h3>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> GP2002.00</li>\n<li>\n<strong>Seri:</strong> Drop</li>\n<li>\n<strong>Renk:</strong> Mat Gri</li>\n<li>\n<strong>Materyal:</strong> Krom kaplama ve plastik</li>\n<li>\n<strong>Boyutlar:</strong> 246 x 163 x 13 mm (G x Y x D)</li>\n<li>\n<strong>Çalışma Prensibi:</strong> Çift kademe</li>\n<li>\n<strong>Çalışma Sistemi:</strong> Manuel</li>\n<li>\n<strong>Montaj:</strong> Duvar üzerine kolay montaj</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>\n<strong>Modern Tasarım:</strong> İnce ve şık yapısıyla banyonuza estetik bir görünüm kazandırır.</li>\n<li>\n<strong>Kullanım Kolaylığı:</strong> Manuel çalışma modu sayesinde kullanıcıya pratik bir kullanım sunar.</li>\n<li>\n<strong>Dayanıklı Malzeme:</strong> Krom kaplama ve plastik malzeme kombinasyonu, uzun ömürlü ve dayanıklı bir yapı sağlar.</li>\n<li>\n<strong>Kolay Montaj:</strong> Duvar üzerine kolayca monte edilebilir, bu da kurulum sürecini hızlandırır.</li>\n</ul>\n<hr>\n<h3>🧼 Temizlik ve Bakım</h3>\n<p>Krom kaplama yüzeyi sayesinde leke tutmaz ve kolay temizlenir. Düzenli olarak nemli bir bezle silinmesi, ürünün parlaklığını ve temizliğini korumasına yardımcı olur.</p>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>1 adet Drop Mat Gri Kumanda Paneli (GP2002.00)</li>\n<li>Montaj için gerekli bağlantı elemanları</li>\n<li>Kullanım ve montaj kılavuzu</li>\n</ul>\n<hr>\n<p><strong>Creavit GP2002.00 Drop Mat Gri Kumanda Paneli</strong>, modern banyolar için estetik ve fonksiyonelliği bir arada sunan ideal bir çözümdür. Kolay montajı, dayanıklı yapısı ve şık tasarımıyla banyonuza değer katacaktır.</p>"
  },
  {
    "id": "creavit-8760428626217",
    "brand": "Creavit",
    "title": "Drop Beyaz Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/Adsiztasarim_84.png?v=1756907282",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/Adsiztasarim_84.png?v=1756907282",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-beyaz-kumanda-paneli-4459.jpg?v=1756907282",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-beyaz-kumanda-paneli-4460.jpg?v=1756907282",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-beyaz-kumanda-paneli-4461.jpg?v=1756907282",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-beyaz-kumanda-paneli-4462.jpg?v=1756907282",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-beyaz-kumanda-paneli-4463.jpg?v=1756907282",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-beyaz-kumanda-paneli-4464.jpg?v=1756907282"
    ],
    "price": "1050.00",
    "sku": "GP2001.00",
    "tags": [
      "Klozet Sistemi",
      "Kumanda Paneli",
      "Rezervuar",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52929342406953,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP2001.00",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1050.00",
        "grams": 0,
        "compare_at_price": "1500.00",
        "position": 1,
        "product_id": 8760428626217,
        "created_at": "2026-04-05T00:25:32+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<h3>Creavit GP2001.00 Drop Beyaz Kumanda Paneli</h3>\n<p>Creavit GP2001.00, \"Drop Beyaz Kumanda Paneli\" Creavit'in gömme rezervuar sistemleriyle uyumlu, modern ve işlevsel bir kumanda panelidir. Estetik tasarımı ve kullanıcı dostu özellikleriyle banyonuza şıklık ve konfor katmak üzere tasarlanmıştır.</p>\n<hr>\n<h3>🛠️ Ürün Özellikleri<strong></strong>\n</h3>\n<ul>\n<li>\n<strong>Materyal:</strong> Krom kaplama ve plastik</li>\n<li>\n<strong>Boyutlar:</strong> 246 x 163 x 13 mm (Genişlik x Yükseklik x Derinlik)</li>\n<li>\n<strong>Çalışma Modu:</strong> Manuel</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit gömme rezervuar sistemleriyle uyumlu</li>\n<li>\n<strong>Montaj:</strong> Duvar üzerine kolay montaj</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>\n<strong>Modern Tasarım:</strong> İnce ve şık yapısıyla banyonuza estetik bir görünüm kazandırır.</li>\n<li>\n<strong>Kullanım Kolaylığı:</strong> Manuel kullanım sayesinde pratik çözüm sunar.</li>\n<li>\n<strong>Dayanıklı Malzeme:</strong> Krom kaplama ve plastik kombinasyonu ile uzun ömürlü kullanım.</li>\n<li>\n<strong>Kolay Montaj:</strong> Hızlı ve zahmetsiz kurulum.</li>\n</ul>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>1 adet Drop Beyaz Kumanda Paneli (GP2001.00)</li>\n<li>Montaj için gerekli bağlantı elemanları</li>\n<li>Kullanım ve montaj kılavuzu</li>\n</ul>"
  },
  {
    "id": "creavit-8823129932073",
    "brand": "Creavit",
    "title": "Start-Stop İç Takım",
    "category": "İç Takım",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/start-stop-ic-takim-5188.png?v=1747225562",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/start-stop-ic-takim-5188.png?v=1747225562",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/start-stop-ic-takim-5189.jpg?v=1747225564"
    ],
    "price": "1890.00",
    "sku": "IT.IT5112",
    "tags": [
      "iç takım",
      "start stop iç takım"
    ],
    "variants": [
      {
        "id": 52920971723049,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "IT.IT5112",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1890.00",
        "grams": 0,
        "compare_at_price": "2520.00",
        "position": 1,
        "product_id": 8823129932073,
        "created_at": "2026-04-03T12:16:57+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit IT5112 Start-Stop İç Takım Kolay ve Hızlı Montaj. İstediğin zaman durdurma özelliği ile su tasarrufu. 5 Yıl Garanti.</p><!---->"
  },
  {
    "id": "creavit-8823127703849",
    "brand": "Creavit",
    "title": "Tek Basmalı İç Takım 40/24  Alttan 3/8",
    "category": "İç Takım",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tek-basmali-ic-takim-40-24-alttan-3-8-5186.png?v=1747225552",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tek-basmali-ic-takim-40-24-alttan-3-8-5186.png?v=1747225552",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tek-basmali-ic-takim-40-24-alttan-3-8-5187.jpg?v=1747225554"
    ],
    "price": "1395.00",
    "sku": "IT.IT1022",
    "tags": [
      "iç takım",
      "tek basmalı iç takım"
    ],
    "variants": [
      {
        "id": 52921484738857,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "IT.IT1022",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1395.00",
        "grams": 0,
        "compare_at_price": "1860.00",
        "position": 1,
        "product_id": 8823127703849,
        "created_at": "2026-04-03T14:44:33+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": ""
  },
  {
    "id": "creavit-8823125311785",
    "brand": "Creavit",
    "title": "Çift Basmalı İç Takım",
    "category": "İç Takım",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/cift-basmali-ic-takim-5184.png?v=1747032708",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/cift-basmali-ic-takim-5184.png?v=1747032708",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/cift-basmali-ic-takim-5185.jpg?v=1747032711"
    ],
    "price": "1575.00",
    "sku": "IT1060",
    "tags": [
      "iç takım",
      "çift basmalı iç takım"
    ],
    "variants": [
      {
        "id": 52922433863977,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "IT1060",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1575.00",
        "grams": 0,
        "compare_at_price": "2100.00",
        "position": 1,
        "product_id": 8823125311785,
        "created_at": "2026-04-03T18:30:58+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": ""
  },
  {
    "id": "creavit-8818974785833",
    "brand": "Creavit",
    "title": "Çöp Kovası 12 Lt (Pedallı) Altın",
    "category": "Çöp Kovaları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/cop-kovasi-12-lt-pedalli-altin-5178.png?v=1747225518",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/cop-kovasi-12-lt-pedalli-altin-5178.png?v=1747225518",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/cop-kovasi-12-lt-pedalli-altin-5180.jpg?v=1747225531",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/cop-kovasi-12-lt-pedalli-altin-5182.jpg?v=1747225541",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/cop-kovasi-12-lt-pedalli-altin-5183.jpg?v=1747225545"
    ],
    "price": "10800.00",
    "sku": "MA.ST17712G",
    "tags": [
      "12 lt",
      "altın",
      "banyo aksesuarı",
      "pedallı çöp kovası",
      "çöp kovası"
    ],
    "variants": [
      {
        "id": 52843230069033,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.ST17712G",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "10800.00",
        "grams": 0,
        "compare_at_price": "14400.00",
        "position": 1,
        "product_id": 8818974785833,
        "created_at": "2026-03-17T12:59:51+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</span><br></p>"
  },
  {
    "id": "creavit-8818974589225",
    "brand": "Creavit",
    "title": "Çöp Kovası 5 Lt (Pedallı) Altın",
    "category": "Çöp Kovaları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/med-st17712g-st17705g-st17703g-copy.jpg?v=1747806746",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/med-st17712g-st17705g-st17703g-copy.jpg?v=1747806746"
    ],
    "price": "7200.00",
    "sku": "MA.ST17705G",
    "tags": [
      "5 lt",
      "altın",
      "banyo aksesuarı",
      "pedallı çöp kovası",
      "çöp kovası"
    ],
    "variants": [
      {
        "id": 52843229970729,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.ST17705G",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7200.00",
        "grams": 0,
        "compare_at_price": "9600.00",
        "position": 1,
        "product_id": 8818974589225,
        "created_at": "2026-03-17T12:59:48+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</span><br></p>"
  },
  {
    "id": "creavit-8818973835561",
    "brand": "Creavit",
    "title": "Çöp Kovası 12 Lt (Pedallı)",
    "category": "Çöp Kovaları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/med-st16612-st16605-st16603-copy.jpg?v=1747806769",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/med-st16612-st16605-st16603-copy.jpg?v=1747806769"
    ],
    "price": "3060.00",
    "sku": "MA.ST16612",
    "tags": [
      "12 lt",
      "banyo aksesuarı",
      "Krom",
      "pedallı çöp kovası",
      "çöp kovası"
    ],
    "variants": [
      {
        "id": 52907154374953,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.ST16612",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "3060.00",
        "grams": 0,
        "compare_at_price": "4080.00",
        "position": 1,
        "product_id": 8818973835561,
        "created_at": "2026-03-31T15:22:56+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</span><br></p>"
  },
  {
    "id": "creavit-8818973409577",
    "brand": "Creavit",
    "title": "Pedallı Çöp Kovası (5 Lt) Mat Siyah",
    "category": "Çöp Kovaları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pedalli-cop-kovasi-5-lt-mat-siyah-5161.png?v=1747128310",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pedalli-cop-kovasi-5-lt-mat-siyah-5161.png?v=1747128310",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pedalli-cop-kovasi-5-lt-mat-siyah-5162.jpg?v=1747128313",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pedalli-cop-kovasi-5-lt-mat-siyah-5163.jpg?v=1747128315",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pedalli-cop-kovasi-5-lt-mat-siyah-5164.jpg?v=1747128318",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pedalli-cop-kovasi-5-lt-mat-siyah-5165.jpg?v=1747128320"
    ],
    "price": "3375.00",
    "sku": "MA.ST16605S",
    "tags": [
      "5 lt",
      "banyo aksesuarı",
      "Drop",
      "Mat Siyah",
      "pedallı çöp kovası",
      "çöp kovası"
    ],
    "variants": [
      {
        "id": 52843232526633,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.ST16605S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3375.00",
        "grams": 0,
        "compare_at_price": "4500.00",
        "position": 1,
        "product_id": 8818973409577,
        "created_at": "2026-03-17T13:00:46+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</span></p>"
  },
  {
    "id": "creavit-8818973278505",
    "brand": "Creavit",
    "title": "Çöp Kovası 5 Lt (Pedallı)",
    "category": "Çöp Kovaları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/cop-kovasi-5-lt-pedalli.png?v=1749220683",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/cop-kovasi-5-lt-pedalli.png?v=1749220683",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/cop-kovasi-5-lt-pedalli-5159.jpg?v=1749220683",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/MA.ST16605_aksesuarlar_creavit_e_ticaret_C-copy-3.jpg?v=1749220683",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/MA.ST16605_aksesuarlar_creavit_e_ticaret_C-copy-4.jpg?v=1749220683"
    ],
    "price": "2160.00",
    "sku": "MA.ST16605",
    "tags": [
      "5 lt",
      "banyo aksesuarı",
      "Krom",
      "pedallı çöp kovası",
      "çöp kovası"
    ],
    "variants": [
      {
        "id": 52886547890473,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.ST16605",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2160.00",
        "grams": 0,
        "compare_at_price": "2880.00",
        "position": 1,
        "product_id": 8818973278505,
        "created_at": "2026-03-27T18:52:48+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</span></p>"
  },
  {
    "id": "creavit-8818910593321",
    "brand": "Creavit",
    "title": "Joyful Tuvalet Fırçalığı",
    "category": "Tuvalet Fırçalığı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-drop-siyah-kumanda-paneli_5.png?v=1749220907",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-drop-siyah-kumanda-paneli_5.png?v=1749220907",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/JOYFULortak_standart_gorseller_aksesuarlar_creavit_e_ticaret_Ccopy4.jpg?v=1749220907",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/MA.BR20216_aksesuarlar_creavit_e_ticaret_Ccopy.jpg?v=1749220906",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/MA.BR20216_aksesuarlar_creavit_e_ticaret_C.jpg?v=1749220906"
    ],
    "price": "1080.00",
    "sku": "MA.BJ11030",
    "tags": [
      "banyo aksesuarı",
      "joyful",
      "klozet fırçalığı",
      "Krom",
      "tuvalet fırçalığı"
    ],
    "variants": [
      {
        "id": 52880072311081,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.BJ11030",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "1080.00",
        "grams": 0,
        "compare_at_price": "1800.00",
        "position": 1,
        "product_id": 8818910593321,
        "created_at": "2026-03-26T08:16:39+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</span><br></p>"
  },
  {
    "id": "creavit-8818910527785",
    "brand": "Creavit",
    "title": "Royale Klozet Fırçalığı Asma (Camlı)",
    "category": "Tuvalet Fırçalığı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-klozet-fircaligi-asma-camli-5144.png?v=1747225419",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-klozet-fircaligi-asma-camli-5144.png?v=1747225419",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-klozet-fircaligi-asma-camli-5145.jpg?v=1747225422",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-klozet-fircaligi-asma-camli-5146.jpg?v=1747225424",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-klozet-fircaligi-asma-camli-5147.jpg?v=1747225427",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-klozet-fircaligi-asma-camli-5148.jpg?v=1747225429",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-klozet-fircaligi-asma-camli-5149.jpg?v=1747225431"
    ],
    "price": "2160.00",
    "sku": "MA.BR20216",
    "tags": [
      "asma tuvalet fırçalığı",
      "banyo aksesuarı",
      "camlı tuvalet fırçalığı",
      "klozet fırçalığı",
      "Krom",
      "royale",
      "tuvalet fırçalığı"
    ],
    "variants": [
      {
        "id": 52843229708585,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.BR20216",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2160.00",
        "grams": 0,
        "compare_at_price": "2880.00",
        "position": 1,
        "product_id": 8818910527785,
        "created_at": "2026-03-17T12:59:42+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</span><br></p>"
  },
  {
    "id": "creavit-8818910396713",
    "brand": "Creavit",
    "title": "Planet Tuvalet Fırçalığı Mat Siyah",
    "category": "Tuvalet Fırçalığı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tuvalet-fircaligi-mat-siyah-5138.png?v=1747225397",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tuvalet-fircaligi-mat-siyah-5138.png?v=1747225397",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tuvalet-fircaligi-mat-siyah-5139.jpg?v=1747225400",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tuvalet-fircaligi-mat-siyah-5140.jpg?v=1747225402",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tuvalet-fircaligi-mat-siyah-5141.jpg?v=1747225405",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tuvalet-fircaligi-mat-siyah-5142.jpg?v=1747225407",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tuvalet-fircaligi-mat-siyah-5143.jpg?v=1747225409"
    ],
    "price": "5220.00",
    "sku": "MA.PL18810-S",
    "tags": [
      "banyo aksesuarı",
      "klozet fırçalığı",
      "Mat Siyah",
      "planet",
      "tuvalet fırçalığı"
    ],
    "variants": [
      {
        "id": 52871576617257,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.PL18810-S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5220.00",
        "grams": 0,
        "compare_at_price": "6960.00",
        "position": 1,
        "product_id": 8818910396713,
        "created_at": "2026-03-24T13:40:38+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</span><br></p>"
  },
  {
    "id": "creavit-8818910232873",
    "brand": "Creavit",
    "title": "Royale Klozet Fırçalığı Asma",
    "category": "Tuvalet Fırçalığı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-klozet-fircaligi-asma-5131.png?v=1747233505",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-klozet-fircaligi-asma-5131.png?v=1747233505",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-klozet-fircaligi-asma-5132.jpg?v=1747233509",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-klozet-fircaligi-asma-5133.jpg?v=1747233512",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-klozet-fircaligi-asma-5134.jpg?v=1747233516",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-klozet-fircaligi-asma-5135.jpg?v=1747233518",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-klozet-fircaligi-asma-5136.jpg?v=1747233521",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-klozet-fircaligi-asma-5137.jpg?v=1747233524"
    ],
    "price": "1980.00",
    "sku": "MA.BR20226",
    "tags": [
      "asma tuvalet fırçalığı",
      "banyo aksesuarı",
      "klozet fırçalığı",
      "Krom",
      "royale",
      "tuvalet fırçalığı"
    ],
    "variants": [
      {
        "id": 52843230396713,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.BR20226",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1980.00",
        "grams": 0,
        "compare_at_price": "2640.00",
        "position": 1,
        "product_id": 8818910232873,
        "created_at": "2026-03-17T12:59:57+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</span></p>"
  },
  {
    "id": "creavit-8818910036265",
    "brand": "Creavit",
    "title": "Planet Tuvalet Fırçalığı",
    "category": "Tuvalet Fırçalığı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tuvalet-fircaligi-5126.png?v=1747225377",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tuvalet-fircaligi-5126.png?v=1747225377",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tuvalet-fircaligi-5127.jpg?v=1747225380",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tuvalet-fircaligi-5128.jpg?v=1747225383",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tuvalet-fircaligi-5129.jpg?v=1747225385",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tuvalet-fircaligi-5130.jpg?v=1747225388"
    ],
    "price": "4860.00",
    "sku": "MA.PL18810",
    "tags": [
      "banyo aksesuarı",
      "klozet fırçalığı",
      "Krom",
      "planet",
      "tuvalet fırçalığı"
    ],
    "variants": [
      {
        "id": 52843232264489,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.PL18810",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "4860.00",
        "grams": 0,
        "compare_at_price": "6480.00",
        "position": 1,
        "product_id": 8818910036265,
        "created_at": "2026-03-17T13:00:39+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</span><br></p>"
  },
  {
    "id": "creavit-8818909839657",
    "brand": "Creavit",
    "title": "Royale Tuvalet Fırçalığı Mat Siyah",
    "category": "Tuvalet Fırçalığı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-tuvalet-fircaligi-mat-siyah-5121.png?v=1747128292",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-tuvalet-fircaligi-mat-siyah-5121.png?v=1747128292",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-tuvalet-fircaligi-mat-siyah-5122.jpg?v=1747128294",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-tuvalet-fircaligi-mat-siyah-5123.jpg?v=1747128297",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-tuvalet-fircaligi-mat-siyah-5124.jpg?v=1747128299",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-tuvalet-fircaligi-mat-siyah-5125.jpg?v=1747128302"
    ],
    "price": "3600.00",
    "sku": "MA.BR20228-S",
    "tags": [
      "banyo aksesuarı",
      "klozet fırçalığı",
      "Mat Siyah",
      "royale",
      "tuvalet fırçalığı"
    ],
    "variants": [
      {
        "id": 52843236688169,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.BR20228-S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3600.00",
        "grams": 0,
        "compare_at_price": "4800.00",
        "position": 1,
        "product_id": 8818909839657,
        "created_at": "2026-03-17T13:02:20+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</span></p>"
  },
  {
    "id": "creavit-8818909610281",
    "brand": "Creavit",
    "title": "Royale Klozet Fırçalığı",
    "category": "Tuvalet Fırçalığı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-klozet-fircaligi-5116.png?v=1747225359",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-klozet-fircaligi-5116.png?v=1747225359",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-klozet-fircaligi-5117.jpg?v=1747225361",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-klozet-fircaligi-5118.jpg?v=1747225364",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-klozet-fircaligi-5119.jpg?v=1747225367",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-klozet-fircaligi-5120.jpg?v=1747225369"
    ],
    "price": "1890.00",
    "sku": "MA.BR20225",
    "tags": [
      "banyo aksesuarı",
      "klozet fırçalığı",
      "Krom",
      "royale",
      "tuvalet fırçalığı"
    ],
    "variants": [
      {
        "id": 52876508561705,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.BR20225",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1890.00",
        "grams": 0,
        "compare_at_price": "2520.00",
        "position": 1,
        "product_id": 8818909610281,
        "created_at": "2026-03-25T12:22:53+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</span></p>"
  },
  {
    "id": "creavit-8818720801065",
    "brand": "Creavit",
    "title": "Royale Kapaklı Tuvalet Kağıtlığı Yedekli",
    "category": "Tuvalet Kağıtlığı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-kapakli-tuvalet-kagitligi-yedekli-5105.png?v=1747225319",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-kapakli-tuvalet-kagitligi-yedekli-5105.png?v=1747225319",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-kapakli-tuvalet-kagitligi-yedekli-5106.jpg?v=1747225322",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-kapakli-tuvalet-kagitligi-yedekli-5107.jpg?v=1747225324",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-kapakli-tuvalet-kagitligi-yedekli-5108.jpg?v=1747225327",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-kapakli-tuvalet-kagitligi-yedekli-5109.jpg?v=1747225329",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-kapakli-tuvalet-kagitligi-yedekli-5110.jpg?v=1747225332"
    ],
    "price": "2475.00",
    "sku": "MA.BR20227",
    "tags": [
      "banyo aksesuarı",
      "Krom",
      "royale",
      "tuvalet kağıtlığı",
      "yedekli tuvalet kağıtlığı"
    ],
    "variants": [
      {
        "id": 52843261526313,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.BR20227",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2475.00",
        "grams": 0,
        "compare_at_price": "3300.00",
        "position": 1,
        "product_id": 8818720801065,
        "created_at": "2026-03-17T13:10:02+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</span><br></p>"
  },
  {
    "id": "creavit-8818720244009",
    "brand": "Creavit",
    "title": "Drop Kağıt Havluluk",
    "category": "Kağıt Havluluk",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-kagit-havluluk-5100.png?v=1747225300",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-kagit-havluluk-5100.png?v=1747225300",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-kagit-havluluk-5101.jpg?v=1747225303",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-kagit-havluluk-5102.jpg?v=1747225305",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-kagit-havluluk-5103.jpg?v=1747225308",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-kagit-havluluk-5104.jpg?v=1747225310"
    ],
    "price": "1620.00",
    "sku": "MA.DR27004",
    "tags": [
      "banyo aksesuarı",
      "Drop",
      "kapaksız tuvalet kağıtlığı",
      "Krom",
      "tuvalet kağıtlığı"
    ],
    "variants": [
      {
        "id": 52896179781929,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.DR27004",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1620.00",
        "grams": 0,
        "compare_at_price": "2160.00",
        "position": 1,
        "product_id": 8818720244009,
        "created_at": "2026-03-29T21:31:55+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, farklı tarzlara uygun seçeneklerle Creavit Aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler uzun ömürlü kullanım sağlarken, şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</p>"
  },
  {
    "id": "creavit-8818719981865",
    "brand": "Creavit",
    "title": "Drop Kağıt Havluluk - Siyah",
    "category": "Kağıt Havluluk",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-kagit-havluluk-siyah-5097.png?v=1747225286",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-kagit-havluluk-siyah-5097.png?v=1747225286",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-kagit-havluluk-siyah-5098.jpg?v=1747225289",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-kagit-havluluk-siyah-5099.jpg?v=1747225291"
    ],
    "price": "2160.00",
    "sku": "MA.DR27004S",
    "tags": [
      "banyo aksesuarı",
      "Drop",
      "kapaksız tuvalet kağıtlığı",
      "siyah",
      "tuvalet kağıtlığı"
    ],
    "variants": [
      {
        "id": 52843231117609,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.DR27004S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2160.00",
        "grams": 0,
        "compare_at_price": "2880.00",
        "position": 1,
        "product_id": 8818719981865,
        "created_at": "2026-03-17T13:00:13+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, farklı tarzlara uygun seçeneklerle Creavit Aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler uzun ömürlü kullanım sağlarken, şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</p>"
  },
  {
    "id": "creavit-8818719162665",
    "brand": "Creavit",
    "title": "Planet Tuvalet Kağıtlığı Kapaklı Mat Siyah",
    "category": "Tuvalet Kağıtlığı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tuvalet-kagitligi-kapakli-mat-siyah-5080.png?v=1747233451",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tuvalet-kagitligi-kapakli-mat-siyah-5080.png?v=1747233451",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tuvalet-kagitligi-kapakli-mat-siyah-5081.jpg?v=1747233454",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tuvalet-kagitligi-kapakli-mat-siyah-5082.jpg?v=1747233458",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tuvalet-kagitligi-kapakli-mat-siyah-5083.jpg?v=1747233461",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tuvalet-kagitligi-kapakli-mat-siyah-5084.jpg?v=1747233463",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tuvalet-kagitligi-kapakli-mat-siyah-5085.jpg?v=1747233468"
    ],
    "price": "3150.00",
    "sku": "MA.PL18809-S",
    "tags": [
      "banyo aksesuarı",
      "kapaklı tuvalet kağıtlığı",
      "Mat Siyah",
      "planet",
      "tuvalet kağıtlığı"
    ],
    "variants": [
      {
        "id": 52871576486185,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.PL18809-S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3150.00",
        "grams": 0,
        "compare_at_price": "4200.00",
        "position": 1,
        "product_id": 8818719162665,
        "created_at": "2026-03-24T13:40:35+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini artırır.</span>"
  },
  {
    "id": "creavit-8818718802217",
    "brand": "Creavit",
    "title": "Drop Geniş Kapaklı Kağıtlık",
    "category": "Tuvalet Kağıtlığı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-genis-kapakli-kagitlik-5076.png?v=1747233431",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-genis-kapakli-kagitlik-5076.png?v=1747233431",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-genis-kapakli-kagitlik-5077.jpg?v=1747233434",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-genis-kapakli-kagitlik-5078.jpg?v=1747233436",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-genis-kapakli-kagitlik-5079.jpg?v=1747233439"
    ],
    "price": "1800.00",
    "sku": "MA.DR27015",
    "tags": [
      "banyo aksesuarı",
      "Drop",
      "kapaklı kağıtlık",
      "kapaklı tuvalet kağıtlığı",
      "Krom",
      "tuvalet kağıtlığı"
    ],
    "variants": [
      {
        "id": 52843251433769,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.DR27015",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1800.00",
        "grams": 0,
        "compare_at_price": "2400.00",
        "position": 1,
        "product_id": 8818718802217,
        "created_at": "2026-03-17T13:06:50+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</span><br></p>"
  },
  {
    "id": "creavit-8818718638377",
    "brand": "Creavit",
    "title": "Drop Geniş Kapaklı Kağıtlık-Siyah",
    "category": "Tuvalet Kağıtlığı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-genis-kapakli-kagitlik-siyah-5071.png?v=1747233407",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-genis-kapakli-kagitlik-siyah-5071.png?v=1747233407",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-genis-kapakli-kagitlik-siyah-5072.jpg?v=1747233410",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-genis-kapakli-kagitlik-siyah-5073.jpg?v=1747233412",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-genis-kapakli-kagitlik-siyah-5074.jpg?v=1747233417",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-genis-kapakli-kagitlik-siyah-5075.jpg?v=1747233422"
    ],
    "price": "2475.00",
    "sku": "MA.DR27015S",
    "tags": [
      "banyo aksesuarı",
      "Drop",
      "kapaklı kağıtlık",
      "kapaklı tuvalet kağıtlığı",
      "siyah",
      "tuvalet kağıtlığı"
    ],
    "variants": [
      {
        "id": 52843230953769,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.DR27015S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2475.00",
        "grams": 0,
        "compare_at_price": "3300.00",
        "position": 1,
        "product_id": 8818718638377,
        "created_at": "2026-03-17T13:00:10+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</span><br></p>"
  },
  {
    "id": "creavit-8818718507305",
    "brand": "Creavit",
    "title": "Planet Tuvalet Kağıtlığı Kapaklı",
    "category": "Tuvalet Kağıtlığı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tuvalet-kagitligi-kapakli-5066.png?v=1747233385",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tuvalet-kagitligi-kapakli-5066.png?v=1747233385",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tuvalet-kagitligi-kapakli-5067.jpg?v=1747233388",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tuvalet-kagitligi-kapakli-5068.jpg?v=1747233392",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tuvalet-kagitligi-kapakli-5069.jpg?v=1747233395",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tuvalet-kagitligi-kapakli-5070.jpg?v=1747233398"
    ],
    "price": "2745.00",
    "sku": "MA.PL18809",
    "tags": [
      "banyo aksesuarı",
      "kapaklı tuvalet kağıtlığı",
      "Krom",
      "planet",
      "tuvalet kağıtlığı"
    ],
    "variants": [
      {
        "id": 52843230822697,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.PL18809",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2745.00",
        "grams": 0,
        "compare_at_price": "3660.00",
        "position": 1,
        "product_id": 8818718507305,
        "created_at": "2026-03-17T13:00:06+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</span><br></p>"
  },
  {
    "id": "creavit-8818718245161",
    "brand": "Creavit",
    "title": "Planet Tekli Tuvalet Kağıtlığı",
    "category": "Tuvalet Kağıtlığı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tekli-tuvalet-kagitligi-5060.png?v=1747233360",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tekli-tuvalet-kagitligi-5060.png?v=1747233360",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tekli-tuvalet-kagitligi-5061.jpg?v=1747233364",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tekli-tuvalet-kagitligi-5062.jpg?v=1747233367",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tekli-tuvalet-kagitligi-5063.jpg?v=1747233370",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tekli-tuvalet-kagitligi-5064.jpg?v=1747233372",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-tekli-tuvalet-kagitligi-5065.jpg?v=1747233376"
    ],
    "price": "2250.00",
    "sku": "MA.PL18807",
    "tags": [
      "banyo aksesuarı",
      "Krom",
      "planet",
      "tekli tuvalet kağıtlığı",
      "tuvalet kağıtlığı"
    ],
    "variants": [
      {
        "id": 52876989301033,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.PL18807",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2250.00",
        "grams": 0,
        "compare_at_price": "3000.00",
        "position": 1,
        "product_id": 8818718245161,
        "created_at": "2026-03-25T15:10:03+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</span><br></p>"
  },
  {
    "id": "creavit-8818718015785",
    "brand": "Creavit",
    "title": "Royale Tuvalet Kağıtlığı (Kapaklı)",
    "category": "Tuvalet Kağıtlığı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-tuvalet-kagitligi-kapakli-5054.png?v=1747225246",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-tuvalet-kagitligi-kapakli-5054.png?v=1747225246",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-tuvalet-kagitligi-kapakli-5055.jpg?v=1747225248",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-tuvalet-kagitligi-kapakli-5056.jpg?v=1747225251",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-tuvalet-kagitligi-kapakli-5057.jpg?v=1747225253",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-tuvalet-kagitligi-kapakli-5058.jpg?v=1747225256",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-tuvalet-kagitligi-kapakli-5059.jpg?v=1747225258"
    ],
    "price": "1440.00",
    "sku": "MA.BR20213",
    "tags": [
      "banyo aksesuarı",
      "kapaklı tuvalet kağıtlığı",
      "Krom",
      "royale",
      "tuvalet kağıtlığı"
    ],
    "variants": [
      {
        "id": 52843248714025,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.BR20213",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1440.00",
        "grams": 0,
        "compare_at_price": "1920.00",
        "position": 1,
        "product_id": 8818718015785,
        "created_at": "2026-03-17T13:05:56+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</span></p>"
  },
  {
    "id": "creavit-8818709102889",
    "brand": "Creavit",
    "title": "Joyful Kapaklı Tuvalet Kağıtlığı",
    "category": "Tuvalet Kağıtlığı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-kapakli-tuvalet-kagitligi-5049.png?v=1747225226",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-kapakli-tuvalet-kagitligi-5049.png?v=1747225226",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-kapakli-tuvalet-kagitligi-5050.jpg?v=1747225229",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-kapakli-tuvalet-kagitligi-5051.jpg?v=1747225231",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-kapakli-tuvalet-kagitligi-5052.jpg?v=1747225234",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-kapakli-tuvalet-kagitligi-5053.jpg?v=1747225236"
    ],
    "price": "612.00",
    "sku": "MA.BJ11028",
    "tags": [
      "banyo aksesuarı",
      "joyful",
      "kapaklı kağıtlık",
      "kapaklı tuvalet kağıtlığı",
      "Krom",
      "tuvalet kağıtlığı"
    ],
    "variants": [
      {
        "id": 52836675879209,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.BJ11028",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "612.00",
        "grams": 0,
        "compare_at_price": "1020.00",
        "position": 1,
        "product_id": 8818709102889,
        "created_at": "2026-03-15T21:14:58+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</span></p>"
  },
  {
    "id": "creavit-8816356163881",
    "brand": "Creavit",
    "title": "Royale Bornozluk (İkili)",
    "category": "Bornozluk",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-bornozluk-ikili-5044.png?v=1747225207",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-bornozluk-ikili-5044.png?v=1747225207",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-bornozluk-ikili-5045.jpg?v=1747225209",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-bornozluk-ikili-5046.jpg?v=1747225212",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-bornozluk-ikili-5047.jpg?v=1747225215",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-bornozluk-ikili-5048.jpg?v=1747225217"
    ],
    "price": "1215.00",
    "sku": "MA.BR20219",
    "tags": [
      "banyo aksesuarı",
      "bornozluk",
      "havluluk",
      "ikili askılık",
      "Krom",
      "royale"
    ],
    "variants": [
      {
        "id": 52843229282601,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.BR20219",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1215.00",
        "grams": 0,
        "compare_at_price": "1620.00",
        "position": 1,
        "product_id": 8816356163881,
        "created_at": "2026-03-17T12:59:33+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, farklı tarzlara uygun seçeneklerle Creavit Aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler uzun ömürlü kullanım sağlarken, şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</p>"
  },
  {
    "id": "creavit-8816355737897",
    "brand": "Creavit",
    "title": "Svida Askılık (İkili)",
    "category": "Havluluk",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/svida-askilik-ikili-5039.png?v=1753794889",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/svida-askilik-ikili-5039.png?v=1753794889",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/svida-askilik-ikili-5040.jpg?v=1747233339",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/svida-askilik-ikili-5041.jpg?v=1747233343",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/svida-askilik-ikili-5042.jpg?v=1747233346",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/svida-askilik-ikili-5043.jpg?v=1747233350"
    ],
    "price": "1125.00",
    "sku": "MA.BS44611",
    "tags": [
      "askılık",
      "banyo aksesuarı",
      "havluluk",
      "ikili askılık",
      "Krom",
      "svida"
    ],
    "variants": [
      {
        "id": 52843229118761,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.BS44611",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1125.00",
        "grams": 0,
        "compare_at_price": "1500.00",
        "position": 1,
        "product_id": 8816355737897,
        "created_at": "2026-03-17T12:59:29+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, farklı tarzlara uygun seçeneklerle Creavit Aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler uzun ömürlü kullanım sağlarken, şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</p>"
  },
  {
    "id": "creavit-8816355442985",
    "brand": "Creavit",
    "title": "Drop 2'li Bornozluk-Siyah",
    "category": "Bornozluk",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-2-li-bornozluk-siyah-5034.png?v=1747225187",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-2-li-bornozluk-siyah-5034.png?v=1747225187",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-2-li-bornozluk-siyah-5035.jpg?v=1747225190",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-2-li-bornozluk-siyah-5036.jpg?v=1747225192",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-2-li-bornozluk-siyah-5037.jpg?v=1747225195",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-2-li-bornozluk-siyah-5038.jpg?v=1747225197"
    ],
    "price": "1395.00",
    "sku": "MA.DR27014S",
    "tags": [
      "askılık",
      "banyo aksesuarı",
      "bornozluk",
      "Drop",
      "havluluk",
      "ikili askılık",
      "siyah"
    ],
    "variants": [
      {
        "id": 52871576387881,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.DR27014S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1395.00",
        "grams": 0,
        "compare_at_price": "1860.00",
        "position": 1,
        "product_id": 8816355442985,
        "created_at": "2026-03-24T13:40:32+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, farklı tarzlara uygun seçeneklerle Creavit Aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler uzun ömürlü kullanım sağlarken, şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</p>"
  },
  {
    "id": "creavit-8816355311913",
    "brand": "Creavit",
    "title": "Drop 2'li Bornozluk",
    "category": "Bornozluk",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-2-li-bornozluk-5029.png?v=1747225168",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-2-li-bornozluk-5029.png?v=1747225168",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-2-li-bornozluk-5030.jpg?v=1747225171",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-2-li-bornozluk-5031.jpg?v=1747225173",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-2-li-bornozluk-5032.jpg?v=1747225176",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-2-li-bornozluk-5033.jpg?v=1747225179"
    ],
    "price": "1035.00",
    "sku": "MA.DR27014",
    "tags": [
      "askılık",
      "banyo aksesuarı",
      "bornozluk",
      "Drop",
      "havluluk",
      "ikili askılık",
      "Krom"
    ],
    "variants": [
      {
        "id": 52843255824681,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.DR27014",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1035.00",
        "grams": 0,
        "compare_at_price": "1380.00",
        "position": 1,
        "product_id": 8816355311913,
        "created_at": "2026-03-17T13:08:13+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, farklı tarzlara uygun seçeneklerle Creavit Aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler uzun ömürlü kullanım sağlarken, şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</p>"
  },
  {
    "id": "creavit-8816354951465",
    "brand": "Creavit",
    "title": "Royale Askılık (İkili)",
    "category": "Havluluk",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-askilik-ikili-5024.png?v=1747225149",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-askilik-ikili-5024.png?v=1747225149",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-askilik-ikili-5025.jpg?v=1747225152",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-askilik-ikili-5026.jpg?v=1747225154",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-askilik-ikili-5027.jpg?v=1747225157",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-askilik-ikili-5028.jpg?v=1747225159"
    ],
    "price": "945.00",
    "sku": "MA.BR20212A",
    "tags": [
      "askılık",
      "banyo aksesuarı",
      "havluluk",
      "ikili askılık",
      "Krom",
      "royale"
    ],
    "variants": [
      {
        "id": 52843251302697,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.BR20212A",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "945.00",
        "grams": 0,
        "compare_at_price": "1260.00",
        "position": 1,
        "product_id": 8816354951465,
        "created_at": "2026-03-17T13:06:47+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, farklı tarzlara uygun seçeneklerle Creavit Aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler uzun ömürlü kullanım sağlarken, şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</p>"
  },
  {
    "id": "creavit-8816349413673",
    "brand": "Creavit",
    "title": "Joyful İkili Bornozluk",
    "category": "Bornozluk",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-ikili-bornozluk-5010.png?v=1747233304",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-ikili-bornozluk-5010.png?v=1747233304",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-ikili-bornozluk-5011.jpg?v=1747233307",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-ikili-bornozluk-5012.jpg?v=1747233310"
    ],
    "price": "396.00",
    "sku": "MA.BJ11026",
    "tags": [
      "askılık",
      "banyo aksesuarı",
      "bornozluk",
      "havluluk",
      "ikili askılık",
      "joyful",
      "Krom"
    ],
    "variants": [
      {
        "id": 52892288614697,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.BJ11026",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "396.00",
        "grams": 0,
        "compare_at_price": "660.00",
        "position": 1,
        "product_id": 8816349413673,
        "created_at": "2026-03-28T19:36:42+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, farklı tarzlara uygun seçeneklerle Creavit Aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler uzun ömürlü kullanım sağlarken, şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</p>"
  },
  {
    "id": "creavit-8816347873577",
    "brand": "Creavit",
    "title": "Drop Uzun Havluluk",
    "category": "Havluluk",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-uzun-havluluk-5005.png?v=1747233283",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-uzun-havluluk-5005.png?v=1747233283",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-uzun-havluluk-5006.jpg?v=1747233286",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-uzun-havluluk-5007.jpg?v=1747233291",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-uzun-havluluk-5008.jpg?v=1747233293",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-uzun-havluluk-5009.jpg?v=1747233296"
    ],
    "price": "2025.00",
    "sku": "MA.DR27006",
    "tags": [
      "askılık",
      "banyo aksesuarı",
      "Drop",
      "havluluk",
      "Krom",
      "uzun havluluk"
    ],
    "variants": [
      {
        "id": 52843228856617,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.DR27006",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2025.00",
        "grams": 0,
        "compare_at_price": "2700.00",
        "position": 1,
        "product_id": 8816347873577,
        "created_at": "2026-03-17T12:59:23+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, farklı tarzlara uygun seçeneklerle Creavit Aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler uzun ömürlü kullanım sağlarken, şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</p>"
  },
  {
    "id": "creavit-8816347382057",
    "brand": "Creavit",
    "title": "Royale Havluluk (Yuvarlak)",
    "category": "Havluluk",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-havluluk-yuvarlak-4999.png?v=1747225086",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-havluluk-yuvarlak-4999.png?v=1747225086",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-havluluk-yuvarlak-5000.jpg?v=1747225089",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-havluluk-yuvarlak-5001.jpg?v=1747225091",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-havluluk-yuvarlak-5002.jpg?v=1747225094",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-havluluk-yuvarlak-5003.jpg?v=1747225096",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-havluluk-yuvarlak-5004.jpg?v=1747225098"
    ],
    "price": "1440.00",
    "sku": "MA.BR20210",
    "tags": [
      "banyo aksesuarı",
      "halka havluluk",
      "havluluk",
      "royale",
      "Yuvarlak",
      "yuvarlak havluluk"
    ],
    "variants": [
      {
        "id": 52912502341929,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.BR20210",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1440.00",
        "grams": 0,
        "compare_at_price": "1920.00",
        "position": 1,
        "product_id": 8816347382057,
        "created_at": "2026-04-01T16:14:32+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, farklı tarzlara uygun seçeneklerle Creavit Aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler uzun ömürlü kullanım sağlarken, şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</p>"
  },
  {
    "id": "creavit-8816346235177",
    "brand": "Creavit",
    "title": "Drop Uzun Havluluk-Siyah",
    "category": "Havluluk",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-uzun-havluluk-siyah-4994.png?v=1747233262",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-uzun-havluluk-siyah-4994.png?v=1747233262",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-uzun-havluluk-siyah-4995.jpg?v=1747233265",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-uzun-havluluk-siyah-4996.jpg?v=1747233268",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-uzun-havluluk-siyah-4997.jpg?v=1747233272",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-uzun-havluluk-siyah-4998.jpg?v=1747233274"
    ],
    "price": "2790.00",
    "sku": "MA.DR27006S",
    "tags": [
      "askılık",
      "banyo aksesuarı",
      "Drop",
      "havluluk",
      "siyah",
      "uzun havluluk"
    ],
    "variants": [
      {
        "id": 52843228758313,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.DR27006S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2790.00",
        "grams": 0,
        "compare_at_price": "3720.00",
        "position": 1,
        "product_id": 8816346235177,
        "created_at": "2026-03-17T12:59:20+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, farklı tarzlara uygun seçeneklerle Creavit Aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler uzun ömürlü kullanım sağlarken, şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</p>"
  },
  {
    "id": "creavit-8816345514281",
    "brand": "Creavit",
    "title": "Planet Yuvarlak Havluluk Mat Siyah",
    "category": "Havluluk",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-yuvarlak-havluluk-mat-siyah-4988.png?v=1747233237",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-yuvarlak-havluluk-mat-siyah-4988.png?v=1747233237",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-yuvarlak-havluluk-mat-siyah-4989.jpg?v=1747233240",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-yuvarlak-havluluk-mat-siyah-4990.jpg?v=1747233244",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-yuvarlak-havluluk-mat-siyah-4991.jpg?v=1747233247",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-yuvarlak-havluluk-mat-siyah-4992.jpg?v=1747233251"
    ],
    "price": "3420.00",
    "sku": "MA.PL18805-S",
    "tags": [
      "askılık",
      "banyo aksesuarı",
      "havluluk",
      "Mat Siyah",
      "planet",
      "Yuvarlak",
      "yuvarlak havluluk"
    ],
    "variants": [
      {
        "id": 52843230691625,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.PL18805-S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3420.00",
        "grams": 0,
        "compare_at_price": "4560.00",
        "position": 1,
        "product_id": 8816345514281,
        "created_at": "2026-03-17T13:00:03+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini artırır.</span></p>"
  },
  {
    "id": "creavit-8816345284905",
    "brand": "Creavit",
    "title": "Drop Yuvarlak Havluluk",
    "category": "Havluluk",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-yuvarlak-havluluk-4983.png?v=1747225066",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-yuvarlak-havluluk-4983.png?v=1747225066",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-yuvarlak-havluluk-4984.jpg?v=1747225069",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-yuvarlak-havluluk-4985.jpg?v=1747225071",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-yuvarlak-havluluk-4986.jpg?v=1747225074",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-yuvarlak-havluluk-4987.jpg?v=1747225076"
    ],
    "price": "1440.00",
    "sku": "MA.DR27005",
    "tags": [
      "askılık",
      "banyo aksesuarı",
      "Drop",
      "halka havluluk",
      "havluluk",
      "Krom",
      "Yuvarlak",
      "yuvarlak havluluk"
    ],
    "variants": [
      {
        "id": 52843228627241,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.DR27005",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1440.00",
        "grams": 0,
        "compare_at_price": "1920.00",
        "position": 1,
        "product_id": 8816345284905,
        "created_at": "2026-03-17T12:59:17+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, farklı tarzlara uygun seçeneklerle Creavit Aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler uzun ömürlü kullanım sağlarken, şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</p>"
  },
  {
    "id": "creavit-8816344989993",
    "brand": "Creavit",
    "title": "Drop Yuvarlak Havluluk-Siyah",
    "category": "Havluluk",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-yuvarlak-havluluk-siyah-4978.png?v=1747225048",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-yuvarlak-havluluk-siyah-4978.png?v=1747225048",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-yuvarlak-havluluk-siyah-4979.jpg?v=1747225050",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-yuvarlak-havluluk-siyah-4980.jpg?v=1747225053",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-yuvarlak-havluluk-siyah-4981.jpg?v=1747225055",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-yuvarlak-havluluk-siyah-4982.jpg?v=1747225058"
    ],
    "price": "1980.00",
    "sku": "MA.DR27005S",
    "tags": [
      "askılık",
      "banyo aksesuarı",
      "Drop",
      "halka havluluk",
      "havluluk",
      "siyah",
      "Yuvarlak",
      "yuvarlak havluluk"
    ],
    "variants": [
      {
        "id": 52876508299561,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.DR27005S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1980.00",
        "grams": 0,
        "compare_at_price": "2640.00",
        "position": 1,
        "product_id": 8816344989993,
        "created_at": "2026-03-25T12:22:47+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, farklı tarzlara uygun seçeneklerle Creavit Aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler uzun ömürlü kullanım sağlarken, şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</p>"
  },
  {
    "id": "creavit-8816344498473",
    "brand": "Creavit",
    "title": "Joyful Yuvarlak Havluluk",
    "category": "Havluluk",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-yuvarlak-havluluk-4975.png?v=1746780716",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-yuvarlak-havluluk-4975.png?v=1746780716",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-yuvarlak-havluluk-4976.jpg?v=1746780722",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-yuvarlak-havluluk-4977.jpg?v=1746780832"
    ],
    "price": "504.00",
    "sku": "MA.BJ11025",
    "tags": [
      "askılık",
      "banyo aksesuarı",
      "halka havluluk",
      "havluluk",
      "Krom",
      "Yuvarlak",
      "yuvarlak havluluk"
    ],
    "variants": [
      {
        "id": 52836674470185,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.BJ11025",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "504.00",
        "grams": 0,
        "compare_at_price": "840.00",
        "position": 1,
        "product_id": 8816344498473,
        "created_at": "2026-03-15T21:14:36+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, farklı tarzlara uygun seçeneklerle Creavit Aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler uzun ömürlü kullanım sağlarken, şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</p>"
  },
  {
    "id": "creavit-8816344367401",
    "brand": "Creavit",
    "title": "Planet Uzun Havluluk Mat Siyah",
    "category": "Havluluk",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-uzun-havluluk-mat-siyah-4970.png?v=1747225029",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-uzun-havluluk-mat-siyah-4970.png?v=1747225029",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-uzun-havluluk-mat-siyah-4971.jpg?v=1747225032",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-uzun-havluluk-mat-siyah-4972.jpg?v=1747225034",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-uzun-havluluk-mat-siyah-4973.jpg?v=1747225037",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-uzun-havluluk-mat-siyah-4974.jpg?v=1747225039"
    ],
    "price": "5040.00",
    "sku": "MA.PL18804-S",
    "tags": [
      "askılık",
      "banyo aksesuarı",
      "havluluk",
      "Mat Siyah",
      "planet",
      "uzun havluluk"
    ],
    "variants": [
      {
        "id": 52843228496169,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.PL18804-S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5040.00",
        "grams": 0,
        "compare_at_price": "6720.00",
        "position": 1,
        "product_id": 8816344367401,
        "created_at": "2026-03-17T12:59:14+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, farklı tarzlara uygun seçeneklerle Creavit Aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler uzun ömürlü kullanım sağlarken, şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</p>"
  },
  {
    "id": "creavit-8816344138025",
    "brand": "Creavit",
    "title": "Planet Uzun Havluluk",
    "category": "Havluluk",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-uzun-havluluk-4965.png?v=1747225011",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-uzun-havluluk-4965.png?v=1747225011",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-uzun-havluluk-4966.jpg?v=1747225013",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-uzun-havluluk-4967.jpg?v=1747225016",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-uzun-havluluk-4968.jpg?v=1747225019",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-uzun-havluluk-4969.jpg?v=1747225021"
    ],
    "price": "4590.00",
    "sku": "MA.PL18804",
    "tags": [
      "askılık",
      "banyo aksesuarı",
      "havluluk",
      "Krom",
      "planet",
      "uzun havluluk"
    ],
    "variants": [
      {
        "id": 52843247567145,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.PL18804",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "4590.00",
        "grams": 0,
        "compare_at_price": "6120.00",
        "position": 1,
        "product_id": 8816344138025,
        "created_at": "2026-03-17T13:05:40+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, farklı tarzlara uygun seçeneklerle Creavit Aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler uzun ömürlü kullanım sağlarken, şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</p>"
  },
  {
    "id": "creavit-8816343908649",
    "brand": "Creavit",
    "title": "Joyful Uzun Havluluk 40cm",
    "category": "Havluluk",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-uzun-havluluk-40cm-4962.png?v=1747224998",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-uzun-havluluk-40cm-4962.png?v=1747224998",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-uzun-havluluk-40cm-4963.jpg?v=1747225000",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-uzun-havluluk-40cm-4964.jpg?v=1747225003"
    ],
    "price": "684.00",
    "sku": "MA.BJ11024",
    "tags": [
      "askılık",
      "banyo aksesuarı",
      "havluluk",
      "joyful",
      "Krom",
      "uzun havluluk"
    ],
    "variants": [
      {
        "id": 52836674142505,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.BJ11024",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "684.00",
        "grams": 0,
        "compare_at_price": "1140.00",
        "position": 1,
        "product_id": 8816343908649,
        "created_at": "2026-03-15T21:14:30+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, farklı tarzlara uygun seçeneklerle Creavit Aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler uzun ömürlü kullanım sağlarken, şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</p>"
  },
  {
    "id": "creavit-8816343515433",
    "brand": "Creavit",
    "title": "Planet Yuvarlak Havluluk",
    "category": "Havluluk",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-yuvarlak-havluluk-4957.png?v=1747233215",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-yuvarlak-havluluk-4957.png?v=1747233215",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-yuvarlak-havluluk-4958.jpg?v=1747233218",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-yuvarlak-havluluk-4959.jpg?v=1747233221",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-yuvarlak-havluluk-4960.jpg?v=1747233224",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-yuvarlak-havluluk-4961.jpg?v=1747233228"
    ],
    "price": "3150.00",
    "sku": "MA.PL18805",
    "tags": [
      "askılık",
      "banyo aksesuarı",
      "havluluk",
      "Krom",
      "planet",
      "Yuvarlak",
      "yuvarlak havluluk"
    ],
    "variants": [
      {
        "id": 52843230560553,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.PL18805",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3150.00",
        "grams": 0,
        "compare_at_price": "4200.00",
        "position": 1,
        "product_id": 8816343515433,
        "created_at": "2026-03-17T13:00:00+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini artırır.</span></p>"
  },
  {
    "id": "creavit-8816343318825",
    "brand": "Creavit",
    "title": "Royale Havluluk 45 cm",
    "category": "Havluluk",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-havluluk-45-cm-4952.png?v=1747233195",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-havluluk-45-cm-4952.png?v=1747233195",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-havluluk-45-cm-4953.jpg?v=1747233197",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-havluluk-45-cm-4954.jpg?v=1747233200",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-havluluk-45-cm-4955.jpg?v=1747233203",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-havluluk-45-cm-4956.jpg?v=1747233206"
    ],
    "price": "2025.00",
    "sku": "MA.BR20208",
    "tags": [
      "askılık",
      "banyo aksesuarı",
      "havluluk",
      "Krom",
      "royale",
      "uzun havluluk"
    ],
    "variants": [
      {
        "id": 52921484312873,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.BR20208",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "2025.00",
        "grams": 0,
        "compare_at_price": "2700.00",
        "position": 1,
        "product_id": 8816343318825,
        "created_at": "2026-04-03T14:44:27+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini artırır.</span></p>"
  },
  {
    "id": "creavit-8815386525993",
    "brand": "Creavit",
    "title": "Planet Diş Fırçalık",
    "category": "Diş Fırçalık",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-dis-fircalik-4946.png?v=1747224977",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-dis-fircalik-4946.png?v=1747224977",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-dis-fircalik-4947.jpg?v=1747224980",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-dis-fircalik-4948.jpg?v=1747224982",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-dis-fircalik-4949.jpg?v=1747224985",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-dis-fircalik-4950.jpg?v=1747224987",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-dis-fircalik-4951.jpg?v=1747224990"
    ],
    "price": "2250.00",
    "sku": "MA.PL18803",
    "tags": [
      "banyo aksesuarı",
      "diş fırçalık",
      "Krom",
      "planet"
    ],
    "variants": [
      {
        "id": 52843228397865,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.PL18803",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2250.00",
        "grams": 0,
        "compare_at_price": "3000.00",
        "position": 1,
        "product_id": 8815386525993,
        "created_at": "2026-03-17T12:59:11+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini artırır.</span></p>"
  },
  {
    "id": "creavit-8815385510185",
    "brand": "Creavit",
    "title": "Planet Diş Fırçalık Mat Siyah",
    "category": "Diş Fırçalık",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-dis-fircalik-mat-siyah-4940.png?v=1747224955",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-dis-fircalik-mat-siyah-4940.png?v=1747224955",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-dis-fircalik-mat-siyah-4941.jpg?v=1747224958",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-dis-fircalik-mat-siyah-4942.jpg?v=1747224960",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-dis-fircalik-mat-siyah-4943.jpg?v=1747224963",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-dis-fircalik-mat-siyah-4944.jpg?v=1747224965",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-dis-fircalik-mat-siyah-4945.jpg?v=1747224968"
    ],
    "price": "2475.00",
    "sku": "MA.PL18803-S",
    "tags": [
      "banyo aksesuarı",
      "diş fırçalık",
      "Mat Siyah",
      "planet"
    ],
    "variants": [
      {
        "id": 52843263852841,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.PL18803-S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2475.00",
        "grams": 0,
        "compare_at_price": "3300.00",
        "position": 1,
        "product_id": 8815385510185,
        "created_at": "2026-03-17T13:10:48+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini artırır.</span></p>"
  },
  {
    "id": "creavit-8815379841321",
    "brand": "Creavit",
    "title": "Joyful Diş Fırçalık",
    "category": "Diş Fırçalık",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-dis-fircalik-4935.png?v=1747224936",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-dis-fircalik-4935.png?v=1747224936",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-dis-fircalik-4936.jpg?v=1747224939",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-dis-fircalik-4937.jpg?v=1747224942",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-dis-fircalik-4938.jpg?v=1747224944",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-dis-fircalik-4939.jpg?v=1747224946"
    ],
    "price": "468.00",
    "sku": "MA.BJ11023",
    "tags": [
      "banyo aksesuarı",
      "diş fırçalık",
      "joyful",
      "Krom"
    ],
    "variants": [
      {
        "id": 52921484083497,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.BJ11023",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "468.00",
        "grams": 0,
        "compare_at_price": "780.00",
        "position": 1,
        "product_id": 8815379841321,
        "created_at": "2026-04-03T14:44:24+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">650Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini artırır.</span></p>"
  },
  {
    "id": "creavit-8811243733289",
    "brand": "Creavit",
    "title": "Royale Sabunluk",
    "category": "Sabunluk",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-sabunluk-4930.png?v=1747224918",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-sabunluk-4930.png?v=1747224918",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-sabunluk-4931.jpg?v=1747224920",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-sabunluk-4932.jpg?v=1747224922",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-sabunluk-4933.jpg?v=1747224925",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-sabunluk-4934.jpg?v=1747224927"
    ],
    "price": "1440.00",
    "sku": "MA.BR20203",
    "tags": [
      "banyo aksesuarı",
      "Krom",
      "Oval",
      "oval sabunluk",
      "Royale",
      "sabunluk"
    ],
    "variants": [
      {
        "id": 52843239178537,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.BR20203",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1440.00",
        "grams": 0,
        "compare_at_price": "1920.00",
        "position": 1,
        "product_id": 8811243733289,
        "created_at": "2026-03-17T13:03:13+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</span><br></p>"
  },
  {
    "id": "creavit-8811242717481",
    "brand": "Creavit",
    "title": "Joyful Sıvı Sabunluk",
    "category": "Sabunluk",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-sivi-sabunluk-4927.png?v=1747224904",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-sivi-sabunluk-4927.png?v=1747224904",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-sivi-sabunluk-4928.jpg?v=1747224907",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-sivi-sabunluk-4929.jpg?v=1747224909"
    ],
    "price": "1188.00",
    "sku": "MA.BJ11022-B",
    "tags": [
      "banyo aksesuarı",
      "Beyaz",
      "joyful",
      "Krom",
      "sabunluk",
      "sıvı sabunluk"
    ],
    "variants": [
      {
        "id": 52912502210857,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.BJ11022-B",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "1188.00",
        "grams": 0,
        "compare_at_price": "1980.00",
        "position": 1,
        "product_id": 8811242717481,
        "created_at": "2026-04-01T16:14:29+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</span><br></p>"
  },
  {
    "id": "creavit-8811242193193",
    "brand": "Creavit",
    "title": "Planet Sabunluk",
    "category": "Sabunluk",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-sabunluk-4922.png?v=1747233174",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-sabunluk-4922.png?v=1747233174",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-sabunluk-4923.jpg?v=1747233178",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-sabunluk-4924.jpg?v=1747233181",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-sabunluk-4925.jpg?v=1747233183",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-sabunluk-4926.jpg?v=1747233186"
    ],
    "price": "2250.00",
    "sku": "MA.PL18802",
    "tags": [
      "banyo aksesuarı",
      "Krom",
      "Oval",
      "oval sabunluk",
      "planet",
      "sabunluk"
    ],
    "variants": [
      {
        "id": 52843228234025,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.PL18802",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2250.00",
        "grams": 0,
        "compare_at_price": "3000.00",
        "position": 1,
        "product_id": 8811242193193,
        "created_at": "2026-03-17T12:59:08+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">1300Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini artırır. </span></p>"
  },
  {
    "id": "creavit-8811241898281",
    "brand": "Creavit",
    "title": "Planet Sabunluk Mat Siyah",
    "category": "Sabunluk",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-sabunluk-mat-siyah-4916.png?v=1747233148",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-sabunluk-mat-siyah-4916.png?v=1747233148",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-sabunluk-mat-siyah-4917.jpg?v=1747233152",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-sabunluk-mat-siyah-4918.jpg?v=1747233156",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-sabunluk-mat-siyah-4919.jpg?v=1747233160",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-sabunluk-mat-siyah-4920.jpg?v=1747233163",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/planet-sabunluk-mat-siyah-4921.jpg?v=1747233166"
    ],
    "price": "2475.00",
    "sku": "MA.PL18802-S",
    "tags": [
      "banyo aksesuarı",
      "Mat Siyah",
      "Oval",
      "oval sabunluk",
      "planet",
      "sabunluk"
    ],
    "variants": [
      {
        "id": 52871576125737,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.PL18802-S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2475.00",
        "grams": 0,
        "compare_at_price": "3300.00",
        "position": 1,
        "product_id": 8811241898281,
        "created_at": "2026-03-24T13:40:25+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</span><br></p>"
  },
  {
    "id": "creavit-8811241570601",
    "brand": "Creavit",
    "title": "Joyful Sabunluk",
    "category": "Sabunluk",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-sabunluk-4913.png?v=1747224891",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-sabunluk-4913.png?v=1747224891",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-sabunluk-4914.jpg?v=1747224893",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/joyful-sabunluk-4915.jpg?v=1747224896"
    ],
    "price": "468.00",
    "sku": "MA.BJ11022",
    "tags": [
      "banyo aksesuarı",
      "Beyaz",
      "joyful",
      "Krom",
      "sabunluk"
    ],
    "variants": [
      {
        "id": 52836673618217,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.BJ11022",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "468.00",
        "grams": 0,
        "compare_at_price": "780.00",
        "position": 1,
        "product_id": 8811241570601,
        "created_at": "2026-03-15T21:14:17+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, </span><span data-mce-fragment=\"1\">farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini arttıracak.</span><br></p>"
  },
  {
    "id": "creavit-8811238850857",
    "brand": "Creavit",
    "title": "Royale Sıvı Sabunluk (Camlı)",
    "category": "Sabunluk",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-sivi-sabunluk-camli-4908.png?v=1747224874",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-sivi-sabunluk-camli-4908.png?v=1747224874",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-sivi-sabunluk-camli-4909.jpg?v=1747224876",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-sivi-sabunluk-camli-4910.jpg?v=1747224879",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-sivi-sabunluk-camli-4911.jpg?v=1747224881",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/royale-sivi-sabunluk-camli-4912.jpg?v=1747224883"
    ],
    "price": "2340.00",
    "sku": "MA.BR20206",
    "tags": [
      "banyo aksesuarı",
      "Krom",
      "royale",
      "sabunluk",
      "sıvı sabunluk"
    ],
    "variants": [
      {
        "id": 52876508234025,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MA.BR20206",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2340.00",
        "grams": 0,
        "compare_at_price": "3120.00",
        "position": 1,
        "product_id": 8811238850857,
        "created_at": "2026-03-25T12:22:43+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Creavit banyo aksesuarları banyo deneyiminizi daha konforlu ve düzenli hale getirmek için tasarlandı. İnce düşünülen detaylar, fonksiyonellik ve estetik, farklı tarzlara uygun seçeneklerle Creavit aksesuarları banyo alanlarınıza zarif bir dokunuş ekleyecek. Kaliteli malzemeler, uzun ömürlü kullanım sağlarken şık tasarımları da banyo alanlarınızın estetiğini artırır. </span></p>"
  },
  {
    "id": "creavit-8808958525737",
    "brand": "Creavit",
    "title": "Lavabo Sifonu 32lik Körüklü Gideri",
    "category": "Lavabo Sifonları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifonu-32lik-koruklu-gideri-4877.png?v=1746868172",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifonu-32lik-koruklu-gideri-4877.png?v=1746868172"
    ],
    "price": "405.00",
    "sku": "SF.SF240",
    "tags": [
      "banyo aksesuarı",
      "Krom",
      "Lavabo Gideri",
      "Lavabo Sifon Başlığı",
      "Lavabo Sifonu"
    ],
    "variants": [
      {
        "id": 52928598868265,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SF.SF240",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "405.00",
        "grams": 0,
        "compare_at_price": "540.00",
        "position": 1,
        "product_id": 8808958525737,
        "created_at": "2026-04-04T21:27:29+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": ""
  },
  {
    "id": "creavit-8808956952873",
    "brand": "Creavit",
    "title": "Lavabo Sifonu Körüklü  - 32 mm",
    "category": "Lavabo Sifonları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifonu-koruklu-32-mm-4876.png?v=1747233108",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifonu-koruklu-32-mm-4876.png?v=1747233108"
    ],
    "price": "270.00",
    "sku": "SF.SF232",
    "tags": [
      "banyo aksesuarı",
      "Krom",
      "Lavabo Gideri",
      "Lavabo Sifon Başlığı",
      "Lavabo Sifonu",
      "Metal Körüklü",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52892288516393,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SF.SF232",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "270.00",
        "grams": 0,
        "compare_at_price": "360.00",
        "position": 1,
        "product_id": 8808956952873,
        "created_at": "2026-03-28T19:36:39+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": ""
  },
  {
    "id": "creavit-8808955085097",
    "brand": "Creavit",
    "title": "Lavabo Sifon 33 cm  G1 1/4 - Altın",
    "category": "Lavabo Sifonları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-33-cm-g1-1-4-altin-4871.png?v=1747233865",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-33-cm-g1-1-4-altin-4871.png?v=1747233865",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-33-cm-g1-1-4-altin-4872.png?v=1747233868",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-33-cm-g1-1-4-altin-4873.png?v=1747233873"
    ],
    "price": "4680.00",
    "sku": "SF.SF198G",
    "tags": [
      "altın",
      "banyo aksesuarı",
      "Lavabo Gideri",
      "Lavabo Sifon Başlığı",
      "Lavabo Sifonu",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52843225022761,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SF.SF198G",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "4680.00",
        "grams": 0,
        "compare_at_price": "6240.00",
        "position": 1,
        "product_id": 8808955085097,
        "created_at": "2026-03-17T12:58:02+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<p><span data-mce-fragment=\"1\">Creavit</span><span data-mce-fragment=\"1\"> lavabo sifonları, banyo ve lavabo alanlarınızı daha hijyenik, daha temiz ve daha işlevsel hale getirmek için tasarlandı. Zarif tasarımları, sade çizgileri ve yüksek kaliteli malzemeleriyle </span><span data-mce-fragment=\"1\">bu lavabo </span><span data-mce-fragment=\"1\">sifonları, banyo veya lavabonuzun estetiğini mükemmel bir şekilde tamamlar. Ayrıca, pratik kullanım sağlayan teknolojileri sayesinde suyun sorunsuz bir şekilde akmasını ve atıkların hızlıca uzaklaştırılmasını garanti eder. Hijyen konusundaki hassasiyetimiz, </span><span data-mce-fragment=\"1\">sifonları temizlemesi kolay ve hijyenik tutar. Su tasarrufu odaklı tasarımı, sürdürülebilirlik çabalarına katkı sağlar. </span><span data-mce-fragment=\"1\">Creavit lavabo</span><span data-mce-fragment=\"1\"> sifonları, banyo ve lavabo deneyiminizi daha konforlu ve çevre dostu hale getirmek için mükemmel bir seçenektir.</span></p>"
  },
  {
    "id": "creavit-8808954331433",
    "brand": "Creavit",
    "title": "Lavabo Sifon 33 cm G1 1/4",
    "category": "Lavabo Sifonları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-33-cm-g1-1-4-4870.png?v=1747224855",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-33-cm-g1-1-4-4870.png?v=1747224855"
    ],
    "price": "3825.00",
    "sku": "SF.SF198",
    "tags": [
      "banyo aksesuarı",
      "Krom",
      "Lavabo Gideri",
      "Lavabo Sifon Başlığı",
      "Lavabo Sifonu",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52843224891689,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SF.SF198",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3825.00",
        "grams": 0,
        "compare_at_price": "5100.00",
        "position": 1,
        "product_id": 8808954331433,
        "created_at": "2026-03-17T12:57:59+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<p><span data-mce-fragment=\"1\">Creavit</span><span data-mce-fragment=\"1\"> lavabo sifonları, banyo ve lavabo alanlarınızı daha hijyenik, daha temiz ve daha işlevsel hale getirmek için tasarlandı. Zarif tasarımları, sade çizgileri ve yüksek kaliteli malzemeleriyle </span><span data-mce-fragment=\"1\">bu lavabo </span><span data-mce-fragment=\"1\">sifonları, banyo veya lavabonuzun estetiğini mükemmel bir şekilde tamamlar. Ayrıca, pratik kullanım sağlayan teknolojileri sayesinde suyun sorunsuz bir şekilde akmasını ve atıkların hızlıca uzaklaştırılmasını garanti eder. Hijyen konusundaki hassasiyetimiz, </span><span data-mce-fragment=\"1\">sifonları temizlemesi kolay ve hijyenik tutar. Su tasarrufu odaklı tasarımı, sürdürülebilirlik çabalarına katkı sağlar. </span><span data-mce-fragment=\"1\">Creavit lavabo</span><span data-mce-fragment=\"1\"> sifonları, banyo ve lavabo deneyiminizi daha konforlu ve çevre dostu hale getirmek için mükemmel bir seçenektir.</span></p>"
  },
  {
    "id": "creavit-8808953119017",
    "brand": "Creavit",
    "title": "Lavabo Sifonu 33 cm Süzgeçli Krom",
    "category": "Lavabo Sifonları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifonu-33-cm-suzgecli-krom-4869.png?v=1747224848",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifonu-33-cm-suzgecli-krom-4869.png?v=1747224848"
    ],
    "price": "3510.00",
    "sku": "SF.SF175",
    "tags": [
      "banyo aksesuarı",
      "Krom",
      "Lavabo Gideri",
      "Lavabo Sifon Başlığı",
      "Lavabo Sifonu",
      "Süzgeçli Sifon",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52843224760617,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SF.SF175",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3510.00",
        "grams": 0,
        "compare_at_price": "4680.00",
        "position": 1,
        "product_id": 8808953119017,
        "created_at": "2026-03-17T12:57:56+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<p><span data-mce-fragment=\"1\">Creavit</span><span data-mce-fragment=\"1\"> lavabo sifonları, banyo ve lavabo alanlarınızı daha hijyenik, daha temiz ve daha işlevsel hale getirmek için tasarlandı. Zarif tasarımları, sade çizgileri ve yüksek kaliteli malzemeleriyle </span><span data-mce-fragment=\"1\">bu lavabo </span><span data-mce-fragment=\"1\">sifonları, banyo veya lavabonuzun estetiğini mükemmel bir şekilde tamamlar. Ayrıca, pratik kullanım sağlayan teknolojileri sayesinde suyun sorunsuz bir şekilde akmasını ve atıkların hızlıca uzaklaştırılmasını garanti eder. Hijyen konusundaki hassasiyetimiz, </span><span data-mce-fragment=\"1\">sifonları temizlemesi kolay ve hijyenik tutar. Su tasarrufu odaklı tasarımı, sürdürülebilirlik çabalarına katkı sağlar. </span><span data-mce-fragment=\"1\">Creavit lavabo</span><span data-mce-fragment=\"1\"> sifonları, banyo ve lavabo deneyiminizi daha konforlu ve çevre dostu hale getirmek için mükemmel bir seçenektir.</span></p>"
  },
  {
    "id": "creavit-8808952299817",
    "brand": "Creavit",
    "title": "Lavabo Sifon 33cm Metal Körüklü",
    "category": "Lavabo Sifonları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-33cm-metal-koruklu-4866.png?v=1747232781",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-33cm-metal-koruklu-4866.png?v=1747232781",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-33cm-metal-koruklu-4867.png?v=1747232784",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-33cm-metal-koruklu-4868.png?v=1747232788"
    ],
    "price": "2385.00",
    "sku": "SF.SF165",
    "tags": [
      "banyo aksesuarı",
      "Krom",
      "Lavabo Gideri",
      "Lavabo Sifon Başlığı",
      "Lavabo Sifonu",
      "Metal Körüklü",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52912458498345,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SF.SF165",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2385.00",
        "grams": 0,
        "compare_at_price": "3180.00",
        "position": 1,
        "product_id": 8808952299817,
        "created_at": "2026-04-01T16:04:45+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<p><span data-mce-fragment=\"1\">Creavit</span><span data-mce-fragment=\"1\"> lavabo sifonları, banyo ve lavabo alanlarınızı daha hijyenik, daha temiz ve daha işlevsel hale getirmek için tasarlandı. Zarif tasarımları, sade çizgileri ve yüksek kaliteli malzemeleriyle </span><span data-mce-fragment=\"1\">bu lavabo </span><span data-mce-fragment=\"1\">sifonları, banyo veya lavabonuzun estetiğini mükemmel bir şekilde tamamlar. Ayrıca, pratik kullanım sağlayan teknolojileri sayesinde suyun sorunsuz bir şekilde akmasını ve atıkların hızlıca uzaklaştırılmasını garanti eder. Hijyen konusundaki hassasiyetimiz, </span><span data-mce-fragment=\"1\">sifonları temizlemesi kolay ve hijyenik tutar. Su tasarrufu odaklı tasarımı, sürdürülebilirlik çabalarına katkı sağlar. </span><span data-mce-fragment=\"1\">Creavit lavabo</span><span data-mce-fragment=\"1\"> sifonları, banyo ve lavabo deneyiminizi daha konforlu ve çevre dostu hale getirmek için mükemmel bir seçenektir.</span></p>"
  },
  {
    "id": "creavit-8808913404201",
    "brand": "Creavit",
    "title": "Lavabo Sifonu 30 cm  U G1 1/4",
    "category": "Lavabo Sifonları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifonu-30-cm-u-g1-1-4-4863.png?v=1747234631",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifonu-30-cm-u-g1-1-4-4863.png?v=1747234631",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifonu-30-cm-u-g1-1-4-4864.png?v=1747234634"
    ],
    "price": "1890.00",
    "sku": "SF.SF153",
    "tags": [
      "banyo aksesuarı",
      "Krom",
      "Lavabo Gideri",
      "Lavabo Sifon Başlığı",
      "Lavabo Sifonu",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52921483854121,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SF.SF153",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1890.00",
        "grams": 0,
        "compare_at_price": "2520.00",
        "position": 1,
        "product_id": 8808913404201,
        "created_at": "2026-04-03T14:44:21+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<p><span data-mce-fragment=\"1\">Creavit</span><span data-mce-fragment=\"1\"> lavabo sifonları, banyo ve lavabo alanlarınızı daha hijyenik, daha temiz ve daha işlevsel hale getirmek için tasarlandı. Zarif tasarımları, sade çizgileri ve yüksek kaliteli malzemeleriyle </span><span data-mce-fragment=\"1\">bu lavabo </span><span data-mce-fragment=\"1\">sifonları, banyo veya lavabonuzun estetiğini mükemmel bir şekilde tamamlar. Ayrıca, pratik kullanım sağlayan teknolojileri sayesinde suyun sorunsuz bir şekilde akmasını ve atıkların hızlıca uzaklaştırılmasını garanti eder. Hijyen konusundaki hassasiyetimiz, </span><span data-mce-fragment=\"1\">sifonları temizlemesi kolay ve hijyenik tutar. Su tasarrufu odaklı tasarımı, sürdürülebilirlik çabalarına katkı sağlar. </span><span data-mce-fragment=\"1\">Creavit lavabo</span><span data-mce-fragment=\"1\"> sifonları, banyo ve lavabo deneyiminizi daha konforlu ve çevre dostu hale getirmek için mükemmel bir seçenektir.</span></p>"
  },
  {
    "id": "creavit-8808911765801",
    "brand": "Creavit",
    "title": "Lavabo Sifonu 25 cm U  G1 1/4",
    "category": "Lavabo Sifonları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifonu-25-cm-u-g1-1-4-4860.png?v=1747232765",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifonu-25-cm-u-g1-1-4-4860.png?v=1747232765",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifonu-25-cm-u-g1-1-4-4861.png?v=1747232768",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifonu-25-cm-u-g1-1-4-4862.png?v=1747232773"
    ],
    "price": "1845.00",
    "sku": "SF.SF152",
    "tags": [
      "banyo aksesuarı",
      "Krom",
      "Lavabo Gideri",
      "Lavabo Sifon Başlığı",
      "Lavabo Sifonu",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52843224629545,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SF.SF152",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1845.00",
        "grams": 0,
        "compare_at_price": "2460.00",
        "position": 1,
        "product_id": 8808911765801,
        "created_at": "2026-03-17T12:57:52+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\r\n<p><span data-mce-fragment=\"1\">Creavit</span><span data-mce-fragment=\"1\"> lavabo sifonları, banyo ve lavabo alanlarınızı daha hijyenik, daha temiz ve daha işlevsel hale getirmek için tasarlandı. Zarif tasarımları, sade çizgileri ve yüksek kaliteli malzemeleriyle </span><span data-mce-fragment=\"1\">bu lavabo </span><span data-mce-fragment=\"1\">sifonları, banyo veya lavabonuzun estetiğini mükemmel bir şekilde tamamlar. Ayrıca, pratik kullanım sağlayan teknolojileri sayesinde suyun sorunsuz bir şekilde akmasını ve atıkların hızlıca uzaklaştırılmasını garanti eder. Hijyen konusundaki hassasiyetimiz, </span><span data-mce-fragment=\"1\">sifonları temizlemesi kolay ve hijyenik tutar. Su tasarrufu odaklı tasarımı, sürdürülebilirlik çabalarına katkı sağlar. </span><span data-mce-fragment=\"1\">Creavit lavabo</span><span data-mce-fragment=\"1\"> sifonları, banyo ve lavabo deneyiminizi daha konforlu ve çevre dostu hale getirmek için mükemmel bir seçenektir.</span></p>"
  },
  {
    "id": "creavit-8808910389545",
    "brand": "Creavit",
    "title": "Lavabo Sifon Süzgeci G1 1/4",
    "category": "Lavabo Sifonları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-suzgeci-g1-1-4-4857.png?v=1747224838",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-suzgeci-g1-1-4-4857.png?v=1747224838",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-suzgeci-g1-1-4-4858.png?v=1747224840"
    ],
    "price": "1215.00",
    "sku": "SF.SF066",
    "tags": [
      "banyo aksesuarı",
      "Krom",
      "Lavabo Gideri",
      "lavabo sifon süzgeci",
      "Lavabo Sifonu",
      "Sifon Başlığı"
    ],
    "variants": [
      {
        "id": 52843224531241,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SF.SF066",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1215.00",
        "grams": 0,
        "compare_at_price": "1620.00",
        "position": 1,
        "product_id": 8808910389545,
        "created_at": "2026-03-17T12:57:49+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\n<p><span>Creavit lavabo sifonları banyo ve lavabo alanlarınızı daha hijyenik, temiz ve işlevsel hale getirmek için tasarlandı. Ayrıca pratik kullanımları sayesinde suyun sorunsuz bir şekilde akmasını ve atıkların hızlıca uzaklaştırılmasını garanti ederken, yüksek kaliteli malzemelerle banyo ve lavabonuzun görünümünü tamamlar.</span></p>"
  },
  {
    "id": "creavit-8808909308201",
    "brand": "Creavit",
    "title": "Lavabo Sifon Başlığı (Taşmasız) 54mm",
    "category": "Lavabo Sifonları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-tasmasiz-54mm-4854.png?v=1747224824",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-tasmasiz-54mm-4854.png?v=1747224824",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-tasmasiz-54mm-4856.png?v=1747224827",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-tasmasiz-54mm-4855.png?v=1747224830"
    ],
    "price": "1395.00",
    "sku": "SF.SF048",
    "tags": [
      "banyo aksesuarı",
      "Krom",
      "Lavabo Gideri",
      "Lavabo Sifon Başlığı",
      "Lavabo Sifonu",
      "Taşmasız Sifon"
    ],
    "variants": [
      {
        "id": 52915972178217,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SF.SF048",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1395.00",
        "grams": 0,
        "compare_at_price": "1860.00",
        "position": 1,
        "product_id": 8808909308201,
        "created_at": "2026-04-02T13:07:17+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\n<p><span>Creavit lavabo sifonları banyo ve lavabo alanlarınızı daha hijyenik, temiz ve işlevsel hale getirmek için tasarlandı. Ayrıca pratik kullanımları sayesinde suyun sorunsuz bir şekilde akmasını ve atıkların hızlıca uzaklaştırılmasını garanti ederken, yüksek kaliteli malzemelerle banyo ve lavabonuzun görünümünü tamamlar.</span></p>"
  },
  {
    "id": "creavit-8808908095785",
    "brand": "Creavit",
    "title": "Lavabo Sifon Başlığı 76 mm (Taşmalı)",
    "category": "Lavabo Sifonları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-76-mm-tasmali-4851.png?v=1747224809",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-76-mm-tasmali-4851.png?v=1747224809",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-76-mm-tasmali-4853.png?v=1747224812",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-76-mm-tasmali-4852.png?v=1747224815"
    ],
    "price": "1665.00",
    "sku": "SF.SF046",
    "tags": [
      "banyo aksesuarı",
      "Krom",
      "Lavabo Gideri",
      "Lavabo Sifon Başlığı",
      "Lavabo Sifonu",
      "Taşmalı Sifon"
    ],
    "variants": [
      {
        "id": 52912210411817,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SF.SF046",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1665.00",
        "grams": 0,
        "compare_at_price": "2220.00",
        "position": 1,
        "product_id": 8808908095785,
        "created_at": "2026-04-01T14:16:49+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\n<p><span>Creavit lavabo sifonları banyo ve lavabo alanlarınızı daha hijyenik, temiz ve işlevsel hale getirmek için tasarlandı. Ayrıca pratik kullanımları sayesinde suyun sorunsuz bir şekilde akmasını ve atıkların hızlıca uzaklaştırılmasını garanti ederken, yüksek kaliteli malzemelerle banyo ve lavabonuzun görünümünü tamamlar.</span></p>"
  },
  {
    "id": "creavit-8808906817833",
    "brand": "Creavit",
    "title": "Lavabo Sifon Başlığı Seramik Üst Takım Taşmasız Siyah",
    "category": "Lavabo Sifonları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-seramik-ust-takim-tasmasiz-siyah-4848.png?v=1747232749",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-seramik-ust-takim-tasmasiz-siyah-4848.png?v=1747232749",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-seramik-ust-takim-tasmasiz-siyah-4850.png?v=1747232752",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-seramik-ust-takim-tasmasiz-siyah-4849.png?v=1747232756"
    ],
    "price": "4680.00",
    "sku": "SF.SF032-S",
    "tags": [
      "banyo aksesuarı",
      "Krom",
      "Lavabo Gideri",
      "Lavabo Sifon Başlığı",
      "Lavabo Sifonu",
      "seramik",
      "siyah",
      "Taşmasız Sifon"
    ],
    "variants": [
      {
        "id": 52843224400169,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SF.SF032-S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "4680.00",
        "grams": 0,
        "compare_at_price": "6240.00",
        "position": 1,
        "product_id": 8808906817833,
        "created_at": "2026-03-17T12:57:46+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\n<p><span>Creavit lavabo sifonları banyo ve lavabo alanlarınızı daha hijyenik, temiz ve işlevsel hale getirmek için tasarlandı. Ayrıca pratik kullanımları sayesinde suyun sorunsuz bir şekilde akmasını ve atıkların hızlıca uzaklaştırılmasını garanti ederken, yüksek kaliteli malzemelerle banyo ve lavabonuzun görünümünü tamamlar.</span></p>"
  },
  {
    "id": "creavit-8808905605417",
    "brand": "Creavit",
    "title": "Lavabo Sifon Başlığı Seramik Üst Takım Taşmasız Beyaz",
    "category": "Lavabo Sifonları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-seramik-ust-takim-tasmasiz-beyaz-4846.png?v=1747234894",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-seramik-ust-takim-tasmasiz-beyaz-4846.png?v=1747234894",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-seramik-ust-takim-tasmasiz-beyaz-4847.png?v=1747234897"
    ],
    "price": "1665.00",
    "sku": "SF.SF032-B",
    "tags": [
      "banyo aksesuarı",
      "Beyaz",
      "Krom",
      "Lavabo Gideri",
      "Lavabo Sifon Başlığı",
      "Lavabo Sifonu",
      "seramik",
      "Taşmasız Sifon"
    ],
    "variants": [
      {
        "id": 52843242455337,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SF.SF032-B",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1665.00",
        "grams": 0,
        "compare_at_price": "2220.00",
        "position": 1,
        "product_id": 8808905605417,
        "created_at": "2026-03-17T13:04:16+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\n<p><span>Creavit lavabo sifonları banyo ve lavabo alanlarınızı daha hijyenik, temiz ve işlevsel hale getirmek için tasarlandı. Ayrıca pratik kullanımları sayesinde suyun sorunsuz bir şekilde akmasını ve atıkların hızlıca uzaklaştırılmasını garanti ederken, yüksek kaliteli malzemelerle banyo ve lavabonuzun görünümünü tamamlar.</span></p>"
  },
  {
    "id": "creavit-8807580926249",
    "brand": "Creavit",
    "title": "Loop Oval Çanak Lavabo 40x60 cm Beyaz",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-oval-canak-lavabo-40x60-cm-beyaz-4840.png?v=1747805463",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-oval-canak-lavabo-40x60-cm-beyaz-4840.png?v=1747805463",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-oval-canak-lavabo-40x60-cm-beyaz-4841.jpg?v=1747805463",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-oval-canak-lavabo-40x60-cm-beyaz-4842.jpg?v=1747805463",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-oval-canak-lavabo-40x60-cm-beyaz-4843.jpg?v=1747805463",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-oval-canak-lavabo-40x60-cm-beyaz-4844.jpg?v=1747805463",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-oval-canak-lavabo-40x60-cm-beyaz-4845.png?v=1747805463"
    ],
    "price": "9405.00",
    "sku": "LP161-00CB00E-0000",
    "tags": [
      "Beyaz",
      "Lavabo",
      "Loop",
      "Oval",
      "Tezgahüstü",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843174494505,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP161-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9405.00",
        "grams": 0,
        "compare_at_price": "12540.00",
        "position": 1,
        "product_id": 8807580926249,
        "created_at": "2026-03-17T12:43:08+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<meta charset=\"utf-8\">\r\n<div class=\"landingUltral__b3secHl\" data-mce-fragment=\"1\"> </div>\r\n\r\n<p>Banyonuz modern sanat galerisine dönüşsün!</p>\r\n\r\n<p>Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\r\n\r\n<p>Lavaboda İnce Düşünenlere!</p>\r\n\r\n<p>Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>\r\n\r\n<div class=\"landingUltral__b3secHl\" data-mce-fragment=\"1\">\r\n<div class=\"landingUltral__b3secHl\"> </div>\r\n</div>"
  },
  {
    "id": "creavit-8804222566697",
    "brand": "Creavit",
    "title": "Lavabo Sifon Başlığı Pop-Up Taşmasız Mat Siyah",
    "category": "Lavabo Sifonları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-pop-up-tasmasiz-mat-siyah-4775.png?v=1746879075",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-pop-up-tasmasiz-mat-siyah-4775.png?v=1746879075",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/Adsiztasarim_85.png?v=1756908443",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-pop-up-tasmasiz-mat-siyah-4776.png?v=1756908443"
    ],
    "price": "1890.00",
    "sku": "SFU.SF030.SYM",
    "tags": [
      "banyo aksesuarı",
      "Diğer Ürünler",
      "Krom",
      "Lavabo Gideri",
      "Lavabo Sifon Başlığı",
      "Lavabo Sifonu",
      "pop-up sifon",
      "Sifon Başlığı",
      "Taşmasız Sifon"
    ],
    "variants": [
      {
        "id": 52927549309225,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SFU.SF030.SYM",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1890.00",
        "grams": 0,
        "compare_at_price": "2520.00",
        "position": 1,
        "product_id": 8804222566697,
        "created_at": "2026-04-04T16:42:39+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\n<p><span>Creavit lavabo sifonları banyo ve lavabo alanlarınızı daha hijyenik, temiz ve işlevsel hale getirmek için tasarlandı. Ayrıca pratik kullanımları sayesinde suyun sorunsuz bir şekilde akmasını ve atıkların hızlıca uzaklaştırılmasını garanti ederken, yüksek kaliteli malzemelerle banyo ve lavabonuzun görünümünü tamamlar.</span></p>"
  },
  {
    "id": "creavit-8804220633385",
    "brand": "Creavit",
    "title": "Lavabo Sifon Başlığı Pop-Up Taşmasız Mat Beyaz",
    "category": "Lavabo Sifonları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-pop-up-tasmasiz-mat-beyaz-4772.png?v=1746879090",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-pop-up-tasmasiz-mat-beyaz-4772.png?v=1746879090",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-beyaz-pop-up-sifon-basligi-lavabo.png?v=1756905408",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-pop-up-tasmasiz-mat-beyaz-4773.png?v=1756905408"
    ],
    "price": "1890.00",
    "sku": "SFU.SF030.MBY",
    "tags": [
      "banyo aksesuarı",
      "Diğer Ürünler",
      "Krom",
      "Lavabo Gideri",
      "Lavabo Sifon Başlığı",
      "Lavabo Sifonu",
      "pop-up sifon",
      "Sifon Başlığı",
      "Taşmasız Sifon"
    ],
    "variants": [
      {
        "id": 52843262935337,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SFU.SF030.MBY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1890.00",
        "grams": 0,
        "compare_at_price": "2520.00",
        "position": 1,
        "product_id": 8804220633385,
        "created_at": "2026-03-17T13:10:27+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\n<p><span>Creavit lavabo sifonları banyo ve lavabo alanlarınızı daha hijyenik, temiz ve işlevsel hale getirmek için tasarlandı. Ayrıca pratik kullanımları sayesinde suyun sorunsuz bir şekilde akmasını ve atıkların hızlıca uzaklaştırılmasını garanti ederken, yüksek kaliteli malzemelerle banyo ve lavabonuzun görünümünü tamamlar.</span></p>"
  },
  {
    "id": "creavit-8804214276393",
    "brand": "Creavit",
    "title": "Lavabo Sifon Başlığı Pop-Up Taşmasız Mat Cappuccino",
    "category": "Lavabo Sifonları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-pop-up-tasmasiz-mat-cappuccino-4769.png?v=1746879061",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-pop-up-tasmasiz-mat-cappuccino-4769.png?v=1746879061",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-pop-up-tasmasiz-mat-cappuccino-4770.png?v=1746879063",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-pop-up-tasmasiz-mat-cappuccino-4771.png?v=1746879067"
    ],
    "price": "1890.00",
    "sku": "SFU.SF030.CCM",
    "tags": [
      "banyo aksesuarı",
      "Diğer Ürünler",
      "Krom",
      "Lavabo Gideri",
      "Lavabo Sifon Başlığı",
      "Lavabo Sifonu",
      "pop-up sifon",
      "Sifon Başlığı",
      "Taşmasız Sifon"
    ],
    "variants": [
      {
        "id": 52843240882473,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SFU.SF030.CCM",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1890.00",
        "grams": 0,
        "compare_at_price": "2520.00",
        "position": 1,
        "product_id": 8804214276393,
        "created_at": "2026-03-17T13:03:47+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\n<p><span>Creavit lavabo sifonları banyo ve lavabo alanlarınızı daha hijyenik, temiz ve işlevsel hale getirmek için tasarlandı. Ayrıca pratik kullanımları sayesinde suyun sorunsuz bir şekilde akmasını ve atıkların hızlıca uzaklaştırılmasını garanti ederken, yüksek kaliteli malzemelerle banyo ve lavabonuzun görünümünü tamamlar.</span></p>"
  },
  {
    "id": "creavit-8804067017001",
    "brand": "Creavit",
    "title": "Lavabo Sifon Başlığı Pop-Up Taşmasız Mat Antrasit",
    "category": "Lavabo Sifonları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-pop-up-tasmasiz-mat-antrasit-4766.png?v=1746879104",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-pop-up-tasmasiz-mat-antrasit-4766.png?v=1746879104",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-pop-up-tasmasiz-mat-antrasit-4768.png?v=1746879106",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-pop-up-tasmasiz-mat-antrasit-4767.png?v=1746879110"
    ],
    "price": "1890.00",
    "sku": "SFU.SF030.ANM",
    "tags": [
      "banyo aksesuarı",
      "Diğer Ürünler",
      "Krom",
      "Lavabo Gideri",
      "Lavabo Sifon Başlığı",
      "Lavabo Sifonu",
      "pop-up sifon",
      "Sifon Başlığı",
      "Taşmalı Sifon"
    ],
    "variants": [
      {
        "id": 52843259265321,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SFU.SF030.ANM",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1890.00",
        "grams": 0,
        "compare_at_price": "2520.00",
        "position": 1,
        "product_id": 8804067017001,
        "created_at": "2026-03-17T13:09:14+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\n<p><span>Creavit lavabo sifonları banyo ve lavabo alanlarınızı daha hijyenik, temiz ve işlevsel hale getirmek için tasarlandı. Ayrıca pratik kullanımları sayesinde suyun sorunsuz bir şekilde akmasını ve atıkların hızlıca uzaklaştırılmasını garanti ederken, yüksek kaliteli malzemelerle banyo ve lavabonuzun görünümünü tamamlar.</span></p>"
  },
  {
    "id": "creavit-8804064624937",
    "brand": "Creavit",
    "title": "Lavabo Sifon Başlığı Pop-Up (Taşmalı) Altın",
    "category": "Lavabo Sifonları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-pop-up-tasmali-altin-4763.png?v=1747233848",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-pop-up-tasmali-altin-4763.png?v=1747233848",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-pop-up-tasmali-altin-4765.png?v=1747233851",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-pop-up-tasmali-altin-4764.png?v=1747233856"
    ],
    "price": "2025.00",
    "sku": "SF.SF031G",
    "tags": [
      "banyo aksesuarı",
      "Diğer Ürünler",
      "Krom",
      "Lavabo Gideri",
      "Lavabo Sifon Başlığı",
      "Lavabo Sifonu",
      "pop-up sifon",
      "Sifon Başlığı",
      "Taşmalı Sifon"
    ],
    "variants": [
      {
        "id": 52876508004649,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SF.SF031G",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2025.00",
        "grams": 0,
        "compare_at_price": "2700.00",
        "position": 1,
        "product_id": 8804064624937,
        "created_at": "2026-03-25T12:22:40+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\n<p><span>Creavit lavabo sifonları banyo ve lavabo alanlarınızı daha hijyenik, temiz ve işlevsel hale getirmek için tasarlandı. Ayrıca pratik kullanımları sayesinde suyun sorunsuz bir şekilde akmasını ve atıkların hızlıca uzaklaştırılmasını garanti ederken, yüksek kaliteli malzemelerle banyo ve lavabonuzun görünümünü tamamlar.</span></p>"
  },
  {
    "id": "creavit-8804062101801",
    "brand": "Creavit",
    "title": "Lavabo Sifon Başlığı Pop-up (Taşmalı)",
    "category": "Lavabo Sifonları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-pop-up-tasmali-4760.png?v=1747234651",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-pop-up-tasmali-4760.png?v=1747234651",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/Adsiztasarim_86.png?v=1756908620",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-pop-up-tasmali-4762.png?v=1756908620"
    ],
    "price": "1620.00",
    "sku": "SF.SF031",
    "tags": [
      "banyo aksesuarı",
      "Diğer Ürünler",
      "Krom",
      "Lavabo Gideri",
      "Lavabo Sifon Başlığı",
      "Lavabo Sifonu",
      "pop-up sifon",
      "Sifon Başlığı",
      "Taşmalı Sifon"
    ],
    "variants": [
      {
        "id": 52920971526441,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SF.SF031",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1620.00",
        "grams": 0,
        "compare_at_price": "2160.00",
        "position": 1,
        "product_id": 8804062101801,
        "created_at": "2026-04-03T12:16:53+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\n<p><span>Creavit lavabo sifonları banyo ve lavabo alanlarınızı daha hijyenik, temiz ve işlevsel hale getirmek için tasarlandı. Ayrıca pratik kullanımları sayesinde suyun sorunsuz bir şekilde akmasını ve atıkların hızlıca uzaklaştırılmasını garanti ederken, yüksek kaliteli malzemelerle banyo ve lavabonuzun görünümünü tamamlar.</span></p>"
  },
  {
    "id": "creavit-8804061413673",
    "brand": "Creavit",
    "title": "Lavabo Sifon Başlığı Pop-up Taşmasız Altın",
    "category": "Lavabo Sifonları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-pop-up-tasmasiz-altin-4757.png?v=1747026871",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-pop-up-tasmasiz-altin-4757.png?v=1747026871",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-pop-up-tasmasiz-altin-4759.png?v=1747026874",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-pop-up-tasmasiz-altin-4758.png?v=1747026876"
    ],
    "price": "1890.00",
    "sku": "SF.SF030G",
    "tags": [
      "banyo aksesuarı",
      "Diğer Ürünler",
      "Krom",
      "Lavabo Gideri",
      "Lavabo Sifon Başlığı",
      "Lavabo Sifonu",
      "pop-up sifon",
      "Sifon Başlığı",
      "Taşmasız Sifon"
    ],
    "variants": [
      {
        "id": 52843263164713,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SF.SF030G",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1890.00",
        "grams": 0,
        "compare_at_price": "2520.00",
        "position": 1,
        "product_id": 8804061413673,
        "created_at": "2026-03-17T13:10:33+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\n<p><span>Creavit lavabo sifonları banyo ve lavabo alanlarınızı daha hijyenik, temiz ve işlevsel hale getirmek için tasarlandı. Ayrıca pratik kullanımları sayesinde suyun sorunsuz bir şekilde akmasını ve atıkların hızlıca uzaklaştırılmasını garanti ederken, yüksek kaliteli malzemelerle banyo ve lavabonuzun görünümünü tamamlar.</span></p>"
  },
  {
    "id": "creavit-8804060266793",
    "brand": "Creavit",
    "title": "Lavabo Sifon Başlığı Pop-up Taşmasız",
    "category": "Lavabo Sifonları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-pop-up-tasmasiz-4754.png?v=1747233094",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-pop-up-tasmasiz-4754.png?v=1747233094",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-pop-up-tasmasiz-4756.png?v=1747233097",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lavabo-sifon-basligi-pop-up-tasmasiz-4755.png?v=1747233101"
    ],
    "price": "1350.00",
    "sku": "SF.SF030",
    "tags": [
      "banyo aksesuarı",
      "Diğer Ürünler",
      "Krom",
      "Lavabo Gideri",
      "Lavabo Sifon Başlığı",
      "Lavabo Sifonu",
      "pop-up sifon",
      "Sifon Başlığı",
      "Taşmasız Sifon"
    ],
    "variants": [
      {
        "id": 52928676364585,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SF.SF030",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1350.00",
        "grams": 0,
        "compare_at_price": "1800.00",
        "position": 1,
        "product_id": 8804060266793,
        "created_at": "2026-04-04T21:47:48+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<!-- x-tinymce/html -->\n<p><span>Creavit lavabo sifonları banyo ve lavabo alanlarınızı daha hijyenik, temiz ve işlevsel hale getirmek için tasarlandı. Ayrıca pratik kullanımları sayesinde suyun sorunsuz bir şekilde akmasını ve atıkların hızlıca uzaklaştırılmasını garanti ederken, yüksek kaliteli malzemelerle banyo ve lavabonuzun görünümünü tamamlar.</span></p>"
  },
  {
    "id": "creavit-8801756381481",
    "brand": "Creavit",
    "title": "Aç Kapa Ara Kesme Valfi 1/2",
    "category": "Ara Musluklar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ac-kapa-ara-kesme-valfi-1-2-4742.png?v=1747232717",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ac-kapa-ara-kesme-valfi-1-2-4742.png?v=1747232717",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/Adsiztasarim_82.png?v=1756905785",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ac-kapa-ara-kesme-valfi-1-2-4743.png?v=1756905785"
    ],
    "price": "2250.00",
    "sku": "MS.AC90L",
    "tags": [
      "ara kesme valfi",
      "ara musluk",
      "Musluklar",
      "valf"
    ],
    "variants": [
      {
        "id": 52843227676969,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MS.AC90L",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2250.00",
        "grams": 0,
        "compare_at_price": "3000.00",
        "position": 1,
        "product_id": 8801756381481,
        "created_at": "2026-03-17T12:58:55+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Minimalist şıklığı ve fonksiyonelliği bir araya getiren Creavit ara musluklar, modern banyolara zarafet katıyor. Kolay kullanımı ve pürüzsüz su akışı ile banyo deneyiminizi maksimum konforla taçlandırıyor. Bu musluklar, yüksek kaliteli malzemelerle üretilen Creavit ara muslukları uzun yıllar boyunca güvenle kullanabilirsiniz. Estetik ve tasarımı, teknoloji ile buluşturan Creavit, kullanıcı odaklı tasarım bakış açısıyla yeni ürün geliştirmeye devam ediyor.</span></p>"
  },
  {
    "id": "creavit-8801755955497",
    "brand": "Creavit",
    "title": "Ara Kesme Valfi 1/2-1/2\" Basalt Mat",
    "category": "Ara Musluklar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-ara-kesme-valfi-basalt-1.png?v=1749221177",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-ara-kesme-valfi-basalt-1.png?v=1749221177",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ara-kesme-valfi-1-2-1-2-basalt-mat-4736.png?v=1749221177",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ara-kesme-valfi-1-2-1-2-basalt-mat-4737.png?v=1749221177",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ara-kesme-valfi-1-2-1-2-basalt-mat-4738.png?v=1749221170"
    ],
    "price": "2025.00",
    "sku": "MS.AC50L.BSM",
    "tags": [
      "ara kesme valfi",
      "ara musluk",
      "Mat Basalt",
      "Musluklar",
      "valf"
    ],
    "variants": [
      {
        "id": 52843250876713,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MS.AC50L.BSM",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2025.00",
        "grams": 0,
        "compare_at_price": "2700.00",
        "position": 1,
        "product_id": 8801755955497,
        "created_at": "2026-03-17T13:06:38+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p style=\"TEXT-ALIGN: left\"><span data-mce-fragment=\"1\">Minimalist şıklığı ve fonksiyonelliği bir araya getiren Creavit ara musluklar modern banyolara zarafet katıyor. Kolay kullanımı ve pürüzsüz su akışı ile banyo deneyiminizi maksimum konforla taçlandırıyor. Yüksek kaliteli malzemelerle üretilen Creavit ara musluklarını uzun yıllar boyunca güvenle kullanabilirsiniz.</span><span data-mce-fragment=\"1\"></span></p>"
  },
  {
    "id": "creavit-8801755791657",
    "brand": "Creavit",
    "title": "Ara Kesme Valfi 1/2-1/2\" Cappucino Mat",
    "category": "Ara Musluklar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-ara-kesme-valfi-cappuccino-1.png?v=1749221195",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-ara-kesme-valfi-cappuccino-1.png?v=1749221195",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ara-kesme-valfi-1-2-1-2-cappucino-mat-4733.png?v=1749221195",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ara-kesme-valfi-1-2-1-2-cappucino-mat-4734.png?v=1749221195"
    ],
    "price": "2025.00",
    "sku": "MS.AC50L.CCM",
    "tags": [
      "ara kesme valfi",
      "ara musluk",
      "Mat Cappuccino",
      "Musluklar",
      "valf"
    ],
    "variants": [
      {
        "id": 52920071094569,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MS.AC50L.CCM",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2025.00",
        "grams": 0,
        "compare_at_price": "2700.00",
        "position": 1,
        "product_id": 8801755791657,
        "created_at": "2026-04-03T08:23:36+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p style=\"TEXT-ALIGN: left\"><span data-mce-fragment=\"1\">Minimalist şıklığı ve fonksiyonelliği bir araya getiren Creavit ara musluklar modern banyolara zarafet katıyor. Kolay kullanımı ve pürüzsüz su akışı ile banyo deneyiminizi maksimum konforla taçlandırıyor. Yüksek kaliteli malzemelerle üretilen Creavit ara musluklarını uzun yıllar boyunca güvenle kullanabilirsiniz.</span><span data-mce-fragment=\"1\"></span></p>"
  },
  {
    "id": "creavit-8801755693353",
    "brand": "Creavit",
    "title": "Aç Kapa Ara Musluk 1/2'' - 3/8'' Krom",
    "category": "Ara Musluklar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ac-kapa-ara-musluk-1-2-3-8-krom-4731.png?v=1747224592",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ac-kapa-ara-musluk-1-2-3-8-krom-4731.png?v=1747224592"
    ],
    "price": "675.00",
    "sku": "MS.CF02",
    "tags": [
      "ara kesme valfi",
      "ara musluk",
      "Musluklar",
      "valf"
    ],
    "variants": [
      {
        "id": 52920971034921,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MS.CF02",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "675.00",
        "grams": 0,
        "compare_at_price": "900.00",
        "position": 1,
        "product_id": 8801755693353,
        "created_at": "2026-04-03T12:16:47+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p style=\"TEXT-ALIGN: left\"><span data-mce-fragment=\"1\">Minimalist şıklığı ve fonksiyonelliği bir araya getiren Creavit ara musluklar modern banyolara zarafet katıyor. Kolay kullanımı ve pürüzsüz su akışı ile banyo deneyiminizi maksimum konforla taçlandırıyor. Yüksek kaliteli malzemelerle üretilen Creavit ara musluklarını uzun yıllar boyunca güvenle kullanabilirsiniz.</span><span data-mce-fragment=\"1\"></span></p>"
  },
  {
    "id": "creavit-8801755496745",
    "brand": "Creavit",
    "title": "Ara Kesme Valfi 1/2-1/2\" Antrasit Mat",
    "category": "Ara Musluklar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-ara-kesme-valfi-antrasit-1.png?v=1749221223",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-ara-kesme-valfi-antrasit-1.png?v=1749221223",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ara-kesme-valfi-1-2-1-2-antrasit-mat-4728.png?v=1749221223",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ara-kesme-valfi-1-2-1-2-antrasit-mat-4729.png?v=1749221223",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ara-kesme-valfi-1-2-1-2-antrasit-mat-4730.png?v=1749221215"
    ],
    "price": "2025.00",
    "sku": "MS.AC50L.ANM",
    "tags": [
      "ara kesme valfi",
      "ara musluk",
      "Mat Antrasit",
      "Musluklar",
      "valf"
    ],
    "variants": [
      {
        "id": 52843241767209,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MS.AC50L.ANM",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2025.00",
        "grams": 0,
        "compare_at_price": "2700.00",
        "position": 1,
        "product_id": 8801755496745,
        "created_at": "2026-03-17T13:04:06+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p style=\"TEXT-ALIGN: left\"><span data-mce-fragment=\"1\">Minimalist şıklığı ve fonksiyonelliği bir araya getiren Creavit ara musluklar modern banyolara zarafet katıyor. Kolay kullanımı ve pürüzsüz su akışı ile banyo deneyiminizi maksimum konforla taçlandırıyor. Yüksek kaliteli malzemelerle üretilen Creavit ara musluklarını uzun yıllar boyunca güvenle kullanabilirsiniz.</span><span data-mce-fragment=\"1\"></span></p>"
  },
  {
    "id": "creavit-8801755234601",
    "brand": "Creavit",
    "title": "Mix Uzun Musluk 1/2 Krom",
    "category": "Ara Musluklar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mix-uzun-musluk-1-2-krom-4726.png?v=1747232706",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mix-uzun-musluk-1-2-krom-4726.png?v=1747232706"
    ],
    "price": "2160.00",
    "sku": "MS.T210L",
    "tags": [
      "ara kesme valfi",
      "ara musluk",
      "Krom",
      "Musluklar",
      "valf"
    ],
    "variants": [
      {
        "id": 52912458072361,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MS.T210L",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2160.00",
        "grams": 0,
        "compare_at_price": "2880.00",
        "position": 1,
        "product_id": 8801755234601,
        "created_at": "2026-04-01T16:04:39+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p style=\"TEXT-ALIGN: left\"><span data-mce-fragment=\"1\">Minimalist şıklığı ve fonksiyonelliği bir araya getiren Creavit ara musluklar modern banyolara zarafet katıyor. Kolay kullanımı ve pürüzsüz su akışı ile banyo deneyiminizi maksimum konforla taçlandırıyor. Yüksek kaliteli malzemelerle üretilen Creavit ara musluklarını uzun yıllar boyunca güvenle kullanabilirsiniz.</span><span data-mce-fragment=\"1\"></span></p>"
  },
  {
    "id": "creavit-8801754972457",
    "brand": "Creavit",
    "title": "Uzun Musluk 1/2 Krom",
    "category": "Ara Musluklar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/uzun-musluk-1-2-krom-4725.png?v=1747224585",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/uzun-musluk-1-2-krom-4725.png?v=1747224585"
    ],
    "price": "1530.00",
    "sku": "MS.T201L",
    "tags": [
      "ara kesme valfi",
      "ara musluk",
      "Krom",
      "Musluklar",
      "valf"
    ],
    "variants": [
      {
        "id": 52920970838313,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MS.T201L",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1530.00",
        "grams": 0,
        "compare_at_price": "2040.00",
        "position": 1,
        "product_id": 8801754972457,
        "created_at": "2026-04-03T12:16:43+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p style=\"TEXT-ALIGN: left\"><span data-mce-fragment=\"1\">Minimalist şıklığı ve fonksiyonelliği bir araya getiren Creavit ara musluklar modern banyolara zarafet katıyor. Kolay kullanımı ve pürüzsüz su akışı ile banyo deneyiminizi maksimum konforla taçlandırıyor. Yüksek kaliteli malzemelerle üretilen Creavit ara musluklarını uzun yıllar boyunca güvenle kullanabilirsiniz.</span><span data-mce-fragment=\"1\"></span></p>"
  },
  {
    "id": "creavit-8801754677545",
    "brand": "Creavit",
    "title": "Ara Musluk 1/2-3/8\" (Krom Volan)",
    "category": "Ara Musluklar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ara-musluk-1-2-3-8-krom-volan-4724.png?v=1747232699",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ara-musluk-1-2-3-8-krom-volan-4724.png?v=1747232699"
    ],
    "price": "720.00",
    "sku": "MS.AC42F",
    "tags": [
      "ara kesme valfi",
      "ara musluk",
      "Krom",
      "Musluklar",
      "valf"
    ],
    "variants": [
      {
        "id": 52843221713193,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MS.AC42F",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "720.00",
        "grams": 0,
        "compare_at_price": "960.00",
        "position": 1,
        "product_id": 8801754677545,
        "created_at": "2026-03-17T12:56:42+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p style=\"TEXT-ALIGN: left\"><span data-mce-fragment=\"1\">Minimalist şıklığı ve fonksiyonelliği bir araya getiren Creavit ara musluklar modern banyolara zarafet katıyor. Kolay kullanımı ve pürüzsüz su akışı ile banyo deneyiminizi maksimum konforla taçlandırıyor. Yüksek kaliteli malzemelerle üretilen Creavit ara musluklarını uzun yıllar boyunca güvenle kullanabilirsiniz.</span><span data-mce-fragment=\"1\"></span></p>"
  },
  {
    "id": "creavit-8801754349865",
    "brand": "Creavit",
    "title": "Ara Kesme Valfi 1/2-1/2\" Siyah Mat",
    "category": "Ara Musluklar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-ara-kesme-valfi-siyah-1.png?v=1749221257",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-ara-kesme-valfi-siyah-1.png?v=1749221257",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ara-kesme-valfi-1-2-1-2-siyah-mat-4721.png?v=1749221257",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ara-kesme-valfi-1-2-1-2-siyah-mat-4722.png?v=1749221257",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ara-kesme-valfi-1-2-1-2-siyah-mat-4723.png?v=1749221253"
    ],
    "price": "2025.00",
    "sku": "MS.AC50L.SYM",
    "tags": [
      "ara kesme valfi",
      "ara musluk",
      "Mat Siyah",
      "Musluklar",
      "valf"
    ],
    "variants": [
      {
        "id": 52843261165865,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MS.AC50L.SYM",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2025.00",
        "grams": 0,
        "compare_at_price": "2700.00",
        "position": 1,
        "product_id": 8801754349865,
        "created_at": "2026-03-17T13:09:55+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p style=\"TEXT-ALIGN: left\"><span data-mce-fragment=\"1\">Minimalist şıklığı ve fonksiyonelliği bir araya getiren Creavit ara musluklar modern banyolara zarafet katıyor. Kolay kullanımı ve pürüzsüz su akışı ile banyo deneyiminizi maksimum konforla taçlandırıyor. Yüksek kaliteli malzemelerle üretilen Creavit ara musluklarını uzun yıllar boyunca güvenle kullanabilirsiniz.</span><span data-mce-fragment=\"1\"></span></p>"
  },
  {
    "id": "creavit-8801753923881",
    "brand": "Creavit",
    "title": "Kısa Musluk 1/2\" Krom",
    "category": "Ara Musluklar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kisa-musluk-1-2-krom-4719.png?v=1747234642",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kisa-musluk-1-2-krom-4719.png?v=1747234642"
    ],
    "price": "1485.00",
    "sku": "MS.T302S",
    "tags": [
      "ara kesme valfi",
      "ara musluk",
      "Krom",
      "Musluklar",
      "valf"
    ],
    "variants": [
      {
        "id": 52843241603369,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MS.T302S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1485.00",
        "grams": 0,
        "compare_at_price": "1980.00",
        "position": 1,
        "product_id": 8801753923881,
        "created_at": "2026-03-17T13:04:03+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p style=\"TEXT-ALIGN: left\"><span data-mce-fragment=\"1\">Minimalist şıklığı ve fonksiyonelliği bir araya getiren Creavit ara musluklar modern banyolara zarafet katıyor. Kolay kullanımı ve pürüzsüz su akışı ile banyo deneyiminizi maksimum konforla taçlandırıyor. Yüksek kaliteli malzemelerle üretilen Creavit ara musluklarını uzun yıllar boyunca güvenle kullanabilirsiniz.</span><span data-mce-fragment=\"1\"></span></p>"
  },
  {
    "id": "creavit-8801753760041",
    "brand": "Creavit",
    "title": "Çamaşır Musluğu 1/2\"-3/4\" Krom",
    "category": "Ara Musluklar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/camasir-muslugu-1-2-3-4-krom-4718.png?v=1747137829",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/camasir-muslugu-1-2-3-4-krom-4718.png?v=1747137829"
    ],
    "price": "1485.00",
    "sku": "MS.T405C",
    "tags": [
      "ara kesme valfi",
      "ara musluk",
      "Krom",
      "Musluklar",
      "valf",
      "çamaşır musluğu"
    ],
    "variants": [
      {
        "id": 52843221483817,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MS.T405C",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1485.00",
        "grams": 0,
        "compare_at_price": "1980.00",
        "position": 1,
        "product_id": 8801753760041,
        "created_at": "2026-03-17T12:56:39+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p style=\"TEXT-ALIGN: left\"><span data-mce-fragment=\"1\">Minimalist şıklığı ve fonksiyonelliği bir araya getiren Creavit ara musluklar modern banyolara zarafet katıyor. Kolay kullanımı ve pürüzsüz su akışı ile banyo deneyiminizi maksimum konforla taçlandırıyor. Yüksek kaliteli malzemelerle üretilen Creavit ara musluklarını uzun yıllar boyunca güvenle kullanabilirsiniz.</span><span data-mce-fragment=\"1\"></span></p>"
  },
  {
    "id": "creavit-8801753628969",
    "brand": "Creavit",
    "title": "Aç Kapa Ara Musluk 1/2 - 3/8",
    "category": "Ara Musluklar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ac-kapa-ara-musluk-1-2-3-8-4715.png?v=1747232684",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ac-kapa-ara-musluk-1-2-3-8-4715.png?v=1747232684",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ac-kapa-ara-musluk-1-2-3-8-4717.png?v=1747232687",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ac-kapa-ara-musluk-1-2-3-8-4716.png?v=1747232691"
    ],
    "price": "900.00",
    "sku": "MS.JK001",
    "tags": [
      "ara kesme valfi",
      "ara musluk",
      "Musluklar",
      "valf"
    ],
    "variants": [
      {
        "id": 52876507971881,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MS.JK001",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "900.00",
        "grams": 0,
        "compare_at_price": "1200.00",
        "position": 1,
        "product_id": 8801753628969,
        "created_at": "2026-03-25T12:22:37+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p style=\"TEXT-ALIGN: left\"><span data-mce-fragment=\"1\">Minimalist şıklığı ve fonksiyonelliği bir araya getiren Creavit ara musluklar modern banyolara zarafet katıyor. Kolay kullanımı ve pürüzsüz su akışı ile banyo deneyiminizi maksimum konforla taçlandırıyor. Yüksek kaliteli malzemelerle üretilen Creavit ara musluklarını uzun yıllar boyunca güvenle kullanabilirsiniz.</span><span data-mce-fragment=\"1\"></span></p>"
  },
  {
    "id": "creavit-8801753530665",
    "brand": "Creavit",
    "title": "50Ø Ara Kesme Valfi  1/2 -1/2",
    "category": "Ara Musluklar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/50-ara-kesme-valfi-1-2-1-2-4712.png?v=1747224575",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/50-ara-kesme-valfi-1-2-1-2-4712.png?v=1747224575",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/50-ara-kesme-valfi-1-2-1-2-4714.png?v=1747224578"
    ],
    "price": "2610.00",
    "sku": "MS.AC100M",
    "tags": [
      "ara kesme valfi",
      "ara musluk",
      "Krom",
      "Musluklar",
      "valf"
    ],
    "variants": [
      {
        "id": 52843227480361,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MS.AC100M",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2610.00",
        "grams": 0,
        "compare_at_price": "3480.00",
        "position": 1,
        "product_id": 8801753530665,
        "created_at": "2026-03-17T12:58:52+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p style=\"TEXT-ALIGN: left\"><span data-mce-fragment=\"1\">Minimalist şıklığı ve fonksiyonelliği bir araya getiren Creavit ara musluklar modern banyolara zarafet katıyor. Kolay kullanımı ve pürüzsüz su akışı ile banyo deneyiminizi maksimum konforla taçlandırıyor. Yüksek kaliteli malzemelerle üretilen Creavit ara musluklarını uzun yıllar boyunca güvenle kullanabilirsiniz.</span><span data-mce-fragment=\"1\"></span></p>"
  },
  {
    "id": "creavit-8801753301289",
    "brand": "Creavit",
    "title": "Çamaşır Musluğu Filtreli 1/2-3/4 (Krom)",
    "category": "Ara Musluklar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/camasir-muslugu-filtreli-1-2-3-4-krom-4711.png?v=1747233571",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/camasir-muslugu-filtreli-1-2-3-4-krom-4711.png?v=1747233571"
    ],
    "price": "900.00",
    "sku": "MS.FTC406",
    "tags": [
      "ara kesme valfi",
      "ara musluk",
      "filtreli musluk",
      "kireç temizleme",
      "Krom",
      "Musluklar",
      "valf",
      "çamaşır musluğu"
    ],
    "variants": [
      {
        "id": 52843221385513,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MS.FTC406",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "900.00",
        "grams": 0,
        "compare_at_price": "1200.00",
        "position": 1,
        "product_id": 8801753301289,
        "created_at": "2026-03-17T12:56:36+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p style=\"TEXT-ALIGN: left\"><span data-mce-fragment=\"1\">Minimalist şıklığı ve fonksiyonelliği bir araya getiren Creavit ara musluklar modern banyolara zarafet katıyor. Kolay kullanımı ve pürüzsüz su akışı ile banyo deneyiminizi maksimum konforla taçlandırıyor. Yüksek kaliteli malzemelerle üretilen Creavit ara musluklarını uzun yıllar boyunca güvenle kullanabilirsiniz.</span><span data-mce-fragment=\"1\"></span></p>"
  },
  {
    "id": "creavit-8801753071913",
    "brand": "Creavit",
    "title": "Aç Kapa Ara Kesme Valfi 3/4\"-3/4\" PPR",
    "category": "Ara Musluklar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ac-kapa-ara-kesme-valfi-3-4-3-4-ppr-4708.png?v=1747224561",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ac-kapa-ara-kesme-valfi-3-4-3-4-ppr-4708.png?v=1747224561",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ac-kapa-ara-kesme-valfi-3-4-3-4-ppr-4710.png?v=1747224564",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ac-kapa-ara-kesme-valfi-3-4-3-4-ppr-4709.png?v=1747224567"
    ],
    "price": "1575.00",
    "sku": "MS.AC25L",
    "tags": [
      "ara kesme valfi",
      "ara musluk",
      "Musluklar",
      "valf"
    ],
    "variants": [
      {
        "id": 52843250745641,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MS.AC25L",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1575.00",
        "grams": 0,
        "compare_at_price": "2100.00",
        "position": 1,
        "product_id": 8801753071913,
        "created_at": "2026-03-17T13:06:34+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p style=\"TEXT-ALIGN: left\"><span data-mce-fragment=\"1\">Minimalist şıklığı ve fonksiyonelliği bir araya getiren Creavit ara musluklar modern banyolara zarafet katıyor. Kolay kullanımı ve pürüzsüz su akışı ile banyo deneyiminizi maksimum konforla taçlandırıyor. Yüksek kaliteli malzemelerle üretilen Creavit ara musluklarını uzun yıllar boyunca güvenle kullanabilirsiniz.</span><span data-mce-fragment=\"1\"></span></p>"
  },
  {
    "id": "creavit-8801752940841",
    "brand": "Creavit",
    "title": "Aç Kapa Ara Kesme Valfi 1/2''-1/2'' PPRC",
    "category": "Ara Musluklar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ac-kapa-ara-kesme-valfi-1-2-1-2-pprc-4705.png?v=1746781592",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ac-kapa-ara-kesme-valfi-1-2-1-2-pprc-4705.png?v=1746781592",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ac-kapa-ara-kesme-valfi-1-2-1-2-pprc-4707.png?v=1746781596",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ac-kapa-ara-kesme-valfi-1-2-1-2-pprc-4706.png?v=1746781599"
    ],
    "price": "1215.00",
    "sku": "MS.AC40P",
    "tags": [
      "ara kesme valfi",
      "ara musluk",
      "Musluklar",
      "valf"
    ],
    "variants": [
      {
        "id": 52920970674473,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MS.AC40P",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1215.00",
        "grams": 0,
        "compare_at_price": "1620.00",
        "position": 1,
        "product_id": 8801752940841,
        "created_at": "2026-04-03T12:16:40+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Minimalist şıklığı ve fonksiyonelliği bir araya getiren Creavit ara musluklar, modern banyolara zarafet katıyor. Kolay kullanımı ve pürüzsüz su akışı ile banyo deneyiminizi maksimum konforla taçlandırıyor. Bu musluklar, yüksek kaliteli malzemelerle üretilen Creavit ara muslukları uzun yıllar boyunca güvenle kullana</span><span data-mce-fragment=\"1\">bilirsiniz</span><span data-mce-fragment=\"1\">. </span><span data-mce-fragment=\"1\">Estetik ve tasarımı, teknoloji ile buluşturan Creavit, kullanıcı odaklı tasarım bakış açısıyla yeni ürün geliştirmeye devam ediyor.</span></p>"
  },
  {
    "id": "creavit-8801752645929",
    "brand": "Creavit",
    "title": "Ara Musluk Filtreli 1/2 - 3/8'' Kumlu",
    "category": "Ara Musluklar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ara-musluk-filtreli-1-2-3-8-kumlu-4704.png?v=1747232676",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ara-musluk-filtreli-1-2-3-8-kumlu-4704.png?v=1747232676"
    ],
    "price": "585.00",
    "sku": "MS.FA002",
    "tags": [
      "ara kesme valfi",
      "ara musluk",
      "kumlu",
      "Musluklar",
      "valf"
    ],
    "variants": [
      {
        "id": 52843231248681,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MS.FA002",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "585.00",
        "grams": 0,
        "compare_at_price": "780.00",
        "position": 1,
        "product_id": 8801752645929,
        "created_at": "2026-03-17T13:00:16+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p style=\"TEXT-ALIGN: left\"><span data-mce-fragment=\"1\">Minimalist şıklığı ve fonksiyonelliği bir araya getiren Creavit ara musluklar modern banyolara zarafet katıyor. Kolay kullanımı ve pürüzsüz su akışı ile banyo deneyiminizi maksimum konforla taçlandırıyor. Yüksek kaliteli malzemelerle üretilen Creavit ara musluklarını uzun yıllar boyunca güvenle kullanabilirsiniz.</span><span data-mce-fragment=\"1\"></span></p>"
  },
  {
    "id": "creavit-8801751531817",
    "brand": "Creavit",
    "title": "Aç Kapa Ara Kesme Valfi 1/2-1/2",
    "category": "Ara Musluklar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ac-kapa-ara-kesme-valfi-1-2-1-2-4700.png?v=1747224545",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ac-kapa-ara-kesme-valfi-1-2-1-2-4700.png?v=1747224545",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ac-kapa-ara-kesme-valfi-1-2-1-2-4702.png?v=1747224548",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ac-kapa-ara-kesme-valfi-1-2-1-2-4701.png?v=1747224551",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ac-kapa-ara-kesme-valfi-1-2-1-2-4703.png?v=1747224554"
    ],
    "price": "1575.00",
    "sku": "MS.AC50L",
    "tags": [
      "ara kesme valfi",
      "ara musluk",
      "Musluklar",
      "valf"
    ],
    "variants": [
      {
        "id": 52843250516265,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MS.AC50L",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1575.00",
        "grams": 0,
        "compare_at_price": "2100.00",
        "position": 1,
        "product_id": 8801751531817,
        "created_at": "2026-03-17T13:06:31+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Minimalist şıklığı ve fonksiyonelliği bir araya getiren Creavit ara musluklar, modern banyolara zarafet katıyor. Kolay kullanımı ve pürüzsüz su akışı ile banyo deneyiminizi maksimum konforla taçlandırıyor. Bu musluklar, yüksek kaliteli malzemelerle üretilen Creavit ara muslukları uzun yıllar boyunca güvenle kullana</span><span data-mce-fragment=\"1\">bilirsiniz</span><span data-mce-fragment=\"1\">. </span><span data-mce-fragment=\"1\">Estetik ve tasarımı, teknoloji ile buluşturan Creavit, kullanıcı odaklı tasarım bakış açısıyla yeni ürün geliştirmeye devam ediyor.</span></p>"
  },
  {
    "id": "creavit-8801724105001",
    "brand": "Creavit",
    "title": "PVC Duş Hortumu 15000mm",
    "category": "Duş Sistemi",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pvc-dus-hortumu-15000mm-4699.png?v=1747234885",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pvc-dus-hortumu-15000mm-4699.png?v=1747234885"
    ],
    "price": "1125.00",
    "sku": "DS.H04",
    "tags": [
      "duş başlığı",
      "duş hortumu",
      "duş ürünleri",
      "Krom",
      "pvc duş hortumu",
      "yaz-20-indirim"
    ],
    "variants": [
      {
        "id": 52886547693865,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.H04",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1125.00",
        "grams": 0,
        "compare_at_price": "1500.00",
        "position": 1,
        "product_id": 8801724105001,
        "created_at": "2026-03-27T18:52:45+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\">Creavit Tamamlayıcı Duş Setleri!</p>\r\n<p data-mce-fragment=\"1\">Kullanıcı alışkanlıkları ve yeni trendler dikkate alınarak tasarlanan duş tamamlayıcıları ile Creavit; ıslak mekanlara yenilikçi ve bütüncül yaklaşımıyla konfor alanınızı genişletiyor.</p>\r\n<p data-mce-fragment=\"1\">Ankastre duş çıkışı, duş dirseği ve su çıkışı ürünleri ile duşta ihtiyaç duyduğunuz bütün duş sistemi kaliteli bir şekilde banyolara sunuyor. Tepe ve el duşu ile tamamlayıcı ürünlerle Creavit kalitesini her alanda hissedin.</p>"
  },
  {
    "id": "creavit-8794245333289",
    "brand": "Creavit",
    "title": "Su Tasarruflu Tepe Duş Başlığı (200mm)",
    "category": "Duş Başlığı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/su-tasarruflu-tepe-dus-basligi-200mm-4689.png?v=1747224495",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/su-tasarruflu-tepe-dus-basligi-200mm-4689.png?v=1747224495"
    ],
    "price": "1209.60",
    "sku": "DS.SH320",
    "tags": [
      "duş başlığı",
      "duş tamamlayıcıları",
      "duş ürünleri",
      "Krom",
      "paslanmaz duş başlığı",
      "Su Tasarruflu",
      "tepe duş başlığı",
      "tepe duşu",
      "yaz-20-indirim",
      "Yuvarlak"
    ],
    "variants": [
      {
        "id": 52836669554985,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.SH320",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "1209.60",
        "grams": 0,
        "compare_at_price": "2016.00",
        "position": 1,
        "product_id": 8794245333289,
        "created_at": "2026-03-15T21:13:08+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\">Kullanıcı alışkanlıkları ve yeni trendler dikkate alınarak tasarlanan duş tamamlayıcıları ile ıslak mekanlarda konfor alanınızı genişletin! Creavit; duş başlıkları, duş dirseği ve su çıkışı gibi duşta ihtiyaç duyduğunuz tüm ürünlerle yanınızda. Tepe, el duşu vb. tamamlayıcı ürünlerle Creavit ailesini her alanda keşfedebilirsiniz.</p>"
  },
  {
    "id": "creavit-8794280689961",
    "brand": "Creavit",
    "title": "Ankastre Paslanmaz Tepe Duş Başlığı Oval",
    "category": "Duş Başlığı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ankastre-paslanmaz-tepe-dus-basligi-oval-4697.png?v=1747224536",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ankastre-paslanmaz-tepe-dus-basligi-oval-4697.png?v=1747224536"
    ],
    "price": "13500.00",
    "sku": "DS.SH5020",
    "tags": [
      "ankastre",
      "duş başlığı",
      "duş tamamlayıcıları",
      "duş ürünleri",
      "Oval",
      "paslanmaz duş başlığı",
      "tepe duş başlığı",
      "tepe duşu",
      "yaz-20-indirim"
    ],
    "variants": [
      {
        "id": 52843221090601,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.SH5020",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "13500.00",
        "grams": 0,
        "compare_at_price": "18000.00",
        "position": 1,
        "product_id": 8794280689961,
        "created_at": "2026-03-17T12:56:30+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Kullanıcı alışkanlıkları ve yeni trendler dikkate alınarak tasarlanan duş tamamlayıcıları ile ıslak mekanlarda konfor alanınızı genişletin! Creavit; ankastre duş başlıkları, duş dirseği ve su çıkışı gibi duşta ihtiyaç duyduğunuz tüm ürünlerle yanınızda. Tepe, el duşu vb. tamamlayıcı ürünlerle Creavit ailesini her alanda keşfedebilirsiniz.</p>"
  },
  {
    "id": "creavit-8794276659497",
    "brand": "Creavit",
    "title": "Paslanmaz Slim Tepe Duş Başlığı Kare 400mm",
    "category": "Duş Başlığı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/paslanmaz-slim-tepe-dus-basligi-kare-400mm-4696.png?v=1747224529",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/paslanmaz-slim-tepe-dus-basligi-kare-400mm-4696.png?v=1747224529"
    ],
    "price": "10800.00",
    "sku": "DS.SH4000",
    "tags": [
      "duş başlığı",
      "duş tamamlayıcıları",
      "duş ürünleri",
      "Kare",
      "Krom",
      "paslanmaz duş başlığı",
      "tepe duş başlığı",
      "tepe duşu",
      "yaz-20-indirim"
    ],
    "variants": [
      {
        "id": 52843220893993,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.SH4000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "10800.00",
        "grams": 0,
        "compare_at_price": "14400.00",
        "position": 1,
        "product_id": 8794276659497,
        "created_at": "2026-03-17T12:56:27+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\">Kullanıcı alışkanlıkları ve yeni trendler dikkate alınarak tasarlanan duş tamamlayıcıları ile ıslak mekanlarda konfor alanınızı genişletin! Creavit; duş başlıkları, duş dirseği ve su çıkışı gibi duşta ihtiyaç duyduğunuz tüm ürünlerle yanınızda. Tepe, el duşu vb. tamamlayıcı ürünlerle Creavit ailesini her alanda keşfedebilirsiniz.</p>"
  },
  {
    "id": "creavit-8794273677609",
    "brand": "Creavit",
    "title": "Kireç Kırıcılı Tepe Duşu Mat Siyah Yuvarlak",
    "category": "Duş Başlığı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kirec-kiricili-tepe-dusu-mat-siyah-yuvarlak-4695.png?v=1747806603",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kirec-kiricili-tepe-dusu-mat-siyah-yuvarlak-4695.png?v=1747806603"
    ],
    "price": "2565.00",
    "sku": "DS.SH330S",
    "tags": [
      "duş başlığı",
      "duş ürünleri",
      "kireç temizleme",
      "Mat Siyah",
      "tepe duş başlığı",
      "tepe duşu",
      "yaz-20-indirim",
      "Yuvarlak"
    ],
    "variants": [
      {
        "id": 52937432301865,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.SH330S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2565.00",
        "grams": 0,
        "compare_at_price": "3420.00",
        "position": 1,
        "product_id": 8794273677609,
        "created_at": "2026-04-06T16:34:11+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\">Kullanıcı alışkanlıkları ve yeni trendler dikkate alarak tasarlanan duş tamamlayıcıları ile Creavit; ıslak mekanlara yenilikçi yaklaşımıyla konfor alanınızı genişletiyor. Kaliteli malzemelerden üretilen Tepe Duşları; en sert su koşullarına bile dayanarak uzun yıllar boyunca sorunsuz performans sunar. Su çıkış başlığında bulunan silikon nozullar kireç birikimini engelleyerel temiz, güçlü bir su akışı sağlar. </p>"
  },
  {
    "id": "creavit-8794271023401",
    "brand": "Creavit",
    "title": "Paslanmaz Slim Tepe Duş Başlığı Yuvarlak 400mm",
    "category": "Duş Başlığı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/paslanmaz-slim-tepe-dus-basligi-yuvarlak-400mm-4694.png?v=1747224521",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/paslanmaz-slim-tepe-dus-basligi-yuvarlak-400mm-4694.png?v=1747224521"
    ],
    "price": "9765.00",
    "sku": "DS.SH3040",
    "tags": [
      "duş başlığı",
      "duş tamamlayıcıları",
      "duş ürünleri",
      "Krom",
      "paslanmaz duş başlığı",
      "tepe duş başlığı",
      "tepe duşu",
      "yaz-20-indirim",
      "Yuvarlak"
    ],
    "variants": [
      {
        "id": 52843220730153,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.SH3040",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9765.00",
        "grams": 0,
        "compare_at_price": "13020.00",
        "position": 1,
        "product_id": 8794271023401,
        "created_at": "2026-03-17T12:56:24+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\">Kullanıcı alışkanlıkları ve yeni trendler dikkate alınarak tasarlanan duş tamamlayıcıları ile ıslak mekanlarda konfor alanınızı genişletin! Creavit; duş başlıkları, duş dirseği ve su çıkışı gibi duşta ihtiyaç duyduğunuz tüm ürünlerle yanınızda. Tepe, el duşu vb. tamamlayıcı ürünlerle Creavit ailesini her alanda keşfedebilirsiniz.</p>"
  },
  {
    "id": "creavit-8794256703785",
    "brand": "Creavit",
    "title": "Paslanmaz Slim Tepe Duş Başlığı Kare 300mm",
    "category": "Duş Başlığı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/paslanmaz-slim-tepe-dus-basligi-kare-300mm-4693.png?v=1747224514",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/paslanmaz-slim-tepe-dus-basligi-kare-300mm-4693.png?v=1747224514"
    ],
    "price": "6750.00",
    "sku": "DS.SH4030",
    "tags": [
      "duş başlığı",
      "duş tamamlayıcıları",
      "duş ürünleri",
      "Kare",
      "Krom",
      "paslanmaz duş başlığı",
      "tepe duş başlığı",
      "tepe duşu",
      "yaz-20-indirim"
    ],
    "variants": [
      {
        "id": 52843220533545,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.SH4030",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6750.00",
        "grams": 0,
        "compare_at_price": "9000.00",
        "position": 1,
        "product_id": 8794256703785,
        "created_at": "2026-03-17T12:56:21+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\">Kullanıcı alışkanlıkları ve yeni trendler dikkate alınarak tasarlanan duş tamamlayıcıları ile ıslak mekanlarda konfor alanınızı genişletin! Creavit; duş başlıkları, duş dirseği ve su çıkışı gibi duşta ihtiyaç duyduğunuz tüm ürünlerle yanınızda. Tepe, el duşu vb. tamamlayıcı ürünlerle Creavit ailesini her alanda keşfedebilirsiniz.</p>"
  },
  {
    "id": "creavit-8794254278953",
    "brand": "Creavit",
    "title": "Ankastre Paslanmaz Tepe Duş Başlığı Düz",
    "category": "Duş Başlığı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ankastre-paslanmaz-tepe-dus-basligi-duz-4692.png?v=1747224508",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ankastre-paslanmaz-tepe-dus-basligi-duz-4692.png?v=1747224508"
    ],
    "price": "14850.00",
    "sku": "DS.SH5010",
    "tags": [
      "ankastre",
      "duş başlığı",
      "duş tamamlayıcıları",
      "duş ürünleri",
      "düz",
      "paslanmaz duş başlığı",
      "tepe duş başlığı",
      "tepe duşu",
      "yaz-20-indirim"
    ],
    "variants": [
      {
        "id": 52843220369705,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.SH5010",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "14850.00",
        "grams": 0,
        "compare_at_price": "19800.00",
        "position": 1,
        "product_id": 8794254278953,
        "created_at": "2026-03-17T12:56:17+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Kullanıcı alışkanlıkları ve yeni trendler dikkate alınarak tasarlanan duş tamamlayıcıları ile ıslak mekanlarda konfor alanınızı genişletin! Creavit; ankastre duş başlıkları, duş dirseği ve su çıkışı gibi duşta ihtiyaç duyduğunuz tüm ürünlerle yanınızda. Tepe, el duşu vb. tamamlayıcı ürünlerle Creavit ailesini her alanda keşfedebilirsiniz.</p>"
  },
  {
    "id": "creavit-8794251526441",
    "brand": "Creavit",
    "title": "Kireç Kırıcılı Tepe Duşu Mat Siyah Kare",
    "category": "Duş Başlığı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kirec-kiricili-tepe-dusu-mat-siyah-kare-4691.png?v=1747806606",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kirec-kiricili-tepe-dusu-mat-siyah-kare-4691.png?v=1747806606"
    ],
    "price": "2700.00",
    "sku": "DS.SH340S",
    "tags": [
      "duş başlığı",
      "duş tamamlayıcıları",
      "duş ürünleri",
      "Kare",
      "kireç temizleme",
      "Mat Siyah",
      "tepe duş başlığı",
      "tepe duşu",
      "yaz-20-indirim"
    ],
    "variants": [
      {
        "id": 52920428134697,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.SH340S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2700.00",
        "grams": 0,
        "compare_at_price": "3600.00",
        "position": 1,
        "product_id": 8794251526441,
        "created_at": "2026-04-03T10:01:08+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\">Kullanıcı alışkanlıkları ve yeni trendler dikkate alarak tasarlanan duş tamamlayıcıları ile Creavit; ıslak mekanlara yenilikçi yaklaşımıyla konfor alanınızı genişletiyor. Kaliteli malzemelerden üretilen Tepe Duşları; en sert su koşullarına bile dayanarak uzun yıllar boyunca sorunsuz performans sunar. Su çıkış başlığında bulunan silikon nozullar kireç birikimini engelleyerel temiz, güçlü bir su akışı sağlar. </p>"
  },
  {
    "id": "creavit-8794248577321",
    "brand": "Creavit",
    "title": "Tepe Duş Başlığı Kare 200mm",
    "category": "Duş Başlığı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tepe-dus-basligi-kare-200mm-4690.png?v=1747224501",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tepe-dus-basligi-kare-200mm-4690.png?v=1747224501"
    ],
    "price": "2655.00",
    "sku": "DS.SH5030",
    "tags": [
      "duş başlığı",
      "duş tamamlayıcıları",
      "duş ürünleri",
      "Kare",
      "Krom",
      "tepe duş başlığı",
      "tepe duşu",
      "yaz-20-indirim"
    ],
    "variants": [
      {
        "id": 52843220205865,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.SH5030",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2655.00",
        "grams": 0,
        "compare_at_price": "3540.00",
        "position": 1,
        "product_id": 8794248577321,
        "created_at": "2026-03-17T12:56:14+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\">Kullanıcı alışkanlıkları ve yeni trendler dikkate alınarak tasarlanan duş tamamlayıcıları ile ıslak mekanlarda konfor alanınızı genişletin! Creavit; duş başlıkları, duş dirseği ve su çıkışı gibi duşta ihtiyaç duyduğunuz tüm ürünlerle yanınızda. Tepe, el duşu vb. tamamlayıcı ürünlerle Creavit ailesini her alanda keşfedebilirsiniz.</p>"
  },
  {
    "id": "creavit-8794244186409",
    "brand": "Creavit",
    "title": "Kireç Kırıcılı Tepe Duşu Kare",
    "category": "Duş Başlığı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kirec-kiricili-tepe-dusu-kare-4688.png?v=1747806610",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kirec-kiricili-tepe-dusu-kare-4688.png?v=1747806610"
    ],
    "price": "2565.00",
    "sku": "DS.SH340",
    "tags": [
      "duş başlığı",
      "duş tamamlayıcıları",
      "duş ürünleri",
      "Kare",
      "kireç temizleme",
      "Krom",
      "tepe duş başlığı",
      "tepe duşu",
      "yaz-20-indirim"
    ],
    "variants": [
      {
        "id": 52920450515241,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.SH340",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2565.00",
        "grams": 0,
        "compare_at_price": "3420.00",
        "position": 1,
        "product_id": 8794244186409,
        "created_at": "2026-04-03T10:06:16+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\">Kullanıcı alışkanlıkları ve yeni trendler dikkate alarak tasarlanan duş tamamlayıcıları ile Creavit; ıslak mekanlara yenilikçi yaklaşımıyla konfor alanınızı genişletiyor. Kaliteli malzemelerden üretilen Tepe Duşları; en sert su koşullarına bile dayanarak uzun yıllar boyunca sorunsuz performans sunar. Su çıkış başlığında bulunan silikon nozullar kireç birikimini engelleyerel temiz, güçlü bir su akışı sağlar. </p>"
  },
  {
    "id": "creavit-8794235765033",
    "brand": "Creavit",
    "title": "Kireç Kırıcılı Tepe Duşu Yuvarlak",
    "category": "Duş Başlığı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kirec-kiricili-tepe-dusu-yuvarlak-4687.png?v=1747806614",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kirec-kiricili-tepe-dusu-yuvarlak-4687.png?v=1747806614"
    ],
    "price": "2385.00",
    "sku": "DS.SH330",
    "tags": [
      "duş başlığı",
      "duş ürünleri",
      "kireç temizleme",
      "Krom",
      "tepe duş başlığı",
      "tepe duşu",
      "yaz-20-indirim",
      "Yuvarlak"
    ],
    "variants": [
      {
        "id": 52843226267945,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.SH330",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2385.00",
        "grams": 0,
        "compare_at_price": "3180.00",
        "position": 1,
        "product_id": 8794235765033,
        "created_at": "2026-03-17T12:58:27+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\">Kullanıcı alışkanlıkları ve yeni trendler dikkate alarak tasarlanan duş tamamlayıcıları ile Creavit; ıslak mekanlara yenilikçi yaklaşımıyla konfor alanınızı genişletiyor. Kaliteli malzemelerden üretilen Tepe Duşları; en sert su koşullarına bile dayanarak uzun yıllar boyunca sorunsuz performans sunar. Su çıkış başlığında bulunan silikon nozullar kireç birikimini engelleyerel temiz, güçlü bir su akışı sağlar. </p>"
  },
  {
    "id": "creavit-8788148519209",
    "brand": "Creavit",
    "title": "Ocean Kolon Duş Sistemi",
    "category": "Duş Sistemi",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ocean-kolon-dus-sistemi-4681.png?v=1747806637",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ocean-kolon-dus-sistemi-4681.png?v=1747806637",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ocean-kolon-dus-sistemi-4682.png?v=1747806637"
    ],
    "price": "43650.00",
    "sku": "DS.SH650",
    "tags": [
      "Beyaz",
      "dus sistemi",
      "duş sistemleri",
      "duş ürünleri",
      "el duşu",
      "kireç temizleme",
      "kolon duş sistemi",
      "ocean",
      "tepe duş sistemi",
      "yaz-20-indirim",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843219648809,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.SH650",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "43650.00",
        "grams": 0,
        "compare_at_price": "58200.00",
        "position": 1,
        "product_id": 8788148519209,
        "created_at": "2026-03-17T12:56:00+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Duşta Konforun Adı Ocean Duş Sistemi!</strong></p>\r\n<p>Bir duşta ihtiyaç duyulan her şeyi bir arada sunan Ocean Duş Sistemi, entegre etajer-havluluk ve termostatik kumanda paneli ile duş keyfini katlar. Şık tasarımı ve dayanıklı yapısıyla, banyolara Creavit ayrıcalığını taşır.</p>\r\n<ul>\r\n<li>Su sıcaklığını sabit tutan termostatik armatür</li>\r\n<li>Geniş tepe duşu ve iki fonksiyonlu el duşu</li>\r\n<li>Butonla kontrol edilebilen duş başlıkları</li>\r\n<li>Kullanışlı etayer ve havluluk</li>\r\n<li>Kireç önleyici mekanizma</li>\r\n<li>Kurulum Türü: Duvara Montaj</li>\n</ul>"
  },
  {
    "id": "creavit-8788149076265",
    "brand": "Creavit",
    "title": "Sürgülü Duş Sistemi",
    "category": "Duş Sistemi",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/surgulu-dus-sistemi-4686.jpg?v=1747224488",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/surgulu-dus-sistemi-4686.jpg?v=1747224488"
    ],
    "price": "4500.00",
    "sku": "DS.SH483",
    "tags": [
      "dus sistemi",
      "duş sistemleri",
      "duş ürünleri",
      "el duşu",
      "kireç temizleme",
      "Krom",
      "masfallı el duşu",
      "yaz-20-indirim"
    ],
    "variants": [
      {
        "id": 52843220074793,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.SH483",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "4500.00",
        "grams": 0,
        "compare_at_price": "6000.00",
        "position": 1,
        "product_id": 8788149076265,
        "created_at": "2026-03-17T12:56:11+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p data-mce-fragment=\"1\"><strong>Sürgülü Tasarım: </strong>Sürgülü tasarımı sayesinde el duşunu istediğiniz yüksekliğe ayarlayarak daha rahat ve konforlu kullanım sağlar.</p>\r\n<p data-mce-fragment=\"1\"><span><strong>Kolay Fonksiyon Değişimi:</strong> Creavit sürgülü duşun fonksiyonlarını tek bir dokunuşla su akışını farklı modlara geçirebilir banyo deneyiminizi çeşitlendirebilirsiniz.</span></p>\r\n<p data-mce-fragment=\"1\"><strong>Dayanıklılık ve Kalite: </strong>Krom kaplamalı pirinç malzemeden üretilen Creavit sürgülü duş sistemleri en sert su koşullarına bile dayanıklılık sağlayarak uzun yıllar boyunca sorunsuz performans sunar.</p>\n</div>\n</div>"
  },
  {
    "id": "creavit-8788148879657",
    "brand": "Creavit",
    "title": "Tepe Duş Sistemi",
    "category": "Duş Sistemi",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tepe-dus-sistemi-4685.png?v=1746557278",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tepe-dus-sistemi-4685.png?v=1746557278"
    ],
    "price": "18900.00",
    "sku": "DS.SH520",
    "tags": [
      "dus sistemi",
      "duş sistemleri",
      "duş ürünleri",
      "el duşu",
      "kireç temizleme",
      "Krom",
      "masfallı el duşu",
      "tepe duş sistemi",
      "yaz-20-indirim"
    ],
    "variants": [
      {
        "id": 52843219943721,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.SH520",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "18900.00",
        "grams": 0,
        "compare_at_price": "25200.00",
        "position": 1,
        "product_id": 8788148879657,
        "created_at": "2026-03-17T12:56:08+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p data-mce-fragment=\"1\">Banyo deneyiminizi yeniden tanımlamak için tasarlanan Creavit Duş Sistemleri modern ve şık tasarımlarıyla banyolara yenilik ve işlevsellik getiriyor. Creavit inovatif duş sistemlerinde bulunan kireç temizleyici teknoloji sayesinde duş başlıklarında pürüzsüz ve etkili su akışı uzun yıllar sorunsuz devam eder. Sert su lekeleriyle uğraşma zahmetinden kurtulurken banyonuz her zaman temiz ve parlak kalır. Creavit Tepe Duş Sistemleri ile her duş lüks bir spa deneyimine dönüşürken aynı zamanda temizlik ve hijyenin keyfini çıkaracaksınız.</p>\n</div>\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\"><br></div>"
  },
  {
    "id": "creavit-8788148715817",
    "brand": "Creavit",
    "title": "Tepe Duş Sistemi (Termostatlı)",
    "category": "Duş Sistemi",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tepe-dus-sistemi-termostatli-4684.png?v=1747224482",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tepe-dus-sistemi-termostatli-4684.png?v=1747224482"
    ],
    "price": "21600.00",
    "sku": "DS.SH510",
    "tags": [
      "dus sistemi",
      "duş sistemleri",
      "duş ürünleri",
      "el duşu",
      "kireç temizleme",
      "Krom",
      "masfallı el duşu",
      "tepe duş sistemi",
      "termostatlı duş sistemi",
      "yaz-20-indirim"
    ],
    "variants": [
      {
        "id": 52843219845417,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.SH510",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "21600.00",
        "grams": 0,
        "compare_at_price": "28800.00",
        "position": 1,
        "product_id": 8788148715817,
        "created_at": "2026-03-17T12:56:05+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p data-mce-fragment=\"1\">Banyo deneyiminizi yeniden tanımlamak için tasarlanan Creavit Duş Sistemleri modern ve şık tasarımlarıyla banyolara yenilik ve işlevsellik getiriyor. Termostatlı Tepe Duş Sistemleri su sıcaklığını istikrarlı bir şekilde korurken, her duş istediğiniz sıcaklık ve konforla başlar ve aynı şekilde devam eder. Kolay montaj ve kaliteli malzemelerden gelen dayanıklılıkla, uzun yıllar sürecek ferah ve konforlu duş deneyimi ile güne enerjik başlayın.</p>\n</div>"
  },
  {
    "id": "creavit-8788147962153",
    "brand": "Creavit",
    "title": "Tepe Duş Sistemi Kendinden Temizleyicili (Oval)",
    "category": "Duş Sistemi",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tepe-dus-sistemi-kendinden-temizleyicili-oval-4680.png?v=1747224464",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tepe-dus-sistemi-kendinden-temizleyicili-oval-4680.png?v=1747224464"
    ],
    "price": "7875.00",
    "sku": "DSU.SH640",
    "tags": [
      "dus sistemi",
      "duş sistemleri",
      "duş ürünleri",
      "el duşu",
      "kireç temizleme",
      "Krom",
      "masfallı el duşu",
      "Oval",
      "tepe duş sistemi",
      "yaz-20-indirim"
    ],
    "variants": [
      {
        "id": 52920970445097,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DSU.SH640",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "7875.00",
        "grams": 0,
        "compare_at_price": "10500.00",
        "position": 1,
        "product_id": 8788147962153,
        "created_at": "2026-04-03T12:16:37+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\n<p data-mce-fragment=\"1\">Banyo deneyiminizi yeniden tanımlamak için tasarlanan Creavit Duş Sistemleri modern ve şık tasarımlarıyla banyolara yenilik ve işlevsellik getiriyor. Creavit inovatif duş sistemlerinde bulunan kireç temizleyici teknoloji sayesinde duş başlıklarında pürüzsüz ve etkili su akışı uzun yıllar sorunsuz devam eder. Sert su lekeleriyle uğraşma zahmetinden kurtulurken banyonuz her zaman temiz ve parlak kalır. Creavit Tepe Duş Sistemleri ile her duş lüks bir spa deneyimine dönüşürken aynı zamanda temizlik ve hijyenin keyfini çıkaracaksınız.</p>\n</div>\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\"><br></div>"
  },
  {
    "id": "creavit-8788120797481",
    "brand": "Creavit",
    "title": "SH630 Tepe Duş Sistemi Kendinden Temizleyicili (Kare)",
    "category": "Duş Sistemi",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tepe-dus-sistemi-kendinden-temizleyicili-kare-4679.png?v=1747312453",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tepe-dus-sistemi-kendinden-temizleyicili-kare-4679.png?v=1747312453"
    ],
    "price": "8100.00",
    "sku": "DSU.SH630",
    "tags": [
      "dus sistemi",
      "duş sistemleri",
      "duş ürünleri",
      "el duşu",
      "kireç temizleme",
      "Krom",
      "masfallı el duşu",
      "tepe duş sistemi",
      "yaz-20-indirim"
    ],
    "variants": [
      {
        "id": 52907154342185,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DSU.SH630",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "8100.00",
        "grams": 0,
        "compare_at_price": "10800.00",
        "position": 1,
        "product_id": 8788120797481,
        "created_at": "2026-03-31T15:22:53+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p data-mce-fragment=\"1\">Banyo deneyiminizi yeniden tanımlamak için tasarlanan Creavit Duş Sistemleri modern ve şık tasarımlarıyla banyolara yenilik ve işlevsellik getiriyor. Creavit inovatif duş sistemlerinde bulunan kireç temizleyici teknoloji sayesinde duş başlıklarında pürüzsüz ve etkili su akışı uzun yıllar sorunsuz devam eder. Sert su lekeleriyle uğraşma zahmetinden kurtulurken banyonuz her zaman temiz ve parlak kalır. Creavit Tepe Duş Sistemleri ile her duş lüks bir spa deneyimine dönüşürken aynı zamanda temizlik ve hijyenin keyfini çıkaracaksınız.</p>\n</div>\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\"><br></div>"
  },
  {
    "id": "creavit-8787052462377",
    "brand": "Creavit",
    "title": "Mafsallı El Duş Seti 3F",
    "category": "El Duş Seti",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mafsalli-el-dus-seti-3f-4678.png?v=1747233532",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mafsalli-el-dus-seti-3f-4678.png?v=1747233532"
    ],
    "price": "2250.00",
    "sku": "DS.SH117",
    "tags": [
      "duş seti",
      "duş setleri",
      "duş ürünleri",
      "el duşu",
      "el duşu seti",
      "Krom",
      "masfallı el duşu",
      "yaz-20-indirim"
    ],
    "variants": [
      {
        "id": 52843250319657,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.SH117",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2250.00",
        "grams": 0,
        "compare_at_price": "3000.00",
        "position": 1,
        "product_id": 8787052462377,
        "created_at": "2026-03-17T13:06:28+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\">Kullanıcı alışkanlıkları ve yeni trendler dikkate alınarak tasarlanan duş tamamlayıcıları ile Creavit; ıslak mekanlara yenilikçi yaklaşımıyla konfor alanınızı genişletiyor. Kaliteli malzemelerden üretilen El Duş Setleri; en sert su koşullarına bile dayanarak uzun yıllar boyunca sorunsuz performans sunar. Ayrıca Esnek mafsal tasarımı sayesinde duş başlığını istediğiniz açıya rahatlıkla ayarlayarak su akışını kişiselleştirebilir, kolay montaj özelliği ile de mevcut duş sisteminize kolaylıkla entegre edebilirsiniz.</p>"
  },
  {
    "id": "creavit-8787046859049",
    "brand": "Creavit",
    "title": "Mafsallı El Duş Seti 5F",
    "category": "El Duş Seti",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mafsalli-el-dus-seti-5f-4677.png?v=1746869888",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mafsalli-el-dus-seti-5f-4677.png?v=1746869888"
    ],
    "price": "1485.00",
    "sku": "DS.SH116",
    "tags": [
      "duş seti",
      "duş setleri",
      "duş ürünleri",
      "el duşu",
      "el duşu seti",
      "Krom",
      "masfallı el duşu",
      "yaz-20-indirim"
    ],
    "variants": [
      {
        "id": 52933935530281,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.SH116",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1485.00",
        "grams": 0,
        "compare_at_price": "1980.00",
        "position": 1,
        "product_id": 8787046859049,
        "created_at": "2026-04-05T23:36:42+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\">Kullanıcı alışkanlıkları ve yeni trendler dikkate alınarak tasarlanan duş tamamlayıcıları ile Creavit; ıslak mekanlara yenilikçi yaklaşımıyla konfor alanınızı genişletiyor. Kaliteli malzemelerden üretilen El Duş Setleri; en sert su koşullarına bile dayanarak uzun yıllar boyunca sorunsuz performans sunar. Ayrıca Esnek mafsal tasarımı sayesinde duş başlığını istediğiniz açıya rahatlıkla ayarlayarak su akışını kişiselleştirebilir, kolay montaj özelliği ile de mevcut duş sisteminize kolaylıkla entegre edebilirsiniz.</p>"
  },
  {
    "id": "creavit-8784943579433",
    "brand": "Creavit",
    "title": "Kireç Kırıcılı El Duşu Seti Mat Siyah (Yuvarlak)",
    "category": "El Duş Seti",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kirec-kiricili-el-dusu-seti-mat-siyah-yuvarlak-4676.png?v=1747806640",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kirec-kiricili-el-dusu-seti-mat-siyah-yuvarlak-4676.png?v=1747806640"
    ],
    "price": "2565.00",
    "sku": "DS.SH121S",
    "tags": [
      "duş seti",
      "duş setleri",
      "duş ürünleri",
      "el duşu",
      "el duşu seti",
      "Mat Siyah",
      "yaz-20-indirim",
      "Yuvarlak"
    ],
    "variants": [
      {
        "id": 52937167634729,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.SH121S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2565.00",
        "grams": 0,
        "compare_at_price": "3420.00",
        "position": 1,
        "product_id": 8784943579433,
        "created_at": "2026-04-06T15:22:47+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\">Kullanıcı alışkanlıkları ve yeni trendler dikkate alınarak tasarlanan Creavit duş tamamlayıcıları; ıslak mekanlara yenilikçi yaklaşımıyla konfor alanınızı genişletiyor. Kaliteli malzemelerden üretilen El Duşları; en sert su koşullarına bile dayanarak uzun yıllar boyunca sorunsuz performans sunar. Su çıkış başlığında bulunan silikon nozullar kireç birikimini engelleyerek temiz, güçlü bir su akışı sağlar. Ayrıca esnek mafsal tasarımı sayesinde duş başlığını istediğiniz açıya rahatlıkla ayarlayarak su akışını kişiselleştirebilir, kolay montaj özelliği ile de mevcut duş sisteminize kolaylıkla entegre edebilirsiniz.</p>"
  },
  {
    "id": "creavit-8784943513897",
    "brand": "Creavit",
    "title": "El Duş Seti Mat Siyah",
    "category": "El Duş Seti",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/el-dus-seti-mat-siyah-4675.png?v=1747232533",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/el-dus-seti-mat-siyah-4675.png?v=1747232533"
    ],
    "price": "2520.00",
    "sku": "DS.SH119S",
    "tags": [
      "duş seti",
      "duş setleri",
      "duş ürünleri",
      "el duşu",
      "el duşu seti",
      "masfallı el duşu",
      "Mat Siyah",
      "yaz-20-indirim"
    ],
    "variants": [
      {
        "id": 52843236327721,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.SH119S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2520.00",
        "grams": 0,
        "compare_at_price": "3360.00",
        "position": 1,
        "product_id": 8784943513897,
        "created_at": "2026-03-17T13:02:10+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\">Kullanıcı alışkanlıkları ve yeni trendler dikkate alarak tasarlanan duş tamamlayıcıları ile Creavit; ıslak mekanlara yenilikçi yaklaşımıyla konfor alanınızı genişletiyor. Kaliteli malzemelerden üretilen El Duş Setleri; en sert su koşullarına bile dayanarak uzun yıllar boyunca sorunsuz performans sunar. Esnek mafsal tasarımı sayesinde duş başlığını istediğiniz açıya rahatlıkla ayarlayarak su akışını kişiselleştirebilir, aynı zamanda kolay montaj özelliği ile mevcut duş sisteminize kolaylıkla entegre edebilirsiniz.</p>"
  },
  {
    "id": "creavit-8784943350057",
    "brand": "Creavit",
    "title": "El Duş Seti",
    "category": "El Duş Seti",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/el-dus-seti-4674.png?v=1747232526",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/el-dus-seti-4674.png?v=1747232526"
    ],
    "price": "2700.00",
    "sku": "DS.SH118",
    "tags": [
      "duş seti",
      "duş setleri",
      "duş ürünleri",
      "el duşu",
      "el duşu seti",
      "Krom",
      "masfallı el duşu",
      "yaz-20-indirim"
    ],
    "variants": [
      {
        "id": 52921483624745,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.SH118",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2700.00",
        "grams": 0,
        "compare_at_price": "3600.00",
        "position": 1,
        "product_id": 8784943350057,
        "created_at": "2026-04-03T14:44:17+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\">Kullanıcı alışkanlıkları ve yeni trendler dikkate alınarak tasarlanan duş tamamlayıcıları ile Creavit; ıslak mekanlara yenilikçi yaklaşımıyla konfor alanınızı genişletiyor. Kaliteli malzemelerden üretilen El Duş Setleri; en sert su koşullarına bile dayanarak uzun yıllar boyunca sorunsuz performans sunar. Ayrıca Esnek mafsal tasarımı sayesinde duş başlığını istediğiniz açıya rahatlıkla ayarlayarak su akışını kişiselleştirebilir, kolay montaj özelliği ile de mevcut duş sisteminize kolaylıkla entegre edebilirsiniz.</p>"
  },
  {
    "id": "creavit-8784943186217",
    "brand": "Creavit",
    "title": "Sürgülü Duş Sistemi Mat Siyah",
    "category": "Duş Sistemi",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/surgulu-dus-sistemi-mat-siyah-4673.png?v=1747224451",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/surgulu-dus-sistemi-mat-siyah-4673.png?v=1747224451"
    ],
    "price": "5040.00",
    "sku": "DS.SH493S",
    "tags": [
      "duş seti",
      "duş setleri",
      "duş ürünleri",
      "el duşu",
      "el duşu seti",
      "masfallı el duşu",
      "Mat Siyah",
      "sürgülü duş seti",
      "yaz-20-indirim"
    ],
    "variants": [
      {
        "id": 52843245175081,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.SH493S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5040.00",
        "grams": 0,
        "compare_at_price": "6720.00",
        "position": 1,
        "product_id": 8784943186217,
        "created_at": "2026-03-17T13:04:53+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p data-mce-fragment=\"1\"><strong>Sürgülü Tasarım: </strong>Sürgülü tasarımı sayesinde el duşunu istediğiniz yüksekliğe ayarlayarak daha rahat ve konforlu kullanım sağlar.</p>\r\n<p data-mce-fragment=\"1\"><span><strong>Kolay Fonksiyon Değişimi:</strong> Creavit sürgülü duşun fonksiyonlarını tek bir dokunuşla su akışını farklı modlara geçirebilir banyo deneyiminizi çeşitlendirebilirsiniz.</span></p>\r\n<p data-mce-fragment=\"1\"><strong>Dayanıklılık ve Kalite: </strong>Krom kaplamalı pirinç malzemeden üretilen Creavit sürgülü duş sistemleri en sert su koşullarına bile dayanıklılık sağlayarak uzun yıllar boyunca sorunsuz performans sunar.</p>\n</div>"
  },
  {
    "id": "creavit-8784943120681",
    "brand": "Creavit",
    "title": "Sürgülü El Duş Seti 1F Altın Renk",
    "category": "Duş Setleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/surgulu-el-dus-seti-1f-altin-renk-4672.png?v=1747224444",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/surgulu-el-dus-seti-1f-altin-renk-4672.png?v=1747224444"
    ],
    "price": "5745.00",
    "sku": "DS.SH411G",
    "tags": [
      "altın",
      "duş seti",
      "duş setleri",
      "duş ürünleri",
      "el duşu",
      "el duşu seti",
      "masfallı el duşu",
      "sürgülü duş seti",
      "yaz-20-indirim"
    ],
    "variants": [
      {
        "id": 52843219222825,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.SH411G",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5745.00",
        "grams": 0,
        "compare_at_price": "7660.00",
        "position": 1,
        "product_id": 8784943120681,
        "created_at": "2026-03-17T12:55:54+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p data-mce-fragment=\"1\"><strong>Sürgülü Tasarım: </strong>Sürgülü tasarımı sayesinde el duşunu istediğiniz yüksekliğe ayarlayarak daha rahat ve konforlu kullanım sağlar.</p>\r\n<p data-mce-fragment=\"1\"><strong>Dayanıklılık ve Kalite: </strong>Krom kaplamalı pirinç malzemeden üretilen Creavit sürgülü duş sistemleri en sert su koşullarına bile dayanıklılık sağlayarak uzun yıllar boyunca sorunsuz performans sunar.</p>\n</div>"
  },
  {
    "id": "creavit-8784942858537",
    "brand": "Creavit",
    "title": "Kireç Kırıcılı El Duşu Seti Mat Siyah (Kare)",
    "category": "El Duş Seti",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kirec-kiricili-el-dusu-seti-mat-siyah-kare-4671.png?v=1747806645",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kirec-kiricili-el-dusu-seti-mat-siyah-kare-4671.png?v=1747806645"
    ],
    "price": "2430.00",
    "sku": "DS.SH120S",
    "tags": [
      "duş seti",
      "duş setleri",
      "duş ürünleri",
      "el duşu",
      "el duşu seti",
      "Kare",
      "kireç temizleme",
      "masfallı el duşu",
      "Mat Siyah",
      "yaz-20-indirim"
    ],
    "variants": [
      {
        "id": 52843233247529,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.SH120S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2430.00",
        "grams": 0,
        "compare_at_price": "3240.00",
        "position": 1,
        "product_id": 8784942858537,
        "created_at": "2026-03-17T13:01:01+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\">Kullanıcı alışkanlıkları ve yeni trendler dikkate alınarak tasarlanan Creavit duş tamamlayıcıları; ıslak mekanlara yenilikçi yaklaşımıyla konfor alanınızı genişletiyor. Kaliteli malzemelerden üretilen El Duşları; en sert su koşullarına bile dayanarak uzun yıllar boyunca sorunsuz performans sunar. Su çıkış başlığında bulunan silikon nozullar kireç birikimini engelleyerek temiz, güçlü bir su akışı sağlar. Ayrıca esnek mafsal tasarımı sayesinde duş başlığını istediğiniz açıya rahatlıkla ayarlayarak su akışını kişiselleştirebilir, kolay montaj özelliği ile de mevcut duş sisteminize kolaylıkla entegre edebilirsiniz.</p>"
  },
  {
    "id": "creavit-8784942727465",
    "brand": "Creavit",
    "title": "Kireç Kırıcılı El Duşu Seti (Yuvarlak)",
    "category": "El Duş Seti",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kirec-kiricili-el-dusu-seti-yuvarlak-4670.png?v=1747806648",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kirec-kiricili-el-dusu-seti-yuvarlak-4670.png?v=1747806648"
    ],
    "price": "2430.00",
    "sku": "DS.SH121",
    "tags": [
      "duş seti",
      "duş setleri",
      "duş ürünleri",
      "el duşu",
      "el duşu seti",
      "Krom",
      "yaz-20-indirim",
      "Yuvarlak"
    ],
    "variants": [
      {
        "id": 52920970117417,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.SH121",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2430.00",
        "grams": 0,
        "compare_at_price": "3240.00",
        "position": 1,
        "product_id": 8784942727465,
        "created_at": "2026-04-03T12:16:34+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\">Kullanıcı alışkanlıkları ve yeni trendler dikkate alınarak tasarlanan Creavit duş tamamlayıcıları; ıslak mekanlara yenilikçi yaklaşımıyla konfor alanınızı genişletiyor. Kaliteli malzemelerden üretilen El Duşları; en sert su koşullarına bile dayanarak uzun yıllar boyunca sorunsuz performans sunar. Su çıkış başlığında bulunan silikon nozullar kireç birikimini engelleyerek temiz, güçlü bir su akışı sağlar. Ayrıca esnek mafsal tasarımı sayesinde duş başlığını istediğiniz açıya rahatlıkla ayarlayarak su akışını kişiselleştirebilir, kolay montaj özelliği ile de mevcut duş sisteminize kolaylıkla entegre edebilirsiniz.</p>"
  },
  {
    "id": "creavit-8784942596393",
    "brand": "Creavit",
    "title": "Sürgülü El Duş Seti 3F Oval",
    "category": "Duş Setleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/surgulu-el-dus-seti-3f-oval-4669.png?v=1747224430",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/surgulu-el-dus-seti-3f-oval-4669.png?v=1747224430"
    ],
    "price": "3870.00",
    "sku": "DS.SH463",
    "tags": [
      "duş seti",
      "duş setleri",
      "duş ürünleri",
      "el duşu",
      "el duşu seti",
      "Krom",
      "masfallı el duşu",
      "Oval",
      "sürgülü duş seti",
      "yaz-20-indirim"
    ],
    "variants": [
      {
        "id": 52843219124521,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.SH463",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3870.00",
        "grams": 0,
        "compare_at_price": "5160.00",
        "position": 1,
        "product_id": 8784942596393,
        "created_at": "2026-03-17T12:55:51+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p data-mce-fragment=\"1\"><strong>Sürgülü Tasarım: </strong>Sürgülü tasarımı sayesinde el duşunu istediğiniz yüksekliğe ayarlayarak daha rahat ve konforlu kullanım sağlar.</p>\r\n<p data-mce-fragment=\"1\"><span><strong>Kolay Fonksiyon Değişimi:</strong> Creavit sürgülü duşun fonksiyonlarını tek bir dokunuşla su akışını farklı modlara geçirebilir banyo deneyiminizi çeşitlendirebilirsiniz.</span></p>\r\n<p data-mce-fragment=\"1\"><strong>Dayanıklılık ve Kalite: </strong>Krom kaplamalı pirinç malzemeden üretilen Creavit sürgülü duş sistemleri en sert su koşullarına bile dayanıklılık sağlayarak uzun yıllar boyunca sorunsuz performans sunar.</p>\n</div>"
  },
  {
    "id": "creavit-8784942432553",
    "brand": "Creavit",
    "title": "Kireç Kırıcılı El Duşu Seti (Kare)",
    "category": "El Duş Seti",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kirec-kiricili-el-dusu-seti-kare-4668.png?v=1747806651",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kirec-kiricili-el-dusu-seti-kare-4668.png?v=1747806651"
    ],
    "price": "2340.00",
    "sku": "DS.SH120",
    "tags": [
      "duş seti",
      "duş setleri",
      "duş ürünleri",
      "el duşu",
      "el duşu seti",
      "Kare",
      "kireç temizleme",
      "Krom",
      "masfallı el duşu",
      "yaz-20-indirim"
    ],
    "variants": [
      {
        "id": 52921483395369,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.SH120",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2340.00",
        "grams": 0,
        "compare_at_price": "3120.00",
        "position": 1,
        "product_id": 8784942432553,
        "created_at": "2026-04-03T14:44:15+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\">Kullanıcı alışkanlıkları ve yeni trendler dikkate alınarak tasarlanan Creavit duş tamamlayıcıları; ıslak mekanlara yenilikçi yaklaşımıyla konfor alanınızı genişletiyor. Kaliteli malzemelerden üretilen El Duşları; en sert su koşullarına bile dayanarak uzun yıllar boyunca sorunsuz performans sunar. Su çıkış başlığında bulunan silikon nozullar kireç birikimini engelleyerek temiz, güçlü bir su akışı sağlar. Ayrıca esnek mafsal tasarımı sayesinde duş başlığını istediğiniz açıya rahatlıkla ayarlayarak su akışını kişiselleştirebilir, kolay montaj özelliği ile de mevcut duş sisteminize kolaylıkla entegre edebilirsiniz.</p>"
  },
  {
    "id": "creavit-8784942006569",
    "brand": "Creavit",
    "title": "Sürgülü El Duş Seti 1F Kare",
    "category": "Duş Setleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/surgulu-el-dus-seti-1f-kare-4667.png?v=1747224423",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/surgulu-el-dus-seti-1f-kare-4667.png?v=1747224423"
    ],
    "price": "3735.00",
    "sku": "DS.SH453",
    "tags": [
      "duş seti",
      "duş setleri",
      "duş ürünleri",
      "el duşu",
      "el duşu seti",
      "Kare",
      "Krom",
      "masfallı el duşu",
      "sürgülü duş seti",
      "yaz-20-indirim"
    ],
    "variants": [
      {
        "id": 52920454938921,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.SH453",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3735.00",
        "grams": 0,
        "compare_at_price": "4980.00",
        "position": 1,
        "product_id": 8784942006569,
        "created_at": "2026-04-03T10:07:14+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p data-mce-fragment=\"1\"><strong>Sürgülü Tasarım: </strong>Sürgülü tasarımı sayesinde el duşunu istediğiniz yüksekliğe ayarlayarak daha rahat ve konforlu kullanım sağlar.</p>\r\n<p data-mce-fragment=\"1\"><strong>Dayanıklılık ve Kalite: </strong>Krom kaplamalı pirinç malzemeden üretilen Creavit sürgülü duş sistemleri en sert su koşullarına bile dayanıklılık sağlayarak uzun yıllar boyunca sorunsuz performans sunar.</p>\n</div>"
  },
  {
    "id": "creavit-8784941908265",
    "brand": "Creavit",
    "title": "Aria 5 Fonksiyonlu Sürgülü El Duş Seti",
    "category": "Duş Setleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/aria-5-fonksiyonlu-surgulu-el-dus-seti-4666.png?v=1747234878",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/aria-5-fonksiyonlu-surgulu-el-dus-seti-4666.png?v=1747234878"
    ],
    "price": "3150.00",
    "sku": "DS.SH425",
    "tags": [
      "duş seti",
      "duş setleri",
      "duş ürünleri",
      "el duşu",
      "el duşu seti",
      "Krom",
      "sürgülü duş seti",
      "yaz-20-indirim"
    ],
    "variants": [
      {
        "id": 52851600720169,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.SH425",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3150.00",
        "grams": 0,
        "compare_at_price": "4200.00",
        "position": 1,
        "product_id": 8784941908265,
        "created_at": "2026-03-19T13:05:16+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div data-mce-fragment=\"1\" class=\"markdown prose w-full break-words dark:prose-invert light\">\n<p data-mce-fragment=\"1\">Creavit Aria 5 Fonksiyonlu Sürgülü El Duş Seti farklı su akış seçenekleri ve sürgülü tasarımı ile banyo deneyiminizi kişiselleştirmek üzere tasarlandı. <span data-mce-fragment=\"1\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"><span data-mce-fragment=\"1\">Aria </span>el duş seti, beş farklı su akış seçeneği sunar. Yağmur etkisi, masaj, su tasarrufu, geniş su akışı ve hava karışımı gibi farklı modlar arasından istediğinizi seçerek banyo deneyiminizi özelleştirin. El Duş Seti, dayanıklı malzemelerden üretilir ve uzun ömürlü kullanım sunar. </span></p>\n<br>\n</div>\n<div data-mce-fragment=\"1\" class=\"markdown prose w-full break-words dark:prose-invert light\"><br></div>"
  },
  {
    "id": "creavit-8784941351209",
    "brand": "Creavit",
    "title": "Mafsallı El Duş Seti 3F",
    "category": "El Duş Seti",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mafsalli-el-dus-seti-3f-4664.png?v=1747224417",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mafsalli-el-dus-seti-3f-4664.png?v=1747224417"
    ],
    "price": "856.80",
    "sku": "DS.SH115",
    "tags": [
      "duş seti",
      "duş setleri",
      "duş ürünleri",
      "el duşu",
      "el duşu seti",
      "Krom",
      "masfallı el duşu",
      "yaz-20-indirim"
    ],
    "variants": [
      {
        "id": 52836668342569,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "DS.SH115",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "856.80",
        "grams": 0,
        "compare_at_price": "1428.00",
        "position": 1,
        "product_id": 8784941351209,
        "created_at": "2026-03-15T21:12:43+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\">Kullanıcı alışkanlıkları ve yeni trendler dikkate alınarak tasarlanan duş tamamlayıcıları ile Creavit; ıslak mekanlara yenilikçi yaklaşımıyla konfor alanınızı genişletiyor. Kaliteli malzemelerden üretilen El Duş Setleri; en sert su koşullarına bile dayanarak uzun yıllar boyunca sorunsuz performans sunar. Ayrıca Esnek mafsal tasarımı sayesinde duş başlığını istediğiniz açıya rahatlıkla ayarlayarak su akışını kişiselleştirebilir, kolay montaj özelliği ile de mevcut duş sisteminize kolaylıkla entegre edebilirsiniz.</p>"
  },
  {
    "id": "creavit-8760429740329",
    "brand": "Creavit",
    "title": "Gömme Rezervuar 3/6 Tuvalet Taşı Uyumlu",
    "category": "Gömme Rezervuarlar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gomme-rezervuar-3-6-tuvalet-tasi-uyumlu-4659.png?v=1747224400",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gomme-rezervuar-3-6-tuvalet-tasi-uyumlu-4659.png?v=1747224400",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gomme-rezervuar-3-6-tuvalet-tasi-uyumlu-4660.jpg?v=1747224402",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gomme-rezervuar-3-6-tuvalet-tasi-uyumlu-4661.jpg?v=1747224405",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gomme-rezervuar-3-6-tuvalet-tasi-uyumlu-4662.jpg?v=1747224407",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gomme-rezervuar-3-6-tuvalet-tasi-uyumlu-4663.jpg?v=1747224410"
    ],
    "price": "4746.00",
    "sku": "GR5006",
    "tags": [
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Rezervuar",
      "Rezervuarlar",
      "Tuvalet Taşı",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52843205722409,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GR5006",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "4746.00",
        "grams": 0,
        "compare_at_price": "6780.00",
        "position": 1,
        "product_id": 8760429740329,
        "created_at": "2026-03-17T12:52:40+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit GR5006 Gömme Rezervuar, modern banyolar için tasarlanmış, Tuvalet Taşı Uyumlu 3/6 litre çift kademeli su tasarruflu deşarj sistemine sahip, dayanıklı ve şık bir gömme rezervuar modelidir. İnce yapısı ve yüksek taşıma kapasitesi ile hem estetik hem fonksiyonel çözümler sunar.</p>\n<hr>\n<h3>🛠️ Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> GR5006</li>\n<li>\n<strong>Kullanım Tipi:</strong> Çift kademeli (3/6 litre) su tasarruflu deşarj sistemi</li>\n<li>\n<strong>Kalınlık:</strong> Yaklaşık 8 cm (ince gövde)</li>\n<li>\n<strong>Montaj Tipi:</strong> Tuğla, gazbeton veya BİMS duvar içi uygulama</li>\n<li>\n<strong>Garanti Süresi:</strong> 10 yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit çift basmalı kumanda panelleriyle uyumludur (butonlar ayrı satılır)</li>\n<li>\n<strong>Ek Özellikler:</strong> Sessiz çalışma, metal ayaklı montaj sistemi</li>\n</ul>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>GR5006 Gömme Rezervuar Gövdesi</li>\n<li>Montaj için gerekli bağlantı elemanları</li>\n<li>Kullanım ve montaj kılavuzu</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>İnce ve dayanıklı tasarım, banyoda yer tasarrufu sağlar.</li>\n<li>Ürün Tuvalet Taşı Uyumludur.</li>\n<li>Sessiz çalışma sistemi ile konforlu kullanım sağlar.</li>\n<li>Kolay montaj imkanıyla hızlı ve pratik kurulum sağlar.</li>\n</ul>"
  },
  {
    "id": "creavit-8760429707561",
    "brand": "Creavit",
    "title": "Gömme Rezervuar 3/6 Asma Klozet Uyumlu Yere Hızlı Montaj",
    "category": "Gömme Rezervuarlar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gomme-rezervuar-3-6-asma-klozet-uyumlu-yere-hizli-montaj-4653.png?v=1747224378",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gomme-rezervuar-3-6-asma-klozet-uyumlu-yere-hizli-montaj-4653.png?v=1747224378",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gomme-rezervuar-3-6-asma-klozet-uyumlu-yere-hizli-montaj-4654.jpg?v=1747224381",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gomme-rezervuar-3-6-asma-klozet-uyumlu-yere-hizli-montaj-4655.jpg?v=1747224383",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gomme-rezervuar-3-6-asma-klozet-uyumlu-yere-hizli-montaj-4656.jpg?v=1747224386",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gomme-rezervuar-3-6-asma-klozet-uyumlu-yere-hizli-montaj-4657.jpg?v=1747224388",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gomme-rezervuar-3-6-asma-klozet-uyumlu-yere-hizli-montaj-4658.jpg?v=1747224391"
    ],
    "price": "10080.00",
    "sku": "GR5004",
    "tags": [
      "Fotoselli Gömme Rezervuar",
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Rezervuar",
      "Rezervuarlar",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52843233607977,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GR5004",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "10080.00",
        "grams": 0,
        "compare_at_price": "14400.00",
        "position": 1,
        "product_id": 8760429707561,
        "created_at": "2026-03-17T13:01:08+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit GR5004 Gömme Rezervuar, asma klozetler için tasarlanmış, 3/6 litre çift kademeli su tasarruflu deşarj sistemine sahip, dayanıklı ve estetik gömme rezervuar modelidir. Modern banyolar için ince yapısı ve yüksek performansıyla ideal bir çözümdür.</p>\n<hr>\n<h3>🛠️ Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> GR5004</li>\n<li>\n<strong>Kullanım Tipi:</strong> Çift kademeli (3/6 litre) su tasarruflu deşarj sistemi</li>\n<li>\n<strong>Kalınlık:</strong> Yaklaşık 8 cm (ince gövde)</li>\n<li>\n<strong>Montaj Tipi:</strong> Tuğla, gazbeton veya BİMS duvar içi uygulama</li>\n<li>\n<strong>Taşıma Kapasitesi:</strong> 400 kg</li>\n<li>\n<strong>Garanti Süresi:</strong> 10 yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit çift basmalı kumanda panelleriyle uyumludur (butonlar ayrı satılır)</li>\n<li>\n<strong>Ek Özellikler:</strong> Sessiz çalışma, metal ayaklı montaj sistemi</li>\n</ul>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>GR5004 Gömme Rezervuar Gövdesi</li>\n<li>Montaj için gerekli bağlantı elemanları</li>\n<li>Kullanım ve montaj kılavuzu</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>İnce ve dayanıklı tasarım, banyoda yer tasarrufu sağlar.</li>\n<li>400 kg taşıma kapasitesi ile güvenli kullanım sunar.</li>\n<li>Sessiz çalışma sistemi ile konforlu kullanım sağlar.</li>\n<li>Kolay montaj imkanıyla hızlı ve pratik kurulum sağlar.</li>\n</ul>"
  },
  {
    "id": "creavit-8760429674793",
    "brand": "Creavit",
    "title": "Gömme Rezervuar 3/6 Asma Klozet Duvar Önü Hızlı Montaj",
    "category": "Gömme Rezervuarlar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gomme-rezervuar-3-6-asma-klozet-duvar-onu-hizli-montaj-4647.png?v=1747224356",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gomme-rezervuar-3-6-asma-klozet-duvar-onu-hizli-montaj-4647.png?v=1747224356",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gomme-rezervuar-3-6-asma-klozet-duvar-onu-hizli-montaj-4648.jpg?v=1747224358",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gomme-rezervuar-3-6-asma-klozet-duvar-onu-hizli-montaj-4649.jpg?v=1747224361",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gomme-rezervuar-3-6-asma-klozet-duvar-onu-hizli-montaj-4650.jpg?v=1747224364",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gomme-rezervuar-3-6-asma-klozet-duvar-onu-hizli-montaj-4651.jpg?v=1747224366",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gomme-rezervuar-3-6-asma-klozet-duvar-onu-hizli-montaj-4652.jpg?v=1747224369"
    ],
    "price": "8820.00",
    "sku": "GR5003",
    "tags": [
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Rezervuar",
      "Rezervuarlar",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52843233083689,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GR5003",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8820.00",
        "grams": 0,
        "compare_at_price": "12600.00",
        "position": 1,
        "product_id": 8760429674793,
        "created_at": "2026-03-17T13:00:58+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit GR5003 Gömme Rezervuar, asma klozetler için özel olarak tasarlanmış, 3/6 litre çift kademeli su tasarruflu deşarj sistemine sahip, dayanıklı ve fonksiyonel bir çözümdür. Modern banyolar için ince ve estetik yapısıyla yer tasarrufu sağlar.</p>\n<hr>\n<h3>🛠️ Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> GR5003</li>\n<li>\n<strong>Kullanım Tipi:</strong> Çift kademeli (3/6 litre) su tasarruflu deşarj sistemi</li>\n<li>\n<strong>Kalınlık:</strong> Yaklaşık 8 cm (ince gövde)</li>\n<li>\n<strong>Montaj Tipi:</strong> Tuğla, gazbeton veya BİMS duvar içi uygulama</li>\n<li>\n<strong>Taşıma Kapasitesi:</strong> 400 kg</li>\n<li>\n<strong>Garanti Süresi:</strong> 10 yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit çift basmalı kumanda panelleriyle uyumludur (butonlar ayrı satılır)</li>\n<li>\n<strong>Ek Özellikler:</strong> Sessiz çalışma, metal ayaklı montaj sistemi</li>\n</ul>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>GR5003 Gömme Rezervuar Gövdesi</li>\n<li>Montaj için gerekli bağlantı elemanları</li>\n<li>Kullanım ve montaj kılavuzu</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>İnce ve dayanıklı tasarım, banyoda yer tasarrufu sağlar.</li>\n<li>400 kg taşıma kapasitesi ile güvenli kullanım sunar.</li>\n<li>Sessiz çalışma sistemi ile konforlu kullanım sağlar.</li>\n<li>Kolay montaj imkanıyla hızlı ve pratik kurulum sağlar.</li>\n</ul>"
  },
  {
    "id": "creavit-8760429642025",
    "brand": "Creavit",
    "title": "Gömme Rezervuar 3/6 Asma Klozet Uyumlu Metal Ayaklı",
    "category": "Gömme Rezervuarlar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gomme-rezervuar-3-6-asma-klozet-uyumlu-metal-ayakli-4641.png?v=1747730672",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gomme-rezervuar-3-6-asma-klozet-uyumlu-metal-ayakli-4641.png?v=1747730672",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gomme-rezervuar-3-6-asma-klozet-uyumlu-metal-ayakli-4642.jpg?v=1747730672",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gomme-rezervuar-3-6-asma-klozet-uyumlu-metal-ayakli-4643.jpg?v=1747730672",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gomme-rezervuar-3-6-asma-klozet-uyumlu-metal-ayakli-4644.jpg?v=1747730672",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gomme-rezervuar-3-6-asma-klozet-uyumlu-metal-ayakli-4645.jpg?v=1747730672",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/gomme-rezervuar-3-6-asma-klozet-uyumlu-metal-ayakli-4646.jpg?v=1747224346"
    ],
    "price": "5670.00",
    "sku": "GR5001",
    "tags": [
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Rezervuar",
      "Rezervuarlar",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52843269095721,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GR5001",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5670.00",
        "grams": 0,
        "compare_at_price": "8100.00",
        "position": 1,
        "product_id": 8760429642025,
        "created_at": "2026-03-17T13:12:28+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit'in asma klozetler için geliştirdiği, 3/6 litre çift kademeli deşarj sistemine sahip, metal ayaklı ve ince tasarımlı gömme rezervuar modeli. Modern banyolar için estetik ve fonksiyonel bir çözümdür.</p>\n<hr>\n<h3>🛠️ Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> GR5001</li>\n<li>\n<strong>Kullanım Tipi:</strong> Çift kademeli (3/6 litre) su tasarruflu deşarj sistemi</li>\n<li>\n<strong>Kalınlık:</strong> 8 cm (ince gövde)</li>\n<li>\n<strong>Montaj Tipi:</strong> Tuğla, gazbeton veya BİMS duvar içi uygulama</li>\n<li>\n<strong>Taşıma Kapasitesi:</strong> 400 kg</li>\n<li>\n<strong>Garanti Süresi:</strong> 10 yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit çift basmalı kumanda panelleriyle uyumludur (butonlar ayrıca satılır)</li>\n<li>\n<strong>Ek Özellikler:</strong> Sessiz çalışma, metal ayaklı yapı, önden basmalı tasarım</li>\n</ul>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>GR5001 Gömme Rezervuar Gövdesi</li>\n<li>Montaj için gerekli bağlantı elemanları</li>\n<li>Kullanım ve montaj kılavuzu</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>İnce ve Şık Tasarım: 8 cm kalınlığındaki gövdesiyle banyolarda yer tasarrufu sağlar.</li>\n<li>Yüksek Taşıma Kapasitesi: 400 kg taşıma kapasitesiyle güvenli kullanım sunar.</li>\n<li>Sessiz Çalışma: Özel doldurma tekniği sayesinde sessiz bir kullanım deneyimi sağlar.</li>\n<li>Kolay Montaj: Tuğla, gazbeton veya BİMS duvar tiplerine uygulanabilir.</li>\n</ul>"
  },
  {
    "id": "creavit-8760429609257",
    "brand": "Creavit",
    "title": "Terra Parlak Krom Kaplama Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-parlak-krom-kaplama-kumanda-paneli-4633.png?v=1747224306",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-parlak-krom-kaplama-kumanda-paneli-4633.png?v=1747224306",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-parlak-krom-kaplama-kumanda-paneli-4634.jpg?v=1747224309",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-parlak-krom-kaplama-kumanda-paneli-4635.jpg?v=1747224311",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-parlak-krom-kaplama-kumanda-paneli-4636.jpg?v=1747224314",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-parlak-krom-kaplama-kumanda-paneli-4637.jpg?v=1747224316",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-parlak-krom-kaplama-kumanda-paneli-4638.jpg?v=1747224319",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-parlak-krom-kaplama-kumanda-paneli-4639.jpg?v=1747224321",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-parlak-krom-kaplama-kumanda-paneli-4640.jpg?v=1747224323"
    ],
    "price": "2352.00",
    "sku": "GP9004.00",
    "tags": [
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "Parlak Krom",
      "Rezervuar",
      "Rezervuarlar",
      "Terra",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52920969986345,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP9004.00",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2352.00",
        "grams": 0,
        "compare_at_price": "3360.00",
        "position": 1,
        "product_id": 8760429609257,
        "created_at": "2026-04-03T12:16:31+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"product-description\">\n<p><strong>Creavit GP9004.00 Terra Parlak Krom Kaplama Kumanda Paneli</strong>, Terra serisinin parlak krom kaplama şıklığını modern banyolarınıza taşıyan gömme rezervuar kumanda panelidir. Estetik tasarımı ve dayanıklı yapısıyla banyonuza zarafet ve fonksiyonellik kazandırır.</p>\n<hr>\n<h3>🛠️ Ürün Özellikleri</h3>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> GP9004.00</li>\n<li>\n<strong>Seri:</strong> Terra</li>\n<li>\n<strong>Renk:</strong> Parlak Krom</li>\n<li>\n<strong>Malzeme:</strong> ABS plastik ve krom kaplama</li>\n<li>\n<strong>Boyutlar:</strong> 246 x 163 x 13 mm (Genişlik x Yükseklik x Derinlik)</li>\n<li>\n<strong>Çalışma Prensibi:</strong> Çift kademeli manuel deşarj sistemi</li>\n<li>\n<strong>Montaj:</strong> Duvar üzerine kolay montaj</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit gömme rezervuar sistemleriyle uyumludur</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>Parlak krom kaplama yüzeyi banyonuza modern ve şık bir görünüm kazandırır.</li>\n<li>Çift kademeli manuel deşarj sistemi ile pratik kullanım sağlar.</li>\n<li>ABS plastik ve krom kaplama malzeme dayanıklı ve uzun ömürlüdür.</li>\n<li>Kolay montaj imkanı sayesinde hızlı kurulum sunar.</li>\n</ul>\n<h3>🧼 Temizlik ve Bakım</h3>\n<p>Parlak krom kaplama yüzey leke tutmaz ve kolay temizlenir. Nemli bez ile düzenli silinmesi ürünün parlaklığını korur.</p>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>1 adet Terra Parlak Krom Kaplama Kumanda Paneli (GP9004.00)</li>\n<li>Montaj için gerekli bağlantı elemanları</li>\n<li>Kullanım ve montaj kılavuzu</li>\n</ul>\n<p><strong>Creavit GP9004.00 Terra Parlak Krom Kaplama Kumanda Paneli</strong>, estetik ve fonksiyonelliği bir arada sunarak modern banyolarınız için ideal bir seçimdir.</p>\n</div>"
  },
  {
    "id": "creavit-8760429576489",
    "brand": "Creavit",
    "title": "Terra Mat Cappucino Boyalı Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-cappucino-boyali-kumanda-paneli-4625.png?v=1747233046",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-cappucino-boyali-kumanda-paneli-4625.png?v=1747233046",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-cappucino-boyali-kumanda-paneli-4626.jpg?v=1747233049",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-cappucino-boyali-kumanda-paneli-4627.jpg?v=1747233052",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-cappucino-boyali-kumanda-paneli-4628.jpg?v=1747233055",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-cappucino-boyali-kumanda-paneli-4629.jpg?v=1747233057",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-cappucino-boyali-kumanda-paneli-4630.jpg?v=1747233060",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-cappucino-boyali-kumanda-paneli-4631.jpg?v=1747233062",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-cappucino-boyali-kumanda-paneli-4632.jpg?v=1747233065"
    ],
    "price": "2016.00",
    "sku": "GP9002.06",
    "tags": [
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "Mat Cappuccino",
      "Rezervuar",
      "Rezervuarlar",
      "Terra",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52843205394729,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP9002.06",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2016.00",
        "grams": 0,
        "compare_at_price": "2880.00",
        "position": 1,
        "product_id": 8760429576489,
        "created_at": "2026-03-17T12:52:34+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"product-description\">\n<p><strong>Creavit GP9002.06 Terra Mat Cappucino Kumanda Paneli</strong>, Terra serisinin modern ve şık tasarımıyla banyonuza zarafet katan mat cappucino renkli bir gömme rezervuar kumanda panelidir. Creavit gömme rezervuar sistemleri ile uyumlu olarak tasarlanmış olup, fonksiyonellik ve estetiği bir arada sunar.</p>\n<hr>\n<h3>🛠️ Ürün Özellikleri</h3>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> GP9002.06</li>\n<li>\n<strong>Seri:</strong> Terra</li>\n<li>\n<strong>Renk:</strong> Mat Cappucino</li>\n<li>\n<strong>Malzeme:</strong> ABS plastik ve krom kaplama</li>\n<li>\n<strong>Boyutlar:</strong> 246 x 163 x 13 mm (Genişlik x Yükseklik x Derinlik)</li>\n<li>\n<strong>Çalışma Prensibi:</strong> Çift kademeli manuel deşarj sistemi</li>\n<li>\n<strong>Montaj:</strong> Duvar üzerine kolay montaj</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit gömme rezervuar sistemleriyle uyumludur</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>Mat cappucino rengi ile banyonuza sıcak ve modern bir görünüm kazandırır.</li>\n<li>Çift kademeli manuel deşarj sistemi sayesinde su tasarrufu sağlar.</li>\n<li>Dayanıklı ABS plastik ve krom kaplama malzeme ile uzun ömürlü kullanım.</li>\n<li>Kolay ve hızlı duvar montajı ile pratik kurulum imkanı.</li>\n</ul>\n<h3>🧼 Temizlik ve Bakım</h3>\n<p>Mat cappucino kaplama yüzeyi leke tutmaz ve kolay temizlenir. Nemli bez ile düzenli temizleme ürünü uzun süre yeni gibi tutar.</p>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>1 adet Terra Mat Cappucino Kumanda Paneli (GP9002.06)</li>\n<li>Montaj için gerekli bağlantı elemanları</li>\n<li>Kullanım ve montaj kılavuzu</li>\n</ul>\n<p><strong>Creavit GP9002.06 Terra Mat Cappucino Kumanda Paneli</strong>, modern banyolarınız için estetik ve fonksiyonelliği bir arada sunan ideal bir çözümdür.</p>\n</div>"
  },
  {
    "id": "creavit-8760429510953",
    "brand": "Creavit",
    "title": "Terra Mat Antrasit Boyalı Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-antrasit-boyali-kumanda-paneli-4617.png?v=1747233013",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-antrasit-boyali-kumanda-paneli-4617.png?v=1747233013",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-antrasit-boyali-kumanda-paneli-4618.jpg?v=1747233016",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-antrasit-boyali-kumanda-paneli-4619.jpg?v=1747233019",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-antrasit-boyali-kumanda-paneli-4620.jpg?v=1747233021",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-antrasit-boyali-kumanda-paneli-4621.jpg?v=1747233025",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-antrasit-boyali-kumanda-paneli-4622.jpg?v=1747233027",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-antrasit-boyali-kumanda-paneli-4623.jpg?v=1747233031",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-antrasit-boyali-kumanda-paneli-4624.jpg?v=1747233035"
    ],
    "price": "2016.00",
    "sku": "GP9002.04",
    "tags": [
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "Mat Antrasit",
      "Rezervuar",
      "Rezervuarlar",
      "Terra",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52843204608297,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP9002.04",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2016.00",
        "grams": 0,
        "compare_at_price": "2880.00",
        "position": 1,
        "product_id": 8760429510953,
        "created_at": "2026-03-17T12:52:31+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"product-description\">\n<p><strong>Creavit GP9002.04 Terra Mat Antrasit Boyalı Kumanda Paneli</strong>, Terra serisinin sofistike tasarımıyla öne çıkan, mat antrasit renkte zarif ve modern bir gömme rezervuar kumanda panelidir. Gömme rezervuar sistemleri ile uyumlu olan bu panel, banyonuza estetik bir görünüm ve pratik kullanım avantajı sunar.</p>\n<hr>\n<h3>🛠️ Ürün Özellikleri</h3>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> GP9002.04</li>\n<li>\n<strong>Seri:</strong> Terra</li>\n<li>\n<strong>Renk:</strong> Mat Antrasit</li>\n<li>\n<strong>Malzeme:</strong> ABS plastik ve krom kaplama</li>\n<li>\n<strong>Boyutlar:</strong> 246 x 163 x 13 mm (Genişlik x Yükseklik x Derinlik)</li>\n<li>\n<strong>Çalışma Prensibi:</strong> Çift kademeli manuel deşarj sistemi</li>\n<li>\n<strong>Montaj:</strong> Duvar üzerine kolay montaj</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit gömme rezervuar sistemleri ile uyumlu</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>Mat antrasit rengiyle modern ve şık görünüm</li>\n<li>Çift kademeli manuel deşarj sistemi ile su tasarrufu sağlar</li>\n<li>Dayanıklı ABS plastik ve krom kaplama malzeme</li>\n<li>Duvara kolay ve hızlı montaj imkanı</li>\n</ul>\n<h3>🧼 Temizlik ve Bakım</h3>\n<p>Mat antrasit yüzey leke ve parmak izi tutmaz. Temizlik için nemli bir bez ile düzenli olarak silinmesi yeterlidir.</p>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>1 adet Terra Mat Antrasit Boyalı Kumanda Paneli (GP9002.04)</li>\n<li>Montaj için gerekli bağlantı elemanları</li>\n<li>Kullanım ve montaj kılavuzu</li>\n</ul>\n<p><strong>Creavit GP9002.04 Terra Mat Antrasit Boyalı Kumanda Paneli</strong>, fonksiyonelliği ve şıklığı bir arada sunarak banyonuza modern bir dokunuş kazandırır.</p>\n</div>"
  },
  {
    "id": "creavit-8760429478185",
    "brand": "Creavit",
    "title": "Terra Mat Siyah Boyalı Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-siyah-boyali-kumanda-paneli-4609.png?v=1747224279",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-siyah-boyali-kumanda-paneli-4609.png?v=1747224279",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-siyah-boyali-kumanda-paneli-4610.jpg?v=1747224281",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-siyah-boyali-kumanda-paneli-4611.jpg?v=1747224283",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-siyah-boyali-kumanda-paneli-4612.jpg?v=1747224285",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-siyah-boyali-kumanda-paneli-4613.jpg?v=1747224288",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-siyah-boyali-kumanda-paneli-4614.jpg?v=1747224291",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-siyah-boyali-kumanda-paneli-4615.jpg?v=1747224293",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-siyah-boyali-kumanda-paneli-4616.jpg?v=1747224296"
    ],
    "price": "2016.00",
    "sku": "GP9002.01",
    "tags": [
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "Mat Siyah",
      "Rezervuar",
      "Rezervuarlar",
      "Terra",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52871576027433,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP9002.01",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2016.00",
        "grams": 0,
        "compare_at_price": "2880.00",
        "position": 1,
        "product_id": 8760429478185,
        "created_at": "2026-03-24T13:40:22+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"product-description\">\n<p><strong>Creavit GP9002.01 Terra Mat Siyah Boyalı Kumanda Paneli</strong>, modern banyolar için şık ve zarif bir çözüm sunar. Terra serisinin mat siyah rengiyle dikkat çeken bu kumanda paneli, fonksiyonelliği estetikle birleştirerek banyonuzda fark yaratır.</p>\n<hr>\n<h3>🛠️ Ürün Özellikleri</h3>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> GP9002.01</li>\n<li>\n<strong>Seri:</strong> Terra</li>\n<li>\n<strong>Renk:</strong> Mat Siyah</li>\n<li>\n<strong>Malzeme:</strong> ABS plastik ve krom kaplama</li>\n<li>\n<strong>Boyutlar:</strong> 246 x 163 x 13 mm (Genişlik x Yükseklik x Derinlik)</li>\n<li>\n<strong>Çalışma Prensibi:</strong> Çift kademeli manuel deşarj sistemi</li>\n<li>\n<strong>Montaj:</strong> Duvar üzerine kolay montaj</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit gömme rezervuar sistemleri ile uyumlu</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>Mat siyah renk ile modern ve şık görünüm</li>\n<li>Çift kademeli manuel deşarj sistemi ile su tasarrufu sağlar</li>\n<li>ABS plastik ve krom kaplama ile dayanıklı yapı</li>\n<li>Kolay ve hızlı montaj imkanı</li>\n</ul>\n<h3>🧼 Temizlik ve Bakım</h3>\n<p>Mat siyah yüzey, leke tutmaz ve parmak izi bırakmaz. Nemli bir bez ile düzenli silinerek temizliği sağlanabilir.</p>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>1 adet Terra Mat Siyah Boyalı Kumanda Paneli (GP9002.01)</li>\n<li>Montaj için gerekli bağlantı elemanları</li>\n<li>Kullanım ve montaj kılavuzu</li>\n</ul>\n<p><strong>Creavit GP9002.01 Terra Mat Siyah Boyalı Kumanda Paneli</strong>, banyonuza sofistike bir dokunuş katarken fonksiyonel özellikleriyle de kullanım kolaylığı sağlar.</p>\n</div>"
  },
  {
    "id": "creavit-8760429445417",
    "brand": "Creavit",
    "title": "Terra Mat Gri Boyalı Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-gri-boyali-kumanda-paneli-4601.png?v=1747224251",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-gri-boyali-kumanda-paneli-4601.png?v=1747224251",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-gri-boyali-kumanda-paneli-4602.jpg?v=1747224254",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-gri-boyali-kumanda-paneli-4603.jpg?v=1747224256",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-gri-boyali-kumanda-paneli-4604.jpg?v=1747224259",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-gri-boyali-kumanda-paneli-4605.jpg?v=1747224261",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-gri-boyali-kumanda-paneli-4606.jpg?v=1747224264",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-gri-boyali-kumanda-paneli-4607.jpg?v=1747224266",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-mat-gri-boyali-kumanda-paneli-4608.jpg?v=1747224268"
    ],
    "price": "1386.00",
    "sku": "GP9002.00",
    "tags": [
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "mat gri",
      "Rezervuar",
      "Rezervuarlar",
      "Terra",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52843204247849,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP9002.00",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1386.00",
        "grams": 0,
        "compare_at_price": "1980.00",
        "position": 1,
        "product_id": 8760429445417,
        "created_at": "2026-03-17T12:52:28+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"product-description\">\n<p><strong>Creavit GP9002.00 Terra Mat Gri Boyalı Kumanda Paneli</strong>, modern ve sade tasarımı ile banyolara şıklık ve zarafet katar. Terra serisinin mat gri rengi, özellikle modern iç mekanlarla uyum içinde çalışır. Estetik tasarımıyla birlikte, fonksiyonel kullanım avantajları sunar. <meta charset=\"utf-8\">Çift kademeli manuel deşarj sistemi ile su tasarrufu sağlar. ABS plastik ve krom kaplama ile dayanıklılık ve uzun ömür.</p>\n<hr>\n<h3>🛠️ Ürün Özellikleri<strong></strong>\n</h3>\n<ul>\n<li>\n<strong>Malzeme:</strong> ABS plastik ve krom kaplama</li>\n<li>\n<strong>Boyutlar:</strong> 246 x 163 x 13 mm (G x Y x D)</li>\n<li>\n<strong>Çalışma Prensibi:</strong> Çift kademeli manuel deşarj sistemi</li>\n<li>\n<strong>Montaj:</strong> Duvar üzerine kolay montaj</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit gömme rezervuar sistemleriyle uyumlu</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n</ul>\n<h3>🧼 Temizlik ve Bakım</h3>\n<p>Mat gri kaplama yüzey, leke ve parmak izi tutmaz. Nemli, yumuşak bir bez ile silinerek kolayca temizlenebilir.</p>\n<p><strong>Creavit GP9002.00 Terra Mat Gri Boyalı Kumanda Paneli</strong>, estetik görünüm ve pratik kullanım özellikleri ile modern banyolar için ideal bir tercihtir.</p>\n</div>"
  },
  {
    "id": "creavit-8760429412649",
    "brand": "Creavit",
    "title": "Terra Beyaz Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-beyaz-kumanda-paneli-4593.png?v=1747234851",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-beyaz-kumanda-paneli-4593.png?v=1747234851",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-beyaz-kumanda-paneli-4594.jpg?v=1747234854",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-beyaz-kumanda-paneli-4595.jpg?v=1747234857",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-beyaz-kumanda-paneli-4596.jpg?v=1747234860",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-beyaz-kumanda-paneli-4597.jpg?v=1747234862",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-beyaz-kumanda-paneli-4598.jpg?v=1747234865",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-beyaz-kumanda-paneli-4599.jpg?v=1747234868",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/terra-beyaz-kumanda-paneli-4600.jpg?v=1747234870"
    ],
    "price": "1050.00",
    "sku": "GP9001.00",
    "tags": [
      "Beyaz",
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "Rezervuar",
      "Rezervuarlar",
      "Terra",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52921483198761,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP9001.00",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "1050.00",
        "grams": 0,
        "compare_at_price": "1500.00",
        "position": 1,
        "product_id": 8760429412649,
        "created_at": "2026-04-03T14:44:11+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"product-description\">\n<p><strong>Creavit GP9001.00 Terra Beyaz Kumanda Paneli</strong>, sade ve modern tasarımıyla banyolarınıza zarif bir görünüm kazandırır. Terra serisine ait bu panel, fonksiyonel yapısıyla birlikte estetik beklentilerinizi de karşılar. Beyaz rengiyle temiz ve ferah bir atmosfer sunar. <meta charset=\"utf-8\">Çift kademeli manuel deşarj sistemi ile su tasarrufu sağlar. <meta charset=\"utf-8\">Kaliteli ABS malzeme ve krom kaplama ile uzun ömürlü kullanım.</p>\n<hr>\n<h3>🛠️ Ürün Özellikleri<strong></strong>\n</h3>\n<ul>\n<li>\n<strong>Malzeme:</strong> ABS plastik ve krom kaplama</li>\n<li>\n<strong>Boyutlar:</strong> 246 x 163 x 13 mm (G x Y x D)</li>\n<li>\n<strong>Çalışma Prensibi:</strong> Çift kademeli manuel deşarj sistemi</li>\n<li>\n<strong>Montaj:</strong> Duvar üzerine kolay montaj</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit gömme rezervuar sistemleriyle uyumlu</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n</ul>\n<h3>🧼 Temizlik ve Bakım</h3>\n<p>Beyaz yüzeyi leke tutmaz ve kolay temizlenir. Yumuşak, nemli bir bezle düzenli temizlik yapılması ürünün ilk günkü görünümünü korumasına yardımcı olur.</p>\n<p><strong>Creavit GP9001.00 Terra Beyaz Kumanda Paneli</strong>, fonksiyonellik ve zarafeti bir araya getirerek banyolarınızda modern ve temiz bir görünüm yaratır.</p>\n</div>"
  },
  {
    "id": "creavit-8760429379881",
    "brand": "Creavit",
    "title": "Arc Parlak Krom Kaplama Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-parlak-krom-kaplama-kumanda-paneli-4585.png?v=1747232981",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-parlak-krom-kaplama-kumanda-paneli-4585.png?v=1747232981",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-parlak-krom-kaplama-kumanda-paneli-4586.jpg?v=1747232984",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-parlak-krom-kaplama-kumanda-paneli-4587.jpg?v=1747232987",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-parlak-krom-kaplama-kumanda-paneli-4588.jpg?v=1747232989",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-parlak-krom-kaplama-kumanda-paneli-4589.jpg?v=1747232993",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-parlak-krom-kaplama-kumanda-paneli-4590.jpg?v=1747232996",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-parlak-krom-kaplama-kumanda-paneli-4591.jpg?v=1747232999",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-parlak-krom-kaplama-kumanda-paneli-4592.jpg?v=1747233002"
    ],
    "price": "2352.00",
    "sku": "GP8004.00",
    "tags": [
      "Arc",
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "Parlak Krom",
      "Rezervuar",
      "Rezervuarlar",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52920969855273,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP8004.00",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2352.00",
        "grams": 0,
        "compare_at_price": "3360.00",
        "position": 1,
        "product_id": 8760429379881,
        "created_at": "2026-04-03T12:16:27+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit GP8004.00 Arc Parlak Krom Kaplama Kumanda Paneli, Arc serisinin modern çizgilerini göz alıcı parlak krom yüzeyle buluşturarak banyonuza şıklık katar. Işıltılı görünümüyle özellikle modern ve lüks banyo tasarımları için ideal bir tercihtir.</p>\n<hr>\n<h3>🛠️ Ürün Özellikleri</h3>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> GP8004.00</li>\n<li>\n<strong>Seri:</strong> Arc</li>\n<li>\n<strong>Renk:</strong> Parlak Krom</li>\n<li>\n<strong>Malzeme:</strong> ABS plastik ve krom kaplama</li>\n<li>\n<strong>Boyutlar:</strong> 246 x 163 x 13 mm (Genişlik x Yükseklik x Derinlik)</li>\n<li>\n<strong>Çalışma Prensibi:</strong> Çift kademeli manuel deşarj sistemi</li>\n<li>\n<strong>Montaj:</strong> Duvar üzerine kolay montaj</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit gömme rezervuar sistemleriyle uyumlu</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>Parlak krom kaplamasıyla modern ve lüks bir görünüm</li>\n<li>Arc serisinin zarif tasarımı ile uyumlu</li>\n<li>Çift kademeli manuel deşarj sistemi sayesinde su tasarrufu sağlar</li>\n<li>ABS plastik gövde ve dayanıklı kaplama ile uzun ömürlü kullanım</li>\n<li>Kolay montaj özelliği ile zahmetsiz kurulum</li>\n</ul>\n<hr>\n<h3>🧼 Temizlik ve Bakım</h3>\n<p>Parlak krom yüzeyi sayesinde kolay temizlenir ve leke tutmaz. Yüzeyin parlaklığını korumak için nemli yumuşak bir bezle silinmesi yeterlidir.</p>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>1 adet Arc Parlak Krom Kaplama Kumanda Paneli (GP8004.00)</li>\n<li>Montaj için gerekli bağlantı elemanları</li>\n<li>Kullanım ve montaj kılavuzu</li>\n</ul>"
  },
  {
    "id": "creavit-8760429347113",
    "brand": "Creavit",
    "title": "Arc Mat Cappucino Boyalı Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-cappucino-boyali-kumanda-paneli-4577.jpg?v=1747232951",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-cappucino-boyali-kumanda-paneli-4577.jpg?v=1747232951",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-cappucino-boyali-kumanda-paneli-4578.jpg?v=1747232954",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-cappucino-boyali-kumanda-paneli-4579.jpg?v=1747232957",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-cappucino-boyali-kumanda-paneli-4580.jpg?v=1747232959",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-cappucino-boyali-kumanda-paneli-4581.jpg?v=1747232961",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-cappucino-boyali-kumanda-paneli-4582.jpg?v=1747232964",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-cappucino-boyali-kumanda-paneli-4583.jpg?v=1747232967",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-cappucino-boyali-kumanda-paneli-4584.jpg?v=1747232970"
    ],
    "price": "2016.00",
    "sku": "GP8002.06",
    "tags": [
      "Arc",
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "Mat Cappuccino",
      "Rezervuar",
      "Rezervuarlar",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52843238228265,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP8002.06",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2016.00",
        "grams": 0,
        "compare_at_price": "2880.00",
        "position": 1,
        "product_id": 8760429347113,
        "created_at": "2026-03-17T13:02:51+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit GP8002.06 Arc Mat Cappucino Kumanda Paneli, doğal tonları sevenler için özel olarak tasarlanmış şık ve modern bir kumanda panelidir. Arc serisinin zarif çizgileriyle birleşen mat cappucino rengi, banyonuza sıcak ve sofistike bir dokunuş katar.</p>\n<hr>\n<h3>🛠️ Ürün Özellikleri</h3>\n<ul>\n  <li>\n<strong>Ürün Kodu:</strong> GP8002.06</li>\n  <li>\n<strong>Seri:</strong> Arc</li>\n  <li>\n<strong>Renk:</strong> Mat Cappucino</li>\n  <li>\n<strong>Malzeme:</strong> ABS plastik ve krom kaplama</li>\n  <li>\n<strong>Boyutlar:</strong> 246 x 163 x 13 mm (Genişlik x Yükseklik x Derinlik)</li>\n  <li>\n<strong>Çalışma Prensibi:</strong> Çift kademeli manuel deşarj sistemi</li>\n  <li>\n<strong>Montaj:</strong> Duvar üzerine kolay montaj</li>\n  <li>\n<strong>Uyumluluk:</strong> Creavit gömme rezervuar sistemleri ile uyumlu</li>\n  <li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n  <li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n  <li>Arc serisinin zarif ve modern tasarımı</li>\n  <li>Mat cappucino yüzey ile doğal ve şık görünüm</li>\n  <li>Kullanımı kolay çift kademeli manuel deşarj sistemi</li>\n  <li>Dayanıklı ABS plastik ve krom kaplama</li>\n  <li>Kolay montaj imkanı sayesinde hızlı kurulum</li>\n</ul>\n<hr>\n<h3>🧼 Temizlik ve Bakım</h3>\n<p>Mat cappucino yüzeyi, kir ve leke tutmaz yapısı sayesinde kolayca temizlenir. Yüzeyin korunması için nemli yumuşak bir bezle düzenli olarak silinmesi önerilir.</p>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n  <li>1 adet Arc Mat Cappucino Kumanda Paneli (GP8002.06)</li>\n  <li>Montaj için gerekli bağlantı elemanları</li>\n  <li>Kullanım ve montaj kılavuzu</li>\n</ul>\n"
  },
  {
    "id": "creavit-8760429314345",
    "brand": "Creavit",
    "title": "Arc Mat Antrasit Boyalı Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-antrasit-boyali-kumanda-paneli-4569.png?v=1747232921",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-antrasit-boyali-kumanda-paneli-4569.png?v=1747232921",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-antrasit-boyali-kumanda-paneli-4570.jpg?v=1747232925",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-antrasit-boyali-kumanda-paneli-4571.jpg?v=1747232928",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-antrasit-boyali-kumanda-paneli-4572.jpg?v=1747232931",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-antrasit-boyali-kumanda-paneli-4573.jpg?v=1747232933",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-antrasit-boyali-kumanda-paneli-4574.jpg?v=1747232937",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-antrasit-boyali-kumanda-paneli-4575.jpg?v=1747232939",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-antrasit-boyali-kumanda-paneli-4576.jpg?v=1747232942"
    ],
    "price": "2016.00",
    "sku": "GP8002.04",
    "tags": [
      "Arc",
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "Mat Antrasit",
      "Rezervuar",
      "Rezervuarlar",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52843204084009,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP8002.04",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2016.00",
        "grams": 0,
        "compare_at_price": "2880.00",
        "position": 1,
        "product_id": 8760429314345,
        "created_at": "2026-03-17T12:52:25+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit GP8002.04 Arc Mat Antrasit Kumanda Paneli, sofistike mat antrasit tonu ve zarif tasarımıyla Arc serisinin modern çizgisini yansıtır. Hem estetik hem de fonksiyonel yapısıyla, modern banyolar için mükemmel bir tamamlayıcıdır.</p>\n<hr>\n<h3>🛠️ Ürün Özellikleri</h3>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> GP8002.04</li>\n<li>\n<strong>Seri:</strong> Arc</li>\n<li>\n<strong>Renk:</strong> Mat Antrasit</li>\n<li>\n<strong>Malzeme:</strong> ABS plastik ve krom kaplama</li>\n<li>\n<strong>Boyutlar:</strong> 246 x 163 x 13 mm (Genişlik x Yükseklik x Derinlik)</li>\n<li>\n<strong>Çalışma Prensibi:</strong> Çift kademeli manuel deşarj sistemi</li>\n<li>\n<strong>Montaj:</strong> Duvar üzerine kolay montaj</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit gömme rezervuar sistemleriyle uyumlu</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>Modern ve zarif Arc tasarımı</li>\n<li>Mat antrasit yüzey ile sofistike görünüm</li>\n<li>Kullanımı kolay çift kademeli manuel deşarj sistemi</li>\n<li>ABS plastik ve krom kaplama ile uzun ömürlü yapı</li>\n<li>Kolay montaj imkanı ile hızlı kurulum</li>\n</ul>\n<hr>\n<h3>🧼 Temizlik ve Bakım</h3>\n<p>Mat antrasit yüzeyi leke tutmaz ve kolayca temizlenebilir. Yüzeyin ilk günkü görünümünü koruması için nemli bir bezle düzenli olarak silinmesi önerilir.</p>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>1 adet Arc Mat Antrasit Kumanda Paneli (GP8002.04)</li>\n<li>Montaj için gerekli bağlantı elemanları</li>\n<li>Kullanım ve montaj kılavuzu</li>\n</ul>"
  },
  {
    "id": "creavit-8760429248809",
    "brand": "Creavit",
    "title": "Arc Mat Siyah Boyalı Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-siyah-boyali-kumanda-paneli-4561.png?v=1747224224",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-siyah-boyali-kumanda-paneli-4561.png?v=1747224224",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-siyah-boyali-kumanda-paneli-4562.jpg?v=1747224227",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-siyah-boyali-kumanda-paneli-4563.jpg?v=1747224229",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-siyah-boyali-kumanda-paneli-4564.jpg?v=1747224232",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-siyah-boyali-kumanda-paneli-4565.jpg?v=1747224234",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-siyah-boyali-kumanda-paneli-4566.jpg?v=1747224236",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-siyah-boyali-kumanda-paneli-4567.jpg?v=1747224238",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-siyah-boyali-kumanda-paneli-4568.jpg?v=1747224241"
    ],
    "price": "2016.00",
    "sku": "GP8002.01",
    "tags": [
      "Arc",
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "Mat Siyah",
      "Rezervuar",
      "Rezervuarlar",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52879004369193,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP8002.01",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2016.00",
        "grams": 0,
        "compare_at_price": "2880.00",
        "position": 1,
        "product_id": 8760429248809,
        "created_at": "2026-03-26T01:04:42+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit GP8002.01 Arc Mat Siyah Boyalı Kumanda Paneli, Arc serisinin zarif çizgilerini mat siyahın modern ve sofistike görünümüyle buluşturur. Şık tasarımı ve dayanıklı yapısıyla, banyolarınıza estetik bir dokunuş katarken fonksiyonellikten de ödün vermez.</p>\n<hr>\n<h3>🛠️ Ürün Özellikleri</h3>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> GP8002.01</li>\n<li>\n<strong>Seri:</strong> Arc</li>\n<li>\n<strong>Renk:</strong> Mat Siyah</li>\n<li>\n<strong>Malzeme:</strong> ABS plastik ve krom kaplama</li>\n<li>\n<strong>Boyutlar:</strong> 246 x 163 x 13 mm (Genişlik x Yükseklik x Derinlik)</li>\n<li>\n<strong>Çalışma Prensibi:</strong> Çift kademeli manuel deşarj sistemi</li>\n<li>\n<strong>Montaj:</strong> Duvar üzerine kolay montaj</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit gömme rezervuar sistemleriyle uyumlu</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>Mat siyah yüzeyiyle modern ve güçlü bir tasarım</li>\n<li>Kullanımı kolay çift kademeli manuel deşarj sistemi</li>\n<li>Dayanıklı ABS plastik ve krom kaplama kombinasyonu</li>\n<li>Duvar üzerine hızlı ve kolay montaj imkanı</li>\n</ul>\n<hr>\n<h3>🧼 Temizlik ve Bakım</h3>\n<p>Mat siyah kaplama yüzey leke tutmaz, kolay temizlenir. Parlaklığını ve temizliğini korumak için düzenli olarak nemli bir bezle silinmesi yeterlidir.</p>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>1 adet Arc Mat Siyah Boyalı Kumanda Paneli (GP8002.01)</li>\n<li>Montaj için gerekli bağlantı elemanları</li>\n<li>Kullanım ve montaj kılavuzu</li>\n</ul>"
  },
  {
    "id": "creavit-8760429216041",
    "brand": "Creavit",
    "title": "Arc Mat Gri Boyalı Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-gri-boyali-kumanda-paneli-4553.png?v=1747249785",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-gri-boyali-kumanda-paneli-4553.png?v=1747249785",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-gri-boyali-kumanda-paneli-4554.jpg?v=1747249788",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-gri-boyali-kumanda-paneli-4555.jpg?v=1747249790",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-gri-boyali-kumanda-paneli-4556.jpg?v=1747249792",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-gri-boyali-kumanda-paneli-4557.jpg?v=1747249794",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-gri-boyali-kumanda-paneli-4558.jpg?v=1747249797",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-gri-boyali-kumanda-paneli-4559.jpg?v=1747249799",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-mat-gri-boyali-kumanda-paneli-4560.jpg?v=1747249802"
    ],
    "price": "1386.00",
    "sku": "GP8002.00",
    "tags": [
      "Arc",
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "mat gri",
      "Rezervuar",
      "Rezervuarlar",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52843233444137,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP8002.00",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1386.00",
        "grams": 0,
        "compare_at_price": "1980.00",
        "position": 1,
        "product_id": 8760429216041,
        "created_at": "2026-03-17T13:01:04+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit GP8002.00 Arc Mat Gri Boyalı Kumanda Paneli, Arc serisinin modern çizgilerini mat gri tonuyla birleştirerek banyonuza şıklık ve işlevsellik kazandırır. Creavit gömme rezervuar sistemleriyle tam uyumlu olan bu panel, hem estetik hem de dayanıklılık arayanlar için ideal bir tercihtir.</p>\n<hr>\n<h3>🛠️ Ürün Özellikleri</h3>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> GP8002.00</li>\n<li>\n<strong>Seri:</strong> Arc</li>\n<li>\n<strong>Renk:</strong> Mat Gri</li>\n<li>\n<strong>Malzeme:</strong> ABS plastik ve krom kaplama</li>\n<li>\n<strong>Boyutlar:</strong> 246 x 163 x 13 mm (Genişlik x Yükseklik x Derinlik)</li>\n<li>\n<strong>Çalışma Prensibi:</strong> Çift kademeli manuel deşarj sistemi</li>\n<li>\n<strong>Montaj:</strong> Duvar üzerine kolay montaj</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit gömme rezervuar sistemleriyle uyumlu</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>Mat gri renk ve modern Arc tasarımı ile estetik bir görünüm</li>\n<li>Kullanımı kolay çift kademeli manuel deşarj sistemi</li>\n<li>ABS plastik ve krom kaplama sayesinde dayanıklı ve uzun ömürlü</li>\n<li>Kolay ve hızlı montaj imkanı ile kullanıcı dostu kurulum</li>\n</ul>\n<hr>\n<h3>🧼 Temizlik ve Bakım</h3>\n<p>Mat gri yüzey kolay temizlenebilir ve leke tutmaz. Nemli bir bezle düzenli silinmesi, panelin ilk günkü görünümünü korumasına yardımcı olur.</p>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>1 adet Arc Mat Gri Boyalı Kumanda Paneli (GP8002.00)</li>\n<li>Montaj için gerekli bağlantı elemanları</li>\n<li>Kullanım ve montaj kılavuzu</li>\n</ul>"
  },
  {
    "id": "creavit-8760429183273",
    "brand": "Creavit",
    "title": "Arc Beyaz Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-beyaz-kumanda-paneli-4546.png?v=1747224200",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-beyaz-kumanda-paneli-4546.png?v=1747224200",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-beyaz-kumanda-paneli-4547.jpg?v=1747224202",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-beyaz-kumanda-paneli-4548.jpg?v=1747224205",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-beyaz-kumanda-paneli-4549.jpg?v=1747224207",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-beyaz-kumanda-paneli-4550.jpg?v=1747224209",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-beyaz-kumanda-paneli-4551.jpg?v=1747224212",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/arc-beyaz-kumanda-paneli-4552.jpg?v=1747224214"
    ],
    "price": "1050.00",
    "sku": "GP8001.00",
    "tags": [
      "Arc",
      "Beyaz",
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "Rezervuar",
      "Rezervuarlar",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52920969691433,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP8001.00",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1050.00",
        "grams": 0,
        "compare_at_price": "1500.00",
        "position": 1,
        "product_id": 8760429183273,
        "created_at": "2026-04-03T12:16:24+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit GP8001.00 Arc Beyaz Kumanda Paneli, modern banyolar için tasarlanmış, şık ve fonksiyonel bir gömme rezervuar kumanda panelidir. Beyaz rengi ve zarif Arc serisi tasarımı ile banyonuza estetik bir dokunuş katar. <meta charset=\"utf-8\"></p>\n<hr>\n<h4>🛠️ Ürün Özellikleri<strong></strong>\n</h4>\n<ul>\n<li>\n<strong>Malzeme:</strong> ABS plastik ve krom kaplama</li>\n<li>\n<strong>Boyutlar:</strong> 246 x 163 x 13 mm (Genişlik x Yükseklik x Derinlik)</li>\n<li>\n<strong>Çalışma Prensibi:</strong> Çift kademeli manuel deşarj sistemi</li>\n<li>\n<strong>Montaj:</strong> Duvar üzerine kolay montaj</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit gömme rezervuar sistemleri ile uyumlu</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n</ul>\n<h4>📦 Paket İçeriği</h4>\n<ul>\n<li>1 adet Ore Beyaz Kumanda Paneli (GP3001.00)</li>\n<li>Montaj için bağlantı elemanları</li>\n<li>Kullanım ve montaj kılavuzu</li>\n</ul>"
  },
  {
    "id": "creavit-8760429150505",
    "brand": "Creavit",
    "title": "SPA Mat Gri Boyalı Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spa-mat-gri-boyali-kumanda-paneli-4539.png?v=1747224174",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spa-mat-gri-boyali-kumanda-paneli-4539.png?v=1747224174",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spa-mat-gri-boyali-kumanda-paneli-4540.jpg?v=1747224177",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spa-mat-gri-boyali-kumanda-paneli-4541.jpg?v=1747224180",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spa-mat-gri-boyali-kumanda-paneli-4542.jpg?v=1747224183",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spa-mat-gri-boyali-kumanda-paneli-4543.jpg?v=1747224185",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spa-mat-gri-boyali-kumanda-paneli-4544.jpg?v=1747224187",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spa-mat-gri-boyali-kumanda-paneli-4545.jpg?v=1747224190"
    ],
    "price": "1386.00",
    "sku": "GP7002.00",
    "tags": [
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "mat gri",
      "Rezervuar",
      "Rezervuarlar",
      "SPA",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52843203920169,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP7002.00",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "1386.00",
        "grams": 0,
        "compare_at_price": "1980.00",
        "position": 1,
        "product_id": 8760429150505,
        "created_at": "2026-03-17T12:52:22+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Creavit GP7002.00 Ore Mat Gri Boyalı Kumanda Paneli</strong>, Ore serisine ait modern tasarımı ve mat gri rengiyle banyolarda hem şıklığı hem de fonksiyonelliği bir araya getirir. Creavit gömme rezervuar sistemleriyle tam uyum sağlayan bu panel, dayanıklı yapısı ve kolay kullanımıyla dikkat çeker.</p>\n<hr>\n<h3>🛠️ Ürün Özellikleri</h3>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> GP7002.00</li>\n<li>\n<strong>Seri:</strong> Ore</li>\n<li>\n<strong>Renk:</strong> Mat Gri</li>\n<li>\n<strong>Malzeme:</strong> ABS plastik ve krom kaplama</li>\n<li>\n<strong>Boyutlar:</strong> 246 x 163 x 13 mm</li>\n<li>\n<strong>Çalışma Prensibi:</strong> Çift kademeli manuel deşarj sistemi</li>\n<li>\n<strong>Montaj:</strong> Duvar üzerine kolay montaj</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit gömme rezervuar sistemleriyle uyumludur</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>Şık mat gri tasarımı banyonuza modern bir görünüm kazandırır.</li>\n<li>Dayanıklı ABS plastik ve krom kaplama ile uzun ömürlü kullanım sağlar.</li>\n<li>Çift kademeli manuel deşarj sistemi sayesinde su tasarrufu sağlar.</li>\n<li>Kolay montaj imkanı ile kullanıcı dostudur.</li>\n</ul>\n<hr>\n<h3>🧼 Temizlik ve Bakım</h3>\n<p>Mat yüzeyi sayesinde parmak izi ve leke tutmaz. Yumuşak, nemli bir bez ile düzenli olarak silinmesi önerilir.</p>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>1 adet Ore Mat Gri Boyalı Kumanda Paneli (GP7002.00)</li>\n<li>Montaj için bağlantı elemanları</li>\n<li>Kullanım ve montaj kılavuzu</li>\n</ul>"
  },
  {
    "id": "creavit-8760429117737",
    "brand": "Creavit",
    "title": "SPA  Beyaz Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spa-beyaz-kumanda-paneli-4532.png?v=1747249759",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spa-beyaz-kumanda-paneli-4532.png?v=1747249759",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spa-beyaz-kumanda-paneli-4533.jpg?v=1747249762",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spa-beyaz-kumanda-paneli-4534.jpg?v=1747249764",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spa-beyaz-kumanda-paneli-4535.jpg?v=1747249767",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spa-beyaz-kumanda-paneli-4536.jpg?v=1747249769",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spa-beyaz-kumanda-paneli-4537.jpg?v=1747249771",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spa-beyaz-kumanda-paneli-4538.jpg?v=1747249775"
    ],
    "price": "1050.00",
    "sku": "GP7001.00",
    "tags": [
      "Beyaz",
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "Rezervuar",
      "Rezervuarlar",
      "SPA",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52843203789097,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP7001.00",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "1050.00",
        "grams": 0,
        "compare_at_price": "1500.00",
        "position": 1,
        "product_id": 8760429117737,
        "created_at": "2026-03-17T12:52:19+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Creavit GP7001.00 Kumanda Paneli</strong>, Creavit'in modern tasarıma sahip, kullanımı kolay gömme rezervuar kumanda panelidir. Estetik görünümü ve dayanıklı yapısıyla banyonuza şıklık ve fonksiyonellik katar.</p>\n<hr>\n<h3>🛠️ Ürün Özellikleri</h3>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> GP7001.00</li>\n<li>\n<strong>Renk:</strong> Genellikle beyaz veya krom kaplama (detaylı renk bilgisi varsa belirtilebilir)</li>\n<li>\n<strong>Malzeme:</strong> ABS plastik ve krom kaplama</li>\n<li>\n<strong>Boyutlar:</strong> 246 x 163 x 13 mm</li>\n<li>\n<strong>Çalışma Prensibi:</strong> Çift kademeli manuel deşarj sistemi</li>\n<li>\n<strong>Montaj:</strong> Duvar üzerine kolay montaj</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit gömme rezervuar sistemleriyle uyumludur</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>Modern ve zarif tasarım</li>\n<li>Kullanımı kolay manuel çift kademeli deşarj sistemi</li>\n<li>Dayanıklı ABS plastik ve krom kaplama</li>\n<li>Kolay ve hızlı montaj imkanı</li>\n</ul>\n<hr>\n<h3>🧼 Temizlik ve Bakım</h3>\n<p>Krom kaplama yüzeyi kolay temizlenir, leke tutmaz. Nemli bezle düzenli silme ürünü uzun süre temiz ve parlak tutar.</p>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>1 adet GP7001.00 Kumanda Paneli</li>\n<li>Montaj için bağlantı elemanları</li>\n<li>Kullanım ve montaj kılavuzu</li>\n</ul>\n<hr>\n<p>Creavit GP7001.00, estetik ve fonksiyonelliği bir arada sunarak modern banyolarınız için ideal bir seçimdir. Kolay montajı ve dayanıklı yapısıyla banyonuza şıklık katacaktır.</p>"
  },
  {
    "id": "creavit-8760429019433",
    "brand": "Creavit",
    "title": "Ore Parlak Krom Kaplama Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-parlak-krom-kaplama-kumanda-paneli-4525.png?v=1747232894",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-parlak-krom-kaplama-kumanda-paneli-4525.png?v=1747232894",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-parlak-krom-kaplama-kumanda-paneli-4526.jpg?v=1747232897",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-parlak-krom-kaplama-kumanda-paneli-4527.jpg?v=1747232900",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-parlak-krom-kaplama-kumanda-paneli-4528.jpg?v=1747232902",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-parlak-krom-kaplama-kumanda-paneli-4529.jpg?v=1747232905",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-parlak-krom-kaplama-kumanda-paneli-4530.jpg?v=1747232907",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-parlak-krom-kaplama-kumanda-paneli-4531.jpg?v=1747232910"
    ],
    "price": "2352.00",
    "sku": "GP3004.00",
    "tags": [
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "Ore",
      "Parlak Krom",
      "Rezervuar",
      "Rezervuarlar",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52843203658025,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP3004.00",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2352.00",
        "grams": 0,
        "compare_at_price": "3360.00",
        "position": 1,
        "product_id": 8760429019433,
        "created_at": "2026-03-17T12:52:16+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit GP3004.00 Ore Parlak Krom Kaplama Kumanda Paneli, Creavit’in Ore serisine ait, parlak krom kaplama yüzeye sahip şık ve modern bir gömme rezervuar kumanda panelidir. Gömme rezervuar sistemleriyle uyumlu olarak tasarlanmış olup, banyonuza hem estetik hem fonksiyonel bir kullanım sunar.</p>\n<hr>\n<h3>Ürün Özellikleri </h3>\n<ul>\n<li>Ürün Kodu: GP3004.00</li>\n<li>Seri: Ore</li>\n<li>Renk: Parlak Krom</li>\n<li>Malzeme: ABS plastik ve krom kaplama</li>\n<li>Boyutlar: 246 x 163 x 13 mm (Genişlik x Yükseklik x Derinlik)</li>\n<li>Çalışma Prensibi: Çift kademeli manuel deşarj sistemi</li>\n<li>Montaj: Duvar üzerine kolay montaj</li>\n<li>Uyumluluk: Creavit gömme rezervuar sistemleriyle uyumludur</li>\n<li>Garanti Süresi: 2 yıl</li>\n<li>Üretim Yeri: Türkiye</li>\n</ul>\n<hr>\n<h3>Öne Çıkan Özellikler</h3>\n<ul>\n<li>Parlak krom kaplama ve modern tasarımı ile banyonuza zarif ve şık bir görünüm kazandırır.</li>\n<li>Manuel çift kademeli deşarj sistemi sayesinde kolay ve pratik kullanım sunar.</li>\n<li>ABS plastik ve krom kaplama dayanıklı ve uzun ömürlü yapı sağlar.</li>\n<li>Duvara kolay montaj imkanı ile hızlı ve sorunsuz kurulum sağlar.</li>\n</ul>\n<hr>\n<h3>Temizlik ve Bakım</h3>\n<p>Parlak krom yüzeyi leke tutmaz ve kolay temizlenir. Düzenli olarak nemli bezle silinmesi, ürünün parlaklığını ve temizliğini uzun süre korumasına yardımcı olur.</p>\n<hr>\n<h3>Paket İçeriği</h3>\n<ul>\n<li>1 adet Ore Parlak Krom Kaplama Kumanda Paneli (GP3004.00)</li>\n<li>Montaj için gerekli bağlantı elemanları</li>\n<li>Kullanım ve montaj kılavuzu</li>\n</ul>\n<hr>\n<p>Creavit GP3004.00 Ore Parlak Krom Kaplama Kumanda Paneli, modern banyolar için estetik ve fonksiyonelliği bir arada sunan ideal bir çözümdür. Kolay montajı ve dayanıklı yapısıyla banyonuza değer katacaktır.</p>"
  },
  {
    "id": "creavit-8760428986665",
    "brand": "Creavit",
    "title": "Ore Mat Siyah Boyalı Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-mat-siyah-boyali-kumanda-paneli-4517.png?v=1747224146",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-mat-siyah-boyali-kumanda-paneli-4517.png?v=1747224146",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-mat-siyah-boyali-kumanda-paneli-4518.jpg?v=1747224149",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-mat-siyah-boyali-kumanda-paneli-4519.jpg?v=1747224151",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-mat-siyah-boyali-kumanda-paneli-4520.jpg?v=1747224154",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-mat-siyah-boyali-kumanda-paneli-4521.jpg?v=1747224157",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-mat-siyah-boyali-kumanda-paneli-4522.jpg?v=1747224159",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-mat-siyah-boyali-kumanda-paneli-4523.jpg?v=1747224162",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-mat-siyah-boyali-kumanda-paneli-4524.jpg?v=1747224164"
    ],
    "price": "2016.00",
    "sku": "GP3002.01",
    "tags": [
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "Mat Siyah",
      "Ore",
      "Rezervuar",
      "Rezervuarlar",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52920969462057,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP3002.01",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2016.00",
        "grams": 0,
        "compare_at_price": "2880.00",
        "position": 1,
        "product_id": 8760428986665,
        "created_at": "2026-04-03T12:16:21+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit GP3002.01 Ore Mat Siyah Boyalı Kumanda Paneli, Creavit’in Ore serisine ait, mat siyah renkte şık ve modern bir gömme rezervuar kumanda panelidir. Gömme rezervuar sistemleriyle uyumlu olarak tasarlanmış olup, banyonuza estetik ve fonksiyonel bir dokunuş sunar.</p>\n<hr>\n<h3>🛠️ Ürün Özellikleri</h3>\n<ul>\n<li>Ürün Kodu: GP3002.01</li>\n<li>Seri: Ore</li>\n<li>Renk: Mat Siyah</li>\n<li>Malzeme: ABS plastik ve krom kaplama</li>\n<li>Boyutlar: 246 x 163 x 13 mm (Genişlik x Yükseklik x Derinlik)</li>\n<li>Çalışma Prensibi: Çift kademeli manuel deşarj sistemi</li>\n<li>Montaj: Duvar üzerine kolay montaj</li>\n<li>Uyumluluk: Creavit gömme rezervuar sistemleriyle uyumludur</li>\n<li>Garanti Süresi: 2 yıl</li>\n<li>Üretim Yeri: Türkiye</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>Mat siyah renk ve modern tasarımıyla banyonuza şık ve sofistike bir görünüm kazandırır.</li>\n<li>Manuel çift kademeli deşarj sistemi ile pratik kullanım kolaylığı sağlar.</li>\n<li>ABS plastik ve krom kaplama sayesinde dayanıklı ve uzun ömürlü bir yapı sunar.</li>\n<li>Duvara kolay montaj imkanı ile hızlı ve sorunsuz kurulum sağlar.</li>\n</ul>\n<hr>\n<h3>🧼 Temizlik ve Bakım</h3>\n<p>Mat siyah kaplama yüzeyi kolay temizlenir, leke tutmaz. Düzenli olarak nemli bezle silinmesi, ürünün uzun süre temiz ve şık kalmasına yardımcı olur.</p>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>1 adet Ore Mat Siyah Boyalı Kumanda Paneli (GP3002.01)</li>\n<li>Montaj için gerekli bağlantı elemanları</li>\n<li>Kullanım ve montaj kılavuzu</li>\n</ul>\n<hr>\n<p>Creavit GP3002.01 Ore Mat Siyah Boyalı Kumanda Paneli, estetik ve fonksiyonelliği bir arada sunarak modern banyolarınız için mükemmel bir tercihtir. Kolay montajı ve dayanıklı yapısı ile banyonuza değer katacaktır.</p>"
  },
  {
    "id": "creavit-8760428953897",
    "brand": "Creavit",
    "title": "Ore Mat Gri Boyalı Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-mat-gri-boyali-kumanda-paneli-4510.png?v=1747224119",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-mat-gri-boyali-kumanda-paneli-4510.png?v=1747224119",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-mat-gri-boyali-kumanda-paneli-4511.jpg?v=1747224122",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-mat-gri-boyali-kumanda-paneli-4512.jpg?v=1747224125",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-mat-gri-boyali-kumanda-paneli-4513.jpg?v=1747224127",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-mat-gri-boyali-kumanda-paneli-4514.jpg?v=1747224130",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-mat-gri-boyali-kumanda-paneli-4515.jpg?v=1747224133",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-mat-gri-boyali-kumanda-paneli-4516.jpg?v=1747224136"
    ],
    "price": "1386.00",
    "sku": "GP3002.00",
    "tags": [
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "mat gri",
      "Ore",
      "Rezervuar",
      "Rezervuarlar",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52909427294505,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP3002.00",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1386.00",
        "grams": 0,
        "compare_at_price": "1980.00",
        "position": 1,
        "product_id": 8760428953897,
        "created_at": "2026-04-01T00:56:56+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<h3><strong>GP3002.00 - Ore Mat Gri Boyalı Kumanda Paneli</strong></h3>\n<p>Creavit GP3002.00 Ore Mat Gri Boyalı Kumanda Paneli, Creavit’in Ore serisine ait, mat gri renkte şık ve modern bir gömme rezervuar kumanda panelidir. Gömme rezervuar sistemleriyle uyumlu olarak tasarlanmış olup, banyonuza hem estetik hem de fonksiyonel bir kullanım sunar.</p>\n<hr>\n<h3>🛠️ Ürün Özellikleri</h3>\n<ul>\n<li>Ürün Kodu: GP3002.00</li>\n<li>Seri: Ore</li>\n<li>Renk: Mat Gri</li>\n<li>Malzeme: ABS plastik ve krom kaplama</li>\n<li>Boyutlar: 246 x 163 x 13 mm (Genişlik x Yükseklik x Derinlik)</li>\n<li>Çalışma Prensibi: Çift kademeli manuel deşarj sistemi</li>\n<li>Montaj: Duvar üzerine kolay montaj</li>\n<li>Uyumluluk: Creavit gömme rezervuar sistemleriyle uyumludur</li>\n<li>Garanti Süresi: 2 yıl</li>\n<li>Üretim Yeri: Türkiye</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>Mat gri renk ve modern tasarımıyla banyonuza zarif bir görünüm katar.</li>\n<li>Manuel çift kademeli deşarj sistemi ile kullanım kolaylığı sağlar.</li>\n<li>ABS plastik ve krom kaplama dayanıklı ve uzun ömürlü bir yapı sunar.</li>\n<li>Duvara kolay montaj imkanı ile hızlı kurulum sağlar.</li>\n</ul>\n<hr>\n<h3>🧼 Temizlik ve Bakım</h3>\n<p>Mat gri kaplama yüzeyi kolay temizlenir, leke tutmaz. Düzenli olarak nemli bezle silinmesi, ürünün uzun süre temiz ve şık kalmasına yardımcı olur.</p>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>1 adet Ore Mat Gri Boyalı Kumanda Paneli (GP3002.00)</li>\n<li>Montaj için gerekli bağlantı elemanları</li>\n<li>Kullanım ve montaj kılavuzu</li>\n</ul>\n<hr>\n<p>Creavit GP3002.00 Ore Mat Gri Boyalı Kumanda Paneli, estetik ve fonksiyonelliği bir arada sunarak modern banyolarınız için ideal bir seçimdir. Kolay montajı ve dayanıklı yapısıyla banyonuza değer katar.</p>"
  },
  {
    "id": "creavit-8760428888361",
    "brand": "Creavit",
    "title": "Ore Beyaz Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-beyaz-kumanda-paneli-4502.png?v=1747224092",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-beyaz-kumanda-paneli-4502.png?v=1747224092",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-beyaz-kumanda-paneli-4503.jpg?v=1747224094",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-beyaz-kumanda-paneli-4504.jpg?v=1747224097",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-beyaz-kumanda-paneli-4505.jpg?v=1747224099",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-beyaz-kumanda-paneli-4506.jpg?v=1747224101",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-beyaz-kumanda-paneli-4507.jpg?v=1747224104",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-beyaz-kumanda-paneli-4508.jpg?v=1747224107",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ore-beyaz-kumanda-paneli-4509.jpg?v=1747224109"
    ],
    "price": "1050.00",
    "sku": "GP3001.00",
    "tags": [
      "Beyaz",
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "Ore",
      "Rezervuar",
      "Rezervuarlar",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52921482969385,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP3001.00",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1050.00",
        "grams": 0,
        "compare_at_price": "1500.00",
        "position": 1,
        "product_id": 8760428888361,
        "created_at": "2026-04-03T14:44:08+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<h4>Creavit GP3001.00 Ore Beyaz Kumanda Paneli</h4>\n<p>Creavit’in Ore serisine ait, beyaz renkli ve şık tasarımlı bir gömme rezervuar kumanda panelidir. Modern banyolar için estetik ve fonksiyonel bir kullanım sunar.</p>\n<hr>\n<h4>🛠️ Ürün Özellikleri<strong></strong>\n</h4>\n<ul>\n<li>\n<strong>Malzeme:</strong> ABS plastik ve krom kaplama</li>\n<li>\n<strong>Boyutlar:</strong> 246 x 163 x 13 mm (Genişlik x Yükseklik x Derinlik)</li>\n<li>\n<strong>Çalışma Prensibi:</strong> Çift kademeli manuel deşarj sistemi</li>\n<li>\n<strong>Montaj:</strong> Duvar üzerine kolay montaj</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit gömme rezervuar sistemleriyle uyumludur</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n</ul>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>1 adet Ore Beyaz Kumanda Paneli (GP3001.00)</li>\n<li>Montaj için bağlantı elemanları</li>\n<li>Kullanım ve montaj kılavuzu</li>\n</ul>"
  },
  {
    "id": "creavit-8760428855593",
    "brand": "Creavit",
    "title": "Drop Parlak Krom Kaplama Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-parlak-krom-kaplama-kumanda-paneli-4495.png?v=1747232799",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-parlak-krom-kaplama-kumanda-paneli-4495.png?v=1747232799",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-parlak-krom-kaplama-kumanda-paneli-4496.jpg?v=1747232803",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-parlak-krom-kaplama-kumanda-paneli-4497.jpg?v=1747232806",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-parlak-krom-kaplama-kumanda-paneli-4498.jpg?v=1747232810",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-parlak-krom-kaplama-kumanda-paneli-4499.jpg?v=1747232813",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-parlak-krom-kaplama-kumanda-paneli-4500.jpg?v=1747232816",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-parlak-krom-kaplama-kumanda-paneli-4501.jpg?v=1747232819"
    ],
    "price": "2352.00",
    "sku": "GP2004.00",
    "tags": [
      "Drop",
      "Gömmer Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "Parlak Krom",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52921482772777,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP2004.00",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2352.00",
        "grams": 0,
        "compare_at_price": "3360.00",
        "position": 1,
        "product_id": 8760428855593,
        "created_at": "2026-04-03T14:44:05+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<h4>Creavit GP2004.00 Drop Parlak Krom Kaplama Kumanda Paneli</h4>\n<p>Creavit’in Drop serisine ait, parlak krom renkli ve şık tasarımlı bir gömme rezervuar kumanda panelidir. Modern banyolar için estetik ve fonksiyonel bir kullanım sunar.</p>\n<hr>\n<h4>🛠️ Ürün Özellikleri <strong></strong>\n</h4>\n<ul>\n<li>\n<strong>Malzeme:</strong> ABS plastik ve krom kaplama</li>\n<li>\n<strong>Boyutlar:</strong> 246 x 163 x 13 mm (Genişlik x Yükseklik x Derinlik)</li>\n<li>\n<strong>Çalışma Prensibi:</strong> Çift kademeli manuel deşarj sistemi</li>\n<li>\n<strong>Montaj:</strong> Duvar üzerine kolay montaj</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit gömme rezervuar sistemleriyle uyumludur</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n</ul>\n<hr>\n<h4>📦 Paket İçeriği</h4>\n<ul>\n<li>1 adet Drop Parlak Krom Kaplama Kumanda Paneli (GP2004.00)</li>\n<li>Montaj için bağlantı elemanları</li>\n<li>Kullanım ve montaj kılavuzu</li>\n</ul>"
  },
  {
    "id": "creavit-8760428790057",
    "brand": "Creavit",
    "title": "Drop Cappucino Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-cappucino-kumanda-paneli-4487.png?v=1747232829",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-cappucino-kumanda-paneli-4487.png?v=1747232829",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-cappucino-kumanda-paneli-4488.jpg?v=1747232833",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-cappucino-kumanda-paneli-4489.jpg?v=1747232836",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-cappucino-kumanda-paneli-4490.jpg?v=1747232838",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-cappucino-kumanda-paneli-4491.jpg?v=1747232841",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-cappucino-kumanda-paneli-4492.jpg?v=1747232843",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-cappucino-kumanda-paneli-4493.jpg?v=1747232846",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-cappucino-kumanda-paneli-4494.jpg?v=1747232849"
    ],
    "price": "2016.00",
    "sku": "GP2002.06",
    "tags": [
      "Cappuccino",
      "Drop",
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52920071029033,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP2002.06",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "2016.00",
        "grams": 0,
        "compare_at_price": "2880.00",
        "position": 1,
        "product_id": 8760428790057,
        "created_at": "2026-04-03T08:23:33+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<h3>Creavit GP2002.06 Drop Cappucino Kumanda Paneli</h3>\n<p>Creavit'in Drop serisine ait, cappuccino renginde şık ve modern bir kumanda panelidir. Gömme rezervuar sistemleriyle uyumlu olarak tasarlanmış olup, banyonuza estetik bir görünüm kazandırır.</p>\n<hr>\n<h3>🛠️ Ürün Özellikleri</h3>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> GP2002.06</li>\n<li>\n<strong>Seri:</strong> Drop</li>\n<li>\n<strong>Renk:</strong> Cappuccino</li>\n<li>\n<strong>Malzeme:</strong> ABS plastik ve krom kaplama</li>\n<li>\n<strong>Boyutlar:</strong> 246 x 163 x 13 mm (Genişlik x Yükseklik x Derinlik)</li>\n<li>\n<strong>Çalışma Prensibi:</strong> Çift kademeli manuel deşarj sistemi</li>\n<li>\n<strong>Montaj:</strong> Duvar üzerine kolay montaj</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit gömme rezervuar sistemleriyle uyumludur</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>Modern tasarımıyla banyonuza ince ve şık bir estetik kazandırır.</li>\n<li>Manuel çalışma modu sayesinde kullanım kolaylığı sağlar.</li>\n<li>ABS plastik ve krom kaplama malzeme kombinasyonu ile uzun ömürlü ve dayanıklıdır.</li>\n<li>Duvar üzerine kolayca monte edilerek kurulum sürecini hızlandırır.</li>\n</ul>\n<hr>\n<h3>🧼 Temizlik ve Bakım</h3>\n<p>Krom kaplama yüzeyi leke tutmaz ve kolay temizlenir. Düzenli olarak nemli bir bezle silinmesi, ürünün parlaklığını ve temizliğini korumasına yardımcı olur.</p>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>1 adet Drop Cappucino Kumanda Paneli (GP2002.06)</li>\n<li>Montaj için gerekli bağlantı elemanları</li>\n<li>Kullanım ve montaj kılavuzu</li>\n</ul>\n<hr>\n<p><strong>Creavit GP2002.06 Drop Cappucino Kumanda Paneli</strong>, modern banyolar için estetik ve fonksiyonelliği bir arada sunan ideal bir çözümdür. Kolay montajı, dayanıklı yapısı ve şık tasarımıyla banyonuza değer katacaktır.</p>"
  },
  {
    "id": "creavit-8760428757289",
    "brand": "Creavit",
    "title": "Drop Antrasit Kumanda Paneli",
    "category": "Kumanda Panelleri",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-antrasit-kumanda-paneli-4479.png?v=1747232860",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-antrasit-kumanda-paneli-4479.png?v=1747232860",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-antrasit-kumanda-paneli-4480.jpg?v=1747232865",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-antrasit-kumanda-paneli-4481.jpg?v=1747232869",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-antrasit-kumanda-paneli-4482.jpg?v=1747232871",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-antrasit-kumanda-paneli-4483.jpg?v=1747232874",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-antrasit-kumanda-paneli-4484.jpg?v=1747232878",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-antrasit-kumanda-paneli-4485.jpg?v=1747232881",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/drop-antrasit-kumanda-paneli-4486.jpg?v=1747232884"
    ],
    "price": "2016.00",
    "sku": "GP2002.04",
    "tags": [
      "Antrasit",
      "Drop",
      "Gömme Rezervuar",
      "Klozet Sistemi",
      "Kumanda Paneli",
      "Rezervuar",
      "yaz-35-indirim"
    ],
    "variants": [
      {
        "id": 52843203428649,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "GP2002.04",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2016.00",
        "grams": 0,
        "compare_at_price": "2880.00",
        "position": 1,
        "product_id": 8760428757289,
        "created_at": "2026-03-17T12:52:10+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<h3>Creavit GP2002.04 Drop Antrasit Kumanda Paneli</h3>\n<p>Creavit GP2002.04 Drop Antrasit Kumanda Paneli, modern banyolar için estetik ve fonksiyonelliği bir arada sunan şık bir çözümdür. Antrasit rengi ve zarif tasarımıyla dikkat çeken bu panel, Creavit'in gömme rezervuar sistemleriyle uyumlu olarak tasarlanmıştır.</p>\n<hr>\n<h3>🛠️ Ürün Özellikleri</h3>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> GP2002.04</li>\n<li>\n<strong>Seri:</strong> Drop</li>\n<li>\n<strong>Renk:</strong> Antrasit</li>\n<li>\n<strong>Malzeme:</strong> ABS plastik ve krom kaplama</li>\n<li>\n<strong>Boyutlar:</strong> 246 x 163 x 13 mm (Genişlik x Yükseklik x Derinlik)</li>\n<li>\n<strong>Çalışma Prensibi:</strong> Çift kademeli manuel deşarj sistemi</li>\n<li>\n<strong>Montaj:</strong> Duvar üzerine kolay montaj</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit gömme rezervuar sistemleriyle uyumludur</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>\n<strong>Modern Tasarım:</strong> İnce ve şık yapısıyla banyonuza estetik bir görünüm kazandırır.</li>\n<li>\n<strong>Kullanım Kolaylığı:</strong> Manuel çalışma modu sayesinde kullanıcıya pratik bir kullanım sunar.</li>\n<li>\n<strong>Dayanıklı Malzeme:</strong> ABS plastik ve krom kaplama kombinasyonu, uzun ömürlü ve dayanıklı bir yapı sağlar.</li>\n<li>\n<strong>Kolay Montaj:</strong> Duvar üzerine kolayca monte edilebilir, bu da kurulum sürecini hızlandırır.</li>\n</ul>\n<hr>\n<h3>🧼 Temizlik ve Bakım</h3>\n<p>Krom kaplama yüzeyi sayesinde leke tutmaz ve kolay temizlenir. Düzenli olarak nemli bir bezle silinmesi, ürünün parlaklığını ve temizliğini korumasına yardımcı olur.</p>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>1 adet Drop Antrasit Kumanda Paneli (GP2002.04)</li>\n<li>Montaj için gerekli bağlantı elemanları</li>\n<li>Kullanım ve montaj kılavuzu</li>\n</ul>\n<hr>\n<p><strong>Creavit GP2002.04 Drop Antrasit Kumanda Paneli</strong>, modern banyolar için estetik ve fonksiyonelliği bir arada sunan ideal bir çözümdür. Kolay montajı, dayanıklı yapısı ve şık tasarımıyla banyonuza değer katacaktır.</p>"
  },
  {
    "id": "creavit-8760291000617",
    "brand": "Creavit",
    "title": "Çınar Thermoplast Yavaş Kapanan Klozet Kapağı Beyaz",
    "category": "Thermoplast Klozet Kapakları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/cinar-thermoplast-yavas-kapanan-klozet-kapagi-beyaz-4456.png?v=1747729669",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/cinar-thermoplast-yavas-kapanan-klozet-kapagi-beyaz-4456.png?v=1747729669",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/cinar-thermoplast-yavas-kapanan-klozet-kapagi-beyaz-4457.jpg?v=1747729669",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/cinar-thermoplast-yavas-kapanan-klozet-kapagi-beyaz-4458.jpg?v=1747729669"
    ],
    "price": "1386.00",
    "sku": "KC0703.03.0000E",
    "tags": [
      "Beyaz",
      "kapak",
      "klozet kapağı",
      "tak-çıkar",
      "thermoplast",
      "yavaş kapama",
      "yaz-25-indirim",
      "Yuvarlak",
      "Çınar"
    ],
    "variants": [
      {
        "id": 52937926541609,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KC0703.03.0000E",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1386.00",
        "grams": 0,
        "compare_at_price": "1980.00",
        "position": 1,
        "product_id": 8760291000617,
        "created_at": "2026-04-06T18:31:08+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<h4>Creavit Çınar Thermoplast Yavaş Kapanan Klozet Kapağı - Beyaz (KC0703.03.0000E)</h4>\n<p><strong>Creavit KC0703.03.0000E</strong> model kodlu klozet kapağı, <strong>Çınar serisine</strong> ait olup, <strong>termoplastik</strong> malzemeden üretilmiştir. <em>Yavaş kapanma (soft-close)</em> özelliği sayesinde sessiz ve güvenli bir kullanım sunar. <strong>Yuvarlak formu</strong> ve sade tasarımıyla banyonuza estetik bir dokunuş katar. <strong>Üstten montaj</strong> sistemiyle kolayca çıkarılıp takılabilir, bu da temizlik işlemlerini oldukça pratik hale getirir.</p>\n<h4>🛠️ Ürün Özellikleri <strong></strong>\n</h4>\n<ul>\n<li>\n<strong>Şekil:</strong> Yuvarlak</li>\n<li>\n<strong>Ölçüler:</strong> 368 x 442 mm</li>\n<li>\n<strong>Montaj Tipi:</strong> Üstten montaj (tak-çıkar özellikli)</li>\n<li>\n<strong>Uyumluluk: </strong>Creavit Sedef, Pitta, TP330, TP340, BD305, BD315, Corner ve TP320 serisi klozetlerle uyumludur.</li>\n<li>\n<strong>Menteşe Türü:</strong> Plastik menteşe</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n</ul>\n<h4>🧼 Hijyen ve Temizlik</h4>\n<p><strong>Termoplastik</strong> malzeme, dayanıklılığı ve kolay temizlenebilirliği ile bilinir. <strong>Üstten montaj</strong> sistemi sayesinde klozet kapağı rahatça çıkarılıp yeniden takılabilir, bu da temizlik işlemlerini oldukça kolaylaştırır. <strong>Yavaş kapanma</strong> özelliği, kapağın klozete çarparak zarar verme riskini ortadan kaldırır ve sessiz bir kullanım sağlar.</p>"
  },
  {
    "id": "creavit-8760278974761",
    "brand": "Creavit",
    "title": "Lara Thermoplast Yavaş Kapanan Klozet Kapağı Beyaz",
    "category": "Thermoplast Klozet Kapakları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-thermoplast-yavas-kapanan-klozet-kapagi-beyaz-4453.png?v=1747806434",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-thermoplast-yavas-kapanan-klozet-kapagi-beyaz-4453.png?v=1747806434",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-thermoplast-yavas-kapanan-klozet-kapagi-beyaz-4454.jpg?v=1747806434",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-thermoplast-yavas-kapanan-klozet-kapagi-beyaz-4455.jpg?v=1747806434"
    ],
    "price": "1512.00",
    "sku": "KC1603.03.0000E",
    "tags": [
      "Beyaz",
      "kapak",
      "Kare",
      "klozet kapağı",
      "Lara",
      "tak-çıkar",
      "thermoplast",
      "yavaş kapama",
      "yaz-25-indirim"
    ],
    "variants": [
      {
        "id": 52938333946153,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KC1603.03.0000E",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "1512.00",
        "grams": 0,
        "compare_at_price": "2160.00",
        "position": 1,
        "product_id": 8760278974761,
        "created_at": "2026-04-06T20:07:36+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<h4>Creavit Lara Thermoplast Yavaş Kapanan Klozet Kapağı - Beyaz (KC1603.03.0000E)</h4>\n<p><strong>Creavit KC1603.03.0000E</strong> klozet kapağı, <strong>Creavit'in Lara serisine</strong> ait, beyaz renkli ve <strong>termoplastik malzemeden</strong> üretilmiş modern bir üründür. <em>Yavaş kapanma (soft-close)</em> özelliği sayesinde sessiz ve güvenli kullanım sunar. <strong>Kare formu</strong> ve modern tasarımıyla banyonuza estetik bir dokunuş katar. <strong>Üstten montaj</strong> sistemiyle kolayca çıkarılıp takılabilir, bu da temizlik işlemlerini oldukça pratik hale getirir.</p>\n<h4>Ürün Özellikleri<strong></strong>\n</h4>\n<ul>\n<li>\n<strong>Şekil:</strong> Kare</li>\n<li>\n<strong>Kapanma Özelliği:</strong> Yavaş kapanma (soft-close)</li>\n<li>\n<strong>Montaj Tipi:</strong> Üstten montaj (tak-çıkar özellikli)</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit TP326 ve Lara serisi klozetlerle uyumludur</li>\n</ul>\n<h4>Hijyen ve Temizlik</h4>\n<p><strong>Termoplastik</strong> malzeme, yüksek dayanıklılığı ve kolay temizlenebilir yapısıyla öne çıkar. <strong>Üstten montaj</strong> sistemi sayesinde klozet kapağı kolaylıkla sökülüp yeniden monte edilebilir, bu da temizlik işlemlerini oldukça basit hale getirir. <strong>Yavaş kapanma</strong> özelliği sayesinde kapağın sert çarpmasını önleyerek sessiz ve konforlu bir kullanım sunar.</p>\n<p><span style=\"font-family: Calibri;\"><strong>NOT:</strong> Bu klozet kapağı, yukarıda belirtilen klozet modelleriyle uyumlu olarak tasarlanmıştır. Siparişinizi oluştururken bu bilgileri dikkate almanız, doğru ürün seçimi yapmanıza yardımcı olur. Hijyen koşulları gereği, <b>streç ambalajı açılmış klozet kapağı ürünlerinde iade kabul edilmemektedir.</b> Sipariş öncesinde uyumluluk bilgisini kontrol etmenizi rica ederiz.</span><!--?xml:namespace prefix = \"o\" ns = \n\"urn:schemas-microsoft-com:office:office\" /--></p>"
  },
  {
    "id": "creavit-8760268882217",
    "brand": "Creavit",
    "title": "Duck Thermoplast Yavaş Kapanan Klozet Kapağı Beyaz",
    "category": "Thermoplast Klozet Kapakları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-thermoplast-yavas-kapanan-klozet-kapagi-beyaz-4449.png?v=1747729706",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-thermoplast-yavas-kapanan-klozet-kapagi-beyaz-4449.png?v=1747729706",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-thermoplast-yavas-kapanan-klozet-kapagi-beyaz-4450.jpg?v=1747729706",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-thermoplast-yavas-kapanan-klozet-kapagi-beyaz-4451.jpg?v=1747729706",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-thermoplast-yavas-kapanan-klozet-kapagi-beyaz-4452.png?v=1747729706"
    ],
    "price": "1512.00",
    "sku": "KC0903.03.0000E",
    "tags": [
      "Beyaz",
      "duck",
      "kapak",
      "klozet kapağı",
      "tak-çıkar",
      "thermoplast",
      "yavaş kapama",
      "yaz-25-indirim",
      "Yuvarlak"
    ],
    "variants": [
      {
        "id": 52920969134377,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KC0903.03.0000E",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "1512.00",
        "grams": 0,
        "compare_at_price": "2160.00",
        "position": 1,
        "product_id": 8760268882217,
        "created_at": "2026-04-03T12:16:17+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<h5>Creavit Duck Yavaş Kapanan Klozet Kapağı - Beyaz (KC0903.03.0000E)</h5>\n<p><strong>Creavit KC0903.03.0000E</strong> klozet kapağı, Creavit'in <strong>Duck serisine</strong> ait, beyaz renkli ve <strong>termoplastik malzemeden</strong> üretilmiş bir üründür. <em>Yavaş kapanma (soft-close)</em> özelliği sayesinde sessiz ve güvenli bir kullanım sunar. <strong>Üstten montaj sistemi</strong> ile kolayca takılıp çıkarılabilir ve temizliği oldukça pratiktir.</p>\n<h5>🛠️ Ürün Özellikleri<strong></strong>\n</h5>\n<ul>\n<li>\n<strong>Menteşe Türü:</strong> Plastik menteşe</li>\n<li>\n<strong>Montaj Tipi:</strong> Üstten montaj (tak-çıkar özellikli)</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit Free ve TP325 serisi klozetlerle uyumludur</li>\n</ul>\n<h5>🧼 Hijyen ve Temizlik</h5>\n<p><strong>Termoplastik</strong> malzeme, dayanıklılığı ve kolay temizlenebilirliği ile öne çıkar. <strong>Üstten montaj</strong> sistemi sayesinde klozet kapağı rahatça çıkarılıp yeniden takılabilir, bu da temizlik işlemlerini oldukça kolaylaştırır. <strong>Yavaş kapanma</strong> özelliği, kapağın klozete çarparak zarar verme riskini ortadan kaldırır ve sessiz bir kullanım sağlar.</p>"
  },
  {
    "id": "creavit-8760222220585",
    "brand": "Creavit",
    "title": "Tefen Duroplast Yavaş Kapanan Klozet Kapağı Beyaz",
    "category": "Duroplast Klozet Kapakları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tefen-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4445.jpg?v=1747806451",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tefen-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4445.jpg?v=1747806451",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tefen-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4444.jpg?v=1747806451",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tefen-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4443.png?v=1747806451"
    ],
    "price": "3360.00",
    "sku": "KC2203.01.0000E",
    "tags": [
      "Beyaz",
      "duroplast",
      "kapak",
      "klozet kapağı",
      "tak-çıkar",
      "Tefen",
      "yavaş kapama",
      "yaz-25-indirim",
      "Yuvarlak"
    ],
    "variants": [
      {
        "id": 52938836967721,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KC2203.01.0000E",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3360.00",
        "grams": 0,
        "compare_at_price": "4800.00",
        "position": 1,
        "product_id": 8760222220585,
        "created_at": "2026-04-06T21:54:17+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<h3>Creavit Tefen Serisi Yavaş Kapanan Klozet Kapağı - Beyaz (KC2203.01.0000E)</h3>\n<p><strong>Creavit KC2203.01.0000E</strong> model koduna sahip klozet kapağı, Creavit'in <strong>Tefen serisine</strong> ait, beyaz renkli ve antibakteriyel özellik taşıyan bir üründür. Yavaş kapanma (<em>soft-close</em>) teknolojisiyle donatılmış bu klozet kapağı, kullanıcı deneyimini iyileştirmek ve banyo hijyenini artırmak amacıyla tasarlanmıştır.</p>\n<h3>🛠️ Ürün Özellikleri</h3>\n<ul>\n<li>\n<strong>Model Kodu:</strong> KC2203.01.0000E</li>\n<li>\n<strong>Seri:</strong> Tefen</li>\n<li>\n<strong>Renk:</strong> Beyaz</li>\n<li>\n<strong>Malzeme:</strong> Duroplast (antibakteriyel)</li>\n<li>\n<strong>Ölçüler:</strong> Yaklaşık 360 x 445 mm (Genişlik x Derinlik)</li>\n<li>\n<strong>Kapanma Özelliği:</strong> Yavaş kapanma (soft-close)</li>\n<li>\n<strong>Menteşe Türü:</strong> Metal menteşe</li>\n<li>\n<strong>Uyumluluk:</strong> Vitroya, Selin, TP325 ve Letoon serisi klozetlerle uyumludur</li>\n<li>\n<strong>Montaj Tipi:</strong> Üstten montaj (tak-çıkar özellikli)</li>\n<li>\n<strong>Ağırlık:</strong> Yaklaşık 2,52 kg</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\n<h3>🔧 Montaj</h3>\n<p>Bu klozet kapağı, <strong>üstten montaj</strong> sistemiyle kolayca çıkarılıp takılabilir. <strong>Metal menteşe</strong> sistemi sayesinde uzun ömürlü ve sağlam bir kullanım sunar.</p>\n<h3>🧼 Hijyen ve Temizlik</h3>\n<p><strong>Duroplast</strong> malzeme, <strong>antibakteriyel</strong> özellikleri sayesinde bakteri ve mikropların üremesini engeller. Bu da klozet kapağının daha hijyenik ve temiz kalmasını sağlar. Ayrıca, <strong>yavaş kapanma özelliği</strong> sayesinde kapağın klozete çarparak zarar verme riski ortadan kalkar.</p>"
  },
  {
    "id": "creavit-8760207278377",
    "brand": "Creavit",
    "title": "Lara Duroplast Yavaş Kapanan Klozet Kapağı Mat Siyah",
    "category": "Duroplast Klozet Kapakları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-duroplast-yavas-kapanan-klozet-kapagi-mat-siyah-4439.png?v=1747806456",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-duroplast-yavas-kapanan-klozet-kapagi-mat-siyah-4439.png?v=1747806456",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-duroplast-yavas-kapanan-klozet-kapagi-mat-siyah-4440.jpg?v=1747806456",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-duroplast-yavas-kapanan-klozet-kapagi-mat-siyah-4441.jpg?v=1747806456",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-duroplast-yavas-kapanan-klozet-kapagi-mat-siyah-4442.jpg?v=1747806456"
    ],
    "price": "5355.00",
    "sku": "KC1603.01.1400E",
    "tags": [
      "duroplast",
      "kapak",
      "Kare",
      "klozet kapağı",
      "Lara",
      "Mat Siyah",
      "tak-çıkar",
      "yavaş kapama",
      "yaz-25-indirim"
    ],
    "variants": [
      {
        "id": 52920969036073,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KC1603.01.1400E",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5355.00",
        "grams": 0,
        "compare_at_price": "10500.00",
        "position": 1,
        "product_id": 8760207278377,
        "created_at": "2026-04-03T12:16:14+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<h2>KC1603.01.1400E Ürün Özellikleri</h2>\n<ul>\n<li>\n<strong>Ürün Türü:</strong> Klozet kapağı</li>\n<li>\n<strong>Marka:</strong> Creavit (Lara Serisi)</li>\n<li>\n<strong>Malzeme:</strong> Duroplast (dayanıklı ve kaliteli plastik)</li>\n<li>\n<strong>Renk:</strong> Mat siyah</li>\n<li>\n<strong>Özellikler:</strong> \n<ul>\n<li>Yavaş kapanan (Soft Close) mekanizma</li>\n<li>Tak-Çıkar (Plug-in) montaj sistemi</li>\n<li>Antibakteriyel yüzey</li>\n</ul>\n</li>\n<li>\n<strong>Boyutlar:</strong> \n<ul>\n<li>Genişlik: 340 mm</li>\n<li>Uzunluk: 357 mm</li>\n</ul>\n</li>\n<li>\n<strong>Uyumluluk:</strong> Lara Serisi Siyah Renk Klozetler ile Uyumludur.</li>\n</ul>"
  },
  {
    "id": "creavit-8758459334953",
    "brand": "Creavit",
    "title": "Duck Duroplast Yavaş Kapanan Klozet Kapağı Mat Cappuccino",
    "category": "Duroplast Klozet Kapakları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-mat-cappuccino-4435.png?v=1747806462",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-mat-cappuccino-4435.png?v=1747806462",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-mat-cappuccino-4436.jpg?v=1747806462",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-mat-cappuccino-4437.jpg?v=1747806462",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-mat-cappuccino-4438.png?v=1747248217"
    ],
    "price": "7350.00",
    "sku": "KC0903.01.0800E",
    "tags": [
      "duck",
      "duroplast",
      "kapak",
      "klozet kapağı",
      "Mat Cappuccino",
      "tak-çıkar",
      "yavaş kapama",
      "yaz-25-indirim",
      "Yuvarlak"
    ],
    "variants": [
      {
        "id": 52843246125353,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KC0903.01.0800E",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7350.00",
        "grams": 0,
        "compare_at_price": "10500.00",
        "position": 1,
        "product_id": 8758459334953,
        "created_at": "2026-03-17T13:05:15+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<h3>Creavit Duck Duroplast Yavaş Kapanan Klozet Kapağı Mat Cappuccino (KC0903.01.0800E)</h3>\n<p>Creavit'in Duck serisine ait modern ve şık bir klozet kapağıdır. Mat cappuccino rengiyle banyonuza estetik bir dokunuş katarken, antibakteriyel Duroplast malzemesi sayesinde hijyenik bir kullanım sunar. Yavaş kapanma özelliği ile sessiz ve güvenli bir deneyim sağlar.</p>\n<hr>\n<h3>🔧 Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> KC0903.01.0800E</li>\n<li>\n<strong>Seri:</strong> Duck</li>\n<li>\n<strong>Malzeme:</strong> Antibakteriyel Duroplast</li>\n<li>\n<strong>Renk:</strong> Mat Cappuccino</li>\n<li>\n<strong>Şekil:</strong> Oval</li>\n<li>\n<strong>Ölçüler:</strong> 445 x 360 mm</li>\n<li>\n<strong>Ağırlık:</strong> 2,55 kg</li>\n<li>\n<strong>Yavaş Kapanma:</strong> Evet (Soft Close)</li>\n<li>\n<strong>Amortisör:</strong> Mevcut</li>\n<li>\n<strong>Montaj:</strong> Üstten sıkmalı, tak-çıkar özellikli</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit Free serisi klozetlerle uyumlu</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 Yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\n<hr>\n<h3>🛠️ Ürün Özellikleri</h3>\n<ul>\n<li>\n<strong>Yavaş Kapanma Özelliği:</strong> Kapağın sessiz ve yavaş kapanmasını sağlayarak çarpmaları ve gürültüyü engeller.</li>\n<li>\n<strong>Antibakteriyel Duroplast Malzeme:</strong> Bakteri ve mikroplara karşı dirençli, hijyenik kullanım sunar.</li>\n<li>\n<strong>Kolay Montaj ve Temizlik:</strong> Üstten sıkmalı sistemi sayesinde kolay kurulum ve temizlik sırasında kapağın çıkarılabilir olması ile pratik kullanım sağlar.</li>\n<li>\n<strong>Dayanıklı Yapı:</strong> Duroplast malzeme, çizilmelere ve darbelere karşı yüksek direnç gösterir.</li>\n</ul>"
  },
  {
    "id": "creavit-8758453600553",
    "brand": "Creavit",
    "title": "Duck Duroplast Yavaş Kapanan Klozet Kapağı Mat Antrasit",
    "category": "Duroplast Klozet Kapakları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-mat-antrasit-4431.png?v=1747806467",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-mat-antrasit-4431.png?v=1747806467",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-mat-antrasit-4433.jpg?v=1747806467",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-mat-antrasit-4432.png?v=1747806467",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-mat-antrasit-4434.jpg?v=1747806467"
    ],
    "price": "7350.00",
    "sku": "KC0903.01.0400E",
    "tags": [
      "duck",
      "duroplast",
      "kapak",
      "klozet kapağı",
      "Mat Antrasit",
      "tak-çıkar",
      "yavaş kapama",
      "yaz-25-indirim",
      "Yuvarlak"
    ],
    "variants": [
      {
        "id": 52843279024425,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KC0903.01.0400E",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7350.00",
        "grams": 0,
        "compare_at_price": "10500.00",
        "position": 1,
        "product_id": 8758453600553,
        "created_at": "2026-03-17T13:13:15+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<h4>Creavit Duck Duroplast Yavaş Kapanan Mat Antrasit Klozet Kapağı (KC0903.01.0400E)</h4>\n<p>Creavit'in <strong>Duck</strong> serisine ait bu modern klozet kapağı, şık <strong>mat antrasit</strong> rengiyle banyonuza estetik bir dokunuş katarken, fonksiyonelliği ile de öne çıkar. <strong>Antibakteriyel Duroplast</strong> malzeme ile üretilmiş olan bu ürün, dayanıklılığı ve hijyenik yapısıyla dikkat çeker. <strong>Yavaş kapanma</strong> özelliği sayesinde sessiz ve güvenli bir kullanım sunar.</p>\n<ul>\n<li>\n<strong>Montaj:</strong> Üstten sıkmalı, tak-çıkar özellikli</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit Free serisi klozetlerle uyumlu</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 Yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>"
  },
  {
    "id": "creavit-8758434005289",
    "brand": "Creavit",
    "title": "Çınar Duroplast Yavaş Kapanan Klozet Kapağı Beyaz",
    "category": "Duroplast Klozet Kapakları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/cinar-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4428.png?v=1748943764",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/cinar-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4428.png?v=1748943764",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/cinar-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4430.jpg?v=1748943764",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/cinar-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4429.jpg?v=1747806474"
    ],
    "price": "3150.00",
    "sku": "KC0703.01.0000E",
    "tags": [
      "Beyaz",
      "duroplast",
      "kapak",
      "klozet kapağı",
      "tak-çıkar",
      "yavaş kapama",
      "yaz-25-indirim",
      "Yuvarlak",
      "Çınar"
    ],
    "variants": [
      {
        "id": 52920968872233,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KC0703.01.0000E",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3150.00",
        "grams": 0,
        "compare_at_price": "4500.00",
        "position": 1,
        "product_id": 8758434005289,
        "created_at": "2026-04-03T12:16:11+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<h3>Creavit Çınar Duroplast Yavaş Kapanan Klozet Kapağı (KC0703.01.0000E)</h3>\n<p>Creavit'in <strong>Çınar serisine</strong> ait bu modern ve fonksiyonel klozet kapağı, banyonuza hem estetik hem de pratik bir dokunuş kazandırır. <strong>Yavaş kapanma (soft close)</strong> özelliği sayesinde sessiz ve güvenli bir kullanım sağlar. <strong>Antibakteriyel Duroplast</strong> malzemeden üretilmiş olup, dayanıklılığı ve hijyenik yapısıyla öne çıkar.</p>\n<hr>\n<h3>🔧 Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> KC0703.01.0000E</li>\n<li>\n<strong>Seri:</strong> Çınar</li>\n<li>\n<strong>Malzeme:</strong> Antibakteriyel Duroplast</li>\n<li>\n<strong>Renk:</strong> Beyaz</li>\n<li>\n<strong>Şekil:</strong> Yuvarlak</li>\n<li>\n<strong>Ölçüler:</strong> 427 x 345 mm</li>\n<li>\n<strong>Ağırlık:</strong> 2,85 kg</li>\n<li>\n<strong>Menteşe Malzemesi:</strong> Metal</li>\n<li>\n<strong>Yavaş Kapanma:</strong> Evet (soft close)</li>\n<li>\n<strong>Amortisör:</strong> Mevcut</li>\n<li>\n<strong>Montaj:</strong> Üstten sıkmalı, tak-çıkar özellikli</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit Sedef, Pitta, TP330, TP340, BD305, BD315, Corner ve TP320 serisi klozetlerle uyumludur.</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 Yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\n<hr>\n<h3>🛠️ Ürün Özellikleri</h3>\n<ul>\n<li>\n<strong>Yavaş Kapanma Özelliği:</strong> Kapağın yavaş ve sessiz bir şekilde kapanmasını sağlar, ani çarpmaları ve gürültüyü engeller.</li>\n<li>\n<strong>Antibakteriyel Duroplast Malzeme:</strong> Bakteri ve mikropların üremesini önleyerek hijyenik bir kullanım sunar.</li>\n<li>\n<strong>Kolay Montaj ve Temizlik:</strong> Üstten sıkmalı montaj sistemi sayesinde kurulumu kolaydır ve temizlik sırasında kapağın kolayca çıkarılmasına olanak tanır.</li>\n<li>\n<strong>Dayanıklı Metal Menteşeler:</strong> Uzun ömürlü kullanım için sağlam metal menteşelerle donatılmıştır.</li>\n</ul>\n<hr>\n<p><strong>Creavit Çınar klozet kapağı</strong>, şıklığı ve fonksiyonelliği bir arada sunarak banyonuza değer katacak ideal bir tercihtir.</p>"
  },
  {
    "id": "creavit-8758412083497",
    "brand": "Creavit",
    "title": "Lara Duroplast Yavaş Kapanan Klozet Kapağı Beyaz",
    "category": "Duroplast Klozet Kapakları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4420.png?v=1756907605",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4420.png?v=1756907605",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4422.jpg?v=1756907605",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lara-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4421.jpg?v=1747806494"
    ],
    "price": "3150.00",
    "sku": "KC1603.01.0000E",
    "tags": [
      "Beyaz",
      "duroplast",
      "kapak",
      "Kare",
      "klozet kapağı",
      "Lara",
      "tak-çıkar",
      "yavaş kapama",
      "yaz-25-indirim"
    ],
    "variants": [
      {
        "id": 52936374124841,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KC1603.01.0000E",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3150.00",
        "grams": 0,
        "compare_at_price": "4500.00",
        "position": 1,
        "product_id": 8758412083497,
        "created_at": "2026-04-06T11:18:08+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<h4>Creavit Lara Duroplast Yavaş Kapanan Klozet Kapağı – KC1603.01.0000E</h4>\n<p><strong>Creavit'in Lara serisine ait, modern ve fonksiyonel bir klozet kapağıdır.</strong> Yavaş kapanma özelliği sayesinde sessiz ve güvenli bir kullanım sunar. Duroplast malzeme dayanıklı ve hijyenik yapısıyla öne çıkar.</p>\n<h4>Teknik Özellikler<strong></strong>\n</h4>\n<ul>\n<li>\n<strong>Malzeme:</strong> Duroplast (antibakteriyel)</li>\n<li>\n<strong>Ölçüler:</strong> 450 × 357 mm</li>\n<li>\n<strong>Yavaş Kapanma:</strong> Evet (soft close)</li>\n<li>\n<strong>Amortisör:</strong> Mevcut</li>\n<li>\n<strong>Montaj:</strong> Üstten sıkmalı, tak-çıkar</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit Lara, TP326 ve Nova serisi klozetlerle uyumlu</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n</ul>\n<p>Yavaş kapanma mekanizması sessiz kullanım sağlar. Duroplast malzeme dayanıklı ve kolay temizlenebilir. Üstten sıkmalı montaj sistemi ile kurulum ve temizlik kolaydır. Creavit Lara, TP326 ve Nova serisi klozetlerle tam uyumludur.</p>"
  },
  {
    "id": "creavit-8758400713001",
    "brand": "Creavit",
    "title": "Amasra Ultima Duroplast Yavaş Kapanan Klozet Kapağı Beyaz",
    "category": "Duroplast Klozet Kapakları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/amasra-ultima-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4419.jpg?v=1747806500",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/amasra-ultima-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4419.jpg?v=1747806500",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/amasra-ultima-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4417.png?v=1747806500",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/amasra-ultima-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4418.jpg?v=1747806500"
    ],
    "price": "2940.00",
    "sku": "KC0103.03.0000E",
    "tags": [
      "Amasra Ultima",
      "Beyaz",
      "duroplast",
      "kapak",
      "klozet kapağı",
      "tak-çıkar",
      "yavaş kapama",
      "yaz-25-indirim",
      "Yuvarlak"
    ],
    "variants": [
      {
        "id": 52921481527593,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KC0103.03.0000E",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2940.00",
        "grams": 0,
        "compare_at_price": "4200.00",
        "position": 1,
        "product_id": 8758400713001,
        "created_at": "2026-04-03T14:43:46+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<h4>Creavit Amasra Ultima Yavaş Kapanan Klozet Kapağı – KC0103.03.0000E</h4>\n<p><strong>Creavit'in Amasra serisine ait, modern ve fonksiyonel bir klozet kapağıdır.</strong> Yavaş kapanma özelliği sayesinde sessiz ve güvenli bir kullanım sunar. Duroplast malzemeden üretilmiş olup, dayanıklılığı ve hijyenik yapısıyla dikkat çeker.</p>\n<h4>Teknik Özellikler</h4>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> KC0103.03.0000E</li>\n<li>\n<strong>Seri:</strong> Amasra Ultima</li>\n<li>\n<strong>Malzeme:</strong> Duroplast (antibakteriyel)</li>\n<li>\n<strong>Renk:</strong> Beyaz</li>\n<li>\n<strong>Şekil:</strong> Yuvarlak</li>\n<li>\n<strong>Ölçüler:</strong> 455 × 347 mm</li>\n<li>\n<strong>Ağırlık:</strong> 2,35 kg</li>\n<li>\n<strong>Yavaş Kapanma:</strong> Evet (soft close)</li>\n<li>\n<strong>Amortisör:</strong> Mevcut</li>\n<li>\n<strong>Montaj:</strong> Üstten sıkmalı, tak-çıkar özellikli</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit Vitroya, Selin TP325 ve Free klozet modelleriyle uyumludur</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\n<h4>Ürün Açıklaması</h4>\n<p>Bu klozet kapağı, <strong>yavaş kapanma özelliği</strong> sayesinde sessiz bir kullanım sağlar ve klozete zarar vermeden kapanır. <strong>Duroplast malzeme</strong>, dayanıklılığı ve kolay temizlenebilirliği ile öne çıkar. <strong>Üstten sıkmalı montaj sistemi</strong>, kurulumu kolaylaştırır ve temizlik sırasında kapağın kolayca çıkarılmasına olanak tanır.</p>\n<p>Creavit Vitroya, Selin, TP325 ve Free serisi modellerle <strong>tam uyumlu</strong> olan bu ürün, banyonuza <strong>şıklık ve fonksiyonellik</strong> katmak için ideal bir tercihtir.</p>\n\n\n\n\n\n\n\n"
  },
  {
    "id": "creavit-8758392455465",
    "brand": "Creavit",
    "title": "Duck Duroplast Yavaş Kapanan Klozet Kapağı Beyaz",
    "category": "Duroplast Klozet Kapakları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4410.png?v=1748941622",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4410.png?v=1748941622",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4413.png?v=1748941622",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4411.jpg?v=1748941622",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4412.png?v=1748941622",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4415.png?v=1747806512",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/duck-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4416.png?v=1747806512"
    ],
    "price": "3150.00",
    "sku": "KC0903.02.0000E",
    "tags": [
      "Beyaz",
      "duck",
      "duroplast",
      "kapak",
      "klozet kapağı",
      "tak-çıkar",
      "yavaş kapama",
      "yaz-25-indirim",
      "Yuvarlak"
    ],
    "variants": [
      {
        "id": 52920968479017,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KC0903.02.0000E",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3150.00",
        "grams": 0,
        "compare_at_price": "4500.00",
        "position": 1,
        "product_id": 8758392455465,
        "created_at": "2026-04-03T12:16:04+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\">\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\">\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<h4>Creavit Duck Yavaş Kapanan Klozet Kapağı – KC0903.02.0000E</h4>\n<p>Creavit'in <strong>Duck</strong> serisine ait olan <strong>KC0903.02.0000E</strong> kodlu klozet kapağı, modern tasarımı ve dayanıklı yapısıyla banyonuza şıklık katmak için ideal bir tercihtir. <strong>Yavaş kapanma</strong> özelliği sayesinde sessiz ve güvenli bir kullanım sunar. <strong>Duroplast</strong> malzemeden üretilmiştir, bu da ürünü hem dayanıklı hem de hijyenik kılar.</p>\n<h4>Teknik Özellikler</h4>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> KC0903.02.0000E</li>\n<li>\n<strong>Seri:</strong> Duck</li>\n<li>\n<strong>Malzeme:</strong> Duroplast</li>\n<li>\n<strong>Renk:</strong> Beyaz</li>\n<li>\n<strong>Şekil:</strong> Yuvarlak</li>\n<li>\n<strong>Ölçüler:</strong> 445 × 360 mm</li>\n<li>\n<strong>Ağırlık:</strong> 2,55 kg</li>\n<li>\n<strong>Yavaş Kapanma:</strong> Evet</li>\n<li>\n<strong>Amortisör:</strong> Mevcut</li>\n<li>\n<strong>Montaj:</strong> Üstten sıkmalı, tak-çıkar özelliği ile kolay montaj</li>\n<li>\n<strong>Uyumluluk:</strong> Creavit Free ve TP325 serisi klozetlerle uyumludur</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\n<h4>Ürün Açıklaması</h4>\n<p>Bu klozet kapağı, <strong>yavaş kapanma özelliği</strong> sayesinde sessiz bir kullanım sağlar ve klozete zarar vermeden kapanır. <strong>Duroplast</strong> malzemesi sayesinde uzun ömürlüdür ve kolay temizlenebilir. Üstten sıkmalı montaj sistemi sayesinde kapağın kurulumu pratik olup, temizlik sırasında çıkarılması da oldukça kolaydır.</p>\n<p><strong>Creavit Free</strong> ve <strong>TP325 serisi</strong> klozetlerle tam uyumludur ve banyonuzda hem estetik hem de işlevsel bir çözüm sunar.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8758383837481",
    "brand": "Creavit",
    "title": "Elegant Duroplast Yavaş Kapanan Klozet Kapağı Beyaz",
    "category": "Duroplast Klozet Kapakları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4404.png?v=1747806518",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4404.png?v=1747806518",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4409.jpg?v=1747806518",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4406.jpg?v=1747806518",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4405.jpg?v=1747806518",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4408.jpg?v=1747806518",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elegant-duroplast-yavas-kapanan-klozet-kapagi-beyaz-4407.jpg?v=1747248528"
    ],
    "price": "3360.00",
    "sku": "KC1103.01.0000E",
    "tags": [
      "Beyaz",
      "duroplast",
      "elegant",
      "kapak",
      "Kare",
      "klozet kapağı",
      "tak-çıkar",
      "yavaş kapama",
      "yaz-25-indirim"
    ],
    "variants": [
      {
        "id": 52921481265449,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KC1103.01.0000E",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3360.00",
        "grams": 0,
        "compare_at_price": "4800.00",
        "position": 1,
        "product_id": 8758383837481,
        "created_at": "2026-04-03T14:43:42+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<h4>Creavit Elegant Yavaş Kapanan Klozet Kapağı – KC1103.01.0000E</h4>\n<p>Creavit'in <strong>Elegant</strong> serisine ait, modern ve fonksiyonel tasarımıyla öne çıkan bu klozet kapağı, <strong>yavaş kapanma</strong> özelliği sayesinde sessiz ve güvenli bir kullanım sunar. <strong>Duroplast</strong> malzeme yapısı ile dayanıklı ve hijyeniktir.</p>\n<h4>Teknik Özellikler</h4>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> KC1103.01.0000E</li>\n<li>\n<strong>Seri:</strong> Elegant</li>\n<li>\n<strong>Malzeme:</strong> Duroplast</li>\n<li>\n<strong>Renk:</strong> Beyaz</li>\n<li>\n<strong>Şekil:</strong> Oval</li>\n<li>\n<strong>Ölçüler:</strong> 448 × 368 mm</li>\n<li>\n<strong>Menteşe Malzemesi:</strong> Krom kaplı pirinç</li>\n<li>\n<strong>Yavaş Kapanma:</strong> Evet</li>\n<li>\n<strong>Amortisör:</strong> Mevcut</li>\n<li>\n<strong>Montaj:</strong> Üstten sıkmalı, tak-çıkar kolay montaj</li>\n<li>\n<strong>Uyumluluk:</strong> Sadece Creavit Elegant serisi klozetlerle uyumlu</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 Yıl</li>\n<li>\n<strong>Üretim Yeri:</strong> Türkiye</li>\n</ul>\n<h4>Ürün Açıklaması</h4>\n<p>Bu klozet kapağı, <strong>yavaş kapanma mekanizması</strong> sayesinde sessiz ve nazikçe kapanır, böylece hem güvenlik sağlar hem de klozetinize zarar vermez. <strong>Duroplast</strong> malzeme sayesinde uzun ömürlü kullanım ve kolay temizlik imkânı sunar.</p>\n<p><strong>Krom kaplı pirinç menteşeler</strong> dayanıklılığı artırırken, <strong>üstten sıkmalı montaj sistemi</strong> sayesinde ürün kolayca monte edilir ve temizlik sırasında rahatlıkla çıkarılabilir.</p>\n<p><strong>Creavit Elegant serisi klozetlerle tam uyumlu</strong> olan bu ürün, banyonuzda hem estetik hem de fonksiyonellik arayanlar için ideal bir tercihtir.</p>"
  },
  {
    "id": "creavit-8758338158889",
    "brand": "Creavit",
    "title": "Sharp Mutfak Armatürü Mat Siyah",
    "category": "Mutfak Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-mutfak-armaturu-mat-siyah-4400.png?v=1747223931",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-mutfak-armaturu-mat-siyah-4400.png?v=1747223931",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-mutfak-armaturu-mat-siyah-4402.jpg?v=1747223935",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-mutfak-armaturu-mat-siyah-4401.jpg?v=1747223939",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-mutfak-armaturu-mat-siyah-4403.jpg?v=1747223941"
    ],
    "price": "10935.00",
    "sku": "BT.SR8500S",
    "tags": [
      "Armatür",
      "Mat Siyah",
      "mutfak",
      "Mutfak Armatürü",
      "Sharp",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843226923305,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.SR8500S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "10935.00",
        "grams": 0,
        "compare_at_price": "14580.00",
        "position": 1,
        "product_id": 8758338158889,
        "created_at": "2026-03-17T12:58:40+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>İnce çizgileriyle armatüre farklı ve yenilikçi bir şekilde yaklaşan Sharp Armatür ailesi ile hijyen deneyiminiz estetikle birleşti. Sharp Mutfak Armatürünün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizmasi, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle mutfak deneyiminiz daha keyifli hale gelecek. Ayrıca döner borulu yapısı bulaşık yıkarken ve lavabo temizliğinde kolaylık sağlar. Creavit armatürleri gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>"
  },
  {
    "id": "creavit-8758326198569",
    "brand": "Creavit",
    "title": "Slope Mutfak Armatürü Krom",
    "category": "Mutfak Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/slope-mutfak-armaturu-krom-4397.png?v=1747223915",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/slope-mutfak-armaturu-krom-4397.png?v=1747223915",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/slope-mutfak-armaturu-krom-4399.jpg?v=1747223917",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/slope-mutfak-armaturu-krom-4398.jpg?v=1747223922"
    ],
    "price": "9315.00",
    "sku": "BT.SP8502",
    "tags": [
      "Armatür",
      "krom",
      "mutfak",
      "Mutfak Armatürü",
      "Slope",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843218829609,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.SP8502",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9315.00",
        "grams": 0,
        "compare_at_price": "12420.00",
        "position": 1,
        "product_id": 8758326198569,
        "created_at": "2026-03-17T12:55:48+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-vfjev-79elbk h-full dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-vfjev-1n7m0yu\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-col text-sm dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"group w-full text-gray-800 dark:text-gray-100 border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-mce-fragment=\"1\">\r\n<div class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\" data-mce-fragment=\"1\">\r\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-grow flex-col gap-3\" data-mce-fragment=\"1\">\r\n<div class=\"min-h-[20px] flex items-start overflow-x-auto whitespace-pre-wrap break-words\" data-mce-fragment=\"1\">\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p>İnce çizgileriyle armatüre farklı ve yenilikçi bir şekilde yaklaşan Slope Armatür ailesi ile hijyen deneyiminiz estetikle birleşti. Slope Mutfak Armatürünün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizmasi, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle mutfak deneyiminiz daha keyifli hale gelecek. Ayrıca döner borulu yapısı bulaşık yıkarken ve lavabo temizliğinde kolaylık sağlar. Creavit armatürleri gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>\n</div>\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\"><strong>Not: Slope armatür ailesinde mutlaka FA002 filtreli ara musluk kullanılmalıdır.</strong></div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8757444346153",
    "brand": "Creavit",
    "title": "Pure Mutfak Armatürü Krom",
    "category": "Mutfak Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pure-mutfak-armaturu-krom-4385.png?v=1747223862",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pure-mutfak-armaturu-krom-4385.png?v=1747223862",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pure-mutfak-armaturu-krom-4387.jpg?v=1747223865",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pure-mutfak-armaturu-krom-4386.jpg?v=1747223868"
    ],
    "price": "7875.00",
    "sku": "BT.PR8501",
    "tags": [
      "Armatür",
      "Krom",
      "mutfak",
      "Mutfak Armatürü",
      "pure",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843218272553,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.PR8501",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7875.00",
        "grams": 0,
        "compare_at_price": "10500.00",
        "position": 1,
        "product_id": 8757444346153,
        "created_at": "2026-03-17T12:55:38+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Yalın çizgileriyle armatüre farklı ve yenilikçi bir şekilde yaklaşan Pure Armatür ailesi ile hijyen deneyiminiz estetikle birleşti. Pure Mutfak Armatürünün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizmasi, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle mutfak deneyiminiz daha keyifli hale gelecek. Ayrıca döner borulu yapısı bulaşık yıkarken ve lavabo temizliğinde kolaylık sağlar. Creavit armatürleri gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p><!---->"
  },
  {
    "id": "creavit-8757441069353",
    "brand": "Creavit",
    "title": "Nero Mutfak Armatürü Krom",
    "category": "Mutfak Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/nero-mutfak-armaturu-krom-4380.png?v=1747223847",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/nero-mutfak-armaturu-krom-4380.png?v=1747223847",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/nero-mutfak-armaturu-krom-4382.jpg?v=1747223850",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/nero-mutfak-armaturu-krom-4381.jpg?v=1747223853"
    ],
    "price": "6000.00",
    "sku": "BT.NR8500",
    "tags": [
      "Armatür",
      "krom",
      "mutfak",
      "Mutfak Armatürü",
      "Nero",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843218043177,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.NR8500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6000.00",
        "grams": 0,
        "compare_at_price": "8000.00",
        "position": 1,
        "product_id": 8757441069353,
        "created_at": "2026-03-17T12:55:32+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Modern çizgileriyle armatüre farklı ve yenilikçi bir şekilde yaklaşan Nero Armatür ailesi ile hijyen deneyiminiz estetikle birleşti. Nero Mutfak Armatürünün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizmasi, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle mutfak deneyiminiz daha keyifli hale gelecek. Ayrıca döner borulu yapısı bulaşık yıkarken ve lavabo temizliğinde kolaylık sağlar. Creavit armatürleri gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p><!---->"
  },
  {
    "id": "creavit-8757439693097",
    "brand": "Creavit",
    "title": "Spiralli Mutfak Armatürü Krom",
    "category": "Mutfak Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spiralli-mutfak-armaturu-krom-4376.png?v=1747805668",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spiralli-mutfak-armaturu-krom-4376.png?v=1747805668",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spiralli-mutfak-armaturu-krom-4378.jpg?v=1747805668",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spiralli-mutfak-armaturu-krom-4377.jpg?v=1747805668",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spiralli-mutfak-armaturu-krom-4379.jpg?v=1747805668"
    ],
    "price": "13950.00",
    "sku": "BT.MF9910L",
    "tags": [
      "Armatür",
      "krom",
      "mutfak",
      "Mutfak Armatürü",
      "spiralli",
      "Spiralli Mutfak Armatürü",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843241210153,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.MF9910L",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "13950.00",
        "grams": 0,
        "compare_at_price": "18600.00",
        "position": 1,
        "product_id": 8757439693097,
        "created_at": "2026-03-17T13:03:54+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-ezbmi-79elbk h-full dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-ezbmi-1n7m0yu\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-col text-sm dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-mce-fragment=\"1\">\r\n<div class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\" data-mce-fragment=\"1\">\r\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-grow flex-col gap-3\" data-mce-fragment=\"1\">\r\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\" data-mce-fragment=\"1\">\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p><strong>Profesyonel Görünüm ile Her Yöne Özgürlük</strong></p>\r\n<p>Creavit'in suyu maksimum verimle kullanabilmek ve rahat yıkama yapabilmek için geliştirilen spiralli armatür ürün grubu mutfakta profesyonelliği sağlıyor. Uzayabilen hortumu ile spiralli armatürler mutfağınızı daha temiz tutmanıza yardımcı olurken hijyen ve konforu üst seviyede tutarak mutfakta verimliliği arttırıyor. Creavit armatürleri tamamen pirinç malzemeden oluşan yapısıyla; suyun doğallığını, kokusunu ve rengini bozmaz ve uzun yıllar güvenle kullanılabilir.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8751496233257",
    "brand": "Creavit",
    "title": "Spiralli Mutfak Armatürü Mat Siyah",
    "category": "Mutfak Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spiralli-mutfak-armaturu-mat-siyah-4372.png?v=1747805676",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spiralli-mutfak-armaturu-mat-siyah-4372.png?v=1747805676",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spiralli-mutfak-armaturu-mat-siyah-4374.jpg?v=1747805676",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spiralli-mutfak-armaturu-mat-siyah-4373.jpg?v=1747805676",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spiralli-mutfak-armaturu-mat-siyah-4375.jpg?v=1747805676"
    ],
    "price": "12780.00",
    "sku": "BT.MF8858S",
    "tags": [
      "Armatür",
      "krom",
      "mutfak",
      "Mutfak Armatürü",
      "spiralli",
      "Spiralli Mutfak Armatürü",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843258183977,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.MF8858S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "12780.00",
        "grams": 0,
        "compare_at_price": "17040.00",
        "position": 1,
        "product_id": 8751496233257,
        "created_at": "2026-03-17T13:08:53+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p><strong>Profesyonel Görünüm ile Her Yöne Özgürlük</strong></p>\r\n<p>Creavit'in suyu maksimum verimle kullanabilmek ve rahat yıkama yapabilmek için geliştirilen spiralli armatür ürün grubu mutfakta profesyonelliği sağlıyor. Uzayabilen hortumu ile spiralli armatürler mutfağınızı daha temiz tutmanıza yardımcı olurken hijyen ve konforu üst seviyede tutarak mutfakta verimliliği arttırıyor. Creavit armatürleri tamamen pirinç malzemeden oluşan yapısıyla; suyun doğallığını, kokusunu ve rengini bozmaz ve uzun yıllar güvenle kullanılabilir.</p>"
  },
  {
    "id": "creavit-8751482241321",
    "brand": "Creavit",
    "title": "Mutfak Armatürü (Pencere Önü) Krom",
    "category": "Mutfak Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mutfak-armaturu-pencere-onu-krom-4368.png?v=1747238122",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mutfak-armaturu-pencere-onu-krom-4368.png?v=1747238122",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mutfak-armaturu-pencere-onu-krom-4369.jpg?v=1747238125",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mutfak-armaturu-pencere-onu-krom-4370.jpg?v=1747238127",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mutfak-armaturu-pencere-onu-krom-4371.jpg?v=1747238130"
    ],
    "price": "12330.00",
    "sku": "BT.MF8600",
    "tags": [
      "Armatür",
      "Krom",
      "mutfak",
      "Mutfak Armatürü",
      "pencere önü",
      "yaz-30-indirim",
      "öne eğilebilen"
    ],
    "variants": [
      {
        "id": 52843217846569,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.MF8600",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "12330.00",
        "grams": 0,
        "compare_at_price": "16440.00",
        "position": 1,
        "product_id": 8751482241321,
        "created_at": "2026-03-17T12:55:29+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-vfjev-79elbk h-full dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-vfjev-1n7m0yu\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-col text-sm dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"group w-full text-gray-800 dark:text-gray-100 border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-mce-fragment=\"1\">\r\n<div class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\" data-mce-fragment=\"1\">\r\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-grow flex-col gap-3\" data-mce-fragment=\"1\">\r\n<div class=\"min-h-[20px] flex items-start overflow-x-auto whitespace-pre-wrap break-words\" data-mce-fragment=\"1\">\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p><strong>Yeniliklerin Öncüsü Creavit'ten Mutfaklar için Fonksiyonel Çözümler</strong></p>\r\n<p>Creavit'in tüketici alışkanlıklarından yola çıkarak tasarladığı mutfak armatürleri evlerimizdeki yaşamın merkezi olan mutfaklara keyif ve konfor katıyor.</p>\r\n<p>Yenilikçi bakış açısı ile fark yaratan tasarımlara imza atan Creavit, 180 derece <span>öne eğilebilen armatürü ile bulaşık, sebze, meyve yıkama esnasında kolaylık sağlayarak, hijyen ve konforu üst seviyede tutuyor.</span></p>\r\n<p><strong>Pencere Önündeki Engelleri Kaldırın</strong></p>\r\n<p>Zarafeti ve işlevselliği pencere önlerine taşıyan Creavit Pencere Önü Mutfak Armatürü 180 derece<span> öne eğilebilen yapısıyla mutfak pencerenizin tamamen açılmasını sağlar. Böylece mutfağınızın tüm potansiyeli ortaya çıkar.</span><span></span></p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8751474442537",
    "brand": "Creavit",
    "title": "Lua Mutfak Armatürü Metalik Gri",
    "category": "Mutfak Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-selale-mutfak-armaturu-metalik-gri-4362.png?v=1747238102",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-selale-mutfak-armaturu-metalik-gri-4362.png?v=1747238102",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-selale-mutfak-armaturu-metalik-gri-4364.jpg?v=1747238105",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-selale-mutfak-armaturu-metalik-gri-4363.jpg?v=1747238107",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-selale-mutfak-armaturu-metalik-gri-4365.jpg?v=1747238109",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-selale-mutfak-armaturu-metalik-gri-4366.jpg?v=1747238112",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-selale-mutfak-armaturu-metalik-gri-4367.jpg?v=1747238114"
    ],
    "price": "9990.00",
    "sku": "BT.LU8500GR",
    "tags": [
      "Armatür",
      "Lua",
      "Metalik Gri",
      "mutfak",
      "Mutfak Armatürü",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843217715497,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.LU8500GR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9990.00",
        "grams": 0,
        "compare_at_price": "13320.00",
        "position": 1,
        "product_id": 8751474442537,
        "created_at": "2026-03-17T12:55:25+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-vfjev-79elbk h-full dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-vfjev-1n7m0yu\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-col text-sm dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"group w-full text-gray-800 dark:text-gray-100 border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-mce-fragment=\"1\">\r\n<div class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\" data-mce-fragment=\"1\">\r\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-grow flex-col gap-3\" data-mce-fragment=\"1\">\r\n<div class=\"min-h-[20px] flex items-start overflow-x-auto whitespace-pre-wrap break-words\" data-mce-fragment=\"1\">\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p><strong>Creavit Lua Duşta, Banyoda, Mutfakta!</strong></p>\r\n<p>Lua<strong> </strong>Armatür serisi özel olarak tasarlanan ideal su çıkış ucu eğimiyle suyun şelale görünümünde akmasını sağlar. Şık ve minimalist çizgileriyle mutfağınıza sofistike bir dokunuş katar. Lua armatür serisi hızlı ve kolay bir şekilde monte edilir. Standart armatür deliği ölçüleriyle uyumludur. Çoğu lavabo veya tezgaha rahatlıkla takılabilir. Creavit armatürleri gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8751465005353",
    "brand": "Creavit",
    "title": "Lua Mutfak Armatürü Krom",
    "category": "Mutfak Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-selale-mutfak-armaturu-krom-4356.png?v=1747039636",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-selale-mutfak-armaturu-krom-4356.png?v=1747039636",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-selale-mutfak-armaturu-krom-4359.jpg?v=1747039639",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-selale-mutfak-armaturu-krom-4357.jpg?v=1747039641",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-selale-mutfak-armaturu-krom-4358.jpg?v=1747039644",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-selale-mutfak-armaturu-krom-4360.jpg?v=1747039647",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-selale-mutfak-armaturu-krom-4361.jpg?v=1747039650"
    ],
    "price": "7920.00",
    "sku": "BT.LU8500",
    "tags": [
      "Armatür",
      "Krom",
      "Lua",
      "mutfak",
      "Mutfak Armatürü",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843217584425,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.LU8500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7920.00",
        "grams": 0,
        "compare_at_price": "10560.00",
        "position": 1,
        "product_id": 8751465005353,
        "created_at": "2026-03-17T12:55:22+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-vfjev-79elbk h-full dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-vfjev-1n7m0yu\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-col text-sm dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"group w-full text-gray-800 dark:text-gray-100 border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-mce-fragment=\"1\">\r\n<div class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\" data-mce-fragment=\"1\">\r\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-grow flex-col gap-3\" data-mce-fragment=\"1\">\r\n<div class=\"min-h-[20px] flex items-start overflow-x-auto whitespace-pre-wrap break-words\" data-mce-fragment=\"1\">\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p><strong>Creavit Lua Duşta, Banyoda, Mutfakta!</strong></p>\r\n<p>Lua<strong> </strong>Armatür serisi özel olarak tasarlanan ideal su çıkış ucu eğimiyle suyun şelale görünümünde akmasını sağlar. Şık ve minimalist çizgileriyle mutfağınıza sofistike bir dokunuş katar. Lua armatür serisi hızlı ve kolay bir şekilde monte edilir. Standart armatür deliği ölçüleriyle uyumludur. Çoğu lavabo veya tezgaha rahatlıkla takılabilir. Creavit armatürleri gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8751456944425",
    "brand": "Creavit",
    "title": "Flow Mutfak Armatürü Krom",
    "category": "Mutfak Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/flow-mutfak-armaturu-krom-4353.png?v=1747223749",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/flow-mutfak-armaturu-krom-4353.png?v=1747223749",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/flow-mutfak-armaturu-krom-4355.jpg?v=1747223754",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/flow-mutfak-armaturu-krom-4354.jpg?v=1747223757"
    ],
    "price": "8850.00",
    "sku": "BT.FL8500",
    "tags": [
      "Armatür",
      "Flow",
      "Krom",
      "Mutfak Armatürü",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52921481068841,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.FL8500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8850.00",
        "grams": 0,
        "compare_at_price": "11800.00",
        "position": 1,
        "product_id": 8751456944425,
        "created_at": "2026-04-03T14:43:39+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"product-description\">\n<h3>Creavit Flow FL8500 Mutfak Armatürü</h3>\n<p><strong>Creavit Flow FL8500</strong> mutfak armatürü, Creavit'in modern tasarımı ve dayanıklılığıyla öne çıkan bir mutfak bataryasıdır. Hem ev hem de ticari alanlarda kullanım için uygundur.</p>\n<hr>\n<h2>🛠️ Teknik Özellikler</h2>\n<ul>\n<li>\n<strong>Model Kodu:</strong> BT.FL8500</li>\n<li>\n<strong>Seri:</strong> Flow</li>\n<li>\n<strong>Armatür Tipi:</strong> Tek kumandalı mix mutfak bataryası</li>\n<li>\n<strong>Uygulama Alanı:</strong> Mutfak</li>\n<li>\n<strong>Malzeme:</strong> %100 pirinç gövde — korozyona karşı dayanıklı</li>\n<li>\n<strong>Kaplama:</strong> Parlak krom — estetik ve uzun ömürlü</li>\n<li>\n<strong>Çıkış Ucu Uzunluğu:</strong> 184 mm</li>\n<li>\n<strong>Çıkış Ucu Yüksekliği:</strong> 236 mm</li>\n<li>\n<strong>Kartuş:</strong> 35 mm seramik kartuş</li>\n<li>\n<strong>Su Akış Debisi:</strong> 7–8 L/dk</li>\n<li>\n<strong>Montaj Tipi:</strong> Dikey düzlem montajı</li>\n<li>\n<strong>Montaj Aparatları:</strong> 3/8\" -M10- 50 cm fleks hortumlar ve sabitleme aparatları</li>\n<li>\n<strong>Garanti Süresi:</strong> 5 Yıl</li>\n</ul>\n<hr>\n<h2>💡 Öne Çıkan Özellikler</h2>\n<ul>\n<li>\n<strong>Modern ve Şık Tasarım:</strong> Flow serisinin zarif çizgileriyle mutfağınıza estetik katar.</li>\n<li>\n<strong>Dayanıklı Yapı:</strong> Pirinç gövde, suyun tadını ve kokusunu bozmaz.</li>\n<li>\n<strong>Kolay Montaj:</strong> Standart aparatlar ile hızlı ve pratik kurulum.</li>\n<li>\n<strong>Hassas Kontrol:</strong> Seramik kartuş ile sıcaklık ve debi üzerinde tam kontrol.</li>\n<li>\n<strong>Enerji Verimliliği:</strong> Düşük su ve enerji tüketimi.</li>\n</ul>\n<hr>\n<h2>📦 Paket İçeriği</h2>\n<ul>\n<li>Creavit BT.FL8500 Flow Mutfak Armatürü</li>\n<li>3/8\" -M10- 50 cm fleks hortumlar</li>\n<li>Sabitleme aparatları ve vidalar</li>\n<li>Kullanım, montaj ve bakım kılavuzu</li>\n</ul>\n<hr>\n<h2>🏷️ Kullanım Alanları</h2>\n<p>Mutfak</p>\n<hr>\n<p><strong>Creavit BT.FL8500 Flow</strong> mutfak armatürü, zarif tasarımı ve dayanıklı yapısıyla mutfağınıza şıklık ve fonksiyonellik katmak için ideal bir tercihtir. Kolay montajı ve uzun ömürlü performansıyla kullanıcı memnuniyetini ön planda tutar.</p>\n</div>"
  },
  {
    "id": "creavit-8751448523049",
    "brand": "Creavit",
    "title": "Foglia Mutfak Armatürü Krom",
    "category": "Mutfak Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/foglia-mutfak-armaturu-krom-4349.png?v=1747223730",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/foglia-mutfak-armaturu-krom-4349.png?v=1747223730",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/foglia-mutfak-armaturu-krom-4352.jpg?v=1747223734",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/foglia-mutfak-armaturu-krom-4350.jpg?v=1747223737",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/foglia-mutfak-armaturu-krom-4351.jpg?v=1747223741"
    ],
    "price": "14850.00",
    "sku": "BT.FG8501",
    "tags": [
      "Armatür",
      "Foglia",
      "Krom",
      "mutfak",
      "Mutfak Armatürü",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843217289513,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.FG8501",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "14850.00",
        "grams": 0,
        "compare_at_price": "19800.00",
        "position": 1,
        "product_id": 8751448523049,
        "created_at": "2026-03-17T12:55:16+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"product-description\">\n<p><strong>Creavit'in Foglia serisine ait BT.FG8501 Foglia Mutfak Armatürü</strong>, mutfaklarda estetik ve fonksiyonelliği bir araya getiren, ödüllü tasarımıyla dikkat çeken bir armatür modelidir. Tasarımcı Defne Koz tarafından geliştirilen bu model, organik formları ve kullanıcı dostu özellikleriyle öne çıkar.</p>\n<hr>\n<h3>🛠️ Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Model Kodu:</strong> BT.FG8501</li>\n<li>\n<strong>Seri:</strong> Foglia</li>\n<li>\n<strong>Armatür Tipi:</strong> Tek kumandalı mix mutfak bataryası</li>\n<li>\n<strong>Kullanım Alanı:</strong> Mutfak eviyeleri</li>\n<li>\n<strong>Malzeme:</strong> %100 pirinç gövde — korozyona karşı dayanıklı ve uzun ömürlü</li>\n<li>\n<strong>Kaplama:</strong> Parlak krom — estetik ve dayanıklı yüzey</li>\n<li>\n<strong>Çıkış Ucu Uzunluğu:</strong> 211 mm</li>\n<li>\n<strong>Çıkış Ucu Yüksekliği:</strong> 247 mm</li>\n<li>\n<strong>Kartuş:</strong> Uzun ömürlü 25 mm seramik kartuş — hassas sıcaklık ve debi kontrolü sağlar</li>\n<li>\n<strong>Su Akış Debisi:</strong> 7-8 litre/dakika</li>\n<li>\n<strong>Montaj Tipi:</strong> Dikey düzlem montajı</li>\n<li>\n<strong>Garanti Süresi:</strong> 5 yıl</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>\n<strong>Tasarım Ödülü:</strong> Uluslararası tasarım ödüllü, Defne Koz imzalı özgün tasarım</li>\n<li>\n<strong>Ergonomik Kullanım:</strong> Elin doğal hareketleriyle uyumlu, kullanıcı dostu kulp yapısı</li>\n<li>\n<strong>Dayanıklı Yapı:</strong> Pirinç gövde ve seramik kartuş ile uzun ömürlü kullanım</li>\n<li>\n<strong>Estetik Görünüm:</strong> Organik form ve parlak krom kaplama ile modern mutfaklara şıklık katar</li>\n<li>\n<strong>Kolay Montaj:</strong> Standart montaj aparatları sayesinde hızlı ve pratik kurulum imkanı</li>\n</ul>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>Creavit BT.FG8501 Foglia Mutfak Armatürü</li>\n<li>3/8\" -M10- 50 cm fleks hortumlar</li>\n<li>Sabitleme aparatları ve vidalar</li>\n<li>Kullanım, montaj ve bakım kılavuzu</li>\n</ul>\n<hr>\n<h3>🏷️ Kullanım Alanları</h3>\n<ul>\n<li>Ev mutfakları</li>\n<li>Restoran ve kafe mutfakları</li>\n<li>Otel ve konaklama tesisleri</li>\n<li>Ofis ve ticari mutfak alanları</li>\n</ul>\n<p><strong>Creavit BT.FG8501 Foglia Mutfak Armatürü</strong>, zarif tasarımı ve dayanıklı yapısıyla mutfaklarınıza şıklık ve fonksiyonellik katmak için ideal bir tercihtir. Kolay montajı ve uzun ömürlü performansıyla kullanıcı memnuniyetini ön planda tutar.</p>\n</div>"
  },
  {
    "id": "creavit-8751421391145",
    "brand": "Creavit",
    "title": "Su Arıtma Çıkışlı Mutfak Armatürü Krom",
    "category": "Mutfak Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/su-aritma-cikisli-mutfak-armaturu-krom-4346.png?v=1747214562",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/su-aritma-cikisli-mutfak-armaturu-krom-4346.png?v=1747214562",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/su-aritma-cikisli-mutfak-armaturu-krom-4347.jpg?v=1747983433",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/su-aritma-cikisli-mutfak-armaturu-krom-4348.jpg?v=1747983433"
    ],
    "price": "10215.00",
    "sku": "BT.DW8700",
    "tags": [
      "Armatür",
      "arıtmalı mutfak armatürü",
      "krom",
      "mutfak",
      "Mutfak Armatürü",
      "su arıtma",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843228004649,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.DW8700",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "10215.00",
        "grams": 0,
        "compare_at_price": "13620.00",
        "position": 1,
        "product_id": 8751421391145,
        "created_at": "2026-03-17T12:59:02+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"product-description group w-full border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\">\n<div class=\"p-4 md:p-6 mx-auto max-w-3xl flex flex-col gap-4\">\n<div class=\"markdown prose dark:prose-invert break-words\">\n<h4 class=\"text-lg md:text-xl font-semibold mb-2\">Creavit BT.DW8700 İçme Suyu Çıkışlı Mutfak Bataryası</h4>\n<p><strong>BT.DW8700</strong>, Creavit’in yüksek kalite standartlarında üretilmiş, hem normal musluk hem de içme suyu için ayrı çıkışı bulunan, modern mutfak kullanımına özel bir bataryadır. Dayanıklılığı, estetik görünümü ve fonksiyonelliği ile öne çıkar.</p>\n<h4 class=\"mt-4 mb-2 font-medium\">Teknik Özellikler</h4>\n<ul class=\"list-disc ml-5 space-y-1\">\n<li>\n<strong>Model Kodu:</strong> BT.DW8700</li>\n<li>\n<strong>Seri:</strong> DW (Double Water / Çift Su Çıkışlı)</li>\n<li>\n<strong>Malzeme:</strong> %100 pirinç gövde</li>\n<li>\n<strong>Kaplama:</strong> Parlak krom (korozyon ve aşınmaya karşı dirençli)</li>\n<li>\n<strong>Renk Seçenekleri:</strong> Parlak krom</li>\n<li>\n<strong>Armatür Tipi:</strong> Tek kumandalı miks su çıkışı + ayrı içme suyu çıkışı</li>\n<li>\n<strong>Montaj Tipi:</strong> Tezgah üstü montaj</li>\n<li>\n<strong>Kartuş:</strong> 40 mm seramik kartuş</li>\n<li>\n<strong>Su Akış Debisi:</strong> Ana çıkış: 7-8 L/dk, İçme suyu çıkışı: düşük debili</li>\n<li>\n<strong>Çıkış Ucu:</strong> Ana çıkış: 212 mm uzunluk, 282 mm yükseklik; içme suyu çıkışı ayrı ve ince tasarım</li>\n<li>\n<strong>Boru Tipi:</strong> Döner boru (ana çıkış 360° dönebilir)</li>\n<li>\n<strong>Perlatör:</strong> Kireç önleyici, sessiz ve homojen akış</li>\n<li>\n<strong>Su Girişi:</strong> Çift girişli + ayrı içme suyu bağlantısı</li>\n<li>\n<strong>Açma-Kapama Mekanizması:</strong> Ana su için tek kumandalı, içme suyu için ayrı vana</li>\n<li>\n<strong>Garanti Süresi:</strong> 5 yıl</li>\n</ul>\n<h4 class=\"mt-4 mb-2 font-medium\">Öne Çıkan Özellikler</h4>\n<ul class=\"list-disc ml-5 space-y-1\">\n<li>\n<strong>Çift Fonksiyonlu Kullanım:</strong> Hem musluk hem arıtılmış içme suyu kontrolü</li>\n<li>\n<strong>Dayanıklı ve Sağlam Yapı:</strong> %100 pirinç gövde ve krom kaplama</li>\n<li>\n<strong>Ergonomik Tasarım:</strong> Tek kumandalı ana kol ve ayrı içme suyu çıkışı</li>\n<li>\n<strong>Döner Boru:</strong> Ana çıkış borusu 360° dönebilir</li>\n<li>\n<strong>Kireç Önleyici Perlatör:</strong> Sessiz ve homojen su akışı sağlar</li>\n<li>\n<strong>Kolay Montaj ve Bakım:</strong> Standart tezgah üstü montaj, kolay erişimli parçalar</li>\n</ul>\n<h4 class=\"mt-4 mb-2 font-medium\">Paket İçeriği</h4>\n<ul class=\"list-disc ml-5 space-y-1\">\n<li>Creavit BT.DW8700 Batarya</li>\n<li>Montaj için bağlantı aparatları ve vidalar</li>\n<li>3/8\" fleks hortumlar (50 cm)</li>\n<li>İçme suyu çıkışı için özel hortum ve adaptörler</li>\n<li>Kurulum ve bakım kılavuzu</li>\n</ul>\n<h4 class=\"mt-4 mb-2 font-medium\">Kullanım Alanları</h4>\n<ul class=\"list-disc ml-5 space-y-1\">\n<li>Ev mutfakları</li>\n<li>Filtreli su kullanan mutfaklar</li>\n<li>Profesyonel ve ticari mutfaklar</li>\n<li>Modern mutfak dekorasyonları</li>\n</ul>\n<p class=\"mt-3\">Creavit BT.DW8700, hem klasik musluk suyu ihtiyacınızı karşılar hem de filtreli içme suyu için ayrı ve hijyenik bir çıkış sunar. Sağlam malzeme ve ergonomik tasarım ile uzun ömürlü, konforlu ve fonksiyonel bir mutfak bataryasıdır. Kireç önleyici perlatör ve hassas seramik kartuş teknolojisi ile su tasarrufu ve kullanım kolaylığı ön plandadır.</p>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8751187820841",
    "brand": "Creavit",
    "title": "City Mutfak Armatürü Krom",
    "category": "Mutfak Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/city-mutfak-armaturu-krom-4339.png?v=1747238067",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/city-mutfak-armaturu-krom-4339.png?v=1747238067",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/city-mutfak-armaturu-krom-4341.jpg?v=1747238070",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/city-mutfak-armaturu-krom-4340.jpg?v=1747238072"
    ],
    "price": "6300.00",
    "sku": "BT.CT8500",
    "tags": [
      "Armatür",
      "City",
      "krom",
      "mutfak",
      "Mutfak Armatürü",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843216961833,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.CT8500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6300.00",
        "grams": 0,
        "compare_at_price": "8400.00",
        "position": 1,
        "product_id": 8751187820841,
        "created_at": "2026-03-17T12:55:13+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit City serisine ait BT.CT8500 mutfak armatürü, modern tasarımı ve fonksiyonel yapısıyla mutfağınıza hem estetik hem de pratiklik kazandırır. Krom kaplaması ve dayanıklı %100 pirinç gövdesiyle uzun ömürlü kullanım sunar.</p>\n<hr>\n<h3>🔧 Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> BT.CT8500</li>\n<li>\n<strong>Seri:</strong> City</li>\n<li>\n<strong>Ürün Tipi:</strong> Mutfak Armatürü</li>\n<li>\n<strong>Montaj Tipi:</strong> Dikey Düzlem</li>\n<li>\n<strong>Armatür Tipi:</strong> Tek Kumandalı Mix Armatür</li>\n<li>\n<strong>Açma Düzeneği:</strong> Aç-Kapa</li>\n<li>\n<strong>Kaplama:</strong> Krom</li>\n<li>\n<strong>Kartuş:</strong> 35 mm Uzun Ömürlü Seramik Kartuş (2 Kademeli)</li>\n<li>\n<strong>Su Giriş Sayısı:</strong> 2 Giriş</li>\n<li>\n<strong>Bağlantı Deliği:</strong> 2 Delikli</li>\n<li>\n<strong>Çıkış Ucu Uzunluğu:</strong> 201.9 mm</li>\n<li>\n<strong>Çıkış Ucu Yüksekliği:</strong> 245.28 mm</li>\n<li>\n<strong>Perlatör:</strong> Hareketli, Kolay Değiştirilebilir, Sessiz Su Akışı Sağlayan</li>\n<li>\n<strong>Malzeme:</strong> %100 Pirinç</li>\n<li>\n<strong>Su Akış Litresi:</strong> 7-8 Litre/Dakika</li>\n<li>\n<strong>Garanti Süresi:</strong> 5 Yıl</li>\n</ul>\n<hr>\n<h3>🛠️ Ürün Özellikleri</h3>\n<ul>\n<li>\n<strong>Estetik Tasarım:</strong> Modern ve şık yapısıyla mutfağınıza sofistike bir hava katar.</li>\n<li>\n<strong>Sessiz Su Akışı:</strong> Özel perlatörü sayesinde sessiz ve konforlu su akışı sağlar.</li>\n<li>\n<strong>Dayanıklı Malzeme:</strong> %100 pirinç gövde ile uzun ömürlü ve sağlam kullanım sunar.</li>\n<li>\n<strong>Kolay Montaj:</strong> Standart dikey montaj sistemi sayesinde hızlı ve pratik kurulum yapılabilir.</li>\n<li>\n<strong>Krom Kaplama:</strong> Parlak yüzeyi sayesinde kolay temizlenir, şık görünümünü uzun süre korur.</li>\n</ul>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>Creavit City Mutfak Armatürü BT.CT8500</li>\n<li>3/8\" - M10 - 50 cm Fleks Hortumlar</li>\n<li>Sabitleme Aparatları</li>\n<li>Kullanım Kılavuzu ve Garanti Belgesi</li>\n</ul>\n<p>Bu armatür, modern mutfaklar için hem estetik hem de işlevsel bir çözüm sunar. Dayanıklı yapısı ve kullanıcı dostu özellikleriyle uzun yıllar güvenle kullanabilirsiniz.</p>"
  },
  {
    "id": "creavit-8751167766825",
    "brand": "Creavit",
    "title": "Alfa Mutfak Armatürü Mat Siyah",
    "category": "Mutfak Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/alfa-mutfak-armaturu-mat-siyah-4335.png?v=1747223676",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/alfa-mutfak-armaturu-mat-siyah-4335.png?v=1747223676",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/alfa-mutfak-armaturu-mat-siyah-4336.jpg?v=1747919956",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/alfa-mutfak-armaturu-mat-siyah-4337.jpg?v=1747919956",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/alfa-mutfak-armaturu-mat-siyah-4338.jpg?v=1747223686"
    ],
    "price": "7650.00",
    "sku": "BT.AL8500S",
    "tags": [
      "Alfa",
      "Armatür",
      "Mat Siyah",
      "mutfak",
      "Mutfak Armatürü",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843241046313,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.AL8500S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7650.00",
        "grams": 0,
        "compare_at_price": "10200.00",
        "position": 1,
        "product_id": 8751167766825,
        "created_at": "2026-03-17T13:03:51+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"product-description\">\n<p><strong>Creavit</strong>'in <strong>Alfa serisine</strong> ait <strong>BT.AL8500S</strong> modeli, mutfaklarda modern tasarımı ve fonksiyonelliğiyle öne çıkan bir armatürdür. Hem <strong>şık</strong> hem de <strong>dayanıklı</strong> bir seçenek arayan kullanıcılar için idealdir.</p>\n<hr>\n<h3>🛠️ Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Model Kodu:</strong> BT.AL8500S</li>\n<li>\n<strong>Seri:</strong> Alfa</li>\n<li>\n<strong>Malzeme:</strong> %100 pirinç</li>\n<li>\n<strong>Kaplama:</strong> Mat Siyah</li>\n<li>\n<strong>Renk: </strong>Mat Siyah</li>\n<li>\n<strong>Armatür Tipi:</strong> Tek kumandalı miks armatür</li>\n<li>\n<strong>Montaj Tipi:</strong> Tezgah üstü montaj (dikey düzlem)</li>\n<li>\n<strong>Kartuş:</strong> 28 mm uzun ömürlü seramik kartuş</li>\n<li>\n<strong>Su Akış Debisi:</strong> 7–8 litre/dakika</li>\n<li>\n<strong>Çıkış Ucu Uzunluğu:</strong> 200 mm</li>\n<li>\n<strong>Çıkış Ucu Yüksekliği:</strong> 250 mm</li>\n<li>\n<strong>Boru:</strong> Sabit</li>\n<li>\n<strong>Su Girişi:</strong> Sıcak ve soğuk su için çift giriş</li>\n<li>\n<strong>Garanti Süresi:</strong> 5 yıl</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>\n<strong>Modern Tasarım:</strong> Minimalist ve şık hatlarıyla mutfağınıza estetik bir dokunuş katar.</li>\n<li>\n<strong>Dayanıklı Malzeme:</strong> %100 pirinç gövde, uzun ömürlü kullanım sağlar.</li>\n<li>\n<strong>Seramik Kartuş:</strong> Su sıcaklığı ve debisini hassas şekilde kontrol eder.</li>\n<li>\n<strong>Kolay Montaj:</strong> Tezgah üstü kurulum için uygundur ve montajı pratiktir.</li>\n</ul>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>Creavit AL8500S Alfa Siyah Mutfak Bataryası</li>\n<li>3/8\" - M10 - 50 cm fleks hortumlar</li>\n<li>Montaj sabitleme aparatları</li>\n<li>Kullanım ve montaj kılavuzu</li>\n</ul>\n<hr>\n<p><strong>Creavit AL8500S</strong> mutfak bataryası, mutfağınızda <em>modern bir atmosfer</em> yaratmak isteyenler için ideal bir tercihtir. Hem <strong>şık</strong> hem de <strong>fonksiyonel</strong> bir çözüm sunar.</p>\n</div>"
  },
  {
    "id": "creavit-8751165473065",
    "brand": "Creavit",
    "title": "Alfa Mutfak Armatürü Krom",
    "category": "Mutfak Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/alfa-mutfak-armaturu-krom-4332.png?v=1747223662",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/alfa-mutfak-armaturu-krom-4332.png?v=1747223662",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/alfa-mutfak-armaturu-krom-4333.jpg?v=1747223664",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/alfa-mutfak-armaturu-krom-4334.jpg?v=1747223668"
    ],
    "price": "7110.00",
    "sku": "BT.AL8500",
    "tags": [
      "Alfa",
      "Armatür",
      "Krom",
      "mutfak",
      "Mutfak Armatürü",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843216830761,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.AL8500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7110.00",
        "grams": 0,
        "compare_at_price": "9480.00",
        "position": 1,
        "product_id": 8751165473065,
        "created_at": "2026-03-17T12:55:10+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<div class=\"product-description\">\n<p><strong>Creavit</strong>'in <strong>Alfa serisine</strong> ait <strong>BT.AL8500</strong> modeli, mutfaklarda modern tasarımı ve fonksiyonelliğiyle öne çıkan bir armatürdür. Hem <strong>şık</strong> hem de <strong>dayanıklı</strong> bir seçenek arayan kullanıcılar için idealdir.</p>\n<hr>\n<h3>🛠️ Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Model Kodu:</strong> BT.AL8500</li>\n<li>\n<strong>Seri:</strong> Alfa</li>\n<li>\n<strong>Malzeme:</strong> %100 pirinç</li>\n<li>\n<strong>Kaplama:</strong> Krom </li>\n<li>\n<strong>Renk: </strong>Krom</li>\n<li>\n<strong>Armatür Tipi:</strong> Tek kumandalı miks armatür</li>\n<li>\n<strong>Montaj Tipi:</strong> Tezgah üstü montaj (dikey düzlem)</li>\n<li>\n<strong>Kartuş:</strong> 28 mm uzun ömürlü seramik kartuş</li>\n<li>\n<strong>Su Akış Debisi:</strong> 7–8 litre/dakika</li>\n<li>\n<strong>Çıkış Ucu Uzunluğu:</strong> 200 mm</li>\n<li>\n<strong>Çıkış Ucu Yüksekliği:</strong> 250 mm</li>\n<li>\n<strong>Boru:</strong> Sabit</li>\n<li>\n<strong>Su Girişi:</strong> Sıcak ve soğuk su için çift giriş</li>\n<li>\n<strong>Garanti Süresi:</strong> 5 yıl</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>\n<strong>Modern Tasarım:</strong> Minimalist ve şık hatlarıyla mutfağınıza estetik bir dokunuş katar.</li>\n<li>\n<strong>Dayanıklı Malzeme:</strong> %100 pirinç gövde, uzun ömürlü kullanım sağlar.</li>\n<li>\n<strong>Seramik Kartuş:</strong> Su sıcaklığı ve debisini hassas şekilde kontrol eder.</li>\n<li>\n<strong>Kolay Montaj:</strong> Tezgah üstü kurulum için uygundur ve montajı pratiktir.</li>\n</ul>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>Creavit AL8500 Alfa Mutfak Bataryası</li>\n<li>3/8\" - M10 - 50 cm fleks hortumlar</li>\n<li>Montaj sabitleme aparatları</li>\n<li>Kullanım ve montaj kılavuzu</li>\n</ul>\n<hr>\n<p><strong>Creavit AL8500</strong> mutfak bataryası, mutfağınızda <em>modern bir atmosfer</em> yaratmak isteyenler için ideal bir tercihtir. Hem <strong>şık</strong> hem de <strong>fonksiyonel</strong> bir çözüm sunar.</p>\n</div>"
  },
  {
    "id": "creavit-8751150793001",
    "brand": "Creavit",
    "title": "Avangart Mutfak Armatürü Altın",
    "category": "Mutfak Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/avangart-mutfak-armaturu-altin-4328.png?v=1747918120",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/avangart-mutfak-armaturu-altin-4328.png?v=1747918120",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/avangart-mutfak-armaturu-altin-4331.jpg?v=1747918120",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/avangart-mutfak-armaturu-altin-4330.jpg?v=1747918120",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/avangart-mutfak-armaturu-altin-4329.jpg?v=1747238232"
    ],
    "price": "9288.00",
    "sku": "BT.AG8500G",
    "tags": [
      "Armatür",
      "avangart",
      "kireç temizleme",
      "mutfak",
      "Mutfak Armatürü",
      "Pirinç",
      "sessiz su akışı",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52836659527977,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.AG8500G",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "9288.00",
        "grams": 0,
        "compare_at_price": "15480.00",
        "position": 1,
        "product_id": 8751150793001,
        "created_at": "2026-03-15T21:11:16+03:00",
        "updated_at": "2026-04-07T05:25:31+03:00"
      }
    ],
    "description": "<p>Creavit Avangart serisinin <strong>BT.AG8500G</strong> modeli, mutfaklarda modern tasarımı ve fonksiyonelliğiyle öne çıkan bir armatürdür. Aşağıda, bu ürünün detaylı teknik özelliklerini bulabilirsiniz:</p>\n<hr>\n<h3>Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Model Kodu:</strong> BT.AG8500G</li>\n<li>\n<strong>Seri:</strong> Avangart</li>\n<li>\n<strong>Malzeme:</strong> %100 pirinç</li>\n<li>\n<strong>Kaplama:</strong> Krom</li>\n<li>\n<strong>Armatür Tipi:</strong> Tek kumandalı miks armatür</li>\n<li>\n<strong>Kartuş:</strong> Uzun ömürlü 35 mm seramik ayaklı kartuş</li>\n<li>\n<strong>Su Akış Debisi:</strong> 7–8 litre/dakika</li>\n<li>\n<strong>Çıkış Ucu Uzunluğu:</strong> 188,9 mm</li>\n<li>\n<strong>Çıkış Ucu Yüksekliği:</strong> 282,7 mm</li>\n<li>\n<strong>Dönme Açısı:</strong> Sağa ve sola 55 derece döner borulu su çıkışı</li>\n<li>\n<strong>Montaj Tipi:</strong> Dikey düzlem (tezgah üstü montaj)</li>\n<li>\n<strong>Perlatör:</strong> Kolay değiştirilebilir, kireç temizleme sistemli, sessiz su akışı sağlayan perlatör</li>\n<li>\n<strong>Renk Seçenekleri:</strong> Gold</li>\n<li>\n<strong>Garanti Süresi:</strong> 5 yıl</li>\n</ul>\n<hr>\n<h3>Öne Çıkan Özellikler</h3>\n<ul>\n<li>\n<strong>Modern Tasarım:</strong> Minimalist ve şık hatlarıyla mutfağınıza estetik bir dokunuş katar.</li>\n<li>\n<strong>Kireç Temizleme Sistemi:</strong> Su akışını engelleyen kireç birikintilerini önler, uzun ömürlü kullanım sağlar.</li>\n<li>\n<strong>Kolay Montaj:</strong> Tezgah üstü montaj imkanı sunar, kurulum sürecini kolaylaştırır.</li>\n<li>\n<strong>Yüksek Kalite:</strong> %100 pirinç malzeme ve uzun ömürlü seramik kartuş ile dayanıklılık sağlar.</li>\n</ul>\n<hr>\n<h3>Paket İçeriği</h3>\n<ul>\n<li>Batarya: Creavit AG8500G Avangart Lüx Gold Mutfak Armatürü</li>\n<li>Montaj Aparatları: 3/8\" - M10 - 50 cm flekso hortumlar ve sabitleme aparatları</li>\n<li>Kullanım Kılavuzu: Kurulum ve bakım talimatlarını içeren kılavuz</li>\n</ul>\n<hr>\n<p>Creavit AG8500G Avangart Lüx Gold Mutfak Armatürü, modern tasarımı, fonksiyonelliği ve dayanıklılığı ile mutfağınızda şıklığı ve konforu bir arada sunar. Krom kaplama ve kireç temizleme sistemi gibi özellikleri sayesinde uzun ömürlü ve kullanıcı dostudur. Fiyat-performans açısından da tatmin edici bir üründür.</p>"
  },
  {
    "id": "creavit-8742390169897",
    "brand": "Creavit",
    "title": "Slope banyo Armatürü Krom",
    "category": "Banyo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/slope-banyo-armaturu-krom-4325.png?v=1747223646",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/slope-banyo-armaturu-krom-4325.png?v=1747223646",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/slope-banyo-armaturu-krom-4327.jpg?v=1747223649",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/slope-banyo-armaturu-krom-4326.jpg?v=1747223654"
    ],
    "price": "7920.00",
    "sku": "BT.SP2500",
    "tags": [
      "Armatür",
      "Banyo",
      "banyo armatürü",
      "Krom",
      "Slope",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843216732457,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.SP2500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "7920.00",
        "grams": 0,
        "compare_at_price": "10560.00",
        "position": 1,
        "product_id": 8742390169897,
        "created_at": "2026-03-17T12:55:07+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-vfjev-79elbk h-full dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-vfjev-1n7m0yu\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-col text-sm dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"group w-full text-gray-800 dark:text-gray-100 border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-mce-fragment=\"1\">\r\n<div class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\" data-mce-fragment=\"1\">\r\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-grow flex-col gap-3\" data-mce-fragment=\"1\">\r\n<div class=\"min-h-[20px] flex items-start overflow-x-auto whitespace-pre-wrap break-words\" data-mce-fragment=\"1\">\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p>Şıklığı ve işlevselliği bir araya getiren Slope Banyo Armatürü banyonuzda estetik bir atmosfer yaratırken aynı zamanda günlük kullanımlarınızda konfor sağlar. Slope Banyo Armatürü'nün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizması, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle banyo deneyiminiz daha keyifli hale gelecek. Creavit armatürleri, gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>\n</div>\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\"><strong>Not: Slope armatür ailesinde mutlaka FA002 filtreli ara musluk kullanılmalıdır.</strong></div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8742380863785",
    "brand": "Creavit",
    "title": "Stilo Banyo Armatürü Krom",
    "category": "Banyo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/stilo-banyo-armaturu-krom-4321.png?v=1747223626",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/stilo-banyo-armaturu-krom-4321.png?v=1747223626",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/stilo-banyo-armaturu-krom-4323.jpg?v=1747223631",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/stilo-banyo-armaturu-krom-4322.jpg?v=1747223633",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/stilo-banyo-armaturu-krom-4324.jpg?v=1747223636"
    ],
    "price": "4752.00",
    "sku": "BT.SL2500",
    "tags": [
      "Armatür",
      "Banyo",
      "banyo armatürü",
      "Krom",
      "Stilo",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52836659233065,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.SL2500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "4752.00",
        "grams": 0,
        "compare_at_price": "7920.00",
        "position": 1,
        "product_id": 8742380863785,
        "created_at": "2026-03-15T21:11:09+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p><strong>Renkli Tasarım:</strong> Değiştirilebilen kılıfları ile  armatüre yenilikçi ve renkli bir şekilde yaklaşan Stilo Armatür serisi banyonuzda eğlenceli bir atmosfer yaratırken aynı zamanda günlük kullanımlarınızda konfor sağlar.</p>\r\n<p><strong>Fonksiyonel Yapı:</strong> Stilo Banyo Armatürü'nün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizmasi, kolay su sıcaklık kontrolü ve su akış ayarı gibi özelliklerle banyo deneyiminiz daha keyifli hale gelecek.</p>\r\n<p><strong>Dayanıklılık ve Kalite:</strong> Creavit armatürleri, gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz. </p>\r\n<p>Estetik ve tasarımı, teknoloji ile buluşturan Creavit, kullanıcı odaklı tasarım bakış açısıyla yeni ürün geliştirmeye devam ediyor.</p><!---->"
  },
  {
    "id": "creavit-8631581344041",
    "brand": "Creavit",
    "title": "Loop Dikdörtgen Çanak Lavabo 40x60cm Beyaz",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-dikdortgen-canak-lavabo-40x60cm-beyaz-3850.png?v=1747805514",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-dikdortgen-canak-lavabo-40x60cm-beyaz-3850.png?v=1747805514",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-dikdortgen-canak-lavabo-40x60cm-beyaz-3851.jpg?v=1747805514",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-dikdortgen-canak-lavabo-40x60cm-beyaz-3853.jpg?v=1747805514",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-dikdortgen-canak-lavabo-40x60cm-beyaz-3854.jpg?v=1747805514"
    ],
    "price": "8955.00",
    "sku": "LP060-00CB00E-0000",
    "tags": [
      "Dikdörtgen",
      "Lavabo",
      "Loop",
      "Tezgah Üstü Lavabo",
      "Tezgahüstü",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843186749737,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP060-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8955.00",
        "grams": 0,
        "compare_at_price": "11940.00",
        "position": 1,
        "product_id": 8631581344041,
        "created_at": "2026-03-17T12:46:40+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "\r\n<p data-mce-fragment=\"1\">Banyonuz modern sanat galerisine dönüşsün!</p>\r\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\r\n<p data-mce-fragment=\"1\">Lavaboda İnce Düşünenlere!</p>\r\n<p data-mce-fragment=\"1\">Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-8742333546793",
    "brand": "Creavit",
    "title": "Pure Banyo Armatürü Krom",
    "category": "Banyo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pure-banyo-armaturu-krom-4312.png?v=1747223580",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pure-banyo-armaturu-krom-4312.png?v=1747223580",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pure-banyo-armaturu-krom-4314.jpg?v=1747223585",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pure-banyo-armaturu-krom-4313.jpg?v=1747223587"
    ],
    "price": "10710.00",
    "sku": "BT.PR2500",
    "tags": [
      "Armatür",
      "Banyo",
      "banyo armatürü",
      "Krom",
      "pure",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843234853161,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.PR2500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "10710.00",
        "grams": 0,
        "compare_at_price": "14280.00",
        "position": 1,
        "product_id": 8742333546793,
        "created_at": "2026-03-17T13:01:35+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p>Şıklığı ve işlevselliği bir araya getiren Pure Banyo Armatürü banyonuzda estetik bir atmosfer yaratırken aynı zamanda günlük kullanımlarınızda konfor sağlar. Pure Banyo Armatürü'nün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizması, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle banyo deneyiminiz daha keyifli hale gelecek. Creavit armatürleri, gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p><!---->"
  },
  {
    "id": "creavit-8742299369769",
    "brand": "Creavit",
    "title": "Lua Banyo Armatürü Metalik Gri",
    "category": "Banyo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-banyo-armaturu-metalik-gri-4307.png?v=1747238027",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-banyo-armaturu-metalik-gri-4307.png?v=1747238027",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-banyo-armaturu-metalik-gri-4308.jpg?v=1747238029",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-banyo-armaturu-metalik-gri-4309.jpg?v=1747238032",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-banyo-armaturu-metalik-gri-4310.jpg?v=1747238035",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-banyo-armaturu-metalik-gri-4311.jpg?v=1747238037"
    ],
    "price": "9990.00",
    "sku": "BT.LU2500GR",
    "tags": [
      "Armatür",
      "Banyo",
      "banyo armatürü",
      "Lua",
      "Metalik Gri",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843216404777,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.LU2500GR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9990.00",
        "grams": 0,
        "compare_at_price": "13320.00",
        "position": 1,
        "product_id": 8742299369769,
        "created_at": "2026-03-17T12:54:58+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p><strong>Creavit Lua Duşta, Banyoda, Mutfakta!</strong></p>\r\n<p>Lua<strong> </strong>Armatür serisi özel olarak tasarlanan ideal su çıkış ucu eğimiyle suyun şelale görünümünde akmasını sağlar. Şık ve minimalist çizgileriyle banyo dekorasyonunuza sofistike bir dokunuş katar. Lua armatür serisi hızlı ve kolay bir şekilde monte edilir. Standart armatür deliği ölçüleriyle uyumludur. Çoğu lavabo veya tezgaha rahatlıkla takılabilir. Creavit armatürleri gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p><!---->"
  },
  {
    "id": "creavit-8742179111209",
    "brand": "Creavit",
    "title": "Flow Banyo Armatürü Krom",
    "category": "Banyo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/flow-banyo-armaturu-krom-4304.png?v=1747238014",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/flow-banyo-armaturu-krom-4304.png?v=1747238014",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/flow-banyo-armaturu-krom-4306.jpg?v=1747238016",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/flow-banyo-armaturu-krom-4305.jpg?v=1747238019"
    ],
    "price": "7875.00",
    "sku": "BT.FL2500",
    "tags": [
      "Armatür",
      "Banyo",
      "banyo armatürü",
      "Flow",
      "Krom",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843216208169,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.FL2500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7875.00",
        "grams": 0,
        "compare_at_price": "10500.00",
        "position": 1,
        "product_id": 8742179111209,
        "created_at": "2026-03-17T12:54:55+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"product-description\">\n<h3>Creavit BT.FL2500 Flow Banyo Bataryası</h3>\n<p><strong>Creavit BT.FL2500 Flow Banyo Bataryası</strong>, estetik tasarımı ve fonksiyonelliğiyle banyo dekorasyonuna şıklık katmak isteyenler için ideal bir tercihtir. Kaliteli malzemesi, dayanıklı yapısı ve su tasarrufu sağlayan özellikleriyle öne çıkar.</p>\n<hr>\n<h3>🔧 Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> BT.FL2500</li>\n<li>\n<strong>Kullanım Alanı:</strong> Standart banyo armatürü</li>\n<li>\n<strong>Malzeme:</strong> Yüksek kaliteli pirinç (bronz)</li>\n<li>\n<strong>Kaplama:</strong> Parlak krom</li>\n<li>\n<strong>Montaj Tipi:</strong> Yatay düzlem (duvara montaj)</li>\n<li>\n<strong>Armatür Tipi:</strong> Tek kumandalı karışım (mix) armatür</li>\n<li>\n<strong>Kartuş Tipi:</strong> Uzun ömürlü 35 mm seramik kartuş</li>\n<li>\n<strong>Su Akış Miktarı:</strong> 7–8 litre/dakika</li>\n<li>\n<strong>Çıkış Ucu Uzunluğu:</strong> 114 mm</li>\n<li>\n<strong>Perlatör:</strong> Var (su akışını düzenler ve tasarruf sağlar)</li>\n</ul>\n<hr>\n<h3>🛠️ Ekstra Özellikler</h3>\n<ul>\n<li>\n<strong>Su Tasarrufu:</strong> Perlatörlü uç sayesinde su tüketimini azaltır.</li>\n<li>\n<strong>Hijyen ve Dayanıklılık:</strong> Krom kaplama, paslanmaya ve kireçlenmeye karşı dirençlidir.</li>\n<li>\n<strong>Ergonomik Kullanım:</strong> Tek kumanda ile kolay sıcaklık ve debi ayarı.</li>\n<li>\n<strong>Estetik Tasarım:</strong> Modern ve şık görünümüyle banyonuza zarif bir dokunuş katar.</li>\n</ul>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>1 Adet BT.FL2500 Flow Banyo Bataryası</li>\n<li>Montaj aparatları (bağlantı vidaları ve contalar)</li>\n<li>Kullanım ve montaj kılavuzu</li>\n<li>Garanti belgesi</li>\n</ul>\n<hr>\n<h3>🧾 Garanti ve Servis</h3>\n<ul>\n<li>\n<strong>Garanti Süresi:</strong> 5 yıl</li>\n<li>\n<strong>Yedek Parça ve Servis:</strong> Creavit yetkili servisleri aracılığıyla temin edilebilir.</li>\n</ul>\n</div>"
  },
  {
    "id": "creavit-8742085951785",
    "brand": "Creavit",
    "title": "City Banyo Armatürü Krom",
    "category": "Banyo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/city-banyo-armaturu-krom-4298.png?v=1747223508",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/city-banyo-armaturu-krom-4298.png?v=1747223508",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/city-banyo-armaturu-krom-4300.jpg?v=1747223512",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/city-banyo-armaturu-krom-4299.jpg?v=1747223515"
    ],
    "price": "6300.00",
    "sku": "BT.CT2500",
    "tags": [
      "Armatür",
      "Banyo",
      "banyo armatürü",
      "City",
      "Krom",
      "sessiz su akışı",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843232100649,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.CT2500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6300.00",
        "grams": 0,
        "compare_at_price": "8400.00",
        "position": 1,
        "product_id": 8742085951785,
        "created_at": "2026-03-17T13:00:36+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p>Creavit City Banyo Armatürü <strong>BT.CT2500</strong>, estetik tasarımı ve dayanıklı yapısıyla öne çıkan bir banyo bataryasıdır. Modern banyolar için şıklık ve işlevselliği bir arada sunar.</p>\n<hr>\n<h3>🔧 Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Ürün Kodu:</strong> BT.CT2500</li>\n<li>\n<strong>Seri:</strong> City</li>\n<li>\n<strong>Ürün Tipi:</strong> Banyo Bataryası</li>\n<li>\n<strong>Montaj Tipi:</strong> Duvar Tipi (Standart)</li>\n<li>\n<strong>Armatür Tipi:</strong> Aplike</li>\n<li>\n<strong>Açma Düzeneği:</strong> Aç-Kapa</li>\n<li>\n<strong>Kaplama:</strong> Krom</li>\n<li>\n<strong>Kartuş:</strong> 35 mm Seramik Kartuş (Uzun Ömürlü, 2 Kademeli)</li>\n<li>\n<strong>Su Giriş Sayısı:</strong> 2 Giriş</li>\n<li>\n<strong>Bağlantı Deliği:</strong> 2 Delikli</li>\n<li>\n<strong>Çıkış Ucu Uzunluğu:</strong> 150.4 mm</li>\n<li>\n<strong>Perlatör:</strong> Hareketli, Kolay Değiştirilebilir, Sessiz Su Akışı Sağlayan</li>\n<li>\n<strong>Malzeme:</strong> %100 Pirinç</li>\n<li>\n<strong>Garanti Süresi:</strong> 5 Yıl</li>\n</ul>\n<hr>\n<h3>🛠️ Ürün Özellikleri</h3>\n<ul>\n<li>\n<strong>Estetik Tasarım:</strong> Modern ve şık tasarımıyla banyonuza sofistike bir hava katar.</li>\n<li>\n<strong>Sessiz Su Akışı:</strong> Perlatör sayesinde su akışı sessizdir, konforlu bir kullanım sunar.</li>\n<li>\n<strong>Dayanıklı Malzeme:</strong> %100 pirinç malzeme ile uzun ömürlü ve dayanıklıdır.</li>\n<li>\n<strong>Kolay Montaj:</strong> Standart duvar tipi montaj ile kolay kurulum imkanı sağlar.</li>\n<li>\n<strong>Krom Kaplama:</strong> Parlak krom kaplaması ile kolay temizlenir ve estetik bir görünüm sunar.</li>\n</ul>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>Creavit City Banyo Armatürü BT.CT2500</li>\n<li>Montaj Aparatları (Eksantrik bağlantılar dahil)</li>\n<li>Kullanım Kılavuzu ve Garanti Belgesi</li>\n</ul>"
  },
  {
    "id": "creavit-8741728321833",
    "brand": "Creavit",
    "title": "Alfa Banyo Armatürü Mat Siyah",
    "category": "Banyo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/alfa-banyo-armaturu-mat-siyah-4294.png?v=1747233075",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/alfa-banyo-armaturu-mat-siyah-4294.png?v=1747233075",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/alfa-banyo-armaturu-mat-siyah-4296.jpg?v=1747233079",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/alfa-banyo-armaturu-mat-siyah-4295.jpg?v=1747233081",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/alfa-banyo-armaturu-mat-siyah-4297.jpg?v=1747233085"
    ],
    "price": "8865.00",
    "sku": "BT.AL2500S",
    "tags": [
      "Alfa",
      "Armatür",
      "Banyo",
      "banyo armatürü",
      "Mat Siyah",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52921480806697,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.AL2500S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "8865.00",
        "grams": 0,
        "compare_at_price": "11820.00",
        "position": 1,
        "product_id": 8741728321833,
        "created_at": "2026-04-03T14:43:36+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p>Creavit'in <strong>Alfa serisine</strong> ait, modern tasarımı ve dayanıklılığıyla öne çıkan bu <strong>banyo bataryası</strong>, %100 pirinç malzemeden üretilmiştir. <strong>28 mm seramik kartuşu</strong> ile uzun ömürlü kullanım sunar. <strong>Çıkış ucu uzunluğu 185 mm</strong> olan bu model, <strong>krom</strong> ve <strong>mat siyah</strong> olmak üzere iki renk seçeneğiyle gelir.</p>\n<hr>\n<h3>🛠️ Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Model Kodu:</strong> BT.AL2500S</li>\n<li>\n<strong>Seri:</strong> Alfa</li>\n<li>\n<strong>Malzeme:</strong> %100 pirinç</li>\n<li>\n<strong>Kaplama:</strong> Mat Siyah</li>\n<li>\n<strong>Renk:</strong> Mat Siyah</li>\n<li>\n<strong>Kartuş:</strong> Uzun ömürlü 28 mm seramik kartuş</li>\n<li>\n<strong>Çıkış Ucu Uzunluğu:</strong> 185 mm</li>\n<li>\n<strong>Montaj Tipi:</strong> Duvara montaj</li>\n<li>\n<strong>Garanti Süresi:</strong> 5 yıl</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>\n<strong>Modern Tasarım:</strong> Zarif hatlarıyla banyonuza estetik bir dokunuş katar.</li>\n<li>\n<strong>Dayanıklı Malzeme:</strong> %100 pirinç gövde, uzun ömürlü kullanım sağlar.</li>\n<li>\n<strong>Seramik Kartuş:</strong> Hassas sıcaklık ve su debisi ayarı sunar.</li>\n</ul>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>Creavit AL2500S Alfa Siyah Banyo Bataryası</li>\n<li>Montaj için gerekli bağlantı elemanları</li>\n<li>Kullanım ve kurulum kılavuzu</li>\n</ul>\n<hr>\n<p>Creavit AL2500S Alfa Siyah Banyo Bataryası, şıklığı ve fonksiyonelliğiyle banyonuza modern bir atmosfer katmak isteyenler için ideal bir tercihtir. Krom kaplama ve seramik kartuş gibi özellikleri sayesinde uzun ömürlü ve kullanıcı dostudur. Fiyat-performans açısından da tatmin edici bir üründür.</p>"
  },
  {
    "id": "creavit-8741666357545",
    "brand": "Creavit",
    "title": "Alfa Banyo Armatürü Krom",
    "category": "Banyo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/alfa-banyo-armaturu-krom-4290.png?v=1747223489",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/alfa-banyo-armaturu-krom-4290.png?v=1747223489",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/alfa-banyo-armaturu-krom-4291.jpg?v=1747223492",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/alfa-banyo-armaturu-krom-4292.jpg?v=1747223497",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/alfa-banyo-armaturu-krom-4293.jpg?v=1747223500"
    ],
    "price": "8370.00",
    "sku": "BT.AL2500",
    "tags": [
      "Alfa",
      "Armatür",
      "Banyo",
      "banyo armatürü",
      "Krom",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843216011561,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.AL2500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8370.00",
        "grams": 0,
        "compare_at_price": "11160.00",
        "position": 1,
        "product_id": 8741666357545,
        "created_at": "2026-03-17T12:54:52+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p>Creavit'in <strong>Alfa serisine</strong> ait, modern tasarımı ve dayanıklılığıyla öne çıkan bu <strong>banyo bataryası</strong>, %100 pirinç malzemeden üretilmiştir. <strong>28 mm seramik kartuşu</strong> ile uzun ömürlü kullanım sunar. <strong>Çıkış ucu uzunluğu 185 mm</strong> olan bu model, <strong>krom</strong> ve <strong>mat siyah</strong> olmak üzere iki renk seçeneğiyle gelir.</p>\n<hr>\n<h3>🛠️ Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Model Kodu:</strong> BT.AL2500</li>\n<li>\n<strong>Seri:</strong> Alfa</li>\n<li>\n<strong>Malzeme:</strong> %100 pirinç</li>\n<li>\n<strong>Kaplama:</strong> Krom </li>\n<li>\n<strong>Renk: </strong>Krom<br>\n</li>\n<li>\n<strong>Kartuş:</strong> Uzun ömürlü 28 mm seramik kartuş</li>\n<li>\n<strong>Çıkış Ucu Uzunluğu:</strong> 185 mm</li>\n<li>\n<strong>Montaj Tipi:</strong> Duvara montaj</li>\n<li>\n<strong>Garanti Süresi:</strong> 5 yıl</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>\n<strong>Modern Tasarım:</strong> Zarif hatlarıyla banyonuza estetik bir dokunuş katar.</li>\n<li>\n<strong>Dayanıklı Malzeme:</strong> %100 pirinç gövde, uzun ömürlü kullanım sağlar.</li>\n<li>\n<strong>Seramik Kartuş:</strong> Hassas sıcaklık ve su debisi ayarı sunar.</li>\n</ul>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>Creavit AL2500 Alfa Banyo Bataryası</li>\n<li>Montaj için gerekli bağlantı elemanları</li>\n<li>Kullanım ve kurulum kılavuzu</li>\n</ul>\n<hr>\n<p>Creavit AL2500 Alfa Banyo Bataryası, şıklığı ve fonksiyonelliğiyle banyonuza modern bir atmosfer katmak isteyenler için ideal bir tercihtir. Krom kaplama ve seramik kartuş gibi özellikleri sayesinde uzun ömürlü ve kullanıcı dostudur. </p>"
  },
  {
    "id": "creavit-8737801273641",
    "brand": "Creavit",
    "title": "Avangart Banyo Armatürü Krom",
    "category": "Banyo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/avangart-banyo-armaturu-krom-4286.png?v=1747223466",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/avangart-banyo-armaturu-krom-4286.png?v=1747223466",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/avangart-banyo-armaturu-krom-4287.jpg?v=1747223470",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/avangart-banyo-armaturu-krom-4288.jpg?v=1747223475",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/avangart-banyo-armaturu-krom-4289.jpg?v=1747223479"
    ],
    "price": "6336.00",
    "sku": "BT.AG2500",
    "tags": [
      "Armatür",
      "avangart",
      "Banyo",
      "banyo armatürü",
      "kireç temizleme",
      "Krom",
      "Pirinç",
      "sessiz su akışı",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52836657299753,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.AG2500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "6336.00",
        "grams": 0,
        "compare_at_price": "10560.00",
        "position": 1,
        "product_id": 8737801273641,
        "created_at": "2026-03-15T21:10:51+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p>Creavit Avangart serisinin <strong>BT.AG2500</strong> modeli, banyo dekorasyonunda modern ve şık bir atmosfer yaratmak isteyenler için ideal bir tercihtir. Aşağıda, bu ürünün tüm teknik özelliklerini ve detaylarını bulabilirsiniz.</p>\n<hr>\n<h3>🛁 Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Model Kodu:</strong> BT.AG2500</li>\n<li>\n<strong>Seri:</strong> Avangart</li>\n<li>\n<strong>Malzeme:</strong> %100 pirinç</li>\n<li>\n<strong>Kaplama:</strong> Krom</li>\n<li>\n<strong>Armatür Tipi:</strong> Tek kumandalı miks armatür</li>\n<li>\n<strong>Montaj Tipi:</strong> Yatay düzlem (duvara montaj)</li>\n<li>\n<strong>Kartuş:</strong> Uzun ömürlü 35 mm seramik ayaklı kartuş</li>\n<li>\n<strong>Su Akış Debisi:</strong> 7–8 litre/dakika</li>\n<li>\n<strong>Çıkış Ucu Uzunluğu:</strong> 180,9 mm</li>\n<li>\n<strong>Su Giriş Sayısı:</strong> 2 giriş</li>\n<li>\n<strong>Bağlantı Deliği:</strong> 2 delikli</li>\n<li>\n<strong>Perlatör:</strong> Kolay değiştirilebilir, kireç temizleme sistemli, sessiz su akışı sağlayan perlatör</li>\n<li>\n<strong>Garanti Süresi:</strong> 5 yıl</li>\n<li>\n<strong>Renk Seçenekleri:</strong> Krom</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>\n<strong>Krom Kaplama:</strong> Modern ve parlak görünüm sağlar, uzun ömürlüdür.</li>\n<li>\n<strong>Kireç Temizleme Sistemi:</strong> Su akışını engelleyen kireç birikintilerini önler.</li>\n<li>\n<strong>Seramik Kartuş:</strong> Sıcaklık ve su debisi ayarlarını hassas bir şekilde yapar, uzun ömürlüdür.</li>\n<li>\n<strong>Kolay Montaj:</strong> Tezgah üstü montaj ile pratik kurulum imkanı sunar.</li>\n</ul>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>Batarya: Creavit AG2500 Avangart Lüx Banyo Bataryası.</li>\n<li>Montaj Aparatları: Montaj için gerekli tüm aparat ve bağlantı elemanları.</li>\n<li>Kullanım Kılavuzu: Kurulum ve bakım talimatlarını içeren kılavuz.</li>\n</ul>\n<hr>\n<p>Creavit AG2500 Avangart Lüx Banyo Bataryası, şıklığı, dayanıklılığı ve fonksiyonelliğiyle banyonuzda modern bir atmosfer yaratmak isteyenler için ideal bir tercihtir. Krom kaplama ve kireç temizleme sistemi gibi özellikleri sayesinde uzun ömürlü ve kullanıcı dostudur. Fiyat-performans açısından da tatmin edici bir üründür.</p>"
  },
  {
    "id": "creavit-8737648050473",
    "brand": "Creavit",
    "title": "Sharp Lavabo Armatürü Altın",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-lavabo-armaturu-altin-4283.png?v=1747223450",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-lavabo-armaturu-altin-4283.png?v=1747223450",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-lavabo-armaturu-altin-4284.jpg?v=1747223454",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-lavabo-armaturu-altin-4285.jpg?v=1747223457"
    ],
    "price": "7425.00",
    "sku": "BT.SR1500G",
    "tags": [
      "altın",
      "Armatür",
      "Lavabo Armatürü",
      "Pirinç",
      "sessiz su akışı",
      "Sharp",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843234722089,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.SR1500G",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7425.00",
        "grams": 0,
        "compare_at_price": "9900.00",
        "position": 1,
        "product_id": 8737648050473,
        "created_at": "2026-03-17T13:01:32+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p>Şıklığı ve işlevselliği bir araya getiren Sharp Lavabo Armatürü banyonuzda estetik bir atmosfer yaratırken aynı zamanda günlük kullanımlarınızda konfor sağlar. Sharp Lavabo Armatürü'nün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizması, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle banyo deneyiminiz daha keyifli hale gelecek. Creavit armatürleri, gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>"
  },
  {
    "id": "creavit-8737624293673",
    "brand": "Creavit",
    "title": "Slope Lavabo Armatürü Krom",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/slope-lavabo-armaturu-krom-4279.png?v=1747806562",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/slope-lavabo-armaturu-krom-4279.png?v=1747806562",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/slope-lavabo-armaturu-krom-4282.jpg?v=1747806562",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/slope-lavabo-armaturu-krom-4280.jpg?v=1747806562",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/slope-lavabo-armaturu-krom-4281.jpg?v=1747806562"
    ],
    "price": "6030.00",
    "sku": "BT.SP1500",
    "tags": [
      "Armatür",
      "Banyo",
      "Krom",
      "Lavabo Armatürü",
      "Slope",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843215880489,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.SP1500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6030.00",
        "grams": 0,
        "compare_at_price": "8040.00",
        "position": 1,
        "product_id": 8737624293673,
        "created_at": "2026-03-17T12:54:49+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-vfjev-79elbk h-full dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-vfjev-1n7m0yu\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-col text-sm dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"group w-full text-gray-800 dark:text-gray-100 border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-mce-fragment=\"1\">\r\n<div class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\" data-mce-fragment=\"1\">\r\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-grow flex-col gap-3\" data-mce-fragment=\"1\">\r\n<div class=\"min-h-[20px] flex items-start overflow-x-auto whitespace-pre-wrap break-words\" data-mce-fragment=\"1\">\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p>Şıklığı ve işlevselliği bir araya getiren Slope Lavabo Armatürü banyonuzda estetik bir atmosfer yaratırken aynı zamanda günlük kullanımlarınızda konfor sağlar. Slope Lavabo Armatürü'nün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizması, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle banyo deneyiminiz daha keyifli hale gelecek. Creavit armatürleri, gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>\n</div>\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\"><strong>Not: Slope armatür ailesinde mutlaka FA002 filtreli ara musluk kullanılmalıdır.</strong></div>\n</div>\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\"></div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8735211815209",
    "brand": "Creavit",
    "title": "Pure Lavabo Armatürü Krom",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pure-lavabo-armaturu-krom-4261.png?v=1747223386",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pure-lavabo-armaturu-krom-4261.png?v=1747223386",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pure-lavabo-armaturu-krom-4263.jpg?v=1747223390",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pure-lavabo-armaturu-krom-4262.jpg?v=1747223393"
    ],
    "price": "7200.00",
    "sku": "BT.PR1500",
    "tags": [
      "Armatür",
      "Banyo",
      "Krom",
      "Lavabo Armatürü",
      "pure",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843234591017,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.PR1500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7200.00",
        "grams": 0,
        "compare_at_price": "9600.00",
        "position": 1,
        "product_id": 8735211815209,
        "created_at": "2026-03-17T13:01:29+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-vfjev-79elbk h-full dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-vfjev-1n7m0yu\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-col text-sm dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"group w-full text-gray-800 dark:text-gray-100 border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-mce-fragment=\"1\">\r\n<div class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\" data-mce-fragment=\"1\">\r\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-grow flex-col gap-3\" data-mce-fragment=\"1\">\r\n<div class=\"min-h-[20px] flex items-start overflow-x-auto whitespace-pre-wrap break-words\" data-mce-fragment=\"1\">\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p>Şıklığı ve işlevselliği bir araya getiren Pure Lavabo Armatürü banyonuzda estetik bir atmosfer yaratırken aynı zamanda günlük kullanımlarınızda konfor sağlar. Pure Lavabo Armatürü'nün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizması, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle banyo deneyiminiz daha keyifli hale gelecek. Creavit armatürleri, gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.<strong></strong></p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8735162204457",
    "brand": "Creavit",
    "title": "Flow Lavabo Armatürü Krom",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/flow-lavabo-armaturu-krom-4258.png?v=1747053575",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/flow-lavabo-armaturu-krom-4258.png?v=1747053575",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/flow-lavabo-armaturu-krom-4260.jpg?v=1747053578",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/flow-lavabo-armaturu-krom-4259.jpg?v=1747053580"
    ],
    "price": "6750.00",
    "sku": "BT.FL1500",
    "tags": [
      "Armatür",
      "Banyo",
      "Flow",
      "Krom",
      "Lavabo Armatürü",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843237212457,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.FL1500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6750.00",
        "grams": 0,
        "compare_at_price": "9000.00",
        "position": 1,
        "product_id": 8735162204457,
        "created_at": "2026-03-17T13:02:30+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"product-description\">\n<p><strong>Creavit Flow FL1500</strong> lavabo armatürü, Creavit'in modern tasarımı ve dayanıklılığıyla öne çıkan bir lavabo bataryasıdır. Hem ev hem de ticari alanlarda kullanım için uygundur.</p>\n<hr>\n<h3>🛠️ Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Model Kodu:</strong> BT.FL1500</li>\n<li>\n<strong>Seri:</strong> Flow</li>\n<li>\n<strong>Armatür Tipi:</strong> Tek kumandalı mix lavabo bataryası</li>\n<li>\n<strong>Uygulama Alanı:</strong> Lavabolar için uygun</li>\n<li>\n<strong>Malzeme:</strong> %100 pirinç gövde — korozyona karşı dayanıklı ve uzun ömürlü</li>\n<li>\n<strong>Kaplama:</strong> Parlak krom — estetik ve dayanıklı yüzey</li>\n<li>\n<strong>Çıkış Ucu Uzunluğu:</strong> 149 mm</li>\n<li>\n<strong>Çıkış Ucu Yüksekliği:</strong> 156 mm</li>\n<li>\n<strong>Kartuş:</strong> 25 mm seramik kartuş — hassas sıcaklık ve debi kontrolü sağlar</li>\n<li>\n<strong>Su Akış Debisi:</strong> 7-8 litre/dakika</li>\n<li>\n<strong>Montaj Tipi:</strong> Dikey düzlem montajı</li>\n<li>\n<strong>Montaj Aparatları:</strong> 3/8\" -M10- 50 cm fleks hortumlar ve sabitleme aparatları dahildir</li>\n<li>\n<strong>Garanti Süresi:</strong> 5 Yıl</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>\n<strong>Modern ve Şık Tasarım:</strong> Flow serisinin zarif çizgileriyle banyonuza estetik bir dokunuş katar.</li>\n<li>\n<strong>Dayanıklı Yapı:</strong> Tamamen pirinçten üretilen gövdesi, suyun tadını, kokusunu ve rengini bozmadan uzun ömürlü kullanım sunar.</li>\n<li>\n<strong>Kolay Montaj:</strong> Standart montaj aparatları sayesinde hızlı ve pratik kurulum imkanı sağlar.</li>\n<li>\n<strong>Hassas Kontrol:</strong> Seramik kartuş teknolojisi ile su sıcaklığı ve debisi üzerinde hassas kontrol imkanı sunar.</li>\n<li>\n<strong>Enerji Verimliliği:</strong> Düşük enerji tüketimi ile uzun pil ömrü sağlar.</li>\n</ul>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>Creavit BT.FL1500 Flow Lavabo Armatürü</li>\n<li>3/8\" -M10- 50 cm fleks hortumlar</li>\n<li>Sabitleme aparatları ve vidalar</li>\n<li>Kullanım, montaj ve bakım kılavuzu</li>\n</ul>\n<hr>\n<h3>🏷️ Kullanım Alanları</h3>\n<ul>\n<li>Ev banyoları</li>\n<li>Otel ve konaklama tesisleri</li>\n<li>Restoran ve kafe lavaboları</li>\n<li>Ofis ve ticari alanlar</li>\n</ul>\n<hr>\n<p><strong>Creavit BT.FL1500 Flow lavabo armatürü</strong>, zarif tasarımı ve dayanıklı yapısıyla banyolarınıza şıklık ve fonksiyonellik katmak için ideal bir tercihtir. Kolay montajı ve uzun ömürlü performansıyla kullanıcı memnuniyetini ön planda tutar.</p>\n</div>"
  },
  {
    "id": "creavit-8735154667817",
    "brand": "Creavit",
    "title": "Foglia Uzun Lavabo Armatürü Krom",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/foglia-uzun-lavabo-armaturu-krom-4254.png?v=1747223369",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/foglia-uzun-lavabo-armaturu-krom-4254.png?v=1747223369",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/foglia-uzun-lavabo-armaturu-krom-4257.jpg?v=1747223372",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/foglia-uzun-lavabo-armaturu-krom-4255.jpg?v=1747223375",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/foglia-uzun-lavabo-armaturu-krom-4256.jpg?v=1747223378"
    ],
    "price": "16650.00",
    "sku": "BT.FG6501",
    "tags": [
      "Armatür",
      "Banyo",
      "Foglia",
      "Krom",
      "Lavabo Armatürü",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843215094057,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.FG6501",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "16650.00",
        "grams": 0,
        "compare_at_price": "22200.00",
        "position": 1,
        "product_id": 8735154667817,
        "created_at": "2026-03-17T12:54:45+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p>Creavit'in Foglia serisine ait modern ve şık tasarımıyla dikkat çeken bir lavabo bataryasıdır. Hem ev hem de ticari alanlarda kullanım için uygundur.</p>\n<hr>\n<h3>🛠️ Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Model Kodu:</strong> BT.FG6501</li>\n<li>\n<strong>Seri:</strong> Foglia</li>\n<li>\n<strong>Armatür Tipi:</strong> Tek kumandalı mix lavabo bataryası</li>\n<li>\n<strong>Uygulama Alanı:</strong> Lavabolar için uygun</li>\n<li>\n<strong>Malzeme:</strong> %100 pirinç gövde — korozyona karşı dayanıklı ve uzun ömürlü</li>\n<li>\n<strong>Kaplama:</strong> Parlak krom — estetik ve dayanıklı yüzey</li>\n<li>\n<strong>Çıkış Ucu Uzunluğu:</strong> 173 mm</li>\n<li>\n<strong>Çıkış Ucu Yüksekliği:</strong> 236 mm</li>\n<li>\n<strong>Kartuş:</strong> 25 mm seramik kartuş — hassas sıcaklık ve debi kontrolü sağlar</li>\n<li>\n<strong>Su Akış Debisi:</strong> 7-8 litre/dakika</li>\n<li>\n<strong>Montaj Tipi:</strong> Dikey düzlem montajı</li>\n<li>\n<strong>Montaj Aparatları:</strong> 3/8\" -M10- 50 cm fleks hortumlar ve sabitleme aparatları dahildir</li>\n<li>\n<strong>Garanti Süresi:</strong> 5 yıl</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>\n<strong>Modern ve Şık Tasarım:</strong> Foglia serisinin zarif çizgileriyle banyonuza estetik bir dokunuş katar.</li>\n<li>\n<strong>Dayanıklı Yapı:</strong> Tamamen pirinçten üretilen gövdesi, uzun ömürlü kullanım ve suyun tadını, kokusunu ve rengini bozmayan bir yapı sunar.</li>\n<li>\n<strong>Kolay Montaj:</strong> Standart montaj aparatları sayesinde hızlı ve pratik kurulum imkanı sağlar.</li>\n<li>\n<strong>Hassas Kontrol:</strong> Seramik kartuş teknolojisi ile su sıcaklığı ve debisi üzerinde hassas kontrol imkanı sunar.</li>\n</ul>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>Creavit BT.FG6501 Foglia Uzun Lavabo Armatürü</li>\n<li>3/8\" -M10- 50 cm fleks hortumlar</li>\n<li>Sabitleme aparatları ve vidalar</li>\n<li>Kullanım, montaj ve bakım kılavuzu</li>\n</ul>\n<hr>\n<h3>🏷️ Kullanım Alanları</h3>\n<ul>\n<li>Ev banyoları</li>\n<li>Otel ve konaklama tesisleri</li>\n<li>Restoran ve kafe lavaboları</li>\n<li>Ofis ve ticari alanlar</li>\n</ul>\n<hr>\n<p><strong>Creavit BT.FG6501 Foglia Uzun lavabo armatürü</strong>, zarif tasarımı ve dayanıklı yapısıyla banyolarınıza şıklık ve fonksiyonellik katmak için ideal bir tercihtir. Kolay montajı ve uzun ömürlü performansıyla kullanıcı memnuniyetini ön planda tutar.</p>"
  },
  {
    "id": "creavit-8735124488489",
    "brand": "Creavit",
    "title": "Foglia Lavabo Armatürü Krom",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/foglia-lavabo-armaturu-krom-4250.png?v=1747223352",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/foglia-lavabo-armaturu-krom-4250.png?v=1747223352",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/foglia-lavabo-armaturu-krom-4253.jpg?v=1747223355",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/foglia-lavabo-armaturu-krom-4251.jpg?v=1747223358",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/foglia-lavabo-armaturu-krom-4252.jpg?v=1747223361"
    ],
    "price": "13950.00",
    "sku": "BT.FG1501",
    "tags": [
      "Armatür",
      "Banyo",
      "Foglia",
      "Krom",
      "Lavabo Armatürü",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843214635305,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.FG1501",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "13950.00",
        "grams": 0,
        "compare_at_price": "18600.00",
        "position": 1,
        "product_id": 8735124488489,
        "created_at": "2026-03-17T12:54:42+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div style=\"font-family: Arial, sans-serif; line-height: 1.6; color: #333;\">\n<p>Creavit'in Foglia serisine ait <strong>BT.FG1501 lavabo armatürü</strong>, modern tasarımı ve dayanıklı yapısıyla öne çıkan, tek kumandalı bir lavabo bataryasıdır. Ev ve ticari kullanımlar için ideal olan bu model, estetik görünümü ve uzun ömürlü performansıyla kullanıcılarına konforlu bir deneyim sunar.</p>\n<hr>\n<h3>🛠️ Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Model Kodu:</strong> BT.FG1501</li>\n<li>\n<strong>Seri:</strong> Foglia</li>\n<li>\n<strong>Armatür Tipi:</strong> Tek kumandalı mix lavabo bataryası</li>\n<li>\n<strong>Uygulama Alanı:</strong> Lavabolar için uygun</li>\n<li>\n<strong>Malzeme:</strong> %100 pirinç gövde — korozyona karşı dayanıklı ve uzun ömürlü</li>\n<li>\n<strong>Kaplama:</strong> Parlak krom — estetik ve dayanıklı yüzey</li>\n<li>\n<strong>Çıkış Ucu Uzunluğu:</strong> 173 mm</li>\n<li>\n<strong>Çıkış Ucu Yüksekliği:</strong> 106 mm</li>\n<li>\n<strong>Kartuş:</strong> Uzun ömürlü 25 mm seramik kartuş</li>\n<li>\n<strong>Su Akış Debisi:</strong> 7-8 litre/dakika</li>\n<li>\n<strong>Montaj Tipi:</strong> Dikey düzlem montajı</li>\n<li>\n<strong>Montaj Aparatları:</strong> 3/8\" -M10- 50 cm fleks hortumlar ve sabitleme aparatları</li>\n<li>\n<strong>Garanti Süresi:</strong> 5 yıl</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>\n<strong>Modern ve Şık Tasarım:</strong> Foglia serisinin zarif çizgileriyle banyonuza estetik bir dokunuş katar.</li>\n<li>\n<strong>Dayanıklı Yapı:</strong> Tamamen pirinçten üretilen gövdesi, suyun tadını, kokusunu ve rengini bozmayan uzun ömürlü kullanım sunar.</li>\n<li>\n<strong>Kolay Montaj:</strong> Standart aparatlarla hızlı ve pratik kurulum sağlar.</li>\n<li>\n<strong>Hassas Kontrol:</strong> Seramik kartuş ile su sıcaklığı ve debisi üzerinde yüksek hassasiyetli kontrol imkanı.</li>\n</ul>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>Creavit BT.FG1501 Foglia Lavabo Armatürü</li>\n<li>3/8\" -M10- 50 cm fleks hortumlar</li>\n<li>Sabitleme aparatları ve vidalar</li>\n<li>Kullanım, montaj ve bakım kılavuzu</li>\n</ul>\n<hr>\n<h3>🏷️ Kullanım Alanları</h3>\n<ul>\n<li>Ev banyoları</li>\n<li>Otel ve konaklama tesisleri</li>\n<li>Restoran ve kafe lavaboları</li>\n<li>Ofis ve ticari alanlar</li>\n</ul>\n<hr>\n<p><strong>Creavit BT.FG1501 Foglia lavabo armatürü</strong>, zarif tasarımı ve sağlam yapısıyla banyonuza şıklık ve fonksiyonellik katmak için ideal bir tercihtir. Kolay montajı ve uzun ömürlü performansı ile kullanıcı memnuniyetini ön planda tutar.</p>\n</div>"
  },
  {
    "id": "creavit-8728483168553",
    "brand": "Creavit",
    "title": "Fotoselli Armatür Köpük Sabun Hazneli",
    "category": "Fotoselli Armatürler",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/fotoselli-armatur-kopuk-sabun-hazneli-4247.png?v=1747223339",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/fotoselli-armatur-kopuk-sabun-hazneli-4247.png?v=1747223339",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/fotoselli-armatur-kopuk-sabun-hazneli-4248.jpg?v=1747986224",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/fotoselli-armatur-kopuk-sabun-hazneli-4249.jpg?v=1747986224"
    ],
    "price": "21750.00",
    "sku": "BT.ES7010",
    "tags": [
      "Armatür",
      "Banyo",
      "Fotoselli armatür",
      "Krom",
      "Lavabo Armatürü",
      "novatech",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843214176553,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.ES7010",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "21750.00",
        "grams": 0,
        "compare_at_price": "29000.00",
        "position": 1,
        "product_id": 8728483168553,
        "created_at": "2026-03-17T12:54:39+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"product-description\">\n<p>BT.ES7010 modeli, hijyen ve kullanım kolaylığını maksimuma çıkaran, entegre köpük sabun hazneli gelişmiş fotoselli lavabo armatürüdür. Özellikle yoğun kullanılan kamu alanları, ticari yapılar, hastaneler, restoranlar ve modern banyolar için idealdir. Temassız kullanımı sayesinde çapraz bulaşma riskini minimize eder ve su ile birlikte sabun kullanımını da otomatik hale getirir.</p>\n<h3>🛠️ Teknik Özellikler</h3>\n<ul>\n<li>Model Kodu: BT.ES7010</li>\n<li>Armatür Tipi: Fotoselli lavabo bataryası, köpük sabun hazneli entegre tasarım</li>\n<li>Malzeme: %100 pirinç gövde</li>\n<li>Kaplama: Parlak krom kaplama</li>\n<li>Renk: Parlak krom</li>\n<li>Montaj Tipi: Tezgah üstü montaj</li>\n<li>Sensör Tipi: Kızılötesi (IR)</li>\n<li>Sensör Algılama Mesafesi: 10-20 cm ayarlanabilir</li>\n<li>Su Girişi: Çift girişli (sıcak-soğuk)</li>\n<li>Kartüş: Elektronik manyetik valf</li>\n<li>Su Akış Debisi: 6-10 litre/dakika</li>\n<li>Çalışma Gerilimi: 6-12V DC</li>\n<li>Güç Kaynağı: 4 adet AAA pil veya adaptör</li>\n<li>Çıkış Ucu Uzunluğu: Yaklaşık 140 mm</li>\n<li>Çıkış Ucu Yüksekliği: Yaklaşık 133 mm</li>\n<li>Sabun Haznesi Kapasitesi: 500 ml</li>\n<li>Sabun Dağıtım Mekanizması: Elektronik pompa</li>\n<li>Açma-Kapama: Su ve sabun sensörleri ayrı çalışır</li>\n<li>Su Sıcaklığı Kontrolü: Manuel kol ile</li>\n<li>Enerji Verimliliği: Düşük enerji tüketimi</li>\n<li>Su Tasarrufu: Sensör teknolojisi ile</li>\n<li>Garanti Süre: 2 yıl</li>\n</ul>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>Entegre köpük sabun haznesi ile yer tasarrufu</li>\n<li>Temassız su ve sabun kullanımı ile maksimum hijyen</li>\n<li>Ayarlanabilir sensör mesafeleri</li>\n<li>Dayanıklı, estetik pirinç gövde ve krom kaplama</li>\n<li>Kolay montaj ve bakım</li>\n<li>Düşük enerji tüketimi ve uzun pil ömrü</li>\n<li>Optimum su ve sabun tüketimi</li>\n<li>Kullanıcı dostu sabun dolum sistemi</li>\n</ul>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>BT.ES7010 Fotoselli Lavabo Armatürü</li>\n<li>Montaj aparatları ve vidalar</li>\n<li>IR sensör ve elektronik valf modülü</li>\n<li>Köpük sabun haznesi (500 ml)</li>\n<li>4 adet AAA pil veya adaptör</li>\n<li>3/8\" fleks hortumlar</li>\n<li>Kullanım ve montaj kılavuzu</li>\n</ul>\n<h3>🏷️ Kullanım Alanları</h3>\n<ul>\n<li>Kamu binaları, hastaneler, okullar, ofisler</li>\n<li>Restoranlar, kafeler, ticari mutfaklar ve oteller</li>\n<li>Spor salonları, AVM'ler, yoğun alanlar</li>\n<li>Modern ev banyoları</li>\n</ul>\n<p><strong>Creavit BT.ES7010</strong>, temassız su ve sabun dağıtımını birleştirerek hijyen standardını yükseltir. Dayanıklı yapısı, enerji verimliliği ve estetik tasarımıyla hem kamu hem bireysel kullanım için ideal bir çözümdür.</p>\n</div>"
  },
  {
    "id": "creavit-8728478417193",
    "brand": "Creavit",
    "title": "Fotoselli Uzun Lavabo Armatürü Tek Su Girişli",
    "category": "Fotoselli Armatürler",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/fotoselli-uzun-lavabo-armaturu-tek-su-girisli-4244.png?v=1747223325",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/fotoselli-uzun-lavabo-armaturu-tek-su-girisli-4244.png?v=1747223325",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/fotoselli-uzun-lavabo-armaturu-tek-su-girisli-4245.jpg?v=1747985122",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/fotoselli-uzun-lavabo-armaturu-tek-su-girisli-4246.jpg?v=1747985122"
    ],
    "price": "16740.00",
    "sku": "BT.ES6500",
    "tags": [
      "Armatür",
      "Banyo",
      "Fotoselli armatür",
      "Krom",
      "Lavabo Armatürü",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843213717801,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.ES6500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "16740.00",
        "grams": 0,
        "compare_at_price": "22320.00",
        "position": 1,
        "product_id": 8728478417193,
        "created_at": "2026-03-17T12:54:36+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"product-description\">\n<p><strong>BT.ES6500 modeli</strong>, yüksek performanslı, gelişmiş sensör teknolojisiyle donatılmış, tek su girişli fotoselli uzun lavabo armatürüdür. Özellikle kamu alanları, ticari yapılar ve yoğun kullanımlı yerlerde hijyen ve su tasarrufu odaklı kullanım sağlar.</p>\n<hr>\n<h3>🛠️ Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Model Kodu:</strong> BT.ES6500</li>\n<li>\n<strong>Armatür Tipi:</strong> Fotoselli, uzun çıkışlı lavabo bataryası</li>\n<li>\n<strong>Su Girişi:</strong> Tek su girişli (sadece soğuk su veya önceden karışık sıcak-soğuk su)</li>\n<li>\n<strong>Montaj Tipi:</strong> Tezgah üstü montaj</li>\n<li>\n<strong>Malzeme:</strong> %100 pirinç gövde — dayanıklı ve uzun ömürlü</li>\n<li>\n<strong>Kaplama:</strong> Parlak krom kaplama — korozyona ve aşınmaya dayanıklı, estetik yüzey</li>\n<li>\n<strong>Renk:</strong> Parlak krom</li>\n<li>\n<strong>Çıkış Ucu Uzunluğu:</strong> 170 mm</li>\n<li>\n<strong>Çıkış Ucu Yüksekliği:</strong> 231 mm</li>\n<li>\n<strong>Sensör Tipi:</strong> Gelişmiş kızılötesi (IR) sensör — hareket ve varlık algılama</li>\n<li>\n<strong>Sensör Algılama Mesafesi:</strong> Ayarlanabilir, 10-20 cm arası hassas algılama</li>\n<li>\n<strong>Kartuş:</strong> Elektronik manyetik valf — hassas ve hızlı su açma/kapama kontrolü</li>\n<li>\n<strong>Su Akış Debisi:</strong> 5-9 litre/dakika (sensör optimizasyonlu)</li>\n<li>\n<strong>Çalışma Gerilimi:</strong> 6-12V DC (4 adet AAA pil veya adaptörle beslenir)</li>\n<li>\n<strong>Güç Kaynağı:</strong> Pil veya adaptör (opsiyonel)</li>\n<li>\n<strong>Açma-Kapama Mekanizması:</strong> Otomatik, sensör algılandığında su açılır, algılamayı kaybedince kapanır</li>\n<li>\n<strong>Su Sıcaklığı Kontrolü:</strong> Tek su girişli olduğundan sıcaklık kontrolü harici sistemle sağlanır veya önceden karışmış su kullanılır</li>\n<li>\n<strong>Su Tasarrufu:</strong> Sensör teknolojisi sayesinde gereksiz su tüketimi engellenir</li>\n<li>\n<strong>Enerji Verimliliği:</strong> Düşük enerji tüketimi, uzun pil ömrü</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>Temassız ve Hijyenik Kullanım: Kullanıcı musluğa dokunmadan suyu açıp kapatabilir, böylece enfeksiyon ve çapraz bulaşma riskini azaltır.</li>\n<li>Uzun Çıkış Ucu: 170 mm uzunluğu ile geniş ve derin lavabolarda rahat kullanım sağlar, ellerin rahatça yıkanmasına imkan verir.</li>\n<li>Tek Su Girişli Tasarım: Tek su hattına bağlanarak basit ve hızlı montaj; sıcak-soğuk karışım harici sistem tarafından sağlanır veya sadece soğuk su kullanılır.</li>\n<li>Ayarlanabilir Sensör Mesafesi: Kullanım alanına ve lavabo tipine göre sensör algılama mesafesi kolayca ayarlanabilir.</li>\n<li>Dayanıklı ve Şık Tasarım: Pirinç gövde ve krom kaplama uzun ömür ve modern estetik görünüm sunar.</li>\n<li>Kolay Montaj ve Bakım: Standart tezgah üstü montaj ve elektronik valf modülüne kolay erişim sayesinde pratik kurulum ve bakım.</li>\n<li>Enerji Verimli: Düşük enerji tüketimi sayesinde piller uzun süre dayanır; adaptörle sürekli güç sağlama imkanı.</li>\n<li>Manuel Kullanım İmkanı: Pil bittiğinde veya sensör arızasında bazı modellerde manuel kullanım opsiyonu (model varyasyonuna bağlı).</li>\n</ul>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>Creavit BT.ES6500 Fotoselli Uzun Lavabo Armatürü (Tek Su Girişli)</li>\n<li>Montaj bağlantı aparatları ve vidalar</li>\n<li>Elektronik manyetik valf ve kızılötesi sensör ünitesi</li>\n<li>4 adet AAA pil veya adaptör (model seçeneğine göre)</li>\n<li>3/8\" fleks bağlantı hortumları</li>\n<li>Kullanım, montaj ve bakım kılavuzu</li>\n</ul>\n<hr>\n<h3>🏷️ Kullanım Alanları</h3>\n<ul>\n<li>Kamu binaları, hastaneler, okullar, ofis ve diğer toplu kullanım alanları</li>\n<li>Restoranlar, kafeler, ticari mutfaklar ve oteller</li>\n<li>Spor salonları, alışveriş merkezleri ve yoğun kullanımlı diğer alanlar</li>\n<li>Modern konut banyoları, özellikle geniş ve derin lavabolar için ideal</li>\n</ul>\n<hr>\n<p>Creavit BT.ES6500 uzun çıkışlı fotoselli lavabo armatürü, tek su girişli yapısıyla kullanım kolaylığı ve esneklik sunar. Gelişmiş IR sensör teknolojisi ile temassız ve hijyenik kullanım sağlarken, su tasarrufunu maksimum düzeye çıkarır. Dayanıklı pirinç gövdesi ve krom kaplamasıyla uzun ömürlüdür ve modern tasarımıyla estetik bir görünüm sunar. Özellikle geniş lavabo alanlarında kullanımı kolaylaştıran uzun çıkış ucu ile pratik bir çözümdür.</p>\n</div>"
  },
  {
    "id": "creavit-8728452071721",
    "brand": "Creavit",
    "title": "Alfa Lavabo Armatürü Mat Siyah",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/RB063_4.png?v=1755769907",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/RB063_4.png?v=1755769907",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/RB063_3.png?v=1755769907"
    ],
    "price": "6300.00",
    "sku": "BT.AL1500S",
    "tags": [
      "Alfa",
      "Armatür",
      "Banyo",
      "Lavabo Armatürü",
      "Mat Siyah",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843242651945,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.AL1500S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6300.00",
        "grams": 0,
        "compare_at_price": "8400.00",
        "position": 1,
        "product_id": 8728452071721,
        "created_at": "2026-03-17T13:04:19+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div style=\"font-family: Arial, sans-serif; color: #333;\">\n<p>Creavit'in <strong>Alfa serisine</strong> ait <strong>AL1500S siyah lavabo bataryası</strong>, modern tasarımı ve fonksiyonelliğiyle banyolarınıza şıklık katmak için tasarlanmıştır. <meta charset=\"utf-8\"><strong>Creavit AL1500S</strong>, şıklığı, dayanıklılığı ve fonksiyonelliğiyle banyonuza modern bir atmosfer katmak isteyenler için mükemmel bir seçimdir. Krom kaplaması ve kaliteli seramik kartuşuyla uzun ömürlü ve kullanıcı dostu bir üründür.</p>\n<hr>\n<ul>\n<li>\n<strong>Malzeme:</strong> %100 pirinç</li>\n<li>\n<strong>Kaplama:</strong> Krom</li>\n<li>\n<strong>Montaj Tipi:</strong> Tezgah üstü montaj (dikey düzlem)<strong></strong>\n</li>\n<li>\n<strong>Garanti Süresi:</strong> 5 Yıl</li>\n</ul>\n</div>"
  },
  {
    "id": "creavit-8728445387049",
    "brand": "Creavit",
    "title": "Alfa Lavabo Armatürü Krom",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/alfa-lavabo-armaturu-krom-4240.png?v=1747223308",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/alfa-lavabo-armaturu-krom-4240.png?v=1747223308",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/alfa-lavabo-armaturu-krom-4241.png?v=1747223313",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/alfa-lavabo-armaturu-krom-4242.png?v=1747223317"
    ],
    "price": "5895.00",
    "sku": "BT.AL1500",
    "tags": [
      "Alfa",
      "Armatür",
      "Banyo",
      "Krom",
      "Lavabo Armatürü",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843227349289,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.AL1500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5895.00",
        "grams": 0,
        "compare_at_price": "7860.00",
        "position": 1,
        "product_id": 8728445387049,
        "created_at": "2026-03-17T12:58:49+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div style=\"font-family: Arial, sans-serif; color: #333;\">\n<p>Creavit'in <strong>Alfa serisine</strong> ait <strong>AL1500 lavabo bataryası</strong>, modern tasarımı ve fonksiyonelliğiyle banyolarınıza şıklık katmak için tasarlanmıştır.</p>\n<hr>\n<h3>🛠️ Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Model Kodu:</strong> AL1500</li>\n<li>\n<strong>Seri:</strong> Alfa</li>\n<li>\n<strong>Malzeme:</strong> %100 pirinç</li>\n<li>\n<strong>Kaplama:</strong> Krom</li>\n<li>\n<strong>Armatür Tipi:</strong> Tek kumandalı miks armatür</li>\n<li>\n<strong>Montaj Tipi:</strong> Tezgah üstü montaj (dikey düzlem)</li>\n<li>\n<strong>Kartuş:</strong> Uzun ömürlü 26 mm seramik kartuş</li>\n<li>\n<strong>Su Akış Debisi:</strong> 7–8 litre/dakika</li>\n<li>\n<strong>Çıkış Ucu Uzunluğu:</strong> 130 mm</li>\n<li>\n<strong>Çıkış Ucu Yüksekliği:</strong> 115 mm</li>\n<li>\n<strong>Boru:</strong> Sabit</li>\n<li>\n<strong>Şekil:</strong> Kare</li>\n<li>\n<strong>Su Girişi:</strong> Çift (sıcak-soğuk)</li>\n<li>\n<strong>Renk Seçenekleri:</strong> Krom</li>\n<li>\n<strong>Garanti Süresi:</strong> 5 Yıl</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>\n<strong>Modern Tasarım:</strong> Minimalist ve şık hatlar.</li>\n<li>\n<strong>Krom Kaplama:</strong> Parlak ve uzun ömürlü yüzey.</li>\n<li>\n<strong>Seramik Kartuş:</strong> Hassas sıcaklık ve debi ayarı.</li>\n<li>\n<strong>Kolay Montaj:</strong> Tezgah üstü montaj ile pratik kurulum.</li>\n</ul>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>1 x Creavit AL1500 Alfa Lavabo Bataryası</li>\n<li>2 x 3/8\" - M10 - 50 cm Fleks Hortum</li>\n<li>1 x Montaj ve Sabitleme Aparatları</li>\n<li>1 x Kullanım ve Kurulum Kılavuzu</li>\n</ul>\n<hr>\n<p><strong>Creavit AL1500</strong>, şıklığı, dayanıklılığı ve fonksiyonelliğiyle banyonuza modern bir atmosfer katmak isteyenler için mükemmel bir seçimdir. Krom kaplaması ve kaliteli seramik kartuşuyla uzun ömürlü ve kullanıcı dostu bir üründür.</p>\n</div>"
  },
  {
    "id": "creavit-8728407933225",
    "brand": "Creavit",
    "title": "Avangart Lavabo Armatürü Altın",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/avangart-lavabo-armaturu-altin-4238.png?v=1747223296",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/avangart-lavabo-armaturu-altin-4238.png?v=1747223296",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/avangart-lavabo-armaturu-altin-4239.jpg?v=1747223300"
    ],
    "price": "5976.00",
    "sku": "BT.AG1500G",
    "tags": [
      "altın",
      "Armatür",
      "avangart",
      "Banyo",
      "kireç temizleme",
      "Lavabo Armatürü",
      "sessiz su akışı",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52836656251177,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.AG1500G",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "5976.00",
        "grams": 0,
        "compare_at_price": "9960.00",
        "position": 1,
        "product_id": 8728407933225,
        "created_at": "2026-03-15T21:10:32+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p><strong>BT.AG1500G</strong>, Creavit markasının Avangart serisine ait Gold Renk bir lavabo bataryası modelidir. Şıklığı, dayanıklılığı ve fonksiyonelliğiyle öne çıkan bu batarya, banyo dekorasyonuna modern bir dokunuş katar.</p>\n<hr>\n<h3>🛁 Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Malzeme:</strong> %100 pirinç.</li>\n<li>\n<strong>Kartuş:</strong> Uzun ömürlü 35 mm seramik ayaklı kartuş.</li>\n<li>\n<strong>Perlatör:</strong> Kolay değiştirilebilir, kireç temizleme sistemli, sessiz su akışı sağlayan perlatör.</li>\n<li>\n<strong>Montaj Tipi:</strong> Tezgah üstü montaj.</li>\n<li>\n<strong>Şekil:</strong> Kare.</li>\n<li>\n<strong>Boru:</strong> Sabit.</li>\n<li>\n<strong>Çıkış Ucu Uzunluğu:</strong> 123,6 mm.</li>\n<li>\n<strong>Çıkış Ucu Yüksekliği:</strong> 113,7 mm.</li>\n<li>\n<strong>Renk:</strong> Gold.</li>\n<li>\n<strong>Garanti Süresi:</strong> 5 Yıl.</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>\n<strong>Krom Kaplama:</strong> Modern ve parlak görünüm sağlar, uzun ömürlüdür.</li>\n<li>\n<strong>Kireç Temizleme Sistemi:</strong> Su akışını engelleyen kireç birikintilerini önler.</li>\n<li>\n<strong>Seramik Kartuş:</strong> Sıcaklık ve su debisi ayarlarını hassas bir şekilde yapar, uzun ömürlüdür.</li>\n<li>\n<strong>Kolay Montaj:</strong> Tezgah üstü montaj ile pratik kurulum imkanı sunar.</li>\n</ul>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>Batarya: Creavit AG1500 Avangart Lüx Lavabo Bataryası.</li>\n<li>Montaj Aparatları: Montaj için gerekli tüm aparat ve bağlantı elemanları.</li>\n<li>Kullanım Kılavuzu: Kurulum ve bakım talimatlarını içeren kılavuz.</li>\n</ul>\n<hr>\n<p>Creavit AG1500G Avangart Lüx Gold Renk Lavabo Bataryası, şıklığı, dayanıklılığı ve fonksiyonelliğiyle banyonuzda modern bir atmosfer yaratmak isteyenler için ideal bir tercihtir. Krom kaplama ve kireç temizleme sistemi gibi özellikleri sayesinde uzun ömürlü ve kullanıcı dostudur. Fiyat-performans açısından da tatmin edici bir üründür.</p>"
  },
  {
    "id": "creavit-8633553092905",
    "brand": "Creavit",
    "title": "Pion Boy Dolabı 40*160 cm Mat Antrasit",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-pion-boy-dolabi-antrasit-banyo-mobilyasi.png?v=1749221653",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-pion-boy-dolabi-antrasit-banyo-mobilyasi.png?v=1749221653",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-boy-dolabi-40-160-cm-mat-antrasit-4235.jpg?v=1749221653",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-boy-dolabi-40-160-cm-mat-antrasit-4236.jpg?v=1757426389",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-boy-dolabi-40-160-cm-mat-antrasit-4237.jpg?v=1757426389",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-boy-dolabi-40-160-cm-mat-antrasit-4234.jpg?v=1749221653"
    ],
    "price": "45127.50",
    "sku": "PN2160.01.GR",
    "tags": [
      "Banyo Mobilyası",
      "boy dolabı",
      "küçük banyolar",
      "Pion"
    ],
    "variants": [
      {
        "id": 52843191927081,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "PN2160.01.GR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "45127.50",
        "grams": 0,
        "compare_at_price": "60170.00",
        "position": 1,
        "product_id": 8633553092905,
        "created_at": "2026-03-17T12:48:08+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Büyük Düşünülmüş Küçük Banyolar: Creavit Pion Banyo Mobilyaları!</strong></p>\r\n<p data-mce-fragment=\"1\"><span data-mce-fragment=\"1\">Pion Banyo mobilyaları, hayalizi yansıtan estetik ve karakteristik fonksiyonel ürünlerle banyonuzda büyük düşünmenizi sağlayacak. İhtiyacınıza uygun depolama seçenekleri ile günlük kullanımınız için gereken tüm öğeleri düzenli tutabilirsiniz. </span></p>\r\n<p data-mce-fragment=\"1\">Dayanıklı malzemeler ve dikkatlice seçilmiş detaylar, uzun yıllar boyunca kullanabileceğiniz kaliteli ürünler sunar. Bu özel koleksiyon, geçmişin zarafetini günümüze taşırken işlevselliği de unutmuyor. </p>"
  },
  {
    "id": "creavit-8633552961833",
    "brand": "Creavit",
    "title": "Mio Boy Dolabı 140 cm Antrasit-Kansas",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crevit-mio-ahsap-boy-dolabi-banyo-mobilyasi.png?v=1749221705",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crevit-mio-ahsap-boy-dolabi-banyo-mobilyasi.png?v=1749221705",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mio-boy-dolabi-140-cm-antrasit-kansas-4231.jpg?v=1749221705",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mio-boy-dolabi-140-cm-antrasit-kansas-4232.jpg?v=1749221705",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mio-boy-dolabi-140-cm-antrasit-kansas-4233.jpg?v=1749221705"
    ],
    "price": "3978.00",
    "sku": "MI2140.00.AK",
    "tags": [
      "Banyo Mobilyası",
      "boy dolabı",
      "küçük banyolar",
      "mio"
    ],
    "variants": [
      {
        "id": 52921480347945,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MI2140.00.AK",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3978.00",
        "grams": 0,
        "compare_at_price": "6630.00",
        "position": 1,
        "product_id": 8633552961833,
        "created_at": "2026-04-03T14:43:33+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\">Küçük ve dar banyolar için özel olarak tasarlanmış Mio Boy Dolabı işlevsellik ve şıklığı bir araya getiriyor. Sınırlı alana sahip banyolarda ek depolama ihtiyacını karşılamak üzere tasarlanan bu dolap dayanıklı malzemelerle uzun ömürlü kullanım sunarken, modern ve zarif tasarımı ile banyonuza zarif bir hava katacak.</p>\n<p data-mce-fragment=\"1\">Mio Banyo Mobilyaları hayalinizi yansıtan estetik ve karakteristik fonksiyonel ürünlerle banyonuzda büyük düşünmenizi sağlayacak. İhtiyacınıza uygun depolama seçenekleri ile banyonuzu her zaman düzenli tutun.</p>"
  },
  {
    "id": "creavit-8633552830761",
    "brand": "Creavit",
    "title": "Mio Boy Dolabı 140 cm Antrasit-Açık Ceviz",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crevit-mio-ceviz-boy-dolabi-banyo-mobilyasi.png?v=1749221735",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/crevit-mio-ceviz-boy-dolabi-banyo-mobilyasi.png?v=1749221735",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mio-boy-dolabi-140-cm-antrasit-acik-ceviz-4228.jpg?v=1749221735",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mio-boy-dolabi-140-cm-antrasit-acik-ceviz-4226.jpg?v=1749221735",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mio-boy-dolabi-140-cm-antrasit-acik-ceviz-4229.jpg?v=1749221730"
    ],
    "price": "3978.00",
    "sku": "MI2140.00.AV",
    "tags": [
      "Banyo Mobilyası",
      "boy dolabı",
      "Boy Dolap",
      "küçük banyolar",
      "mio"
    ],
    "variants": [
      {
        "id": 52452318675241,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MI2140.00.AV",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "3978.00",
        "grams": 0,
        "compare_at_price": "6630.00",
        "position": 1,
        "product_id": 8633552830761,
        "created_at": "2026-01-16T16:23:46+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\">Küçük ve dar banyolar için özel olarak tasarlanmış Mio Boy Dolabı işlevsellik ve şıklığı bir araya getiriyor. Sınırlı alana sahip banyolarda ek depolama ihtiyacını karşılamak üzere tasarlanan bu dolap dayanıklı malzemelerle uzun ömürlü kullanım sunarken, modern ve zarif tasarımı ile banyonuza zarif bir hava katacak.</p>\n<p data-mce-fragment=\"1\">Mio Banyo Mobilyaları hayalinizi yansıtan estetik ve karakteristik fonksiyonel ürünlerle banyonuzda büyük düşünmenizi sağlayacak. İhtiyacınıza uygun depolama seçenekleri ile banyonuzu her zaman düzenli tutun.</p>"
  },
  {
    "id": "creavit-8633552765225",
    "brand": "Creavit",
    "title": "Kayra Boy Dolabı 130cm Mat Safire Blue",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-boy-dolabi-mavi.png?v=1748524380",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-boy-dolabi-mavi.png?v=1748524380",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-boy-dolabi-130cm-mat-safire-blue-4224.jpg?v=1748524380",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-boy-dolabi-130cm-mat-safire-blue-4223.jpg?v=1748524380",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-boy-dolabi-130cm-mat-safire-blue-4225.jpg?v=1748524594"
    ],
    "price": "18397.50",
    "sku": "KY2130.01.MSB",
    "tags": [
      "Banyo Mobilyası",
      "boy dolabı",
      "kayra",
      "mat safir mavi",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52867282239785,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY2130.01.MSB",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "18397.50",
        "grams": 0,
        "compare_at_price": "24530.00",
        "position": 1,
        "product_id": 8633552765225,
        "created_at": "2026-03-23T16:03:08+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-col text-sm dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-mce-fragment=\"1\" data-testid=\"conversation-turn-136\">\r\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\" data-mce-fragment=\"1\">\r\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\" data-mce-fragment=\"1\">\r\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\" data-mce-fragment=\"1\">\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p><strong><span class=\"s6\">Creavit Kayra; Zamansız ve Stil Sahibi!</span></strong></p>\r\n<p><span class=\"s6\">Yaratıcı ve estetik çözümleriyle banyoları birer yaşam alanı olarak tasarlayan Creavit, Country stiline özgü çizgiler barındıran Kayra ile yeni nesil banyolar için ideal birseçenek sunuyor.</span></p>\r\n<p><strong><span class=\"s6\">Klasikten Vazgeçemeyenler için Tasarlandı</span></strong></p>\r\n<p><span class=\"s6\">Klasik dokusunu yanında yüzeylerinde 'country' stiline özgü çizgiler de barındıran Kayra serisi; klasik tasarımdan vazgeçemeyen kullanıcılara yeni bir model seçeneği sunuyor. Klasik tasarımının yanında mat görünümü; antrasit, beyaz, gri ve safir mavi renkleriyle banyolarınızda zamansız tasarımlar elde etmenize imkan sağlıyor.</span></p>\r\n<p><strong><span class=\"s6\">İç Mekanlar ile Uyumlu</span></strong></p>\r\n<p><span class=\"s6\">Creavit, Kayra serisi ile dar ve küçük alanlara sahip banyolar için de tercih edilebilecek çözümler sunuyor. Kayra 100 cm'lik model alternatifine ek olarak tasarlanan 60 ve 80 cm'lik modelleriyle, küçük alanlarda etkileyici tasarımlar oluşturmanıza yardımcı oluyor.</span></p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633552634153",
    "brand": "Creavit",
    "title": "Kayra Boy Dolabı 130cm Mat Antrasit",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-boy-dolabi-antrasit.png?v=1748524468",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-boy-dolabi-antrasit.png?v=1748524468",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-60cm-mat-antrasit-4064.jpg?v=1748861477",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-boy-dolabi-130cm-mat-antrasit-4221.jpg?v=1748524468",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-boy-dolabi-130cm-mat-safire-blue-4225.jpg?v=1748524594"
    ],
    "price": "18397.50",
    "sku": "KY2130.01.MAN",
    "tags": [
      "Banyo Mobilyası",
      "boy dolabı",
      "kayra",
      "Mat Antrasit",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52843186290985,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY2130.01.MAN",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "18397.50",
        "grams": 0,
        "compare_at_price": "24530.00",
        "position": 1,
        "product_id": 8633552634153,
        "created_at": "2026-03-17T12:46:28+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-col text-sm dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-mce-fragment=\"1\" data-testid=\"conversation-turn-136\">\r\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\" data-mce-fragment=\"1\">\r\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\" data-mce-fragment=\"1\">\r\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\" data-mce-fragment=\"1\">\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p><strong><span class=\"s6\">Creavit Kayra; Zamansız ve Stil Sahibi!</span></strong></p>\r\n<p><span class=\"s6\">Yaratıcı ve estetik çözümleriyle banyoları birer yaşam alanı olarak tasarlayan Creavit, Country stiline özgü çizgiler barındıran Kayra ile yeni nesil banyolar için ideal birseçenek sunuyor.</span></p>\r\n<p><strong><span class=\"s6\">Klasikten Vazgeçemeyenler için Tasarlandı</span></strong></p>\r\n<p><span class=\"s6\">Klasik dokusunu yanında yüzeylerinde 'country' stiline özgü çizgiler de barındıran Kayra serisi; klasik tasarımdan vazgeçemeyen kullanıcılara yeni bir model seçeneği sunuyor. Klasik tasarımının yanında mat görünümü; antrasit, beyaz, gri ve safir mavi renkleriyle banyolarınızda zamansız tasarımlar elde etmenize imkan sağlıyor.</span></p>\r\n<p><strong><span class=\"s6\">İç Mekanlar ile Uyumlu</span></strong></p>\r\n<p><span class=\"s6\">Creavit, Kayra serisi ile dar ve küçük alanlara sahip banyolar için de tercih edilebilecek çözümler sunuyor. Kayra 100 cm'lik model alternatifine ek olarak tasarlanan 60 ve 80 cm'lik modelleriyle, küçük alanlarda etkileyici tasarımlar oluşturmanıza yardımcı oluyor.</span></p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633552470313",
    "brand": "Creavit",
    "title": "Kayra Boy Dolabı 130cm Mat Gri",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-boy-dolabi-gri.png?v=1748524560",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-boy-dolabi-gri.png?v=1748524560",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-boy-dolabi-130cm-mat-gri-4219.jpg?v=1748524560",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-boy-dolabi-130cm-mat-gri-4218.jpg?v=1748524560",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-boy-dolabi-130cm-mat-gri-4220.jpg?v=1748524558"
    ],
    "price": "18397.50",
    "sku": "KY2130.01.MGR",
    "tags": [
      "Banyo Mobilyası",
      "boy dolabı",
      "kayra",
      "mat gri",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52843186094377,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY2130.01.MGR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "18397.50",
        "grams": 0,
        "compare_at_price": "24530.00",
        "position": 1,
        "product_id": 8633552470313,
        "created_at": "2026-03-17T12:46:25+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-col text-sm dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-mce-fragment=\"1\" data-testid=\"conversation-turn-136\">\r\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\" data-mce-fragment=\"1\">\r\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\" data-mce-fragment=\"1\">\r\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\" data-mce-fragment=\"1\">\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p><strong><span class=\"s6\">Creavit Kayra; Zamansız ve Stil Sahibi!</span></strong></p>\r\n<p><span class=\"s6\">Yaratıcı ve estetik çözümleriyle banyoları birer yaşam alanı olarak tasarlayan Creavit, Country stiline özgü çizgiler barındıran Kayra ile yeni nesil banyolar için ideal birseçenek sunuyor.</span></p>\r\n<p><strong><span class=\"s6\">Klasikten Vazgeçemeyenler için Tasarlandı</span></strong></p>\r\n<p><span class=\"s6\">Klasik dokusunu yanında yüzeylerinde 'country' stiline özgü çizgiler de barındıran Kayra serisi; klasik tasarımdan vazgeçemeyen kullanıcılara yeni bir model seçeneği sunuyor. Klasik tasarımının yanında mat görünümü; antrasit, beyaz, gri ve safir mavi renkleriyle banyolarınızda zamansız tasarımlar elde etmenize imkan sağlıyor.</span></p>\r\n<p><strong><span class=\"s6\">İç Mekanlar ile Uyumlu</span></strong></p>\r\n<p><span class=\"s6\">Creavit, Kayra serisi ile dar ve küçük alanlara sahip banyolar için de tercih edilebilecek çözümler sunuyor. Kayra 100 cm'lik model alternatifine ek olarak tasarlanan 60 ve 80 cm'lik modelleriyle, küçük alanlarda etkileyici tasarımlar oluşturmanıza yardımcı oluyor.</span></p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633552339241",
    "brand": "Creavit",
    "title": "Kayra Boy Dolabı 130cm Mat Beyaz",
    "category": "Boy Dolapları",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-boy-dolabi-beyaz.png?v=1748524625",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-boy-dolabi-beyaz.png?v=1748524625",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-boy-dolabi-130cm-mat-beyaz-4216.jpg?v=1748524625",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-boy-dolabi-130cm-mat-beyaz-4215.jpg?v=1748524625",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-boy-dolabi-130cm-mat-beyaz-4217.jpg?v=1748524623"
    ],
    "price": "18397.50",
    "sku": "KY2130.01.MBY",
    "tags": [
      "Banyo Mobilyası",
      "boy dolabı",
      "kayra",
      "Mat Beyaz",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52892532670761,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY2130.01.MBY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "18397.50",
        "grams": 0,
        "compare_at_price": "24530.00",
        "position": 1,
        "product_id": 8633552339241,
        "created_at": "2026-03-28T20:42:41+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-col text-sm dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-mce-fragment=\"1\" data-testid=\"conversation-turn-136\">\r\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\" data-mce-fragment=\"1\">\r\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\" data-mce-fragment=\"1\">\r\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\" data-mce-fragment=\"1\">\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p><strong><span class=\"s6\">Creavit Kayra; Zamansız ve Stil Sahibi!</span></strong></p>\r\n<p><span class=\"s6\">Yaratıcı ve estetik çözümleriyle banyoları birer yaşam alanı olarak tasarlayan Creavit, Country stiline özgü çizgiler barındıran Kayra ile yeni nesil banyolar için ideal birseçenek sunuyor.</span></p>\r\n<p><strong><span class=\"s6\">Klasikten Vazgeçemeyenler için Tasarlandı</span></strong></p>\r\n<p><span class=\"s6\">Klasik dokusunu yanında yüzeylerinde 'country' stiline özgü çizgiler de barındıran Kayra serisi; klasik tasarımdan vazgeçemeyen kullanıcılara yeni bir model seçeneği sunuyor. Klasik tasarımının yanında mat görünümü; antrasit, beyaz, gri ve safir mavi renkleriyle banyolarınızda zamansız tasarımlar elde etmenize imkan sağlıyor.</span></p>\r\n<p><strong><span class=\"s6\">İç Mekanlar ile Uyumlu</span></strong></p>\r\n<p><span class=\"s6\">Creavit, Kayra serisi ile dar ve küçük alanlara sahip banyolar için de tercih edilebilecek çözümler sunuyor. Kayra 100 cm'lik model alternatifine ek olarak tasarlanan 60 ve 80 cm'lik modelleriyle, küçük alanlarda etkileyici tasarımlar oluşturmanıza yardımcı oluyor.</span></p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633552208169",
    "brand": "Creavit",
    "title": "Pion Plus Ayna 60 cm Beyaz",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-pion-plus-ayna-banyo-mobilyasi-beyaz.png?v=1749221764",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-pion-plus-ayna-banyo-mobilyasi-beyaz.png?v=1749221764",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-plus-ayna-60-cm-beyaz-4214.jpg?v=1749221764",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-plus-ayna-60-cm-beyaz-4213.jpg?v=1749221764",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-plus-ayna-60-cm-beyaz-4211.jpg?v=1749221764"
    ],
    "price": "29370.00",
    "sku": "PN1070.01.BB",
    "tags": [
      "Ayna",
      "Banyo Mobilyası",
      "dolaplı ayna",
      "küçük banyolar",
      "Pion"
    ],
    "variants": [
      {
        "id": 52843185963305,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "PN1070.01.BB",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "29370.00",
        "grams": 0,
        "compare_at_price": "39160.00",
        "position": 1,
        "product_id": 8633552208169,
        "created_at": "2026-03-17T12:46:22+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong><span data-mce-fragment=\"1\">Büyük Düşünülmüş Küçük Banyolar: Creavit Pion Aynalar!</span></strong></p>\r\n<p data-mce-fragment=\"1\">Creavit Pion Plus Ayna sabah ve akşamları, her zaman en iyi görünümünüzü yakalamanıza yardımcı olacak. Pion Plus kendinden raflı ve LED Işıklı tasarımıyla banyo deneyiminizi daha aydınlık ve işlevsel hale getirecek. Modern ve minimalist tasarımı, her türlü banyo dekoruna uyum sağlarken aynı zamanda bulundukları alanı daha geniş gösterme özelliği sayesinde banyonuz ferah bir görüntüye ulaşacak.<span> </span></p>"
  },
  {
    "id": "creavit-8633552109865",
    "brand": "Creavit",
    "title": "Mio Ayna 45 cm Antrasit",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mio-ayna-45-cm-antrasit-4208.jpg?v=1751456205",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mio-ayna-45-cm-antrasit-4208.jpg?v=1751456205",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mio-ayna-45-cm-antrasit-4209.jpg?v=1747223164",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/mio-ayna-45-cm-antrasit-4210.jpg?v=1747223167"
    ],
    "price": "1758.00",
    "sku": "MI1045.00.AA",
    "tags": [
      "Ayna",
      "Banyo Mobilyası",
      "mio"
    ],
    "variants": [
      {
        "id": 52452318445865,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MI1045.00.AA",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "1758.00",
        "grams": 0,
        "compare_at_price": "2930.00",
        "position": 1,
        "product_id": 8633552109865,
        "created_at": "2026-01-16T16:23:27+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p><strong style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\">Büyük Düşünülmüş Küçük Banyolar: Creavit Mio Aynalar!</strong><br></p>\n<p data-mce-fragment=\"1\"><meta charset=\"utf-8\">Creavit Mio Ayna sabah ve akşamları, her zaman en iyi görünümünüzü yakalamanıza yardımcı olacak. Mio Aynalar kendinden raflı tasarımıyla banyo deneyiminizi daha aydınlık ve işlevsel hale getirecek. Modern ve minimalist tasarımı, her türlü banyo dekoruna uyum sağlarken aynı zamanda bulundukları alanı daha geniş gösterme özelliği sayesinde banyonuz ferah bir görüntüye ulaşacak.<meta charset=\"utf-8\"><span> </span></p>"
  },
  {
    "id": "creavit-8633551913257",
    "brand": "Creavit",
    "title": "Kayra Led Ayna 50cm Mat Safire Blue",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-led-ayna-50cm-mat-safire-blue-4207.png?v=1747804672",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-led-ayna-50cm-mat-safire-blue-4207.png?v=1747804672",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-safir-blue-cekmeceli-lavabo-dolabi-80-cm-4123.jpg?v=1748860418",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/KY4001.01.MSB.jpg?v=1748525842",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/KY4001.01-AYNALAR-ORTAK.jpg?v=1748526047"
    ],
    "price": "11137.50",
    "sku": "KY4001.01.MSB",
    "tags": [
      "Banyo Mobilyası",
      "kayra",
      "led ayna",
      "mat safir mavi",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52843260215593,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY4001.01.MSB",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11137.50",
        "grams": 0,
        "compare_at_price": "14850.00",
        "position": 1,
        "product_id": 8633551913257,
        "created_at": "2026-03-17T13:09:33+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-col text-sm dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-mce-fragment=\"1\" data-testid=\"conversation-turn-136\">\r\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\" data-mce-fragment=\"1\">\r\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\" data-mce-fragment=\"1\">\r\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\" data-mce-fragment=\"1\">\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p><strong><span class=\"s6\">Creavit Kayra; Zamansız ve Stil Sahibi!</span></strong></p>\r\n<p><span class=\"s6\">Yaratıcı ve estetik çözümleriyle banyoları birer yaşam alanı olarak tasarlayan Creavit, Country stiline özgü çizgiler barındıran Kayra ile yeni nesil banyolar için ideal birseçenek sunuyor.</span></p>\r\n<p><strong><span class=\"s6\">Klasikten Vazgeçemeyenler için Tasarlandı</span></strong></p>\r\n<p><span class=\"s6\">Klasik dokusunu yanında yüzeylerinde 'country' stiline özgü çizgiler de barındıran Kayra serisi; klasik tasarımdan vazgeçemeyen kullanıcılara yeni bir model seçeneği sunuyor. Klasik tasarımının yanında mat görünümü; antrasit, beyaz, gri ve safir mavi renkleriyle banyolarınızda zamansız tasarımlar elde etmenize imkan sağlıyor.</span></p>\r\n<p><strong><span class=\"s6\">İç Mekanlar ile Uyumlu</span></strong></p>\r\n<p><span class=\"s6\">Creavit, Kayra serisi ile dar ve küçük alanlara sahip banyolar için de tercih edilebilecek çözümler sunuyor. Kayra 100 cm'lik model alternatifine ek olarak tasarlanan 60 ve 80 cm'lik modelleriyle, küçük alanlarda etkileyici tasarımlar oluşturmanıza yardımcı oluyor.</span></p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633551782185",
    "brand": "Creavit",
    "title": "Kayra Led Ayna 50cm Mat Antrasit",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-led-ayna-50cm-mat-antrasit-4206.png?v=1747804677",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-led-ayna-50cm-mat-antrasit-4206.png?v=1747804677",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-60cm-mat-antrasit-4064.jpg?v=1748861477",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/KY4001.01.MAN.jpg?v=1748525798",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/KY4001.01-AYNALAR-ORTAK.jpg?v=1748526047"
    ],
    "price": "11137.50",
    "sku": "KY4001.01.MAN",
    "tags": [
      "Banyo Mobilyası",
      "kayra",
      "led ayna",
      "Mat Antrasit",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52843240325417,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY4001.01.MAN",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11137.50",
        "grams": 0,
        "compare_at_price": "14850.00",
        "position": 1,
        "product_id": 8633551782185,
        "created_at": "2026-03-17T13:03:38+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-col text-sm dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-mce-fragment=\"1\" data-testid=\"conversation-turn-136\">\r\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\" data-mce-fragment=\"1\">\r\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\" data-mce-fragment=\"1\">\r\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\" data-mce-fragment=\"1\">\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p><strong><span class=\"s6\">Creavit Kayra; Zamansız ve Stil Sahibi!</span></strong></p>\r\n<p><span class=\"s6\">Yaratıcı ve estetik çözümleriyle banyoları birer yaşam alanı olarak tasarlayan Creavit, Country stiline özgü çizgiler barındıran Kayra ile yeni nesil banyolar için ideal birseçenek sunuyor.</span></p>\r\n<p><strong><span class=\"s6\">Klasikten Vazgeçemeyenler için Tasarlandı</span></strong></p>\r\n<p><span class=\"s6\">Klasik dokusunu yanında yüzeylerinde 'country' stiline özgü çizgiler de barındıran Kayra serisi; klasik tasarımdan vazgeçemeyen kullanıcılara yeni bir model seçeneği sunuyor. Klasik tasarımının yanında mat görünümü; antrasit, beyaz, gri ve safir mavi renkleriyle banyolarınızda zamansız tasarımlar elde etmenize imkan sağlıyor.</span></p>\r\n<p><strong><span class=\"s6\">İç Mekanlar ile Uyumlu</span></strong></p>\r\n<p><span class=\"s6\">Creavit, Kayra serisi ile dar ve küçük alanlara sahip banyolar için de tercih edilebilecek çözümler sunuyor. Kayra 100 cm'lik model alternatifine ek olarak tasarlanan 60 ve 80 cm'lik modelleriyle, küçük alanlarda etkileyici tasarımlar oluşturmanıza yardımcı oluyor.</span></p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633551683881",
    "brand": "Creavit",
    "title": "Kayra Led Ayna 50cm Mat Gri",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-led-ayna-50cm-mat-gri-4205.png?v=1747804681",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-led-ayna-50cm-mat-gri-4205.png?v=1747804681",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-ayna-yan-dolabi-30cm-mat-beyaz-4199.jpg?v=1748853574",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-80cm-mat-gri-4116.jpg?v=1748860452",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/KY4001.01.MGR.jpg?v=1748525966",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/KY4001.01-AYNALAR-ORTAK.jpg?v=1748526047"
    ],
    "price": "11137.50",
    "sku": "KY4001.01.MGR",
    "tags": [
      "Banyo Mobilyası",
      "kayra",
      "led ayna",
      "mat gri",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52921480184105,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY4001.01.MGR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "11137.50",
        "grams": 0,
        "compare_at_price": "14850.00",
        "position": 1,
        "product_id": 8633551683881,
        "created_at": "2026-04-03T14:43:29+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-col text-sm dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-mce-fragment=\"1\" data-testid=\"conversation-turn-136\">\r\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\" data-mce-fragment=\"1\">\r\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\" data-mce-fragment=\"1\">\r\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\" data-mce-fragment=\"1\">\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p><strong><span class=\"s6\">Creavit Kayra; Zamansız ve Stil Sahibi!</span></strong></p>\r\n<p><span class=\"s6\">Yaratıcı ve estetik çözümleriyle banyoları birer yaşam alanı olarak tasarlayan Creavit, Country stiline özgü çizgiler barındıran Kayra ile yeni nesil banyolar için ideal birseçenek sunuyor.</span></p>\r\n<p><strong><span class=\"s6\">Klasikten Vazgeçemeyenler için Tasarlandı</span></strong></p>\r\n<p><span class=\"s6\">Klasik dokusunu yanında yüzeylerinde 'country' stiline özgü çizgiler de barındıran Kayra serisi; klasik tasarımdan vazgeçemeyen kullanıcılara yeni bir model seçeneği sunuyor. Klasik tasarımının yanında mat görünümü; antrasit, beyaz, gri ve safir mavi renkleriyle banyolarınızda zamansız tasarımlar elde etmenize imkan sağlıyor.</span></p>\r\n<p><strong><span class=\"s6\">İç Mekanlar ile Uyumlu</span></strong></p>\r\n<p><span class=\"s6\">Creavit, Kayra serisi ile dar ve küçük alanlara sahip banyolar için de tercih edilebilecek çözümler sunuyor. Kayra 100 cm'lik model alternatifine ek olarak tasarlanan 60 ve 80 cm'lik modelleriyle, küçük alanlarda etkileyici tasarımlar oluşturmanıza yardımcı oluyor.</span></p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633551454505",
    "brand": "Creavit",
    "title": "Kayra Led Ayna 50cm Mat Beyaz",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-led-ayna-50cm-mat-beyaz-4204.png?v=1747804686",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-led-ayna-50cm-mat-beyaz-4204.png?v=1747804686",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-beyaz-lavabo-dolabi-cekmeceli-100cm-4153.jpg?v=1748855548",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/KY4001.01.MBY.jpg?v=1748526047",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/KY4001.01-AYNALAR-ORTAK.jpg?v=1748526047"
    ],
    "price": "11137.50",
    "sku": "KY4001.01.MBY",
    "tags": [
      "Banyo Mobilyası",
      "kayra",
      "led ayna",
      "Mat Beyaz",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52867247046953,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY4001.01.MBY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11137.50",
        "grams": 0,
        "compare_at_price": "14850.00",
        "position": 1,
        "product_id": 8633551454505,
        "created_at": "2026-03-23T15:58:00+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\" data-mce-fragment=\"1\">\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\" data-mce-fragment=\"1\">\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\" data-mce-fragment=\"1\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\" data-mce-fragment=\"1\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-mce-fragment=\"1\" data-testid=\"conversation-turn-136\">\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\" data-mce-fragment=\"1\">\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\" data-mce-fragment=\"1\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\" data-mce-fragment=\"1\">\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\" data-mce-fragment=\"1\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\" data-mce-fragment=\"1\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\n<p><strong><span class=\"s6\">Creavit Kayra; Zamansız ve Stil Sahibi! </span></strong></p>\n<p><span class=\"s6\">Yaratıcı ve estetik çözümleriyle banyoları birer yaşam alanı olarak tasarlayan Creavit, Country stiline özgü çizgiler barındıran Kayra ile yeni nesil banyolar için ideal birseçenek sunuyor.</span></p>\n<p><strong><span class=\"s6\">Klasikten Vazgeçemeyenler için Tasarlandı</span></strong></p>\n<p><span class=\"s6\">Klasik dokusunu yanında yüzeylerinde 'country' stiline özgü çizgiler de barındıran Kayra serisi; klasik tasarımdan vazgeçemeyen kullanıcılara yeni bir model seçeneği sunuyor. Klasik tasarımının yanında mat görünümü; antrasit, beyaz, gri ve safir mavi renkleriyle banyolarınızda zamansız tasarımlar elde etmenize imkan sağlıyor.</span></p>\n<p><strong><span class=\"s6\">İç Mekanlar ile Uyumlu</span></strong></p>\n<p><span class=\"s6\">Creavit, Kayra serisi ile dar ve küçük alanlara sahip banyolar için de tercih edilebilecek çözümler sunuyor. Kayra 100 cm'lik model alternatifine ek olarak tasarlanan 60 ve 80 cm'lik modelleriyle, küçük alanlarda etkileyici tasarımlar oluşturmanıza yardımcı oluyor.</span></p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633551388969",
    "brand": "Creavit",
    "title": "Kayra Ayna Yan Dolabı 30cm Mat Safire Blue",
    "category": "Üst Dolaplar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-ust-dolap-mavi.png?v=1748526120",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-ust-dolap-mavi.png?v=1748526120",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/KY1030.01.MSB-B_1.jpg?v=1748852969",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-ayna-yan-dolabi-30cm-mat-safire-blue-4203.jpg?v=1748852969",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/KY1030.01-ORTAK_2_92410743-20e2-4348-87fb-3e84a4d473af.jpg?v=1748852969"
    ],
    "price": "9487.50",
    "sku": "KY1030.01.MSB",
    "tags": [
      "Banyo Mobilyası",
      "kayra",
      "mat safir mavi",
      "yan dolap",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52843260051753,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY1030.01.MSB",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9487.50",
        "grams": 0,
        "compare_at_price": "12650.00",
        "position": 1,
        "product_id": 8633551388969,
        "created_at": "2026-03-17T13:09:30+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\">\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\">\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-testid=\"conversation-turn-136\">\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\">\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<ul>\n<li class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 30x80x23 cm.</li>\n<li class=\"product-description-content\">İçerisinde İki Adet Raf Bulunmaktadır.</li>\n<li class=\"product-description-content\">Ürün Sadece Ayna Yan Dolaptır.</li>\n<li class=\"product-description-content\">MDF</li>\n</ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633551257897",
    "brand": "Creavit",
    "title": "Kayra Ayna Yan Dolabı 30cm Mat Gri",
    "category": "Üst Dolaplar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-ust-dolap-gri.png?v=1748852910",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-ust-dolap-gri.png?v=1748852910",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/KY1030.01.GRI-B_1.jpg?v=1748852910",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-ayna-yan-dolabi-30cm-mat-gri-4202.jpg?v=1748852910",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/KY1030.01-ORTAK_2.jpg?v=1748852910"
    ],
    "price": "9487.50",
    "sku": "KY1030.01.MGR",
    "tags": [
      "Banyo Mobilyası",
      "kayra",
      "mat gri",
      "yaz-15-indirim",
      "Üst Dolap"
    ],
    "variants": [
      {
        "id": 52863869419817,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY1030.01.MGR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9487.50",
        "grams": 0,
        "compare_at_price": "12650.00",
        "position": 1,
        "product_id": 8633551257897,
        "created_at": "2026-03-22T16:33:22+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\">\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\">\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-testid=\"conversation-turn-136\">\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\">\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<ul>\n<li class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 30x80x23 cm.</li>\n<li class=\"product-description-content\">İçerisinde İki Adet Raf Bulunmaktadır.</li>\n<li class=\"product-description-content\">Ürün Sadece Ayna Yan Dolaptır.</li>\n<li class=\"product-description-content\">MDF</li>\n</ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633551159593",
    "brand": "Creavit",
    "title": "Kayra Ayna Yan Dolabı 30cm Mat Antrasit",
    "category": "Üst Dolaplar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-ust-dolap-antrasit.png?v=1748853005",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-ust-dolap-antrasit.png?v=1748853005",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-ayna-yan-dolabi-30cm-mat-antrasit-4201.jpg?v=1748853005",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/KY1030.01-ORTAK_2_701ab5b2-7eff-4ee5-829e-6d6a51c4a99b.jpg?v=1748853005"
    ],
    "price": "9487.50",
    "sku": "KY1030.01.MAN",
    "tags": [
      "Banyo Mobilyası",
      "kayra",
      "Mat Antrasit",
      "yan dolap",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52920968118569,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY1030.01.MAN",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9487.50",
        "grams": 0,
        "compare_at_price": "12650.00",
        "position": 1,
        "product_id": 8633551159593,
        "created_at": "2026-04-03T12:15:58+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\">\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\">\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-testid=\"conversation-turn-136\">\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\">\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<ul>\n<li class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 30x80x23 cm.</li>\n<li class=\"product-description-content\">İçerisinde İki Adet Raf Bulunmaktadır.</li>\n<li class=\"product-description-content\">Ürün Sadece Ayna Yan Dolaptır.</li>\n<li class=\"product-description-content\">MDF</li>\n</ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633551028521",
    "brand": "Creavit",
    "title": "Kayra Ayna Yan Dolabı 30cm Mat Beyaz",
    "category": "Üst Dolaplar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-lavabo-ust-dolap-banyo-mobilyasi-beyaz.png?v=1748853574",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-lavabo-ust-dolap-banyo-mobilyasi-beyaz.png?v=1748853574",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-ayna-yan-dolabi-30cm-mat-beyaz-4199.jpg?v=1748853574",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-ayna-yan-dolabi-30cm-mat-beyaz-4198.jpg?v=1748853574",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-ayna-yan-dolabi-30cm-mat-beyaz-4200.jpg?v=1748853572"
    ],
    "price": "9487.50",
    "sku": "KY1030.01.MBY",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "kayra",
      "yan dolap",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52880900620585,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY1030.01.MBY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9487.50",
        "grams": 0,
        "compare_at_price": "12650.00",
        "position": 1,
        "product_id": 8633551028521,
        "created_at": "2026-03-26T11:14:38+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\">\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\">\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-testid=\"conversation-turn-136\">\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\">\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<ul>\n<li class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 30x80x23 cm.</li>\n<li class=\"product-description-content\">İçerisinde İki Adet Raf Bulunmaktadır.</li>\n<li class=\"product-description-content\">Ürün Sadece Ayna Yan Dolaptır.</li>\n<li class=\"product-description-content\">MDF</li>\n</ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633550864681",
    "brand": "Creavit",
    "title": "Font Dolaplı Ayna 50 cm Beyaz",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/font-dolapli-ayna-50-cm-beyaz-4194.jpg?v=1747118822",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/font-dolapli-ayna-50-cm-beyaz-4194.jpg?v=1747118822",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/font-dolapli-ayna-50-cm-beyaz-4195.jpg?v=1747118822",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/font-dolapli-ayna-50-cm-beyaz-4196.png?v=1747118822",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/font-dolapli-ayna-50-cm-beyaz-4197.jpg?v=1747118822"
    ],
    "price": "6352.50",
    "sku": "FT1050.01.BB",
    "tags": [
      "Ayna",
      "Banyo Mobilyası",
      "Beyaz",
      "font",
      "Sağ Üst Dolap",
      "yaz-15-indirim",
      "Üst Dolap"
    ],
    "variants": [
      {
        "id": 52936357970217,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "FT1050.01.BB",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6352.50",
        "grams": 0,
        "compare_at_price": "8470.00",
        "position": 1,
        "product_id": 8633550864681,
        "created_at": "2026-04-06T11:13:06+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<ul>\n<li class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 80x67x12 cm.</li>\n<li class=\"product-description-content\">İçerisinde İki Adet Raf Bulunmaktadır.</li>\n<li class=\"product-description-content\">Sağa Açılır Kapak Üzerinde Ayna.</li>\n<li class=\"product-description-content\">MDF</li>\n</ul>"
  },
  {
    "id": "creavit-8633550799145",
    "brand": "Creavit",
    "title": "Elmas Ayna ve Etajer 45 cm Beyaz-Siyah",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-ayna-ve-etajer-45-cm-beyaz-siyah-4191.jpg?v=1747743281",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-ayna-ve-etajer-45-cm-beyaz-siyah-4191.jpg?v=1747743281",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-ayna-ve-etajer-45-cm-beyaz-siyah-4192.jpg?v=1747743281",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-ayna-ve-etajer-45-cm-beyaz-siyah-4193.jpg?v=1747743281"
    ],
    "price": "3382.50",
    "sku": "EM1045.01.BS",
    "tags": [
      "Ayna",
      "Banyo Mobilyası",
      "elmas",
      "Üst Dolap"
    ],
    "variants": [
      {
        "id": 52921479954729,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "EM1045.01.BS",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "3382.50",
        "grams": 0,
        "compare_at_price": "4510.00",
        "position": 1,
        "product_id": 8633550799145,
        "created_at": "2026-04-03T14:43:26+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Günlük rutinlerinizin önemli bir parçası olan banyonuzda Elmas Etajerli Ayna banyonuzu işlevsel ve düzenli hale getirirken aynı zamanda görsel çekicilik katacak.</span></p>\r\n<p><span data-mce-fragment=\"1\">Üstün kaliteli ve geniş ayna yüzeyi makyaj yapma, saç bakımı ve diğer günlük kullanımlarınızı kolaylaştırırken aynı zamanda banyonuzun daha geniş ve ferah görünmesini sağlar.</span></p>\r\n<p><span data-mce-fragment=\"1\">Dayanıklı malzemelerle üretilen etajerli ayna banyonuzda uzun ömürlü kullanım sağlar. Ayrıca k</span><span data-mce-fragment=\"1\">olay montajı ile hızlıca banyonuza entegre ederek hemen kullanmaya başlayabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-8633550635305",
    "brand": "Creavit",
    "title": "Elmas Ayna ve Etajer 45 cm Beyaz-Parlak Belly",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-ayna-ve-etajer-45-cm-beyaz-parlak-belly-4188.jpg?v=1751456223",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-ayna-ve-etajer-45-cm-beyaz-parlak-belly-4188.jpg?v=1751456223",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-ayna-ve-etajer-45-cm-beyaz-parlak-belly-4189.jpg?v=1757425479",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-ayna-ve-etajer-45-cm-beyaz-parlak-belly-4190.jpg?v=1747743295"
    ],
    "price": "3382.50",
    "sku": "EM1045.01.BL",
    "tags": [
      "Ayna",
      "Banyo Mobilyası",
      "elmas",
      "Üst Dolap"
    ],
    "variants": [
      {
        "id": 52843185340713,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "EM1045.01.BL",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3382.50",
        "grams": 0,
        "compare_at_price": "4510.00",
        "position": 1,
        "product_id": 8633550635305,
        "created_at": "2026-03-17T12:46:10+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p><span data-mce-fragment=\"1\">Günlük rutinlerinizin önemli bir parçası olan banyonuzda Elmas Etajerli Ayna banyonuzu işlevsel ve düzenli hale getirirken aynı zamanda görsel çekicilik katacak.</span></p>\r\n<p><span data-mce-fragment=\"1\">Üstün kaliteli ve geniş ayna yüzeyi makyaj yapma, saç bakımı ve diğer günlük kullanımlarınızı kolaylaştırırken aynı zamanda banyonuzun daha geniş ve ferah görünmesini sağlar.</span></p>\r\n<p><span data-mce-fragment=\"1\">Dayanıklı malzemelerle üretilen etajerli ayna banyonuzda uzun ömürlü kullanım sağlar. Ayrıca k</span><span data-mce-fragment=\"1\">olay montajı ile hızlıca banyonuza entegre ederek hemen kullanmaya başlayabilirsiniz.</span></p>"
  },
  {
    "id": "creavit-8633550569769",
    "brand": "Creavit",
    "title": "Elmas Ayna ve Etajer 45 cm Beyaz",
    "category": "Aynalar",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-ayna-ve-etajer-45-cm-beyaz-4185.jpg?v=1747743308",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-ayna-ve-etajer-45-cm-beyaz-4185.jpg?v=1747743308",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-ayna-ve-etajer-45-cm-beyaz-4186.jpg?v=1747743308",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-ayna-ve-etajer-45-cm-beyaz-4187.jpg?v=1747743308"
    ],
    "price": "3382.50",
    "sku": "EM1045.01.BB",
    "tags": [
      "Ayna",
      "Banyo Mobilyası",
      "elmas",
      "Üst Dolap"
    ],
    "variants": [
      {
        "id": 52876512362793,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "EM1045.01.BB",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3382.50",
        "grams": 0,
        "compare_at_price": "4510.00",
        "position": 1,
        "product_id": 8633550569769,
        "created_at": "2026-03-25T12:27:47+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<ul>\n<li class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 44x56x8 cm.</li>\n<li class=\"product-description-content\">Ürün Ayna ve Ayna Etajeridir.</li>\n<li class=\"product-description-content\">Etajer Derinliği 8 cm.</li>\n</ul>"
  },
  {
    "id": "creavit-8633550405929",
    "brand": "Creavit",
    "title": "Pion Plus Lavabo Dolabı 70 cm Mat Beyaz - Antrasit",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-pion-plus-lavabo-dolabi-beyaz-antrasit-70cm.png?v=1749221824",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-pion-plus-lavabo-dolabi-beyaz-antrasit-70cm.png?v=1749221824",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-plus-lavabo-dolabi-70-cm-mat-beyaz-antrasit-4182.jpg?v=1757426389",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-plus-lavabo-dolabi-70-cm-mat-beyaz-antrasit-4183.jpg?v=1757426389",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-plus-lavabo-dolabi-70-cm-mat-beyaz-antrasit-4184.jpg?v=1749221824",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/pion-plus-lavabo-dolabi-70-cm-mat-beyaz-antrasit-4181.jpg?v=1749221824"
    ],
    "price": "63525.00",
    "sku": "PN0070.01.BGR",
    "tags": [
      "Banyo Mobilyası",
      "küçük banyolar",
      "Lavabo Dolabı",
      "Pion"
    ],
    "variants": [
      {
        "id": 52843185078569,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "PN0070.01.BGR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "63525.00",
        "grams": 0,
        "compare_at_price": "84700.00",
        "position": 1,
        "product_id": 8633550405929,
        "created_at": "2026-03-17T12:46:03+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<ul>\n<li class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 70x85x52 cm.</li>\n<li class=\"product-description-content\">UL060-00CB00E-0000 Kodlu Seramik Çanak Lavabo Dahildir.</li>\n<li class=\"product-description-content\">Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</li>\n<li class=\"product-description-content\">Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</li>\n<li class=\"product-description-content\">Tek Çekmeceli.</li>\n<li class=\"product-description-content\">Gizli Çekmece Mevcuttur.</li>\n<li class=\"product-description-content\">MDF.</li>\n</ul>"
  },
  {
    "id": "creavit-8633550307625",
    "brand": "Creavit",
    "title": "Mio Lavabo Dolabı 45 cm Antrasit-Açık Ceviz",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-mio-lavabo-dolabi-acik-ceviz-banyo-mobilyasi-45cm.png?v=1746543523",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-mio-lavabo-dolabi-acik-ceviz-banyo-mobilyasi-45cm.png?v=1746543523",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-mio-lavabo-dolabi-banyo-mobilyasi-MI0045.00.AV-A.jpg?v=1746543523",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-mio-lavabo-dolabi-banyo-mobilyasi-MI0045.00.AV-B.jpg?v=1746543523",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-mio-lavabo-dolabi-banyo-mobilyasi-MI0045.00.AV-C.jpg?v=1746543523",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-mio-lavabo-dolabi-banyo-mobilyasi-MI0045.00.AV-D.jpg?v=1746543518"
    ],
    "price": "5040.00",
    "sku": "MI0045.00.AV",
    "tags": [
      "Banyo Mobilyası",
      "küçük banyolar",
      "Lavabo Dolabı",
      "mio"
    ],
    "variants": [
      {
        "id": 49734004965673,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MI0045.00.AV",
        "requires_shipping": true,
        "taxable": true,
        "featured_image": null,
        "available": false,
        "price": "5040.00",
        "grams": 0,
        "compare_at_price": null,
        "position": 1,
        "product_id": 8633550307625,
        "created_at": "2025-01-24T16:07:17+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\">Küçük ve dar banyolar için özel olarak tasarlanmış Mio Boy Dolabı işlevsellik ve şıklığı bir araya getiriyor. Sınırlı alana sahip banyolarda ek depolama ihtiyacını karşılamak üzere tasarlanan bu dolap dayanıklı malzemelerle uzun ömürlü kullanım sunarken, modern ve zarif tasarımı ile banyonuza zarif bir hava katacak.</p>\n<p data-mce-fragment=\"1\">Mio Banyo Mobilyaları hayalinizi yansıtan estetik ve karakteristik fonksiyonel ürünlerle banyonuzda büyük düşünmenizi sağlayacak. İhtiyacınıza uygun depolama seçenekleri ile banyonuzu her zaman düzenli tutun.</p>"
  },
  {
    "id": "creavit-8633550012713",
    "brand": "Creavit",
    "title": "Kayra Lavabo Dolabı Çekmeceli 100cm Mat Safire Blue",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-mavi-cekmeceli-melamin-lavabo-dolabi-banyo-mobilyasi-100cm_14b86d12-3e7d-4ca0-80e1-39db53eee42d.png?v=1748855314",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-mavi-cekmeceli-melamin-lavabo-dolabi-banyo-mobilyasi-100cm_14b86d12-3e7d-4ca0-80e1-39db53eee42d.png?v=1748855314",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-100cm-matsafireblue-4169.jpg?v=1748855314",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-100cm-matsafireblue-4170.jpg?v=1748855314",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-100cm-matsafireblue-4168.jpg?v=1748855314",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-100cm-matsafireblue-4171.jpg?v=1748855314",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-100cm-matsafireblue-4172.jpg?v=1748855314"
    ],
    "price": "28545.00",
    "sku": "KY0100.42.MSB",
    "tags": [
      "Banyo Mobilyası",
      "kayra",
      "Lavabo Dolabı",
      "mat safir mavi",
      "yaz-15-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843189698857,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY0100.42.MSB",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "28545.00",
        "grams": 0,
        "compare_at_price": "38060.00",
        "position": 1,
        "product_id": 8633550012713,
        "created_at": "2026-03-17T12:47:41+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\">\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\">\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-testid=\"conversation-turn-136\">\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\">\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<ul>\n<li class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 97x58x44 cm.</li>\n<li class=\"product-description-content\">SU100-00CB00E-0000 Kodlu Seramik Etajerli Lavabo Dahildir.</li>\n<li class=\"product-description-content\">Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</li>\n<li class=\"product-description-content\">Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</li>\n<li class=\"product-description-content\">Çift Çekmeceli</li>\n<li class=\"product-description-content\">MDF</li>\n</ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633549914409",
    "brand": "Creavit",
    "title": "Kayra Lavabo Dolabı Çekmeceli 100cm Mat Gri",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-mat-gri-cekmeceli-melamin-lavabo-dolabi-banyo-mobilyasi-100cm.png?v=1748854526",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-mat-gri-cekmeceli-melamin-lavabo-dolabi-banyo-mobilyasi-100cm.png?v=1748854526",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-100cm-mat-gri-4165.jpg?v=1748854520",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-100cm-mat-gri-4164.jpg?v=1748854520",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-100cm-mat-gri-4167.jpg?v=1748854520",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-100cm-mat-gri-4163.jpg?v=1748854520",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-100cm-mat-gri-4166.jpg?v=1748854520"
    ],
    "price": "28545.00",
    "sku": "KY0100.42.MGR",
    "tags": [
      "Banyo Mobilyası",
      "kayra",
      "Lavabo Dolabı",
      "mat gri",
      "yaz-15-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843188453673,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY0100.42.MGR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "28545.00",
        "grams": 0,
        "compare_at_price": "38060.00",
        "position": 1,
        "product_id": 8633549914409,
        "created_at": "2026-03-17T12:47:12+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\">\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\">\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-testid=\"conversation-turn-136\">\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\">\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<ul>\n<li class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 97x58x44 cm.</li>\n<li class=\"product-description-content\">SU100-00CB00E-0000 Kodlu Seramik Etajerli Lavabo Dahildir.</li>\n<li class=\"product-description-content\">Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</li>\n<li class=\"product-description-content\">Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</li>\n<li class=\"product-description-content\">Çift Çekmeceli</li>\n<li class=\"product-description-content\">MDF</li>\n</ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633549783337",
    "brand": "Creavit",
    "title": "Kayra Lavabo Dolabı Çekmeceli 100cm Mat Antrasit",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-mat-antrasit-cekmeceli-melamin-lavabo-dolabi-banyo-mobilyasi-100cm.png?v=1748855398",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-mat-antrasit-cekmeceli-melamin-lavabo-dolabi-banyo-mobilyasi-100cm.png?v=1748855398",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-100cm-mat-antrasit-4161.jpg?v=1748855398",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-100cm-mat-antrasit-4159.jpg?v=1748855398",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-100cm-mat-antrasit-4158.jpg?v=1748855389",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-100cm-mat-antrasit-4160.jpg?v=1748855384",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-100cm-mat-antrasit-4162.jpg?v=1748855384"
    ],
    "price": "28545.00",
    "sku": "KY0100.42.MAN",
    "tags": [
      "Banyo Mobilyası",
      "kayra",
      "Lavabo Dolabı",
      "Mat Antrasit",
      "yaz-15-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52920967758121,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY0100.42.MAN",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "28545.00",
        "grams": 0,
        "compare_at_price": "38060.00",
        "position": 1,
        "product_id": 8633549783337,
        "created_at": "2026-04-03T12:15:52+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\">\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\">\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-testid=\"conversation-turn-136\">\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\">\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<ul>\n<li class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 97x58x44 cm.</li>\n<li class=\"product-description-content\">SU100-00CB00E-0000 Kodlu Seramik Etajerli Lavabo Dahildir.</li>\n<li class=\"product-description-content\">Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</li>\n<li class=\"product-description-content\">Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</li>\n<li class=\"product-description-content\">Çift Çekmeceli</li>\n<li class=\"product-description-content\">MDF</li>\n</ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633549586729",
    "brand": "Creavit",
    "title": "Kayra Mat Beyaz Lavabo Dolabı Çekmeceli 100cm",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-mat-beyaz-cekmeceli-melamin-lavabo-dolabi-banyo-mobilyasi-100cm.png?v=1748855548",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-mat-beyaz-cekmeceli-melamin-lavabo-dolabi-banyo-mobilyasi-100cm.png?v=1748855548",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-beyaz-lavabo-dolabi-cekmeceli-100cm-4153.jpg?v=1748855548",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-beyaz-lavabo-dolabi-cekmeceli-100cm-4154.jpg?v=1748855548",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-beyaz-lavabo-dolabi-cekmeceli-100cm-4156.jpg?v=1748855548",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-beyaz-lavabo-dolabi-cekmeceli-100cm-4152.jpg?v=1748855548",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-beyaz-lavabo-dolabi-cekmeceli-100cm-4155.jpg?v=1748855548",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-beyaz-lavabo-dolabi-cekmeceli-100cm-4157.jpg?v=1748855548"
    ],
    "price": "28545.00",
    "sku": "KY0100.42.MBY",
    "tags": [
      "Banyo Mobilyası",
      "kayra",
      "Lavabo Dolabı",
      "Mat Beyaz",
      "yaz-15-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52921479725353,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY0100.42.MBY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "28545.00",
        "grams": 0,
        "compare_at_price": "38060.00",
        "position": 1,
        "product_id": 8633549586729,
        "created_at": "2026-04-03T14:43:23+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\">\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\">\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-testid=\"conversation-turn-136\">\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\">\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<ul>\n<li class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 97x58x44 cm.</li>\n<li class=\"product-description-content\">SU100-00CB00E-0000 Kodlu Seramik Etajerli Lavabo Dahildir.</li>\n<li class=\"product-description-content\">Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</li>\n<li class=\"product-description-content\">Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</li>\n<li class=\"product-description-content\">Çift Çekmeceli</li>\n<li class=\"product-description-content\">MDF</li>\n</ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633549422889",
    "brand": "Creavit",
    "title": "Kayra Mat Safir Blue Lavabo Dolabı Kapaklı 100cm",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-mavi-kapakli-melamin-lavabo-dolabi-banyo-mobilyasi-100cm.png?v=1748855762",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-mavi-kapakli-melamin-lavabo-dolabi-banyo-mobilyasi-100cm.png?v=1748855762",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-safir-blue-lavabo-dolabi-kapakli-100cm-4147.jpg?v=1748855762",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-safir-blue-lavabo-dolabi-kapakli-100cm-4149.jpg?v=1748855762",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-safir-blue-lavabo-dolabi-kapakli-100cm-4150.jpg?v=1748855762",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-safir-blue-lavabo-dolabi-kapakli-100cm-4146.jpg?v=1748855762",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-safir-blue-lavabo-dolabi-kapakli-100cm-4148.jpg?v=1748855762",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-safir-blue-lavabo-dolabi-kapakli-100cm-4151.jpg?v=1748855751"
    ],
    "price": "22522.50",
    "sku": "KY0100.01.MSB",
    "tags": [
      "Banyo Mobilyası",
      "kapaklı lavabo dolabı",
      "kayra",
      "Lavabo Dolabı",
      "mat safir mavi",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52920967561513,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY0100.01.MSB",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "22522.50",
        "grams": 0,
        "compare_at_price": "30030.00",
        "position": 1,
        "product_id": 8633549422889,
        "created_at": "2026-04-03T12:15:48+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\">\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\">\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-testid=\"conversation-turn-136\">\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\">\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<ul>\n<li class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 97x58x44 cm.</li>\n<li class=\"product-description-content\">SU100-00CB00E-0000 Kodlu Seramik Etajerli Lavabo Dahildir.</li>\n<li class=\"product-description-content\">Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</li>\n<li class=\"product-description-content\">Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</li>\n<li class=\"product-description-content\">Çift Kapaklı</li>\n<li class=\"product-description-content\">MDF</li>\n</ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633549259049",
    "brand": "Creavit",
    "title": "Kayra Lavabo Dolabı Kapaklı 100cm Mat Gri",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-mat-gri-kapakli-melamin-lavabo-dolabi-banyo-mobilyasi-100cm.png?v=1748856219",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-mat-gri-kapakli-melamin-lavabo-dolabi-banyo-mobilyasi-100cm.png?v=1748856219",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-100cm-mat-gri-4142.jpg?v=1748856219",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-100cm-mat-gri-4144.jpg?v=1748856219",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-100cm-mat-gri-4141.jpg?v=1748856219",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-100cm-mat-gri-4143.jpg?v=1748856219",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-100cm-mat-gri-4145.jpg?v=1748856219"
    ],
    "price": "22522.50",
    "sku": "KY0100.01.MGR",
    "tags": [
      "Banyo Mobilyası",
      "kapaklı lavabo dolabı",
      "kayra",
      "Lavabo Dolabı",
      "mat gri",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52920967364905,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY0100.01.MGR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "22522.50",
        "grams": 0,
        "compare_at_price": "30030.00",
        "position": 1,
        "product_id": 8633549259049,
        "created_at": "2026-04-03T12:15:45+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\">\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\">\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-testid=\"conversation-turn-136\">\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\">\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<ul>\n<li class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 97x58x44 cm.</li>\n<li class=\"product-description-content\">SU100-00CB00E-0000 Kodlu Seramik Etajerli Lavabo Dahildir.</li>\n<li class=\"product-description-content\">Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</li>\n<li class=\"product-description-content\">Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</li>\n<li class=\"product-description-content\">Çift Kapaklı</li>\n<li class=\"product-description-content\">MDF</li>\n</ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633549095209",
    "brand": "Creavit",
    "title": "Kayra Lavabo Dolabı Kapaklı 100cm Mat Antrasit",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-mat-antrasit-kapakli-melamin-lavabo-dolabi-banyo-mobilyasi-100cm.png?v=1748856109",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-mat-antrasit-kapakli-melamin-lavabo-dolabi-banyo-mobilyasi-100cm.png?v=1748856109",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-100cm-mat-antrasit-4137.jpg?v=1748856109",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-100cm-mat-antrasit-4138.jpg?v=1748856109",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-100cm-mat-antrasit-4136.jpg?v=1748856109",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-100cm-mat-antrasit-4139.jpg?v=1748856109",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-100cm-mat-antrasit-4140.jpg?v=1748856109"
    ],
    "price": "22522.50",
    "sku": "KY0100.01.MAN",
    "tags": [
      "Banyo Mobilyası",
      "kapaklı lavabo dolabı",
      "kayra",
      "Lavabo Dolabı",
      "Mat Antrasit",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52936018952489,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY0100.01.MAN",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "22522.50",
        "grams": 0,
        "compare_at_price": "30030.00",
        "position": 1,
        "product_id": 8633549095209,
        "created_at": "2026-04-06T09:26:21+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\">\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\">\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-testid=\"conversation-turn-136\">\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\">\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<ul>\n<li class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 97x58x44 cm.</li>\n<li class=\"product-description-content\">SU100-00CB00E-0000 Kodlu Seramik Etajerli Lavabo Dahildir.</li>\n<li class=\"product-description-content\">Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</li>\n<li class=\"product-description-content\">Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</li>\n<li class=\"product-description-content\">Çift Kapaklı</li>\n<li class=\"product-description-content\">MDF</li>\n</ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633548996905",
    "brand": "Creavit",
    "title": "Kayra Lavabo Dolabı Kapaklı 100cm Mat Beyaz",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-mat-beyaz-kapakli-melamin-lavabo-dolabi-banyo-mobilyasi-100cm.png?v=1748856451",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-mat-beyaz-kapakli-melamin-lavabo-dolabi-banyo-mobilyasi-100cm.png?v=1748856451",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-100cm-mat-beyaz-4131.jpg?v=1748856451",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-100cm-mat-beyaz-4132.jpg?v=1748856451",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-100cm-mat-beyaz-4133.jpg?v=1748856451",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-100cm-mat-beyaz-4130.jpg?v=1748856451",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-100cm-mat-beyaz-4134.jpg?v=1748856451",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-100cm-mat-beyaz-4135.jpg?v=1748856451"
    ],
    "price": "22522.50",
    "sku": "KY0100.01.MBY",
    "tags": [
      "Banyo Mobilyası",
      "kapaklı lavabo dolabı",
      "kayra",
      "Lavabo Dolabı",
      "Mat Beyaz",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52843259527465,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY0100.01.MBY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "22522.50",
        "grams": 0,
        "compare_at_price": "30030.00",
        "position": 1,
        "product_id": 8633548996905,
        "created_at": "2026-03-17T13:09:21+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\">\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\">\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-testid=\"conversation-turn-136\">\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\">\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<ul>\n<li class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 97x58x44 cm.</li>\n<li class=\"product-description-content\">SU100-00CB00E-0000 Kodlu Seramik Etajerli Lavabo Dahildir.</li>\n<li class=\"product-description-content\">Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</li>\n<li class=\"product-description-content\">Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</li>\n<li class=\"product-description-content\">Çift Kapaklı</li>\n<li class=\"product-description-content\">MDF</li>\n</ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633548865833",
    "brand": "Creavit",
    "title": "Kayra Lavabo Dolabı Çekmeceli 80cm Mat Antrasit",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-lavabo-dolabi-antrasit-cekmeceli-80cm.png?v=1748860375",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-lavabo-dolabi-antrasit-cekmeceli-80cm.png?v=1748860375",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-80cm-mat-antrasit-4128.jpg?v=1748860375",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-80cm-mat-antrasit-4126.jpg?v=1748860375",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-80cm-mat-antrasit-4125.jpg?v=1748860375",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-80cm-mat-antrasit-4127.jpg?v=1748860372",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-80cm-mat-antrasit-4129.jpg?v=1748860372"
    ],
    "price": "26235.00",
    "sku": "KY0080.42.MAN",
    "tags": [
      "Banyo Mobilyası",
      "kayra",
      "Lavabo Dolabı",
      "Mat Antrasit",
      "yaz-15-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843188289833,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY0080.42.MAN",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "26235.00",
        "grams": 0,
        "compare_at_price": "34980.00",
        "position": 1,
        "product_id": 8633548865833,
        "created_at": "2026-03-17T12:47:09+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\">\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\">\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-testid=\"conversation-turn-136\">\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\">\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<ul>\n<li class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 76x58x43 cm.</li>\n<li class=\"product-description-content\">SU080-00CB00E-0000 Kodlu Seramik Etajerli Lavabo Dahildir.</li>\n<li class=\"product-description-content\">Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</li>\n<li class=\"product-description-content\">Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</li>\n<li class=\"product-description-content\">Çift Çekmeceli</li>\n<li class=\"product-description-content\">MDF</li>\n</ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633548767529",
    "brand": "Creavit",
    "title": "Kayra Mat Safir Blue Çekmeceli Lavabo Dolabı 80 cm",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-lavabo-dolabi-mavi-cekmeceli-80cm.png?v=1748860418",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-lavabo-dolabi-mavi-cekmeceli-80cm.png?v=1748860418",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-safir-blue-cekmeceli-lavabo-dolabi-80-cm-4121.jpg?v=1748860418",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-safir-blue-cekmeceli-lavabo-dolabi-80-cm-4123.jpg?v=1748860418",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-safir-blue-cekmeceli-lavabo-dolabi-80-cm-4120.jpg?v=1748860418",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-safir-blue-cekmeceli-lavabo-dolabi-80-cm-4122.jpg?v=1748860418",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-safir-blue-cekmeceli-lavabo-dolabi-80-cm-4124.jpg?v=1748860415"
    ],
    "price": "26235.00",
    "sku": "KY0080.42.MSB",
    "tags": [
      "Banyo Mobilyası",
      "kayra",
      "Lavabo Dolabı",
      "mat safir mavi",
      "yaz-15-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52921479299369,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY0080.42.MSB",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "26235.00",
        "grams": 0,
        "compare_at_price": "34980.00",
        "position": 1,
        "product_id": 8633548767529,
        "created_at": "2026-04-03T14:43:17+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\">\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\">\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-testid=\"conversation-turn-136\">\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\">\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<ul>\n<li class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 76x58x43 cm.</li>\n<li class=\"product-description-content\">SU080-00CB00E-0000 Kodlu Seramik Etajerli Lavabo Dahildir.</li>\n<li class=\"product-description-content\">Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</li>\n<li class=\"product-description-content\">Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</li>\n<li class=\"product-description-content\">Çift Çekmeceli</li>\n<li class=\"product-description-content\">MDF</li>\n</ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633548669225",
    "brand": "Creavit",
    "title": "Kayra Lavabo Dolabı Çekmeceli 80cm Mat Gri",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-lavabo-dolabi-gri-cekmeceli-80cm_3e344eb4-21c3-408f-9236-8847c66199c5.png?v=1748860453",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-lavabo-dolabi-gri-cekmeceli-80cm_3e344eb4-21c3-408f-9236-8847c66199c5.png?v=1748860453",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-80cm-mat-gri-4118.jpg?v=1748860453",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-80cm-mat-gri-4116.jpg?v=1748860452",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-80cm-mat-gri-4115.jpg?v=1748860452",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-80cm-mat-gri-4117.jpg?v=1748860452",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-80cm-mat-gri-4119.jpg?v=1748860449"
    ],
    "price": "26235.00",
    "sku": "KY0080.42.MGR",
    "tags": [
      "Banyo Mobilyası",
      "kayra",
      "Lavabo Dolabı",
      "mat gri",
      "yaz-15-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843268440361,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY0080.42.MGR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "26235.00",
        "grams": 0,
        "compare_at_price": "34980.00",
        "position": 1,
        "product_id": 8633548669225,
        "created_at": "2026-03-17T13:12:16+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\">\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\">\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-testid=\"conversation-turn-136\">\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\">\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<ul>\n<li class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 76x58x43 cm.</li>\n<li class=\"product-description-content\">SU080-00CB00E-0000 Kodlu Seramik Etajerli Lavabo Dahildir.</li>\n<li class=\"product-description-content\">Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</li>\n<li class=\"product-description-content\">Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</li>\n<li class=\"product-description-content\">Çift Çekmeceli</li>\n<li class=\"product-description-content\">MDF</li>\n</ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633548538153",
    "brand": "Creavit",
    "title": "Kayra Lavabo Dolabı Çekmeceli 80cm Mat Beyaz",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-lavabo-dolabi-beyaz-cekmeceli-80cm.png?v=1748860481",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-lavabo-dolabi-beyaz-cekmeceli-80cm.png?v=1748860481",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-80cm-mat-beyaz-4112.jpg?v=1748860481",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-80cm-mat-beyaz-4111.jpg?v=1748860481",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-80cm-mat-beyaz-4110.jpg?v=1748860481",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-80cm-mat-beyaz-4113.jpg?v=1748860479",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-80cm-mat-beyaz-4114.jpg?v=1748860479"
    ],
    "price": "26235.00",
    "sku": "KY0080.42.MBY",
    "tags": [
      "Banyo Mobilyası",
      "kayra",
      "Lavabo Dolabı",
      "Mat Beyaz",
      "yaz-15-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843184357673,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY0080.42.MBY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "26235.00",
        "grams": 0,
        "compare_at_price": "34980.00",
        "position": 1,
        "product_id": 8633548538153,
        "created_at": "2026-03-17T12:45:51+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\">\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\">\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-testid=\"conversation-turn-136\">\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\">\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<ul>\n<li class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 76x58x43 cm.</li>\n<li class=\"product-description-content\">SU080-00CB00E-0000 Kodlu Seramik Etajerli Lavabo Dahildir.</li>\n<li class=\"product-description-content\">Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</li>\n<li class=\"product-description-content\">Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</li>\n<li class=\"product-description-content\">Çift Çekmeceli</li>\n<li class=\"product-description-content\">MDF</li>\n</ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633548472617",
    "brand": "Creavit",
    "title": "Kayra Mat Safir Blue Kapaklı Lavabo Dolabı 80cm",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-kapakli-lavabo-dolabi-mavi-80cm.png?v=1748860513",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-kapakli-lavabo-dolabi-mavi-80cm.png?v=1748860513",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-safir-blue-kapakli-lavabo-dolabi-80cm-4106.jpg?v=1748860513",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-safir-blue-kapakli-lavabo-dolabi-80cm-4108.jpg?v=1748860513",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-safir-blue-kapakli-lavabo-dolabi-80cm-4105.jpg?v=1748860513",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-safir-blue-kapakli-lavabo-dolabi-80cm-4107.jpg?v=1748860513",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-safir-blue-kapakli-lavabo-dolabi-80cm-4109.jpg?v=1748860510"
    ],
    "price": "20212.50",
    "sku": "KY0080.01.MSB",
    "tags": [
      "Banyo Mobilyası",
      "kapaklı lavabo dolabı",
      "kayra",
      "Lavabo Dolabı",
      "mat safir mavi",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52867281322281,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY0080.01.MSB",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "20212.50",
        "grams": 0,
        "compare_at_price": "26950.00",
        "position": 1,
        "product_id": 8633548472617,
        "created_at": "2026-03-23T16:03:05+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<ul>\n<li class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 77x58x45 cm.</li>\n<li class=\"product-description-content\">SU080-00CB00E-0000 Kodlu Seramik Etajerli Lavabo Dahildir.</li>\n<li class=\"product-description-content\">Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</li>\n<li class=\"product-description-content\">Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</li>\n<li class=\"product-description-content\">Çift Kapaklı</li>\n<li class=\"product-description-content\">MDF</li>\n</ul>"
  },
  {
    "id": "creavit-8633548407081",
    "brand": "Creavit",
    "title": "Kayra Lavabo Dolabı Kapaklı 80cm Mat Antrasit",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-kapakli-lavabo-dolabi-antrasit-80cm.png?v=1748860834",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-kapakli-lavabo-dolabi-antrasit-80cm.png?v=1748860834",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-80cm-mat-antrasit-4101.jpg?v=1748860834",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-80cm-mat-antrasit-4103.jpg?v=1748860834",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-80cm-mat-antrasit-4100.jpg?v=1748860834",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-80cm-mat-antrasit-4102.jpg?v=1748860834",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-80cm-mat-antrasit-4104.jpg?v=1748860833"
    ],
    "price": "20212.50",
    "sku": "KY0080.01.MAN",
    "tags": [
      "Banyo Mobilyası",
      "kapaklı lavabo dolabı",
      "kayra",
      "Lavabo Dolabı",
      "Mat Antrasit",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52843184128297,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY0080.01.MAN",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "20212.50",
        "grams": 0,
        "compare_at_price": "26950.00",
        "position": 1,
        "product_id": 8633548407081,
        "created_at": "2026-03-17T12:45:48+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\">\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\">\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-testid=\"conversation-turn-136\">\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\">\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<ul>\n<li class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 77x58x45 cm.</li>\n<li class=\"product-description-content\">SU080-00CB00E-0000 Kodlu Seramik Etajerli Lavabo Dahildir.</li>\n<li class=\"product-description-content\">Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</li>\n<li class=\"product-description-content\">Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</li>\n<li class=\"product-description-content\">Çift Kapaklı</li>\n<li class=\"product-description-content\">MDF</li>\n</ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633548276009",
    "brand": "Creavit",
    "title": "Kayra Lavabo Dolabı Kapaklı 80cm Mat Beyaz",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-kapakli-lavabo-dolabi-beyaz-80cm.png?v=1748860872",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-kapakli-lavabo-dolabi-beyaz-80cm.png?v=1748860872",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-80cm-mat-beyaz-4097.jpg?v=1748860872",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-80cm-mat-beyaz-4096.jpg?v=1748860872",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-80cm-mat-beyaz-4095.jpg?v=1748860872",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-80cm-mat-beyaz-4098.jpg?v=1748860870",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-80cm-mat-beyaz-4099.jpg?v=1748860870"
    ],
    "price": "20212.50",
    "sku": "KY0080.01.MBY",
    "tags": [
      "Banyo Mobilyası",
      "kapaklı lavabo dolabı",
      "kayra",
      "Lavabo Dolabı",
      "Mat Beyaz",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52921479069993,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY0080.01.MBY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "20212.50",
        "grams": 0,
        "compare_at_price": "26950.00",
        "position": 1,
        "product_id": 8633548276009,
        "created_at": "2026-04-03T14:43:14+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\">\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\">\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-testid=\"conversation-turn-136\">\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\">\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<ul>\n<li class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 77x58x45 cm.</li>\n<li class=\"product-description-content\">SU080-00CB00E-0000 Kodlu Seramik Etajerli Lavabo Dahildir.</li>\n<li class=\"product-description-content\">Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</li>\n<li class=\"product-description-content\">Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</li>\n<li class=\"product-description-content\">Çift Kapaklı</li>\n<li class=\"product-description-content\">MDF</li>\n</ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633548177705",
    "brand": "Creavit",
    "title": "Kayra Lavabo Dolabı Kapaklı 80cm Mat Gri",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-kapakli-lavabo-dolabi-gri-80cm.png?v=1748860892",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-kapakli-lavabo-dolabi-gri-80cm.png?v=1748860892",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-80cm-mat-gri-4091.jpg?v=1748860892",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-80cm-mat-gri-4093.jpg?v=1748860892",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-80cm-mat-gri-4090.jpg?v=1748860892",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-80cm-mat-gri-4092.jpg?v=1748860892",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-80cm-mat-gri-4094.jpg?v=1748860891"
    ],
    "price": "20212.50",
    "sku": "KY0080.01.MGR",
    "tags": [
      "Banyo Mobilyası",
      "kapaklı lavabo dolabı",
      "kayra",
      "Lavabo Dolabı",
      "mat gri",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52921478840617,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY0080.01.MGR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "20212.50",
        "grams": 0,
        "compare_at_price": "26950.00",
        "position": 1,
        "product_id": 8633548177705,
        "created_at": "2026-04-03T14:43:11+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\">\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\">\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-testid=\"conversation-turn-136\">\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\">\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<ul>\n<li class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 77x58x45 cm.</li>\n<li class=\"product-description-content\">SU080-00CB00E-0000 Kodlu Seramik Etajerli Lavabo Dahildir.</li>\n<li class=\"product-description-content\">Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</li>\n<li class=\"product-description-content\">Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</li>\n<li class=\"product-description-content\">Çift Kapaklı</li>\n<li class=\"product-description-content\">MDF</li>\n</ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633548013865",
    "brand": "Creavit",
    "title": "Kayra Lavabo Dolabı Çekmeceli 60cm Mat Gri",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-cekmeceli-lavabo-dolabi-gri-60cm.png?v=1748861112",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-cekmeceli-lavabo-dolabi-gri-60cm.png?v=1748861112",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-60cm-mat-gri-4088.jpg?v=1748861112",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-60cm-mat-gri-4086.jpg?v=1748861112",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-60cm-mat-gri-4085.jpg?v=1748861112",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-60cm-mat-gri-4087.jpg?v=1748861110",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-cekmeceli-60cm-mat-gri-4089.jpg?v=1748861110"
    ],
    "price": "24750.00",
    "sku": "KY0060.42.MGR",
    "tags": [
      "Banyo Mobilyası",
      "kayra",
      "Lavabo Dolabı",
      "mat gri",
      "yaz-15-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52864968556841,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY0060.42.MGR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "24750.00",
        "grams": 0,
        "compare_at_price": "33000.00",
        "position": 1,
        "product_id": 8633548013865,
        "created_at": "2026-03-23T00:21:19+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\">\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\">\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-testid=\"conversation-turn-136\">\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\">\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<ul>\n<li class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 57x58x44 cm.</li>\n<li class=\"product-description-content\">SU060-00CB00E-0000 Kodlu Seramik Etajerli Lavabo Dahildir.</li>\n<li class=\"product-description-content\">Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</li>\n<li class=\"product-description-content\">Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</li>\n<li class=\"product-description-content\">Çift Çekmeceli</li>\n<li class=\"product-description-content\">MDF</li>\n</ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633547948329",
    "brand": "Creavit",
    "title": "Kayra Mat Safir Blue Çekmeceli Lavabo Dolabı 60 cm",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-cekmeceli-lavabo-dolabi-mavi-60cm.png?v=1748861133",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-cekmeceli-lavabo-dolabi-mavi-60cm.png?v=1748861133",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-safir-blue-cekmeceli-lavabo-dolabi-60-cm-4081.jpg?v=1748861133",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-safir-blue-cekmeceli-lavabo-dolabi-60-cm-4083.jpg?v=1748861133",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-safir-blue-cekmeceli-lavabo-dolabi-60-cm-4080.jpg?v=1748861133",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-safir-blue-cekmeceli-lavabo-dolabi-60-cm-4082.jpg?v=1748861131",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-safir-blue-cekmeceli-lavabo-dolabi-60-cm-4084.jpg?v=1748861131"
    ],
    "price": "24750.00",
    "sku": "KY0060.42.MSB",
    "tags": [
      "Banyo Mobilyası",
      "kayra",
      "Lavabo Dolabı",
      "mat safir mavi",
      "yaz-15-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52843183538473,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY0060.42.MSB",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "24750.00",
        "grams": 0,
        "compare_at_price": "33000.00",
        "position": 1,
        "product_id": 8633547948329,
        "created_at": "2026-03-17T12:45:39+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\">\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\">\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-testid=\"conversation-turn-136\">\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\">\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<ul>\n<li class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 57x58x44 cm.</li>\n<li class=\"product-description-content\">SU060-00CB00E-0000 Kodlu Seramik Etajerli Lavabo Dahildir.</li>\n<li class=\"product-description-content\">Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</li>\n<li class=\"product-description-content\">Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</li>\n<li class=\"product-description-content\">Çift Çekmeceli</li>\n<li class=\"product-description-content\">MDF</li>\n</ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633547817257",
    "brand": "Creavit",
    "title": "Kayra Lavabo Dolabı Çekmeceli 60cm Mat Antrasit",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-cekmeceli-lavabo-dolabi-antrasit-60cm.png?v=1748861152",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-cekmeceli-lavabo-dolabi-antrasit-60cm.png?v=1748861152",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/KY0060.42.MAN-A.jpg?v=1748861243",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/KY0060.42.MAN-B.jpg?v=1748861243",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/KY0060.42.MAN-C.jpg?v=1748861243",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/KY0060.42.MAN-D.jpg?v=1748861243",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/KY0060.42.MAN-E.jpg?v=1748861243"
    ],
    "price": "24750.00",
    "sku": "KY0060.42.MAN",
    "tags": [
      "Banyo Mobilyası",
      "kayra",
      "Lavabo Dolabı",
      "Mat Antrasit",
      "yaz-15-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52880685891881,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY0060.42.MAN",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "24750.00",
        "grams": 0,
        "compare_at_price": "33000.00",
        "position": 1,
        "product_id": 8633547817257,
        "created_at": "2026-03-26T10:49:17+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\">\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\">\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-testid=\"conversation-turn-136\">\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\">\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<ul>\n<li class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 57x58x44 cm.</li>\n<li class=\"product-description-content\">SU060-00CB00E-0000 Kodlu Seramik Etajerli Lavabo Dahildir.</li>\n<li class=\"product-description-content\">Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</li>\n<li class=\"product-description-content\">Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</li>\n<li class=\"product-description-content\">Çift Çekmeceli</li>\n<li class=\"product-description-content\">MDF</li>\n</ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633547718953",
    "brand": "Creavit",
    "title": "Kayra Lavabo Dolabı Çekmeceli 60cm Mat Beyaz",
    "category": "Çekmeceli Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-cekmeceli-lavabo-dolabi-beyaz-60cm.png?v=1748861285",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-cekmeceli-lavabo-dolabi-beyaz-60cm.png?v=1748861285",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/KY0060.42.MBY-A.jpg?v=1748861324",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/KY0060.42.MBY-B.jpg?v=1748861324",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/KY0060.42.MBY-C.jpg?v=1748861324",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/KY0060.42.MBY-D.jpg?v=1748861324",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/KY0060.42.MBY-E.jpg?v=1748861324"
    ],
    "price": "24750.00",
    "sku": "KY0060.42.MBY",
    "tags": [
      "Banyo Mobilyası",
      "kayra",
      "Lavabo Dolabı",
      "Mat Beyaz",
      "yaz-15-indirim",
      "çekmeceli lavabo dolabı"
    ],
    "variants": [
      {
        "id": 52880685793577,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY0060.42.MBY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "24750.00",
        "grams": 0,
        "compare_at_price": "33000.00",
        "position": 1,
        "product_id": 8633547718953,
        "created_at": "2026-03-26T10:49:14+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\">\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\">\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-testid=\"conversation-turn-136\">\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\">\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<ul>\n<li class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 57x58x44 cm.</li>\n<li class=\"product-description-content\">SU060-00CB00E-0000 Kodlu Seramik Etajerli Lavabo Dahildir.</li>\n<li class=\"product-description-content\">Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</li>\n<li class=\"product-description-content\">Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</li>\n<li class=\"product-description-content\">Çift Çekmeceli</li>\n<li class=\"product-description-content\">MDF</li>\n</ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633547587881",
    "brand": "Creavit",
    "title": "Kayra Mat Safir Blue Kapaklı Lavabo Dolabı 60 cm",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-kapakli-lavabo-dolabi-mavi-60cm.png?v=1748861433",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-kapakli-lavabo-dolabi-mavi-60cm.png?v=1748861433",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-safir-blue-kapakli-lavabo-dolabi-60-cm-4074.jpg?v=1748861433",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-safir-blue-kapakli-lavabo-dolabi-60-cm-4073.jpg?v=1748861433",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-mat-safir-blue-kapakli-lavabo-dolabi-60-cm-4077.jpg?v=1748861433"
    ],
    "price": "18397.50",
    "sku": "KY0060.01.MSB",
    "tags": [
      "Banyo Mobilyası",
      "kapaklı lavabo dolabı",
      "kayra",
      "Lavabo Dolabı",
      "mat safir mavi",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52921478414633,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY0060.01.MSB",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "18397.50",
        "grams": 0,
        "compare_at_price": "24530.00",
        "position": 1,
        "product_id": 8633547587881,
        "created_at": "2026-04-03T14:43:07+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\">\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\">\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-testid=\"conversation-turn-136\">\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\">\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<ul>\n<li class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 57x58x44 cm.</li>\n<li class=\"product-description-content\">SU060-00CB00E-0000 Kodlu Seramik Etajerli Lavabo Dahildir.</li>\n<li class=\"product-description-content\">Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</li>\n<li class=\"product-description-content\">Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</li>\n<li class=\"product-description-content\">Çift Kapaklı</li>\n<li class=\"product-description-content\">MDF</li>\n</ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633547424041",
    "brand": "Creavit",
    "title": "Kayra Lavabo Dolabı Kapaklı 60cm Mat Beyaz",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-kapakli-lavabo-dolabi-beyaz-60cm.png?v=1748861462",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-kapakli-lavabo-dolabi-beyaz-60cm.png?v=1748861462",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-60cm-mat-beyaz-4070.jpg?v=1748861462",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-60cm-mat-beyaz-4069.jpg?v=1748861462",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-60cm-mat-beyaz-4068.jpg?v=1748861462",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-60cm-mat-beyaz-4071.jpg?v=1748861461",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-60cm-mat-beyaz-4072.jpg?v=1748861461"
    ],
    "price": "18397.50",
    "sku": "KY0060.01.MBY",
    "tags": [
      "Banyo Mobilyası",
      "kapaklı lavabo dolabı",
      "kayra",
      "Lavabo Dolabı",
      "Mat Beyaz",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52920967233833,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY0060.01.MBY",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "18397.50",
        "grams": 0,
        "compare_at_price": "24530.00",
        "position": 1,
        "product_id": 8633547424041,
        "created_at": "2026-04-03T12:15:42+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\">\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\">\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-testid=\"conversation-turn-136\">\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\">\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<ul>\n<li class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 57x58x44 cm.</li>\n<li class=\"product-description-content\">SU060-00CB00E-0000 Kodlu Seramik Etajerli Lavabo Dahildir.</li>\n<li class=\"product-description-content\">Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</li>\n<li class=\"product-description-content\">Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</li>\n<li class=\"product-description-content\">Çift Kapaklı</li>\n<li class=\"product-description-content\">MDF</li>\n</ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633547325737",
    "brand": "Creavit",
    "title": "Kayra Lavabo Dolabı Kapaklı 60cm Mat Antrasit",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-kapakli-lavabo-dolabi-antrasit-60cm.png?v=1748861477",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-kapakli-lavabo-dolabi-antrasit-60cm.png?v=1748861477",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-60cm-mat-antrasit-4064.jpg?v=1748861477",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-60cm-mat-antrasit-4065.jpg?v=1748861477",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-60cm-mat-antrasit-4063.jpg?v=1748861477",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-60cm-mat-antrasit-4066.jpg?v=1748861475"
    ],
    "price": "18397.50",
    "sku": "KY0060.01.MAN",
    "tags": [
      "Banyo Mobilyası",
      "kapaklı lavabo dolabı",
      "kayra",
      "Lavabo Dolabı",
      "Mat Antrasit",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52843182981417,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY0060.01.MAN",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "18397.50",
        "grams": 0,
        "compare_at_price": "24530.00",
        "position": 1,
        "product_id": 8633547325737,
        "created_at": "2026-03-17T12:45:29+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\">\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\">\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-testid=\"conversation-turn-136\">\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\">\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<ul>\n<li class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 57x58x44 cm.</li>\n<li class=\"product-description-content\">SU060-00CB00E-0000 Kodlu Seramik Etajerli Lavabo Dahildir.</li>\n<li class=\"product-description-content\">Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</li>\n<li class=\"product-description-content\">Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</li>\n<li class=\"product-description-content\">Çift Kapaklı</li>\n<li class=\"product-description-content\">MDF</li>\n</ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633547161897",
    "brand": "Creavit",
    "title": "Kayra Lavabo Dolabı Kapaklı 60cm Mat Gri",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-kapakli-lavabo-dolabi-gri-60cm.png?v=1748861492",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-kayra-banyo-kapakli-lavabo-dolabi-gri-60cm.png?v=1748861492",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-60cm-mat-gri-4061.jpg?v=1748861492",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-60cm-mat-gri-4059.jpg?v=1748861492",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-60cm-mat-gri-4058.jpg?v=1748861492",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-60cm-mat-gri-4060.jpg?v=1748861490",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/kayra-lavabo-dolabi-kapakli-60cm-mat-gri-4062.jpg?v=1748861490"
    ],
    "price": "18397.50",
    "sku": "KY0060.01.MGR",
    "tags": [
      "Banyo Mobilyası",
      "kapaklı lavabo dolabı",
      "kayra",
      "Lavabo Dolabı",
      "mat gri",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52843182784809,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "KY0060.01.MGR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "18397.50",
        "grams": 0,
        "compare_at_price": "24530.00",
        "position": 1,
        "product_id": 8633547161897,
        "created_at": "2026-03-17T12:45:26+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\">\n<div class=\"react-scroll-to-bottom--css-facts-79elbk h-full dark:bg-gray-800\">\n<div class=\"react-scroll-to-bottom--css-facts-1n7m0yu\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-testid=\"conversation-turn-136\">\n<div class=\"p-4 justify-center text-base md:gap-6 md:py-6 m-auto\">\n<div class=\"flex flex-1 gap-4 text-base mx-auto md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl }\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3 max-w-full\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<ul>\n<li class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 57x58x44 cm.</li>\n<li class=\"product-description-content\">SU060-00CB00E-0000 Kodlu Seramik Etajerli Lavabo Dahildir.</li>\n<li class=\"product-description-content\">Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</li>\n<li class=\"product-description-content\">Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</li>\n<li class=\"product-description-content\">Çift Kapaklı</li>\n<li class=\"product-description-content\">MDF</li>\n</ul>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8633547030825",
    "brand": "Creavit",
    "title": "Font Lavabo Dolabı 50 cm Beyaz-Barok",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-font-lavabo-dolabi-barok.png?v=1749222508",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-font-lavabo-dolabi-barok.png?v=1749222508",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-font-beyaz-banyo-mobilyasi-kucuk-banyolar-bakir2.png?v=1749222508",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-font-beyaz-banyo-mobilyasi-kucuk-banyolar-bakir3.png?v=1749222508"
    ],
    "price": "8002.50",
    "sku": "FT0054.01.BBK",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "font",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52843182588201,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "FT0054.01.BBK",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8002.50",
        "grams": 0,
        "compare_at_price": "10670.00",
        "position": 1,
        "product_id": 8633547030825,
        "created_at": "2026-03-17T12:45:23+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 50x85x40 cm.</p>\n<p class=\"product-description-content\">NX242-00CB00E-0000 Kodlu Seramik Lavabo Dahildir.</p>\n<p class=\"product-description-content\">Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</p>\n<p class=\"product-description-content\">Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</p>\n<p class=\"product-description-content\">Tek Kapaklı</p>\n<p class=\"product-description-content\">MDF</p>"
  },
  {
    "id": "creavit-8633546932521",
    "brand": "Creavit",
    "title": "Font Lavabo Dolabı 50 cm Beyaz-Bakır",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-font-lavabo-dolabi-bakir.png?v=1749223055",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-font-lavabo-dolabi-bakir.png?v=1749223055",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/15.png?v=1749223055",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/14.png?v=1749223055",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/font-lavabo-dolabi-50-cm-beyaz-barok-4051.jpg?v=1749223055",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/font-lavabo-dolabi-50-cm-beyaz-barok-4053.jpg?v=1749223055",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/font-lavabo-dolabi-50-cm-beyaz-barok-4047.jpg?v=1749223055"
    ],
    "price": "8002.50",
    "sku": "FT0054.01.BBR",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "font",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52920967069993,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "FT0054.01.BBR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8002.50",
        "grams": 0,
        "compare_at_price": "10670.00",
        "position": 1,
        "product_id": 8633546932521,
        "created_at": "2026-04-03T12:15:38+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p class=\"product-description-content\">Genişlik x Derinlik x Yükseklik: 50x85x40 cm.</p>\n<p class=\"product-description-content\">NX242-00CB00E-0000 Kodlu Seramik Lavabo Dahildir.</p>\n<p class=\"product-description-content\">Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</p>\n<p class=\"product-description-content\">Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</p>\n<p class=\"product-description-content\">Tek Kapaklı</p>\n<p class=\"product-description-content\">MDF</p>"
  },
  {
    "id": "creavit-8633546768681",
    "brand": "Creavit",
    "title": "Font Lavabo Dolabı 50 cm Beyaz",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-drop-siyah-kumanda-paneli_6.png?v=1749223451",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-drop-siyah-kumanda-paneli_6.png?v=1749223451",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/med-font-beyaz-ana-sahne.jpg?v=1749223451",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/med-font-beyaz-detay-1.jpg?v=1749223451",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/font-lavabo-dolabi-50-cm-beyaz-4040.jpg?v=1749223451",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/font-lavabo-dolabi-50-cm-beyaz-4044.jpg?v=1749223451",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/font-lavabo-dolabi-50-cm-beyaz-4045.jpg?v=1749223451",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/font-lavabo-dolabi-50-cm-beyaz-4046.jpg?v=1749223451"
    ],
    "price": "8002.50",
    "sku": "FT0054.01.BB",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "font",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52936357740841,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "FT0054.01.BB",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8002.50",
        "grams": 0,
        "compare_at_price": "10670.00",
        "position": 1,
        "product_id": 8633546768681,
        "created_at": "2026-04-06T11:13:03+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\">Küçük ve dar banyolar için özel olarak tasarlanmış Font Lavabo Dolabı işlevsellik ve şıklığı bir araya getiriyor. Sınırlı alana sahip banyolarda ek depolama ihtiyacını karşılamak üzere tasarlanan bu dolap dayanıklı malzemelerle uzun ömürlü kullanım sunarken, modern ve zarif tasarımı ile banyonuza zarif bir hava katacak.</p>\r\n<p data-mce-fragment=\"1\">Font Banyo Mobilyaları hayalinizi yansıtan estetik ve karakteristik fonksiyonel ürünlerle banyonuzda büyük düşünmenizi sağlayacak. İhtiyacınıza uygun depolama seçenekleri ile banyonuzu her zaman düzenli tutun.</p>"
  },
  {
    "id": "creavit-8633546670377",
    "brand": "Creavit",
    "title": "Forest Lavabo Dolabı 50 cm Beyaz-Bakır",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/forest-lavabo-dolabi-50-cm-beyaz-bakir-4034.png?v=1747749304",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/forest-lavabo-dolabi-50-cm-beyaz-bakir-4034.png?v=1747749304",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/forest-lavabo-dolabi-50-cm-beyaz-bakir-4035.jpg?v=1747749304",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/forest-lavabo-dolabi-50-cm-beyaz-bakir-4036.jpg?v=1747749304",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/forest-lavabo-dolabi-50-cm-beyaz-bakir-4037.jpg?v=1747749304",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/forest-lavabo-dolabi-50-cm-beyaz-bakir-4038.jpg?v=1747749304"
    ],
    "price": "7177.50",
    "sku": "FT0053.01.BBK",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "forest",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52921477890345,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "FT0053.01.BBK",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7177.50",
        "grams": 0,
        "compare_at_price": "9570.00",
        "position": 1,
        "product_id": 8633546670377,
        "created_at": "2026-04-03T14:43:01+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<ul>\n<li><span>Genişlik x Derinlik x Yükseklik: 50x85x30 cm.</span></li>\n<li><span>TP026-00CB00E-0000 Kodlu Seramik Lavabo Dahildir.</span></li>\n<li><span>Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</span></li>\n<li><span>Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</span></li>\n<li><span>Tek Kapaklı</span></li>\n<li><span>MDF</span></li>\n</ul>"
  },
  {
    "id": "creavit-8633546506537",
    "brand": "Creavit",
    "title": "Forest Lavabo Dolabı 50 cm Beyaz-Barok",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/forest-lavabo-dolabi-50-cm-beyaz-barok-4029.png?v=1747749311",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/forest-lavabo-dolabi-50-cm-beyaz-barok-4029.png?v=1747749311",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/forest-lavabo-dolabi-50-cm-beyaz-barok-4030.jpg?v=1747749311",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/forest-lavabo-dolabi-50-cm-beyaz-barok-4031.jpg?v=1747749311",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/forest-lavabo-dolabi-50-cm-beyaz-barok-4032.jpg?v=1747749311",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/forest-lavabo-dolabi-50-cm-beyaz-barok-4033.jpg?v=1747749311"
    ],
    "price": "7177.50",
    "sku": "FT0053.01.BBR",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "forest",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52886547398953,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "FT0053.01.BBR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7177.50",
        "grams": 0,
        "compare_at_price": "9570.00",
        "position": 1,
        "product_id": 8633546506537,
        "created_at": "2026-03-27T18:52:38+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<ul>\n<li><span>Genişlik x Derinlik x Yükseklik: 50x85x30 cm.</span></li>\n<li><span>TP026-00CB00E-0000 Kodlu Seramik Lavabo Dahildir.</span></li>\n<li><span>Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</span></li>\n<li><span>Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</span></li>\n<li><span>Tek Kapaklı</span></li>\n<li><span>MDF</span></li>\n</ul>"
  },
  {
    "id": "creavit-8633546375465",
    "brand": "Creavit",
    "title": "Forest Lavabo Dolabı 50 cm Beyaz",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/forest-lavabo-dolabi-50-cm-beyaz-4024.png?v=1747729416",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/forest-lavabo-dolabi-50-cm-beyaz-4024.png?v=1747729416",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/forest-lavabo-dolabi-50-cm-beyaz-4025.jpg?v=1747729419",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/forest-lavabo-dolabi-50-cm-beyaz-4026.jpg?v=1747729419",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/forest-lavabo-dolabi-50-cm-beyaz-4027.jpg?v=1747729419",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/forest-lavabo-dolabi-50-cm-beyaz-4028.jpg?v=1747729419"
    ],
    "price": "7177.50",
    "sku": "FT0053.01.BB",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "forest",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52920966906153,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "FT0053.01.BB",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7177.50",
        "grams": 0,
        "compare_at_price": "9570.00",
        "position": 1,
        "product_id": 8633546375465,
        "created_at": "2026-04-03T12:15:35+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<ul>\n<li><span>Genişlik x Derinlik x Yükseklik: 50x85x30 cm.</span></li>\n<li><span>TP026-00CB00E-0000 Kodlu Seramik Lavabo Dahildir.</span></li>\n<li><span>Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</span></li>\n<li><span>Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</span></li>\n<li><span>Tek Kapaklı</span></li>\n<li><span>MDF</span></li>\n</ul>"
  },
  {
    "id": "creavit-8633546244393",
    "brand": "Creavit",
    "title": "Elmas Lavabo Dolabı 45 cm Beyaz-Siyah",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-elmas-lavabo-dolabi-beyaz-siyah-45cm.png?v=1749223516",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-elmas-lavabo-dolabi-beyaz-siyah-45cm.png?v=1749223516",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-lavabo-dolabi-45-cm-beyaz-siyah-4022.jpg?v=1749223516",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-lavabo-dolabi-45-cm-beyaz-siyah-4021.jpg?v=1757425479",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-lavabo-dolabi-45-cm-beyaz-siyah-4020.jpg?v=1749223516",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-lavabo-dolabi-45-cm-beyaz-siyah-4023.jpg?v=1749223510"
    ],
    "price": "6352.50",
    "sku": "EM0045.01.BS",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "elmas",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52921477726505,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "EM0045.01.BS",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6352.50",
        "grams": 0,
        "compare_at_price": "8470.00",
        "position": 1,
        "product_id": 8633546244393,
        "created_at": "2026-04-03T14:42:58+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p>Küçük ve dar banyolar için özel olarak tasarlanmış Elmas Kapaklı Lavabo Dolabı, işlevsellik ve şıklığı bir araya getiriyor. Sınırlı alana sahip banyolarda ek depolama ihtiyacını karşılamak üzere tasarlanan bu dolap işlevselliği ve estetiği bir araya getiriyor. Dayanıklı malzemelerden üretilmiş olan Elmas Kapaklı Lavabo Dolabı uzun ömürlü kullanım sunarken, modern ve zarif tasarımı ile banyonuza zarif bir hava katacak.</p><!---->"
  },
  {
    "id": "creavit-8633546080553",
    "brand": "Creavit",
    "title": "Elmas Lavabo Dolabı 45 cm Beyaz-Parlak Belly",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-elmas-lavabo-dolabi-beyaz-bakir-45cm.png?v=1749223546",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-elmas-lavabo-dolabi-beyaz-bakir-45cm.png?v=1749223546",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-lavabo-dolabi-45-cm-beyaz-parlak-belly-4017.jpg?v=1749223546",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-lavabo-dolabi-45-cm-beyaz-parlak-belly-4018.jpg?v=1749223546",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-lavabo-dolabi-45-cm-beyaz-parlak-belly-4016.jpg?v=1749223546",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-lavabo-dolabi-45-cm-beyaz-parlak-belly-4019.jpg?v=1749223543"
    ],
    "price": "6352.50",
    "sku": "EM0045.01.BL",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "elmas",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52876512166185,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "EM0045.01.BL",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6352.50",
        "grams": 0,
        "compare_at_price": "8470.00",
        "position": 1,
        "product_id": 8633546080553,
        "created_at": "2026-03-25T12:27:35+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<ul>\n<li><span>Genişlik x Derinlik x Yükseklik: 45x85x25 cm.</span></li>\n<li><span>TP025-00CB00E-0000 Kodlu Seramik Lavabo Dahildir.</span></li>\n<li><span>Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</span></li>\n<li><span>Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</span></li>\n<li><span>Tek Kapaklı</span></li>\n<li><span>MDF</span></li>\n</ul>\n<!---->"
  },
  {
    "id": "creavit-8633545949481",
    "brand": "Creavit",
    "title": "Elmas Lavabo Dolabı 45 cm Beyaz",
    "category": "Kapaklı Lavabo Dolabı",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-elmas-lavabo-dolabi-beyaz-45cm.png?v=1749223585",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/creavit-elmas-lavabo-dolabi-beyaz-45cm.png?v=1749223585",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-lavabo-dolabi-45-cm-beyaz-4013.jpg?v=1749223585",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-lavabo-dolabi-45-cm-beyaz-4014.jpg?v=1749223585",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-lavabo-dolabi-45-cm-beyaz-4012.jpg?v=1749223585",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-lavabo-dolabi-45-cm-beyaz-4015.jpg?v=1749223581"
    ],
    "price": "6352.50",
    "sku": "EM0045.01.BB",
    "tags": [
      "Banyo Mobilyası",
      "Beyaz",
      "elmas",
      "Lavabo Dolabı"
    ],
    "variants": [
      {
        "id": 52881455382825,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "EM0045.01.BB",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6352.50",
        "grams": 0,
        "compare_at_price": "8470.00",
        "position": 1,
        "product_id": 8633545949481,
        "created_at": "2026-03-26T12:46:23+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<ul>\n<li><span>Genişlik x Derinlik x Yükseklik: 45x85x25 cm.</span></li>\n<li><span>TP025-00CB00E-0000 Kodlu Seramik Lavabo Dahildir.</span></li>\n<li><span>Armatür, Sifon Alt Grubu ve Süzgeç Ürüne Dahil Değildir.</span></li>\n<li><span>Ürün Lavabo Dolabı ve Lavabodan Oluşmaktadır.</span></li>\n<li><span>Tek Kapaklı</span></li>\n<li><span>MDF</span></li>\n</ul>\n<!---->"
  },
  {
    "id": "creavit-8631582294313",
    "brand": "Creavit",
    "title": "Tezgah Altı Lavabo 33*43cm Beyaz",
    "category": "Tezgah Altı Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tezgah-alti-lavabo-33-43cm-beyaz-3962.png?v=1747305382",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tezgah-alti-lavabo-33-43cm-beyaz-3962.png?v=1747305382",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tezgah-alti-lavabo-33-43cm-beyaz-3963.jpg?v=1747305384",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tezgah-alti-lavabo-33-43cm-beyaz-3964.jpg?v=1747305386",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tezgah-alti-lavabo-33-43cm-beyaz-3965.jpg?v=1747305389",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tezgah-alti-lavabo-33-43cm-beyaz-3966.jpg?v=1747305391",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tezgah-alti-lavabo-33-43cm-beyaz-3967.png?v=1747305394"
    ],
    "price": "2700.00",
    "sku": "TP211-00CB00E-0000",
    "tags": [
      "beyaz",
      "Lavabo",
      "siyah",
      "tezgah altı",
      "tezgah altı lavabo",
      "Vitrifiye",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52843265687849,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "TP211-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2700.00",
        "grams": 0,
        "compare_at_price": "3600.00",
        "position": 1,
        "product_id": 8631582294313,
        "created_at": "2026-03-17T13:11:23+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p><meta charset=\"utf-8\">Toplu kullanım alanlarında hijyen toplum sağlığını yakından ilgilendirmektedir. Creavit olarak okul, hastane, alışveriş merkezleri gibi yerlerde bir çok kişinin ortak kullanımına sunduğumuz lavabo modellerimizle hijyen ve temizliği en üst düzeyde tutuyoruz. Modern ve yenilikçi tasarımlarımızla kullanıcı istek ve beklentilerine uygun tasarımlar yaratıyor, tüm mekanlar için uygun hijyen çözümleri sunuyoruz.</p>"
  },
  {
    "id": "creavit-8631582196009",
    "brand": "Creavit",
    "title": "Ultra Yuvarlak Çanak Lavabo 45cm Beyaz",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-yuvarlak-canak-lavabo-45cm-beyaz-3955.jpg?v=1747805344",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-yuvarlak-canak-lavabo-45cm-beyaz-3955.jpg?v=1747805344",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-yuvarlak-canak-lavabo-45cm-beyaz-3956.jpg?v=1747805344",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-yuvarlak-canak-lavabo-45cm-beyaz-3957.jpg?v=1747805344",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-yuvarlak-canak-lavabo-45cm-beyaz-3958.jpg?v=1747805344",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-yuvarlak-canak-lavabo-45cm-beyaz-3959.jpg?v=1747805344"
    ],
    "price": "6930.00",
    "sku": "UL145-00CB00E-0000",
    "tags": [
      "Beyaz",
      "Lavabo",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "Tezgahüstü",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Yuvarlak",
      "yuvarlak lavabo",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843242094889,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "UL145-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "6930.00",
        "grams": 0,
        "compare_at_price": "9240.00",
        "position": 1,
        "product_id": 8631582196009,
        "created_at": "2026-03-17T13:04:13+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div data-mce-fragment=\"1\" class=\"flex-1 overflow-hidden\">\n<div data-mce-fragment=\"1\" class=\"react-scroll-to-bottom--css-ezbmi-79elbk h-full dark:bg-gray-800\">\n<div data-mce-fragment=\"1\" class=\"react-scroll-to-bottom--css-ezbmi-1n7m0yu\">\n<div data-mce-fragment=\"1\" class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div data-mce-fragment=\"1\" class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\">\n<div data-mce-fragment=\"1\" class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\">\n<div data-mce-fragment=\"1\" class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div data-mce-fragment=\"1\" class=\"flex flex-grow flex-col gap-3\">\n<div data-mce-fragment=\"1\" class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div data-mce-fragment=\"1\" class=\"markdown prose w-full break-words dark:prose-invert light\">\n<p data-mce-fragment=\"1\"><strong>Ultra İnce Tasarım:</strong> Beyazın ışıltılı temizliği, yuvarlak şekli ve ultra ince yapısıyla banyonuzda eşsiz uyumu yakalayacaksınız.</p>\n<p data-mce-fragment=\"1\"><meta charset=\"utf-8\"><strong>Kullanım Kolaylığı: </strong>Creavit Ultra Lavabolar, ergonomik tasarımı sayesinde size kullanım kolaylığı sunar. Yükseklik ve genişlik açısından ideal ölçülerle tasarlanmış olan Ultra Yuvarlak Çanak Lavabo, suyun akışını ve kullanımını en rahat şekilde sağlar.</p>\n<strong>Dayanıklı Malzemeler: </strong>Kaliteli malzemelerle üretilen Creavit Lavabolar günlük kullanıma karşı sağlam bir yapı sunar. Pürüzsüz yüzeyi kolay temizlenerek zamandan tasarruf sağlar.<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> </span><br>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8631582163241",
    "brand": "Creavit",
    "title": "Ultra Yuvarlak Çanak Lavabo 40cm Beyaz",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-yuvarlak-canak-lavabo-40cm-beyaz-3948.png?v=1747805353",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-yuvarlak-canak-lavabo-40cm-beyaz-3948.png?v=1747805353",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-yuvarlak-canak-lavabo-40cm-beyaz-3949.jpg?v=1747805353",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-yuvarlak-canak-lavabo-40cm-beyaz-3950.jpg?v=1747805353",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-yuvarlak-canak-lavabo-40cm-beyaz-3951.jpg?v=1747805353"
    ],
    "price": "6525.00",
    "sku": "UL140-00CB00E-0000",
    "tags": [
      "Beyaz",
      "Lavabo",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "Tezgahüstü",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Yuvarlak",
      "yuvarlak lavabo",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843188125993,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "UL140-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6525.00",
        "grams": 0,
        "compare_at_price": "8700.00",
        "position": 1,
        "product_id": 8631582163241,
        "created_at": "2026-03-17T12:47:06+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div data-mce-fragment=\"1\" class=\"flex-1 overflow-hidden\">\n<div data-mce-fragment=\"1\" class=\"react-scroll-to-bottom--css-ezbmi-79elbk h-full dark:bg-gray-800\">\n<div data-mce-fragment=\"1\" class=\"react-scroll-to-bottom--css-ezbmi-1n7m0yu\">\n<div data-mce-fragment=\"1\" class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div data-mce-fragment=\"1\" class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\">\n<div data-mce-fragment=\"1\" class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\">\n<div data-mce-fragment=\"1\" class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div data-mce-fragment=\"1\" class=\"flex flex-grow flex-col gap-3\">\n<div data-mce-fragment=\"1\" class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div data-mce-fragment=\"1\" class=\"markdown prose w-full break-words dark:prose-invert light\">\n<p data-mce-fragment=\"1\"><strong>Ultra İnce Tasarım:</strong> Beyazın ışıltılı temizliği, yuvarlak şekli ve ultra ince yapısıyla banyonuzda eşsiz uyumu yakalayacaksınız.</p>\n<p data-mce-fragment=\"1\"><meta charset=\"utf-8\"><strong>Kullanım Kolaylığı: </strong>Creavit Ultra Lavabolar, ergonomik tasarımı sayesinde size kullanım kolaylığı sunar. Yükseklik ve genişlik açısından ideal ölçülerle tasarlanmış olan Ultra Yuvarlak Çanak Lavabo, suyun akışını ve kullanımını en rahat şekilde sağlar.</p>\n<strong>Dayanıklı Malzemeler: </strong>Kaliteli malzemelerle üretilen Creavit Lavabolar günlük kullanıma karşı sağlam bir yapı sunar. Pürüzsüz yüzeyi kolay temizlenerek zamandan tasarruf sağlar.<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> </span><br>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8631582130473",
    "brand": "Creavit",
    "title": "Ultra Dikdörtgen Çanak Lavabo 80cm Beyaz",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-80cm-beyaz-3942.png?v=1747805360",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-80cm-beyaz-3942.png?v=1747805360",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-80cm-beyaz-3943.jpg?v=1747805360",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-80cm-beyaz-3944.jpg?v=1747805360",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-80cm-beyaz-3945.jpg?v=1747805360",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-80cm-beyaz-3947.png?v=1747805360"
    ],
    "price": "10665.00",
    "sku": "UL080-00CB00E-0000",
    "tags": [
      "Lavabo",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "Tezgahüstü",
      "Ultra İnce",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843187962153,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "UL080-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "10665.00",
        "grams": 0,
        "compare_at_price": "14220.00",
        "position": 1,
        "product_id": 8631582130473,
        "created_at": "2026-03-17T12:47:02+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div data-mce-fragment=\"1\" class=\"flex-1 overflow-hidden\">\n<div data-mce-fragment=\"1\" class=\"react-scroll-to-bottom--css-ezbmi-79elbk h-full dark:bg-gray-800\">\n<div data-mce-fragment=\"1\" class=\"react-scroll-to-bottom--css-ezbmi-1n7m0yu\">\n<div data-mce-fragment=\"1\" class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div data-mce-fragment=\"1\" class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\">\n<div data-mce-fragment=\"1\" class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\">\n<div data-mce-fragment=\"1\" class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div data-mce-fragment=\"1\" class=\"flex flex-grow flex-col gap-3\">\n<div data-mce-fragment=\"1\" class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div data-mce-fragment=\"1\" class=\"markdown prose w-full break-words dark:prose-invert light\">\n<p data-mce-fragment=\"1\"><strong>Ultra İnce Tasarım:</strong> Beyazın ışıltılı temizliği, dikdörtgen şekli ve ultra ince yapısıyla banyonuzda eşsiz uyumu yakalayacaksınız.</p>\n<p data-mce-fragment=\"1\"><meta charset=\"utf-8\"><strong>Kullanım Kolaylığı: </strong>Creavit Ultra Lavabolar, ergonomik tasarımı sayesinde size kullanım kolaylığı sunar. Yükseklik ve genişlik açısından ideal ölçülerle tasarlanmış olan Ultra Dikdörtgen Çanak Lavabo, suyun akışını ve kullanımını en rahat şekilde sağlar.</p>\n<strong>Dayanıklı Malzemeler: </strong>Kaliteli malzemelerle üretilen Creavit Lavabolar günlük kullanıma karşı sağlam bir yapı sunar. Pürüzsüz yüzeyi kolay temizlenerek zamandan tasarruf sağlar.<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> </span><br>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8631582097705",
    "brand": "Creavit",
    "title": "Ultra Dikdörtgen Çanak Lavabo 60cm Mat Siyah",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60cm-mat-siyah-3936.png?v=1747804595",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60cm-mat-siyah-3936.png?v=1747804595",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60cm-mat-siyah-3937.jpg?v=1747804595",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60cm-mat-siyah-3938.jpg?v=1747804595",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60cm-mat-siyah-3939.jpg?v=1747804595",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60cm-mat-siyah-3940.jpg?v=1747804595",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60cm-mat-siyah-3941.png?v=1747804595"
    ],
    "price": "8250.00",
    "sku": "UL060-00SM00E-0000",
    "tags": [
      "Lavabo",
      "Mat Siyah",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "Tezgahüstü",
      "Ultra İnce",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843187831081,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "UL060-00SM00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8250.00",
        "grams": 0,
        "compare_at_price": "11000.00",
        "position": 1,
        "product_id": 8631582097705,
        "created_at": "2026-03-17T12:46:59+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div data-mce-fragment=\"1\" class=\"flex-1 overflow-hidden\">\n<div data-mce-fragment=\"1\" class=\"react-scroll-to-bottom--css-ezbmi-79elbk h-full dark:bg-gray-800\">\n<div data-mce-fragment=\"1\" class=\"react-scroll-to-bottom--css-ezbmi-1n7m0yu\">\n<div data-mce-fragment=\"1\" class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div data-mce-fragment=\"1\" class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\">\n<div data-mce-fragment=\"1\" class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\">\n<div data-mce-fragment=\"1\" class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div data-mce-fragment=\"1\" class=\"flex flex-grow flex-col gap-3\">\n<div data-mce-fragment=\"1\" class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div data-mce-fragment=\"1\" class=\"markdown prose w-full break-words dark:prose-invert light\">\n<p data-mce-fragment=\"1\"><strong>Ultra İnce Tasarım:</strong> Şık Tasarımı, dikdörtgen şekli ve ultra ince yapısıyla banyonuzda eşsiz uyumu yakalayacaksınız. </p>\n<p data-mce-fragment=\"1\"><meta charset=\"utf-8\"><strong>Kullanım Kolaylığı: </strong>Creavit Ultra Lavabolar, ergonomik tasarımı sayesinde size kullanım kolaylığı sunar. Yükseklik ve genişlik açısından ideal ölçülerle tasarlanmış olan Ultra Dikdörtgen Çanak Lavabo, suyun akışını ve kullanımını en rahat şekilde sağlar.</p>\n<strong>Dayanıklı Malzemeler: </strong>Kaliteli malzemelerle üretilen Creavit Lavabolar günlük kullanıma karşı sağlam bir yapı sunar. Pürüzsüz yüzeyi kolay temizlenerek zamandan tasarruf sağlar.<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> </span><br>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8631581901097",
    "brand": "Creavit",
    "title": "Ultra Kare Çanak Lavabo 40cm Mat Siyah",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-mat-siyah-3928.png?v=1747805381",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-mat-siyah-3928.png?v=1747805381",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-mat-siyah-3929.jpg?v=1747805381",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-mat-siyah-3930.jpg?v=1747805381",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-mat-siyah-3931.jpg?v=1747805381",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-mat-siyah-3932.jpg?v=1747805381",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-mat-siyah-3933.jpg?v=1747805381",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-mat-siyah-3934.jpg?v=1747222247",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-mat-siyah-3935.png?v=1747222251"
    ],
    "price": "7500.00",
    "sku": "UL040-00SM00E-0000",
    "tags": [
      "Kare",
      "kare lavabo",
      "Lavabo",
      "Mat Siyah",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "Tezgahüstü",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843187601705,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "UL040-00SM00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7500.00",
        "grams": 0,
        "compare_at_price": "10000.00",
        "position": 1,
        "product_id": 8631581901097,
        "created_at": "2026-03-17T12:46:56+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div data-mce-fragment=\"1\" class=\"flex-1 overflow-hidden\">\n<div data-mce-fragment=\"1\" class=\"react-scroll-to-bottom--css-ezbmi-79elbk h-full dark:bg-gray-800\">\n<div data-mce-fragment=\"1\" class=\"react-scroll-to-bottom--css-ezbmi-1n7m0yu\">\n<div data-mce-fragment=\"1\" class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div data-mce-fragment=\"1\" class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\">\n<div data-mce-fragment=\"1\" class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\">\n<div data-mce-fragment=\"1\" class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div data-mce-fragment=\"1\" class=\"flex flex-grow flex-col gap-3\">\n<div data-mce-fragment=\"1\" class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div data-mce-fragment=\"1\" class=\"markdown prose w-full break-words dark:prose-invert light\">\n<p data-mce-fragment=\"1\"><strong>Ultra İnce Tasarım:</strong> Şık Tasarımı, kare şekli ve ultra ince yapısıyla banyonuzda eşsiz uyumu yakalayacaksınız.</p>\n<p data-mce-fragment=\"1\"><meta charset=\"utf-8\"><strong>Kullanım Kolaylığı: </strong>Creavit Ultra Lavabolar, ergonomik tasarımı sayesinde size kullanım kolaylığı sunar. Yükseklik ve genişlik açısından ideal ölçülerle tasarlanmış olan Ultra Kare Çanak Lavabo, suyun akışını ve kullanımını en rahat şekilde sağlar.</p>\n<strong>Dayanıklı Malzemeler: </strong>Kaliteli malzemelerle üretilen Creavit Lavabolar günlük kullanıma karşı sağlam bir yapı sunar. Pürüzsüz yüzeyi kolay temizlenerek zamandan tasarruf sağlar.<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> </span><br>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8631581868329",
    "brand": "Creavit",
    "title": "Ultra Kare Çanak Lavabo 40cm Mat Cappuccino",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-mat-cappuccino-3921.png?v=1747805387",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-mat-cappuccino-3921.png?v=1747805387",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-mat-cappuccino-3922.jpg?v=1747805387",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-mat-cappuccino-3923.jpg?v=1747805387",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-mat-cappuccino-3924.jpg?v=1747805387",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-mat-cappuccino-3925.jpg?v=1747805387",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-mat-cappuccino-3926.jpg?v=1747805387",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-mat-cappuccino-3927.png?v=1747805387"
    ],
    "price": "9810.00",
    "sku": "UL040-00CM00E-0000",
    "tags": [
      "Kare",
      "kare lavabo",
      "Lavabo",
      "Mat Cappucino",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "Tezgahüstü",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843255529769,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "UL040-00CM00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9810.00",
        "grams": 0,
        "compare_at_price": "13080.00",
        "position": 1,
        "product_id": 8631581868329,
        "created_at": "2026-03-17T13:08:06+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div data-mce-fragment=\"1\" class=\"flex-1 overflow-hidden\">\n<div data-mce-fragment=\"1\" class=\"react-scroll-to-bottom--css-ezbmi-79elbk h-full dark:bg-gray-800\">\n<div data-mce-fragment=\"1\" class=\"react-scroll-to-bottom--css-ezbmi-1n7m0yu\">\n<div data-mce-fragment=\"1\" class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div data-mce-fragment=\"1\" class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\">\n<div data-mce-fragment=\"1\" class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\">\n<div data-mce-fragment=\"1\" class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div data-mce-fragment=\"1\" class=\"flex flex-grow flex-col gap-3\">\n<div data-mce-fragment=\"1\" class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div data-mce-fragment=\"1\" class=\"markdown prose w-full break-words dark:prose-invert light\">\n<p data-mce-fragment=\"1\"><strong>Ultra İnce Tasarım:</strong> Şık Tasarımı, kare şekli ve ultra ince yapısıyla banyonuzda eşsiz uyumu yakalayacaksınız.</p>\n<p data-mce-fragment=\"1\"><meta charset=\"utf-8\"><strong>Kullanım Kolaylığı: </strong>Creavit Ultra Lavabolar, ergonomik tasarımı sayesinde size kullanım kolaylığı sunar. Yükseklik ve genişlik açısından ideal ölçülerle tasarlanmış olan Ultra Kare Çanak Lavabo, suyun akışını ve kullanımını en rahat şekilde sağlar.</p>\n<strong>Dayanıklı Malzemeler: </strong>Kaliteli malzemelerle üretilen Creavit Lavabolar günlük kullanıma karşı sağlam bir yapı sunar. Pürüzsüz yüzeyi kolay temizlenerek zamandan tasarruf sağlar.<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> </span><br>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8631581802793",
    "brand": "Creavit",
    "title": "Ultra Kare Çanak Lavabo 40cm Beyaz",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-beyaz-3912.png?v=1747805394",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-beyaz-3912.png?v=1747805394",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-beyaz-3913.jpg?v=1747805394",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-beyaz-3914.jpg?v=1747805394",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-beyaz-3915.jpg?v=1747805394",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-beyaz-3916.jpg?v=1747805394",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-beyaz-3917.jpg?v=1747805394",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-beyaz-3918.jpg?v=1747222183",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-beyaz-3919.jpg?v=1747222186",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-beyaz-3920.png?v=1747222191"
    ],
    "price": "6525.00",
    "sku": "UL040-00CB00E-0000",
    "tags": [
      "Beyaz",
      "Kare",
      "kare lavabo",
      "Lavabo",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "Tezgahüstü",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843187437865,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "UL040-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6525.00",
        "grams": 0,
        "compare_at_price": "8700.00",
        "position": 1,
        "product_id": 8631581802793,
        "created_at": "2026-03-17T12:46:53+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div data-mce-fragment=\"1\" class=\"flex-1 overflow-hidden\">\n<div data-mce-fragment=\"1\" class=\"react-scroll-to-bottom--css-ezbmi-79elbk h-full dark:bg-gray-800\">\n<div data-mce-fragment=\"1\" class=\"react-scroll-to-bottom--css-ezbmi-1n7m0yu\">\n<div data-mce-fragment=\"1\" class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div data-mce-fragment=\"1\" class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\">\n<div data-mce-fragment=\"1\" class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\">\n<div data-mce-fragment=\"1\" class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div data-mce-fragment=\"1\" class=\"flex flex-grow flex-col gap-3\">\n<div data-mce-fragment=\"1\" class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\n<div data-mce-fragment=\"1\" class=\"markdown prose w-full break-words dark:prose-invert light\">\n<p data-mce-fragment=\"1\"><strong>Ultra İnce Tasarım:</strong> Beyazın ışıltılı temizliği, kare şekli ve ultra ince yapısıyla banyonuzda eşsiz uyumu yakalayacaksınız.</p>\n<p data-mce-fragment=\"1\"><meta charset=\"utf-8\"><strong>Kullanım Kolaylığı: </strong>Creavit Ultra Lavabolar, ergonomik tasarımı sayesinde size kullanım kolaylığı sunar. Yükseklik ve genişlik açısından ideal ölçülerle tasarlanmış olan Ultra Kare Çanak Lavabo, suyun akışını ve kullanımını en rahat şekilde sağlar.</p>\n<strong>Dayanıklı Malzemeler: </strong>Kaliteli malzemelerle üretilen Creavit Lavabolar günlük kullanıma karşı sağlam bir yapı sunar. Pürüzsüz yüzeyi kolay temizlenerek zamandan tasarruf sağlar.<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> </span><br>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8631581770025",
    "brand": "Creavit",
    "title": "Ultra Kare Çanak Lavabo 40cm Mat Antrasit",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-mat-antrasit-3904.png?v=1747805402",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-mat-antrasit-3904.png?v=1747805402",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-mat-antrasit-3905.jpg?v=1747805402",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-mat-antrasit-3906.jpg?v=1747805402",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-mat-antrasit-3907.jpg?v=1747805402",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-mat-antrasit-3908.jpg?v=1747805402",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-mat-antrasit-3909.jpg?v=1747805402",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-kare-canak-lavabo-40cm-mat-antrasit-3910.jpg?v=1747805402"
    ],
    "price": "9810.00",
    "sku": "UL040-00AM00E-0000",
    "tags": [
      "Kare",
      "kare lavabo",
      "Lavabo",
      "Mat Antrasit",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "Tezgahüstü",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843187339561,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "UL040-00AM00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9810.00",
        "grams": 0,
        "compare_at_price": "13080.00",
        "position": 1,
        "product_id": 8631581770025,
        "created_at": "2026-03-17T12:46:50+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<meta charset=\"utf-8\">\r\n<p data-mce-fragment=\"1\">Minimalizmin Şıklığı: Ultra İnce Kare Çanak Lavabo!</p>\r\n\r\n<p data-mce-fragment=\"1\">Banyo dekorasyonunuzu modern ve zarif bir şekilde tamamlamak isteyenlere, Creavit Ultra İnce Kare Çanak Lavabo sizin için mükemmel bir seçenektir. Bu özel tasarım lavabo, minimalizmi şıklıkla buluşturan zarif çizgileri ve ince yapısıyla dikkat çekiyor.</p>\r\n\r\n<p><span data-mce-fragment=\"1\">Modern ve Zarif Tasarım:</span><span data-mce-fragment=\"1\" data-mce-style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"><span data-mce-fragment=\"1\"> Kare</span> şekli ve ultra ince yapısıyla lavabo, banyonuza modern bir estetik katarken aynı zamanda şıklığı da vurgular.</span><br data-mce-fragment=\"1\">\r\n<span data-mce-fragment=\"1\">Yer Tasarrufu:</span><span data-mce-fragment=\"1\" data-mce-style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"><span data-mce-fragment=\"1\"> </span>İnce ve kompakt yapısı sayesinde banyo alanınızda yer tasarrufu sağlar, özellikle daha küçük banyolarda ideal bir seçenektir.</span><br data-mce-fragment=\"1\">\r\n<span data-mce-fragment=\"1\">Dayanıklı Malzeme:</span><span data-mce-fragment=\"1\" data-mce-style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"><span data-mce-fragment=\"1\"> </span>Kaliteli malzemelerden üretilen lavabo, uzun ömürlü kullanım sağlar ve dayanıklılık sunar.</span><br data-mce-fragment=\"1\">\r\n<span data-mce-fragment=\"1\">Kolay Temizlik:</span><span data-mce-fragment=\"1\" data-mce-style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"><span data-mce-fragment=\"1\"> </span>Pürüzsüz yüzeyi sayesinde temizliği kolaydır ve banyo hijyenini ön planda tutar.</span><br data-mce-fragment=\"1\">\r\n<span data-mce-fragment=\"1\">Estetik ve Fonksiyonellik:</span><span data-mce-fragment=\"1\" data-mce-style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"><span data-mce-fragment=\"1\"> </span>Hem görünümü hem de işlevselliği ile dikkat çeken bu lavabo, banyo deneyiminizi daha rahat ve keyifli hale getirir.</span><br data-mce-fragment=\"1\">\r\n<span data-mce-fragment=\"1\">Kişiselleştirme:</span><span data-mce-fragment=\"1\" data-mce-style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"><span data-mce-fragment=\"1\"> </span>Farklı tarz ve renkteki musluklarla kombinleyerek lavabonuzu kişisel zevkinize uygun hale getirebilirsiniz.</span></p>\r\n\r\n<p> </p>\r\n\r\n<p data-mce-fragment=\"1\">Ultra İnce Kare Çanak Lavabo ile banyonuzda minimalist bir dokunuş ve şıklık yakalayın! Estetik ve pratikliği bir araya getiren bu lavabo ile banyo anlarınızı daha keyifli hale getirin!</p>\r\n\r\n<p> </p>"
  },
  {
    "id": "creavit-8631581737257",
    "brand": "Creavit",
    "title": "Topic Tezgah Üzeri Çanak Lavabo 70cm Beyaz",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/topic-tezgah-uzeri-canak-lavabo-70cm-beyaz-3898.png?v=1747222109",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/topic-tezgah-uzeri-canak-lavabo-70cm-beyaz-3898.png?v=1747222109",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/topic-tezgah-uzeri-canak-lavabo-70cm-beyaz-3899.jpg?v=1747222115",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/topic-tezgah-uzeri-canak-lavabo-70cm-beyaz-3900.jpg?v=1747222118",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/topic-tezgah-uzeri-canak-lavabo-70cm-beyaz-3901.jpg?v=1747222120",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/topic-tezgah-uzeri-canak-lavabo-70cm-beyaz-3902.jpg?v=1747222123",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/topic-tezgah-uzeri-canak-lavabo-70cm-beyaz-3903.png?v=1747222126"
    ],
    "price": "6390.00",
    "sku": "TP172-00CB00E-0000",
    "tags": [
      "Beyaz",
      "Lavabo",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "tezgah üzeri lavabo",
      "Tezgahüstü",
      "Topic",
      "Vitrifiye",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52843188846889,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "TP172-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6390.00",
        "grams": 0,
        "compare_at_price": "8520.00",
        "position": 1,
        "product_id": 8631581737257,
        "created_at": "2026-03-17T12:47:21+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p>Topic<strong> </strong>Tezgah Üzeri Çanak Lavabo, <meta charset=\"utf-8\">klasiğin dışındaki kendinden tezgahlı ve çanak formlu tasarımı sayesinde banyonuza pratik bir hava getirecek. Creavit Tezgah Üstü Lavabolar, ergonomik tasarımı sayesinde size kullanım kolaylığı sunar. Yükseklik ve genişlik açısından ideal ölçülerle tasarlanmış olan Topic Tezgah Üzeri Lavabo, suyun akışını ve kullanımını en rahat şekilde sağlar. Kaliteli malzemelerle üretilen Creavit Lavabolar günlük kullanıma karşı sağlam bir yapı sunar. Pürüzsüz yüzeyi kolay temizlenerek zamandan tasarruf sağlar.<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> </span></p>\n<!---->"
  },
  {
    "id": "creavit-8631581507881",
    "brand": "Creavit",
    "title": "Loop Yuvarlak Çanak Lavabo Ø45 cm Beyaz",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-beyaz-3865.png?v=1747805441",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-beyaz-3865.png?v=1747805441",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-beyaz-3866.jpg?v=1747805441",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-beyaz-3867.jpg?v=1747805441",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-beyaz-3868.jpg?v=1747805441",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-beyaz-3872.jpg?v=1747805441",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-45-cm-beyaz-3873.png?v=1747805441"
    ],
    "price": "7965.00",
    "sku": "LP145-00CB00E-0000",
    "tags": [
      "Beyaz",
      "Lavabo",
      "Loop",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "ultra ince",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843255234857,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP145-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7965.00",
        "grams": 0,
        "compare_at_price": "10620.00",
        "position": 1,
        "product_id": 8631581507881,
        "created_at": "2026-03-17T13:08:03+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz modern sanat galerisine dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-8631581212969",
    "brand": "Creavit",
    "title": "Loop Kare Çanak Lavabo 40 cm Beyaz",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-canak-lavabo-40-cm-beyaz-3844.png?v=1747805519",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-canak-lavabo-40-cm-beyaz-3844.png?v=1747805519",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-canak-lavabo-40-cm-beyaz-3846.jpg?v=1747805519",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-canak-lavabo-40-cm-beyaz-3848.jpg?v=1747805519",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-canak-lavabo-40-cm-beyaz-3849.png?v=1747805519"
    ],
    "price": "4995.00",
    "sku": "LP040-00CB00E-0000",
    "tags": [
      "Beyaz",
      "Kare",
      "Lavabo",
      "Tezgahüstü",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843186651433,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP040-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "4995.00",
        "grams": 0,
        "compare_at_price": "6660.00",
        "position": 1,
        "product_id": 8631581212969,
        "created_at": "2026-03-17T12:46:37+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz modern sanat galerisine dönüşsün!</strong></p>\r\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\r\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\r\n<p data-mce-fragment=\"1\">Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-8631581081897",
    "brand": "Creavit",
    "title": "Next Tezgah Üzeri Kare Lavabo 70cm Beyaz",
    "category": "Tezgah Üstü Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/next-tezgah-uzeri-kare-lavabo-70cm-beyaz-3839.png?v=1747221871",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/next-tezgah-uzeri-kare-lavabo-70cm-beyaz-3839.png?v=1747221871",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/next-tezgah-uzeri-kare-lavabo-70cm-beyaz-3840.jpg?v=1747221873",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/next-tezgah-uzeri-kare-lavabo-70cm-beyaz-3841.png?v=1747221878",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/next-tezgah-uzeri-kare-lavabo-70cm-beyaz-3842.png?v=1747221881",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/next-tezgah-uzeri-kare-lavabo-70cm-beyaz-3843.png?v=1747221888"
    ],
    "price": "7785.00",
    "sku": "NX270-00CB00E-0000",
    "tags": [
      "Beyaz",
      "Kare",
      "Lavabo",
      "next",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "tezgah üzeri lavabo",
      "Tezgahüstü",
      "Vitrifiye",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52843190878505,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "NX270-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7785.00",
        "grams": 0,
        "compare_at_price": "10380.00",
        "position": 1,
        "product_id": 8631581081897,
        "created_at": "2026-03-17T12:47:55+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\">Creavit Next Tezgah Üstü Lavabo ile banyonuzun atmosferini değiştirin ve en özel mekanlardan birini yaratın. Estetik tasarımı ve kullanım kolaylığıyla birleşen bu lavabo, banyo deneyiminizi baştan sona mükemmel kılacak.</p>\r\n<p><span data-mce-fragment=\"1\">Şık ve Zarif Tasarım:</span><span data-mce-fragment=\"1\"> Tezgah Üstü Lavabo, şık ve zarif tasarımı sayesinde banyonuza sofistike bir hava katar. İnce detaylar ve dikkat çekici hatlar, banyonuzu güzellik dolu bir yaşam alanına dönüştürür.</span><br data-mce-fragment=\"1\"><span data-mce-fragment=\"1\">Kullanım Kolaylığı:</span><span data-mce-fragment=\"1\"> Tezgah üstü lavabo, ergonomik tasarımı sayesinde size kullanım kolaylığı sunar. Yükseklik ve genişlik açısından ideal ölçülerle tasarlanmış olan Next Tezgah Üstü Lavabo, suyun akışını ve kullanımını en rahat şekilde sağlar.</span><br data-mce-fragment=\"1\"><span data-mce-fragment=\"1\">Dayanıklılık:</span><span data-mce-fragment=\"1\"> Kaliteli malzemelerle üretilen Creavit lavabolar, uzun ömürlü kullanım imkanı sunar. Dayanıklı yapısı sayesinde, günlük kullanımda dahi parlaklığını ve şıklığını korur.</span><br data-mce-fragment=\"1\"><span data-mce-fragment=\"1\">Kolay Montaj ve Temizlik:</span><span data-mce-fragment=\"1\"> Next Tezgah Üstü Lavabo'nun montajı oldukça kolaydır ve tüm gerekli montaj aksesuarları ile birlikte gelir. Pürüzsüz yüzeyi sayesinde temizliği oldukça pratiktir, zamandan tasarruf sağlar.</span></p>\r\n<p> </p>\r\n<p data-mce-fragment=\"1\">Creavit Next Tezgah Üstü Lavabo, banyonuzun odak noktası haline gelecek. Şıklığı ve fonksiyonelliği bir arada arayanlar için vazgeçilmez bir seçenek olan Creavit Next Tezgah Üstü Lavabo ile banyonuzda güzelliğin keyfini yaşayın!</p>\r\n<p> </p>"
  },
  {
    "id": "creavit-8631581049129",
    "brand": "Creavit",
    "title": "Next Tezgah Üzeri Kare Lavabo 60cm Beyaz",
    "category": "Tezgah Üstü Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/next-tezgah-uzeri-kare-lavabo-60cm-beyaz-3834.png?v=1747723420",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/next-tezgah-uzeri-kare-lavabo-60cm-beyaz-3834.png?v=1747723420",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/next-tezgah-uzeri-kare-lavabo-60cm-beyaz-3835.jpg?v=1747723423",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/next-tezgah-uzeri-kare-lavabo-60cm-beyaz-3836.png?v=1747723426",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/next-tezgah-uzeri-kare-lavabo-60cm-beyaz-3837.png?v=1747723429",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/next-tezgah-uzeri-kare-lavabo-60cm-beyaz-3838.png?v=1747723432"
    ],
    "price": "6570.00",
    "sku": "NX260-00CB00E-0000",
    "tags": [
      "Beyaz",
      "Kare",
      "Lavabo",
      "next",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "tezgah üzeri lavabo",
      "Tezgahüstü",
      "Vitrifiye",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52843191566633,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "NX260-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6570.00",
        "grams": 0,
        "compare_at_price": "8760.00",
        "position": 1,
        "product_id": 8631581049129,
        "created_at": "2026-03-17T12:48:01+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><span style=\"FONT-FAMILY: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif\">Creavit Tezgah Üstü Lavabo, şık ve zarif tasarımı sayesinde banyonuza sofistike bir hava katar. İnce detaylar ve dikkat çekici hatlar, banyonuzu güzellik dolu bir yaşam alanına dönüştürür. </span><span data-mce-fragment=\"1\">Tezgah üstü lavabo, ergonomik tasarımı sayesinde size kullanım kolaylığı sunar. Yükseklik ve genişlik açısından ideal ölçülerle tasarlanmış olan Next Tezgah Üstü Lavabo, suyun akışını ve kullanımını en rahat şekilde sağlar. </span><span data-mce-fragment=\"1\">Kaliteli malzemelerle üretilen Creavit lavabolar, uzun ömürlü kullanım imkanı sunar. Dayanıklı yapısı sayesinde, günlük kullanımda dahi parlaklığını ve şıklığını korur.</span><br data-mce-fragment=\"1\"><span data-mce-fragment=\"1\"></span></p>"
  },
  {
    "id": "creavit-8631580983593",
    "brand": "Creavit",
    "title": "Next Tezgah Üzeri Lavabo 40x50cm Beyaz",
    "category": "Tezgah Üstü Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/next-tezgah-uzeri-lavabo-40x50cm-beyaz-3829.png?v=1747234182",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/next-tezgah-uzeri-lavabo-40x50cm-beyaz-3829.png?v=1747234182",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/next-tezgah-uzeri-lavabo-40x50cm-beyaz-3830.jpg?v=1747234185",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/next-tezgah-uzeri-lavabo-40x50cm-beyaz-3831.png?v=1747234188",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/next-tezgah-uzeri-lavabo-40x50cm-beyaz-3832.png?v=1747234191",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/next-tezgah-uzeri-lavabo-40x50cm-beyaz-3833.png?v=1747234195"
    ],
    "price": "5175.00",
    "sku": "NX242-00CB00E-0000",
    "tags": [
      "Beyaz",
      "Dikdörtgen",
      "Lavabo",
      "next",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "tezgah üzeri lavabo",
      "Tezgahüstü",
      "Vitrifiye",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52843252908329,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "NX242-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5175.00",
        "grams": 0,
        "compare_at_price": "6900.00",
        "position": 1,
        "product_id": 8631580983593,
        "created_at": "2026-03-17T13:07:18+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "\r\n<p data-mce-fragment=\"1\">Creavit Next Tezgah Üstü Lavabo ile banyonuzun atmosferini değiştirin ve en özel mekanlardan birini yaratın. Estetik tasarımı ve kullanım kolaylığıyla birleşen bu lavabo, banyo deneyiminizi baştan sona mükemmel kılacak.</p>\r\n<p>Şık ve Zarif Tasarım:<span data-mce-fragment=\"1\"> Tezgah Üstü Lavabo, şık ve zarif tasarımı sayesinde banyonuza sofistike bir hava katar. İnce detaylar ve dikkat çekici hatlar, banyonuzu güzellik dolu bir yaşam alanına dönüştürür.</span><br data-mce-fragment=\"1\">Kullanım Kolaylığı:<span data-mce-fragment=\"1\"> Creavit Tezgah üstü lavabolar, ergonomik tasarımı sayesinde size kullanım kolaylığı sunar. Yükseklik ve genişlik açısından ideal ölçülerle tasarlanmış olan Next Tezgah Üstü Lavabo, suyun akışını ve kullanımını en rahat şekilde sağlar.</span><br data-mce-fragment=\"1\">Dayanıklılık:<span data-mce-fragment=\"1\"> Kaliteli malzemelerle üretilen Creavit lavabolar, uzun ömürlü kullanım imkanı sunar. Dayanıklı yapısı sayesinde, günlük kullanımda dahi parlaklığını ve şıklığını korur.</span><br data-mce-fragment=\"1\">Kolay Montaj ve Temizlik:<span data-mce-fragment=\"1\"> Creavit tezgah üstü lavaboların montajı oldukça kolaydır ve tüm gerekli montaj aksesuarları ile birlikte gelir. Pürüzsüz yüzeyi sayesinde temizliği oldukça pratiktir, zamandan tasarruf sağlar.</span></p>\r\n<p data-mce-fragment=\"1\">Creavit Next Tezgah Üstü Lavabo, banyonuzun odak noktası haline gelecek. Şıklığı ve fonksiyonelliği bir arada arayanlar için vazgeçilmez bir seçenek olan Creavit Next Tezgah Üstü Lavabo ile banyonuzda güzelliğin keyfini yaşayın!</p>"
  },
  {
    "id": "creavit-8631580918057",
    "brand": "Creavit",
    "title": "Su Etajerli Lavabo 100cm Beyaz",
    "category": "Etajerli Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/su-etajerli-lavabo-100cm-beyaz-3823.png?v=1747221817",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/su-etajerli-lavabo-100cm-beyaz-3823.png?v=1747221817",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/su-etajerli-lavabo-100cm-beyaz-3824.jpg?v=1747221820",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/su-etajerli-lavabo-100cm-beyaz-3825.jpg?v=1747221823",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/su-etajerli-lavabo-100cm-beyaz-3826.jpg?v=1747221827",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/su-etajerli-lavabo-100cm-beyaz-3827.jpg?v=1747221829",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/su-etajerli-lavabo-100cm-beyaz-3828.png?v=1747221834"
    ],
    "price": "7560.00",
    "sku": "SU100-00CB00E-0000",
    "tags": [
      "Beyaz",
      "Etajerli Lavabo",
      "Lavabo",
      "Su",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "Vitrifiye",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52890437812521,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SU100-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7560.00",
        "grams": 0,
        "compare_at_price": "10080.00",
        "position": 1,
        "product_id": 8631580918057,
        "created_at": "2026-03-28T11:33:38+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p>﻿﻿Banyonuza zarafet ve düzen katmak için Creavit Su Etajerli Lavabo ile tanışın! Şık tasarımı ve işlevsel özellikleri ile banyonuzu estetik bir yaşam alanına dönüştürerek, günlük kullanımınızı pratikleştirecek.</p>\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p data-mce-fragment=\"1\">Estetik ve Şık Tasarım:<span data-mce-fragment=\"1\"> Etajerli Lavabo, modern ve zarif tasarımı sayesinde banyonuza sofistike bir atmosfer katar. Şık hatları ve ince detayları ile görsel bir şölen sunarak banyonuzun dekorasyonunu tamamlayacak.</span></p>\r\n<p data-mce-fragment=\"1\">Düzenleyici Etajer:<span data-mce-fragment=\"1\"> Geniş etajeri sayesinde, banyo malzemelerinizi düzenli bir şekilde saklamanızı sağlar. Kişisel eşyalarınızı kolayca yerleştirerek banyonuzu daha organize ve ferah bir hale getirir.</span></p>\n</div>\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">Dayanıklı Malzemeler:<span data-mce-fragment=\"1\"> Kaliteli malzemelerle üretilen Etajerli Lavabo, uzun süre dayanıklılığını korur ve günlük kullanıma karşı sağlam bir yapı sunar. Böylece uzun yıllar boyunca sorunsuz bir şekilde kullanabilirsiniz.</span> </div>\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\n<br data-mce-fragment=\"1\">Kolay Montaj ve Temizlik:<span data-mce-fragment=\"1\"> Etajerli Lavabo'nun montajı kolaydır ve tüm gerekli montaj aksesuarları ile birlikte gelir. Pürüzsüz yüzeyi, kolay temizlik sağlar ve size zaman kazandırır.</span><br data-mce-fragment=\"1\">  \r\n<p data-mce-fragment=\"1\">Etajerli Lavabo, sadece bir lavabo değil, aynı zamanda banyonuzun düzenleyici ve estetik bir parçası olacak. Şık tasarımı ile göz alıcı bir öğe olarak ön plana çıkar ve banyonuzda rahat, ferah ve huzurlu bir atmosfer yaratır.</p>\r\n<p data-mce-fragment=\"1\">Banyonuzun güzellik dolu bir yaşam alanına dönüşmesini sağlayan Creavit Su Etajerli Lavabo ile banyo deneyiminiz artık benzersiz olacak!</p>\n</div>"
  },
  {
    "id": "creavit-8631580852521",
    "brand": "Creavit",
    "title": "Su Etajerli Lavabo 80 cm Beyaz",
    "category": "Etajerli Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/su-etajerli-lavabo-80-cm-beyaz-3817.png?v=1747556742",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/su-etajerli-lavabo-80-cm-beyaz-3817.png?v=1747556742",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/su-etajerli-lavabo-80-cm-beyaz-3818.jpg?v=1747556745",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/su-etajerli-lavabo-80-cm-beyaz-3819.jpg?v=1747556747",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/su-etajerli-lavabo-80-cm-beyaz-3820.jpg?v=1747556749",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/su-etajerli-lavabo-80-cm-beyaz-3821.jpg?v=1747556751",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/su-etajerli-lavabo-80-cm-beyaz-3822.png?v=1747556755"
    ],
    "price": "6525.00",
    "sku": "SU080-00CB00E-0000",
    "tags": [
      "Beyaz",
      "Etajerli Lavabo",
      "Lavabo",
      "Su",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "Vitrifiye",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52843240194345,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SU080-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6525.00",
        "grams": 0,
        "compare_at_price": "8700.00",
        "position": 1,
        "product_id": 8631580852521,
        "created_at": "2026-03-17T13:03:35+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "\r\n<p data-mce-fragment=\"1\">Banyonuza zarafet ve düzen katmak için Creavit Su Etajerli Lavabo ile tanışın! Şık tasarımı ve işlevsel özellikleri ile banyonuzu estetik bir yaşam alanına dönüştürerek, günlük kullanımınızı pratikleştirecek.</p>\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p data-mce-fragment=\"1\">Estetik ve Şık Tasarım:<span data-mce-fragment=\"1\"> Etajerli Lavabo, modern ve zarif tasarımı sayesinde banyonuza sofistike bir atmosfer katar. Şık hatları ve ince detayları ile görsel bir şölen sunarak banyonuzun dekorasyonunu tamamlayacak.</span></p>\r\n<p data-mce-fragment=\"1\">Düzenleyici Etajer:<span data-mce-fragment=\"1\"> Geniş etajeri sayesinde, banyo malzemelerinizi düzenli bir şekilde saklamanızı sağlar. Kişisel eşyalarınızı kolayca yerleştirerek banyonuzu daha organize ve ferah bir hale getirir.</span></p>\n</div>\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">Dayanıklı Malzemeler:<span data-mce-fragment=\"1\"> Kaliteli malzemelerle üretilen Etajerli Lavabo, uzun süre dayanıklılığını korur ve günlük kullanıma karşı sağlam bir yapı sunar. Böylece uzun yıllar boyunca sorunsuz bir şekilde kullanabilirsiniz.</span> </div>\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\n<br data-mce-fragment=\"1\">Kolay Montaj ve Temizlik:<span data-mce-fragment=\"1\"> Etajerli Lavabo'nun montajı kolaydır ve tüm gerekli montaj aksesuarları ile birlikte gelir. Pürüzsüz yüzeyi, kolay temizlik sağlar ve size zaman kazandırır.</span><br data-mce-fragment=\"1\">  \r\n<p data-mce-fragment=\"1\">Etajerli Lavabo, sadece bir lavabo değil, aynı zamanda banyonuzun düzenleyici ve estetik bir parçası olacak. Şık tasarımı ile göz alıcı bir öğe olarak ön plana çıkar ve banyonuzda rahat, ferah ve huzurlu bir atmosfer yaratır.</p>\r\n<p data-mce-fragment=\"1\">Banyonuzun güzellik dolu bir yaşam alanına dönüşmesini sağlayan Creavit Su Etajerli Lavabo ile banyo deneyiminiz artık benzersiz olacak!</p>\n</div>"
  },
  {
    "id": "creavit-8631580819753",
    "brand": "Creavit",
    "title": "Su Etajerli Lavabo 60 cm Beyaz",
    "category": "Etajerli Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/su-etajerli-lavabo-60-cm-beyaz-3811.png?v=1747221757",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/su-etajerli-lavabo-60-cm-beyaz-3811.png?v=1747221757",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/su-etajerli-lavabo-60-cm-beyaz-3812.jpg?v=1747221760",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/su-etajerli-lavabo-60-cm-beyaz-3813.jpg?v=1747221763",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/su-etajerli-lavabo-60-cm-beyaz-3814.jpg?v=1747221765",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/su-etajerli-lavabo-60-cm-beyaz-3815.jpg?v=1747221768",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/su-etajerli-lavabo-60-cm-beyaz-3816.png?v=1747221774"
    ],
    "price": "5805.00",
    "sku": "SU060-00CB00E-0000",
    "tags": [
      "Beyaz",
      "Etajerli Lavabo",
      "Lavabo",
      "Su",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "Vitrifiye",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52843260313897,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "SU060-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5805.00",
        "grams": 0,
        "compare_at_price": "7740.00",
        "position": 1,
        "product_id": 8631580819753,
        "created_at": "2026-03-17T13:09:36+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "\r\n<p data-mce-fragment=\"1\">Banyonuza zarafet ve düzen katmak için Creavit Su Etajerli Lavabo ile tanışın! Şık tasarımı ve işlevsel özellikleri ile banyonuzu estetik bir yaşam alanına dönüştürerek, günlük kullanımınızı pratikleştirecek.</p>\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p data-mce-fragment=\"1\">Estetik ve Şık Tasarım:<span data-mce-fragment=\"1\"> Etajerli Lavabo, modern ve zarif tasarımı sayesinde banyonuza sofistike bir atmosfer katar. Şık hatları ve ince detayları ile görsel bir şölen sunarak banyonuzun dekorasyonunu tamamlayacak.</span></p>\r\n<p data-mce-fragment=\"1\">Düzenleyici Etajer:<span data-mce-fragment=\"1\"> Geniş etajeri sayesinde, banyo malzemelerinizi düzenli bir şekilde saklamanızı sağlar. Kişisel eşyalarınızı kolayca yerleştirerek banyonuzu daha organize ve ferah bir hale getirir.</span></p>\n</div>\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">Dayanıklı Malzemeler:<span data-mce-fragment=\"1\"> Kaliteli malzemelerle üretilen Etajerli Lavabo, uzun süre dayanıklılığını korur ve günlük kullanıma karşı sağlam bir yapı sunar. Böylece uzun yıllar boyunca sorunsuz bir şekilde kullanabilirsiniz.</span> </div>\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\n<br data-mce-fragment=\"1\">Kolay Montaj ve Temizlik:<span data-mce-fragment=\"1\"> Etajerli Lavabo'nun montajı kolaydır ve tüm gerekli montaj aksesuarları ile birlikte gelir. Pürüzsüz yüzeyi, kolay temizlik sağlar ve size zaman kazandırır.</span><br data-mce-fragment=\"1\">  \r\n<p data-mce-fragment=\"1\">Etajerli Lavabo, sadece bir lavabo değil, aynı zamanda banyonuzun düzenleyici ve estetik bir parçası olacak. Şık tasarımı ile göz alıcı bir öğe olarak ön plana çıkar ve banyonuzda rahat, ferah ve huzurlu bir atmosfer yaratır.</p>\r\n<p data-mce-fragment=\"1\">Banyonuzun güzellik dolu bir yaşam alanına dönüşmesini sağlayan Creavit Su Etajerli Lavabo ile banyo deneyiminiz artık benzersiz olacak!</p>\n</div>"
  },
  {
    "id": "creavit-8631580786985",
    "brand": "Creavit",
    "title": "Memory Etajerli Lavabo 45 cm Beyaz",
    "category": "Etajerli Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/memory-etajerli-lavabo-45-cm-beyaz-3805.png?v=1747221729",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/memory-etajerli-lavabo-45-cm-beyaz-3805.png?v=1747221729",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/memory-etajerli-lavabo-45-cm-beyaz-3806.jpg?v=1747221732",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/memory-etajerli-lavabo-45-cm-beyaz-3807.jpg?v=1747221734",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/memory-etajerli-lavabo-45-cm-beyaz-3808.jpg?v=1747221737",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/memory-etajerli-lavabo-45-cm-beyaz-3809.jpg?v=1747221739",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/memory-etajerli-lavabo-45-cm-beyaz-3810.png?v=1747221747"
    ],
    "price": "4860.00",
    "sku": "MY045-00CB00E-0000",
    "tags": [
      "Beyaz",
      "Etajerli Lavabo",
      "küçük",
      "Lavabo",
      "memory",
      "Vitrifiye",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52843181965609,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "MY045-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "4860.00",
        "grams": 0,
        "compare_at_price": "6480.00",
        "position": 1,
        "product_id": 8631580786985,
        "created_at": "2026-03-17T12:45:14+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Yerden Tasarruf:</strong> Memory Lavabo az yer kaplayan tasarımı ile sınırlı alanlarda etkili bir çözüm sunar. Banyonuzu ferah ve kullanışlı hale getirir.</p>\r\n<p data-mce-fragment=\"1\"><strong>Estetik ve Modern Tasarım: </strong>Memory<strong> </strong>Lavabonun şık hatları, modern ve zarif tasarımı ile banyonuzun dekorasyonunu tamamlayın.</p>\r\n<p data-mce-fragment=\"1\"><strong>Dayanıklı Malzemeler: </strong>Kaliteli malzemelerle üretilen Creavit Lavabolar günlük kullanıma karşı sağlam bir yapı sunar. Pürüzsüz yüzeyi kolay temizlenerek zamandan tasarruf sağlar.</p>"
  },
  {
    "id": "creavit-8570981744937",
    "brand": "Creavit",
    "title": "Çift Su Girişli Yandan Kumandalı Fotoselli Lavabo Armatürü",
    "category": "Fotoselli Armatürler",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/cift-su-girisli-yandan-kumandali-fotoselli-lavabo-armaturu-3707.png?v=1747221574",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/cift-su-girisli-yandan-kumandali-fotoselli-lavabo-armaturu-3707.png?v=1747221574",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/cift-su-girisli-yandan-kumandali-fotoselli-lavabo-armaturu-3708.jpg?v=1747984503",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/cift-su-girisli-yandan-kumandali-fotoselli-lavabo-armaturu-3709.jpg?v=1747984503"
    ],
    "price": "18750.00",
    "sku": "BT.ES2570",
    "tags": [
      "Armatür",
      "Banyo",
      "Fotoselli armatür",
      "Krom",
      "Lavabo Armatürü",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843224006953,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.ES2570",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "18750.00",
        "grams": 0,
        "compare_at_price": "25000.00",
        "position": 1,
        "product_id": 8570981744937,
        "created_at": "2026-03-17T12:57:37+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div style=\"font-family: Arial, sans-serif; line-height: 1.6; color: #333;\">\n<p>Creavit BT.ES2570, yüksek teknoloji ürünü fotoselli lavabo bataryasıdır. Hijyenik kullanım ve su tasarrufunu bir arada sunar. Özellikle yoğun kullanılan kamu alanları, ticari yapılar, hastaneler ve restoranlarda ideal çözümdür. Dokunmadan su açıp kapama özelliği sayesinde çapraz bulaşma riskini azaltır ve kullanım kolaylığı sağlar.</p>\n<hr>\n<h3>🛠️ Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Model Kodu:</strong> BT.ES2570</li>\n<li>\n<strong>Seri:</strong> ES (Elektronik Sensörlü)</li>\n<li>\n<strong>Malzeme:</strong> %100 pirinç gövde — dayanıklı, korozyona dirençli</li>\n<li>\n<strong>Kaplama:</strong> Parlak krom kaplama — estetik ve uzun ömürlü yüzey</li>\n<li>\n<strong>Renk:</strong> Parlak krom</li>\n<li>\n<strong>Armatür Tipi:</strong> Fotoselli (kızılötesi sensörlü) lavabo bataryası</li>\n<li>\n<strong>Montaj Tipi:</strong> Tezgah üstü montaj</li>\n<li>\n<strong>Sensör Tipi:</strong> Kızılötesi (IR) sensör — hareket algılama, dokunmadan su kontrolü</li>\n<li>\n<strong>Sensör Algılama Mesafesi:</strong> Ayarlanabilir, genellikle 10-15 cm arası</li>\n<li>\n<strong>Kartuş:</strong> Elektronik manyetik valf — hassas su açma/kapama</li>\n<li>\n<strong>Su Akış Debisi:</strong> 6-9 litre/dakika (sensör optimizasyonlu)</li>\n<li>\n<strong>Çalışma Gerilimi:</strong> 6-12V DC (pil veya adaptör ile beslenir)</li>\n<li>\n<strong>Güç Kaynağı:</strong> 4 adet AAA pil veya adaptör (model seçeneğine göre)</li>\n<li>\n<strong>Çıkış Ucu Uzunluğu:</strong> 154 mm</li>\n<li>\n<strong>Çıkış Ucu Yüksekliği:</strong> 122 mm</li>\n<li>\n<strong>Açma-Kapama Mekanizması:</strong> Otomatik — sensör algıladığında su açılır, algılamayı kaybedince kapanır</li>\n<li>\n<strong>Su Girişi:</strong> Sıcak ve soğuk su için çift giriş</li>\n<li>\n<strong>Su Sıcaklığı Kontrolü:</strong> Manuel, tezgah üzerindeki kol ile</li>\n<li>\n<strong>Su Tasarrufu:</strong> Sensör teknolojisi gereksiz su tüketimini engeller</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>Temassız ve Hijyenik Kullanım: Kullanıcı musluğa dokunmadan suyu açıp kapatabilir, böylece hijyen üst seviyeye çıkar.</li>\n<li>Ayarlanabilir Sensör Mesafesi: Kullanım alanına göre algılama aralığı kolayca ayarlanabilir.</li>\n<li>Düşük Enerji Tüketimi: Pil ömrü uzun, ayrıca adaptör ile sürekli güç sağlama imkanı.</li>\n<li>Dayanıklı ve Estetik: Pirinç gövde ve krom kaplama, hem sağlamlık hem de şıklık sunar.</li>\n<li>Kolay Montaj: Standart tezgah üstü montaj sistemi sayesinde hızlı ve kolay kurulum.</li>\n<li>Su Tasarrufu Sağlar: Gereksiz su akışlarını otomatik durdurur, çevre ve bütçe dostudur.</li>\n<li>Manuel Yedekleme: Pil veya sensör arızası durumunda bazı modellerde manuel kullanım mümkün (model varyasyonuna bağlı).</li>\n</ul>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>Creavit BT.ES2570 Fotoselli Lavabo Armatürü</li>\n<li>Montaj bağlantı aparatları ve vidalar</li>\n<li>Elektronik valf ve IR sensör ünitesi</li>\n<li>4 adet AAA pil veya adaptör (model seçeneğine göre)</li>\n<li>3/8\" fleks bağlantı hortumları</li>\n<li>Kullanım, montaj ve bakım kılavuzu</li>\n</ul>\n<hr>\n<h3>🏷️ Kullanım Alanları</h3>\n<ul>\n<li>Kamu binaları, okullar, hastaneler, ofis lavaboları</li>\n<li>Restoranlar, kafeler, ticari mutfaklar</li>\n<li>Spor salonları, alışveriş merkezleri, toplu kullanım alanları</li>\n<li>Modern konut banyoları, hijyen ve kullanım kolaylığı arayan evler</li>\n</ul>\n<hr>\n<p>Creavit BT.ES2570, en son sensör teknolojisiyle donatılmış fotoselli lavabo bataryasıdır. Hem su tasarrufu sağlar hem de hijyenik kullanım sunar. Sağlam pirinç yapısı ve krom kaplamasıyla dayanıklı ve estetik bir üründür. Ayarlanabilir sensör mesafesi ve enerji verimli tasarımıyla uzun ömürlü ve konforlu kullanım sağlar.</p>\n</div>"
  },
  {
    "id": "creavit-8561471717673",
    "brand": "Creavit",
    "title": "Sharp Lavabo Armatürü Krom",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-lavabo-armaturu-krom-3703.png?v=1747221557",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-lavabo-armaturu-krom-3703.png?v=1747221557",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-lavabo-armaturu-krom-3705.jpg?v=1747221561",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-lavabo-armaturu-krom-3704.jpg?v=1747221563",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-lavabo-armaturu-krom-3706.jpg?v=1747221566"
    ],
    "price": "6030.00",
    "sku": "BT.SR1500",
    "tags": [
      "Armatür",
      "Krom",
      "Lavabo Armatürü",
      "Pirinç",
      "sessiz su akışı",
      "Sharp",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843234459945,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.SR1500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6030.00",
        "grams": 0,
        "compare_at_price": "8040.00",
        "position": 1,
        "product_id": 8561471717673,
        "created_at": "2026-03-17T13:01:26+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p>Şıklığı ve işlevselliği bir araya getiren Sharp Lavabo Armatürü banyonuzda estetik bir atmosfer yaratırken aynı zamanda günlük kullanımlarınızda konfor sağlar. Sharp Lavabo Armatürü'nün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizması, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle banyo deneyiminiz daha keyifli hale gelecek. Creavit armatürleri, gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>"
  },
  {
    "id": "creavit-8560329523497",
    "brand": "Creavit",
    "title": "Avangart Mutfak Armatürü Krom",
    "category": "Mutfak Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/avangart-mutfak-armaturu-krom-3696.png?v=1747221524",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/avangart-mutfak-armaturu-krom-3696.png?v=1747221524",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/avangart-mutfak-armaturu-krom-3697.jpg?v=1747221527",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/avangart-mutfak-armaturu-krom-3698.jpg?v=1747221529",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/avangart-mutfak-armaturu-krom-3699.jpg?v=1747221532"
    ],
    "price": "7872.00",
    "sku": "BT.AG8500",
    "tags": [
      "Armatür",
      "avangart",
      "kireç temizleme",
      "mutfak",
      "Mutfak Armatürü",
      "Pirinç",
      "sessiz su akışı",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52836709859625,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.AG8500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7872.00",
        "grams": 0,
        "compare_at_price": "13120.00",
        "position": 1,
        "product_id": 8560329523497,
        "created_at": "2026-03-15T21:26:25+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p>Creavit Avangart serisinin <strong>BT.AG8500</strong> modeli, mutfaklarda modern tasarımı ve fonksiyonelliğiyle öne çıkan bir armatürdür. Aşağıda, bu ürünün detaylı teknik özelliklerini bulabilirsiniz:</p>\n<hr>\n<h3>🛠️ Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Model Kodu:</strong> BT.AG8500</li>\n<li>\n<strong>Seri:</strong> Avangart</li>\n<li>\n<strong>Malzeme:</strong> %100 pirinç</li>\n<li>\n<strong>Kaplama:</strong> Krom</li>\n<li>\n<strong>Armatür Tipi:</strong> Tek kumandalı miks armatür</li>\n<li>\n<strong>Kartuş:</strong> Uzun ömürlü 35 mm seramik ayaklı kartuş</li>\n<li>\n<strong>Su Akış Debisi:</strong> 7–8 litre/dakika</li>\n<li>\n<strong>Çıkış Ucu Uzunluğu:</strong> 188,9 mm</li>\n<li>\n<strong>Çıkış Ucu Yüksekliği:</strong> 282,7 mm</li>\n<li>\n<strong>Dönme Açısı:</strong> Sağa ve sola 55 derece döner borulu su çıkışı</li>\n<li>\n<strong>Montaj Tipi:</strong> Dikey düzlem (tezgah üstü montaj)</li>\n<li>\n<strong>Perlatör:</strong> Kolay değiştirilebilir, kireç temizleme sistemli, sessiz su akışı sağlayan perlatör</li>\n<li>\n<strong>Renk Seçenekleri:</strong> Krom</li>\n<li>\n<strong>Garanti Süresi:</strong> 5 yıl</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>\n<strong>Modern Tasarım:</strong> Minimalist ve şık hatlarıyla mutfağınıza estetik bir dokunuş katar.</li>\n<li>\n<strong>Kireç Temizleme Sistemi:</strong> Su akışını engelleyen kireç birikintilerini önler, uzun ömürlü kullanım sağlar.</li>\n<li>\n<strong>Kolay Montaj:</strong> Tezgah üstü montaj imkanı sunar, kurulum sürecini kolaylaştırır.</li>\n<li>\n<strong>Yüksek Kalite:</strong> %100 pirinç malzeme ve uzun ömürlü seramik kartuş ile dayanıklılık sağlar.</li>\n</ul>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>Batarya: Creavit AG8500 Avangart Lüx Mutfak Armatürü</li>\n<li>Montaj Aparatları: 3/8\" - M10 - 50 cm flekso hortumlar ve sabitleme aparatları</li>\n<li>Kullanım Kılavuzu: Kurulum ve bakım talimatlarını içeren kılavuz</li>\n</ul>\n<hr>\n<p>Creavit AG8500 Avangart Lüx Mutfak Armatürü, modern tasarımı, fonksiyonelliği ve dayanıklılığı ile mutfağınızda şıklığı ve konforu bir arada sunar. Krom kaplama ve kireç temizleme sistemi gibi özellikleri sayesinde uzun ömürlü ve kullanıcı dostudur. Fiyat-performans açısından da tatmin edici bir üründür.</p>"
  },
  {
    "id": "creavit-8560273097001",
    "brand": "Creavit",
    "title": "Fotoselli Lavabo Armatürü Çift Su Girişli Krom",
    "category": "Fotoselli Armatürler",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/fotoselli-lavabo-armaturu-cift-su-girisli-krom-3693.png?v=1747805534",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/fotoselli-lavabo-armaturu-cift-su-girisli-krom-3693.png?v=1747805534",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/fotoselli-lavabo-armaturu-cift-su-girisli-krom-3694.jpg?v=1747984341",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/fotoselli-lavabo-armaturu-cift-su-girisli-krom-3695.jpg?v=1747984341"
    ],
    "price": "19125.00",
    "sku": "BT.ES2410",
    "tags": [
      "Armatür",
      "Banyo",
      "Fotoselli armatür",
      "Krom",
      "Lavabo Armatürü",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843223843113,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.ES2410",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "19125.00",
        "grams": 0,
        "compare_at_price": "25500.00",
        "position": 1,
        "product_id": 8560273097001,
        "created_at": "2026-03-17T12:57:34+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"product-description\">\n<p>Creavit BT.ES2410, hijyen, su tasarrufu ve kullanım kolaylığını ön planda tutan gelişmiş sensör teknolojisiyle donatılmış fotoselli lavabo bataryasıdır. Özellikle yoğun kullanılan kamu binaları, hastaneler, restoranlar ve ticari alanlar için tasarlanmıştır. Dokunmadan su akışı sağlayarak hijyenik ortam yaratır ve gereksiz su israfını önler.</p>\n<hr>\n<h3>🛠️ Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Model Kodu:</strong> BT.ES2410</li>\n<li>\n<strong>Seri:</strong> ES (Elektronik Sensörlü)</li>\n<li>\n<strong>Malzeme:</strong> %100 pirinç gövde – dayanıklı, uzun ömürlü ve korozyona karşı yüksek direnç</li>\n<li>\n<strong>Kaplama:</strong> Parlak krom kaplama – estetik ve koruyucu yüzey</li>\n<li>\n<strong>Renk:</strong> Parlak krom</li>\n<li>\n<strong>Armatür Tipi:</strong> Fotoselli (kızılötesi sensörlü) lavabo bataryası</li>\n<li>\n<strong>Montaj Tipi:</strong> Tezgah üstü montaj</li>\n<li>\n<strong>Sensör Tipi:</strong> Kızılötesi (IR) sensör – hareket algılama özelliği ile dokunmadan kontrol</li>\n<li>\n<strong>Sensör Algılama Mesafesi:</strong> Ayarlanabilir, tipik olarak 10-15 cm arası</li>\n<li>\n<strong>Kartuş:</strong> Elektronik kontrollü manyetik valf – su akışını hassas şekilde açıp kapatır</li>\n<li>\n<strong>Su Akış Debisi:</strong> 6-8 litre/dakika (sensör optimizasyonlu)</li>\n<li>\n<strong>Çalışma Gerilimi:</strong> 6-12V (pil veya adaptör ile beslenir)</li>\n<li>\n<strong>Güç Kaynağı:</strong> 4 adet AAA pil veya adaptör seçeneği</li>\n<li>\n<strong>Çıkış Ucu Uzunluğu:</strong> 140 mm</li>\n<li>\n<strong>Çıkış Ucu Yüksekliği:</strong> 128 mm</li>\n<li>\n<strong>Açma-Kapama Mekanizması:</strong> Otomatik, sensör algıladığında su açılır, algılamayı kaybedince otomatik kapanır</li>\n<li>\n<strong>Su Girişi:</strong> Sıcak ve soğuk su için çift giriş</li>\n<li>\n<strong>Su Tasarrufu:</strong> Sensör teknolojisi gereksiz su tüketimini engeller</li>\n<li>\n<strong>Su Sıcaklığı Kontrolü:</strong> Manuel, tezgah üzerindeki kumanda koluyla</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>Hijyenik ve Temassız Kullanım: Kullanıcı musluğa dokunmadan su akışı sağlar, çapraz bulaşma riskini büyük ölçüde azaltır.</li>\n<li>Ayarlanabilir Sensör Mesafesi: Farklı lavabolara ve kullanım senaryolarına uyum için algılama aralığı kolayca ayarlanabilir.</li>\n<li>Enerji Verimliliği: Düşük enerji tüketimi sayesinde piller uzun ömürlü olur; alternatif olarak adaptör kullanımı mümkündür.</li>\n<li>Su Tasarrufu Sağlar: Gereksiz su akışını otomatik olarak durdurarak hem çevreye hem de ekonomik tasarrufa katkı sağlar.</li>\n<li>Dayanıklı Malzeme ve Estetik Tasarım: Pirinç gövde ile uzun ömürlü kullanım ve parlak krom kaplama ile modern ve şık görünüm.</li>\n<li>Kolay Montaj ve Bakım: Standart tezgah üstü montaj uyumu ve kolay erişilebilir elektronik valf birimi sayesinde pratik kurulum ve servis imkanı.</li>\n<li>Manuel Yedekleme: Pil bitimi ya da sensör arızası durumunda bazı modellerde manuel kullanıma geçiş mümkün (model varyasyonuna bağlı).</li>\n</ul>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>Creavit BT.ES2410 Fotoselli Lavabo Armatürü</li>\n<li>Montaj için gerekli bağlantı aparatları ve vidalar</li>\n<li>Elektronik valf ve kızılötesi sensör ünitesi</li>\n<li>4 adet AAA pil veya adaptör (model seçeneğine göre)</li>\n<li>3/8\" standart fleks hortumlar</li>\n<li>Kullanım, montaj ve bakım kılavuzu</li>\n</ul>\n<hr>\n<h3>🏷️ Kullanım Alanları</h3>\n<ul>\n<li>Kamu binaları, ofisler, hastaneler, okullar ve diğer toplu kullanım alanları</li>\n<li>Restoran, kafe ve ticari mutfaklar</li>\n<li>Modern konut banyoları ve hijyenin ön planda olduğu ev ortamları</li>\n<li>Spor salonları, alışveriş merkezleri ve yoğun kullanımlı alanlar</li>\n</ul>\n<hr>\n<p>Creavit BT.ES2410 Fotoselli Lavabo Armatürü, gelişmiş sensör teknolojisi ile kullanıcıların musluğa dokunmadan suyu kullanmasını sağlayarak hijyen ve su tasarrufunu maksimum seviyeye çıkarır. Dayanıklı pirinç yapısı ve krom kaplamasıyla uzun yıllar güvenle kullanabileceğiniz, estetik ve fonksiyonel bir musluk çözümüdür. Ayarlanabilir sensör mesafesi ve enerji verimliliği sayesinde kullanım kolaylığı sunar.</p>\n</div>"
  },
  {
    "id": "creavit-8556687327529",
    "brand": "Creavit",
    "title": "Spiralli Mutfak Armatürü Krom",
    "category": "Mutfak Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spiralli-mutfak-armaturu-krom-3689.png?v=1747805702",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spiralli-mutfak-armaturu-krom-3689.png?v=1747805702",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spiralli-mutfak-armaturu-krom-3691.jpg?v=1747805702",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spiralli-mutfak-armaturu-krom-3690.jpg?v=1747805702",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/spiralli-mutfak-armaturu-krom-3692.jpg?v=1747805702"
    ],
    "price": "11880.00",
    "sku": "BT.MF8858",
    "tags": [
      "Armatür",
      "krom",
      "mutfak",
      "Mutfak Armatürü",
      "spiralli",
      "Spiralli Mutfak Armatürü",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843260576041,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.MF8858",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11880.00",
        "grams": 0,
        "compare_at_price": "15840.00",
        "position": 1,
        "product_id": 8556687327529,
        "created_at": "2026-03-17T13:09:43+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-ezbmi-79elbk h-full dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-ezbmi-1n7m0yu\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-col text-sm dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-mce-fragment=\"1\">\r\n<div class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\" data-mce-fragment=\"1\">\r\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-grow flex-col gap-3\" data-mce-fragment=\"1\">\r\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\" data-mce-fragment=\"1\">\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p><strong>Profesyonel Görünüm ile Her Yöne Özgürlük</strong></p>\r\n<p>Creavit'in suyu maksimum verimle kullanabilmek ve rahat yıkama yapabilmek için geliştirilen spiralli armatür ürün grubu mutfakta profesyonelliği sağlıyor. Uzayabilen hortumu ile spiralli armatürler mutfağınızı daha temiz tutmanıza yardımcı olurken hijyen ve konforu üst seviyede tutarak mutfakta verimliliği arttırıyor. Creavit armatürleri tamamen pirinç malzemeden oluşan yapısıyla; suyun doğallığını, kokusunu ve rengini bozmaz ve uzun yıllar güvenle kullanılabilir.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8556642828585",
    "brand": "Creavit",
    "title": "Termostatik Banyo Armatürü",
    "category": "Termostatik Banyo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/termostatik-banyo-armaturu-3686.png?v=1747805698",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/termostatik-banyo-armaturu-3686.png?v=1747805698",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/termostatik-banyo-armaturu-3688.jpg?v=1747805698",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/termostatik-banyo-armaturu-3687.jpg?v=1747805698"
    ],
    "price": "20925.00",
    "sku": "BT.TS2505",
    "tags": [
      "Armatür",
      "Banyo",
      "banyo armatürü",
      "Krom",
      "termostatik",
      "termostatik banyo armatürü",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843223744809,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.TS2505",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "20925.00",
        "grams": 0,
        "compare_at_price": "27900.00",
        "position": 1,
        "product_id": 8556642828585,
        "created_at": "2026-03-17T12:57:31+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<div class=\"flex-1 overflow-hidden\">\r\n<div class=\"react-scroll-to-bottom--css-ezbmi-79elbk h-full dark:bg-gray-800\">\r\n<div class=\"react-scroll-to-bottom--css-ezbmi-1n7m0yu\">\r\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\r\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\">\r\n<div class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\">\r\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\r\n<div class=\"flex flex-grow flex-col gap-3\">\r\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\r\n<p><strong>Banyoda Sıcak - Soğuk Dengesi; Creavit Termostatik Armatür!</strong></p>\r\n<p>Su sıcaklığını sabitleme özelliği ile duş almayı sorun olmaktan çıkaran Creavit Termostatik Armatür fonksiyonel özellikleriyle banyolara konfor katıyor.</p>\r\n<p><strong>Hassas Sıcaklık Kontrolü: </strong>Termostatik teknoloji sayesinde suyun sıcaklık ayarını hassas bir şekilde yaparak anlık sıcaklık dalgalanmaları olmadan sabit sıcaklıkta banyo yapabilirsiniz.</p>\r\n<p><strong>Kolay Kullanım: </strong>Tek bir kol ile su sıcaklığını banyo esnasında bile istenilen şekilde kolayca değiştirmeye olanak verir.</p>\r\n<p><strong>Modern Tasarım:</strong> Şık ve modern tasarımı, banyonuza zarif bir dokunuş ekleyerek banyo dekorasyonunuzu tamamlar.</p>\n<br>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8531878379817",
    "brand": "Creavit",
    "title": "Ultra Dikdörtgen Çanak Lavabo 60 cm Mat Antrasit",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60-cm-mat-antrasit-3678.png?v=1747804605",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60-cm-mat-antrasit-3678.png?v=1747804605",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60-cm-mat-antrasit-3679.jpg?v=1747804605",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60-cm-mat-antrasit-3680.jpg?v=1747804605",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60-cm-mat-antrasit-3681.jpg?v=1747804605",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60-cm-mat-antrasit-3682.jpg?v=1747221462",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60-cm-mat-antrasit-3683.jpg?v=1747221464",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60-cm-mat-antrasit-3684.jpg?v=1747221467",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60-cm-mat-antrasit-3685.png?v=1747221471"
    ],
    "price": "11160.00",
    "sku": "UL060-00AM00E-0000",
    "tags": [
      "Dikdörtgen",
      "Lavabo",
      "Mat Antrasit",
      "Tezgahüstü",
      "Ultra İnce",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52908330713385,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "UL060-00AM00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11160.00",
        "grams": 0,
        "compare_at_price": "14880.00",
        "position": 1,
        "product_id": 8531878379817,
        "created_at": "2026-03-31T19:26:42+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p> </p>\n<div class=\"flex-1 overflow-hidden\" data-mce-fragment=\"1\">\n<div class=\"react-scroll-to-bottom--css-ezbmi-79elbk h-full dark:bg-gray-800\" data-mce-fragment=\"1\">\n<div class=\"react-scroll-to-bottom--css-ezbmi-1n7m0yu\" data-mce-fragment=\"1\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\" data-mce-fragment=\"1\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-mce-fragment=\"1\">\n<div class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\" data-mce-fragment=\"1\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\" data-mce-fragment=\"1\">\n<div class=\"flex flex-grow flex-col gap-3\" data-mce-fragment=\"1\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\" data-mce-fragment=\"1\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\n<p data-mce-fragment=\"1\">Minimalizmin Şıklığı: Ultra İnce Dikdörtgen Çanak Lavabo\" </p>\n<p data-mce-fragment=\"1\">Banyo dekorasyonunuzu modern ve zarif bir şekilde tamamlamak isteyenlere, Creavit Ultra İnce Dikdörtgen Çanak Lavabo sizin için mükemmel bir seçenek olacak. Bu özel tasarım lavabo, minimalizmi şıklıkla buluşturan zarif çizgileri ve ince yapısıyla dikkat çekiyor.</p>\nModern ve Zarif Tasarım:<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> Dikdörtgen şekli ve ultra ince yapısıyla lavabo, banyonuza modern bir estetik katarken aynı zamanda şıklığı da vurgular.</span><br>Yer Tasarrufu:<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> İnce ve kompakt yapısı sayesinde banyo alanınızda yer tasarrufu sağlar, özellikle daha küçük banyolarda ideal bir seçenektir.</span><br>Dayanıklı Malzeme:<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> Kaliteli malzemelerden üretilen lavabo, uzun ömürlü kullanım sağlar ve dayanıklılık sunar.</span><br>Kolay Temizlik:<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> Pürüzsüz yüzeyi sayesinde temizliği kolaydır ve banyo hijyenini ön planda tutar.</span><br>Estetik ve Fonksiyonellik:<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> Hem görünümü hem de işlevselliği ile dikkat çeken bu lavabo, banyo deneyiminizi daha rahat ve keyifli hale getirir.</span><br>Kişiselleştirme:<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> Farklı tarz ve renkteki musluklarla kombinleyerek lavabonuzu kişisel zevkinize uygun hale getirebilirsiniz.</span>\n<p data-mce-fragment=\"1\">Ultra İnce Dikdörtgen Çanak Lavabo ile banyonuzda minimalist bir dokunuş ve şıklık yakalayın! Estetik ve pratikliği bir araya getiren bu lavabo ile banyo anlarınızı daha keyifli hale getirin!</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n<p> </p>"
  },
  {
    "id": "creavit-8531847119145",
    "brand": "Creavit",
    "title": "Ultra Dikdörtgen Çanak Lavabo 60 cm Mat Cappucino",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60-cm-mat-cappucino-3671.png?v=1747804613",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60-cm-mat-cappucino-3671.png?v=1747804613",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60-cm-mat-cappucino-3672.jpg?v=1747804613",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60-cm-mat-cappucino-3673.jpg?v=1747804613",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60-cm-mat-cappucino-3674.jpg?v=1747804613",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60-cm-mat-cappucino-3675.jpg?v=1747804613",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60-cm-mat-cappucino-3676.jpg?v=1747804613",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60-cm-mat-cappucino-3677.png?v=1747804613"
    ],
    "price": "11160.00",
    "sku": "UL060-00CM00E-0000",
    "tags": [
      "Dikdörtgen",
      "Lavabo",
      "Mat Cappucino",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "Tezgahüstü",
      "Ultra İnce",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843181441321,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "UL060-00CM00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11160.00",
        "grams": 0,
        "compare_at_price": "14880.00",
        "position": 1,
        "product_id": 8531847119145,
        "created_at": "2026-03-17T12:45:07+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<meta charset=\"utf-8\"><meta charset=\"utf-8\">\r\n<div class=\"flex-1 overflow-hidden\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-ezbmi-79elbk h-full dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-ezbmi-1n7m0yu\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-col text-sm dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-mce-fragment=\"1\">\r\n<div class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\" data-mce-fragment=\"1\">\r\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-grow flex-col gap-3\" data-mce-fragment=\"1\">\r\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\" data-mce-fragment=\"1\">\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p data-mce-fragment=\"1\">Minimalizmin Şıklığı: Ultra İnce Dikdörtgen Çanak Lavabo!</p>\r\n\r\n<p data-mce-fragment=\"1\">Banyo dekorasyonunuzu modern ve zarif bir şekilde tamamlamak isteyenlere, Creavit Ultra İnce Dikdörtgen Çanak Lavabo sizin için mükemmel bir seçenektir. Bu özel tasarım lavabo, minimalizmi şıklıkla buluşturan zarif çizgileri ve ince yapısıyla dikkat çekiyor.</p>\r\nModern ve Zarif Tasarım:<span data-mce-style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> Dikdörtgen şekli ve ultra ince yapısıyla lavabo, banyonuza modern bir estetik katarken aynı zamanda şıklığı da vurgular.</span><br>\r\nYer Tasarrufu:<span data-mce-style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> İnce ve kompakt yapısı sayesinde banyo alanınızda yer tasarrufu sağlar, özellikle daha küçük banyolarda ideal bir seçenektir.</span><br>\r\nDayanıklı Malzeme:<span data-mce-style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> Kaliteli malzemelerden üretilen lavabo, uzun ömürlü kullanım sağlar ve dayanıklılık sunar.</span><br>\r\nKolay Temizlik:<span data-mce-style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> Pürüzsüz yüzeyi sayesinde temizliği kolaydır ve banyo hijyenini ön planda tutar.</span><br>\r\nEstetik ve Fonksiyonellik:<span data-mce-style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> Hem görünümü hem de işlevselliği ile dikkat çeken bu lavabo, banyo deneyiminizi daha rahat ve keyifli hale getirir.</span><br>\r\nKişiselleştirme:<span data-mce-style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\" style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> Farklı tarz ve renkteki musluklarla kombinleyerek lavabonuzu kişisel zevkinize uygun hale getirebilirsiniz.</span>\r\n\r\n<p data-mce-fragment=\"1\">Ultra İnce Dikdörtgen Çanak Lavabo ile banyonuzda minimalist bir dokunuş ve şıklık yakalayın! Estetik ve pratikliği bir araya getiren bu lavabo ile banyo anlarınızı daha keyifli hale getirin!</p>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>\r\n</div>"
  },
  {
    "id": "creavit-8531388530985",
    "brand": "Creavit",
    "title": "Ultra Dikdörtgen Çanak Lavabo 60 cm Beyaz",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60-cm-beyaz-3662.png?v=1747804631",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60-cm-beyaz-3662.png?v=1747804631",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60-cm-beyaz-3663.jpg?v=1747804631",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60-cm-beyaz-3664.jpg?v=1747804631",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60-cm-beyaz-3665.jpg?v=1747804631",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60-cm-beyaz-3666.jpg?v=1747221396",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60-cm-beyaz-3667.jpg?v=1747221400",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60-cm-beyaz-3668.jpg?v=1747221402",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60-cm-beyaz-3669.jpg?v=1747221405",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/ultra-dikdortgen-canak-lavabo-60-cm-beyaz-3670.png?v=1747221408"
    ],
    "price": "7785.00",
    "sku": "UL060-00CB00E-0000",
    "tags": [
      "Dikdörtgen",
      "Lavabo",
      "Mat Beyaz",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "Tezgahüstü",
      "Ultra İnce",
      "Vitrifiye",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843269914921,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "UL060-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7785.00",
        "grams": 0,
        "compare_at_price": "10380.00",
        "position": 1,
        "product_id": 8531388530985,
        "created_at": "2026-03-17T13:12:46+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p> </p>\n<div class=\"flex-1 overflow-hidden\" data-mce-fragment=\"1\">\n<div class=\"react-scroll-to-bottom--css-ezbmi-79elbk h-full dark:bg-gray-800\" data-mce-fragment=\"1\">\n<div class=\"react-scroll-to-bottom--css-ezbmi-1n7m0yu\" data-mce-fragment=\"1\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\" data-mce-fragment=\"1\">\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-mce-fragment=\"1\">\n<div class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\" data-mce-fragment=\"1\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\" data-mce-fragment=\"1\">\n<div class=\"flex flex-grow flex-col gap-3\" data-mce-fragment=\"1\">\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\" data-mce-fragment=\"1\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\n<p data-mce-fragment=\"1\">Minimalizmin Şıklığı: Ultra İnce Dikdörtgen Çanak Lavabo! </p>\n<p data-mce-fragment=\"1\">Banyo dekorasyonunuzu modern ve zarif bir şekilde tamamlamak isteyenlere, Creavit Ultra İnce Dikdörtgen Çanak Lavabo sizin için mükemmel bir seçenektir. Bu özel tasarım lavabo, minimalizmi şıklıkla buluşturan zarif çizgileri ve ince yapısıyla dikkat çekiyor.</p>\nModern ve Zarif Tasarım:<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> Dikdörtgen şekli ve ultra ince yapısıyla lavabo, banyonuza modern bir estetik katarken aynı zamanda şıklığı da vurgular.</span><br>Yer Tasarrufu:<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> İnce ve kompakt yapısı sayesinde banyo alanınızda yer tasarrufu sağlar, özellikle daha küçük banyolarda ideal bir seçenektir.</span><br>Dayanıklı Malzeme:<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> Kaliteli malzemelerden üretilen lavabo, uzun ömürlü kullanım sağlar ve dayanıklılık sunar.</span><br>Kolay Temizlik:<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> Pürüzsüz yüzeyi sayesinde temizliği kolaydır ve banyo hijyenini ön planda tutar.</span><br>Estetik ve Fonksiyonellik:<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> Hem görünümü hem de işlevselliği ile dikkat çeken bu lavabo, banyo deneyiminizi daha rahat ve keyifli hale getirir.</span><br>Kişiselleştirme:<span style=\"font-family: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif; font-size: 0.875rem;\"> Farklı tarz ve renkteki musluklarla kombinleyerek lavabonuzu kişisel zevkinize uygun hale getirebilirsiniz.</span>\n<p data-mce-fragment=\"1\">Ultra İnce Dikdörtgen Çanak Lavabo ile banyonuzda minimalist bir dokunuş ve şıklık yakalayın! Estetik ve pratikliği bir araya getiren bu lavabo ile banyo anlarınızı daha keyifli hale getirin!</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8528266101033",
    "brand": "Creavit",
    "title": "Avangart Banyo Armatürü Altın",
    "category": "Banyo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/avangart-banyo-armaturu-altin-3659.png?v=1747221369",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/avangart-banyo-armaturu-altin-3659.png?v=1747221369",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/avangart-banyo-armaturu-altin-3660.jpg?v=1747221372",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/avangart-banyo-armaturu-altin-3661.jpg?v=1747221376"
    ],
    "price": "7452.00",
    "sku": "BT.AG2500G",
    "tags": [
      "altın",
      "Armatür",
      "avangart",
      "Banyo",
      "banyo armatürü",
      "kireç temizleme",
      "Pirinç",
      "sessiz su akışı",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52836709630249,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.AG2500G",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "7452.00",
        "grams": 0,
        "compare_at_price": "12420.00",
        "position": 1,
        "product_id": 8528266101033,
        "created_at": "2026-03-15T21:26:09+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p>Creavit Avangart serisinin <strong>BT.AG2500G</strong> modeli, banyo dekorasyonunda modern ve şık bir atmosfer yaratmak isteyenler için ideal bir tercihtir. Aşağıda, bu ürünün tüm teknik özelliklerini ve detaylarını bulabilirsiniz.</p>\n<hr>\n<h3>Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Model Kodu:</strong> BT.AG2500G</li>\n<li>\n<strong>Seri:</strong> Avangart</li>\n<li>\n<strong>Malzeme:</strong> %100 pirinç</li>\n<li>\n<strong>Kaplama:</strong> Krom</li>\n<li>\n<strong>Armatür Tipi:</strong> Tek kumandalı miks armatür</li>\n<li>\n<strong>Montaj Tipi:</strong> Yatay düzlem (duvara montaj)</li>\n<li>\n<strong>Kartuş:</strong> Uzun ömürlü 35 mm seramik ayaklı kartuş</li>\n<li>\n<strong>Su Akış Debisi:</strong> 7–8 litre/dakika</li>\n<li>\n<strong>Çıkış Ucu Uzunluğu:</strong> 180,9 mm</li>\n<li>\n<strong>Su Giriş Sayısı:</strong> 2 giriş</li>\n<li>\n<strong>Bağlantı Deliği:</strong> 2 delikli</li>\n<li>\n<strong>Perlatör:</strong> Kolay değiştirilebilir, kireç temizleme sistemli, sessiz su akışı sağlayan perlatör</li>\n<li>\n<strong>Garanti Süresi:</strong> 5 yıl</li>\n<li>\n<strong>Renk Seçenekleri:</strong> Gold</li>\n</ul>\n<hr>\n<h3>Öne Çıkan Özellikler</h3>\n<ul>\n<li>\n<strong>Krom Kaplama:</strong> Modern ve parlak görünüm sağlar, uzun ömürlüdür.</li>\n<li>\n<strong>Kireç Temizleme Sistemi:</strong> Su akışını engelleyen kireç birikintilerini önler.</li>\n<li>\n<strong>Seramik Kartuş:</strong> Sıcaklık ve su debisi ayarlarını hassas bir şekilde yapar, uzun ömürlüdür.</li>\n<li>\n<strong>Kolay Montaj:</strong> Tezgah üstü montaj ile pratik kurulum imkanı sunar.</li>\n</ul>\n<hr>\n<h3>Paket İçeriği</h3>\n<ul>\n<li>Batarya: Creavit AG2500G Avangart Lüx Gold Banyo Bataryası.</li>\n<li>Montaj Aparatları: Montaj için gerekli tüm aparat ve bağlantı elemanları.</li>\n<li>Kullanım Kılavuzu: Kurulum ve bakım talimatlarını içeren kılavuz.</li>\n</ul>\n<hr>\n<p>Creavit AG2500G Avangart Lüx Gold Banyo Bataryası, şıklığı, dayanıklılığı ve fonksiyonelliğiyle banyonuzda modern bir atmosfer yaratmak isteyenler için ideal bir tercihtir. Krom kaplama ve kireç temizleme sistemi gibi özellikleri sayesinde uzun ömürlü ve kullanıcı dostudur. Fiyat-performans açısından da tatmin edici bir üründür.</p>"
  },
  {
    "id": "creavit-8527629320489",
    "brand": "Creavit",
    "title": "Giza Lavabo Armatürü Krom 3 Delikli Sifonlu",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/giza-lavabo-armaturu-krom-3-delikli-sifonlu-3634.png?v=1747221262",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/giza-lavabo-armaturu-krom-3-delikli-sifonlu-3634.png?v=1747221262",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/giza-lavabo-armaturu-krom-3-delikli-sifonlu-3637.jpg?v=1747221265",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/giza-lavabo-armaturu-krom-3-delikli-sifonlu-3635.jpg?v=1747221270",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/giza-lavabo-armaturu-krom-3-delikli-sifonlu-3636.jpg?v=1747221272"
    ],
    "price": "11655.00",
    "sku": "BT.GZ1503",
    "tags": [
      "Armatür",
      "Giza",
      "kireç temizleme",
      "Krom",
      "Lavabo Armatürü",
      "Pirinç",
      "pop-up sifon",
      "sessiz su akışı",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843223646505,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.GZ1503",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11655.00",
        "grams": 0,
        "compare_at_price": "15540.00",
        "position": 1,
        "product_id": 8527629320489,
        "created_at": "2026-03-17T12:57:28+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p>Giza Lavabo Armatürü ayrı sıcak ve soğuk su kolları ile su akışını ve sıcaklığını hassas bir şekilde kontrol edebilme imkanı sunar. Orta kısmında yer alan lavabo musluğu ile banyonuzda estetiği ve işlevselliği bir arada yaşayacaksınız. Entegre Pop-up taşmalı sifon sistemi suyun aşırı dolması durumunda taşmayı önler. Tek bir dokunuşla kolayca açılıp kapanabilen bu sistem lavabo kullanımınızı daha konforlu ve güvenli hale getirir. Creavit armatürleri, gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>"
  },
  {
    "id": "creavit-8527593341225",
    "brand": "Creavit",
    "title": "Giza Lavabo Armatürü Altın 3 Delikli sifonlu",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/giza-lavabo-armaturu-altin-3-delikli-sifonlu-3630.png?v=1747237865",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/giza-lavabo-armaturu-altin-3-delikli-sifonlu-3630.png?v=1747237865",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/giza-lavabo-armaturu-altin-3-delikli-sifonlu-3633.jpg?v=1747237867",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/giza-lavabo-armaturu-altin-3-delikli-sifonlu-3631.jpg?v=1747237870",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/giza-lavabo-armaturu-altin-3-delikli-sifonlu-3632.jpg?v=1747237873"
    ],
    "price": "11340.00",
    "sku": "BT.GZ1503G",
    "tags": [
      "altın",
      "Armatür",
      "Giza",
      "kireç temizleme",
      "Lavabo Armatürü",
      "Pirinç",
      "pop-up sifon",
      "sessiz su akışı",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843223515433,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.GZ1503G",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "11340.00",
        "grams": 0,
        "compare_at_price": "15120.00",
        "position": 1,
        "product_id": 8527593341225,
        "created_at": "2026-03-17T12:57:25+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-vfjev-79elbk h-full dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-vfjev-1n7m0yu\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-col text-sm dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"group w-full text-gray-800 dark:text-gray-100 border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-mce-fragment=\"1\">\r\n<div class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\" data-mce-fragment=\"1\">\r\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-grow flex-col gap-3\" data-mce-fragment=\"1\">\r\n<div class=\"min-h-[20px] flex items-start overflow-x-auto whitespace-pre-wrap break-words\" data-mce-fragment=\"1\">\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<div class=\"flex-1 overflow-hidden\">\r\n<div class=\"react-scroll-to-bottom--css-eehor-79elbk h-full dark:bg-gray-800\">\r\n<div class=\"react-scroll-to-bottom--css-eehor-1n7m0yu\">\r\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\r\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\">\r\n<div class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\">\r\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\r\n<div class=\"flex flex-grow flex-col gap-3\">\r\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\r\n<div class=\"flex-1 overflow-hidden\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-ltlgb-79elbk h-full dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-ltlgb-1n7m0yu\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-col text-sm dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-mce-fragment=\"1\">\r\n<div class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\" data-mce-fragment=\"1\">\r\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-grow flex-col gap-3\" data-mce-fragment=\"1\">\r\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\" data-mce-fragment=\"1\">\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p>Giza Lavabo Armatürü ayrı sıcak ve soğuk su kolları ile su akışını ve sıcaklığını hassas bir şekilde kontrol edebilme imkanı sunar. Orta kısmında yer alan lavabo musluğu ile banyonuzda estetiği ve işlevselliği bir arada yaşayacaksınız. Entegre Pop-up taşmalı sifon sistemi suyun aşırı dolması durumunda taşmayı önler. Tek bir dokunuşla kolayca açılıp kapanabilen bu sistem lavabo kullanımınızı daha konforlu ve güvenli hale getirir. Creavit armatürleri, gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8527550611753",
    "brand": "Creavit",
    "title": "Faye Mutfak Armatürü Krom",
    "category": "Mutfak Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/faye-mutfak-armaturu-krom-3628.png?v=1747221231",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/faye-mutfak-armaturu-krom-3628.png?v=1747221231",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/faye-mutfak-armaturu-krom-3629.jpg?v=1747221234"
    ],
    "price": "8370.00",
    "sku": "BT.FY8500",
    "tags": [
      "Armatür",
      "Faye",
      "krom",
      "mutfak",
      "Mutfak Armatürü",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843223384361,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.FY8500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8370.00",
        "grams": 0,
        "compare_at_price": "11160.00",
        "position": 1,
        "product_id": 8527550611753,
        "created_at": "2026-03-17T12:57:22+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p>Şıklığı ve işlevselliği bir araya getiren Faye Mutfak Armatürü mutfağınızda estetik bir atmosfer yaratırken aynı zamanda günlük kullanımlarınızda konfor sağlar. Faye Mutfak Armatürünün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizmasi, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle mutfak deneyiminiz daha keyifli hale gelecek. Ayrıca döner borulu yapısı bulaşık yıkarken ve lavabo temizliğinde kolaylık sağlar. Creavit armatürleri gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>"
  },
  {
    "id": "creavit-8527545925929",
    "brand": "Creavit",
    "title": "Sharp Lavabo Armatürü Siyah",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-lavabo-armaturu-siyah-3622.png?v=1747221209",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-lavabo-armaturu-siyah-3622.png?v=1747221209",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-lavabo-armaturu-siyah-3626.jpg?v=1747221211",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-lavabo-armaturu-siyah-3623.jpg?v=1747221214",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-lavabo-armaturu-siyah-3624.jpg?v=1747221218",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-lavabo-armaturu-siyah-3625.jpg?v=1747221221",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-lavabo-armaturu-siyah-3627.jpg?v=1747221224"
    ],
    "price": "7425.00",
    "sku": "BT.SR1500S",
    "tags": [
      "Armatür",
      "Lavabo Armatürü",
      "Pirinç",
      "sessiz su akışı",
      "Sharp",
      "siyah",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843258052905,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.SR1500S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7425.00",
        "grams": 0,
        "compare_at_price": "9900.00",
        "position": 1,
        "product_id": 8527545925929,
        "created_at": "2026-03-17T13:08:50+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p>Şıklığı ve işlevselliği bir araya getiren Sharp Lavabo Armatürü banyonuzda estetik bir atmosfer yaratırken aynı zamanda günlük kullanımlarınızda konfor sağlar. Sharp Lavabo Armatürü'nün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizması, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle banyo deneyiminiz daha keyifli hale gelecek. Creavit armatürleri, gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>"
  },
  {
    "id": "creavit-8527524823337",
    "brand": "Creavit",
    "title": "Sharp Banyo Armatürü Krom",
    "category": "Banyo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-banyo-armaturu-krom-3619.png?v=1747221194",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-banyo-armaturu-krom-3619.png?v=1747221194",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-banyo-armaturu-krom-3621.jpg?v=1747221196",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-banyo-armaturu-krom-3620.jpg?v=1747221198"
    ],
    "price": "7875.00",
    "sku": "BT.SR2510",
    "tags": [
      "Armatür",
      "Banyo",
      "banyo armatürü",
      "Pirinç",
      "sessiz su akışı",
      "Sharp",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843223253289,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.SR2510",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7875.00",
        "grams": 0,
        "compare_at_price": "10500.00",
        "position": 1,
        "product_id": 8527524823337,
        "created_at": "2026-03-17T12:57:19+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p>Şıklığı ve işlevselliği bir araya getiren Sharp Banyo Armatürü banyonuzda estetik bir atmosfer yaratırken aynı zamanda günlük kullanımlarınızda konfor sağlar. Sharp Banyo Armatürü'nün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizması, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle banyo deneyiminiz daha keyifli hale gelecek. Creavit armatürleri, gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>"
  },
  {
    "id": "creavit-8527493923113",
    "brand": "Creavit",
    "title": "Sharp Mutfak Armatürü Krom",
    "category": "Mutfak Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-mutfak-armaturu-krom-3615.png?v=1747221177",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-mutfak-armaturu-krom-3615.png?v=1747221177",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-mutfak-armaturu-krom-3617.jpg?v=1747221180",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-mutfak-armaturu-krom-3616.jpg?v=1747221183",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-mutfak-armaturu-krom-3618.jpg?v=1747221186"
    ],
    "price": "9315.00",
    "sku": "BT.SR8500",
    "tags": [
      "Armatür",
      "Krom",
      "mutfak",
      "Mutfak Armatürü",
      "Sharp",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843223122217,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.SR8500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9315.00",
        "grams": 0,
        "compare_at_price": "12420.00",
        "position": 1,
        "product_id": 8527493923113,
        "created_at": "2026-03-17T12:57:15+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p>İnce çizgileriyle armatüre farklı ve yenilikçi bir şekilde yaklaşan Sharp Armatür ailesi ile hijyen deneyiminiz estetikle birleşti. Sharp Mutfak Armatürünün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizmasi, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle mutfak deneyiminiz daha keyifli hale gelecek. Ayrıca döner borulu yapısı bulaşık yıkarken ve lavabo temizliğinde kolaylık sağlar. Creavit armatürleri gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>"
  },
  {
    "id": "creavit-8527386083625",
    "brand": "Creavit",
    "title": "Sharp Banyo Armatürü Mat Siyah",
    "category": "Banyo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-banyo-armaturu-mat-siyah-3612.png?v=1747234059",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-banyo-armaturu-mat-siyah-3612.png?v=1747234059",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-banyo-armaturu-mat-siyah-3614.jpg?v=1747234062",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/sharp-banyo-armaturu-mat-siyah-3613.jpg?v=1747234064"
    ],
    "price": "9270.00",
    "sku": "BT.SR2510S",
    "tags": [
      "Armatür",
      "Banyo",
      "banyo armatürü",
      "Mat Siyah",
      "Pirinç",
      "sessiz su akışı",
      "Sharp",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843257954601,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.SR2510S",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "9270.00",
        "grams": 0,
        "compare_at_price": "12360.00",
        "position": 1,
        "product_id": 8527386083625,
        "created_at": "2026-03-17T13:08:47+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p>Şıklığı ve işlevselliği bir araya getiren Sharp Banyo Armatürü banyonuzda estetik bir atmosfer yaratırken aynı zamanda günlük kullanımlarınızda konfor sağlar. Sharp Banyo Armatürü'nün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizması, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle banyo deneyiminiz daha keyifli hale gelecek. Creavit armatürleri, gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>"
  },
  {
    "id": "creavit-8527361540393",
    "brand": "Creavit",
    "title": "Solo Lavabo Armatürü Krom",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-lavabo-armaturu-krom-3607.png?v=1747221156",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-lavabo-armaturu-krom-3607.png?v=1747221156",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-lavabo-armaturu-krom-3610.jpg?v=1747221159",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-lavabo-armaturu-krom-3608.jpg?v=1747221163",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-lavabo-armaturu-krom-3609.jpg?v=1747221166",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-lavabo-armaturu-krom-3611.jpg?v=1747221169"
    ],
    "price": "4815.00",
    "sku": "BT.SO1500",
    "tags": [
      "Armatür",
      "Banyo",
      "Krom",
      "Lavabo Armatürü",
      "sessiz su akışı",
      "Solo",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52907154276649,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.SO1500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "4815.00",
        "grams": 0,
        "compare_at_price": "6420.00",
        "position": 1,
        "product_id": 8527361540393,
        "created_at": "2026-03-31T15:22:50+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p>İnce çizgileriyle armatüre farklı ve yenilikçi bir şekilde yaklaşan Solo Armatür serisi ile hijyen deneyiminiz estetikle birleşti. Şıklığı ve işlevselliği bir araya getiren Solo Lavabo Armatürü banyonuzda estetik bir atmosfer yaratırken aynı zamanda günlük kullanımlarınızda konfor sağlar. Solo Lavabo Armatürü'nün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizması, kolay su sıcaklık kontrolü ve su akış ayarı gibi özelliklerle banyo deneyiminiz daha keyifli hale gelecek. Creavit armatürleri, gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz. </p><!---->"
  },
  {
    "id": "creavit-8527345942825",
    "brand": "Creavit",
    "title": "Solo Banyo Armatürü Krom",
    "category": "Banyo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-banyo-armaturu-krom-3602.png?v=1747221135",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-banyo-armaturu-krom-3602.png?v=1747221135",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-banyo-armaturu-krom-3604.jpg?v=1747221139",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-banyo-armaturu-krom-3603.jpg?v=1747221143",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-banyo-armaturu-krom-3605.jpg?v=1747221145",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-banyo-armaturu-krom-3606.jpg?v=1747221148"
    ],
    "price": "5535.00",
    "sku": "BT.SO2500",
    "tags": [
      "Armatür",
      "Banyo",
      "banyo armatürü",
      "Krom",
      "sessiz su akışı",
      "Solo",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52907154145577,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.SO2500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5535.00",
        "grams": 0,
        "compare_at_price": "7380.00",
        "position": 1,
        "product_id": 8527345942825,
        "created_at": "2026-03-31T15:22:47+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p>İnce çizgileriyle armatüre farklı ve yenilikçi bir şekilde yaklaşan Solo Armatür serisi ile hijyen deneyiminiz estetikle birleşti. Şıklığı ve işlevselliği bir araya getiren Solo Banyo Armatürü banyonuzda estetik bir atmosfer yaratırken aynı zamanda günlük kullanımlarınızda konfor sağlar. Solo Banyo Armatürü'nün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizması, kolay su sıcaklık kontrolü ve su akış ayarı gibi özelliklerle banyo deneyiminiz daha keyifli hale gelecek. Creavit armatürleri, gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz. </p>\r\n<p><br></p><!---->"
  },
  {
    "id": "creavit-8527310553385",
    "brand": "Creavit",
    "title": "Solo Mutfak Armatürü Krom",
    "category": "Mutfak Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-mutfak-armaturu-krom-3599.png?v=1747221120",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-mutfak-armaturu-krom-3599.png?v=1747221120",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-mutfak-armaturu-krom-3601.jpg?v=1747221123",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/solo-mutfak-armaturu-krom-3600.jpg?v=1747221125"
    ],
    "price": "4905.00",
    "sku": "BT.SO8500",
    "tags": [
      "Armatür",
      "krom",
      "mutfak",
      "Mutfak Armatürü",
      "Solo",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52907153981737,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.SO8500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "4905.00",
        "grams": 0,
        "compare_at_price": "6540.00",
        "position": 1,
        "product_id": 8527310553385,
        "created_at": "2026-03-31T15:22:44+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p>Modern çizgileriyle armatüre farklı ve yenilikçi bir şekilde yaklaşan Solo Armatür ailesi ile hijyen deneyiminiz estetikle birleşti. Solo Mutfak Armatürünün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizmasi, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle mutfak deneyiminiz daha keyifli hale gelecek. Ayrıca döner borulu yapısı bulaşık yıkarken ve lavabo temizliğinde kolaylık sağlar. Creavit armatürleri gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>"
  },
  {
    "id": "creavit-8525139280169",
    "brand": "Creavit",
    "title": "Liva Banyo Armatürü",
    "category": "Banyo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/28.png?v=1756900186",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/28.png?v=1756900186",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/29.png?v=1756900186"
    ],
    "price": "4050.00",
    "sku": "BT.LV2500",
    "tags": [
      "Armatür",
      "Banyo",
      "Krom",
      "Liva",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843235868969,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.LV2500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "4050.00",
        "grams": 0,
        "compare_at_price": "5400.00",
        "position": 1,
        "product_id": 8525139280169,
        "created_at": "2026-03-17T13:02:01+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p>Şıklığı ve işlevselliği bir araya getiren Liva Banyo Armatürü banyonuzda estetik bir atmosfer yaratırken aynı zamanda günlük kullanımlarınızda konfor sağlar. Liva Banyo Armatürü'nün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizmasi, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle banyo deneyiminiz daha keyifli hale gelecek. Creavit armatürleri, gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p><!---->"
  },
  {
    "id": "creavit-8525088031017",
    "brand": "Creavit",
    "title": "Fotoselli Lavabo Armatürü Çift Su Girişli AC/DC",
    "category": "Fotoselli Armatürler",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/fotoselli-lavabo-armaturu-cift-su-girisli-ac-dc-3595.png?v=1747221100",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/fotoselli-lavabo-armaturu-cift-su-girisli-ac-dc-3595.png?v=1747221100",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/fotoselli-lavabo-armaturu-cift-su-girisli-ac-dc-3596.jpg?v=1747984018",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/fotoselli-lavabo-armaturu-cift-su-girisli-ac-dc-3597.jpg?v=1747984018"
    ],
    "price": "20925.00",
    "sku": "BT.ES2210",
    "tags": [
      "Armatür",
      "Banyo",
      "Fotoselli armatür",
      "Krom",
      "Lavabo Armatürü",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843222991145,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.ES2210",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "20925.00",
        "grams": 0,
        "compare_at_price": "27900.00",
        "position": 1,
        "product_id": 8525088031017,
        "created_at": "2026-03-17T12:57:12+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"product-description\">\n<p>Creavit BT.ES2210, modern teknoloji ve dayanıklılığı bir araya getiren fotoselli lavabo bataryasıdır. Hijyen ve su tasarrufu sağlamak amacıyla tasarlanmış, otomatik su açma-kapama özelliği sayesinde kullanıcı konforunu artırır. Özellikle kamu alanları, hastaneler, restoranlar ve iş yerleri için ideal bir üründür.</p>\n<hr>\n<h3>🛠️ Teknik Özellikler</h3>\n<ul>\n<li>\n<strong>Model Kodu:</strong> BT.ES2210</li>\n<li>\n<strong>Seri:</strong> ES (Elektronik Sensörlü)</li>\n<li>\n<strong>Malzeme:</strong> %100 pirinç gövde, dayanıklı ve korozyona karşı dirençli</li>\n<li>\n<strong>Kaplama:</strong> Parlak krom kaplama</li>\n<li>\n<strong>Renk:</strong> Krom</li>\n<li>\n<strong>Armatür Tipi:</strong> Fotoselli (sensörlü) lavabo bataryası</li>\n<li>\n<strong>Montaj Tipi:</strong> Tezgah üstü montaj</li>\n<li>\n<strong>Sensör Tipi:</strong> Kızılötesi sensör (IR)</li>\n<li>\n<strong>Sensör Algılama Mesafesi:</strong> Ayarlanabilir, genellikle 10-15 cm arası</li>\n<li>\n<strong>Kartuş:</strong> Elektronik kontrollü valf (su akışını kontrol eden manyetik valf)</li>\n<li>\n<strong>Su Akış Debisi:</strong> Ortalama 6-8 litre/dakika (sensörle optimize edilmiş)</li>\n<li>\n<strong>Çalışma Gerilimi:</strong> 6V - 12V (genellikle 4 adet AAA pil veya adaptörle beslenir)</li>\n<li>\n<strong>Güç Kaynağı:</strong> Pilli veya adaptörlü (seçeneklere bağlı)</li>\n<li>\n<strong>Çıkış Ucu Uzunluğu:</strong> 114 mm</li>\n<li>\n<strong>Çıkış Ucu Yüksekliği:</strong> 147 mm</li>\n<li>\n<strong>Açma-Kapama Mekanizması:</strong> Otomatik, sensör algılandığında su açılır, algılanmadığında otomatik kapanır</li>\n<li>\n<strong>Su Girişi:</strong> Sıcak ve soğuk su bağlantısı için çift giriş</li>\n<li>\n<strong>Su Tasarrufu:</strong> Var, sensör sayesinde gereksiz su akışı engellenir</li>\n<li>\n<strong>Su Sıcaklığı:</strong> Sıcak-soğuk karışımı manuel kontrol (tezgah üzerindeki kumanda ile)</li>\n<li>\n<strong>Garanti Süresi:</strong> 2 yıl</li>\n</ul>\n<hr>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>Hijyenik Kullanım: Fotoselli sistem sayesinde musluğa elle dokunmaya gerek kalmaz, bu da çapraz bulaş riskini azaltır.</li>\n<li>Otomatik Açma-Kapama: Sensör sayesinde kullanıcı lavabo önüne geldiğinde su otomatik açılır, ayrıldığında ise otomatik kapanır.</li>\n<li>Ayarlanabilir Sensör Mesafesi: Farklı lavabo ve kullanım alanlarına uygun algılama mesafesi kolayca ayarlanabilir.</li>\n<li>Uzun Pil Ömrü: Düşük güç tüketimi ile uzun süre pil değişimi gerektirmez.</li>\n<li>Su Tasarrufu Sağlar: Gereksiz su akışlarını engeller, ekonomik ve çevre dostudur.</li>\n<li>Dayanıklı ve Estetik Tasarım: Pirinç gövde ve krom kaplama ile uzun ömürlü ve şık görünüm.</li>\n<li>Kolay Montaj: Standart tezgah üstü montaj sistemi sayesinde hızlı ve pratik kurulum.</li>\n<li>Sensör Sistemi Arızasında Manuel Kullanım: Bazı modellerde pil bittiğinde veya sensör arızalandığında manuel olarak da kullanılabilir (model varyasyonuna bağlı).</li>\n</ul>\n<hr>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>Creavit BT.ES2210 Fotoselli Lavabo Armatürü</li>\n<li>Montaj için bağlantı aparatları ve vidalar</li>\n<li>Elektronik valf ve sensör ünitesi</li>\n<li>4 adet AAA kalem pil veya adaptör (model seçeneğine bağlı)</li>\n<li>3/8\" fleks hortumlar (standart uzunlukta)</li>\n<li>Kullanım, montaj ve bakım kılavuzu</li>\n</ul>\n<hr>\n<h3>🏷️ Kullanım Alanları</h3>\n<ul>\n<li>Kamu binaları, ofisler, hastaneler, okul ve kurum lavaboları</li>\n<li>Restoran ve kafelerde hijyen ve su tasarrufu amaçlı kullanım</li>\n<li>Modern konut banyolarında pratik ve temiz kullanım isteyenler</li>\n<li>Spor salonları, alışveriş merkezleri gibi yoğun kullanımlı alanlar</li>\n</ul>\n<hr>\n<p>Creavit BT.ES2210 Fotoselli Lavabo Armatürü, hijyen, su tasarrufu ve konforu en üst düzeye çıkaran gelişmiş bir musluk sistemidir. Kullanıcıların musluğa dokunmadan suyu kullanabilmelerini sağlar, böylece çapraz bulaş riskini azaltır ve gereksiz su tüketimini engeller. Sağlam pirinç yapısı ve estetik krom kaplamasıyla uzun ömürlüdür. Otomatik sensör ayarları kolayca yapılabilir, pil veya adaptör ile çalışabilir.</p>\n</div>"
  },
  {
    "id": "creavit-8509537911081",
    "brand": "Creavit",
    "title": "Infinity Banyo Armatürü",
    "category": "Banyo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/infinity-banyo-armaturu-3592.png?v=1747805721",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/infinity-banyo-armaturu-3592.png?v=1747805721",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/infinity-banyo-armaturu-3594.jpg?v=1747805721",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/infinity-banyo-armaturu-3593.jpg?v=1747805721"
    ],
    "price": "36180.00",
    "sku": "BT.IF2500",
    "tags": [
      "Armatür",
      "Banyo",
      "banyo armatürü",
      "Infinity",
      "Krom",
      "Pirinç",
      "sessiz su akışı",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843222860073,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.IF2500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "36180.00",
        "grams": 0,
        "compare_at_price": "48240.00",
        "position": 1,
        "product_id": 8509537911081,
        "created_at": "2026-03-17T12:57:09+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-vfjev-79elbk h-full dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-vfjev-1n7m0yu\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-col text-sm dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"group w-full text-gray-800 dark:text-gray-100 border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-mce-fragment=\"1\">\r\n<div class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\" data-mce-fragment=\"1\">\r\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-grow flex-col gap-3\" data-mce-fragment=\"1\">\r\n<div class=\"min-h-[20px] flex items-start overflow-x-auto whitespace-pre-wrap break-words\" data-mce-fragment=\"1\">\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<div class=\"flex-1 overflow-hidden\">\r\n<div class=\"react-scroll-to-bottom--css-eehor-79elbk h-full dark:bg-gray-800\">\r\n<div class=\"react-scroll-to-bottom--css-eehor-1n7m0yu\">\r\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\r\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\">\r\n<div class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\">\r\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">Şıklığı ve işlevselliği bir araya getiren Infinity Banyo Armatürü banyonuzda estetik bir atmosfer yaratırken aynı zamanda günlük kullanımlarınızda konfor sağlar. Infinity Banyo Armatürü'nün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizması, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle banyo deneyiminiz daha keyifli hale gelecek. Creavit armatürleri, gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8509379805481",
    "brand": "Creavit",
    "title": "Infinity Lavabo Armatürü Krom",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/infinity-lavabo-armaturu-krom-3588.png?v=1747805726",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/infinity-lavabo-armaturu-krom-3588.png?v=1747805726",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/infinity-lavabo-armaturu-krom-3591.jpg?v=1747805726",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/infinity-lavabo-armaturu-krom-3589.jpg?v=1747805726",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/infinity-lavabo-armaturu-krom-3590.jpg?v=1747805726"
    ],
    "price": "15795.00",
    "sku": "BT.IF1500",
    "tags": [
      "Armatür",
      "Infinity",
      "Krom",
      "Lavabo Armatürü",
      "Pirinç",
      "sessiz su akışı",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843222761769,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.IF1500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "15795.00",
        "grams": 0,
        "compare_at_price": "21060.00",
        "position": 1,
        "product_id": 8509379805481,
        "created_at": "2026-03-17T12:57:06+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-vfjev-79elbk h-full dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"react-scroll-to-bottom--css-vfjev-1n7m0yu\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-col text-sm dark:bg-gray-800\" data-mce-fragment=\"1\">\r\n<div class=\"group w-full text-gray-800 dark:text-gray-100 border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\" data-mce-fragment=\"1\">\r\n<div class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\" data-mce-fragment=\"1\">\r\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\" data-mce-fragment=\"1\">\r\n<div class=\"flex flex-grow flex-col gap-3\" data-mce-fragment=\"1\">\r\n<div class=\"min-h-[20px] flex items-start overflow-x-auto whitespace-pre-wrap break-words\" data-mce-fragment=\"1\">\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<div class=\"flex-1 overflow-hidden\">\r\n<div class=\"react-scroll-to-bottom--css-eehor-79elbk h-full dark:bg-gray-800\">\r\n<div class=\"react-scroll-to-bottom--css-eehor-1n7m0yu\">\r\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\r\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\">\r\n<div class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\">\r\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\r\n<div class=\"flex flex-grow flex-col gap-3\">\r\n<div class=\"min-h-[20px] flex flex-col items-start gap-3 overflow-x-auto whitespace-pre-wrap break-words\">\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\r\n<div class=\"flex-1 overflow-hidden\">\r\n<div class=\"react-scroll-to-bottom--css-eehor-79elbk h-full dark:bg-gray-800\">\r\n<div class=\"react-scroll-to-bottom--css-eehor-1n7m0yu\">\r\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\r\n<div class=\"group w-full text-token-text-primary border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\">\r\n<div class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\">\r\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">Şıklığı ve işlevselliği bir araya getiren Infinity Lavabo Armatürü banyonuzda estetik bir atmosfer yaratırken aynı zamanda günlük kullanımlarınızda konfor sağlar. Infinity Lavabo Armatürü'nün pratik kullanıma olanak veren tasarımı sayesinde; kolay açma-kapama mekanizmasi, dengeli su sıcaklık kontrolü ve sessiz su akışı gibi özelliklerle banyo deneyiminiz daha keyifli hale gelecek. Creavit armatürleri, gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8475194261801",
    "brand": "Creavit",
    "title": "Bevel Mutfak Armatürü Krom",
    "category": "Mutfak Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bevel-mutfak-armaturu-krom-3581.png?v=1746724640",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bevel-mutfak-armaturu-krom-3581.png?v=1746724640",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bevel-mutfak-armaturu-krom-3583.jpg?v=1746724647",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bevel-mutfak-armaturu-krom-3582.jpg?v=1746724651",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bevel-mutfak-armaturu-krom-3584.jpg?v=1747235025"
    ],
    "price": "5400.00",
    "sku": "BT.BV8500",
    "tags": [
      "Armatür",
      "krom",
      "mutfak",
      "Mutfak Armatürü",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843270340905,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.BV8500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5400.00",
        "grams": 0,
        "compare_at_price": "7200.00",
        "position": 1,
        "product_id": 8475194261801,
        "created_at": "2026-03-17T13:12:56+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<section class=\"product-details\">\n<h2>🛠️ Teknik Özellikler</h2>\n<ul>\n<li>\n<strong>Model Kodu:</strong> BT.BV8500</li>\n<li>\n<strong>Seri:</strong> Bevel</li>\n<li>\n<strong>Malzeme:</strong> %100 pirinç gövde</li>\n<li>\n<strong>Kaplama:</strong> Parlak krom kaplama</li>\n<li>\n<strong>Renk Seçenekleri:</strong> Parlak Krom</li>\n<li>\n<strong>Armatür Tipi:</strong> Tek kumandalı miks mutfak bataryası</li>\n<li>\n<strong>Montaj Tipi:</strong> Tezgah üstü montaj</li>\n<li>\n<strong>Kartuş:</strong> 35 mm seramik kartuş</li>\n<li>\n<strong>Su Akış Debisi:</strong> Ortalama 7-8 litre/dakika </li>\n<li>\n<strong>Çıkış Ucu Uzunluğu:</strong> 185 mm</li>\n<li>\n<strong>Çıkış Ucu Yüksekliği:</strong> 270 mm</li>\n<li>\n<strong>Boru Tipi:</strong> Döner borulu</li>\n<li>\n<strong>Perlatör:</strong> Kireç önleyici, sessiz ve homojen su akışı sağlayan, kolay sökülebilir ve temizlenebilir</li>\n<li>\n<strong>Açma-Kapama Mekanizması:</strong> Tek kumandalı ergonomik kol</li>\n<li>\n<strong>Su Girişi:</strong> Çift girişli</li>\n<li>\n<strong>Garanti Süresi:</strong> 5 yıl</li>\n</ul>\n<h3>💡 Öne Çıkan Özellikler</h3>\n<ul>\n<li>Modern ve Fonksiyonel Tasarım: Bevel serisinin karakteristik şık, minimalist ve ergonomik çizgileri ile mutfağınıza çağdaş bir estetik katar.</li>\n<li>Dayanıklı Malzeme Yapısı: %100 pirinç gövde uzun süreli dayanıklılık ve korozyona karşı yüksek direnç sunar.</li>\n<li>Hassas Seramik Kartuş Teknolojisi: Su sıcaklığı ve debisini sızdırmaz şekilde hassas kontrol etmenizi sağlar, uzun ömürlüdür.</li>\n<li>Kireç Önleyici Perlatör: Su akışını temiz, sessiz ve pürüzsüz hale getirir; perlatör kireç tutmaması için kolay temizlenebilir.</li>\n<li>Kolay Montaj: Standart tezgah üstü montaj sistemi ile hızlı ve sorunsuz kurulum.</li>\n<li>Ergonomik Kullanım: Tek kumandalı kol, suyu açıp kapamada ve sıcaklık ayarında büyük kolaylık sağlar.</li>\n</ul>\n<h3>📦 Paket İçeriği</h3>\n<ul>\n<li>Creavit BT.BV8500 Bevel Mutfak Armatürü</li>\n<li>Montaj için gerekli bağlantı aparatı ve vidalar</li>\n<li>3/8\" fleks hortumlar (50 cm uzunlukta)</li>\n<li>Kullanım, montaj ve bakım kılavuzu</li>\n</ul>\n<h3>🏷️ Kullanım Alanları</h3>\n<ul>\n<li>Ev mutfakları</li>\n<li>Profesyonel restoran, kafe ve ticari mutfaklar</li>\n<li>Modern, minimalist ve şık mutfak dekorasyonları</li>\n</ul>\n<h3><br></h3>\n<p>Creavit BT.BV8500 Bevel Mutfak Armatürü, dayanıklı malzemeleri ve ergonomik tasarımıyla uzun yıllar boyunca sorunsuz kullanım sağlar. Kireç önleyici perlatör ve döner boru ile mutfağınızda maksimum konfor ve fonksiyonellik sunar.</p>\n</section>"
  },
  {
    "id": "creavit-8475123122473",
    "brand": "Creavit",
    "title": "Bevel Banyo Armatürü Krom",
    "category": "Banyo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bevel-banyo-armaturu-krom-3577.png?v=1747221036",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bevel-banyo-armaturu-krom-3577.png?v=1747221036",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bevel-banyo-armaturu-krom-3578.jpg?v=1747922561",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bevel-banyo-armaturu-krom-3580.jpg?v=1747922563",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bevel-banyo-armaturu-krom-3579.jpg?v=1747922563"
    ],
    "price": "6300.00",
    "sku": "BT.BV2500",
    "tags": [
      "Armatür",
      "Banyo",
      "banyo armatürü",
      "Bevel",
      "Krom",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843222630697,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.BV2500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6300.00",
        "grams": 0,
        "compare_at_price": "8400.00",
        "position": 1,
        "product_id": 8475123122473,
        "created_at": "2026-03-17T12:57:03+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<h2>🛠️ Teknik Özellikler</h2>\n<ul>\n<li>\n<strong>Model Kodu:</strong> BT.BV2500</li>\n<li>\n<strong>Seri:</strong> Bevel</li>\n<li>\n<strong>Malzeme:</strong> %100 pirinç gövde</li>\n<li>\n<strong>Kaplama:</strong> Parlak krom kaplama</li>\n<li>\n<strong>Renk Seçenekleri:</strong> Krom</li>\n<li>\n<strong>Armatür Tipi:</strong> Tek kumandalı miks lavabo bataryası</li>\n<li>\n<strong>Montaj Tipi:</strong> Duvara Montaj</li>\n<li>\n<strong>Kartuş:</strong> 35 mm seramik kartuş</li>\n<li>\n<strong>Su Akış Debisi:</strong> Ortalama 7-8 litre/dakika</li>\n<li>\n<strong>Çıkış Ucu Uzunluğu:</strong> 136 mm</li>\n<li>\n<strong>Boru Tipi:</strong> Sabit (dönmeyen)</li>\n<li>\n<strong>Kilitlemeli Yönlendirici:</strong> Var</li>\n<li>\n<strong>Su Girişi:</strong> Çift girişli (sıcak ve soğuk su bağlantısı için)</li>\n<li>\n<strong>360° Döner Boru:</strong> Yok</li>\n<li>\n<strong>Açma-Kapama Mekanizması:</strong> Tek kumandalı kol</li>\n<li>\n<strong>Garanti Süresi:</strong> 5 yıl</li>\n</ul>\n<hr>\n<h2>💡 Öne Çıkan Özellikler</h2>\n<ul>\n<li>Modern ve Zarif Tasarım: Minimalist ve şık çizgileri ile her tarz banyoya uyum sağlar.</li>\n<li>Dayanıklı ve Sağlam Gövde: %100 pirinçten üretilmiş olup korozyon ve mekanik darbelere karşı dayanıklıdır.</li>\n<li>Yüksek Hassasiyetli Seramik Kartuş: Sıcaklık ve su debisi ayarını kolay ve sızdırmaz şekilde yapmanıza olanak verir.</li>\n<li>Kireç Önleyici Perlatör Teknolojisi: Su akışını temiz, sessiz ve pürüzsüz tutar, kireç birikimini önler ve bakım ihtiyacını azaltır.</li>\n<li>Kolay Montaj: Duvara montaj sistemi sayesinde hızlı ve pratik kurulum yapılabilir.</li>\n<li>Ergonomik Kullanım: Tek kol kumanda mekanizması sayesinde suyu rahat açıp kapatabilir, sıcaklığı kolayca ayarlayabilirsiniz.</li>\n</ul>\n<hr>\n<h2>📦 Paket İçeriği</h2>\n<ul>\n<li>Creavit BT.BV2500 Bevel Banyo Bataryası</li>\n<li>Montaj için gerekli bağlantı aparatları, vidalar</li>\n<li>3/8\" fleks bağlantı hortumları (50 cm uzunlukta)</li>\n<li>Kurulum ve bakım kılavuzu</li>\n</ul>\n<hr>\n<h2>🏷️ Kullanım Alanları</h2>\n<ul>\n<li>Ev banyoları</li>\n<li>Otel, restoran ve ticari banyolar</li>\n<li>Ofis ve ticari alanlar</li>\n<li>Modern ve klasik banyolara uyum sağlayan şık tasarım</li>\n</ul>\n<hr>\n<p>Creavit BT.BV2500 Bevel Banyo bataryası, yüksek kaliteli malzemeleri ve gelişmiş seramik kartuş teknolojisi ile uzun ömürlü, kullanıcı dostu ve estetik bir ürün olarak banyonuza değer katar. Kireç önleyici perlatör ve ergonomik tasarımıyla konforlu ve sorunsuz su kullanımı sağlar.</p>"
  },
  {
    "id": "creavit-8475109785897",
    "brand": "Creavit",
    "title": "Bevel Lavabo Armatürü Krom",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bevel-lavabo-armaturu-krom-3573.png?v=1747221014",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bevel-lavabo-armaturu-krom-3573.png?v=1747221014",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bevel-lavabo-armaturu-krom-3576.jpg?v=1747221018",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bevel-lavabo-armaturu-krom-3574.jpg?v=1747221023",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/bevel-lavabo-armaturu-krom-3575.jpg?v=1747221026"
    ],
    "price": "4365.00",
    "sku": "BT.BV1500",
    "tags": [
      "Armatür",
      "Banyo",
      "Bevel",
      "Krom",
      "Lavabo Armatürü",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52920966447401,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.BV1500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "4365.00",
        "grams": 0,
        "compare_at_price": "5820.00",
        "position": 1,
        "product_id": 8475109785897,
        "created_at": "2026-04-03T12:15:29+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<h2>🛠️ Teknik Özellikler</h2>\n<ul>\n<li>\n<strong>Model Kodu:</strong> BT.BV1500</li>\n<li>\n<strong>Seri:</strong> Bevel</li>\n<li>\n<strong>Malzeme:</strong> %100 pirinç gövde</li>\n<li>\n<strong>Kaplama:</strong> Krom parlak kaplama </li>\n<li>\n<strong>Renk Seçenekleri:</strong> Krom </li>\n<li>\n<strong>Armatür Tipi:</strong> Tek kumandalı miks lavabo bataryası</li>\n<li>\n<strong>Montaj Tipi:</strong> Tezgah üstü montaj, lavabo üzerine sabitlenir</li>\n<li>\n<strong>Kartuş:</strong> Uzun ömürlü seramik kartuş (genellikle 35 mm çapında, hassas sıcaklık ve debi ayarı sağlar)</li>\n<li>\n<strong>Su Akış Debisi:</strong> Ortalama 7-8 litre/dakika (enerji ve su tasarrufu için optimize edilmiş)</li>\n<li>\n<strong>Çıkış Ucu Uzunluğu:</strong> 105 mm</li>\n<li>\n<strong>Çıkış Ucu Yüksekliği:</strong> 117,5 mm</li>\n<li>\n<strong>Boru Tipi:</strong> Sabit</li>\n<li>\n<strong>Su Girişi:</strong> Çift giriş – sıcak ve soğuk su bağlantısı için uygun</li>\n<li>\n<strong>Perlatör:</strong> Kireç temizleme sistemli, sessiz su akışı sağlayan, kolay değiştirilebilir perlatör</li>\n<li>\n<strong>360° Döner Boru:</strong> Yok</li>\n<li>\n<strong>Açma-Kapama Mekanizması:</strong> Tek kol kumandalı, hassas kontrol imkanı veren</li>\n<li>\n<strong>Garanti Süresi:</strong> 5 yıl</li>\n</ul>\n<h2>💡 Öne Çıkan Özellikler</h2>\n<ul>\n<li>\n<strong>Modern ve Zarif Tasarım: </strong>Minimalist hatlarıyla her türlü banyoya uyum sağlar, estetik bir görünüm sunar.</li>\n<li>\n<strong>Uzun Ömürlü Malzeme:</strong> %100 pirinçten üretilen gövde, korozyona ve mekanik darbelere karşı dayanıklıdır.</li>\n<li>\n<strong>Seramik Kartuş Teknolojisi:</strong> Su sıcaklığı ve debisi hassas şekilde ayarlanabilir, sızdırmazlık ve uzun kullanım ömrü sağlar.</li>\n<li>\n<strong>Kireç Önleyici Perlatör:</strong> Su akışını temiz, sessiz ve homojen tutar; bakım kolaylığı sağlar.</li>\n<li>\n<strong>Kolay Montaj:</strong> Standart tezgah üstü montaj sistemi sayesinde hızlı ve pratik kurulum imkanı.</li>\n<li>\n<strong>Kullanıcı Dostu:</strong> Tek kumanda kolu ergonomik yapısıyla rahat kullanım sunar.</li>\n</ul>\n<h2>📦 Paket İçeriği</h2>\n<ul>\n<li>Creavit BT.BV1500 Bevel Lavabo Bataryası</li>\n<li>Montaj için gerekli bağlantı aparatları ve vidalar</li>\n<li>3/8\" fleksible bağlantı hortumları (50 cm uzunlukta)</li>\n<li>Kullanım ve montaj kılavuzu</li>\n</ul>\n<h2>🏷️ Kullanım Alanları</h2>\n<ul>\n<li>Ev banyoları</li>\n<li>Otel ve restoran banyoları</li>\n<li>Ofis ve ticari alanlar</li>\n<li>Modern ve klasik banyolarda uyumlu kullanım</li>\n</ul>\n<p>Creavit BT.BV1500 Bevel lavabo bataryası, dayanıklılığı ve şıklığıyla banyo dekorasyonunuza estetik bir dokunuş sağlar. Yüksek kalite malzeme ve gelişmiş seramik kartuş teknolojisi sayesinde suyu hassas kontrol eder ve uzun yıllar sorunsuz kullanım garantisi verir.</p>"
  },
  {
    "id": "creavit-8474904723753",
    "brand": "Creavit",
    "title": "Elmas Lavabo 50 cm Beyaz",
    "category": "Tezgah Üstü Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-lavabo-50-cm-beyaz-3572.png?v=1747232504",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-lavabo-50-cm-beyaz-3572.png?v=1747232504"
    ],
    "price": "3060.00",
    "sku": "TP026-00CB00E-0000",
    "tags": [
      "beyaz",
      "elmas",
      "ergonomik",
      "küçük",
      "lavabo",
      "tezgah üzeri lavabo",
      "Vitrifiye",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52843181211945,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "TP026-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "3060.00",
        "grams": 0,
        "compare_at_price": "4080.00",
        "position": 1,
        "product_id": 8474904723753,
        "created_at": "2026-03-17T12:45:04+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\">Elmas Lavabo az yer kaplayan tasarımı ile sınırlı alanlarda etkili bir çözüm sunar. Banyonuzu ferah ve kullanışlı hale getirir. Elmas<strong> </strong>Lavabonun şık hatları, modern ve zarif tasarımı ile banyonuzun dekorasyonunu tamamlayın.<strong> </strong>Kaliteli malzemelerle üretilen Creavit Lavabolar günlük kullanıma karşı sağlam bir yapı sunar. Pürüzsüz yüzeyi kolay temizlenerek zamandan tasarruf sağlar.</p>"
  },
  {
    "id": "creavit-8474903478569",
    "brand": "Creavit",
    "title": "Elmas Lavabo 45 cm Beyaz",
    "category": "Tezgah Üstü Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-lavabo-45-cm-beyaz-3567.jpg?v=1747835492",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-lavabo-45-cm-beyaz-3567.jpg?v=1747835492",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-lavabo-45-cm-beyaz-3568.jpg?v=1747220998",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-lavabo-45-cm-beyaz-3569.jpg?v=1747221000",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-lavabo-45-cm-beyaz-3570.jpg?v=1747221003",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/elmas-lavabo-45-cm-beyaz-3571.png?v=1747221006"
    ],
    "price": "2610.00",
    "sku": "TP025-00CB00E-0000",
    "tags": [
      "beyaz",
      "elmas",
      "ergonomik",
      "küçük",
      "lavabo",
      "tezgah üzeri lavabo",
      "Vitrifiye",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52927604293929,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "TP025-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2610.00",
        "grams": 0,
        "compare_at_price": "3480.00",
        "position": 1,
        "product_id": 8474903478569,
        "created_at": "2026-04-04T16:57:51+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Yerden Tasarruf:</strong> Elmas Lavabo az yer kaplayan tasarımı ile sınırlı alanlarda etkili bir çözüm sunar. Banyonuzu ferah ve kullanışlı hale getirir.</p>\r\n<p data-mce-fragment=\"1\"><strong>Estetik ve Modern Tasarım: </strong>Elmas<strong> </strong>Lavabonun şık hatları, modern ve zarif tasarımı ile banyonuzun dekorasyonunu tamamlayın.</p>\r\n<p data-mce-fragment=\"1\"><strong>Dayanıklı Malzemeler: </strong>Kaliteli malzemelerle üretilen Creavit Lavabolar günlük kullanıma karşı sağlam bir yapı sunar. Pürüzsüz yüzeyi kolay temizlenerek zamandan tasarruf sağlar.</p>"
  },
  {
    "id": "creavit-8474857341225",
    "brand": "Creavit",
    "title": "Tezgah Altı Oval Lavabo 40*52 cm Beyaz",
    "category": "Tezgah Altı Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tezgah-alti-oval-lavabo-40-52-cm-beyaz-3566.png?v=1747234782",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tezgah-alti-oval-lavabo-40-52-cm-beyaz-3566.png?v=1747234782"
    ],
    "price": "2970.00",
    "sku": "TP205-00CB00E-0000",
    "tags": [
      "beyaz",
      "Lavabo",
      "Oval",
      "siyah",
      "tezgah altı",
      "tezgah altı lavabo",
      "Vitrifiye",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52898590916905,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "TP205-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "2970.00",
        "grams": 0,
        "compare_at_price": "3960.00",
        "position": 1,
        "product_id": 8474857341225,
        "created_at": "2026-03-30T15:37:10+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\">\n<div class=\"react-scroll-to-bottom--css-vfjev-79elbk h-full dark:bg-gray-800\">\n<div class=\"react-scroll-to-bottom--css-vfjev-1n7m0yu\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-gray-800 dark:text-gray-100 border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\">\n<div class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3\">\n<div class=\"min-h-[20px] flex items-start overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<p><meta charset=\"utf-8\">Toplu kullanım alanlarında hijyen toplum sağlığını yakından ilgilendirmektedir. Creavit olarak okul, hastane, alışveriş merkezleri gibi yerlerde bir çok kişinin ortak kullanımına sunduğumuz lavabo modellerimizle hijyen ve temizliği en üst düzeyde tutuyoruz. Modern ve yenilikçi tasarımlarımızla kullanıcı istek ve beklentilerine uygun tasarımlar yaratıyor, tüm mekanlar için uygun hijyen çözümleri sunuyoruz.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8474845872425",
    "brand": "Creavit",
    "title": "Tezgah Altı Lavabo 30*50cm Beyaz",
    "category": "Tezgah Altı Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tezgah-alti-lavabo-30-50cm-beyaz-3560.png?v=1746619647",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tezgah-alti-lavabo-30-50cm-beyaz-3560.png?v=1746619647",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tezgah-alti-lavabo-30-50cm-beyaz-3561.jpg?v=1746619649",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tezgah-alti-lavabo-30-50cm-beyaz-3562.jpg?v=1746619651",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tezgah-alti-lavabo-30-50cm-beyaz-3563.jpg?v=1746619653",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tezgah-alti-lavabo-30-50cm-beyaz-3564.jpg?v=1746619656",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tezgah-alti-lavabo-30-50cm-beyaz-3565.png?v=1746619658"
    ],
    "price": "4050.00",
    "sku": "TP730-00CB00E-0000",
    "tags": [
      "beyaz",
      "Lavabo",
      "siyah",
      "tezgah altı",
      "tezgah altı lavabo",
      "Vitrifiye",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52927310627113,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "TP730-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "4050.00",
        "grams": 0,
        "compare_at_price": "5400.00",
        "position": 1,
        "product_id": 8474845872425,
        "created_at": "2026-04-04T15:21:18+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\">\n<div class=\"react-scroll-to-bottom--css-vfjev-79elbk h-full dark:bg-gray-800\">\n<div class=\"react-scroll-to-bottom--css-vfjev-1n7m0yu\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-gray-800 dark:text-gray-100 border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\">\n<div class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3\">\n<div class=\"min-h-[20px] flex items-start overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<p><meta charset=\"utf-8\">Toplu kullanım alanlarında hijyen toplum sağlığını yakından ilgilendirmektedir. Creavit olarak okul, hastane, alışveriş merkezleri gibi yerlerde bir çok kişinin ortak kullanımına sunduğumuz lavabo modellerimizle hijyen ve temizliği en üst düzeyde tutuyoruz. Modern ve yenilikçi tasarımlarımızla kullanıcı istek ve beklentilerine uygun tasarımlar yaratıyor, tüm mekanlar için uygun hijyen çözümleri sunuyoruz.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8474843611433",
    "brand": "Creavit",
    "title": "Tezgah Altı Lavabo 38*51 cm Beyaz",
    "category": "Tezgah Altı Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tezgah-alti-lavabo-38-51-cm-beyaz-3554.png?v=1747118919",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tezgah-alti-lavabo-38-51-cm-beyaz-3554.png?v=1747118919",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tezgah-alti-lavabo-38-51-cm-beyaz-3555.jpg?v=1747118921",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tezgah-alti-lavabo-38-51-cm-beyaz-3556.jpg?v=1747118923",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tezgah-alti-lavabo-38-51-cm-beyaz-3557.jpg?v=1747118926",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tezgah-alti-lavabo-38-51-cm-beyaz-3558.jpg?v=1747118928",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/tezgah-alti-lavabo-38-51-cm-beyaz-3559.png?v=1747118931"
    ],
    "price": "5400.00",
    "sku": "TP738-00CB00E-0000",
    "tags": [
      "beyaz",
      "Lavabo",
      "siyah",
      "tezgah altı",
      "tezgah altı lavabo",
      "Vitrifiye",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52921477038377,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "TP738-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5400.00",
        "grams": 0,
        "compare_at_price": "7200.00",
        "position": 1,
        "product_id": 8474843611433,
        "created_at": "2026-04-03T14:42:48+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"flex-1 overflow-hidden\">\n<div class=\"react-scroll-to-bottom--css-vfjev-79elbk h-full dark:bg-gray-800\">\n<div class=\"react-scroll-to-bottom--css-vfjev-1n7m0yu\">\n<div class=\"flex flex-col text-sm dark:bg-gray-800\">\n<div class=\"group w-full text-gray-800 dark:text-gray-100 border-b border-black/10 dark:border-gray-900/50 bg-gray-50 dark:bg-[#444654]\">\n<div class=\"flex p-4 gap-4 text-base md:gap-6 md:max-w-2xl lg:max-w-[38rem] xl:max-w-3xl md:py-6 lg:px-0 m-auto\">\n<div class=\"relative flex w-[calc(100%-50px)] flex-col gap-1 md:gap-3 lg:w-[calc(100%-115px)]\">\n<div class=\"flex flex-grow flex-col gap-3\">\n<div class=\"min-h-[20px] flex items-start overflow-x-auto whitespace-pre-wrap break-words\">\n<div class=\"markdown prose w-full break-words dark:prose-invert light\">\n<p><meta charset=\"utf-8\">Toplu kullanım alanlarında hijyen toplum sağlığını yakından ilgilendirmektedir. Creavit olarak okul, hastane, alışveriş merkezleri gibi yerlerde bir çok kişinin ortak kullanımına sunduğumuz lavabo modellerimizle hijyen ve temizliği en üst düzeyde tutuyoruz. Modern ve yenilikçi tasarımlarımızla kullanıcı istek ve beklentilerine uygun tasarımlar yaratıyor, tüm mekanlar için uygun hijyen çözümleri sunuyoruz.</p>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>"
  },
  {
    "id": "creavit-8474339803433",
    "brand": "Creavit",
    "title": "Eksen Etajerli Lavabo 100 cm Beyaz",
    "category": "Etajerli Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/eksen-etajerli-lavabo-100-cm-beyaz-3548.png?v=1747234158",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/eksen-etajerli-lavabo-100-cm-beyaz-3548.png?v=1747234158",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/eksen-etajerli-lavabo-100-cm-beyaz-3549.jpg?v=1747234161",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/eksen-etajerli-lavabo-100-cm-beyaz-3550.jpg?v=1747234163",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/eksen-etajerli-lavabo-100-cm-beyaz-3551.jpg?v=1747234165",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/eksen-etajerli-lavabo-100-cm-beyaz-3552.jpg?v=1747234169",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/eksen-etajerli-lavabo-100-cm-beyaz-3553.png?v=1747234173"
    ],
    "price": "7290.00",
    "sku": "EK100-00CB00E-0000",
    "tags": [
      "beyaz",
      "eksen",
      "etajerli lavabo",
      "Lavabo",
      "tezgah üstü",
      "Vitrifiye",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52847195849001,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "EK100-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7290.00",
        "grams": 0,
        "compare_at_price": "9720.00",
        "position": 1,
        "product_id": 8474339803433,
        "created_at": "2026-03-18T12:00:50+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p data-mce-fragment=\"1\"><strong>Düzenleyici Etajer: </strong>Geniş etajeri sayesinde kişisel eşyalarınızı kolayca yerleştirerek banyonuzu daha organize ve ferah hale getirin.</p>\r\n<p data-mce-fragment=\"1\"><strong>Estetik ve Modern Tasarım: </strong>Eksen Etajerli Lavabonun şık hatları, modern ve zarif tasarımı ile banyonuzun dekorasyonunu tamamlayın.</p>\r\n<p data-mce-fragment=\"1\"><strong>Dayanıklı Malzemeler: </strong>Kaliteli malzemelerle üretilen Eksen Etajerli Lavabo günlük kullanıma karşı sağlam bir yapı sunar. Pürüzsüz yüzeyi kolay temizlenerek zamandan tasarruf sağlar.</p>\n</div>"
  },
  {
    "id": "creavit-8474327154985",
    "brand": "Creavit",
    "title": "Eksen Etajerli Lavabo 80 cm Beyaz",
    "category": "Etajerli Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/eksen-etajerli-lavabo-80-cm-beyaz-3542.png?v=1747220971",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/eksen-etajerli-lavabo-80-cm-beyaz-3542.png?v=1747220971",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/eksen-etajerli-lavabo-80-cm-beyaz-3543.jpg?v=1747220975",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/eksen-etajerli-lavabo-80-cm-beyaz-3544.jpg?v=1747220979",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/eksen-etajerli-lavabo-80-cm-beyaz-3545.jpg?v=1747220981",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/eksen-etajerli-lavabo-80-cm-beyaz-3546.jpg?v=1747220983",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/eksen-etajerli-lavabo-80-cm-beyaz-3547.png?v=1747220986"
    ],
    "price": "5715.00",
    "sku": "EK080-00CB00E-0000",
    "tags": [
      "beyaz",
      "eksen",
      "etajerli lavabo",
      "Lavabo",
      "tezgah üstü",
      "Vitrifiye",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52843252777257,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "EK080-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5715.00",
        "grams": 0,
        "compare_at_price": "7620.00",
        "position": 1,
        "product_id": 8474327154985,
        "created_at": "2026-03-17T13:07:14+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p data-mce-fragment=\"1\">Geniş etajeri sayesinde kişisel eşyalarınızı kolayca yerleştirerek banyonuzu daha organize ve ferah hale getirin. Eksen Etajerli Lavabonun şık hatları, modern ve zarif tasarımı ile banyonuzun dekorasyonunu tamamlayın. Kaliteli malzemelerle üretilen Eksen Etajerli Lavabo günlük kullanıma karşı sağlam bir yapı sunar. Pürüzsüz yüzeyi kolay temizlenerek zamandan tasarruf sağlar.</p>\n</div>"
  },
  {
    "id": "creavit-8474326597929",
    "brand": "Creavit",
    "title": "Eksen Etajerli Lavabo 65 cm Beyaz",
    "category": "Etajerli Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/eksen-etajerli-lavabo-65-cm-beyaz-3536.png?v=1747234134",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/eksen-etajerli-lavabo-65-cm-beyaz-3536.png?v=1747234134",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/eksen-etajerli-lavabo-65-cm-beyaz-3537.jpg?v=1747234136",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/eksen-etajerli-lavabo-65-cm-beyaz-3538.jpg?v=1747234139",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/eksen-etajerli-lavabo-65-cm-beyaz-3539.jpg?v=1747234142",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/eksen-etajerli-lavabo-65-cm-beyaz-3540.jpg?v=1747234144",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/eksen-etajerli-lavabo-65-cm-beyaz-3541.png?v=1747234148"
    ],
    "price": "4950.00",
    "sku": "EK065-00CB00E-0000",
    "tags": [
      "beyaz",
      "eksen",
      "etajerli lavabo",
      "Lavabo",
      "tezgah üstü",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52843248582953,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "EK065-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "4950.00",
        "grams": 0,
        "compare_at_price": "6600.00",
        "position": 1,
        "product_id": 8474326597929,
        "created_at": "2026-03-17T13:05:53+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">\r\n<p data-mce-fragment=\"1\">Banyonuza zarafet ve düzen katmak için Creavit Eksen Etajerli Lavabo ile tanışın! Şık tasarımı ve işlevsel özellikleri ile banyonuzu estetik bir yaşam alanına dönüştürerek, günlük kullanımınızı pratikleştirecek.</p>\r\n<p data-mce-fragment=\"1\">Estetik ve Şık Tasarım:<span data-mce-fragment=\"1\"> Etajerli Lavabo, modern ve zarif tasarımı sayesinde banyonuza sofistike bir atmosfer katar. Şık hatları ve ince detayları ile görsel bir şölen sunarak banyonuzun dekorasyonunu tamamlayacak.</span></p>\r\n<p data-mce-fragment=\"1\">Düzenleyici Etajer:<span data-mce-fragment=\"1\"> Geniş etajeri sayesinde, banyo malzemelerinizi düzenli bir şekilde saklamanızı sağlar. Kişisel eşyalarınızı kolayca yerleştirerek banyonuzu daha organize ve ferah bir hale getirir.</span></p>\r\n<p data-mce-fragment=\"1\">Dayanıklı Malzemeler:<span data-mce-fragment=\"1\"> Kaliteli malzemelerle üretilen Etajerli Lavabo, uzun süre dayanıklılığını korur ve günlük kullanıma karşı sağlam bir yapı sunar. Böylece uzun yıllar boyunca sorunsuz bir şekilde kullanabilirsiniz.</span></p>\n</div>\r\n<div class=\"markdown prose w-full break-words dark:prose-invert light\" data-mce-fragment=\"1\">Kolay Montaj ve Temizlik:<span data-mce-fragment=\"1\"> Etajerli Lavabo'nun montajı kolaydır ve tüm gerekli montaj aksesuarları ile birlikte gelir. Pürüzsüz yüzeyi, kolay temizlik sağlar ve size zaman kazandırır.</span> \r\n<p data-mce-fragment=\"1\">Etajerli Lavabo, sadece bir lavabo değil, aynı zamanda banyonuzun düzenleyici ve estetik bir parçası olacak. Şık tasarımı ile göz alıcı bir öğe olarak ön plana çıkar ve banyonuzda rahat, ferah ve huzurlu bir atmosfer yaratır.</p>\r\n<p data-mce-fragment=\"1\">Banyonuzun güzellik dolu bir yaşam alanına dönüşmesini sağlayan Etajerli Lavabo ile banyo deneyiminiz artık benzersiz olacak!</p>\n</div>"
  },
  {
    "id": "creavit-8471621075241",
    "brand": "Creavit",
    "title": "Next Tezgah Üzeri Kare Lavabo 50*50 cm Beyaz",
    "category": "Tezgah Üstü Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/next-tezgah-uzeri-kare-lavabo-50-50-cm-beyaz-3531.png?v=1747220946",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/next-tezgah-uzeri-kare-lavabo-50-50-cm-beyaz-3531.png?v=1747220946",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/next-tezgah-uzeri-kare-lavabo-50-50-cm-beyaz-3532.jpg?v=1747220949",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/next-tezgah-uzeri-kare-lavabo-50-50-cm-beyaz-3533.png?v=1747220952",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/next-tezgah-uzeri-kare-lavabo-50-50-cm-beyaz-3534.png?v=1747220955",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/next-tezgah-uzeri-kare-lavabo-50-50-cm-beyaz-3535.png?v=1747220959"
    ],
    "price": "5580.00",
    "sku": "NX255-00CB00E-0000",
    "tags": [
      "Beyaz",
      "Kare",
      "Lavabo",
      "next",
      "tezgah üstü",
      "Tezgah Üstü Lavabo",
      "tezgah üzeri lavabo",
      "Tezgahüstü",
      "Vitrifiye",
      "yaz-15-indirim"
    ],
    "variants": [
      {
        "id": 52843191730473,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "NX255-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "5580.00",
        "grams": 0,
        "compare_at_price": "7440.00",
        "position": 1,
        "product_id": 8471621075241,
        "created_at": "2026-03-17T12:48:04+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Şık ve Zarif Tasarım: </strong>Next Tezgah Üstü Lavabo, şık ve zarif tasarımı sayesinde banyonuza sofistike bir hava katar. İnce detayları ve dikkat çekici hatlarıyla banyonuzu güzellik dolu bir yaşam alanına dönüştürür.<br></p>\r\n<p data-mce-fragment=\"1\"><strong>Kullanım Kolaylığı: </strong>Creavit Tezgah Üstü Lavabolar, ergonomik tasarımı sayesinde size kullanım kolaylığı sunar. Yükseklik ve genişlik açısından ideal ölçülerle tasarlanmış olan Next Tezgah Üstü Lavabo, suyun akışını ve kullanımını en rahat şekilde sağlar.</p>\r\n<p data-mce-fragment=\"1\"><strong>Dayanıklı Malzemeler: </strong>Kaliteli malzemelerle üretilen Creavit Lavabolar günlük kullanıma karşı sağlam bir yapı sunar. Pürüzsüz yüzeyi kolay temizlenerek zamandan tasarruf sağlar.<span style=\"FONT-FAMILY: -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif\"> </span></p>"
  },
  {
    "id": "creavit-8372774994217",
    "brand": "Creavit",
    "title": "Loop Oval Çanak Lavabo 40x60 cm Beyaz",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-oval-canak-lavabo-40x60-cm-beyaz-3525.png?v=1747805550",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-oval-canak-lavabo-40x60-cm-beyaz-3525.png?v=1747805550",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-oval-canak-lavabo-40x60-cm-beyaz-3526.jpg?v=1747805550",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-oval-canak-lavabo-40x60-cm-beyaz-3527.jpg?v=1747805550",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-oval-canak-lavabo-40x60-cm-beyaz-3528.jpg?v=1747805550",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-oval-canak-lavabo-40x60-cm-beyaz-3529.jpg?v=1747805550",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-oval-canak-lavabo-40x60-cm-beyaz-3530.png?v=1747805550"
    ],
    "price": "8775.00",
    "sku": "LP160-00CB00E-0000",
    "tags": [
      "Beyaz",
      "Lavabo",
      "Loop",
      "Oval",
      "Tezgahüstü",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52895608930601,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP160-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8775.00",
        "grams": 0,
        "compare_at_price": "11700.00",
        "position": 1,
        "product_id": 8372774994217,
        "created_at": "2026-03-29T17:38:05+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<meta charset=\"utf-8\">\r\n<div class=\"landingUltral__b3secHl\" data-mce-fragment=\"1\"> </div>\r\n\r\n<p>Banyonuz modern sanat galerisine dönüşsün!</p>\r\n\r\n<p>Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\r\n\r\n<p>Lavaboda İnce Düşünenlere!</p>\r\n\r\n<p>Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>\r\n\r\n<div class=\"landingUltral__b3secHl\" data-mce-fragment=\"1\">\r\n<div class=\"landingUltral__b3secHl\"> </div>\r\n</div>"
  },
  {
    "id": "creavit-8293750571305",
    "brand": "Creavit",
    "title": "Loop Yuvarlak Çanak Lavabo Ø40 cm",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-40-cm-3512.png?v=1747805560",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-40-cm-3512.png?v=1747805560",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-40-cm-3513.jpg?v=1747805560",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-40-cm-3514.jpg?v=1747805560",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-40-cm-3515.jpg?v=1747805560",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-40-cm-3516.jpg?v=1747805560",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-40-cm-3517.jpg?v=1747805560",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-yuvarlak-canak-lavabo-40-cm-3518.png?v=1747805560"
    ],
    "price": "7515.00",
    "sku": "LP140-00CB00E-0000",
    "tags": [
      "Beyaz",
      "Lavabo",
      "Loop",
      "Tezgahüstü",
      "yaz-15-indirim",
      "Yuvarlak",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52843260444969,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP140-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7515.00",
        "grams": 0,
        "compare_at_price": "10020.00",
        "position": 1,
        "product_id": 8293750571305,
        "created_at": "2026-03-17T13:09:39+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz modern sanat galerisine dönüşsün!</strong></p>\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\n<p data-mce-fragment=\"1\">Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-8293745951017",
    "brand": "Creavit",
    "title": "Loop Dikdörtgen Çanak Lavabo 45x60 cm Beyaz",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-dikdortgen-canak-lavabo-45x60-cm-beyaz-3507.png?v=1747805565",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-dikdortgen-canak-lavabo-45x60-cm-beyaz-3507.png?v=1747805565",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-dikdortgen-canak-lavabo-45x60-cm-beyaz-3508.jpg?v=1747805565",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-dikdortgen-canak-lavabo-45x60-cm-beyaz-3509.jpg?v=1747805565",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-dikdortgen-canak-lavabo-45x60-cm-beyaz-3510.jpg?v=1747805565",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-dikdortgen-canak-lavabo-45x60-cm-beyaz-3511.png?v=1747805565"
    ],
    "price": "9405.00",
    "sku": "LP061-00CB00E-0000",
    "tags": [
      "Beyaz",
      "Dikdörtgen",
      "Lavabo",
      "Loop",
      "Tezgahüstü",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52921476809001,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP061-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": false,
        "price": "9405.00",
        "grams": 0,
        "compare_at_price": "12540.00",
        "position": 1,
        "product_id": 8293745951017,
        "created_at": "2026-04-03T14:42:45+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<meta charset=\"utf-8\"><meta charset=\"utf-8\">\r\n<p data-mce-fragment=\"1\">Banyonuz modern sanat galerisine dönüşsün!</p>\r\n\r\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\r\n\r\n<p data-mce-fragment=\"1\">Lavaboda İnce Düşünenlere!</p>\r\n\r\n<p data-mce-fragment=\"1\">Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>\r\n\r\n<p> </p>"
  },
  {
    "id": "creavit-8293757976873",
    "brand": "Creavit",
    "title": "Loop Kare Çanak Lavabo 45 cm Beyaz",
    "category": "Çanak Lavabo",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-canak-lavabo-45-cm-beyaz-3519.png?v=1747805555",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-canak-lavabo-45-cm-beyaz-3519.png?v=1747805555",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-canak-lavabo-45-cm-beyaz-3520.jpg?v=1747805555",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-canak-lavabo-45-cm-beyaz-3521.jpg?v=1747805555",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-canak-lavabo-45-cm-beyaz-3522.jpg?v=1747805555",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/loop-kare-canak-lavabo-45-cm-beyaz-3523.jpg?v=1747805555"
    ],
    "price": "8280.00",
    "sku": "LP046-00CB00E-0000",
    "tags": [
      "Beyaz",
      "Kare",
      "Lavabo",
      "Loop",
      "Tezgahüstü",
      "Ultra İnce",
      "yaz-15-indirim",
      "Çanak",
      "Çanak Lavabo"
    ],
    "variants": [
      {
        "id": 52848948478249,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "LP046-00CB00E-0000",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8280.00",
        "grams": 0,
        "compare_at_price": "11040.00",
        "position": 1,
        "product_id": 8293757976873,
        "created_at": "2026-03-18T20:19:04+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p data-mce-fragment=\"1\"><strong>Banyonuz modern sanat galerisine dönüşsün!</strong></p>\r\n<p data-mce-fragment=\"1\">Creavit'in renkli ve ince düşünülmüş zarif detaylara sahip Loop lavabolarıyla, banyonuzda sanatsal bir hava yaratın. Banyonuzu dilediğiniz gibi renklendirecek seçenekleriyle keyifli bir hale getirmek Loop ile mümkün; beyaz, mat basalt, mat cappuccino, mat antrasit, mat siyah, mat beyaz, nil yeşili, cool gray, berry, neon, mint, sakura ile banyonuzu renklerin büyüsüne bırakın.</p>\r\n<p data-mce-fragment=\"1\"><strong>Lavaboda İnce Düşünenlere!</strong></p>\r\n<p data-mce-fragment=\"1\">Kenarları tamamen 5mm inceliğinde olan Loop serisi lavabolar, banyoda şıklığı en ince ayrıntısına kadar düşünenler için özel olarak üretildi. Kare, dikdörtgen ve yuvarlak formlara sahip Loop modelleri, farklı banyo tarzlarına ve metrekarelerine özel seçim özgürlüğü sunuyor.</p>"
  },
  {
    "id": "creavit-8293726290217",
    "brand": "Creavit",
    "title": "Lua Lavabo Armatürü Krom",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-selale-lavabo-armaturu-krom-3502.jpg?v=1747039658",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-selale-lavabo-armaturu-krom-3502.jpg?v=1747039658",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-selale-lavabo-armaturu-krom-3504.jpg?v=1747039660",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-selale-lavabo-armaturu-krom-3503.jpg?v=1747039663",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-selale-lavabo-armaturu-krom-3505.jpg?v=1747039665",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-selale-lavabo-armaturu-krom-3506.jpg?v=1747039668"
    ],
    "price": "6525.00",
    "sku": "BT.LU1500",
    "tags": [
      "Armatür",
      "Banyo",
      "Krom",
      "Lavabo Armatürü",
      "Lua",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52920966218025,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.LU1500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "6525.00",
        "grams": 0,
        "compare_at_price": "8700.00",
        "position": 1,
        "product_id": 8293726290217,
        "created_at": "2026-04-03T12:15:26+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p><strong>Creavit Lua Duşta, Banyoda, Mutfakta!</strong></p>\r\n<p>Lua<strong> </strong>Armatür serisi özel olarak tasarlanan ideal su çıkış ucu eğimiyle suyun şelale görünümünde akmasını sağlar. Şık ve minimalist çizgileriyle banyo dekorasyonunuza sofistike bir dokunuş katar. Lua armatür serisi hızlı ve kolay bir şekilde monte edilir. Standart armatür deliği ölçüleriyle uyumludur. Çoğu lavabo veya tezgaha rahatlıkla takılabilir. Creavit armatürleri gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p><!---->"
  },
  {
    "id": "creavit-8293725536553",
    "brand": "Creavit",
    "title": "Lua Banyo Armatürü Krom",
    "category": "Banyo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-banyo-armaturu-krom-3497.jpg?v=1747220826",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-banyo-armaturu-krom-3497.jpg?v=1747220826",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-banyo-armaturu-krom-3498.jpg?v=1747220829",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-banyo-armaturu-krom-3499.jpg?v=1747220834",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-banyo-armaturu-krom-3500.jpg?v=1747220837",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-banyo-armaturu-krom-3501.jpg?v=1747220840"
    ],
    "price": "8190.00",
    "sku": "BT.LU2500",
    "tags": [
      "Armatür",
      "Banyo",
      "banyo armatürü",
      "Krom",
      "Lua",
      "yaz-30-indirim"
    ],
    "variants": [
      {
        "id": 52843222434089,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.LU2500",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "8190.00",
        "grams": 0,
        "compare_at_price": "10920.00",
        "position": 1,
        "product_id": 8293725536553,
        "created_at": "2026-03-17T12:57:00+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p><strong>Creavit Lua Duşta, Banyoda, Mutfakta!</strong></p>\r\n<p>Lua<strong> </strong>Armatür serisi özel olarak tasarlanan ideal su çıkış ucu eğimiyle suyun şelale görünümünde akmasını sağlar. Şık ve minimalist çizgileriyle banyo dekorasyonunuza sofistike bir dokunuş katar. Lua armatür serisi hızlı ve kolay bir şekilde monte edilir. Standart armatür deliği ölçüleriyle uyumludur. Çoğu lavabo veya tezgaha rahatlıkla takılabilir. Creavit armatürleri gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>"
  },
  {
    "id": "creavit-8253996466473",
    "brand": "Creavit",
    "title": "Lua Lavabo Armatürü Metalik Gri",
    "category": "Lavabo Armatürü",
    "image": "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-selale-lavabo-armaturu-metalik-gri-3492.jpg?v=1747220809",
    "images": [
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-selale-lavabo-armaturu-metalik-gri-3492.jpg?v=1747220809",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-selale-lavabo-armaturu-metalik-gri-3493.jpg?v=1747220812",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-selale-lavabo-armaturu-metalik-gri-3494.jpg?v=1747220814",
      "https://cdn.shopify.com/s/files/1/0753/5627/4985/files/lua-selale-lavabo-armaturu-metalik-gri-3495.jpg?v=1747220817"
    ],
    "price": "7920.00",
    "sku": "BT.LU1500GR",
    "tags": [
      "Armatür",
      "Banyo",
      "Lavabo Armatürü",
      "Lua",
      "Metalik Gri",
      "yaz-30-indirim",
      "Şelale"
    ],
    "variants": [
      {
        "id": 52843231969577,
        "title": "Default Title",
        "option1": "Default Title",
        "option2": null,
        "option3": null,
        "sku": "BT.LU1500GR",
        "requires_shipping": true,
        "taxable": false,
        "featured_image": null,
        "available": true,
        "price": "7920.00",
        "grams": 0,
        "compare_at_price": "10560.00",
        "position": 1,
        "product_id": 8253996466473,
        "created_at": "2026-03-17T13:00:33+03:00",
        "updated_at": "2026-04-07T05:25:32+03:00"
      }
    ],
    "description": "<p><strong>Creavit Lua Duşta, Banyoda, Mutfakta!</strong></p>\r\n<p>Lua<strong> </strong>Armatür serisi özel olarak tasarlanan ideal su çıkış ucu eğimiyle suyun şelale görünümünde akmasını sağlar. Şık ve minimalist çizgileriyle banyo dekorasyonunuza sofistike bir dokunuş katar. Lua armatür serisi hızlı ve kolay bir şekilde monte edilir. Standart armatür deliği ölçüleriyle uyumludur. Çoğu lavabo veya tezgaha rahatlıkla takılabilir. Creavit armatürleri gövdeleri tamamen pirinç malzemeden oluştuğu için suyun doğallığını, kokusunu ve rengini bozmaz.</p>"
  }
]